(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7209],{

/***/ 79104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16600);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/base/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/base/api/no-ssr/)
 */
function NoSsr(props) {
  const {
    children,
    defer = false,
    fallback = null
  } = props;
  const [mountedState, setMountedState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]);

  // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: mountedState ? children : fallback
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (NoSsr);

/***/ }),

/***/ 7078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
}), 'Chat');

exports.Z = _default;

/***/ }),

/***/ 51310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
}), 'Fullscreen');

exports.Z = _default;

/***/ }),

/***/ 66235:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
}), 'FullscreenExit');

exports.Z = _default;

/***/ }),

/***/ 22205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ko; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1초 미만',
    other: '{{count}}초 미만'
  },
  xSeconds: {
    one: '1초',
    other: '{{count}}초'
  },
  halfAMinute: '30초',
  lessThanXMinutes: {
    one: '1분 미만',
    other: '{{count}}분 미만'
  },
  xMinutes: {
    one: '1분',
    other: '{{count}}분'
  },
  aboutXHours: {
    one: '약 1시간',
    other: '약 {{count}}시간'
  },
  xHours: {
    one: '1시간',
    other: '{{count}}시간'
  },
  xDays: {
    one: '1일',
    other: '{{count}}일'
  },
  aboutXWeeks: {
    one: '약 1주',
    other: '약 {{count}}주'
  },
  xWeeks: {
    one: '1주',
    other: '{{count}}주'
  },
  aboutXMonths: {
    one: '약 1개월',
    other: '약 {{count}}개월'
  },
  xMonths: {
    one: '1개월',
    other: '{{count}}개월'
  },
  aboutXYears: {
    one: '약 1년',
    other: '약 {{count}}년'
  },
  xYears: {
    one: '1년',
    other: '{{count}}년'
  },
  overXYears: {
    one: '1년 이상',
    other: '{{count}}년 이상'
  },
  almostXYears: {
    one: '거의 1년',
    other: '거의 {{count}}년'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' 후';
    } else {
      return result + ' 전';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/_lib/formatLong/index.js

var dateFormats = {
  full: 'y년 M월 d일 EEEE',
  long: 'y년 M월 d일',
  medium: 'y.MM.dd',
  short: 'y.MM.dd'
};
var timeFormats = {
  full: 'a H시 mm분 ss초 zzzz',
  long: 'a H:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/_lib/localize/index.js

var eraValues = {
  narrow: ['BC', 'AD'],
  abbreviated: ['BC', 'AD'],
  wide: ['기원전', '서기']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1분기', '2분기', '3분기', '4분기']
};
var monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
};
var dayValues = {
  narrow: ['일', '월', '화', '수', '목', '금', '토'],
  short: ['일', '월', '화', '수', '목', '금', '토'],
  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
};
var dayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = String(options === null || options === void 0 ? void 0 : options.unit);

  switch (unit) {
    case 'minute':
    case 'second':
      return String(number);

    case 'date':
      return number + '일';

    default:
      return number + '번째';
  }
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ko/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */

var locale = {
  code: 'ko',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var ko = (locale);

/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  const {
    entries,
    setPrototypeOf,
    isFrozen,
    getPrototypeOf,
    getOwnPropertyDescriptor
  } = Object;
  let {
    freeze,
    seal,
    create
  } = Object; // eslint-disable-line import/no-mutable-exports
  let {
    apply,
    construct
  } = typeof Reflect !== 'undefined' && Reflect;
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return new Func(...args);
    };
  }
  const arrayForEach = unapply(Array.prototype.forEach);
  const arrayPop = unapply(Array.prototype.pop);
  const arrayPush = unapply(Array.prototype.push);
  const stringToLowerCase = unapply(String.prototype.toLowerCase);
  const stringToString = unapply(String.prototype.toString);
  const stringMatch = unapply(String.prototype.match);
  const stringReplace = unapply(String.prototype.replace);
  const stringIndexOf = unapply(String.prototype.indexOf);
  const stringTrim = unapply(String.prototype.trim);
  const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
  const regExpTest = unapply(RegExp.prototype.test);
  const typeErrorCreate = unconstruct(TypeError);

  /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }

  /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */
  function addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    let l = array.length;
    while (l--) {
      let element = array[l];
      if (typeof element === 'string') {
        const lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */
  function cleanArray(array) {
    for (let index = 0; index < array.length; index++) {
      const isPropertyExist = objectHasOwnProperty(array, index);
      if (!isPropertyExist) {
        array[index] = null;
      }
    }
    return array;
  }

  /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */
  function clone(object) {
    const newObject = create(null);
    for (const [property, value] of entries(object)) {
      const isPropertyExist = objectHasOwnProperty(object, property);
      if (isPropertyExist) {
        if (Array.isArray(value)) {
          newObject[property] = cleanArray(value);
        } else if (value && typeof value === 'object' && value.constructor === Object) {
          newObject[property] = clone(value);
        } else {
          newObject[property] = value;
        }
      }
    }
    return newObject;
  }

  /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */
  function lookupGetter(object, prop) {
    while (object !== null) {
      const desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue() {
      return null;
    }
    return fallbackValue;
  }

  const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  const text = freeze(['#text']);

  const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
  const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  const DOCTYPE_NAME = seal(/^html$/i);
  const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var EXPRESSIONS = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MUSTACHE_EXPR: MUSTACHE_EXPR,
    ERB_EXPR: ERB_EXPR,
    TMPLIT_EXPR: TMPLIT_EXPR,
    DATA_ATTR: DATA_ATTR,
    ARIA_ATTR: ARIA_ATTR,
    IS_ALLOWED_URI: IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE: ATTR_WHITESPACE,
    DOCTYPE_NAME: DOCTYPE_NAME,
    CUSTOM_ELEMENT: CUSTOM_ELEMENT
  });

  // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
  const NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
  };
  const getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */
  const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
      suffix = purifyHostElement.getAttribute(ATTR_NAME);
    }
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML(html) {
          return html;
        },
        createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    const DOMPurify = root => createDOMPurify(root);

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '3.1.6';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    let {
      document
    } = window;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const {
      DocumentFragment,
      HTMLTemplateElement,
      Node,
      Element,
      NodeFilter,
      NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
      HTMLFormElement,
      DOMParser,
      trustedTypes
    } = window;
    const ElementPrototype = Element.prototype;
    const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    const remove = lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      const template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const {
      implementation,
      createNodeIterator,
      createDocumentFragment,
      getElementsByTagName
    } = document;
    const {
      importNode
    } = originalDocument;
    let hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const {
      MUSTACHE_EXPR,
      ERB_EXPR,
      TMPLIT_EXPR,
      DATA_ATTR,
      ARIA_ATTR,
      IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE,
      CUSTOM_ELEMENT
    } = EXPRESSIONS;
    let {
      IS_ALLOWED_URI: IS_ALLOWED_URI$1
    } = EXPRESSIONS;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);

    /* Allowed attribute names */
    let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    let FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    let FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    let ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    let ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    let ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    let ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    let SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    let SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    let WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    let SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    let FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    let RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    let RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    let RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    let SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    let KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    let IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    let USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;

    /* Keep a reference to config to pass to hooks */
    let CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
      let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || typeof cfg !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, text);
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }
      if (cfg.TRUSTED_TYPES_POLICY) {
        if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
          throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        }
        if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
          throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        }

        // Overwrite existing TrustedTypes policy.
        trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;

        // Sign local variables required by `sanitize`.
        emptyHTML = trustedTypesPolicy.createHTML('');
      } else {
        // Uninitialized policy, attempt to initialize the internal dompurify policy.
        if (trustedTypesPolicy === undefined) {
          trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
        }

        // If creating the internal policy succeeded sign internal variables.
        if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
          emptyHTML = trustedTypesPolicy.createHTML('');
        }
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    const HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
    const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);

    /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    const _checkValidNamespace = function _checkValidNamespace(element) {
      let parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      const tagName = stringToLowerCase(element.tagName);
      const parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    const _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        getParentNode(node).removeChild(node);
      } catch (_) {
        remove(node);
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    const _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    const _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      let doc = null;
      let leadingWhitespace = null;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        const matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      const body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */
    const _createNodeIterator = function _createNodeIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    const _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    const _isNode = function _isNode(object) {
      return typeof Node === 'function' && object instanceof Node;
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    const _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], hook => {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    const _sanitizeElements = function _sanitizeElements(currentNode) {
      let content = null;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      const tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any occurrence of processing instructions */
      if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
            return false;
          }
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
            return false;
          }
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          const parentNode = getParentNode(currentNode) || currentNode.parentNode;
          const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            const childCount = childNodes.length;
            for (let i = childCount - 1; i >= 0; --i) {
              const childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
        /* Get the element's text content */
        content = currentNode.textContent;
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          content = stringReplace(content, expr, ' ');
        });
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */
    const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      const {
        attributes
      } = currentNode;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes) {
        return;
      }
      const hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      let l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        const attr = attributes[l];
        const {
          name,
          namespaceURI,
          value: attrValue
        } = attr;
        const lcName = transformCaseFunc(name);
        let value = name === 'value' ? attrValue : stringTrim(attrValue);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;

        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
            value = stringReplace(value, expr, ' ');
          });
        }

        /* Is `value` valid for this attribute? */
        const lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      let shadowNode = null;
      const shadowIterator = _createNodeIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let body = null;
      let importedNode = null;
      let currentNode = null;
      let returnNode = null;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Return dirty HTML if DOMPurify cannot run */
      if (!DOMPurify.isSupported) {
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          const tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);
      }

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          serializedHTML = stringReplace(serializedHTML, expr, ' ');
        });
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function () {
      let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      const lcTag = transformCaseFunc(tag);
      const lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 70413:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42391:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pe": function() { return /* binding */ Ye; },
/* harmony export */   "rY": function() { return /* binding */ $e; }
/* harmony export */ });
/* unused harmony exports GroupChannelCollection, MembershipFilter, PublicGroupChannelListQuery, ScheduledMessageListQuery */
/* harmony import */ var _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34182);
/* harmony import */ var _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18490);
/* harmony import */ var _lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4500);
/* harmony import */ var _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77522);
/* harmony import */ var _lib_bundle_123134d8_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73235);
var De,Pe={},He=function(){function t(t){var n=t._iid,a=t.limit,r=void 0===a?100:a,o=this;this.ref=0,this._iid=n,this._limit=r;var l,u=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),c=u.sdkState,d=u.dispatcher,p=u.logger,m=u.cacheContext,C=u.statManager;this._metadataKey=(l=c.userId,"sendbird:".concat(l,"@groupchannel/sync.meta"));var b=function(e){return"sendbird:".concat(e,"@groupchannel/sync")}(c.userId);this._sync=new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.S(b,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(o,void 0,void 0,(function(){var e,t,n,a,r,i,o,l,u,h,d,f,b,S,M,w;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){switch(s.label){case 0:return e={hasNext:!0,nextToken:""},[4,this.loadMetadata()];case 1:if(s.sent(),p.debug("channel background sync from",null===(u=this._metadata)||void 0===u?void 0:u.token),null===(h=this._metadata)||void 0===h?void 0:h.completed)return[3,14];t={includeEmpty:!0,includeMetaData:!0,order:_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHRONOLOGICAL},s.label=2;case 2:if(s.trys.push([2,9,12,13]),t.order!==_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.LATEST_LAST_MESSAGE)return[3,6];s.label=3;case 3:return s.trys.push([3,5,,6]),[4,m.preference.get((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.K)(c.appId))];case 4:return n=s.sent(),t.includeChatNotification=Boolean(n),[3,6];case 5:return s.sent(),t.includeChatNotification=!1,[3,6];case 6:return[4,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid).getMyGroupChannels(null!==(f=null===(d=this._metadata)||void 0===d?void 0:d.token)&&void 0!==f?f:"",t,this._limit,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.SYNC_CHANNEL_BACKGROUND)];case 7:return a=s.sent(),r=a.channels,i=a.token,e.hasNext=r.length>=this._limit&&!!i,e.nextToken=i,this._metadata&&(this._metadata.token=i,(l=this._metadata.range).extends.apply(l,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.p)([],(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.q)(r.map((function(e){return e.createdAt}))),!1)),this._metadata.completed=!e.hasNext),p.debug("channel background sync progress",e),[4,this.saveMetadata()];case 8:return s.sent(),[3,13];case 9:return o=s.sent(),p.debug("channel background sync error",o),o instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s&&o.isInvalidTokenError?[4,this.clearMetaData()]:[3,11];case 10:s.sent(),s.label=11;case 11:throw o;case 12:return C.put(new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b9({type:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ba.FEATURE_LOCALCACHE_EVENT,ts:Date.now(),data:{channel_url:"",measured_on:"channel_back_sync",event:"cache_fetch",max_db_size:null!==(S=null===(b=m.localCacheConfig)||void 0===b?void 0:b.maxSize)&&void 0!==S?S:0,use_local_cache:m.localCacheEnabled,starting_point:0,message_init_policy:null!==(w=null===(M=t.order)||void 0===M?void 0:M.toString())&&void 0!==w?w:"",collection_id:c.userId}})),[7];case 13:return[3,15];case 14:e.hasNext=!1,e.nextToken="",s.label=15;case 15:return[2,e]}}))}))})),this._connectionEventContext=d.on((function(e){if(e instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.D)if(e.stateType===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.CONNECTED)o.resume();else o.pause()}))}return t.of=function(e){return Pe[e]||(Pe[e]=new t({_iid:e})),Pe[e].ref++,Pe[e]},t.clear=function(e){Pe[e]&&(Pe[e].close(),delete Pe[e])},Object.defineProperty(t.prototype,"range",{get:function(){var e,t;return null!==(t=null===(e=this._metadata)||void 0===e?void 0:e.range)&&void 0!==t?t:new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.T({})},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"completed",{get:function(){var e;return!!(null===(e=this._metadata)||void 0===e?void 0:e.completed)},enumerable:!1,configurable:!0}),t.prototype.loadMetadata=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return this._metadata?[3,2]:[4,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).cacheContext.preference.get(this._metadataKey)];case 1:e=t.sent(),this._metadata={token:e?e.token:"",range:new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.T(e?e.range:{top:Number.MAX_SAFE_INTEGER,bottom:0}),completed:!!e&&e.completed},t.label=2;case 2:return[2,this._metadata]}}))}))},t.prototype.saveMetadata=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return this._metadata?[4,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).cacheContext.preference.set(this._metadataKey,this._metadata)]:[3,2];case 1:return e.sent(),[2,!0];case 2:return[2,!1]}}))}))},t.prototype.clearMetaData=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).cacheContext.preference.remove(this._metadataKey)];case 1:return e.sent(),this._metadata=void 0,[2]}}))}))},t.prototype.resume=function(){var e,t,n=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),a=n.logger;n.sessionManager.session.hasSession&&(a.debug("channel background sync resume()"),this._sync.start(null!==(t=null===(e=this._metadata)||void 0===e?void 0:e.token)&&void 0!==t?t:""))},t.prototype.pause=function(){_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).logger.debug("channel background sync stop()"),this._sync.stop()},t.prototype.close=function(){this.ref--,this.ref<=0&&(this.ref=0,this.pause(),this._connectionEventContext.close(),delete Pe[this._iid])},t}(),Re={},Ve=function(){function t(t){var n=t._iid,a=this;this.ref=0,this._iid=n;var r,o=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),l=o.logger,u=o.sdkState,c=o.dispatcher,d=o.cacheContext,p=o.statManager;this._metadataKey=(r=u.userId,"sendbird:".concat(r,"@groupchannel/changelogs.meta")),this._subscribers=new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.E;var m=function(e){return"sendbird:".concat(e,"@groupchannel/changelogs")}(u.userId);this._sync=new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.S(m,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(a,void 0,void 0,(function(){var e,t,n,a,r,i,o,c,h,f,m,y;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){switch(s.label){case 0:return e={hasNext:!0,nextToken:0},[4,this.loadMetadata()];case 1:s.sent(),l.debug("channel changelog sync from",null===(f=this._metadata)||void 0===f?void 0:f.token),s.label=2;case 2:s.trys.push([2,9,,12]),t={includeEmpty:!0,includeMetaData:!0},s.label=3;case 3:return s.trys.push([3,5,,6]),[4,d.preference.get((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.K)(u.appId))];case 4:return n=s.sent(),t.includeChatNotification=Boolean(n),[3,6];case 5:return s.sent(),t.includeChatNotification=!1,[3,6];case 6:return[4,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid).getMyGroupChannelChangeLogs(null!==(y=null===(m=this._metadata)||void 0===m?void 0:m.token)&&void 0!==y?y:"",t,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.SYNC_CHANNEL_CHANGELOGS)];case 7:return a=s.sent(),r=a.updatedChannels,i=a.deletedChannelUrls,o=a.hasMore,c=a.token,this._subscribers.dispatch("progress",{updatedChannels:r,deletedChannelUrls:i,hasMore:o,token:c}),e.hasNext=o,e.nextToken=c,this._metadata&&(this._metadata.token=c),l.debug("channel changelog sync progress",e),[4,this.saveMetadata()];case 8:return s.sent(),d.localCacheEnabled&&p.put(new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b9({type:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ba.FEATURE_LOCALCACHE_EVENT,ts:Date.now(),data:{channel_url:"",measured_on:"channel_change_log_sync",event:r.length>0||i.length>0?"cache_miss":"cache_hit",max_db_size:r.length,use_local_cache:d.localCacheEnabled,starting_point:0,message_init_policy:i.length.toString(),collection_id:u.userId}})),[3,12];case 9:return h=s.sent(),l.debug("channel changelog sync error",h),h instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s&&h.isInvalidTokenError?[4,this.clearMetadata()]:[3,11];case 10:s.sent(),s.label=11;case 11:throw h;case 12:return[2,e]}}))}))})),this._sync.on("stop",(function(){a._subscribers.dispatch("pause")})),this._connectionEventContext=c.on((function(e){if(e instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.D)if(e.stateType===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.CONNECTED)a.resume();else a.pause()}))}return t.of=function(e){return Re[e]||(Re[e]=new t({_iid:e})),Re[e].ref++,Re[e]},t.clear=function(e){Re[e]&&(Re[e].close(),delete Re[e])},Object.defineProperty(t.prototype,"isRunning",{get:function(){return this._sync.isRunning},enumerable:!1,configurable:!0}),t.prototype.loadMetadata=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,n,a;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(r){switch(r.label){case 0:return this._metadata?[3,2]:(e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),t=e.cacheContext,n=e.firstConnectedAt,[4,t.preference.get(this._metadataKey)]);case 1:a=r.sent(),this._metadata={token:a?a.token:n},r.label=2;case 2:return[2,this._metadata]}}))}))},t.prototype.saveMetadata=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return this._metadata?[4,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).cacheContext.preference.set(this._metadataKey,this._metadata)]:[3,2];case 1:return e.sent(),[2,!0];case 2:return[2,!1]}}))}))},t.prototype.clearMetadata=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).cacheContext.preference.remove(this._metadataKey)];case 1:return e.sent(),this._metadata=void 0,[2]}}))}))},t.prototype.on=function(e,t){return this._subscribers.on(e,t)},t.prototype.resume=function(){_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).sessionManager.session.hasSession&&this._sync.start(0)},t.prototype.pause=function(){this._sync.stop()},t.prototype.close=function(){this.ref--,this.ref<=0&&(this.ref=0,this.pause(),this._connectionEventContext.close(),delete Re[this._iid])},t}(),Ke=function(e,t){return e.findIndex((function(e){return e.isIdentical(t)}))},ze=function(e,t,n){if(e.length>0){for(var a=Ke(e,t),r=0,i=e.length-1,s=Math.floor((r+i)/2);r<i;){var o=Qe(e[s],t,n);if(o>0)i=s,s=Math.floor((r+i)/2);else{if(!(o<0))return{place:s,oldPosition:a};r=s+1,s=Math.floor((r+i)/2)}}return{place:Qe(e[s],t,n)>=0?s:s+1,oldPosition:a}}return{place:e.length,oldPosition:-1}},Qe=function(e,t,n){switch(n){case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.LATEST_LAST_MESSAGE:return e.lastMessage&&t.lastMessage?0===(a=t.lastMessage.createdAt-e.lastMessage.createdAt)?t.createdAt-e.createdAt:a:e.lastMessage?-1:t.lastMessage?1:t.createdAt-e.createdAt;case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHRONOLOGICAL:return t.createdAt-e.createdAt;case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHANNEL_NAME_ALPHABETICAL:var a;return 0===(a=e.name.localeCompare(t.name))?e.createdAt-t.createdAt:a;default:return 0}},je=function(){function t(t,n){var a=n.filter,r=void 0===a?new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.a:a,o=n.order,l=void 0===o?_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.LATEST_LAST_MESSAGE:o,u=n.limit,c=void 0===u?_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_3__.Q:u,d=n.includeChangesOnInitialLoad,p=void 0!==d&&d,_=this;this.channels=[],this._isInitialized=!1,this._iid=t,this._key="gcc-".concat((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.n)()),this._isDisposed=!1,this._isGetRemoteChannelsSucceeded=!0,this._includeChangesOnInitialLoad=p,this.filter=r,this.order=l,this._hasMore=!0,this._token="",this._limit=c;var v=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),m=v.sdkState,g=v.cacheContext,y=v.dispatcher;g.localCacheEnabled&&(this._backgroundSync=He.of(t),this._backgroundSync.resume()),this._changelogSync=Ve.of(t),this._changelogSync.resume(),_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid).subscribeChannelEvent(this._key,{onUpdate:function(e,t){var n=t.source;if((0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.s)(n)){var a=e.filter((function(e){return _.filter.match(e,m.userId)})),r=e.filter((function(e){return!_.filter.match(e,m.userId)})).map((function(e){return e.url}));a.length>0&&_._addChannelsToView(a,t),r.length>0&&_._removeChannelsFromView(r,t)}},onRemove:function(e,t){_._removeChannelsFromView(e,t)}}),y.on((function(t){t instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.D&&(t.stateType===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.CONNECTED?_._isGetRemoteChannelsSucceeded||(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(_,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._revokeLoadMore()];case 1:return e.sent(),[2]}}))})):t.stateType===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.LOGOUT&&_.dispose())}))}return Object.defineProperty(t.prototype,"hasMore",{get:function(){return!this._isDisposed&&this._hasMore},enumerable:!1,configurable:!0}),t.prototype.setGroupChannelCollectionHandler=function(e){this._handler=e},t.prototype._addChannelsToView=function(t,n,a){var r,i,o,l,u=this;void 0===a&&(a=!1);var c=[],h=[],d=[];try{for(var p=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(t),f=p.next();!f.done;f=p.next()){var _=f.value,v=Ke(this.channels,_);v>=0&&this.channels.splice(v,1);var m=ze(this.channels,_,this.order).place;if(v<0)m===this.channels.length?!a&&this._hasMore||(c.push(_),this.channels.push(_)):(c.push(_),this.channels.splice(m,0,_));else switch(n.source){case _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.EVENT_CHANNEL_UPDATED:case _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.EVENT_MESSAGE_RECEIVED:case _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.SYNC_CHANNEL_CHANGELOGS:case _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.EVENT_MESSAGE_SENT:this.order===_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHANNEL_NAME_ALPHABETICAL&&this._hasMore&&m===this.channels.length?d.push(_):(this.channels.splice(m,0,_),h.push(_));break;default:this.channels.splice(m,0,_),h.push(_)}}}catch(e){r={error:e}}finally{try{f&&!f.done&&(i=p.return)&&i.call(p)}finally{if(r)throw r.error}}if(d.length>0)try{for(var g=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(d),y=g.next();!y.done;y=g.next()){_=y.value;var C=Ke(this.channels,_);-1!==C&&this.channels.splice(C,1)}}catch(e){o={error:e}}finally{try{y&&!y.done&&(l=g.return)&&l.call(g)}finally{if(o)throw o.error}}(0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.s)(n.source)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(u,void 0,void 0,(function(){var e,t,a;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(r){return c.length>0&&(null===(e=this._handler)||void 0===e?void 0:e.onChannelsAdded)&&this._handler.onChannelsAdded(n,c),h.length>0&&(null===(t=this._handler)||void 0===t?void 0:t.onChannelsUpdated)&&this._handler.onChannelsUpdated(n,h),d.length>0&&(null===(a=this._handler)||void 0===a?void 0:a.onChannelsDeleted)&&this._handler.onChannelsDeleted(n,d.map((function(e){return e.url}))),[2]}))}))}))},t.prototype._removeChannelsFromView=function(t,n){var a,r,i=this,o=[],l=function(e){var t=u.channels.findIndex((function(t){return t.url===e}));t>=0&&(o.push(u.channels[t].url),u.channels.splice(t,1))},u=this;try{for(var c=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(t),h=c.next();!h.done;h=c.next()){l(h.value)}}catch(e){a={error:e}}finally{try{h&&!h.done&&(r=c.return)&&r.call(c)}finally{if(a)throw a.error}}return (0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.s)(n.source)&&o.length>0&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(i,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){return(null===(e=this._handler)||void 0===e?void 0:e.onChannelsDeleted)&&this._handler.onChannelsDeleted(n,o),[2]}))}))})),o},t.prototype._getLocalChannels=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){switch(n.label){case 0:return e=_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid),t=this.channels.length>0?function(e,t){var n,a,r,i;switch(t){case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.LATEST_LAST_MESSAGE:return null!==(a=null===(n=e.lastMessage)||void 0===n?void 0:n.createdAt)&&void 0!==a?a:e.createdAt;case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHRONOLOGICAL:return e.createdAt;case _lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.G.CHANNEL_NAME_ALPHABETICAL:return e.name;default:return null!==(i=null===(r=e.lastMessage)||void 0===r?void 0:r.createdAt)&&void 0!==i?i:e.createdAt}}(this.channels[this.channels.length-1],this.order):null,[4,e.getChannelsFromCache(t,this.filter,this.order,this._limit,t?this.channels[this.channels.length-1].url:void 0)];case 1:return[2,n.sent()]}}))}))},t.prototype._getRemoteChannels=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,n;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(a){switch(a.label){case 0:return[4,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid).getMyGroupChannels(this._token,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},this.filter),{userIdsFilter:this.filter.userIdsFilter,searchFilter:this.filter.searchFilter,order:this.order})),this._limit)];case 1:return e=a.sent(),t=e.channels,n=e.token,this._token=n,this._hasMore=!!n,[2,t]}}))}))},t.prototype._revokeLoadMore=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:if(this._isDisposed)return[2];t.label=1;case 1:return t.trys.push([1,3,,4]),[4,this._getRemoteChannels()];case 2:return e=t.sent(),this._isGetRemoteChannelsSucceeded=!0,this._addChannelsToView(e,{source:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.REQUEST_CHANNEL},!0),[3,4];case 3:return t.sent(),this._isGetRemoteChannelsSucceeded=!1,[3,4];case 4:return[2]}}))}))},t.prototype.loadMore=function(){var t;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,a,r,o,l,u,c,h,d,p,f,_,m,y,C,b,S,M,E,w=this;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(L){switch(L.label){case 0:if(this._isDisposed)throw new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s({code:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a8.COLLECTION_DISPOSED,message:"Collection has been disposed."});return n=null,this._includeChangesOnInitialLoad&&0===this.channels.length&&this._changelogSync.isRunning?[4,new Promise((function(e){w._changelogSyncSubscriberContext=w._changelogSync.on("progress",(function(t){return e(t)})).on("pause",(function(){return e(null)}))}))]:[3,2];case 1:n=L.sent(),null===(t=this._changelogSyncSubscriberContext)||void 0===t||t.close(),L.label=2;case 2:return a=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid),r=a.cacheContext,o=a.connectionManager,l=a.statManager,this._isInitialized?[3,5]:(this._isInitialized=!0,r.localCacheEnabled?[4,this._backgroundSync.loadMetadata()]:[3,4]);case 3:L.sent(),L.label=4;case 4:l.put(new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bb({type:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ba.FEATURE_LOCALCACHE,data:{use_local_cache:r.localCacheEnabled,collection_interface:{group_channel:!0}}})),L.label=5;case 5:return u=[],this._hasMore?!r.localCacheEnabled||o.isConnected&&!this._backgroundSync.completed?[3,7]:[4,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.B)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(w,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._getLocalChannels()];case 1:return u=e.sent(),[2]}}))}))}))]:[3,11];case 6:return L.sent(),this._hasMore=u.length>=this._limit,[3,10];case 7:return L.trys.push([7,9,,10]),[4,this._getRemoteChannels()];case 8:return u=L.sent(),this._isGetRemoteChannelsSucceeded=!0,[3,10];case 9:return L.sent(),this._isGetRemoteChannelsSucceeded=!1,[3,10];case 10:this._addChannelsToView(u,{source:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.REQUEST_CHANNEL},!0),L.label=11;case 11:if(n){try{for(c=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(n.updatedChannels),h=c.next();!h.done;h=c.next())d=h.value,(C=Ke(u,d))>=0?u[C]=d:(p=ze(u,d,this.order).place,u.splice(p,0,d))}catch(e){b={error:e}}finally{try{h&&!h.done&&(S=c.return)&&S.call(c)}finally{if(b)throw b.error}}f=u.map((function(e){return e.url}));try{for(_=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(n.deletedChannelUrls),m=_.next();!m.done;m=_.next())y=m.value,(C=f.indexOf(y))>=0&&(u.splice(C,1),f.splice(C,1))}catch(e){M={error:e}}finally{try{m&&!m.done&&(E=_.return)&&E.call(_)}finally{if(M)throw M.error}}}return[2,u]}}))}))},t.prototype.dispose=function(){var e,t,n;this._isDisposed||(this._isDisposed=!0,this.channels.length>0&&this.channels.splice(0,this.channels.length),null===(e=this._backgroundSync)||void 0===e||e.close(),null===(t=this._changelogSync)||void 0===t||t.close(),null===(n=this._changelogSyncSubscriberContext)||void 0===n||n.close(),_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G.of(this._iid).unsubscribeChannelEvent(this._key))},t}(),We=function(e){function t(t){var n=this,a=t.token,r=t.limit,i=t.order,s=t.includeEmpty,o=t.membershipFilter,l=t.channelNameContainsFilter,u=t.channelUrlsFilter,c=t.customTypesFilter,h=t.customTypeStartsWithFilter,d=t.superChannelFilter,p=t.metadataOrderKeyFilter,f=t.metadataKey,_=t.metadataValues,v=t.metadataValueStartsWith,m=t.includeFrozen,g=t.includeMetaData;return(n=e.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.GET,n.path=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.az,n.params=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)({token:a,limit:r,order:i,show_member:!0,show_read_receipt:!0,show_delivery_receipt:!0,show_empty:s,public_mode:_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.P.PUBLIC,public_membership_mode:o,name_contains:l,channel_urls:u,custom_types:c,custom_type_startswith:h,super_mode:d,metadata_order_key:p,metadata_key:f,metadata_values:_,metadata_value_startswith:v,show_frozen:m,show_metadata:g})),n}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),Be=function(e){function t(t,n){var a=e.call(this,t,n)||this;a.channels=[];var r=n.next,i=n.channels,s=n.ts;return a.token=r,i&&i.length>0&&(a.channels=i.map((function(e){return e.ts=s,new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.b(t,e)}))),a.ts="number"==typeof s?s:0,a}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h);!function(e){e.ALL="all",e.JOINED="joined"}(De||(De={}));var qe=function(t){function n(e,n){var a,r,i,s,o,l,u,c,h,d,p,f,_,v,m=this;return(m=t.call(this,e,n)||this).includeEmpty=!1,m.includeFrozen=!0,m.includeMetaData=!0,m.channelUrlsFilter=null,m.customTypesFilter=null,m.customTypeStartsWithFilter=null,m.channelNameContainsFilter=null,m.membershipFilter=De.ALL,m.superChannelFilter=_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.c.ALL,m.metadataKey=null,m.metadataValues=null,m.metadataOrderKeyFilter=null,m.metadataValueStartsWith=null,m.order=_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.P.CHRONOLOGICAL,m.includeEmpty=null!==(a=n.includeEmpty)&&void 0!==a&&a,m.includeFrozen=null===(r=n.includeFrozen)||void 0===r||r,m.includeMetaData=null===(i=n.includeMetaData)||void 0===i||i,m.channelUrlsFilter=null!==(s=n.channelUrlsFilter)&&void 0!==s?s:null,m.customTypesFilter=null!==(o=n.customTypesFilter)&&void 0!==o?o:null,m.customTypeStartsWithFilter=null!==(l=n.customTypeStartsWithFilter)&&void 0!==l?l:null,m.channelNameContainsFilter=null!==(u=n.channelNameContainsFilter)&&void 0!==u?u:null,m.membershipFilter=null!==(c=n.membershipFilter)&&void 0!==c?c:De.ALL,m.superChannelFilter=null!==(h=n.superChannelFilter)&&void 0!==h?h:_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.c.ALL,m.metadataKey=null!==(d=n.metadataKey)&&void 0!==d?d:null,m.metadataValues=null!==(p=n.metadataValues)&&void 0!==p?p:null,m.metadataOrderKeyFilter=null!==(f=n.metadataOrderKeyFilter)&&void 0!==f?f:null,m.metadataValueStartsWith=null!==(_=n.metadataValueStartsWith)&&void 0!==_?_:null,m.order=null!==(v=n.order)&&void 0!==v?v:_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.P.CHRONOLOGICAL,m}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(n,t),n.prototype._validate=function(){return t.prototype._validate.call(this)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.includeEmpty)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.includeFrozen)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.includeMetaData)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.channelNameContainsFilter,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",this.channelUrlsFilter,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",this.customTypesFilter,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.customTypeStartsWithFilter,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.X)(De,this.membershipFilter)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.X)(_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.c,this.superChannelFilter)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.X)(_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.P,this.order)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.metadataOrderKeyFilter,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.metadataKey,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",this.metadataValues,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.metadataValueStartsWith,!0)},n.prototype.next=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,n,a,r,o,l;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){switch(s.label){case 0:return this._validate()?this._isLoading?[3,3]:(e=[],this._hasNext?(this._isLoading=!0,t=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new We((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},this),{token:this._token}))),[4,t.send(n)]):[3,2]):[3,5];case 1:return a=s.sent(),r=a.as(Be),o=r.channels,l=r.token,this._token=l,this._hasNext=!!l,this._isLoading=!1,[2,o];case 2:return[2,e];case 3:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.queryInProgress;case 4:return[3,6];case 5:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters;case 6:return[2]}}))}))},n}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aO),Ye=function(e){function t(t){void 0===t&&(t={});var n=e.call(this)||this;return Object.keys(t).forEach((function(e){n.hasOwnProperty(e)&&(n[e]=t[e])})),n}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onUserJoined=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onUserLeft=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onUserReceivedInvitation=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onUserDeclinedInvitation=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onChannelHidden=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onUnreadMemberStatusUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onUndeliveredMemberStatusUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onTypingStatusUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onPollUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onPollVoted=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onPollDeleted=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t.onPinnedMessageUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(_lib_bundle_123134d8_js__WEBPACK_IMPORTED_MODULE_4__.B)),Xe=function(e){function t(t){var n=this,a=t.token,r=t.limit,i=t.order,s=t.reverse,o=t.channelUrl,l=t.messageTypeFilter,u=t.scheduledStatus;return(n=e.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.GET,n.path="".concat(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bc),n.params=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)({token:a,limit:r,reverse:s,channel_url:o,order:i,message_type:l,status:u})),n}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),Je=function(e){function t(t,n){var a=e.call(this,t,n)||this;a.scheduledMessages=[];var r=n.next,i=n.scheduled_messages;return a.token=r,a.scheduledMessages=i.map((function(e){return (0,_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_3__.T)(t,e)})),a}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,e),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h),Ze=function(t){function n(e,n){var a,r,i,s,o,l=this;return(l=t.call(this,e,n)||this).channelUrl=null,l.order=null,l.reverse=!1,l.scheduledStatus=null,l.messageTypeFilter=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aq.ALL,l.channelUrl=null!==(a=n.channelUrl)&&void 0!==a?a:null,l.order=null!==(r=n.order)&&void 0!==r?r:null,l.reverse=null!==(i=n.reverse)&&void 0!==i&&i,l.scheduledStatus=null!==(s=n.scheduledStatus)&&void 0!==s?s:null,l.messageTypeFilter=null!==(o=n.messageTypeFilter)&&void 0!==o?o:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aq.ALL,l}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(n,t),n.prototype._validate=function(){return t.prototype._validate.call(this)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.channelUrl,!0)&&((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.X)(_lib_bundle_24f017be_js__WEBPACK_IMPORTED_MODULE_2__.S,this.order)||null===this.order)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.reverse)&&((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_3__.V,this.scheduledStatus)||null===this.scheduledStatus)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.X)(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aq,this.messageTypeFilter)},n.prototype.next=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,n,a,r,o;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){switch(s.label){case 0:return this._validate()?this._isLoading?[3,3]:this._hasNext?(this._isLoading=!0,e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,t=new Xe((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},this),{token:this._token}))),[4,e.send(t)]):[3,2]:[3,5];case 1:return n=s.sent(),a=n.as(Je),r=a.scheduledMessages,o=a.token,this._token=o,this._hasNext=!!o,this._isLoading=!1,[2,r];case 2:return[2,[]];case 3:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.queryInProgress;case 4:return[3,6];case 5:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters;case 6:return[2]}}))}))},n}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aO),$e=function(t){function n(){var e=null!==t&&t.apply(this,arguments)||this;return e.name="groupChannel",e}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(n,t),n.prototype.init=function(e,n){var a=n.sdkState,r=n.dispatcher,i=n.sessionManager,s=n.requestQueue,o=n.logger,l=n.onlineDetector,u=n.cacheContext;t.prototype.init.call(this,e,{sdkState:a,dispatcher:r,sessionManager:i,requestQueue:s,logger:o,onlineDetector:l,cacheContext:u}),this._manager=new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.G(e,{sdkState:a,cacheContext:u,dispatcher:r,sessionManager:i,requestQueue:s,logger:o})},n.prototype.createGroupChannelCollection=function(e){return void 0===e&&(e={}),new je(this._iid,e)},n.prototype.createMyGroupChannelListQuery=function(e){return void 0===e&&(e={}),new _lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.d(this._iid,e)},n.prototype.createPublicGroupChannelListQuery=function(e){return void 0===e&&(e={}),new qe(this._iid,e)},n.prototype.createScheduledMessageListQuery=function(e){return void 0===e&&(e={}),new Ze(this._iid,e)},n.prototype.addGroupChannelHandler=function(e,t){(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e)&&t instanceof Ye).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),this._manager.addHandler(e,t)},n.prototype.removeGroupChannelHandler=function(e){(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),this._manager.removeHandler(e)},n.prototype.removeAllGroupChannelHandlers=function(){this._manager.clearHandler()},n.prototype.buildGroupChannelFromSerializedData=function(e){return this._manager.buildGroupChannelFromSerializedData(e)},n.prototype.buildGroupChannelListQueryFromSerializedData=function(e){return this._manager.buildGroupChannelListQueryFromSerializedData(e)},n.prototype.buildMemberFromSerializedData=function(e){return this._manager.buildMemberFromSerializedData(e)},n.prototype.getChannel=function(t){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",t)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[2,this._manager.getChannel(t)]}))}))},n.prototype.getChannelWithoutCache=function(t){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",t)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[2,this._manager.getChannelWithoutCache(t)]}))}))},n.prototype.getMyGroupChannelChangeLogsByToken=function(t,n){return void 0===n&&(n={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(a){switch(a.label){case 0:return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.e),n),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",t)&&(0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.v)(e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[4,this._manager.getMyGroupChannelChangeLogs(t,e)];case 1:return[2,a.sent()]}}))}))},n.prototype.getMyGroupChannelChangeLogsByTimestamp=function(t,n){return void 0===n&&(n={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(a){switch(a.label){case 0:return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.e),n),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("number",t)&&(0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.v)(e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[4,this._manager.getMyGroupChannelChangeLogs(t,e)];case 1:return[2,a.sent()]}}))}))},n.prototype.getGroupChannelCount=function(t){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.f),t),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.g)(e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[2,this._manager.getGroupChannelCount(e)]}))}))},n.prototype.getUnreadItemCount=function(t){return void 0===t&&(t={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._manager.getUnreadItemCount(t)];case 1:return[2,e.sent()]}}))}))},n.prototype.getTotalUnreadChannelCount=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._manager.getTotalUnreadChannelCount()];case 1:return[2,e.sent()]}}))}))},n.prototype.getTotalUnreadMessageCount=function(t){return void 0===t&&(t={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._manager.getTotalUnreadMessageCount(t)];case 1:return[2,e.sent()]}}))}))},n.prototype.getTotalScheduledMessageCount=function(t){return void 0===t&&(t={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,this._manager.getTotalScheduledMessageCount(t)];case 1:return[2,e.sent()]}}))}))},n.prototype.getSubscribedTotalUnreadMessageCount=function(){return this._manager.getSubscribedTotalUnreadMessageCount()},n.prototype.getSubscribedCustomTypeTotalUnreadMessageCount=function(){return this._manager.getSubscribedCustomTypeTotalUnreadMessageCount()},n.prototype.getSubscribedCustomTypeUnreadMessageCount=function(e){return this._manager.getSubscribedCustomTypeUnreadMessageCount(e)},n.prototype.createChannel=function(t){return void 0===t&&(t={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.h),t),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.i)(e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[2,this._manager.createChannel(e)]}))}))},n.prototype.createDistinctChannelIfNotExist=function(t){return void 0===t&&(t={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.h),t),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.i)(e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),e&&(e.isDistinct=!0),[2,this.createChannel(e)]}))}))},n.prototype.createChannelWithUserIds=function(t,n,a,r,i,o){return void 0===n&&(n=!1),void 0===i&&(i=""),void 0===o&&(o=""),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){return e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_cc71b396_js__WEBPACK_IMPORTED_MODULE_1__.h),{invitedUserIds:t,isDistinct:n,name:a,data:i,customType:o}),"string"==typeof r?e.coverUrl=r:e.coverImage=r,[2,this.createChannel(e)]}))}))},n.prototype.markAsReadAll=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._manager.markAsReadAll(),[2]}))}))},n.prototype.markAsReadWithChannelUrls=function(t){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",t)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),this._manager.markAsReadWithChannelUrls(t),[2]}))}))},n.prototype.markAsDelivered=function(t){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",t)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),[4,this.getChannel(t)];case 1:return[4,e.sent().markAsDelivered()];case 2:return e.sent(),[2]}}))}))},n}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a_);


/***/ }),

/***/ 51947:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W8": function() { return /* binding */ mt; },
  "ZP": function() { return /* binding */ In; }
});

// UNUSED EXPORTS: AppInfo, ApplicationUserListQuery, BannedUserListQuery, BaseChannel, BlockedUserListQuery, CachedChannelInfo, CachedDataClearOrder, ChannelType, CollectionEventSource, ConnectionHandler, ConnectionState, DeviceOsPlatform, Emoji, EmojiCategory, FriendListQuery, LastMessageThreadingPolicy, LocalCacheConfig, LogLevel, MemoryStore, MutedUserListQuery, NotificationInfo, OperatorListQuery, Participant, Plugin, PushTemplate, PushTokenRegistrationState, PushTokenType, PushTriggerOption, ReportCategory, RestrictedUser, RestrictionInfo, RestrictionType, Role, SendbirdChatOptions, SendbirdError, SendbirdErrorCode, SendbirdPlatform, SendbirdProduct, SessionHandler, UIKitConfigInfo, UnreadCountThreadingPolicy, User, UserEventHandler, UserOnlineState

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-1db3fd0b.js
var _bundle_1db3fd0b = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e1a5e3f1.js
var _bundle_e1a5e3f1 = __webpack_require__(4500);
;// CONCATENATED MODULE: ./node_modules/@sendbird/chat/poll.js
var poll_b=function(a){function b(){var t=null!==a&&a.apply(this,arguments)||this;return t.name="poll",t}return (0,_bundle_1db3fd0b.c)(b,a),b.prototype.init=function(t,r){var n=r.sdkState,o=r.dispatcher,i=r.sessionManager,s=r.requestQueue,l=r.logger,u=r.onlineDetector,c=r.cacheContext;a.prototype.init.call(this,t,{sdkState:n,dispatcher:o,sessionManager:i,requestQueue:s,logger:l,onlineDetector:u,cacheContext:c}),this._manager=new _bundle_1db3fd0b.aN(t,{sdkState:n,dispatcher:o,sessionManager:i,requestQueue:s,logger:l,onlineDetector:u,cacheContext:c})},b.prototype.create=function(t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b.b)(this,(function(r){return e=(0,_bundle_1db3fd0b.g)((0,_bundle_1db3fd0b.g)({},_bundle_1db3fd0b.b0),t),(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.b1)(e)).throw(_bundle_1db3fd0b.s.invalidParameters),[2,this._manager.create(e)]}))}))},b.prototype.get=function(t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b.b)(this,(function(r){return e=(0,_bundle_1db3fd0b.g)((0,_bundle_1db3fd0b.g)({},_bundle_1db3fd0b.b2),t),(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.b3)(e)).throw(_bundle_1db3fd0b.s.invalidParameters),[2,this._manager.get(e)]}))}))},b.prototype.getOption=function(t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b.b)(this,(function(r){return e=(0,_bundle_1db3fd0b.g)((0,_bundle_1db3fd0b.g)({},_bundle_1db3fd0b.b4),t),(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.b5)(e)).throw(_bundle_1db3fd0b.s.invalidParameters),[2,this._manager.getOption(e)]}))}))},b.prototype.buildPollFromSerializedData=function(t){return this._manager.buildPollFromSerializedData(t)},b}(_bundle_1db3fd0b.a_);

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-24f017be.js
var _bundle_24f017be = __webpack_require__(77522);
;// CONCATENATED MODULE: ./node_modules/@sendbird/chat/lib/__bundle-31d4ecef.js
var _bundle_31d4ecef_e=function(t){return["-lastMessageUpdatedAt","-createdAt","syncIndex"]},_bundle_31d4ecef_r=function(n){function e(){return null!==n&&n.apply(this,arguments)||this}return (0,_bundle_1db3fd0b.c)(e,n),e}(_bundle_1db3fd0b.b8);

;// CONCATENATED MODULE: ./node_modules/@sendbird/chat/index.js
var vt=function(e){this.key=e.key,this.url=e.url},gt=function(e){this.id=e.id,this.name=e.name,this.url=e.url,this.emojis=e.emojis?e.emojis.map((function(e){return new vt(e)})):[]},mt=function(e){this.emojiHash=e.emoji_hash||"",this.emojiCategories=e.emoji_categories?e.emoji_categories.map((function(e){return new gt(e)})):[]},bt={profileImage:void 0,profileUrl:void 0,nickname:void 0},_t=function(e){return function(t,n){return (0,_bundle_1db3fd0b._)(void 0,void 0,void 0,(function(){var r,s,o,c;return (0,_bundle_1db3fd0b.b)(this,(function(d){switch(d.label){case 0:switch(t){case 1:case 2:case 3:case 4:return[3,1];case 5:return[3,2];case 6:return[3,4]}return[3,11];case 1:return n(),[3,12];case 2:return[4,e.reset()];case 3:return d.sent(),n(),[3,12];case 4:return d.trys.push([4,9,,10]),r=function(e){return{v2:function(){return (0,_bundle_1db3fd0b._)(void 0,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return[4,e.commitSchema([{collectionName:_bundle_e1a5e3f1.a,keyName:_bundle_e1a5e3f1.b,index:[(0,_bundle_24f017be.g)(_bundle_24f017be.G.LATEST_LAST_MESSAGE),(0,_bundle_24f017be.g)(_bundle_24f017be.G.CHRONOLOGICAL),(0,_bundle_24f017be.g)(_bundle_24f017be.G.CHANNEL_NAME_ALPHABETICAL)]},{collectionName:_bundle_e1a5e3f1.N,keyName:_bundle_e1a5e3f1.c,index:[(0,_bundle_e1a5e3f1.g)(_bundle_e1a5e3f1.M.CHANNEL_LATEST),(0,_bundle_e1a5e3f1.g)(_bundle_e1a5e3f1.M.NEWEST_CHILD_MESSAGE)]},{collectionName:_bundle_e1a5e3f1.d,keyName:_bundle_e1a5e3f1.e,index:[(0,_bundle_e1a5e3f1.g)(_bundle_e1a5e3f1.M.CHANNEL_LATEST),(0,_bundle_e1a5e3f1.g)(_bundle_e1a5e3f1.M.NEWEST_CHILD_MESSAGE)]},{collectionName:_bundle_e1a5e3f1.f,keyName:_bundle_e1a5e3f1.h}])];case 1:return[2,t.sent()]}}))}))},v3:function(){return (0,_bundle_1db3fd0b._)(void 0,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return[4,e.commitSchema([{collectionName:_bundle_e1a5e3f1.i,keyName:_bundle_e1a5e3f1.j,index:[_bundle_31d4ecef_e("latest_last_message")]}])];case 1:return[2,t.sent()]}}))}))},v4:function(){return (0,_bundle_1db3fd0b._)(void 0,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return[4,e.commitSchema([{collectionName:_bundle_e1a5e3f1.k,keyName:_bundle_e1a5e3f1.l,index:[(0,_bundle_e1a5e3f1.m)()]}])];case 1:return[2,t.sent()]}}))}))}}}(e),s=r.v2,o=r.v3,c=r.v4,[4,s()];case 5:return d.sent(),[4,o()];case 6:return d.sent(),[4,c()];case 7:return d.sent(),[4,e.collection(_bundle_e1a5e3f1.N).removeIf({where:{channelType:_bundle_1db3fd0b.C.OPEN}})];case 8:case 9:return d.sent(),[3,10];case 10:return n(),[3,12];case 11:n(),d.label=12;case 12:return[2]}}))}))}},yt=function(){return"undefined"!=typeof document?document.visibilityState:"visible"},wt=function(e){function t(t){var n=t.getVisibilityState,r=void 0===n?yt:n,i=t.initialState,s=void 0===i?"visible":i,o=t.isEnabled,a=void 0===o||o,u=t.pauseCheckDelay,c=void 0===u?3e4:u,d=e.call(this)||this;return d._pauseCheckDelay=3e4,d._currentState="visible",d._getVisibilityState=r,d._pauseCheckDelay=c,d._currentState=s,d._isEnabled=a,d._boundToggleState=d._toggleState.bind(d),d}return (0,_bundle_1db3fd0b.c)(t,e),Object.defineProperty(t.prototype,"currentState",{get:function(){return this._currentState},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isAvailable",{get:function(){return"undefined"!=typeof window&&!!window.addEventListener&&!!window.removeEventListener},enumerable:!1,configurable:!0}),t.prototype._toggleState=function(){var e=this,t=this._getVisibilityState();"hidden"!==t?"hidden"===this._currentState&&(this._pauseDelayTimer&&(clearTimeout(this._pauseDelayTimer),this._pauseDelayTimer=void 0),this.dispatch("resume")):"hidden"!==this._currentState&&(this._pauseDelayTimer=setTimeout((function(){e._pauseDelayTimer=void 0,e.dispatch("pause")}),this._pauseCheckDelay)),this._currentState=t},t.prototype.start=function(){this._isEnabled&&this.isAvailable&&(this._boundToggleState=this._toggleState.bind(this),window.addEventListener("visibilitychange",this._boundToggleState,{capture:!0}))},t.prototype.stop=function(){this._isEnabled&&this.isAvailable&&this._boundToggleState&&window.removeEventListener("visibilitychange",this._boundToggleState,{capture:!0})},t}(_bundle_1db3fd0b.E),kt=function(){function e(e){var t=e.logger,n=e.connectionDelegate,r=void 0===n?null:n,i=this;this._onlineWorker=function(){var e;return null===(e=i.connectionDelegate)||void 0===e?void 0:e.reconnect()},this._offlineWorker=function(){var e;return null===(e=i.connectionDelegate)||void 0===e?void 0:e.disconnect()},this.unsubscribes=[],this._onlineListener=function(e){if(i.isAvailableOnWeb)return window.addEventListener("online",e),function(){return window.removeEventListener("online",e,!1)}},this._offlineListener=function(e){if(i.isAvailableOnWeb)return window.addEventListener("offline",e),function(){return window.removeEventListener("offline",e,!1)}},this.logger=t,r&&(this.connectionDelegate=r)}return Object.defineProperty(e.prototype,"isAvailableOnWeb",{get:function(){return"undefined"!=typeof window&&!!window.addEventListener&&"ononline"in window&&"onoffline"in window&&"undefined"!=typeof navigator&&void 0!==navigator.onLine},enumerable:!1,configurable:!0}),e.prototype.setOnlineListener=function(e){Boolean(e)&&"function"==typeof e&&(this._onlineListener=e)},e.prototype.setOfflineListener=function(e){Boolean(e)&&"function"==typeof e&&(this._offlineListener=e)},e.prototype.start=function(){this.unsubscribes=[this._onlineListener(this._onlineWorker),this._offlineListener(this._offlineWorker)]},e.prototype.stop=function(){var e=this;this.unsubscribes.forEach((function(t){try{null==t||t()}catch(t){e.logger.warn(t.message)}})),this.unsubscribes=[]},e.prototype.isOnline=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return this.isAvailableOnWeb?[2,navigator.onLine]:[2,new Promise((function(e){fetch("https://www.google.com",{method:_bundle_1db3fd0b.A.GET,mode:"no-cors"}).then((function(){return e(!0)})).catch((function(){return e(!1)}))}))]}))}))},e}(),St=function(e){function t(t){var n=t.userId,r=t.nickname,i=t.profileUrl,s=t.profileImage,o=t.preferredLanguages,a=e.call(this)||this;return a.method=_bundle_1db3fd0b.A.PUT,a.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n)),a.params=(0,_bundle_1db3fd0b.e)((0,_bundle_1db3fd0b.u)({nickname:r,profile_url:i,profile_file:s,preferred_languages:o})),a}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),It=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.user=new _bundle_1db3fd0b.U(t,(0,_bundle_1db3fd0b.g)({},n)),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Ct=function(e){function t(t){var n=t.userId,r=t.token,i=t.deviceOS,s=t.deviceManufacturer,o=t.systemPushEnabled,a=e.call(this)||this;return a.method=_bundle_1db3fd0b.A.POST,a.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/apns"),a.params=(0,_bundle_1db3fd0b.e)({apns_device_token:r,always_push:!0,device_os:i,device_manufacturer:s,system_push_enabled:o}),a}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.token=n.token,r.type=n.type?_bundle_1db3fd0b.P[n.type.toLowerCase()]:_bundle_1db3fd0b.P.UNKNOWN,r.user=new _bundle_1db3fd0b.U(t,n.user),r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Et=function(e){function t(t){var n=t.userId,r=t.token,i=t.deviceOS,s=t.deviceManufacturer,o=t.systemPushEnabled,a=e.call(this)||this;return a.method=_bundle_1db3fd0b.A.POST,a.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/gcm"),a.params=(0,_bundle_1db3fd0b.e)({gcm_reg_token:r,always_push:!0,device_os:i,device_manufacturer:s,system_push_enabled:o}),a}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.token=n.token,r.type=n.type?_bundle_1db3fd0b.P[n.type.toLowerCase()]:_bundle_1db3fd0b.P.UNKNOWN,r.user=new _bundle_1db3fd0b.U(t,n.user),r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Tt=function(e){function t(t){var n=t.userId,r=t.token,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.DELETE,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/apns/").concat(encodeURIComponent(r)),i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.token=n.token,r.user=new _bundle_1db3fd0b.U(t,n.user),r.lastDeletedAt=n.device_token_last_deleted_at,r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Pt=function(e){function t(t){var n=t.userId,r=t.token,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.DELETE,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/gcm/").concat(encodeURIComponent(r)),i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.token=n.token,r.user=new _bundle_1db3fd0b.U(t,n.user),r.lastDeletedAt=n.device_token_last_deleted_at,r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Dt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.DELETE,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/apns"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.type=n.type?_bundle_1db3fd0b.P[n.type.toLowerCase()]:_bundle_1db3fd0b.P.UNKNOWN,r.user=new _bundle_1db3fd0b.U(t,n.user),r.lastDeletedAt=n.device_token_last_deleted_at,r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Ut=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.DELETE,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/gcm"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.type=n.type?_bundle_1db3fd0b.P[n.type.toLowerCase()]:_bundle_1db3fd0b.P.UNKNOWN,r.user=new _bundle_1db3fd0b.U(t,n.user),r.lastDeletedAt=n.device_token_last_deleted_at,r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Ot=function(e){function t(t){var n=t.userId,r=t.type,i=t.token,s=t.ts,o=e.call(this)||this;return o.method=_bundle_1db3fd0b.A.GET,o.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/").concat(encodeURIComponent(r),"/device_tokens"),o.params={created_ts:s,token:i},o}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),At=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.pushTokens={type:n.type?_bundle_1db3fd0b.P[n.type.toLowerCase()]:_bundle_1db3fd0b.P.UNKNOWN,deviceTokens:n.device_tokens,hasMore:n.has_more,token:n.token},r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Nt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/channel_invitation_preference"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Mt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.autoAccept=n.auto_accept,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Lt=function(e){function t(t){var n=t.userId,r=t.willAutoAccept,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.PUT,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/channel_invitation_preference"),i.params={auto_accept:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Rt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.autoAccept=n.auto_accept,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),zt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Qt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.preference={doNotDisturbOn:n.do_not_disturb,startHour:n.start_hour,startMin:n.start_min,endHour:n.end_hour,endMin:n.end_min,timezone:n.timezone},r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),jt=function(e){function t(t){var n=t.userId,r=t.doNotDisturbOn,i=t.startHour,s=t.startMin,o=t.endHour,a=t.endMin,u=t.timezone,c=e.call(this)||this;return c.method=_bundle_1db3fd0b.A.PUT,c.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),c.params={do_not_disturb:r,start_hour:i,start_min:s,end_hour:o,end_min:a,timezone:u},c}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Ft=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.preference={doNotDisturbOn:n.do_not_disturb,startHour:n.start_hour,startMin:n.start_min,endHour:n.end_hour,endMin:n.end_min,timezone:n.timezone},r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),qt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Ht=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.snoozePeriod={isSnoozeOn:n.snooze_enabled},"number"==typeof n.snooze_start_ts&&(r.snoozePeriod.startTs=n.snooze_start_ts),"number"==typeof n.snooze_end_ts&&(r.snoozePeriod.endTs=n.snooze_end_ts),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),xt=function(e){function t(t){var n=t.userId,r=t.snoozeOn,i=t.startTs,s=t.endTs,o=e.call(this)||this;return o.method=_bundle_1db3fd0b.A.PUT,o.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),o.params={snooze_enabled:r,snooze_start_ts:i,snooze_end_ts:s},o}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Kt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.snoozePeriod={isSnoozeOn:n.snooze_enabled},"number"==typeof n.snooze_start_ts&&(r.snoozePeriod.startTs=n.snooze_start_ts),"number"==typeof n.snooze_end_ts&&(r.snoozePeriod.endTs=n.snooze_end_ts),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Gt=function(e){function t(t){var n=t.userId,r=t.blockedUserId,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.POST,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/block"),i.params={target_id:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.user=new _bundle_1db3fd0b.U(t,n),r}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Wt=function(e){function t(t){var n=t.userId,r=t.unblockedUserId,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.DELETE,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/block/").concat(encodeURIComponent(r)),i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(){return null!==e&&e.apply(this,arguments)||this}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var Vt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Bt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.pushTriggerOption=n.push_trigger_option,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Jt=function(e){function t(t){var n=t.userId,r=t.pushTriggerOption,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.PUT,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push_preference"),i.params={push_trigger_option:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),Yt=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.pushTriggerOption=n.push_trigger_option,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Zt=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/template"),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),$t=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.name=n.name,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),Xt=function(e){function t(t){var n=t.userId,r=t.templateName,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.PUT,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/push/template"),i.params={name:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),en=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.name=n.name,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),tn=function(e){function t(t){var n=t.userId,r=t.token,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.GET,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/friends/changelogs"),i.params={token:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),nn=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.changelogs={addedUsers:n.added.map((function(e){return new _bundle_1db3fd0b.U(t,e)})),updatedUsers:n.updated.map((function(e){return new _bundle_1db3fd0b.U(t,e)})),deletedUserIds:n.deleted,hasMore:n.has_more,token:n.next},r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),rn=function(e){function t(t){var n=t.userId,r=t.discoveries,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.PUT,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/friend_discoveries"),i.params={friend_discoveries:r.map((function(e){return{friend_discovery_key:e.friendDiscoveryKey,friend_name:e.friendName}}))},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),sn=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.friendDiscoveryRequestId=n.friend_discovery_request_id,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),on=function(e){function t(t){var n=t.userId,r=t.discoveryKeys,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.DELETE,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/friend_discoveries"),i.params={friend_discovery_keys:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(){return null!==e&&e.apply(this,arguments)||this}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var an=function(e){function t(t){var n=t.userId,r=t.userIds,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.POST,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/friends"),i.params={user_ids:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),un=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.users=n.users.map((function(e){return new _bundle_1db3fd0b.U(t,e)})),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),cn=function(e){function t(t){var n=t.userId,r=t.userIds,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.DELETE,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(encodeURIComponent(n),"/friends"),i.params={user_ids:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(){return null!==e&&e.apply(this,arguments)||this}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var dn=function(e){function t(t){var n=t.userId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.d,"/").concat(n,"/allow_friend_discovery"),r.params={},r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),ln=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.allowFriendDiscovery=n.allow_friend_discovery,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),hn=function(e){function t(t){var n=t.userId,r=t.allowFriendDiscovery,i=e.call(this)||this;return i.method=_bundle_1db3fd0b.A.PUT,i.path="".concat(_bundle_1db3fd0b.d,"/").concat(n,"/allow_friend_discovery"),i.params={allow_friend_discovery:r},i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);!function(e){function t(){return null!==e&&e.apply(this,arguments)||this}(0,_bundle_1db3fd0b.c)(t,e)}(_bundle_1db3fd0b.h);var fn,pn=function(e){function t(){var t=e.call(this)||this;return t.method=_bundle_1db3fd0b.A.GET,t.path=_bundle_1db3fd0b.j,t}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),vn=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.emojiContainer=new mt(n),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),gn=function(e){function t(t){var n=t.categoryId,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.j,"/").concat(n),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),mn=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.emojiCategory=new gt(n),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),bn=function(e){function t(t){var n=t.key,r=e.call(this)||this;return r.method=_bundle_1db3fd0b.A.GET,r.path="".concat(_bundle_1db3fd0b.k,"/").concat(n),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),_n=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.emoji=new vt(n),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h),yn=function(e){function t(){var t=e.call(this)||this;return t.method=_bundle_1db3fd0b.A.GET,t.path="".concat(_bundle_1db3fd0b.l),t}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f),wn=function(e){function t(t,n){var r,i=this,s=null!=n?n:{};return(i=e.call(this,t,n)||this).uikitConfiguration={string:JSON.stringify(s),json:s},i.updatedAt=null!==(r=null==n?void 0:n.updated_at)&&void 0!==r?r:0,i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.h);!function(e){e.DELIVERED="DELIVERED",e.CLICKED="CLICKED"}(fn||(fn={}));var kn,Sn=function(e){function t(t){var n=t.deviceToken,r=t.pushTrackingId,i=t.messageId,s=t.allowedPushNotification,o=t.channelKey,a=t.templateKey,u=t.eventType,c=t.notificationEventDeadline,d=e.call(this)||this;return d.method=_bundle_1db3fd0b.A.POST,d.path=_bundle_1db3fd0b.m,d.params=(0,_bundle_1db3fd0b.e)({device_token:n,push_tracking_id:r,message_id:i,allowed_push_notification:s,channel_key:o,template_key:a,event_type:u,notification_event_deadline:c}),d}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.f);var In=function(){function n(e,t,n){var r=this;this._storeInitialized=!1,this._iid=e,this.options=t;var s=_bundle_1db3fd0b.V.of(e),o=s.sdkState,u=s.cacheContext,c=s.dispatcher,d=s.sessionManager,l=s.requestQueue,h=s.logger,f=s.userEventHandlers,p=s.appStateToggleEnabled;this._onlineDetector=new kt({logger:h,connectionDelegate:{reconnect:function(){return (0,_bundle_1db3fd0b._)(r,void 0,void 0,(function(){var t,n,r,i,s,o;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:if(t=_bundle_1db3fd0b.V.of(e),n=t.sdkState,r=t.connectionManager,(i=t.sessionManager).session.hasSession)return[3,5];a.label=1;case 1:return a.trys.push([1,3,,4]),[4,r.connect(i.session.authToken)];case 2:return a.sent(),[3,4];case 3:if(s=a.sent(),(0,_bundle_1db3fd0b.O)(s))throw s;return h.debug("connect failed by reconnect event = ",s),[3,4];case 4:return[3,9];case 5:if("foreground"!==n.appState)return[3,9];a.label=6;case 6:return a.trys.push([6,8,,9]),[4,r.resetAndReconnect()];case 7:return a.sent(),[3,9];case 8:if(o=a.sent(),(0,_bundle_1db3fd0b.O)(o))throw o;return h.debug("resetAndReconnect failed by reconnect event = ",o),[3,9];case 9:return c.dispatch(new _bundle_31d4ecef_r),[2]}}))}))},disconnect:function(){(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(r,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return[4,_bundle_1db3fd0b.V.of(e).connectionManager.disconnect()];case 1:return t.sent(),[2]}}))}))}))}}});var v=new _bundle_24f017be.A(e,{localCacheEnabled:u.localCacheEnabled,enableAutoResend:u.localCacheConfig.enableAutoResend,dispatcher:c,sdkState:o,logger:h});n.forEach((function(t){t.init(e,{sdkState:o,cacheContext:u,dispatcher:c,sessionManager:d,requestQueue:l,logger:h,onlineDetector:r._onlineDetector}),r[t.name]=t})),this._appStateChangeDetector=new wt({isEnabled:p}),this._appStateChangeDetector.on("resume",(function(){h.debug("the page resumes from freeze"),r.setForegroundState()})).on("pause",(function(){h.debug("the page freezes"),r.setBackgroundState()})),c.on((function(t){var n;if(t instanceof _bundle_1db3fd0b.D){if(t.stateType===_bundle_1db3fd0b.F.CONNECTED)v.processNonAutoResendRegisteredPendingMessages()}else if(t instanceof _bundle_1db3fd0b.W){if("USEV"===t.code){var s=t.as(_bundle_24f017be.U).event;if(s.category===_bundle_24f017be.a.FRIEND_DISCOVERED){var c=_bundle_24f017be.b.getDataAsFriendDiscoveredEvent(e,s).friendDiscoveries;(0,_bundle_1db3fd0b.G)((function(){return (0,_bundle_1db3fd0b._)(r,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,f.forEach((function(e){e.onFriendsDiscovered&&e.onFriendsDiscovered(c)}))]}))}))}))}}}else if(t instanceof _bundle_1db3fd0b.H){var d=_bundle_1db3fd0b.V.of(r._iid).subscribedUnreadMessageCount,l=!1,p=t.ts;"number"==typeof p&&p>d.ts&&(d.all!==t.all&&(l=!0),d.all=t.all>=0?t.all:0,t.customTypes&&Object.keys(t.customTypes).forEach((function(e){d.customTypes[e]!==t.customTypes[e]&&(l=!0),d.customTypes[e]=t.customTypes[e]})),l=l&&d.ts>0,d.ts=p),l&&(0,_bundle_1db3fd0b.G)((function(){return (0,_bundle_1db3fd0b._)(r,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,f.forEach((function(e){e.onTotalUnreadMessageCountChanged&&e.onTotalUnreadMessageCountChanged({groupChannelCount:d.all,feedChannelCount:d.feed,customTypeUnreadCount:d.customTypes}),e.onTotalUnreadMessageCountUpdated&&e.onTotalUnreadMessageCountUpdated(d.all,d.customTypes)}))]}))}))}))}else t instanceof _bundle_1db3fd0b.I?(u.preference.set(r._getUserProfileCacheKey(o.userId),_bundle_1db3fd0b.J.payloadify(t.userProfile)),(null===(n=t.userProfile.appInfo.notificationInfo)||void 0===n?void 0:n.isEnabled)&&u.preference.set((0,_bundle_1db3fd0b.K)(r.appId),{value:!0})):t instanceof _bundle_1db3fd0b.M&&t.error&&t.error.isSessionInvalidatedError&&(h.debug("session revoked."),r._internalDisconnect(t.error))}))}return n.init=function(e){var t=e.appId,r=e.appVersion,i=e.modules,s=void 0===i?[]:i,o=e.options,a=void 0===o?new _bundle_1db3fd0b.S:o,u=e.debugMode,c=void 0!==u&&u,d=e.customApiHost,l=e.customWebSocketHost,h=e.newInstance,f=void 0!==h&&h,p=e.logLevel,v=e.localCacheEnabled,g=void 0!==v&&v,m=e.localCacheConfig,b=void 0===m?new _bundle_1db3fd0b.L:m,_=e.localCacheEncryption,y=e.useAsyncStorageStore,w=void 0===y?null:y,k=e.useMMKVStorageStore,S=void 0===k?null:k,I=e.appStateToggleEnabled,C=void 0===I||I;if(!kn||f){var E="su-".concat((0,_bundle_1db3fd0b.n)()),T=null!=_?_:{encrypt:function(e){return e},decrypt:function(e){return e}},P=new _bundle_e1a5e3f1.L;P.level=null!=p?p:_bundle_e1a5e3f1.n.WARN;var D=new _bundle_e1a5e3f1.o({encryption:T});c||((0,_bundle_1db3fd0b.o)()?S?D=new _bundle_e1a5e3f1.p({MMKV:S,encryption:T}):w&&(D=new _bundle_e1a5e3f1.A({AsyncStorage:w,encryption:T}),P.warn("AsyncStorage store is deprecated due to the small size limit. Please use MMKVStorage store instead.")):D=new _bundle_e1a5e3f1.I({encryption:T})),new _bundle_1db3fd0b.V(E,{appId:t,appVersion:r,options:a,apiHost:null!=d?d:"https://api-".concat(t,".sendbird.com"),websocketHost:null!=l?l:"wss://ws-".concat(t,".sendbird.com"),store:D,encryption:T,logger:P,localCacheEnabled:g,localCacheConfig:b,debugMode:c,appStateToggleEnabled:C});var U=[new _bundle_e1a5e3f1.q,new poll_b],O=new n(E,a,(0,_bundle_1db3fd0b.p)((0,_bundle_1db3fd0b.p)([],(0,_bundle_1db3fd0b.q)(s),!1),(0,_bundle_1db3fd0b.q)(U),!1));return kn||(kn=O),O}return kn},Object.defineProperty(n,"instance",{get:function(){return kn},enumerable:!1,configurable:!0}),Object.defineProperty(n,"version",{get:function(){return _bundle_1db3fd0b.v},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"appId",{get:function(){return _bundle_1db3fd0b.V.of(this._iid).sdkState.appId},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"appInfo",{get:function(){var e=_bundle_1db3fd0b.V.of(this._iid).appInfo;return null!=e?e:null},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"appVersion",{get:function(){var e;return null!==(e=_bundle_1db3fd0b.V.of(this._iid).sdkState.appVersion)&&void 0!==e?e:""},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"debugMode",{get:function(){return!!_bundle_1db3fd0b.V.of(this._iid).debugMode},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"logLevel",{get:function(){return _bundle_1db3fd0b.V.of(this._iid).logger.level},set:function(e){_bundle_1db3fd0b.V.of(this._iid).logger.level=e},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"isCacheEnabled",{get:function(){return _bundle_1db3fd0b.V.of(this._iid).cacheContext.localCacheEnabled},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"localCacheConfig",{get:function(){var e=_bundle_1db3fd0b.V.of(this._iid).cacheContext;return e.localCacheEnabled?e.localCacheConfig:null},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"ekey",{get:function(){return _bundle_1db3fd0b.V.of(this._iid).sessionManager.ekey},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"currentUser",{get:function(){var e;return null!==(e=_bundle_1db3fd0b.V.of(this._iid).sessionManager.currentUser)&&void 0!==e?e:null},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"connectionState",{get:function(){var e=_bundle_1db3fd0b.V.of(this._iid).connectionManager;return e.isConnected?_bundle_1db3fd0b.r.OPEN:e.isConnecting?_bundle_1db3fd0b.r.CONNECTING:_bundle_1db3fd0b.r.CLOSED},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"lastConnectedAt",{get:function(){var e=_bundle_1db3fd0b.V.of(this._iid),t=e.connectedAt;return e.connectionManager.isConnected?t:0},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"fcmPushToken",{get:function(){var e;return null!==(e=this._fcmPushToken)&&void 0!==e?e:null},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"apnsPushToken",{get:function(){var e;return null!==(e=this._apnsPushToken)&&void 0!==e?e:null},enumerable:!1,configurable:!0}),n.prototype._getNestDBVersion=function(){return 7},n.prototype._getPreferenceCacheKey=function(e){return"sendbird@".concat(this.appId,"/").concat(e,".pref")},n.prototype._getUserProfileCacheKey=function(e){return"sendbird@".concat(this.appId,"/").concat(e,".profile")},n.prototype._internalDisconnect=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return t=_bundle_1db3fd0b.V.of(this._iid),n=t.connectionManager,r=t.sdkState,i=t.requestQueue,this._appStateChangeDetector.stop(),this._onlineDetector.stop(),i.cancelAll(),[4,n.logout(e)];case 1:return s.sent(),[4,this.clearCachedData()];case 2:return s.sent(),r.appState="foreground",[2]}}))}))},n.prototype.getMemoryStoreForDebugging=function(){var e=_bundle_1db3fd0b.V.of(this._iid),t=e.debugMode,n=e.cacheContext;if(t)return n.store instanceof _bundle_e1a5e3f1.o?n.store:null;throw _bundle_1db3fd0b.s.debugModeRequired},n.prototype.addExtension=function(e,t){var n=_bundle_1db3fd0b.V.of(this._iid).sdkState;["sb_uikit","sb_syncmanager","device-os-platform"].indexOf(e)>-1&&n.extensions&&(n.extensions[e]=t)},n.prototype.addSendbirdExtensions=function(e,t,n){var r,i,s=_bundle_1db3fd0b.V.of(this._iid),o=s.logger,a=s.sdkState,u=new RegExp(_bundle_1db3fd0b.N);if(0===e.length)return o.debug("sb.addSendbirdExtensions() has failed because the given sendbirdExtensions is empty."),!1;if(e.find((function(e){return!u.test(e.version)})))return o.debug("sb.addSendbirdExtensions() has failed because the given version did not satisfy the SemVer specification."),!1;if(n)try{for(var c=(0,_bundle_1db3fd0b.t)(Object.entries(n)),d=c.next();!d.done;d=c.next()){var l=(0,_bundle_1db3fd0b.q)(d.value,2),h=l[0],f=l[1];if(/&|=/.test(h)||/&|=/.test(f))return o.debug("sb.addSendbirdExtensions() has failed because the given customData includes at least one invalid character: = or &."),!1}}catch(e){r={error:e}}finally{try{d&&!d.done&&(i=c.return)&&i.call(c)}finally{if(r)throw r.error}}return a.sendbirdRuntimeEnvironment={sendbirdExtensions:e,deviceOS:t,customData:n},!0},n.prototype.setOnlineListener=function(e){this._onlineDetector.setOnlineListener(e)},n.prototype.setOfflineListener=function(e){this._onlineDetector.setOfflineListener(e)},n.prototype._safeInitializeStore=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t;return (0,_bundle_1db3fd0b.b)(this,(function(n){switch(n.label){case 0:t=_bundle_1db3fd0b.V.of(this._iid).cacheContext,n.label=1;case 1:return n.trys.push([1,3,,5]),[4,t.store.init(e)];case 2:return n.sent(),this._storeInitialized=!0,[3,5];case 3:return n.sent(),t.replaceStore(new _bundle_e1a5e3f1.o),[4,this._safeInitializeStore(e)];case 4:return n.sent(),[3,5];case 5:return[2]}}))}))},n.prototype.setLocaleForChatbot=function(e){var t=_bundle_1db3fd0b.V.of(this._iid).sdkState,n=function(e){return e.replace(/[^a-zA-Z-_.]/g,"")}(e.trim());n&&(t.localeForChatbot=n)},n.prototype.initializeCache=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i,s,o,u,c,d;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:if(t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.cacheContext,i=t.dispatcher,s=t.logger,n.userId&&n.userId===e)return[3,13];o="sendbird@".concat(n.appId,"/").concat(e,".db"),a.label=1;case 1:return a.trys.push([1,9,11,13]),r.localCacheEnabled?r.nestdb&&r.nestdb.state!==_bundle_e1a5e3f1.v.CLOSED&&r.nestdb.name===o?[3,3]:(u="sendbird@".concat(n.appId,"/").concat(e,".db"),(c=r.nestdb=new _bundle_e1a5e3f1.w({name:u,version:this._getNestDBVersion(),store:r.store,config:new _bundle_e1a5e3f1.x({dbname:u,itemSizeLimit:61440})})).on("upgrade",_t(c)),c.on("storeReplaced",(function(e){r.replaceStore(e),r.localCacheEnabled=!1,c.on("upgrade",_t(c))})),[4,c.open()]):[3,6];case 2:return a.sent(),this._storeInitialized=!0,i.dispatch(new _bundle_24f017be.D(this._iid,{userId:e})),[3,5];case 3:return[4,this._safeInitializeStore(o)];case 4:a.sent(),a.label=5;case 5:return n.userId=e,[3,8];case 6:return[4,this._safeInitializeStore(o)];case 7:a.sent(),n.userId=e,a.label=8;case 8:return[3,13];case 9:return d=a.sent(),s.warn("Nest DB Open Failed. ",d),r.store instanceof _bundle_e1a5e3f1.o||(r.replaceStore(new _bundle_e1a5e3f1.o),r.localCacheEnabled=!1),[4,this._safeInitializeStore(o)];case 10:throw a.sent(),n.userId=e,_bundle_1db3fd0b.s.databaseError;case 11:return[4,this._setupPreference(e)];case 12:return a.sent(),[7];case 13:return[2]}}))}))},n.prototype.getCacheDataSize=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return(e=_bundle_1db3fd0b.V.of(this._iid).cacheContext).localCacheEnabled&&e.nestdb?[4,e.nestdb.estimateUsage()]:[3,2];case 1:return[2,t.sent()];case 2:return[2,0]}}))}))},n.prototype.clearCachedData=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return(e=_bundle_1db3fd0b.V.of(this._iid).cacheContext).localCacheEnabled&&e.nestdb?[4,e.nestdb.clear()]:[3,2];case 1:t.sent(),t.label=2;case 2:return this._storeInitialized?[4,e.preference.clear()]:[3,4];case 3:t.sent(),t.label=4;case 4:return[2]}}))}))},n.prototype.clearCachedMessages=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r=this;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.Q)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_e1a5e3f1.t.of(this._iid),n=_bundle_e1a5e3f1.u.of(this._iid),t&&n?[4,Promise.all(e.map((function(e){return (0,_bundle_1db3fd0b._)(r,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(r){switch(r.label){case 0:return[4,t.removeMessagesOfChannel(e)];case 1:return r.sent(),[4,n.removeMessagesOfChannel(e)];case 2:return r.sent(),[2]}}))}))})))]:[3,2];case 1:s.sent(),s.label=2;case 2:return[2]}}))}))},n.prototype._setupPreference=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.cacheContext,i=t.statManager,[4,r.preference.init(this._getPreferenceCacheKey(e),this._getNestDBVersion())];case 1:return o.sent(),[4,r.preference.get(this._getUserProfileCacheKey(e))];case 2:return(s=o.sent())&&new _bundle_1db3fd0b.J(this._iid,s).apply(),[4,i.init("sendbird@".concat(n.appId,"/").concat(e,".statlog"))];case 3:return o.sent(),[2]}}))}))},n.prototype._ready=function(e,n,r){return void 0===r&&(r={}),(0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var i,s,o,u,c,d;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&(0,_bundle_1db3fd0b.a)("string",n,!0)).throw(_bundle_1db3fd0b.s.invalidParameters),i=_bundle_1db3fd0b.V.of(this._iid),s=i.sdkState,o=i.cacheContext,u=i.connectionManager,c=r.errorForOtherUser,s.userId&&s.userId!==e?c?[3,2]:[4,u.logout()]:[3,3];case 1:return a.sent(),[3,3];case 2:throw c;case 3:return a.trys.push([3,5,,6]),[4,this.initializeCache(e)];case 4:return a.sent(),_bundle_1db3fd0b.V.of(this._iid).dispatcher.dispatch(new _bundle_24f017be.R),[3,6];case 5:return a.sent(),d=_bundle_1db3fd0b.V.of(this._iid).logger,o.localCacheEnabled=!1,d.warn("Cache initialization failed - cache is not available."),[3,6];case 6:return[2]}}))}))},n.prototype.authenticateFeed=function(e,t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(n){switch(n.label){case 0:return[4,this.authenticate(e,t)];case 1:return[2,n.sent()]}}))}))},n.prototype.authenticate=function(e,t){var n;return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var r,i,s,o;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return r=_bundle_1db3fd0b.V.of(this._iid),i=r.sessionManager,s=r.connectionManager,[4,this._ready(e,t,{errorForOtherUser:s.isConnected?_bundle_1db3fd0b.s.alreadyConnectedAsAnotherUser:void 0})];case 1:return a.sent(),(null===(n=i.session.services)||void 0===n?void 0:n.includes(_bundle_1db3fd0b.R.CHAT))?[3,3]:(t||i.handler||(o=new _bundle_e1a5e3f1.S,this.setSessionHandler(o)),[4,i.authenticate(e,t)]);case 2:a.sent(),a.label=3;case 3:return[2,this.currentUser]}}))}))},n.prototype.connect=function(e,t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(n){switch(n.label){case 0:return[4,this._ready(e,t)];case 1:n.sent(),n.label=2;case 2:return n.trys.push([2,,4,5]),[4,_bundle_1db3fd0b.V.of(this._iid).connectionManager.connect(t)];case 3:return n.sent(),[3,5];case 4:return this._onlineDetector.start(),this._appStateChangeDetector.start(),[7];case 5:return[2,this.currentUser]}}))}))},n.prototype.reconnect=function(){var e=_bundle_1db3fd0b.V.of(this._iid),t=e.connectionManager,n=e.sdkState,r=e.sessionManager.session.hasSession;return r&&(this._appStateChangeDetector.start(),this._onlineDetector.start(),t.resetAndReconnect().then((function(){n.appState="foreground"})).catch((function(){}))),r},n.prototype.disconnect=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){switch(e.label){case 0:return[4,this._internalDisconnect()];case 1:return e.sent(),[2]}}))}))},n.prototype.disconnectWebSocket=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n;return (0,_bundle_1db3fd0b.b)(this,(function(r){switch(r.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.connectionManager,n=e.requestQueue,this._appStateChangeDetector.stop(),this._onlineDetector.stop(),n.cancelAll(),[4,t.disconnectWebSocket(!0)];case 1:return r.sent(),[2]}}))}))},n.prototype.setBackgroundState=function(){var e=_bundle_1db3fd0b.V.of(this._iid),t=e.connectionManager,n=e.sdkState,r=e.logger;"foreground"===n.appState&&(n.appState="background",r.debug("going background state"),t.background().catch((function(e){r.debug("setBackgroundState error = ",e)})))},n.prototype.setForegroundState=function(){var e=_bundle_1db3fd0b.V.of(this._iid),t=e.connectionManager,n=e.sdkState,r=e.dispatcher,i=e.logger;"background"===n.appState&&(n.appState="foreground",i.debug("going foreground state"),t.resetAndReconnect().catch((function(e){i.debug("setForgroundState error = ",e)})),r.dispatch(new _bundle_31d4ecef_r))},n.prototype.setSessionHandler=function(e){(0,_bundle_1db3fd0b.w)(e instanceof _bundle_e1a5e3f1.S).throw(_bundle_1db3fd0b.s.invalidParameters),_bundle_1db3fd0b.V.of(this._iid).sessionManager.handler=e},n.prototype.addUserEventHandler=function(e,n){(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&n instanceof _bundle_e1a5e3f1.U).throw(_bundle_1db3fd0b.s.invalidParameters),_bundle_1db3fd0b.V.of(this._iid).userEventHandlers.set(e,n)},n.prototype.removeUserEventHandler=function(e){_bundle_1db3fd0b.V.of(this._iid).userEventHandlers.delete(e)},n.prototype.removeAllUserEventHandler=function(){_bundle_1db3fd0b.V.of(this._iid).userEventHandlers.clear()},n.prototype.addConnectionHandler=function(e,n){(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&n instanceof _bundle_e1a5e3f1.C).throw(_bundle_1db3fd0b.s.invalidParameters),_bundle_1db3fd0b.V.of(this._iid).connectionHandlers.set(e,n)},n.prototype.removeConnectionHandler=function(e){_bundle_1db3fd0b.V.of(this._iid).connectionHandlers.delete(e)},n.prototype.removeAllConnectionHandler=function(){_bundle_1db3fd0b.V.of(this._iid).connectionHandlers.clear()},n.prototype.createApplicationUserListQuery=function(e){return void 0===e&&(e={}),new _bundle_e1a5e3f1.r(this._iid,e)},n.prototype.createBlockedUserListQuery=function(e){return void 0===e&&(e={}),new _bundle_e1a5e3f1.B(this._iid,e)},n.prototype.createFriendListQuery=function(e){return void 0===e&&(e={}),new _bundle_e1a5e3f1.F(this._iid,e)},n.prototype.createMessageSearchQuery=function(e){return new _bundle_e1a5e3f1.s(this._iid,e)},n.prototype.createPollListQuery=function(e){return new _bundle_1db3fd0b.x(this._iid,(0,_bundle_1db3fd0b.g)({},e))},n.prototype.createPollVoterListQuery=function(e){return new _bundle_1db3fd0b.y(this._iid,(0,_bundle_1db3fd0b.g)({},e))},n.prototype.buildUserFromSerializedData=function(e){var t=(0,_bundle_1db3fd0b.z)(e);return new _bundle_1db3fd0b.U(this._iid,_bundle_1db3fd0b.U.payloadify(t))},n.prototype.updateCurrentUserInfo=function(n){return void 0===n&&(n={}),(0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var r,i,s,o,u,c,d;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return r=(0,_bundle_1db3fd0b.g)((0,_bundle_1db3fd0b.g)({},bt),n),(0,_bundle_1db3fd0b.w)(function(n){return (0,_bundle_1db3fd0b.i)(n.profileImage,!0)&&(0,_bundle_1db3fd0b.a)("string",n.profileUrl,!0)&&(0,_bundle_1db3fd0b.a)("string",n.nickname,!0)}(r)).throw(_bundle_1db3fd0b.s.invalidParameters),this.currentUser?(i=_bundle_1db3fd0b.V.of(this._iid),s=i.sdkState,o=i.requestQueue,u=new St((0,_bundle_1db3fd0b.g)({userId:s.userId},r)),[4,o.send(u)]):[3,2];case 1:return c=a.sent(),d=c.as(It).user,this.currentUser&&(r.nickname&&(this.currentUser.nickname=d.nickname),(r.profileUrl||r.profileImage)&&(this.currentUser.plainProfileUrl=d.profileUrl)),[2,d];case 2:throw _bundle_1db3fd0b.s.connectionRequired}}))}))},n.prototype.updateCurrentUserInfoWithPreferredLanguages=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i,s,o;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.Q)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),this.currentUser?(t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new St({userId:n.userId,preferredLanguages:e}),[4,r.send(i)]):[3,2];case 1:return s=a.sent(),o=s.as(It).user,this.currentUser&&(this.currentUser.preferredLanguages=o.preferredLanguages),[2,o];case 2:throw _bundle_1db3fd0b.s.connectionRequired}}))}))},n.prototype.registerFCMPushTokenForCurrentUser=function(e,n){var r,s;return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var o,u,c,d,l,h,f=this;return (0,_bundle_1db3fd0b.b)(this,(function(p){switch(p.label){case 0:if((0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&(0,_bundle_1db3fd0b.a)("string",null==n?void 0:n.deviceManufacturer,!0)).throw(_bundle_1db3fd0b.s.invalidParameters),(null==n?void 0:n.deviceOS)&&(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.X)(_bundle_1db3fd0b.Y,n.deviceOS.platform,!0)&&(0,_bundle_1db3fd0b.a)("string",n.deviceOS.version,!0)).throw(_bundle_1db3fd0b.s.invalidParameters),!this.currentUser)return[3,6];o={deviceOS:"".concat((null===(r=null==n?void 0:n.deviceOS)||void 0===r?void 0:r.platform)||_bundle_1db3fd0b.Y.ANDROID,"-").concat((null===(s=null==n?void 0:n.deviceOS)||void 0===s?void 0:s.version)||"unknown"),deviceManufacturer:null==n?void 0:n.deviceManufacturer,systemPushEnabled:null==n?void 0:n.systemPushEnabled},p.label=1;case 1:return p.trys.push([1,4,,5]),u=_bundle_1db3fd0b.V.of(this._iid),c=u.sessionManager,d=u.sdkState,l=u.requestQueue,c.hasDeviceToken(_bundle_1db3fd0b.P.FCM,e)?[2,_bundle_1db3fd0b.T.SUCCESS]:(h=new Et({userId:d.userId,token:e,deviceOS:o.deviceOS,deviceManufacturer:o.deviceManufacturer,systemPushEnabled:o.systemPushEnabled}),[4,l.send(h)]);case 2:return p.sent(),[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(f,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return c.setDeviceToken(_bundle_1db3fd0b.P.FCM,e,o),[4,c.saveDeviceToken()];case 1:return t.sent(),[2]}}))}))}))];case 3:return p.sent(),this._fcmPushToken="",[2,_bundle_1db3fd0b.T.SUCCESS];case 4:return p.sent(),[2,_bundle_1db3fd0b.T.ERROR];case 5:return[3,7];case 6:return this._fcmPushToken=e,[2,_bundle_1db3fd0b.T.PENDING];case 7:return[2]}}))}))},n.prototype.unregisterFCMPushTokenForCurrentUser=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,s,o,u,c,d=this;return (0,_bundle_1db3fd0b.b)(this,(function(l){switch(l.label){case 0:if((0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),!this.currentUser)return[3,6];l.label=1;case 1:return l.trys.push([1,4,,5]),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sessionManager,s=n.sdkState,o=n.requestQueue,u=new Pt({userId:s.userId,token:e}),[4,o.send(u)];case 2:return c=l.sent().lastDeletedAt,[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(d,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return r.unsetDeviceToken(_bundle_1db3fd0b.P.FCM,e),r.setDeviceTokenDeletedAt(c),[4,r.saveDeviceToken()];case 1:return t.sent(),[2]}}))}))}))];case 3:return l.sent(),this._fcmPushToken="",[2,_bundle_1db3fd0b.T.SUCCESS];case 4:return l.sent(),[2,_bundle_1db3fd0b.T.ERROR];case 5:return[3,7];case 6:return this._fcmPushToken=e,[2,_bundle_1db3fd0b.T.PENDING];case 7:return[2]}}))}))},n.prototype.unregisterFCMPushTokenAllForCurrentUser=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,s,o,u=this;return (0,_bundle_1db3fd0b.b)(this,(function(c){switch(c.label){case 0:return this.currentUser?(e=_bundle_1db3fd0b.V.of(this._iid),t=e.sessionManager,n=e.sdkState,r=e.requestQueue,s=new Ut({userId:n.userId}),[4,r.send(s)]):[3,3];case 1:return o=c.sent().lastDeletedAt,[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(u,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){switch(e.label){case 0:return t.unsetDeviceTokens(_bundle_1db3fd0b.P.FCM),t.setDeviceTokenDeletedAt(o),[4,t.saveDeviceToken()];case 1:return e.sent(),[2]}}))}))}))];case 2:c.sent(),c.label=3;case 3:return[2]}}))}))},n.prototype.registerAPNSPushTokenForCurrentUser=function(e,n){var r,s;return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var o,u,c,d,l,h,f=this;return (0,_bundle_1db3fd0b.b)(this,(function(p){switch(p.label){case 0:if((0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&(0,_bundle_1db3fd0b.a)("string",null==n?void 0:n.deviceManufacturer,!0)).throw(_bundle_1db3fd0b.s.invalidParameters),(null==n?void 0:n.deviceOS)&&(0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.X)(_bundle_1db3fd0b.Y,n.deviceOS.platform,!0)&&(0,_bundle_1db3fd0b.a)("string",n.deviceOS.version,!0)).throw(_bundle_1db3fd0b.s.invalidParameters),!this.currentUser)return[3,6];o={deviceOS:"".concat((null===(r=null==n?void 0:n.deviceOS)||void 0===r?void 0:r.platform)||_bundle_1db3fd0b.Y.IOS,"-").concat((null===(s=null==n?void 0:n.deviceOS)||void 0===s?void 0:s.version)||"unknown"),deviceManufacturer:null==n?void 0:n.deviceManufacturer,systemPushEnabled:null==n?void 0:n.systemPushEnabled},p.label=1;case 1:return p.trys.push([1,4,,5]),u=_bundle_1db3fd0b.V.of(this._iid),c=u.sessionManager,d=u.sdkState,l=u.requestQueue,c.hasDeviceToken(_bundle_1db3fd0b.P.APNS,e)?[2,_bundle_1db3fd0b.T.SUCCESS]:(h=new Ct({userId:d.userId,token:e,deviceOS:o.deviceOS,deviceManufacturer:o.deviceManufacturer,systemPushEnabled:o.systemPushEnabled}),[4,l.send(h)]);case 2:return p.sent(),[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(f,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return c.setDeviceToken(_bundle_1db3fd0b.P.APNS,e,o),[4,c.saveDeviceToken()];case 1:return t.sent(),[2]}}))}))}))];case 3:return p.sent(),this._apnsPushToken="",[2,_bundle_1db3fd0b.T.SUCCESS];case 4:return p.sent(),[2,_bundle_1db3fd0b.T.ERROR];case 5:return[3,7];case 6:return this._apnsPushToken=e,[2,_bundle_1db3fd0b.T.PENDING];case 7:return[2]}}))}))},n.prototype.unregisterAPNSPushTokenForCurrentUser=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,s,o,u,c,d=this;return (0,_bundle_1db3fd0b.b)(this,(function(l){switch(l.label){case 0:if((0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),!this.currentUser)return[3,6];l.label=1;case 1:return l.trys.push([1,4,,5]),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sessionManager,s=n.sdkState,o=n.requestQueue,u=new Tt({userId:s.userId,token:e}),[4,o.send(u)];case 2:return c=l.sent().lastDeletedAt,[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(d,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){switch(t.label){case 0:return r.unsetDeviceToken(_bundle_1db3fd0b.P.APNS,e),r.setDeviceTokenDeletedAt(c),[4,r.saveDeviceToken()];case 1:return t.sent(),[2]}}))}))}))];case 3:return l.sent(),this._apnsPushToken="",[2,_bundle_1db3fd0b.T.SUCCESS];case 4:return l.sent(),[2,_bundle_1db3fd0b.T.ERROR];case 5:return[3,7];case 6:return this._apnsPushToken=e,[2,_bundle_1db3fd0b.T.PENDING];case 7:return[2]}}))}))},n.prototype.unregisterAPNSPushTokenAllForCurrentUser=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,s,o,u=this;return (0,_bundle_1db3fd0b.b)(this,(function(c){switch(c.label){case 0:return this.currentUser?(e=_bundle_1db3fd0b.V.of(this._iid),t=e.sessionManager,n=e.sdkState,r=e.requestQueue,s=new Dt({userId:n.userId}),[4,r.send(s)]):[3,3];case 1:return o=c.sent().lastDeletedAt,[4,(0,_bundle_1db3fd0b.B)((function(){return (0,_bundle_1db3fd0b._)(u,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){switch(e.label){case 0:return t.unsetDeviceTokens(_bundle_1db3fd0b.P.APNS),t.setDeviceTokenDeletedAt(o),[4,t.saveDeviceToken()];case 1:return e.sent(),[2]}}))}))}))];case 2:c.sent(),c.label=3;case 3:return[2]}}))}))},n.prototype.markPushNotificationAsDelivered=function(e,t){var n;return void 0===t&&(t=!0),(0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var r,i,s,o,u,c,d,l,h,f,p,v,g,m,b,_,y,w,k;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:if(r=_bundle_1db3fd0b.V.of(this._iid),i=r.logger,s=r.sessionManager,o=r.requestQueue,u=r.pushNotificationAckManager,i.debug("markPushNotificationAsDelivered:",e),c=fn.DELIVERED,d=u.parseData(e),l=d.pushTrackingId,h=d.sessionTopics,f=d.sessionKey,p=d.messageId,v=d.channelKey,g=d.templateKey,m=d.notificationEventDeadline,!f)throw i.info("Can't use markPushNotificationAsDelivered() feature."),_bundle_1db3fd0b.s.malformedDataError;if(!h.includes(_bundle_1db3fd0b.Z.PUSH_ACKNOWLEDGEMENT))throw i.info("Can't use markPushNotificationAsDelivered() feature."),_bundle_1db3fd0b.s.malformedDataError;if(u.isAcked(l,c))return i.info("already delivered push notification:",l),[2];b=Boolean(v),_=t&&b,y=null===(n=s.deviceTokens[0])||void 0===n?void 0:n.token,w=new Sn({deviceToken:null!=y?y:"",pushTrackingId:l,eventType:c,messageId:p,channelKey:v,templateKey:g,notificationEventDeadline:m,allowedPushNotification:_}),f&&(w.headers["Session-Key"]=f),a.label=1;case 1:return a.trys.push([1,3,,4]),[4,o.send(w)];case 2:return a.sent(),u.markAsAcked(l,c),[3,4];case 3:throw k=a.sent(),i.debug("failed to mark push notification as delivered. push tracking id: ".concat(l,". error: ").concat(k)),k;case 4:return[2]}}))}))},n.prototype.markPushNotificationAsClicked=function(e){var t;return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s,o,u,c,d,l,h,f,p,v,g,m,b,_;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:if(n=_bundle_1db3fd0b.V.of(this._iid),r=n.logger,i=n.sessionManager,s=n.requestQueue,o=n.pushNotificationAckManager,r.debug("markPushNotificationAsClicked:",e),u=fn.CLICKED,c=o.parseData(e),d=c.pushTrackingId,l=c.sessionTopics,h=c.sessionKey,f=c.messageId,p=c.channelKey,v=c.templateKey,g=c.notificationEventDeadline,!h)throw r.info("Can't use markPushNotificationAsDelivered() feature."),_bundle_1db3fd0b.s.malformedDataError;if(!l.includes(_bundle_1db3fd0b.Z.PUSH_ACKNOWLEDGEMENT))throw r.info("Can't use markPushNotificationAsDelivered() feature."),_bundle_1db3fd0b.s.malformedDataError;if(o.isAcked(d,u))return r.info("already clicked push notification:",d),[2];m=null===(t=i.deviceTokens[0])||void 0===t?void 0:t.token,b=new Sn({deviceToken:null!=m?m:"",pushTrackingId:d,eventType:u,messageId:f,channelKey:p,templateKey:v,notificationEventDeadline:g}),h&&(b.headers["Session-Key"]=h),a.label=1;case 1:return a.trys.push([1,3,,4]),[4,s.send(b)];case 2:return a.sent(),o.markAsAcked(d,u),[3,4];case 3:throw _=a.sent(),r.debug("failed to mark push notification as clicked. push tracking id: ".concat(d,". error: ").concat(_)),_;case 4:return[2]}}))}))},n.prototype.getChannelInvitationPreference=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new Nt({userId:t.userId}),[4,n.send(r)];case 1:return i=s.sent(),[2,{autoAccept:i.as(Mt).autoAccept}]}}))}))},n.prototype.setChannelInvitationPreference=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s,o;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("boolean",e)).throw(_bundle_1db3fd0b.s.invalidParameters),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sdkState,i=n.requestQueue,s=new Lt({userId:r.userId,willAutoAccept:e}),[4,i.send(s)];case 1:return o=a.sent(),[2,{autoAccept:o.as(Rt).autoAccept}]}}))}))},n.prototype.getDoNotDisturb=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new zt({userId:t.userId}),[4,n.send(r)];case 1:return i=s.sent(),[2,i.as(Qt).preference]}}))}))},n.prototype.setDoNotDisturb=function(e,n,r,s,o,u){return void 0===n&&(n=0),void 0===r&&(r=0),void 0===s&&(s=0),void 0===o&&(o=0),void 0===u&&(u=""),(0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var i,c,d,l,h;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("boolean",e)&&(0,_bundle_1db3fd0b.a)("number",n)&&(0,_bundle_1db3fd0b.a)("number",r)&&(0,_bundle_1db3fd0b.a)("number",s)&&(0,_bundle_1db3fd0b.a)("number",o)&&(0,_bundle_1db3fd0b.a)("string",u)).throw(_bundle_1db3fd0b.s.invalidParameters),i=_bundle_1db3fd0b.V.of(this._iid),c=i.sdkState,d=i.requestQueue,l=new jt({userId:c.userId,doNotDisturbOn:e,startHour:n,startMin:r,endHour:s,endMin:o,timezone:u}),[4,d.send(l)];case 1:return h=a.sent(),[2,h.as(Ft).preference]}}))}))},n.prototype.getSnoozePeriod=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new qt({userId:t.userId}),[4,n.send(r)];case 1:return i=s.sent(),[2,i.as(Ht).snoozePeriod]}}))}))},n.prototype.setSnoozePeriod=function(e,n,r){return void 0===n&&(n=0),void 0===r&&(r=0),(0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var i,s,o,u,c;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("boolean",e)&&(0,_bundle_1db3fd0b.a)("number",n)&&(0,_bundle_1db3fd0b.a)("number",r)).throw(_bundle_1db3fd0b.s.invalidParameters),i=_bundle_1db3fd0b.V.of(this._iid),s=i.sdkState,o=i.requestQueue,u=new xt({userId:s.userId,snoozeOn:e,startTs:n,endTs:r}),[4,o.send(u)];case 1:return c=a.sent(),[2,c.as(Kt).snoozePeriod]}}))}))},n.prototype.getMyPushTokensByToken=function(e,n){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var r,i,s,o,u,c,d,l,h,f,p,v;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)&&(0,_bundle_1db3fd0b.X)(_bundle_1db3fd0b.P,n)).throw(_bundle_1db3fd0b.s.invalidParameters),r=_bundle_1db3fd0b.V.of(this._iid),i=r.sdkState,s=r.requestQueue,o=r.sessionManager,u=new Ot({userId:i.userId,type:n,token:e}),[4,s.send(u)];case 1:c=a.sent(),d=c.as(At).pushTokens;try{for(l=(0,_bundle_1db3fd0b.t)(d.deviceTokens),h=l.next();!h.done;h=l.next())f=h.value,o.setDeviceToken(d.type,f)}catch(e){p={error:e}}finally{try{h&&!h.done&&(v=l.return)&&v.call(l)}finally{if(p)throw p.error}}return[4,o.saveDeviceToken()];case 2:return a.sent(),[2,d]}}))}))},n.prototype.getPushTriggerOption=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r;return (0,_bundle_1db3fd0b.b)(this,(function(i){switch(i.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new Vt({userId:t.userId}),[4,n.send(r)];case 1:return[2,i.sent().as(Bt).pushTriggerOption]}}))}))},n.prototype.setPushTriggerOption=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.X)(_bundle_1db3fd0b.$,e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new Jt({userId:n.userId,pushTriggerOption:e}),[4,r.send(i)];case 1:return[2,s.sent().as(Yt).pushTriggerOption]}}))}))},n.prototype.getPushTemplate=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r;return (0,_bundle_1db3fd0b.b)(this,(function(i){switch(i.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new Zt({userId:t.userId}),[4,n.send(r)];case 1:return[2,i.sent().as($t).name]}}))}))},n.prototype.setPushTemplate=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.X)(_bundle_1db3fd0b.a0,e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new Xt({userId:n.userId,templateName:e}),[4,r.send(i)];case 1:return[2,s.sent().as(en).name]}}))}))},n.prototype.blockUser=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return (0,_bundle_1db3fd0b.w)(e instanceof _bundle_1db3fd0b.U||(0,_bundle_1db3fd0b.a)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sdkState,i=n.requestQueue,s=new Gt({userId:r.userId,blockedUserId:e instanceof _bundle_1db3fd0b.U?e.userId:e}),[4,i.send(s)];case 1:return o.sent(),[2]}}))}))},n.prototype.blockUserWithUserId=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){return[2,this.blockUser(e)]}))}))},n.prototype.unblockUser=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return (0,_bundle_1db3fd0b.w)(e instanceof _bundle_1db3fd0b.U||(0,_bundle_1db3fd0b.a)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sdkState,i=n.requestQueue,s=new Wt({userId:r.userId,unblockedUserId:e instanceof _bundle_1db3fd0b.U?e.userId:e}),[4,i.send(s)];case 1:return o.sent(),[2]}}))}))},n.prototype.unblockUserWithUserId=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){return[2,this.unblockUser(e)]}))}))},n.prototype.getFriendChangeLogsByToken=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s,o;return (0,_bundle_1db3fd0b.b)(this,(function(a){switch(a.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sdkState,i=n.requestQueue,s=new tn({userId:r.userId,token:e}),[4,i.send(s)];case 1:return o=a.sent(),[2,o.as(nn).changelogs]}}))}))},n.prototype.getAllowFriendDiscovery=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),t=e.sdkState,n=e.requestQueue,r=new dn({userId:t.userId}),[4,n.send(r)];case 1:return i=s.sent(),[2,i.as(ln).allowFriendDiscovery]}}))}))},n.prototype.setAllowFriendDiscovery=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.a)("boolean",e)).throw(_bundle_1db3fd0b.s.invalidParameters),n=_bundle_1db3fd0b.V.of(this._iid),r=n.sdkState,i=n.requestQueue,s=new hn({userId:r.userId,allowFriendDiscovery:e}),[4,i.send(s)];case 1:return o.sent(),[2,e]}}))}))},n.prototype.uploadFriendDiscoveries=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new rn({userId:n.userId,discoveries:e}),[4,r.send(i)];case 1:return s=o.sent(),[2,s.as(sn).friendDiscoveryRequestId]}}))}))},n.prototype.deleteFriendDiscovery=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){return[2,this.deleteFriendDiscoveries([e])]}))}))},n.prototype.deleteFriendDiscoveries=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.Q)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new on({userId:n.userId,discoveryKeys:e}),[4,r.send(i)];case 1:return s.sent(),[2]}}))}))},n.prototype.addFriends=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i,s;return (0,_bundle_1db3fd0b.b)(this,(function(o){switch(o.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.Q)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new an({userId:n.userId,userIds:e}),[4,r.send(i)];case 1:return s=o.sent(),[2,s.as(un).users]}}))}))},n.prototype.deleteFriend=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(t){return[2,this.deleteFriends([e])]}))}))},n.prototype.deleteFriends=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r,i;return (0,_bundle_1db3fd0b.b)(this,(function(s){switch(s.label){case 0:return (0,_bundle_1db3fd0b.w)((0,_bundle_1db3fd0b.Q)("string",e)).throw(_bundle_1db3fd0b.s.invalidParameters),t=_bundle_1db3fd0b.V.of(this._iid),n=t.sdkState,r=t.requestQueue,i=new cn({userId:n.userId,userIds:e}),[4,r.send(i)];case 1:return s.sent(),[2]}}))}))},n.prototype.getAllEmoji=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n;return (0,_bundle_1db3fd0b.b)(this,(function(r){switch(r.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid).requestQueue,t=new pn,[4,e.send(t)];case 1:return n=r.sent(),[2,n.as(vn).emojiContainer]}}))}))},n.prototype.getEmojiCategory=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r;return (0,_bundle_1db3fd0b.b)(this,(function(i){switch(i.label){case 0:return t=_bundle_1db3fd0b.V.of(this._iid).requestQueue,n=new gn({categoryId:e}),[4,t.send(n)];case 1:return r=i.sent(),[2,r.as(mn).emojiCategory]}}))}))},n.prototype.getEmoji=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var t,n,r;return (0,_bundle_1db3fd0b.b)(this,(function(i){switch(i.label){case 0:return t=_bundle_1db3fd0b.V.of(this._iid).requestQueue,n=new bn({key:e}),[4,t.send(n)];case 1:return r=i.sent(),[2,r.as(_n).emoji]}}))}))},n.prototype.getUIKitConfiguration=function(){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){var e,t,n,r;return (0,_bundle_1db3fd0b.b)(this,(function(i){switch(i.label){case 0:return e=_bundle_1db3fd0b.V.of(this._iid),(0,_bundle_1db3fd0b.w)(e.hasExtension("sb_uikit")).throw(_bundle_1db3fd0b.s.notSupportedError),t=e.requestQueue,n=new yn,[4,t.send(n)];case 1:return r=i.sent(),[2,r.as(wn).uikitConfiguration]}}))}))},n}();


/***/ }),

/***/ 73235:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34182);
var t=function(){this.onUserMuted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onUserUnmuted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onUserBanned=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onUserUnbanned=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onChannelChanged=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onChannelDeleted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onChannelFrozen=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onChannelUnfrozen=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onOperatorUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onChannelMemberCountChanged=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaDataCreated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaDataUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaDataDeleted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaCounterCreated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaCounterUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMetaCounterDeleted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMessageReceived=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMessageUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMessageDeleted=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onMentionReceived=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onReactionUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,this.onThreadInfoUpdated=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA};


/***/ }),

/***/ 77522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ S; },
/* harmony export */   "D": function() { return /* binding */ v; },
/* harmony export */   "G": function() { return /* binding */ E; },
/* harmony export */   "P": function() { return /* binding */ p; },
/* harmony export */   "R": function() { return /* binding */ D; },
/* harmony export */   "S": function() { return /* binding */ R; },
/* harmony export */   "U": function() { return /* binding */ T; },
/* harmony export */   "a": function() { return /* binding */ C; },
/* harmony export */   "b": function() { return /* binding */ N; },
/* harmony export */   "c": function() { return /* binding */ b; },
/* harmony export */   "g": function() { return /* binding */ L; }
/* harmony export */ });
/* harmony import */ var _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34182);
/* harmony import */ var _bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4500);
var E,p,R;!function(e){e.LATEST_LAST_MESSAGE="latest_last_message",e.CHRONOLOGICAL="chronological",e.CHANNEL_NAME_ALPHABETICAL="channel_name_alphabetical",e.METADATA_VALUE_ALPHABETICAL="metadata_value_alphabetical"}(E||(E={})),function(e){e.CHRONOLOGICAL="chronological",e.CHANNEL_NAME_ALPHABETICAL="channel_name_alphabetical",e.METADATA_VALUE_ALPHABETICAL="metadata_value_alphabetical"}(p||(p={})),function(e){e.CREATED_AT="created_at",e.SCHEDULED_AT="scheduled_at"}(R||(R={}));var C,L=function(e){switch(e){case E.LATEST_LAST_MESSAGE:return["-lastMessageUpdatedAt","-createdAt","syncIndex"];case E.CHRONOLOGICAL:return["-createdAt","syncIndex"];case E.CHANNEL_NAME_ALPHABETICAL:return["name"];default:return["-lastMessageUpdatedAt","-createdAt","syncIndex"]}},b=function(t){function s(e){var s=e.message,n=t.call(this)||this;return n.message=s,n}return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(s,t),s}(_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b8),I={},S=function(){function e(e,t){var s=t.localCacheEnabled,n=t.enableAutoResend,r=t.dispatcher,a=t.sdkState,u=t.logger,d=this;this._iid=e,I[e]=this,this._localCacheEnabled=s,this._enableAutoResend=n,this._isProcessingAutoResend=!1,this._autoResendQueue=[],this._dispatcher=r,this._logger=u,this._sdkState=a,this._localCacheEnabled&&r.on((function(e){if(e instanceof _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.D)switch(e.stateType){case _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.CONNECTED:d._isProcessingAutoResend||d.processAutoResendRegisteredPendingMessages().then((function(){return d._processNextAutoResend()}));break;case _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.INTERNAL_DISCONNECTED:case _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.EXTERNAL_DISCONNECTED:d._isProcessingAutoResend=!1}}))}return e.of=function(e){return I[e]},e.prototype.processNonAutoResendRegisteredPendingMessages=function(){return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,s,a,i,o;return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){switch(n.label){case 0:return this._enableAutoResend?[4,this._fetchAllCachedPendingMessages()]:[2];case 1:e=n.sent();try{for(t=(0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(e),s=t.next();!s.done;s=t.next())0===(a=s.value).errorCode&&(this._logger.debug("cached pending message is not auto-resend registered. changing its sending status to failed: ",a.reqId),a.sendingStatus=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ao.FAILED,a.errorCode=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a8.ACK_TIMEOUT,this._dispatcher.dispatch(new _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.an({messages:[a],source:_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.LOCAL_MESSAGE_FAILED})))}catch(e){i={error:e}}finally{try{s&&!s.done&&(o=t.return)&&o.call(t)}finally{if(i)throw i.error}}return[2]}}))}))},e.prototype.processAutoResendRegisteredPendingMessages=function(){return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t,s,i,o,d,l,_;return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){switch(n.label){case 0:return[4,this._fetchAllCachedPendingMessages()];case 1:e=n.sent();try{for(t=(0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(e),s=t.next();!s.done;s=t.next())i=s.value,this._enableAutoResend&&i.errorCode&&(0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aK)(i.errorCode)&&(o=(new Date).getTime(),d=i.createdAt+2592e5,this._enableAutoResend&&o<=d?this._autoResendQueue.map((function(e){return e.reqId})).indexOf(i.reqId)<0&&this._autoResendQueue.push(i):(this._logger.debug("auto-resend registered pending messaged expired. expiration date: ",new Date(d).toLocaleString()),i.sendingStatus=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ao.FAILED,this._dispatcher.dispatch(new _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.an({messages:[i],source:_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.LOCAL_MESSAGE_FAILED}))))}catch(e){l={error:e}}finally{try{s&&!s.done&&(_=t.return)&&_.call(t)}finally{if(l)throw l.error}}return[2]}}))}))},e.prototype.completeCurrentAndProcessNextAutoResend=function(e){if(this._localCacheEnabled&&this._enableAutoResend&&(e.sendingStatus===_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ao.SUCCEEDED||e.sendingStatus===_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ao.FAILED&&!(0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aK)(e.errorCode))){var t=this.indexOf(e);t>=0&&this._autoResendQueue.splice(t,1),0===t&&this._processNextAutoResend()}},e.prototype._fetchAllCachedPendingMessages=function(){return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,t;return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(s){switch(s.label){case 0:return e=_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_1__.u.of(this._iid),(t=new _bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_1__.K).replyType=_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ay.ALL,[4,e.fetch({sendingStatus:_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ao.PENDING,backward:!0,filter:t})];case 1:return[2,s.sent()]}}))}))},e.prototype.indexOf=function(e){return this._autoResendQueue.length>0?this._autoResendQueue.map((function(e){return e.reqId})).indexOf(e.reqId):-1},e.prototype._isNotInQueue=function(e){return-1===this._autoResendQueue.map((function(e){return e.reqId})).indexOf(e.reqId)},e.prototype._processNextAutoResend=function(){return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e;return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){if(this._localCacheEnabled&&this._enableAutoResend&&"foreground"===this._sdkState.appState)try{this._autoResendQueue.length>0?(this._isProcessingAutoResend||(this._logger.debug("auto-resend queue started."),this._isProcessingAutoResend=!0),e=this._autoResendQueue[0],this._dispatcher.dispatch(new b({message:e})),this._logger.debug("processing auto-resend for message request id: ",e.reqId)):(this._logger.debug("auto-resend queue finished."),this._isProcessingAutoResend=!1)}catch(e){this._logger.warn("process auto-resend error: ",e),this._isProcessingAutoResend=!1}return[2]}))}))},e}();!function(e){e[e.USER_BLOCK=20001]="USER_BLOCK",e[e.USER_UNBLOCK=2e4]="USER_UNBLOCK",e[e.FRIEND_DISCOVERED=20900]="FRIEND_DISCOVERED"}(C||(C={}));var N=function(){function e(e){this.category=e.cat,this.data=e.data}return e.getDataAsUserBlockEvent=function(e,t){var s=t.data,n=s.blocker,r=s.blockee;return{blocker:new _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,n),blockee:new _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,r)}},e.getDataAsFriendDiscoveredEvent=function(e,t){var s=t.data.friend_discoveries;return{friendDiscoveries:Array.isArray(s)?s.map((function(t){return new _bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,t)})):[]}},e}(),v=function(t){function s(e,s){var n=s.userId,r=t.call(this)||this;return r._iid=e,r.userId=n,r}return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(s,t),s}(_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b8),D=function(t){function s(){return t.call(this)||this}return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(s,t),s}(_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b8),T=function(t){function s(e,s,n){var r=t.call(this,e,"USEV",n)||this;return r.event=new N(n),r}return (0,_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(s,t),s}(_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.W);


/***/ }),

/***/ 53742:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ L; },
  "B": function() { return /* binding */ H; },
  "C": function() { return /* binding */ v; },
  "M": function() { return /* binding */ y; },
  "O": function() { return /* binding */ T; },
  "P": function() { return /* binding */ b; },
  "R": function() { return /* binding */ U; },
  "T": function() { return /* binding */ M; },
  "U": function() { return /* binding */ g; },
  "a": function() { return /* binding */ f; },
  "b": function() { return /* binding */ I; }
});

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-1db3fd0b.js
var _bundle_1db3fd0b = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e1a5e3f1.js
var _bundle_e1a5e3f1 = __webpack_require__(4500);
;// CONCATENATED MODULE: ./node_modules/@sendbird/chat/lib/__bundle-acd77193.js
var _bundle_acd77193_s=function(s,i){this.pollId=0,this.messageId=0,this.pollId=i.poll.id,this.messageId=i.poll.message_id,this._iid=s,this._payload=i};

;// CONCATENATED MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e53b9010.js
var f;!function(e){e[e.NONE=0]="NONE",e[e.CHANNEL_ENTER=10102]="CHANNEL_ENTER",e[e.CHANNEL_EXIT=10103]="CHANNEL_EXIT",e[e.USER_CHANNEL_MUTE=10201]="USER_CHANNEL_MUTE",e[e.USER_CHANNEL_UNMUTE=10200]="USER_CHANNEL_UNMUTE",e[e.USER_CHANNEL_BAN=10601]="USER_CHANNEL_BAN",e[e.USER_CHANNEL_UNBAN=10600]="USER_CHANNEL_UNBAN",e[e.CHANNEL_FREEZE=10701]="CHANNEL_FREEZE",e[e.CHANNEL_UNFREEZE=10700]="CHANNEL_UNFREEZE",e[e.TYPING_START=10900]="TYPING_START",e[e.TYPING_END=10901]="TYPING_END",e[e.CHANNEL_JOIN=1e4]="CHANNEL_JOIN",e[e.CHANNEL_LEAVE=10001]="CHANNEL_LEAVE",e[e.CHANNEL_OPERATOR_UPDATE=10002]="CHANNEL_OPERATOR_UPDATE",e[e.CHANNEL_INVITE=10020]="CHANNEL_INVITE",e[e.CHANNEL_ACCEPT_INVITE=10021]="CHANNEL_ACCEPT_INVITE",e[e.CHANNEL_DECLINE_INVITE=10022]="CHANNEL_DECLINE_INVITE",e[e.CHANNEL_PROP_CHANGED=11e3]="CHANNEL_PROP_CHANGED",e[e.CHANNEL_DELETED=12e3]="CHANNEL_DELETED",e[e.CHANNEL_META_DATA_CHANGED=11100]="CHANNEL_META_DATA_CHANGED",e[e.CHANNEL_META_COUNTERS_CHANGED=11200]="CHANNEL_META_COUNTERS_CHANGED",e[e.CHANNEL_HIDE=13e3]="CHANNEL_HIDE",e[e.CHANNEL_UNHIDE=13001]="CHANNEL_UNHIDE",e[e.PINNED_MESSAGE_CHANGED=11300]="PINNED_MESSAGE_CHANGED"}(f||(f={}));var m=function(){function n(e){var n;this.channelUrl=e.channel_url,this.channelType=e.channel_type,this.category=e.cat,this.data=null!==(n=e.data)&&void 0!==n?n:{},this.ts=e.ts}return Object.defineProperty(n.prototype,"isGroupChannelEvent",{get:function(){return this.channelType===_bundle_1db3fd0b.C.GROUP},enumerable:!1,configurable:!0}),Object.defineProperty(n.prototype,"isOpenChannelEvent",{get:function(){return this.channelType===_bundle_1db3fd0b.C.OPEN},enumerable:!1,configurable:!0}),n}(),v=function(e){function t(n,t,s){var r=e.call(this,n,"SYEV",s)||this;return r.event=new m(s),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),T=function(e){function t(n,t,r){var a=e.call(this,n,t,r)||this,i=r.data.operators,o=void 0===i?[]:i;return a.operators=o.map((function(e){return new _bundle_1db3fd0b.U(a._iid,e)})),a}return (0,_bundle_1db3fd0b.c)(t,e),t}(v),g=function(e){function t(n,t,s){var a,i=this;return(i=e.call(this,n,"SYEV",s)||this).pinnedMessageIds=[],i.latestPinnedMessage=null,i.ts=0,s.data&&(i.pinnedMessageIds=null!==(a=s.data.pinned_message_ids)&&void 0!==a?a:[],i.latestPinnedMessage=s.data.latest_pinned_message?(0,_bundle_e1a5e3f1.T)(n,(0,_bundle_1db3fd0b.g)({},s.data.latest_pinned_message)):null),i.ts=s.ts,i}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),H=function(e){function t(n,t){var s=e.call(this,n)||this;return s._logger=t.logger,s._sdkState=t.sdkState,s._sessionManager=t.sessionManager,s._requestQueue=t.requestQueue,s._dispatcher=t.dispatcher,s._cacheContext=t.cacheContext,s._channelType=t.channelType,s}return (0,_bundle_1db3fd0b.c)(t,e),Object.defineProperty(t.prototype,"_messageBroadcast",{get:function(){return _bundle_e1a5e3f1.aL.of(this._iid)},enumerable:!1,configurable:!0}),t.prototype.subscribeMessageEvent=function(e,n){this._messageBroadcast.subscribe(e,n)},t.prototype.unsubscribeMessageEvent=function(e){this._messageBroadcast.unsubscribe(e)},t.prototype.getMessageFromCache=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,null]}))}))},t.prototype.getExactlyMatchingMessagesForTokenFromCache=function(e,n,t){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,[]]}))}))},t.prototype.getMessagesFromCache=function(e,n,t,s,r,o){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,[]]}))}))},t.prototype.getPollMessagesFromCache=function(e,n,t,s){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,[]]}))}))},t.prototype.getCachedMessageCountBetween=function(e,n,t,s){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,0]}))}))},t.prototype.getUnsentMessagesFromCache=function(e,n){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2,[]]}))}))},t.prototype.removeFailedMessageFromCache=function(e){return (0,_bundle_1db3fd0b._)(this,void 0,void 0,(function(){return (0,_bundle_1db3fd0b.b)(this,(function(e){return[2]}))}))},t}(_bundle_1db3fd0b.af),L=function(e){function t(n,t,s){var r,a,i,o,N=this;(N=e.call(this,n,"ADMM",s)||this).message=new _bundle_e1a5e3f1.aM(n,s);var c=_bundle_1db3fd0b.V.of(n).sdkState;return N.isMentioned=(0,_bundle_1db3fd0b.au)(N.message.mentionType,null!==(i=null!==(r=N.message.mentionedUserIds)&&void 0!==r?r:null===(a=N.message.mentionedUsers)||void 0===a?void 0:a.map((function(e){return e.userId})))&&void 0!==i?i:[],c.userId),N.forceUpdateLastMessage=null!==(o=s.force_update_last_message)&&void 0!==o&&o,N}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),I=function(e){function t(n,t,s){var r,a,i,o,E,_=this;(_=e.call(this,n,"AEDI",s)||this).message=new _bundle_e1a5e3f1.aM(n,s);var l=_bundle_1db3fd0b.V.of(n).sdkState;return _.mentionCountChange=(0,_bundle_1db3fd0b.aE)({mentionType:null===(r=s.old_values)||void 0===r?void 0:r.mention_type,mentionedUserIds:null!==(i=null===(a=s.old_values)||void 0===a?void 0:a.mentioned_user_ids)&&void 0!==i?i:[]},(0,_bundle_1db3fd0b.u)({mentionType:_.message.mentionType,mentionedUserIds:null!==(o=_.message.mentionedUserIds)&&void 0!==o?o:null===(E=_.message.mentionedUsers)||void 0===E?void 0:E.map((function(e){return e.userId}))}),l.userId),_}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),U=function(e){function t(n,t,s){var r=e.call(this,n,"MRCT",s)||this;return r.channelUrl=s.channel_url,r.channelType=s.channel_type,r.event=new _bundle_e1a5e3f1.aN(s),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),M=function(e){function t(n,t,s){var r=e.call(this,n,"MTHD",s)||this;return r.event=new _bundle_e1a5e3f1.a1(n,s),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),y=function(e){function t(n,t,s){var r=e.call(this,n,"MCNT",s)||this;return r.groupChannelMemberCounts=s.group_channels.map((function(e){return{channelUrl:e.channel_url,memberCount:e.member_count,joinedMemberCount:e.joined_member_count,updatedAt:e.ts}})),r.openChannelMemberCounts=s.open_channels.map((function(e){return{channelUrl:e.channel_url,participantCount:e.participant_count,updatedAt:e.ts}})),r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W),b=function(e){function t(n,t,s){var r=e.call(this,n,"PEDI",s)||this;return r.event=new _bundle_acd77193_s(n,s),r.status=(0,_bundle_1db3fd0b.bm)(s.poll.status)||s.poll.status,r.channelUrl=s.channel_url,r.channelType=s.channel_type,r}return (0,_bundle_1db3fd0b.c)(t,e),t}(_bundle_1db3fd0b.W);


/***/ }),

/***/ 35065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I6": function() { return /* binding */ xe; },
/* harmony export */   "T_": function() { return /* binding */ Ae; },
/* harmony export */   "p$": function() { return /* binding */ ke; }
/* harmony export */ });
/* unused harmony exports OpenChannelListQuery, ParticipantListQuery */
/* harmony import */ var _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34182);
/* harmony import */ var _lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4500);
/* harmony import */ var _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53742);
/* harmony import */ var _lib_bundle_123134d8_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73235);
var Ce=function(r){function a(){var e=null!==r&&r.apply(this,arguments)||this;return e._channels=new Map,e._enteredChannelUrls=[],e}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(a,r),Object.defineProperty(a.prototype,"enteredChannels",{get:function(){var e=this;return this._enteredChannelUrls.map((function(n){return e._channels.get(n)})).filter((function(e){return!!e}))},enumerable:!1,configurable:!0}),a.prototype.isEnteredChannel=function(e){return this._enteredChannelUrls.includes(e)},a.prototype.enter=function(e){this._enteredChannelUrls.indexOf(e)<0&&this._enteredChannelUrls.push(e)},a.prototype.exit=function(e){var n=this._enteredChannelUrls.indexOf(e);n>=0&&this._enteredChannelUrls.splice(n,1)},a.prototype.exitAll=function(){this._enteredChannelUrls=[]},a.prototype.get=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return[2,this._channels.get(e)]}))}))},a.prototype.upsert=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,r=this;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){return n=[],e.forEach((function(e){if(r._channels.has(e.url)){var t=r._channels.get(e.url);Object.assign(t,e),n.push(t)}else r._channels.set(e.url,e),n.push(e)})),[2,n]}))}))},a.prototype.remove=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return this._channels.delete(e),this.exit(e),[2]}))}))},a.prototype.clear=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._channels.clear(),this._enteredChannelUrls=[],[2]}))}))},a}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.af),ve={channelUrl:void 0,name:void 0,coverUrlOrImage:void 0,data:void 0,customType:void 0,operatorUserIds:void 0,isEphemeral:void 0},_e=function(n){function t(e){var t=e.channelUrl,r=e.isInternalCall,a=n.call(this)||this;return a.method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.GET,a.path="".concat(r?_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bn:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,"/").concat(encodeURIComponent(t)),a.params={show_pinned_messages:!0},a}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),ge=function(n){function t(e,t){var r=n.call(this,e,t)||this;return r.channel=new xe(e,t),r}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h),ye=function(n){function t(e){var t=this,r=e.channelUrl,a=e.coverUrlOrImage,u=e.name,c=e.data,h=e.customType,f=e.operatorUserIds,C=e.isEphemeral;return(t=n.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.POST,t.path=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,t.params=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)({channel_url:r,cover_url:(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",a)?a:null,cover_file:(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.i)(a)?a:null,name:u,data:c,custom_type:h,operators:f,is_ephemeral:C})),t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f);!function(n){function t(e,t){var r=n.call(this,e,t)||this;return r.channel=new xe(e,t),r}(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n)}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h);var me=function(n){function t(e){var t=e.channelUrl;return n.call(this,{code:"ENTR",payload:{channel_url:t},ackRequired:!0})||this}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ak),Ue=function(n){function t(e,t,r){var a,s,i=this;return i=n.call(this,e,"SYEV",r)||this,r.data&&(i.participantCount=null!==(a=r.data.participant_count)&&void 0!==a?a:0,i.user=new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,r.data),i.ts=null!==(s=r.data.edge_ts)&&void 0!==s?s:0),i}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.C),Ee=function(n){function t(e){var t=e.channelUrl;return n.call(this,{code:"EXIT",payload:{channel_url:t},ackRequired:!0})||this}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ak),Me=function(n){function t(e,t,r){var a,s,i=this;return i=n.call(this,e,"EXIT",r)||this,r.data&&(i.participantCount=null!==(a=r.data.participant_count)&&void 0!==a?a:0,i.user=new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,r.data),i.ts=null!==(s=r.data.edge_ts)&&void 0!==s?s:0),i}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.C),we={},Pe=function(r){function o(e,a){var s=r.call(this,e,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},a),{channelType:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN}))||this;return s.subscribeChannelEvent=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,s.unsubscribeChannelEvent=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,s.refreshChannel=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(s,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return[2,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA)()]}))}))},s._openChannelCache=new Ce(e),s._openChannelHandlers=new Map,s._dispatcher.on((function(e){var n,t;if(e instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.W)s._handleEvent(e).catch((function(e){if((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.O)(e)&&"foreground"===s._sdkState.appState)throw e}));else if(e instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.D&&e.stateType===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.F.CONNECTED){var r=s._openChannelCache.enteredChannels;try{for(var a=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(r),i=a.next();!i.done;i=a.next()){i.value.enter()}}catch(e){n={error:e}}finally{try{i&&!i.done&&(t=a.return)&&t.call(a)}finally{if(n)throw n.error}}}})),we[e]||(we[e]=s),s}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(o,r),o.of=function(e){return we[e]},o.prototype.buildOpenChannelFromSerializedData=function(e){var n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.z)(e);return new xe(this._iid,xe.payloadify(n))},o.prototype.getChannelFromCache=function(e){var r;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){switch(n.label){case 0:return[4,this._openChannelCache.get(e)];case 1:return[2,null!==(r=n.sent())&&void 0!==r?r:null]}}))}))},o.prototype.upsertChannelsToCache=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){switch(n.label){case 0:return[4,this._openChannelCache.upsert(e)];case 1:return[2,n.sent()]}}))}))},o.prototype.removeChannelsFromCache=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,r,a,s,i,o;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:t.trys.push([0,5,6,7]),n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(e),r=n.next(),t.label=1;case 1:return r.done?[3,4]:(a=r.value,[4,this._openChannelCache.remove(a)]);case 2:t.sent(),t.label=3;case 3:return r=n.next(),[3,1];case 4:return[3,7];case 5:return s=t.sent(),i={error:s},[3,7];case 6:try{r&&!r.done&&(o=n.return)&&o.call(n)}finally{if(i)throw i.error}return[7];case 7:return[2]}}))}))},o.prototype.setEnteredToCache=function(e){this._openChannelCache.enter(e.url)},o.prototype.setExitedToCache=function(e){this._openChannelCache.exit(e.url)},Object.defineProperty(o.prototype,"handlers",{get:function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.p)([],(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.q)(this._openChannelHandlers.values()),!1)},enumerable:!1,configurable:!0}),o.prototype._handleEvent=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var r,a,s,i,o,u,l,c,h,d,p,f,C,v,_,g,y,U,E,w,P,O,x,L,R,F,k,S,$,J,ee,ne,te,ae,fe,Ce,ve,_e,ge,ye,me,Ee,we,Pe,be,Te,Ne,De,He,Ie,Oe,xe,Ae,Le,Re,Fe,ke,Se,ze,qe,Qe,Ge,je,Be,Ke,Ve,We,Xe,Ye,Ze,$e,Je,en,nn,tn=this;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(rn){switch(rn.label){case 0:switch(rn.trys.push([0,59,,60]),e.code){case"MESG":case"FILE":case"ADMM":case"BRDM":return[3,1];case"MEDI":case"FEDI":case"AEDI":return[3,4];case"DELM":return[3,7];case"MRCT":return[3,10];case"MTHD":return[3,13];case"MCNT":return[3,16];case"PEDI":return[3,27];case"VOTE":return[3,30];case"SYEV":return[3,33]}return[3,58];case 1:return i=null,"MESG"===e.code?i=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.ag):"FILE"===e.code?i=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.ah):"ADMM"!==e.code&&"BRDM"!=e.code||(i=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.A)),i?(r=i.message,a=i.isMentioned,r.channelType!==_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[3,3]:[4,this.getChannel(r.channelUrl,!0)]):[3,3];case 2:s=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,i,o,u;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())i=n.value,this._openChannelCache.isEnteredChannel(s.url)&&(i.onMessageReceived&&i.onMessageReceived(s,r),a&&i.onMentionReceived&&i.onMentionReceived(s,r))}catch(e){o={error:e}}finally{try{n&&!n.done&&(u=e.return)&&u.call(e)}finally{if(o)throw o.error}}return[2]}))}))})),rn.label=3;case 3:return[3,58];case 4:return i=null,"MEDI"===e.code?i=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.ae):"FEDI"===e.code?i=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.af):"AEDI"===e.code&&(i=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.b)),i?(o=i.message,u=i.mentionCountChange,o.channelType!==_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[3,6]:[4,this.getChannel(o.channelUrl,!0)]):[3,6];case 5:l=rn.sent(),c=!1,l.lastPinnedMessage&&l.lastPinnedMessage.messageId===o.messageId&&l.lastPinnedMessage.updatedAt<o.updatedAt&&(l.lastPinnedMessage=o,c=!0),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s,i,h;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())r=n.value,this._openChannelCache.isEnteredChannel(l.url)&&(c&&(null===(i=r.onPinnedMessageUpdated)||void 0===i||i.call(r,l),null===(h=r.onChannelChanged)||void 0===h||h.call(r,l)),r.onMessageUpdated&&r.onMessageUpdated(l,o),u>0&&r.onMentionReceived&&r.onMentionReceived(l,o))}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=6;case 6:return[3,58];case 7:return h=e.as(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bi),ne=h.channelUrl,te=h.channelType,d=h.messageId,te!==_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[3,9]:[4,this.getChannel(ne,!0)];case 8:p=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())r=n.value,this._openChannelCache.isEnteredChannel(p.url)&&r.onMessageDeleted&&r.onMessageDeleted(p,d)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=9;case 9:return[3,58];case 10:return f=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.R),ne=f.channelUrl,te=f.channelType,C=f.event,te!==_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[3,12]:[4,this.getChannel(ne,!0)];case 11:v=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())r=n.value,this._openChannelCache.isEnteredChannel(v.url)&&r.onReactionUpdated&&r.onReactionUpdated(v,C)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=12;case 12:return[3,58];case 13:return(_=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.T).event).channelType!==_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[3,15]:[4,this.getChannel(_.channelUrl,!0)];case 14:g=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())r=n.value,this._openChannelCache.isEnteredChannel(g.url)&&r.onThreadInfoUpdated&&r.onThreadInfoUpdated(g,_)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=15;case 15:return[3,58];case 16:y=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.M).openChannelMemberCounts,U=[],rn.label=17;case 17:rn.trys.push([17,22,23,24]),E=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(y),w=E.next(),rn.label=18;case 18:return w.done?[3,21]:(P=w.value,ne=P.channelUrl,Ee=P.participantCount,O=P.updatedAt,[4,this.getChannelFromCache(ne)]);case 19:(x=rn.sent())&&x._updateParticipantCount(Ee,O)&&U.push(x),rn.label=20;case 20:return w=E.next(),[3,18];case 21:return[3,24];case 22:return L=rn.sent(),en={error:L},[3,24];case 23:try{w&&!w.done&&(nn=E.return)&&nn.call(E)}finally{if(en)throw en.error}return[7];case 24:return U.length>0?[4,this.upsertChannelsToCache(U)]:[3,26];case 25:R=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())(r=n.value).onChannelMemberCountChanged&&r.onChannelMemberCountChanged(R)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=26;case 26:return[3,58];case 27:return F=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.P),k=F.event,S=F.status,ne=F.channelUrl,te=F.channelType,ne&&te===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[4,this.getChannel(ne,!0)]:[3,29];case 28:$=rn.sent(),this._dispatcher.dispatch(new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aT({event:k,source:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.EVENT_POLL_UPDATED})),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)(S===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bj?function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())(r=n.value).onPollDeleted&&r.onPollDeleted($,k.pollId)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))}:function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())(r=n.value).onPollUpdated&&r.onPollUpdated($,k)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))}),rn.label=29;case 29:return[3,58];case 30:return J=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.aa),ee=J.event,ne=J.channelUrl,te=J.channelType,ne&&te===_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN?[4,this.getChannel(ne,!0)]:[3,32];case 31:ae=rn.sent(),this._dispatcher.dispatch(new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aM({event:ee,source:_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a2.EVENT_POLL_VOTED})),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())(r=n.value).onPollVoted&&r.onPollVoted(ae,ee)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),rn.label=32;case 32:return[3,58];case 33:if(!(fe=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.C).event).isOpenChannelEvent)return[3,57];switch(fe.category){case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_ENTER:return[3,34];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_EXIT:return[3,36];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_OPERATOR_UPDATE:return[3,38];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_MUTE:case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_UNMUTE:return[3,40];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_BAN:case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_UNBAN:return[3,42];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_FREEZE:case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_UNFREEZE:return[3,44];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_DELETED:return[3,46];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_PROP_CHANGED:return[3,49];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_META_DATA_CHANGED:return[3,51];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.CHANNEL_META_COUNTERS_CHANGED:return[3,53];case _lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.PINNED_MESSAGE_CHANGED:return[3,55]}return[3,57];case 34:return[4,this.getChannel(fe.channelUrl,!0)];case 35:return Ce=rn.sent(),ve=e.as(Ue),Ee=ve.participantCount,_e=ve.user,ge=Ce._updateParticipantCount(Ee,fe.ts),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onUserEntered&&e.onUserEntered(Ce,_e),ge&&e.onChannelParticipantCountChanged&&e.onChannelParticipantCountChanged(Ce)})),[2]}))}))})),[3,57];case 36:return[4,this.getChannel(fe.channelUrl,!0)];case 37:return ye=rn.sent(),me=e.as(Me),Ee=me.participantCount,we=me.user,Pe=ye._updateParticipantCount(Ee,fe.ts),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onUserExited&&e.onUserExited(ye,we),Pe&&e.onChannelParticipantCountChanged&&e.onChannelParticipantCountChanged(ye)})),[2]}))}))})),[3,57];case 38:return[4,this.getChannel(fe.channelUrl,!0)];case 39:return be=rn.sent(),Te=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.O).operators,be.operators=Te,this.upsertChannelsToCache([be]),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onOperatorUpdated&&e.onOperatorUpdated(be,Te)})),[2]}))}))})),[3,57];case 40:return[4,this.getChannel(fe.channelUrl,!0)];case 41:return Ne=rn.sent(),De=fe.category===_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_MUTE,He=e.as(De?_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a8:_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a9).user,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){De?e.onUserMuted&&e.onUserMuted(Ne,He):e.onUserUnmuted&&e.onUserUnmuted(Ne,He)})),[2]}))}))})),[3,57];case 42:return[4,this.getChannel(fe.channelUrl,!0)];case 43:return Ie=rn.sent(),Oe=fe.category===_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.a.USER_CHANNEL_BAN,xe=e.as(Oe?_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a7:_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a6).user,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){Oe?e.onUserBanned&&e.onUserBanned(Ie,xe):e.onUserUnbanned&&e.onUserUnbanned(Ie,xe)})),[2]}))}))})),[3,57];case 44:return[4,this.getChannel(fe.channelUrl,!0)];case 45:return Ae=rn.sent(),Le=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a5).freeze,Ae.isFrozen=Le,this.upsertChannelsToCache([Ae]),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){Le?e.onChannelFrozen&&e.onChannelFrozen(Ae):e.onChannelUnfrozen&&e.onChannelUnfrozen(Ae)})),[2]}))}))})),[3,57];case 46:return[4,this.getChannel(fe.channelUrl,!0)];case 47:return Re=rn.sent(),[4,this.removeChannelsFromCache([Re.url])];case 48:return rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onChannelDeleted&&e.onChannelDeleted(Re.url,Re.channelType)})),[2]}))}))})),[3,57];case 49:return[4,this.getChannelWithoutCache(fe.channelUrl,!0)];case 50:return Fe=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onChannelChanged&&e.onChannelChanged(Fe)})),[2]}))}))})),[3,57];case 51:return[4,this.getChannel(fe.channelUrl,!0)];case 52:return ke=rn.sent(),Se=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a4),ze=Se.created,qe=Se.updated,Qe=Se.deleted,ze&&ke._upsertCachedMetaData(ze,fe.ts),qe&&ke._upsertCachedMetaData(qe,fe.ts),Qe&&ke._removeFromCachedMetaData(Qe,fe.ts),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){ze&&e.onMetaDataCreated&&e.onMetaDataCreated(ke,ze),qe&&e.onMetaDataUpdated&&e.onMetaDataUpdated(ke,qe),Qe&&e.onMetaDataDeleted&&e.onMetaDataDeleted(ke,Qe)})),[2]}))}))})),[3,57];case 53:return[4,this.getChannel(fe.channelUrl,!0)];case 54:return Ge=rn.sent(),je=e.as(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.a3),Be=je.created,Ke=je.updated,Ve=je.deleted,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){Be&&e.onMetaCounterCreated&&e.onMetaCounterCreated(Ge,Be),Ke&&e.onMetaCounterUpdated&&e.onMetaCounterUpdated(Ge,Ke),Ve&&e.onMetaCounterDeleted&&e.onMetaCounterDeleted(Ge,Ve)})),[2]}))}))})),[3,57];case 55:return[4,this.getChannel(fe.channelUrl,!0)];case 56:return We=rn.sent(),Xe=e.as(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.U),Ye=Xe.pinnedMessageIds,Ze=Xe.latestPinnedMessage,($e=Xe.ts)>We._pinnedMessagesUpdatedAt&&(We.pinnedMessageIds=Ye,We.lastPinnedMessage=Ze,We._pinnedMessagesUpdatedAt=$e,this.upsertChannelsToCache([We]),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){var e,n,r,a,s;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){try{for(e=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.t)(this._openChannelHandlers.values()),n=e.next();!n.done;n=e.next())(r=n.value).onChannelChanged&&r.onChannelChanged(We)}catch(e){a={error:e}}finally{try{n&&!n.done&&(s=e.return)&&s.call(e)}finally{if(a)throw a.error}}return[2]}))}))})),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.G)((function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(tn,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){return this._openChannelHandlers.forEach((function(e){e.onPinnedMessageUpdated&&e.onPinnedMessageUpdated(We)})),[2]}))}))}))),[3,57];case 57:return[3,58];case 58:return[3,60];case 59:if(Je=rn.sent(),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.O)(Je))throw Je;return[3,60];case 60:return[2]}}))}))},o.prototype.addHandler=function(e,n){this._openChannelHandlers.set(e,n)},o.prototype.removeHandler=function(e){this._openChannelHandlers.delete(e)},o.prototype.clearHandler=function(){this._openChannelHandlers.clear()},o.prototype.getChannel=function(e,r){return void 0===r&&(r=!1),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),t.label=1;case 1:return t.trys.push([1,3,,4]),[4,this.getChannelFromCache(e)];case 2:return(n=t.sent())?[2,n]:[3,4];case 3:return t.sent(),[3,4];case 4:return[4,this.getChannelWithoutCache(e,r)];case 5:return[2,t.sent()]}}))}))},o.prototype.getChannelWithoutCache=function(e,r){return void 0===r&&(r=!1),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,a,i;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),n=new _e({channelUrl:e,isInternalCall:r}),[4,this._requestQueue.send(n)];case 1:return a=t.sent(),i=a.as(ge).channel,[4,this.upsertChannelsToCache([i])];case 2:return[2,t.sent()[0]]}}))}))},o.prototype.createChannel=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,r,o,u;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},ve),e),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)(function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",e.operatorUserIds,!0)&&((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.coverUrlOrImage,!0)||(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.i)(e.coverUrlOrImage,!0))&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.name,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.data,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.customType,!0)&&((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.channelUrl)&&/^\w+$/.test(e.channelUrl)||null===e.channelUrl||void 0===e.channelUrl)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",e.isEphemeral,!0)}(n)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),r=new ye(n),[4,this._requestQueue.send(r)];case 1:return o=t.sent(),u=o.as(ge).channel,this.upsertChannelsToCache([u]),[2,u]}}))}))},o}(_lib_bundle_e53b9010_js__WEBPACK_IMPORTED_MODULE_1__.B),be={name:void 0,coverUrlOrImage:void 0,data:void 0,customType:void 0,operatorUserIds:void 0},Te=function(n){function t(e){var t=this,r=e.channelUrl,a=e.token,s=e.limit;return(t=n.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.GET,t.path="".concat(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,"/").concat(encodeURIComponent(r),"/participants"),t.params={token:a,limit:s},t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),Ne=function(n){function t(e,t){var r=n.call(this,e,t)||this;r.participants=[];var a=t.next,s=t.participants;return r.token=a,r.participants=s.map((function(n){return new _lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.P(e,n)})),r}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h),De=function(r){function a(e,n,t){return r.call(this,e,n,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN,t)||this}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(a,r),a.prototype._validate=function(){return r.prototype._validate.call(this)},a.prototype.next=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,n,r,a,s,i;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return this._validate()?this._isLoading?[3,3]:this._hasNext?(this._isLoading=!0,e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new Te((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},this),{token:this._token})),[4,e.send(n)]):[3,2]:[3,5];case 1:return r=t.sent(),a=r.as(Ne),s=a.participants,i=a.token,this._token=i,this._hasNext=!!i,this._isLoading=!1,[2,s];case 2:return[2,[]];case 3:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.queryInProgress;case 4:return[3,6];case 5:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters;case 6:return[2]}}))}))},a}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aB),He=function(n){function t(e){var t=this,r=e.channelUrl,a=e.coverUrlOrImage,u=e.name,c=e.data,h=e.customType,f=e.operatorUserIds;return(t=n.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.PUT,t.path="".concat(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,"/").concat(encodeURIComponent(r)),t.params=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)({cover_url:(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",a)?a:null,cover_file:(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.i)(a)?a:null,name:u,data:c,custom_type:h,operators:f})),t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),Ie=function(n){function t(e,t){var r=n.call(this,e,t)||this;return r.channel=new xe(e,t),r}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h),Oe=function(n){function t(e){var t=this,r=e.channelUrl;return(t=n.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.DELETE,t.path="".concat(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,"/").concat(encodeURIComponent(r)),t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f);!function(n){function t(e,t){return n.call(this,e,t)||this}(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n)}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h);var xe=function(r){function o(e,n){var t,a=this;return(a=r.call(this,e,n)||this)._lastParticipantCountUpdated=0,a.participantCount=0,a.operators=[],a.lastPinnedMessage=null,a._pinnedMessagesUpdatedAt=0,a.channelType=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.C.OPEN,a.participantCount=null!==(t=n.participant_count)&&void 0!==t?t:0,a.operators=Array.isArray(n.operators)?n.operators.map((function(n){return new _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U(e,n)})):[],a.lastPinnedMessage=n.latest_pinned_message?(0,_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.T)(a._iid,(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({channel_type:a.channelType},n.latest_pinned_message)):null,a}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(o,r),o.payloadify=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.z.payloadify(e)),{participant_count:e.participantCount,operators:e.operators.map((function(e){return _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U.payloadify(e)})),latest_pinned_message:e.lastPinnedMessage?(0,_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.as)(e.lastPinnedMessage):null})))},o.prototype.serialize=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.ai)(this)},o.prototype.isOperator=function(e){return e instanceof _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.U?this.isOperator(e.userId):this.operators.some((function(n){return n.userId===e}))},o.prototype._updateParticipantCount=function(e,n){return n>this._lastParticipantCountUpdated&&(this.participantCount=e,this._lastParticipantCountUpdated=n,!0)},o.prototype.createParticipantListQuery=function(e){return new De(this._iid,this.url,e)},o.prototype.refresh=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(e){switch(e.label){case 0:return[4,Pe.of(this._iid).getChannelWithoutCache(this.url)];case 1:return[2,e.sent()]}}))}))},o.prototype.enter=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,n,r,a,s,i;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new me({channelUrl:this.url}),[4,e.send(n)];case 1:return r=t.sent(),a=r.as(Ue),s=a.participantCount,i=a.ts,this._updateParticipantCount(s,i),Pe.of(this._iid).setEnteredToCache(this),[2]}}))}))},o.prototype.exit=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,n,r,a,s,i;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new Ee({channelUrl:this.url}),[4,e.send(n)];case 1:return r=t.sent(),a=r.as(Me),s=a.participantCount,i=a.ts,this._updateParticipantCount(s,i),Pe.of(this._iid).setExitedToCache(this),_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.ak.of(this._iid).fileMessageQueue.cancel(this),[2]}}))}))},o.prototype.updateChannel=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,r,o,u,l;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},be),e),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.w)(function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",e.operatorUserIds,!0)&&((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.coverUrlOrImage,!0)||(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.i)(e.coverUrlOrImage,!0))&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.name,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.data,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",e.customType,!0)}(n)).throw(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters),r=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,o=new He((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({channelUrl:this.url},n)),[4,r.send(o)];case 1:return u=t.sent(),l=u.as(Ie).channel,this._update(l),[4,Pe.of(this._iid).upsertChannelsToCache([l])];case 2:return t.sent(),[2,this]}}))}))},o.prototype.updateChannelWithOperatorUserIds=function(e,r,a,s,i){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){return n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},be),{name:e,coverUrlOrImage:r,data:a,operatorUserIds:s,customType:i}),[2,this.updateChannel(n)]}))}))},o.prototype.delete=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,n;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new Oe({channelUrl:this.url}),[4,e.send(n)];case 1:return t.sent(),[4,Pe.of(this._iid).removeChannelsFromCache([this.url])];case 2:return t.sent(),[2]}}))}))},o.prototype.updateUserMessage=function(e,a){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,s,i,o=this;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return[4,r.prototype.updateUserMessage.call(this,e,a)];case 1:return n=t.sent(),s=!1,i=!1,this.lastPinnedMessage&&this.lastPinnedMessage.messageId===n.messageId&&(this.lastPinnedMessage=n,s=!0,i=!0),s&&Pe.of(this._iid).handlers.map((function(e){e.onChannelChanged&&e.onChannelChanged(o)})),i&&Pe.of(this._iid).handlers.map((function(e){e.onPinnedMessageUpdated&&e.onPinnedMessageUpdated(o)})),[2,n]}}))}))},o.prototype.updateFileMessage=function(e,a){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n,s,i,o=this;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return[4,r.prototype.updateFileMessage.call(this,e,a)];case 1:return n=t.sent(),s=!1,i=!1,this.lastPinnedMessage&&this.lastPinnedMessage.messageId===n.messageId&&(this.lastPinnedMessage=n,s=!0,i=!0),s&&Pe.of(this._iid).handlers.map((function(e){e.onChannelChanged&&e.onChannelChanged(o)})),i&&Pe.of(this._iid).handlers.map((function(e){e.onPinnedMessageUpdated&&e.onPinnedMessageUpdated(o)})),[2,n]}}))}))},o}(_lib_bundle_e1a5e3f1_js__WEBPACK_IMPORTED_MODULE_2__.z),Ae=function(n){function t(e){void 0===e&&(e={});var t=n.call(this)||this;return Object.keys(e).forEach((function(n){t.hasOwnProperty(n)&&(t[n]=e[n])})),t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(function(n){function t(){var e=null!==n&&n.apply(this,arguments)||this;return e.onUserEntered=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onUserExited=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onChannelParticipantCountChanged=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onPollUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onPollVoted=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onPollDeleted=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e.onPinnedMessageUpdated=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aA,e}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_123134d8_js__WEBPACK_IMPORTED_MODULE_3__.B)),Le=function(n){function t(e){var t=this,r=e.token,a=e.limit,s=e.nameKeyword,i=e.urlKeyword,u=e.customTypes,c=e.includeFrozen,h=e.includeMetaData;return(t=n.call(this)||this).method=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.A.GET,t.path=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.bo,t.params=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.e)({token:r,limit:a,name_contains:s,url_contains:i,custom_types:u,show_frozen:c,show_metadata:h,show_pinned_messages:!0}),t}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.f),Re=function(n){function t(e,t){var r=n.call(this,e,t)||this;r.channels=[];var a=t.next,s=t.channels,i=t.ts;return r.token=a,s&&s.length>0&&(r.channels=s.map((function(n){return new xe(e,n)}))),r.ts="number"==typeof i?i:null,r}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(t,n),t}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.h),Fe=function(r){function i(e,n){var t,a,s,i,o,u=this;return(u=r.call(this,e,n)||this).includeFrozen=!0,u.includeMetaData=!0,u.nameKeyword=null,u.urlKeyword=null,u.customTypes=null,u.includeFrozen=null===(t=n.includeFrozen)||void 0===t||t,u.includeMetaData=null===(a=n.includeMetaData)||void 0===a||a,u.nameKeyword=null!==(s=n.nameKeyword)&&void 0!==s?s:null,u.urlKeyword=null!==(i=n.urlKeyword)&&void 0!==i?i:null,u.customTypes=null!==(o=n.customTypes)&&void 0!==o?o:null,u}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(i,r),i.prototype._validate=function(){return r.prototype._validate.call(this)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.includeFrozen)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("boolean",this.includeMetaData)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.nameKeyword,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a)("string",this.urlKeyword,!0)&&(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.Q)("string",this.customTypes,!0)},i.prototype.next=function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var e,n,r,a,s,i;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){switch(t.label){case 0:return this._validate()?this._isLoading?[3,4]:this._hasNext?(this._isLoading=!0,e=_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.V.of(this._iid).requestQueue,n=new Le((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.u)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)((0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},this),{token:this._token}))),[4,e.send(n)]):[3,3]:[3,6];case 1:return r=t.sent(),a=r.as(Re),s=a.channels,i=a.token,this._token=i,this._hasNext=!!i,[4,Pe.of(this._iid).upsertChannelsToCache(s)];case 2:return t.sent(),this._isLoading=!1,[2,s];case 3:return[2,[]];case 4:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.queryInProgress;case 5:return[3,7];case 6:throw _lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.s.invalidParameters;case 7:return[2]}}))}))},i}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.aO),ke=function(r){function a(){var e=null!==r&&r.apply(this,arguments)||this;return e.name="openChannel",e}return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.c)(a,r),a.prototype.init=function(e,n){var t=n.sdkState,a=n.dispatcher,s=n.sessionManager,i=n.requestQueue,o=n.logger,u=n.onlineDetector,l=n.cacheContext;r.prototype.init.call(this,e,{sdkState:t,dispatcher:a,sessionManager:s,requestQueue:i,logger:o,onlineDetector:u,cacheContext:l}),this._manager=new Pe(e,{sdkState:t,dispatcher:a,requestQueue:i,logger:o,cacheContext:l,sessionManager:s})},a.prototype.createOpenChannelListQuery=function(e){return void 0===e&&(e={}),new Fe(this._iid,e)},a.prototype.addOpenChannelHandler=function(e,n){this._manager.addHandler(e,n)},a.prototype.removeOpenChannelHandler=function(e){this._manager.removeHandler(e)},a.prototype.removeAllOpenChannelHandlers=function(){this._manager.clearHandler()},a.prototype.buildOpenChannelFromSerializedData=function(e){return this._manager.buildOpenChannelFromSerializedData(e)},a.prototype.getChannel=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return[2,this._manager.getChannel(e)]}))}))},a.prototype.getChannelWithoutCache=function(e){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return[2,this._manager.getChannelWithoutCache(e)]}))}))},a.prototype.createChannel=function(e){return void 0===e&&(e={}),(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(n){return[2,this._manager.createChannel(e)]}))}))},a.prototype.createChannelWithOperatorUserIds=function(e,r,a,s,i){return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__._)(this,void 0,void 0,(function(){var n;return (0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.b)(this,(function(t){return(n=(0,_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.g)({},ve)).name=e,n.coverUrlOrImage=r,n.data=a,n.operatorUserIds=s,n.customType=i,[2,this._manager.createChannel(n)]}))}))},a}(_lib_bundle_1db3fd0b_js__WEBPACK_IMPORTED_MODULE_0__.a_);


/***/ }),

/***/ 73459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useHandleUploadFiles; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99366);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85385);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69466);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71091);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29515);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(61448);































var useHandleUploadFiles = function (_a, _b) {
    var sendFileMessage = _a.sendFileMessage, sendMultipleFilesMessage = _a.sendMultipleFilesMessage, quoteMessage = _a.quoteMessage;
    var logger = _b.logger;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A)().config;
    var imageCompression = config.imageCompression;
    var uikitUploadSizeLimit = config === null || config === void 0 ? void 0 : config.uikitUploadSizeLimit;
    var uikitMultipleFilesMessageLimit = config === null || config === void 0 ? void 0 : config.uikitMultipleFilesMessageLimit;
    var openModal = (0,_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__.b)().openModal;
    var handleUploadFiles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (files) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var compressedFiles, sendingFiles, file, imageFiles_1, otherFiles_1;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Validate Parameters
                    if (!sendFileMessage || !sendMultipleFilesMessage) {
                        logger.warning('Channel|useHandleUploadFiles: required functions are undefined', { sendFileMessage: sendFileMessage, sendMultipleFilesMessage: sendMultipleFilesMessage });
                        return [2 /*return*/];
                    }
                    if (files.length === 0) {
                        logger.warning('Channel|useHandleUploadFiles: given file list is empty.', { files: files });
                        return [2 /*return*/];
                    }
                    if (files.length > uikitMultipleFilesMessageLimit) {
                        logger.info("Channel|useHandleUploadFiles: Cannot upload files more than ".concat(uikitMultipleFilesMessageLimit));
                        openModal({
                            modalProps: {
                                titleText: stringSet.FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT.replace('%d', "".concat(uikitMultipleFilesMessageLimit)),
                                hideFooter: true,
                            },
                            childElement: function (_a) {
                                var closeModal = _a.closeModal;
                                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__.c, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_6__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                            },
                        });
                        return [2 /*return*/];
                    }
                    /**
                     * Validate file sizes
                     * The default value of uikitUploadSizeLimit is 25MiB
                     */
                    if (files.some(function (file) { return file.size > uikitUploadSizeLimit; })) {
                        logger.info("Channel|useHandleUploadFiles: Cannot upload file size exceeding ".concat(uikitUploadSizeLimit));
                        openModal({
                            modalProps: {
                                titleText: stringSet.FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT.replace('%d', "".concat(Math.floor(uikitUploadSizeLimit / _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_20__.O))),
                                hideFooter: true,
                            },
                            childElement: function (_a) {
                                var closeModal = _a.closeModal;
                                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__.c, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_6__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                            },
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,_chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_8__.c)({
                            files: files,
                            imageCompression: imageCompression,
                            logger: logger,
                        })];
                case 1:
                    compressedFiles = (_a.sent()).compressedFiles;
                    sendingFiles = compressedFiles;
                    // Send File Message
                    if (sendingFiles.length === 1) {
                        logger.info('Channel|useHandleUploadFiles: sending one file.');
                        file = sendingFiles[0];
                        sendFileMessage(file, quoteMessage);
                    }
                    else if (sendingFiles.length > 1) {
                        logger.info('Channel|useHandleUploadFiles: sending multiple files.');
                        imageFiles_1 = [];
                        otherFiles_1 = [];
                        sendingFiles.forEach(function (file) {
                            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.j)(file.type)) {
                                imageFiles_1.push(file);
                            }
                            else {
                                otherFiles_1.push(file);
                            }
                        });
                        return [2 /*return*/, otherFiles_1.reduce(function (previousPromise, item) {
                                return previousPromise.then(function () {
                                    return sendFileMessage(item, quoteMessage);
                                });
                            }, (function () {
                                if (imageFiles_1.length === 0) {
                                    return Promise.resolve();
                                }
                                else if (imageFiles_1.length === 1) {
                                    return sendFileMessage(imageFiles_1[0], quoteMessage);
                                }
                                else {
                                    return sendMultipleFilesMessage(imageFiles_1, quoteMessage);
                                }
                            })())];
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        sendFileMessage,
        sendMultipleFilesMessage,
        quoteMessage,
    ]);
    return handleUploadFiles;
};


//# sourceMappingURL=useHandleUploadFiles.js.map


/***/ }),

/***/ 60196:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kt": function() { return /* binding */ compareMessagesForGrouping; }
/* harmony export */ });
/* unused harmony exports default, getMessageCreatedAt, isSameGroup */
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61448);












/**
 * exported, should be backward compatible
 * @returns [chainTop: `boolean`, chainBottom: `boolean`]
 */
var compareMessagesForGrouping = function (prevMessage, currMessage, nextMessage, currentChannel, replyType) {
    if (!currentChannel || currentChannel.channelType !== 'group') {
        return [
            isSameGroup(prevMessage, currMessage),
            isSameGroup(currMessage, nextMessage),
        ];
    }
    if (replyType === 'THREAD' && (currMessage === null || currMessage === void 0 ? void 0 : currMessage.threadInfo)) {
        return [false, false];
    }
    var sendingStatus = (currMessage === null || currMessage === void 0 ? void 0 : currMessage.sendingStatus) || '';
    var isAcceptable = sendingStatus !== 'pending' && sendingStatus !== 'failed';
    return [
        isSameGroup(prevMessage, currMessage, currentChannel) && isAcceptable,
        isSameGroup(currMessage, nextMessage, currentChannel) && isAcceptable,
    ];
};
var getMessageCreatedAt = function (message) {
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.u)().stringSet;
    return (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_0__.f)(message.createdAt, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT);
};
var isSameGroup = function (message, comparingMessage, currentChannel) {
    var _a, _b;
    if (!(message
        && comparingMessage
        && message.messageType
        && message.messageType !== 'admin'
        && comparingMessage.messageType
        && (comparingMessage === null || comparingMessage === void 0 ? void 0 : comparingMessage.messageType) !== 'admin'
        && 'sender' in message
        && 'sender' in comparingMessage
        && message.createdAt
        && comparingMessage.createdAt
        && message.sender.userId
        && comparingMessage.sender.userId)) {
        return false;
    }
    return ((message === null || message === void 0 ? void 0 : message.sendingStatus) === (comparingMessage === null || comparingMessage === void 0 ? void 0 : comparingMessage.sendingStatus)
        && ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = comparingMessage === null || comparingMessage === void 0 ? void 0 : comparingMessage.sender) === null || _b === void 0 ? void 0 : _b.userId)
        && getMessageCreatedAt(message) === getMessageCreatedAt(comparingMessage)) && (currentChannel ? (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.a)(currentChannel, message) === (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.a)(currentChannel, comparingMessage) : true);
};
var messages = {
    compareMessagesForGrouping: compareMessagesForGrouping,
    getMessageCreatedAt: getMessageCreatedAt,
    isSameGroup: isSameGroup,
};


//# sourceMappingURL=compareMessagesForGrouping.js.map


/***/ }),

/***/ 3196:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getMessagePartsInfo; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_BAXCq_Wt_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46367);
/* harmony import */ var _compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60196);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8978);














/**
 * exported, should be backward compatible
 */
var getMessagePartsInfo = function (_a) {
    var _b = _a.allMessages, allMessages = _b === void 0 ? [] : _b, _c = _a.isMessageGroupingEnabled, isMessageGroupingEnabled = _c === void 0 ? true : _c, _d = _a.currentIndex, currentIndex = _d === void 0 ? 0 : _d, currentMessage = _a.currentMessage, _e = _a.currentChannel, currentChannel = _e === void 0 ? null : _e, _f = _a.replyType, replyType = _f === void 0 ? '' : _f;
    var previousMessage = allMessages[currentIndex - 1];
    var nextMessage = allMessages[currentIndex + 1];
    var _g = isMessageGroupingEnabled
        ? (0,_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_0__/* .compareMessagesForGrouping */ .kt)(previousMessage, currentMessage, nextMessage, currentChannel, replyType)
        : [false, false], chainTop = _g[0], chainBottom = _g[1];
    var previousMessageCreatedAt = previousMessage === null || previousMessage === void 0 ? void 0 : previousMessage.createdAt;
    var currentCreatedAt = currentMessage.createdAt;
    // NOTE: for pending/failed messages
    var isLocalMessage = 'sendingStatus' in currentMessage && (currentMessage.sendingStatus !== 'succeeded');
    // https://stackoverflow.com/a/41855608
    var hasSeparator = isLocalMessage ? false : !(previousMessageCreatedAt && ((0,_chunks_bundle_BAXCq_Wt_js__WEBPACK_IMPORTED_MODULE_8__.i)(currentCreatedAt, previousMessageCreatedAt)));
    return {
        chainTop: chainTop,
        chainBottom: chainBottom,
        hasSeparator: hasSeparator,
    };
};


//# sourceMappingURL=getMessagePartsInfo.js.map


/***/ }),

/***/ 45333:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GroupChannel; }
/* harmony export */ });
/* unused harmony export GroupChannel */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _GroupChannel_context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27165);
/* harmony import */ var _GroupChannel_components_GroupChannelUI_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48580);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46776);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_CLczesce_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(22280);
/* harmony import */ var _GroupChannel_components_TypingIndicator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(42443);
/* harmony import */ var _chunks_bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(15880);
/* harmony import */ var _ui_ConnectionStatus_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(55922);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(10364);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(72661);
/* harmony import */ var _GroupChannel_components_GroupChannelHeader_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(24782);
/* harmony import */ var _chunks_bundle_BpNhTt2R_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(48609);
/* harmony import */ var _ui_ChannelAvatar_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(80203);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(11639);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(56210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(21112);
/* harmony import */ var _GroupChannel_components_MessageList_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(84492);
/* harmony import */ var _GroupChannel_components_Message_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(61284);
/* harmony import */ var _chunks_bundle_CJirTNRH_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(86694);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(75010);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(66421);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(8743);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(1165);
/* harmony import */ var _ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(3533);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(24277);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(69139);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(8627);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(30156);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(56842);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(23012);
/* harmony import */ var _ui_AdminMessage_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(1167);
/* harmony import */ var _ui_QuoteMessage_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(26862);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(78828);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(56342);
/* harmony import */ var _ui_ThreadReplies_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(68873);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(1277);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(40286);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(12210);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(60424);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(28464);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(48845);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(21402);
/* harmony import */ var _ui_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(15345);
/* harmony import */ var _ui_MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(45143);
/* harmony import */ var _ui_MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(74062);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(76039);
/* harmony import */ var _GroupChannel_components_SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(52597);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(12225);
/* harmony import */ var _GroupChannel_components_FileViewer_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(41593);
/* harmony import */ var _chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(70400);
/* harmony import */ var _GroupChannel_components_RemoveMessageModal_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(53346);
/* harmony import */ var _chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(84241);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(44892);
/* harmony import */ var _GroupChannel_components_UnreadCount_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(11621);
/* harmony import */ var _GroupChannel_components_FrozenNotification_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(88137);
/* harmony import */ var _ui_TypingIndicatorBubble_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(10765);
/* harmony import */ var _Channel_utils_getMessagePartsInfo_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(3196);
/* harmony import */ var _Channel_utils_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(60196);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(18107);
/* harmony import */ var _GroupChannel_components_MessageInputWrapper_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(1195);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(91607);
/* harmony import */ var _GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(85562);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(67840);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(12291);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(85385);














































































































































var GroupChannel = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GroupChannel_context_js__WEBPACK_IMPORTED_MODULE_2__/* .GroupChannelProvider */ .H, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GroupChannel_components_GroupChannelUI_js__WEBPACK_IMPORTED_MODULE_3__/* .GroupChannelUI */ .v, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props))));
};


//# sourceMappingURL=GroupChannel.js.map


/***/ }),

/***/ 41593:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FileViewer; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70400);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27165);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4399);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(13160);












































var FileViewer = function (props) {
    var _a = (0,_context_js__WEBPACK_IMPORTED_MODULE_3__/* .useGroupChannelContext */ .St)(), deleteMessage = _a.deleteMessage, onBeforeDownloadFileMessage = _a.onBeforeDownloadFileMessage;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useSendbirdStateContext */ .A)().config;
    var logger = config.logger;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_2__.F, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { deleteMessage: deleteMessage, onDownloadClick: function (e) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!onBeforeDownloadFileMessage)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: props.message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (!allowDownload) {
                            e.preventDefault();
                            (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileViewer: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileViewer: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } })));
};


//# sourceMappingURL=FileViewer.js.map


/***/ }),

/***/ 88137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FrozenNotification; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61448);







var FrozenNotification = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_5__.c)('sendbird-notification', 'sendbird-notification--frozen', className), "data-testid": "sendbird-notification" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-notification__text", testID: "sendbird-notification__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2 }, stringSet.CHANNEL_FROZEN)));
};


//# sourceMappingURL=FrozenNotification.js.map


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GroupChannelHeader; },
/* harmony export */   "t": function() { return /* binding */ GroupChannelHeader; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BpNhTt2R_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48609);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27165);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43822);
/* harmony import */ var _ui_ChannelAvatar_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80203);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11639);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26765);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41238);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59587);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21112);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29515);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(73935);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(13160);


















































var GroupChannelHeader = function (props) {
    var context = (0,_context_js__WEBPACK_IMPORTED_MODULE_3__/* .useGroupChannelContext */ .St)();
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BpNhTt2R_js__WEBPACK_IMPORTED_MODULE_2__.G, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, context, { currentChannel: context.currentChannel })));
};


//# sourceMappingURL=GroupChannelHeader.js.map


/***/ }),

/***/ 48580:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ GroupChannelUI; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_CLczesce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22280);
/* harmony import */ var _GroupChannelHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24782);
/* harmony import */ var _MessageList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84492);
/* harmony import */ var _MessageInputWrapper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1195);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(80360);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46776);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(13160);
/* harmony import */ var _TypingIndicator_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(42443);
/* harmony import */ var _chunks_bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(15880);
/* harmony import */ var _ui_ConnectionStatus_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(55922);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(10364);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_BpNhTt2R_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(48609);
/* harmony import */ var _ui_ChannelAvatar_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(80203);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(11639);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(56210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(21112);
/* harmony import */ var _Message_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(61284);
/* harmony import */ var _chunks_bundle_CJirTNRH_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(86694);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(75010);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(66421);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(8743);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(1165);
/* harmony import */ var _ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(3533);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(24277);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(69139);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(8627);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(30156);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(56842);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(23012);
/* harmony import */ var _ui_AdminMessage_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(1167);
/* harmony import */ var _ui_QuoteMessage_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(26862);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(78828);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(56342);
/* harmony import */ var _ui_ThreadReplies_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(68873);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(1277);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(40286);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(12210);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(60424);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(28464);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(48845);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(21402);
/* harmony import */ var _ui_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(15345);
/* harmony import */ var _ui_MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(45143);
/* harmony import */ var _ui_MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(74062);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(76039);
/* harmony import */ var _SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(52597);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(12225);
/* harmony import */ var _FileViewer_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(41593);
/* harmony import */ var _chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(70400);
/* harmony import */ var _RemoveMessageModal_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(53346);
/* harmony import */ var _chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(84241);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(44892);
/* harmony import */ var _UnreadCount_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(11621);
/* harmony import */ var _FrozenNotification_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(88137);
/* harmony import */ var _ui_TypingIndicatorBubble_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(10765);
/* harmony import */ var _Channel_utils_getMessagePartsInfo_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(3196);
/* harmony import */ var _Channel_utils_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(60196);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(18107);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(91607);
/* harmony import */ var _SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(85562);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(67840);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(12291);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(85385);













































































































































var GroupChannelUI = function (props) {
    var context = (0,_context_js__WEBPACK_IMPORTED_MODULE_2__/* .useGroupChannelContext */ .St)();
    var channelUrl = context.channelUrl, fetchChannelError = context.fetchChannelError;
    // Inject components to presentation layer
    var _a = (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_121__.d)(props), _b = _a.renderChannelHeader, renderChannelHeader = _b === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GroupChannelHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .GroupChannelHeader */ .t, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _b, _c = _a.renderMessageList, renderMessageList = _c === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MessageList_js__WEBPACK_IMPORTED_MODULE_5__/* .MessageList */ .r, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { className: "sendbird-conversation__message-list" })); } : _c, _d = _a.renderMessageInput, renderMessageInput = _d === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MessageInputWrapper_js__WEBPACK_IMPORTED_MODULE_6__/* .MessageInputWrapper */ .jn, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _d;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CLczesce_js__WEBPACK_IMPORTED_MODULE_3__.G, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, context, { isInvalid: fetchChannelError !== null, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};


//# sourceMappingURL=GroupChannelUI.js.map


/***/ }),

/***/ 61284:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Message; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63507);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30302);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_CJirTNRH_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86694);
/* harmony import */ var _FileViewer_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41593);
/* harmony import */ var _RemoveMessageModal_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53346);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71091);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17693);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(75010);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(66421);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(8743);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(21112);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(1165);
/* harmony import */ var _ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(3533);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(95341);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(24277);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(69139);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(4399);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(8627);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(30156);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(82314);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(23012);
/* harmony import */ var _ui_AdminMessage_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(1167);
/* harmony import */ var _ui_QuoteMessage_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(26862);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(78828);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(56342);
/* harmony import */ var _ui_ThreadReplies_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(68873);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(1277);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(40286);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(12210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(60424);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(28464);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(48845);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(21402);
/* harmony import */ var _ui_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(15345);
/* harmony import */ var _ui_MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(45143);
/* harmony import */ var _ui_MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(74062);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(76039);
/* harmony import */ var _SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(52597);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(70400);
/* harmony import */ var _chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(84241);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(44892);



















































































































var Message = function (props) {
    var _a = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)(), config = _a.config, emojiManager = _a.emojiManager;
    var _b = (0,_context_js__WEBPACK_IMPORTED_MODULE_6__/* .useGroupChannelContext */ .St)(), loading = _b.loading, currentChannel = _b.currentChannel, animatedMessageId = _b.animatedMessageId, setAnimatedMessageId = _b.setAnimatedMessageId, scrollToMessage = _b.scrollToMessage, replyType = _b.replyType, threadReplySelectType = _b.threadReplySelectType, isReactionEnabled = _b.isReactionEnabled, toggleReaction = _b.toggleReaction, nicknamesMap = _b.nicknamesMap, setQuoteMessage = _b.setQuoteMessage, renderUserMentionItem = _b.renderUserMentionItem, filterEmojiCategoryIds = _b.filterEmojiCategoryIds, onQuoteMessageClick = _b.onQuoteMessageClick, onReplyInThreadClick = _b.onReplyInThreadClick, onMessageAnimated = _b.onMessageAnimated, onBeforeDownloadFileMessage = _b.onBeforeDownloadFileMessage, messages = _b.messages, updateUserMessage = _b.updateUserMessage, sendUserMessage = _b.sendUserMessage, resendMessage = _b.resendMessage, deleteMessage = _b.deleteMessage;
    var message = props.message;
    var initialized = !loading && Boolean(currentChannel);
    var shouldRenderSuggestedReplies = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useIIFE */ .B7)(function () {
        var _a;
        var _b = config.groupChannel, enableSuggestedReplies = _b.enableSuggestedReplies, showSuggestedRepliesFor = _b.showSuggestedRepliesFor;
        var lastMessageInView = messages[messages.length - 1];
        var hasUnsentMessage = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.k)(lastMessageInView) && lastMessageInView.sendingStatus !== 'succeeded';
        var showSuggestedReplies = showSuggestedRepliesFor === 'all_messages' ? true : message.messageId === ((_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.lastMessage) === null || _a === void 0 ? void 0 : _a.messageId);
        return enableSuggestedReplies && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.g)(message).length > 0 && !hasUnsentMessage && showSuggestedReplies;
    });
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CJirTNRH_js__WEBPACK_IMPORTED_MODULE_7__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { channel: currentChannel, emojiContainer: emojiManager.emojiContainer, editInputDisabled: !initialized
            || (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_5__.i)(currentChannel !== null && currentChannel !== void 0 ? currentChannel : undefined)
            || (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_5__.a)(currentChannel !== null && currentChannel !== void 0 ? currentChannel : undefined)
            || !config.isOnline, shouldRenderSuggestedReplies: shouldRenderSuggestedReplies, isReactionEnabled: isReactionEnabled !== null && isReactionEnabled !== void 0 ? isReactionEnabled : false, replyType: replyType !== null && replyType !== void 0 ? replyType : 'NONE', threadReplySelectType: threadReplySelectType !== null && threadReplySelectType !== void 0 ? threadReplySelectType : _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_10__.T.PARENT, nicknamesMap: nicknamesMap, renderUserMentionItem: renderUserMentionItem, filterEmojiCategoryIds: filterEmojiCategoryIds, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction, setQuoteMessage: setQuoteMessage, onQuoteMessageClick: onQuoteMessageClick, onReplyInThreadClick: onReplyInThreadClick, sendUserMessage: sendUserMessage, updateUserMessage: updateUserMessage, resendMessage: resendMessage, deleteMessage: deleteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, onMessageAnimated: onMessageAnimated, renderFileViewer: function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FileViewer_js__WEBPACK_IMPORTED_MODULE_8__/* .FileViewer */ .$, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); }, renderRemoveMessageModal: function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_RemoveMessageModal_js__WEBPACK_IMPORTED_MODULE_9__/* .RemoveMessageModal */ .N, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); }, usedInLegacy: false, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage })));
};


//# sourceMappingURL=Message.js.map


/***/ }),

/***/ 1195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jn": function() { return /* binding */ MessageInputWrapper; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91607);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48614);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41238);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
/* harmony import */ var _SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85562);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(459);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66421);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67840);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78828);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(32177);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(17693);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(78614);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(12291);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(28464);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(68962);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(21112);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(85385);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(13160);


































































var MessageInputWrapper = function (props) {
    var context = (0,_context_js__WEBPACK_IMPORTED_MODULE_3__/* .useGroupChannelContext */ .St)();
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_2__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, context));
};


//# sourceMappingURL=MessageInputWrapper.js.map


/***/ }),

/***/ 84492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MessageList; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15880);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10364);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43822);
/* harmony import */ var _Message_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61284);
/* harmony import */ var _UnreadCount_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11621);
/* harmony import */ var _FrozenNotification_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88137);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(69466);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41238);
/* harmony import */ var _ui_TypingIndicatorBubble_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10765);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(80360);
/* harmony import */ var _Channel_utils_getMessagePartsInfo_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3196);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23012);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18107);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99366);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_CJirTNRH_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(86694);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48614);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(66421);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(8743);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(21112);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(459);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(1165);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(71091);
/* harmony import */ var _ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(3533);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(16167);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(73935);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(78614);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(69139);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(4399);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(26765);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(30156);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(18087);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(90832);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(82314);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(80031);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(32080);
/* harmony import */ var _ui_AdminMessage_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(1167);
/* harmony import */ var _ui_QuoteMessage_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(26862);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(78828);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(56342);
/* harmony import */ var _ui_ThreadReplies_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(68873);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(1277);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(40286);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(12210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(60424);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(28464);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(48845);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(21402);
/* harmony import */ var _ui_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(15345);
/* harmony import */ var _ui_MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(45143);
/* harmony import */ var _ui_MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(74062);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(76039);
/* harmony import */ var _SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(52597);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(12225);
/* harmony import */ var _FileViewer_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(41593);
/* harmony import */ var _chunks_bundle_C_v0tgQ0_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(70400);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(13160);
/* harmony import */ var _RemoveMessageModal_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(53346);
/* harmony import */ var _chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(84241);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(44892);
/* harmony import */ var _Channel_utils_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(60196);




























































































































var InfiniteList = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, listRef) {
    var messages = props.messages, renderMessage = props.renderMessage, scrollPositionRef = props.scrollPositionRef, scrollDistanceFromBottomRef = props.scrollDistanceFromBottomRef, onLoadPrevious = props.onLoadPrevious, onLoadNext = props.onLoadNext, _a = props.loadThreshold, loadThreshold = _a === void 0 ? 0.05 : _a, typingIndicator = props.typingIndicator, _b = props.onScrollPosition, onScrollPosition = _b === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_105__.n : _b, initDeps = props.initDeps;
    var isFetching = react__WEBPACK_IMPORTED_MODULE_1__.useRef(false);
    var direction = react__WEBPACK_IMPORTED_MODULE_1__.useRef();
    var oldScrollTop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    // SideEffect: scroll to bottom on initialized
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        }
    }, initDeps);
    // SideEffect: keep scroll position
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        if (listRef.current) {
            if (direction.current === 'top') {
                listRef.current.scrollTop = listRef.current.scrollHeight - scrollPositionRef.current;
            }
            if (direction.current === 'bottom') {
                listRef.current.scrollTop = oldScrollTop.current;
            }
            direction.current = undefined;
        }
    }, [listRef.current, messages.length]);
    var handleScroll = function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var list, threshold;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!listRef.current)
                        return [2 /*return*/];
                    list = listRef.current;
                    onScrollPosition(getReachedStatus(list));
                    scrollPositionRef.current = list.scrollHeight - list.scrollTop;
                    scrollDistanceFromBottomRef.current = scrollPositionRef.current - list.clientHeight;
                    oldScrollTop.current = list.scrollTop;
                    if (isFetching.current)
                        return [2 /*return*/];
                    threshold = list.clientHeight * Math.min(Math.max(0, loadThreshold), 1);
                    if (!(list.scrollTop <= threshold)) return [3 /*break*/, 2];
                    isFetching.current = true;
                    direction.current = 'top';
                    return [4 /*yield*/, onLoadPrevious()];
                case 1:
                    _a.sent();
                    isFetching.current = false;
                    return [3 /*break*/, 5];
                case 2:
                    if (!(list.scrollHeight - list.scrollTop - list.clientHeight <= threshold)) return [3 /*break*/, 4];
                    isFetching.current = true;
                    direction.current = 'bottom';
                    return [4 /*yield*/, onLoadNext()];
                case 3:
                    _a.sent();
                    isFetching.current = false;
                    return [3 /*break*/, 5];
                case 4:
                    direction.current = undefined;
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-conversation__scroll-container" },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-conversation__padding" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { ref: listRef, className: "sendbird-conversation__messages-padding", "data-testid": "sendbird-message-list-container", onScroll: handleScroll },
            messages.map(function (message, index) { return renderMessage({ message: message, index: index }); }),
            typingIndicator)));
});
function getReachedStatus(element) {
    if ((0,_chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_16__.a)(element.scrollTop, 0, _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_106__.S)) {
        return 'top';
    }
    if ((0,_chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_16__.a)(element.scrollHeight, element.clientHeight + element.scrollTop, _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_106__.S)) {
        return 'bottom';
    }
    return 'middle';
}

var MessageList = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = props.className, className = _f === void 0 ? '' : _f;
    var _g = (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_105__.d)(props), _h = _g.renderMessage, renderMessage = _h === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Message_js__WEBPACK_IMPORTED_MODULE_7__/* .Message */ .v, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _h, renderMessageContent = _g.renderMessageContent, renderSuggestedReplies = _g.renderSuggestedReplies, renderCustomSeparator = _g.renderCustomSeparator, _j = _g.renderPlaceholderLoader, renderPlaceholderLoader = _j === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.LOADING */ .v.LOADING }); } : _j, _k = _g.renderPlaceholderEmpty, renderPlaceholderEmpty = _k === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { className: "sendbird-conversation__no-messages", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.NO_MESSAGES */ .v.NO_MESSAGES }); } : _k, _l = _g.renderFrozenNotification, renderFrozenNotification = _l === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FrozenNotification_js__WEBPACK_IMPORTED_MODULE_9__/* .FrozenNotification */ .O, { className: "sendbird-conversation__messages__notification" }); } : _l;
    var _m = (0,_context_js__WEBPACK_IMPORTED_MODULE_12__/* .useGroupChannelContext */ .St)(), channelUrl = _m.channelUrl, hasNext = _m.hasNext, loading = _m.loading, messages = _m.messages, newMessages = _m.newMessages, scrollToBottom = _m.scrollToBottom, isScrollBottomReached = _m.isScrollBottomReached, isMessageGroupingEnabled = _m.isMessageGroupingEnabled, scrollRef = _m.scrollRef, scrollDistanceFromBottomRef = _m.scrollDistanceFromBottomRef, scrollPositionRef = _m.scrollPositionRef, currentChannel = _m.currentChannel, replyType = _m.replyType, scrollPubSub = _m.scrollPubSub, loadNext = _m.loadNext, loadPrevious = _m.loadPrevious, setIsScrollBottomReached = _m.setIsScrollBottomReached, resetNewMessages = _m.resetNewMessages;
    var store = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__/* .useSendbirdStateContext */ .A)();
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), unreadSinceDate = _o[0], setUnreadSinceDate = _o[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (isScrollBottomReached) {
            setUnreadSinceDate(undefined);
        }
        else {
            setUnreadSinceDate(new Date());
        }
    }, [isScrollBottomReached]);
    /**
     * 1. Move the message list scroll
     *    when each message's height is changed by `reactions` OR `showEdit`
     * 2. Keep the scrollBottom value after fetching new message list
     */
    var onMessageContentSizeChanged = function (isBottomMessageAffected) {
        if (isBottomMessageAffected === void 0) { isBottomMessageAffected = false; }
        var elem = scrollRef.current;
        if (elem) {
            var latestDistance = scrollDistanceFromBottomRef.current;
            var currentDistance = elem.scrollHeight - elem.scrollTop - elem.offsetHeight;
            if (latestDistance < currentDistance && (!isBottomMessageAffected || latestDistance < _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_106__.S)) {
                var diff = currentDistance - latestDistance;
                // Move the scroll as much as the height of the message has changed
                scrollPubSub.publish('scroll', { top: elem.scrollTop + diff, lazy: false, animated: false });
            }
        }
    };
    var renderer = {
        frozenNotification: function () {
            if (!currentChannel || !currentChannel.isFrozen)
                return null;
            return renderFrozenNotification();
        },
        unreadMessagesNotification: function () {
            if (isScrollBottomReached || !unreadSinceDate)
                return null;
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_UnreadCount_js__WEBPACK_IMPORTED_MODULE_8__/* .UnreadCount */ .b, { className: "sendbird-conversation__messages__notification", count: newMessages.length, lastReadAt: unreadSinceDate, onClick: function () { return scrollToBottom(); } }));
        },
        scrollToBottomButton: function () {
            if (!hasNext() && isScrollBottomReached)
                return null;
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-conversation__scroll-bottom-button", onClick: function () { return scrollToBottom(); }, onKeyDown: function () { return scrollToBottom(); }, tabIndex: 0, role: "button" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.CHEVRON_DOWN */ .Qy.CHEVRON_DOWN, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconColors.PRIMARY */ .zo.PRIMARY })));
        },
    };
    if (loading) {
        return renderPlaceholderLoader();
    }
    if (messages.length === 0) {
        return renderPlaceholderEmpty();
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-conversation__messages ".concat(className) },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(InfiniteList, { ref: scrollRef, initDeps: [channelUrl], scrollPositionRef: scrollPositionRef, scrollDistanceFromBottomRef: scrollDistanceFromBottomRef, onLoadNext: loadNext, onLoadPrevious: loadPrevious, onScrollPosition: function (it) {
                    var isScrollBottomReached = it === 'bottom';
                    if (newMessages.length > 0 && isScrollBottomReached) {
                        resetNewMessages();
                    }
                    setIsScrollBottomReached(isScrollBottomReached);
                }, messages: messages, renderMessage: function (_a) {
                    var message = _a.message, index = _a.index;
                    var _b = (0,_Channel_utils_getMessagePartsInfo_js__WEBPACK_IMPORTED_MODULE_13__/* .getMessagePartsInfo */ .v)({
                        allMessages: messages,
                        replyType: replyType !== null && replyType !== void 0 ? replyType : 'NONE',
                        isMessageGroupingEnabled: isMessageGroupingEnabled !== null && isMessageGroupingEnabled !== void 0 ? isMessageGroupingEnabled : false,
                        currentIndex: index,
                        currentMessage: message,
                        currentChannel: currentChannel,
                    }), chainTop = _b.chainTop, chainBottom = _b.chainBottom, hasSeparator = _b.hasSeparator;
                    var isOutgoingMessage = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.k)(message) && message.sender.userId === store.config.userId;
                    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Message_context_js__WEBPACK_IMPORTED_MODULE_14__/* .MessageProvider */ .x, { message: message, key: (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_15__.g)(message), isByMe: isOutgoingMessage }, renderMessage({
                        handleScroll: onMessageContentSizeChanged,
                        message: message,
                        hasSeparator: hasSeparator,
                        chainTop: chainTop,
                        chainBottom: chainBottom,
                        renderMessageContent: renderMessageContent,
                        renderSuggestedReplies: renderSuggestedReplies,
                        renderCustomSeparator: renderCustomSeparator,
                    })));
                }, typingIndicator: !hasNext()
                    && ((_b = (_a = store === null || store === void 0 ? void 0 : store.config) === null || _a === void 0 ? void 0 : _a.groupChannel) === null || _b === void 0 ? void 0 : _b.enableTypingIndicator)
                    && ((_e = (_d = (_c = store === null || store === void 0 ? void 0 : store.config) === null || _c === void 0 ? void 0 : _c.groupChannel) === null || _d === void 0 ? void 0 : _d.typingIndicatorTypes) === null || _e === void 0 ? void 0 : _e.has(_chunks_bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_4__.T.Bubble)) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(TypingIndicatorBubbleWrapper, { channelUrl: channelUrl, handleScroll: onMessageContentSizeChanged })) }),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, renderer.frozenNotification()),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, renderer.unreadMessagesNotification()),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, renderer.scrollToBottomButton()))));
};
var TypingIndicatorBubbleWrapper = function (props) {
    var stores = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__/* .useSendbirdStateContext */ .A)().stores;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), typingMembers = _a[0], setTypingMembers = _a[1];
    (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useGroupChannelHandler */ .l7)(stores.sdkStore.sdk, {
        onTypingStatusUpdated: function (channel) {
            if (channel.url === props.channelUrl) {
                setTypingMembers(channel.getTypingUsers());
            }
        },
    });
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_TypingIndicatorBubble_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { typingMembers: typingMembers, handleScroll: props.handleScroll });
};


//# sourceMappingURL=MessageList.js.map


/***/ }),

/***/ 53346:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ RemoveMessageModal; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84241);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46776);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(44892);










































var RemoveMessageModal = function (props) {
    var deleteMessage = (0,_context_js__WEBPACK_IMPORTED_MODULE_2__/* .useGroupChannelContext */ .St)().deleteMessage;
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BHNcTHkg_js__WEBPACK_IMPORTED_MODULE_3__.R, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { deleteMessage: deleteMessage }));
};


//# sourceMappingURL=RemoveMessageModal.js.map


/***/ }),

/***/ 85562:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SuggestedMentionList; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61448);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41238);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(459);

















var SuggestedMentionList = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_2__.S, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)));
};


//# sourceMappingURL=SuggestedMentionList.js.map


/***/ }),

/***/ 52597:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuggestedReplies; }
/* harmony export */ });
/* unused harmony export ReplyItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ReplyItem = function (_a) {
    var value = _a.value, onClickReply = _a.onClickReply, _b = _a.type, type = _b === void 0 ? 'vertical' : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-suggested-replies__option ".concat(type), id: value, onClick: function (e) { return onClickReply(e, value); } }, value));
};
var SuggestedReplies = function (_a) {
    var replyOptions = _a.replyOptions, onSendMessage = _a.onSendMessage, _b = _a.type, type = _b === void 0 ? 'vertical' : _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), replied = _c[0], setReplied = _c[1];
    var onClickReply = function (event, option) {
        event.preventDefault();
        onSendMessage({ message: option });
        setReplied(true);
    };
    if (replied) {
        return null;
    }
    var children = replyOptions.map(function (option, index) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReplyItem, { key: index, value: option, onClickReply: onClickReply, type: type }));
    });
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-suggested-replies ".concat(type) }, children);
};


//# sourceMappingURL=SuggestedReplies.js.map


/***/ }),

/***/ 42443:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c2": function() { return /* binding */ TypingIndicator; }
/* harmony export */ });
/* unused harmony exports TypingIndicatorText, default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42391);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88071);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71091);










var TypingIndicatorText = function (_a) {
    var members = _a.members;
    function getText() {
        var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.L).stringSet;
        if (!members || members.length === 0) {
            return '';
        }
        if (members && members.length === 1) {
            return "".concat(members[0].nickname, " ").concat(stringSet.TYPING_INDICATOR__IS_TYPING);
        }
        if (members && members.length === 2) {
            return "".concat(members[0].nickname, " ").concat(stringSet.TYPING_INDICATOR__AND, " ").concat(members[1].nickname, " ").concat(stringSet.TYPING_INDICATOR__ARE_TYPING);
        }
        return stringSet.TYPING_INDICATOR__MULTIPLE_TYPING;
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, getText());
};
var TypingIndicator = function (_a) {
    var _b, _c, _d;
    var channelUrl = _a.channelUrl;
    var globalStore = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)();
    var sb = (_c = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.sdk;
    var logger = (_d = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _d === void 0 ? void 0 : _d.logger;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_7__.u)()), handlerId = _e[0], setHandlerId = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), typingMembers = _f[0], setTypingMembers = _f[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var _a;
        if ((_a = sb === null || sb === void 0 ? void 0 : sb.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler) {
            sb.groupChannel.removeGroupChannelHandler(handlerId);
            var newHandlerId = (0,_chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_7__.u)();
            var handler = new _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_8__/* .GroupChannelHandler */ .pe({
                onTypingStatusUpdated: function (groupChannel) {
                    // there is a possible warning in here - setState called after unmount
                    logger.info('Channel > Typing Indicator: onTypingStatusUpdated', groupChannel);
                    if (groupChannel.url === channelUrl) {
                        var members = groupChannel.getTypingUsers();
                        setTypingMembers(members);
                    }
                },
            });
            sb.groupChannel.addGroupChannelHandler(newHandlerId, handler);
            setHandlerId(newHandlerId);
        }
        return function () {
            var _a;
            setTypingMembers([]);
            if ((_a = sb === null || sb === void 0 ? void 0 : sb.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) {
                sb.groupChannel.removeGroupChannelHandler(handlerId);
            }
        };
    }, [channelUrl]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-conversation__footer__typing-indicator__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_2 },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(TypingIndicatorText, { members: typingMembers })));
};


//# sourceMappingURL=TypingIndicator.js.map


/***/ }),

/***/ 11621:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ UnreadCount; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61448);










var UnreadCount = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.count, count = _c === void 0 ? 0 : _c, _d = _a.time, time = _d === void 0 ? '' : _d, onClick = _a.onClick, lastReadAt = _a.lastReadAt;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L), stringSet = _e.stringSet, dateLocale = _e.dateLocale;
    var unreadSince = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var _a, _b;
        // TODO: Remove this on v4
        if (stringSet.CHANNEL__MESSAGE_LIST__NOTIFICATION__ON !== 'on') {
            var timeArray = ((_b = (_a = time === null || time === void 0 ? void 0 : time.toString) === null || _a === void 0 ? void 0 : _a.call(time)) === null || _b === void 0 ? void 0 : _b.split(' ')) || [];
            timeArray === null || timeArray === void 0 ? void 0 : timeArray.splice(-2, 0, stringSet.CHANNEL__MESSAGE_LIST__NOTIFICATION__ON);
            return timeArray.join(' ');
        }
        else if (lastReadAt) {
            return (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_4__.f)(lastReadAt, stringSet.DATE_FORMAT__MESSAGE_LIST__NOTIFICATION__UNREAD_SINCE, { locale: dateLocale });
        }
    }, [time, lastReadAt]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_7__.c)(count < 1 ? 'sendbird-notification--hide' : 'sendbird-notification', className), "data-testid": "sendbird-notification", onClick: onClick },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-notification__text", testID: "sendbird-notification__text", color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONCONTENT_1, type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2 }, "".concat(count, " "),
            stringSet.CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE, " ".concat(unreadSince)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.CHEVRON_DOWN */ .Qy.CHEVRON_DOWN, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT */ .zo.CONTENT })));
};


//# sourceMappingURL=UnreadCount.js.map


/***/ }),

/***/ 27165:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GroupChannelProvider; },
/* harmony export */   "St": function() { return /* binding */ useGroupChannelContext; }
/* harmony export */ });
/* unused harmony export GroupChannelContext */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(4500);
/* harmony import */ var _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(34182);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46776);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38204);
/* harmony import */ var _chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(3153);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30302);
/* harmony import */ var _chunks_bundle_B5OWYHQO_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(50152);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69466);
/* harmony import */ var _chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(14014);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13160);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48614);







































function useMessageListScroll(behavior, deps) {
    if (deps === void 0) { deps = []; }
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var scrollPositionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var scrollDistanceFromBottomRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var scrollPubSub = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function () { return (0,_chunks_bundle_B5OWYHQO_js__WEBPACK_IMPORTED_MODULE_25__.p)({ publishSynchronous: true }); })[0];
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isScrollBottomReached = _a[0], setIsScrollBottomReached = _a[1];
    // SideEffect: Reset scroll state
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        scrollPositionRef.current = 0;
        scrollDistanceFromBottomRef.current = 0;
        setIsScrollBottomReached(true);
        if (scrollRef.current)
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, deps);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        var unsubscribes = [];
        unsubscribes.push(scrollPubSub.subscribe('scrollToBottom', function (_a) {
            var resolve = _a.resolve, animated = _a.animated;
            runCallback(function () {
                if (!scrollRef.current) {
                    if (resolve)
                        resolve();
                    return;
                }
                if (scrollRef.current.scroll) {
                    scrollRef.current.scroll({ top: scrollRef.current.scrollHeight, behavior: getScrollBehavior(behavior, animated) });
                }
                else {
                    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
                }
                // Update data by manual update
                scrollDistanceFromBottomRef.current = 0;
                setIsScrollBottomReached(true);
                if (resolve)
                    resolve();
            });
        }));
        unsubscribes.push(scrollPubSub.subscribe('scroll', function (_a) {
            var top = _a.top, animated = _a.animated, lazy = _a.lazy, resolve = _a.resolve;
            runCallback(function () {
                if (!scrollRef.current)
                    return;
                var _a = scrollRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
                if (scrollRef.current.scroll) {
                    scrollRef.current.scroll({ top: top, behavior: getScrollBehavior(behavior, animated) });
                }
                else if (typeof top === 'number') {
                    scrollRef.current.scrollTop = top;
                }
                // Update data by manual update
                scrollDistanceFromBottomRef.current = Math.max(0, scrollHeight - scrollTop - clientHeight);
                setIsScrollBottomReached(scrollDistanceFromBottomRef.current === 0);
                if (resolve)
                    resolve();
            }, lazy);
        }));
        return function () {
            unsubscribes.forEach(function (_a) {
                var remove = _a.remove;
                return remove();
            });
        };
    }, [behavior]);
    return {
        scrollRef: scrollRef,
        scrollPubSub: scrollPubSub,
        isScrollBottomReached: isScrollBottomReached,
        setIsScrollBottomReached: setIsScrollBottomReached,
        scrollDistanceFromBottomRef: scrollDistanceFromBottomRef,
        scrollPositionRef: scrollPositionRef,
    };
}
function runCallback(callback, lazy) {
    if (lazy === void 0) { lazy = true; }
    if (lazy) {
        setTimeout(function () {
            callback();
        });
    }
    else {
        callback();
    }
}
function getScrollBehavior(behavior, animated) {
    if (typeof animated === 'boolean')
        return animated ? 'smooth' : 'auto';
    return behavior;
}

var pass = function (value) { return value; };
/**
 * @description This hook controls common processes related to message sending, updating.
 * */
function useMessageActions(params) {
    var _this = this;
    var _a = params.onBeforeSendUserMessage, onBeforeSendUserMessage = _a === void 0 ? pass : _a, _b = params.onBeforeSendFileMessage, onBeforeSendFileMessage = _b === void 0 ? pass : _b, _c = params.onBeforeUpdateUserMessage, onBeforeUpdateUserMessage = _c === void 0 ? pass : _c, _d = params.onBeforeSendVoiceMessage, onBeforeSendVoiceMessage = _d === void 0 ? pass : _d, _e = params.onBeforeSendMultipleFilesMessage, onBeforeSendMultipleFilesMessage = _e === void 0 ? pass : _e, sendFileMessage = params.sendFileMessage, sendMultipleFilesMessage = params.sendMultipleFilesMessage, sendUserMessage = params.sendUserMessage, updateUserMessage = params.updateUserMessage, scrollToBottom = params.scrollToBottom, quoteMessage = params.quoteMessage, replyType = params.replyType;
    var buildInternalMessageParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (basicParams) {
        var messageParams = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, basicParams);
        if (params.quoteMessage && replyType !== 'NONE') {
            messageParams.isReplyToChannel = true;
            messageParams.parentMessageId = quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId;
        }
        return messageParams;
    }, [replyType, quoteMessage]);
    // This is a hack for the hotfix of following issue
    // https://sendbird.atlassian.net/browse/SBISSUE-17029
    var asyncScrollToBottom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        setTimeout(scrollToBottom, 0);
    }, []);
    return {
        sendUserMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (params) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var internalParams, processedParams;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalParams = buildInternalMessageParams(params);
                        return [4 /*yield*/, onBeforeSendUserMessage(internalParams)];
                    case 1:
                        processedParams = _a.sent();
                        return [2 /*return*/, sendUserMessage(processedParams, asyncScrollToBottom)];
                }
            });
        }); }, [buildInternalMessageParams, sendUserMessage, scrollToBottom]),
        sendFileMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (params) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var internalParams, processedParams;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalParams = buildInternalMessageParams(params);
                        return [4 /*yield*/, onBeforeSendFileMessage(internalParams)];
                    case 1:
                        processedParams = _a.sent();
                        return [2 /*return*/, sendFileMessage(processedParams, asyncScrollToBottom)];
                }
            });
        }); }, [buildInternalMessageParams, sendFileMessage, scrollToBottom]),
        sendMultipleFilesMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (params) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var internalParams, processedParams;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalParams = buildInternalMessageParams(params);
                        return [4 /*yield*/, onBeforeSendMultipleFilesMessage(internalParams)];
                    case 1:
                        processedParams = _a.sent();
                        return [2 /*return*/, sendMultipleFilesMessage(processedParams, asyncScrollToBottom)];
                }
            });
        }); }, [buildInternalMessageParams, sendMultipleFilesMessage, scrollToBottom]),
        sendVoiceMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (params, duration) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var internalParams, processedParams;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalParams = buildInternalMessageParams((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, params), { fileName: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__.f, mimeType: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__.b, metaArrays: [
                                new _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_27__.aq({
                                    key: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__.M,
                                    value: ["".concat(duration)],
                                }),
                                new _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_27__.aq({
                                    key: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__.g,
                                    value: [_chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_26__.h],
                                }),
                            ] }));
                        return [4 /*yield*/, onBeforeSendVoiceMessage(internalParams)];
                    case 1:
                        processedParams = _a.sent();
                        return [2 /*return*/, sendFileMessage(processedParams, asyncScrollToBottom)];
                }
            });
        }); }, [buildInternalMessageParams, sendFileMessage, scrollToBottom]),
        updateUserMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (messageId, params) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var internalParams, processedParams;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalParams = buildInternalMessageParams(params);
                        return [4 /*yield*/, onBeforeUpdateUserMessage(internalParams)];
                    case 1:
                        processedParams = _a.sent();
                        return [2 /*return*/, updateUserMessage(messageId, processedParams)];
                }
            });
        }); }, [buildInternalMessageParams, updateUserMessage]),
    };
}

var GroupChannelContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
var GroupChannelProvider = function (props) {
    var channelUrl = props.channelUrl, children = props.children, moduleReactionEnabled = props.isReactionEnabled, moduleReplyType = props.replyType, moduleThreadReplySelectType = props.threadReplySelectType, _a = props.isMessageGroupingEnabled, isMessageGroupingEnabled = _a === void 0 ? true : _a, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, showSearchIcon = props.showSearchIcon, _b = props.disableMarkAsRead, disableMarkAsRead = _b === void 0 ? false : _b, _c = props.scrollBehavior, scrollBehavior = _c === void 0 ? 'auto' : _c, startingPoint = props.startingPoint, _animatedMessageId = props.animatedMessageId, messageListQueryParams = props.messageListQueryParams, onBeforeSendUserMessage = props.onBeforeSendUserMessage, onBeforeSendFileMessage = props.onBeforeSendFileMessage, onBeforeSendVoiceMessage = props.onBeforeSendVoiceMessage, onBeforeSendMultipleFilesMessage = props.onBeforeSendMultipleFilesMessage, onBeforeUpdateUserMessage = props.onBeforeUpdateUserMessage, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, onMessageAnimated = props.onMessageAnimated, onBackClick = props.onBackClick, onChatHeaderActionClick = props.onChatHeaderActionClick, onReplyInThreadClick = props.onReplyInThreadClick, onSearchClick = props.onSearchClick, onQuoteMessageClick = props.onQuoteMessageClick, renderUserMentionItem = props.renderUserMentionItem, filterEmojiCategoryIds = props.filterEmojiCategoryIds;
    // Global context
    var _d = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useSendbirdStateContext */ .A)(), config = _d.config, stores = _d.stores;
    var sdkStore = stores.sdkStore;
    var markAsReadScheduler = config.markAsReadScheduler, logger = config.logger, htmlTextDirection = config.htmlTextDirection, forceLeftToRightMessageLayout = config.forceLeftToRightMessageLayout;
    // State
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), quoteMessage = _e[0], setQuoteMessage = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), animatedMessageId = _f[0], setAnimatedMessageId = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), currentChannel = _g[0], setCurrentChannel = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), fetchChannelError = _h[0], setFetchChannelError = _h[1];
    // Ref
    var _j = useMessageListScroll(scrollBehavior, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]), scrollRef = _j.scrollRef, scrollPubSub = _j.scrollPubSub, scrollDistanceFromBottomRef = _j.scrollDistanceFromBottomRef, isScrollBottomReached = _j.isScrollBottomReached, setIsScrollBottomReached = _j.setIsScrollBottomReached, scrollPositionRef = _j.scrollPositionRef;
    var messageInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var toggleReaction = (0,_chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_5__.u)(currentChannel, logger);
    var replyType = (0,_chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_28__.g)(moduleReplyType !== null && moduleReplyType !== void 0 ? moduleReplyType : config.groupChannel.replyType).upperCase;
    var threadReplySelectType = (0,_chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_28__.a)(moduleThreadReplySelectType !== null && moduleThreadReplySelectType !== void 0 ? moduleThreadReplySelectType : config.groupChannel.threadReplySelectType).upperCase;
    var chatReplyType = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useIIFE */ .B7)(function () {
        if (replyType === 'NONE')
            return _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_29__.ay.NONE;
        return _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_29__.ay.ONLY_REPLY_TO_CHANNEL;
    });
    var isReactionEnabled = (0,_chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_30__.g)({
        channel: currentChannel,
        config: config,
        moduleLevel: moduleReactionEnabled,
    });
    var nicknamesMap = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { var _a; return new Map(((_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members) !== null && _a !== void 0 ? _a : []).map(function (_a) {
        var userId = _a.userId, nickname = _a.nickname;
        return [userId, nickname];
    })); }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members]);
    var messageDataSource = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useGroupChannelMessages */ .Tz)(sdkStore.sdk, currentChannel, {
        startingPoint: startingPoint,
        replyType: chatReplyType,
        collectionCreator: getCollectionCreator(currentChannel, messageListQueryParams),
        shouldCountNewMessages: function () { return !isScrollBottomReached; },
        markAsRead: function (channels) {
            if (isScrollBottomReached && !disableMarkAsRead) {
                channels.forEach(function (it) { return markAsReadScheduler.push(it); });
            }
        },
        onMessagesReceived: function () {
            // FIXME: onMessagesReceived called with onApiResult
            if (isScrollBottomReached && (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__.d)()) {
                setTimeout(function () {
                    scrollPubSub.publish('scrollToBottom', {});
                }, 10);
            }
        },
        onChannelDeleted: function () {
            setCurrentChannel(null);
            setFetchChannelError(null);
            onBackClick === null || onBackClick === void 0 ? void 0 : onBackClick();
        },
        onCurrentUserBanned: function () {
            setCurrentChannel(null);
            setFetchChannelError(null);
            onBackClick === null || onBackClick === void 0 ? void 0 : onBackClick();
        },
        onChannelUpdated: function (channel) { return setCurrentChannel(channel); },
        logger: logger,
    });
    // SideEffect: Fetch and set to current channel by channelUrl prop.
    (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useAsyncEffect */ .bd)(function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var channel, error_1;
        var _a;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(sdkStore.initialized && channelUrl)) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, sdkStore.sdk.groupChannel.getChannel(channelUrl)];
                case 2:
                    channel = _b.sent();
                    setCurrentChannel(channel);
                    setFetchChannelError(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    setCurrentChannel(null);
                    setFetchChannelError(error_1);
                    (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, 'GroupChannelProvider: error when fetching channel', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    // Reset states when channel changes
                    setQuoteMessage(null);
                    setAnimatedMessageId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [sdkStore.initialized, sdkStore.sdk, channelUrl]);
    // SideEffect: Scroll to the bottom
    //  - On the initialized message list
    //  - On messages sent from the thread
    (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .useAsyncLayoutEffect */ .A0)(function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var onSentMessageFromOtherModule, subscribes;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            if (messageDataSource.initialized) {
                scrollPubSub.publish('scrollToBottom', {});
            }
            onSentMessageFromOtherModule = function (data) {
                if (data.channel.url === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url))
                    scrollPubSub.publish('scrollToBottom', {});
            };
            subscribes = [
                config.pubSub.subscribe(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_7__.p.SEND_USER_MESSAGE, onSentMessageFromOtherModule),
                config.pubSub.subscribe(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_7__.p.SEND_FILE_MESSAGE, onSentMessageFromOtherModule),
            ];
            return [2 /*return*/, function () {
                    subscribes.forEach(function (subscribe) { return subscribe.remove(); });
                }];
        });
    }); }, [messageDataSource.initialized, currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    // SideEffect: Reset MessageCollection with startingPoint prop.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (typeof startingPoint === 'number') {
            // We do not handle animation for message search here.
            // Please update the animatedMessageId prop to trigger the animation.
            scrollToMessage(startingPoint, 0, false, false);
        }
    }, [startingPoint]);
    // SideEffect: Update animatedMessageId prop to state.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (_animatedMessageId)
            setAnimatedMessageId(_animatedMessageId);
    }, [_animatedMessageId]);
    (0,_chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_8__.u)(htmlTextDirection, forceLeftToRightMessageLayout, messageDataSource.loading);
    var scrollToBottom = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .usePreservedCallback */ .zS)(function (animated) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!scrollRef.current)
                        return [2 /*return*/];
                    setAnimatedMessageId(null);
                    setIsScrollBottomReached(true);
                    if (!(config.isOnline && messageDataSource.hasNext())) return [3 /*break*/, 2];
                    return [4 /*yield*/, messageDataSource.resetWithStartingPoint(Number.MAX_SAFE_INTEGER)];
                case 1:
                    _a.sent();
                    scrollPubSub.publish('scrollToBottom', { animated: animated });
                    return [3 /*break*/, 3];
                case 2:
                    scrollPubSub.publish('scrollToBottom', { animated: animated });
                    _a.label = 3;
                case 3:
                    if (currentChannel && !messageDataSource.hasNext()) {
                        messageDataSource.resetNewMessages();
                        if (!disableMarkAsRead)
                            markAsReadScheduler.push(currentChannel);
                    }
                    return [2 /*return*/];
            }
        });
    }); });
    var scrollToMessage = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__/* .usePreservedCallback */ .zS)(function (createdAt, messageId, messageFocusAnimated, scrollAnimated) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var element, parentNode, clickHandler, message, topOffset;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    element = scrollRef.current;
                    parentNode = element === null || element === void 0 ? void 0 : element.parentNode;
                    clickHandler = {
                        activate: function () {
                            if (!element || !parentNode)
                                return;
                            element.style.pointerEvents = 'auto';
                            parentNode.style.cursor = 'auto';
                        },
                        deactivate: function () {
                            if (!element || !parentNode)
                                return;
                            element.style.pointerEvents = 'none';
                            parentNode.style.cursor = 'wait';
                        },
                    };
                    clickHandler.deactivate();
                    setAnimatedMessageId(null);
                    message = messageDataSource.messages.find(function (it) { return it.messageId === messageId || it.createdAt === createdAt; });
                    if (!message) return [3 /*break*/, 1];
                    topOffset = (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__.e)(message.createdAt);
                    if (topOffset)
                        scrollPubSub.publish('scroll', { top: topOffset, animated: scrollAnimated });
                    if (messageFocusAnimated !== null && messageFocusAnimated !== void 0 ? messageFocusAnimated : true)
                        setAnimatedMessageId(messageId);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, messageDataSource.resetWithStartingPoint(createdAt)];
                case 2:
                    _a.sent();
                    setTimeout(function () {
                        var topOffset = (0,_chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__.e)(createdAt);
                        if (topOffset)
                            scrollPubSub.publish('scroll', { top: topOffset, lazy: false, animated: scrollAnimated });
                        if (messageFocusAnimated !== null && messageFocusAnimated !== void 0 ? messageFocusAnimated : true)
                            setAnimatedMessageId(messageId);
                    });
                    _a.label = 3;
                case 3:
                    clickHandler.activate();
                    return [2 /*return*/];
            }
        });
    }); });
    var messageActions = useMessageActions((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), messageDataSource), { scrollToBottom: scrollToBottom, quoteMessage: quoteMessage, replyType: replyType }));
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(GroupChannelContext.Provider, { value: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ 
            // # Props
            channelUrl: channelUrl, isReactionEnabled: isReactionEnabled, isMessageGroupingEnabled: isMessageGroupingEnabled, isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled, showSearchIcon: showSearchIcon !== null && showSearchIcon !== void 0 ? showSearchIcon : config.groupChannelSettings.enableMessageSearch, replyType: replyType, threadReplySelectType: threadReplySelectType, disableMarkAsRead: disableMarkAsRead, scrollBehavior: scrollBehavior, 
            // # Custom Props
            messageListQueryParams: messageListQueryParams, 
            // ## Message
            onBeforeSendUserMessage: onBeforeSendUserMessage, onBeforeSendFileMessage: onBeforeSendFileMessage, onBeforeSendVoiceMessage: onBeforeSendVoiceMessage, onBeforeSendMultipleFilesMessage: onBeforeSendMultipleFilesMessage, onBeforeUpdateUserMessage: onBeforeUpdateUserMessage, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage, 
            // ## Focusing
            onMessageAnimated: onMessageAnimated, 
            // ## Click
            onBackClick: onBackClick, onChatHeaderActionClick: onChatHeaderActionClick, onReplyInThreadClick: onReplyInThreadClick, onSearchClick: onSearchClick, onQuoteMessageClick: onQuoteMessageClick, 
            // ## Custom render
            renderUserMentionItem: renderUserMentionItem, filterEmojiCategoryIds: filterEmojiCategoryIds, 
            // Internal Interface
            currentChannel: currentChannel, fetchChannelError: fetchChannelError, nicknamesMap: nicknamesMap, scrollRef: scrollRef, scrollDistanceFromBottomRef: scrollDistanceFromBottomRef, scrollPositionRef: scrollPositionRef, scrollPubSub: scrollPubSub, messageInputRef: messageInputRef, quoteMessage: quoteMessage, setQuoteMessage: setQuoteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, isScrollBottomReached: isScrollBottomReached, setIsScrollBottomReached: setIsScrollBottomReached, scrollToBottom: scrollToBottom, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction }, messageDataSource), messageActions) },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_3__.U, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), children)));
};
var useGroupChannelContext = function () {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GroupChannelContext);
    if (!context)
        throw new Error('GroupChannelContext not found. Use within the GroupChannel module.');
    return context;
};
function getCollectionCreator(groupChannel, messageListQueryParams) {
    return function (defaultParams) {
        var params = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, defaultParams), { prevResultLimit: 30, nextResultLimit: 30 }), messageListQueryParams);
        return groupChannel.createMessageCollection((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, params), { filter: new _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_27__.K(params) }));
    };
}


//# sourceMappingURL=context.js.map


/***/ }),

/***/ 23012:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMessageContext; },
/* harmony export */   "x": function() { return /* binding */ MessageProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


// todo@v4.0.0: combine with the provider in core-ts, see:
// https://github.com/sendbird/sendbird-uikit-core-ts
// packages/react-uikit-message-template-view/src/context/MessageContextProvider.tsx
var defaultValue = {
    message: {},
    isByMe: false,
};
var MessageContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultValue);
var MessageProvider = function (props) {
    var children = props.children, message = props.message, _a = props.isByMe, isByMe = _a === void 0 ? false : _a;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MessageContext.Provider, { value: {
            message: message,
            isByMe: isByMe,
        } }, children));
};
var useMessageContext = function () {
    var value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MessageContext);
    if (value === undefined) {
        throw new Error('useMessageContext must be used within a MessageProvider');
    }
    return value;
};


//# sourceMappingURL=context.js.map


/***/ }),

/***/ 66421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useDirtyGetMentions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function getMentionNodes(root) {
    if (root) {
        var mentions = root.querySelectorAll('[data-sb-mention=\'true\']');
        var mentionsArray = Array.from(mentions);
        return mentionsArray;
    }
    return [];
}

/**
 * exported, should be backwords compatible
 * This is a dirty way to get the mentions given DOM node
 */
function useDirtyGetMentions(_a, _b) {
    var ref = _a.ref;
    var logger = _b.logger;
    // Select the node that will be observed for mutations
    var targetNode = ref.current;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), mentionNodes = _c[0], setMentionNodes = _c[1];
    // to get the initial mentions
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
        if (targetNode) {
            var mentions = getMentionNodes(targetNode);
            setMentionNodes(mentions);
        }
    }, [targetNode]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // Options for the observer (which mutations to observe)
        var config = { childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        var callback = function (mutationList) {
            var hasMutation = mutationList.length > 0;
            if (hasMutation) {
                setMentionNodes(getMentionNodes(targetNode));
            }
        };
        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);
        if (targetNode) {
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
            // logger.info('useDirtyGetMentions: observer started', { observer, config });
        }
        return function () {
            try {
                observer.disconnect();
                // logger.info('useDirtyGetMentions: observer disconnected', { observer });
            }
            catch (error) {
                logger.error('useDirtyGetMentions: observer disconnect failed', { observer: observer });
            }
        };
    }, [targetNode]);
    return mentionNodes;
}


//# sourceMappingURL=useDirtyGetMentions.js.map


/***/ }),

/***/ 66099:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OpenChannelSetting; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _OpenChannelSettings_components_OpenChannelSettingsUI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73798);
/* harmony import */ var _OpenChannelSettings_context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95697);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43822);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10364);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72661);
/* harmony import */ var _OpenChannelSettings_components_OperatorUI_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65192);
/* harmony import */ var _OpenChannelSettings_components_OpenChannelProfile_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78595);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21112);
/* harmony import */ var _ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23170);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4399);
/* harmony import */ var _OpenChannelSettings_components_EditDetailsModal_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77831);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(78614);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(47689);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(46776);
/* harmony import */ var _ui_AccordionGroup_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(78757);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(67412);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(22284);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(56842);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(10856);
/* harmony import */ var _ui_Accordion_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(72248);






















































var OpenChannelSetting = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_OpenChannelSettings_context_js__WEBPACK_IMPORTED_MODULE_2__/* .OpenChannelSettingsProvider */ .B, { channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl, onCloseClick: props === null || props === void 0 ? void 0 : props.onCloseClick, onBeforeUpdateChannel: props === null || props === void 0 ? void 0 : props.onBeforeUpdateChannel, onChannelModified: props === null || props === void 0 ? void 0 : props.onChannelModified, onDeleteChannel: props === null || props === void 0 ? void 0 : props.onDeleteChannel, disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_OpenChannelSettings_components_OpenChannelSettingsUI_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { renderOperatorUI: props === null || props === void 0 ? void 0 : props.renderOperatorUI, renderParticipantList: props === null || props === void 0 ? void 0 : props.renderParticipantList })));
};


//# sourceMappingURL=OpenChannelSettings.js.map


/***/ }),

/***/ 77831:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EditDetails; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17693);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99366);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88569);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21790);
/* harmony import */ var _ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23170);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95697);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29515);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(78614);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(46776);








































var EditDetails = function (props) {
    var onCancel = props.onCancel;
    var globalState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_12__/* .useSendbirdStateContext */ .A)();
    var _a = globalState.config, logger = _a.logger, theme = _a.theme, pubSub = _a.pubSub;
    var _b = (0,_context_js__WEBPACK_IMPORTED_MODULE_11__/* .useOpenChannelSettingsContext */ .E)(), channel = _b.channel, onBeforeUpdateChannel = _b.onBeforeUpdateChannel, onChannelModified = _b.onChannelModified, setChannel = _b.setChannel;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var hiddenInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), currentImg = _c[0], setCurrentImg = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), newFile = _d[0], setNewFile = _d[1];
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var title = channel === null || channel === void 0 ? void 0 : channel.name;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_3__.M, { isFullScreenOnMobile: true, titleText: stringSet.MODAL__CHANNEL_INFORMATION__TITLE, submitText: stringSet.BUTTON__SAVE, onCancel: onCancel, onSubmit: function () {
            var _a, _b, _c, _d, _e;
            if (title !== '' && !((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value)) {
                if ((_b = formRef.current) === null || _b === void 0 ? void 0 : _b.reportValidity) { // might not work in explorer
                    formRef.current.reportValidity();
                }
                return;
            }
            var currentTitle = (_d = (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '';
            var currentImg = newFile;
            logger.info('ChannelSettings: Channel information being updated');
            var params = onBeforeUpdateChannel
                ? onBeforeUpdateChannel(currentTitle, currentImg, (_e = channel === null || channel === void 0 ? void 0 : channel.data) !== null && _e !== void 0 ? _e : '')
                : {
                    name: currentTitle,
                    coverUrlOrImage: currentImg !== null && currentImg !== void 0 ? currentImg : undefined,
                    data: channel === null || channel === void 0 ? void 0 : channel.data,
                };
            logger.info('ChannelSettings: Updating channel information', params);
            channel === null || channel === void 0 ? void 0 : channel.updateChannel(params).then(function (updatedChannel) {
                logger.info('ChannelSettings: Channel information update succeeded', updatedChannel);
                onChannelModified === null || onChannelModified === void 0 ? void 0 : onChannelModified(updatedChannel);
                setChannel === null || setChannel === void 0 ? void 0 : setChannel(updatedChannel);
                pubSub === null || pubSub === void 0 ? void 0 : pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_2__.p.UPDATE_OPEN_CHANNEL, updatedChannel);
            }).catch(function (error) {
                logger.error('ChannelSettings: Channel infomation update failed', error);
                setChannel === null || setChannel === void 0 ? void 0 : setChannel(null);
            });
            onCancel();
        }, type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_8__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("form", { className: "channel-profile-form", ref: formRef, onSubmit: function (e) { e.preventDefault(); } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "channel-profile-form__img-section" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Input_js__WEBPACK_IMPORTED_MODULE_4__/* .InputLabel */ .A, null, stringSet.MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "channel-profile-form__avatar" }, currentImg
                    ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_5__.A, { height: "80px", width: "80px", src: currentImg })) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { height: 80, width: 80, channel: channel, theme: theme }))),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", { ref: hiddenInputRef, type: "file", accept: "image/gif, image/jpeg, image/png", style: { display: 'none' }, onChange: function (e) {
                        if (e.target.files) {
                            setCurrentImg(URL.createObjectURL(e.target.files[0]));
                            setNewFile(e.target.files[0]);
                        }
                        if (hiddenInputRef.current)
                            hiddenInputRef.current.value = '';
                    } }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_TextButton_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { className: "channel-profile-form__avatar-button", onClick: function () { var _a; return (_a = hiddenInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disableUnderline: true },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.BUTTON_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.PRIMARY }, stringSet.MODAL__CHANNEL_INFORMATION__UPLOAD))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "channel-profile-form__name-section" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Input_js__WEBPACK_IMPORTED_MODULE_4__/* .InputLabel */ .A, null, stringSet.MODAL__CHANNEL_INFORMATION__CHANNEL_NAME),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Input_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { required: title !== '', name: "channel-profile-form__name", ref: inputRef, value: title, placeHolder: stringSet.MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER })))));
};


//# sourceMappingURL=EditDetailsModal.js.map


/***/ }),

/***/ 78595:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChannelProfile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21790);
/* harmony import */ var _ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23170);
/* harmony import */ var _EditDetailsModal_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77831);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41238);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95697);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4399);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(78614);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(46776);









































function ChannelProfile() {
    var _a, _b;
    var globalState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_6__/* .useSendbirdStateContext */ .A)();
    var disabled = !((_a = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _a === void 0 ? void 0 : _a.isOnline);
    var theme = (_b = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _b === void 0 ? void 0 : _b.theme;
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_7__/* .useOpenChannelSettingsContext */ .E)().channel;
    var title = channel === null || channel === void 0 ? void 0 : channel.name;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showModal = _c[0], setShowModal = _c[1];
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-profile" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-profile--inner" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-profile__avatar" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { channel: channel, theme: theme, height: 80, width: 80 })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1, className: "sendbird-openchannel-profile__title" }, title || stringSet.OPEN_CHANNEL_SETTINGS__NO_TITLE),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_TextButton_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { disabled: disabled, className: "sendbird-openchannel-profile__edit", onClick: function () {
                    if (disabled) {
                        return;
                    }
                    setShowModal(true);
                }, disableUnderline: true },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BUTTON_1, color: disabled ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.PRIMARY }, stringSet.CHANNEL_SETTING__PROFILE__EDIT)),
            showModal && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EditDetailsModal_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { onCancel: function () { return setShowModal(false); } })))));
}


//# sourceMappingURL=OpenChannelProfile.js.map


/***/ }),

/***/ 73798:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OpenChannelUI; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41238);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95697);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10364);
/* harmony import */ var _OperatorUI_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65192);
/* harmony import */ var _chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47689);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(61448);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(72661);
/* harmony import */ var _OpenChannelProfile_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(78595);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(21112);
/* harmony import */ var _ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(23170);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(4399);
/* harmony import */ var _EditDetailsModal_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(77831);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(80031);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(80385);
/* harmony import */ var _ui_Accordion_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(72248);
/* harmony import */ var _ui_AccordionGroup_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(78757);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(56842);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(22284);





















































function InvalidChannel(_a) {
    var onCloseClick = _a.onCloseClick;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__header" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, stringSet.CHANNEL_SETTING__HEADER__TITLE),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconTypes.CLOSE */ .Qy.CLOSE, className: "sendbird-openchannel-settings__close-icon", height: "24px", width: "24px", onClick: function () {
                    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
                } })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__placeholder" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_6__/* .PlaceHolderTypes.WRONG */ .v.WRONG }))));
}

var OpenChannelUI = function (_a) {
    var _b, _c, _d;
    var renderOperatorUI = _a.renderOperatorUI, renderParticipantList = _a.renderParticipantList;
    var _e = (0,_context_js__WEBPACK_IMPORTED_MODULE_2__/* .useOpenChannelSettingsContext */ .E)(), channel = _e.channel, onCloseClick = _e.onCloseClick, isChannelInitialized = _e.isChannelInitialized;
    var globalStore = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useSendbirdStateContext */ .A)();
    var logger = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _b === void 0 ? void 0 : _b.logger;
    var user = (_d = (_c = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _c === void 0 ? void 0 : _c.userStore) === null || _d === void 0 ? void 0 : _d.user;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    if (isChannelInitialized && !channel) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(InvalidChannel, { onCloseClick: function () {
                logger.info('OpenChannelSettings: Click close');
                if (onCloseClick) {
                    onCloseClick();
                }
            } }));
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-openchannel-settings' },
        (channel === null || channel === void 0 ? void 0 : channel.isOperator(user)) && ((renderOperatorUI === null || renderOperatorUI === void 0 ? void 0 : renderOperatorUI()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_OperatorUI_js__WEBPACK_IMPORTED_MODULE_7__/* .OperatorUI */ .DL, null))),
        !(channel === null || channel === void 0 ? void 0 : channel.isOperator(user)) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__participant" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__header" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__PARTICIPANTS_TITLE),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconTypes.CLOSE */ .Qy.CLOSE, className: "sendbird-openchannel-settings__close-icon", height: "24px", width: "24px", onClick: function () {
                        onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
                    } })),
            (renderParticipantList === null || renderParticipantList === void 0 ? void 0 : renderParticipantList()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__.P, null))))));
};


//# sourceMappingURL=OpenChannelSettingsUI.js.map


/***/ }),

/***/ 65192:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DL": function() { return /* binding */ OperatorUI; }
/* harmony export */ });
/* unused harmony exports copyToClipboard, default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95697);
/* harmony import */ var _OpenChannelProfile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78595);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17693);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47689);
/* harmony import */ var _ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72248);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16167);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29515);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(65614);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26765);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73935);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(78614);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(21112);
/* harmony import */ var _ui_OpenChannelAvatar_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(23170);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(4399);
/* harmony import */ var _EditDetailsModal_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(77831);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(80031);
/* harmony import */ var _ui_Input_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(80385);
/* harmony import */ var _ui_AccordionGroup_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(78757);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(67412);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(22284);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(10856);


















































function DeleteChannel() {
    var _a, _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showDeleteChannelModal = _c[0], setShowDeleteChannelModal = _c[1];
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var globalState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var isOnline = (_a = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _a === void 0 ? void 0 : _a.isOnline;
    var logger = (_b = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _b === void 0 ? void 0 : _b.logger;
    var _d = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)(), channel = _d.channel, onDeleteChannel = _d.onDeleteChannel;
    var deleteChannel = function () {
        channel === null || channel === void 0 ? void 0 : channel.delete().then(function (response) {
            logger.info('OpenChannelSettings: Delete channel success', response);
            if (onDeleteChannel) {
                onDeleteChannel(channel);
            }
        }).catch(function (error) {
            logger.warning('OpenChannelSettings: Delete channel failed', error);
        });
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__panel-item\n          sendbird-openchannel-settings__delete-channel\n            ".concat(!isOnline ? 'sendbird-openchannel-settings__panel-item__disabled' : ''), role: "button", tabIndex: 0, onKeyDown: function () {
                if (!isOnline) {
                    return;
                }
                setShowDeleteChannelModal(true);
            }, onClick: function () {
                if (!isOnline) {
                    return;
                }
                setShowDeleteChannelModal(true);
            } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DELETE */ .Qy.DELETE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ERROR */ .zo.ERROR, className: [
                    'sendbird-openchannel-settings__panel-icon-left',
                    'sendbird-openchannel-settings__panel-icon__delete',
                ].join(' '), height: "24px", width: "24px" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_PANEL)),
        showDeleteChannelModal && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { isFullScreenOnMobile: true, onCancel: function () {
                setShowDeleteChannelModal(false);
            }, onSubmit: function () {
                deleteChannel();
            }, titleText: stringSet.OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_TITLE, submitText: stringSet.OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_SUBMIT }, stringSet.OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_CONTEXT))));
}

function OperatorListModal(_a) {
    var _b;
    var onCancel = _a.onCancel;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), users = _c[0], setUsers = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), operatorQuery = _d[0], setOperatorQuery = _d[1];
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var currentUserId = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.userId;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var operatorListQuery = channel === null || channel === void 0 ? void 0 : channel.createOperatorListQuery({
            limit: 20,
        });
        if (operatorListQuery) {
            operatorListQuery.next().then(function (participants) {
                setUsers(participants);
            });
            setOperatorQuery(operatorListQuery);
        }
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { hideFooter: true, isFullScreenOnMobile: true, titleText: stringSet.OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ALL, onCancel: onCancel },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-more-users__popup-scroll", onScroll: function (e) {
                    var hasNext = operatorQuery === null || operatorQuery === void 0 ? void 0 : operatorQuery.hasNext;
                    var target = e.target;
                    var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                    if (hasNext && fetchMore) {
                        operatorQuery.next().then(function (o) {
                            setUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)([], users, true), o, true));
                        });
                    }
                } }, users.map(function (operator) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_14__/* .UserListItem */ .Q, { currentUser: currentUserId, user: operator, key: operator.userId, action: function (_a) {
                    var parentRef = _a.parentRef, actionRef = _a.actionRef;
                    return (currentUserId !== (operator === null || operator === void 0 ? void 0 : operator.userId)
                        ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { parentContainRef: parentRef, parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                        channel === null || channel === void 0 ? void 0 : channel.removeOperators([operator.userId]).then(function () {
                                            setUsers(users.filter(function (_a) {
                                                var userId = _a.userId;
                                                return userId !== operator.userId;
                                            }));
                                        });
                                        closeDropdown();
                                    }, testID: "open_channel_setting_operator_context_menu_unregister_operator" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
                } })); })))));
}

function AddOperatorsModal(_a) {
    var onCancel = _a.onCancel, onSubmit = _a.onSubmit;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), participants = _b[0], setParticipants = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), selectedUsers = _c[0], setSelectedUsers = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), participantQuery = _d[0], setParticipantQuery = _d[1];
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var participantListQuery = channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery({
            limit: 20,
        });
        if (participantListQuery) {
            participantListQuery.next().then(function (users) {
                setParticipants(users);
            });
            setParticipantQuery(participantListQuery);
        }
    }, []);
    var selectedCount = Object.keys(selectedUsers).filter(function (m) { return selectedUsers[m]; }).length;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { isFullScreenOnMobile: true, type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.CHANNEL_SETTING__OPERATORS__ADD_BUTTON, onCancel: onCancel, onSubmit: function () {
                var users = Object.keys(selectedUsers).filter(function (m) { return selectedUsers[m]; });
                channel === null || channel === void 0 ? void 0 : channel.addOperators(users).then(function () {
                    onSubmit(users);
                });
            }, titleText: stringSet.OPEN_CHANNEL_CONVERSATION__SELECT_PARTICIPANTS },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { color: (selectedCount > 0) ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.PRIMARY : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_3, type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_1 }, "".concat(selectedCount, " ").concat(stringSet.MODAL__INVITE_MEMBER__SELECTED)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-more-users__popup-scroll", onScroll: function (e) {
                    var hasNext = participantQuery ? participantQuery.hasNext : false;
                    var target = e.target;
                    var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                    if (hasNext && fetchMore && participantQuery) {
                        participantQuery.next().then(function (o) {
                            setParticipants((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)([], participants, true), o, true));
                        });
                    }
                } }, participants.map(function (participant) {
                var isOperator = (channel === null || channel === void 0 ? void 0 : channel.operators.find(function (operator) { return (operator === null || operator === void 0 ? void 0 : operator.userId) === (participant === null || participant === void 0 ? void 0 : participant.userId); })) ? true : false;
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_14__/* .UserListItem */ .Q, { user: participant, key: participant.userId, checkBox: true, checked: selectedUsers[participant.userId] || isOperator, disabled: isOperator, isOperator: isOperator, onChange: function (event) {
                        var _a;
                        var modifiedSelectedUsers = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__._)({}, selectedUsers), (_a = {}, _a[event.target.id] = event.target.checked, _a));
                        if (!event.target.checked) {
                            delete modifiedSelectedUsers[event.target.id];
                        }
                        setSelectedUsers(modifiedSelectedUsers);
                    } }));
            })))));
}

var OperatorList = function () {
    var _a, _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showAdd = _c[0], setShowAdd = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showMore = _d[0], setShowMore = _d[1];
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var currentUserId = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.userId;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, (_b = channel === null || channel === void 0 ? void 0 : channel.operators) === null || _b === void 0 ? void 0 :
        _b.slice(0, 10).map(function (operator) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__.U, { key: operator.userId, user: operator, currentUser: currentUserId, action: function (_a) {
                var actionRef = _a.actionRef;
                return (currentUserId !== (operator === null || operator === void 0 ? void 0 : operator.userId)
                    ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-openchannel-operator-list__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                    channel === null || channel === void 0 ? void 0 : channel.removeOperators([operator.userId]).then(function () {
                                        closeDropdown();
                                    });
                                }, testID: "open_channel_setting_operator_context_menu_unregister_operator" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR),
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.h, { channel: channel, user: operator, onChange: function () { return closeDropdown(); }, onError: function () {
                                    // FIXME: handle error later
                                    closeDropdown();
                                }, testID: "open_channel_setting_operator_context_menu_".concat(operator.isMuted ? 'unmute' : 'mute') }, operator.isMuted
                                ? stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNMUTE
                                : stringSet.OPEN_CHANNEL_SETTING__MODERATION__MUTE),
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                    channel === null || channel === void 0 ? void 0 : channel.banUser(operator).then(function () {
                                        closeDropdown();
                                    });
                                }, testID: "open_channel_setting_operator_context_menu_ban" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__BAN))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
            } })); }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-operator-list__footer" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: function () {
                    setShowAdd(true);
                } }, stringSet.OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ADD),
            (channel === null || channel === void 0 ? void 0 : channel.operators) && channel.operators.length > 10 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: function () {
                    setShowMore(true);
                } }, stringSet.OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ALL))),
        showMore && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(OperatorListModal, { onCancel: function () {
                    setShowMore(false);
                } }))),
        showAdd && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(AddOperatorsModal, { onCancel: function () { return setShowAdd(false); }, onSubmit: function () {
                    setShowAdd(false);
                } })))));
};

function MutedParticipantsModal(_a) {
    var _b;
    var onCancel = _a.onCancel;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), mutedUsers = _c[0], setMutedUsers = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), userListQuery = _d[0], setUserListQuery = _d[1];
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var currentUserId = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.userId;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var mutedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMutedUserListQuery({
            limit: 10,
        });
        mutedUserListQuery === null || mutedUserListQuery === void 0 ? void 0 : mutedUserListQuery.next().then(function (users) {
            setMutedUsers(users);
        });
        if (mutedUserListQuery) {
            setUserListQuery(mutedUserListQuery);
        }
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { isFullScreenOnMobile: true, hideFooter: true, onCancel: function () { return onCancel(); }, onSubmit: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_38__.n, titleText: stringSet.OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: function (e) {
                    var hasNext = userListQuery === null || userListQuery === void 0 ? void 0 : userListQuery.hasNext;
                    var target = e.target;
                    var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                    if (hasNext && fetchMore) {
                        userListQuery.next().then(function (o) {
                            setMutedUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)([], mutedUsers, true), o, true));
                        });
                    }
                } }, mutedUsers.map(function (mutedUser) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_14__/* .UserListItem */ .Q, { currentUser: currentUserId, user: mutedUser, key: mutedUser.userId, action: function (_a) {
                    var actionRef = _a.actionRef;
                    return ((mutedUser === null || mutedUser === void 0 ? void 0 : mutedUser.userId) !== currentUserId
                        ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                        channel === null || channel === void 0 ? void 0 : channel.unmuteUser(mutedUser).then(function () {
                                            closeDropdown();
                                            setMutedUsers(mutedUsers.filter(function (u) {
                                                return (u.userId !== mutedUser.userId);
                                            }));
                                        });
                                    }, testID: "open_channel_setting_muted_member_context_menu_unmute" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNMUTE))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
                } })); })))));
}

var MutedParticipantList = function () {
    var _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), mutedUsers = _b[0], setMutedUsers = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasNext = _c[0], setHasNext = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showModal = _d[0], setShowModal = _d[1];
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var currentUserId = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.userId;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!channel) {
            setMutedUsers([]);
            return;
        }
        var mutedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMutedUserListQuery({
            limit: 10,
        });
        mutedUserListQuery.next().then(function (members) {
            setMutedUsers(members);
            setHasNext(mutedUserListQuery.hasNext);
        });
    }, [channel]);
    var refreshList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        if (!channel) {
            setMutedUsers([]);
            return;
        }
        var mutedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMutedUserListQuery({
            limit: 10,
        });
        mutedUserListQuery.next().then(function (members) {
            setMutedUsers(members);
            setHasNext(mutedUserListQuery.hasNext);
        });
    }, [channel]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        mutedUsers.map(function (mutedUser) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__.U, { key: mutedUser.userId, user: mutedUser, currentUser: currentUserId, isOperator: channel === null || channel === void 0 ? void 0 : channel.isOperator(mutedUser.userId), action: function (_a) {
                var actionRef = _a.actionRef;
                return ((mutedUser === null || mutedUser === void 0 ? void 0 : mutedUser.userId) !== currentUserId
                    ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { closeDropdown: closeDropdown, openLeft: true, parentRef: actionRef },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                    channel === null || channel === void 0 ? void 0 : channel.unmuteUser(mutedUser).then(function () {
                                        refreshList();
                                        closeDropdown();
                                    });
                                }, testID: "open_channel_setting_muted_member_context_menu_unmute" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNMUTE))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
            } })); }),
        mutedUsers && mutedUsers.length === 0 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-channel-settings__empty-list", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_3 }, stringSet.OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__NO_ONE)),
        hasNext && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-channel-settings-muted-participant-list__footer" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: function () {
                    setShowModal(true);
                } }, stringSet.OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE_ALL))),
        showModal && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutedParticipantsModal, { onCancel: function () {
                setShowModal(false);
                refreshList();
            } }))));
};

function BannedUsersModal(_a) {
    var _b;
    var onCancel = _a.onCancel;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), bannedUsers = _c[0], setBannedUsers = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), userListQuery = _d[0], setUserListQuery = _d[1];
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var currentUserId = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.userId;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var bannedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery();
        bannedUserListQuery === null || bannedUserListQuery === void 0 ? void 0 : bannedUserListQuery.next().then(function (users) {
            setBannedUsers(users);
        });
        setUserListQuery(bannedUserListQuery !== null && bannedUserListQuery !== void 0 ? bannedUserListQuery : null);
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { hideFooter: true, isFullScreenOnMobile: true, onCancel: function () { return onCancel(); }, onSubmit: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_38__.n, titleText: stringSet.OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: function (e) {
                    var hasNext = userListQuery === null || userListQuery === void 0 ? void 0 : userListQuery.hasNext;
                    var target = e.target;
                    var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                    if (hasNext && fetchMore) {
                        userListQuery.next().then(function (o) {
                            setBannedUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_13__.c)([], bannedUsers, true), o, true));
                        });
                    }
                } }, bannedUsers.map(function (bannedUser) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_14__/* .UserListItem */ .Q, { user: bannedUser, key: bannedUser.userId, action: function (_a) {
                    var actionRef = _a.actionRef;
                    return ((bannedUser === null || bannedUser === void 0 ? void 0 : bannedUser.userId) !== currentUserId
                        ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                        channel === null || channel === void 0 ? void 0 : channel.unbanUser(bannedUser).then(function () {
                                            closeDropdown();
                                            setBannedUsers(bannedUsers.filter(function (u) {
                                                return (u.userId !== bannedUser.userId);
                                            }));
                                        });
                                    }, testID: "open_channel_setting_banned_user_context_menu_unban" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNBAN))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
                } })); })))));
}

var BannedUserList = function () {
    var _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), bannedUsers = _b[0], setBannedUsers = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasNext = _c[0], setHasNext = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showModal = _d[0], setShowModal = _d[1];
    var channel = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)().channel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var currentUserId = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.userId;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!channel) {
            setBannedUsers([]);
            return;
        }
        var bannedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery();
        bannedUserListQuery.next().then(function (users) {
            setBannedUsers(users);
            setHasNext(bannedUserListQuery.hasNext);
        });
    }, [channel]);
    var refreshList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        if (!channel) {
            setBannedUsers([]);
            return;
        }
        var bannedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery();
        bannedUserListQuery.next().then(function (users) {
            setBannedUsers(users);
            setHasNext(bannedUserListQuery.hasNext);
        });
    }, [channel]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        bannedUsers.map(function (bannedUser) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__.U, { key: bannedUser.userId, user: bannedUser, isOperator: channel === null || channel === void 0 ? void 0 : channel.isOperator(bannedUser.userId), action: function (_a) {
                var actionRef = _a.actionRef;
                return ((bannedUser === null || bannedUser === void 0 ? void 0 : bannedUser.userId) !== currentUserId
                    ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.b, { parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__.c, { onClick: function () {
                                    channel === null || channel === void 0 ? void 0 : channel.unbanUser(bannedUser).then(function () {
                                        closeDropdown();
                                        refreshList();
                                    });
                                }, testID: "open_channel_setting_banned_user_context_menu_unban" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNBAN))); } })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
            } })); }),
        bannedUsers && bannedUsers.length === 0 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-channel-settings__empty-list", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_3 }, stringSet.OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__NO_ONE)),
        hasNext && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-channel-settings-banned-user-list__footer" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_10__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: function () {
                    setShowModal(true);
                } }, stringSet.OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE_ALL))),
        showModal && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(BannedUsersModal, { onCancel: function () {
                setShowModal(false);
                refreshList();
            } }))));
};

var copyToClipboard = function (text) {
    // @ts-ignore: Unreachable code error
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        // @ts-ignore: Unreachable code error
        return window.clipboardData.setData('Text', text);
    }
    if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand('copy'); // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            return false;
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
    return false;
};
var OperatorUI = function (_a) {
    var renderChannelProfile = _a.renderChannelProfile;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var _b = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useOpenChannelSettingsContext */ .E)(), onCloseClick = _b.onCloseClick, channel = _b.channel;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__header" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.CHANNEL_SETTING__HEADER__TITLE),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__close-icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.CLOSE */ .Qy.CLOSE, height: "24px", width: "24px", onClick: function () {
                    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
                } })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__profile" }, (renderChannelProfile === null || renderChannelProfile === void 0 ? void 0 : renderChannelProfile()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_OpenChannelProfile_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-openchannel-settings__url" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__copy-icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.COPY */ .Qy.COPY, height: "22px", width: "22px", onClick: function () {
                    var _a;
                    copyToClipboard((_a = channel === null || channel === void 0 ? void 0 : channel.url) !== null && _a !== void 0 ? _a : '');
                } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-openchannel-settings__url-label", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 }, stringSet.OPEN_CHANNEL_SETTINGS__OPERATOR_URL),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-openchannel-settings__url-value", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_2 }, channel === null || channel === void 0 ? void 0 : channel.url)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__/* .AccordionGroup */ .bq, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__operators-list", id: "operators", renderTitle: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__operator-accordion-icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.OPERATOR */ .Qy.OPERATOR, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__OPERATORS_TITLE))); }, renderContent: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(OperatorList, null))); } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, { className: "sendbird-channel-settings__operators-list", id: "participants", renderTitle: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MEMBERS */ .Qy.MEMBERS, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: 24, height: 24, className: "sendbird-openchannel-settings__operator-accordion-icon" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__PARTICIPANTS_ACCORDION_TITLE))); }, renderContent: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DX03rGyh_js__WEBPACK_IMPORTED_MODULE_8__.P, { isOperatorView: true }))); } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, { className: "sendbird-channel-settings__operators-list", id: "mutedMembers", renderTitle: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__operator-accordion-icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MUTE */ .Qy.MUTE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE))); }, renderContent: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutedParticipantList, null))); } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Accordion_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, { className: "sendbird-channel-settings__operators-list", id: "bannedUsers", renderTitle: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-openchannel-settings__operator-accordion-icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.BAN */ .Qy.BAN, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE))); }, renderContent: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(BannedUserList, null))); } })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(DeleteChannel, null)));
};


//# sourceMappingURL=OperatorUI.js.map


/***/ }),

/***/ 95697:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ OpenChannelSettingsProvider; },
/* harmony export */   "E": function() { return /* binding */ useOpenChannelSettingsContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_chat_openChannel__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(35065);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(88071);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78614);






























var OpenChannelSettingsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var OpenChannelSettingsProvider = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var children = props.children, channelUrl = props.channelUrl, onCloseClick = props.onCloseClick, onChannelModified = props.onChannelModified, onBeforeUpdateChannel = props.onBeforeUpdateChannel, onDeleteChannel = props.onDeleteChannel;
    // fetch store from <SendbirdProvider />
    var globalStore = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useSendbirdStateContext */ .A)();
    var sdk = (_b = (_a = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _a === void 0 ? void 0 : _a.sdkStore) === null || _b === void 0 ? void 0 : _b.sdk;
    var isSDKInitialized = (_d = (_c = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _c === void 0 ? void 0 : _c.sdkStore) === null || _d === void 0 ? void 0 : _d.initialized;
    var logger = (_e = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _e === void 0 ? void 0 : _e.logger;
    var currentUserId = (_f = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _f === void 0 ? void 0 : _f.userId;
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), currentChannel = _j[0], setChannel = _j[1];
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isChannelInitialized = _k[0], setChannelInitialized = _k[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!channelUrl || !sdk.openChannel) {
            setChannel(null);
            return;
        }
        sdk.openChannel.getChannel(channelUrl)
            .then(function (channel) {
            logger.info('open channel setting: fetched', channel);
            // TODO: Add pending status
            channel.enter()
                .then(function () {
                setChannel(channel);
                logger.info('OpenChannelSettings | Succeeded to enter channel', channel === null || channel === void 0 ? void 0 : channel.url);
                setChannelInitialized(true);
            })
                .catch(function (error) {
                setChannel(null);
                logger.warning('OpenChannelSettings | Failed to enter channel', error);
            });
        })
            .catch(function (error) {
            logger.error('open channel setting: error fetching', error);
            setChannel(null);
        });
        return function () {
            if (currentChannel && currentChannel.exit) {
                currentChannel.exit()
                    .then(function () {
                    logger.info('OpenChannelSettings | Succeeded to exit channel', currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url);
                })
                    .catch(function (error) {
                    logger.warning('OpenChannelSettings | Failed to exit channel', error);
                });
            }
        };
    }, [channelUrl, isSDKInitialized]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var _a;
        var channelHandlerId = (0,_chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_20__.u)();
        if (currentChannel !== null && ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.openChannel) === null || _a === void 0 ? void 0 : _a.addOpenChannelHandler)) {
            var channelHandlerParams = new _sendbird_chat_openChannel__WEBPACK_IMPORTED_MODULE_21__/* .OpenChannelHandler */ .T_({
                onOperatorUpdated: function (channel) {
                    if ((channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
                        setChannel(channel);
                    }
                },
                onUserMuted: function (channel, user) {
                    if ((channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === currentUserId) {
                        setChannel(channel);
                    }
                },
                onUserUnmuted: function (channel, user) {
                    if ((channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === currentUserId) {
                        setChannel(channel);
                    }
                },
                onUserBanned: function (channel, user) {
                    if ((channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === currentUserId) {
                        setChannel(null);
                    }
                },
                onUserUnbanned: function (channel, user) {
                    if ((user === null || user === void 0 ? void 0 : user.userId) === currentUserId) {
                        setChannel(channel);
                    }
                },
                onChannelChanged: function (channel) {
                    if ((channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
                        setChannel(channel);
                    }
                },
                onChannelDeleted: function (channelUrl) {
                    if (channelUrl === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
                        setChannel(null);
                    }
                },
            });
            sdk.openChannel.addOpenChannelHandler(channelHandlerId, channelHandlerParams);
        }
        return function () {
            var _a, _b, _c;
            if (((_a = sdk === null || sdk === void 0 ? void 0 : sdk.openChannel) === null || _a === void 0 ? void 0 : _a.removeOpenChannelHandler) && channelHandlerId) {
                logger.info('OpenChannelSettings | Removing channel handlers', channelHandlerId);
                (_c = (_b = sdk.openChannel).removeOpenChannelHandler) === null || _c === void 0 ? void 0 : _c.call(_b, channelHandlerId);
            }
        };
    }, [channelUrl]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(OpenChannelSettingsContext.Provider, { value: {
            channelUrl: channelUrl,
            channel: currentChannel,
            isChannelInitialized: isChannelInitialized,
            setChannel: setChannel,
            onCloseClick: onCloseClick,
            onChannelModified: onChannelModified,
            onBeforeUpdateChannel: onBeforeUpdateChannel,
            onDeleteChannel: onDeleteChannel,
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_2__.U, { isOpenChannel: true, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile, disableUserProfile: (_g = props === null || props === void 0 ? void 0 : props.disableUserProfile) !== null && _g !== void 0 ? _g : (_h = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _h === void 0 ? void 0 : _h.disableUserProfile }, children)));
};
var useOpenChannelSettingsContext = function () {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(OpenChannelSettingsContext);
    if (!context)
        throw new Error('OpenChannelSettingsContext not found. Use within the OpenChannelSettings module.');
    return context;
};


//# sourceMappingURL=context.js.map


/***/ }),

/***/ 29205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Thread; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Thread_context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31723);
/* harmony import */ var _Thread_components_ThreadUI_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40287);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13566);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18107);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6623);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(78614);
/* harmony import */ var _Thread_context_types_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(53474);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(11639);
/* harmony import */ var _Thread_components_ParentMessageInfo_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(33116);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(24354);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(44892);
/* harmony import */ var _Thread_components_ParentMessageInfoItem_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(5806);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(4399);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(21112);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(30156);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(8627);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(82314);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(23012);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(28464);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(1165);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(40286);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(41519);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(459);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(69139);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(88221);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(56342);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(66421);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(76039);
/* harmony import */ var _Thread_components_ThreadHeader_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(95137);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(56210);
/* harmony import */ var _Thread_components_ThreadList_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(61029);
/* harmony import */ var _Thread_components_ThreadListItem_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(5591);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(8743);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(34835);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(12210);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(48845);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(78828);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(21402);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(30302);
/* harmony import */ var _Channel_utils_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(60196);
/* harmony import */ var _Thread_components_ThreadMessageInput_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(38506);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(91607);
/* harmony import */ var _GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(85562);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(67840);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(12291);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(85385);
/* harmony import */ var _GroupChannel_context_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(38204);
/* harmony import */ var _Channel_hooks_useHandleUploadFiles_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(73459);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(10364);

































































































































var Thread = function (props) {
    var _a;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_108__.c)('sendbird-thread', (_a = props === null || props === void 0 ? void 0 : props.className) !== null && _a !== void 0 ? _a : '') },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Thread_context_js__WEBPACK_IMPORTED_MODULE_2__/* .ThreadProvider */ .I, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Thread_components_ThreadUI_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)))));
};


//# sourceMappingURL=Thread.js.map


/***/ }),

/***/ 33116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ParentMessageInfo; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24354);
/* harmony import */ var _ParentMessageInfoItem_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5806);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(14014);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41238);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31723);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41519);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99366);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6989);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69139);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16167);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13462);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88221);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8627);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(56342);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(66421);
/* harmony import */ var _chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(3153);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(76039);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(17693);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(73935);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(88569);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(44892);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(4399);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(21112);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(30156);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(60090);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56842);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(10856);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(61448);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(78614);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(80031);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(23012);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(28464);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(1165);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(40286);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(43071);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(13566);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(18107);
/* harmony import */ var _context_types_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(53474);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(27856);



























































































function ParentMessageInfo(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g;
    var className = _a.className, _h = _a.renderEmojiMenu, renderEmojiMenu = _h === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_14__/* .MessageEmojiMenu */ .j, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _h, _j = _a.renderMessageMenu, renderMessageMenu = _j === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_24__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _j;
    var _k = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)(), stores = _k.stores, config = _k.config;
    var isOnline = config.isOnline, userMention = config.userMention, logger = config.logger, groupChannel = config.groupChannel;
    var userId = (_c = (_b = stores.userStore.user) === null || _b === void 0 ? void 0 : _b.userId) !== null && _c !== void 0 ? _c : '';
    var _l = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)(), dateLocale = _l.dateLocale, stringSet = _l.stringSet;
    var _m = (0,_context_js__WEBPACK_IMPORTED_MODULE_8__/* .useThreadContext */ .i)(), currentChannel = _m.currentChannel, parentMessage = _m.parentMessage, allThreadMessages = _m.allThreadMessages, emojiContainer = _m.emojiContainer, toggleReaction = _m.toggleReaction, updateMessage = _m.updateMessage, deleteMessage = _m.deleteMessage, onMoveToParentMessage = _m.onMoveToParentMessage, onHeaderActionClick = _m.onHeaderActionClick, isMuted = _m.isMuted, isChannelFrozen = _m.isChannelFrozen, onBeforeDownloadFileMessage = _m.onBeforeDownloadFileMessage, filterEmojiCategoryIds = _m.filterEmojiCategoryIds;
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_20__.u)().isMobile;
    var isMenuMounted = (0,_chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_25__.u)("#".concat((0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.g)(parentMessage.messageId), ".").concat(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.e), [
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.d),
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.E),
    ]);
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showRemove = _o[0], setShowRemove = _o[1];
    var _p = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFileViewer = _p[0], setShowFileViewer = _p[1];
    var isReactionEnabled = (0,_chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_73__.g)({
        channel: currentChannel,
        config: config,
    });
    var isMentionEnabled = groupChannel.enableMention;
    var replyType = (0,_chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_74__.g)(groupChannel.replyType).upperCase;
    var isByMe = userId === parentMessage.sender.userId;
    // Mobile
    var mobileMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _q = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMobileMenu = _q[0], setShowMobileMenu = _q[1];
    var longPress = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_21__.u)({
        onLongPress: function () {
            if (isMobile) {
                setShowMobileMenu(true);
            }
        },
    }, {
        shouldPreventDefault: false,
    });
    // Edit message
    var _r = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showEditInput = _r[0], setShowEditInput = _r[1];
    var disabled = !isOnline || isMuted || isChannelFrozen && !((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myRole) === _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_19__.R.OPERATOR);
    // Mention
    var editMessageInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), mentionNickname = _s[0], setMentionNickname = _s[1];
    var _t = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUsers = _t[0], setMentionedUsers = _t[1];
    var _u = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _u[0], setMentionedUserIds = _u[1];
    var _v = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), messageInputEvent = _v[0], setMessageInputEvent = _v[1];
    var _w = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedUser = _w[0], setSelectedUser = _w[1];
    var _x = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionSuggestedUsers = _x[0], setMentionSuggestedUsers = _x[1];
    var displaySuggestedMentionList = isOnline
        && isMentionEnabled
        && mentionNickname.length > 0
        && !isMuted
        && !(isChannelFrozen && !(currentChannel.myRole === _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_19__.R.OPERATOR));
    var mentionNodes = (0,_Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_23__/* .useDirtyGetMentions */ .X)({ ref: editMessageInputRef }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    var handleOnDownloadClick = function (e) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
        var allowDownload, err_1;
        var _a, _b;
        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!onBeforeDownloadFileMessage)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onBeforeDownloadFileMessage({ message: parentMessage })];
                case 2:
                    allowDownload = _c.sent();
                    if (!allowDownload) {
                        e.preventDefault();
                        (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'ParentMessageInfo: Not allowed to download.');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'ParentMessageInfo: Error occurred while determining download continuation:', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // User Profile
    var avatarRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _y = (0,_chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_9__.u)(), disableUserProfile = _y.disableUserProfile, renderUserProfile = _y.renderUserProfile;
    if (showEditInput && ((_d = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.isUserMessage) === null || _d === void 0 ? void 0 : _d.call(parentMessage))) {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            displaySuggestedMentionList && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_10__.S, { className: "parent-message-info--suggested-mention-list", targetNickname: mentionNickname, inputEvent: messageInputEvent !== null && messageInputEvent !== void 0 ? messageInputEvent : undefined, 
                // renderUserMentionItem={renderUserMentionItem}
                onUserItemClick: function (user) {
                    if (user) {
                        setMentionedUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], mentionedUsers, true), [user], false));
                    }
                    setMentionNickname('');
                    setSelectedUser(user);
                    setMessageInputEvent(null);
                }, onFocusItemChange: function () {
                    setMessageInputEvent(null);
                }, onFetchUsers: function (users) {
                    setMentionSuggestedUsers(users);
                }, ableAddMention: ableMention, maxMentionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount, maxSuggestionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, { channel: currentChannel, isEdit: true, disabled: disabled, ref: editMessageInputRef, mentionSelectedUser: selectedUser, isMentionEnabled: isMentionEnabled, message: parentMessage, onStartTyping: function () {
                    var _a;
                    (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.startTyping) === null || _a === void 0 ? void 0 : _a.call(currentChannel);
                }, onUpdateMessage: function (_a) {
                    var _b;
                    var messageId = _a.messageId, message = _a.message, mentionTemplate = _a.mentionTemplate;
                    updateMessage({
                        messageId: messageId,
                        message: message,
                        mentionedUsers: mentionedUsers,
                        mentionTemplate: mentionTemplate,
                    });
                    setShowEditInput(false);
                    (_b = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _b === void 0 ? void 0 : _b.call(currentChannel);
                }, onCancelEdit: function () {
                    var _a;
                    setMentionNickname('');
                    setMentionedUsers([]);
                    setMentionedUserIds([]);
                    setMentionSuggestedUsers([]);
                    setShowEditInput(false);
                    (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _a === void 0 ? void 0 : _a.call(currentChannel);
                }, onUserMentioned: function (user) {
                    if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                        setSelectedUser(null);
                        setMentionNickname('');
                    }
                }, onMentionStringChange: function (mentionText) {
                    setMentionNickname(mentionText);
                }, onMentionedUserIdsUpdated: function (userIds) {
                    setMentionedUserIds(userIds);
                }, onKeyDown: function (e) {
                    if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                        && ((e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_18__.M.Enter && ableMention) || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_18__.M.ArrowUp || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_18__.M.ArrowDown)) {
                        setMessageInputEvent(e);
                        return true;
                    }
                    return false;
                } })));
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: "sendbird-parent-message-info ".concat(className) }, (isMobile) ? (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, longPress) : {}, { ref: mobileMenuRef }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.C, { menuTrigger: function (toggleDropdown) {
                var _a, _b, _c;
                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_11__.A, { className: "sendbird-parent-message-info__sender", ref: avatarRef, src: ((_b = (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members) === null || _a === void 0 ? void 0 : _a.find(function (m) { var _a; return (m === null || m === void 0 ? void 0 : m.userId) === ((_a = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender) === null || _a === void 0 ? void 0 : _a.userId); })) === null || _b === void 0 ? void 0 : _b.profileUrl)
                        || ((_c = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender) === null || _c === void 0 ? void 0 : _c.profileUrl), alt: "thread message sender", width: "40px", height: "40px", onClick: function () {
                        if (!disableUserProfile) {
                            toggleDropdown();
                        }
                    } }));
            }, menuItems: function (closeDropdown) { return (renderUserProfile
                ? renderUserProfile({
                    user: parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender,
                    close: closeDropdown,
                    currentUserId: userId,
                    avatarRef: avatarRef,
                })
                : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_15__.b, { parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, { user: parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender, currentUserId: userId, onSuccess: closeDropdown })))); } }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info__content" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info__content__info" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.L, { className: isReactionEnabled
                        ? 'sendbird-parent-message-info__content__info__sender-name--use-reaction'
                        : 'sendbird-parent-message-info__content__info__sender-name', type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.b.ONBACKGROUND_2 }, ((_f = (_e = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members) === null || _e === void 0 ? void 0 : _e.find(function (member) { var _a; return (member === null || member === void 0 ? void 0 : member.userId) === ((_a = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender) === null || _a === void 0 ? void 0 : _a.userId); })) === null || _f === void 0 ? void 0 : _f.nickname) || (_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.e === null || _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.e === void 0 ? void 0 : (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.e)(parentMessage))),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.L, { className: "sendbird-parent-message-info__content__info__sent-at", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__.b.ONBACKGROUND_2 }, (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)((parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.createdAt) || 0, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, { locale: dateLocale }))),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ParentMessageInfoItem_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { message: parentMessage, showFileViewer: setShowFileViewer, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage })),
        !isMobile && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: 'sendbird-parent-message-info__menu-container' },
            renderMessageMenu({
                className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_75__.c)('sendbird-parent-message-info__context-menu', isReactionEnabled && 'use-reaction', isMenuMounted && 'sendbird-mouse-hover'),
                channel: currentChannel,
                message: parentMessage,
                isByMe: userId === ((_g = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender) === null || _g === void 0 ? void 0 : _g.userId),
                disableDeleteMessage: allThreadMessages.length > 0,
                replyType: replyType,
                showEdit: setShowEditInput,
                showRemove: setShowRemove,
                onMoveToParentMessage: function () {
                    onMoveToParentMessage === null || onMoveToParentMessage === void 0 ? void 0 : onMoveToParentMessage({ message: parentMessage, channel: currentChannel });
                },
                deleteMessage: deleteMessage,
            }),
            isReactionEnabled && (renderEmojiMenu({
                className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_75__.c)('sendbird-parent-message-info__reaction-menu', isMenuMounted && 'sendbird-mouse-hover'),
                message: parentMessage,
                userId: userId,
                emojiContainer: emojiContainer,
                toggleReaction: toggleReaction,
                filterEmojiCategoryIds: filterEmojiCategoryIds,
            })))),
        showRemove && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_3__.R, { onCancel: function () { return setShowRemove(false); }, onSubmit: function () {
                onHeaderActionClick === null || onHeaderActionClick === void 0 ? void 0 : onHeaderActionClick();
            }, message: parentMessage })),
        showFileViewer && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, { message: parentMessage, onClose: function () { return setShowFileViewer(false); }, onDelete: function () {
                deleteMessage(parentMessage)
                    .then(function () {
                    setShowFileViewer(false);
                });
            }, onDownloadClick: handleOnDownloadClick })),
        showMobileMenu && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_22__/* .MobileMenu */ .nn, { parentRef: mobileMenuRef, channel: currentChannel, message: parentMessage, userId: userId, replyType: replyType, hideMenu: function () {
                setShowMobileMenu(false);
            }, deleteMessage: deleteMessage, deleteMenuState: (allThreadMessages === null || allThreadMessages === void 0 ? void 0 : allThreadMessages.length) === 0
                ? 'ACTIVE'
                : 'HIDE', isReactionEnabled: isReactionEnabled, isByMe: isByMe, emojiContainer: emojiContainer, showEdit: setShowEditInput, showRemove: setShowRemove, toggleReaction: toggleReaction, isOpenedFromThread: true, onDownloadClick: handleOnDownloadClick }))));
}


//# sourceMappingURL=ParentMessageInfo.js.map


/***/ }),

/***/ 5806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ParentMessageInfoItem; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4399);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43822);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21790);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41238);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27835);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31723);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71612);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43071);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8978);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71091);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30156);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(16167);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(73935);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(78614);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29515);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(18087);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(17693);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(90832);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(82314);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(80031);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(23012);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(13566);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(18107);
/* harmony import */ var _context_types_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(53474);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(13160);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(28464);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(72661);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(40286);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(60424);






































































function ParentMessageInfoItem(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var className = _a.className, message = _a.message, showFileViewer = _a.showFileViewer, _k = _a.onBeforeDownloadFileMessage, onBeforeDownloadFileMessage = _k === void 0 ? null : _k;
    var _l = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_8__/* .useSendbirdStateContext */ .A)(), stores = _l.stores, config = _l.config, eventHandlers = _l.eventHandlers;
    var logger = config.logger;
    var onPressUserProfileHandler = (_b = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.reaction) === null || _b === void 0 ? void 0 : _b.onPressUserProfile;
    var currentUserId = (_d = (_c = stores === null || stores === void 0 ? void 0 : stores.userStore) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.userId;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.u)().stringSet;
    var _m = (0,_context_js__WEBPACK_IMPORTED_MODULE_10__/* .useThreadContext */ .i)(), currentChannel = _m.currentChannel, emojiContainer = _m.emojiContainer, nicknamesMap = _m.nicknamesMap, toggleReaction = _m.toggleReaction, filterEmojiCategoryIds = _m.filterEmojiCategoryIds;
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__.u)().isMobile;
    var isReactionEnabled = config.groupChannel.enableReactions;
    var isMentionEnabled = config.groupChannel.enableMention;
    var threadMessageKindKey = (0,_chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_14__.u)({
        threadMessageKind: _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_14__.T.PARENT,
        isMobile: isMobile,
    });
    // For MultipleFilesMessage only.
    var statefulFileInfoList = (0,_chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_14__.a)(message);
    var isMentionedMessage = isMentionEnabled
        && ((_e = message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate) === null || _e === void 0 ? void 0 : _e.length) > 0
        && (message === null || message === void 0 ? void 0 : message.mentionedUsers)
        && message.mentionedUsers.length > 0;
    // Emoji reactions
    var isReactionActivated = isReactionEnabled
        && config.groupChannel.replyType === 'thread'
        && ((_f = message === null || message === void 0 ? void 0 : message.reactions) === null || _f === void 0 ? void 0 : _f.length) > 0;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        var _a;
        if (isMentionedMessage) {
            return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_13__.t)({
                mentionedUsers: (_a = message === null || message === void 0 ? void 0 : message.mentionedUsers) !== null && _a !== void 0 ? _a : undefined,
                messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
                includeMarkdown: config.groupChannel.enableMarkdownForUserMessage,
            });
        }
        return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_13__.t)({
            messageText: message === null || message === void 0 ? void 0 : message.message,
            includeMarkdown: config.groupChannel.enableMarkdownForUserMessage,
        });
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    // Only for the FileMessageItemBody
    var downloadFileWithUrl = function () {
        if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.b)(message))
            (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_56__.o)(message.url);
    };
    var handleOnClickTextButton = onBeforeDownloadFileMessage
        ? function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(message.messageType === 'file')) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (allowDownload) {
                            downloadFileWithUrl();
                        }
                        else {
                            (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'ParentMessageInfoItem: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'ParentMessageInfoItem: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }
        : downloadFileWithUrl;
    // Thumbnail mesage
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isImageRendered = _o[0], setImageRendered = _o[1];
    var thumbnailUrl = ((_g = message === null || message === void 0 ? void 0 : message.thumbnails) === null || _g === void 0 ? void 0 : _g.length) > 0
        ? (_h = message === null || message === void 0 ? void 0 : message.thumbnails[0]) === null || _h === void 0 ? void 0 : _h.url : '';
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item ".concat(className) },
        (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.l)(message) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-parent-message-info-item__text-message", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_12__.T, { tokens: tokens }),
            (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.d)(message) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-parent-message-info-item__text-message edited", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, " ".concat(stringSet.MESSAGE_EDITED, " "))))),
        // Instead of the FileMessageItemBody component
        ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.m)(message) === (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.n)().FILE) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__file-message" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__file-message__file-icon" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { className: "sendbird-parent-message-info-item__file-message__file-icon__icon", type: {
                        IMAGE: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.PHOTO */ .Qy.PHOTO,
                        VIDEO: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.PLAY */ .Qy.PLAY,
                        AUDIO: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.FILE_AUDIO */ .Qy.FILE_AUDIO,
                        GIF: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.GIF */ .Qy.GIF,
                        OTHERS: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.FILE_DOCUMENT */ .Qy.FILE_DOCUMENT,
                    }[(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.o)(message === null || message === void 0 ? void 0 : message.type)], fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_TextButton_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { className: "sendbird-parent-message-info-item__file-message__file-name", onClick: handleOnClickTextButton, color: _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_16__.C.ONBACKGROUND_1 },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-parent-message-info-item__file-message__file-name__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.t)((message === null || message === void 0 ? void 0 : message.name) || (message === null || message === void 0 ? void 0 : message.url), 30))))),
        (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.c)(message) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_14__.M, { className: "sendbird-parent-message-info-item__multiple-files-message-wrapper", message: message, isByMe: false, isReactionEnabled: isReactionEnabled, threadMessageKindKey: threadMessageKindKey, statefulFileInfoList: statefulFileInfoList, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage })),
        (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.i)(message) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__voice-message" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_11__/* .VoiceMessageItemBody */ .C, { className: "sendbird-parent-message-info-item__voice-message__item", message: message, channelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url, isByMe: false, isReactionEnabled: isReactionEnabled }))),
        (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.p)(message) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message", onClick: function () {
                if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.q)(message)) {
                    showFileViewer === null || showFileViewer === void 0 ? void 0 : showFileViewer(true);
                }
            } },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { className: "sendbird-parent-message-info-item__thumbnail-message__thumbnail", url: thumbnailUrl || (message === null || message === void 0 ? void 0 : message.url) || (message === null || message === void 0 ? void 0 : message.plainUrl), alt: message === null || message === void 0 ? void 0 : message.type, width: "200px", height: "148px", onLoad: function () { setImageRendered(true); }, placeHolder: function (_a) {
                    var style = _a.style;
                    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message__placeholder", style: style },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message__placeholder__icon" },
                            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { type: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.r)(message) ? _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.PLAY */ .Qy.PLAY : _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.PHOTO */ .Qy.PHOTO, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "34px", height: "34px" }))));
                } }),
            ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.r)(message) && !thumbnailUrl) && !isImageRendered && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("video", { className: "sendbird-parent-message-info-item__thumbnail-message__video" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("source", { src: (message === null || message === void 0 ? void 0 : message.url) || (message === null || message === void 0 ? void 0 : message.plainUrl), type: message === null || message === void 0 ? void 0 : message.type }))),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message__image-cover" }),
            ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.r)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.s)(message)) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message__icon-wrapper" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__thumbnail-message__icon-wrapper__icon" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { type: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.r)(message) ? _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.PLAY */ .Qy.PLAY : _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconTypes.GIF */ .Qy.GIF, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_6__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "34px", height: "34px" })))))),
        (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.m)(message) === ((_j = _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.n === null || _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.n === void 0 ? void 0 : (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_3__.n)()) === null || _j === void 0 ? void 0 : _j.UNKNOWN) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info-item__unknown-message" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-parent-message-info-item__unknown-message__header", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, stringSet.UNKNOWN__UNKNOWN_MESSAGE_TYPE),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-parent-message-info-item__unknown-message__description", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, stringSet.UNKNOWN__CANNOT_READ_MESSAGE))),
        isReactionActivated && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-parent-message-info__reactions" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { userId: currentUserId, message: message, channel: currentChannel, isByMe: false, emojiContainer: emojiContainer, memberNicknamesMap: nicknamesMap, toggleReaction: toggleReaction, onPressUserProfile: onPressUserProfileHandler, filterEmojiCategoryIds: filterEmojiCategoryIds })))));
}


//# sourceMappingURL=ParentMessageInfoItem.js.map


/***/ }),

/***/ 95137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreadHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56210);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26765);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21112);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29515);













function ThreadHeader(_a) {
    var className = _a.className, channelName = _a.channelName, renderActionIcon = _a.renderActionIcon, onActionIconClick = _a.onActionIconClick, onChannelNameClick = _a.onChannelNameClick;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.u)().stringSet;
    var MemoizedActionIcon = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (typeof renderActionIcon === 'function' && onActionIconClick) {
            return renderActionIcon({ onActionIconClick: onActionIconClick });
        }
        return null;
    }, [renderActionIcon]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-thread-header ".concat(className), renderMiddle: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Title */ .ZP.Title, { title: stringSet.THREAD__HEADER_TITLE, subtitle: channelName, onClickSubtitle: onChannelNameClick })); }, renderRight: function () { return (MemoizedActionIcon || (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-thread-header__action" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].IconButton */ .ZP.IconButton, { onClick: function (e) { return onActionIconClick(e); }, type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.CLOSE */ .Qy.CLOSE, color: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1 })))); } }));
}


//# sourceMappingURL=ThreadHeader.js.map


/***/ }),

/***/ 61029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ThreadList; }
});

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-XQWyv823.js
var bundle_XQWyv823 = __webpack_require__(65614);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadListItem.js
var ThreadListItem = __webpack_require__(5591);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/context.js + 1 modules
var context = __webpack_require__(31723);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Channel/utils/compareMessagesForGrouping.js
var compareMessagesForGrouping = __webpack_require__(60196);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/useSendbirdStateContext.js
var useSendbirdStateContext = __webpack_require__(41238);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Message/context.js
var Message_context = __webpack_require__(23012);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BOn8npYv.js
var bundle_BOn8npYv = __webpack_require__(3153);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-QTCuDZTl.js
var bundle_QTCuDZTl = __webpack_require__(75010);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle--PhH_XFy.js
var bundle_PhH_XFy = __webpack_require__(59587);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BPcbf_pM.js
var bundle_BPcbf_pM = __webpack_require__(61448);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/DateSeparator.js
var DateSeparator = __webpack_require__(8743);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BL3yUpTV.js
var bundle_BL3yUpTV = __webpack_require__(21112);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ixnsp7Bg.js
var bundle_ixnsp7Bg = __webpack_require__(99366);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BkDHtL7_.js
var bundle_BkDHtL7_ = __webpack_require__(24354);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-NL8iE1lF.js
var bundle_NL8iE1lF = __webpack_require__(17693);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D_-9RmNe.js
var bundle_D_9RmNe = __webpack_require__(6623);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/utils/message/getOutgoingMessageState.js
var getOutgoingMessageState = __webpack_require__(8978);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-R3uJ_0BB.js
var bundle_R3uJ_0BB = __webpack_require__(26765);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/IconButton.js
var IconButton = __webpack_require__(29515);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Button.js
var Button = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Icon.js
var Icon = __webpack_require__(43822);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/index.js + 31 modules
var esm = __webpack_require__(63507);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/withSendbird.js
var withSendbird = __webpack_require__(71091);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BMJP8SSM.js
var bundle_BMJP8SSM = __webpack_require__(90832);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ml-PByBw.js
var bundle_ml_PByBw = __webpack_require__(16167);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/SortByRow.js
var SortByRow = __webpack_require__(78614);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-B8L7dGsu.js
var bundle_B8L7dGsu = __webpack_require__(44892);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FileViewer.js
var FileViewer = __webpack_require__(6989);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-52W7LREX.js
var bundle_52W7LREX = __webpack_require__(82314);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ImageRenderer.js
var ImageRenderer = __webpack_require__(4399);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-vS1u8K1w.js
var bundle_vS1u8K1w = __webpack_require__(60424);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CXPOT202.js
var bundle_CXPOT202 = __webpack_require__(41519);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CUxTGz0r.js
var bundle_CUxTGz0r = __webpack_require__(12225);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-C6DfLTJj.js
var bundle_C6DfLTJj = __webpack_require__(48614);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CLlCJbe7.js
var bundle_CLlCJbe7 = __webpack_require__(459);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageInput.js
var MessageInput = __webpack_require__(65134);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-tC4B8MXx.js + 1 modules
var bundle_tC4B8MXx = __webpack_require__(89171);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D7JevDoE.js
var bundle_D7JevDoE = __webpack_require__(1165);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/context/types.js
var types = __webpack_require__(53474);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageItemReactionMenu.js
var MessageItemReactionMenu = __webpack_require__(69139);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ReactionButton.js
var ReactionButton = __webpack_require__(60090);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CruP9bVM.js
var bundle_CruP9bVM = __webpack_require__(8627);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BX_znRDF.js
var bundle_BX_znRDF = __webpack_require__(95341);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Loader.js
var Loader = __webpack_require__(72661);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CmKxC8hb.js
var bundle_CmKxC8hb = __webpack_require__(25528);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/EmojiReactions.js
var EmojiReactions = __webpack_require__(27835);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ReactionBadge.js
var ReactionBadge = __webpack_require__(30156);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/BottomSheet.js
var BottomSheet = __webpack_require__(18087);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UserListItem.js
var UserListItem = __webpack_require__(56842);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bv8KtnvF.js
var bundle_Bv8KtnvF = __webpack_require__(46776);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MutedAvatarOverlay.js
var MutedAvatarOverlay = __webpack_require__(67412);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Checkbox.js
var Checkbox = __webpack_require__(10856);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UserProfile.js
var UserProfile = __webpack_require__(13462);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/sendbirdSelectors.js
var sendbirdSelectors = __webpack_require__(22284);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DRlnZqdp.js
var bundle_DRlnZqdp = __webpack_require__(80031);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Tooltip.js
var Tooltip = __webpack_require__(76886);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TooltipWrapper.js
var TooltipWrapper = __webpack_require__(32080);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MobileMenu.js
var MobileMenu = __webpack_require__(56342);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BFQnMRhA.js
var bundle_BFQnMRhA = __webpack_require__(43071);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CfaZQwKj.js
var bundle_CfaZQwKj = __webpack_require__(24277);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D634UqaM.js
var bundle_D634UqaM = __webpack_require__(76039);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-KDJ0EkHX.js
var bundle_KDJ0EkHX = __webpack_require__(15394);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/OGMessageItemBody.js
var OGMessageItemBody = __webpack_require__(34835);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DjfGQ-DS.js
var bundle_DjfGQ_DS = __webpack_require__(1277);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MentionLabel.js
var MentionLabel = __webpack_require__(81823);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/LinkLabel.js
var LinkLabel = __webpack_require__(40286);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TextMessageItemBody.js
var TextMessageItemBody = __webpack_require__(50206);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FileMessageItemBody.js
var FileMessageItemBody = __webpack_require__(12210);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TextButton.js
var TextButton = __webpack_require__(21790);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/VoiceMessageItemBody.js
var VoiceMessageItemBody = __webpack_require__(71612);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ProgressBar.js
var ProgressBar = __webpack_require__(68962);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/VoicePlayer/useVoicePlayer.js
var useVoicePlayer = __webpack_require__(32177);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/PlaybackTime.js
var PlaybackTime = __webpack_require__(28464);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ThumbnailMessageItemBody.js
var ThumbnailMessageItemBody = __webpack_require__(48845);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-oZLTNsQY.js
var bundle_oZLTNsQY = __webpack_require__(78828);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UnknownMessageItemBody.js
var UnknownMessageItemBody = __webpack_require__(33709);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TemplateMessageItemBody.js
var TemplateMessageItemBody = __webpack_require__(49754);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-KNrNIKZQ.js
var bundle_KNrNIKZQ = __webpack_require__(19652);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FallbackTemplateMessageItemBody.tsx.js
var FallbackTemplateMessageItemBody_tsx = __webpack_require__(34498);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/LoadingTemplateMessageItemBody.tsx.js
var LoadingTemplateMessageItemBody_tsx = __webpack_require__(64437);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageFeedbackFailedModal.js
var MessageFeedbackFailedModal = __webpack_require__(21402);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BaMsxnN_.js
var bundle_BaMsxnN_ = __webpack_require__(30302);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BdZX50Kw.js
var bundle_BdZX50Kw = __webpack_require__(88221);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Message/hooks/useDirtyGetMentions.js
var useDirtyGetMentions = __webpack_require__(66421);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CDvkkTNs.js
var bundle_CDvkkTNs = __webpack_require__(13566);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CtcQd9Ql.js
var bundle_CtcQd9Ql = __webpack_require__(18107);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DKR-710v.js
var bundle_DKR_710v = __webpack_require__(74531);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BbVJcZ9w.js
var bundle_BbVJcZ9w = __webpack_require__(13160);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadList.js














































































































function ThreadList(_a) {
    var className = _a.className, _b = _a.renderMessage, renderMessage = _b === void 0 ? function (props) { return react.createElement(ThreadListItem/* default */.Z, (0,bundle_XQWyv823._)({}, props)); } : _b, renderCustomSeparator = _a.renderCustomSeparator, scrollRef = _a.scrollRef, scrollBottom = _a.scrollBottom;
    var config = (0,useSendbirdStateContext/* useSendbirdStateContext */.A)().config;
    var userId = config.userId;
    var _c = (0,context/* useThreadContext */.i)(), currentChannel = _c.currentChannel, allThreadMessages = _c.allThreadMessages, localThreadMessages = _c.localThreadMessages;
    return (react.createElement("div", { className: "sendbird-thread-list ".concat(className) },
        allThreadMessages.map(function (message, idx) {
            var _a;
            var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
            var prevMessage = allThreadMessages[idx - 1];
            var nextMessage = allThreadMessages[idx + 1];
            // eslint-disable-next-line no-constant-condition
            var _b = (0,compareMessagesForGrouping/* compareMessagesForGrouping */.kt)(prevMessage, message, nextMessage, currentChannel, (0,bundle_BOn8npYv.g)(config.groupChannel.replyType).upperCase)
                , chainTop = _b[0], chainBottom = _b[1];
            var hasSeparator = !((prevMessage === null || prevMessage === void 0 ? void 0 : prevMessage.createdAt) > 0 && (isSameDay(message === null || message === void 0 ? void 0 : message.createdAt, prevMessage === null || prevMessage === void 0 ? void 0 : prevMessage.createdAt)));
            var handleScroll = function () {
                var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
                if (current && scrollBottom) {
                    var bottom = current.scrollHeight - current.scrollTop - current.offsetHeight;
                    if (scrollBottom < bottom) {
                        current.scrollTop += bottom - scrollBottom;
                    }
                }
            };
            return (react.createElement(Message_context/* MessageProvider */.x, { message: message, isByMe: isByMe, key: message === null || message === void 0 ? void 0 : message.messageId }, renderMessage({
                message: message,
                chainTop: chainTop,
                chainBottom: chainBottom,
                hasSeparator: hasSeparator,
                renderCustomSeparator: renderCustomSeparator,
                handleScroll: handleScroll,
            })));
        }),
        localThreadMessages.map(function (message) {
            var _a;
            var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
            var handleScroll = function () {
                var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
                if (current) {
                    var bottom = current.scrollHeight - current.scrollTop - current.offsetHeight;
                    if (scrollBottom < bottom) {
                        current.scrollTop += bottom - scrollBottom;
                    }
                }
            };
            return (react.createElement(Message_context/* MessageProvider */.x, { message: message, isByMe: isByMe, key: message === null || message === void 0 ? void 0 : message.messageId }, renderMessage({
                message: message,
                hasSeparator: false,
                renderCustomSeparator: renderCustomSeparator,
                handleScroll: handleScroll,
            })));
        })));
}


//# sourceMappingURL=ThreadList.js.map


/***/ }),

/***/ 5591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreadListItem; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8743);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24354);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6989);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31723);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41519);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65134);
/* harmony import */ var _context_types_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53474);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16167);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69139);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(95341);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27835);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8627);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56342);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43071);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(76039);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(15394);
/* harmony import */ var _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(88221);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(66421);
/* harmony import */ var _chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(14014);
/* harmony import */ var _chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(3153);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(17693);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(73935);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(88569);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(44892);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(13566);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(18107);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(1165);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(78614);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(60090);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(25528);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(30156);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(56842);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(23012);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(1277);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(40286);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(12210);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(21790);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(28464);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(48845);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(78828);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(21402);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(30302);











































































































function ThreadListItemContent(props) {
    var _this = this;
    var _a, _b, _c;
    // Internal props
    var className = props.className, userId = props.userId, channel = props.channel, message = props.message, _d = props.chainTop, chainTop = _d === void 0 ? false : _d, _e = props.chainBottom, chainBottom = _e === void 0 ? false : _e, _f = props.isReactionEnabled, isReactionEnabled = _f === void 0 ? false : _f, _g = props.disableQuoteMessage, disableQuoteMessage = _g === void 0 ? false : _g, replyType = props.replyType, nicknamesMap = props.nicknamesMap, emojiContainer = props.emojiContainer, showEdit = props.showEdit, showRemove = props.showRemove, showFileViewer = props.showFileViewer, resendMessage = props.resendMessage, toggleReaction = props.toggleReaction, onReplyInThread = props.onReplyInThread;
    // Public props for customization
    var _h = (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.d)(props), _j = _h.renderSenderProfile, renderSenderProfile = _j === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_25__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _j, _k = _h.renderMessageBody, renderMessageBody = _k === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_25__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _k, _l = _h.renderMessageHeader, renderMessageHeader = _l === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_25__.b, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _l, _m = _h.renderMessageMenu, renderMessageMenu = _m === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_23__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _m, _o = _h.renderEmojiMenu, renderEmojiMenu = _o === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_15__/* .MessageEmojiMenu */ .j, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _o, _p = _h.renderEmojiReactions, renderEmojiReactions = _p === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _p, _q = _h.renderMobileMenuOnLongPress, renderMobileMenuOnLongPress = _q === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_21__/* .MobileMenu */ .nn, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _q;
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_19__.u)().isMobile;
    var _r = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.u)(), dateLocale = _r.dateLocale, stringSet = _r.stringSet;
    var _s = (_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__/* .useSendbirdStateContext */ .A === null || _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__/* .useSendbirdStateContext */ .A === void 0 ? void 0 : (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__/* .useSendbirdStateContext */ .A)()) || {}, config = _s.config, eventHandlers = _s.eventHandlers;
    var logger = config.logger;
    var onPressUserProfileHandler = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.reaction) === null || _a === void 0 ? void 0 : _a.onPressUserProfile;
    var isMenuMounted = (0,_chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_24__.u)("#".concat((0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__.g)(message.messageId), ".").concat(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__.e), [
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__.d),
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__.E),
    ]);
    var _t = (0,_context_js__WEBPACK_IMPORTED_MODULE_8__/* .useThreadContext */ .i)(), deleteMessage = _t.deleteMessage, onBeforeDownloadFileMessage = _t.onBeforeDownloadFileMessage, filterEmojiCategoryIds = _t.filterEmojiCategoryIds;
    var isByMe = (userId === ((_b = message === null || message === void 0 ? void 0 : message.sender) === null || _b === void 0 ? void 0 : _b.userId))
        || ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'pending')
        || ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'failed');
    var useReplying = !!((replyType === 'QUOTE_REPLY' || replyType === 'THREAD')
        && (message === null || message === void 0 ? void 0 : message.parentMessageId) && (message === null || message === void 0 ? void 0 : message.parentMessage)
        && !disableQuoteMessage);
    var supposedHoverClassName = isMenuMounted ? 'sendbird-mouse-hover' : '';
    var isReactionEnabledInChannel = isReactionEnabled && !(channel === null || channel === void 0 ? void 0 : channel.isEphemeral);
    var isOgMessageEnabledInGroupChannel = channel.isGroupChannel() && config.groupChannel.enableOgtag;
    // Mobile
    var mobileMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _u = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMobileMenu = _u[0], setShowMobileMenu = _u[1];
    var longPress = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_20__.u)({
        onLongPress: function () {
            if (isMobile) {
                setShowMobileMenu(true);
            }
        },
    }, {
        shouldPreventDefault: false,
    });
    var threadMessageKindKey = (0,_chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_22__.u)({
        threadMessageKind: _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_22__.T.CHILD,
        isMobile: isMobile,
    });
    // For MultipleFilesMessage only.
    var statefulFileInfoList = (0,_chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_22__.a)(message);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.c)('sendbird-thread-list-item-content', className, isByMe ? 'outgoing' : 'incoming'), ref: mobileMenuRef },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.c)('sendbird-thread-list-item-content__left', isReactionEnabledInChannel && 'use-reaction', isByMe ? 'outgoing' : 'incoming') },
            (!isByMe && !chainBottom) && (renderSenderProfile((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), { className: 'sendbird-thread-list-item-content__left__avatar', isByMe: isByMe, displayThreadReplies: false }))),
            (isByMe && !isMobile) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.c)('sendbird-thread-list-item-content-menu', isReactionEnabledInChannel && 'use-reaction', isByMe ? 'outgoing' : 'incoming', supposedHoverClassName) },
                renderMessageMenu({
                    className: 'sendbird-thread-list-item-content-menu__normal-menu',
                    channel: channel,
                    message: message,
                    isByMe: isByMe,
                    replyType: replyType,
                    showEdit: showEdit,
                    showRemove: showRemove,
                    resendMessage: resendMessage,
                    onReplyInThread: onReplyInThread,
                    deleteMessage: deleteMessage,
                }),
                isReactionEnabledInChannel && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, renderEmojiMenu({
                    className: 'sendbird-thread-list-item-content-menu__reaction-menu',
                    message: message,
                    userId: userId,
                    emojiContainer: emojiContainer,
                    toggleReaction: toggleReaction,
                    filterEmojiCategoryIds: filterEmojiCategoryIds,
                })))))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: "sendbird-thread-list-item-content__middle" }, (isMobile) ? (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, longPress) : {}),
            (!isByMe && !chainTop && !useReplying) && renderMessageHeader(props),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.x)(['sendbird-thread-list-item-content__middle__body-container']) },
                (isByMe && !chainBottom) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.x)(['sendbird-thread-list-item-content__middle__body-container__created-at', 'left', supposedHoverClassName]) },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thread-list-item-content__middle__body-container__created-at__component-container" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_17__.M, { message: message, channel: channel })))),
                renderMessageBody({
                    className: 'sendbird-thread-list-item-content__middle__message-item-body',
                    message: message,
                    channel: channel,
                    showFileViewer: showFileViewer,
                    mouseHover: false,
                    isMobile: isMobile,
                    config: config,
                    isReactionEnabledInChannel: isReactionEnabledInChannel,
                    isByMe: isByMe,
                    onBeforeDownloadFileMessage: onBeforeDownloadFileMessage,
                    /** This is for internal customization to keep the legacy */
                    customSubcomponentsProps: {
                        ThumbnailMessageItemBody: {
                            style: {
                                width: isMobile ? '100%' : '200px',
                                height: '148px',
                            },
                        },
                        MultipleFilesMessageItemBody: {
                            threadMessageKindKey: threadMessageKindKey,
                            statefulFileInfoList: statefulFileInfoList,
                        },
                    },
                    // TODO: Support these props in Thread
                    // onMessageHeightChange,
                    // onTemplateMessageRenderedCallback,
                }),
                (isReactionEnabledInChannel && ((_c = message === null || message === void 0 ? void 0 : message.reactions) === null || _c === void 0 ? void 0 : _c.length) > 0) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.x)([
                        'sendbird-thread-list-item-content-reactions',
                        (!isByMe
                            || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.p)(message)
                            || (isOgMessageEnabledInGroupChannel && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.M)(message))
                            || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.c)(message)) ? '' : 'primary',
                    ]) }, renderEmojiReactions({
                    userId: userId,
                    message: message,
                    channel: channel,
                    isByMe: isByMe,
                    emojiContainer: emojiContainer,
                    memberNicknamesMap: nicknamesMap,
                    toggleReaction: toggleReaction,
                    onPressUserProfile: onPressUserProfileHandler,
                    filterEmojiCategoryIds: filterEmojiCategoryIds,
                }))),
                (!isByMe && !chainBottom) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__.x)(['sendbird-thread-list-item-content__middle__body-container__created-at', 'right', supposedHoverClassName]), type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_2 }, (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)((message === null || message === void 0 ? void 0 : message.createdAt) || 0, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                    locale: dateLocale,
                }))))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.c)('sendbird-thread-list-item-content__right', chainTop && 'chain-top', isByMe ? 'outgoing' : 'incoming') }, (!isByMe && !isMobile) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thread-list-item-content-menu ".concat(supposedHoverClassName) },
            isReactionEnabledInChannel && (renderEmojiMenu({
                className: 'sendbird-thread-list-item-content-menu__reaction-menu',
                message: message,
                userId: userId,
                emojiContainer: emojiContainer,
                toggleReaction: toggleReaction,
                filterEmojiCategoryIds: filterEmojiCategoryIds,
            })),
            renderMessageMenu({
                className: 'sendbird-thread-list-item-content-menu__normal-menu',
                channel: channel,
                message: message,
                isByMe: isByMe,
                replyType: replyType,
                showRemove: showRemove,
                resendMessage: resendMessage,
                onReplyInThread: onReplyInThread,
                deleteMessage: deleteMessage,
            })))),
        showMobileMenu && (renderMobileMenuOnLongPress({
            parentRef: mobileMenuRef,
            channel: channel,
            message: message,
            userId: userId,
            replyType: replyType,
            hideMenu: function () {
                setShowMobileMenu(false);
            },
            isReactionEnabled: isReactionEnabled,
            isByMe: isByMe,
            emojiContainer: emojiContainer,
            showEdit: showEdit,
            showRemove: showRemove,
            toggleReaction: toggleReaction,
            isOpenedFromThread: true,
            deleteMessage: deleteMessage,
            onDownloadClick: function (e) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var allowDownload, err_1;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!onBeforeDownloadFileMessage)
                                return [2 /*return*/];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message })];
                        case 2:
                            allowDownload = _c.sent();
                            if (!allowDownload) {
                                e.preventDefault();
                                (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'ThreadListItemContent: Not allowed to download.');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _c.sent();
                            (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'ThreadListItemContent: Error occurred while determining download continuation:', err_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
        }))));
}

function ThreadListItem(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var className = props.className, message = props.message, chainTop = props.chainTop, chainBottom = props.chainBottom, hasSeparator = props.hasSeparator, renderCustomSeparator = props.renderCustomSeparator, handleScroll = props.handleScroll;
    var _e = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_9__/* .useSendbirdStateContext */ .A)(), stores = _e.stores, config = _e.config;
    var isOnline = config.isOnline, userMention = config.userMention, logger = config.logger, groupChannel = config.groupChannel;
    var userId = (_b = (_a = stores === null || stores === void 0 ? void 0 : stores.userStore) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId;
    var _f = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.u)(), dateLocale = _f.dateLocale, stringSet = _f.stringSet;
    var threadContext = _context_js__WEBPACK_IMPORTED_MODULE_8__/* .useThreadContext */ .i === null || _context_js__WEBPACK_IMPORTED_MODULE_8__/* .useThreadContext */ .i === void 0 ? void 0 : (0,_context_js__WEBPACK_IMPORTED_MODULE_8__/* .useThreadContext */ .i)();
    var currentChannel = threadContext.currentChannel, nicknamesMap = threadContext.nicknamesMap, emojiContainer = threadContext.emojiContainer, toggleReaction = threadContext.toggleReaction, threadListState = threadContext.threadListState, updateMessage = threadContext.updateMessage, resendMessage = threadContext.resendMessage, deleteMessage = threadContext.deleteMessage, isMuted = threadContext.isMuted, isChannelFrozen = threadContext.isChannelFrozen, onBeforeDownloadFileMessage = threadContext.onBeforeDownloadFileMessage;
    var openingMessage = threadContext === null || threadContext === void 0 ? void 0 : threadContext.message;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showEdit = _g[0], setShowEdit = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showRemove = _h[0], setShowRemove = _h[1];
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFileViewer = _j[0], setShowFileViewer = _j[1];
    var isReactionEnabled = (0,_chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_89__.g)({
        channel: currentChannel,
        config: config,
    });
    var isMentionEnabled = groupChannel.enableMention;
    var replyType = (0,_chunks_bundle_BOn8npYv_js__WEBPACK_IMPORTED_MODULE_90__.g)(groupChannel.replyType).upperCase;
    // Move to message
    var messageScrollRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        var _a;
        if ((openingMessage === null || openingMessage === void 0 ? void 0 : openingMessage.messageId) === (message === null || message === void 0 ? void 0 : message.messageId) && (messageScrollRef === null || messageScrollRef === void 0 ? void 0 : messageScrollRef.current)) {
            (_a = messageScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'center', inline: 'center' });
        }
    }, [openingMessage, messageScrollRef === null || messageScrollRef === void 0 ? void 0 : messageScrollRef.current]);
    // reactions
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll();
    }, [showEdit, (_c = message === null || message === void 0 ? void 0 : message.reactions) === null || _c === void 0 ? void 0 : _c.length]);
    // mention
    var editMessageInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), mentionNickname = _k[0], setMentionNickname = _k[1];
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUsers = _l[0], setMentionedUsers = _l[1];
    var _m = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _m[0], setMentionedUserIds = _m[1];
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), messageInputEvent = _o[0], setMessageInputEvent = _o[1];
    var _p = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedUser = _p[0], setSelectedUser = _p[1];
    var _q = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionSuggestedUsers = _q[0], setMentionSuggestedUsers = _q[1];
    var displaySuggestedMentionList = isOnline
        && isMentionEnabled
        && mentionNickname.length > 0
        && !isMuted
        && !(isChannelFrozen && !(currentChannel.myRole === _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_26__.R.OPERATOR));
    var mentionNodes = (0,_Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_27__/* .useDirtyGetMentions */ .X)({ ref: editMessageInputRef }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    // edit input
    var disabled = !(threadListState === _context_types_js__WEBPACK_IMPORTED_MODULE_12__/* .ThreadListStateTypes.INITIALIZED */ .RZ.INITIALIZED)
        || !isOnline
        || isMuted
        || isChannelFrozen;
    // memorize
    var MemorizedSeparator = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        if (typeof renderCustomSeparator === 'function') {
            return renderCustomSeparator === null || renderCustomSeparator === void 0 ? void 0 : renderCustomSeparator({ message: message });
        }
    }, [message, renderCustomSeparator]);
    // Edit message
    if (showEdit && message.isUserMessage()) {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            displaySuggestedMentionList && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_10__.S, { targetNickname: mentionNickname, inputEvent: messageInputEvent !== null && messageInputEvent !== void 0 ? messageInputEvent : undefined, 
                // renderUserMentionItem={renderUserMentionItem}
                onUserItemClick: function (user) {
                    if (user) {
                        setMentionedUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], mentionedUsers, true), [user], false));
                    }
                    setMentionNickname('');
                    setSelectedUser(user);
                    setMessageInputEvent(null);
                }, onFocusItemChange: function () {
                    setMessageInputEvent(null);
                }, onFetchUsers: function (users) {
                    setMentionSuggestedUsers(users);
                }, ableAddMention: ableMention, maxMentionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount, maxSuggestionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { isEdit: true, channel: currentChannel, disabled: disabled, ref: editMessageInputRef, mentionSelectedUser: selectedUser, isMentionEnabled: isMentionEnabled, message: message, onStartTyping: function () {
                    var _a;
                    (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.startTyping) === null || _a === void 0 ? void 0 : _a.call(currentChannel);
                }, onUpdateMessage: function (_a) {
                    var _b;
                    var messageId = _a.messageId, message = _a.message, mentionTemplate = _a.mentionTemplate;
                    updateMessage({
                        messageId: messageId,
                        message: message,
                        mentionedUsers: mentionedUsers,
                        mentionTemplate: mentionTemplate,
                    });
                    setShowEdit(false);
                    (_b = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _b === void 0 ? void 0 : _b.call(currentChannel);
                }, onCancelEdit: function () {
                    var _a;
                    setMentionNickname('');
                    setMentionedUsers([]);
                    setMentionedUserIds([]);
                    setMentionSuggestedUsers([]);
                    setShowEdit(false);
                    (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _a === void 0 ? void 0 : _a.call(currentChannel);
                }, onUserMentioned: function (user) {
                    if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                        setSelectedUser(null);
                        setMentionNickname('');
                    }
                }, onMentionStringChange: function (mentionText) {
                    setMentionNickname(mentionText);
                }, onMentionedUserIdsUpdated: function (userIds) {
                    setMentionedUserIds(userIds);
                }, onKeyDown: function (e) {
                    if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                        && ((e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_13__.M.Enter && ableMention) || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_13__.M.ArrowUp || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_13__.M.ArrowDown)) {
                        setMessageInputEvent(e);
                        return true;
                    }
                    return false;
                } })));
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { ref: messageScrollRef, className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_88__.c)('sendbird-thread-list-item', className), "data-testid": "sendbird-thread-list-item" },
        hasSeparator && (message === null || message === void 0 ? void 0 : message.createdAt) && (MemorizedSeparator || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null,
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_2 }, (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)(message === null || message === void 0 ? void 0 : message.createdAt, stringSet.DATE_FORMAT__THREAD_LIST__DATE_SEPARATOR, { locale: dateLocale }))))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(ThreadListItemContent, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { userId: userId, channel: currentChannel, message: message, chainTop: chainTop, chainBottom: chainBottom, isReactionEnabled: isReactionEnabled, disableQuoteMessage: true, replyType: replyType, nicknamesMap: nicknamesMap, emojiContainer: emojiContainer, resendMessage: resendMessage, showRemove: setShowRemove, showFileViewer: setShowFileViewer, toggleReaction: toggleReaction, showEdit: setShowEdit })),
        showRemove && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_6__.R, { message: message, onCancel: function () { return setShowRemove(false); } })),
        showFileViewer && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { message: message, isByMe: ((_d = message === null || message === void 0 ? void 0 : message.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId, onClose: function () { return setShowFileViewer(false); }, onDelete: function () {
                deleteMessage(message);
                setShowFileViewer(false);
            }, onDownloadClick: function (e) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var allowDownload, err_1;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!onBeforeDownloadFileMessage)
                                return [2 /*return*/];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message })];
                        case 2:
                            allowDownload = _c.sent();
                            if (!allowDownload) {
                                e.preventDefault();
                                (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'ThreadListItem: Not allowed to download.');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _c.sent();
                            (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'ThreadListItem: Error occurred while determining download continuation:', err_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); } }))));
}


//# sourceMappingURL=ThreadListItem.js.map


/***/ }),

/***/ 38506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreadMessageInput$1; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(34182);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26765);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31723);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59587);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41519);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91607);
/* harmony import */ var _GroupChannel_context_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88221);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66421);
/* harmony import */ var _Channel_hooks_useHandleUploadFiles_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73459);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18107);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(80360);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13566);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80031);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6623);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73935);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(61448);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(78614);
/* harmony import */ var _context_types_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(53474);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(82314);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(30302);
/* harmony import */ var _GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(85562);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(67840);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(78828);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(32177);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(12291);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(28464);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(68962);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(85385);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(38204);










































































var ThreadMessageInput = function (props, ref) {
    var _a;
    var className = props.className, renderFileUploadIcon = props.renderFileUploadIcon, renderVoiceMessageIcon = props.renderVoiceMessageIcon, renderSendMessageIcon = props.renderSendMessageIcon, acceptableMimeTypes = props.acceptableMimeTypes;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A)().config;
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__.u)().isMobile;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__.u)().stringSet;
    var isOnline = config.isOnline, userMention = config.userMention, logger = config.logger, groupChannel = config.groupChannel;
    var threadContext = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useThreadContext */ .i)();
    var currentChannel = threadContext.currentChannel, parentMessage = threadContext.parentMessage, sendMessage = threadContext.sendMessage, sendFileMessage = threadContext.sendFileMessage, sendVoiceMessage = threadContext.sendVoiceMessage, sendMultipleFilesMessage = threadContext.sendMultipleFilesMessage, isMuted = threadContext.isMuted, isChannelFrozen = threadContext.isChannelFrozen, allThreadMessages = threadContext.allThreadMessages;
    var messageInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var isMentionEnabled = groupChannel.enableMention;
    var isVoiceMessageEnabled = groupChannel.enableVoiceMessage;
    var isMultipleFilesMessageEnabled = (_a = threadContext.isMultipleFilesMessageEnabled) !== null && _a !== void 0 ? _a : config.isMultipleFilesMessageEnabled;
    var threadInputDisabled = props.disabled
        || !isOnline
        || isMuted
        || (!((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myRole) === _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_11__.R.OPERATOR) && isChannelFrozen) || parentMessage === null;
    // MFM
    var handleUploadFiles = (0,_Channel_hooks_useHandleUploadFiles_js__WEBPACK_IMPORTED_MODULE_13__/* .useHandleUploadFiles */ .l)({
        sendFileMessage: sendFileMessage,
        sendMultipleFilesMessage: sendMultipleFilesMessage,
        quoteMessage: parentMessage,
    }, {
        logger: logger,
    });
    // mention
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), mentionNickname = _b[0], setMentionNickname = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUsers = _c[0], setMentionedUsers = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _d[0], setMentionedUserIds = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedUser = _e[0], setSelectedUser = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionSuggestedUsers = _f[0], setMentionSuggestedUsers = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), messageInputEvent = _g[0], setMessageInputEvent = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showVoiceMessageInput = _h[0], setShowVoiceMessageInput = _h[1];
    var displaySuggestedMentionList = isOnline
        && isMentionEnabled
        && mentionNickname.length > 0
        && !(0,_chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_14__.b)(currentChannel)
        && !(0,_chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_14__.c)(currentChannel)
        && !(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isBroadcast);
    // Reset when changing channel
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setShowVoiceMessageInput(false);
    }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    var mentionNodes = (0,_Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_12__/* .useDirtyGetMentions */ .X)({ ref: ref || messageInputRef }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isBroadcast) && (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myRole) !== _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_11__.R.OPERATOR) {
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_55__.c)(showVoiceMessageInput ? 'sendbird-thread-message-input--voice-message' : 'sendbird-thread-message-input', className) },
        displaySuggestedMentionList && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_8__.S, { targetNickname: mentionNickname, inputEvent: messageInputEvent !== null && messageInputEvent !== void 0 ? messageInputEvent : undefined, 
            // renderUserMentionItem={renderUserMentionItem}
            onUserItemClick: function (user) {
                if (user) {
                    setMentionedUsers((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], mentionedUsers, true), [user], false));
                }
                setMentionNickname('');
                setSelectedUser(user);
                setMessageInputEvent(null);
            }, onFocusItemChange: function () {
                setMessageInputEvent(null);
            }, onFetchUsers: function (users) {
                setMentionSuggestedUsers(users);
            }, ableAddMention: ableMention, maxMentionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount, maxSuggestionCount: userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount })),
        showVoiceMessageInput
            ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_9__.V, { channel: currentChannel, onSubmitClick: function (recordedFile, duration) {
                    sendVoiceMessage(recordedFile, duration, parentMessage);
                    setShowVoiceMessageInput(false);
                }, onCancelClick: function () {
                    setShowVoiceMessageInput(false);
                } }))
            : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { className: "sendbird-thread-message-input__message-input", messageFieldId: "sendbird-message-input-text-field--thread", channel: currentChannel, channelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url, isMobile: isMobile, disabled: threadInputDisabled, acceptableMimeTypes: acceptableMimeTypes, setMentionedUsers: setMentionedUsers, mentionSelectedUser: selectedUser, isMentionEnabled: isMentionEnabled, isVoiceMessageEnabled: isVoiceMessageEnabled, isSelectingMultipleFilesEnabled: isMultipleFilesMessageEnabled, onVoiceMessageIconClick: function () {
                    setShowVoiceMessageInput(true);
                }, renderFileUploadIcon: renderFileUploadIcon, renderVoiceMessageIcon: renderVoiceMessageIcon, renderSendMessageIcon: renderSendMessageIcon, ref: ref || messageInputRef, placeholder: ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isFrozen) && !((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myRole) === _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_11__.R.OPERATOR) && stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED)
                    || ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myMutedState) === _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_56__.be.MUTED && stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT)
                    || (allThreadMessages.length > 0
                        ? stringSet.THREAD__INPUT__REPLY_TO_THREAD
                        : stringSet.THREAD__INPUT__REPLY_IN_THREAD), onStartTyping: function () {
                    var _a;
                    (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.startTyping) === null || _a === void 0 ? void 0 : _a.call(currentChannel);
                }, onSendMessage: function (_a) {
                    var _b;
                    var message = _a.message, mentionTemplate = _a.mentionTemplate;
                    sendMessage({
                        message: message,
                        mentionedUsers: mentionedUsers,
                        mentionTemplate: mentionTemplate,
                        quoteMessage: parentMessage,
                    });
                    setMentionNickname('');
                    setMentionedUsers([]);
                    (_b = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _b === void 0 ? void 0 : _b.call(currentChannel);
                }, onFileUpload: handleUploadFiles, onUserMentioned: function (user) {
                    if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                        setSelectedUser(null);
                        setMentionNickname('');
                    }
                }, onMentionStringChange: function (mentionText) {
                    setMentionNickname(mentionText);
                }, onMentionedUserIdsUpdated: function (userIds) {
                    setMentionedUserIds(userIds);
                }, onKeyDown: function (e) {
                    if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                        && ((e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.Enter && ableMention) || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.ArrowUp || e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.ArrowDown)) {
                        setMessageInputEvent(e);
                        return true;
                    }
                    return false;
                } }))));
};
var ThreadMessageInput$1 = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(ThreadMessageInput);


//# sourceMappingURL=ThreadMessageInput.js.map


/***/ }),

/***/ 40287:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreadUI; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11639);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31723);
/* harmony import */ var _ParentMessageInfo_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33116);
/* harmony import */ var _ThreadHeader_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95137);
/* harmony import */ var _ThreadList_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61029);
/* harmony import */ var _ThreadMessageInput_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38506);
/* harmony import */ var _context_types_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53474);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10364);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13566);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23012);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(80360);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(88569);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_DKR_710v_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(74531);
/* harmony import */ var _chunks_bundle_BbVJcZ9w_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(13160);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_BkDHtL7_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(24354);
/* harmony import */ var _chunks_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(44892);
/* harmony import */ var _ParentMessageInfoItem_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(5806);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(4399);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(21112);
/* harmony import */ var _ui_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(27835);
/* harmony import */ var _ui_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(30156);
/* harmony import */ var _ui_ReactionButton_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(8627);
/* harmony import */ var _ui_BottomSheet_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(18087);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(82314);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(67412);
/* harmony import */ var _ui_Checkbox_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(10856);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(22284);
/* harmony import */ var _ui_Tooltip_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(76886);
/* harmony import */ var _ui_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(32080);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(71612);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(32177);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(28464);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(1165);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(40286);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(43071);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(18107);
/* harmony import */ var _chunks_bundle_CXPOT202_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(41519);
/* harmony import */ var _chunks_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(12225);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(459);
/* harmony import */ var _ui_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(69139);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(65134);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(89171);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_BdZX50Kw_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(88221);
/* harmony import */ var _ui_MobileMenu_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(56342);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(66421);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(76039);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(56210);
/* harmony import */ var _ThreadListItem_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(5591);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(8743);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(25528);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(15394);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(34835);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(12210);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(48845);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(78828);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(19652);
/* harmony import */ var _ui_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(34498);
/* harmony import */ var _ui_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(64437);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(21402);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(30302);
/* harmony import */ var _Channel_utils_compareMessagesForGrouping_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(60196);
/* harmony import */ var _chunks_bundle_SyLbPukg_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(91607);
/* harmony import */ var _GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(85562);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(67840);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(19515);
/* harmony import */ var _chunks_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(12291);
/* harmony import */ var _chunks_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(85385);
/* harmony import */ var _GroupChannel_context_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(27165);
/* harmony import */ var _chunks_bundle_BApwq9D9_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(38204);
/* harmony import */ var _Channel_hooks_useHandleUploadFiles_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(73459);
































































































































var useMemorizedHeader = function (_a) {
    var renderHeader = _a.renderHeader;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (typeof renderHeader === 'function') {
            return renderHeader();
        }
        return null;
    }, [renderHeader]);
};

var useMemorizedParentMessageInfo = function (_a) {
    var parentMessage = _a.parentMessage, parentMessageState = _a.parentMessageState, renderParentMessageInfo = _a.renderParentMessageInfo, renderParentMessageInfoPlaceholder = _a.renderParentMessageInfoPlaceholder;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (parentMessageState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.NIL */ .KD.NIL
            || parentMessageState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.LOADING */ .KD.LOADING
            || parentMessageState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.INVALID */ .KD.INVALID) {
            if (typeof renderParentMessageInfoPlaceholder === 'function') {
                return renderParentMessageInfoPlaceholder(parentMessageState);
            }
            switch (parentMessageState) {
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.NIL */ .KD.NIL: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-thread-ui__parent-message-info placeholder-nil", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* .PlaceHolderTypes.NO_RESULTS */ .v.NO_RESULTS, iconSize: "64px" }));
                }
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.LOADING */ .KD.LOADING: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-thread-ui__parent-message-info placeholder-loading", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* .PlaceHolderTypes.LOADING */ .v.LOADING, iconSize: "64px" }));
                }
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.INVALID */ .KD.INVALID: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-thread-ui__parent-message-info placeholder-invalid", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* .PlaceHolderTypes.WRONG */ .v.WRONG, iconSize: "64px" }));
                }
                default: {
                    return null;
                }
            }
        }
        else if (parentMessageState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ParentMessageStateTypes.INITIALIZED */ .KD.INITIALIZED) {
            if (typeof renderParentMessageInfo === 'function') {
                return renderParentMessageInfo();
            }
        }
        return null;
    }, [
        parentMessage,
        parentMessageState,
        renderParentMessageInfo,
        renderParentMessageInfoPlaceholder,
    ]);
};

var useMemorizedThreadList = function (_a) {
    var threadListState = _a.threadListState, renderThreadListPlaceHolder = _a.renderThreadListPlaceHolder;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (threadListState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.NIL */ .RZ.NIL
            || threadListState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.LOADING */ .RZ.LOADING
            || threadListState === _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.INVALID */ .RZ.INVALID) {
            if (typeof renderThreadListPlaceHolder === 'function') {
                return renderThreadListPlaceHolder(threadListState);
            }
            switch (threadListState) {
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.LOADING */ .RZ.LOADING: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-thread-ui__thread-list placeholder-loading", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* .PlaceHolderTypes.LOADING */ .v.LOADING, iconSize: "64px" }));
                }
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.INVALID */ .RZ.INVALID: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-thread-ui__thread-list placeholder-invalid", type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_10__/* .PlaceHolderTypes.WRONG */ .v.WRONG, iconSize: "64px" }));
                }
                case _context_types_js__WEBPACK_IMPORTED_MODULE_9__/* .ThreadListStateTypes.NIL */ .RZ.NIL: {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
                }
                default: {
                    return null;
                }
            }
        }
        return null;
    }, [
        threadListState,
        renderThreadListPlaceHolder,
    ]);
};

var ThreadUI = function (_a) {
    var _b, _c, _d, _e;
    var renderHeader = _a.renderHeader, _f = _a.renderParentMessageInfo, renderParentMessageInfo = _f === void 0 ? function () { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ParentMessageInfo_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { className: "sendbird-thread-ui__parent-message-info" }); } : _f, renderMessage = _a.renderMessage, renderMessageInput = _a.renderMessageInput, renderCustomSeparator = _a.renderCustomSeparator, renderParentMessageInfoPlaceholder = _a.renderParentMessageInfoPlaceholder, renderThreadListPlaceHolder = _a.renderThreadListPlaceHolder, renderFileUploadIcon = _a.renderFileUploadIcon, renderVoiceMessageIcon = _a.renderVoiceMessageIcon, renderSendMessageIcon = _a.renderSendMessageIcon;
    var stores = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useSendbirdStateContext */ .A)().stores;
    var currentUserId = (_d = (_c = (_b = stores === null || stores === void 0 ? void 0 : stores.sdkStore) === null || _b === void 0 ? void 0 : _b.sdk) === null || _c === void 0 ? void 0 : _c.currentUser) === null || _d === void 0 ? void 0 : _d.userId;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.u)().stringSet;
    var _g = (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .useThreadContext */ .i)(), currentChannel = _g.currentChannel, allThreadMessages = _g.allThreadMessages, parentMessage = _g.parentMessage, parentMessageState = _g.parentMessageState, threadListState = _g.threadListState, hasMorePrev = _g.hasMorePrev, hasMoreNext = _g.hasMoreNext, fetchPrevThreads = _g.fetchPrevThreads, fetchNextThreads = _g.fetchNextThreads, onHeaderActionClick = _g.onHeaderActionClick, onMoveToParentMessage = _g.onMoveToParentMessage;
    var replyCount = allThreadMessages.length;
    var isByMe = currentUserId === ((_e = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender) === null || _e === void 0 ? void 0 : _e.userId);
    // Memoized custom components
    var MemorizedHeader = useMemorizedHeader({ renderHeader: renderHeader });
    var MemorizedParentMessageInfo = useMemorizedParentMessageInfo({
        parentMessage: parentMessage,
        parentMessageState: parentMessageState,
        renderParentMessageInfo: renderParentMessageInfo,
        renderParentMessageInfoPlaceholder: renderParentMessageInfoPlaceholder,
    });
    var MemorizedThreadList = useMemorizedThreadList({
        threadListState: threadListState,
        renderThreadListPlaceHolder: renderThreadListPlaceHolder,
    });
    // scroll
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), scrollBottom = _h[0], setScrollBottom = _h[1];
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onScroll = function (e) {
        var _a;
        var element = e.target;
        var scrollTop = element.scrollTop, clientHeight = element.clientHeight, scrollHeight = element.scrollHeight;
        var threadItemNodes = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sendbird-thread-list-item');
        var firstNode = threadItemNodes === null || threadItemNodes === void 0 ? void 0 : threadItemNodes[0];
        if ((0,_chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_12__.i)(scrollTop, 0, 10) && hasMorePrev) {
            fetchPrevThreads(function (messages) {
                var _a;
                if (messages) {
                    try {
                        (_a = firstNode === null || firstNode === void 0 ? void 0 : firstNode.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(firstNode, { block: 'start', inline: 'nearest' });
                    }
                    catch (error) {
                        //
                    }
                }
            });
        }
        if ((0,_chunks_bundle_CDvkkTNs_js__WEBPACK_IMPORTED_MODULE_12__.i)(clientHeight + scrollTop, scrollHeight, 10) && hasMoreNext) {
            var scrollTop_1 = scrollTop;
            fetchNextThreads(function (messages) {
                if (messages) {
                    try {
                        element.scrollTop = scrollTop_1;
                        if (scrollRef.current) {
                            scrollRef.current.scrollTop = scrollTop_1;
                        }
                    }
                    catch (error) {
                        //
                    }
                }
            });
        }
        // save the lastest scroll bottom value
        if (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) {
            var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
            setScrollBottom(current.scrollHeight - current.scrollTop - current.offsetHeight);
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-thread-ui' },
        MemorizedHeader || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ThreadHeader_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { className: "sendbird-thread-ui__header", channelName: (0,_chunks_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_3__.g)(currentChannel, currentUserId !== null && currentUserId !== void 0 ? currentUserId : '', stringSet), onActionIconClick: onHeaderActionClick, onChannelNameClick: function () {
                onMoveToParentMessage === null || onMoveToParentMessage === void 0 ? void 0 : onMoveToParentMessage({ message: parentMessage, channel: currentChannel });
            } })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_107__.c)('sendbird-thread-ui--scroll', 'sendbird-conversation__messages'), ref: scrollRef, onScroll: onScroll },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Message_context_js__WEBPACK_IMPORTED_MODULE_13__/* .MessageProvider */ .x, { message: parentMessage, isByMe: isByMe }, MemorizedParentMessageInfo),
            replyCount > 0 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-thread-ui__reply-counts" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_11__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_11__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_11__.b.ONBACKGROUND_3 }, "".concat(replyCount, " ").concat(replyCount > 1 ? stringSet.THREAD__THREAD_REPLIES : stringSet.THREAD__THREAD_REPLY)))),
            MemorizedThreadList || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ThreadList_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { className: "sendbird-thread-ui__thread-list", renderMessage: renderMessage, renderCustomSeparator: renderCustomSeparator, scrollRef: scrollRef, scrollBottom: scrollBottom }))),
        (renderMessageInput === null || renderMessageInput === void 0 ? void 0 : renderMessageInput()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ThreadMessageInput_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { className: "sendbird-thread-ui__message-input", renderFileUploadIcon: renderFileUploadIcon, renderVoiceMessageIcon: renderVoiceMessageIcon, renderSendMessageIcon: renderSendMessageIcon }))));
};


//# sourceMappingURL=ThreadUI.js.map


/***/ }),

/***/ 31723:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ThreadProvider; },
  "i": function() { return /* binding */ useThreadContext; }
});

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-XQWyv823.js
var bundle_XQWyv823 = __webpack_require__(65614);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CDvkkTNs.js
var bundle_CDvkkTNs = __webpack_require__(13566);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bv8KtnvF.js
var bundle_Bv8KtnvF = __webpack_require__(46776);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/useSendbirdStateContext.js
var useSendbirdStateContext = __webpack_require__(41238);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/context/types.js
var types = __webpack_require__(53474);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-1db3fd0b.js
var _bundle_1db3fd0b = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DRlnZqdp.js
var bundle_DRlnZqdp = __webpack_require__(80031);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DKR-710v.js
var bundle_DKR_710v = __webpack_require__(74531);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/groupChannel.js
var groupChannel = __webpack_require__(42391);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bq93DTET.js
var bundle_Bq93DTET = __webpack_require__(88071);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BKwxWorE.js
var isEmpty = function (val) { return (val === null || val === undefined); };
// Some Ids return string and number inconsistently
// only use to compare IDs
function compareIds(a, b) {
    if (isEmpty(a) || isEmpty(b)) {
        return false;
    }
    var aString = a.toString();
    var bString = b.toString();
    return aString === bString;
}


//# sourceMappingURL=bundle-BKwxWorE.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e1a5e3f1.js
var _bundle_e1a5e3f1 = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle--PhH_XFy.js
var bundle_PhH_XFy = __webpack_require__(59587);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DABR6HKW.js
var bundle_DABR6HKW = __webpack_require__(69466);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BbVJcZ9w.js
var bundle_BbVJcZ9w = __webpack_require__(13160);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CtcQd9Ql.js
var bundle_CtcQd9Ql = __webpack_require__(18107);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/utils/message/getOutgoingMessageState.js
var getOutgoingMessageState = __webpack_require__(8978);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/index.js + 31 modules
var esm = __webpack_require__(63507);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/withSendbird.js
var withSendbird = __webpack_require__(71091);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-NL8iE1lF.js
var bundle_NL8iE1lF = __webpack_require__(17693);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D_-9RmNe.js
var bundle_D_9RmNe = __webpack_require__(6623);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-R3uJ_0BB.js
var bundle_R3uJ_0BB = __webpack_require__(26765);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/IconButton.js
var IconButton = __webpack_require__(29515);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Button.js
var Button = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ixnsp7Bg.js
var bundle_ixnsp7Bg = __webpack_require__(99366);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BPcbf_pM.js
var bundle_BPcbf_pM = __webpack_require__(61448);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Icon.js
var Icon = __webpack_require__(43822);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BMJP8SSM.js
var bundle_BMJP8SSM = __webpack_require__(90832);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ml-PByBw.js
var bundle_ml_PByBw = __webpack_require__(16167);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/SortByRow.js
var SortByRow = __webpack_require__(78614);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Thread/context.js






































var PREV_THREADS_FETCH_SIZE = 30;
var NEXT_THREADS_FETCH_SIZE = 30;

var ThreadContextActionTypes;
(function (ThreadContextActionTypes) {
    // initialize
    ThreadContextActionTypes["INIT_USER_ID"] = "INIT_USER_ID";
    // channel
    ThreadContextActionTypes["GET_CHANNEL_START"] = "GET_CHANNEL_START";
    ThreadContextActionTypes["GET_CHANNEL_SUCCESS"] = "GET_CHANNEL_SUCCESS";
    ThreadContextActionTypes["GET_CHANNEL_FAILURE"] = "GET_CHANNEL_FAILURE";
    // emojis
    ThreadContextActionTypes["SET_EMOJI_CONTAINER"] = "SET_EMOJI_CONTAINER";
    // parent message
    ThreadContextActionTypes["GET_PARENT_MESSAGE_START"] = "GET_PARENT_MESSAGE_START";
    ThreadContextActionTypes["GET_PARENT_MESSAGE_SUCCESS"] = "GET_PARENT_MESSAGE_SUCCESS";
    ThreadContextActionTypes["GET_PARENT_MESSAGE_FAILURE"] = "GET_PARENT_MESSAGE_FAILURE";
    // fetch threads
    ThreadContextActionTypes["INITIALIZE_THREAD_LIST_START"] = "INITIALIZE_THREAD_LIST_START";
    ThreadContextActionTypes["INITIALIZE_THREAD_LIST_SUCCESS"] = "INITIALIZE_THREAD_LIST_SUCCESS";
    ThreadContextActionTypes["INITIALIZE_THREAD_LIST_FAILURE"] = "INITIALIZE_THREAD_LIST_FAILURE";
    ThreadContextActionTypes["GET_PREV_MESSAGES_START"] = "GET_PREV_MESSAGES_START";
    ThreadContextActionTypes["GET_PREV_MESSAGES_SUCESS"] = "GET_PREV_MESSAGES_SUCESS";
    ThreadContextActionTypes["GET_PREV_MESSAGES_FAILURE"] = "GET_PREV_MESSAGES_FAILURE";
    ThreadContextActionTypes["GET_NEXT_MESSAGES_START"] = "GET_NEXT_MESSAGES_START";
    ThreadContextActionTypes["GET_NEXT_MESSAGES_SUCESS"] = "GET_NEXT_MESSAGES_SUCESS";
    ThreadContextActionTypes["GET_NEXT_MESSAGES_FAILURE"] = "GET_NEXT_MESSAGES_FAILURE";
    // handle messages
    ThreadContextActionTypes["SEND_MESSAGE_START"] = "SEND_MESSAGE_START";
    ThreadContextActionTypes["SEND_MESSAGE_SUCESS"] = "SEND_MESSAGE_SUCESS";
    ThreadContextActionTypes["SEND_MESSAGE_FAILURE"] = "SEND_MESSAGE_FAILURE";
    ThreadContextActionTypes["RESEND_MESSAGE_START"] = "RESEND_MESSAGE_START";
    ThreadContextActionTypes["ON_MESSAGE_DELETED_BY_REQ_ID"] = "ON_MESSAGE_DELETED_BY_REQ_ID";
    // event handlers - message status change
    ThreadContextActionTypes["ON_MESSAGE_RECEIVED"] = "ON_MESSAGE_RECEIVED";
    ThreadContextActionTypes["ON_MESSAGE_UPDATED"] = "ON_MESSAGE_UPDATED";
    ThreadContextActionTypes["ON_MESSAGE_DELETED"] = "ON_MESSAGE_DELETED";
    ThreadContextActionTypes["ON_REACTION_UPDATED"] = "ON_REACTION_UPDATED";
    ThreadContextActionTypes["ON_FILE_INFO_UPLOADED"] = "ON_FILE_INFO_UPLOADED";
    // event handlers - user status change
    ThreadContextActionTypes["ON_USER_MUTED"] = "ON_USER_MUTED";
    ThreadContextActionTypes["ON_USER_UNMUTED"] = "ON_USER_UNMUTED";
    ThreadContextActionTypes["ON_USER_BANNED"] = "ON_USER_BANNED";
    ThreadContextActionTypes["ON_USER_UNBANNED"] = "ON_USER_UNBANNED";
    ThreadContextActionTypes["ON_USER_LEFT"] = "ON_USER_LEFT";
    // event handler - channel status change
    ThreadContextActionTypes["ON_CHANNEL_FROZEN"] = "ON_CHANNEL_FROZEN";
    ThreadContextActionTypes["ON_CHANNEL_UNFROZEN"] = "ON_CHANNEL_UNFROZEN";
    ThreadContextActionTypes["ON_OPERATOR_UPDATED"] = "ON_OPERATOR_UPDATED";
    // event handler - typing status change
    ThreadContextActionTypes["ON_TYPING_STATUS_UPDATED"] = "ON_TYPING_STATUS_UPDATED";
})(ThreadContextActionTypes || (ThreadContextActionTypes = {}));

function reducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    switch (action.type) {
        // initialize
        case ThreadContextActionTypes.INIT_USER_ID: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { currentUserId: action.payload });
        }
        case ThreadContextActionTypes.GET_CHANNEL_START: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { channelState: types/* ChannelStateTypes.LOADING */.cM.LOADING, currentChannel: null });
        }
        case ThreadContextActionTypes.GET_CHANNEL_SUCCESS: {
            var groupChannel = action.payload.groupChannel;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { channelState: types/* ChannelStateTypes.INITIALIZED */.cM.INITIALIZED, currentChannel: groupChannel, 
                // only support in normal group channel
                isMuted: ((_b = (_a = groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.members) === null || _a === void 0 ? void 0 : _a.find(function (member) { return (member === null || member === void 0 ? void 0 : member.userId) === state.currentUserId; })) === null || _b === void 0 ? void 0 : _b.isMuted) || false, isChannelFrozen: (groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.isFrozen) || false });
        }
        case ThreadContextActionTypes.GET_CHANNEL_FAILURE: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { channelState: types/* ChannelStateTypes.INVALID */.cM.INVALID, currentChannel: null });
        }
        case ThreadContextActionTypes.SET_EMOJI_CONTAINER: {
            var emojiContainer = action.payload.emojiContainer;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { emojiContainer: emojiContainer });
        }
        case ThreadContextActionTypes.GET_PARENT_MESSAGE_START: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessageState: types/* ParentMessageStateTypes.LOADING */.KD.LOADING, parentMessage: null });
        }
        case ThreadContextActionTypes.GET_PARENT_MESSAGE_SUCCESS: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessageState: types/* ParentMessageStateTypes.INITIALIZED */.KD.INITIALIZED, parentMessage: action.payload.parentMessage });
        }
        case ThreadContextActionTypes.GET_PARENT_MESSAGE_FAILURE: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessageState: types/* ParentMessageStateTypes.INVALID */.KD.INVALID, parentMessage: null });
        }
        // fetch threads
        case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_START: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { threadListState: types/* ThreadListStateTypes.LOADING */.RZ.LOADING, allThreadMessages: [] });
        }
        case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_SUCCESS: {
            var _z = action.payload, parentMessage = _z.parentMessage, anchorMessage = _z.anchorMessage, threadedMessages = _z.threadedMessages;
            var anchorMessageCreatedAt_1 = (!(anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.messageId)) ? parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.createdAt : anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.createdAt;
            var anchorIndex = threadedMessages.findIndex(function (message) { return (message === null || message === void 0 ? void 0 : message.createdAt) > anchorMessageCreatedAt_1; });
            var prevThreadMessages = anchorIndex > -1 ? threadedMessages.slice(0, anchorIndex) : threadedMessages;
            var anchorThreadMessage = (anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.messageId) ? [anchorMessage] : [];
            var nextThreadMessages = anchorIndex > -1 ? threadedMessages.slice(anchorIndex) : [];
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { threadListState: types/* ThreadListStateTypes.INITIALIZED */.RZ.INITIALIZED, hasMorePrev: anchorIndex === -1 || anchorIndex === PREV_THREADS_FETCH_SIZE, hasMoreNext: threadedMessages.length - anchorIndex === NEXT_THREADS_FETCH_SIZE, allThreadMessages: [prevThreadMessages, anchorThreadMessage, nextThreadMessages].flat() });
        }
        case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_FAILURE: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { threadListState: types/* ThreadListStateTypes.INVALID */.RZ.INVALID, allThreadMessages: [] });
        }
        case ThreadContextActionTypes.GET_NEXT_MESSAGES_START: {
            return (0,bundle_XQWyv823._)({}, state);
        }
        case ThreadContextActionTypes.GET_NEXT_MESSAGES_SUCESS: {
            var threadedMessages = action.payload.threadedMessages;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { hasMoreNext: threadedMessages.length === NEXT_THREADS_FETCH_SIZE, allThreadMessages: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], state.allThreadMessages, true), threadedMessages, true) });
        }
        case ThreadContextActionTypes.GET_NEXT_MESSAGES_FAILURE: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { hasMoreNext: false });
        }
        case ThreadContextActionTypes.GET_PREV_MESSAGES_START: {
            return (0,bundle_XQWyv823._)({}, state);
        }
        case ThreadContextActionTypes.GET_PREV_MESSAGES_SUCESS: {
            var threadedMessages = action.payload.threadedMessages;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { hasMorePrev: threadedMessages.length === PREV_THREADS_FETCH_SIZE, allThreadMessages: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], threadedMessages, true), state.allThreadMessages, true) });
        }
        case ThreadContextActionTypes.GET_PREV_MESSAGES_FAILURE: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { hasMorePrev: false });
        }
        // event handlers - message status change
        case ThreadContextActionTypes.ON_MESSAGE_RECEIVED: {
            var _0 = action.payload, channel = _0.channel, message_1 = _0.message;
            if (((_c = state.currentChannel) === null || _c === void 0 ? void 0 : _c.url) !== (channel === null || channel === void 0 ? void 0 : channel.url)
                || state.hasMoreNext
                || ((_d = message_1 === null || message_1 === void 0 ? void 0 : message_1.parentMessage) === null || _d === void 0 ? void 0 : _d.messageId) !== ((_e = state === null || state === void 0 ? void 0 : state.parentMessage) === null || _e === void 0 ? void 0 : _e.messageId)) {
                return state;
            }
            var isAlreadyReceived = state.allThreadMessages.findIndex(function (m) { return (m.messageId === message_1.messageId); }) > -1;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessage: ((_f = state.parentMessage) === null || _f === void 0 ? void 0 : _f.messageId) === (message_1 === null || message_1 === void 0 ? void 0 : message_1.messageId) ? message_1 : state.parentMessage, allThreadMessages: isAlreadyReceived
                    ? state.allThreadMessages.map(function (m) { return (m.messageId === message_1.messageId ? message_1 : m); })
                    : (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], state.allThreadMessages.filter(function (m) { return (m === null || m === void 0 ? void 0 : m.reqId) !== (message_1 === null || message_1 === void 0 ? void 0 : message_1.reqId); }), true), [
                        message_1,
                    ], false) });
        }
        case ThreadContextActionTypes.ON_MESSAGE_UPDATED: {
            var _1 = action.payload, channel = _1.channel, message_2 = _1.message;
            if (((_g = state.currentChannel) === null || _g === void 0 ? void 0 : _g.url) !== (channel === null || channel === void 0 ? void 0 : channel.url)) {
                return state;
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessage: ((_h = state.parentMessage) === null || _h === void 0 ? void 0 : _h.messageId) === (message_2 === null || message_2 === void 0 ? void 0 : message_2.messageId)
                    ? message_2
                    : state.parentMessage, allThreadMessages: (_j = state.allThreadMessages) === null || _j === void 0 ? void 0 : _j.map(function (msg) { return (((msg === null || msg === void 0 ? void 0 : msg.messageId) === (message_2 === null || message_2 === void 0 ? void 0 : message_2.messageId)) ? message_2 : msg); }) });
        }
        case ThreadContextActionTypes.ON_MESSAGE_DELETED: {
            var _2 = action.payload, channel = _2.channel, messageId_1 = _2.messageId;
            if (((_k = state.currentChannel) === null || _k === void 0 ? void 0 : _k.url) !== (channel === null || channel === void 0 ? void 0 : channel.url)) {
                return state;
            }
            if (((_l = state === null || state === void 0 ? void 0 : state.parentMessage) === null || _l === void 0 ? void 0 : _l.messageId) === messageId_1) {
                return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { parentMessage: null, parentMessageState: types/* ParentMessageStateTypes.NIL */.KD.NIL, allThreadMessages: [] });
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { allThreadMessages: (_m = state.allThreadMessages) === null || _m === void 0 ? void 0 : _m.filter(function (msg) { return ((msg === null || msg === void 0 ? void 0 : msg.messageId) !== messageId_1); }), localThreadMessages: (_o = state.localThreadMessages) === null || _o === void 0 ? void 0 : _o.filter(function (msg) { return ((msg === null || msg === void 0 ? void 0 : msg.messageId) !== messageId_1); }) });
        }
        case ThreadContextActionTypes.ON_MESSAGE_DELETED_BY_REQ_ID: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { localThreadMessages: state.localThreadMessages.filter(function (m) { return (!(0,bundle_CDvkkTNs.c)(m.reqId, action.payload)); }) });
        }
        case ThreadContextActionTypes.ON_REACTION_UPDATED: {
            var reactionEvent_1 = (_p = action.payload) === null || _p === void 0 ? void 0 : _p.reactionEvent;
            if (((_q = state === null || state === void 0 ? void 0 : state.parentMessage) === null || _q === void 0 ? void 0 : _q.messageId) === (reactionEvent_1 === null || reactionEvent_1 === void 0 ? void 0 : reactionEvent_1.messageId)) {
                (_s = (_r = state.parentMessage) === null || _r === void 0 ? void 0 : _r.applyReactionEvent) === null || _s === void 0 ? void 0 : _s.call(_r, reactionEvent_1);
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { allThreadMessages: state.allThreadMessages.map(function (m) {
                    var _a;
                    if ((reactionEvent_1 === null || reactionEvent_1 === void 0 ? void 0 : reactionEvent_1.messageId) === (m === null || m === void 0 ? void 0 : m.messageId)) {
                        (_a = m === null || m === void 0 ? void 0 : m.applyReactionEvent) === null || _a === void 0 ? void 0 : _a.call(m, reactionEvent_1);
                        return m;
                    }
                    return m;
                }) });
        }
        // event handlers - user status change
        case ThreadContextActionTypes.ON_USER_MUTED: {
            var _3 = action.payload, channel = _3.channel, user = _3.user;
            if (((_t = state.currentChannel) === null || _t === void 0 ? void 0 : _t.url) !== (channel === null || channel === void 0 ? void 0 : channel.url) || state.currentUserId !== (user === null || user === void 0 ? void 0 : user.userId)) {
                return state;
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { isMuted: true });
        }
        case ThreadContextActionTypes.ON_USER_UNMUTED: {
            var _4 = action.payload, channel = _4.channel, user = _4.user;
            if (((_u = state.currentChannel) === null || _u === void 0 ? void 0 : _u.url) !== (channel === null || channel === void 0 ? void 0 : channel.url) || state.currentUserId !== (user === null || user === void 0 ? void 0 : user.userId)) {
                return state;
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { isMuted: false });
        }
        case ThreadContextActionTypes.ON_USER_BANNED: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { channelState: types/* ChannelStateTypes.NIL */.cM.NIL, threadListState: types/* ThreadListStateTypes.NIL */.RZ.NIL, parentMessageState: types/* ParentMessageStateTypes.NIL */.KD.NIL, currentChannel: null, parentMessage: null, allThreadMessages: [], hasMorePrev: false, hasMoreNext: false });
        }
        case ThreadContextActionTypes.ON_USER_UNBANNED: {
            return (0,bundle_XQWyv823._)({}, state);
        }
        case ThreadContextActionTypes.ON_USER_LEFT: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { channelState: types/* ChannelStateTypes.NIL */.cM.NIL, threadListState: types/* ThreadListStateTypes.NIL */.RZ.NIL, parentMessageState: types/* ParentMessageStateTypes.NIL */.KD.NIL, currentChannel: null, parentMessage: null, allThreadMessages: [], hasMorePrev: false, hasMoreNext: false });
        }
        // event handler - channel status change
        case ThreadContextActionTypes.ON_CHANNEL_FROZEN: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { isChannelFrozen: true });
        }
        case ThreadContextActionTypes.ON_CHANNEL_UNFROZEN: {
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { isChannelFrozen: false });
        }
        case ThreadContextActionTypes.ON_OPERATOR_UPDATED: {
            var channel = action.payload.channel;
            if ((channel === null || channel === void 0 ? void 0 : channel.url) === ((_v = state.currentChannel) === null || _v === void 0 ? void 0 : _v.url)) {
                return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { currentChannel: channel });
            }
            return state;
        }
        // message
        case ThreadContextActionTypes.SEND_MESSAGE_START: {
            var message = action.payload.message;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { localThreadMessages: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], state.localThreadMessages, true), [
                    message,
                ], false) });
        }
        case ThreadContextActionTypes.SEND_MESSAGE_SUCESS: {
            var message_3 = action.payload.message;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { allThreadMessages: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], state.allThreadMessages.filter(function (m) { return (!(0,bundle_CDvkkTNs.c)(m === null || m === void 0 ? void 0 : m.reqId, message_3 === null || message_3 === void 0 ? void 0 : message_3.reqId)); }), true), [
                    message_3,
                ], false), localThreadMessages: state.localThreadMessages.filter(function (m) { return (!(0,bundle_CDvkkTNs.c)(m === null || m === void 0 ? void 0 : m.reqId, message_3 === null || message_3 === void 0 ? void 0 : message_3.reqId)); }) });
        }
        case ThreadContextActionTypes.SEND_MESSAGE_FAILURE: {
            var message_4 = action.payload.message;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { localThreadMessages: state.localThreadMessages.map(function (m) { return ((0,bundle_CDvkkTNs.c)(m === null || m === void 0 ? void 0 : m.reqId, message_4 === null || message_4 === void 0 ? void 0 : message_4.reqId)
                    ? message_4
                    : m); }) });
        }
        case ThreadContextActionTypes.RESEND_MESSAGE_START: {
            var message_5 = action.payload.message;
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { localThreadMessages: state.localThreadMessages.map(function (m) { return ((0,bundle_CDvkkTNs.c)(m === null || m === void 0 ? void 0 : m.reqId, message_5 === null || message_5 === void 0 ? void 0 : message_5.reqId)
                    ? message_5
                    : m); }) });
        }
        case ThreadContextActionTypes.ON_FILE_INFO_UPLOADED: {
            var _5 = action.payload, channelUrl = _5.channelUrl, requestId_1 = _5.requestId, index = _5.index, uploadableFileInfo = _5.uploadableFileInfo, error = _5.error;
            if (!(0,bundle_CDvkkTNs.c)(channelUrl, (_w = state.currentChannel) === null || _w === void 0 ? void 0 : _w.url)) {
                return state;
            }
            /**
             * We don't have to do anything here because
             * onFailed() will be called so handle error there instead.
             */
            if (error)
                return state;
            var localThreadMessages = state.localThreadMessages;
            var messageToUpdate = localThreadMessages.find(function (message) { return (0,bundle_CDvkkTNs.c)(hasReqId(message) && message.reqId, requestId_1); });
            var fileInfoList = (_x = messageToUpdate
                .messageParams) === null || _x === void 0 ? void 0 : _x.fileInfoList;
            if (Array.isArray(fileInfoList)) {
                fileInfoList[index] = uploadableFileInfo;
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { localThreadMessages: localThreadMessages });
        }
        case ThreadContextActionTypes.ON_TYPING_STATUS_UPDATED: {
            var _6 = action.payload, channel = _6.channel, typingMembers = _6.typingMembers;
            if (!(0,bundle_CDvkkTNs.c)(channel.url, (_y = state.currentChannel) === null || _y === void 0 ? void 0 : _y.url)) {
                return state;
            }
            return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { typingMembers: typingMembers });
        }
        default: {
            return state;
        }
    }
}
function hasReqId(message) {
    return 'reqId' in message;
}

var initialState = {
    currentChannel: null,
    allThreadMessages: [],
    localThreadMessages: [],
    parentMessage: null,
    channelState: types/* ChannelStateTypes.NIL */.cM.NIL,
    parentMessageState: types/* ParentMessageStateTypes.NIL */.KD.NIL,
    threadListState: types/* ThreadListStateTypes.NIL */.RZ.NIL,
    hasMorePrev: false,
    hasMoreNext: false,
    emojiContainer: {},
    isMuted: false,
    isChannelFrozen: false,
    currentUserId: '',
    typingMembers: [],
};

function useGetChannel(_a, _b) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit, message = _a.message;
    var sdk = _b.sdk, logger = _b.logger, threadDispatcher = _b.threadDispatcher;
    (0,react.useEffect)(function () {
        var _a, _b;
        // validation check
        if (sdkInit && channelUrl && (sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel)) {
            threadDispatcher({
                type: ThreadContextActionTypes.GET_CHANNEL_START,
                payload: null,
            });
            (_b = (_a = sdk.groupChannel).getChannel) === null || _b === void 0 ? void 0 : _b.call(_a, channelUrl).then(function (groupChannel) {
                logger.info('Thread | useInitialize: Get channel succeeded', groupChannel);
                threadDispatcher({
                    type: ThreadContextActionTypes.GET_CHANNEL_SUCCESS,
                    payload: { groupChannel: groupChannel },
                });
            }).catch(function (error) {
                logger.info('Thread | useInitialize: Get channel failed', error);
                threadDispatcher({
                    type: ThreadContextActionTypes.GET_CHANNEL_FAILURE,
                    payload: error,
                });
            });
        }
    }, [message, sdkInit]);
    /**
     * We don't use channelUrl here,
     * because Thread must operate independently of the channel.
     */
}

function useGetAllEmoji(_a, _b) {
    var sdk = _a.sdk;
    var logger = _b.logger, threadDispatcher = _b.threadDispatcher;
    (0,react.useEffect)(function () {
        if (sdk === null || sdk === void 0 ? void 0 : sdk.getAllEmoji) { // validation check
            sdk === null || sdk === void 0 ? void 0 : sdk.getAllEmoji().then(function (emojiContainer) {
                logger.info('Thread | useGetAllEmoji: Getting emojis succeeded.', emojiContainer);
                threadDispatcher({
                    type: ThreadContextActionTypes.SET_EMOJI_CONTAINER,
                    payload: { emojiContainer: emojiContainer },
                });
            }).catch(function (error) {
                logger.info('Thread | useGetAllEmoji: Getting emojis failed.', error);
            });
        }
    }, [sdk]);
}

function useGetParentMessage(_a, _b) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit, parentMessage = _a.parentMessage;
    var sdk = _b.sdk, logger = _b.logger, threadDispatcher = _b.threadDispatcher;
    (0,react.useEffect)(function () {
        var _a, _b, _c;
        // validation check
        if (sdkInit && ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.message) === null || _a === void 0 ? void 0 : _a.getMessage) && parentMessage) {
            threadDispatcher({
                type: ThreadContextActionTypes.GET_PARENT_MESSAGE_START,
                payload: null,
            });
            var params = {
                channelUrl: channelUrl,
                channelType: _bundle_1db3fd0b.C.GROUP,
                messageId: parentMessage.messageId,
                includeMetaArray: true,
                includeReactions: true,
                includeThreadInfo: true,
                includeParentMessageInfo: true,
            };
            logger.info('Thread | useGetParentMessage: Get parent message start.', params);
            (_c = (_b = sdk.message).getMessage) === null || _c === void 0 ? void 0 : _c.call(_b, params).then(function (parentMsg) {
                logger.info('Thread | useGetParentMessage: Get parent message succeeded.', parentMessage);
                // @ts-ignore
                parentMsg.ogMetaData = (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.ogMetaData) || null; // ogMetaData is not included for now
                threadDispatcher({
                    type: ThreadContextActionTypes.GET_PARENT_MESSAGE_SUCCESS,
                    payload: { parentMessage: parentMsg },
                });
            }).catch(function (error) {
                logger.info('Thread | useGetParentMessage: Get parent message failed.', error);
                threadDispatcher({
                    type: ThreadContextActionTypes.GET_PARENT_MESSAGE_FAILURE,
                    payload: error,
                });
            });
        }
    }, [sdkInit, parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId]);
    /**
     * We don't use channelUrl here,
     * because Thread must operate independently of the channel.
     */
}

function useHandleThreadPubsubEvents(_a, _b) {
    var sdkInit = _a.sdkInit, currentChannel = _a.currentChannel, parentMessage = _a.parentMessage;
    var pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    (0,react.useEffect)(function () {
        var subscriber = new Map();
        if (pubSub === null || pubSub === void 0 ? void 0 : pubSub.subscribe) {
            // TODO: subscribe ON_FILE_INFO_UPLOADED
            subscriber.set(bundle_DRlnZqdp.p.SEND_MESSAGE_START, pubSub.subscribe(bundle_DRlnZqdp.p.SEND_MESSAGE_START, function (props) {
                var _a, _b;
                var channel = props.channel, message = props.message, publishingModules = props.publishingModules;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url) && (message === null || message === void 0 ? void 0 : message.parentMessageId) === (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId) && (0,bundle_DRlnZqdp.a)(publishingModules)) {
                    // TODO: const clonedMessage = cloneMessage(message);
                    var pendingMessage = (0,bundle_XQWyv823._)({}, message);
                    if (message.isMultipleFilesMessage()) {
                        pendingMessage.fileInfoList = (_b = (_a = message === null || message === void 0 ? void 0 : message.messageParams) === null || _a === void 0 ? void 0 : _a.fileInfoList.map(function (fileInfo) { return ((0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, fileInfo), { url: URL.createObjectURL(fileInfo.file) })); })) !== null && _b !== void 0 ? _b : [];
                    }
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_START,
                        payload: {
                            message: pendingMessage,
                        },
                    });
                }
                bundle_CDvkkTNs.s === null || bundle_CDvkkTNs.s === void 0 ? void 0 : (0,bundle_CDvkkTNs.s)();
            }));
            subscriber.set(bundle_DRlnZqdp.b.ON_FILE_INFO_UPLOADED, pubSub.subscribe(bundle_DRlnZqdp.b.ON_FILE_INFO_UPLOADED, function (props) {
                var response = props.response, publishingModules = props.publishingModules;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === response.channelUrl && (0,bundle_DRlnZqdp.a)(publishingModules)) {
                    threadDispatcher({
                        type: bundle_DKR_710v.s,
                        payload: response,
                    });
                }
            }));
            subscriber.set(bundle_DRlnZqdp.p.SEND_USER_MESSAGE, pubSub.subscribe(bundle_DRlnZqdp.p.SEND_USER_MESSAGE, function (props) {
                var _a = props, channel = _a.channel, message = _a.message;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)
                    && (message === null || message === void 0 ? void 0 : message.parentMessageId) === (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId)) {
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
                        payload: { message: message },
                    });
                }
                bundle_CDvkkTNs.s === null || bundle_CDvkkTNs.s === void 0 ? void 0 : (0,bundle_CDvkkTNs.s)();
            }));
            subscriber.set(bundle_DRlnZqdp.p.SEND_MESSAGE_FAILED, pubSub.subscribe(bundle_DRlnZqdp.p.SEND_MESSAGE_FAILED, function (props) {
                var channel = props.channel, message = props.message, publishingModules = props.publishingModules;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url) && (message === null || message === void 0 ? void 0 : message.parentMessageId) === (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId) && (0,bundle_DRlnZqdp.a)(publishingModules)) {
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                        payload: { message: message },
                    });
                }
            }));
            subscriber.set(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, pubSub.subscribe(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, function (props) {
                var channel = props.channel, message = props.message, publishingModules = props.publishingModules;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url) && (0,bundle_DRlnZqdp.a)(publishingModules)) {
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
                        payload: { message: message },
                    });
                }
                bundle_CDvkkTNs.s === null || bundle_CDvkkTNs.s === void 0 ? void 0 : (0,bundle_CDvkkTNs.s)();
            }));
            subscriber.set(bundle_DRlnZqdp.p.UPDATE_USER_MESSAGE, pubSub.subscribe(bundle_DRlnZqdp.p.UPDATE_USER_MESSAGE, function (props) {
                var _a = props, channel = _a.channel, message = _a.message;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
                        payload: { channel: channel, message: message },
                    });
                }
            }));
            subscriber.set(bundle_DRlnZqdp.p.DELETE_MESSAGE, pubSub.subscribe(bundle_DRlnZqdp.p.DELETE_MESSAGE, function (props) {
                var _a = props, channel = _a.channel, messageId = _a.messageId;
                if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
                        payload: { messageId: messageId },
                    });
                }
            }));
        }
        return function () {
            subscriber === null || subscriber === void 0 ? void 0 : subscriber.forEach(function (s) {
                try {
                    s === null || s === void 0 ? void 0 : s.remove();
                }
                catch (_a) {
                    //
                }
            });
        };
    }, [sdkInit, currentChannel, parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId]);
}

function useHandleChannelEvents(_a, _b) {
    var sdk = _a.sdk, currentChannel = _a.currentChannel;
    var logger = _b.logger, threadDispatcher = _b.threadDispatcher;
    (0,react.useEffect)(function () {
        var _a, _b, _c;
        var handlerId = (0,bundle_Bq93DTET.u)();
        // validation check
        if (((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler)
            && currentChannel) {
            var channelHandlerParams = {
                // message status change
                onMessageReceived: function (channel, message) {
                    logger.info('Thread | useHandleChannelEvents: onMessageReceived', { channel: channel, message: message });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_MESSAGE_RECEIVED,
                        payload: { channel: channel, message: message },
                    });
                },
                onMessageUpdated: function (channel, message) {
                    logger.info('Thread | useHandleChannelEvents: onMessageUpdated', { channel: channel, message: message });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
                        payload: { channel: channel, message: message },
                    });
                },
                onMessageDeleted: function (channel, messageId) {
                    logger.info('Thread | useHandleChannelEvents: onMessageDeleted', { channel: channel, messageId: messageId });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
                        payload: { channel: channel, messageId: messageId },
                    });
                },
                onReactionUpdated: function (channel, reactionEvent) {
                    logger.info('Thread | useHandleChannelEvents: onReactionUpdated', { channel: channel, reactionEvent: reactionEvent });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_REACTION_UPDATED,
                        payload: { channel: channel, reactionEvent: reactionEvent },
                    });
                },
                // user status change
                onUserMuted: function (channel, user) {
                    logger.info('Thread | useHandleChannelEvents: onUserMuted', { channel: channel, user: user });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_USER_MUTED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserUnmuted: function (channel, user) {
                    logger.info('Thread | useHandleChannelEvents: onUserUnmuted', { channel: channel, user: user });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_USER_UNMUTED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserBanned: function (channel, user) {
                    logger.info('Thread | useHandleChannelEvents: onUserBanned', { channel: channel, user: user });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_USER_BANNED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserUnbanned: function (channel, user) {
                    logger.info('Thread | useHandleChannelEvents: onUserUnbanned', { channel: channel, user: user });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_USER_UNBANNED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserLeft: function (channel, user) {
                    logger.info('Thread | useHandleChannelEvents: onUserLeft', { channel: channel, user: user });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_USER_LEFT,
                        payload: { channel: channel, user: user },
                    });
                },
                // channel status change
                onChannelFrozen: function (channel) {
                    logger.info('Thread | useHandleChannelEvents: onChannelFrozen', { channel: channel });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_CHANNEL_FROZEN,
                        payload: { channel: channel },
                    });
                },
                onChannelUnfrozen: function (channel) {
                    logger.info('Thread | useHandleChannelEvents: onChannelUnfrozen', { channel: channel });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_CHANNEL_UNFROZEN,
                        payload: { channel: channel },
                    });
                },
                onOperatorUpdated: function (channel, users) {
                    logger.info('Thread | useHandleChannelEvents: onOperatorUpdated', { channel: channel, users: users });
                    threadDispatcher({
                        type: ThreadContextActionTypes.ON_OPERATOR_UPDATED,
                        payload: { channel: channel, users: users },
                    });
                },
                onTypingStatusUpdated: function (channel) {
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, currentChannel.url)) {
                        logger.info('Channel | onTypingStatusUpdated', { channel: channel });
                        var typingMembers = channel.getTypingUsers();
                        threadDispatcher({
                            type: bundle_DKR_710v.t,
                            payload: {
                                channel: channel,
                                typingMembers: typingMembers,
                            },
                        });
                    }
                },
            };
            var channelHandler = new groupChannel/* GroupChannelHandler */.pe(channelHandlerParams);
            (_c = (_b = sdk.groupChannel).addGroupChannelHandler) === null || _c === void 0 ? void 0 : _c.call(_b, handlerId, channelHandler);
            logger.info('Thread | useHandleChannelEvents: Added channelHandler in Thread', { handlerId: handlerId, channelHandler: channelHandler });
        }
        return function () {
            var _a, _b, _c;
            // validation check
            if (handlerId && ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler)) {
                (_c = (_b = sdk.groupChannel).removeGroupChannelHandler) === null || _c === void 0 ? void 0 : _c.call(_b, handlerId);
                logger.info('Thread | useHandleChannelEvents: Removed channelHandler in Thread.', handlerId);
            }
        };
    }, [
        sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel,
        currentChannel,
    ]);
}

function useSendFileMessageCallback(_a, _b) {
    var currentChannel = _a.currentChannel, onBeforeSendFileMessage = _a.onBeforeSendFileMessage;
    var logger = _b.logger, pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    return (0,react.useCallback)(function (file, quoteMessage) {
        return new Promise(function (resolve, reject) {
            var _a;
            var createParamsDefault = function () {
                var params = {};
                params.file = file;
                if (quoteMessage) {
                    params.isReplyToChannel = true;
                    params.parentMessageId = quoteMessage.messageId;
                }
                return params;
            };
            var params = (_a = onBeforeSendFileMessage === null || onBeforeSendFileMessage === void 0 ? void 0 : onBeforeSendFileMessage(file, quoteMessage)) !== null && _a !== void 0 ? _a : createParamsDefault();
            logger.info('Thread | useSendFileMessageCallback: Sending file message start.', params);
            currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendFileMessage(params).onPending(function (pendingMessage) {
                threadDispatcher({
                    type: ThreadContextActionTypes.SEND_MESSAGE_START,
                    payload: {
                        /* pubSub is used instead of messagesDispatcher
                          to avoid redundantly calling `messageActionTypes.SEND_MESSAGE_START` */
                        // TODO: remove data pollution
                        message: (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, pendingMessage), { url: URL.createObjectURL(file), 
                            // pending thumbnail message seems to be failed
                            requestState: 'pending', isUserMessage: pendingMessage.isUserMessage, isFileMessage: pendingMessage.isFileMessage, isAdminMessage: pendingMessage.isAdminMessage, isMultipleFilesMessage: pendingMessage.isMultipleFilesMessage }),
                    },
                });
                setTimeout(function () { return (0,bundle_CDvkkTNs.s)(); }, bundle_DABR6HKW.e);
            }).onFailed(function (error, message) {
                message.localUrl = URL.createObjectURL(file);
                message.file = file;
                logger.info('Thread | useSendFileMessageCallback: Sending file message failed.', { message: message, error: error });
                threadDispatcher({
                    type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                    payload: { message: message, error: error },
                });
                reject(error);
            }).onSucceeded(function (message) {
                logger.info('Thread | useSendFileMessageCallback: Sending file message succeeded.', message);
                pubSub.publish(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, {
                    channel: currentChannel,
                    message: message,
                    publishingModules: [bundle_DRlnZqdp.P.THREAD],
                });
                resolve(message);
            });
        });
    }, [currentChannel]);
}

function useUpdateMessageCallback(_a, _b) {
    var currentChannel = _a.currentChannel, isMentionEnabled = _a.isMentionEnabled;
    var logger = _b.logger, pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    // TODO: add type
    return (0,react.useCallback)(function (props) {
        var _a;
        var messageId = props.messageId, message = props.message, mentionedUsers = props.mentionedUsers, mentionTemplate = props.mentionTemplate;
        var createParamsDefault = function () {
            var params = {};
            params.message = message;
            if (isMentionEnabled && mentionedUsers && (mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length) > 0) {
                params.mentionedUsers = mentionedUsers;
            }
            if (isMentionEnabled && mentionTemplate) {
                params.mentionedMessageTemplate = mentionTemplate;
            }
            else {
                params.mentionedMessageTemplate = message;
            }
            return params;
        };
        var params = createParamsDefault();
        logger.info('Thread | useUpdateMessageCallback: Message update start.', params);
        (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.updateUserMessage) === null || _a === void 0 ? void 0 : _a.call(currentChannel, messageId, params).then(function (message) {
            logger.info('Thread | useUpdateMessageCallback: Message update succeeded.', message);
            threadDispatcher({
                type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
                payload: {
                    channel: currentChannel,
                    message: message,
                },
            });
            pubSub.publish(bundle_DRlnZqdp.p.UPDATE_USER_MESSAGE, {
                fromSelector: true,
                channel: currentChannel,
                message: message,
                publishingModules: [bundle_DRlnZqdp.P.THREAD],
            });
        });
    }, [currentChannel, isMentionEnabled]);
}

function useDeleteMessageCallback(_a, _b) {
    var currentChannel = _a.currentChannel, threadDispatcher = _a.threadDispatcher;
    var logger = _b.logger;
    return (0,react.useCallback)(function (message) {
        logger.info('Thread | useDeleteMessageCallback: Deleting message.', message);
        var sendingStatus = message.sendingStatus;
        return new Promise(function (resolve, reject) {
            var _a;
            logger.info('Thread | useDeleteMessageCallback: Deleting message requestState:', sendingStatus);
            // Message is only on local
            if (sendingStatus === 'failed' || sendingStatus === 'pending') {
                logger.info('Thread | useDeleteMessageCallback: Deleted message from local:', message);
                threadDispatcher({
                    type: ThreadContextActionTypes.ON_MESSAGE_DELETED_BY_REQ_ID,
                    payload: message.reqId,
                });
                resolve();
            }
            logger.info('Thread | useDeleteMessageCallback: Deleting message from remote:', sendingStatus);
            (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.deleteMessage) === null || _a === void 0 ? void 0 : _a.call(currentChannel, message).then(function () {
                logger.info('Thread | useDeleteMessageCallback: Deleting message success!', message);
                threadDispatcher({
                    type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
                    payload: { message: message, channel: currentChannel },
                });
                resolve();
            }).catch(function (err) {
                logger.warning('Thread | useDeleteMessageCallback: Deleting message failed!', err);
                reject(err);
            });
        });
    }, [currentChannel]);
}

function useToggleReactionCallback(_a, _b) {
    var currentChannel = _a.currentChannel;
    var logger = _b.logger;
    return (0,react.useCallback)(function (message, key, isReacted) {
        var _a, _b;
        if (isReacted) {
            (_a = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.deleteReaction) === null || _a === void 0 ? void 0 : _a.call(currentChannel, message, key).then(function (res) {
                logger.info('Thread | useToggleReactionsCallback: Delete reaction succeeded.', res);
            }).catch(function (err) {
                logger.warning('Thread | useToggleReactionsCallback: Delete reaction failed.', err);
            });
            return;
        }
        (_b = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.addReaction) === null || _b === void 0 ? void 0 : _b.call(currentChannel, message, key).then(function (res) {
            logger.info('Thread | useToggleReactionsCallback: Add reaction succeeded.', res);
        }).catch(function (err) {
            logger.warning('Thread | useToggleReactionsCallback: Add reaction failed.', err);
        });
    }, [currentChannel]);
}

function useSendUserMessageCallback(_a, _b) {
    var isMentionEnabled = _a.isMentionEnabled, currentChannel = _a.currentChannel, onBeforeSendUserMessage = _a.onBeforeSendUserMessage;
    var logger = _b.logger, pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    var sendMessage = (0,react.useCallback)(function (props) {
        var _a;
        var message = props.message, quoteMessage = props.quoteMessage, mentionTemplate = props.mentionTemplate, mentionedUsers = props.mentionedUsers;
        var createDefaultParams = function () {
            var params = {};
            params.message = message;
            var mentionedUsersLength = (mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length) || 0;
            if (isMentionEnabled && mentionedUsersLength) {
                params.mentionedUsers = mentionedUsers;
            }
            if (isMentionEnabled && mentionTemplate && mentionedUsersLength) {
                params.mentionedMessageTemplate = mentionTemplate;
            }
            if (quoteMessage) {
                params.isReplyToChannel = true;
                params.parentMessageId = quoteMessage.messageId;
            }
            return params;
        };
        var params = (_a = onBeforeSendUserMessage === null || onBeforeSendUserMessage === void 0 ? void 0 : onBeforeSendUserMessage(message, quoteMessage)) !== null && _a !== void 0 ? _a : createDefaultParams();
        logger.info('Thread | useSendUserMessageCallback: Sending user message start.', params);
        if (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendUserMessage) {
            currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendUserMessage(params).onPending(function (pendingMessage) {
                threadDispatcher({
                    type: ThreadContextActionTypes.SEND_MESSAGE_START,
                    payload: { message: pendingMessage },
                });
            }).onFailed(function (error, message) {
                logger.info('Thread | useSendUserMessageCallback: Sending user message failed.', { message: message, error: error });
                threadDispatcher({
                    type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                    payload: { error: error, message: message },
                });
            }).onSucceeded(function (message) {
                logger.info('Thread | useSendUserMessageCallback: Sending user message succeeded.', message);
                // because Thread doesn't subscribe SEND_USER_MESSAGE
                pubSub.publish(bundle_DRlnZqdp.p.SEND_USER_MESSAGE, {
                    channel: currentChannel,
                    message: message,
                    publishingModules: [bundle_DRlnZqdp.P.THREAD],
                });
            });
        }
    }, [isMentionEnabled, currentChannel]);
    return sendMessage;
}

function useResendMessageCallback(_a, _b) {
    var currentChannel = _a.currentChannel;
    var logger = _b.logger, pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    return (0,react.useCallback)(function (failedMessage) {
        var _a, _b, _c, _d, _e;
        if (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isResendable) {
            logger.info('Thread | useResendMessageCallback: Resending failedMessage start.', failedMessage);
            if (((_a = failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isUserMessage) === null || _a === void 0 ? void 0 : _a.call(failedMessage)) || (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.messageType) === _bundle_1db3fd0b.ah.USER) {
                try {
                    currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.resendMessage(failedMessage).onPending(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending user message started.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.RESEND_MESSAGE_START,
                            payload: { message: message },
                        });
                    }).onSucceeded(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending user message succeeded.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
                            payload: { message: message },
                        });
                        pubSub.publish(bundle_DRlnZqdp.p.SEND_USER_MESSAGE, {
                            channel: currentChannel,
                            message: message,
                            publishingModules: [bundle_DRlnZqdp.P.THREAD],
                        });
                    }).onFailed(function (error) {
                        logger.warning('Thread | useResendMessageCallback: Resending user message failed.', error);
                        failedMessage.sendingStatus = _bundle_1db3fd0b.ao.FAILED;
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                            payload: { message: failedMessage },
                        });
                    });
                }
                catch (err) {
                    logger.warning('Thread | useResendMessageCallback: Resending user message failed.', err);
                    failedMessage.sendingStatus = _bundle_1db3fd0b.ao.FAILED;
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                        payload: { message: failedMessage },
                    });
                }
            }
            else if ((_b = failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isFileMessage) === null || _b === void 0 ? void 0 : _b.call(failedMessage)) {
                try {
                    (_c = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.resendMessage) === null || _c === void 0 ? void 0 : _c.call(currentChannel, failedMessage).onPending(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending file message started.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.RESEND_MESSAGE_START,
                            payload: { message: message },
                        });
                    }).onSucceeded(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending file message succeeded.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
                            payload: { message: message },
                        });
                        pubSub.publish(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, {
                            channel: currentChannel,
                            message: failedMessage,
                            publishingModules: [bundle_DRlnZqdp.P.THREAD],
                        });
                    }).onFailed(function (error) {
                        logger.warning('Thread | useResendMessageCallback: Resending file message failed.', error);
                        failedMessage.sendingStatus = _bundle_1db3fd0b.ao.FAILED;
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                            payload: { message: failedMessage },
                        });
                    });
                }
                catch (err) {
                    logger.warning('Thread | useResendMessageCallback: Resending file message failed.', err);
                    failedMessage.sendingStatus = _bundle_1db3fd0b.ao.FAILED;
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                        payload: { message: failedMessage },
                    });
                }
            }
            else if ((_d = failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isMultipleFilesMessage) === null || _d === void 0 ? void 0 : _d.call(failedMessage)) {
                try {
                    (_e = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.resendMessage) === null || _e === void 0 ? void 0 : _e.call(currentChannel, failedMessage).onPending(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending multiple files message started.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.RESEND_MESSAGE_START,
                            payload: { message: message },
                        });
                    }).onFileUploaded(function (requestId, index, uploadableFileInfo, error) {
                        logger.info('Thread | useResendMessageCallback: onFileUploaded during resending multiple files message.', {
                            requestId: requestId,
                            index: index,
                            error: error,
                            uploadableFileInfo: uploadableFileInfo,
                        });
                        pubSub.publish(bundle_DRlnZqdp.p.ON_FILE_INFO_UPLOADED, {
                            response: {
                                channelUrl: currentChannel.url,
                                requestId: requestId,
                                index: index,
                                uploadableFileInfo: uploadableFileInfo,
                                error: error,
                            },
                            publishingModules: [bundle_DRlnZqdp.P.THREAD],
                        });
                    }).onSucceeded(function (message) {
                        logger.info('Thread | useResendMessageCallback: Resending MFM succeeded.', message);
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
                            payload: { message: message },
                        });
                        pubSub.publish(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, {
                            channel: currentChannel,
                            message: message,
                            publishingModules: [bundle_DRlnZqdp.P.THREAD],
                        });
                    }).onFailed(function (error, message) {
                        logger.warning('Thread | useResendMessageCallback: Resending MFM failed.', error);
                        threadDispatcher({
                            type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                            payload: { message: message },
                        });
                    });
                }
                catch (err) {
                    logger.warning('Thread | useResendMessageCallback: Resending MFM failed.', err);
                    threadDispatcher({
                        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                        payload: { message: failedMessage },
                    });
                }
            }
            else {
                logger.warning('Thread | useResendMessageCallback: Message is not resendable.', failedMessage);
                failedMessage.sendingStatus = _bundle_1db3fd0b.ao.FAILED;
                threadDispatcher({
                    type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                    payload: { message: failedMessage },
                });
            }
        }
    }, [currentChannel]);
}

var useSendVoiceMessageCallback = function (_a, _b) {
    var currentChannel = _a.currentChannel, onBeforeSendVoiceMessage = _a.onBeforeSendVoiceMessage;
    var logger = _b.logger, pubSub = _b.pubSub, threadDispatcher = _b.threadDispatcher;
    var sendMessage = (0,react.useCallback)(function (file, duration, quoteMessage) {
        var messageParams = (onBeforeSendVoiceMessage
            && typeof onBeforeSendVoiceMessage === 'function')
            ? onBeforeSendVoiceMessage(file, quoteMessage)
            : {
                file: file,
                fileName: bundle_DABR6HKW.f,
                mimeType: bundle_DABR6HKW.b,
                metaArrays: [
                    new _bundle_e1a5e3f1.aq({
                        key: bundle_DABR6HKW.M,
                        value: ["".concat(duration)],
                    }),
                    new _bundle_e1a5e3f1.aq({
                        key: bundle_DABR6HKW.g,
                        value: [bundle_DABR6HKW.h],
                    }),
                ],
            };
        if (quoteMessage) {
            messageParams.isReplyToChannel = true;
            messageParams.parentMessageId = quoteMessage.messageId;
        }
        logger.info('Thread | useSendVoiceMessageCallback:  Start sending voice message', messageParams);
        currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendFileMessage(messageParams).onPending(function (pendingMessage) {
            threadDispatcher({
                type: ThreadContextActionTypes.SEND_MESSAGE_START,
                payload: {
                    /* pubSub is used instead of messagesDispatcher
                    to avoid redundantly calling `messageActionTypes.SEND_MESSAGE_START` */
                    // TODO: remove data pollution
                    message: (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, pendingMessage), { url: URL.createObjectURL(file), 
                        // pending thumbnail message seems to be failed
                        requestState: 'pending', isUserMessage: pendingMessage.isUserMessage, isFileMessage: pendingMessage.isFileMessage, isAdminMessage: pendingMessage.isAdminMessage, isMultipleFilesMessage: pendingMessage.isMultipleFilesMessage }),
                },
            });
            setTimeout(function () { return (0,bundle_CDvkkTNs.s)(); }, bundle_DABR6HKW.e);
        }).onFailed(function (error, message) {
            message.localUrl = URL.createObjectURL(file);
            message.file = file;
            logger.info('Thread | useSendVoiceMessageCallback: Sending voice message failed.', { message: message, error: error });
            threadDispatcher({
                type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
                payload: { message: message, error: error },
            });
        }).onSucceeded(function (message) {
            logger.info('Thread | useSendVoiceMessageCallback: Sending voice message succeeded.', message);
            pubSub.publish(bundle_DRlnZqdp.p.SEND_FILE_MESSAGE, {
                channel: currentChannel,
                message: message,
                publishingModules: [bundle_DRlnZqdp.P.THREAD],
            });
        });
    }, [
        currentChannel,
        onBeforeSendVoiceMessage,
    ]);
    return sendMessage;
};

function getThreadMessageListParams(params) {
    return (0,bundle_XQWyv823._)({ prevResultSize: PREV_THREADS_FETCH_SIZE, nextResultSize: NEXT_THREADS_FETCH_SIZE, includeMetaArray: true }, params);
}
var useThreadFetchers = function (_a) {
    var isReactionEnabled = _a.isReactionEnabled, anchorMessage = _a.anchorMessage, staleParentMessage = _a.parentMessage, threadDispatcher = _a.threadDispatcher, logger = _a.logger, oldestMessageTimeStamp = _a.oldestMessageTimeStamp, latestMessageTimeStamp = _a.latestMessageTimeStamp, threadListState = _a.threadListState;
    var stores = (0,useSendbirdStateContext/* useSendbirdStateContext */.A)().stores;
    var timestamp = (anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.createdAt) || 0;
    var initialize = (0,react.useCallback)(function (callback) { return (0,bundle_XQWyv823.a)(void 0, void 0, void 0, function () {
        var params, _a, threadedMessages_1, parentMessage, error_1;
        return (0,bundle_XQWyv823.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!stores.sdkStore.initialized || !staleParentMessage)
                        return [2 /*return*/];
                    threadDispatcher({
                        type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_START,
                        payload: null,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    params = getThreadMessageListParams({ includeReactions: isReactionEnabled });
                    logger.info('Thread | useGetThreadList: Initialize thread list start.', { timestamp: timestamp, params: params });
                    return [4 /*yield*/, staleParentMessage.getThreadedMessagesByTimestamp(timestamp, params)];
                case 2:
                    _a = _b.sent(), threadedMessages_1 = _a.threadedMessages, parentMessage = _a.parentMessage;
                    logger.info('Thread | useGetThreadList: Initialize thread list succeeded.', { staleParentMessage: staleParentMessage, threadedMessages: threadedMessages_1 });
                    threadDispatcher({
                        type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_SUCCESS,
                        payload: { parentMessage: parentMessage, anchorMessage: anchorMessage, threadedMessages: threadedMessages_1 },
                    });
                    setTimeout(function () { return callback === null || callback === void 0 ? void 0 : callback(threadedMessages_1); });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    logger.info('Thread | useGetThreadList: Initialize thread list failed.', error_1);
                    threadDispatcher({
                        type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_FAILURE,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [stores.sdkStore.initialized, staleParentMessage, anchorMessage, isReactionEnabled]);
    var loadPrevious = (0,react.useCallback)(function (callback) { return (0,bundle_XQWyv823.a)(void 0, void 0, void 0, function () {
        var params, _a, threadedMessages_2, parentMessage, error_2;
        return (0,bundle_XQWyv823.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (threadListState !== types/* ThreadListStateTypes.INITIALIZED */.RZ.INITIALIZED || oldestMessageTimeStamp === 0 || !staleParentMessage)
                        return [2 /*return*/];
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_PREV_MESSAGES_START,
                        payload: null,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    params = getThreadMessageListParams({ nextResultSize: 0, includeReactions: isReactionEnabled });
                    return [4 /*yield*/, staleParentMessage.getThreadedMessagesByTimestamp(oldestMessageTimeStamp, params)];
                case 2:
                    _a = _b.sent(), threadedMessages_2 = _a.threadedMessages, parentMessage = _a.parentMessage;
                    logger.info('Thread | useGetPrevThreadsCallback: Fetch prev threads succeeded.', { parentMessage: parentMessage, threadedMessages: threadedMessages_2 });
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_PREV_MESSAGES_SUCESS,
                        payload: { parentMessage: parentMessage, threadedMessages: threadedMessages_2 },
                    });
                    setTimeout(function () { return callback === null || callback === void 0 ? void 0 : callback(threadedMessages_2); });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    logger.info('Thread | useGetPrevThreadsCallback: Fetch prev threads failed.', error_2);
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_PREV_MESSAGES_FAILURE,
                        payload: error_2,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [threadListState, oldestMessageTimeStamp, isReactionEnabled, staleParentMessage]);
    var loadNext = (0,react.useCallback)(function (callback) { return (0,bundle_XQWyv823.a)(void 0, void 0, void 0, function () {
        var params, _a, threadedMessages_3, parentMessage, error_3;
        return (0,bundle_XQWyv823.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (threadListState !== types/* ThreadListStateTypes.INITIALIZED */.RZ.INITIALIZED || latestMessageTimeStamp === 0 || !staleParentMessage)
                        return [2 /*return*/];
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_NEXT_MESSAGES_START,
                        payload: null,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    params = getThreadMessageListParams({ prevResultSize: 0, includeReactions: isReactionEnabled });
                    return [4 /*yield*/, staleParentMessage.getThreadedMessagesByTimestamp(latestMessageTimeStamp, params)];
                case 2:
                    _a = _b.sent(), threadedMessages_3 = _a.threadedMessages, parentMessage = _a.parentMessage;
                    logger.info('Thread | useGetNextThreadsCallback: Fetch next threads succeeded.', { parentMessage: parentMessage, threadedMessages: threadedMessages_3 });
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_NEXT_MESSAGES_SUCESS,
                        payload: { parentMessage: parentMessage, threadedMessages: threadedMessages_3 },
                    });
                    setTimeout(function () { return callback === null || callback === void 0 ? void 0 : callback(threadedMessages_3); });
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    logger.info('Thread | useGetNextThreadsCallback: Fetch next threads failed.', error_3);
                    threadDispatcher({
                        type: ThreadContextActionTypes.GET_NEXT_MESSAGES_FAILURE,
                        payload: error_3,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [threadListState, latestMessageTimeStamp, isReactionEnabled, staleParentMessage]);
    return {
        initialize: initialize,
        loadPrevious: loadPrevious,
        loadNext: loadNext,
    };
};

var ThreadContext = react.createContext(null);
var ThreadProvider = function (props) {
    var _a, _b;
    var children = props.children, channelUrl = props.channelUrl, onHeaderActionClick = props.onHeaderActionClick, onMoveToParentMessage = props.onMoveToParentMessage, onBeforeSendUserMessage = props.onBeforeSendUserMessage, onBeforeSendFileMessage = props.onBeforeSendFileMessage, onBeforeSendVoiceMessage = props.onBeforeSendVoiceMessage, onBeforeSendMultipleFilesMessage = props.onBeforeSendMultipleFilesMessage, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, filterEmojiCategoryIds = props.filterEmojiCategoryIds;
    var propsMessage = props === null || props === void 0 ? void 0 : props.message;
    var propsParentMessage = (0,bundle_CDvkkTNs.g)(propsMessage);
    // Context from SendbirdProvider
    var globalStore = (0,useSendbirdStateContext/* useSendbirdStateContext */.A)();
    var stores = globalStore.stores, config = globalStore.config;
    // // stores
    var sdkStore = stores.sdkStore, userStore = stores.userStore;
    var sdk = sdkStore.sdk;
    var user = userStore.user;
    var sdkInit = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.initialized;
    // // config
    var logger = config.logger, pubSub = config.pubSub, htmlTextDirection = config.htmlTextDirection, forceLeftToRightMessageLayout = config.forceLeftToRightMessageLayout;
    var isMentionEnabled = config.groupChannel.enableMention;
    var isReactionEnabled = config.groupChannel.enableReactions;
    // dux of Thread
    var _c = (0,react.useReducer)(reducer, initialState), threadStore = _c[0], threadDispatcher = _c[1];
    var currentChannel = threadStore.currentChannel, allThreadMessages = threadStore.allThreadMessages, localThreadMessages = threadStore.localThreadMessages, parentMessage = threadStore.parentMessage, channelState = threadStore.channelState, threadListState = threadStore.threadListState, parentMessageState = threadStore.parentMessageState, hasMorePrev = threadStore.hasMorePrev, hasMoreNext = threadStore.hasMoreNext, emojiContainer = threadStore.emojiContainer, isMuted = threadStore.isMuted, isChannelFrozen = threadStore.isChannelFrozen, currentUserId = threadStore.currentUserId, typingMembers = threadStore.typingMembers;
    // Initialization
    (0,react.useEffect)(function () {
        threadDispatcher({
            type: ThreadContextActionTypes.INIT_USER_ID,
            payload: user === null || user === void 0 ? void 0 : user.userId,
        });
    }, [user]);
    useGetChannel({
        channelUrl: channelUrl,
        sdkInit: sdkInit,
        message: propsMessage,
    }, { sdk: sdk, logger: logger, threadDispatcher: threadDispatcher });
    useGetParentMessage({
        channelUrl: channelUrl,
        sdkInit: sdkInit,
        parentMessage: propsParentMessage,
    }, { sdk: sdk, logger: logger, threadDispatcher: threadDispatcher });
    useGetAllEmoji({ sdk: sdk }, { logger: logger, threadDispatcher: threadDispatcher });
    // Handle channel events
    useHandleChannelEvents({
        sdk: sdk,
        currentChannel: currentChannel,
    }, { logger: logger, threadDispatcher: threadDispatcher });
    useHandleThreadPubsubEvents({
        sdkInit: sdkInit,
        currentChannel: currentChannel,
        parentMessage: parentMessage,
    }, { logger: logger, pubSub: pubSub, threadDispatcher: threadDispatcher });
    var _d = useThreadFetchers({
        parentMessage: parentMessage,
        // anchorMessage should be null when parentMessage doesn't exist
        anchorMessage: (propsMessage === null || propsMessage === void 0 ? void 0 : propsMessage.messageId) !== (propsParentMessage === null || propsParentMessage === void 0 ? void 0 : propsParentMessage.messageId) ? propsMessage || undefined : undefined,
        logger: logger,
        isReactionEnabled: isReactionEnabled,
        threadDispatcher: threadDispatcher,
        threadListState: threadListState,
        oldestMessageTimeStamp: ((_a = allThreadMessages[0]) === null || _a === void 0 ? void 0 : _a.createdAt) || 0,
        latestMessageTimeStamp: ((_b = allThreadMessages[allThreadMessages.length - 1]) === null || _b === void 0 ? void 0 : _b.createdAt) || 0,
    }), initialize = _d.initialize, loadPrevious = _d.loadPrevious, loadNext = _d.loadNext;
    (0,react.useEffect)(function () {
        if (stores.sdkStore.initialized && config.isOnline) {
            initialize();
        }
    }, [stores.sdkStore.initialized, config.isOnline, initialize]);
    (0,bundle_BbVJcZ9w.u)(htmlTextDirection, forceLeftToRightMessageLayout, channelState === types/* ChannelStateTypes.LOADING */.cM.LOADING
        || threadListState === types/* ThreadListStateTypes.LOADING */.RZ.LOADING
        || parentMessageState === types/* ParentMessageStateTypes.LOADING */.KD.LOADING);
    var toggleReaction = useToggleReactionCallback({ currentChannel: currentChannel }, { logger: logger });
    // Send Message Hooks
    var sendMessage = useSendUserMessageCallback({
        isMentionEnabled: isMentionEnabled,
        currentChannel: currentChannel,
        onBeforeSendUserMessage: onBeforeSendUserMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        threadDispatcher: threadDispatcher,
    });
    var sendFileMessage = useSendFileMessageCallback({
        currentChannel: currentChannel,
        onBeforeSendFileMessage: onBeforeSendFileMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        threadDispatcher: threadDispatcher,
    });
    var sendVoiceMessage = useSendVoiceMessageCallback({
        currentChannel: currentChannel,
        onBeforeSendVoiceMessage: onBeforeSendVoiceMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        threadDispatcher: threadDispatcher,
    });
    var sendMultipleFilesMessage = (0,bundle_CDvkkTNs.u)({
        currentChannel: currentChannel,
        onBeforeSendMultipleFilesMessage: onBeforeSendMultipleFilesMessage,
        publishingModules: [bundle_DRlnZqdp.P.THREAD],
    }, {
        logger: logger,
        pubSub: pubSub,
    })[0];
    var resendMessage = useResendMessageCallback({
        currentChannel: currentChannel,
    }, { logger: logger, pubSub: pubSub, threadDispatcher: threadDispatcher });
    var updateMessage = useUpdateMessageCallback({
        currentChannel: currentChannel,
        isMentionEnabled: isMentionEnabled,
    }, { logger: logger, pubSub: pubSub, threadDispatcher: threadDispatcher });
    var deleteMessage = useDeleteMessageCallback({ currentChannel: currentChannel, threadDispatcher: threadDispatcher }, { logger: logger });
    // memo
    var nicknamesMap = (0,react.useMemo)(function () { return ((config.groupChannel.replyType !== 'none' && currentChannel)
        ? (0,bundle_CDvkkTNs.a)(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members)
        : new Map()); }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members]);
    return (react.createElement(ThreadContext.Provider, { value: {
            // ThreadProviderProps
            channelUrl: channelUrl,
            message: propsMessage,
            onHeaderActionClick: onHeaderActionClick,
            onMoveToParentMessage: onMoveToParentMessage,
            isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled,
            onBeforeDownloadFileMessage: onBeforeDownloadFileMessage,
            // ThreadContextInitialState
            currentChannel: currentChannel,
            allThreadMessages: allThreadMessages,
            localThreadMessages: localThreadMessages,
            parentMessage: parentMessage,
            channelState: channelState,
            threadListState: threadListState,
            parentMessageState: parentMessageState,
            hasMorePrev: hasMorePrev,
            hasMoreNext: hasMoreNext,
            emojiContainer: emojiContainer,
            // hooks
            fetchPrevThreads: loadPrevious,
            fetchNextThreads: loadNext,
            toggleReaction: toggleReaction,
            sendMessage: sendMessage,
            sendFileMessage: sendFileMessage,
            sendVoiceMessage: sendVoiceMessage,
            sendMultipleFilesMessage: sendMultipleFilesMessage,
            resendMessage: resendMessage,
            updateMessage: updateMessage,
            deleteMessage: deleteMessage,
            // context
            nicknamesMap: nicknamesMap,
            isMuted: isMuted,
            isChannelFrozen: isChannelFrozen,
            currentUserId: currentUserId,
            typingMembers: typingMembers,
            filterEmojiCategoryIds: filterEmojiCategoryIds,
        } },
        react.createElement(bundle_Bv8KtnvF.U, (0,bundle_XQWyv823._)({}, props), children)));
};
var useThreadContext = function () {
    var context = react.useContext(ThreadContext);
    if (!context)
        throw new Error('ThreadContext not found. Use within the Thread module');
    return context;
};


//# sourceMappingURL=context.js.map


/***/ }),

/***/ 53474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KD": function() { return /* binding */ ParentMessageStateTypes; },
/* harmony export */   "RZ": function() { return /* binding */ ThreadListStateTypes; },
/* harmony export */   "cM": function() { return /* binding */ ChannelStateTypes; }
/* harmony export */ });
// Initializing status
var ChannelStateTypes;
(function (ChannelStateTypes) {
    ChannelStateTypes["NIL"] = "NIL";
    ChannelStateTypes["LOADING"] = "LOADING";
    ChannelStateTypes["INVALID"] = "INVALID";
    ChannelStateTypes["INITIALIZED"] = "INITIALIZED";
})(ChannelStateTypes || (ChannelStateTypes = {}));
var ParentMessageStateTypes;
(function (ParentMessageStateTypes) {
    ParentMessageStateTypes["NIL"] = "NIL";
    ParentMessageStateTypes["LOADING"] = "LOADING";
    ParentMessageStateTypes["INVALID"] = "INVALID";
    ParentMessageStateTypes["INITIALIZED"] = "INITIALIZED";
})(ParentMessageStateTypes || (ParentMessageStateTypes = {}));
var ThreadListStateTypes;
(function (ThreadListStateTypes) {
    ThreadListStateTypes["NIL"] = "NIL";
    ThreadListStateTypes["LOADING"] = "LOADING";
    ThreadListStateTypes["INVALID"] = "INVALID";
    ThreadListStateTypes["INITIALIZED"] = "INITIALIZED";
})(ThreadListStateTypes || (ThreadListStateTypes = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 32177:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useVoicePlayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69466);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78614);





























var useVoicePlayer = function (_a) {
    var _b;
    var _c = _a.key, key = _c === void 0 ? '' : _c, _d = _a.channelUrl, channelUrl = _d === void 0 ? '' : _d, audioFile = _a.audioFile, _e = _a.audioFileUrl, audioFileUrl = _e === void 0 ? '' : _e, _f = _a.audioFileMimeType, audioFileMimeType = _f === void 0 ? _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_19__.b : _f;
    var groupKey = (0,_chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_1__.g)(channelUrl, key);
    var _g = (0,_chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_1__.u)(), play = _g.play, pause = _g.pause, stop = _g.stop, voicePlayerStore = _g.voicePlayerStore;
    var isRecordable = (0,_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__.u)().isRecordable;
    var currentAudioUnit = ((_b = voicePlayerStore === null || voicePlayerStore === void 0 ? void 0 : voicePlayerStore.audioStorage) === null || _b === void 0 ? void 0 : _b[groupKey]) || (0,_chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_1__.A)();
    var playVoicePlayer = function () {
        if (!isRecordable) {
            play === null || play === void 0 ? void 0 : play({
                groupKey: groupKey,
                audioFile: audioFile,
                audioFileUrl: audioFileUrl,
                audioFileMimeType: audioFileMimeType,
            });
        }
    };
    var pauseVoicePlayer = function () {
        pause === null || pause === void 0 ? void 0 : pause(groupKey);
    };
    var stopVoicePlayer = function (text) {
        if (text === void 0) { text = ''; }
        stop === null || stop === void 0 ? void 0 : stop(text);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        return function () {
            var _a;
            if (audioFile || audioFileUrl) {
                // Can't get the current AudioPlayer through the React hooks(useReducer or useState) in this scope
                var voiceAudioPlayerElement = document.getElementById(_chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_19__.a);
                (_a = voiceAudioPlayerElement === null || voiceAudioPlayerElement === void 0 ? void 0 : voiceAudioPlayerElement.pause) === null || _a === void 0 ? void 0 : _a.call(voiceAudioPlayerElement);
            }
        };
    }, []);
    return ({
        play: playVoicePlayer,
        pause: pauseVoicePlayer,
        stop: stopVoicePlayer,
        /**
         * The reason why we multiply this by *1000 is,
         * The unit of playbackTime and duration should be millisecond
         */
        playbackTime: ((currentAudioUnit === null || currentAudioUnit === void 0 ? void 0 : currentAudioUnit.playbackTime) || 0) * 1000,
        duration: ((currentAudioUnit === null || currentAudioUnit === void 0 ? void 0 : currentAudioUnit.duration) || 0) * 1000,
        playingStatus: currentAudioUnit.playingStatus,
    });
};


//# sourceMappingURL=useVoicePlayer.js.map


/***/ }),

/***/ 19515:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useVoiceRecorder; },
/* harmony export */   "s": function() { return /* binding */ VoiceRecorderStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17693);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16167);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78614);





























// export interface UseVoiceRecorderProps extends VoiceRecorderEventHandler {
//   /**
//    * onRecordingStarted
//    * onRecordingEnded
//    */
// }
/* eslint-disable no-redeclare */
var VoiceRecorderStatus = {
    PREPARING: 'PREPARING',
    READY_TO_RECORD: 'READY_TO_RECORD',
    RECORDING: 'RECORDING',
    COMPLETED: 'COMPLETED',
};
var useVoiceRecorder = function (_a) {
    var _b = _a.onRecordingStarted, onRecordingStarted = _b === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_19__.n : _b, _c = _a.onRecordingEnded, onRecordingEnded = _c === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_19__.n : _c;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A)().config;
    var voiceRecord = config.voiceRecord;
    var maxRecordingTime = voiceRecord.maxRecordingTime;
    var voiceRecorder = (0,_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    var isRecordable = voiceRecorder.isRecordable;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), recordedFile = _d[0], setRecordedFile = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(VoiceRecorderStatus.PREPARING), recordingStatus = _e[0], setRecordingStatus = _e[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isRecordable && recordingStatus === VoiceRecorderStatus.PREPARING) {
            setRecordingStatus(VoiceRecorderStatus.READY_TO_RECORD);
        }
    }, [isRecordable]);
    var start = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        voiceRecorder === null || voiceRecorder === void 0 ? void 0 : voiceRecorder.start({
            onRecordingStarted: function () {
                setRecordingStatus(VoiceRecorderStatus.RECORDING);
                onRecordingStarted();
                startTimer();
            },
            onRecordingEnded: function (audioFile) {
                setRecordingStatus(VoiceRecorderStatus.COMPLETED);
                onRecordingEnded(audioFile);
                setRecordedFile(audioFile);
                stopTimer();
            },
        });
    }, [onRecordingStarted, onRecordingEnded]);
    var stop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        voiceRecorder === null || voiceRecorder === void 0 ? void 0 : voiceRecorder.stop();
        stopTimer();
    }, [voiceRecorder]);
    var cancel = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        stop();
        setRecordedFile(null);
    }, [voiceRecorder]);
    // Timer
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), recordingTime = _f[0], setRecordingTime = _f[1];
    var timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    function startTimer() {
        stopTimer();
        setRecordingTime(0);
        timer.current = setInterval(function () {
            setRecordingTime(function (prevTime) {
                var newTime = prevTime + 100;
                if (newTime > maxRecordingTime) {
                    stopTimer();
                }
                return newTime;
            });
        }, 100);
    }
    function stopTimer() {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (recordingTime > maxRecordingTime) {
            stop();
        }
    }, [recordingTime, maxRecordingTime, stop]);
    return ({
        start: start,
        stop: stop,
        cancel: cancel,
        recordingStatus: recordingStatus,
        recordingTime: recordingTime,
        recordedFile: recordedFile,
        recordingLimit: maxRecordingTime,
    });
};


//# sourceMappingURL=useVoiceRecorder.js.map


/***/ }),

/***/ 59587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LocalizationContext; },
/* harmony export */   "a": function() { return /* binding */ LocalizationProvider; },
/* harmony export */   "l": function() { return /* binding */ locale; },
/* harmony export */   "u": function() { return /* binding */ useLocalization; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61448);




var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var LocalizationContextDefault = {
    stringSet: (0,_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_2__.g)('en'),
    dateLocale: locale,
};
var LocalizationContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(LocalizationContextDefault);
var LocalizationProvider = function (props) {
    var children = props.children;
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(LocalizationContext.Provider, { value: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, LocalizationContextDefault), props) }, children);
};
var useLocalization = function () { return react__WEBPACK_IMPORTED_MODULE_1__.useContext(LocalizationContext); };


//# sourceMappingURL=bundle--PhH_XFy.js.map


/***/ }),

/***/ 82314:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Avatar$1; },
/* harmony export */   "a": function() { return /* binding */ AvatarDefault; }
/* harmony export */ });
/* unused harmony export b */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4399);
/* harmony import */ var _bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81715);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80360);







var AvatarDefault = function (props) {
    var width = props.width, height = props.height, text = props.text;
    var iconWidth = (0,_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_4__.p)(width);
    var iconHeight = (0,_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_4__.p)(height);
    if (typeof iconWidth === 'number' && !Number.isNaN(iconWidth)) {
        iconWidth *= 0.575;
    }
    if (typeof iconHeight === 'number' && !Number.isNaN(iconHeight)) {
        iconHeight *= 0.575;
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_5__.c)('sendbird-avatar-img--default', text && 'text'), style: { width: width, height: height } }, text
        ? react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: 'sendbird-avatar-text' }, text)
        : react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.USER */ .Qy.USER, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.CONTENT */ .zo.CONTENT, width: iconWidth, height: iconHeight })));
};

var imageRendererClassName = 'sendbird-avatar-img';
var AvatarInner = function (_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, _c = _a.alt, alt = _c === void 0 ? '' : _c, height = _a.height, width = _a.width, customDefaultComponent = _a.customDefaultComponent;
    var defaultComponent = function () { return customDefaultComponent
        ? customDefaultComponent({ width: width, height: height })
        : react__WEBPACK_IMPORTED_MODULE_1__.createElement(AvatarDefault, { width: width, height: height }); };
    if (typeof src === 'string') {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src, height: height, width: width, alt: alt, defaultComponent: defaultComponent }));
    }
    if (src && src.length) {
        if (src.length === 1) {
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[0], height: height, width: width, alt: alt, defaultComponent: defaultComponent }));
        }
        if (src.length === 2) {
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-avatar--inner__two-child" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[0], height: height, width: width, alt: alt, defaultComponent: defaultComponent }),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[1], height: height, width: width, alt: alt, defaultComponent: defaultComponent })));
        }
        if (src.length === 3) {
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-avatar--inner__three-child--upper" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[0], height: height, width: width, alt: alt, defaultComponent: defaultComponent })),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-avatar--inner__three-child--lower" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[1], height: height, width: width, alt: alt, defaultComponent: defaultComponent }),
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: src[2], height: height, width: width, alt: alt, defaultComponent: defaultComponent }))));
        }
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-avatar--inner__four-child" }, src.slice(0, 4)
            .map(function (url, index) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: url, height: height, width: width, alt: alt, key: "".concat(url, "-").concat(index), defaultComponent: defaultComponent })); })));
    }
    // default img
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: imageRendererClassName, url: "", height: height, width: width, alt: alt, defaultComponent: defaultComponent }));
};
function Avatar(_a, ref) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.src, src = _c === void 0 ? '' : _c, _d = _a.alt, alt = _d === void 0 ? '' : _d, _e = _a.width, width = _e === void 0 ? '56px' : _e, _f = _a.height, height = _f === void 0 ? '56px' : _f, _g = _a.zIndex, zIndex = _g === void 0 ? 0 : _g, _h = _a.left, left = _h === void 0 ? '' : _h, _j = _a.bottom, bottom = _j === void 0 ? '' : _j, onClick = _a.onClick, customDefaultComponent = _a.customDefaultComponent;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-avatar',
        ], false).join(' '), role: "button", ref: ref, style: {
            height: height,
            width: width,
            zIndex: zIndex,
            left: left,
            bottom: bottom,
        }, onClick: onClick, onKeyDown: onClick, tabIndex: 0 },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(AvatarInner, { src: src, width: width, height: height, alt: alt, customDefaultComponent: customDefaultComponent })));
}
var Avatar$1 = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(Avatar);


//# sourceMappingURL=bundle-52W7LREX.js.map


/***/ }),

/***/ 14014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getIsReactionEnabled; }
/* harmony export */ });
/**
 * This function helps consider the every condition
 * related to enabling emoji reaction feature.
 */
function getIsReactionEnabled(_a) {
    var channel = _a.channel, config = _a.config, moduleLevel = _a.moduleLevel;
    if (!channel || channel.isBroadcast || channel.isEphemeral) {
        return false;
    }
    if (channel.isSuper)
        return moduleLevel !== null && moduleLevel !== void 0 ? moduleLevel : config.groupChannel.enableReactionsSupergroup;
    return moduleLevel !== null && moduleLevel !== void 0 ? moduleLevel : config.groupChannel.enableReactions;
}


//# sourceMappingURL=bundle-B2NeDUAs.js.map


/***/ }),

/***/ 50152:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ pubSubFactory; }
/* harmony export */ });
// we use pubsub to sync events between multiple components(example - ChannelList, Channel)
// for example, if customer sends a message from their custom component
// without pubsub,we would not be able to listen to it
// in our ChannelList or Conversation
var pubSubFactory = function (opts) {
    var topics = {};
    return {
        __getTopics: function () { return topics; },
        subscribe: function (topic, listener) {
            var _a;
            (_a = topics[topic]) !== null && _a !== void 0 ? _a : (topics[topic] = new Set());
            topics[topic].add(listener);
            return {
                remove: function () {
                    topics[topic].delete(listener);
                },
            };
        },
        publish: function (topic, info) {
            if (topics[topic]) {
                topics[topic].forEach(function (fn) {
                    if (opts === null || opts === void 0 ? void 0 : opts.publishSynchronous) {
                        fn(info !== undefined ? info : {});
                    }
                    else {
                        setTimeout(function () { return fn(info !== undefined ? info : {}); }, 0);
                    }
                });
            }
        },
    };
};


//# sourceMappingURL=bundle-B5OWYHQO.js.map


/***/ }),

/***/ 44892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getModalDeleteMessageTitle; }
/* harmony export */ });
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6623);


function getModalDeleteMessageTitle(stringSet, message) {
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.K)(message)
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.c, function () {
        var filesCount = message.fileInfoList.length;
        return "Do you want to delete all ".concat(filesCount, " photos?");
    })
        .otherwise(function () {
        return stringSet.MODAL__DELETE_MESSAGE__TITLE;
    });
}


//# sourceMappingURL=bundle-B8L7dGsu.js.map


/***/ }),

/***/ 46367:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3323);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_0__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_0__.t)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_0__.r)(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}


//# sourceMappingURL=bundle-BAXCq_Wt.js.map


/***/ }),

/***/ 38204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useToggleReactionCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var LOG_PRESET = 'useToggleReactionCallback:';
function useToggleReactionCallback(currentChannel, logger) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (message, key, isReacted) {
        if (!currentChannel) {
            logger === null || logger === void 0 ? void 0 : logger.warning("".concat(LOG_PRESET, " currentChannel doesn't exist"), currentChannel);
            return;
        }
        if (isReacted) {
            currentChannel
                .deleteReaction(message, key)
                .then(function (res) {
                logger === null || logger === void 0 ? void 0 : logger.info("".concat(LOG_PRESET, " Delete reaction success"), res);
            })
                .catch(function (err) {
                logger === null || logger === void 0 ? void 0 : logger.warning("".concat(LOG_PRESET, " Delete reaction failed"), err);
            });
        }
        else {
            currentChannel
                .addReaction(message, key)
                .then(function (res) {
                logger === null || logger === void 0 ? void 0 : logger.info("".concat(LOG_PRESET, " Add reaction success"), res);
            })
                .catch(function (err) {
                logger === null || logger === void 0 ? void 0 : logger.warning("".concat(LOG_PRESET, " Add reaction failed"), err);
            });
        }
    }, [currentChannel]);
}


//# sourceMappingURL=bundle-BApwq9D9.js.map


/***/ }),

/***/ 43071:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MultipleFilesMessageItemBody; },
/* harmony export */   "T": function() { return /* binding */ ThreadMessageKind; },
/* harmony export */   "a": function() { return /* binding */ useFileInfoListWithUploaded; },
/* harmony export */   "u": function() { return /* binding */ useThreadMessageKindKeySelector; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65614);
/* harmony import */ var _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34182);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4399);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6989);









function ImageGrid(_a) {
    var _b;
    var children = _a.children, className = _a.className, message = _a.message, isReactionEnabled = _a.isReactionEnabled;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-image-grid-wrap' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.x)([
                className !== null && className !== void 0 ? className : '',
                'sendbird-image-grid',
                (isReactionEnabled && ((_b = message === null || message === void 0 ? void 0 : message.reactions) === null || _b === void 0 ? void 0 : _b.length) > 0) ? 'reactions' : '',
            ]) }, children)));
}

var GRID_WIDTH_CHAT_WEB = 400;
var GRID_SIDE_PADDING = 8;
var GRID_GAP = 4;
var TIMESTAMP_WIDTH_AND_ITS_SIDE_MARGIN = 54;
var PROFILE_IMAGE_WIDTH = 40;
var CHAT_MOBILE_SIDE_PADDING = 48;
var THREAD_PARENT_WIDTH = 320;
var THREAD_PARENT_SIDE_PADDING = 28;
var THREAD_PARENT_GRID_MARGIN_LEFT = 12;
var THREAD_CHILD_WIDTH = 200;
var THREAD_CHILD_SIDE_PADDING = 8;
var THREAD_CHILD_MOBILE_SIDE_PADDING = 32;
var THREAD_CHILD_MOBILE_TIMESTAMP_WIDTH_AND_ITS_SIDE_MARGIN = 60;
var MULTIPLE_FILES_IMAGE_SIDE_LENGTH = {
    CHAT_WEB: "calc(".concat(GRID_WIDTH_CHAT_WEB / 2, "px - ").concat((GRID_SIDE_PADDING + GRID_GAP) / 2, "px)"),
    CHAT_MOBILE: "calc(50vw - ".concat((CHAT_MOBILE_SIDE_PADDING + PROFILE_IMAGE_WIDTH + TIMESTAMP_WIDTH_AND_ITS_SIDE_MARGIN + GRID_SIDE_PADDING + GRID_GAP) / 2, "px)"),
    THREAD_PARENT_WEB: "calc(".concat((THREAD_PARENT_WIDTH - (THREAD_PARENT_SIDE_PADDING + PROFILE_IMAGE_WIDTH + THREAD_PARENT_GRID_MARGIN_LEFT + GRID_GAP)) / 2, "px)"),
    THREAD_PARENT_MOBILE: "calc(50vw - ".concat((THREAD_PARENT_SIDE_PADDING + PROFILE_IMAGE_WIDTH + THREAD_PARENT_GRID_MARGIN_LEFT + GRID_GAP) / 2, "px)"),
    THREAD_CHILD_WEB: "calc(".concat((THREAD_CHILD_WIDTH - THREAD_CHILD_SIDE_PADDING - GRID_GAP) / 2, "px)"),
    THREAD_CHILD_MOBILE: "calc(50vw - ".concat((THREAD_CHILD_MOBILE_SIDE_PADDING + PROFILE_IMAGE_WIDTH + THREAD_CHILD_MOBILE_TIMESTAMP_WIDTH_AND_ITS_SIDE_MARGIN + GRID_SIDE_PADDING + GRID_GAP) / 2, "px)"),
};
var MULTIPLE_FILES_IMAGE_BORDER_RADIUS = {
    CHAT_WEB: '6px',
    CHAT_MOBILE: '6px',
    THREAD_PARENT_WEB: '6px',
    THREAD_PARENT_MOBILE: '6px',
    THREAD_CHILD_WEB: '6px',
    THREAD_CHILD_MOBILE: '6px',
};
var MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH = '34px';

var ThreadMessageKind = {
    PARENT: 'parent',
    CHILD: 'child',
};
function MultipleFilesMessageItemBody(_a) {
    var _this = this;
    var _b, _c;
    var className = _a.className, message = _a.message, _d = _a.isReactionEnabled, isReactionEnabled = _d === void 0 ? false : _d, threadMessageKindKey = _a.threadMessageKindKey, _e = _a.statefulFileInfoList, statefulFileInfoList = _e === void 0 ? [] : _e, _f = _a.onBeforeDownloadFileMessage, onBeforeDownloadFileMessage = _f === void 0 ? null : _f;
    var logger = (_c = (_b = _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A === null || _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A === void 0 ? void 0 : (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A)()) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.logger;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1), currentFileViewerIndex = _g[0], setCurrentFileViewerIndex = _g[1];
    function onClose() {
        setCurrentFileViewerIndex(-1);
    }
    function onClickLeft() {
        setCurrentFileViewerIndex(currentFileViewerIndex === 0 ? statefulFileInfoList.length - 1 : currentFileViewerIndex - 1);
    }
    function onClickRight() {
        setCurrentFileViewerIndex(currentFileViewerIndex === statefulFileInfoList.length - 1 ? 0 : currentFileViewerIndex + 1);
    }
    return (threadMessageKindKey ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        currentFileViewerIndex > -1 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_FileViewer_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { message: message, statefulFileInfoList: statefulFileInfoList, currentIndex: currentFileViewerIndex, onClickLeft: onClickLeft, onClickRight: onClickRight, onClose: onClose, onDownloadClick: function (e) { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__.a)(_this, void 0, void 0, function () {
                var allowDownload, err_1;
                var _a, _b;
                return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!onBeforeDownloadFileMessage)
                                return [2 /*return*/];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message, index: currentFileViewerIndex })];
                        case 2:
                            allowDownload = _c.sent();
                            if (!allowDownload) {
                                e.preventDefault();
                                (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'MultipleFilesMessageItemBody: Not allowed to download.');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _c.sent();
                            (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'MultipleFilesMessageItemBody: Error occurred while determining download continuation:', err_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); } })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageGrid, { className: className, message: message, isReactionEnabled: isReactionEnabled }, statefulFileInfoList.map(function (fileInfo, index) {
            var _a, _b, _c, _d;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-multiple-files-image-renderer-wrapper", onClick: message.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_7__.ao.SUCCEEDED ? function () { return setCurrentFileViewerIndex(index); } : undefined, key: "sendbird-multiple-files-image-renderer-".concat(index, "-").concat(fileInfo.url) },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { url: (_d = (_c = (_b = (_a = fileInfo.thumbnails) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : fileInfo.url) !== null && _d !== void 0 ? _d : '', fixedSize: false, width: MULTIPLE_FILES_IMAGE_SIDE_LENGTH[threadMessageKindKey], maxSideLength: MULTIPLE_FILES_IMAGE_SIDE_LENGTH.CHAT_WEB, height: MULTIPLE_FILES_IMAGE_SIDE_LENGTH[threadMessageKindKey], borderRadius: (0,_ui_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__/* .getBorderRadiusForMultipleImageRenderer */ .Mh)(MULTIPLE_FILES_IMAGE_BORDER_RADIUS[threadMessageKindKey], index, statefulFileInfoList.length), shadeOnHover: true, isUploaded: !!fileInfo.isUploaded, placeHolder: function (_a) {
                        var style = _a.style;
                        if (fileInfo.mimeType && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.z)(fileInfo.mimeType))
                            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImagePlaceholder.GIF, { style: style });
                        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImagePlaceholder.Default, { style: style });
                    }, defaultComponent: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImagePlaceholder.LoadError, null) })));
        })))) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null));
}
var ImagePlaceholder = {
    Default: function (_a) {
        var style = _a.style;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-multiple-files-image-renderer__thumbnail__placeholder", style: style },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.PHOTO */ .Qy.PHOTO, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH, height: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH })));
    },
    GIF: function (_a) {
        var style = _a.style;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-multiple-files-image-renderer__thumbnail__placeholder", style: style },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-multiple-files-image-renderer__thumbnail__placeholder__icon" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.GIF */ .Qy.GIF, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.THUMBNAIL_ICON */ .zo.THUMBNAIL_ICON, width: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH, height: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH }))));
    },
    LoadError: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-multiple-files-image-renderer__thumbnail__placeholder" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.THUMBNAIL_NONE */ .Qy.THUMBNAIL_NONE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH, height: MULTIPLE_FILES_IMAGE_THUMBNAIL_SIDE_LENGTH }))); },
};

function useThreadMessageKindKeySelector(_a) {
    var threadMessageKind = _a.threadMessageKind, isMobile = _a.isMobile;
    var threadMessageKindKey = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.K)(threadMessageKind)
            .with(ThreadMessageKind.PARENT, function () { return (isMobile
            ? 'THREAD_PARENT_MOBILE'
            : 'THREAD_PARENT_WEB'); })
            .with(ThreadMessageKind.CHILD, function () { return (isMobile
            ? 'THREAD_CHILD_MOBILE'
            : 'THREAD_CHILD_WEB'); })
            .otherwise(function () { return (isMobile
            ? 'CHAT_MOBILE'
            : 'CHAT_WEB'); });
    }, [isMobile, threadMessageKind]);
    return threadMessageKindKey;
}

// SendingStatus.SCHEDULED is currently not covered in UIKit
//  So we can ignore for now, but for future, it is better to explicitly use PENDING, FAILED, or CANCELED.
var useFileInfoListWithUploaded = function (message) {
    var _a, _b;
    var blobHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map());
    var getObjectURL = function (index, blob) {
        if (!blobHandler.current.has(index) && blob)
            blobHandler.current.set(index, URL.createObjectURL(blob));
        return blobHandler.current.get(index);
    };
    var revokeURLs = function () {
        if (blobHandler.current.size > 0) {
            blobHandler.current.forEach(function (url) { return URL.revokeObjectURL(url); });
            blobHandler.current.clear();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        return function () { return revokeURLs(); };
    }, []);
    if (!message || !message.isMultipleFilesMessage || !message.isMultipleFilesMessage()) {
        return [];
    }
    else if (message.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_7__.ao.SUCCEEDED) {
        revokeURLs();
        return message.fileInfoList.map(function (it) {
            var _a, _b;
            return ((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, it), { url: it.url, isUploaded: true, mimeType: (_a = it.mimeType) !== null && _a !== void 0 ? _a : undefined, fileName: (_b = it.fileName) !== null && _b !== void 0 ? _b : undefined }));
        });
    }
    else {
        return (_b = (_a = message === null || message === void 0 ? void 0 : message.messageParams) === null || _a === void 0 ? void 0 : _a.fileInfoList.map(function (it, index) {
            var _a, _b;
            return ((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, it), { url: (_b = (_a = getObjectURL(index)) !== null && _a !== void 0 ? _a : it.fileUrl) !== null && _b !== void 0 ? _b : (it.file instanceof Blob ? getObjectURL(index, it.file) : undefined), isUploaded: !it.file && typeof it.fileUrl === 'string' && it.fileUrl.length > 0 }));
        })) !== null && _b !== void 0 ? _b : [];
    }
};


//# sourceMappingURL=bundle-BFQnMRhA.js.map


/***/ }),

/***/ 80360:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ classnames; },
/* harmony export */   "d": function() { return /* binding */ deleteNullish; },
/* harmony export */   "n": function() { return /* binding */ noop; },
/* harmony export */   "o": function() { return /* binding */ openURL; }
/* harmony export */ });
var noop = function () {
    /** noop * */
};
var deleteNullish = function (obj) {
    var cleaned = {};
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined && value !== null) {
            cleaned[key] = value;
        }
    });
    return cleaned;
};
function openURL(url) {
    var safeURL = url;
    if (safeURL) {
        if (!safeURL.startsWith('http://') && !safeURL.startsWith('https://')) {
            safeURL = 'https://' + safeURL;
        }
        window.open(safeURL, '_blank', 'noopener,noreferrer');
    }
}
function classnames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.filter(Boolean).join(' ');
}


//# sourceMappingURL=bundle-BHC96gO0.js.map


/***/ }),

/***/ 84241:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RemoveMessageModalView; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17693);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88569);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59587);
/* harmony import */ var _bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44892);








var RemoveMessageModalView = function (props) {
    var _a;
    var _b = props.onSubmit, onSubmit = _b === void 0 ? function () {
        /* noop */
    } : _b, onCancel = props.onCancel, message = props.message, deleteMessage = props.deleteMessage;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__.M, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_4__/* .ButtonTypes.DANGER */ .qh.DANGER, disabled: ((_a = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) ? message.threadInfo.replyCount > 0 : undefined, onCancel: onCancel, onSubmit: function () {
            if (message.isUserMessage() || message.isFileMessage() || message.isMultipleFilesMessage()) {
                deleteMessage(message).then(function () {
                    // For other status such as PENDING, SCHEDULED, and CANCELED,
                    // invalid parameters error is thrown so nothing happens.
                    onSubmit();
                    onCancel();
                });
            }
        }, submitText: stringSet.MESSAGE_MENU__DELETE, titleText: (0,_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_6__.g)(stringSet, message) }));
};


//# sourceMappingURL=bundle-BHNcTHkg.js.map


/***/ }),

/***/ 21112:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Colors; },
/* harmony export */   "c": function() { return /* binding */ changeColorToClassName; }
/* harmony export */ });
var Colors;
(function (Colors) {
    Colors["ONBACKGROUND_1"] = "ONBACKGROUND_1";
    Colors["ONBACKGROUND_2"] = "ONBACKGROUND_2";
    Colors["ONBACKGROUND_3"] = "ONBACKGROUND_3";
    Colors["ONBACKGROUND_4"] = "ONBACKGROUND_4";
    Colors["ONCONTENT_1"] = "ONCONTENT_1";
    Colors["ONCONTENT_2"] = "ONCONTENT_2";
    Colors["PRIMARY"] = "PRIMARY";
    Colors["ERROR"] = "ERROR";
})(Colors || (Colors = {}));
var changeColorToClassName = function (color) {
    switch (color) {
        case Colors.ONBACKGROUND_1: return 'sendbird-color--onbackground-1';
        case Colors.ONBACKGROUND_2: return 'sendbird-color--onbackground-2';
        case Colors.ONBACKGROUND_3: return 'sendbird-color--onbackground-3';
        case Colors.ONBACKGROUND_4: return 'sendbird-color--onbackground-4';
        case Colors.ONCONTENT_1: return 'sendbird-color--oncontent-1';
        case Colors.PRIMARY: return 'sendbird-color--primary';
        case Colors.ERROR: return 'sendbird-color--error';
        default: return '';
    }
};


//# sourceMappingURL=bundle-BL3yUpTV.js.map


/***/ }),

/***/ 90832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ AudioUnitDefaultValue; },
/* harmony export */   "V": function() { return /* binding */ VOICE_PLAYER_STATUS; },
/* harmony export */   "b": function() { return /* binding */ VoicePlayerProvider; },
/* harmony export */   "g": function() { return /* binding */ generateGroupKey; },
/* harmony export */   "u": function() { return /* binding */ useVoicePlayerContext; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65614);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69466);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93475);






var INITIALIZE_AUDIO_UNIT = 'INITIALIZE_AUDIO_UNIT';
var RESET_AUDIO_UNIT = 'RESET_AUDIO_UNIT';
var SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER';
var ON_VOICE_PLAYER_PLAY = 'ON_VOICE_PLAYER_PLAY';
var ON_VOICE_PLAYER_PAUSE = 'ON_VOICE_PLAYER_PAUSE';
var ON_CURRENT_TIME_UPDATE = 'ON_CURRENT_TIME_UPDATE';

var VOICE_PLAYER_STATUS = {
    IDLE: 'IDLE',
    PREPARING: 'PREPARING',
    PLAYING: 'PLAYING',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
};
var AudioUnitDefaultValue = function () { return ({
    audioFile: null,
    playbackTime: 0,
    duration: 1000,
    playingStatus: VOICE_PLAYER_STATUS.IDLE,
}); };
var voicePlayerInitialState = {
    currentPlayer: null,
    currentGroupKey: '',
    audioStorage: {},
};

function voicePlayerReducer(state, action) {
    var _a, _b, _c, _d, _e;
    var _f, _g, _h, _j;
    switch (action.type) {
        case INITIALIZE_AUDIO_UNIT: {
            var groupKey = action.payload.groupKey;
            var audioUnit = (((_f = state.audioStorage) === null || _f === void 0 ? void 0 : _f[groupKey]) ? state.audioStorage[groupKey] : AudioUnitDefaultValue());
            audioUnit.playingStatus = VOICE_PLAYER_STATUS.PREPARING;
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { audioStorage: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state.audioStorage), (_a = {}, _a[groupKey] = audioUnit, _a)) });
        }
        case RESET_AUDIO_UNIT: {
            var groupKey = action.payload.groupKey;
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { audioStorage: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state.audioStorage), (_b = {}, _b[groupKey] = AudioUnitDefaultValue(), _b)) });
        }
        case SET_CURRENT_PLAYER: {
            var _k = action.payload, audioPlayer = _k.audioPlayer, groupKey = _k.groupKey;
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { currentPlayer: audioPlayer, currentGroupKey: groupKey });
        }
        case ON_VOICE_PLAYER_PLAY: {
            var _l = action.payload, groupKey = _l.groupKey, audioFile = _l.audioFile;
            var audioUnit = (((_g = state.audioStorage) === null || _g === void 0 ? void 0 : _g[groupKey]) ? state.audioStorage[groupKey] : AudioUnitDefaultValue());
            audioUnit.audioFile = audioFile;
            audioUnit.playingStatus = VOICE_PLAYER_STATUS.PLAYING;
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { audioStorage: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state.audioStorage), (_c = {}, _c[groupKey] = audioUnit, _c)) });
        }
        case ON_VOICE_PLAYER_PAUSE: {
            var _m = action.payload, groupKey = _m.groupKey, duration = _m.duration, currentTime = _m.currentTime;
            var audioUnit = (((_h = state.audioStorage) === null || _h === void 0 ? void 0 : _h[groupKey]) ? state.audioStorage[groupKey] : AudioUnitDefaultValue());
            audioUnit.playingStatus = VOICE_PLAYER_STATUS.PAUSED;
            if (duration === currentTime) {
                audioUnit.playbackTime = 0;
            }
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { audioStorage: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state.audioStorage), (_d = {}, _d[groupKey] = audioUnit, _d)) });
        }
        case ON_CURRENT_TIME_UPDATE: {
            var groupKey = action.payload.groupKey;
            var _o = state.currentPlayer, currentTime = _o.currentTime, duration = _o.duration;
            var audioUnit = (((_j = state.audioStorage) === null || _j === void 0 ? void 0 : _j[groupKey]) ? state.audioStorage[groupKey] : AudioUnitDefaultValue());
            // sometimes the final time update is fired AFTER the pause event when audio is finished
            if (audioUnit.playbackTime === audioUnit.duration && audioUnit.playingStatus === VOICE_PLAYER_STATUS.PAUSED) {
                audioUnit.playbackTime = 0;
            }
            else if (currentTime > 0 && duration > 0) {
                audioUnit.playbackTime = currentTime;
                audioUnit.duration = duration;
            }
            return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state), { audioStorage: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__._)({}, state.audioStorage), (_e = {}, _e[groupKey] = audioUnit, _e)) });
        }
        default:
            return state;
    }
}

var generateGroupKey = function (channelUrl, key) {
    if (channelUrl === void 0) { channelUrl = ''; }
    if (key === void 0) { key = ''; }
    return ("".concat(channelUrl, "-").concat(key));
};
/**
 * Parses and returns the correct MIME type based on the browser.
 * If the browser is Safari and the file type is m4a, use 'audio/x-m4a' for the audio player.
 * Safari doesn't support 'audio/mp3' well.
 * Also, 'audio/m4a' should be converted to 'audio/x-m4a' to be correctly played in Safari.
 * @link: https://sendbird.atlassian.net/browse/CLNP-2997
 *
 * @param mimeType - The original MIME type.
 * @returns Converted file name and MIME type.
 */
var getParsedVoiceAudioFileInfo = function (mimeType) {
    if ((0,_bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_3__.a)(navigator.userAgent) && mimeType.includes('m4a')) {
        return {
            name: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.l,
            mimeType: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.m,
        };
    }
    return {
        name: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.f,
        mimeType: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.b,
    };
};

var ALL = 'ALL';
var noop = function () { };
var VoicePlayerStoreDefaultValue = {
    currentGroupKey: '',
    currentPlayer: null,
    audioStorage: {},
};
var Context = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    play: noop,
    pause: noop,
    stop: noop,
    voicePlayerStore: VoicePlayerStoreDefaultValue,
});
var VoicePlayerProvider = function (_a) {
    var children = _a.children;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(voicePlayerReducer, voicePlayerInitialState), voicePlayerStore = _b[0], voicePlayerDispatcher = _b[1];
    var currentGroupKey = voicePlayerStore.currentGroupKey, currentPlayer = voicePlayerStore.currentPlayer, audioStorage = voicePlayerStore.audioStorage;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useSendbirdStateContext */ .A)().config;
    var logger = config.logger;
    var stop = function (text) {
        if (text === void 0) { text = ''; }
        if (currentGroupKey.includes(text)) {
            logger.info('VoicePlayer: Pause playing(by text).');
            pause(currentGroupKey);
        }
    };
    var pause = function (groupKey) {
        if (currentPlayer) {
            if (groupKey === currentGroupKey) {
                logger.info('VoicePlayer: Pause playing(by group key).');
                currentPlayer.pause();
            }
            else if (groupKey === ALL) {
                logger.info('VoicePlayer: Pause playing(all).');
                currentPlayer.pause();
            }
        }
        else {
            logger.warning('VoicePlayer: No currentPlayer to pause.');
        }
    };
    var play = function (_a) {
        var groupKey = _a.groupKey, audioFile = _a.audioFile, _b = _a.audioFileUrl, audioFileUrl = _b === void 0 ? '' : _b, _c = _a.audioFileMimeType, audioFileMimeType = _c === void 0 ? _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.b : _c;
        if (groupKey !== currentGroupKey) {
            pause(currentGroupKey);
        }
        // Clear the previous AudioPlayer element
        var voicePlayerRoot = document.getElementById(_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.V);
        var voicePlayerAudioElement = document.getElementById(_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.a);
        if (voicePlayerRoot && voicePlayerAudioElement) {
            voicePlayerRoot.removeChild(voicePlayerAudioElement);
        }
        logger.info('VoicePlayer: Start getting audio file.');
        new Promise(function (resolve, reject) {
            var _a;
            voicePlayerDispatcher({
                type: INITIALIZE_AUDIO_UNIT,
                payload: { groupKey: groupKey },
            });
            // audio file passed as a parameter
            if (audioFile) {
                logger.info('VoicePlayer: Use the audioFile instance.');
                resolve(audioFile);
                return;
            }
            // audio file from the audioStorage
            var cachedAudioFile = (_a = audioStorage === null || audioStorage === void 0 ? void 0 : audioStorage[groupKey]) === null || _a === void 0 ? void 0 : _a.audioFile;
            if (cachedAudioFile) {
                logger.info('VoicePlayer: Get from the audioStorage.');
                resolve(cachedAudioFile);
                return;
            }
            // fetch the audio file from URL
            fetch(audioFileUrl)
                .then(function (res) { return res.blob(); })
                .then(function (blob) {
                var audioFile = new File([blob], getParsedVoiceAudioFileInfo(audioFileMimeType).name, {
                    lastModified: new Date().getTime(),
                    type: getParsedVoiceAudioFileInfo(audioFileMimeType).mimeType,
                });
                resolve(audioFile);
                logger.info('VoicePlayer: Get the audioFile from URL.');
            })
                .catch(reject);
        })
            .then(function (audioFile) {
            var _a;
            var voicePlayerRoot = document.getElementById(_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.V);
            logger.info('VoicePlayer: Succeeded getting audio file.', { audioFile: audioFile });
            var currentAudioUnit = audioStorage[groupKey] || AudioUnitDefaultValue();
            var audioPlayer = new Audio((_a = URL === null || URL === void 0 ? void 0 : URL.createObjectURL) === null || _a === void 0 ? void 0 : _a.call(URL, audioFile));
            audioPlayer.id = _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.a;
            audioPlayer.currentTime = currentAudioUnit.playbackTime;
            audioPlayer.volume = 1;
            audioPlayer.loop = false;
            audioPlayer.onplaying = function () {
                logger.info('VoicePlayer: OnPlaying event is called from audioPlayer', { groupKey: groupKey, audioPlayer: audioPlayer });
                voicePlayerDispatcher({
                    type: ON_VOICE_PLAYER_PLAY,
                    payload: { groupKey: groupKey, audioFile: audioFile },
                });
            };
            audioPlayer.onpause = function () {
                logger.info('VoicePlayer: OnPause event is called from audioPlayer', { groupKey: groupKey, audioPlayer: audioPlayer });
                voicePlayerDispatcher({
                    type: ON_VOICE_PLAYER_PAUSE,
                    payload: { groupKey: groupKey, duration: audioPlayer.duration, currentTime: audioPlayer.currentTime },
                });
            };
            audioPlayer.ontimeupdate = function () {
                voicePlayerDispatcher({
                    type: ON_CURRENT_TIME_UPDATE,
                    payload: { groupKey: groupKey },
                });
            };
            audioPlayer.onerror = function (error) {
                logger.error('VoicePlayer: Failed to load the audioFile on the audio player.', error);
                voicePlayerDispatcher({
                    type: RESET_AUDIO_UNIT,
                    payload: { groupKey: groupKey },
                });
            };
            audioPlayer.dataset.sbGroupId = groupKey;
            // clean up the previous audio player
            try {
                voicePlayerRoot === null || voicePlayerRoot === void 0 ? void 0 : voicePlayerRoot.childNodes.forEach(function (node) {
                    var _a, _b;
                    var element = node;
                    var thisGroupKey = (_a = element.dataset) === null || _a === void 0 ? void 0 : _a.sbGroupKey;
                    if (thisGroupKey !== groupKey) {
                        (_b = element === null || element === void 0 ? void 0 : element.pause) === null || _b === void 0 ? void 0 : _b.call(element);
                        voicePlayerRoot.removeChild(element);
                        logger.info('VoicePlayer: Removed other player.', { element: element });
                    }
                });
            }
            finally {
                audioPlayer === null || audioPlayer === void 0 ? void 0 : audioPlayer.play();
                voicePlayerRoot === null || voicePlayerRoot === void 0 ? void 0 : voicePlayerRoot.appendChild(audioPlayer);
                voicePlayerDispatcher({
                    type: SET_CURRENT_PLAYER,
                    payload: { groupKey: groupKey, audioPlayer: audioPlayer },
                });
                logger.info('VoicePlayer: Succeeded playing audio player.', { groupKey: groupKey, audioPlayer: audioPlayer });
            }
        })
            .catch(function (error) {
            logger.warning('VoicePlayer: Failed loading audio file with URL.', error);
            voicePlayerDispatcher({
                type: RESET_AUDIO_UNIT,
                payload: { groupKey: groupKey },
            });
        });
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, { value: {
            play: play,
            pause: pause,
            stop: stop,
            voicePlayerStore: voicePlayerStore,
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_4__.V, style: { display: 'none' } }),
        children));
};
var useVoicePlayerContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context); };


//# sourceMappingURL=bundle-BMJP8SSM.js.map


/***/ }),

/***/ 3153:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getCaseResolvedThreadReplySelectType; },
/* harmony export */   "g": function() { return /* binding */ getCaseResolvedReplyType; }
/* harmony export */ });
/**
 * Dashboard UIKitConfig's replyType is consisted of all lowercases,
 * we need to convert it into uppercase ones(or vice versa)
 * when we pass the value to internal components
 *  - 'thread' <-> 'THREAD'
 *  - 'quote_reply' <-> 'QUOTE_REPLY'
 */
function getCaseResolvedReplyType(replyType) {
    return {
        lowerCase: replyType.toLowerCase(),
        upperCase: replyType.toUpperCase(),
    };
}
/**
 * Dashboard UIKitConfig's threadReplySelectType is consisted of all lowercase letters,
 * we need to convert it into uppercase ones(or vice versa)
 * when we pass the value to internal components
 *  - 'thread' <-> 'THREAD'
 *  - 'parent' <-> 'PARENT'
 */
function getCaseResolvedThreadReplySelectType(threadReplySelectType) {
    return {
        lowerCase: threadReplySelectType.toLowerCase(),
        upperCase: threadReplySelectType.toUpperCase(),
    };
}


//# sourceMappingURL=bundle-BOn8npYv.js.map


/***/ }),

/***/ 61448:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getStringSet; }
/* harmony export */ });
/**
 * NOTE:
 * Do not forget to update the string set table on Docs
 * When you update this string set
 *
 * `%d` will be replaced by a proper number
 */
var stringSet = {
    en: {
        // Group Channel - Conversation
        MESSAGE_STATUS__YESTERDAY: 'Yesterday',
        CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'new message(s) since',
        /** @deprecated Please use `DATE_FORMAT__MESSAGE_LIST__NOTIFICATION__UNREAD_SINCE` instead * */
        CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'on',
        // Channel List
        CHANNEL_PREVIEW_MOBILE_LEAVE: 'Leave channel',
        // Group Channel - Settings
        CHANNEL_SETTING__HEADER__TITLE: 'Channel information',
        CHANNEL_SETTING__PROFILE__EDIT: 'Edit',
        CHANNEL_SETTING__MEMBERS__TITLE: 'Members',
        CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'All members',
        CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Invite users',
        CHANNEL_SETTING__MEMBERS__YOU: ' (You)',
        CHANNEL_SETTING__MEMBERS__SELECT_TITLE: 'Select members',
        CHANNEL_SETTING__MEMBERS__OPERATOR: 'Operator',
        CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Leave channel',
        CHANNEL_SETTING__OPERATORS__TITLE: 'Operators',
        CHANNEL_SETTING__OPERATORS__TITLE_ALL: 'All operators',
        CHANNEL_SETTING__OPERATORS__TITLE_ADD: 'Add operator',
        CHANNEL_SETTING__OPERATORS__ADD_BUTTON: 'Add',
        CHANNEL_SETTING__MUTED_MEMBERS__TITLE: 'Muted members',
        CHANNEL_SETTING__MUTED_MEMBERS__TITLE_ALL: 'All muted members',
        CHANNEL_SETTING__NO_UNMUTED: 'No muted members yet',
        CHANNEL_SETTING__BANNED_MEMBERS__TITLE: 'Banned users',
        CHANNEL_SETTING__FREEZE_CHANNEL: 'Freeze Channel',
        CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR: 'Register as operator',
        CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR: 'Unregister operator',
        CHANNEL_SETTING__MODERATION__MUTE: 'Mute',
        CHANNEL_SETTING__MODERATION__UNMUTE: 'Unmute',
        CHANNEL_SETTING__MODERATION__BAN: 'Ban',
        CHANNEL_SETTING__MODERATION__UNBAN: 'Unban',
        CHANNEL_SETTING__MODERATION__EMPTY_BAN: 'No banned members yet',
        CHANNEL_SETTING__MODERATION__ALL_BAN: 'All banned members',
        // OpenChannel - Conversation
        OPEN_CHANNEL_CONVERSATION__TITLE_PARTICIPANTS: 'participants',
        OPEN_CHANNEL_CONVERSATION__SELECT_PARTICIPANTS: 'Select participants',
        // OpenChannelList
        OPEN_CHANNEL_LIST__TITLE: 'Channels',
        CREATE_OPEN_CHANNEL_LIST__TITLE: 'New channel profile',
        CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_SECTION: 'Channel image',
        CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_UPLOAD: 'Upload',
        CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_SECTION: 'Channel name',
        CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_PLACE_HOLDER: 'Enter channel name',
        CREATE_OPEN_CHANNEL_LIST__SUBMIT: 'Create',
        // OpenChannel - Settings
        OPEN_CHANNEL_SETTINGS__OPERATOR_TITLE: 'Channel Information',
        OPEN_CHANNEL_SETTINGS__OPERATOR_URL: 'URL',
        OPEN_CHANNEL_SETTINGS__PARTICIPANTS_ACCORDION_TITLE: 'Participants',
        OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_PANEL: 'Delete channel',
        OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_TITLE: 'Delete channel?',
        OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_CONTEXT: 'Once deleted, this channel can\'t be restored.',
        OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_SUBMIT: 'Delete',
        OPEN_CHANNEL_SETTINGS__OPERATORS_TITLE: 'Operators',
        OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ADD: 'Add operator',
        OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ALL: 'All operators',
        OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE: 'Muted participants',
        OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE_ALL: 'All muted participants',
        OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__NO_ONE: 'No muted participants yet',
        OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE: 'Banned users',
        OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE_ALL: 'All banned users',
        OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__NO_ONE: 'No banned users yet',
        OPEN_CHANNEL_SETTINGS__MEMBERS__YOU: ' (You)',
        OPEN_CHANNEL_SETTINGS__MEMBERS__OPERATOR: 'Operator',
        OPEN_CHANNEL_SETTINGS__PARTICIPANTS_TITLE: 'Participants',
        OPEN_CHANNEL_SETTINGS__EMPTY_LIST: 'No participants yet',
        OPEN_CHANNEL_SETTINGS__SEE_ALL: 'See all participants',
        OPEN_CHANNEL_SETTINGS__ALL_PARTICIPANTS_TITLE: 'All participants',
        OPEN_CHANNEL_SETTINGS__NO_TITLE: '(No title)',
        OPEN_CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR: 'Register as operator',
        OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR: 'Unregister operator',
        OPEN_CHANNEL_SETTING__MODERATION__MUTE: 'Mute',
        OPEN_CHANNEL_SETTING__MODERATION__UNMUTE: 'Unmute',
        OPEN_CHANNEL_SETTING__MODERATION__BAN: 'Ban',
        OPEN_CHANNEL_SETTING__MODERATION__UNBAN: 'Unban',
        // Channel - Common
        TRYING_TO_CONNECT: 'Trying to connect…',
        TYPING_INDICATOR__IS_TYPING: 'is typing...',
        TYPING_INDICATOR__AND: 'and',
        TYPING_INDICATOR__ARE_TYPING: 'are typing...',
        TYPING_INDICATOR__MULTIPLE_TYPING: 'Several people are typing...',
        CHANNEL_FROZEN: 'Channel frozen',
        PLACE_HOLDER__NO_CHANNEL: 'No channels',
        PLACE_HOLDER__WRONG: 'Something went wrong',
        PLACE_HOLDER__RETRY_TO_CONNECT: 'Retry',
        PLACE_HOLDER__NO_MESSAGES: 'No messages',
        TOOLTIP__AND_YOU: ', and you',
        TOOLTIP__YOU: 'you',
        TOOLTIP__UNKNOWN_USER: '(no name)',
        UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Unknown message type)',
        UNKNOWN__CANNOT_READ_MESSAGE: 'Cannot read this message.',
        UNKNOWN__TEMPLATE_ERROR: '(Template error)',
        FORM_VERSION_ERROR: 'Form type messages are not available in this version.',
        UNKNOWN__CANNOT_READ_TEMPLATE: 'Cannot read this template.',
        MESSAGE_EDITED: '(edited)',
        // Channel - Modal
        MODAL__DELETE_MESSAGE__TITLE: 'Delete this message?',
        MODAL__CHANNEL_INFORMATION__TITLE: 'Edit channel information',
        MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Channel image',
        MODAL__CHANNEL_INFORMATION__UPLOAD: 'Upload',
        MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Channel name',
        MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Enter name',
        MODAL__INVITE_MEMBER__TITLE: 'Invite member',
        MODAL__INVITE_MEMBER__SELECTED: 'selected',
        MODAL__CHOOSE_CHANNEL_TYPE__TITLE: 'New channel',
        MODAL__CHOOSE_CHANNEL_TYPE__GROUP: 'Group',
        MODAL__CHOOSE_CHANNEL_TYPE__SUPER_GROUP: 'Super group',
        MODAL__CHOOSE_CHANNEL_TYPE__BROADCAST: 'Broadcast',
        MODAL__CREATE_CHANNEL__TITLE: 'New channel',
        MODAL__CREATE_CHANNEL__GROUP: 'Group',
        MODAL__CREATE_CHANNEL__SUPER: 'Super group',
        MODAL__CREATE_CHANNEL__BROADCAST: 'Broadcast',
        MODAL__CREATE_CHANNEL__SELECTED: 'selected',
        MODAL__LEAVE_CHANNEL__TITLE: 'Leave this channel?',
        MODAL__LEAVE_CHANNEL__FOOTER: 'Leave',
        MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_MUTED: 'You\'re muted by the operator.',
        MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_FROZEN: 'Channel is frozen.',
        // User Profile
        USER_PROFILE__MESSAGE: 'Message',
        USER_PROFILE__USER_ID: 'User ID',
        EDIT_PROFILE__TITLE: 'My profile',
        EDIT_PROFILE__IMAGE_LABEL: 'Profile image',
        EDIT_PROFILE__IMAGE_UPLOAD: 'Upload',
        EDIT_PROFILE__NICKNAME_LABEL: 'Nickname',
        EDIT_PROFILE__NICKNAME_PLACEHOLDER: 'Enter your nickname',
        EDIT_PROFILE__USERID_LABEL: 'User ID',
        EDIT_PROFILE__THEME_LABEL: 'Dark theme',
        // Message Input
        MESSAGE_INPUT__PLACE_HOLDER: 'Enter message',
        MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Chat is unavailable in this channel',
        MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES: 'Please choose one from above',
        MESSAGE_INPUT__PLACE_HOLDER__MESSAGE_FORM: 'Please fill out the message form.',
        MESSAGE_INPUT__PLACE_HOLDER__FROZEN: 'Chat is unavailable in this channel',
        MESSAGE_INPUT__PLACE_HOLDER__MUTED: 'Chat is unavailable because you\'re muted',
        MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT: 'You\'re muted',
        MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Reply to message',
        // Common UI
        BUTTON__SUBMIT: 'Submit',
        BUTTON__CANCEL: 'Cancel',
        BUTTON__DELETE: 'Delete',
        BUTTON__SAVE: 'Save',
        BUTTON__CREATE: 'Create',
        BUTTON__INVITE: 'Invite',
        BUTTON__OK: 'OK',
        BADGE__OVER: '+',
        NO_TITLE: 'No title',
        NO_NAME: '(No name)',
        NO_MEMBERS: '(No members)',
        LABEL__OPERATOR: 'Operator',
        // Context Menu
        MESSAGE_MENU__COPY: 'Copy',
        MESSAGE_MENU__REPLY: 'Reply',
        MESSAGE_MENU__THREAD: 'Reply in thread',
        MESSAGE_MENU__OPEN_IN_CHANNEL: 'Open in channel',
        MESSAGE_MENU__EDIT: 'Edit',
        MESSAGE_MENU__RESEND: 'Resend',
        MESSAGE_MENU__DELETE: 'Delete',
        MESSAGE_MENU__SAVE: 'Save',
        //  * FIXME: get back legacy, remove after refactoring open channel messages *
        CONTEXT_MENU_DROPDOWN__COPY: 'Copy',
        CONTEXT_MENU_DROPDOWN__EDIT: 'Edit',
        CONTEXT_MENU_DROPDOWN__RESEND: 'Resend',
        CONTEXT_MENU_DROPDOWN__DELETE: 'Delete',
        CONTEXT_MENU_DROPDOWN__SAVE: 'Save',
        // Feature - Message Search
        SEARCH: 'Search',
        SEARCH_IN_CHANNEL: 'Search in channel',
        SEARCH_IN: 'Search in',
        SEARCHING: 'Searching for messages...',
        NO_SEARCHED_MESSAGE: 'No results found.',
        // Feature - Message Reply
        QUOTE_MESSAGE_INPUT__REPLY_TO: 'Reply to',
        QUOTE_MESSAGE_INPUT__FILE_TYPE_IMAGE: 'Photo',
        QUOTE_MESSAGE_INPUT__FILE_TYPE_GIF: 'GIF',
        QUOTE_MESSAGE_INPUT__FILE_TYPE__VIDEO: 'Video',
        QUOTED_MESSAGE__REPLIED_TO: 'replied to',
        QUOTED_MESSAGE__CURRENT_USER: 'You',
        QUOTED_MESSAGE__UNAVAILABLE: 'Message unavailable',
        // Feature - Thread
        THREAD__HEADER_TITLE: 'Thread',
        CHANNEL__THREAD_REPLY: 'reply',
        CHANNEL__THREAD_REPLIES: 'replies',
        CHANNEL__THREAD_OVER_MAX: '99+',
        THREAD__THREAD_REPLY: 'reply',
        THREAD__THREAD_REPLIES: 'replies',
        THREAD__INPUT__REPLY_TO_THREAD: 'Reply to thread',
        THREAD__INPUT__REPLY_IN_THREAD: 'Reply in thread',
        // Feature - Mention
        MENTION_NAME__NO_NAME: '(No name)',
        MENTION_COUNT__OVER_LIMIT: 'You can mention up to %d times at a time.',
        UI__FILE_VIEWER__UNSUPPORT: 'Unsupported message',
        // Feature - Voice Message
        VOICE_RECORDING_PERMISSION_DENIED: "You cannot record the voice since\n        voice recording is not permitted in your device system setting",
        VOICE_MESSAGE: 'Voice Message',
        // Channel preview last message file type display strings
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GIF: 'GIF',
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_PHOTO: 'Photo',
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VIDEO: 'Video',
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_AUDIO: 'Audio',
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VOICE_MESSAGE: 'Voice message',
        CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GENERAL: 'File',
        CHANNEL_PREVIEW_LAST_MESSAGE_TEMPLATE_MESSAGE: 'Message',
        // Date format
        DATE_FORMAT__MESSAGE_LIST__NOTIFICATION__UNREAD_SINCE: 'p \'on\' MMM dd',
        DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR: 'MMMM dd, yyyy',
        DATE_FORMAT__THREAD_LIST__DATE_SEPARATOR: 'MMM dd, yyyy',
        DATE_FORMAT__MESSAGE_CREATED_AT: 'p',
        DATE_FORMAT__UNREAD_SINCE: 'p MMM dd',
        DATE_FORMAT__LAST_MESSAGE_CREATED_AT__TODAY: 'p',
        DATE_FORMAT__LAST_MESSAGE_CREATED_AT__THIS_YEAR: 'MMM d',
        DATE_FORMAT__LAST_MESSAGE_CREATED_AT__PREVIOUS_YEAR: 'yyyy/M/d',
        // File upload
        FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT: 'Up to %d files can be attached.',
        FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT: 'The maximum size per file is %d MB.',
        // Feedback button text
        FEEDBACK_LIKE: 'Like',
        FEEDBACK_DISLIKE: 'Dislike',
        // Mobile feedback options menu items
        EDIT_COMMENT: 'Edit comment',
        REMOVE_FEEDBACK: 'Remove Feedback',
        // Feedback modal title
        FEEDBACK_MODAL_TITLE: 'Provide additional feedback (optional)',
        FEEDBACK_CONTENT_PLACEHOLDER: 'Leave a comment',
        BUTTON__REMOVE_FEEDBACK: 'Remove feedback',
        // Feedback failed modal title
        FEEDBACK_FAILED_SUBMIT: 'Couldn’t submit. Try again.',
        FEEDBACK_FAILED_SAVE: 'Couldn’t save. Try again.',
        FEEDBACK_FAILED_DELETE: 'Couldn’t delete. Try again.',
        // Form submit failed error messages
        FORM_ITEM_REQUIRED: 'This field is required',
        FORM_ITEM_INVALID: 'Please check the value',
        FORM_ITEM_OPTIONAL_EMPTY: 'No Response',
    },
};
var getStringSet = function (lang) {
    if (lang === void 0) { lang = 'en'; }
    return stringSet[lang];
};


//# sourceMappingURL=bundle-BPcbf_pM.js.map


/***/ }),

/***/ 85385:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ compressImages; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var _bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81715);



var compressImage = function (_a) {
    var imageFile = _a.imageFile, compressionRate = _a.compressionRate, resizingWidth = _a.resizingWidth, resizingHeight = _a.resizingHeight, outputFormat = _a.outputFormat;
    var image = document.createElement('img');
    return new Promise(function (resolve, reject) {
        image.src = URL.createObjectURL(imageFile);
        image.onerror = reject;
        image.onload = function () {
            URL.revokeObjectURL(image.src);
            var canvas = document.createElement('canvas');
            var originWidth = image.width;
            var originHeight = image.height;
            var targetResizingWidth = (!resizingWidth || resizingWidth > originWidth) ? originWidth : resizingWidth;
            var targetResizingHeight = (!resizingHeight || resizingHeight > originHeight) ? originHeight : resizingHeight;
            var widthRatio = originWidth / targetResizingWidth;
            var heightRatio = originHeight / targetResizingHeight;
            /**
             * Set the target resizing values again with the calculated ratios
             * to use the impactful value, so the original images' ratio won't be broken.
             */
            if (widthRatio > heightRatio) {
                targetResizingHeight = originHeight / (resizingWidth ? widthRatio : 1);
            }
            else if (heightRatio > widthRatio) {
                targetResizingWidth = originWidth / (resizingHeight ? heightRatio : 1);
            }
            canvas.width = targetResizingWidth;
            canvas.height = targetResizingHeight;
            var ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Failed to get canvas 2d context'));
                return;
            }
            ctx.drawImage(image, 0, 0, targetResizingWidth, targetResizingHeight);
            // Change the file.name & file.type for converting file type
            var targetFileType = outputFormat === 'preserve' ? imageFile.type : "image/".concat(outputFormat);
            var targetSubtype = targetFileType.split('/').pop();
            var dotIndex = imageFile.name.lastIndexOf('.');
            // targetName = `fileName.targetSubtype`
            var targetName = "".concat(dotIndex === -1 ? imageFile.name : imageFile.name.substring(0, dotIndex), ".").concat(targetSubtype);
            ctx.canvas.toBlob(function (blob) {
                if (blob) {
                    var file = new File([blob], targetName, { type: targetFileType });
                    resolve(file);
                }
                else {
                    reject(new Error('Failed to compress image'));
                }
            }, targetFileType, compressionRate);
        };
    });
};
var compressImages = function (_a) { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, [_a], void 0, function (_b) {
    var compressionRate, _c, outputFormat, resizingWidth, resizingHeight, result;
    var files = _b.files, logger = _b.logger, imageCompression = _b.imageCompression;
    return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_d) {
        switch (_d.label) {
            case 0:
                compressionRate = imageCompression.compressionRate, _c = imageCompression.outputFormat, outputFormat = _c === void 0 ? 'preserve' : _c;
                resizingWidth = imageCompression.resizingWidth ? (0,_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_1__.p)(imageCompression.resizingWidth) : undefined;
                resizingHeight = imageCompression.resizingHeight ? (0,_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_1__.p)(imageCompression.resizingHeight) : undefined;
                result = {
                    failedIndexes: [],
                    compressedFiles: [],
                };
                if (!(Array.isArray(files) && files.length > 0)) {
                    logger === null || logger === void 0 ? void 0 : logger.warning('utils - compressImages: There are no files.', files);
                    return [2 /*return*/, result];
                }
                if (!compressionRate || compressionRate < 0 || 1 < compressionRate) {
                    logger === null || logger === void 0 ? void 0 : logger.warning('utils - compressImages: The compressionRate is not acceptable.', compressionRate);
                    return [2 /*return*/, result];
                }
                return [4 /*yield*/, Promise.all(files
                        .map(function (file, index) { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
                        var compressedImage, err_1;
                        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg')) {
                                        logger === null || logger === void 0 ? void 0 : logger.warning('utils - compressImages: The fileType is not compressible.', { file: file, index: index });
                                        result.failedIndexes.push(index);
                                        result.compressedFiles.push(file);
                                        return [2 /*return*/];
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, compressImage({
                                            imageFile: file,
                                            compressionRate: compressionRate,
                                            resizingWidth: resizingWidth,
                                            resizingHeight: resizingHeight,
                                            outputFormat: outputFormat,
                                        })];
                                case 2:
                                    compressedImage = _a.sent();
                                    result.compressedFiles.push(compressedImage);
                                    return [3 /*break*/, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    result.compressedFiles.push(file);
                                    result.failedIndexes.push(index);
                                    logger === null || logger === void 0 ? void 0 : logger.warning('utils - compressImages: Failed to compress image file', { file: file, err: err_1 });
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 1:
                _d.sent();
                logger === null || logger === void 0 ? void 0 : logger.info('utils - compressImages: Finished compressing images', result);
                return [2 /*return*/, result];
        }
    });
}); };


//# sourceMappingURL=bundle-BRWtuT59.js.map


/***/ }),

/***/ 95341:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageStatus; }
/* harmony export */ });
/* unused harmony exports a, b, c, d, e, g */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75010);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _ui_Loader_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72661);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8978);
/* harmony import */ var _bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25528);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59587);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80360);












var getChannelTitle = function (channel, currentUserId, stringSet) {
    var _a;
    if (stringSet === void 0) { stringSet = LabelStringSet; }
    if (!(channel === null || channel === void 0 ? void 0 : channel.name) && !(channel === null || channel === void 0 ? void 0 : channel.members)) {
        return stringSet.NO_TITLE;
    }
    if ((channel === null || channel === void 0 ? void 0 : channel.name) && channel.name !== 'Group Channel') {
        return channel.name;
    }
    if (((_a = channel === null || channel === void 0 ? void 0 : channel.members) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        return stringSet.NO_MEMBERS;
    }
    return ((channel === null || channel === void 0 ? void 0 : channel.members) || [])
        .filter(function (_a) {
        var userId = _a.userId;
        return userId !== currentUserId;
    })
        .map(function (_a) {
        var nickname = _a.nickname;
        return nickname || stringSet.NO_NAME;
    })
        .join(', ');
};
var getLastMessageCreatedAt = function (_a) {
    var _b;
    var channel = _a.channel, locale = _a.locale, _c = _a.stringSet, stringSet = _c === void 0 ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.c : _c;
    var createdAt = (_b = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _b === void 0 ? void 0 : _b.createdAt;
    var optionalParam = locale ? { locale: locale } : null;
    if (!createdAt) {
        return '';
    }
    if ((0,_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_8__.i)(createdAt)) {
        return (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__TODAY, optionalParam);
    }
    if ((0,_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_8__.a)(createdAt)) {
        return stringSet.MESSAGE_STATUS__YESTERDAY || 'Yesterday';
    }
    if ((0,_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_8__.b)(createdAt)) {
        return (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__THIS_YEAR, optionalParam);
    }
    return (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__PREVIOUS_YEAR, optionalParam);
};
var getTotalMembers = function (channel) { return ((channel === null || channel === void 0 ? void 0 : channel.memberCount) ? channel.memberCount : 0); };
var getChannelPreviewFileDisplayString = function (mimeType, stringSet) {
    var _a, _b, _c, _d, _e, _f;
    if (stringSet === void 0) { stringSet = LabelStringSet; }
    if (isGif(mimeType)) {
        return (_a = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GIF) !== null && _a !== void 0 ? _a : '';
    }
    if (isImage(mimeType)) {
        return (_b = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_PHOTO) !== null && _b !== void 0 ? _b : '';
    }
    if (isVideo(mimeType)) {
        return (_c = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VIDEO) !== null && _c !== void 0 ? _c : '';
    }
    if (isAudio(mimeType)) {
        return (_d = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_AUDIO) !== null && _d !== void 0 ? _d : '';
    }
    if (isVoiceMessageMimeType(mimeType)) {
        return (_e = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VOICE_MESSAGE) !== null && _e !== void 0 ? _e : '';
    }
    return (_f = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GENERAL) !== null && _f !== void 0 ? _f : '';
};
var getPrettyLastMessage = function (message, stringSet) {
    var _a, _b, _c, _d;
    if (message === void 0) { message = null; }
    if (stringSet === void 0) { stringSet = LabelStringSet; }
    if (!message)
        return '';
    if (isTemplateMessage(message)) {
        return stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_TEMPLATE_MESSAGE;
    }
    if (message.isFileMessage()) {
        return getChannelPreviewFileDisplayString(message.type, stringSet);
    }
    if (message.isMultipleFilesMessage()) {
        var mimeType = (_b = (_a = message.fileInfoList) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.mimeType;
        if (isImage(mimeType) || isGif(mimeType)) {
            return (_c = stringSet === null || stringSet === void 0 ? void 0 : stringSet.CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_PHOTO) !== null && _c !== void 0 ? _c : '';
        }
        return getChannelPreviewFileDisplayString(mimeType, stringSet);
    }
    return (_d = message.message) !== null && _d !== void 0 ? _d : '';
};
var getLastMessageText = function (channel, stringSet) {
    if (stringSet === void 0) { stringSet = LabelStringSet; }
    return (channel === null || channel === void 0 ? void 0 : channel.lastMessage) ? getPrettyLastMessage(channel === null || channel === void 0 ? void 0 : channel.lastMessage, stringSet) : '';
};
var getChannelUnreadMessageCount = function (channel) { return (channel === null || channel === void 0 ? void 0 : channel.unreadMessageCount) ? channel.unreadMessageCount : 0; };

var _a, _b;
var MessageStatusTypes = _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates */ .o;
var iconType = (_a = {},
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.SENT */ .o.SENT] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DONE */ .Qy.DONE,
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.DELIVERED */ .o.DELIVERED] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DONE_ALL */ .Qy.DONE_ALL,
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.READ */ .o.READ] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DONE_ALL */ .Qy.DONE_ALL,
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.FAILED */ .o.FAILED] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.ERROR */ .Qy.ERROR,
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.PENDING */ .o.PENDING] = undefined,
    _a[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.NONE */ .o.NONE] = undefined,
    _a);
var iconColor = (_b = {},
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.SENT */ .o.SENT] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.SENT */ .zo.SENT,
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.DELIVERED */ .o.DELIVERED] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.SENT */ .zo.SENT,
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.READ */ .o.READ] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.READ */ .zo.READ,
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.FAILED */ .o.FAILED] = _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ERROR */ .zo.ERROR,
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.PENDING */ .o.PENDING] = undefined,
    _b[_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.NONE */ .o.NONE] = undefined,
    _b);
function MessageStatus(_a) {
    var _b;
    var className = _a.className, message = _a.message, channel = _a.channel, _c = _a.isDateSeparatorConsidered, isDateSeparatorConsidered = _c === void 0 ? true : _c;
    var _d = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__.u)(), stringSet = _d.stringSet, dateLocale = _d.dateLocale;
    var status = (0,_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .getOutgoingMessageState */ .$)(channel, message);
    var hideMessageStatusIcon = ((_b = channel === null || channel === void 0 ? void 0 : channel.isGroupChannel) === null || _b === void 0 ? void 0 : _b.call(channel)) && ((channel.isSuper || channel.isPublic || channel.isBroadcast)
        && !(status === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.PENDING */ .o.PENDING || status === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.FAILED */ .o.FAILED));
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-message-status',
        ], false).join(' ') },
        (status === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.PENDING */ .o.PENDING) ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Loader_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { className: "sendbird-message-status__icon", testID: "sendbird-message-status-icon", width: "16px", height: "16px" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.SPINNER */ .Qy.SPINNER, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "16px", height: "16px" }))) : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_10__.c)('sendbird-message-status__icon', hideMessageStatusIcon && 'hide-icon', status !== _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__/* .OutgoingMessageStates.FAILED */ .o.FAILED && 'sendbird-message-status--sent'), testID: "sendbird-message-status-icon", type: iconType[status] || _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.ERROR */ .Qy.ERROR, fillColor: iconColor[status], width: "16px", height: "16px" })),
        (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.F)(status) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-message-status__text", testID: "sendbird-message-status-text", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.CAPTION_3, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, isDateSeparatorConsidered
            ? (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)((message === null || message === void 0 ? void 0 : message.createdAt) || 0, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, { locale: dateLocale })
            : getLastMessageCreatedAt({ channel: channel, locale: dateLocale, stringSet: stringSet })))));
}


//# sourceMappingURL=bundle-BX_znRDF.js.map


/***/ }),

/***/ 15880:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TypingIndicatorType; }
/* harmony export */ });
var TypingIndicatorType;
(function (TypingIndicatorType) {
    TypingIndicatorType["Text"] = "text";
    TypingIndicatorType["Bubble"] = "bubble";
})(TypingIndicatorType || (TypingIndicatorType = {}));


//# sourceMappingURL=bundle-BY9N9Qg0.js.map


/***/ }),

/***/ 30302:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ isDisabledBecauseMuted; },
/* harmony export */   "b": function() { return /* binding */ isDisabledBecauseSuggestedReplies; },
/* harmony export */   "c": function() { return /* binding */ isDisabledBecauseMessageForm; },
/* harmony export */   "d": function() { return /* binding */ isContextMenuClosed; },
/* harmony export */   "e": function() { return /* binding */ getMessageTopOffset; },
/* harmony export */   "f": function() { return /* binding */ isFormVersionCompatible; },
/* harmony export */   "g": function() { return /* binding */ getComponentKeyFromMessage; },
/* harmony export */   "i": function() { return /* binding */ isDisabledBecauseFrozen; }
/* harmony export */ });
/* harmony import */ var _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48614);


function getComponentKeyFromMessage(message) {
    if ('sendingStatus' in message) {
        if (message.sendingStatus === 'succeeded')
            return String(message.messageId);
        return message.reqId;
    }
    return String(message.messageId);
}
function isContextMenuClosed() {
    var _a, _b;
    return (((_a = document.getElementById('sendbird-dropdown-portal')) === null || _a === void 0 ? void 0 : _a.childElementCount) === 0
        && ((_b = document.getElementById('sendbird-emoji-list-portal')) === null || _b === void 0 ? void 0 : _b.childElementCount) === 0);
}
function getMessageTopOffset(messageCreatedAt) {
    var _a;
    var element = (_a = document.querySelectorAll("[data-sb-created-at=\"".concat(messageCreatedAt, "\"]"))) === null || _a === void 0 ? void 0 : _a[0];
    if (element instanceof HTMLElement) {
        return element.offsetTop;
    }
    return null;
}
var isDisabledBecauseFrozen = function (groupChannel) {
    if (!groupChannel)
        return false;
    return groupChannel.isFrozen && groupChannel.myRole !== 'operator';
};
var isDisabledBecauseMuted = function (groupChannel) {
    if (!groupChannel)
        return false;
    return groupChannel.myMutedState === 'muted';
};
var isDisabledBecauseSuggestedReplies = function (channel, enableSuggestedReplies) {
    var _a, _b, _c, _d;
    return enableSuggestedReplies
        && Array.isArray((_b = (_a = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _a === void 0 ? void 0 : _a.extendedMessagePayload) === null || _b === void 0 ? void 0 : _b.suggested_replies)
        && !!((_d = (_c = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _c === void 0 ? void 0 : _c.extendedMessagePayload) === null || _d === void 0 ? void 0 : _d.disable_chat_input);
};
var isFormVersionCompatible = function (version) {
    return version <= _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_0__.U;
};
var isDisabledBecauseMessageForm = function (allMessages, enableFormTypeMessage) {
    return enableFormTypeMessage
        && allMessages.some(function (message) {
            var _a;
            return (!!message.messageForm
                && !message.messageForm.isSubmitted
                && !!((_a = message.extendedMessagePayload) === null || _a === void 0 ? void 0 : _a.disable_chat_input)
                && isFormVersionCompatible(message.messageForm.version));
        });
};


//# sourceMappingURL=bundle-BaMsxnN_.js.map


/***/ }),

/***/ 13160:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useHTMLTextDirection; },
/* harmony export */   "u": function() { return /* binding */ useMessageLayoutDirection; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69466);



var useHTMLTextDirection = function (direction) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        /**
         * It sets the 'dir' attribute of the closest parent <div> element of the element with VOICE_PLAYER_ROOT_ID cause:
         * - An empty <div> element is created in the VoiceMessageProvider, which is the highest-level <div> element within the SendbirdProvider.
         * - It tries to find the nearest parent <div> element within the SendbirdProvider and sets 'dir' attribute,
         * ensuring that the directionality is applied correctly.
         * */
        var targetElement = document.getElementById(_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_1__.V);
        targetElement.parentElement.dir = direction;
    }, [direction]);
};
var useMessageLayoutDirection = function (direction, forceLeftToRightMessageLayout, loading) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (loading)
            return;
        var messageListElements = document.getElementsByClassName('sendbird-conversation__messages');
        if (messageListElements.length > 0) {
            Array.from(messageListElements).forEach(function (elem) {
                elem.dir = forceLeftToRightMessageLayout
                    ? 'ltr'
                    : direction;
            });
        }
    }, [direction, forceLeftToRightMessageLayout, loading]);
};


//# sourceMappingURL=bundle-BbVJcZ9w.js.map


/***/ }),

/***/ 88221:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Role; }
/* harmony export */ });
// note to SDK team:
// using enum inside .d.ts won’t work for jest, but const enum will work.
var Role = {
    OPERATOR: 'operator',
    NONE: 'none',
};


//# sourceMappingURL=bundle-BdZX50Kw.js.map


/***/ }),

/***/ 81715:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ pxToNumber; }
/* harmony export */ });
var pxToNumber = function (px) {
    if (typeof px === 'number') {
        return px;
    }
    if (typeof px === 'string') {
        var parsed = Number.parseFloat(px);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }
    return NaN;
};


//# sourceMappingURL=bundle-BdwvjJsK.js.map


/***/ }),

/***/ 24354:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RemoveMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17693);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88569);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59587);
/* harmony import */ var _Thread_context_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31723);
/* harmony import */ var _bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44892);









var RemoveMessage = function (props) {
    var _a, _b;
    var onCancel = props.onCancel, onSubmit = props.onSubmit, message = props.message;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__.L).stringSet;
    var deleteMessage = (0,_Thread_context_js__WEBPACK_IMPORTED_MODULE_6__/* .useThreadContext */ .i)().deleteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_1__.M, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_4__/* .ButtonTypes.DANGER */ .qh.DANGER, disabled: ((_b = (_a = message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) !== null && _b !== void 0 ? _b : 0) > 0, onCancel: onCancel, onSubmit: function () {
            deleteMessage(message).then(function () {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
            });
        }, submitText: stringSet.MESSAGE_MENU__DELETE, titleText: (0,_bundle_B8L7dGsu_js__WEBPACK_IMPORTED_MODULE_7__.g)(stringSet, message) }));
};


//# sourceMappingURL=bundle-BkDHtL7_.js.map


/***/ }),

/***/ 13195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ OG_MESSAGE_BODY_CLASSNAME; }
/* harmony export */ });
var OG_MESSAGE_BODY_CLASSNAME = 'sendbird-og-message-item-body__text-bubble';


//# sourceMappingURL=bundle-BmHwyA9G.js.map


/***/ }),

/***/ 48609:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ GroupChannelHeaderView; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _ui_ChannelAvatar_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80203);
/* harmony import */ var _bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11639);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26765);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41238);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _ui_Header_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56210);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80360);











var GroupChannelHeaderView = function (_a) {
    var className = _a.className, currentChannel = _a.currentChannel, showSearchIcon = _a.showSearchIcon, onBackClick = _a.onBackClick, onSearchClick = _a.onSearchClick, onChatHeaderActionClick = _a.onChatHeaderActionClick, 
    // Header custom props
    renderLeft = _a.renderLeft, renderMiddle = _a.renderMiddle, renderRight = _a.renderRight;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_6__/* .useSendbirdStateContext */ .A)().config;
    var userId = config.userId, theme = config.theme;
    var isMobile = (0,_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_5__.u)().isMobile;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var isMuted = (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myMutedState) === 'muted';
    var channelTitle = (0,_bundle_CgymNuYl_js__WEBPACK_IMPORTED_MODULE_4__.g)(currentChannel, userId, stringSet);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-chat-header', className), renderLeft: renderLeft !== null && renderLeft !== void 0 ? renderLeft : (function () { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            isMobile && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Icon */ .ZP.Icon, { className: "sendbird-chat-header__icon_back", onClick: onBackClick, type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.ARROW_LEFT */ .Qy.ARROW_LEFT, color: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_ChannelAvatar_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { theme: theme, channel: currentChannel, userId: userId, height: 32, width: 32 }))); }), renderMiddle: renderMiddle !== null && renderMiddle !== void 0 ? renderMiddle : (function () { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .ZP.Title, { title: channelTitle })); }), renderRight: renderRight !== null && renderRight !== void 0 ? renderRight : (function () { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            isMuted && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Icon */ .ZP.Icon, { className: "sendbird-chat-header__right__mute", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.NOTIFICATIONS_OFF_FILLED */ .Qy.NOTIFICATIONS_OFF_FILLED, color: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "24px", height: "24px" })),
            (showSearchIcon && !(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isEphemeral)) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].IconButton */ .ZP.IconButton, { className: "sendbird-chat-header__right__search", onClick: onSearchClick, type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.SEARCH */ .Qy.SEARCH, color: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.PRIMARY */ .zo.PRIMARY, renderIcon: function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Icon */ .ZP.Icon, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { width: "24px", height: "24px" })); } })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].IconButton */ .ZP.IconButton, { className: "sendbird-chat-header__right__info", onClick: onChatHeaderActionClick, type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.INFO */ .Qy.INFO, color: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.PRIMARY */ .zo.PRIMARY, renderIcon: function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Header_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Icon */ .ZP.Icon, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { width: "24px", height: "24px" })); } }))); }) }));
};


//# sourceMappingURL=bundle-BpNhTt2R.js.map


/***/ }),

/***/ 88071:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ uuidv4; }
/* harmony export */ });
/* eslint-disable no-bitwise */
/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
// https://stackoverflow.com/a/2117523
// used mainly for dom key generation
var uuidv4 = function () { return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
}); };


//# sourceMappingURL=bundle-Bq93DTET.js.map


/***/ }),

/***/ 46776:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ UserProfileProvider; },
/* harmony export */   "u": function() { return /* binding */ useUserProfileContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65614);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71091);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17693);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90832);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26765);
/* harmony import */ var _bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16167);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73935);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41238);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29515);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99366);



















/**
 * user profile goes deep inside the component tree
 * use this context as a short circuit to send in values
 */
var UserProfileContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    disableUserProfile: true,
    isOpenChannel: false,
});
var useUserProfileContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(UserProfileContext); };
var UserProfileProvider = function (_a) {
    var _b;
    var _c = _a.isOpenChannel, isOpenChannel = _c === void 0 ? false : _c, _d = _a.disableUserProfile, _disableUserProfile = _d === void 0 ? false : _d, _renderUserProfile = _a.renderUserProfile, _onUserProfileMessage = _a.onUserProfileMessage, _onStartDirectMessage = _a.onStartDirectMessage, children = _a.children;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_11__/* .useSendbirdStateContext */ .A)().config;
    var onStartDirectMessage = (_b = _onStartDirectMessage !== null && _onStartDirectMessage !== void 0 ? _onStartDirectMessage : _onUserProfileMessage) !== null && _b !== void 0 ? _b : config.onStartDirectMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserProfileContext.Provider, { value: {
            isOpenChannel: isOpenChannel,
            disableUserProfile: _disableUserProfile !== null && _disableUserProfile !== void 0 ? _disableUserProfile : !config.common.enableUsingDefaultUserProfile,
            renderUserProfile: _renderUserProfile !== null && _renderUserProfile !== void 0 ? _renderUserProfile : config.renderUserProfile,
            onStartDirectMessage: onStartDirectMessage,
            /** legacy of onStartDirectMessage */
            onUserProfileMessage: onStartDirectMessage,
        } }, children));
};


//# sourceMappingURL=bundle-Bv8KtnvF.js.map


/***/ }),

/***/ 48614:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MAX_USER_MENTION_COUNT; },
/* harmony export */   "T": function() { return /* binding */ ThreadReplySelectType; },
/* harmony export */   "U": function() { return /* binding */ UIKIT_COMPATIBLE_FORM_VERSION; },
/* harmony export */   "a": function() { return /* binding */ USER_MENTION_TEMP_CHAR; },
/* harmony export */   "b": function() { return /* binding */ MAX_USER_SUGGESTION_COUNT; }
/* harmony export */ });
var MAX_USER_MENTION_COUNT = 10;
var MAX_USER_SUGGESTION_COUNT = 15;
var USER_MENTION_TEMP_CHAR = '@';
var UIKIT_COMPATIBLE_FORM_VERSION = 1;
var ThreadReplySelectType;
(function (ThreadReplySelectType) {
    ThreadReplySelectType["PARENT"] = "PARENT";
    ThreadReplySelectType["THREAD"] = "THREAD";
})(ThreadReplySelectType || (ThreadReplySelectType = {}));


//# sourceMappingURL=bundle-C6DfLTJj.js.map


/***/ }),

/***/ 13566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getNicknamesMapFromMembers; },
/* harmony export */   "c": function() { return /* binding */ compareIds; },
/* harmony export */   "g": function() { return /* binding */ getParentMessageFrom; },
/* harmony export */   "i": function() { return /* binding */ isAboutSame; },
/* harmony export */   "s": function() { return /* binding */ scrollIntoLast; },
/* harmony export */   "u": function() { return /* binding */ useSendMultipleFilesMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80031);
/* harmony import */ var _bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18107);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8978);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69466);







var getNicknamesMapFromMembers = function (members) {
    if (members === void 0) { members = []; }
    var nicknamesMap = new Map();
    for (var memberIndex = 0; memberIndex < members.length; memberIndex += 1) {
        var _a = members[memberIndex], userId = _a.userId, nickname = _a.nickname;
        nicknamesMap.set(userId, nickname);
    }
    return nicknamesMap;
};
var getParentMessageFrom = function (message) {
    if (!message) {
        return null;
    }
    if (isParentMessage(message)) {
        return message;
    }
    if (isThreadMessage(message)) {
        return (message === null || message === void 0 ? void 0 : message.parentMessage) || null;
    }
    return null;
};
var isParentMessage = function (message) {
    return ((message === null || message === void 0 ? void 0 : message.parentMessage) === null
        && typeof (message === null || message === void 0 ? void 0 : message.parentMessageId) === 'number'
        && !(message === null || message === void 0 ? void 0 : message.parentMessageId));
};
var isThreadMessage = function (message) {
    return ((message === null || message === void 0 ? void 0 : message.parentMessage) !== null
        && typeof (message === null || message === void 0 ? void 0 : message.parentMessageId) === 'number'
        && (message === null || message === void 0 ? void 0 : message.parentMessageId) > 0
        && (message === null || message === void 0 ? void 0 : message.threadInfo) === null);
};
var isAboutSame = function (a, b, px) { return (Math.abs(a - b) <= px); };
var isEmpty = function (val) { return (val === null || val === undefined); };
// Some Ids return string and number inconsistently
// only use to comapre IDs
function compareIds(a, b) {
    if (isEmpty(a) || isEmpty(b)) {
        return false;
    }
    var aString = a.toString();
    var bString = b.toString();
    return aString === bString;
}
var scrollIntoLast = function (intialTry) {
    if (intialTry === void 0) { intialTry = 0; }
    var MAX_TRIES = 10;
    var currentTry = intialTry;
    if (currentTry > MAX_TRIES) {
        return;
    }
    try {
        var scrollDOM = document.querySelector('.sendbird-thread-ui--scroll');
        // eslint-disable-next-line no-multi-assign
        if (scrollDOM) {
            scrollDOM.scrollTop = scrollDOM.scrollHeight;
        }
    }
    catch (error) {
        setTimeout(function () {
            scrollIntoLast(currentTry + 1);
        }, 500 * currentTry);
    }
};

/**
 * pubSub is used instead of messagesDispatcher to avoid redundantly calling
 * because this useSendMultipleFilesMessage is used in the Channel and Thread both
 */
var useSendMultipleFilesMessage = function (_a, _b) {
    var currentChannel = _a.currentChannel, onBeforeSendMultipleFilesMessage = _a.onBeforeSendMultipleFilesMessage, publishingModules = _a.publishingModules;
    var logger = _b.logger, pubSub = _b.pubSub, scrollRef = _b.scrollRef;
    var sendMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (files, quoteMessage) {
        return new Promise(function (resolve, reject) {
            if (!currentChannel) {
                logger.warning('Channel: Sending MFm failed, because currentChannel is null.', { currentChannel: currentChannel });
                reject();
            }
            if (files.length <= 1) {
                logger.warning('Channel: Sending MFM failed, because there are no multiple files.', { files: files });
                reject();
            }
            var messageParams = {
                fileInfoList: files.map(function (file) { return ({
                    file: file,
                    fileName: file.name,
                    fileSize: file.size,
                    mimeType: file.type,
                }); }),
            };
            if (quoteMessage) {
                messageParams.isReplyToChannel = true;
                messageParams.parentMessageId = quoteMessage.messageId;
            }
            if (typeof onBeforeSendMultipleFilesMessage === 'function') {
                messageParams = onBeforeSendMultipleFilesMessage(files, quoteMessage);
            }
            logger.info('Channel: Start sending MFM', { messageParams: messageParams });
            try {
                currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendMultipleFilesMessage(messageParams).onFileUploaded(function (requestId, index, uploadableFileInfo, error) {
                    logger.info('Channel: onFileUploaded during sending MFM', {
                        requestId: requestId,
                        index: index,
                        error: error,
                        uploadableFileInfo: uploadableFileInfo,
                    });
                    pubSub.publish(_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.p.ON_FILE_INFO_UPLOADED, {
                        response: {
                            channelUrl: currentChannel.url,
                            requestId: requestId,
                            index: index,
                            uploadableFileInfo: uploadableFileInfo,
                            error: error,
                        },
                        publishingModules: publishingModules,
                    });
                }).onPending(function (pendingMessage) {
                    logger.info('Channel: in progress of sending MFM', { pendingMessage: pendingMessage, fileInfoList: messageParams.fileInfoList });
                    pubSub.publish(_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.p.SEND_MESSAGE_START, {
                        message: pendingMessage,
                        channel: currentChannel,
                        publishingModules: publishingModules,
                    });
                    setTimeout(function () {
                        if (scrollRef && (0,_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.s)(publishingModules)) {
                            (0,_bundle_CtcQd9Ql_js__WEBPACK_IMPORTED_MODULE_2__.s)(0, scrollRef);
                        }
                        if ((0,_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.a)(publishingModules)) {
                            scrollIntoLast(0);
                        }
                    }, _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_5__.e);
                }).onFailed(function (error, failedMessage) {
                    logger.error('Channel: Sending MFM failed.', { error: error, failedMessage: failedMessage });
                    pubSub.publish(_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.p.SEND_MESSAGE_FAILED, {
                        channel: currentChannel,
                        message: failedMessage,
                        publishingModules: publishingModules,
                    });
                    reject(error);
                }).onSucceeded(function (succeededMessage) {
                    logger.info('Channel: Sending voice message success!', { succeededMessage: succeededMessage });
                    pubSub.publish(_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_1__.p.SEND_FILE_MESSAGE, {
                        channel: currentChannel,
                        message: succeededMessage,
                        publishingModules: publishingModules,
                    });
                    resolve(succeededMessage);
                });
            }
            catch (error) {
                logger.error('Channel: Sending MFM failed.', { error: error });
                reject(error);
            }
        });
    }, [
        currentChannel,
        onBeforeSendMultipleFilesMessage,
        publishingModules,
    ]);
    return [sendMessage];
};


//# sourceMappingURL=bundle-CDvkkTNs.js.map


/***/ }),

/***/ 86694:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageView; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75010);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48614);
/* harmony import */ var _bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30302);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66421);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6623);
/* harmony import */ var _ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8743);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99366);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65134);
/* harmony import */ var _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(459);
/* harmony import */ var _ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3533);
/* harmony import */ var _GroupChannel_components_SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52597);
/* harmony import */ var _bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12225);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80360);


















var useDidMountEffect = function (func, deps) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), didMount = _a[0], setDidmount = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (didMount) {
            func();
        }
        else {
            setDidmount(true);
        }
    }, deps);
};

// TODO: Refactor this component, is too complex now
var MessageView = function (props) {
    var _a, _b;
    var 
    // MessageProps
    message = props.message, children = props.children, hasSeparator = props.hasSeparator, chainTop = props.chainTop, chainBottom = props.chainBottom, handleScroll = props.handleScroll, 
    // MessageViewProps
    channel = props.channel, emojiContainer = props.emojiContainer, editInputDisabled = props.editInputDisabled, shouldRenderSuggestedReplies = props.shouldRenderSuggestedReplies, isReactionEnabled = props.isReactionEnabled, replyType = props.replyType, threadReplySelectType = props.threadReplySelectType, nicknamesMap = props.nicknamesMap, scrollToMessage = props.scrollToMessage, toggleReaction = props.toggleReaction, setQuoteMessage = props.setQuoteMessage, onQuoteMessageClick = props.onQuoteMessageClick, onReplyInThreadClick = props.onReplyInThreadClick, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, sendUserMessage = props.sendUserMessage, updateUserMessage = props.updateUserMessage, resendMessage = props.resendMessage, deleteMessage = props.deleteMessage, setAnimatedMessageId = props.setAnimatedMessageId, animatedMessageId = props.animatedMessageId, onMessageAnimated = props.onMessageAnimated, _c = props.usedInLegacy, usedInLegacy = _c === void 0 ? true : _c;
    var _d = (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_16__.d)(props), renderUserMentionItem = _d.renderUserMentionItem, renderMessage = _d.renderMessage, _e = _d.renderMessageContent, renderMessageContent = _e === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageContent_js__WEBPACK_IMPORTED_MODULE_13__/* .MessageContent */ .En, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _e, _f = _d.renderSuggestedReplies, renderSuggestedReplies = _f === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GroupChannel_components_SuggestedReplies_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _f, renderCustomSeparator = _d.renderCustomSeparator, renderEditInput = _d.renderEditInput, renderFileViewer = _d.renderFileViewer, renderRemoveMessageModal = _d.renderRemoveMessageModal, filterEmojiCategoryIds = _d.filterEmojiCategoryIds;
    var _g = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.u)(), dateLocale = _g.dateLocale, stringSet = _g.stringSet;
    var globalStore = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useSendbirdStateContext */ .A)();
    var _h = globalStore.config, userId = _h.userId, isOnline = _h.isOnline, userMention = _h.userMention, logger = _h.logger, groupChannel = _h.groupChannel;
    var maxUserMentionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_5__.M;
    var maxUserSuggestionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_5__.b;
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showEdit = _j[0], setShowEdit = _j[1];
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showRemove = _k[0], setShowRemove = _k[1];
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFileViewer = _l[0], setShowFileViewer = _l[1];
    var _m = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAnimated = _m[0], setIsAnimated = _m[1];
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), mentionNickname = _o[0], setMentionNickname = _o[1];
    var _p = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUsers = _p[0], setMentionedUsers = _p[1];
    var _q = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _q[0], setMentionedUserIds = _q[1];
    var _r = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), messageInputEvent = _r[0], setMessageInputEvent = _r[1];
    var _s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedUser = _s[0], setSelectedUser = _s[1];
    var _t = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionSuggestedUsers = _t[0], setMentionSuggestedUsers = _t[1];
    var editMessageInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var messageScrollRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var displaySuggestedMentionList = isOnline
        && groupChannel.enableMention && mentionNickname.length > 0
        && !(0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__.i)(channel)
        && !(0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_6__.a)(channel);
    var mentionNodes = (0,_Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_7__/* .useDirtyGetMentions */ .X)({ ref: editMessageInputRef }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < maxUserMentionCount;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    // Side effect: scroll position update when showEdit is toggled or reactions updated
    useDidMountEffect(function () {
        handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll();
    }, [showEdit, (_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.length]);
    // Side effect: scroll position update when message updated
    useDidMountEffect(function () {
        handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll(true);
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    // Side effect: scroll position update when suggested replies are rendered or hidden
    var prevShouldRenderSuggestedReplies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(shouldRenderSuggestedReplies);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (prevShouldRenderSuggestedReplies.current !== shouldRenderSuggestedReplies) {
            handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll();
        }
        else {
            prevShouldRenderSuggestedReplies.current = shouldRenderSuggestedReplies;
        }
    }, [shouldRenderSuggestedReplies]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        // Keep the scrollBottom value after fetching new message list (but GroupChannel module is not needed.)
        if (usedInLegacy)
            handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        var timeouts = [];
        if (animatedMessageId === message.messageId && (messageScrollRef === null || messageScrollRef === void 0 ? void 0 : messageScrollRef.current)) {
            timeouts.push(setTimeout(function () {
                setIsAnimated(true);
            }, 500));
            timeouts.push(setTimeout(function () {
                setAnimatedMessageId(null);
                onMessageAnimated === null || onMessageAnimated === void 0 ? void 0 : onMessageAnimated();
            }, 1600));
        }
        else {
            setIsAnimated(false);
        }
        return function () {
            timeouts.forEach(function (it) { return clearTimeout(it); });
        };
    }, [animatedMessageId, messageScrollRef.current, message.messageId]);
    var renderedCustomSeparator = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { var _a; return (_a = renderCustomSeparator === null || renderCustomSeparator === void 0 ? void 0 : renderCustomSeparator({ message: message })) !== null && _a !== void 0 ? _a : null; }, [message, renderCustomSeparator]);
    var renderChildren = function () {
        if (children) {
            return children;
        }
        if (renderMessage) {
            var messageProps = (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), { renderMessage: undefined });
            return renderMessage(messageProps);
        }
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            renderMessageContent({
                className: 'sendbird-message-hoc__message-content',
                userId: userId,
                scrollToMessage: scrollToMessage,
                channel: channel,
                message: message,
                disabled: !isOnline,
                chainTop: chainTop,
                chainBottom: chainBottom,
                isReactionEnabled: isReactionEnabled,
                replyType: replyType,
                threadReplySelectType: threadReplySelectType,
                nicknamesMap: nicknamesMap,
                emojiContainer: emojiContainer,
                showEdit: setShowEdit,
                showRemove: setShowRemove,
                showFileViewer: setShowFileViewer,
                resendMessage: resendMessage,
                deleteMessage: deleteMessage,
                toggleReaction: toggleReaction,
                setQuoteMessage: setQuoteMessage,
                onReplyInThread: onReplyInThreadClick,
                onQuoteMessageClick: onQuoteMessageClick,
                onMessageHeightChange: handleScroll,
                onBeforeDownloadFileMessage: onBeforeDownloadFileMessage,
                filterEmojiCategoryIds: filterEmojiCategoryIds,
            }),
            shouldRenderSuggestedReplies && renderSuggestedReplies({
                replyOptions: (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_8__.g)(message),
                onSendMessage: sendUserMessage,
                type: groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.suggestedRepliesDirection,
            }),
            showRemove && (renderRemoveMessageModal === null || renderRemoveMessageModal === void 0 ? void 0 : renderRemoveMessageModal({ message: message, onCancel: function () { return setShowRemove(false); } })),
            showFileViewer && renderFileViewer({ message: message, onCancel: function () { return setShowFileViewer(false); } })));
    };
    if (showEdit && ((_b = message === null || message === void 0 ? void 0 : message.isUserMessage) === null || _b === void 0 ? void 0 : _b.call(message))) {
        return ((renderEditInput === null || renderEditInput === void 0 ? void 0 : renderEditInput()) || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            displaySuggestedMentionList && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_15__.S, { currentChannel: channel, targetNickname: mentionNickname, inputEvent: messageInputEvent !== null && messageInputEvent !== void 0 ? messageInputEvent : undefined, renderUserMentionItem: renderUserMentionItem, onUserItemClick: function (user) {
                    if (user) {
                        setMentionedUsers((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], mentionedUsers, true), [user], false));
                    }
                    setMentionNickname('');
                    setSelectedUser(user);
                    setMessageInputEvent(null);
                }, onFocusItemChange: function () {
                    setMessageInputEvent(null);
                }, onFetchUsers: function (users) {
                    setMentionSuggestedUsers(users);
                }, ableAddMention: ableMention, maxMentionCount: maxUserMentionCount, maxSuggestionCount: maxUserSuggestionCount })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { isEdit: true, channel: channel, disabled: editInputDisabled, ref: editMessageInputRef, mentionSelectedUser: selectedUser, isMentionEnabled: groupChannel.enableMention, message: message, onStartTyping: function () {
                    var _a;
                    (_a = channel === null || channel === void 0 ? void 0 : channel.startTyping) === null || _a === void 0 ? void 0 : _a.call(channel);
                }, onUpdateMessage: function (_a) {
                    var _b;
                    var messageId = _a.messageId, message = _a.message, mentionTemplate = _a.mentionTemplate;
                    updateUserMessage(messageId, {
                        message: message,
                        mentionedUsers: mentionedUsers,
                        mentionedMessageTemplate: mentionTemplate,
                    });
                    setShowEdit(false);
                    (_b = channel === null || channel === void 0 ? void 0 : channel.endTyping) === null || _b === void 0 ? void 0 : _b.call(channel);
                }, onCancelEdit: function () {
                    var _a;
                    setMentionNickname('');
                    setMentionedUsers([]);
                    setMentionedUserIds([]);
                    setMentionSuggestedUsers([]);
                    setShowEdit(false);
                    (_a = channel === null || channel === void 0 ? void 0 : channel.endTyping) === null || _a === void 0 ? void 0 : _a.call(channel);
                }, onUserMentioned: function (user) {
                    if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                        setSelectedUser(null);
                        setMentionNickname('');
                    }
                }, onMentionStringChange: function (mentionText) {
                    setMentionNickname(mentionText);
                }, onMentionedUserIdsUpdated: function (userIds) {
                    setMentionedUserIds(userIds);
                }, onKeyDown: function (e) {
                    if (displaySuggestedMentionList
                        && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                        && ((e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_12__.M.Enter && ableMention)
                            || e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_12__.M.ArrowUp
                            || e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_12__.M.ArrowDown)) {
                        setMessageInputEvent(e);
                        return true;
                    }
                    return false;
                } }))));
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_16__.c)('sendbird-msg-hoc sendbird-msg--scroll-ref', isAnimated && 'sendbird-msg-hoc__animated'), "data-testid": "sendbird-message-view", style: children || renderMessage ? undefined : { marginBottom: '2px' }, "data-sb-message-id": message.messageId, "data-sb-created-at": message.createdAt, ref: messageScrollRef },
        hasSeparator
            && (renderedCustomSeparator || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_DateSeparator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, null,
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_10__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_10__.a.CAPTION_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_10__.b.ONBACKGROUND_2 }, (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)(message.createdAt, stringSet.DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR, {
                    locale: dateLocale,
                }))))),
        renderChildren()));
};


//# sourceMappingURL=bundle-CJirTNRH.js.map


/***/ }),

/***/ 22280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ GroupChannelUIView; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41238);
/* harmony import */ var _GroupChannel_components_TypingIndicator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42443);
/* harmony import */ var _bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15880);
/* harmony import */ var _ui_ConnectionStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55922);
/* harmony import */ var _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10364);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80360);








var GroupChannelUIView = function (props) {
    var _a, _b, _c, _d;
    var isLoading = props.isLoading, isInvalid = props.isInvalid, channelUrl = props.channelUrl;
    var _e = (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_6__.d)(props), renderChannelHeader = _e.renderChannelHeader, renderMessageList = _e.renderMessageList, renderMessageInput = _e.renderMessageInput, renderTypingIndicator = _e.renderTypingIndicator, renderPlaceholderLoader = _e.renderPlaceholderLoader, renderPlaceholderInvalid = _e.renderPlaceholderInvalid;
    var _f = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useSendbirdStateContext */ .A)(), stores = _f.stores, config = _f.config;
    var sdkError = (_a = stores === null || stores === void 0 ? void 0 : stores.sdkStore) === null || _a === void 0 ? void 0 : _a.error;
    var logger = config.logger, isOnline = config.isOnline;
    // Note: This is not a loading status of the message list.
    //  It is just for custom props from the Channel module and is not used in the GroupChannel module. (We should remove this in v4)
    if (isLoading) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderLoader === null || renderPlaceholderLoader === void 0 ? void 0 : renderPlaceholderLoader()) || react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.LOADING */ .v.LOADING }));
    }
    if (!channelUrl) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.NO_CHANNELS */ .v.NO_CHANNELS })));
    }
    if (isInvalid) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.WRONG */ .v.WRONG }));
    }
    if (sdkError) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { type: _ui_PlaceHolder_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceHolderTypes.WRONG */ .v.WRONG, retryToConnect: function () {
                logger.info('Channel: reconnecting');
                // reconnect();
            } }))));
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation" }, renderChannelHeader === null || renderChannelHeader === void 0 ? void 0 :
        renderChannelHeader({ className: 'sendbird-conversation__channel-header' }), renderMessageList === null || renderMessageList === void 0 ? void 0 :
        renderMessageList(props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation__footer" }, renderMessageInput === null || renderMessageInput === void 0 ? void 0 :
            renderMessageInput(),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-conversation__footer__typing-indicator" },
                (renderTypingIndicator === null || renderTypingIndicator === void 0 ? void 0 : renderTypingIndicator())
                    || (((_b = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _b === void 0 ? void 0 : _b.enableTypingIndicator) && ((_d = (_c = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _c === void 0 ? void 0 : _c.typingIndicatorTypes) === null || _d === void 0 ? void 0 : _d.has(_bundle_BY9N9Qg0_js__WEBPACK_IMPORTED_MODULE_3__.T.Text)) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_GroupChannel_components_TypingIndicator_js__WEBPACK_IMPORTED_MODULE_2__/* .TypingIndicator */ .c2, { channelUrl: channelUrl }))),
                !isOnline && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_ConnectionStatus_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null)))));
};


//# sourceMappingURL=bundle-CLczesce.js.map


/***/ }),

/***/ 459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageInputKeys; },
/* harmony export */   "N": function() { return /* binding */ NodeTypes; },
/* harmony export */   "a": function() { return /* binding */ NodeNames; }
/* harmony export */ });
var MessageInputKeys = {
    Enter: 'Enter',
    ArrowUp: 'ArrowUp',
    ArrowDown: 'ArrowDown',
    Backspace: 'Backspace',
};
var NodeTypes = {
    ElementNode: 1,
    TextNode: 3,
};
var NodeNames = {
    Span: 'SPAN',
    Br: 'BR',
    Div: 'DIV',
};


//# sourceMappingURL=bundle-CLlCJbe7.js.map


/***/ }),

/***/ 12225:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SuggestedMentionListView; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82314);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88071);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80360);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41238);
/* harmony import */ var _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48614);
/* harmony import */ var _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(459);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65614);












function SuggestedUserMentionItem(props) {
    var member = props.member, _a = props.isFocused, isFocused = _a === void 0 ? false : _a, parentScrollRef = props.parentScrollRef, onClick = props.onClick, onMouseOver = props.onMouseOver, onMouseMove = props.onMouseMove, renderUserMentionItem = props.renderUserMentionItem;
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.L).stringSet;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isFocused && (parentScrollRef === null || parentScrollRef === void 0 ? void 0 : parentScrollRef.current) != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) != null
            && (parentScrollRef.current.scrollTop >= scrollRef.current.offsetTop
                || parentScrollRef.current.scrollTop + parentScrollRef.current.clientHeight <= scrollRef.current.offsetTop)) {
            scrollRef.current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    }, [isFocused]);
    var customMentionItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (renderUserMentionItem) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-mention-suggest-list__user-item", onClick: function (event) { return onClick === null || onClick === void 0 ? void 0 : onClick({ event: event, member: member, itemRef: scrollRef }); }, onMouseOver: function (event) { return onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver({ event: event, member: member, itemRef: scrollRef }); }, onMouseMove: function (event) { return onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove({ event: event, member: member, itemRef: scrollRef }); }, key: (member === null || member === void 0 ? void 0 : member.userId) || (0,_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_9__.u)(), ref: scrollRef }, renderUserMentionItem({ user: member })));
        }
    }, [renderUserMentionItem]);
    if (customMentionItem) {
        return customMentionItem;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_10__.c)('sendbird-mention-suggest-list__user-item', isFocused && 'focused'), onClick: function (event) { return onClick === null || onClick === void 0 ? void 0 : onClick({ event: event, member: member, itemRef: scrollRef }); }, onMouseOver: function (event) { return onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver({ event: event, member: member, itemRef: scrollRef }); }, onMouseMove: function (event) { return onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove({ event: event, member: member, itemRef: scrollRef }); }, key: (member === null || member === void 0 ? void 0 : member.userId) || (0,_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_9__.u)(), ref: scrollRef },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_3__.A, { className: "sendbird-mention-suggest-list__user-item__avatar", src: member === null || member === void 0 ? void 0 : member.profileUrl, alt: "user-profile", width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-mention-suggest-list__user-item__nickname", testID: "sendbird-mention-suggest-list__user-item__nickname", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.SUBTITLE_2, color: (member === null || member === void 0 ? void 0 : member.nickname) ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_1 : _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_3 }, (member === null || member === void 0 ? void 0 : member.nickname) || (stringSet === null || stringSet === void 0 ? void 0 : stringSet.MENTION_NAME__NO_NAME)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-mention-suggest-list__user-item__user-id", testID: "sendbird-mention-suggest-list__user-item__user-id", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.SUBTITLE_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_2 }, member === null || member === void 0 ? void 0 : member.userId)));
}

function fetchMembersFromChannel(currentUserId, channel, maxSuggestionCount, searchString) {
    return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__.a)(this, void 0, void 0, function () {
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__.b)(this, function (_a) {
            return [2 /*return*/, channel.members
                    .sort(function (a, b) { var _a; return (_a = a.nickname) === null || _a === void 0 ? void 0 : _a.localeCompare(b.nickname); })
                    .filter(function (member) {
                    var _a;
                    return ((_a = member.nickname) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(searchString.toLowerCase()))
                        && member.userId !== currentUserId
                        && member.isActive;
                }).slice(0, maxSuggestionCount)];
        });
    });
}
function fetchMembersFromQuery(currentUserId, channel, maxSuggestionCount, searchString) {
    return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__.a)(this, void 0, void 0, function () {
        var query;
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__.b)(this, function (_a) {
            query = channel.createMemberListQuery({
                limit: maxSuggestionCount + 1, // because current user could be included
                nicknameStartsWithFilter: searchString,
            });
            return [2 /*return*/, query.next()
                    .then(function (memberList) {
                    return memberList
                        .filter(function (member) { return currentUserId !== (member === null || member === void 0 ? void 0 : member.userId); })
                        .slice(0, maxSuggestionCount);
                })];
        });
    });
}

var DEBOUNCING_TIME = 300;
var SuggestedMentionListView = function (props) {
    var _a, _b, _c;
    var className = props.className, currentChannel = props.currentChannel, _d = props.targetNickname, targetNickname = _d === void 0 ? '' : _d, 
    // memberListQuery,
    onUserItemClick = props.onUserItemClick, onFocusItemChange = props.onFocusItemChange, onFetchUsers = props.onFetchUsers, renderUserMentionItem = props.renderUserMentionItem, inputEvent = props.inputEvent, _e = props.ableAddMention, ableAddMention = _e === void 0 ? true : _e, _f = props.maxMentionCount, maxMentionCount = _f === void 0 ? _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_6__.M : _f, _g = props.maxSuggestionCount, maxSuggestionCount = _g === void 0 ? _bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_6__.b : _g;
    var _h = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_5__/* .useSendbirdStateContext */ .A)(), config = _h.config, stores = _h.stores;
    var logger = config.logger;
    var currentUserId = ((_c = (_b = (_a = stores === null || stores === void 0 ? void 0 : stores.sdkStore) === null || _a === void 0 ? void 0 : _a.sdk) === null || _b === void 0 ? void 0 : _b.currentUser) === null || _c === void 0 ? void 0 : _c.userId) || '';
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), timer = _j[0], setTimer = _j[1];
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), searchString = _k[0], setSearchString = _k[1];
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), lastSearchString = _l[0], setLastSearchString = _l[1];
    var _m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), currentFocusedMember = _m[0], setCurrentFocusedMember = _m[1];
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), currentMemberList = _o[0], setCurrentMemberList = _o[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        clearTimeout(timer !== null && timer !== void 0 ? timer : undefined);
        setTimer(setTimeout(function () {
            setSearchString(targetNickname);
        }, DEBOUNCING_TIME));
    }, [targetNickname]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.Enter) {
            if (currentFocusedMember && currentMemberList.length > 0) {
                onUserItemClick === null || onUserItemClick === void 0 ? void 0 : onUserItemClick(currentFocusedMember);
            }
        }
        if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.ArrowUp) {
            var currentUserIndex = currentMemberList.findIndex(function (member) { return (member === null || member === void 0 ? void 0 : member.userId) === (currentFocusedMember === null || currentFocusedMember === void 0 ? void 0 : currentFocusedMember.userId); });
            if (0 < currentUserIndex) {
                setCurrentFocusedMember(currentMemberList[currentUserIndex - 1]);
                onFocusItemChange === null || onFocusItemChange === void 0 ? void 0 : onFocusItemChange(currentMemberList[currentUserIndex - 1]);
            }
        }
        if ((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.key) === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_7__.M.ArrowDown) {
            var currentUserIndex = currentMemberList.findIndex(function (member) { return (member === null || member === void 0 ? void 0 : member.userId) === (currentFocusedMember === null || currentFocusedMember === void 0 ? void 0 : currentFocusedMember.userId); });
            if (currentUserIndex < currentMemberList.length - 1) {
                setCurrentFocusedMember(currentMemberList[currentUserIndex + 1]);
                onFocusItemChange === null || onFocusItemChange === void 0 ? void 0 : onFocusItemChange(currentMemberList[currentUserIndex + 1]);
            }
        }
    }, [inputEvent]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (lastSearchString && searchString.indexOf(lastSearchString) === 0 && currentMemberList.length === 0) {
            // Don't need to request query again
            return;
        }
        if (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isSuper) {
            if (!(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.createMemberListQuery)) {
                logger.warning('SuggestedMentionList: Creating member list query failed');
                return;
            }
        }
        var fetcher = (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isSuper) ? fetchMembersFromQuery : fetchMembersFromChannel;
        fetcher(currentUserId, currentChannel, maxSuggestionCount, searchString.slice(_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_6__.a.length))
            .then(function (suggestingMembers) {
            if (suggestingMembers.length < 1) {
                logger.info('SuggestedMentionList: Fetched member list is empty');
            }
            else {
                logger.info('SuggestedMentionList: Fetching member list succeeded', { memberList: suggestingMembers });
                setCurrentFocusedMember(suggestingMembers[0]);
            }
            setLastSearchString(searchString);
            onFetchUsers === null || onFetchUsers === void 0 ? void 0 : onFetchUsers(suggestingMembers);
            setCurrentMemberList(suggestingMembers);
        })
            .catch(function (error) {
            if (error) {
                logger.error('SuggestedMentionList: Fetching member list failed', error);
            }
        });
    }, [
        currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url,
        // We have to be specific like this or React would not recognize the changes in instances.
        currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members.map(function (member) { return member.nickname; }).join(),
        currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members.map(function (member) { return member.isActive; }).join(),
        searchString,
        maxSuggestionCount,
        currentUserId,
        currentMemberList.length,
        lastSearchString,
    ]);
    if (!ableAddMention && currentMemberList.length === 0) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_10__.c)('sendbird-mention-suggest-list', className), "data-testid": "sendbird-mention-suggest-list", key: "sendbird-mention-suggest-list", ref: scrollRef },
        ableAddMention
            && (currentMemberList === null || currentMemberList === void 0 ? void 0 : currentMemberList.map(function (member) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SuggestedUserMentionItem, { key: (member === null || member === void 0 ? void 0 : member.userId) || (0,_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_9__.u)(), member: member, isFocused: (member === null || member === void 0 ? void 0 : member.userId) === (currentFocusedMember === null || currentFocusedMember === void 0 ? void 0 : currentFocusedMember.userId), parentScrollRef: scrollRef, onClick: function (_a) {
                    var member = _a.member;
                    onUserItemClick === null || onUserItemClick === void 0 ? void 0 : onUserItemClick(member);
                }, onMouseOver: function (_a) {
                    var member = _a.member;
                    setCurrentFocusedMember(member);
                }, renderUserMentionItem: renderUserMentionItem })); })),
        !ableAddMention && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-mention-suggest-list__notice-item" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: "sendbird-mention-suggest-list__notice-item__icon", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.INFO */ .Qy.INFO, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "20px", height: "20px" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-mention-suggest-list__notice-item__text", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.SUBTITLE_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_2 }, stringSet.MENTION_COUNT__OVER_LIMIT.replace('%d', String(maxMentionCount)))))));
};


//# sourceMappingURL=bundle-CUxTGz0r.js.map


/***/ }),

/***/ 41519:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SuggestedMentionList; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12225);
/* harmony import */ var _Thread_context_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31723);





var SuggestedMentionList = function (props) {
    var currentChannel = (0,_Thread_context_js__WEBPACK_IMPORTED_MODULE_3__/* .useThreadContext */ .i)().currentChannel;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_CUxTGz0r_js__WEBPACK_IMPORTED_MODULE_2__.S, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { currentChannel: currentChannel })));
};


//# sourceMappingURL=bundle-CXPOT202.js.map


/***/ }),

/***/ 16423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TEXT_MESSAGE_BODY_CLASSNAME; }
/* harmony export */ });
var TEXT_MESSAGE_BODY_CLASSNAME = 'sendbird-text-message-item-body';


//# sourceMappingURL=bundle-CXiD3Is4.js.map


/***/ }),

/***/ 70400:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FileViewerView; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82314);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17693);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41238);









var FileViewerView = function (_a) {
    var message = _a.message, onCancel = _a.onCancel, deleteMessage = _a.deleteMessage, onDownloadClick = _a.onDownloadClick;
    var sender = message.sender, type = message.type, url = message.url, _b = message.name, name = _b === void 0 ? '' : _b, threadInfo = message.threadInfo;
    var profileUrl = sender.profileUrl, nickname = sender.nickname, userId = sender.userId;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)().config;
    return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(react__WEBPACK_IMPORTED_MODULE_0__.createElement(FileViewerComponent, { profileUrl: profileUrl, nickname: nickname, type: type, url: url, name: name, onCancel: onCancel, onDelete: function () { return deleteMessage(message).then(function () { return onCancel(); }); }, isByMe: config.userId === userId, disableDelete: (threadInfo === null || threadInfo === void 0 ? void 0 : threadInfo.replyCount) ? threadInfo.replyCount > 0 : false, onDownloadClick: onDownloadClick }), document.getElementById(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.a));
};
var FileViewerComponent = function (_a) {
    var 
    // sender
    profileUrl = _a.profileUrl, nickname = _a.nickname, 
    // file
    name = _a.name, type = _a.type, url = _a.url, 
    // others
    isByMe = _a.isByMe, onCancel = _a.onCancel, onDelete = _a.onDelete, disableDelete = _a.disableDelete, onDownloadClick = _a.onDownloadClick;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_6__.M, { onClose: onCancel },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer", "data-testid": "sendbird-fileviewer" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__left" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__left__avatar" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_2__.A, { height: "32px", width: "32px", src: profileUrl })),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__left__text-container" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-fileviewer__header__left__filename", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.H_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, name),
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-fileviewer__header__left__sender-name", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, nickname))),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__right" },
                    (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.f)(type) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__right__actions" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { className: "sendbird-fileviewer__header__right__actions__download", rel: "noopener noreferrer", href: url, target: "_blank", onClick: onDownloadClick },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DOWNLOAD */ .Qy.DOWNLOAD, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px" })),
                        onDelete && isByMe && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__right__actions__delete" },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: disableDelete ? 'disabled' : '', type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.DELETE */ .Qy.DELETE, fillColor: disableDelete ? _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.GRAY */ .zo.GRAY : _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: function () {
                                    if (!disableDelete) {
                                        onDelete();
                                    }
                                } }))))),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__header__right__actions__close" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.CLOSE */ .Qy.CLOSE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: onCancel })))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__content" },
                (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.h)(type) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", { controls: true, className: "sendbird-fileviewer__content__video" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: url, type: type }))),
                (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.j)(type) && react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: url, alt: name, className: "sendbird-fileviewer__content__img" }),
                !(0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.f)(type) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-fileviewer__content__unsupported" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.H_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1 }, _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.c.UI__FILE_VIEWER__UNSUPPORT)))))));
};


//# sourceMappingURL=bundle-C_v0tgQ0.js.map


/***/ }),

/***/ 17374:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getChannelAvatarSource; },
/* harmony export */   "b": function() { return /* binding */ getOpenChannelAvatar; },
/* harmony export */   "g": function() { return /* binding */ generateDefaultAvatar; }
/* harmony export */ });
var DEFAULT_URL_PREFIX = 'https://static.sendbird.com/sample/cover/cover_';
var getOpenChannelAvatar = function (channel) {
    if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
        return channel.coverUrl;
    }
    return undefined;
};
var getChannelAvatarSource = function (channel, currentUserId) {
    if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
        if (!(new RegExp("^".concat(DEFAULT_URL_PREFIX)).test(channel.coverUrl))) {
            return channel.coverUrl;
        }
    }
    return ((channel === null || channel === void 0 ? void 0 : channel.members) || [])
        .filter(function (member) { return member.userId !== currentUserId; })
        .map(function (_a) {
        var profileUrl = _a.profileUrl;
        return profileUrl;
    });
};
var generateDefaultAvatar = function (channel) {
    if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
        if (new RegExp("^".concat(DEFAULT_URL_PREFIX)).test(channel.coverUrl)) {
            return true;
        }
        return false;
    }
    return true;
};


//# sourceMappingURL=bundle-CcuSHuDt.js.map


/***/ }),

/***/ 24277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80360);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41238);
/* harmony import */ var _bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16167);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29515);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34182);











var TriggerIcon = function (_a) {
    var ref = _a.ref, _b = _a.onClick, onClick = _b === void 0 ? _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.n : _b, _c = _a.onBlur, onBlur = _c === void 0 ? _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.n : _c, _d = _a.renderIcon, renderIcon = _d === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props)); } : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ref: ref, width: "32px", height: "32px", onClick: onClick, onBlur: onBlur }, renderIcon({
        type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconTypes.MORE */ .Qy.MORE,
        fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE,
        width: '24px',
        height: '24px',
    })));
};
var CopyMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), message = _b.message, hideMenu = _b.hideMenu;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { onClick: function (e) {
            var _a;
            if ((0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.l)(message))
                (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.A)(message.message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__COPY));
};
var ReplyMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), message = _b.message, hideMenu = _b.hideMenu, setQuoteMessage = _b.setQuoteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { disabled: message.parentMessageId > 0, onClick: function (e) {
            var _a;
            setQuoteMessage(message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__REPLY));
};
var ThreadMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), message = _b.message, hideMenu = _b.hideMenu, onReplyInThread = _b.onReplyInThread;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { onClick: function (e) {
            var _a;
            onReplyInThread({ message: message });
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__THREAD));
};
var OpenInChannelMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), hideMenu = _b.hideMenu, onMoveToParentMessage = _b.onMoveToParentMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { onClick: function (e) {
            var _a;
            onMoveToParentMessage();
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__OPEN_IN_CHANNEL));
};
var EditMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), hideMenu = _b.hideMenu, showEdit = _b.showEdit, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                showEdit(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__EDIT));
};
var ResendMenuItem = function (props) {
    var _a;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _b = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), message = _b.message, hideMenu = _b.hideMenu, resendMessage = _b.resendMessage, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                resendMessage(message);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : stringSet.MESSAGE_MENU__RESEND));
};
var DeleteMenuItem = function (props) {
    var _a, _b, _c;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var _d = (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.u)(), message = _d.message, hideMenu = _d.hideMenu, deleteMessage = _d.deleteMessage, showRemove = _d.showRemove, isOnline = _d.isOnline, disableDeleteMessage = _d.disableDeleteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.a, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props, { disabled: typeof disableDeleteMessage === 'boolean'
            ? disableDeleteMessage
            : ((_b = (_a = message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) !== null && _b !== void 0 ? _b : 0) > 0, onClick: function (e) {
            var _a;
            if ((0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.w)(message)) {
                deleteMessage(message);
            }
            else if (isOnline) {
                showRemove(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_c = props.children) !== null && _c !== void 0 ? _c : stringSet.MESSAGE_MENU__DELETE));
};

var isReplyTypeMessageEnabled = function (_a) {
    var _b;
    var channel = _a.channel, message = _a.message;
    if ((0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.w)(message) || (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.v)(message)) {
        return false;
    }
    if (!((_b = channel === null || channel === void 0 ? void 0 : channel.isGroupChannel) === null || _b === void 0 ? void 0 : _b.call(channel)) || (channel === null || channel === void 0 ? void 0 : channel.isEphemeral)) {
        return false;
    }
    var isBroadcast = channel === null || channel === void 0 ? void 0 : channel.isBroadcast;
    var isOperator = (channel === null || channel === void 0 ? void 0 : channel.myRole) === _sendbird_chat__WEBPACK_IMPORTED_MODULE_9__.a7.OPERATOR;
    if (isBroadcast)
        return isOperator;
    return true;
};
var showMenuItemCopy = function (_a) {
    var message = _a.message;
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.l)(message);
};
var showMenuItemEdit = function (_a) {
    var message = _a.message, channel = _a.channel, isByMe = _a.isByMe;
    return (!(channel === null || channel === void 0 ? void 0 : channel.isEphemeral) && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.l)(message) && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.q)(message) && isByMe);
};
var showMenuItemResend = function (_a) {
    var message = _a.message, isByMe = _a.isByMe;
    return ((0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.w)(message) && (message === null || message === void 0 ? void 0 : message.isResendable) && isByMe);
};
var showMenuItemDelete = function (_a) {
    var message = _a.message, channel = _a.channel, isByMe = _a.isByMe;
    return !(channel === null || channel === void 0 ? void 0 : channel.isEphemeral) && !(0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.v)(message) && isByMe;
};
var showMenuItemOpenInChannel = function (_a) {
    var _b = _a.onMoveToParentMessage, onMoveToParentMessage = _b === void 0 ? undefined : _b;
    return !!onMoveToParentMessage;
};
var showMenuItemReply = function (_a) {
    var channel = _a.channel, message = _a.message, replyType = _a.replyType;
    return isReplyTypeMessageEnabled({ channel: channel, message: message }) && replyType === 'QUOTE_REPLY';
};
var showMenuItemThread = function (_a) {
    var channel = _a.channel, message = _a.message, replyType = _a.replyType, onReplyInThread = _a.onReplyInThread;
    return isReplyTypeMessageEnabled({ channel: channel, message: message }) && replyType === 'THREAD' && !(message === null || message === void 0 ? void 0 : message.parentMessageId) && typeof onReplyInThread === 'function';
};

var MessageMenu = function (_a) {
    var _b;
    var className = _a.className, message = _a.message, channel = _a.channel, isByMe = _a.isByMe, replyType = _a.replyType, _c = _a.renderTrigger, renderTrigger = _c === void 0 ? TriggerIcon : _c, renderMenuItems = _a.renderMenuItems, _d = _a.disableDeleteMessage, disableDeleteMessage = _d === void 0 ? null : _d, _e = _a.showEdit, showEdit = _e === void 0 ? _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.n : _e, _f = _a.showRemove, showRemove = _f === void 0 ? _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.n : _f, deleteMessage = _a.deleteMessage, resendMessage = _a.resendMessage, setQuoteMessage = _a.setQuoteMessage, onReplyInThread = _a.onReplyInThread, onMoveToParentMessage = _a.onMoveToParentMessage;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useSendbirdStateContext */ .A)().config;
    var isOnline = config.isOnline;
    var triggerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMenuVisible = _g[0], setMenuVisibility = _g[1];
    var hideMenu = function () { return setMenuVisibility(false); };
    var showMenu = function () { return setMenuVisibility(true); };
    var toggleMenu = function () { return setMenuVisibility(function (visible) { return !visible; }); };
    var params = {
        message: message,
        channel: channel,
        isByMe: isByMe,
        replyType: replyType,
        onReplyInThread: onReplyInThread,
        onMoveToParentMessage: onMoveToParentMessage,
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.c)('sendbird-message-menu', className), ref: containerRef },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.M, { value: {
                message: message,
                hideMenu: hideMenu,
                showMenu: showMenu,
                toggleMenu: toggleMenu,
                setQuoteMessage: setQuoteMessage,
                onReplyInThread: onReplyInThread,
                onMoveToParentMessage: onMoveToParentMessage,
                showEdit: showEdit,
                showRemove: showRemove,
                deleteMessage: deleteMessage,
                resendMessage: resendMessage,
                isOnline: isOnline,
                disableDeleteMessage: disableDeleteMessage,
                triggerRef: triggerRef,
                containerRef: containerRef,
            } },
            (renderTrigger({ ref: triggerRef, onClick: toggleMenu })),
            isMenuVisible && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.b, { id: (0,_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.g)(message.messageId), parentRef: triggerRef, parentContainRef: containerRef, closeDropdown: hideMenu, openLeft: isByMe }, (_b = renderMenuItems === null || renderMenuItems === void 0 ? void 0 : renderMenuItems({
                items: {
                    CopyMenuItem: CopyMenuItem,
                    ReplyMenuItem: ReplyMenuItem,
                    ThreadMenuItem: ThreadMenuItem,
                    OpenInChannelMenuItem: OpenInChannelMenuItem,
                    EditMenuItem: EditMenuItem,
                    ResendMenuItem: ResendMenuItem,
                    DeleteMenuItem: DeleteMenuItem,
                },
            })) !== null && _b !== void 0 ? _b : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                showMenuItemCopy(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(CopyMenuItem, null),
                showMenuItemReply(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReplyMenuItem, null),
                showMenuItemThread(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThreadMenuItem, null),
                showMenuItemOpenInChannel(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(OpenInChannelMenuItem, null),
                showMenuItemEdit(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(EditMenuItem, null),
                showMenuItemResend(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResendMenuItem, null),
                showMenuItemDelete(params) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(DeleteMenuItem, null))))))));
};


//# sourceMappingURL=bundle-CfaZQwKj.js.map


/***/ }),

/***/ 11639:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getChannelTitle; }
/* harmony export */ });
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99366);


var getChannelTitle = function (channel, currentUserId, stringSet) {
    var _a;
    var LABEL_STRING_SET = stringSet || _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_0__.c;
    if (!(channel === null || channel === void 0 ? void 0 : channel.name) && !(channel === null || channel === void 0 ? void 0 : channel.members)) {
        return LABEL_STRING_SET.NO_TITLE;
    }
    if ((channel === null || channel === void 0 ? void 0 : channel.name) && channel.name !== 'Group Channel') {
        return channel.name;
    }
    if (((_a = channel === null || channel === void 0 ? void 0 : channel.members) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        return LABEL_STRING_SET.NO_MEMBERS;
    }
    return channel === null || channel === void 0 ? void 0 : channel.members.filter(function (_a) {
        var userId = _a.userId;
        return userId !== currentUserId;
    }).map(function (_a) {
        var nickname = _a.nickname;
        return (nickname || LABEL_STRING_SET.NO_NAME);
    }).join(', ');
};


//# sourceMappingURL=bundle-CgymNuYl.js.map


/***/ }),

/***/ 25528:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ isYesterday; },
/* harmony export */   "b": function() { return /* binding */ isThisYear; },
/* harmony export */   "i": function() { return /* binding */ isToday; }
/* harmony export */ });
/* harmony import */ var _bundle_BAXCq_Wt_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46367);
/* harmony import */ var _bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3323);
/* harmony import */ var _bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75010);




/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  return (0,_bundle_BAXCq_Wt_js__WEBPACK_IMPORTED_MODULE_2__.i)(dirtyDate, Date.now());
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var dateLeft = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDateLeft);
  var dateRight = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  return isSameYear(dirtyDate, Date.now());
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var amount = (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_0__.t)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var amount = (0,_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_0__.t)(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  return (0,_bundle_BAXCq_Wt_js__WEBPACK_IMPORTED_MODULE_2__.i)(dirtyDate, subDays(Date.now(), 1));
}


//# sourceMappingURL=bundle-CmKxC8hb.js.map


/***/ }),

/***/ 8627:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useLongPress; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26765);




var DEFAULT_DURATION = 300;
function preventDefault(e) {
    if (!isTouchEvent(e)) {
        return;
    }
    if (e.touches.length < 2 && e.preventDefault) {
        e.preventDefault();
    }
}
function isTouchEvent(e) {
    return e && 'touches' in e;
}
function useLongPress(_a, _b) {
    var onLongPress = _a.onLongPress, onClick = _a.onClick;
    var _c = _b === void 0 ? {} : _b, _d = _c.delay, delay = _d === void 0 ? DEFAULT_DURATION : _d, _e = _c.shouldPreventDefault, shouldPreventDefault = _e === void 0 ? true : _e, _f = _c.shouldStopPropagation, shouldStopPropagation = _f === void 0 ? false : _f;
    var isMobile = (0,_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_2__.u)().isMobile;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), longPressTriggered = _g[0], setLongPressTriggered = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), dragTriggered = _h[0], setDragTriggered = _h[1];
    // https://www.typescriptlang.org/docs/handbook/utility-types.html#returntypetype
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var target = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var start = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e) {
        e.persist();
        var clonedEvent = (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, e);
        setDragTriggered(false);
        if (shouldStopPropagation) {
            e.stopPropagation();
        }
        if (shouldPreventDefault && e.target) {
            e.target.addEventListener('touchend', preventDefault, {
                passive: false,
            });
            target.current = e.target;
        }
        timeout.current = setTimeout(function () {
            onLongPress(clonedEvent);
            setLongPressTriggered(true);
        }, delay);
    }, [onLongPress, delay, shouldPreventDefault, shouldStopPropagation, isMobile]);
    var clear = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e, shouldTriggerClick, onDrag) {
        if (shouldTriggerClick === void 0) { shouldTriggerClick = true; }
        if (onDrag === void 0) { onDrag = false; }
        if (onDrag) {
            setDragTriggered(true);
        }
        else {
            setDragTriggered(false);
        }
        if (timeout === null || timeout === void 0 ? void 0 : timeout.current) {
            clearTimeout(timeout.current);
        }
        if (shouldTriggerClick && !longPressTriggered && !dragTriggered) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
        setLongPressTriggered(false);
        if (shouldPreventDefault && target.current) {
            target.current.removeEventListener('touchend', preventDefault);
        }
    }, [shouldPreventDefault, onClick, longPressTriggered, dragTriggered]);
    return {
        onMouseDown: function (e) { return start(e); },
        onMouseUp: function (e) { return clear(e); },
        onMouseLeave: function (e) { return clear(e, false); },
        onTouchStart: function (e) { return start(e); },
        // setDragTriggered as true on touchmove, so that next onTouchEnd is ignored
        // if we dont do it, onClick?.(e) will be triggred, see inside clear()
        onTouchMove: function (e) { return clear(e, false, true); },
        onTouchEnd: function (e) { return clear(e); },
    };
}


//# sourceMappingURL=bundle-CruP9bVM.js.map


/***/ }),

/***/ 18107:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ isAboutSame; },
/* harmony export */   "b": function() { return /* binding */ isDisabledBecauseFrozen; },
/* harmony export */   "c": function() { return /* binding */ isDisabledBecauseMuted; },
/* harmony export */   "s": function() { return /* binding */ scrollIntoLast; }
/* harmony export */ });
/* unused harmony exports d, e, g, i, m, p */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);




var scrollToRenderedMessage = function (scrollRef, initialTimeStamp, setIsScrolled) {
    var _a;
    try {
        var container = scrollRef.current;
        // scroll into the message with initialTimeStamp
        var element = (_a = container === null || container === void 0 ? void 0 : container.querySelectorAll("[data-sb-created-at=\"".concat(initialTimeStamp, "\"]"))) === null || _a === void 0 ? void 0 : _a[0];
        if (container && element instanceof HTMLElement) {
            // Set the scroll position of the container to bring the element to the top
            container.scrollTop = element.offsetTop;
        }
    }
    catch (_b) {
        // do nothing
    }
    finally {
        setIsScrolled === null || setIsScrolled === void 0 ? void 0 : setIsScrolled(true);
    }
};
/* eslint-disable default-param-last */
var scrollIntoLast = function (initialTry, scrollRef, setIsScrolled) {
    if (initialTry === void 0) { initialTry = 0; }
    var MAX_TRIES = 10;
    var currentTry = initialTry;
    if (currentTry > MAX_TRIES) {
        setIsScrolled === null || setIsScrolled === void 0 ? void 0 : setIsScrolled(true);
        return;
    }
    try {
        var scrollDOM = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) || document.querySelector('.sendbird-conversation__messages-padding');
        if (scrollDOM)
            scrollDOM.scrollTop = scrollDOM.scrollHeight;
        setIsScrolled === null || setIsScrolled === void 0 ? void 0 : setIsScrolled(true);
    }
    catch (error) {
        setTimeout(function () {
            scrollIntoLast(currentTry + 1, scrollRef, setIsScrolled);
        }, 500 * currentTry);
    }
};
var isOperator = function (groupChannel) {
    var myRole = groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.myRole;
    return myRole === 'operator';
};
var isDisabledBecauseFrozen = function (groupChannel) {
    var isFrozen = groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.isFrozen;
    return isFrozen && !isOperator(groupChannel);
};
var isDisabledBecauseMuted = function (groupChannel) {
    var myMutedState = groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.myMutedState;
    return myMutedState === 'muted';
};
var getAllEmojisMapFromEmojiContainer = function (emojiContainer) {
    var _a = emojiContainer.emojiCategories, emojiCategories = _a === void 0 ? [] : _a;
    var allEmojisMap = new Map();
    for (var categoryIndex = 0; categoryIndex < emojiCategories.length; categoryIndex += 1) {
        var emojis = emojiCategories[categoryIndex].emojis;
        for (var emojiIndex = 0; emojiIndex < emojis.length; emojiIndex += 1) {
            var _b = emojis[emojiIndex], key = _b.key, url = _b.url;
            allEmojisMap.set(key, url);
        }
    }
    return allEmojisMap;
};
var getNicknamesMapFromMembers = function (members) {
    if (members === void 0) { members = []; }
    var nicknamesMap = new Map();
    for (var memberIndex = 0; memberIndex < members.length; memberIndex += 1) {
        var _a = members[memberIndex], userId = _a.userId, nickname = _a.nickname;
        nicknamesMap.set(userId, nickname);
    }
    return nicknamesMap;
};
var getUniqueListBy = function (arr, key) {
    var entries = arr.map(function (item) { return [item[key], item]; });
    return Array.from(new Map(entries).values());
};
var getUniqueListByMessageId = function (arr) {
    return getUniqueListBy(arr, 'messageId');
};
var sortByCreatedAt = function (messages) {
    return messages.sort(function (a, b) { return a.createdAt - b.createdAt; });
};
var mergeAndSortMessages = function (oldMessages, newMessages) {
    var lastOldMessage = oldMessages[oldMessages.length - 1];
    var firstNewMessage = newMessages[0];
    // If the last message of oldMessages is older than the first message of newMessages,
    // then we can safely append newMessages to oldMessages.
    if ((lastOldMessage === null || lastOldMessage === void 0 ? void 0 : lastOldMessage.createdAt) < (firstNewMessage === null || firstNewMessage === void 0 ? void 0 : firstNewMessage.createdAt)) {
        return __spreadArray(__spreadArray([], oldMessages, true), newMessages, true);
    }
    // todo: optimize this
    // If the last message of oldMessages is newer than the first message of newMessages,
    // then we need to merge the two arrays and sort them by createdAt.
    var mergedMessages = __spreadArray(__spreadArray([], oldMessages, true), newMessages, true);
    var unique = getUniqueListByMessageId(mergedMessages);
    return sortByCreatedAt(unique);
};
var passUnsuccessfullMessages = function (allMessages, newMessage) {
    if ('sendingStatus' in newMessage
        && (newMessage.sendingStatus === SendingStatus.SUCCEEDED || newMessage.sendingStatus === SendingStatus.PENDING)) {
        var lastIndexOfSucceededMessage = allMessages
            .map(function (message) {
            if ('sendingStatus' in message && message.sendingStatus)
                return message.sendingStatus;
            return message.isAdminMessage() ? SendingStatus.SUCCEEDED : null;
        })
            .lastIndexOf(SendingStatus.SUCCEEDED);
        if (lastIndexOfSucceededMessage + 1 < allMessages.length) {
            var messages = __spreadArray([], allMessages, true);
            messages.splice(lastIndexOfSucceededMessage + 1, 0, newMessage);
            return messages;
        }
    }
    return __spreadArray(__spreadArray([], allMessages, true), [newMessage], false);
};
var isAboutSame = function (a, b, px) {
    return Math.abs(a - b) <= px;
};


//# sourceMappingURL=bundle-CtcQd9Ql.js.map


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useElementObserver; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/* global MutationCallback */
/* global MutationObserverInit */
// To prevent Undefined lint errors: https://github.com/standard/standard/issues/1159#issuecomment-403003627
function useElementObserver(selector, targetElement) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isElementMounted = _a[0], setIsElementMounted = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var targetElements = Array.isArray(targetElement) ? targetElement : [targetElement];
        var updateElementState = function () {
            var _a;
            var elements = targetElements === null || targetElements === void 0 ? void 0 : targetElements.map(function (target) { return target === null || target === void 0 ? void 0 : target.querySelector(selector); });
            setIsElementMounted((_a = elements === null || elements === void 0 ? void 0 : elements.some(function (element) { return !!element; })) !== null && _a !== void 0 ? _a : false);
        };
        updateElementState();
        var observerCallback = function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length || mutation.removedNodes.length) {
                    Array.from(mutation.addedNodes).forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
                            setIsElementMounted(true);
                        }
                    });
                    Array.from(mutation.removedNodes).forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
                            setIsElementMounted(false);
                        }
                    });
                }
            });
        };
        var observer = new MutationObserver(observerCallback);
        var observerOptions = {
            childList: true, // Observe addition and removal of child nodes
            subtree: true, // Observe the entire subtree
        };
        targetElements === null || targetElements === void 0 ? void 0 : targetElements.forEach(function (target) {
            if (target)
                observer.observe(target, observerOptions);
        });
        return function () {
            observer.disconnect();
        };
    }, [selector, targetElement]);
    return isElementMounted;
}


//# sourceMappingURL=bundle-D634UqaM.js.map


/***/ }),

/***/ 1165:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TOKEN_TYPES; },
/* harmony export */   "U": function() { return /* binding */ USER_MENTION_PREFIX; },
/* harmony export */   "a": function() { return /* binding */ tokenizeMarkdown; },
/* harmony export */   "b": function() { return /* binding */ getWhiteSpacePreservedText; },
/* harmony export */   "t": function() { return /* binding */ tokenizeMessage; }
/* harmony export */ });
/* unused harmony export g */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);


var USER_MENTION_PREFIX = '@';

var TOKEN_TYPES = {
    string: 'string',
    mention: 'mention',
    url: 'url',
    undetermined: 'undetermined',
    markdown: 'markdown',
};

/**
 * /\[(.*?)\]\((.*?)\) is for url.
 * /\*\*(.*?)\*\* for bold.
 */
var MarkdownRegex = /\[(.*?)\]\((.*?)\)|\*\*(.*?)\*\*/g;
function getUserMentionRegex(mentionedUsers, templatePrefix_) {
    var templatePrefix = templatePrefix_ || USER_MENTION_PREFIX;
    return RegExp("(".concat(mentionedUsers.map(function (u) {
        var userId = u.userId.replace(
        // If user.id includes these patterns, need to convert it into an escaped one
        /([.*+?^${}()|[\]\\])/g, '\\$1');
        /**
         * //{ And //} are also for escaping
         * because curly braces `{}` are metacharacters in regular expressions used to specify repetition
         */
        return "".concat(templatePrefix, "\\{").concat(userId, "\\}");
    }).join('|'), ")"), 'g');
}
function identifyMentions(_a) {
    var tokens = _a.tokens, _b = _a.mentionedUsers, mentionedUsers = _b === void 0 ? [] : _b, _c = _a.templatePrefix, templatePrefix = _c === void 0 ? USER_MENTION_PREFIX : _c;
    if (!(mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length)) {
        return tokens;
    }
    var userMentionRegex = getUserMentionRegex(mentionedUsers, templatePrefix);
    var results = tokens.map(function (token) {
        // if the token is not undetermined, return it as is
        // is kinda unnecessary with TS, but just in case
        if (token.type !== TOKEN_TYPES.undetermined) {
            return token;
        }
        var value = token.value;
        var parts = value.split(userMentionRegex);
        var tokens = parts.map(function (part) {
            if (part.match(userMentionRegex)) {
                var matchedUser = mentionedUsers.find(function (user) { return "@{".concat(user === null || user === void 0 ? void 0 : user.userId, "}") === part; });
                var nickname = (matchedUser === null || matchedUser === void 0 ? void 0 : matchedUser.nickname) || '(No name)';
                return { value: nickname, type: TOKEN_TYPES.mention, userId: matchedUser === null || matchedUser === void 0 ? void 0 : matchedUser.userId };
            }
            else {
                return { value: part, type: TOKEN_TYPES.undetermined };
            }
        });
        return tokens;
    }).flat();
    return results;
}
function identifyUrlsAndStrings(token) {
    var URL_REG = /(?:https?:\/\/|www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.(xn--)?[a-z]{2,20}\b([-a-zA-Z0-9@:%_+[\],.~#?&/=]*[-a-zA-Z0-9@:%_+~#?&/=])*/g;
    var results = token.map(function (token) {
        if (token.type !== TOKEN_TYPES.undetermined) {
            return token;
        }
        var _a = token.value, value = _a === void 0 ? '' : _a;
        var matches = Array.from(value.matchAll(URL_REG));
        var founds = matches.map(function (value) {
            var _a;
            var text = value[0];
            var start = (_a = value.index) !== null && _a !== void 0 ? _a : 0;
            var end = start + text.length;
            return { text: text, start: start, end: end };
        });
        var items = [{ value: value, type: TOKEN_TYPES.string }];
        var cursor = 0;
        founds.forEach(function (_a) {
            var text = _a.text, start = _a.start, end = _a.end;
            var restText = items.pop().value;
            var head = restText.slice(0, start - cursor);
            var mid = text;
            var tail = restText.slice(end - cursor);
            if (head.length > 0)
                items.push({ value: head, type: TOKEN_TYPES.string });
            items.push({ value: mid, type: TOKEN_TYPES.url });
            if (tail.length > 0)
                items.push({ value: tail, type: TOKEN_TYPES.string });
            cursor = end;
        });
        return items;
    }).flat();
    return results;
}
/**
 * For every string token in the given list of tokens, if the token contains markdowns, the token is split into
 * string tokens and markdown tokens in the original order.
 * Returns a new array tokens.
 * @param tokens
 */
function splitTokensWithMarkdowns(tokens) {
    var prevTokens = tokens;
    var newTokens = [];
    prevTokens.forEach(function (token) {
        if (token.type === TOKEN_TYPES.mention || token.type === TOKEN_TYPES.markdown) {
            newTokens.push(token);
            return;
        }
        var rawStr = token.value;
        // @ts-ignore
        var matches = Array.from(rawStr.matchAll(MarkdownRegex));
        var allMatches = matches.map(function (value) {
            var _a;
            var text = value[0];
            var start = (_a = value.index) !== null && _a !== void 0 ? _a : 0;
            var end = start + text.length;
            return { text: text, start: start, end: end, groups: value.filter(function (val) { return typeof val === 'string'; }) };
        });
        var restText = rawStr;
        var cursor = 0;
        allMatches.forEach(function (_a) {
            var text = _a.text, start = _a.start, end = _a.end, groups = _a.groups;
            var left = {
                type: TOKEN_TYPES.undetermined,
                value: restText.slice(0, start - cursor),
            };
            newTokens.push(left);
            var markdownType;
            if (text.startsWith('[')) {
                markdownType = 'url';
            }
            else if (text.startsWith('**')) {
                markdownType = 'bold';
            }
            var mid = {
                type: TOKEN_TYPES.markdown,
                markdownType: markdownType,
                value: text,
                groups: groups,
            };
            newTokens.push(mid);
            restText = rawStr.slice(end);
            cursor = end;
        });
        if (restText) {
            var right = {
                type: TOKEN_TYPES.undetermined,
                value: restText,
            };
            newTokens.push(right);
        }
    });
    return newTokens;
}
function combineNearbyStrings(tokens) {
    var results = tokens.reduce(function (acc, token) {
        var lastToken = acc[acc.length - 1];
        if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === TOKEN_TYPES.string && token.type === TOKEN_TYPES.string) {
            lastToken.value = "".concat(lastToken.value).concat(token.value);
            return acc;
        }
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], acc, true), [token], false);
    }, []);
    return results;
}
/**
 * Converts text into set of rich tokens
 */
function tokenizeMessage(_a) {
    var messageText = _a.messageText, _b = _a.mentionedUsers, mentionedUsers = _b === void 0 ? [] : _b, _c = _a.templatePrefix, templatePrefix = _c === void 0 ? USER_MENTION_PREFIX : _c, _d = _a.includeMarkdown, includeMarkdown = _d === void 0 ? false : _d;
    // mention can be squeezed-in(no-space-between) with other mentions and urls
    // if no users are mentioned, return the messageText as a single token
    var partialResult = [{
            type: TOKEN_TYPES.undetermined,
            value: messageText,
        }];
    // order is important because we want to identify mentions first
    // identifyMentions will return a token with type mention or undetermined
    var partialWithMentions = identifyMentions({
        tokens: partialResult,
        mentionedUsers: mentionedUsers,
        templatePrefix: templatePrefix,
    });
    var partialsWithUrlsAndMentions = identifyUrlsAndStrings(includeMarkdown
        ? splitTokensWithMarkdowns(partialWithMentions)
        : partialWithMentions);
    var result = combineNearbyStrings(partialsWithUrlsAndMentions);
    return result;
}
function getChannelPreviewMessage(messageText) {
    var partialResult = [{
            type: TOKEN_TYPES.undetermined,
            value: messageText,
        }];
    var tokens = splitTokensWithMarkdowns(partialResult);
    return markDownTokenResolver(tokens);
}
function markDownTokenResolver(tokens) {
    var result = tokens.map(function (token) {
        if (token.type === TOKEN_TYPES.markdown) {
            return markDownTokenResolver(tokenizeMarkdown({ messageText: token.groups[1] }));
        }
        return token.value;
    });
    return result.join('');
}
function tokenizeMarkdown(_a) {
    var messageText = _a.messageText;
    var partialResult = [{
            type: TOKEN_TYPES.undetermined,
            value: messageText,
        }];
    var result = combineNearbyStrings(splitTokensWithMarkdowns(partialResult));
    return result;
}
/**
 * Don't need to use this util in DOM element since the white spaces will be kept as is,
 * but will need if the text is wrapped \w React.Fragement or </>
 * @link https://sendbird.slack.com/archives/GPGHESTL3/p1681180484341369
 * Or!!! -> convert any space or tab in leading/trailing to nbsp
 * to preserve the leading & trailing white spaces
 */
function getWhiteSpacePreservedText(text) {
    var NON_BREAKING_SPACE = '\u00A0';
    // Split the input string into lines
    var lines = text.split('\n');
    // Process each line and convert leading and trailing white spaces to "\u00A0"
    var processedLines = lines.map(function (line) {
        var _a, _b;
        var leadingWhitespace = ((_a = line.match(/^\s*/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
        var trailingWhitespace = ((_b = line.match(/\s*$/)) === null || _b === void 0 ? void 0 : _b[0]) || '';
        var convertedLeadingWhitespace = leadingWhitespace.replace(/ /g, NON_BREAKING_SPACE);
        var convertedTrailingWhitespace = trailingWhitespace.replace(/ /g, NON_BREAKING_SPACE);
        return convertedLeadingWhitespace + line.trim() + convertedTrailingWhitespace;
    });
    // Combine the processed lines into a new string with "\n"
    var result = processedLines.join('\n');
    return result;
}


//# sourceMappingURL=bundle-D7JevDoE.js.map


/***/ }),

/***/ 69466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ BROWSER_SUPPORT_MIME_TYPE_LIST; },
/* harmony export */   "C": function() { return /* binding */ CACHED_MESSAGE_TEMPLATES_TOKEN_KEY; },
/* harmony export */   "M": function() { return /* binding */ META_ARRAY_VOICE_DURATION_KEY; },
/* harmony export */   "O": function() { return /* binding */ ONE_MiB; },
/* harmony export */   "S": function() { return /* binding */ SCROLL_BUFFER; },
/* harmony export */   "V": function() { return /* binding */ VOICE_PLAYER_ROOT_ID; },
/* harmony export */   "a": function() { return /* binding */ VOICE_PLAYER_AUDIO_ID; },
/* harmony export */   "b": function() { return /* binding */ VOICE_MESSAGE_MIME_TYPE; },
/* harmony export */   "c": function() { return /* binding */ VOICE_RECORDER_AUDIO_SAMPLE_RATE; },
/* harmony export */   "e": function() { return /* binding */ SCROLL_BOTTOM_DELAY_FOR_SEND; },
/* harmony export */   "f": function() { return /* binding */ VOICE_MESSAGE_FILE_NAME; },
/* harmony export */   "g": function() { return /* binding */ META_ARRAY_MESSAGE_TYPE_KEY; },
/* harmony export */   "h": function() { return /* binding */ META_ARRAY_MESSAGE_TYPE_VALUE__VOICE; },
/* harmony export */   "i": function() { return /* binding */ MESSAGE_TEMPLATE_KEY; },
/* harmony export */   "j": function() { return /* binding */ VOICE_RECORDER_CLICK_BUFFER_TIME; },
/* harmony export */   "k": function() { return /* binding */ VOICE_RECORDER_DEFAULT_MIN; },
/* harmony export */   "l": function() { return /* binding */ VOICE_MESSAGE_FILE_NAME__XM4A; },
/* harmony export */   "m": function() { return /* binding */ VOICE_MESSAGE_MIME_TYPE__XM4A; },
/* harmony export */   "n": function() { return /* binding */ SLIDER_BUTTON_ICON_SIDE_LENGTH; },
/* harmony export */   "o": function() { return /* binding */ VOICE_RECORDER_AUDIO_BIT_RATE; },
/* harmony export */   "p": function() { return /* binding */ CACHED_MESSAGE_TEMPLATES_KEY; },
/* harmony export */   "q": function() { return /* binding */ DEFAULT_MULTIPLE_FILES_MESSAGE_LIMIT; },
/* harmony export */   "r": function() { return /* binding */ DEFAULT_UPLOAD_SIZE_LIMIT; },
/* harmony export */   "s": function() { return /* binding */ VOICE_RECORDER_DEFAULT_MAX; }
/* harmony export */ });
/* unused harmony exports D, d */
var ONE_MiB = 1024 * 1024;
var SCROLL_BUFFER = 10;
var SCROLL_BOTTOM_DELAY_FOR_SEND = 100;
var SCROLL_BOTTOM_DELAY_FOR_FETCH = 100;
// voice message record
var VOICE_RECORDER_CLICK_BUFFER_TIME = 250;
var VOICE_RECORDER_DEFAULT_MIN = 1000; // 1 seconds
var VOICE_RECORDER_DEFAULT_MAX = 600000; // 10 minutes
var VOICE_RECORDER_AUDIO_BIT_RATE = 12000;
var VOICE_RECORDER_AUDIO_SAMPLE_RATE = 11025;
var BROWSER_SUPPORT_MIME_TYPE_LIST = ['audio/webm', 'audio/mp4', 'audio/mpeg', 'audio/ogg'];
/**
 * Append Audio element to the root
 * because I can't get the Audio element in the useEffect unmount scope
 */
var VOICE_PLAYER_ROOT_ID = 'sendbird-voice-player-provider-root';
var VOICE_PLAYER_AUDIO_ID = 'sendbird-global-audio-player-id';
// voice message file
var VOICE_MESSAGE_FILE_NAME = 'Voice_message.mp3';
var VOICE_MESSAGE_FILE_NAME__XM4A = 'Voice_message.m4a';
var VOICE_MESSAGE_MIME_TYPE = 'audio/mp3;sbu_type=voice';
var VOICE_MESSAGE_MIME_TYPE__XM4A = 'audio/x-m4a;sbu_type=voice';
// meta array
var META_ARRAY_VOICE_DURATION_KEY = 'KEY_VOICE_MESSAGE_DURATION';
var META_ARRAY_MESSAGE_TYPE_KEY = 'KEY_INTERNAL_MESSAGE_TYPE';
var META_ARRAY_MESSAGE_TYPE_VALUE__VOICE = 'voice/mp3';
// delivery receipt in feature list
var DELIVERY_RECEIPT = 'delivery_receipt';
// file viewer slider
var SLIDER_BUTTON_ICON_SIDE_LENGTH = '32px';
// multiple files message file info count limit
var DEFAULT_MULTIPLE_FILES_MESSAGE_LIMIT = 10;
var DEFAULT_UPLOAD_SIZE_LIMIT = 25 * 1024 * 1024;
// Local storage item key for sdk templates token
var CACHED_MESSAGE_TEMPLATES_TOKEN_KEY = 'sendbird_message_templates_token_key';
// Local storage item key for templates in JSON string form
var CACHED_MESSAGE_TEMPLATES_KEY = 'sendbird_message_templates_key';
var MESSAGE_TEMPLATE_KEY = 'message_template';


//# sourceMappingURL=bundle-DABR6HKW.js.map


/***/ }),

/***/ 12291:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ VoiceMessageInputStatus; },
/* harmony export */   "a": function() { return /* binding */ VoiceMessageInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28464);
/* harmony import */ var _ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68962);
/* harmony import */ var _ui_TextButton_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21790);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43822);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99366);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59587);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69466);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80360);










/* eslint-disable no-redeclare */
var VoiceMessageInputStatus = {
    READY_TO_RECORD: 'READY_TO_RECORD',
    RECORDING: 'RECORDING',
    READY_TO_PLAY: 'READY_TO_PLAY',
    PLAYING: 'PLAYING',
};

var ControlerIcon = function (_a) {
    var inputState = _a.inputState;
    switch (inputState) {
        case VoiceMessageInputStatus.READY_TO_RECORD: {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-controler-icon record-icon" }));
        }
        case VoiceMessageInputStatus.RECORDING: {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-controler-icon stop-icon" }));
        }
        case VoiceMessageInputStatus.READY_TO_PLAY: {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { className: "sendbird-controler-icon play-icon", width: "20px", height: "20px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.PLAY */ .Qy.PLAY, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1 }));
        }
        case VoiceMessageInputStatus.PLAYING: {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-controler-icon pause-icon" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-controler-icon pause-icon-inner" }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-controler-icon pause-icon-inner" })));
        }
        default:
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
    }
};

var VoiceMessageInput = function (_a) {
    var _b = _a.minRecordTime, minRecordTime = _b === void 0 ? _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_7__.k : _b, maximumValue = _a.maximumValue, _c = _a.currentValue, currentValue = _c === void 0 ? 0 : _c, currentType = _a.currentType, onCancelClick = _a.onCancelClick, onControlClick = _a.onControlClick, onSubmitClick = _a.onSubmitClick, renderCancelButton = _a.renderCancelButton, renderControlButton = _a.renderControlButton, renderSubmitButton = _a.renderSubmitButton;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), lastClickTime = _d[0], setLastClickTime = _d[1];
    var isReadyToRecord = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return currentType === VoiceMessageInputStatus.READY_TO_RECORD; }, [currentType]);
    var isRecording = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return currentType === VoiceMessageInputStatus.RECORDING; }, [currentType]);
    var isSendButtonDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        if (currentType === VoiceMessageInputStatus.READY_TO_RECORD
            || currentType === VoiceMessageInputStatus.RECORDING) {
            return minRecordTime > currentValue;
        }
        return false;
    }, [currentType, minRecordTime, currentValue]);
    var isPlayMode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (currentType === VoiceMessageInputStatus.READY_TO_PLAY
            || currentType === VoiceMessageInputStatus.PLAYING);
    }, [currentType]);
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var handleOnCancelClick = function () {
        var currentTime = Date.now();
        if (currentTime - lastClickTime > _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_7__.j) {
            onCancelClick === null || onCancelClick === void 0 ? void 0 : onCancelClick();
            setLastClickTime(currentTime);
        }
    };
    var handleOnControlClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        var currentTime = Date.now();
        if (currentTime - lastClickTime > _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_7__.j) {
            onControlClick === null || onControlClick === void 0 ? void 0 : onControlClick(currentType);
            setLastClickTime(currentTime);
        }
    }, [currentType]);
    var handleOnSubmitClick = function () {
        var currentTime = Date.now();
        if (currentTime - lastClickTime > _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_7__.j) {
            if (!isSendButtonDisabled) {
                onSubmitClick === null || onSubmitClick === void 0 ? void 0 : onSubmitClick();
            }
            setLastClickTime(currentTime);
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input__indicator" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input__indicator__progress-bar" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_ProgressBar_js__WEBPACK_IMPORTED_MODULE_2__/* .ProgressBar */ .ko, { className: "sendbird-voice-message-input__indicator__progress-bar__bar", disabled: isReadyToRecord, maxSize: maximumValue, currentSize: currentValue })),
            (isRecording) ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input__indicator__on-rec" })) : null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_1__/* .PlaybackTime */ .S, { className: "sendbird-voice-message-input__indicator__playback-time", time: isPlayMode ? maximumValue - currentValue : currentValue, labelColor: isReadyToRecord ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_4 : _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONCONTENT_1 })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input__controler" },
            (renderCancelButton === null || renderCancelButton === void 0 ? void 0 : renderCancelButton()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_TextButton_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { className: "sendbird-voice-message-input__controler__cancel", onClick: handleOnCancelClick, disableUnderline: true },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.BUTTON_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.PRIMARY }, stringSet.BUTTON__CANCEL))),
            (renderControlButton === null || renderControlButton === void 0 ? void 0 : renderControlButton(currentType)) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-input__controler__main", onClick: handleOnControlClick },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(ControlerIcon, { inputState: currentType }))),
            (renderSubmitButton === null || renderSubmitButton === void 0 ? void 0 : renderSubmitButton()) || (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_8__.c)('sendbird-voice-message-input__controler__submit', isSendButtonDisabled && 'voice-message--disabled'), onClick: handleOnSubmitClick },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { width: "19px", height: "19px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.SEND */ .Qy.SEND, fillColor: isSendButtonDisabled ? _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_4 */ .zo.ON_BACKGROUND_4 : _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.CONTENT */ .zo.CONTENT }))))));
};


//# sourceMappingURL=bundle-DBeNFit6.js.map


/***/ }),

/***/ 74531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ON_FILE_INFO_UPLOADED; },
/* harmony export */   "t": function() { return /* binding */ ON_TYPING_STATUS_UPDATED; }
/* harmony export */ });
/* unused harmony exports F, M, O, R, S, a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, u */
var RESET_MESSAGES = 'RESET_MESSAGES';
var FETCH_INITIAL_MESSAGES_START = 'FETCH_INITIAL_MESSAGES_START';
var FETCH_INITIAL_MESSAGES_SUCCESS = 'FETCH_INITIAL_MESSAGES_SUCCESS';
var FETCH_INITIAL_MESSAGES_FAILURE = 'FETCH_INITIAL_MESSAGES_FAILURE';
var FETCH_PREV_MESSAGES_SUCCESS = 'FETCH_PREV_MESSAGES_SUCCESS';
var FETCH_PREV_MESSAGES_FAILURE = 'FETCH_PREV_MESSAGES_FAILURE';
var FETCH_NEXT_MESSAGES_SUCCESS = 'FETCH_NEXT_MESSAGES_SUCCESS';
var FETCH_NEXT_MESSAGES_FAILURE = 'FETCH_NEXT_MESSAGES_FAILURE';
var SEND_MESSAGE_START = 'SEND_MESSAGE_START';
var SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
var SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';
var RESEND_MESSAGE_START = 'RESEND_MESSAGE_START';
var ON_MESSAGE_RECEIVED = 'ON_MESSAGE_RECEIVED';
var ON_MESSAGE_UPDATED = 'ON_MESSAGE_UPDATED';
var ON_MESSAGE_THREAD_INFO_UPDATED = 'ON_MESSAGE_THREAD_INFO_UPDATED';
var ON_MESSAGE_DELETED = 'ON_MESSAGE_DELETED';
var ON_MESSAGE_DELETED_BY_REQ_ID = 'ON_MESSAGE_DELETED_BY_REQ_ID';
var SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var SET_CHANNEL_INVALID = 'SET_CHANNEL_INVALID';
var MARK_AS_READ = 'MARK_AS_READ';
var ON_REACTION_UPDATED = 'ON_REACTION_UPDATED';
var SET_EMOJI_CONTAINER = 'SET_EMOJI_CONTAINER';
var MESSAGE_LIST_PARAMS_CHANGED = 'MESSAGE_LIST_PARAMS_CHANGED';
var ON_FILE_INFO_UPLOADED = 'ON_FILE_INFO_UPLOADED';
var ON_TYPING_STATUS_UPDATED = 'ON_TYPING_STATUS_UPDATED';

var channelActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_INITIAL_MESSAGES_FAILURE: FETCH_INITIAL_MESSAGES_FAILURE,
  FETCH_INITIAL_MESSAGES_START: FETCH_INITIAL_MESSAGES_START,
  FETCH_INITIAL_MESSAGES_SUCCESS: FETCH_INITIAL_MESSAGES_SUCCESS,
  FETCH_NEXT_MESSAGES_FAILURE: FETCH_NEXT_MESSAGES_FAILURE,
  FETCH_NEXT_MESSAGES_SUCCESS: FETCH_NEXT_MESSAGES_SUCCESS,
  FETCH_PREV_MESSAGES_FAILURE: FETCH_PREV_MESSAGES_FAILURE,
  FETCH_PREV_MESSAGES_SUCCESS: FETCH_PREV_MESSAGES_SUCCESS,
  MARK_AS_READ: MARK_AS_READ,
  MESSAGE_LIST_PARAMS_CHANGED: MESSAGE_LIST_PARAMS_CHANGED,
  ON_FILE_INFO_UPLOADED: ON_FILE_INFO_UPLOADED,
  ON_MESSAGE_DELETED: ON_MESSAGE_DELETED,
  ON_MESSAGE_DELETED_BY_REQ_ID: ON_MESSAGE_DELETED_BY_REQ_ID,
  ON_MESSAGE_RECEIVED: ON_MESSAGE_RECEIVED,
  ON_MESSAGE_THREAD_INFO_UPDATED: ON_MESSAGE_THREAD_INFO_UPDATED,
  ON_MESSAGE_UPDATED: ON_MESSAGE_UPDATED,
  ON_REACTION_UPDATED: ON_REACTION_UPDATED,
  ON_TYPING_STATUS_UPDATED: ON_TYPING_STATUS_UPDATED,
  RESEND_MESSAGE_START: RESEND_MESSAGE_START,
  RESET_MESSAGES: RESET_MESSAGES,
  SEND_MESSAGE_FAILURE: SEND_MESSAGE_FAILURE,
  SEND_MESSAGE_START: SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCESS: SEND_MESSAGE_SUCCESS,
  SET_CHANNEL_INVALID: SET_CHANNEL_INVALID,
  SET_CURRENT_CHANNEL: SET_CURRENT_CHANNEL,
  SET_EMOJI_CONTAINER: SET_EMOJI_CONTAINER
});


//# sourceMappingURL=bundle-DKR-710v.js.map


/***/ }),

/***/ 80031:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ PublishingModuleType; },
/* harmony export */   "a": function() { return /* binding */ shouldPubSubPublishToThread; },
/* harmony export */   "b": function() { return /* binding */ PUBSUB_TOPICS; },
/* harmony export */   "p": function() { return /* binding */ pubSubTopics; },
/* harmony export */   "s": function() { return /* binding */ shouldPubSubPublishToChannel; }
/* harmony export */ });
var PublishingModuleType;
(function (PublishingModuleType) {
    PublishingModuleType["CHANNEL"] = "CHANNEL";
    PublishingModuleType["THREAD"] = "THREAD";
})(PublishingModuleType || (PublishingModuleType = {}));
// NOTE: To maintain compatibility with the sendbirdSelector provided to customers
//  this utility function ensures that if publishingModules is not provided or its length is zero
//  it will maintain the same behavior as before.
var isTargetIncludedInModules = function (target, modules) {
    if (!modules || modules.length === 0)
        return true;
    else
        return modules.includes(target);
};
function shouldPubSubPublishToChannel(modules) {
    return isTargetIncludedInModules(PublishingModuleType.CHANNEL, modules);
}
function shouldPubSubPublishToThread(modules) {
    return isTargetIncludedInModules(PublishingModuleType.THREAD, modules);
}

// NOTE: It seems not distinguish topics by channel type.
var PUBSUB_TOPICS;
(function (PUBSUB_TOPICS) {
    // Group Channel
    PUBSUB_TOPICS["USER_UPDATED"] = "USER_UPDATED";
    PUBSUB_TOPICS["SEND_MESSAGE_START"] = "SEND_MESSAGE_START";
    PUBSUB_TOPICS["SEND_MESSAGE_FAILED"] = "SEND_MESSAGE_FAILED";
    PUBSUB_TOPICS["SEND_USER_MESSAGE"] = "SEND_USER_MESSAGE";
    PUBSUB_TOPICS["SEND_FILE_MESSAGE"] = "SEND_FILE_MESSAGE";
    PUBSUB_TOPICS["ON_FILE_INFO_UPLOADED"] = "ON_FILE_INFO_UPLOADED";
    PUBSUB_TOPICS["UPDATE_USER_MESSAGE"] = "UPDATE_USER_MESSAGE";
    PUBSUB_TOPICS["DELETE_MESSAGE"] = "DELETE_MESSAGE";
    PUBSUB_TOPICS["LEAVE_CHANNEL"] = "LEAVE_CHANNEL";
    PUBSUB_TOPICS["CREATE_CHANNEL"] = "CREATE_CHANNEL";
    // Open Channel
    PUBSUB_TOPICS["UPDATE_OPEN_CHANNEL"] = "UPDATE_OPEN_CHANNEL";
})(PUBSUB_TOPICS || (PUBSUB_TOPICS = {}));
var pubSubTopics = PUBSUB_TOPICS;


//# sourceMappingURL=bundle-DRlnZqdp.js.map


/***/ }),

/***/ 47689:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ParticipantList; },
/* harmony export */   "U": function() { return /* binding */ UserListItem; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88569);
/* harmony import */ var _bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16167);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43822);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29515);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99366);
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4500);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46776);
/* harmony import */ var _ui_AccordionGroup_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78757);
/* harmony import */ var _bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82314);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73935);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26765);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71091);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17693);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6623);
/* harmony import */ var _bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90832);
/* harmony import */ var _ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67412);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(13462);
/* harmony import */ var _OpenChannelSettings_context_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95697);
/* harmony import */ var _ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56842);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(80360);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41238);





























function ParticipantsModal(_a) {
    var _b, _c, _d;
    var onCancel = _a.onCancel;
    var state = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_22__/* .useSendbirdStateContext */ .A)();
    var channel = (0,_OpenChannelSettings_context_js__WEBPACK_IMPORTED_MODULE_20__/* .useOpenChannelSettingsContext */ .E)().channel;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.L).stringSet;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), participants = _e[0], setParticipants = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), participantListQuery = _f[0], setParticipantListQuery = _f[1];
    var userId = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.userId;
    var sdk = (_d = (_c = state === null || state === void 0 ? void 0 : state.stores) === null || _c === void 0 ? void 0 : _c.sdkStore) === null || _d === void 0 ? void 0 : _d.sdk;
    var isOperatorView = channel === null || channel === void 0 ? void 0 : channel.isOperator(userId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (!channel || !(channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery)) {
            return;
        }
        var participantListQuery = channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery({});
        setParticipantListQuery(participantListQuery);
        participantListQuery.next().then(function (participantList) {
            setParticipants(participantList);
        });
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_15__.M, { hideFooter: true, isFullScreenOnMobile: true, onCancel: function () { return onCancel(); }, onSubmit: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.n, titleText: stringSet.OPEN_CHANNEL_SETTINGS__ALL_PARTICIPANTS_TITLE },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: function (e) {
                    if (participantListQuery) {
                        var hasNext = participantListQuery.hasNext;
                        var target = e.target;
                        var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                        if (hasNext && fetchMore) {
                            participantListQuery.next().then(function (fetchedParticipants) {
                                setParticipants((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (participants !== null && participants !== void 0 ? participants : []), true), fetchedParticipants, true));
                            });
                        }
                    }
                } }, participants === null || participants === void 0 ? void 0 : participants.map(function (p) {
                var _a;
                var isOperator = channel === null || channel === void 0 ? void 0 : channel.isOperator(p.userId);
                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_UserListItem_js__WEBPACK_IMPORTED_MODULE_21__/* .UserListItem */ .Q, { user: p, key: p.userId, currentUser: (_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId, action: (userId !== p.userId && isOperatorView)
                        ? function (_a) {
                            var actionRef = _a.actionRef, parentRef = _a.parentRef;
                            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.b, { parentContainRef: parentRef, parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.O, { channel: channel, user: p, onChange: function () { return closeDropdown(); }, onError: function () {
                                            // FIXME: handle error later
                                            closeDropdown();
                                        }, testID: "open_channel_setting_participant_context_menu_".concat((isOperator) ? 'unregister_operator' : 'register_as_operator') }, isOperator
                                        ? stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR
                                        : stringSet.OPEN_CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR),
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.h, { channel: channel, user: p, onChange: function () { return closeDropdown(); }, onError: function () {
                                            // FIXME: handle error later
                                            closeDropdown();
                                        }, testID: "open_channel_setting_participant_context_menu_".concat(p.isMuted ? 'unmute' : 'mute') }, p.isMuted
                                        ? stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNMUTE
                                        : stringSet.OPEN_CHANNEL_SETTING__MODERATION__MUTE),
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.c, { onClick: function () {
                                            channel === null || channel === void 0 ? void 0 : channel.banUser(p).then(function () {
                                                closeDropdown();
                                            });
                                        }, testID: "open_channel_setting_participant_context_menu_ban" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__BAN))); } }));
                        }
                        : function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null); } }));
            })))));
}

var UserListItem = function (_a) {
    var user = _a.user, currentUser = _a.currentUser, isOperator = _a.isOperator, action = _a.action;
    var avatarRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var actionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _b = (0,_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_8__.u)(), disableUserProfile = _b.disableUserProfile, renderUserProfile = _b.renderUserProfile;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-participants-accordion__member" },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-participants-accordion__member-avatar" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_10__.A, { className: "sendbird-participants-accordion__member-avatar__avatar", onClick: function () {
                            if (!disableUserProfile) {
                                toggleDropdown();
                            }
                        }, ref: avatarRef, src: user.profileUrl, width: 24, height: 24 }),
                    user instanceof _sendbird_chat__WEBPACK_IMPORTED_MODULE_24__.P && user.isMuted ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, null)) : '')); }, menuItems: function (closeDropdown) { return (renderUserProfile
                    ? renderUserProfile({
                        user: user,
                        currentUserId: currentUser !== null && currentUser !== void 0 ? currentUser : '',
                        close: closeDropdown,
                        avatarRef: avatarRef,
                    })
                    : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.b, { openLeft: true, parentRef: avatarRef, 
                        // for catching location(x, y) of MenuItems
                        parentContainRef: avatarRef, 
                        // for toggling more options(menus & reactions)
                        closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, { disableMessaging: true, user: user, currentUserId: currentUser, onSuccess: closeDropdown })))); } })),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: "sendbird-participants-accordion__member__title", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.SUBTITLE_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_1 },
            user.nickname || stringSet.NO_NAME,
            (currentUser === user.userId) && (stringSet.OPEN_CHANNEL_SETTINGS__MEMBERS__YOU)), // if there is now nickname, display userId
        !user.nickname && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: "sendbird-participants-accordion__member__title user-id", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.CAPTION_3, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_2 }, user.userId)),
        isOperator && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: "sendbird-participants-accordion__member__title\n                ".concat((user === null || user === void 0 ? void 0 : user.userId) !== currentUser ? 'operator' : '', "\n                ").concat((user === null || user === void 0 ? void 0 : user.userId) === currentUser ? 'self-operator' : '', "\n              "), type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.SUBTITLE_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_2 }, stringSet.OPEN_CHANNEL_SETTINGS__MEMBERS__OPERATOR)),
        action && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-participants-accordion__member__action", ref: actionRef }, action({ actionRef: actionRef })))));
};

function ParticipantList(_a) {
    var _b;
    var _c = _a.isOperatorView, isOperatorView = _c === void 0 ? false : _c;
    var globalState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_22__/* .useSendbirdStateContext */ .A)();
    var currentUserId = (_b = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _b === void 0 ? void 0 : _b.userId;
    var channel = (0,_OpenChannelSettings_context_js__WEBPACK_IMPORTED_MODULE_20__/* .useOpenChannelSettingsContext */ .E)().channel;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.L).stringSet;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), participants = _d[0], setParticipants = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), participantListQuery = _e[0], setParticipantListQuery = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showParticipantsModal = _f[0], setShowParticipantsModal = _f[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (!channel || !(channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery)) {
            return;
        }
        var participantListQuery = channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery({ limit: 10 });
        setParticipantListQuery(participantListQuery);
        participantListQuery.next().then(function (participants) {
            setParticipants(participants);
        });
    }, [channel]);
    var refreshList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        if (!channel) {
            setParticipants([]);
            return;
        }
        var participantListQuery = channel === null || channel === void 0 ? void 0 : channel.createParticipantListQuery({ limit: 10 });
        participantListQuery.next().then(function (participants) {
            setParticipants(participants);
        });
    }, [channel]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-openchannel-settings__participant-list", onScroll: function (e) {
            if (participantListQuery) {
                var hasNext = participantListQuery.hasNext;
                var target = e.target;
                var fetchMore = (target.clientHeight + target.scrollTop === target.scrollHeight);
                if (hasNext && fetchMore) {
                    participantListQuery.next().then(function (fetchedParticipants) {
                        setParticipants((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (participants !== null && participants !== void 0 ? participants : []), true), fetchedParticipants, true));
                    });
                }
            }
        } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, participants === null || participants === void 0 ? void 0 :
            participants.map(function (p) {
                var isOperator = channel === null || channel === void 0 ? void 0 : channel.isOperator(p.userId);
                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(UserListItem, { user: p, currentUser: currentUserId, key: p.userId, isOperator: isOperator, action: function (_a) {
                        var actionRef = _a.actionRef;
                        return ((isOperatorView && currentUserId !== (p === null || p === void 0 ? void 0 : p.userId))
                            ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { className: "sendbird-openchannel-participant-list__menu", width: "32px", height: "32px", onClick: toggleDropdown },
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { width: "24px", height: "24px", type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.MORE */ .Qy.MORE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE }))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.b, { parentRef: actionRef, closeDropdown: closeDropdown, openLeft: true },
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.O, { channel: channel, user: p, onChange: function () {
                                            closeDropdown();
                                            refreshList();
                                        }, onError: function () {
                                            // FIXME: handle error later
                                            closeDropdown();
                                        }, testID: "open_channel_setting_partitipant_conext_menu_".concat((isOperator) ? 'unregister_operator' : 'register_as_operator') }, isOperator
                                        ? stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR
                                        : stringSet.OPEN_CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR),
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.h, { channel: channel, user: p, onChange: function () {
                                            closeDropdown();
                                            refreshList();
                                        }, onError: function () {
                                            // FIXME: handle error later
                                            closeDropdown();
                                        }, testID: "open_channel_setting_partitipant_conext_menu_".concat(p.isMuted ? 'unmute' : 'mute') }, p.isMuted
                                        ? stringSet.OPEN_CHANNEL_SETTING__MODERATION__UNMUTE
                                        : stringSet.OPEN_CHANNEL_SETTING__MODERATION__MUTE),
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_3__.c, { onClick: function () {
                                            channel === null || channel === void 0 ? void 0 : channel.banUser(p).then(function () {
                                                closeDropdown();
                                                refreshList();
                                            });
                                        }, testID: "open_channel_setting_partitipant_conext_menu_ban" }, stringSet.OPEN_CHANNEL_SETTING__MODERATION__BAN))); } }))
                            : null);
                    } }));
            }),
            (participants && participants.length === 0)
                ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: "sendbird-channel-settings__empty-list", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.SUBTITLE_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_3 }, stringSet.OPEN_CHANNEL_SETTINGS__EMPTY_LIST)) : null,
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-openchannel-participant-list__footer" }, (participantListQuery === null || participantListQuery === void 0 ? void 0 : participantListQuery.hasNext) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_2__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_2__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: function () { return setShowParticipantsModal(true); } }, stringSet.OPEN_CHANNEL_SETTINGS__ALL_PARTICIPANTS_TITLE))),
            showParticipantsModal && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(ParticipantsModal, { onCancel: function () {
                    setShowParticipantsModal(false);
                    refreshList();
                } })))));
}


//# sourceMappingURL=bundle-DX03rGyh.js.map


/***/ }),

/***/ 6623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ copyToClipboard; },
/* harmony export */   "C": function() { return /* binding */ isTemplateMessage; },
/* harmony export */   "F": function() { return /* binding */ isSentStatus; },
/* harmony export */   "G": function() { return /* binding */ arrayEqual; },
/* harmony export */   "H": function() { return /* binding */ getMimeTypesUIKitAccepts; },
/* harmony export */   "I": function() { return /* binding */ isImageMessage; },
/* harmony export */   "J": function() { return /* binding */ isImageFileInfo; },
/* harmony export */   "K": function() { return /* binding */ K; },
/* harmony export */   "L": function() { return /* binding */ isAudioMessage; },
/* harmony export */   "M": function() { return /* binding */ isOGMessage; },
/* harmony export */   "N": function() { return /* binding */ uiContainerType; },
/* harmony export */   "O": function() { return /* binding */ isFormMessage; },
/* harmony export */   "P": function() { return /* binding */ isAdminMessage; },
/* harmony export */   "Q": function() { return /* binding */ isValidTemplateMessageType; },
/* harmony export */   "R": function() { return /* binding */ isThreadMessage; },
/* harmony export */   "T": function() { return /* binding */ getEmojiListAll; },
/* harmony export */   "U": function() { return /* binding */ UIKitMessageTypes; },
/* harmony export */   "V": function() { return /* binding */ getEmojiUrl; },
/* harmony export */   "W": function() { return /* binding */ isReactedBy; },
/* harmony export */   "X": function() { return /* binding */ getEmojiTooltipString; },
/* harmony export */   "Y": function() { return /* binding */ getEmojiMapAll; },
/* harmony export */   "Z": function() { return /* binding */ isTextMessage; },
/* harmony export */   "a": function() { return /* binding */ isReadMessage; },
/* harmony export */   "a3": function() { return /* binding */ isTextuallyNull; },
/* harmony export */   "b": function() { return /* binding */ isFileMessage; },
/* harmony export */   "c": function() { return /* binding */ isMultipleFilesMessage; },
/* harmony export */   "d": function() { return /* binding */ isEditedMessage; },
/* harmony export */   "e": function() { return /* binding */ getSenderName; },
/* harmony export */   "f": function() { return /* binding */ isSupportedFileView; },
/* harmony export */   "g": function() { return /* binding */ getSuggestedReplies; },
/* harmony export */   "h": function() { return /* binding */ isVideo; },
/* harmony export */   "i": function() { return /* binding */ isVoiceMessage; },
/* harmony export */   "j": function() { return /* binding */ isImage; },
/* harmony export */   "k": function() { return /* binding */ isSendableMessage; },
/* harmony export */   "l": function() { return /* binding */ isUserMessage; },
/* harmony export */   "m": function() { return /* binding */ getUIKitMessageType; },
/* harmony export */   "n": function() { return /* binding */ getUIKitMessageTypes; },
/* harmony export */   "o": function() { return /* binding */ getUIKitFileType; },
/* harmony export */   "p": function() { return /* binding */ isThumbnailMessage; },
/* harmony export */   "q": function() { return /* binding */ isSentMessage; },
/* harmony export */   "r": function() { return /* binding */ isVideoMessage; },
/* harmony export */   "s": function() { return /* binding */ isGifMessage; },
/* harmony export */   "t": function() { return /* binding */ truncateString; },
/* harmony export */   "u": function() { return /* binding */ getEmojiListByCategoryIds; },
/* harmony export */   "v": function() { return /* binding */ isPendingMessage; },
/* harmony export */   "w": function() { return /* binding */ isFailedMessage; },
/* harmony export */   "x": function() { return /* binding */ getClassName; },
/* harmony export */   "y": function() { return /* binding */ getUIKitFileTypes; },
/* harmony export */   "z": function() { return /* binding */ isGif; }
/* harmony export */ });
/* unused harmony exports $, B, D, E, S, _, a0, a1, a2 */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8978);
/* harmony import */ var _bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93475);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69466);







var n=Symbol("@ts-pattern/matcher"),t="@ts-pattern/anonymous-select-key",e=function(n){return Boolean(n&&"object"==typeof n)},r=function(t){return t&&!!t[n]},u=function t(u,i,c){if(e(u)){if(r(u)){var o=u[n]().match(i),a=o.matched,f=o.selections;return a&&f&&Object.keys(f).forEach(function(n){return c(n,f[n])}),a}if(!e(i))return !1;if(Array.isArray(u))return !!Array.isArray(i)&&u.length===i.length&&u.every(function(n,e){return t(n,i[e],c)});if(u instanceof Map)return i instanceof Map&&Array.from(u.keys()).every(function(n){return t(u.get(n),i.get(n),c)});if(u instanceof Set){if(!(i instanceof Set))return !1;if(0===u.size)return 0===i.size;if(1===u.size){var s=Array.from(u.values())[0];return r(s)?Array.from(i.values()).every(function(n){return t(s,n,c)}):i.has(s)}return Array.from(u.values()).every(function(n){return i.has(n)})}return Object.keys(u).every(function(e){var o,a=u[e];return (e in i||r(o=a)&&"optional"===o[n]().matcherType)&&t(a,i[e],c)})}return Object.is(i,u)},i=function t(u){var i,o,a;return e(u)?r(u)?null!=(i=null==(o=(a=u[n]()).getSelectionKeys)?void 0:o.call(a))?i:[]:Array.isArray(u)?c(u,t):c(Object.values(u),t):[]},c=function(n,t){return n.reduce(function(n,e){return n.concat(t(e))},[])};function o(t){var e;return (e={})[n]=function(){return {match:function(n){var e={},r=function(n,t){e[n]=t;};return void 0===n?(i(t).forEach(function(n){return r(n,void 0)}),{matched:!0,selections:e}):{matched:u(t,n,r),selections:e}},getSelectionKeys:function(){return i(t)},matcherType:"optional"}},e}function a(t){var e;return (e={})[n]=function(){return {match:function(n){if(!Array.isArray(n))return {matched:!1};var e={};if(0===n.length)return i(t).forEach(function(n){e[n]=[];}),{matched:!0,selections:e};var r=function(n,t){e[n]=(e[n]||[]).concat([t]);};return {matched:n.every(function(n){return u(t,n,r)}),selections:e}},getSelectionKeys:function(){return i(t)}}},e}function f(){var t,e=[].slice.call(arguments);return (t={})[n]=function(){return {match:function(n){var t={},r=function(n,e){t[n]=e;};return {matched:e.every(function(t){return u(t,n,r)}),selections:t}},getSelectionKeys:function(){return c(e,i)},matcherType:"and"}},t}function s(){var t,e=[].slice.call(arguments);return (t={})[n]=function(){return {match:function(n){var t={},r=function(n,e){t[n]=e;};return c(e,i).forEach(function(n){return r(n,void 0)}),{matched:e.some(function(t){return u(t,n,r)}),selections:t}},getSelectionKeys:function(){return c(e,i)},matcherType:"or"}},t}function l(t){var e;return (e={})[n]=function(){return {match:function(n){return {matched:!u(t,n,function(){})}},getSelectionKeys:function(){return []},matcherType:"not"}},e}function h(t){var e;return (e={})[n]=function(){return {match:function(n){return {matched:Boolean(t(n))}}}},e}function v(){var e,r=[].slice.call(arguments),c="string"==typeof r[0]?r[0]:void 0,o=2===r.length?r[1]:"string"==typeof r[0]?void 0:r[0];return (e={})[n]=function(){return {match:function(n){var e,r=((e={})[null!=c?c:t]=n,e);return {matched:void 0===o||u(o,n,function(n,t){r[n]=t;}),selections:r}},getSelectionKeys:function(){return [null!=c?c:t].concat(void 0===o?[]:i(o))}}},e}var y=h(function(n){return !0}),m=y,d=h(function(n){return "string"==typeof n}),g=h(function(n){return "number"==typeof n}),p=h(function(n){return "boolean"==typeof n}),b=h(function(n){return "bigint"==typeof n}),w=h(function(n){return "symbol"==typeof n}),A=h(function(n){return null==n}),S={__proto__:null,optional:o,array:a,intersection:f,union:s,not:l,when:h,select:v,any:y,_:m,string:d,number:g,boolean:p,bigint:b,symbol:w,nullish:A,instanceOf:function(n){return h(function(n){return function(t){return t instanceof n}}(n))},typed:function(){return {array:a,optional:o,intersection:f,union:s,not:l,select:v,when:h}}};function K(n){return new O(n,[])}var O=/*#__PURE__*/function(){function n(n,t){this.value=void 0,this.cases=void 0,this.value=n,this.cases=t;}var e=n.prototype;return e.with=function(){var e=[].slice.call(arguments),r=e[e.length-1],i=[e[0]],c=[];return 3===e.length&&"function"==typeof e[1]?(i.push(e[0]),c.push(e[1])):e.length>2&&i.push.apply(i,e.slice(1,e.length-1)),new n(this.value,this.cases.concat([{match:function(n){var e={},r=Boolean(i.some(function(t){return u(t,n,function(n,t){e[n]=t;})})&&c.every(function(t){return t(n)}));return {matched:r,value:r&&Object.keys(e).length?t in e?e[t]:e:n}},handler:r}]))},e.when=function(t,e){return new n(this.value,this.cases.concat([{match:function(n){return {matched:Boolean(t(n)),value:n}},handler:e}]))},e.otherwise=function(t){return new n(this.value,this.cases.concat([{match:function(n){return {matched:!0,value:n}},handler:t}])).run()},e.exhaustive=function(){return this.run()},e.run=function(){for(var n=this.value,t=void 0,e=0;e<this.cases.length;e++){var r=this.cases[e],u=r.match(this.value);if(u.matched){n=u.value,t=r.handler;break}}if(!t){var i;try{i=JSON.stringify(this.value);}catch(n){i=this.value;}throw new Error("Pattern matching error: no pattern matches value "+i)}return t(n,this.value)},n}();

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMilliseconds(0);
  return date;
}

/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */
function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}

var _a;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
var SUPPORTED_MIMES = {
    IMAGE: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/svg+xml',
        'image/webp', // not supported in IE
    ],
    VIDEO: [
        'video/mpeg',
        'video/ogg',
        'video/webm',
        'video/mp4',
        // 'video/quicktime', // NOTE: Do not support ThumbnailMessage for the .mov video
    ],
    AUDIO: [
        'audio/aac',
        'audio/midi',
        'audio/x-midi',
        'audio/mpeg',
        'audio/ogg',
        'audio/opus',
        'audio/wav',
        'audio/webm',
        'audio/3gpp',
        'audio/3gpp2',
        'audio/mp3',
    ],
    DOCUMENT: [
        'text/plain',
        'text/css',
        'text/csv',
        'text/html',
        'text/calendar',
        'text/javascript',
        'text/xml',
        'video/quicktime', // NOTE: Assume this video is a normal file, not video
    ],
    APPLICATION: [
        'application/x-abiword',
        'application/x-freearc',
        'application/vnd.amazon.ebook',
        'application/octet-stream',
        'application/x-bzip',
        'application/x-bzip2',
        'application/x-cdf',
        'application/x-csh',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-fontobject',
        'application/epub+zip',
        'application/gzip',
        'application/java-archive',
        'application/json',
        'application/ld+json',
        'application/vnd.apple.installer+xml',
        'application/vnd.oasis.opendocument.presentation',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.text',
        'application/ogg',
        'application/pdf',
        'application/x-httpd-php',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.rar',
        'application/rtf',
        'application/x-sh',
        'application/x-tar',
        'application/vnd.visio',
        'application/xhtml+xml',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/xml',
        'application/vnd.mozilla.xul+xml',
        'application/zip',
        'application/x-7z-compressed',
    ],
};
var getMimeTypesUIKitAccepts = function (acceptableMimeTypes) {
    if (Array.isArray(acceptableMimeTypes) && acceptableMimeTypes.length > 0) {
        return acceptableMimeTypes
            .reduce(function (prev, curr) {
            switch (curr) {
                case 'image': {
                    prev.push.apply(prev, SUPPORTED_MIMES.IMAGE);
                    break;
                }
                case 'video': {
                    prev.push.apply(prev, SUPPORTED_MIMES.VIDEO);
                    break;
                }
                case 'audio': {
                    prev.push.apply(prev, SUPPORTED_MIMES.AUDIO);
                    break;
                }
                default: {
                    prev.push(curr);
                    break;
                }
            }
            return prev;
        }, [])
            .join();
    }
    return Object.values(SUPPORTED_MIMES).reduce(function (prev, curr) { return (prev.concat(curr)); }, []).join();
};
var UIKitMessageTypes = {
    ADMIN: 'ADMIN',
    TEXT: 'TEXT',
    FILE: 'FILE',
    MULTIPLE_FILES: 'MULTIPLE_FILES',
    THUMBNAIL: 'THUMBNAIL',
    OG: 'OG',
    UNKNOWN: 'UNKNOWN',
};
var UIKitFileTypes = {
    IMAGE: 'IMAGE',
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO',
    GIF: 'GIF',
    VOICE: 'VOICE',
    OTHERS: 'OTHERS',
};
var isTextuallyNull = function (text) {
    if (text === '' || text === null) {
        return true;
    }
    return false;
};
var isMOVType = function (type) { return type === 'video/quicktime'; };
/**
 * @link: https://sendbird.atlassian.net/browse/SBISSUE-16031?focusedCommentId=270601
 * We limitedly support .mov file type for ThumbnailMessage only in Safari browser.
 * */
var isSupportedVideoFileTypeInSafari = function (type) { return (0,_bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_2__.a)(navigator.userAgent) && isMOVType(type); };
var isImage = function (type) { return SUPPORTED_MIMES.IMAGE.indexOf(type) >= 0; };
var isVideo = function (type) { return SUPPORTED_MIMES.VIDEO.indexOf(type) >= 0
    || isSupportedVideoFileTypeInSafari(type); };
var isGif = function (type) { return type === 'image/gif'; };
var isSupportedFileView = function (type) { return isImage(type) || isVideo(type); };
var isAudio = function (type) { return SUPPORTED_MIMES.AUDIO.indexOf(type) >= 0; };
var getUIKitFileTypes = function () { return ((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, UIKitFileTypes)); };
var getUIKitFileType = function (type) {
    if (isGif(type))
        return UIKitFileTypes.GIF;
    if (isImage(type))
        return UIKitFileTypes.IMAGE;
    if (isVideo(type))
        return UIKitFileTypes.VIDEO;
    if (isAudio(type))
        return UIKitFileTypes.AUDIO;
    return UIKitFileTypes.OTHERS;
};
var isSentMessage = function (message) { return (message.sendingStatus === 'succeeded'); };
var isReadMessage = function (channel, message) { return ((0,_utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__/* .getOutgoingMessageState */ .$)(channel, message) === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__/* .OutgoingMessageStates.READ */ .o.READ); };
// TODO: Remove channel from the params, it seems unnecessary
var isFailedMessage = function (message) { return ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'failed'); };
var isPendingMessage = function (message) { return ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'pending'); };
var isSentStatus = function (state) { return (state === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__/* .OutgoingMessageStates.SENT */ .o.SENT
    || state === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__/* .OutgoingMessageStates.DELIVERED */ .o.DELIVERED
    || state === _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_1__/* .OutgoingMessageStates.READ */ .o.READ); };
var isAdminMessage = function (message) { return (message && (message['isAdminMessage'] && typeof message.isAdminMessage === 'function'
    ? message.isAdminMessage()
    : (message === null || message === void 0 ? void 0 : message.messageType) === 'admin')); };
var isUserMessage = function (message) { return (message && (message['isUserMessage'] && typeof message.isUserMessage === 'function'
    ? message.isUserMessage()
    : (message === null || message === void 0 ? void 0 : message.messageType) === 'user')); };
var isFileMessage = function (message) { return (!!message && (message['isFileMessage'] && typeof message.isFileMessage === 'function'
    ? message.isFileMessage()
    : (message === null || message === void 0 ? void 0 : message.messageType) === 'file')); };
var isMultipleFilesMessage = function (message) { return (message && (message['isMultipleFilesMessage'] && typeof message.isMultipleFilesMessage === 'function'
    ? message.isMultipleFilesMessage()
    : (message.messageType === 'file'
        && Object.prototype.hasOwnProperty.call(message, 'fileInfoList')))); };
var isThreadMessage = function (message) { return (!!message.parentMessageId && !!message.parentMessage); };
var isFormMessage = function (message) { return !!(message.messageForm); };
var isTemplateMessage = function (message) {
    var _a;
    return !!(message && ((_a = message.extendedMessagePayload) === null || _a === void 0 ? void 0 : _a[_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_3__.i]));
};
var isValidTemplateMessageType = function (templatePayload) {
    var type = templatePayload['type'];
    return !(type && !MessageTemplateTypes[type]);
};
var MessageTemplateTypes = {
    default: 'default',
};
var uiContainerType = (_a = {},
    _a[MessageTemplateTypes.default] = 'ui_container_type__default',
    _a);
var isOGMessage = function (message) {
    if (!message || !isUserMessage(message))
        return false;
    return (!!message.ogMetaData
        && !!(message.ogMetaData.url || message.ogMetaData.title || message.ogMetaData.description || message.ogMetaData.defaultImage));
};
var isTextMessage = function (message) {
    return isUserMessage(message);
};
var isThumbnailMessage = function (message) {
    if (!message || !isFileMessage(message))
        return false;
    return isSupportedFileView(message.type);
};
var isImageMessage = function (message) {
    if (!message || !isFileMessage(message))
        return false;
    return isThumbnailMessage(message) && isImage(message.type);
};
var isVideoMessage = function (message) {
    if (!message || !isFileMessage(message))
        return false;
    return isThumbnailMessage(message) && isVideo(message.type);
};
var isGifMessage = function (message) {
    if (!message || !isFileMessage(message))
        return false;
    return isThumbnailMessage(message) && isGif(message.type);
};
var isAudioMessage = function (message) {
    if (!message || !isFileMessage(message))
        return false;
    return isAudio(message.type);
};
var isImageFileInfo = function (fileInfo) {
    if (!fileInfo)
        return false;
    return !!fileInfo.mimeType && (isImage(fileInfo.mimeType) || isGif(fileInfo.mimeType));
};
var isAudioMessageMimeType = function (type) { return (/^audio\//.test(type)); };
var isVoiceMessageMimeType = function (type) { return (/^voice\//.test(type)); };
var isVoiceMessage = function (message) {
    var _a, _b, _c, _d;
    if (!message || !isFileMessage(message) || !message.type)
        return false;
    // ex) audio/m4a OR audio/m4a;sbu_type=voice
    var _e = message.type.split(';'), mimeType = _e[0], typeParameter = _e[1];
    if (!isAudioMessageMimeType(mimeType)) {
        return false;
    }
    if (typeParameter) {
        var _f = typeParameter.split('='), key = _f[0], value = _f[1];
        return key === 'sbu_type' && value === 'voice';
    }
    // ex) message.metaArrays = [{ key: 'KEY_INTERNAL_MESSAGE_TYPE', value: ['voice/m4a'] }]
    return isVoiceMessageMimeType((_d = (_c = (_b = (_a = message === null || message === void 0 ? void 0 : message.metaArrays) === null || _a === void 0 ? void 0 : _a.find(function (metaArray) { return metaArray.key === 'KEY_INTERNAL_MESSAGE_TYPE'; })) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '');
};
var isEditedMessage = function (message) { return isUserMessage(message) && ((message === null || message === void 0 ? void 0 : message.updatedAt) > 0); };
var getUIKitMessageTypes = function () { return ((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, UIKitMessageTypes)); };
/**
 * Do not use this for MultipleFilesMessage. Use isMultipleFilesMessage() instead.
 */
var getUIKitMessageType = function (message) {
    if (isAdminMessage(message))
        return UIKitMessageTypes.ADMIN;
    if (isUserMessage(message)) {
        return isOGMessage(message) ? UIKitMessageTypes.OG : UIKitMessageTypes.TEXT;
    }
    // This is only a safeguard to not return UNKNOWN for MFM.
    if (isMultipleFilesMessage(message)) {
        return UIKitMessageTypes.MULTIPLE_FILES;
    }
    if (isFileMessage(message)) {
        if (isThumbnailMessage(message)) {
            return UIKitMessageTypes.THUMBNAIL;
        }
        if (isVoiceMessage(message)) {
            return UIKitFileTypes.VOICE;
        }
        return UIKitMessageTypes.FILE;
    }
    return UIKitMessageTypes.UNKNOWN;
};
var reducer = function (accumulator, currentValue) {
    if (Array.isArray(currentValue)) {
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], accumulator, true), currentValue, true);
    }
    else {
        accumulator.push(currentValue);
        return accumulator;
    }
};
var getClassName = function (classNames) { return (Array.isArray(classNames)
    ? classNames.reduce(reducer, []).join(' ')
    : classNames); };
var isReactedBy = function (userId, reaction) { return (reaction.userIds.some(function (reactorUserId) { return reactorUserId === userId; })); };
var getEmojiTooltipString = function (reaction, userId, memberNicknamesMap, stringSet) {
    var you = '';
    if (isReactedBy(userId, reaction)) {
        you = reaction.userIds.length === 1 ? stringSet.TOOLTIP__YOU : stringSet.TOOLTIP__AND_YOU;
    }
    return ("".concat(reaction.userIds
        .filter(function (reactorUserId) { return reactorUserId !== userId; })
        .map(function (reactorUserId) { return (memberNicknamesMap.get(reactorUserId) || stringSet.TOOLTIP__UNKNOWN_USER); })
        .join(', ')).concat(you));
};
function getSuggestedReplies(message) {
    var _a;
    if ((message === null || message === void 0 ? void 0 : message.extendedMessagePayload) && Array.isArray((_a = message === null || message === void 0 ? void 0 : message.extendedMessagePayload) === null || _a === void 0 ? void 0 : _a.suggested_replies)) {
        return message.extendedMessagePayload.suggested_replies;
    }
    else {
        return [];
    }
}
var URL_REG = /^((http|https):\/\/)?([a-z\d-]+\.)+[a-z]{2,}(\:[0-9]{1,5})?(\/[-a-zA-Z\d%_.~+&=]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(#\S*)?$/;
/** @deprecated
 * URL detection in a message text will be handled in utils/tokens/tokenize.ts
 */
var isUrl = function (text) { return URL_REG.test(text); };
var truncateString = function (fullStr, strLen) {
    if (!strLen)
        strLen = 40;
    if (fullStr === null || fullStr === undefined)
        return '';
    if (fullStr.length <= strLen)
        return fullStr;
    var separator = '...';
    var sepLen = separator.length;
    var charsToShow = strLen - sepLen;
    var frontChars = Math.ceil(charsToShow / 2);
    var backChars = Math.floor(charsToShow / 2);
    return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars);
};
var copyToClipboard = function (text) {
    // @ts-ignore: Unreachable code error
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        // @ts-ignore: Unreachable code error
        return window.clipboardData.setData('Text', text);
    }
    if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand('copy'); // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            return false;
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
    return false;
};
var getEmojiListAll = function (emojiContainer) {
    var _a;
    return ((_a = emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.emojiCategories) === null || _a === void 0 ? void 0 : _a.map(function (emojiCategory) { return emojiCategory.emojis; }).reduce(function (prevArr, currArr) { return prevArr.concat(currArr); }, []));
};
var getEmojiMapAll = function (emojiContainer) {
    var _a;
    var emojiMap = new Map();
    (_a = emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.emojiCategories) === null || _a === void 0 ? void 0 : _a.forEach(function (category) {
        var _a;
        (_a = category === null || category === void 0 ? void 0 : category.emojis) === null || _a === void 0 ? void 0 : _a.forEach(function (emoji) {
            if (emoji && emoji.key) {
                emojiMap.set(emoji.key, emoji);
            }
        });
    });
    return emojiMap;
};
var getEmojiListByCategoryIds = function (emojiContainer, categoryIds) {
    var _a;
    if (!categoryIds)
        return getEmojiListAll(emojiContainer);
    return ((_a = emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.emojiCategories) === null || _a === void 0 ? void 0 : _a.filter(function (emojiCategory) { return categoryIds.includes(emojiCategory.id); }).flatMap(function (emojiCategory) { return emojiCategory.emojis; })) || [];
};
var findEmojiUrl = function (targetKey) { return function (_a) {
    var key = _a.key;
    return key === targetKey;
}; };
var getEmojiUrl = function (emojiContainer, emojiKey) {
    var _a, _b;
    var isFindingKey = findEmojiUrl(emojiKey !== null && emojiKey !== void 0 ? emojiKey : '');
    return ((_b = (_a = emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.emojiCategories.find(function (category) { return category.emojis.some(isFindingKey); })) === null || _a === void 0 ? void 0 : _a.emojis.find(isFindingKey)) === null || _b === void 0 ? void 0 : _b.url) || '';
};
var getUserName = function (user) { return ((user === null || user === void 0 ? void 0 : user.friendName) || (user === null || user === void 0 ? void 0 : user.nickname) || (user === null || user === void 0 ? void 0 : user.userId)); };
var getSenderName = function (message) { return ((message === null || message === void 0 ? void 0 : message.sender) && getUserName(message === null || message === void 0 ? void 0 : message.sender)); };
var hasSameMembers = function (a, b) {
    if (a === b) {
        return true;
    }
    if (a == null || b == null) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }
    var sortedA = __spreadArray([], a, true).sort();
    var sortedB = __spreadArray([], b, true).sort();
    for (var i = 0; i < sortedA.length; ++i) {
        if (sortedA[i] !== sortedB[i]) {
            return false;
        }
    }
    return true;
};
var isFriend = function (user) {
    if (!user)
        return false;
    return !!(user.friendDiscoveryKey || user.friendName);
};
var filterMessageListParams = function (params, message) {
    var _a, _b, _c, _d;
    var _e = params.customTypesFilter, customTypesFilter = _e === void 0 ? [] : _e;
    // @ts-ignore
    if ((params === null || params === void 0 ? void 0 : params.messageTypeFilter) && params.messageTypeFilter !== message.messageType) {
        return false;
    }
    if ((customTypesFilter === null || customTypesFilter === void 0 ? void 0 : customTypesFilter.length) > 0) {
        var customTypes = customTypesFilter.filter(function (item) { return item !== '*'; });
        // Because Chat SDK inserts '*' when customTypes is empty
        if (customTypes.length > 0 && !customTypes.includes(message.customType)) {
            return false;
        }
    }
    if ((params === null || params === void 0 ? void 0 : params.senderUserIdsFilter) && ((_a = params === null || params === void 0 ? void 0 : params.senderUserIdsFilter) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        if (((_b = message === null || message === void 0 ? void 0 : message.isUserMessage) === null || _b === void 0 ? void 0 : _b.call(message)) || ((_c = message === null || message === void 0 ? void 0 : message.isFileMessage) === null || _c === void 0 ? void 0 : _c.call(message))) {
            var messageSender = message.sender || message['_sender'];
            if (!((_d = params === null || params === void 0 ? void 0 : params.senderUserIdsFilter) === null || _d === void 0 ? void 0 : _d.includes(messageSender === null || messageSender === void 0 ? void 0 : messageSender.userId))) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    if (!(params === null || params === void 0 ? void 0 : params.includeParentMessageInfo) && ((message === null || message === void 0 ? void 0 : message.parentMessageId) || (message === null || message === void 0 ? void 0 : message.parentMessage))) {
        return false;
    }
    return true;
};
var filterChannelListParams = function (params, channel, currentUserId) {
    var _a, _b, _c, _d, _e, _f, _g;
    var includeEmpty = params.includeEmpty, includeFrozen = params.includeFrozen, searchFilter = params.searchFilter, userIdsFilter = params.userIdsFilter, customTypesFilter = params.customTypesFilter, channelUrlsFilter = params.channelUrlsFilter, customTypeStartsWithFilter = params.customTypeStartsWithFilter, channelNameContainsFilter = params.channelNameContainsFilter, nicknameContainsFilter = params.nicknameContainsFilter, myMemberStateFilter = params.myMemberStateFilter, hiddenChannelFilter = params.hiddenChannelFilter, unreadChannelFilter = params.unreadChannelFilter, publicChannelFilter = params.publicChannelFilter, superChannelFilter = params.superChannelFilter, _h = params.metadataKey, metadataKey = _h === void 0 ? '' : _h, _j = params.metadataValues, metadataValues = _j === void 0 ? ['a', 'b'] : _j, metadataValueStartsWith = params.metadataValueStartsWith;
    if (!includeEmpty && (channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null) {
        return false;
    }
    if ((searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.query) && ((_b = (_a = searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.fields) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
        var searchQuery_1 = searchFilter.query;
        var searchFields = searchFilter.fields;
        if (searchQuery_1 && searchFields && searchFields.length > 0) {
            if (!searchFields.some(function (searchField) {
                var _a, _b;
                switch (searchField) {
                    case 'channel_name': {
                        return (_a = channel === null || channel === void 0 ? void 0 : channel.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchQuery_1.toLowerCase());
                    }
                    case 'member_nickname': {
                        return (_b = channel === null || channel === void 0 ? void 0 : channel.members) === null || _b === void 0 ? void 0 : _b.some(function (member) { return member.nickname.toLowerCase().includes(searchQuery_1.toLowerCase()); });
                    }
                    default: {
                        return true;
                    }
                }
            })) {
                return false;
            }
        }
    }
    if (((_c = userIdsFilter === null || userIdsFilter === void 0 ? void 0 : userIdsFilter.userIds) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        var includeMode = userIdsFilter.includeMode, queryType = userIdsFilter.queryType;
        var userIds = userIdsFilter.userIds;
        var memberIds_1 = (_d = channel === null || channel === void 0 ? void 0 : channel.members) === null || _d === void 0 ? void 0 : _d.map(function (member) { return member.userId; });
        if (!includeMode) { // exact match
            if (!userIds.includes(currentUserId)) {
                userIds.push(currentUserId); // add the caller's userId if not added already.
            }
            if (((_e = channel === null || channel === void 0 ? void 0 : channel.members) === null || _e === void 0 ? void 0 : _e.length) > userIds.length) {
                return false; // userIds may contain one or more non-member(s).
            }
            if (!hasSameMembers(userIds, memberIds_1)) {
                return false;
            }
        }
        else if (userIds.length > 0) { // inclusive
            switch (queryType) {
                case 'AND': {
                    if (userIds.some(function (userId) { return !memberIds_1.includes(userId); })) {
                        return false;
                    }
                    break;
                }
                case 'OR': {
                    if (userIds.every(function (userId) { return !memberIds_1.includes(userId); })) {
                        return false;
                    }
                    break;
                }
            }
        }
    }
    if (includeEmpty === false && (channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null) {
        return false;
    }
    if (includeFrozen === false && (channel === null || channel === void 0 ? void 0 : channel.isFrozen) === true) {
        return false;
    }
    if (customTypesFilter && !customTypesFilter.includes(channel === null || channel === void 0 ? void 0 : channel.customType)) {
        return false;
    }
    if (customTypeStartsWithFilter && !new RegExp("^".concat(customTypeStartsWithFilter)).test(channel === null || channel === void 0 ? void 0 : channel.customType)) {
        return false;
    }
    if (channelNameContainsFilter && !((_f = channel === null || channel === void 0 ? void 0 : channel.name) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(channelNameContainsFilter.toLowerCase()))) {
        return false;
    }
    if (nicknameContainsFilter) {
        var lowerCasedSubString_1 = nicknameContainsFilter.toLowerCase();
        if ((_g = channel === null || channel === void 0 ? void 0 : channel.members) === null || _g === void 0 ? void 0 : _g.every(function (member) { return !member.nickname.toLowerCase().includes(lowerCasedSubString_1); })) {
            return false;
        }
    }
    if (channelUrlsFilter && !channelUrlsFilter.includes(channel === null || channel === void 0 ? void 0 : channel.url)) {
        return false;
    }
    if (myMemberStateFilter) {
        switch (myMemberStateFilter) {
            case 'joined_only':
                if ((channel === null || channel === void 0 ? void 0 : channel.myMemberState) !== 'joined') {
                    return false;
                }
                break;
            case 'invited_only':
                if ((channel === null || channel === void 0 ? void 0 : channel.myMemberState) !== 'invited') {
                    return false;
                }
                break;
            case 'invited_by_friend':
                if ((channel === null || channel === void 0 ? void 0 : channel.myMemberState) !== 'invited' || !isFriend(channel === null || channel === void 0 ? void 0 : channel.inviter)) {
                    return false;
                }
                break;
            case 'invited_by_non_friend':
                if ((channel === null || channel === void 0 ? void 0 : channel.myMemberState) !== 'invited' || isFriend(channel === null || channel === void 0 ? void 0 : channel.inviter)) {
                    return false;
                }
                break;
        }
    }
    if (hiddenChannelFilter) {
        switch (hiddenChannelFilter) {
            case 'unhidden_only':
                if ((channel === null || channel === void 0 ? void 0 : channel.isHidden) || (channel === null || channel === void 0 ? void 0 : channel.hiddenState) !== 'unhidden') {
                    return false;
                }
                break;
            case 'hidden_only':
                if (!(channel === null || channel === void 0 ? void 0 : channel.isHidden)) {
                    return false;
                }
                break;
            case 'hidden_allow_auto_unhide':
                if (!(channel === null || channel === void 0 ? void 0 : channel.isHidden) || (channel === null || channel === void 0 ? void 0 : channel.hiddenState) !== 'hidden_allow_auto_unhide') {
                    return false;
                }
                break;
            case 'hidden_prevent_auto_unhide':
                if (!(channel === null || channel === void 0 ? void 0 : channel.isHidden) || (channel === null || channel === void 0 ? void 0 : channel.hiddenState) !== 'hidden_prevent_auto_unhide') {
                    return false;
                }
                break;
        }
    }
    if (unreadChannelFilter) {
        switch (unreadChannelFilter) {
            case 'unread_message':
                if ((channel === null || channel === void 0 ? void 0 : channel.unreadMessageCount) === 0) {
                    return false;
                }
                break;
        }
    }
    if (publicChannelFilter) {
        switch (publicChannelFilter) {
            case 'public':
                if (!(channel === null || channel === void 0 ? void 0 : channel.isPublic)) {
                    return false;
                }
                break;
            case 'private':
                if (channel === null || channel === void 0 ? void 0 : channel.isPublic) {
                    return false;
                }
                break;
        }
    }
    if (superChannelFilter) {
        switch (superChannelFilter) {
            case 'super':
                if (!(channel === null || channel === void 0 ? void 0 : channel.isSuper)) {
                    return false;
                }
                break;
            case 'nonsuper':
                if (channel === null || channel === void 0 ? void 0 : channel.isSuper) {
                    return false;
                }
                break;
        }
    }
    var _k = channel.cachedMetaData, cachedMetaData = _k === void 0 ? {} : _k;
    if (metadataKey && (metadataValues || metadataValueStartsWith)) {
        var metadataValue_1 = cachedMetaData[metadataKey];
        if (!metadataValue_1) {
            return false;
        }
        if (metadataValues && !metadataValues.every(function (value) { return metadataValue_1.includes(value); })) {
            return false;
        }
        if (metadataValueStartsWith && !metadataValue_1.startsWith(metadataValueStartsWith)) {
            return false;
        }
    }
    return true;
};
var sortChannelList = function (channels, order) {
    var compareFunc = K(order)
        .with(GroupChannelListOrder.CHANNEL_NAME_ALPHABETICAL, function () { return (function (a, b) { return a.name.localeCompare(b.name); }); })
        .with(GroupChannelListOrder.CHRONOLOGICAL, function () { return (function (a, b) { return b.createdAt - a.createdAt; }); })
        .otherwise(function () { return (function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = b.lastMessage) === null || _a === void 0 ? void 0 : _a.createdAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER) - ((_d = (_c = a.lastMessage) === null || _c === void 0 ? void 0 : _c.createdAt) !== null && _d !== void 0 ? _d : Number.MIN_SAFE_INTEGER); }); });
    return channels.sort(compareFunc);
};
/**
 * Upserts given channel to the channel list and then returns the sorted channel list.
 */
var getChannelsWithUpsertedChannel = function (_channels, channel, order) {
    var channels = __spreadArray([], _channels, true);
    var findingIndex = channels.findIndex(function (ch) { return ch.url === channel.url; });
    if (findingIndex !== -1) {
        channels[findingIndex] = channel;
    }
    else {
        channels.push(channel);
    }
    return sortChannelList(channels, order !== null && order !== void 0 ? order : GroupChannelListOrder.LATEST_LAST_MESSAGE);
};
var StringObjType;
(function (StringObjType) {
    StringObjType["normal"] = "normal";
    StringObjType["mention"] = "mention";
    StringObjType["url"] = "url";
})(StringObjType || (StringObjType = {}));
/**
 * @deprecated
 * use modules/message/utils/tokenize instead
 */
var convertWordToStringObj = function (word, _users, _template) {
    var users = _users || [];
    var template = '@'; // Use global variable
    var resultArray = [];
    var regex = RegExp("".concat(template, "{(").concat(users.map(function (user) { return user === null || user === void 0 ? void 0 : user.userId; }).join('|'), ")}"), 'g');
    var excutionResult;
    var lastIndex = 0;
    var _loop_1 = function () {
        var template_1 = excutionResult[0], userId = excutionResult[1];
        var endIndex = regex.lastIndex;
        var startIndex = endIndex - template_1.length;
        // Normal text
        var normalText = word.slice(lastIndex, startIndex);
        resultArray.push({
            type: isUrl(normalText) ? StringObjType.url : StringObjType.normal,
            value: normalText,
        });
        // Mention template
        var mentionedUser = users.find(function (user) { return (user === null || user === void 0 ? void 0 : user.userId) === userId; });
        if (!mentionedUser) {
            resultArray.push({
                type: StringObjType.normal,
                value: template_1, // because template is the origin text
            });
        }
        else {
            resultArray.push({
                type: StringObjType.mention,
                value: (mentionedUser === null || mentionedUser === void 0 ? void 0 : mentionedUser.nickname) || '(No name)',
                userId: userId,
            });
        }
        lastIndex = endIndex;
    };
    while ((excutionResult = regex.exec(word)) !== null) {
        _loop_1();
    }
    if (lastIndex < word.length) {
        // Normal text
        var normalText = word.slice(lastIndex);
        resultArray.push({
            type: isUrl(normalText) ? StringObjType.url : StringObjType.normal,
            value: normalText,
        });
    }
    return resultArray;
};
var arrayEqual = function (array1, array2) {
    if (Array.isArray(array1) && Array.isArray(array2) && array1.length === array2.length) {
        for (var i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
    }
    return false;
};
var isSendableMessage = function (message) {
    return Boolean(message) && 'sender' in message;
};
/**
 * If the channel is just created, the channel's createdAt and currentUser's invitedAt are the same.
 */
var isChannelJustCreated = function (channel) {
    return isSameSecond(channel.createdAt, channel.invitedAt) && !channel.lastMessage;
};


//# sourceMappingURL=bundle-D_-9RmNe.js.map


/***/ }),

/***/ 1277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TextFragment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6623);
/* harmony import */ var _bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1165);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23012);
/* harmony import */ var _ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81823);
/* harmony import */ var _ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40286);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99366);








// this function is used to generate a unique key for token in message
// it changes with updated time and index
// messageUpdatedAt is the key part of this key generator
function keyGenerator(createdAt, messageUpdatedAt, index) {
    return "sb-msg_".concat(createdAt, "_").concat(messageUpdatedAt, "_").concat(index);
}

function asSafeURL(url) {
    var safeURL = decodeURIComponent(url);
    try {
        var protocol_1 = new URL(safeURL).protocol;
        if (['https:', 'http:'].some(function (it) { return it === protocol_1.toLowerCase(); })) {
            return safeURL;
        }
        else {
            return '#';
        }
    }
    catch (error) {
        if (!safeURL.startsWith('http://') && !safeURL.startsWith('https://')) {
            safeURL = 'https://' + safeURL;
        }
    }
    return safeURL;
}

function TextFragment(_a) {
    var tokens = _a.tokens;
    var messageStore = (0,_Message_context_js__WEBPACK_IMPORTED_MODULE_3__/* .useMessageContext */ .f)();
    var message = messageStore === null || messageStore === void 0 ? void 0 : messageStore.message;
    var isByMe = messageStore === null || messageStore === void 0 ? void 0 : messageStore.isByMe;
    var updatedAt = message.updatedAt, createdAt = message.createdAt;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, tokens === null || tokens === void 0 ? void 0 : tokens.map(function (token, idx) {
        var key = keyGenerator(createdAt, updatedAt, idx);
        return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.K)(token.type)
            .with(_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.T.markdown, function () {
            var markdownToken = token;
            var groups = markdownToken.groups;
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-word", key: key, "data-testid": "sendbird-ui-word" }, (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.K)(markdownToken.markdownType)
                .with('bold', function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: { fontWeight: 'bold' } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(TextFragment, { tokens: (0,_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.a)({ messageText: groups[1] }) }))); })
                .with('url', function () {
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { className: isByMe
                        ? 'sendbird-label--color-oncontent-1'
                        : 'sendbird-label--color-onbackground-1', href: asSafeURL(groups[2]) },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(TextFragment, { tokens: (0,_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.a)({ messageText: groups[1] }) })));
            })
                .otherwise(function () { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null); }));
        })
            .with(_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.T.mention, function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-word", key: key, "data-testid": "sendbird-ui-word" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_MentionLabel_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { mentionTemplate: _bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.U, 
                // @ts-ignore
                mentionedUserId: token.userId, mentionedUserNickname: token.value, isByMe: isByMe }))); })
            .with(_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.T.url, function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-word", key: key, "data-testid": "sendbird-ui-word" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_LinkLabel_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { src: token.value, type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.BODY_1, color: isByMe ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONCONTENT_1 : _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_1 }, token.value))); })
            .otherwise(function () { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: key }, (0,_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_2__.b)(token.value)); });
    })));
}


//# sourceMappingURL=bundle-DjfGQ-DS.js.map


/***/ }),

/***/ 3323:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ _typeof; },
/* harmony export */   "r": function() { return /* binding */ requiredArgs; },
/* harmony export */   "t": function() { return /* binding */ toDate; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}


//# sourceMappingURL=bundle-DnujA9kt.js.map


/***/ }),

/***/ 15394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageProfile; },
/* harmony export */   "a": function() { return /* binding */ MessageBody; },
/* harmony export */   "b": function() { return /* binding */ MessageHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6623);
/* harmony import */ var _bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16167);
/* harmony import */ var _bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82314);
/* harmony import */ var _ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13462);
/* harmony import */ var _bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46776);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(80360);
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65614);
/* harmony import */ var _ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34835);
/* harmony import */ var _ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50206);
/* harmony import */ var _ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12210);
/* harmony import */ var _bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43071);
/* harmony import */ var _ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71612);
/* harmony import */ var _ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48845);
/* harmony import */ var _ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33709);
/* harmony import */ var _ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49754);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88569);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99366);
/* harmony import */ var _ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21402);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59587);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43822);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41238);
/* harmony import */ var _bundle_CXiD3Is4_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(16423);
/* harmony import */ var _bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(30302);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69466);


























function MessageProfile(_a) {
    var 
    // Internal props
    _b = _a.className, 
    // Internal props
    className = _b === void 0 ? '' : _b, isByMe = _a.isByMe, displayThreadReplies = _a.displayThreadReplies, bottom = _a.bottom, 
    // MessageContentProps
    message = _a.message, channel = _a.channel, userId = _a.userId, _c = _a.chainBottom, chainBottom = _c === void 0 ? false : _c;
    var avatarRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _d = (0,_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_5__.u)(), disableUserProfile = _d.disableUserProfile, renderUserProfile = _d.renderUserProfile;
    if (isByMe || chainBottom || !(0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.k)(message)) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.C, { menuTrigger: function (toggleDropdown) {
            var _a, _b;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_3__.A, { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_22__.c)(className, displayThreadReplies && 'use-thread-replies'), src: ((_b = (_a = channel === null || channel === void 0 ? void 0 : channel.members) === null || _a === void 0 ? void 0 : _a.find(function (member) { return (member === null || member === void 0 ? void 0 : member.userId) === message.sender.userId; })) === null || _b === void 0 ? void 0 : _b.profileUrl)
                    || message.sender.profileUrl
                    || '', 
                // TODO: Divide getting profileUrl logic to utils
                ref: avatarRef, width: "28px", height: "28px", bottom: bottom, onClick: function () {
                    if (!disableUserProfile)
                        toggleDropdown();
                } }));
        }, menuItems: function (closeDropdown) { return (renderUserProfile ? (renderUserProfile({
            user: message.sender,
            close: closeDropdown,
            currentUserId: userId,
            avatarRef: avatarRef,
        })) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_2__.b
        /**
         * parentRef: For catching location(x, y) of MenuItems
         * parentContainRef: For toggling more options(menus & reactions)
        */
        , { 
            /**
             * parentRef: For catching location(x, y) of MenuItems
             * parentContainRef: For toggling more options(menus & reactions)
            */
            parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UserProfile_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { user: message.sender, onSuccess: closeDropdown })))); } }));
}

var InputLabel = function (_a) {
    var children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-form-message__input__label', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.CAPTION_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_2 }, children));
};
var FormInput = function (props) {
    var name = props.name, required = props.required, errorMessage = props.errorMessage, isValid = props.isValid, values = props.values, isInvalidated = props.isInvalidated, isSubmitTried = props.isSubmitTried, style = props.style, onFocused = props.onFocused, onChange = props.onChange, placeHolder = props.placeHolder, isSubmitted = props.isSubmitted;
    var layout = style.layout, _a = style.options, options = _a === void 0 ? [] : _a, resultCount = style.resultCount;
    var _b = resultCount !== null && resultCount !== void 0 ? resultCount : {}, _c = _b.min, min = _c === void 0 ? 1 : _c, _d = _b.max, max = _d === void 0 ? 1 : _d;
    var chipDataList = getInitialChipDataList();
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_18__.L).stringSet;
    var handleFocus = function () {
        onFocused === null || onFocused === void 0 ? void 0 : onFocused(true);
    };
    var handleBlur = function () {
        onFocused === null || onFocused === void 0 ? void 0 : onFocused(false);
    };
    function getInitialChipDataList() {
        if (isSubmitted) {
            return options.map(function (option) { return ({
                state: values.includes(option)
                    ? 'submittedSelected'
                    : 'submittedDefault',
                option: option,
            }); });
        }
        else {
            return options.map(function (option) { return ({
                state: values.includes(option) ? 'selected' : 'default',
                option: option,
            }); });
        }
    }
    var onChipClick = function (index) {
        if (isSubmitted)
            return;
        var newDraftedValues;
        if (min === 1 && max === 1) {
            // Single select
            newDraftedValues = chipDataList[index].state === 'selected' ? [] : [chipDataList[index].option];
        }
        else {
            newDraftedValues = chipDataList.reduce(function (acc, chipData, i) {
                if (i === index) {
                    if (chipData.state === 'default' && values.length < max) {
                        acc.push(chipData.option);
                    }
                }
                else if (chipData.state === 'selected') {
                    acc.push(chipData.option);
                }
                return acc;
            }, []);
        }
        onChange(newDraftedValues);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__input__root' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputLabel, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__input__title-container' },
                name,
                " ",
                !required && react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: 'sendbird-form-message__input__title-optional' }, "(optional)"))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-input_for_form' },
            (function () {
                switch (layout) {
                    case 'chip': {
                        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__input__chip-container' }, chipDataList.map(function (chipData, index) {
                            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-form-message__input__chip ".concat(chipData.state), key: index, onClick: function () { return onChipClick(index); } },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__input__chip-text' }, chipData.option),
                                isSubmitted
                                    && chipData.state === 'submittedSelected' && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, { className: 'sendbird-form-message__submitted-check-icon-chip', type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconTypes.DONE */ .Qy.DONE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconColors.SECONDARY_2 */ .zo.SECONDARY_2, width: '20px', height: '20px' }))));
                        })));
                    }
                    case 'textarea': {
                        var currentValue = values.length > 0 ? values[0] : '';
                        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__input__container' }, isSubmitted ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__submitted-input-box textarea' },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__submitted-input-box-text' }, currentValue),
                            isValid && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-form-message__submitted-check-icon-container' },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconTypes.DONE */ .Qy.DONE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconColors.SECONDARY_2 */ .zo.SECONDARY_2, width: '20px', height: '20px' }))),
                            !currentValue && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-input__placeholder', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BODY_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_3 }, stringSet.FORM_ITEM_OPTIONAL_EMPTY)))) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_22__.c)('sendbird-input__input', !!errorMessage && 'error', 'sendbird-form-message__input__textarea'), required: required, disabled: isSubmitted, value: currentValue, onFocus: handleFocus, onBlur: handleBlur, onChange: function (event) {
                                    var value = event.target.value;
                                    onChange(value ? [value] : []);
                                } }),
                            (placeHolder && !currentValue) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-input__placeholder textarea', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BODY_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_3 }, placeHolder))))));
                    }
                    case 'text':
                    case 'number':
                    case 'phone':
                    case 'email': {
                        var currentValue = values.length > 0 ? values[0] : '';
                        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-form-message__input__container" }, isSubmitted ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-form-message__submitted-input-box" },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-form-message__submitted-input-box-text" }, currentValue),
                            isValid && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-form-message__submitted-check-icon-container" },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconTypes.DONE */ .Qy.DONE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_19__/* .IconColors.SECONDARY_2 */ .zo.SECONDARY_2, width: "20px", height: "20px" }))),
                            !currentValue && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-input__placeholder', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BODY_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_3 }, stringSet.FORM_ITEM_OPTIONAL_EMPTY)))) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", { type: layout === 'number' ? 'text' : layout, inputMode: layout === 'number' ? 'numeric' : 'text', className: "sendbird-input__input ".concat(errorMessage ? 'error' : ''), name: name, required: required, disabled: isSubmitted, value: currentValue, onFocus: handleFocus, onBlur: handleBlur, onChange: function (event) {
                                    var value = event.target.value;
                                    onChange(value ? [value] : []);
                                } }),
                            (placeHolder && !currentValue) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-input__placeholder', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BODY_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_3 }, placeHolder))))));
                    }
                    default: {
                        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
                    }
                }
            })(),
            errorMessage && (isSubmitTried || isInvalidated) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: 'sendbird-form-message__error-label', type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.CAPTION_3 }, errorMessage)))));
};

var FallbackUserMessage = function (_a) {
    var isByMe = _a.isByMe, text = _a.text;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.x)([
            'sendbird-unknown-message-item-body',
            isByMe ? 'outgoing' : 'incoming',
        ]) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: "sendbird-unknown-message-item-body__description", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BODY_1, color: isByMe ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONCONTENT_3 : _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_3 }, text)));
};
function FormMessageItemBody(props) {
    var _this = this;
    var message = props.message, form = props.form, isByMe = props.isByMe;
    var items = form.items, formId = form.id;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_18__.L).stringSet;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_20__/* .useSendbirdStateContext */ .A)().config;
    var logger = config.logger;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), submitFailed = _a[0], setSubmitFailed = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmitTried = _b[0], setIsSubmitTried = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        var initialFormValues = [];
        items.forEach(function (_a) {
            var required = _a.required, style = _a.style;
            var layout = style.layout, _b = style.defaultOptions, defaultOptions = _b === void 0 ? [] : _b;
            initialFormValues.push({
                draftValues: layout === 'chip' ? defaultOptions : [],
                required: required,
                errorMessage: null,
                isInvalidated: false,
            });
        });
        return initialFormValues;
    }), formValues = _c[0], setFormValues = _c[1];
    var isSubmitted = form.isSubmitted;
    var hasError = formValues.some(function (_a) {
        var errorMessage = _a.errorMessage;
        return !!errorMessage;
    });
    var hasInvalidated = formValues.some(function (_a) {
        var isInvalidated = _a.isInvalidated;
        return isInvalidated;
    });
    var isButtonDisabled = (hasError && (isSubmitTried || hasInvalidated)) || isSubmitted;
    var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__.a)(_this, void 0, void 0, function () {
        var hasError_1, isMissingRequired, error_1;
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitTried(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    hasError_1 = formValues.some(function (_a) {
                        var errorMessage = _a.errorMessage;
                        return errorMessage;
                    });
                    if (hasError_1) {
                        return [2 /*return*/];
                    }
                    isMissingRequired = formValues.some(function (formValue) { return formValue.required
                        && (!formValue.draftValues || formValue.draftValues.length === 0); });
                    if (isMissingRequired) {
                        setFormValues(function (oldFormValues) {
                            return oldFormValues.map(function (formValue) {
                                if (formValue.required && formValue.draftValues.length === 0) {
                                    return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({}, formValue), { errorMessage: stringSet.FORM_ITEM_REQUIRED });
                                }
                                return formValue;
                            });
                        });
                        return [2 /*return*/];
                    }
                    formValues.forEach(function (formValue, index) {
                        items[index].draftValues = formValue.draftValues;
                    });
                    return [4 /*yield*/, message.submitMessageForm()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setSubmitFailed(true);
                    logger === null || logger === void 0 ? void 0 : logger.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [formValues, message.messageId, message.submitMessageForm, formId]);
    if (!(0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_21__.f)(form.version)) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(FallbackUserMessage, { isByMe: isByMe, text: stringSet.FORM_VERSION_ERROR });
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.x)([
            "".concat(_bundle_CXiD3Is4_js__WEBPACK_IMPORTED_MODULE_23__.T, " disable-hover"),
            'sendbird-form-message__root',
            'incoming',
        ]) },
        items.map(function (item, index) {
            var _a;
            var name = item.name, placeholder = item.placeholder, id = item.id, required = item.required, style = item.style;
            var _b = formValues[index], _c = _b.draftValues, draftValues = _c === void 0 ? [] : _c, errorMessage = _b.errorMessage;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormInput, { key: id, style: style, placeHolder: placeholder, values: (_a = item.submittedValues) !== null && _a !== void 0 ? _a : draftValues, isInvalidated: formValues[index].isInvalidated, isSubmitTried: isSubmitTried, errorMessage: errorMessage, isValid: isSubmitted, isSubmitted: isSubmitted, name: name, required: required, onFocused: function (isFocus) {
                    if (errorMessage && !isFocus && !formValues[index].isInvalidated) {
                        setFormValues(function (_a) {
                            var newInputs = _a.slice(0);
                            newInputs[index] = (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({}, newInputs[index]), { isInvalidated: true });
                            return newInputs;
                        });
                    }
                    else if (!errorMessage) {
                        setFormValues(function (_a) {
                            var newInputs = _a.slice(0);
                            newInputs[index] = (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({}, newInputs[index]), { isInvalidated: false });
                            return newInputs;
                        });
                    }
                }, onChange: function (values) {
                    setFormValues(function (_a) {
                        var newInputs = _a.slice(0);
                        newInputs[index] = (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({}, newInputs[index]), { draftValues: values, errorMessage: (function () {
                                if (!item.isValid(values)) {
                                    return stringSet.FORM_ITEM_INVALID;
                                }
                                if (required && values.length === 0) {
                                    return stringSet.FORM_ITEM_REQUIRED;
                                }
                                return null;
                            })() });
                        return newInputs; // Return the new array
                    });
                } }));
        }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, { className: 'sendbird-form-message__submit-button', onClick: handleSubmit, disabled: isButtonDisabled, labelType: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.BUTTON_2, labelColor: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONCONTENT_1 }, isSubmitted ? 'Submitted successfully' : 'Submit'),
        submitFailed && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, { text: 'Submit failed.', onCancel: function () {
                setSubmitFailed(false);
            } }))));
}

var MESSAGE_ITEM_BODY_CLASSNAME = 'sendbird-message-content__middle__message-item-body';
var MessageBody = function (props) {
    var _a;
    var _b = props.className, className = _b === void 0 ? MESSAGE_ITEM_BODY_CLASSNAME : _b, message = props.message, channel = props.channel, showFileViewer = props.showFileViewer, onMessageHeightChange = props.onMessageHeightChange, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, mouseHover = props.mouseHover, isMobile = props.isMobile, config = props.config, isReactionEnabledInChannel = props.isReactionEnabledInChannel, isByMe = props.isByMe;
    // Private props for internal customization.
    var customSubcomponentsProps = (_a = props['customSubcomponentsProps']) !== null && _a !== void 0 ? _a : {};
    var threadMessageKindKey = (0,_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_10__.u)({
        isMobile: isMobile,
    });
    var statefulFileInfoList = (0,_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_10__.a)(message); // For MultipleFilesMessage.
    var messageTypes = (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.n)();
    var isOgMessageEnabledInGroupChannel = (channel === null || channel === void 0 ? void 0 : channel.isGroupChannel()) && config.groupChannel.enableOgtag;
    var isFormMessageEnabledInGroupChannel = (channel === null || channel === void 0 ? void 0 : channel.isGroupChannel()) && config.groupChannel.enableFormTypeMessage;
    var renderUnknownMessageItemBody = function () { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, { className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isReactionEnabled: isReactionEnabledInChannel }); };
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.K)(message)
        .when(function (message) { return isFormMessageEnabledInGroupChannel && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.O)(message); }, function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormMessageItemBody, { isByMe: isByMe, message: message, form: message.messageForm })); })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.C, function () {
        var _a, _b;
        var templatePayload = message.extendedMessagePayload[_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_24__.i];
        if (!(0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.Q)(templatePayload)) {
            (_b = (_a = config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'TemplateMessageItemBody: invalid type value in message.extendedMessagePayload.message_template.', templatePayload);
            return renderUnknownMessageItemBody();
        }
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_14__/* .TemplateMessageItemBody */ .EC, { className: className, message: message, isByMe: isByMe, theme: config === null || config === void 0 ? void 0 : config.theme });
    })
        .when(function (message) { return isOgMessageEnabledInGroupChannel
        && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.k)(message)
        && (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.M)(message); }, function () {
        var _a;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isMentionEnabled: (_a = config.groupChannel.enableMention) !== null && _a !== void 0 ? _a : false, isReactionEnabled: isReactionEnabledInChannel, onMessageHeightChange: onMessageHeightChange, isMarkdownEnabled: config.groupChannel.enableMarkdownForUserMessage }));
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.Z, function () {
        var _a;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isMentionEnabled: (_a = config.groupChannel.enableMention) !== null && _a !== void 0 ? _a : false, isReactionEnabled: isReactionEnabledInChannel, isMarkdownEnabled: config.groupChannel.enableMarkdownForUserMessage }));
    })
        .when(function (message) { return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.m)(message) === messageTypes.FILE; }, function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isReactionEnabled: isReactionEnabledInChannel, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage })); })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c, function () {
        var _a;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_10__.M, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({ className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isReactionEnabled: isReactionEnabledInChannel, threadMessageKindKey: threadMessageKindKey, statefulFileInfoList: statefulFileInfoList, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage }, (_a = customSubcomponentsProps['MultipleFilesMessageItemBody']) !== null && _a !== void 0 ? _a : {})));
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.i, function () {
        var _a;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_11__/* .VoiceMessageItemBody */ .C, { className: className, message: message, channelUrl: (_a = channel === null || channel === void 0 ? void 0 : channel.url) !== null && _a !== void 0 ? _a : '', isByMe: isByMe, isReactionEnabled: isReactionEnabledInChannel }));
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.p, function () {
        var _a;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ui_ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__._)({ className: className, message: message, isByMe: isByMe, mouseHover: mouseHover, isReactionEnabled: isReactionEnabledInChannel, showFileViewer: showFileViewer, style: isMobile ? { width: '100%' } : {} }, (_a = customSubcomponentsProps['ThumbnailMessageItemBody']) !== null && _a !== void 0 ? _a : {})));
    })
        .otherwise(function () {
        return renderUnknownMessageItemBody();
    });
};

var MessageHeader = function (props) {
    var _a, _b;
    var channel = props.channel, message = props.message;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: "sendbird-message-content__middle__sender-name", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.CAPTION_2, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_2 }, 
    /**
     * To use the latest member profile information, message.sender might be outdated
     */
    ((_b = (_a = channel === null || channel === void 0 ? void 0 : channel.members) === null || _a === void 0 ? void 0 : _a.find(function (member) {
        var _a;
        // @ts-ignore
        return (member === null || member === void 0 ? void 0 : member.userId) === ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId);
    })) === null || _b === void 0 ? void 0 : _b.nickname) || (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.e)(message)
    // TODO: Divide getting profileUrl logic to utils
    ));
};


//# sourceMappingURL=bundle-KDJ0EkHX.js.map


/***/ }),

/***/ 19652:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageProvider; },
/* harmony export */   "a": function() { return /* binding */ MessageTemplate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ComponentType;
(function (ComponentType) {
    ComponentType["Box"] = "box";
    ComponentType["Text"] = "text";
    ComponentType["Image"] = "image";
    ComponentType["TextButton"] = "textButton";
    ComponentType["ImageButton"] = "imageButton";
    ComponentType["Carousel"] = "carouselView";
})(ComponentType || (ComponentType = {}));

const outSingle$1 = (key, obj) => {
    if (typeof obj[key] !== 'string')
        return {};
    return { [key]: argbToRgba(obj[key]) };
};
function argbToRgba(string) {
    if (!string.startsWith('#')) {
        return string;
    }
    if (string.length === 9) {
        return `#${string.slice(3)}${string[1]}${string[2]}`;
    }
    if (string.length === 5) {
        return `#${string.slice(2)}${string[1]}`;
    }
    return string;
}
const outViewStyle$1 = (viewStyle) => {
    if (!viewStyle)
        return {};
    return {
        viewStyle: Object.assign(Object.assign(Object.assign({}, viewStyle), outSingle$1('backgroundColor', viewStyle)), outSingle$1('borderColor', viewStyle)),
    };
};
const outTextStyle$1 = (textStyle) => {
    if (!textStyle)
        return {};
    return {
        textStyle: Object.assign(Object.assign({}, textStyle), outSingle$1('color', textStyle)),
    };
};
const outImageStyle = (imageStyle) => {
    if (!imageStyle)
        return {};
    return {
        imageStyle: Object.assign(Object.assign({}, imageStyle), outSingle$1('tintColor', imageStyle)),
    };
};
const colorTransform = {
    run(prop) {
        if (prop.type === ComponentType.Text || prop.type === ComponentType.TextButton) {
            return Object.assign(Object.assign(Object.assign({}, prop), outViewStyle$1(prop.viewStyle)), outTextStyle$1(prop.textStyle));
        }
        if (prop.type === ComponentType.ImageButton || prop.type === ComponentType.Image) {
            return Object.assign(Object.assign(Object.assign({}, prop), outViewStyle$1(prop.viewStyle)), outImageStyle(prop.imageStyle));
        }
        return Object.assign(Object.assign({}, prop), outViewStyle$1(prop.viewStyle));
    },
};

const isNumber = (val) => {
    if (typeof val === 'string') {
        return !Number.isNaN(Number(val));
    }
    return typeof val === 'number' && !Number.isNaN(val);
};
const outSingle = (key, obj) => {
    if (obj[key] === undefined || obj[key] === null)
        return {};
    return isNumber(obj[key]) ? { [key]: Number(obj[key]) } : {};
};
const outSpacing = (key, spacing) => {
    if (!spacing)
        return {};
    return {
        [key]: {
            left: isNumber(spacing.left) ? Number(spacing.left) : spacing.left,
            right: isNumber(spacing.right) ? Number(spacing.right) : spacing.right,
            top: isNumber(spacing.top) ? Number(spacing.top) : spacing.top,
            bottom: isNumber(spacing.bottom) ? Number(spacing.bottom) : spacing.bottom,
        },
    };
};
const outSize = (key, size) => {
    if (!size)
        return {};
    return {
        [key]: {
            type: size.type,
            value: isNumber(size.value) ? Number(size.value) : size.value,
        },
    };
};
const outMetadata = (metaData) => {
    if (!metaData)
        return {};
    return {
        metaData: {
            pixelWidth: isNumber(metaData.pixelWidth) ? Number(metaData.pixelWidth) : metaData.pixelWidth,
            pixelHeight: isNumber(metaData.pixelHeight) ? Number(metaData.pixelHeight) : metaData.pixelHeight,
        },
    };
};
const outViewStyle = (viewStyle) => {
    if (!viewStyle)
        return {};
    return {
        viewStyle: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, viewStyle), outSingle('borderWidth', viewStyle)), outSingle('radius', viewStyle)), outSpacing('margin', viewStyle.margin)), outSpacing('padding', viewStyle.padding)),
    };
};
const outTextStyle = (textStyle) => {
    if (!textStyle)
        return {};
    return {
        textStyle: Object.assign(Object.assign(Object.assign({}, textStyle), outSingle('size', textStyle)), outSingle('weight', textStyle)),
    };
};
const outCarouselStyle = (carouselstyle) => {
    if (!carouselstyle)
        return {};
    return {
        carouselStyle: Object.assign(Object.assign({}, carouselstyle), outSingle('spacing', carouselstyle)),
    };
};
const outViewProps = (view) => {
    return Object.assign(Object.assign(Object.assign({}, outSize('width', view.width)), outSize('height', view.height)), outViewStyle(view.viewStyle));
};
const outTextProps = (text) => {
    return Object.assign(Object.assign(Object.assign({}, outViewProps(text)), outTextStyle(text.textStyle)), outSingle('maxTextLines', text));
};
const outImageProps = (image) => {
    return Object.assign(Object.assign({}, outViewProps(image)), outMetadata(image.metaData));
};
const outCarouselProps = (carousel) => {
    return Object.assign(Object.assign(Object.assign({}, outViewProps(carousel)), outCarouselStyle(carousel.carouselStyle)), { 
        // Convert only top-level items to find has fill width values.
        items: carousel.items.map((item) => (Object.assign(Object.assign({}, item), { body: Object.assign(Object.assign({}, item.body), { items: item.body.items.map((it) => numberTransform.run(it)) }) }))) });
};
const numberTransform = {
    run(prop) {
        if (prop.type === ComponentType.Text || prop.type === ComponentType.TextButton) {
            return Object.assign(Object.assign({}, prop), outTextProps(prop));
        }
        if (prop.type === ComponentType.ImageButton || prop.type === ComponentType.Image) {
            return Object.assign(Object.assign({}, prop), outImageProps(prop));
        }
        if (prop.type === ComponentType.Carousel) {
            return Object.assign(Object.assign({}, prop), outCarouselProps(prop));
        }
        return Object.assign(Object.assign({}, prop), outViewProps(prop));
    },
};

// -------- Set property mapper
const MAPPER = () => undefined;
const createParser = (params) => {
    var _a;
    const defaultMapper = (params === null || params === void 0 ? void 0 : params.defaultMapper) || MAPPER;
    const mapper = {
        defaultMapper,
        mapBoxProps: (params === null || params === void 0 ? void 0 : params.mapBoxProps) || defaultMapper,
        mapTextProps: (params === null || params === void 0 ? void 0 : params.mapTextProps) || defaultMapper,
        mapImageProps: (params === null || params === void 0 ? void 0 : params.mapImageProps) || defaultMapper,
        mapTextButtonProps: (params === null || params === void 0 ? void 0 : params.mapTextButtonProps) || defaultMapper,
        mapImageButtonProps: (params === null || params === void 0 ? void 0 : params.mapImageButtonProps) || defaultMapper,
        mapCarouselProps: (params === null || params === void 0 ? void 0 : params.mapCarouselProps) || defaultMapper,
    };
    const transforms = [colorTransform, numberTransform, ...((_a = params === null || params === void 0 ? void 0 : params.transforms) !== null && _a !== void 0 ? _a : [])];
    const transformDirty = new Set();
    return {
        setTransforms(newTransforms) {
            transforms.length = 0;
            transforms.push(...newTransforms);
            transformDirty.clear();
        },
        addTransforms(newTransforms) {
            transforms.push(...newTransforms);
        },
        parse(rawItem, options) {
            // Note: it is for mutable transforms
            // const uniqId =
            //   typeof options.depth === 'number' && typeof options.elemIdx === 'number'
            //     ? `id-${options.depth}-${options.elemIdx}`
            //     : rawItem.id ?? rawItem.elementId ?? JSON.stringify(rawItem);
            //
            // let item = rawItem;
            // if (!transformDirty.has(uniqId)) {
            //   item = transforms.reduce((it, transform) => transform(it), rawItem);
            //   transformDirty.add(uniqId);
            // }
            const item = transforms.reduce((it, transform) => transform.run(it), rawItem);
            switch (item.type) {
                case ComponentType.Box: {
                    return { transformed: item, properties: mapper.mapBoxProps(item, options) };
                }
                case ComponentType.Text: {
                    return { transformed: item, properties: mapper.mapTextProps(item, options) };
                }
                case ComponentType.Image: {
                    return { transformed: item, properties: mapper.mapImageProps(item, options) };
                }
                case ComponentType.TextButton: {
                    return { transformed: item, properties: mapper.mapTextButtonProps(item, options) };
                }
                case ComponentType.ImageButton: {
                    return { transformed: item, properties: mapper.mapImageButtonProps(item, options) };
                }
                case ComponentType.Carousel: {
                    return { transformed: item, properties: mapper.mapCarouselProps(item, options) };
                }
                default:
                    return { transformed: item, properties: undefined };
            }
        },
    };
};

const FRAGMENT = ({ children }) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
function createRenderer(params) {
    var _a, _b, _c, _d, _e, _f;
    return {
        box: ((_a = params === null || params === void 0 ? void 0 : params.views) === null || _a === void 0 ? void 0 : _a.box) || FRAGMENT,
        text: ((_b = params === null || params === void 0 ? void 0 : params.views) === null || _b === void 0 ? void 0 : _b.text) || FRAGMENT,
        image: ((_c = params === null || params === void 0 ? void 0 : params.views) === null || _c === void 0 ? void 0 : _c.image) || FRAGMENT,
        imageButton: ((_d = params === null || params === void 0 ? void 0 : params.views) === null || _d === void 0 ? void 0 : _d.imageButton) || FRAGMENT,
        textButton: ((_e = params === null || params === void 0 ? void 0 : params.views) === null || _e === void 0 ? void 0 : _e.textButton) || FRAGMENT,
        carouselView: ((_f = params === null || params === void 0 ? void 0 : params.views) === null || _f === void 0 ? void 0 : _f.carouselView) || FRAGMENT,
    };
}

var __rest$5 = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const SizeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    sizes: {},
    updateSize: () => { },
});
const SizeContextProvider = ({ children }) => {
    const [sizes, setSizes] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({});
    const updateSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_a) => {
        var { id } = _a, rest = __rest$5(_a, ["id"]);
        if (id) {
            setSizes((prevSizes) => (Object.assign(Object.assign({}, prevSizes), { [id]: rest })));
        }
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Provider, { value: { sizes, updateSize } }, children);
};
const useSizeContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SizeContext);

var Layout;
(function (Layout) {
    Layout["Row"] = "row";
    Layout["Column"] = "column";
})(Layout || (Layout = {}));
var AlignValue;
(function (AlignValue) {
    AlignValue["Center"] = "center";
    AlignValue["Left"] = "left";
    AlignValue["Right"] = "right";
    AlignValue["Top"] = "top";
    AlignValue["Bottom"] = "bottom";
})(AlignValue || (AlignValue = {}));
/**
 * @description
 * Caution: Numbers are passed as string types in the message template builder.
 * Use `==` comparison instead of `===` comparison when using a regular enum instead of a string enum.
 */
var FlexSizeSpecValue;
(function (FlexSizeSpecValue) {
    FlexSizeSpecValue[FlexSizeSpecValue["FillParent"] = 0] = "FillParent";
    FlexSizeSpecValue[FlexSizeSpecValue["WrapContent"] = 1] = "WrapContent";
})(FlexSizeSpecValue || (FlexSizeSpecValue = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight["Normal"] = "normal";
    FontWeight["Bold"] = "bold";
})(FontWeight || (FontWeight = {}));
var MediaContentMode;
(function (MediaContentMode) {
    MediaContentMode["AspectFit"] = "aspectFit";
    MediaContentMode["AspectFill"] = "aspectFill";
    MediaContentMode["ScalesToFill"] = "scalesToFill";
})(MediaContentMode || (MediaContentMode = {}));

const SUPPORTED_TEMPLATE_VERSIONS = [
    1,
    2, // Composite templates: Carousel
];
const alignInFlex = (align) => {
    switch (align) {
        case AlignValue.Right:
        case AlignValue.Bottom:
            return 'flex-end';
        case AlignValue.Center:
            return 'center';
        case AlignValue.Left:
        case AlignValue.Top:
        default:
            return 'flex-start';
    }
};
const isTemplateVersionSupported = (templateVersion) => {
    if (!templateVersion)
        return true;
    return SUPPORTED_TEMPLATE_VERSIONS.includes(Number(templateVersion));
};

const memoize = (fn) => {
    const cache = new Map();
    const cached = function (val) {
        return cache.has(val) ? cache.get(val) : cache.set(val, fn.call(this, val)) && cache.get(val);
    };
    cached.cache = cache;
    return cached;
};
/**
 * Generate each item's id by each item's array depth
 */
const setTemplateItemId = memoize((data) => {
    const addIdRecursively = (item, id) => {
        if ('items' in item && (item === null || item === void 0 ? void 0 : item.items) != null) {
            item.items.forEach((subItem, subIdx) => {
                const subId = `${id}-${subIdx}`;
                subItem.id = subId;
                addIdRecursively(subItem, subId);
            });
        }
    };
    data.forEach((item, idx) => {
        const id = `${idx}`;
        item.id = id;
        addIdRecursively(item, id);
    });
    return data;
});

const defaultProperties = {
    rootLayout: Layout.Column,
    view: {
        size: {
            width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
            height: { type: 'flex', value: FlexSizeSpecValue.WrapContent },
        },
    },
    box: {
        layout: Layout.Row,
        align: { vertical: AlignValue.Top, horizontal: AlignValue.Left },
    },
    textButton: {
        maxTextLines: 1,
    },
    carousel: {
        style: {
            spacing: 10,
            maxChildWidth: 240,
        },
    },
};

const createMessageTemplate = (opts) => {
    const Container = opts.Container || react__WEBPACK_IMPORTED_MODULE_0__.Fragment;
    const UnknownMessage = opts.UnknownMessage || (() => null);
    const parser = opts.parser || createParser();
    const renderer = opts.renderer || createRenderer();
    const MessageTemplateBase = ({ templateItems, templateVersion, parentLayout = defaultProperties.box.layout, depth = 0, }) => {
        if (!isTemplateVersionSupported(templateVersion)) {
            throw new Error(`Cannot parse template item due to unsupported template version: ${templateVersion}, ${SUPPORTED_TEMPLATE_VERSIONS}`);
        }
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, templateItems.map((rawItem, index, siblings) => {
            const result = parser.parse(rawItem, { parentLayout, depth, elemIdx: index, siblings });
            const item = result.transformed;
            const rendererProps = {
                key: index,
                siblings,
                parentLayout,
                parsedProperties: result.properties,
            };
            switch (item.type) {
                case ComponentType.Carousel: {
                    if (!Array.isArray(item.items) || item.items.length === 0) {
                        throw new Error('Cannot parse template item as Carousel if carousel has no items.');
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.carouselView, Object.assign({}, item, rendererProps), item.items.map((template, index) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MessageTemplateBase, { key: index, templateItems: template.body.items || [], depth: depth + 1, templateVersion: template.version })))));
                }
                case ComponentType.Box: {
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.box, Object.assign({}, item, rendererProps),
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(MessageTemplateBase, { templateItems: item.items || [], parentLayout: item.layout, depth: depth + 1, templateVersion: templateVersion })));
                }
                case ComponentType.Text: {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.text, Object.assign({}, item, rendererProps));
                }
                case ComponentType.Image: {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.image, Object.assign({}, item, rendererProps));
                }
                case ComponentType.TextButton: {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.textButton, Object.assign({}, item, rendererProps));
                }
                case ComponentType.ImageButton: {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(renderer.imageButton, Object.assign({}, item, rendererProps));
                }
                default: {
                    // or throw new Error('Cannot parse template item')
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(UnknownMessage, { item: item });
                }
            }
        })));
    };
    return {
        MessageTemplate: ({ templateVersion, templateItems, parentLayout = defaultProperties.rootLayout, }) => {
            const items = setTemplateItemId(templateItems);
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContextProvider, null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(MessageTemplateBase, { isRoot: true, parentLayout: parentLayout, templateItems: items, templateVersion: templateVersion }))));
        },
        MessageTemplateBase,
    };
};

var ActionType;
(function (ActionType) {
    ActionType["Web"] = "web";
    ActionType["Custom"] = "custom";
    ActionType["UIKit"] = "uikit";
})(ActionType || (ActionType = {}));

({
    version: 1,
    body: {
        items: [
            {
                type: ComponentType.Image,
                action: { type: ActionType.Web, data: 'https://docs.sendbird.com' },
                height: { type: 'fixed', value: 236 },
                viewStyle: {
                    padding: {
                        left: 4,
                        right: 4,
                        top: 4,
                        bottom: 4,
                    },
                },
                imageUrl: 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                imageStyle: { contentMode: MediaContentMode.AspectFill },
            },
            {
                type: ComponentType.Box,
                layout: Layout.Column,
                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                height: { type: 'fixed', value: 200 },
                items: [
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        viewStyle: { backgroundColor: '#fa6464' },
                    },
                    {
                        type: ComponentType.Box,
                        layout: Layout.Column,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.WrapContent },
                        viewStyle: { backgroundColor: '#ffaf5c' },
                        items: [
                            {
                                type: ComponentType.Text,
                                text: 'Message',
                                align: { horizontal: AlignValue.Center, vertical: AlignValue.Center },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                            },
                            {
                                type: ComponentType.Image,
                                action: { type: ActionType.Web, data: 'https://docs.sendbird.com' },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                                imageUrl: 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                                imageStyle: { contentMode: MediaContentMode.AspectFill },
                            },
                        ],
                    },
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'fixed', value: 20 },
                        viewStyle: { backgroundColor: '#ffe450' },
                    },
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        viewStyle: { backgroundColor: '#329a1b' },
                    },
                ],
            },
            {
                type: ComponentType.Box,
                viewStyle: { padding: { top: 12, bottom: 12, left: 12, right: 12 } },
                layout: Layout.Column,
                items: [
                    {
                        type: ComponentType.Box,
                        align: { horizontal: AlignValue.Left, vertical: AlignValue.Center },
                        layout: Layout.Row,
                        viewStyle: {
                            borderWidth: 1,
                            borderColor: '#72723f',
                        },
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'fixed', value: 150 },
                        items: [
                            {
                                type: ComponentType.Text,
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                                text: 'Sample1 text',
                                maxTextLines: 1,
                                align: { vertical: AlignValue.Center, horizontal: AlignValue.Left },
                                viewStyle: {
                                    backgroundColor: '#cc4400',
                                },
                                textStyle: {
                                    size: 16,
                                    color: '#f8f8f8',
                                    weight: FontWeight.Bold,
                                },
                            },
                            {
                                type: ComponentType.ImageButton,
                                action: { type: ActionType.UIKit, data: 'uikit://delete' },
                                width: { type: 'fixed', value: 20 },
                                height: { type: 'fixed', value: 20 },
                                imageUrl: 'https://file-ap-1.sendbird.com/5b5379aa73fd460da22ffaf9a61d0d7f.png',
                                imageStyle: { contentMode: MediaContentMode.AspectFit },
                            },
                        ],
                    },
                    {
                        type: ComponentType.Text,
                        viewStyle: { padding: { top: 6, bottom: 12, left: 0, right: 0 } },
                        text: 'Esse eu esse duis ipsum et dolor eu ut sit amet consectetur cillum velit officia. Ex adipisicing elit quis ea sit. Occaecat in eu aliqua nulla magna id ut excepteur minim.',
                        maxTextLines: 2,
                        textStyle: { size: 14, color: '#e10000' },
                        width: { type: 'fixed', value: 200 },
                        height: { type: 'fixed', value: 50 },
                    },
                    {
                        type: ComponentType.TextButton,
                        action: { type: ActionType.Web, data: 'https://www.daum.net' },
                        text: 'Button 3',
                        textStyle: { size: 14, color: '#742ddd', weight: FontWeight.Bold },
                    },
                ],
            },
        ],
    },
});
({
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Image,
                'action': { 'type': ActionType.Web, 'data': 'https://www.naver.com/' },
                'height': { 'type': 'fixed', 'value': 136 },
                'imageUrl': 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
            },
            {
                'type': ComponentType.Box,
                'viewStyle': { 'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 }, backgroundColor: '#cccccc' },
                'layout': Layout.Column,
                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                'items': [
                    {
                        'type': ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        'layout': Layout.Row,
                        'items': [
                            {
                                'type': ComponentType.TextButton,
                                'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                width: { type: 'fixed', value: 150 },
                                'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 0, 'right': 4 } },
                                'text': 'Button 2',
                                'textStyle': { 'size': 14, 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.TextButton,
                                'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 4, 'right': 0 } },
                                'text': 'Button 3',
                                'textStyle': { 'size': 14, 'weight': FontWeight.Bold },
                            },
                        ],
                    },
                    {
                        'type': ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        'layout': Layout.Row,
                        'items': [
                            {
                                'type': ComponentType.Text,
                                'text': 'Sample2 text',
                                'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                                'maxTextLines': 1,
                                'textStyle': { 'size': 16, 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.ImageButton,
                                'action': { 'type': ActionType.UIKit, 'data': 'uikit://delete' },
                                'width': { 'type': 'fixed', 'value': 20 },
                                'height': { 'type': 'fixed', 'value': 20 },
                                'imageUrl': 'https://file-ap-1.sendbird.com/5b5379aa73fd460da22ffaf9a61d0d7f.png',
                                'imageStyle': { 'contentMode': MediaContentMode.AspectFit },
                            },
                        ],
                    },
                    {
                        'type': ComponentType.Text,
                        'viewStyle': { 'padding': { 'top': 6, 'bottom': 12, 'left': 0, 'right': 0 } },
                        'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                        'textStyle': { 'size': 14 },
                    },
                ],
            },
        ],
    },
});
({
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Box,
                'viewStyle': { 'backgroundColor': '#ffffff', 'borderWidth': 1, 'borderColor': '#eeeeee', 'radius': 16 },
                'layout': Layout.Column,
                'items': [
                    {
                        'type': ComponentType.Image,
                        'height': { 'type': 'fixed', 'value': 200 },
                        'imageUrl': 'https://img.freepik.com/free-vector/cartoon-happy-hours-background_52683-81243.jpg?w=2000&t=st=1666689198~exp=1666689798~hmac=23109d44ba03deee7aee069cbeebfcb48fa27f85e53c1cafc5d5d7345f1a2041',
                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                    },
                    {
                        'type': ComponentType.Box,
                        'viewStyle': { 'padding': { 'top': 15, 'bottom': 15, 'left': 15, 'right': 15 } },
                        'layout': Layout.Column,
                        'items': [
                            {
                                'type': ComponentType.Text,
                                'text': "Don't miss these deals today",
                                'maxTextLines': 1,
                                'textStyle': { 'size': 20, 'color': '#e10000', 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.Text,
                                'viewStyle': { 'margin': { 'top': 5, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'text': 'Pay with Maya and get cashback!',
                                'maxTextLines': 1,
                                'textStyle': { 'size': 14, 'color': '#e10000' },
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://yt3.ggpht.com/ytc/AMLnZu8Kg89ymE7qt5bsS9vMqi9h2aHiN6m9ID-IgxR6-Q=s900-c-k-c0x00ffffff-no-rj',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Meralco',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://1000logos.net/wp-content/uploads/2021/12/Globe-Telecom-logo.png',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill, tintColor: '#a49a9a' },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Globe',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Cignal.svg/640px-Cignal.svg.png',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Cignal',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.TextButton,
                                        'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                        'viewStyle': {
                                            'backgroundColor': '#e0e0e0',
                                            'radius': 16,
                                            'margin': { 'top': 0, 'bottom': 0, 'left': 0, 'right': 4 },
                                            'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 },
                                        },
                                        'text': 'Learn more',
                                        'textStyle': { 'size': 15, 'color': '#e10000', 'weight': FontWeight.Bold },
                                    },
                                    {
                                        'type': ComponentType.TextButton,
                                        'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                        'viewStyle': {
                                            'backgroundColor': '#e10000',
                                            'radius': 16,
                                            'margin': { 'top': 0, 'bottom': 0, 'left': 4, 'right': 0 },
                                            'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 },
                                        },
                                        'text': 'Pay now',
                                        'textStyle': { 'size': 15, 'color': '#ffffff', 'weight': FontWeight.Bold },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
});
({
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Box,
                'layout': Layout.Column,
                'items': [
                    {
                        'type': ComponentType.Image,
                        'imageUrl': 'https://static.sendbird.com/sample/profiles/profile_40_512px.png',
                        'metaData': {
                            'pixelWidth': 512,
                            'pixelHeight': 512,
                        },
                        'imageStyle': {
                            'tintColor': '#44ff1188',
                        },
                        viewStyle: {
                            'padding': {
                                'top': 12,
                                'right': 12,
                                'bottom': 12,
                                'left': 12,
                            },
                        },
                    },
                    {
                        'type': ComponentType.Box,
                        'viewStyle': {
                            'padding': {
                                'top': 12,
                                'right': 12,
                                'bottom': 12,
                                'left': 12,
                            },
                        },
                        'layout': Layout.Column,
                        'items': [
                            {
                                'type': ComponentType.Box,
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Box,
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'hi',
                                                'maxTextLines': 3,
                                                'viewStyle': {
                                                    'padding': {
                                                        'top': 0,
                                                        'bottom': 6,
                                                        'left': 0,
                                                        'right': 0,
                                                    },
                                                },
                                                'textStyle': {
                                                    'size': 16,
                                                    'weight': FontWeight.Bold,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'bye',
                                                'maxTextLines': 10,
                                                'textStyle': {
                                                    'size': 14,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        'type': ComponentType.ImageButton,
                                        'action': {
                                            'type': ActionType.UIKit,
                                            'data': 'sendbirduikit://delete',
                                        },
                                        'width': {
                                            'type': 'fixed',
                                            'value': 20,
                                        },
                                        'height': {
                                            'type': 'fixed',
                                            'value': 20,
                                        },
                                        'metaData': {
                                            'pixelWidth': 60,
                                            'pixelHeight': 60,
                                        },
                                        'imageUrl': 'https://dxstmhyqfqr1o.cloudfront.net/sendbird-message-builder/icon-more.png',
                                        'imageStyle': {
                                            'tintColor': '#ff8d5a',
                                        },
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'layout': Layout.Column,
                                'items': [
                                    {
                                        'type': ComponentType.Box,
                                        'viewStyle': {
                                            'margin': {
                                                'top': 16,
                                                'bottom': 0,
                                                'left': 0,
                                                'right': 0,
                                            },
                                        },
                                        'align': {
                                            'horizontal': AlignValue.Left,
                                            'vertical': AlignValue.Center,
                                        },
                                        'layout': Layout.Row,
                                        'items': [
                                            {
                                                'type': ComponentType.Image,
                                                'imageUrl': 'https://ca.slack-edge.com/T0ADCTNEL-ULE240VNV-83fd5776e78e-512',
                                                'width': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'height': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'metaData': {
                                                    'pixelWidth': 512,
                                                    'pixelHeight': 512,
                                                },
                                                'viewStyle': {
                                                    'backgroundColor': '#BDBDBD',
                                                    'radius': 20,
                                                },
                                                'imageStyle': {
                                                    'contentMode': MediaContentMode.AspectFill,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Box,
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 0,
                                                        'bottom': 0,
                                                        'left': 12,
                                                        'right': 0,
                                                    },
                                                },
                                                'layout': Layout.Column,
                                                'items': [
                                                    {
                                                        'type': ComponentType.Text,
                                                        'text': 'Chongbu',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 16,
                                                            'weight': FontWeight.Bold,
                                                        },
                                                    },
                                                    {
                                                        'type': ComponentType.Text,
                                                        'viewStyle': {
                                                            'margin': {
                                                                'top': 4,
                                                                'bottom': 0,
                                                                'left': 0,
                                                                'right': 0,
                                                            },
                                                        },
                                                        'text': ' ',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 14,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'viewStyle': {
                                            'margin': {
                                                'top': 16,
                                                'bottom': 0,
                                                'left': 0,
                                                'right': 0,
                                            },
                                        },
                                        'align': {
                                            'horizontal': AlignValue.Left,
                                            'vertical': AlignValue.Center,
                                        },
                                        'layout': Layout.Row,
                                        'items': [
                                            {
                                                'type': ComponentType.Image,
                                                'imageUrl': 'https://ca.slack-edge.com/T0ADCTNEL-U02LA25KY8J-d41a3e8c7554-512',
                                                'width': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'height': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'metaData': {
                                                    'pixelWidth': 512,
                                                    'pixelHeight': 512,
                                                },
                                                'viewStyle': {
                                                    'backgroundColor': '#BDBDBD',
                                                    'radius': 20,
                                                },
                                                'imageStyle': {
                                                    'contentMode': MediaContentMode.AspectFill,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Box,
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 0,
                                                        'bottom': 0,
                                                        'left': 12,
                                                        'right': 0,
                                                    },
                                                },
                                                'layout': Layout.Column,
                                                'items': [
                                                    {
                                                        'type': ComponentType.Text,
                                                        'text': 'Amanda',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 16,
                                                            'weight': FontWeight.Bold,
                                                        },
                                                    },
                                                    {
                                                        'type': ComponentType.Text,
                                                        'viewStyle': {
                                                            'margin': {
                                                                'top': 4,
                                                                'bottom': 0,
                                                                'left': 0,
                                                                'right': 0,
                                                            },
                                                        },
                                                        'text': 'This is title message',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 14,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
});
({
    'version': '1',
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                height: { type: 'fixed', value: 600 },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'viewStyle': { 'radius': '8', 'padding': { 'top': '12', 'bottom': '12', 'left': '12', 'right': '12' } },
                        'items': [
                            {
                                'type': 'text',
                                'text': 'Title text',
                                'textStyle': { 'color': '#E0000000', 'size': '16', 'weight': 'bold' },
                                'maxTextLines': '5',
                                'viewStyle': {},
                                'action': { 'data': 'www.naver.com' },
                            },
                            {
                                'type': 'text',
                                'viewStyle': { 'margin': { 'top': '8', 'right': '0', 'bottom': '0', 'left': '0' } },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': { 'color': '#E0000000', 'size': '14', 'weight': 'normal' },
                                'maxTextLines': '5',
                                'action': { 'data': 'https://www.naver.com' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'viewStyle': { 'margin': { 'top': '12', 'right': '0', 'bottom': '0', 'left': '0' } },
                                'items': [
                                    {
                                        'type': 'textButton',
                                        'viewStyle': {
                                            'backgroundColor': '#E0E0E0',
                                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                                        },
                                        'text': 'Button 1',
                                        'textStyle': { 'color': '#742DDD', 'size': '14', 'weight': 'bold' },
                                        'maxTextLines': '5',
                                        'action': { 'data': 'www.naver.com' },
                                    },
                                    {
                                        'type': 'textButton',
                                        'viewStyle': {
                                            'backgroundColor': '#E0E0E0',
                                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                                            'margin': { 'left': '8', 'right': '0', 'top': '0', 'bottom': '0' },
                                        },
                                        'text': 'Button 2',
                                        'textStyle': { 'color': '#742DDD', 'size': '14', 'weight': 'bold' },
                                        'maxTextLines': '5',
                                        'action': { 'data': 'https://www.naver.com' },
                                    },
                                ],
                            },
                        ],
                        'action': { 'data': 'https://www.naver.com' },
                    },
                    {
                        'type': 'image',
                        'viewStyle': {},
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'imageUrl': 'https://file-preprod.sendbird.com/d03c08bb3f9041a88c1207b6bbf15ab8.png',
                        'metaData': { 'pixelWidth': '1062', 'pixelHeight': '1070' },
                    },
                    {
                        'type': 'textButton',
                        'viewStyle': {
                            'backgroundColor': '#E0E0E0',
                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                        },
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'text': 'Button',
                        'textStyle': { 'color': '#742DDD', 'size': '16', 'weight': 'normal' },
                        'maxTextLines': '5',
                        'action': { 'data': 'www.naver.com' },
                    },
                    {
                        'type': 'imageButton',
                        'viewStyle': {},
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'imageUrl': 'https://file-preprod.sendbird.com/38fdf5c1056f42b89a44b38155cc4b49.jpg',
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'metaData': { 'pixelWidth': '1080', 'pixelHeight': '2640' },
                        'action': { 'data': 'www.naver.com' },
                    },
                ],
                'viewStyle': {},
            },
        ],
    },
});
({
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': FlexSizeSpecValue.FillParent,
                },
                'height': {
                    'type': 'flex',
                    'value': FlexSizeSpecValue.WrapContent,
                },
                'items': [
                    {
                        'type': 'text',
                        'viewStyle': {
                            'backgroundColor': '#a0c0ffff',
                            'margin': {
                                'top': 16,
                                'bottom': 16,
                                'left': 16,
                                'right': 16,
                            },
                            'padding': {
                                'top': 16,
                                'bottom': 16,
                                'left': 16,
                                'right': 16,
                            },
                        },
                        'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                        'textStyle': {
                            'size': 14,
                            'color': '#222121e0',
                            'weight': 'normal',
                        },
                        'maxTextLines': 5,
                        'width': {
                            'type': 'flex',
                            'value': FlexSizeSpecValue.FillParent,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                    },
                    {
                        'type': 'imageButton',
                        'viewStyle': {
                            margin: {
                                left: 24,
                                right: 12,
                            },
                        },
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'fixed', 'value': 250 },
                        'imageUrl': 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'metaData': { 'pixelWidth': '1080', 'pixelHeight': '2640' },
                        'action': { 'data': 'www.naver.com' },
                    },
                ],
            },
        ],
    },
});

const SWIPE_THRESHOLD = 24;
function useCarousel({ spacing, childrenLength, paddingInlineStart, paddingInlineEnd }) {
    // TODO: RTL support
    const paddingStart = paddingInlineStart;
    const paddingEnd = paddingInlineEnd;
    const carouselRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const childrenRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Array.from({ length: childrenLength }, () => react__WEBPACK_IMPORTED_MODULE_0__.createRef()));
    const isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const isScrolling = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const animationFrame = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const drag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        sx: null,
        sy: null,
        offset: 0,
        translateX: 0,
        currentIndex: 0,
    });
    const [childWidths, setChildWidths] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => childrenRefs.current.map(() => 0));
    const itemPositions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        let currentPosition = paddingStart;
        return childWidths.map((width, i) => {
            const start = currentPosition - (i > 0 ? spacing : 0);
            const end = start - width;
            currentPosition = end;
            return { start, end };
        });
    }, [childWidths, spacing, paddingStart]);
    const totalContentWidth = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        const totalItemWidth = childWidths.reduce((acc, width) => acc + width, 0);
        const totalSpacing = spacing * (childrenLength - 1);
        return totalItemWidth + totalSpacing;
    }, [childWidths, spacing, childrenLength]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
        setChildWidths(childrenRefs.current.map((ref) => { var _a, _b; return (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0; }));
    }, [childrenLength]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
        if (itemPositions.length > 0) {
            drag.current.translateX = itemPositions[0].start;
            animate();
        }
    }, [itemPositions]);
    const dragStart = () => {
        if (!carouselRef.current)
            return;
        isDragging.current = true;
        carouselRef.current.style.cursor = 'grabbing';
        carouselRef.current.style.transition = 'none';
        animationFrame.current = requestAnimationFrame(animate);
    };
    const dragStop = () => {
        if (!carouselRef.current)
            return;
        isDragging.current = false;
        carouselRef.current.style.cursor = 'grab';
        carouselRef.current.style.transition = 'transform 0.5s ease';
        if (animationFrame.current) {
            cancelAnimationFrame(animationFrame.current);
            animationFrame.current = null;
        }
    };
    const dragRelease = () => {
        const { offset, currentIndex } = drag.current;
        const thresholdExceeded = Math.abs(offset) >= SWIPE_THRESHOLD;
        const swipeToNext = offset < 0 && currentIndex < childrenLength - 1;
        const swipeToPrev = offset > 0 && currentIndex > 0;
        let newIndex = currentIndex;
        if (thresholdExceeded && swipeToNext) {
            newIndex = currentIndex + 1;
        }
        else if (thresholdExceeded && swipeToPrev) {
            newIndex = currentIndex - 1;
        }
        function clampTranslateX(translateX) {
            var _a, _b;
            const containerWidth = (_b = (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
            const start = paddingStart;
            const end = Math.min(0, containerWidth - totalContentWidth) - paddingEnd;
            return Math.min(start, Math.max(end, translateX));
        }
        drag.current.currentIndex = newIndex;
        drag.current.translateX = clampTranslateX(itemPositions[newIndex].start);
        drag.current.offset = 0;
    };
    const scrollStart = () => {
        isScrolling.current = true;
    };
    const scrollStop = () => {
        isScrolling.current = false;
    };
    const animate = () => {
        if (carouselRef.current) {
            carouselRef.current.style.transform = `translateX(${drag.current.translateX + drag.current.offset}px)`;
        }
        if (animationFrame.current) {
            animationFrame.current = requestAnimationFrame(animate);
        }
    };
    const blockScroll = () => {
        if (carouselRef.current) {
            carouselRef.current.style.touchAction = 'pan-x';
        }
    };
    const unblockScroll = () => {
        if (carouselRef.current) {
            carouselRef.current.style.touchAction = 'pan-y';
        }
    };
    const onMouseDown = (event) => {
        dragStart();
        scrollStop();
        drag.current.sx = event.clientX;
        drag.current.sy = event.clientY;
        drag.current.offset = 0;
        animationFrame.current = requestAnimationFrame(animate);
    };
    const onMouseMove = (event) => {
        if (!isDragging.current || drag.current.sx === null)
            return;
        drag.current.offset = event.clientX - drag.current.sx;
    };
    const onMouseUp = () => {
        if (!isDragging.current)
            return;
        scrollStop();
        dragRelease();
        dragStop();
    };
    const onMouseLeave = () => {
        if (!isDragging.current)
            return;
        scrollStop();
        dragRelease();
        dragStop();
    };
    const onTouchStart = (event) => {
        scrollStop();
        dragStop();
        const touch = event.touches[0];
        drag.current.sx = touch.clientX;
        drag.current.sy = touch.clientY;
        drag.current.offset = 0;
        animationFrame.current = requestAnimationFrame(animate);
    };
    const onTouchMove = (event) => {
        if (drag.current.sx === null || drag.current.sy === null || isScrolling.current)
            return;
        const { clientX, clientY } = event.touches[0];
        const { sx, sy } = drag.current;
        if (isDragging.current) {
            drag.current.offset = clientX - sx;
            return;
        }
        const isVerticalScroll = Math.abs(clientY - sy) > Math.abs(clientX - sx);
        if (isVerticalScroll) {
            scrollStart();
        }
        else {
            drag.current.offset = clientX - sx;
            blockScroll();
            dragStart();
        }
    };
    const onTouchEnd = () => {
        unblockScroll();
        scrollStop();
        dragRelease();
        dragStop();
    };
    return {
        carouselRef,
        childrenRefs,
        handlers: {
            onMouseDown,
            onMouseMove,
            onMouseUp,
            onMouseLeave,
            onTouchStart,
            onTouchMove,
            onTouchEnd,
        },
    };
}

var __rest$4 = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const Carousel = ({ children, style, spacing = defaultProperties.carousel.style.spacing, maxChildWidth = defaultProperties.carousel.style.maxChildWidth, }) => {
    const _a = style !== null && style !== void 0 ? style : {}, { paddingInlineStart = 0, paddingInlineEnd = 0 } = _a, restStyle = __rest$4(_a, ["paddingInlineStart", "paddingInlineEnd"]);
    const { carouselRef, childrenRefs, handlers } = useCarousel({
        spacing,
        childrenLength: children.length,
        paddingInlineStart: Number(paddingInlineStart),
        paddingInlineEnd: Number(paddingInlineEnd),
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({}, handlers, { ref: carouselRef, className: 'sb-message-template__carousel', style: Object.assign(Object.assign({}, restStyle), { gap: spacing, width: '100%', overflow: 'visible' }) }), children.map((item, index) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(CarouselChild, { ref: childrenRefs.current[index], key: index, maxChildWidth: maxChildWidth }, item)))));
};
const CarouselChild = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CarouselChild({ maxChildWidth, children }, ref) {
    const maxWidth = shouldSetMaxChildWidth(children.props, maxChildWidth) ? maxChildWidth : 'fit-content';
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: ref, style: { maxWidth, width: '100%', flexShrink: 0, overflow: 'hidden', userSelect: 'none' } }, children));
});
// Note: Set the maxChildWidth because it's impossible to determine the maximum width of items in the Carousel Child template when they have FillParent
function shouldSetMaxChildWidth(props, maxChildWidth) {
    return !!props.templateItems.find((it) => {
        var _a, _b, _c, _d;
        const hasFillWidth = ((_a = it.width) === null || _a === void 0 ? void 0 : _a.type) === 'flex' && ((_b = it.width) === null || _b === void 0 ? void 0 : _b.value) === FlexSizeSpecValue.FillParent;
        const overMaxChildWidth = ((_c = it.width) === null || _c === void 0 ? void 0 : _c.type) === 'fixed' && ((_d = it.width) === null || _d === void 0 ? void 0 : _d.value) >= maxChildWidth;
        return hasFillWidth || overMaxChildWidth;
    });
}

function isWrappedText(view) {
    var _a;
    return view.type === ComponentType.Text && ((_a = view.width) === null || _a === void 0 ? void 0 : _a.value) == FlexSizeSpecValue.WrapContent;
}
// Compares the size spec to the option and returns whether they are equal or not.
const isSizeCompatibleWithOption = ({ size, option, }) => {
    if (option === 'wrap') {
        return size.type === 'flex' && size.value == FlexSizeSpecValue.WrapContent;
    }
    if (option === 'fill') {
        return size.type === 'flex' && size.value == FlexSizeSpecValue.FillParent;
    }
    return size.type === 'fixed';
};
const isGif = (url) => {
    var _a;
    if (typeof url !== 'string')
        return false;
    const extension = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return extension === 'gif';
};

var __rest$3 = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const CanvasReactMessageTemplateImage = (props) => {
    const { imageSize, canvasRef, canvasProps } = useCanvasMessageTemplateImage(props);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("canvas", Object.assign({}, canvasProps, { ref: canvasRef, width: imageSize === null || imageSize === void 0 ? void 0 : imageSize.width, height: imageSize === null || imageSize === void 0 ? void 0 : imageSize.height, onError: props.onError })));
};
const useCanvasMessageTemplateImage = (_a) => {
    var { metaData, tintColor } = _a, props = __rest$3(_a, ["metaData", "tintColor"]);
    const canvasRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [fallbackImageSize, setFallbackImageSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const imageSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        if ((metaData === null || metaData === void 0 ? void 0 : metaData.pixelHeight) && (metaData === null || metaData === void 0 ? void 0 : metaData.pixelWidth)) {
            return { width: metaData.pixelWidth, height: metaData.pixelHeight };
        }
        return fallbackImageSize;
    }, [fallbackImageSize, metaData === null || metaData === void 0 ? void 0 : metaData.pixelHeight, metaData === null || metaData === void 0 ? void 0 : metaData.pixelWidth]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (imageSize == null) {
            console.log('Canvas_ReactMessageTemplateImage: no metaData, render fit to container');
            if (canvasRef.current) {
                canvasRef.current.style.width = '100%';
                canvasRef.current.style.height = '100%';
                const containerSize = canvasRef.current.getBoundingClientRect();
                setFallbackImageSize(containerSize);
            }
        }
    }, [imageSize]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (props.src) {
            const img = new Image();
            const onImageLoad = () => {
                if (canvasRef.current && tintColor && imageSize) {
                    const ctx = canvasRef.current.getContext('2d');
                    if (ctx) {
                        const { width: imageWidth, height: imageHeight } = imageSize;
                        // reset context before draw, consider `.save()` and `.restore()` api
                        ctx.clearRect(0, 0, imageWidth, imageHeight);
                        ctx.beginPath();
                        ctx.globalCompositeOperation = 'source-over';
                        ctx.fillStyle = '#000';
                        // draw
                        ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
                        ctx.globalCompositeOperation = 'source-atop';
                        ctx.fillStyle = tintColor;
                        ctx.fillRect(0, 0, imageWidth, imageHeight);
                    }
                }
            };
            const onImageError = (event) => {
                var _a;
                // @ts-ignore
                (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, event);
            };
            img.addEventListener('load', onImageLoad);
            img.addEventListener('error', onImageError);
            img.src = props.src;
            return () => {
                img.removeEventListener('load', onImageLoad);
                img.removeEventListener('error', onImageError);
            };
        }
        return;
    }, [props.src, imageSize, tintColor]);
    return {
        canvasRef,
        canvasProps: props,
        imageSize,
    };
};

const ImgReactMessageTemplateImage = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", Object.assign({}, props, { onError: props.onError, referrerPolicy: "no-referrer" }));
};

const PlaceholderReactMessageTemplateImage = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: Object.assign(Object.assign({}, props.style), { backgroundColor: 'transparent' }) });
};

var __rest$2 = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const ReactMessageTemplateImage = (_a) => {
    var { tintColor, metaData } = _a, props = __rest$2(_a, ["tintColor", "metaData"]);
    const { hasError, onError } = useImageLoadError(props.src);
    if (props.onError)
        console.warn('`onError` is intercepted and not executed in the ReactMessageTemplateImage.');
    if (hasError) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(PlaceholderReactMessageTemplateImage, Object.assign({}, props));
    }
    else if (tintColor && !isGif(props.src)) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(CanvasReactMessageTemplateImage, Object.assign({}, props, { onError: onError, tintColor: tintColor, metaData: metaData }));
    }
    else {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImgReactMessageTemplateImage, Object.assign({}, props, { onError: onError }));
    }
};
const useImageLoadError = (source) => {
    const [hasError, setHasError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => setHasError(false), [source]);
    return {
        hasError,
        onError: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setHasError(true), []),
    };
};

function getDefaultStyles(overrides) {
    return Object.assign({ display: 'flex', overflow: 'hidden', boxSizing: 'border-box' }, overrides);
}
function setViewProps(styles, props, options) {
    setViewSize(styles, props, options);
    setViewStyle(styles, props);
}
function setBorderStyle(styles, borderWidth, borderColor, radius) {
    if (borderWidth) {
        styles['--border-width'] = `${borderWidth}px`;
        styles['--border-color'] = borderColor || 'transparent';
    }
    if (radius) {
        styles['borderRadius'] = radius;
        styles['--border-radius'] = `${radius}px`;
    }
}
function setViewStyle(styles, props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { viewStyle } = props;
    styles['marginBlockStart'] = (_a = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _a === void 0 ? void 0 : _a.top;
    styles['marginBlockEnd'] = (_b = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _b === void 0 ? void 0 : _b.bottom;
    styles['marginInlineStart'] = (_c = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _c === void 0 ? void 0 : _c.left;
    styles['marginInlineEnd'] = (_d = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _d === void 0 ? void 0 : _d.right;
    const marginHorizontal = ((_f = (_e = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _e === void 0 ? void 0 : _e.left) !== null && _f !== void 0 ? _f : 0) + ((_h = (_g = viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.margin) === null || _g === void 0 ? void 0 : _g.right) !== null && _h !== void 0 ? _h : 0);
    if (marginHorizontal > 0 && styles.width === '100%')
        styles.width = `calc(100% - ${marginHorizontal}px)`;
    if (viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.backgroundColor)
        styles['backgroundColor'] = viewStyle.backgroundColor;
    // use JSON.stringify to escape special characters in image URL
    if (viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.backgroundImageUrl) {
        styles['backgroundImage'] = `url(${JSON.stringify(viewStyle.backgroundImageUrl)})`;
        styles['backgroundSize'] = '100% 100%';
        styles['backgroundPosition'] = 'center';
    }
    setBorderStyle(styles, viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.borderWidth, viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.borderColor, viewStyle === null || viewStyle === void 0 ? void 0 : viewStyle.radius);
}
function getViewSizeStyle(width, height, parentLayout) {
    const style = {};
    if (width.type === 'flex' && width.value == FlexSizeSpecValue.FillParent) {
        style['width'] = '100%';
        if (parentLayout === Layout.Row) {
            style['flex'] = 1;
        }
    }
    else if (width.type === 'fixed' && width.value >= 0) {
        style['width'] = width.value;
    }
    if (height.type === 'flex' && height.value == FlexSizeSpecValue.FillParent) {
        style['height'] = '100%';
        if (parentLayout === Layout.Column) {
            style['flex'] = 1;
        }
    }
    else if (height.type === 'fixed' && height.value >= 0) {
        style['height'] = height.value;
    }
    return style;
}
function setViewSize(styles, props, options) {
    var _a, _b;
    const { width: defaultWidth, height: defaultHeight } = defaultProperties.view.size;
    const { parentLayout } = options;
    const sizeStyle = getViewSizeStyle((_a = props.width) !== null && _a !== void 0 ? _a : defaultWidth, (_b = props.height) !== null && _b !== void 0 ? _b : defaultHeight, parentLayout);
    Object.assign(styles, sizeStyle);
}
function setAlign(styles, layout = defaultProperties.box.layout, align = defaultProperties.box.align) {
    if (layout === Layout.Row) {
        styles['flexDirection'] = 'row';
        styles['alignItems'] = alignInFlex(align.vertical);
        styles['justifyContent'] = alignInFlex(align.horizontal);
    }
    if (layout === Layout.Column) {
        styles['flexDirection'] = 'column';
        styles['alignItems'] = alignInFlex(align.horizontal);
        styles['justifyContent'] = alignInFlex(align.vertical);
    }
}
function setTextAlign(styles, align = defaultProperties.box.align.horizontal) {
    styles.textAlign = align;
}
function setImageStyle(styles, imageStyle) {
    const { contentMode = MediaContentMode.AspectFit } = imageStyle || {};
    if (contentMode) {
        switch (contentMode) {
            case MediaContentMode.AspectFill:
                styles['objectFit'] = 'cover';
                break;
            case MediaContentMode.AspectFit:
                styles['objectFit'] = 'contain';
                break;
            case MediaContentMode.ScalesToFill:
                styles['objectFit'] = 'fill';
                break;
        }
    }
}
// uses image meta-data to render images that doesn't break the UI
// https://sendbird.atlassian.net/wiki/spaces/UK/pages/2008220608/Message+template+-+Image+policy
function setImageAspectRatio(styles, props) {
    var _a, _b, _c, _d;
    const imageMetaData = props === null || props === void 0 ? void 0 : props.metaData;
    if (!(imageMetaData === null || imageMetaData === void 0 ? void 0 : imageMetaData.pixelHeight) || !(imageMetaData === null || imageMetaData === void 0 ? void 0 : imageMetaData.pixelWidth)) {
        return;
    }
    if (((_a = props === null || props === void 0 ? void 0 : props.width) === null || _a === void 0 ? void 0 : _a.type) === 'fixed' || ((_b = props === null || props === void 0 ? void 0 : props.height) === null || _b === void 0 ? void 0 : _b.type) === 'fixed') {
        return;
    }
    styles['aspectRatio'] = `${(_c = props === null || props === void 0 ? void 0 : props.metaData) === null || _c === void 0 ? void 0 : _c.pixelWidth} / ${(_d = props === null || props === void 0 ? void 0 : props.metaData) === null || _d === void 0 ? void 0 : _d.pixelHeight}`;
}
function webkitLineClampStyles(numberOfLines) {
    return {
        WebkitLineClamp: numberOfLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        flex: 1,
    };
}
function setTextStyle(styles, props, options) {
    const { textStyle, width } = props;
    // TODO: Change default as design
    const { size, color, weight } = textStyle || {};
    if (size)
        styles['fontSize'] = size;
    if (color)
        styles['color'] = color;
    if (weight)
        styles['fontWeight'] = weight;
    if ((width === null || width === void 0 ? void 0 : width.type) === 'flex' && (width === null || width === void 0 ? void 0 : width.value) == FlexSizeSpecValue.WrapContent) {
        styles['width'] = 'fit-content';
        styles['maxWidth'] = '100%';
    }
    if (props.type === ComponentType.Text) {
        const { siblings, elemIdx } = options;
        // To push out any subsequent components from the container,
        // if a prior one is long enough to occupy an entire line
        // @link https://sendbird.atlassian.net/browse/NOTI-709
        if (siblings != null && siblings.length >= 2 && siblings.every(isWrappedText)) {
            styles.flexShrink = siblings.length - 1 === elemIdx ? 1 : 0;
        }
    }
}

// create a context provider for MessageComponent
//  - this is a wrapper for MessageComponent
const MessageContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const MessageProvider = (props) => {
    const { message, handleWebAction, handleCustomAction, handlePredefinedAction, children } = props;
    const value = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
        message,
        handleWebAction,
        handleCustomAction,
        handlePredefinedAction,
    }), [message === null || message === void 0 ? void 0 : message.updatedAt]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(MessageContext.Provider, { value: value }, children);
};
const useMessageContext = () => {
    const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MessageContext);
    if (!context) {
        throw new Error('useMessageContext must be used within a MessageProvider');
    }
    return context;
};

/**
 * Preserves a reference to the given callback function as an argument while the component is mounted.
 * Wraps the given callback in React's Ref to preserve the reference.
 * @param callback want to be preserved
 */
function usePreservedCallback(callback) {
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        callbackRef.current = callback;
    }, [callback]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => {
        return callbackRef.current(...args);
    }, [callbackRef]);
}

/**
 * This hook can be used when you want to safely effect the value stored in useRef
 * Got this idea from https://github.com/facebook/react/issues/15176
 * @param callback
 * @param deps
 * @returns effect callback
 */
function useRefEffect(callback, deps) {
    const preservedCallback = usePreservedCallback(callback);
    const disposeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(noop);
    const effect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((element) => {
        disposeRef.current();
        disposeRef.current = noop;
        if (element != null) {
            const cleanup = callback(element);
            if (typeof cleanup === 'function') {
                disposeRef.current = cleanup;
            }
        }
    }, [preservedCallback, ...deps]);
    return effect;
}
function noop() { }

/**
 * Subscribes to ResizeObserver on the component exposing the Ref,
 * to detect changes in the size of DOM elements.
 * The ResizeObserver API is required.
 * If you are targeting browsers that do not support that API, probably need to add appropriate polyfill too.
 * @param onResize
 * @returns ref
 */
function useResizeObserver(onResize) {
    const resizeCallback = usePreservedCallback(onResize);
    const ref = useRefEffect((elem) => {
        const observer = new ResizeObserver((entries) => {
            if (entries[0] != null) {
                resizeCallback(entries[0]);
            }
        });
        observer.observe(elem);
        return () => {
            observer.unobserve(elem);
        };
    }, [resizeCallback]);
    return ref;
}

/**
 * @returns an element's width / height observed by IntersectionObserver,
 * and ref to detect its resize event
 */
function useElementSize() {
    const [width, setWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const [contentWidth, setContentWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const [contentHeight, setContentHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const [paddingWidth, setPaddingWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const [paddingHeight, setPaddingHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
    const ref = useResizeObserver((entry) => {
        // contentRect: content size only
        const { width: contentWidth, height: contentHeight } = entry.contentRect;
        // target: content + padding + border size
        const target = entry.target;
        const { width, height } = target.getBoundingClientRect();
        setWidth(width);
        setHeight(height);
        setContentWidth(contentWidth);
        setContentHeight(contentHeight);
        setPaddingWidth(width - contentWidth);
        setPaddingHeight(height - contentHeight);
    });
    return { ref, width, height, contentWidth, contentHeight, paddingWidth, paddingHeight };
}

var __rest$1 = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function isViewCompatibleWithSizeOption({ width = defaultProperties.view.size.width, height = defaultProperties.view.size.height, parentLayout = defaultProperties.box.layout, option, }) {
    if (parentLayout === Layout.Row) {
        return isSizeCompatibleWithOption({
            size: width,
            option,
        });
    }
    return isSizeCompatibleWithOption({
        size: height,
        option,
    });
}
function useRecalculateWidth(params) {
    const { style, props } = params;
    const _a = useElementSize(), { ref: elemRef } = _a, size = __rest$1(_a, ["ref"]);
    const { updateSize, sizes } = useSizeContext();
    const { id, siblings, parentLayout } = props;
    const { width, height, paddingWidth, paddingHeight, contentWidth, contentHeight } = size;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        updateSize({
            id: props.id,
            width,
            height,
            paddingWidth,
            paddingHeight,
            contentWidth,
            contentHeight,
        });
    }, [props.id, width, height, paddingWidth, paddingHeight, contentWidth, contentHeight, updateSize]);
    const currentStyle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        const sumViewSize = (acc = 0, view) => {
            var _a, _b, _c, _d;
            if (parentLayout === Layout.Row) {
                return acc + ((_b = (_a = sizes[view.id]) === null || _a === void 0 ? void 0 : _a.contentWidth) !== null && _b !== void 0 ? _b : 0);
            }
            return acc + ((_d = (_c = sizes[view.id]) === null || _c === void 0 ? void 0 : _c.contentHeight) !== null && _d !== void 0 ? _d : 0);
        };
        const hasFillOption = isViewCompatibleWithSizeOption({
            width: props.width,
            height: props.height,
            parentLayout,
            option: 'fill',
        });
        if (hasFillOption) {
            const wrapSiblingsSize = siblings
                .filter(({ width, height }) => !isViewCompatibleWithSizeOption({
                width: width,
                height: height,
                parentLayout,
                option: 'fill',
            }))
                .reduce(sumViewSize, 0);
            const fillSiblingCount = siblings.filter(({ width, height }) => isViewCompatibleWithSizeOption({
                width: width,
                height: height,
                parentLayout,
                option: 'fill',
            })).length;
            const maxSizeOption = (() => {
                if (parentLayout === Layout.Row) {
                    return {
                        maxWidth: `calc((100% - ${wrapSiblingsSize}px) / ${fillSiblingCount})`,
                    };
                }
                return {
                    maxHeight: `calc((100% - ${wrapSiblingsSize}px) / ${fillSiblingCount})`,
                };
            })();
            return Object.assign(Object.assign(Object.assign({}, style), maxSizeOption), (width == 0 && { height: 0 }));
        }
        else {
            const currentElemIdx = siblings.findIndex((sibling) => sibling.id === id);
            const forwardSiblingsSize = siblings
                .slice(0, currentElemIdx)
                .filter(({ width, height }) => isViewCompatibleWithSizeOption({
                width: width,
                height: height,
                parentLayout,
                option: 'wrap',
            }))
                .reduce(sumViewSize, 0);
            return Object.assign(Object.assign(Object.assign({}, style), (width === 0 && { height: 0 })), (parentLayout === Layout.Row
                ? {
                    maxWidth: `calc(100% - ${forwardSiblingsSize}px)`,
                }
                : {
                    maxHeight: `calc(100% - ${forwardSiblingsSize}px)`,
                }));
        }
    }, [props.width, props.height, parentLayout, sizes, siblings, style, width, id]);
    return { recalculatedStyle: currentStyle, elemRef };
}

var __rest = ( false) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const hasValidUrlProtocol = (url = '') => ['http://', 'https://', 'ftp://'].some((protocol) => url.startsWith(protocol));
/**
 * @param url - url to be checked
 * @returns url with http:// protocol if it doesn't have any protocol
 * @example
 * returnUrl('www.sendbird.com') // returns 'http://www.sendbird.com'
 * returnUrl('https://www.sendbird.com') // returns 'https://www.sendbird.com'
 * returnUrl('ftp://www.sendbird.com') // returns 'ftp://www.sendbird.com'
 * returnUrl('sendbird.com') // returns 'https://sendbird.com'
 **/
const returnUrl = (url = '') => {
    if (hasValidUrlProtocol(url)) {
        return url;
    }
    return `https://${url}`;
};
// todo: semantic html here is not perfect, need to revisit. Same for Button
const ActionHandler = ({ children, props, className, style }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { recalculatedStyle, elemRef } = useRecalculateWidth({ style, props });
    const { message, handleWebAction, handleCustomAction, handlePredefinedAction } = useMessageContext();
    const borderClass = ((_a = props.viewStyle) === null || _a === void 0 ? void 0 : _a.borderWidth) ? 'sb-message-template__border' : '';
    const paddingStyles = {
        paddingBlockStart: (_c = (_b = props.viewStyle) === null || _b === void 0 ? void 0 : _b.padding) === null || _c === void 0 ? void 0 : _c.top,
        paddingBlockEnd: (_e = (_d = props.viewStyle) === null || _d === void 0 ? void 0 : _d.padding) === null || _e === void 0 ? void 0 : _e.bottom,
        paddingInlineStart: (_g = (_f = props.viewStyle) === null || _f === void 0 ? void 0 : _f.padding) === null || _g === void 0 ? void 0 : _g.left,
        paddingInlineEnd: (_j = (_h = props.viewStyle) === null || _h === void 0 ? void 0 : _h.padding) === null || _j === void 0 ? void 0 : _j.right,
    };
    const onClick = (e) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (((_a = props.action) === null || _a === void 0 ? void 0 : _a.type) === 'web') {
            if (handleWebAction) {
                handleWebAction(e, props.action, message);
            }
            else {
                (_c = window === null || window === void 0 ? void 0 : window.open(returnUrl((_b = props === null || props === void 0 ? void 0 : props.action) === null || _b === void 0 ? void 0 : _b.data), '_blank', 'noopener noreferrer')) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
        else if (((_d = props.action) === null || _d === void 0 ? void 0 : _d.type) === 'custom') {
            if (handleCustomAction) {
                handleCustomAction(e, props.action, message);
            }
            else {
                (_f = window === null || window === void 0 ? void 0 : window.open(returnUrl((_e = props === null || props === void 0 ? void 0 : props.action) === null || _e === void 0 ? void 0 : _e.data), '_blank', 'noopener noreferrer')) === null || _f === void 0 ? void 0 : _f.focus();
            }
        }
        else if (((_g = props.action) === null || _g === void 0 ? void 0 : _g.type) === 'uikit') {
            handlePredefinedAction === null || handlePredefinedAction === void 0 ? void 0 : handlePredefinedAction(e, props.action, message);
        }
    };
    if (props.type === ComponentType.TextButton) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", { className: clx(className, borderClass), "data-sb-template-id": props.elementId, style: Object.assign(Object.assign({}, style), paddingStyles), onClick: onClick }, children));
    }
    const { display, flexDirection, justifyContent, alignItems, objectFit } = recalculatedStyle, wrapperStyles = __rest(recalculatedStyle, ["display", "flexDirection", "justifyContent", "alignItems", "objectFit"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: elemRef, className: clx(className, borderClass, props.action && 'sb-message-template__action'), "data-sb-template-id": props.elementId, style: wrapperStyles, onClick: onClick },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: Object.assign({ display,
                flexDirection,
                justifyContent,
                alignItems,
                objectFit, width: '100%', height: '100%' }, paddingStyles) }, children)));
};
function clx(...names) {
    return names.filter((it) => !!it).join(' ');
}

/**
 * Text that is fixed or fill parent should be wrapped in a div with max-width: 100% and max-height: 100%
 * This is to prevent text from overflowing the padding of the container
 */
function isFixedOrFill(view) {
    var _a, _b, _c, _d;
    const heightType = (_a = view === null || view === void 0 ? void 0 : view.height) === null || _a === void 0 ? void 0 : _a.type;
    const widthType = (_b = view === null || view === void 0 ? void 0 : view.width) === null || _b === void 0 ? void 0 : _b.type;
    const isFixedDiamension = heightType === 'fixed' || widthType === 'fixed';
    const isFill = (heightType === 'flex' && ((_c = view === null || view === void 0 ? void 0 : view.height) === null || _c === void 0 ? void 0 : _c.value) === FlexSizeSpecValue.FillParent) ||
        (widthType === 'flex' && ((_d = view === null || view === void 0 ? void 0 : view.width) === null || _d === void 0 ? void 0 : _d.value) === FlexSizeSpecValue.FillParent);
    return isFixedDiamension || isFill;
}
function convertNewlinesToBr(text) {
    return text.split('\n').map((line, index) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: index },
        line,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null))));
}
function renderText(view) {
    const { text, maxTextLines } = view;
    const isToBeWrapped = isFixedOrFill(view);
    const hasMaxLines = typeof maxTextLines === 'number' && maxTextLines > 0;
    const convertedText = convertNewlinesToBr(text);
    if (hasMaxLines || isToBeWrapped) {
        const wrapperStyling = Object.assign(Object.assign({}, ((hasMaxLines || isToBeWrapped) && { maxWidth: '100%' })), (isToBeWrapped && { maxHeight: '100%', overflow: 'hidden' }));
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: wrapperStyling }, hasMaxLines ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: webkitLineClampStyles(maxTextLines) }, convertedText) : convertedText));
    }
    return hasMaxLines ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: webkitLineClampStyles(maxTextLines) }, convertedText) : convertedText;
}
const renderer = createRenderer({
    views: {
        box(props) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionHandler, { className: "sb-message-template__box", elementId: props.elementId, style: props.parsedProperties, props: props }, props.children));
        },
        text(props) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionHandler, { className: "sb-message-template__text", elementId: props.elementId, style: props.parsedProperties, props: props }, renderText(props)));
        },
        image(props) {
            var _a;
            // todo: add image backup
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionHandler, { className: "sb-message-template__image-container", elementId: props.elementId, style: props.parsedProperties, props: props },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReactMessageTemplateImage, { className: "sb-message-template__image", alt: "image", src: props.imageUrl, style: { width: '100%', height: '100%', aspectRatio: 'inherit', objectFit: 'inherit' }, tintColor: (_a = props.imageStyle) === null || _a === void 0 ? void 0 : _a.tintColor, metaData: props.metaData })));
        },
        textButton(props) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionHandler, { className: "sb-message-template__text-button", elementId: props.elementId, style: props.parsedProperties, props: props }, renderText(Object.assign({ maxTextLines: defaultProperties.textButton.maxTextLines }, props))));
        },
        imageButton(props) {
            var _a;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionHandler, { className: "sb-message-template__image-container sb-message-template__image-button", elementId: props.elementId, style: props.parsedProperties, props: props },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReactMessageTemplateImage, { className: "sb-message-template__image", alt: "image-button", src: props.imageUrl, style: { width: '100%', height: '100%', aspectRatio: 'inherit', objectFit: 'inherit' }, tintColor: (_a = props.imageStyle) === null || _a === void 0 ? void 0 : _a.tintColor, metaData: props.metaData })));
        },
        carouselView(props) {
            var _a, _b;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Carousel, { maxChildWidth: (_a = props.carouselStyle) === null || _a === void 0 ? void 0 : _a.maxChildWidth, spacing: (_b = props.carouselStyle) === null || _b === void 0 ? void 0 : _b.spacing, style: props.parsedProperties }, props.children));
        },
    },
});
const parser = createParser({
    mapBoxProps(props, options) {
        const styles = getDefaultStyles();
        setViewProps(styles, props, options);
        setAlign(styles, props.layout, props.align);
        return styles;
    },
    mapTextProps(props, options) {
        var _a;
        const styles = getDefaultStyles({ whiteSpace: 'pre-line', wordBreak: 'break-word' });
        // Better not set flex 1 to text
        setViewProps(styles, props, options);
        setTextStyle(styles, props, options);
        setAlign(styles, Layout.Row, props.align);
        setTextAlign(styles, (_a = props.align) === null || _a === void 0 ? void 0 : _a.horizontal);
        return styles;
    },
    mapImageProps(props, options) {
        const styles = getDefaultStyles();
        setViewProps(styles, props, options);
        setImageStyle(styles, props.imageStyle);
        setImageAspectRatio(styles, props);
        return styles;
    },
    mapTextButtonProps(props, options) {
        const styles = getDefaultStyles({ whiteSpace: 'pre-line', alignItems: 'center', justifyContent: 'center' });
        setViewProps(styles, props, options);
        setTextStyle(styles, props, options);
        return styles;
    },
    mapImageButtonProps(props, options) {
        const styles = getDefaultStyles();
        setViewProps(styles, props, options);
        setImageStyle(styles, props.imageStyle);
        setImageAspectRatio(styles, props);
        return styles;
    },
    mapCarouselProps(props, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const styles = getDefaultStyles();
        setViewProps(styles, props, options);
        styles['paddingBlockStart'] = (_b = (_a = props.viewStyle) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.top;
        styles['paddingBlockEnd'] = (_d = (_c = props.viewStyle) === null || _c === void 0 ? void 0 : _c.padding) === null || _d === void 0 ? void 0 : _d.bottom;
        styles['paddingInlineStart'] = (_f = (_e = props.viewStyle) === null || _e === void 0 ? void 0 : _e.padding) === null || _f === void 0 ? void 0 : _f.left;
        styles['paddingInlineEnd'] = (_h = (_g = props.viewStyle) === null || _g === void 0 ? void 0 : _g.padding) === null || _h === void 0 ? void 0 : _h.right;
        return styles;
    },
});
createMessageTemplate({
    renderer,
    parser,
    Container: ({ children, className }) => {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: `sb-message-template__parent ${className}`, style: {
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 400,
                marginBlockEnd: 24,
            } }, children));
    },
});

var CustomTemplate = createMessageTemplate({
    parser: parser,
    renderer: renderer,
    Container: function (_a) {
        var children = _a.children, className = _a.className;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: [
                "sb-message-template__parent ".concat(className),
                'sendbird-message-template__root',
            ].join(' ') }, children));
    },
}).MessageTemplate;
function MessageTemplate(_a) {
    var templateItems = _a.templateItems, templateVersion = _a.templateVersion;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomTemplate, { templateItems: templateItems, templateVersion: templateVersion });
}


//# sourceMappingURL=bundle-KNrNIKZQ.js.map


/***/ }),

/***/ 17693:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ EmojiManager; },
/* harmony export */   "G": function() { return /* binding */ GlobalModalProvider; },
/* harmony export */   "M": function() { return /* binding */ Modal; },
/* harmony export */   "V": function() { return /* binding */ VoiceRecorderProvider; },
/* harmony export */   "a": function() { return /* binding */ MODAL_ROOT; },
/* harmony export */   "b": function() { return /* binding */ useGlobalModalContext; },
/* harmony export */   "c": function() { return /* binding */ ModalFooter; },
/* harmony export */   "d": function() { return /* binding */ ModalRoot; },
/* harmony export */   "m": function() { return /* binding */ mapColorKeys; },
/* harmony export */   "u": function() { return /* binding */ useVoiceRecorderContext; }
/* harmony export */ });
/* unused harmony exports e, f, i */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80360);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73935);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26765);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29515);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88569);
/* harmony import */ var _ui_Icon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43822);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99366);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71091);
/* harmony import */ var _bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88071);
/* harmony import */ var _bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90832);
/* harmony import */ var _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69466);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41238);
/* harmony import */ var _bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16167);























/**
 * Mapping object to convert numeric keys to descriptive text
 * [(legacy) numeric key]: [(new) descriptive text]
 */
var colorMapping = {
    // Primary / Secondary / Error / Information
    100: 'extra-light',
    200: 'light',
    300: 'main',
    400: 'dark',
    500: 'extra-dark',
    // Overlay
    'overlay-01': 'overlay-dark',
    'overlay-02': 'overlay-light',
    // OnLight
    'onlight-01': 'onlight-text-high-emphasis',
    'onlight-02': 'onlight-text-mid-emphasis',
    'onlight-03': 'onlight-text-low-emphasis',
    'onlight-04': 'onlight-text-disabled',
    // OnDark
    'ondark-01': 'ondark-text-high-emphasis',
    'ondark-02': 'ondark-text-mid-emphasis',
    'ondark-03': 'ondark-text-low-emphasis',
    'ondark-04': 'ondark-text-disabled',
};
/**
 * Order of mappings to ensure longer keys are matched first
 * e.g. In --sendbird-dark-background-extra-dark, 'extra-dark' should be matched instead of 'dark'
 */
var colorMappingOrder = Object
    .values(colorMapping)
    .sort(function (a, b) { return b.length - a.length; });
/**
 * Convert colorMapping to a Map for quick lookup in mapColorKeys
 */
var colorMappingMap = new Map(Object.entries(colorMapping).map(function (_a) {
    var key = _a[0], value = _a[1];
    return [value, key];
}));
/**
 * Converts descriptive color keys to their numeric equivalents.
 *
 * This function takes a set of CSS variable keys and transforms
 * descriptive color keys (e.g. 'extra-light', 'main') into their
 * numeric equivalents(e.g. 100, 200, ..., 500) as defined in the colorMapping object.
 *
 * e.g.
 * Input:
 * {
 *   '--sendbird-light-primary-extra-dark': '#00487c',
 *   '--sendbird-light-primary-dark': '#4bb3fd',
 *   '--sendbird-light-primary-main': '#3e6680',
 *   '--sendbird-light-primary-light': '#0496ff',
 *   '--sendbird-light-primary-extra-light': '#027bce',
 * }
 *
 * Output:
 * {
 *   '--sendbird-light-primary-500': '#00487c',
 *   '--sendbird-light-primary-400': '#4bb3fd',
 *   '--sendbird-light-primary-300': '#3e6680',
 *   '--sendbird-light-primary-200': '#0496ff',
 *   '--sendbird-light-primary-100': '#027bce',
 * }
 *
 * @param {ColorSet} colorSet - The input object containing CSS variables with descriptive keys.
 * @returns {ColorSet} The transformed object with numeric keys.
 */
var mapColorKeys = function (colorSet) {
    var mappedColors = {};
    Object.entries(colorSet).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        var descriptiveKey = key;
        for (var _i = 0, colorMappingOrder_1 = colorMappingOrder; _i < colorMappingOrder_1.length; _i++) {
            var mappingValue = colorMappingOrder_1[_i];
            // Prepare a regex to match the mapping value at the end of the key
            // e.g., '-extra-dark$'
            var regex = new RegExp("-".concat(mappingValue, "$"));
            if (regex.test(key)) {
                // Find the corresponding numeric key for the mapping value using Map
                var numericKey = colorMappingMap.get(mappingValue);
                if (numericKey) {
                    // Replace the descriptive text with the numeric key
                    descriptiveKey = key.replace(regex, "-".concat(numericKey));
                    break;
                }
            }
        }
        mappedColors[descriptiveKey] = value;
    });
    return mappedColors;
};

// simple component to be used as modal root
var MODAL_ROOT = 'sendbird-modal-root';
var ModalRoot = function () { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { id: MODAL_ROOT, className: MODAL_ROOT })); };

var ModalHeader = function (_a) {
    var titleText = _a.titleText, onCloseClick = _a.onCloseClick;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-modal__header" },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.a.H_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.b.ONBACKGROUND_1 }, titleText),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-modal__close" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_IconButton_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { width: "32px", height: "32px", onClick: onCloseClick },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.CLOSE */ .Qy.CLOSE, fillColor: _ui_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.DEFAULT */ .zo.DEFAULT, width: "24px", height: "24px" })))));
};
var ModalBody = function (_a) {
    var children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-modal__body" },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.a.SUBTITLE_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.b.ONBACKGROUND_2 }, children)));
};
var ModalFooter = function (_a) {
    var submitText = _a.submitText, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hideCancelButton, hideCancelButton = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? _ui_Button_js__WEBPACK_IMPORTED_MODULE_7__/* .ButtonTypes.DANGER */ .qh.DANGER : _d, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-modal__footer" },
        !hideCancelButton && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_7__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, onClick: onCancel },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.L, { type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.a.BUTTON_1, color: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_9__.b.ONBACKGROUND_1 }, stringSet.BUTTON__CANCEL))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, { type: type, disabled: disabled, onClick: onSubmit }, submitText)));
};
function Modal(props) {
    var _a;
    var _b = props.children, children = _b === void 0 ? null : _b, _c = props.className, className = _c === void 0 ? '' : _c, _d = props.contentClassName, contentClassName = _d === void 0 ? '' : _d, _e = props.isCloseOnClickOutside, isCloseOnClickOutside = _e === void 0 ? false : _e, _f = props.isFullScreenOnMobile, isFullScreenOnMobile = _f === void 0 ? false : _f, titleText = props.titleText, submitText = props.submitText, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.hideFooter, hideFooter = _h === void 0 ? false : _h, _j = props.type, type = _j === void 0 ? _ui_Button_js__WEBPACK_IMPORTED_MODULE_7__/* .ButtonTypes.DANGER */ .qh.DANGER : _j, renderHeader = props.renderHeader, _k = props.onSubmit, onSubmit = _k === void 0 ? _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n : _k, onClose = props.onClose, onCancel = props.onCancel, customFooter = props.customFooter;
    var handleClose = (_a = onClose !== null && onClose !== void 0 ? onClose : onCancel) !== null && _a !== void 0 ? _a : _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n;
    var eventHandlers = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__/* .useSendbirdStateContext */ .A)().eventHandlers;
    var id = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function () { return "sbu-modal-".concat((0,_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_16__.u)()); })[0];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var _a, _b;
        return (_b = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.modal) === null || _a === void 0 ? void 0 : _a.onMounted) === null || _b === void 0 ? void 0 : _b.call(_a, { close: handleClose, id: id });
    }, []);
    var isMobile = (0,_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_5__.u)().isMobile;
    return (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.c)('sendbird-modal', className, isFullScreenOnMobile && isMobile && 'sendbird-modal--full-mobile') },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.c.apply(void 0, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)(['sendbird-modal__content'], (Array.isArray(contentClassName) ? contentClassName : [contentClassName]), false)) },
            (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || react__WEBPACK_IMPORTED_MODULE_1__.createElement(ModalHeader, { titleText: titleText !== null && titleText !== void 0 ? titleText : '', onCloseClick: handleClose }),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(ModalBody, null, children),
            !hideFooter
                && (customFooter !== null && customFooter !== void 0 ? customFooter : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(ModalFooter, { disabled: disabled, onCancel: handleClose, onSubmit: onSubmit, submitText: submitText !== null && submitText !== void 0 ? submitText : '', type: type })))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.c)('sendbird-modal__backdrop', isCloseOnClickOutside && 'sendbird-modal__backdrop--clickoutside'), onClick: function (e) {
                e === null || e === void 0 ? void 0 : e.stopPropagation();
                if (isCloseOnClickOutside) {
                    handleClose();
                }
            } })), document.getElementById(MODAL_ROOT));
}

var Context = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    start: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n,
    stop: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n,
    isRecordable: false,
});
var VoiceRecorderProvider = function (props) {
    var _a;
    var children = props.children;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__/* .useSendbirdStateContext */ .A)().config;
    var logger = config.logger, groupChannel = config.groupChannel;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), mediaRecorder = _b[0], setMediaRecorder = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRecordable = _c[0], setIsRecordable = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), permissionWarning = _d[0], setPermissionWarning = _d[1];
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    var isVoiceMessageEnabled = groupChannel.enableVoiceMessage;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), webAudioUtils = _e[0], setWebAudioUtils = _e[1];
    var browserSupportMimeType = (_a = _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.B.find(function (mimeType) { return MediaRecorder.isTypeSupported(mimeType); })) !== null && _a !== void 0 ? _a : '';
    if (isVoiceMessageEnabled && !browserSupportMimeType) {
        logger.error('VoiceRecorder: Browser does not support mimeType', { mimmeTypes: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.B });
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (isVoiceMessageEnabled && !webAudioUtils) {
            Promise.all(/* import() */[__webpack_require__.e(6717), __webpack_require__.e(2881)]).then(__webpack_require__.bind(__webpack_require__, 72881)).then(function (module) { return setWebAudioUtils(module); });
        }
    }, [isVoiceMessageEnabled, webAudioUtils]);
    var start = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (eventHandler) {
        var _a, _b;
        if (isVoiceMessageEnabled && !webAudioUtils) {
            logger.error('VoiceRecorder: Recording audio processor is being loaded.');
            return;
        }
        var checkPermission = function () {
            try {
                // Type '"microphone"' is not assignable to type 'PermissionName'.ts(2322)
                // this is typescript issue
                // https://github.com/microsoft/TypeScript/issues/33923
                // @ts-expect-error
                navigator.permissions.query({ name: 'microphone' }).then(function (result) {
                    if (result.state === 'denied') {
                        logger.warning('VoiceRecorder: Permission denied.');
                        setPermissionWarning(true);
                    }
                });
            }
            catch (error) {
                logger.warning('VoiceRecorder: Failed to check permission.', error);
            }
        };
        logger.info('VoiceRecorder: Start recording.');
        if (mediaRecorder) {
            stop();
            logger.info('VoiceRecorder: Previous mediaRecorder is stopped.');
        }
        checkPermission();
        (_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia) === null || _b === void 0 ? void 0 : _b.call(_a, { audio: true }).then(function (stream) {
            var _a;
            logger.info('VoiceRecorder: Succeeded getting media stream.', stream);
            setIsRecordable(true);
            var mediaRecorder = new MediaRecorder(stream, {
                mimeType: browserSupportMimeType,
                audioBitsPerSecond: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.o,
            });
            // when recording stops
            mediaRecorder.ondataavailable = function (e) {
                logger.info('VoiceRecorder: Succeeded getting an available data.', e.data);
                var audioFile = new File([e.data], _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.f, {
                    lastModified: new Date().getTime(),
                    type: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.b,
                });
                webAudioUtils === null || webAudioUtils === void 0 ? void 0 : webAudioUtils.downsampleToWav(audioFile, function (buffer) {
                    var _a;
                    var mp3Buffer = webAudioUtils === null || webAudioUtils === void 0 ? void 0 : webAudioUtils.encodeMp3(buffer);
                    var mp3blob = new Blob(mp3Buffer, { type: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.b });
                    var convertedAudioFile = new File([mp3blob], _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.f, {
                        lastModified: new Date().getTime(),
                        type: _bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_17__.b,
                    });
                    (_a = eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler.onRecordingEnded) === null || _a === void 0 ? void 0 : _a.call(eventHandler, convertedAudioFile);
                    logger.info('VoiceRecorder: Succeeded converting audio file.', convertedAudioFile);
                });
                var tracks = stream.getAudioTracks();
                tracks.forEach(function (track) { return track.stop(); });
                setIsRecordable(false);
            };
            mediaRecorder.onstart = (_a = eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler.onRecordingStarted) !== null && _a !== void 0 ? _a : _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n;
            mediaRecorder === null || mediaRecorder === void 0 ? void 0 : mediaRecorder.start();
            setMediaRecorder(mediaRecorder);
        }).catch(function (err) {
            logger.error('VoiceRecorder: Failed getting media stream.', err);
            setMediaRecorder(null);
        });
    }, [mediaRecorder, webAudioUtils]);
    var stop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        // Stop recording
        mediaRecorder === null || mediaRecorder === void 0 ? void 0 : mediaRecorder.stop();
        setMediaRecorder(null);
        setIsRecordable(false);
        logger.info('VoiceRecorder: Stop recording.');
    }, [mediaRecorder]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(Context.Provider, { value: { start: start, stop: stop, isRecordable: isRecordable } },
        children,
        permissionWarning && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(Modal, { hideFooter: true, onClose: function () { return setPermissionWarning(false); } },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, stringSet.VOICE_RECORDING_PERMISSION_DENIED)))));
};
var useVoiceRecorderContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Context); };
var index = {
    VoiceRecorderProvider: VoiceRecorderProvider,
    useVoiceRecorderContext: useVoiceRecorderContext,
};

var GlobalModalContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    openModal: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.n,
});
var GlobalModalProvider = function (_a) {
    var children = _a.children;
    // Idea from https://dev.to/nurislamov/simple-modals-queue-in-react-4g6c
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), globalModalQueue = _b[0], setGlobalModalQueue = _b[1];
    var openModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (props) {
        setGlobalModalQueue(function (currentQue) { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], currentQue, true), [props], false); });
    }, []);
    var closeModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        setGlobalModalQueue(function (currentQue) { return currentQue.slice(1); });
    }, []);
    var ModalComponent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return function () {
        return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.K)(globalModalQueue)
            .when(function (q) { return q.length === 0; }, function () {
            return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
        })
            .otherwise(function () {
            var _a = globalModalQueue[0], modalProps = _a.modalProps, childElement = _a.childElement;
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(Modal, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, modalProps, { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_15__.c)('sendbird-global-modal', modalProps === null || modalProps === void 0 ? void 0 : modalProps.className), onClose: function () {
                    var _a;
                    (_a = modalProps === null || modalProps === void 0 ? void 0 : modalProps.onClose) === null || _a === void 0 ? void 0 : _a.call(modalProps);
                    closeModal();
                } }), childElement({
                closeModal: closeModal,
            })));
        });
    }; }, [globalModalQueue]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(GlobalModalContext.Provider, { value: {
            openModal: openModal,
        } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(ModalComponent, null),
        children));
};
var useGlobalModalContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GlobalModalContext); };

var EmojiManager = /** @class */ (function () {
    function EmojiManager(props) {
        var _this = this;
        var _a;
        var sdk = props.sdk, logger = props.logger;
        (_a = sdk === null || sdk === void 0 ? void 0 : sdk.getAllEmoji) === null || _a === void 0 ? void 0 : _a.call(sdk).then(function (emojiContainer) {
            _this._emojiContainer = emojiContainer;
            logger === null || logger === void 0 ? void 0 : logger.info('EmojiManager | Succeeded getting all emojis. ', emojiContainer);
        }).catch(function () {
            logger === null || logger === void 0 ? void 0 : logger.warning('EmojiManager | Failed getting all emojis.');
        });
    }
    Object.defineProperty(EmojiManager.prototype, "AllEmojisAsArray", {
        get: function () {
            return this._emojiContainer.emojiCategories.flatMap(function (category) { return category.emojis; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmojiManager.prototype, "AllEmojisAsMap", {
        get: function () {
            return this._emojiContainer.emojiCategories
                .flatMap(function (category) { return category.emojis; })
                .reduce(function (map, emoji) {
                map.set(emoji.key, emoji.url);
                return map;
            }, new Map());
        },
        enumerable: false,
        configurable: true
    });
    EmojiManager.prototype.getAllEmojis = function (type) {
        var _this = this;
        return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.K)(type)
            .when(function (type) { return ['array', 'arr'].includes(type); }, function () { return _this.AllEmojisAsArray; })
            .when(function (type) { return ['map'].includes(type); }, function () { return _this.AllEmojisAsMap; })
            .otherwise(function () { return _this.AllEmojisAsArray; });
    };
    EmojiManager.prototype.getEmojiUrl = function (reactionKey) {
        var _a, _b;
        return (_b = (_a = this.AllEmojisAsArray.find(function (emoji) { return emoji.key === reactionKey; })) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '';
    };
    Object.defineProperty(EmojiManager.prototype, "emojiContainer", {
        get: function () {
            return this._emojiContainer;
        },
        enumerable: false,
        configurable: true
    });
    return EmojiManager;
}());


//# sourceMappingURL=bundle-NL8iE1lF.js.map


/***/ }),

/***/ 75010:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ format; },
/* harmony export */   "t": function() { return /* binding */ toInteger; }
/* harmony export */ });
/* harmony import */ var _bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3323);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59587);



/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  return value instanceof Date || (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__._)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var timestamp = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(1, arguments);
  var date = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$1 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$1.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$1.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$1.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.r)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_0__.l;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,_bundle_DnujA9kt_js__WEBPACK_IMPORTED_MODULE_1__.t)(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}


//# sourceMappingURL=bundle-QTCuDZTl.js.map


/***/ }),

/***/ 26765:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MediaQueryProvider; },
/* harmony export */   "u": function() { return /* binding */ useMediaQueryContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var DEFAULT_MOBILE = false;
// const DEFAULT_MOBILE = '768px';
var MOBILE_CLASSNAME = 'sendbird--mobile-mode';
var MediaQueryContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    breakpoint: DEFAULT_MOBILE,
    isMobile: false,
});
var addClassNameToBody = function () {
    try {
        var body = document.querySelector('body');
        body === null || body === void 0 ? void 0 : body.classList.add(MOBILE_CLASSNAME);
    }
    catch (_a) {
        // noop
    }
};
var removeClassNameFromBody = function () {
    try {
        var body = document.querySelector('body');
        body === null || body === void 0 ? void 0 : body.classList.remove(MOBILE_CLASSNAME);
    }
    catch (_a) {
        // noop
    }
};
var MediaQueryProvider = function (props) {
    var children = props.children, logger = props.logger;
    var breakpoint = (props === null || props === void 0 ? void 0 : props.breakpoint) || false;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMobile = _a[0], setIsMobile = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var _a;
        var updateSize = function () {
            var _a;
            if (typeof breakpoint === 'boolean') {
                setIsMobile(breakpoint);
                if (breakpoint) {
                    addClassNameToBody();
                }
                else {
                    removeClassNameFromBody();
                }
            }
            else {
                var mq = window.matchMedia("(max-width: ".concat(breakpoint, ")"));
                (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, "MediaQueryProvider: Screensize updated to ".concat(breakpoint));
                if (mq.matches) {
                    setIsMobile(true);
                    addClassNameToBody();
                }
                else {
                    setIsMobile(false);
                    removeClassNameFromBody();
                }
            }
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'MediaQueryProvider: addEventListener', { updateSize: updateSize });
        return function () {
            var _a;
            window.removeEventListener('resize', updateSize);
            (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'MediaQueryProvider: removeEventListener', { updateSize: updateSize });
        };
    }, [breakpoint]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MediaQueryContext.Provider, { value: { breakpoint: breakpoint, isMobile: isMobile } }, children));
};
var useMediaQueryContext = function () { return react__WEBPACK_IMPORTED_MODULE_0__.useContext(MediaQueryContext); };


//# sourceMappingURL=bundle-R3uJ_0BB.js.map


/***/ }),

/***/ 91607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MessageInputWrapperView; },
/* harmony export */   "V": function() { return /* binding */ VoiceMessageInputWrapper; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30302);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85562);
/* harmony import */ var _Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66421);
/* harmony import */ var _ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67840);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32177);
/* harmony import */ var _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19515);
/* harmony import */ var _bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12291);
/* harmony import */ var _bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17693);
/* harmony import */ var _ui_Button_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88569);
/* harmony import */ var _bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90832);
/* harmony import */ var _bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(88071);
/* harmony import */ var _ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65134);
/* harmony import */ var _bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26765);
/* harmony import */ var _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(459);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6623);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99366);
/* harmony import */ var _bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85385);






















var VoiceMessageInputWrapper = function (_a) {
    var channel = _a.channel, onCancelClick = _a.onCancelClick, onSubmitClick = _a.onSubmitClick;
    var uuid = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)((0,_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_20__.u)()).current;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), audioFile = _b[0], setAudioFile = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD), voiceInputState = _c[0], setVoiceInputState = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubmitted = _d[0], setSubmit = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDisabled = _e[0], setDisabled = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showModal = _f[0], setShowModal = _f[1];
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)().config;
    var _g = (0,_VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_9__/* .useVoiceRecorder */ .f)({
        onRecordingStarted: function () {
            setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.RECORDING);
        },
        onRecordingEnded: function (audioFile) {
            setAudioFile(audioFile);
        },
    }), start = _g.start, stop = _g.stop, cancel = _g.cancel, recordingTime = _g.recordingTime, recordingStatus = _g.recordingStatus, recordingLimit = _g.recordingLimit;
    var voicePlayer = (0,_VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_8__/* .useVoicePlayer */ .O)({
        channelUrl: channel === null || channel === void 0 ? void 0 : channel.url,
        key: uuid,
        audioFile: audioFile !== null && audioFile !== void 0 ? audioFile : undefined,
    });
    var play = voicePlayer.play, pause = voicePlayer.pause, playbackTime = voicePlayer.playbackTime, playingStatus = voicePlayer.playingStatus;
    var stopVoicePlayer = voicePlayer.stop;
    // disabled state: muted & frozen
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if ((0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.i)(channel) || (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.a)(channel)) {
            setDisabled(true);
        }
        else {
            setDisabled(false);
        }
    }, [channel === null || channel === void 0 ? void 0 : channel.myRole, channel === null || channel === void 0 ? void 0 : channel.isFrozen, channel === null || channel === void 0 ? void 0 : channel.myMutedState]);
    // call onSubmitClick when submit button is clicked and recorded audio file is created
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (isSubmitted && audioFile) {
            onSubmitClick === null || onSubmitClick === void 0 ? void 0 : onSubmitClick(audioFile, recordingTime);
            setSubmit(false);
            setAudioFile(null);
        }
    }, [isSubmitted, audioFile, recordingTime]);
    // operate which control button should be displayed
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (audioFile) {
            if (recordingTime < config.voiceRecord.minRecordingTime) {
                setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD);
                setAudioFile(null);
            }
            else if (playingStatus === _bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_13__.V.PLAYING) {
                setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.PLAYING);
            }
            else {
                setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_PLAY);
            }
        }
    }, [audioFile, recordingTime, playingStatus]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-voice-message-input-wrapper" },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.a, { currentValue: recordingStatus === _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_9__/* .VoiceRecorderStatus.COMPLETED */ .s.COMPLETED ? playbackTime : recordingTime, maximumValue: recordingStatus === _VoiceRecorder_useVoiceRecorder_js__WEBPACK_IMPORTED_MODULE_9__/* .VoiceRecorderStatus.COMPLETED */ .s.COMPLETED ? recordingTime : recordingLimit, currentType: voiceInputState, onCancelClick: function () {
                onCancelClick === null || onCancelClick === void 0 ? void 0 : onCancelClick();
                cancel();
                stopVoicePlayer();
            }, onSubmitClick: function () {
                if (isDisabled) {
                    setShowModal(true);
                    setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD);
                }
                else {
                    stop();
                    pause();
                    setSubmit(true);
                }
            }, onControlClick: function (type) {
                switch (type) {
                    case _bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD: {
                        stopVoicePlayer();
                        start();
                        break;
                    }
                    case _bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.RECORDING: {
                        if (recordingTime >= config.voiceRecord.minRecordingTime && !isDisabled) {
                            stop();
                        }
                        else if (isDisabled) {
                            cancel();
                            setShowModal(true);
                            setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD);
                        }
                        else {
                            cancel();
                            setVoiceInputState(_bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_RECORD);
                        }
                        break;
                    }
                    case _bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.READY_TO_PLAY: {
                        play();
                        break;
                    }
                    case _bundle_DBeNFit6_js__WEBPACK_IMPORTED_MODULE_10__.V.PLAYING: {
                        pause();
                        break;
                    }
                }
            } }),
        showModal && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_11__.M, { className: "sendbird-voice-message-input-wrapper-alert", titleText: (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.a)(channel)
                ? stringSet.MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_MUTED
                : stringSet.MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_FROZEN, hideFooter: true, isCloseOnClickOutside: true, onClose: function () {
                setShowModal(false);
                onCancelClick === null || onCancelClick === void 0 ? void 0 : onCancelClick();
            } },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-voice-message-input-wrapper-alert__body" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_Button_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, { className: "sendbird-voice-message-input-wrapper-alert__body__ok-button", type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_12__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, size: _ui_Button_js__WEBPACK_IMPORTED_MODULE_12__/* .ButtonSizes.BIG */ .Ph.BIG, onClick: function () {
                        setShowModal(false);
                        onCancelClick === null || onCancelClick === void 0 ? void 0 : onCancelClick();
                    } }, stringSet.BUTTON__OK))))));
};

var useHandleUploadFiles = function (_a, _b) {
    var sendFileMessage = _a.sendFileMessage, sendMultipleFilesMessage = _a.sendMultipleFilesMessage, quoteMessage = _a.quoteMessage;
    var logger = _b.logger;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)().config;
    var imageCompression = config.imageCompression;
    var uikitUploadSizeLimit = config === null || config === void 0 ? void 0 : config.uikitUploadSizeLimit;
    var uikitMultipleFilesMessageLimit = config === null || config === void 0 ? void 0 : config.uikitMultipleFilesMessageLimit;
    var openModal = (0,_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_11__.b)().openModal;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (files) { return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(void 0, void 0, void 0, function () {
        var ONE_MiB, compressedFiles, sendingFiles, file, imageFiles_1, otherFiles_1;
        return (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (files.length === 0) {
                        logger.warning('Channel|useHandleUploadFiles: given file list is empty.', { files: files });
                        return [2 /*return*/];
                    }
                    if (files.length > uikitMultipleFilesMessageLimit) {
                        logger.info("Channel|useHandleUploadFiles: Cannot upload files more than ".concat(uikitMultipleFilesMessageLimit));
                        openModal({
                            modalProps: {
                                titleText: stringSet.FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT.replace('%d', "".concat(uikitUploadSizeLimit)),
                                hideFooter: true,
                            },
                            childElement: function (_a) {
                                var closeModal = _a.closeModal;
                                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_11__.c, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_12__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                            },
                        });
                        return [2 /*return*/];
                    }
                    // Validate file sizes
                    if (files.some(function (file) { return file.size > uikitUploadSizeLimit; })) {
                        // The default value of uikitUploadSizeLimit is 26MB
                        logger.info("Channel|useHandleUploadFiles: Cannot upload file size exceeding ".concat(uikitUploadSizeLimit));
                        ONE_MiB = 1024 * 1024;
                        openModal({
                            modalProps: {
                                titleText: stringSet.FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT.replace('%d', "".concat(Math.floor(uikitUploadSizeLimit / ONE_MiB))),
                                hideFooter: true,
                            },
                            childElement: function (_a) {
                                var closeModal = _a.closeModal;
                                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_11__.c, { type: _ui_Button_js__WEBPACK_IMPORTED_MODULE_12__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                            },
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,_bundle_BRWtuT59_js__WEBPACK_IMPORTED_MODULE_19__.c)({
                            files: files,
                            imageCompression: imageCompression,
                            logger: logger,
                        })];
                case 1:
                    compressedFiles = (_a.sent()).compressedFiles;
                    sendingFiles = compressedFiles;
                    // Send File Message
                    if (sendingFiles.length === 1) {
                        logger.info('Channel|useHandleUploadFiles: sending one file.');
                        file = sendingFiles[0];
                        return [2 /*return*/, sendFileMessage({ file: file, parentMessageId: quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId })];
                    }
                    else if (sendingFiles.length > 1) {
                        logger.info('Channel|useHandleUploadFiles: sending multiple files.');
                        imageFiles_1 = [];
                        otherFiles_1 = [];
                        sendingFiles.forEach(function (file) {
                            if ((0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_17__.j)(file.type)) {
                                imageFiles_1.push(file);
                            }
                            else {
                                otherFiles_1.push(file);
                            }
                        });
                        return [2 /*return*/, otherFiles_1.reduce(function (previousPromise, item) {
                                return previousPromise.then(function () {
                                    return sendFileMessage({ file: item, parentMessageId: quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId });
                                });
                            }, (function () {
                                if (imageFiles_1.length === 0) {
                                    return Promise.resolve();
                                }
                                else if (imageFiles_1.length === 1) {
                                    return sendFileMessage({ file: imageFiles_1[0] });
                                }
                                else {
                                    return sendMultipleFilesMessage({
                                        fileInfoList: imageFiles_1.map(function (file) { return ({
                                            file: file,
                                            fileName: file.name,
                                            fileSize: file.size,
                                            mimeType: file.type,
                                        }); }),
                                        parentMessageId: quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId,
                                    });
                                }
                            })())];
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [sendFileMessage, sendMultipleFilesMessage, quoteMessage]);
};

var MessageInputWrapperView = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
    var _a;
    // Props
    var currentChannel = props.currentChannel, messages = props.messages, loading = props.loading, quoteMessage = props.quoteMessage, setQuoteMessage = props.setQuoteMessage, messageInputRef = props.messageInputRef, sendUserMessage = props.sendUserMessage, sendFileMessage = props.sendFileMessage, sendVoiceMessage = props.sendVoiceMessage, sendMultipleFilesMessage = props.sendMultipleFilesMessage, 
    // render
    renderUserMentionItem = props.renderUserMentionItem, renderFileUploadIcon = props.renderFileUploadIcon, renderVoiceMessageIcon = props.renderVoiceMessageIcon, renderSendMessageIcon = props.renderSendMessageIcon, acceptableMimeTypes = props.acceptableMimeTypes, disabled = props.disabled;
    var stringSet = (0,_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    var isMobile = (0,_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__.u)().isMobile;
    var _b = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)(), stores = _b.stores, config = _b.config;
    var isOnline = config.isOnline, userMention = config.userMention, logger = config.logger, groupChannel = config.groupChannel;
    var sdk = stores.sdkStore.sdk;
    var maxMentionCount = userMention.maxMentionCount, maxSuggestionCount = userMention.maxSuggestionCount;
    var isBroadcast = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.isBroadcast;
    var isOperator = (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.myRole) === 'operator';
    var isMultipleFilesMessageEnabled = (_a = props.isMultipleFilesMessageEnabled) !== null && _a !== void 0 ? _a : config.isMultipleFilesMessageEnabled;
    var isMentionEnabled = groupChannel.enableMention;
    var isVoiceMessageEnabled = groupChannel.enableVoiceMessage;
    // States
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), mentionNickname = _c[0], setMentionNickname = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUsers = _d[0], setMentionedUsers = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _e[0], setMentionedUserIds = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedUser = _f[0], setSelectedUser = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionSuggestedUsers = _g[0], setMentionSuggestedUsers = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), messageInputEvent = _h[0], setMessageInputEvent = _h[1];
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showVoiceMessageInput = _j[0], setShowVoiceMessageInput = _j[1];
    // Conditions
    var isMessageInputDisabled = loading
        || (!currentChannel || !sdk)
        || (!sdk.isCacheEnabled && !isOnline)
        || (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.i)(currentChannel)
        || (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.a)(currentChannel)
        || (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.b)(currentChannel, config.groupChannel.enableSuggestedReplies)
        || (0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.c)(messages, config.groupChannel.enableFormTypeMessage)
        || disabled;
    var showSuggestedMentionList = !isMessageInputDisabled
        && isMentionEnabled
        && mentionNickname.length > 0
        && !isBroadcast;
    var mentionNodes = (0,_Message_hooks_useDirtyGetMentions_js__WEBPACK_IMPORTED_MODULE_6__/* .useDirtyGetMentions */ .X)({ ref: (ref || messageInputRef) }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < maxMentionCount;
    // Operate states
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionNickname('');
        setMentionedUsers([]);
        setMentionedUserIds([]);
        setSelectedUser(null);
        setMentionSuggestedUsers([]);
        setMessageInputEvent(null);
        setShowVoiceMessageInput(false);
    }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    // Callbacks
    var handleUploadFiles = useHandleUploadFiles({
        sendFileMessage: sendFileMessage,
        sendMultipleFilesMessage: sendMultipleFilesMessage,
        quoteMessage: quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined,
    }, { logger: logger });
    if (isBroadcast && !isOperator) {
        /* Only `Operator` can send messages in the Broadcast channel */
        return null;
    }
    // other conditions
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: showVoiceMessageInput ? 'sendbird-message-input-wrapper--voice-message' : 'sendbird-message-input-wrapper' },
        showSuggestedMentionList && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GroupChannel_components_SuggestedMentionList_js__WEBPACK_IMPORTED_MODULE_5__/* .SuggestedMentionList */ .u, { currentChannel: currentChannel, targetNickname: mentionNickname, inputEvent: messageInputEvent !== null && messageInputEvent !== void 0 ? messageInputEvent : undefined, renderUserMentionItem: renderUserMentionItem, onUserItemClick: function (user) {
                if (user) {
                    setMentionedUsers((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], mentionedUsers, true), [user], false));
                }
                setMentionNickname('');
                setSelectedUser(user);
                setMessageInputEvent(null);
            }, onFocusItemChange: function () {
                setMessageInputEvent(null);
            }, onFetchUsers: function (users) {
                setMentionSuggestedUsers(users);
            }, ableAddMention: ableMention, maxMentionCount: maxMentionCount, maxSuggestionCount: maxSuggestionCount })),
        quoteMessage && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-input-wrapper__quote-message-input" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_QuoteMessageInput_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { replyingMessage: quoteMessage, onClose: function () { return setQuoteMessage(null); } }))),
        showVoiceMessageInput ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(VoiceMessageInputWrapper, { channel: currentChannel !== null && currentChannel !== void 0 ? currentChannel : undefined, onSubmitClick: function (recordedFile, duration) {
                sendVoiceMessage({ file: recordedFile, parentMessageId: quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId }, duration);
                setQuoteMessage(null);
                setShowVoiceMessageInput(false);
            }, onCancelClick: function () {
                setShowVoiceMessageInput(false);
            } })) : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_MessageInput_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, { className: "sendbird-message-input-wrapper__message-input", channel: currentChannel, channelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url, isMobile: isMobile, acceptableMimeTypes: acceptableMimeTypes, mentionSelectedUser: selectedUser, isMentionEnabled: isMentionEnabled, isVoiceMessageEnabled: isVoiceMessageEnabled, isSelectingMultipleFilesEnabled: isMultipleFilesMessageEnabled, onVoiceMessageIconClick: function () {
                setShowVoiceMessageInput(true);
            }, setMentionedUsers: setMentionedUsers, placeholder: (quoteMessage && stringSet.MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER)
                || ((0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.i)(currentChannel) && stringSet.MESSAGE_INPUT__PLACE_HOLDER__FROZEN)
                || ((0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.a)(currentChannel)
                    && (isMobile
                        ? stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT
                        : stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED))
                || ((0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.b)(currentChannel, config.groupChannel.enableSuggestedReplies)
                    && stringSet.MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES)
                || ((0,_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_2__.c)(messages, config.groupChannel.enableFormTypeMessage)
                    && stringSet.MESSAGE_INPUT__PLACE_HOLDER__MESSAGE_FORM)
                || (disabled && stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED)
                || undefined, ref: (ref || messageInputRef), disabled: isMessageInputDisabled, renderFileUploadIcon: renderFileUploadIcon, renderSendMessageIcon: renderSendMessageIcon, renderVoiceMessageIcon: renderVoiceMessageIcon, onStartTyping: function () {
                currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.startTyping();
            }, onSendMessage: function (_a) {
                var _b;
                var message = _a.message, mentionTemplate = _a.mentionTemplate;
                sendUserMessage({
                    message: message,
                    mentionedUsers: mentionedUsers,
                    mentionedMessageTemplate: mentionTemplate,
                    parentMessageId: quoteMessage === null || quoteMessage === void 0 ? void 0 : quoteMessage.messageId,
                });
                setMentionNickname('');
                setMentionedUsers([]);
                setQuoteMessage(null);
                (_b = currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.endTyping) === null || _b === void 0 ? void 0 : _b.call(currentChannel);
            }, onFileUpload: function (fileList) {
                handleUploadFiles(fileList);
                setQuoteMessage(null);
            }, onUserMentioned: function (user) {
                if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                    setSelectedUser(null);
                    setMentionNickname('');
                }
            }, onMentionStringChange: function (mentionText) {
                setMentionNickname(mentionText);
            }, onMentionedUserIdsUpdated: function (userIds) {
                setMentionedUserIds(userIds);
            }, onKeyDown: function (e) {
                if (showSuggestedMentionList
                    && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                    && ((e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_16__.M.Enter && ableMention)
                        || e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_16__.M.ArrowUp
                        || e.key === _bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_16__.M.ArrowDown)) {
                    setMessageInputEvent(e);
                    return true;
                }
                return false;
            } }))));
});


//# sourceMappingURL=bundle-SyLbPukg.js.map


/***/ }),

/***/ 65614:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ __assign; },
/* harmony export */   "a": function() { return /* binding */ __awaiter; },
/* harmony export */   "b": function() { return /* binding */ __generator; },
/* harmony export */   "c": function() { return /* binding */ __spreadArray; },
/* harmony export */   "e": function() { return /* binding */ __extends; }
/* harmony export */ });
/* unused harmony export d */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};


//# sourceMappingURL=bundle-XQWyv823.js.map


/***/ }),

/***/ 93475:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ isSafari; },
/* harmony export */   "i": function() { return /* binding */ isMobileIOS; }
/* harmony export */ });
var isIOS = function (userAgent) { return /iPhone|iPad|iPod/i.test(userAgent); };
var isWebkit = function (userAgent) { return /WebKit/i.test(userAgent); };
var isChrome = function (userAgent) { return /Chrome/i.test(userAgent); };
var isSafari = function (userAgent) { return !isChrome(userAgent) && /Safari/i.test(userAgent); };
var isMobileIOS = function (userAgent) {
    return isIOS(userAgent) && (isWebkit(userAgent) || isSafari(userAgent));
};


//# sourceMappingURL=bundle-eZsqrPY3.js.map


/***/ }),

/***/ 99366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Label; },
/* harmony export */   "a": function() { return /* binding */ LabelTypography; },
/* harmony export */   "b": function() { return /* binding */ LabelColors; },
/* harmony export */   "c": function() { return /* binding */ LabelStringSet; },
/* harmony export */   "d": function() { return /* binding */ changeColorToClassName; }
/* harmony export */ });
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61448);




var Typography = {
    H_1: 'H_1',
    H_2: 'H_2',
    SUBTITLE_1: 'SUBTITLE_1',
    SUBTITLE_2: 'SUBTITLE_2',
    BODY_1: 'BODY_1',
    BODY_2: 'BODY_2',
    BUTTON_1: 'BUTTON_1',
    BUTTON_2: 'BUTTON_2',
    BUTTON_3: 'BUTTON_3',
    CAPTION_1: 'CAPTION_1',
    CAPTION_2: 'CAPTION_2',
    CAPTION_3: 'CAPTION_3',
};
var Colors = {
    ONBACKGROUND_1: 'ONBACKGROUND_1',
    ONBACKGROUND_2: 'ONBACKGROUND_2',
    ONBACKGROUND_3: 'ONBACKGROUND_3',
    ONBACKGROUND_4: 'ONBACKGROUND_4',
    ONCONTENT_1: 'ONCONTENT_1',
    ONCONTENT_2: 'ONCONTENT_2',
    ONCONTENT_3: 'ONCONTENT_3',
    ONCONTENT_INVERSE_1: 'ONCONTENT_INVERSE_1',
    ONCONTENT_INVERSE_3: 'ONCONTENT_INVERSE_3',
    PRIMARY: 'PRIMARY',
    ERROR: 'ERROR',
    SECONDARY_3: 'SECONDARY_3',
};

function changeTypographyToClassName(type) {
    switch (type) {
        case Typography.H_1: return 'sendbird-label--h-1';
        case Typography.H_2: return 'sendbird-label--h-2';
        case Typography.SUBTITLE_1: return 'sendbird-label--subtitle-1';
        case Typography.SUBTITLE_2: return 'sendbird-label--subtitle-2';
        case Typography.BODY_1: return 'sendbird-label--body-1';
        case Typography.BODY_2: return 'sendbird-label--body-2';
        case Typography.BUTTON_1: return 'sendbird-label--button-1';
        case Typography.BUTTON_2: return 'sendbird-label--button-2';
        case Typography.BUTTON_3: return 'sendbird-label--button-3';
        case Typography.CAPTION_1: return 'sendbird-label--caption-1';
        case Typography.CAPTION_2: return 'sendbird-label--caption-2';
        case Typography.CAPTION_3: return 'sendbird-label--caption-3';
        default: return '';
    }
}
function changeColorToClassName(color) {
    switch (color) {
        case Colors.ONBACKGROUND_1: return 'sendbird-label--color-onbackground-1';
        case Colors.ONBACKGROUND_2: return 'sendbird-label--color-onbackground-2';
        case Colors.ONBACKGROUND_3: return 'sendbird-label--color-onbackground-3';
        case Colors.ONBACKGROUND_4: return 'sendbird-label--color-onbackground-4';
        case Colors.ONCONTENT_1: return 'sendbird-label--color-oncontent-1';
        case Colors.ONCONTENT_2: return 'sendbird-label--color-oncontent-2';
        case Colors.ONCONTENT_3: return 'sendbird-label--color-oncontent-3';
        case Colors.ONCONTENT_INVERSE_1: return 'sendbird-label--color-oncontent-inverse-1';
        case Colors.ONCONTENT_INVERSE_3: return 'sendbird-label--color-oncontent-inverse-3';
        case Colors.PRIMARY: return 'sendbird-label--color-primary'; // should be Primary-3 fix me
        case Colors.ERROR: return 'sendbird-label--color-error';
        case Colors.SECONDARY_3: return 'sendbird-label--color-secondary-3';
        default: return '';
    }
}

var Label = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
    var _b = _a.className, className = _b === void 0 ? [] : _b, type = _a.type, color = _a.color, _c = _a.children, children = _c === void 0 ? null : _c, testID = _a.testID;
    return (
    // Donot make this into div
    // Mention uses Label. If we use div, it would break the mention detection on Paste
    // https://github.com/sendbird/sendbird-uikit-react/pull/479
    react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", { className: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-label',
            changeTypographyToClassName(type),
            changeColorToClassName(color),
        ], false).join(' '), ref: ref, "data-testid": testID }, children));
});
var LabelTypography = Typography;
var LabelColors = Colors;
var LabelStringSet = (0,_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_2__.g)('en');


//# sourceMappingURL=bundle-ixnsp7Bg.js.map


/***/ }),

/***/ 16167:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ BottomSheetMenuItem; },
/* harmony export */   "C": function() { return /* binding */ ContextMenu; },
/* harmony export */   "E": function() { return /* binding */ EMOJI_MENU_ROOT_ID; },
/* harmony export */   "M": function() { return /* binding */ MessageMenuProvider; },
/* harmony export */   "O": function() { return /* binding */ OperatorMenuItem; },
/* harmony export */   "a": function() { return /* binding */ MenuItem$1; },
/* harmony export */   "b": function() { return /* binding */ MenuItems; },
/* harmony export */   "c": function() { return /* binding */ MenuItem; },
/* harmony export */   "d": function() { return /* binding */ MENU_ROOT_ID; },
/* harmony export */   "e": function() { return /* binding */ MENU_OBSERVING_CLASS_NAME; },
/* harmony export */   "f": function() { return /* binding */ EmojiListItems; },
/* harmony export */   "g": function() { return /* binding */ getObservingId; },
/* harmony export */   "h": function() { return /* binding */ MuteMenuItem; },
/* harmony export */   "i": function() { return /* binding */ EmojiReactionListRoot; },
/* harmony export */   "j": function() { return /* binding */ MenuRoot; },
/* harmony export */   "u": function() { return /* binding */ useMessageMenuContext; }
/* harmony export */ });
/* unused harmony export A */
/* harmony import */ var _bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80360);
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34182);
/* harmony import */ var _sendbird_chat_openChannel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35065);
/* harmony import */ var _ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71091);
/* harmony import */ var _ui_IconButton_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29515);
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99366);













var APP_LAYOUT_ROOT = 'sendbird-app__layout';

var HEIGHT_PADDING = 60;
var MenuItems$1 = /** @class */ (function (_super) {
    (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.e)(MenuItems, _super);
    function MenuItems(props) {
        var _this = _super.call(this, props) || this;
        _this.menuRef = react__WEBPACK_IMPORTED_MODULE_1__.createRef();
        _this.setupEvents = function () {
            var closeDropdown = _this.props.closeDropdown;
            var menuRef = _this.menuRef;
            var handleClickOutside = function (event) {
                var _a, _b;
                if ((menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) && !((_b = (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, event.target))) {
                    closeDropdown === null || closeDropdown === void 0 ? void 0 : closeDropdown();
                }
            };
            _this.setState({
                handleClickOutside: handleClickOutside,
            });
            document.addEventListener('mousedown', handleClickOutside);
        };
        _this.cleanUpEvents = function () {
            var handleClickOutside = _this.state.handleClickOutside;
            document.removeEventListener('mousedown', handleClickOutside);
        };
        _this.getMenuPosition = function () {
            var _a, _b, _c;
            var _d = _this.props, parentRef = _d.parentRef, openLeft = _d.openLeft;
            var portalElement = document.getElementById(APP_LAYOUT_ROOT);
            var portalRect = ((_a = portalElement === null || portalElement === void 0 ? void 0 : portalElement.getBoundingClientRect) === null || _a === void 0 ? void 0 : _a.call(portalElement)) || {
                top: 0,
                left: 0,
                width: window.innerWidth,
                height: window.innerHeight,
            };
            var parentRect = (_c = (_b = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect) === null || _c === void 0 ? void 0 : _c.call(_b);
            var x = ((parentRect === null || parentRect === void 0 ? void 0 : parentRect.x) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.left) || 0) - portalRect.left;
            var y = ((parentRect === null || parentRect === void 0 ? void 0 : parentRect.y) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.top) || 0) - portalRect.top;
            var menuStyle = {
                top: y,
                left: x,
            };
            if (!_this.menuRef.current)
                return menuStyle;
            var rect = _this.menuRef.current.getBoundingClientRect();
            if (y + rect.height + HEIGHT_PADDING > portalRect.height) {
                menuStyle.top -= rect.height;
            }
            if (x + rect.width > portalRect.width && !openLeft) {
                menuStyle.left -= rect.width;
            }
            if (menuStyle.top < 0) {
                menuStyle.top = rect.height < portalRect.height ? (portalRect.height - rect.height) / 2 : 0;
            }
            menuStyle.top += 32;
            if (openLeft) {
                var padding = Number.isNaN(rect.width - 30)
                    ? 108 // default
                    : rect.width - 30;
                menuStyle.left -= padding;
            }
            if (menuStyle.left < 0) {
                menuStyle.left = rect.width < portalRect.width ? (portalRect.width - rect.width) / 2 : 0;
            }
            _this.setState({ menuStyle: menuStyle });
            return menuStyle;
        };
        _this.state = {
            menuStyle: { top: 0, left: 0 },
            handleClickOutside: function () { },
        };
        return _this;
    }
    MenuItems.prototype.componentDidMount = function () {
        this.setupEvents();
        this.getMenuPosition();
    };
    MenuItems.prototype.componentWillUnmount = function () {
        this.cleanUpEvents();
    };
    MenuItems.prototype.render = function () {
        var portalElement = document.getElementById(MENU_ROOT_ID);
        if (!portalElement)
            return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
        var menuStyle = this.state.menuStyle;
        var _a = this.props, children = _a.children, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b, testID = _a.testID, id = _a.id;
        return ((0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)((react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)(MENU_OBSERVING_CLASS_NAME, className), "data-testid": testID, id: id },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-dropdown__menu-backdrop" }),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("ul", { className: "".concat(className, " sendbird-dropdown__menu"), ref: this.menuRef, style: (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ display: 'inline-block', position: 'fixed', left: "".concat(Math.round(menuStyle.left), "px"), top: "".concat(Math.round(menuStyle.top), "px") }, style), "data-testid": "sendbird-dropdown-menu" }, children))), portalElement));
    };
    return MenuItems;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component));

var MuteMenuItem = function (_a) {
    var channel = _a.channel, user = _a.user, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.disable, disable = _c === void 0 ? false : _c, _d = _a.dataSbId, dataSbId = _d === void 0 ? '' : _d, testID = _a.testID, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.onError, onError = _f === void 0 ? function () { } : _f;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(user.isMuted), isMuted = _g[0], setIsMuted = _g[1];
    var isProcessing = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        if (!isProcessing.current) {
            isProcessing.current = true;
            if (isMuted) {
                channel.unmuteUser(user)
                    .then(function () {
                    setIsMuted(false);
                    onChange(channel, user, false);
                    isProcessing.current = false;
                })
                    .catch(function (err) {
                    onError(err);
                    isProcessing.current = false;
                });
            }
            else {
                channel.muteUser(user)
                    .then(function () {
                    setIsMuted(true);
                    onChange(channel, user, true);
                    isProcessing.current = false;
                })
                    .catch(function (err) {
                    onError(err);
                    isProcessing.current = false;
                });
            }
        }
    }, [isProcessing, isMuted]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MenuItem, { className: className, disable: disable, testID: testID !== null && testID !== void 0 ? testID : dataSbId, onClick: onClickHandler }, children));
};

var OperatorMenuItem = function (_a) {
    var channel = _a.channel, user = _a.user, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.disable, disable = _c === void 0 ? false : _c, _d = _a.dataSbId, dataSbId = _d === void 0 ? '' : _d, testID = _a.testID, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.onError, onError = _f === void 0 ? function () { } : _f;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(channel instanceof _sendbird_chat_openChannel__WEBPACK_IMPORTED_MODULE_10__/* .OpenChannel */ .I6
        ? channel.isOperator(user)
        : user.role === _sendbird_chat__WEBPACK_IMPORTED_MODULE_11__.a7.OPERATOR), isOperator = _g[0], setIsOperator = _g[1];
    var isProcessing = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        if (!isProcessing.current) {
            isProcessing.current = true;
            if (isOperator) {
                channel.removeOperators([user.userId])
                    .then(function () {
                    setIsOperator(false);
                    onChange(channel, user, false);
                    isProcessing.current = false;
                })
                    .catch(function (err) {
                    onError(err);
                    isProcessing.current = false;
                });
            }
            else {
                channel.addOperators([user.userId])
                    .then(function () {
                    setIsOperator(true);
                    onChange(channel, user, true);
                    isProcessing.current = false;
                })
                    .catch(function (err) {
                    onError(err);
                    isProcessing.current = false;
                });
            }
        }
    }, [isProcessing, isOperator]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MenuItem, { className: className, disable: disable, testID: testID !== null && testID !== void 0 ? testID : dataSbId, onClick: onClickHandler }, children));
};

var defaultParentRect = { x: 0, y: 0, left: 0, top: 0, height: 0 };
var EmojiListItems$1 = function (_a) {
    var id = _a.id, children = _a.children, parentRef = _a.parentRef, parentContainRef = _a.parentContainRef, _b = _a.spaceFromTrigger, spaceFromTrigger = _b === void 0 ? { x: 0, y: 0 } : _b, closeDropdown = _a.closeDropdown;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({ left: 0, top: 0 }), reactionStyle = _c[0], setReactionStyle = _c[1];
    var reactionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    /* showParent & hideParent */
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (parentContainRef && (parentContainRef === null || parentContainRef === void 0 ? void 0 : parentContainRef.current)) {
            parentContainRef.current.classList.add('sendbird-reactions--pressed');
        }
        return function () {
            if (parentContainRef && (parentContainRef === null || parentContainRef === void 0 ? void 0 : parentContainRef.current)) {
                parentContainRef.current.classList.remove('sendbird-reactions--pressed');
            }
        };
    }, []);
    /* setupEvents & cleanupEvents */
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var handleClickOutSide = function (event) {
            var _a, _b;
            if ((reactionRef === null || reactionRef === void 0 ? void 0 : reactionRef.current) && !((_b = (_a = reactionRef === null || reactionRef === void 0 ? void 0 : reactionRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, event.target))) {
                closeDropdown();
            }
        };
        document.addEventListener('mousedown', handleClickOutSide);
        return function () {
            document.removeEventListener('mousedown', handleClickOutSide);
        };
    }, []);
    /* getBarPosition */
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var _a, _b, _c, _d;
        var spaceFromTriggerX = (spaceFromTrigger === null || spaceFromTrigger === void 0 ? void 0 : spaceFromTrigger.x) || 0;
        var spaceFromTriggerY = (spaceFromTrigger === null || spaceFromTrigger === void 0 ? void 0 : spaceFromTrigger.y) || 0;
        var portalElement = document.getElementById(APP_LAYOUT_ROOT);
        var portalRect = ((_a = portalElement === null || portalElement === void 0 ? void 0 : portalElement.getBoundingClientRect) === null || _a === void 0 ? void 0 : _a.call(portalElement)) || {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
        };
        var parentRect = (_c = (_b = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : defaultParentRect;
        var x = ((parentRect === null || parentRect === void 0 ? void 0 : parentRect.x) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.left) || 0) - portalRect.left;
        var y = ((parentRect === null || parentRect === void 0 ? void 0 : parentRect.y) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.top) || 0) - portalRect.top;
        var reactionStyle = {
            top: y,
            left: x,
        };
        if (!(reactionRef === null || reactionRef === void 0 ? void 0 : reactionRef.current)) {
            setReactionStyle(reactionStyle);
        }
        else {
            var rect = (_d = reactionRef === null || reactionRef === void 0 ? void 0 : reactionRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
            if (reactionStyle.top < rect.height) {
                reactionStyle.top += parentRect.height;
                reactionStyle.top += spaceFromTriggerY;
            }
            else {
                reactionStyle.top -= rect.height;
                reactionStyle.top -= spaceFromTriggerY;
            }
            reactionStyle.left -= rect.width / 2;
            reactionStyle.left += (parentRect.height / 2) - 2;
            reactionStyle.left += spaceFromTriggerX;
            var maximumLeft = portalRect.width - rect.width;
            if (maximumLeft < reactionStyle.left) {
                reactionStyle.left = maximumLeft;
            }
            if (reactionStyle.left < 0) {
                reactionStyle.left = 0;
            }
            setReactionStyle(reactionStyle);
        }
    }, []);
    var rootElement = document.getElementById(EMOJI_MENU_ROOT_ID);
    if (rootElement) {
        return ((0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: MENU_OBSERVING_CLASS_NAME, id: id },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-dropdown__menu-backdrop" }),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("ul", { className: "sendbird-dropdown__reaction-bar", "data-testid": "sendbird-dropdown__reaction-bar", ref: reactionRef, style: {
                    display: 'inline-block',
                    position: 'fixed',
                    left: "".concat(Math.round(reactionStyle.left), "px"),
                    top: "".concat(Math.round(reactionStyle.top), "px"),
                } },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ui_SortByRow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { className: "sendbird-dropdown__reaction-bar__row", maxItemCount: 8, itemWidth: 44, itemHeight: 40 }, children))), rootElement));
    }
    return null;
};

var MessageMenuContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var MessageMenuProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MessageMenuContext.Provider, { value: value }, children));
};
var useMessageMenuContext = function () {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MessageMenuContext);
    if (!context) {
        throw new Error('useMessageMenuContext must be used within a MessageMenuProvider.');
    }
    return context;
};

var MenuItem$1 = function (_a) {
    var className = _a.className, disabled = _a.disabled, _b = _a.tabIndex, tabIndex = _b === void 0 ? 0 : _b, testID = _a.testID, onClick = _a.onClick, children = _a.children;
    var handleClickEvent = function (e) {
        if (!disabled && onClick) {
            onClick(e);
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("li", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-menu-item', className), role: "menuitem", "aria-disabled": disabled, "data-testid": testID, tabIndex: tabIndex, onClick: handleClickEvent, onKeyDown: function (e) { if (e.code === 'Enter')
            handleClickEvent(e); } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.L, { className: "sendbird-menu-item__text", type: _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.a.SUBTITLE_2, color: disabled ? _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.ONBACKGROUND_4 : _bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.ONBACKGROUND_1 }, children)));
};
var BottomSheetMenuItem = function (_a) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, testID = _a.testID, onClick = _a.onClick, children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-message__bottomsheet--action', className), role: "menuitem", tabIndex: tabIndex, "aria-disabled": disabled, onClick: onClick, "data-testid": testID }, children));
};

// # useElementObserve
var MENU_OBSERVING_CLASS_NAME = 'sendbird-observing-message-menu';
var getObservingId = function (txt) { return "m_".concat(txt); };
var MenuItems = MenuItems$1;
var EmojiListItems = EmojiListItems$1;
/**
 * @deprecated
 * Use the `MenuItem` from '@sendbird/uikit-react/ui/MessageMenu' instead
 */
var MenuItem = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, onClick = _a.onClick, _c = _a.disable, disable = _c === void 0 ? false : _c, _d = _a.dataSbId, dataSbId = _d === void 0 ? '' : _d, testID = _a.testID;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MenuItem$1, { className: _bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c.apply(void 0, (0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), false), ['sendbird-dropdown__menu-item',
            disable ? 'disable' : ''], false)), disabled: disable, testID: testID !== null && testID !== void 0 ? testID : dataSbId, onClick: onClick }, children));
};
var MENU_ROOT_ID = 'sendbird-dropdown-portal';
var MenuRoot = function () { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { id: MENU_ROOT_ID, className: MENU_ROOT_ID })); };
var EMOJI_MENU_ROOT_ID = 'sendbird-emoji-list-portal';
var EmojiReactionListRoot = function () { return react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { id: EMOJI_MENU_ROOT_ID }); };
function ContextMenu(_a) {
    var menuTrigger = _a.menuTrigger, menuItems = _a.menuItems, isOpen = _a.isOpen, onClick = _a.onClick;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMenu = _b[0], setShowMenu = _b[1];
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-context-menu", onClick: onClick }, menuTrigger === null || menuTrigger === void 0 ? void 0 :
        menuTrigger(function () { return setShowMenu(!showMenu); }),
        (showMenu || isOpen) && menuItems(function () { return setShowMenu(false); })));
}


//# sourceMappingURL=bundle-ml-PByBw.js.map


/***/ }),

/***/ 78828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getMessageFirstFileType; },
/* harmony export */   "b": function() { return /* binding */ getMessageFirstFileName; },
/* harmony export */   "c": function() { return /* binding */ getMessageFirstFileThumbnailUrl; },
/* harmony export */   "g": function() { return /* binding */ getMessageFirstFileUrl; }
/* harmony export */ });
/* harmony import */ var _bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6623);


function getMessageFirstFileType(message) {
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.K)(message)
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.b, function () {
        var _a;
        return (_a = message === null || message === void 0 ? void 0 : message.type) !== null && _a !== void 0 ? _a : '';
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.c, function () {
        var _a, _b;
        return (_b = (_a = getFirstFileInfo(message)) === null || _a === void 0 ? void 0 : _a.mimeType) !== null && _b !== void 0 ? _b : '';
    })
        .otherwise(function () {
        return '';
    });
}
function getFirstFileInfo(message) {
    var fileInfoList = message.fileInfoList;
    return fileInfoList.length > 0 ? fileInfoList[0] : null;
}
function getMessageFirstFileName(message) {
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.K)(message)
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.b, function () {
        var _a;
        return (_a = message === null || message === void 0 ? void 0 : message.name) !== null && _a !== void 0 ? _a : '';
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.c, function () {
        var _a, _b;
        return (_b = (_a = getFirstFileInfo(message)) === null || _a === void 0 ? void 0 : _a.fileName) !== null && _b !== void 0 ? _b : '';
    })
        .otherwise(function () {
        return '';
    });
}
function getMessageFirstFileUrl(message) {
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.K)(message)
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.b, function () {
        var _a;
        return (_a = message === null || message === void 0 ? void 0 : message.url) !== null && _a !== void 0 ? _a : '';
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.c, function () {
        var _a, _b;
        return (_b = (_a = getFirstFileInfo(message)) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '';
    })
        .otherwise(function () {
        return '';
    });
}
function getMessageFirstFileThumbnails(message) {
    return (0,_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.K)(message)
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.b, function () {
        return message.thumbnails;
    })
        .when(_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_0__.c, function () {
        var _a, _b;
        return (_b = (_a = getFirstFileInfo(message)) === null || _a === void 0 ? void 0 : _a.thumbnails) !== null && _b !== void 0 ? _b : [];
    })
        .otherwise(function () {
        return [];
    });
}
function getMessageFirstFileThumbnailUrl(message) {
    var thumbnails = getMessageFirstFileThumbnails(message);
    return (thumbnails && thumbnails.length > 0) ? thumbnails[0].url : '';
}


//# sourceMappingURL=bundle-oZLTNsQY.js.map


/***/ }),

/***/ 89171:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ extractTextAndMentions; },
  "i": function() { return /* binding */ isChannelTypeSupportsMultipleFilesMessage; },
  "n": function() { return /* binding */ nodeListToArray; },
  "r": function() { return /* binding */ renderToString; },
  "s": function() { return /* binding */ sanitizeString; },
  "u": function() { return /* binding */ usePaste; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CLlCJbe7.js
var bundle_CLlCJbe7 = __webpack_require__(459);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-C6DfLTJj.js
var bundle_C6DfLTJj = __webpack_require__(48614);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-XQWyv823.js
var bundle_XQWyv823 = __webpack_require__(65614);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle--FsN6ZvY.js
var MENTION_USER_LABEL_CLASSNAME = 'sendbird-mention-user-label';


//# sourceMappingURL=bundle--FsN6ZvY.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CXiD3Is4.js
var bundle_CXiD3Is4 = __webpack_require__(16423);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BmHwyA9G.js
var bundle_BmHwyA9G = __webpack_require__(13195);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-tC4B8MXx.js









function renderToString(_a) {
    var userId = _a.userId, nickname = _a.nickname;
    // donot change this template, it wont work
    var el = "<span data-userid=\"".concat(userId, "\" data-sb-mention=\"true\" class=\"").concat(MENTION_USER_LABEL_CLASSNAME, "\">").concat(nickname, "</span>");
    var purifier = purify(window);
    var sanitized_ = purifier.sanitize(el);
    var token = sanitized_.split(' ');
    var spanTag = token[0], rest = token.slice(1);
    // we do this because DOMPurify removes the contenteditable attribute
    var sanitized = (0,bundle_XQWyv823.c)([spanTag, 'contenteditable="false"'], rest, true).join(' ');
    return sanitized;
}

var sanitizeString = function (str) {
    return str === null || str === void 0 ? void 0 : str.replace(/[\u00A0-\u9999<>]/gim, function (i) { return ''.concat('&#', String(i.charCodeAt(0)), ';'); });
};
/**
 * NodeList cannot be used with Array methods
 * @param {NodeListOf<ChildNode>} childNodes
 * @returns Array of child nodes
 */
var nodeListToArray = function (childNodes) {
    return childNodes ? Array.from(childNodes) : [];
};
function isChannelTypeSupportsMultipleFilesMessage(channel) {
    var _a;
    return channel && ((_a = channel.isGroupChannel) === null || _a === void 0 ? void 0 : _a.call(channel)) && !channel.isBroadcast && !channel.isSuper;
}
// Type guard: This function ensures that the node contains `innerText` and `dataset` properties
function isHTMLElement(node) {
    return node.nodeType === bundle_CLlCJbe7.N.ElementNode;
}
// eslint-disable-next-line no-undef
function extractTextAndMentions(childNodes) {
    var messageText = '';
    var mentionTemplate = '';
    childNodes.forEach(function (node) {
        if (isHTMLElement(node) && node.nodeName === bundle_CLlCJbe7.a.Span) {
            var innerText = node.innerText, _a = node.dataset, dataset = _a === void 0 ? {} : _a;
            var _b = dataset.userid, userid = _b === void 0 ? '' : _b;
            messageText += innerText;
            mentionTemplate += "".concat(bundle_C6DfLTJj.a, "{").concat(userid, "}");
        }
        else if (isHTMLElement(node) && node.nodeName === bundle_CLlCJbe7.a.Br) {
            messageText += '\n';
            mentionTemplate += '\n';
        }
        else if (isHTMLElement(node) && node.nodeName === bundle_CLlCJbe7.a.Div) {
            var _c = node.textContent, textContent = _c === void 0 ? '' : _c;
            messageText += "\n".concat(textContent);
            mentionTemplate += "\n".concat(textContent);
        }
        else {
            var _d = node.textContent, textContent = _d === void 0 ? '' : _d;
            messageText += textContent;
            mentionTemplate += textContent;
        }
    });
    return { messageText: messageText, mentionTemplate: mentionTemplate };
}

function inserTemplateToDOM(templateList) {
    var nodes = templateList.map(function (template) {
        var text = template.text, userId = template.userId;
        if (userId) {
            return renderToString({ userId: userId, nickname: text });
        }
        return sanitizeString(text);
    })
        .join(' ')
        // add a space at the end of the mention, else cursor/caret wont work
        .concat(' ');
    document.execCommand('insertHTML', false, nodes);
}

var PASTE_NODE = 'sendbird-uikit__paste-node';
var TEXT_MESSAGE_CLASS = 'sendbird-word';
var MENTION_CLASS = 'sendbird-word__mention';
var MENTION_CLASS_IN_INPUT = 'sendbird-mention-user-label';
var MENTION_CLASS_COMBINED_QUERY = ".".concat(MENTION_CLASS, ", .").concat(MENTION_CLASS_IN_INPUT);

function querySelectorIncludingSelf(master, selector) {
    var result = (0,bundle_XQWyv823.c)([
        master
    ], Array.from(master.querySelectorAll(selector)), true).find(function (el) { return el.matches(selector); });
    return result;
}
// Pasted dom node can be OG_MESSAGE or partial message or full message
// full messsage would have TEXT_MESSAGE_BODY_CLASSNAME and have childNodes
// partial message would not have TEXT_MESSAGE_BODY_CLASSNAME
function getLeafNodes(master) {
    // og message
    var ogMessage = querySelectorIncludingSelf(master, ".".concat(bundle_BmHwyA9G.O));
    if (ogMessage) {
        return nodeListToArray(ogMessage.childNodes);
    }
    var textMessageBody = querySelectorIncludingSelf(master, ".".concat(bundle_CXiD3Is4.T));
    if (textMessageBody) {
        return nodeListToArray(textMessageBody.childNodes);
    }
    return nodeListToArray(master.childNodes);
}
function createPasteNode() {
    var pasteNode = document.body.querySelector("#".concat(PASTE_NODE));
    // remove existing paste node
    if (pasteNode) {
        pasteNode === null || pasteNode === void 0 ? void 0 : pasteNode.remove();
    }
    // create new paste node and return
    var node = document.createElement('div');
    node.id = PASTE_NODE;
    node.style.display = 'none';
    return node;
}
function hasMention(parent) {
    return (parent === null || parent === void 0 ? void 0 : parent.querySelector(MENTION_CLASS_COMBINED_QUERY)) ? true : false;
}
var extractTextFromNodes = function (nodes) {
    var text = '';
    nodes.forEach(function (node) {
        // to preserve space between words
        var textNodes = node.querySelectorAll(".".concat(TEXT_MESSAGE_CLASS));
        if (textNodes.length > 0) {
            text += ((extractTextFromNodes(Array.from(textNodes))) + ' ');
        }
        text += (node.innerText + ' ');
    });
    return text;
};
function domToMessageTemplate(nodeArray) {
    var templates = nodeArray === null || nodeArray === void 0 ? void 0 : nodeArray.reduce(function (accumulator, currentValue) {
        var _a, _b;
        // currentValue can be node(from messageBody or messageInput) or text
        var mentionNode;
        // this looks awkward, but it is a fallback to set default text
        var text = currentValue === null || currentValue === void 0 ? void 0 : currentValue.innerText;
        // if text node, set text
        if (currentValue instanceof Text) {
            mentionNode = false;
            text = (_a = currentValue.textContent) !== null && _a !== void 0 ? _a : '';
        }
        if (currentValue instanceof HTMLElement) {
            mentionNode = (currentValue.classList.contains(MENTION_CLASS) || currentValue.classList.contains(MENTION_CLASS_IN_INPUT))
                ? currentValue
                : currentValue.querySelector(MENTION_CLASS_COMBINED_QUERY);
        }
        // if mentionNode is not null, it is a mention
        if (mentionNode) {
            var text_1 = currentValue === null || currentValue === void 0 ? void 0 : currentValue.innerText;
            var userId = (_b = mentionNode.dataset) === null || _b === void 0 ? void 0 : _b.userid;
            return (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], accumulator, true), [
                {
                    text: text_1,
                    userId: userId,
                },
            ], false);
        }
        return (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], accumulator, true), [
            {
                text: text,
            },
        ], false);
    }, []);
    return templates;
}
function getUsersFromWords(templates, channel) {
    var userMap = {};
    var users = channel.members;
    templates.forEach(function (template) {
        if (template.userId) {
            var mentionedMember = users.find(function (user) { return user.userId === template.userId; });
            // Object.values would return array-> [undefined] if the user is not in the channel
            if (mentionedMember) {
                userMap[template.userId] = mentionedMember;
            }
        }
    });
    return Object.values(userMap);
}

// exported, should be backward compatible
// conditions to test:
// 1. paste simple text
// 2. paste text with mention
// 3. paste text with mention and text
// 4. paste text with mention and text and paste again before and after
// 5. copy message with mention(only one mention, no other text) and paste
// 6. copy message with mention from input and paste(before and after)
function usePaste(_a) {
    var ref = _a.ref, setIsInput = _a.setIsInput, setHeight = _a.setHeight, channel = _a.channel, setMentionedUsers = _a.setMentionedUsers;
    return (0,react.useCallback)(function (e) {
        e.preventDefault();
        var html = e.clipboardData.getData('text/html');
        // simple text, continue as normal
        if (!html) {
            var text = e.clipboardData.getData('text') || getURIListText(e);
            document.execCommand('insertText', false, sanitizeString(text));
            setIsInput(true);
            setHeight();
            return;
        }
        // has html, check if there are mentions, sanitize and insert
        var purifier = purify(window);
        var clean = purifier.sanitize(html);
        var pasteNode = createPasteNode();
        if (pasteNode) {
            pasteNode.innerHTML = clean;
            // does not have mention, continue as normal
            if (!hasMention(pasteNode)) {
                // to preserve space between words
                var text = extractTextFromNodes(Array.from(pasteNode.children));
                document.execCommand('insertText', false, sanitizeString(text));
                pasteNode.remove();
                setIsInput(true);
                setHeight();
                return;
            }
            // has mention, collect leaf nodes and parse words
            var leafNodes = getLeafNodes(pasteNode);
            var words = domToMessageTemplate(leafNodes);
            var mentionedUsers = channel.isGroupChannel() ? getUsersFromWords(words, channel) : [];
            // side effects
            setMentionedUsers(mentionedUsers);
            inserTemplateToDOM(words);
            pasteNode.remove();
        }
        setIsInput(true);
        setHeight();
    }, [ref, setIsInput, setHeight, channel, setMentionedUsers]);
}
// https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#dragging_links
function getURIListText(e) {
    var pasteData = e.clipboardData.getData('text/uri-list');
    if (pasteData.length === 0)
        return '';
    return pasteData
        .split('\n')
        .reduce(function (accumulator, line) {
        var txt = line.trim();
        if (txt !== '' && !txt.startsWith('#')) {
            accumulator += txt + '\n';
        }
        return accumulator;
    }, '');
}


//# sourceMappingURL=bundle-tC4B8MXx.js.map


/***/ }),

/***/ 60424:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useKeyDown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63507);



function useKeyDown(ref, keyDownCallbackMap) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [ref.current]);
    var onKeyDown = (0,_sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_1__/* .usePreservedCallback */ .zS)(function (event) {
        var callback = keyDownCallbackMap[event.key];
        callback === null || callback === void 0 ? void 0 : callback(event);
        event.stopPropagation();
    });
    return onKeyDown;
}


//# sourceMappingURL=bundle-vS1u8K1w.js.map


/***/ }),

/***/ 65749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* reexport */ SendbirdProvider_SendbirdProvider; }
});

// UNUSED EXPORTS: App, Channel, ChannelList, ChannelSettings, MessageSearch, OpenChannel, OpenChannelSettings, TypingIndicatorType, getStringSet, sendBirdSelectors, sendbirdSelectors, useSendbirdStateContext, withSendBird

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-XQWyv823.js
var bundle_XQWyv823 = __webpack_require__(65614);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/index.js + 31 modules
var esm = __webpack_require__(63507);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/withSendbird.js
var withSendbird = __webpack_require__(71091);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-NL8iE1lF.js
var bundle_NL8iE1lF = __webpack_require__(17693);
;// CONCATENATED MODULE: ./node_modules/css-vars-ponyfill/dist/css-vars-ponyfill.esm.js
/*!
 * css-vars-ponyfill
 * v2.4.9
 * https://jhildenbiddle.github.io/css-vars-ponyfill/
 * (c) 2018-2024 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/*!
 * get-css-data
 * v2.1.0
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2022 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */ function getUrls(urls) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var settings = {
        mimeType: options.mimeType || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var urlArray = Array.isArray(urls) ? urls : [ urls ];
    var urlQueue = Array.apply(null, Array(urlArray.length)).map((function(x) {
        return null;
    }));
    function isValidCss(text) {
        var isString = typeof text === "string";
        var isHTML = isString && text.trim().charAt(0) === "<";
        return isString && !isHTML;
    }
    function onError(xhr, urlIndex) {
        settings.onError(xhr, urlArray[urlIndex], urlIndex);
    }
    function onSuccess(responseText, urlIndex) {
        var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
        responseText = returnVal === false ? "" : returnVal || responseText;
        urlQueue[urlIndex] = responseText;
        if (urlQueue.indexOf(null) === -1) {
            settings.onComplete(urlQueue);
        }
    }
    var parser = document.createElement("a");
    urlArray.forEach((function(url, i) {
        parser.setAttribute("href", url);
        parser.href = String(parser.href);
        var isIElte9 = Boolean(document.all && !window.atob);
        var isIElte9CORS = isIElte9 && parser.host.split(":")[0] !== location.host.split(":")[0];
        if (isIElte9CORS) {
            var isSameProtocol = parser.protocol === location.protocol;
            if (isSameProtocol) {
                var xdr = new XDomainRequest;
                xdr.open("GET", url);
                xdr.timeout = 0;
                xdr.onprogress = Function.prototype;
                xdr.ontimeout = Function.prototype;
                xdr.onload = function() {
                    var text = xdr.responseText;
                    if (isValidCss(text)) {
                        onSuccess(text, i);
                    } else {
                        onError(xdr, i);
                    }
                };
                xdr.onerror = function(err) {
                    onError(xdr, i);
                };
                setTimeout((function() {
                    xdr.send();
                }), 0);
            } else {
                console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(url, ")"));
                onError(null, i);
            }
        } else {
            var xhr = new XMLHttpRequest;
            xhr.open("GET", url);
            if (settings.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(settings.mimeType);
            }
            settings.onBeforeSend(xhr, url, i);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    var text = xhr.responseText;
                    if (xhr.status < 400 && isValidCss(text)) {
                        onSuccess(text, i);
                    } else if (xhr.status === 0 && isValidCss(text)) {
                        onSuccess(text, i);
                    } else {
                        onError(xhr, i);
                    }
                }
            };
            xhr.send();
        }
    }));
}

/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {boolean}  [options.skipDisabled=true] Determines if disabled
 *                   stylesheets will be skipped while collecting CSS data.
 * @param {boolean}  [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement : document,
 *     include     : 'style,link[rel="stylesheet"]',
 *     exclude     : '[href="skip.css"]',
 *     filter      : /red/,
 *     skipDisabled: true,
 *     useCSSOM    : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */ function getCssData(options) {
    var regex = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
    };
    var settings = {
        rootElement: options.rootElement || document,
        include: options.include || 'style,link[rel="stylesheet"]',
        exclude: options.exclude || null,
        filter: options.filter || null,
        skipDisabled: options.skipDisabled !== false,
        useCSSOM: options.useCSSOM || false,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var sourceNodes = Array.apply(null, settings.rootElement.querySelectorAll(settings.include)).filter((function(node) {
        return !matchesSelector(node, settings.exclude);
    }));
    var cssArray = Array.apply(null, Array(sourceNodes.length)).map((function(x) {
        return null;
    }));
    function handleComplete() {
        var isComplete = cssArray.indexOf(null) === -1;
        if (isComplete) {
            cssArray.reduce((function(skipIndices, value, i) {
                if (value === "") {
                    skipIndices.push(i);
                }
                return skipIndices;
            }), []).reverse().forEach((function(skipIndex) {
                return [ sourceNodes, cssArray ].forEach((function(arr) {
                    return arr.splice(skipIndex, 1);
                }));
            }));
            var cssText = cssArray.join("");
            settings.onComplete(cssText, cssArray, sourceNodes);
        }
    }
    function handleSuccess(cssText, cssIndex, node, sourceUrl) {
        var returnVal = settings.onSuccess(cssText, node, sourceUrl);
        cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
        resolveImports(cssText, node, sourceUrl, (function(resolvedCssText, errorData) {
            if (cssArray[cssIndex] === null) {
                errorData.forEach((function(data) {
                    return settings.onError(data.xhr, node, data.url);
                }));
                if (!settings.filter || settings.filter.test(resolvedCssText)) {
                    cssArray[cssIndex] = resolvedCssText;
                } else {
                    cssArray[cssIndex] = "";
                }
                handleComplete();
            }
        }));
    }
    function parseImportData(cssText, baseUrl) {
        var ignoreRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var importData = {};
        importData.rules = (cssText.replace(regex.cssComments, "").match(regex.cssImports) || []).filter((function(rule) {
            return ignoreRules.indexOf(rule) === -1;
        }));
        importData.urls = importData.rules.map((function(rule) {
            return rule.replace(regex.cssImports, "$1");
        }));
        importData.absoluteUrls = importData.urls.map((function(url) {
            return getFullUrl$1(url, baseUrl);
        }));
        importData.absoluteRules = importData.rules.map((function(rule, i) {
            var oldUrl = importData.urls[i];
            var newUrl = getFullUrl$1(importData.absoluteUrls[i], baseUrl);
            return rule.replace(oldUrl, newUrl);
        }));
        return importData;
    }
    function resolveImports(cssText, node, baseUrl, callbackFn) {
        var __errorData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var __errorRules = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var importData = parseImportData(cssText, baseUrl, __errorRules);
        if (importData.rules.length) {
            getUrls(importData.absoluteUrls, {
                onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                    settings.onBeforeSend(xhr, node, url);
                },
                onSuccess: function onSuccess(cssText, url, urlIndex) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    var responseImportData = parseImportData(cssText, url, __errorRules);
                    responseImportData.rules.forEach((function(rule, i) {
                        cssText = cssText.replace(rule, responseImportData.absoluteRules[i]);
                    }));
                    return cssText;
                },
                onError: function onError(xhr, url, urlIndex) {
                    __errorData.push({
                        xhr: xhr,
                        url: url
                    });
                    __errorRules.push(importData.rules[urlIndex]);
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                },
                onComplete: function onComplete(responseArray) {
                    responseArray.forEach((function(importText, i) {
                        cssText = cssText.replace(importData.rules[i], importText);
                    }));
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                }
            });
        } else {
            callbackFn(cssText, __errorData);
        }
    }
    if (sourceNodes.length) {
        sourceNodes.forEach((function(node, i) {
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = node.nodeName.toLowerCase() === "link" && linkHref && linkRel && linkRel.toLowerCase().indexOf("stylesheet") !== -1;
            var isSkip = settings.skipDisabled === false ? false : node.disabled;
            var isStyle = node.nodeName.toLowerCase() === "style";
            if (isLink && !isSkip) {
                var isURIScheme = linkHref.indexOf("data:text/css") !== -1;
                if (isURIScheme) {
                    var cssText = decodeURIComponent(linkHref.substring(linkHref.indexOf(",") + 1));
                    if (settings.useCSSOM) {
                        cssText = Array.apply(null, node.sheet.cssRules).map((function(rule) {
                            return rule.cssText;
                        })).join("");
                    }
                    handleSuccess(cssText, i, node, location.href);
                } else {
                    getUrls(linkHref, {
                        mimeType: "text/css",
                        onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                            settings.onBeforeSend(xhr, node, url);
                        },
                        onSuccess: function onSuccess(cssText, url, urlIndex) {
                            var sourceUrl = getFullUrl$1(linkHref);
                            handleSuccess(cssText, i, node, sourceUrl);
                        },
                        onError: function onError(xhr, url, urlIndex) {
                            cssArray[i] = "";
                            settings.onError(xhr, node, url);
                            handleComplete();
                        }
                    });
                }
            } else if (isStyle && !isSkip) {
                var _cssText = node.textContent;
                if (settings.useCSSOM) {
                    _cssText = Array.apply(null, node.sheet.cssRules).map((function(rule) {
                        return rule.cssText;
                    })).join("");
                }
                handleSuccess(_cssText, i, node, location.href);
            } else {
                cssArray[i] = "";
                handleComplete();
            }
        }));
    } else {
        settings.onComplete("", []);
    }
}

function getFullUrl$1(url, base) {
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base || document.baseURI || (document.querySelector("base") || {}).href || location.href;
    a.href = url;
    return a.href;
}

function matchesSelector(elm, selector) {
    var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
    return matches.call(elm, selector);
}

var balancedMatch = balanced;

function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}

function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}

balanced.range = range;

function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) {
            return [ ai, bi ];
        }
        begs = [];
        left = str.length;
        while (i >= 0 && !result) {
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) {
                result = [ begs.pop(), bi ];
            } else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) {
            result = [ left, right ];
        }
    }
    return result;
}

function parseCss(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        preserveStatic: true,
        removeComments: false
    };
    var settings = _extends({}, defaults, options);
    var errors = [];
    function error(msg) {
        throw new Error("CSS parse error: ".concat(msg));
    }
    function match(re) {
        var m = re.exec(css);
        if (m) {
            css = css.slice(m[0].length);
            return m;
        }
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function whitespace() {
        match(/^\s*/);
    }
    function comment() {
        whitespace();
        if (css[0] !== "/" || css[1] !== "*") {
            return;
        }
        var i = 2;
        while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
            i++;
        }
        if (!css[i]) {
            return error("end of comment is missing");
        }
        var str = css.slice(2, i);
        css = css.slice(i + 2);
        return {
            type: "comment",
            comment: str
        };
    }
    function comments() {
        var cmnts = [];
        var c;
        while (c = comment()) {
            cmnts.push(c);
        }
        return settings.removeComments ? [] : cmnts;
    }
    function selector() {
        whitespace();
        while (css[0] === "}") {
            error("extra closing bracket");
        }
        var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
        if (m) {
            var _selector = m[0].trim();
            var selectorItems;
            var hasComment = /\/\*/.test(_selector);
            if (hasComment) {
                _selector = _selector.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "");
            }
            var hasCommaInQuotes = /["']\w*,\w*["']/.test(_selector);
            if (hasCommaInQuotes) {
                _selector = _selector.replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, (function(m) {
                    return m.replace(/,/g, "‌");
                }));
            }
            var hasMultipleSelectors = /,/.test(_selector);
            if (hasMultipleSelectors) {
                selectorItems = _selector.split(/\s*(?![^(]*\)),\s*/);
            } else {
                selectorItems = [ _selector ];
            }
            if (hasCommaInQuotes) {
                selectorItems = selectorItems.map((function(s) {
                    return s.replace(/\u200C/g, ",");
                }));
            }
            return selectorItems;
        }
    }
    function declaration() {
        if (css[0] === "@") {
            return at_rule();
        }
        match(/^([;\s]*)+/);
        var comment_regexp = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
        var prop = match(/^(\*?[-#/*\\\w.]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!prop) {
            return;
        }
        prop = prop[0].trim();
        if (!match(/^:\s*/)) {
            return error("property missing ':'");
        }
        var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
        var ret = {
            type: "declaration",
            property: prop.replace(comment_regexp, ""),
            value: val ? val[0].replace(comment_regexp, "").trim() : ""
        };
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        if (!open()) {
            return error("missing '{'");
        }
        var d;
        var decls = comments();
        while (d = declaration()) {
            decls.push(d);
            decls = decls.concat(comments());
        }
        if (!close()) {
            return error("missing '}'");
        }
        return decls;
    }
    function keyframe() {
        whitespace();
        var vals = [];
        var m;
        while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (vals.length) {
            return {
                type: "keyframe",
                values: vals,
                declarations: declarations()
            };
        }
    }
    function at_keyframes() {
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) {
            return;
        }
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) {
            return error("@keyframes missing name");
        }
        var name = m[1];
        if (!open()) {
            return error("@keyframes missing '{'");
        }
        var frame;
        var frames = comments();
        while (frame = keyframe()) {
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) {
            return error("@keyframes missing '}'");
        }
        return {
            type: "keyframes",
            name: name,
            vendor: vendor,
            keyframes: frames
        };
    }
    function at_page() {
        var m = match(/^@page */);
        if (m) {
            var sel = selector() || [];
            return {
                type: "page",
                selectors: sel,
                declarations: declarations()
            };
        }
    }
    function at_page_margin_box() {
        var m = match(/@(top|bottom|left|right)-(left|center|right|top|middle|bottom)-?(corner)?\s*/);
        if (m) {
            var name = "".concat(m[1], "-").concat(m[2]) + (m[3] ? "-".concat(m[3]) : "");
            return {
                type: "page-margin-box",
                name: name,
                declarations: declarations()
            };
        }
    }
    function at_fontface() {
        var m = match(/^@font-face\s*/);
        if (m) {
            return {
                type: "font-face",
                declarations: declarations()
            };
        }
    }
    function at_supports() {
        var m = match(/^@supports *([^{]+)/);
        if (m) {
            return {
                type: "supports",
                supports: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_host() {
        var m = match(/^@host\s*/);
        if (m) {
            return {
                type: "host",
                rules: rules()
            };
        }
    }
    function at_media() {
        var m = match(/^@media([^{]+)*/);
        if (m) {
            return {
                type: "media",
                media: (m[1] || "").trim(),
                rules: rules()
            };
        }
    }
    function at_custom_m() {
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (m) {
            return {
                type: "custom-media",
                name: m[1].trim(),
                media: m[2].trim()
            };
        }
    }
    function at_document() {
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (m) {
            return {
                type: "document",
                document: m[2].trim(),
                vendor: m[1] ? m[1].trim() : null,
                rules: rules()
            };
        }
    }
    function at_x() {
        var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
        if (m) {
            return {
                type: m[1],
                name: m[2].trim()
            };
        }
    }
    function at_rule() {
        whitespace();
        if (css[0] === "@") {
            var ret = at_x() || at_fontface() || at_media() || at_keyframes() || at_supports() || at_document() || at_custom_m() || at_host() || at_page() || at_page_margin_box();
            if (ret && !settings.preserveStatic) {
                var hasVarFunc = false;
                if (ret.declarations) {
                    hasVarFunc = ret.declarations.some((function(decl) {
                        return /var\(/.test(decl.value);
                    }));
                } else {
                    var arr = ret.keyframes || ret.rules || [];
                    hasVarFunc = arr.some((function(obj) {
                        return (obj.declarations || []).some((function(decl) {
                            return /var\(/.test(decl.value);
                        }));
                    }));
                }
                return hasVarFunc ? ret : {};
            }
            return ret;
        }
    }
    function rule() {
        if (!settings.preserveStatic) {
            var balancedMatch$1 = balancedMatch("{", "}", css);
            if (balancedMatch$1) {
                var hasVarDecl = /:(?:root|host)(?![.:#(])/.test(balancedMatch$1.pre) && /--\S*\s*:/.test(balancedMatch$1.body);
                var hasVarFunc = /var\(/.test(balancedMatch$1.body);
                if (!hasVarDecl && !hasVarFunc) {
                    css = css.slice(balancedMatch$1.end + 1);
                    return {};
                }
            }
        }
        var sel = selector() || [];
        var decls = settings.preserveStatic ? declarations() : declarations().filter((function(decl) {
            var hasVarDecl = sel.some((function(s) {
                return /:(?:root|host)(?![.:#(])/.test(s);
            })) && /^--\S/.test(decl.property);
            var hasVarFunc = /var\(/.test(decl.value);
            return hasVarDecl || hasVarFunc;
        }));
        if (!sel.length) {
            error("selector missing");
        }
        return {
            type: "rule",
            selectors: sel,
            declarations: decls
        };
    }
    function rules(core) {
        if (!core && !open()) {
            return error("missing '{'");
        }
        var node;
        var rules = comments();
        while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
            if (node.type) {
                rules.push(node);
            }
            rules = rules.concat(comments());
        }
        if (!core && !close()) {
            return error("missing '}'");
        }
        return rules;
    }
    return {
        type: "stylesheet",
        stylesheet: {
            rules: rules(true),
            errors: errors
        }
    };
}

function parseVars(cssData) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        parseHost: false,
        store: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    var reVarDeclSelectors = new RegExp(":".concat(settings.parseHost ? "host" : "root", "$"));
    if (typeof cssData === "string") {
        cssData = parseCss(cssData, settings);
    }
    cssData.stylesheet.rules.forEach((function(rule) {
        if (rule.type !== "rule" || !rule.selectors.some((function(s) {
            return reVarDeclSelectors.test(s);
        }))) {
            return;
        }
        rule.declarations.forEach((function(decl, i) {
            var prop = decl.property;
            var value = decl.value;
            if (prop && prop.indexOf("--") === 0) {
                settings.store[prop] = value;
            }
        }));
    }));
    return settings.store;
}

function stringifyCss(tree) {
    var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var renderMethods = {
        charset: function charset(node) {
            return "@charset " + node.name + ";";
        },
        comment: function comment(node) {
            return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
        },
        "custom-media": function customMedia(node) {
            return "@custom-media " + node.name + " " + node.media + ";";
        },
        declaration: function declaration(node) {
            return node.property + ":" + node.value + ";";
        },
        document: function document(node) {
            return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
        },
        "font-face": function fontFace(node) {
            return "@font-face" + "{" + visit(node.declarations) + "}";
        },
        host: function host(node) {
            return "@host" + "{" + visit(node.rules) + "}";
        },
        import: function _import(node) {
            return "@import " + node.name + ";";
        },
        keyframe: function keyframe(node) {
            return node.values.join(",") + "{" + visit(node.declarations) + "}";
        },
        keyframes: function keyframes(node) {
            return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
        },
        media: function media(node) {
            return "@media " + node.media + "{" + visit(node.rules) + "}";
        },
        namespace: function namespace(node) {
            return "@namespace " + node.name + ";";
        },
        page: function page(node) {
            return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
        },
        "page-margin-box": function pageMarginBox(node) {
            return "@" + node.name + "{" + visit(node.declarations) + "}";
        },
        rule: function rule(node) {
            var decls = node.declarations;
            if (decls.length) {
                return node.selectors.join(",") + "{" + visit(decls) + "}";
            }
        },
        supports: function supports(node) {
            return "@supports " + node.supports + "{" + visit(node.rules) + "}";
        }
    };
    function visit(nodes) {
        var buf = "";
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (cb) {
                cb(n);
            }
            var txt = renderMethods[n.type](n);
            if (txt) {
                buf += txt;
                if (txt.length && n.selectors) {
                    buf += delim;
                }
            }
        }
        return buf;
    }
    return visit(tree.stylesheet.rules);
}

function walkCss(node, fn) {
    node.rules.forEach((function(rule) {
        if (rule.rules) {
            walkCss(rule, fn);
            return;
        }
        if (rule.keyframes) {
            rule.keyframes.forEach((function(keyframe) {
                if (keyframe.type === "keyframe") {
                    fn(keyframe.declarations, rule);
                }
            }));
            return;
        }
        if (!rule.declarations) {
            return;
        }
        fn(rule.declarations, node);
    }));
}

var VAR_PROP_IDENTIFIER = "--";

var VAR_FUNC_IDENTIFIER = "var";

function transformCss(cssData) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        preserveStatic: true,
        preserveVars: false,
        variables: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    if (typeof cssData === "string") {
        cssData = parseCss(cssData, settings);
    }
    walkCss(cssData.stylesheet, (function(declarations, node) {
        for (var i = 0; i < declarations.length; i++) {
            var decl = declarations[i];
            var type = decl.type;
            var prop = decl.property;
            var value = decl.value;
            if (type !== "declaration") {
                continue;
            }
            if (!settings.preserveVars && prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
                declarations.splice(i, 1);
                i--;
                continue;
            }
            if (value.indexOf(VAR_FUNC_IDENTIFIER + "(") !== -1) {
                var resolvedValue = resolveValue(value, settings);
                if (resolvedValue !== decl.value) {
                    resolvedValue = fixNestedCalc(resolvedValue);
                    if (!settings.preserveVars) {
                        decl.value = resolvedValue;
                    } else {
                        declarations.splice(i, 0, {
                            type: type,
                            property: prop,
                            value: resolvedValue
                        });
                        i++;
                    }
                }
            }
        }
    }));
    return stringifyCss(cssData);
}

function fixNestedCalc(value) {
    var reCalcVal = /calc\(([^)]+)\)/g;
    (value.match(reCalcVal) || []).forEach((function(match) {
        var newVal = "calc".concat(match.split("calc").join(""));
        value = value.replace(match, newVal);
    }));
    return value;
}

function resolveValue(value) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var __recursiveFallback = arguments.length > 2 ? arguments[2] : undefined;
    if (value.indexOf("var(") === -1) {
        return value;
    }
    var valueData = balancedMatch("(", ")", value);
    function resolveFunc(value) {
        var name = value.split(",")[0].replace(/[\s\n\t]/g, "");
        var fallback = (value.match(/(?:\s*,\s*){1}(.*)?/) || [])[1];
        var match = Object.prototype.hasOwnProperty.call(settings.variables, name) ? String(settings.variables[name]) : undefined;
        var replacement = match || (fallback ? String(fallback) : undefined);
        var unresolvedFallback = __recursiveFallback || value;
        if (!match) {
            settings.onWarning('variable "'.concat(name, '" is undefined'));
        }
        if (replacement && replacement !== "undefined" && replacement.length > 0) {
            return resolveValue(replacement, settings, unresolvedFallback);
        } else {
            return "var(".concat(unresolvedFallback, ")");
        }
    }
    if (!valueData) {
        if (value.indexOf("var(") !== -1) {
            settings.onWarning('missing closing ")" in the value "'.concat(value, '"'));
        }
        return value;
    } else if (valueData.pre.slice(-3) === "var") {
        var isEmptyVarFunc = valueData.body.trim().length === 0;
        if (isEmptyVarFunc) {
            settings.onWarning("var() must contain a non-whitespace string");
            return value;
        } else {
            return valueData.pre.slice(0, -3) + resolveFunc(valueData.body) + resolveValue(valueData.post, settings);
        }
    } else {
        return valueData.pre + "(".concat(resolveValue(valueData.body, settings), ")") + resolveValue(valueData.post, settings);
    }
}

var isBrowser = typeof window !== "undefined";

var isNativeSupport = isBrowser && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");

var counters = {
    group: 0,
    job: 0
};

var defaults = {
    rootElement: isBrowser ? document : null,
    shadowDOM: false,
    include: "style,link[rel=stylesheet]",
    exclude: "",
    variables: {},
    onlyLegacy: true,
    preserveStatic: true,
    preserveVars: false,
    silent: false,
    updateDOM: true,
    updateURLs: true,
    watch: null,
    onBeforeSend: function onBeforeSend() {},
    onError: function onError() {},
    onWarning: function onWarning() {},
    onSuccess: function onSuccess() {},
    onComplete: function onComplete() {},
    onFinally: function onFinally() {}
};

var regex = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssKeyframes: /@(?:-\w*-)?keyframes/,
    cssMediaQueries: /@media[^{]+\{([\s\S]+?})\s*}/g,
    cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
    cssVarDeclRules: /(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^}]*})/g,
    cssVarDecls: /(?:[\s;]*)(-{2}\w[\w-]*)(?:\s*:\s*)([^;]*);/g,
    cssVarFunc: /var\(\s*--[\w-]/,
    cssVars: /(?:(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};

var variableStore = {
    dom: {},
    job: {},
    user: {}
};

var cssVarsIsRunning = false;

var cssVarsObserver = null;

var cssVarsSrcNodeCount = 0;

var debounceTimer = null;

var isShadowDOMReady = false;

/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.preserveStatic=true] Determines if CSS
 *                   declarations that do not reference a custom property will
 *                   be preserved in the transformed CSS
 * @param {boolean}  [options.preserveVars=false] Determines if CSS custom
 *                   property declarations will be preserved in the transformed
 *                   CSS
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if relative url()
 *                   paths will be converted to absolute urls in external CSS
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) an array of
 *                   output <style> node references that have been appended to
 *                   the DOM, 3) an object containing all custom properies names
 *                   and values, and 4) the ponyfill execution time in
 *                   milliseconds.
 * @param {function} [options.onFinally] Callback in modern and legacy browsers
 *                   after the ponyfill has finished all tasks. Passes 1) a
 *                   boolean indicating if the last ponyfill call resulted in a
 *                   style change, 2) a boolean indicating if the current
 *                   browser provides native support for CSS custom properties,
 *                   and 3) the ponyfill execution time in milliseconds.
 * @example
 *
 *   cssVars({
 *     rootElement   : document,
 *     shadowDOM     : false,
 *     include       : 'style,link[rel="stylesheet"]',
 *     exclude       : '',
 *     variables     : {},
 *     onlyLegacy    : true,
 *     preserveStatic: true,
 *     preserveVars  : false,
 *     silent        : false,
 *     updateDOM     : true,
 *     updateURLs    : true,
 *     watch         : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onError(message, node, xhr, url) {},
 *     onWarning(message) {},
 *     onSuccess(cssText, node, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {},
 *     onFinally(hasChanged, hasNativeSupport, benchmark)
 *   });
 */ function cssVars() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var msgPrefix = "cssVars(): ";
    var settings = _extends({}, defaults, options);
    function handleError(message, sourceNode, xhr, url) {
        if (!settings.silent && window.console) {
            console.error("".concat(msgPrefix).concat(message, "\n"), sourceNode);
        }
        settings.onError(message, sourceNode, xhr, url);
    }
    function handleWarning(message) {
        if (!settings.silent && window.console) {
            console.warn("".concat(msgPrefix).concat(message));
        }
        settings.onWarning(message);
    }
    function handleFinally(hasChanged) {
        settings.onFinally(Boolean(hasChanged), isNativeSupport, getTimeStamp() - settings.__benchmark);
    }
    if (!isBrowser) {
        return;
    }
    if (settings.watch) {
        settings.watch = defaults.watch;
        addMutationObserver(settings);
        cssVars(settings);
        return;
    } else if (settings.watch === false && cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    if (!settings.__benchmark) {
        if (cssVarsIsRunning === settings.rootElement) {
            cssVarsDebounced(options);
            return;
        }
        var srcNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])'));
        settings.__benchmark = getTimeStamp();
        settings.exclude = [ cssVarsObserver ? '[data-cssvars]:not([data-cssvars=""])' : '[data-cssvars="out"]', "link[disabled]:not([data-cssvars])", settings.exclude ].filter((function(selector) {
            return selector;
        })).join(",");
        settings.variables = fixVarNames(settings.variables);
        srcNodes.forEach((function(srcNode) {
            var hasStyleCache = srcNode.nodeName.toLowerCase() === "style" && srcNode.__cssVars.text;
            var hasStyleChanged = hasStyleCache && srcNode.textContent !== srcNode.__cssVars.text;
            if (hasStyleCache && hasStyleChanged) {
                srcNode.sheet && (srcNode.sheet.disabled = false);
                srcNode.setAttribute("data-cssvars", "");
            }
        }));
        if (!cssVarsObserver) {
            var outNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars="out"]'));
            outNodes.forEach((function(outNode) {
                var dataGroup = outNode.getAttribute("data-cssvars-group");
                var srcNode = dataGroup ? settings.rootElement.querySelector('[data-cssvars="src"][data-cssvars-group="'.concat(dataGroup, '"]')) : null;
                if (!srcNode) {
                    outNode.parentNode.removeChild(outNode);
                }
            }));
            if (cssVarsSrcNodeCount && srcNodes.length < cssVarsSrcNodeCount) {
                cssVarsSrcNodeCount = srcNodes.length;
                variableStore.dom = {};
            }
        }
    }
    if (document.readyState !== "loading") {
        if (isNativeSupport && settings.onlyLegacy) {
            var hasVarChange = false;
            if (settings.updateDOM) {
                var targetElm = settings.rootElement.host || (settings.rootElement === document ? document.documentElement : settings.rootElement);
                Object.keys(settings.variables).forEach((function(key) {
                    var varValue = settings.variables[key];
                    hasVarChange = hasVarChange || varValue !== getComputedStyle(targetElm).getPropertyValue(key);
                    targetElm.style.setProperty(key, varValue);
                }));
            }
            handleFinally(hasVarChange);
        } else if (!isShadowDOMReady && (settings.shadowDOM || settings.rootElement.shadowRoot || settings.rootElement.host)) {
            getCssData({
                rootElement: defaults.rootElement,
                include: defaults.include,
                exclude: settings.exclude,
                skipDisabled: false,
                onSuccess: function onSuccess(cssText, node, url) {
                    var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
                    if (isUserDisabled) {
                        return false;
                    }
                    cssText = cssText.replace(regex.cssComments, "").replace(regex.cssMediaQueries, "");
                    cssText = (cssText.match(regex.cssVarDeclRules) || []).join("");
                    return cssText || false;
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    parseVars(cssText, {
                        store: variableStore.dom,
                        onWarning: handleWarning
                    });
                    isShadowDOMReady = true;
                    cssVars(settings);
                }
            });
        } else {
            cssVarsIsRunning = settings.rootElement;
            getCssData({
                rootElement: settings.rootElement,
                include: settings.include,
                exclude: settings.exclude,
                skipDisabled: false,
                onBeforeSend: settings.onBeforeSend,
                onError: function onError(xhr, node, url) {
                    var responseUrl = xhr.responseURL || getFullUrl(url, location.href);
                    var statusText = xhr.statusText ? "(".concat(xhr.statusText, ")") : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
                    var errorMsg = "CSS XHR Error: ".concat(responseUrl, " ").concat(xhr.status, " ").concat(statusText);
                    handleError(errorMsg, node, xhr, responseUrl);
                },
                onSuccess: function onSuccess(cssText, node, url) {
                    var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
                    if (isUserDisabled) {
                        return false;
                    }
                    var isLink = node.nodeName.toLowerCase() === "link";
                    var isStyleImport = node.nodeName.toLowerCase() === "style" && cssText !== node.textContent;
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
                    if (settings.updateURLs && (isLink || isStyleImport)) {
                        cssText = fixRelativeCssUrls(cssText, url);
                    }
                    return cssText;
                },
                onComplete: function onComplete(cssText, cssArray) {
                    var nodeArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    var currentVars = _extends({}, variableStore.dom, variableStore.user);
                    var hasVarChange = false;
                    variableStore.job = {};
                    nodeArray.forEach((function(node, i) {
                        var nodeCSS = cssArray[i];
                        node.__cssVars = node.__cssVars || {};
                        node.__cssVars.text = nodeCSS;
                        if (regex.cssVars.test(nodeCSS)) {
                            try {
                                var cssTree = parseCss(nodeCSS, {
                                    preserveStatic: settings.preserveStatic,
                                    removeComments: true
                                });
                                parseVars(cssTree, {
                                    parseHost: Boolean(settings.rootElement.host),
                                    store: variableStore.dom,
                                    onWarning: handleWarning
                                });
                                node.__cssVars.tree = cssTree;
                            } catch (err) {
                                handleError(err.message, node);
                            }
                        }
                    }));
                    _extends(variableStore.job, variableStore.dom);
                    if (settings.updateDOM) {
                        _extends(variableStore.user, settings.variables);
                        _extends(variableStore.job, variableStore.user);
                    } else {
                        _extends(variableStore.job, variableStore.user, settings.variables);
                        _extends(currentVars, settings.variables);
                    }
                    hasVarChange = counters.job > 0 && Boolean(Object.keys(variableStore.job).length > Object.keys(currentVars).length || Boolean(Object.keys(currentVars).length && Object.keys(variableStore.job).some((function(key) {
                        return variableStore.job[key] !== currentVars[key];
                    }))));
                    if (hasVarChange) {
                        resetCssNodes(settings.rootElement);
                        cssVars(settings);
                    } else {
                        var outCssArray = [];
                        var outNodeArray = [];
                        var hasKeyframesWithVars = false;
                        if (settings.updateDOM) {
                            counters.job++;
                        }
                        nodeArray.forEach((function(node, i) {
                            var isSkip = !node.__cssVars.tree;
                            if (node.__cssVars.tree) {
                                try {
                                    transformCss(node.__cssVars.tree, _extends({}, settings, {
                                        variables: variableStore.job,
                                        onWarning: handleWarning
                                    }));
                                    var outCss = stringifyCss(node.__cssVars.tree);
                                    if (settings.updateDOM) {
                                        var nodeCSS = cssArray[i];
                                        var hasCSSVarFunc = regex.cssVarFunc.test(nodeCSS);
                                        if (!node.getAttribute("data-cssvars")) {
                                            node.setAttribute("data-cssvars", "src");
                                        }
                                        if (outCss.length && hasCSSVarFunc) {
                                            var dataGroup = node.getAttribute("data-cssvars-group") || ++counters.group;
                                            var outCssNoSpaces = outCss.replace(/\s/g, "");
                                            var outNode = settings.rootElement.querySelector('[data-cssvars="out"][data-cssvars-group="'.concat(dataGroup, '"]')) || document.createElement("style");
                                            hasKeyframesWithVars = hasKeyframesWithVars || regex.cssKeyframes.test(outCss);
                                            if (settings.preserveStatic) {
                                                node.sheet && (node.sheet.disabled = true);
                                            }
                                            if (!outNode.hasAttribute("data-cssvars")) {
                                                outNode.setAttribute("data-cssvars", "out");
                                            }
                                            if (outCssNoSpaces === node.textContent.replace(/\s/g, "")) {
                                                isSkip = true;
                                                if (outNode && outNode.parentNode) {
                                                    node.removeAttribute("data-cssvars-group");
                                                    outNode.parentNode.removeChild(outNode);
                                                }
                                            } else if (outCssNoSpaces !== outNode.textContent.replace(/\s/g, "")) {
                                                [ node, outNode ].forEach((function(n) {
                                                    n.setAttribute("data-cssvars-job", counters.job);
                                                    n.setAttribute("data-cssvars-group", dataGroup);
                                                }));
                                                outNode.textContent = outCss;
                                                outCssArray.push(outCss);
                                                outNodeArray.push(outNode);
                                                if (!outNode.parentNode) {
                                                    node.parentNode.insertBefore(outNode, node.nextSibling);
                                                }
                                            }
                                        }
                                    } else {
                                        if (node.textContent.replace(/\s/g, "") !== outCss) {
                                            outCssArray.push(outCss);
                                        }
                                    }
                                } catch (err) {
                                    handleError(err.message, node);
                                }
                            }
                            if (isSkip) {
                                node.setAttribute("data-cssvars", "skip");
                            }
                            if (!node.hasAttribute("data-cssvars-job")) {
                                node.setAttribute("data-cssvars-job", counters.job);
                            }
                        }));
                        cssVarsSrcNodeCount = settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])').length;
                        if (settings.shadowDOM) {
                            var elms = [].concat(settings.rootElement).concat([].slice.call(settings.rootElement.querySelectorAll("*")));
                            for (var i = 0, elm; elm = elms[i]; ++i) {
                                if (elm.shadowRoot && elm.shadowRoot.querySelector("style")) {
                                    var shadowSettings = _extends({}, settings, {
                                        rootElement: elm.shadowRoot
                                    });
                                    cssVars(shadowSettings);
                                }
                            }
                        }
                        if (settings.updateDOM && hasKeyframesWithVars) {
                            fixKeyframes(settings.rootElement);
                        }
                        cssVarsIsRunning = false;
                        settings.onComplete(outCssArray.join(""), outNodeArray, JSON.parse(JSON.stringify(variableStore.job)), getTimeStamp() - settings.__benchmark);
                        handleFinally(outNodeArray.length);
                    }
                }
            });
        }
    } else {
        document.addEventListener("DOMContentLoaded", (function init(evt) {
            cssVars(options);
            document.removeEventListener("DOMContentLoaded", init);
        }));
    }
}

cssVars.reset = function() {
    counters.job = 0;
    counters.group = 0;
    cssVarsIsRunning = false;
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    cssVarsSrcNodeCount = 0;
    debounceTimer = null;
    isShadowDOMReady = false;
    for (var prop in variableStore) {
        variableStore[prop] = {};
    }
};

function addMutationObserver(settings) {
    function isDisabled(node) {
        var isDisabledAttr = isLink(node) && node.hasAttribute("disabled");
        var isDisabledSheet = (node.sheet || {}).disabled;
        return isDisabledAttr || isDisabledSheet;
    }
    function isLink(node) {
        var isStylesheet = node.nodeName.toLowerCase() === "link" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
        return isStylesheet;
    }
    function isStyle(node) {
        return node.nodeName.toLowerCase() === "style";
    }
    function isValidAttributeMutation(mutation) {
        var isValid = false;
        if (mutation.type === "attributes" && isLink(mutation.target) && !isDisabled(mutation.target)) {
            var isEnabledMutation = mutation.attributeName === "disabled";
            var isHrefMutation = mutation.attributeName === "href";
            var isSkipNode = mutation.target.getAttribute("data-cssvars") === "skip";
            var isSrcNode = mutation.target.getAttribute("data-cssvars") === "src";
            if (isEnabledMutation) {
                isValid = !isSkipNode && !isSrcNode;
            } else if (isHrefMutation) {
                if (isSkipNode) {
                    mutation.target.setAttribute("data-cssvars", "");
                } else if (isSrcNode) {
                    resetCssNodes(settings.rootElement, true);
                }
                isValid = true;
            }
        }
        return isValid;
    }
    function isValidStyleTextMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            var isStyleElm = isStyle(mutation.target);
            var isOutNode = mutation.target.getAttribute("data-cssvars") === "out";
            isValid = isStyleElm && !isOutNode;
        }
        return isValid;
    }
    function isValidAddMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            isValid = [].slice.call(mutation.addedNodes).some((function(node) {
                var isElm = node.nodeType === 1;
                var hasAttr = isElm && node.hasAttribute("data-cssvars");
                var isStyleWithVars = isStyle(node) && regex.cssVars.test(node.textContent);
                var isValid = !hasAttr && (isLink(node) || isStyleWithVars);
                return isValid && !isDisabled(node);
            }));
        }
        return isValid;
    }
    function isValidRemoveMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            isValid = [].slice.call(mutation.removedNodes).some((function(node) {
                var isElm = node.nodeType === 1;
                var isOutNode = isElm && node.getAttribute("data-cssvars") === "out";
                var isSrcNode = isElm && node.getAttribute("data-cssvars") === "src";
                var isValid = isSrcNode;
                if (isSrcNode || isOutNode) {
                    var dataGroup = node.getAttribute("data-cssvars-group");
                    var orphanNode = settings.rootElement.querySelector('[data-cssvars-group="'.concat(dataGroup, '"]'));
                    if (isSrcNode) {
                        resetCssNodes(settings.rootElement, true);
                    }
                    if (orphanNode) {
                        orphanNode.parentNode.removeChild(orphanNode);
                    }
                }
                return isValid;
            }));
        }
        return isValid;
    }
    if (!window.MutationObserver) {
        return;
    }
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    cssVarsObserver = new MutationObserver((function(mutations) {
        var hasValidMutation = mutations.some((function(mutation) {
            return isValidAttributeMutation(mutation) || isValidStyleTextMutation(mutation) || isValidAddMutation(mutation) || isValidRemoveMutation(mutation);
        }));
        if (hasValidMutation) {
            cssVars(settings);
        }
    }));
    cssVarsObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [ "disabled", "href" ],
        childList: true,
        subtree: true
    });
}

function cssVarsDebounced(settings) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout((function() {
        settings.__benchmark = null;
        cssVars(settings);
    }), delay);
}

function fixKeyframes(rootElement) {
    var animationNameProp = [ "animation-name", "-moz-animation-name", "-webkit-animation-name" ].filter((function(prop) {
        return getComputedStyle(document.body)[prop];
    }))[0];
    if (animationNameProp) {
        var allNodes = [].slice.call(rootElement.querySelectorAll("*"));
        var keyframeNodes = [];
        var nameMarker = "__CSSVARSPONYFILL-KEYFRAMES__";
        for (var i = 0, len = allNodes.length; i < len; i++) {
            var node = allNodes[i];
            var animationName = getComputedStyle(node)[animationNameProp];
            if (animationName !== "none") {
                node.style[animationNameProp] += nameMarker;
                keyframeNodes.push(node);
            }
        }
        void document.body.offsetHeight;
        for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
            var nodeStyle = keyframeNodes[_i].style;
            nodeStyle[animationNameProp] = nodeStyle[animationNameProp].replace(nameMarker, "");
        }
    }
}

function fixRelativeCssUrls(cssText, baseUrl) {
    var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
    cssUrls.forEach((function(cssUrl) {
        var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
        var newUrl = getFullUrl(oldUrl, baseUrl);
        cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
    }));
    return cssText;
}

function fixVarNames() {
    var varObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reLeadingHyphens = /^-{2}/;
    return Object.keys(varObj).reduce((function(obj, value) {
        var key = reLeadingHyphens.test(value) ? value : "--".concat(value.replace(/^-+/, ""));
        obj[key] = varObj[value];
        return obj;
    }), {});
}

function getFullUrl(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function getTimeStamp() {
    return isBrowser && (window.performance || {}).now ? window.performance.now() : (new Date).getTime();
}

function resetCssNodes(rootElement) {
    var resetDOMVariableStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var resetNodes = [].slice.call(rootElement.querySelectorAll('[data-cssvars="skip"],[data-cssvars="src"]'));
    resetNodes.forEach((function(node) {
        return node.setAttribute("data-cssvars", "");
    }));
    if (resetDOMVariableStore) {
        variableStore.dom = {};
    }
}


//# sourceMappingURL=css-vars-ponyfill.esm.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D_-9RmNe.js
var bundle_D_9RmNe = __webpack_require__(6623);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DaJasFqz.js
var bundle_DaJasFqz_USER_ACTIONS = {
    INIT_USER: 'INIT_USER',
    RESET_USER: 'RESET_USER',
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
};


//# sourceMappingURL=bundle-DaJasFqz.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e1a5e3f1.js
var _bundle_e1a5e3f1 = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bq93DTET.js
var bundle_Bq93DTET = __webpack_require__(88071);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DNUUqUmN.js





function bundle_DNUUqUmN_useOnlineStatus(sdk, logger) {
    var _a, _b;
    var _c = (0,react.useState)(
    // window is undefined in SSR env
    typeof window !== 'undefined'
        ? ((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.onLine) !== null && _b !== void 0 ? _b : true)
        : true), isOnline = _c[0], setIsOnline = _c[1];
    (0,react.useEffect)(function () {
        var uniqueHandlerId = (0,bundle_Bq93DTET.u)();
        try {
            logger.warning('sdk changed', uniqueHandlerId);
            var handler = new _bundle_e1a5e3f1.C({
                onDisconnected: function () {
                    setIsOnline(false);
                    logger.warning('onDisconnected', { isOnline: isOnline });
                },
                onReconnectStarted: function () {
                    setIsOnline(false);
                    logger.warning('onReconnectStarted', { isOnline: isOnline });
                },
                onReconnectSucceeded: function () {
                    setIsOnline(true);
                    logger.warning('onReconnectSucceeded', { isOnline: isOnline });
                },
                onReconnectFailed: function () {
                    sdk.reconnect();
                    logger.warning('onReconnectFailed');
                },
            });
            if (sdk === null || sdk === void 0 ? void 0 : sdk.addConnectionHandler) {
                // workaround -> addConnectionHandler invalidates session handler
                // provided through configureSession
                sdk.addConnectionHandler(uniqueHandlerId, handler);
                logger.info('Added ConnectionHandler', uniqueHandlerId);
            }
        }
        catch (_a) {
            //
        }
        return function () {
            try {
                sdk.removeConnectionHandler(uniqueHandlerId);
                logger.info('Removed ConnectionHandler', uniqueHandlerId);
            }
            catch (_a) {
                //
            }
        };
    }, [sdk]);
    (0,react.useEffect)(function () {
        var tryReconnect = function () {
            try {
                logger.warning('Try reconnecting SDK');
                if (sdk.connectionState !== 'OPEN') { // connection is not broken yet
                    sdk.reconnect();
                }
            }
            catch (_a) {
                //
            }
        };
        // addEventListener version
        window.addEventListener('online', tryReconnect);
        return function () {
            window.removeEventListener('online', tryReconnect);
        };
    }, [sdk]);
    // add offline-class to body
    (0,react.useEffect)(function () {
        var body = document.querySelector('body');
        if (!isOnline && !(sdk === null || sdk === void 0 ? void 0 : sdk.isCacheEnabled)) {
            try {
                body === null || body === void 0 ? void 0 : body.classList.add('sendbird__offline');
                logger.info('Added class sendbird__offline to body');
            }
            catch (e) {
                //
            }
        }
        else {
            try {
                body === null || body === void 0 ? void 0 : body.classList.remove('sendbird__offline');
                logger.info('Removed class sendbird__offline from body');
            }
            catch (e) {
                //
            }
        }
    }, [isOnline, sdk === null || sdk === void 0 ? void 0 : sdk.isCacheEnabled]);
    return isOnline;
}

var TIMEOUT = 2000;
/*
  * This is a factory function that returns a scheduler.
  * The scheduler is a queue that calls the callback function on intervals.
  * If interval is empty, the callback function is called immediately.
  * If interval is not empty, the callback function is called after the interval.
*/
function schedulerFactory(_a) {
    var logger = _a.logger, timeout = _a.timeout, cb = _a.cb;
    var queue = [];
    var interval = null;
    var push = function (channel) {
        var channelPresent = queue.find(function (c) { return c.url === channel.url; });
        if (!channelPresent) {
            queue.push(channel);
        }
        else {
            logger.info('Channel: Mark as read already in queue', { channel: channel });
        }
        // start the interval if it's not already running
        if (interval) {
            return;
        }
        var item = queue.shift();
        if (item) {
            cb(item);
        }
        interval = setInterval(function () {
            if (queue.length === 0 && interval) {
                clearInterval(interval);
                interval = null;
                return;
            }
            var item = queue.shift();
            if (item) {
                cb(item);
            }
        }, (timeout || TIMEOUT));
    };
    var clear = function () {
        queue = [];
        if (interval) {
            clearInterval(interval);
            interval = null;
        }
    };
    return {
        push: push,
        clear: clear,
        getQueue: function () { return queue; },
    };
}

// this hook accepts a callback to run component is unmounted
function useUnmount(callback, deps) {
    if (deps === void 0) { deps = []; }
    (0,react.useLayoutEffect)(function () {
        return function () {
            callback();
        };
    }, deps);
}

function bundle_DNUUqUmN_useMarkAsDeliveredScheduler(_a, _b) {
    var _this = this;
    var isConnected = _a.isConnected;
    var logger = _b.logger;
    var markAsDeliveredScheduler = (0,react.useMemo)(function () { return schedulerFactory({
        logger: logger,
        cb: function (channel) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
            var error_1;
            return (0,bundle_XQWyv823.b)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, channel.markAsDelivered()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.warning('Channel: Mark as delivered failed', { channel: channel, error: error_1 });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    }); }, []);
    (0,react.useEffect)(function () {
        // for simplicity, we clear the queue when the connection is lost
        if (!isConnected) {
            markAsDeliveredScheduler.clear();
        }
    }, [isConnected]);
    useUnmount(function () { markAsDeliveredScheduler.clear(); });
    return markAsDeliveredScheduler;
}


//# sourceMappingURL=bundle-DNUUqUmN.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-1db3fd0b.js
var _bundle_1db3fd0b = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/index.js + 2 modules
var chat = __webpack_require__(51947);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/openChannel.js
var openChannel = __webpack_require__(35065);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/groupChannel.js
var groupChannel = __webpack_require__(42391);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BHC96gO0.js
var bundle_BHC96gO0 = __webpack_require__(80360);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-B5OWYHQO.js
var bundle_B5OWYHQO = __webpack_require__(50152);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BMJP8SSM.js
var bundle_BMJP8SSM = __webpack_require__(90832);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle--PhH_XFy.js
var bundle_PhH_XFy = __webpack_require__(59587);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-R3uJ_0BB.js
var bundle_R3uJ_0BB = __webpack_require__(26765);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BPcbf_pM.js
var bundle_BPcbf_pM = __webpack_require__(61448);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DABR6HKW.js
var bundle_DABR6HKW = __webpack_require__(69466);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BOn8npYv.js
var bundle_BOn8npYv = __webpack_require__(3153);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ml-PByBw.js
var bundle_ml_PByBw = __webpack_require__(16167);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BbVJcZ9w.js
var bundle_BbVJcZ9w = __webpack_require__(13160);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/useSendbirdStateContext.js
var uikit_react_useSendbirdStateContext = __webpack_require__(41238);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/IconButton.js
var ui_IconButton = __webpack_require__(29515);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Button.js
var ui_Button = __webpack_require__(88569);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ixnsp7Bg.js
var bundle_ixnsp7Bg = __webpack_require__(99366);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Icon.js
var ui_Icon = __webpack_require__(43822);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/utils/message/getOutgoingMessageState.js
var getOutgoingMessageState = __webpack_require__(8978);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/SortByRow.js
var SortByRow = __webpack_require__(78614);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/SendbirdProvider.js


































var DEFAULT_COLOR_SET = {
    '--sendbird-dark-primary-500': '#4d2aa6',
    '--sendbird-dark-primary-400': '#6440C4',
    '--sendbird-dark-primary-300': '#7B53EF',
    '--sendbird-dark-primary-200': '#9E8CF5',
    '--sendbird-dark-primary-100': '#E2DFFF',
    '--sendbird-dark-secondary-500': '#007A7A',
    '--sendbird-dark-secondary-400': '#189A8D',
    '--sendbird-dark-secondary-300': '#2EBA9F',
    '--sendbird-dark-secondary-200': '#6FD6BE',
    '--sendbird-dark-secondary-100': '#AEF2DC',
    '--sendbird-dark-information-100': '#b2d9ff',
    '--sendbird-dark-error-500': '#A30E2D',
    '--sendbird-dark-error-400': '#C11F41',
    '--sendbird-dark-error-300': '#E53157',
    '--sendbird-dark-error-200': '#FF6183',
    '--sendbird-dark-error-100': '#FFABBD',
    '--sendbird-dark-background-700': '#000000',
    '--sendbird-dark-background-600': '#161616',
    '--sendbird-dark-background-500': '#2C2C2C',
    '--sendbird-dark-background-400': '#393939',
    '--sendbird-dark-background-300': '#A8A8A8',
    '--sendbird-dark-background-200': '#D9D9D9',
    '--sendbird-dark-background-100': '#F0F0F0',
    '--sendbird-dark-background-50': '#FFFFFF',
    '--sendbird-dark-overlay': 'rgba(0, 0, 0, 0.32)',
    '--sendbird-dark-onlight-01': 'rgba(0, 0, 0, 0.88)',
    '--sendbird-dark-onlight-02': 'rgba(0, 0, 0, 0.50)',
    '--sendbird-dark-onlight-03': 'rgba(0, 0, 0, 0.38)',
    '--sendbird-dark-onlight-04': 'rgba(0, 0, 0, 0.12)',
    '--sendbird-dark-ondark-01': 'rgba(255, 255, 255, 0.88)',
    '--sendbird-dark-ondark-02': 'rgba(255, 255, 255, 0.50)',
    '--sendbird-dark-ondark-03': 'rgba(255, 255, 255, 0.38)',
    '--sendbird-dark-ondark-04': 'rgba(255, 255, 255, 0.12)',
    '--sendbird-dark-shadow-01': '0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)',
    '--sendbird-dark-shadow-02': '0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)',
    '--sendbird-dark-shadow-03': '0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)',
    '--sendbird-dark-shadow-04': '0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)',
    '--sendbird-dark-shadow-message-input': '0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
    '--sendbird-light-primary-500': '#4d2aa6',
    '--sendbird-light-primary-400': '#6440C4',
    '--sendbird-light-primary-300': '#7B53EF',
    '--sendbird-light-primary-200': '#9E8CF5',
    '--sendbird-light-primary-100': '#E2DFFF',
    '--sendbird-light-secondary-500': '#007A7A',
    '--sendbird-light-secondary-400': '#189A8D',
    '--sendbird-light-secondary-300': '#2EBA9F',
    '--sendbird-light-secondary-200': '#6FD6BE',
    '--sendbird-light-secondary-100': '#AEF2DC',
    '--sendbird-light-information-100': '#b2d9ff',
    '--sendbird-light-error-500': '#A30E2D',
    '--sendbird-light-error-400': '#C11F41',
    '--sendbird-light-error-300': '#E53157',
    '--sendbird-light-error-200': '#FF6183',
    '--sendbird-light-error-100': '#FFABBD',
    '--sendbird-light-background-700': '#000000',
    '--sendbird-light-background-600': '#161616',
    '--sendbird-light-background-500': '#2C2C2C',
    '--sendbird-light-background-400': '#393939',
    '--sendbird-light-background-300': '#A8A8A8',
    '--sendbird-light-background-200': '#D9D9D9',
    '--sendbird-light-background-100': '#F0F0F0',
    '--sendbird-light-background-50': ' #FFFFFF',
    '--sendbird-light-overlay': 'rgba(0, 0, 0, 0.32)',
    '--sendbird-light-onlight-01': 'rgba(0, 0, 0, 0.88)',
    '--sendbird-light-onlight-02': 'rgba(0, 0, 0, 0.50)',
    '--sendbird-light-onlight-03': 'rgba(0, 0, 0, 0.38)',
    '--sendbird-light-onlight-04': 'rgba(0, 0, 0, 0.12)',
    '--sendbird-light-ondark-01': 'rgba(255, 255, 255, 0.88)',
    '--sendbird-light-ondark-02': 'rgba(255, 255, 255, 0.50)',
    '--sendbird-light-ondark-03': 'rgba(255, 255, 255, 0.38)',
    '--sendbird-light-ondark-04': 'rgba(255, 255, 255, 0.12)',
    '--sendbird-light-shadow-01': '0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)',
    '--sendbird-light-shadow-02': '0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)',
    '--sendbird-light-shadow-03': '0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)',
    '--sendbird-light-shadow-04': '0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)',
    '--sendbird-light-shadow-message-input': '0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
};
var isEmpty = function (obj) {
    if (obj === null || obj === undefined) {
        return true;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
};
var useTheme = function (overrides) {
    (0,react.useLayoutEffect)(function () {
        if (!isEmpty(overrides)) {
            var variables = (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, DEFAULT_COLOR_SET), (0,bundle_NL8iE1lF.m)(overrides));
            cssVars({ variables: variables });
        }
    }, [overrides]);
};

var SDK_ACTIONS = {
    INIT_SDK: 'INIT_SDK',
    SET_SDK_LOADING: 'SET_SDK_LOADING',
    RESET_SDK: 'RESET_SDK',
    SDK_ERROR: 'SDK_ERROR',
};

var initialState$2 = {
    initialized: false,
    loading: false,
    sdk: {},
    error: false,
};

function reducer$2(state, action) {
    return (0,bundle_D_9RmNe.K)(action)
        .with({ type: SDK_ACTIONS.SET_SDK_LOADING }, function (_a) {
        var payload = _a.payload;
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { initialized: false, loading: payload });
    })
        .with({ type: SDK_ACTIONS.SDK_ERROR }, function () {
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { initialized: false, loading: false, error: true });
    })
        .with({ type: SDK_ACTIONS.INIT_SDK }, function (_a) {
        var payload = _a.payload;
        return {
            sdk: payload,
            initialized: true,
            loading: false,
            error: false,
        };
    })
        .with({ type: SDK_ACTIONS.RESET_SDK }, function () {
        return initialState$2;
    })
        .otherwise(function () {
        return state;
    });
}

var initialState$1 = {
    initialized: false,
    loading: false,
    user: {},
};

function reducer$1(state, action) {
    return (0,bundle_D_9RmNe.K)(action)
        .with({ type: bundle_DaJasFqz_USER_ACTIONS.INIT_USER }, function (_a) {
        var payload = _a.payload;
        return {
            initialized: true,
            loading: false,
            user: payload,
        };
    })
        .with({ type: bundle_DaJasFqz_USER_ACTIONS.RESET_USER }, function () {
        return initialState$1;
    })
        .with({ type: bundle_DaJasFqz_USER_ACTIONS.UPDATE_USER_INFO }, function (_a) {
        var payload = _a.payload;
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { user: payload });
    })
        .otherwise(function () {
        return state;
    });
}

var APP_INFO_ACTIONS = {
    INITIALIZE_MESSAGE_TEMPLATES_INFO: 'INITIALIZE_MESSAGE_TEMPLATES_INFO',
    UPSERT_MESSAGE_TEMPLATES: 'UPSERT_MESSAGE_TEMPLATES',
    UPSERT_WAITING_TEMPLATE_KEYS: 'UPSERT_WAITING_TEMPLATE_KEYS',
    MARK_ERROR_WAITING_TEMPLATE_KEYS: 'MARK_ERROR_WAITING_TEMPLATE_KEYS',
};

function reducer(state, action) {
    return (0,bundle_D_9RmNe.K)(action)
        .with({ type: APP_INFO_ACTIONS.INITIALIZE_MESSAGE_TEMPLATES_INFO }, function (_a) {
        var payload = _a.payload;
        return {
            messageTemplatesInfo: payload,
            waitingTemplateKeysMap: {},
        };
    })
        .with({ type: APP_INFO_ACTIONS.UPSERT_MESSAGE_TEMPLATES }, function (_a) {
        var payload = _a.payload;
        var templatesInfo = state.messageTemplatesInfo;
        if (!templatesInfo)
            return state; // Not initialized. Ignore.
        var waitingTemplateKeysMap = (0,bundle_XQWyv823._)({}, state.waitingTemplateKeysMap);
        payload.forEach(function (templatesMapData) {
            var key = templatesMapData.key, template = templatesMapData.template;
            templatesInfo.templatesMap[key] = template;
            delete waitingTemplateKeysMap[key];
        });
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { waitingTemplateKeysMap: waitingTemplateKeysMap, messageTemplatesInfo: templatesInfo });
    })
        .with({ type: APP_INFO_ACTIONS.UPSERT_WAITING_TEMPLATE_KEYS }, function (_a) {
        var payload = _a.payload;
        var keys = payload.keys, requestedAt = payload.requestedAt;
        var waitingTemplateKeysMap = (0,bundle_XQWyv823._)({}, state.waitingTemplateKeysMap);
        keys.forEach(function (key) {
            var _a, _b;
            waitingTemplateKeysMap[key] = {
                erroredMessageIds: (_b = (_a = waitingTemplateKeysMap[key]) === null || _a === void 0 ? void 0 : _a.erroredMessageIds) !== null && _b !== void 0 ? _b : [],
                requestedAt: requestedAt,
            };
        });
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { waitingTemplateKeysMap: waitingTemplateKeysMap });
    })
        .with({ type: APP_INFO_ACTIONS.MARK_ERROR_WAITING_TEMPLATE_KEYS }, function (_a) {
        var payload = _a.payload;
        var keys = payload.keys, messageId = payload.messageId;
        var waitingTemplateKeysMap = (0,bundle_XQWyv823._)({}, state.waitingTemplateKeysMap);
        keys.forEach(function (key) {
            var waitingTemplateKeyData = waitingTemplateKeysMap[key];
            if (waitingTemplateKeyData && waitingTemplateKeyData.erroredMessageIds.indexOf(messageId) === -1) {
                waitingTemplateKeyData.erroredMessageIds.push(messageId);
            }
        });
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, state), { waitingTemplateKeysMap: waitingTemplateKeysMap });
    })
        .otherwise(function () {
        return state;
    });
}

var initialState = {
    waitingTemplateKeysMap: {},
};

function disconnectSdk(_a) {
    return (0,bundle_XQWyv823.a)(this, arguments, void 0, function (_b) {
        var sdkDispatcher = _b.sdkDispatcher, userDispatcher = _b.userDispatcher, sdk = _b.sdk;
        return (0,bundle_XQWyv823.b)(this, function (_c) {
            return [2 /*return*/, new Promise(function (resolve) {
                    sdkDispatcher({ type: SDK_ACTIONS.SET_SDK_LOADING, payload: true });
                    if (sdk === null || sdk === void 0 ? void 0 : sdk.disconnectWebSocket) {
                        sdk.disconnectWebSocket()
                            .then(function () {
                            sdkDispatcher({ type: SDK_ACTIONS.RESET_SDK });
                            userDispatcher({ type: bundle_DaJasFqz_USER_ACTIONS.RESET_USER });
                        })
                            .finally(function () {
                            resolve(true);
                        });
                    }
                    else {
                        resolve(true);
                    }
                })];
        });
    });
}

var APP_VERSION_STRING = '3.15.5';
var INIT_SDK = SDK_ACTIONS.INIT_SDK, SET_SDK_LOADING = SDK_ACTIONS.SET_SDK_LOADING, RESET_SDK = SDK_ACTIONS.RESET_SDK, SDK_ERROR = SDK_ACTIONS.SDK_ERROR;
var INIT_USER = bundle_DaJasFqz_USER_ACTIONS.INIT_USER, UPDATE_USER_INFO = bundle_DaJasFqz_USER_ACTIONS.UPDATE_USER_INFO, RESET_USER = bundle_DaJasFqz_USER_ACTIONS.RESET_USER;
function getMissingParamError(_a) {
    var userId = _a.userId, appId = _a.appId;
    return "SendbirdProvider | useConnect/setupConnection/Connection failed UserId: ".concat(userId, " or appId: ").concat(appId, " missing");
}
function getConnectSbError(error) {
    return "SendbirdProvider | useConnect/setupConnection/Connection failed. ".concat((error === null || error === void 0 ? void 0 : error.code) || '', " ").concat((error === null || error === void 0 ? void 0 : error.message) || '');
}
function setUpConnection(_a) {
    return (0,bundle_XQWyv823.a)(this, arguments, void 0, function (_b) {
        var errorMessage;
        var _this = this;
        var _c, _d;
        var logger = _b.logger, sdkDispatcher = _b.sdkDispatcher, userDispatcher = _b.userDispatcher, initDashboardConfigs = _b.initDashboardConfigs, userId = _b.userId, appId = _b.appId, isNewApp = _b.isNewApp, customApiHost = _b.customApiHost, customWebSocketHost = _b.customWebSocketHost, configureSession = _b.configureSession, nickname = _b.nickname, profileUrl = _b.profileUrl, accessToken = _b.accessToken, isUserIdUsedForNickname = _b.isUserIdUsedForNickname, sdkInitParams = _b.sdkInitParams, customExtensionParams = _b.customExtensionParams, _e = _b.isMobile, isMobile = _e === void 0 ? false : _e, eventHandlers = _b.eventHandlers, initializeMessageTemplatesInfo = _b.initializeMessageTemplatesInfo;
        return (0,bundle_XQWyv823.b)(this, function (_f) {
            (_c = logger.info) === null || _c === void 0 ? void 0 : _c.call(logger, 'SendbirdProvider | useConnect/setupConnection/init', { userId: userId, appId: appId });
            sdkDispatcher({ type: SET_SDK_LOADING, payload: true });
            if (!userId || !appId) {
                errorMessage = getMissingParamError({ userId: userId, appId: appId });
                (_d = logger.error) === null || _d === void 0 ? void 0 : _d.call(logger, errorMessage);
                sdkDispatcher({ type: SDK_ERROR });
                return [2 /*return*/, Promise.reject(errorMessage)];
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var _a;
                    (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, "SendbirdProvider | useConnect/setupConnection/connect connecting using ".concat(accessToken !== null && accessToken !== void 0 ? accessToken : userId));
                    var sdk = initSDK({ appId: appId, customApiHost: customApiHost, customWebSocketHost: customWebSocketHost, isNewApp: isNewApp, sdkInitParams: sdkInitParams });
                    var sessionHandler = typeof configureSession === 'function' ? configureSession(sdk) : undefined;
                    setupSDK(sdk, { logger: logger, sessionHandler: sessionHandler, customExtensionParams: customExtensionParams, isMobile: isMobile });
                    sdk
                        .connect(userId, accessToken)
                        .then(function (user) { return onConnected(user); })
                        .catch(function (error) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
                        var sessionToken, user, error_1;
                        var _a;
                        return (0,bundle_XQWyv823.b)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(shouldRetryWithValidSessionToken(error) && sessionHandler)) return [3 /*break*/, 6];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 5, , 6]);
                                    return [4 /*yield*/, new Promise(sessionHandler.onSessionTokenRequired)];
                                case 2:
                                    sessionToken = _b.sent();
                                    if (!sessionToken) return [3 /*break*/, 4];
                                    (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, "SendbirdProvider | useConnect/setupConnection/connect retry connect with valid session token: ".concat(sessionToken.slice(0, 10) + '...'));
                                    return [4 /*yield*/, sdk.connect(userId, sessionToken)];
                                case 3:
                                    user = _b.sent();
                                    return [2 /*return*/, onConnected(user)];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    error_1 = _b.sent();
                                    // NOTE: Filter out the error from `onSessionTokenRequired`.
                                    if (error_1 instanceof _bundle_1db3fd0b.s) {
                                        // connect in offline mode
                                        // if (sdk.isCacheEnabled && sdk.currentUser) return onConnected(sdk.currentUser);
                                        return [2 /*return*/, onConnectFailed(error_1)];
                                    }
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/, onConnectFailed(error)];
                            }
                        });
                    }); });
                    var onConnected = function (user) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
                        var error_2, error_3, updateParams, updatedUser;
                        var _b, _c, _d, _e, _f, _g, _h, _j;
                        return (0,bundle_XQWyv823.b)(this, function (_k) {
                            switch (_k.label) {
                                case 0:
                                    (_b = logger.info) === null || _b === void 0 ? void 0 : _b.call(logger, 'SendbirdProvider | useConnect/setupConnection/onConnected', user);
                                    sdkDispatcher({ type: INIT_SDK, payload: sdk });
                                    userDispatcher({ type: INIT_USER, payload: user });
                                    _k.label = 1;
                                case 1:
                                    _k.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, initializeMessageTemplatesInfo(sdk)];
                                case 2:
                                    _k.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _k.sent();
                                    (_c = logger.error) === null || _c === void 0 ? void 0 : _c.call(logger, 'SendbirdProvider | useConnect/setupConnection/upsertMessageTemplateListInLocalStorage failed', { error: error_2 });
                                    return [3 /*break*/, 4];
                                case 4:
                                    _k.trys.push([4, 6, , 7]);
                                    return [4 /*yield*/, initDashboardConfigs(sdk)];
                                case 5:
                                    _k.sent();
                                    (_d = logger.info) === null || _d === void 0 ? void 0 : _d.call(logger, 'SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration success');
                                    return [3 /*break*/, 7];
                                case 6:
                                    error_3 = _k.sent();
                                    (_e = logger.error) === null || _e === void 0 ? void 0 : _e.call(logger, 'SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration failed', { error: error_3 });
                                    return [3 /*break*/, 7];
                                case 7:
                                    _k.trys.push([7, 10, , 11]);
                                    if (!((nickname !== user.nickname || profileUrl !== user.profileUrl) && !((0,bundle_D_9RmNe.a3)(nickname) && (0,bundle_D_9RmNe.a3)(profileUrl)))) return [3 /*break*/, 9];
                                    (_f = logger.info) === null || _f === void 0 ? void 0 : _f.call(logger, 'SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo', { nickname: nickname, profileUrl: profileUrl });
                                    updateParams = {
                                        nickname: nickname || user.nickname || (isUserIdUsedForNickname ? user.userId : ''),
                                        profileUrl: profileUrl || user.profileUrl,
                                    };
                                    return [4 /*yield*/, sdk.updateCurrentUserInfo(updateParams)];
                                case 8:
                                    updatedUser = _k.sent();
                                    (_g = logger.info) === null || _g === void 0 ? void 0 : _g.call(logger, 'SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo success', updateParams);
                                    userDispatcher({ type: UPDATE_USER_INFO, payload: updatedUser });
                                    _k.label = 9;
                                case 9: return [3 /*break*/, 11];
                                case 10:
                                    _k.sent();
                                    return [3 /*break*/, 11];
                                case 11:
                                    resolve();
                                    (_j = (_h = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.connection) === null || _h === void 0 ? void 0 : _h.onConnected) === null || _j === void 0 ? void 0 : _j.call(_h, user);
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    var onConnectFailed = function (e) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
                        var errorMessage;
                        var _a, _b, _c, _d;
                        return (0,bundle_XQWyv823.b)(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    if (!(sdk.isCacheEnabled && shouldClearCache(e))) return [3 /*break*/, 2];
                                    (_a = logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, "SendbirdProvider | useConnect/setupConnection/connect clear cache [".concat(e.code, "/").concat(e.message, "]"));
                                    return [4 /*yield*/, sdk.clearCachedData()];
                                case 1:
                                    _e.sent();
                                    _e.label = 2;
                                case 2:
                                    errorMessage = getConnectSbError(e);
                                    (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, errorMessage, { e: e, appId: appId, userId: userId });
                                    userDispatcher({ type: RESET_USER });
                                    sdkDispatcher({ type: RESET_SDK });
                                    sdkDispatcher({ type: SDK_ERROR });
                                    reject(errorMessage);
                                    (_d = (_c = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.connection) === null || _c === void 0 ? void 0 : _c.onFailed) === null || _d === void 0 ? void 0 : _d.call(_c, e);
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                })];
        });
    });
}
/**
 * Initializes the Sendbird SDK with the provided parameters.
 * */
function initSDK(_a) {
    var appId = _a.appId, _b = _a.isNewApp, isNewApp = _b === void 0 ? false : _b, customApiHost = _a.customApiHost, customWebSocketHost = _a.customWebSocketHost, _c = _a.sdkInitParams, sdkInitParams = _c === void 0 ? {} : _c;
    var params = Object.assign(sdkInitParams, {
        appId: appId,
        modules: [new groupChannel/* GroupChannelModule */.rY(), new openChannel/* OpenChannelModule */.p$()],
        newInstance: isNewApp,
        localCacheEnabled: true,
    });
    if (customApiHost)
        params.customApiHost = customApiHost;
    if (customWebSocketHost)
        params.customWebSocketHost = customWebSocketHost;
    return chat/* default.init */.ZP.init(params);
}
/**
 * Sets up the Sendbird SDK after initialization.
 * Configures necessary settings, adds extensions, sets the platform, and configures the session handler if provided.
 */
function setupSDK(sdk, params) {
    var _a, _b;
    var logger = params.logger, sessionHandler = params.sessionHandler, isMobile = params.isMobile, customExtensionParams = params.customExtensionParams;
    (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'SendbirdProvider | useConnect/setupConnection/setVersion', { version: APP_VERSION_STRING });
    sdk.addExtension('sb_uikit', APP_VERSION_STRING);
    sdk.addSendbirdExtensions([{ product: _bundle_1db3fd0b.ac.UIKIT_CHAT, version: APP_VERSION_STRING, platform: _bundle_1db3fd0b.ad === null || _bundle_1db3fd0b.ad === void 0 ? void 0 : _bundle_1db3fd0b.ad.JS }], { platform: isMobile ? _bundle_1db3fd0b.Y.MOBILE_WEB : _bundle_1db3fd0b.Y.WEB }, customExtensionParams);
    if (sessionHandler) {
        (_b = logger.info) === null || _b === void 0 ? void 0 : _b.call(logger, 'SendbirdProvider | useConnect/setupConnection/configureSession', sessionHandler);
        sdk.setSessionHandler(sessionHandler);
    }
}
function shouldClearCache(error) {
    if (!(error instanceof _bundle_1db3fd0b.s))
        return false;
    return [
        _bundle_1db3fd0b.a8.USER_AUTH_DEACTIVATED,
        _bundle_1db3fd0b.a8.USER_AUTH_DELETED_OR_NOT_FOUND,
        _bundle_1db3fd0b.a8.SESSION_TOKEN_EXPIRED,
        _bundle_1db3fd0b.a8.SESSION_REVOKED,
    ].includes(error.code);
}
function shouldRetryWithValidSessionToken(error) {
    if (!(error instanceof _bundle_1db3fd0b.s))
        return false;
    return [
        _bundle_1db3fd0b.a8.SESSION_TOKEN_EXPIRED,
        /**
         * Note: INVALID_TOKEN has been added arbitrarily due to legacy constraints
         *
         * In the useEffect of the useConnect hook, authentication is being performed
         * but changes of the `accessToken` is not being detected.
         * `disconnectSdk` is called when connect is called redundantly for the same user ID, causing issues, so `accessToken` has been excluded form the deps.
         *
         * In case the `accessToken` is missed, an additional attempt to connect is made
         * */
        _bundle_1db3fd0b.a8.INVALID_TOKEN,
    ].includes(error.code);
}

function connect(_a) {
    return (0,bundle_XQWyv823.a)(this, arguments, void 0, function (_b) {
        var logger = _b.logger, sdkDispatcher = _b.sdkDispatcher, userDispatcher = _b.userDispatcher, appInfoDispatcher = _b.appInfoDispatcher, initDashboardConfigs = _b.initDashboardConfigs, userId = _b.userId, appId = _b.appId, _c = _b.isNewApp, isNewApp = _c === void 0 ? false : _c, customApiHost = _b.customApiHost, customWebSocketHost = _b.customWebSocketHost, configureSession = _b.configureSession, nickname = _b.nickname, profileUrl = _b.profileUrl, accessToken = _b.accessToken, sdk = _b.sdk, sdkInitParams = _b.sdkInitParams, customExtensionParams = _b.customExtensionParams, isMobile = _b.isMobile, eventHandlers = _b.eventHandlers, isUserIdUsedForNickname = _b.isUserIdUsedForNickname, initializeMessageTemplatesInfo = _b.initializeMessageTemplatesInfo;
        return (0,bundle_XQWyv823.b)(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, disconnectSdk({
                        logger: logger,
                        sdkDispatcher: sdkDispatcher,
                        userDispatcher: userDispatcher,
                        sdk: sdk,
                    })];
                case 1:
                    _d.sent();
                    return [4 /*yield*/, setUpConnection({
                            logger: logger,
                            sdkDispatcher: sdkDispatcher,
                            userDispatcher: userDispatcher,
                            appInfoDispatcher: appInfoDispatcher,
                            initDashboardConfigs: initDashboardConfigs,
                            userId: userId,
                            appId: appId,
                            isNewApp: isNewApp,
                            customApiHost: customApiHost,
                            customWebSocketHost: customWebSocketHost,
                            configureSession: configureSession,
                            nickname: nickname,
                            profileUrl: profileUrl,
                            accessToken: accessToken,
                            sdkInitParams: sdkInitParams,
                            customExtensionParams: customExtensionParams,
                            isMobile: isMobile,
                            eventHandlers: eventHandlers,
                            isUserIdUsedForNickname: isUserIdUsedForNickname,
                            initializeMessageTemplatesInfo: initializeMessageTemplatesInfo,
                        })];
                case 2:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    });
}

function useConnect(triggerTypes, staticTypes) {
    var _this = this;
    var userId = triggerTypes.userId, appId = triggerTypes.appId, accessToken = triggerTypes.accessToken, isMobile = triggerTypes.isMobile, isUserIdUsedForNickname = triggerTypes.isUserIdUsedForNickname;
    var logger = staticTypes.logger, nickname = staticTypes.nickname, profileUrl = staticTypes.profileUrl, configureSession = staticTypes.configureSession, customApiHost = staticTypes.customApiHost, customWebSocketHost = staticTypes.customWebSocketHost, sdk = staticTypes.sdk, sdkDispatcher = staticTypes.sdkDispatcher, userDispatcher = staticTypes.userDispatcher, appInfoDispatcher = staticTypes.appInfoDispatcher, initDashboardConfigs = staticTypes.initDashboardConfigs, sdkInitParams = staticTypes.sdkInitParams, customExtensionParams = staticTypes.customExtensionParams, eventHandlers = staticTypes.eventHandlers, initializeMessageTemplatesInfo = staticTypes.initializeMessageTemplatesInfo;
    // Note: This is a workaround to prevent the creation of multiple SDK instances when React strict mode is enabled.
    var connectDeps = (0,react.useRef)({
        appId: '',
        userId: '',
    });
    (0,react.useEffect)(function () {
        var _a;
        (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'SendbirdProvider | useConnect/useEffect', { userId: userId, appId: appId, accessToken: accessToken });
        var isNewApp = connectDeps.current.appId !== appId;
        if (connectDeps.current.appId === appId && connectDeps.current.userId === userId) {
            return;
        }
        else {
            connectDeps.current = { appId: appId, userId: userId };
        }
        connect({
            userId: userId,
            appId: appId,
            isNewApp: isNewApp,
            accessToken: accessToken,
            logger: logger,
            nickname: nickname,
            profileUrl: profileUrl,
            configureSession: configureSession,
            customApiHost: customApiHost,
            customWebSocketHost: customWebSocketHost,
            sdk: sdk,
            sdkDispatcher: sdkDispatcher,
            userDispatcher: userDispatcher,
            appInfoDispatcher: appInfoDispatcher,
            initDashboardConfigs: initDashboardConfigs,
            isUserIdUsedForNickname: isUserIdUsedForNickname,
            sdkInitParams: sdkInitParams,
            customExtensionParams: customExtensionParams,
            isMobile: isMobile,
            eventHandlers: eventHandlers,
            initializeMessageTemplatesInfo: initializeMessageTemplatesInfo,
        }).catch(function (error) {
            var _a;
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, 'SendbirdProvider | useConnect/useEffect', error);
        });
    }, [userId, appId]);
    var reconnect = (0,react.useCallback)(function () { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
        var error_1;
        var _a, _b;
        return (0,bundle_XQWyv823.b)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'SendbirdProvider | useConnect/reconnect/useCallback', { sdk: sdk });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, connect({
                            userId: userId,
                            appId: appId,
                            accessToken: accessToken,
                            logger: logger,
                            nickname: nickname,
                            profileUrl: profileUrl,
                            configureSession: configureSession,
                            customApiHost: customApiHost,
                            customWebSocketHost: customWebSocketHost,
                            sdk: sdk,
                            sdkDispatcher: sdkDispatcher,
                            userDispatcher: userDispatcher,
                            appInfoDispatcher: appInfoDispatcher,
                            initDashboardConfigs: initDashboardConfigs,
                            isUserIdUsedForNickname: isUserIdUsedForNickname,
                            sdkInitParams: sdkInitParams,
                            customExtensionParams: customExtensionParams,
                            isMobile: isMobile,
                            eventHandlers: eventHandlers,
                            initializeMessageTemplatesInfo: initializeMessageTemplatesInfo,
                        })];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'SendbirdProvider | useConnect/reconnect/useCallback', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [sdk]);
    return reconnect;
}

// Logger, pretty much explains it
// in SendbirdProvider
// const [logger, setLogger] = useState(LoggerFactory(logLevel));
var LOG_LEVELS = {
    DEBUG: 'debug',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info',
    ALL: 'all',
};
var colorLog = function (level) {
    switch (level) {
        case LOG_LEVELS.WARNING:
            return ('color: Orange');
        case LOG_LEVELS.ERROR:
            return ('color: Red');
        default:
            return ('color: Gray');
    }
};
var printLog = function (_a) {
    var level = _a.level, title = _a.title, _b = _a.description, description = _b === void 0 ? '' : _b, _c = _a.payload, payload = _c === void 0 ? [] : _c;
    // eslint-disable-next-line no-console
    console.log.apply(console, (0,bundle_XQWyv823.c)(["%c SendbirdUIKit | ".concat(level, " | ").concat(new Date().toISOString(), " | ").concat(title, " ").concat(description && '|'), colorLog(level), description], payload, false));
};
var getDefaultLogger = function () { return ({
    info: bundle_BHC96gO0.n,
    error: bundle_BHC96gO0.n,
    warning: bundle_BHC96gO0.n,
}); };
var LoggerFactory = function (lvl, customInterface) {
    var logInterface = printLog;
    var lvlArray = Array.isArray(lvl) ? lvl : [lvl];
    var applyLog = function (lgLvl) { return function (title, description) {
        var payload = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            payload[_i - 2] = arguments[_i];
        }
        return logInterface({
            level: lgLvl,
            title: title,
            description: description,
            payload: payload,
        });
    }; };
    return lvlArray.reduce(function (accumulator, currentLvl) {
        if (currentLvl === LOG_LEVELS.DEBUG || currentLvl === LOG_LEVELS.ALL) {
            return ((0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, accumulator), { info: applyLog(LOG_LEVELS.INFO), error: applyLog(LOG_LEVELS.ERROR), warning: applyLog(LOG_LEVELS.WARNING) }));
        }
        if (currentLvl === LOG_LEVELS.INFO) {
            return ((0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, accumulator), { info: applyLog(LOG_LEVELS.INFO) }));
        }
        if (currentLvl === LOG_LEVELS.ERROR) {
            return ((0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, accumulator), { error: applyLog(LOG_LEVELS.ERROR) }));
        }
        if (currentLvl === LOG_LEVELS.WARNING) {
            return ((0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, accumulator), { warning: applyLog(LOG_LEVELS.WARNING) }));
        }
        return (0,bundle_XQWyv823._)({}, accumulator);
    }, getDefaultLogger());
};
// TODO: Make this to hook, useLogger

var VoiceMessageProvider = function (_a) {
    var children = _a.children;
    return (react.createElement(bundle_BMJP8SSM.b, null,
        react.createElement(bundle_NL8iE1lF.V, null, children)));
};

function uikitConfigMapper(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    var legacyConfig = _a.legacyConfig, _9 = _a.uikitOptions, uikitOptions = _9 === void 0 ? {} : _9;
    var replyType = legacyConfig.replyType, isMentionEnabled = legacyConfig.isMentionEnabled, isReactionEnabled = legacyConfig.isReactionEnabled, disableUserProfile = legacyConfig.disableUserProfile, isVoiceMessageEnabled = legacyConfig.isVoiceMessageEnabled, isTypingIndicatorEnabledOnChannelList = legacyConfig.isTypingIndicatorEnabledOnChannelList, isMessageReceiptStatusEnabledOnChannelList = legacyConfig.isMessageReceiptStatusEnabledOnChannelList, showSearchIcon = legacyConfig.showSearchIcon;
    return {
        common: {
            enableUsingDefaultUserProfile: (_c = (_b = uikitOptions.common) === null || _b === void 0 ? void 0 : _b.enableUsingDefaultUserProfile) !== null && _c !== void 0 ? _c : (typeof disableUserProfile === 'boolean' ? !disableUserProfile : undefined),
        },
        groupChannel: {
            enableOgtag: (_d = uikitOptions.groupChannel) === null || _d === void 0 ? void 0 : _d.enableOgtag,
            enableMention: (_f = (_e = uikitOptions.groupChannel) === null || _e === void 0 ? void 0 : _e.enableMention) !== null && _f !== void 0 ? _f : isMentionEnabled,
            enableReactions: (_h = (_g = uikitOptions.groupChannel) === null || _g === void 0 ? void 0 : _g.enableReactions) !== null && _h !== void 0 ? _h : isReactionEnabled,
            enableReactionsSupergroup: (_j = uikitOptions.groupChannel) === null || _j === void 0 ? void 0 : _j.enableReactionsSupergroup,
            enableTypingIndicator: (_k = uikitOptions.groupChannel) === null || _k === void 0 ? void 0 : _k.enableTypingIndicator,
            enableVoiceMessage: (_m = (_l = uikitOptions.groupChannel) === null || _l === void 0 ? void 0 : _l.enableVoiceMessage) !== null && _m !== void 0 ? _m : isVoiceMessageEnabled,
            replyType: (_p = (_o = uikitOptions.groupChannel) === null || _o === void 0 ? void 0 : _o.replyType) !== null && _p !== void 0 ? _p : (replyType != null ? (0,bundle_BOn8npYv.g)(replyType).lowerCase : undefined),
            threadReplySelectType: (_q = uikitOptions.groupChannel) === null || _q === void 0 ? void 0 : _q.threadReplySelectType,
            input: {
                enableDocument: (_s = (_r = uikitOptions.groupChannel) === null || _r === void 0 ? void 0 : _r.input) === null || _s === void 0 ? void 0 : _s.enableDocument,
            },
            typingIndicatorTypes: (_t = uikitOptions.groupChannel) === null || _t === void 0 ? void 0 : _t.typingIndicatorTypes,
            enableFeedback: (_u = uikitOptions.groupChannel) === null || _u === void 0 ? void 0 : _u.enableFeedback,
            enableSuggestedReplies: (_v = uikitOptions.groupChannel) === null || _v === void 0 ? void 0 : _v.enableSuggestedReplies,
            showSuggestedRepliesFor: (_w = uikitOptions.groupChannel) === null || _w === void 0 ? void 0 : _w.showSuggestedRepliesFor,
            suggestedRepliesDirection: (_x = uikitOptions.groupChannel) === null || _x === void 0 ? void 0 : _x.suggestedRepliesDirection,
            enableMarkdownForUserMessage: (_y = uikitOptions.groupChannel) === null || _y === void 0 ? void 0 : _y.enableMarkdownForUserMessage,
            enableFormTypeMessage: (_z = uikitOptions.groupChannel) === null || _z === void 0 ? void 0 : _z.enableFormTypeMessage,
        },
        groupChannelList: {
            enableTypingIndicator: (_1 = (_0 = uikitOptions.groupChannelList) === null || _0 === void 0 ? void 0 : _0.enableTypingIndicator) !== null && _1 !== void 0 ? _1 : isTypingIndicatorEnabledOnChannelList,
            enableMessageReceiptStatus: (_3 = (_2 = uikitOptions.groupChannelList) === null || _2 === void 0 ? void 0 : _2.enableMessageReceiptStatus) !== null && _3 !== void 0 ? _3 : isMessageReceiptStatusEnabledOnChannelList,
        },
        groupChannelSettings: {
            enableMessageSearch: (_5 = (_4 = uikitOptions.groupChannelSettings) === null || _4 === void 0 ? void 0 : _4.enableMessageSearch) !== null && _5 !== void 0 ? _5 : showSearchIcon,
        },
        openChannel: {
            enableOgtag: (_6 = uikitOptions.openChannel) === null || _6 === void 0 ? void 0 : _6.enableOgtag,
            input: {
                enableDocument: (_8 = (_7 = uikitOptions.openChannel) === null || _7 === void 0 ? void 0 : _7.input) === null || _8 === void 0 ? void 0 : _8.enableDocument,
            },
        },
    };
}

function useMarkAsReadScheduler(_a, _b) {
    var isConnected = _a.isConnected;
    var logger = _b.logger;
    var markAsReadScheduler = (0,react.useMemo)(function () { return schedulerFactory({
        logger: logger,
        cb: function (channel) {
            try {
                channel.markAsRead();
            }
            catch (error) {
                logger.warning('Channel: Mark as delivered failed', { channel: channel, error: error });
            }
        },
    }); }, []);
    (0,react.useEffect)(function () {
        // for simplicity, we clear the queue when the connection is lost
        if (!isConnected) {
            markAsReadScheduler.clear();
        }
    }, [isConnected]);
    useUnmount(function () { markAsReadScheduler.clear(); });
    return markAsReadScheduler;
}

var uikitConfigStorage = {
    getItem: function (key) {
        return (0,bundle_XQWyv823.a)(this, void 0, void 0, function () {
            var _a;
            return (0,bundle_XQWyv823.b)(this, function (_b) {
                return [2 /*return*/, (_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : null];
            });
        });
    },
    setItem: function (key, value) {
        return (0,bundle_XQWyv823.a)(this, void 0, void 0, function () {
            return (0,bundle_XQWyv823.b)(this, function (_a) {
                return [2 /*return*/, localStorage.setItem(key, value)];
            });
        });
    },
};

/**
 * Takes JSON parsed template and then returns processed message template for storing it in global state.
 */
var getProcessedTemplate = function (parsedTemplate) {
    return {
        version: Number(parsedTemplate.ui_template.version),
        uiTemplate: JSON.stringify(parsedTemplate.ui_template.body.items),
        colorVariables: parsedTemplate.color_variables,
    };
};
var getProcessedTemplatesMap = function (parsedTemplates) {
    var processedTemplates = {};
    parsedTemplates.forEach(function (template) {
        processedTemplates[template.key] = getProcessedTemplate(template);
    });
    return processedTemplates;
};

var MESSAGE_TEMPLATES_FETCH_LIMIT = 20;
var INITIALIZE_MESSAGE_TEMPLATES_INFO = APP_INFO_ACTIONS.INITIALIZE_MESSAGE_TEMPLATES_INFO, UPSERT_MESSAGE_TEMPLATES = APP_INFO_ACTIONS.UPSERT_MESSAGE_TEMPLATES, UPSERT_WAITING_TEMPLATE_KEYS = APP_INFO_ACTIONS.UPSERT_WAITING_TEMPLATE_KEYS, MARK_ERROR_WAITING_TEMPLATE_KEYS = APP_INFO_ACTIONS.MARK_ERROR_WAITING_TEMPLATE_KEYS;
function useMessageTemplateUtils(_a) {
    var _this = this;
    var sdk = _a.sdk, logger = _a.logger, appInfoStore = _a.appInfoStore, appInfoDispatcher = _a.appInfoDispatcher;
    var messageTemplatesInfo = appInfoStore === null || appInfoStore === void 0 ? void 0 : appInfoStore.messageTemplatesInfo;
    var getCachedTemplate = function (key) {
        var _a, _b;
        if (!messageTemplatesInfo)
            return null;
        var cachedTemplate = null;
        var cachedMessageTemplates = (_a = messageTemplatesInfo === null || messageTemplatesInfo === void 0 ? void 0 : messageTemplatesInfo.templatesMap) !== null && _a !== void 0 ? _a : null;
        if (cachedMessageTemplates) {
            cachedTemplate = (_b = cachedMessageTemplates[key]) !== null && _b !== void 0 ? _b : null;
        }
        return cachedTemplate;
    };
    /**
     * Fetches a single message template by given key and then
     * returns processed template for updating templates info in global state.
     * If no such templates exists (error) or any error occurs in response, return null.
     */
    var fetchAllMessageTemplates = function (readySdk) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
        var hasMore, paginationToken, fetchedTemplates, res;
        return (0,bundle_XQWyv823.b)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hasMore = true;
                    paginationToken = null;
                    fetchedTemplates = [];
                    _a.label = 1;
                case 1:
                    if (!hasMore) return [3 /*break*/, 3];
                    return [4 /*yield*/, readySdk.message.getMessageTemplatesByToken(paginationToken, { limit: MESSAGE_TEMPLATES_FETCH_LIMIT })];
                case 2:
                    res = _a.sent();
                    hasMore = res.hasMore;
                    paginationToken = res.token;
                    res.templates.forEach(function (messageTemplate) {
                        fetchedTemplates.push(JSON.parse(messageTemplate.template));
                    });
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, fetchedTemplates];
            }
        });
    }); };
    var initializeMessageTemplatesInfo = function (readySdk) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
        var sdkMessageTemplateToken, cachedMessageTemplatesToken, cachedMessageTemplates, parsedTemplates, newMessageTemplatesInfo, parsedTemplates, newMessageTemplatesInfo;
        var _a;
        return (0,bundle_XQWyv823.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sdkMessageTemplateToken = (_a = readySdk.appInfo) === null || _a === void 0 ? void 0 : _a.messageTemplateInfo.token;
                    /**
                     * no sdkMessageTemplateToken => no templates => clear cached
                     */
                    if (!sdkMessageTemplateToken) {
                        localStorage.removeItem(bundle_DABR6HKW.C);
                        localStorage.removeItem(bundle_DABR6HKW.p);
                        return [2 /*return*/];
                    }
                    cachedMessageTemplatesToken = localStorage.getItem(bundle_DABR6HKW.C);
                    cachedMessageTemplates = localStorage.getItem(bundle_DABR6HKW.p);
                    if (!(!cachedMessageTemplatesToken
                        || cachedMessageTemplatesToken !== sdkMessageTemplateToken)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchAllMessageTemplates(readySdk)];
                case 1:
                    parsedTemplates = _b.sent();
                    newMessageTemplatesInfo = {
                        token: sdkMessageTemplateToken,
                        templatesMap: getProcessedTemplatesMap(parsedTemplates),
                    };
                    appInfoDispatcher({ type: INITIALIZE_MESSAGE_TEMPLATES_INFO, payload: newMessageTemplatesInfo });
                    localStorage.setItem(bundle_DABR6HKW.C, sdkMessageTemplateToken);
                    localStorage.setItem(bundle_DABR6HKW.p, JSON.stringify(parsedTemplates));
                    return [3 /*break*/, 3];
                case 2:
                    if (cachedMessageTemplatesToken
                        && cachedMessageTemplatesToken === sdkMessageTemplateToken
                        && cachedMessageTemplates) {
                        parsedTemplates = JSON.parse(cachedMessageTemplates);
                        newMessageTemplatesInfo = {
                            token: sdkMessageTemplateToken,
                            templatesMap: getProcessedTemplatesMap(parsedTemplates),
                        };
                        appInfoDispatcher({ type: INITIALIZE_MESSAGE_TEMPLATES_INFO, payload: newMessageTemplatesInfo });
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * If given message is a template message with template key and if the key does not exist in the cache,
     * update the cache by fetching the template.
     */
    var updateMessageTemplatesInfo = function (templateKeys, messageId, requestedAt) { return (0,bundle_XQWyv823.a)(_this, void 0, void 0, function () {
        var newParsedTemplates_1, hasMore, token, result, e_1, cachedMessageTemplates, parsedTemplates_1, existingKeys_1;
        var _a;
        return (0,bundle_XQWyv823.b)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!appInfoDispatcher) return [3 /*break*/, 7];
                    appInfoDispatcher({
                        type: UPSERT_WAITING_TEMPLATE_KEYS,
                        payload: {
                            keys: templateKeys,
                            requestedAt: requestedAt,
                        },
                    });
                    newParsedTemplates_1 = [];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    hasMore = true;
                    token = null;
                    _b.label = 2;
                case 2:
                    if (!hasMore) return [3 /*break*/, 4];
                    return [4 /*yield*/, sdk.message.getMessageTemplatesByToken(token, {
                            keys: templateKeys,
                        })];
                case 3:
                    result = _b.sent();
                    result.templates.forEach(function (newTemplate) {
                        newParsedTemplates_1.push(JSON.parse(newTemplate.template));
                    });
                    hasMore = result.hasMore;
                    token = result.token;
                    return [3 /*break*/, 2];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, 'Sendbird | fetchProcessedMessageTemplates failed', e_1, templateKeys);
                    return [3 /*break*/, 6];
                case 6:
                    if (newParsedTemplates_1.length > 0) {
                        cachedMessageTemplates = localStorage.getItem(bundle_DABR6HKW.p);
                        if (cachedMessageTemplates) {
                            parsedTemplates_1 = JSON.parse(cachedMessageTemplates);
                            existingKeys_1 = parsedTemplates_1.map(function (parsedTemplate) { return parsedTemplate.key; });
                            newParsedTemplates_1.forEach(function (newParsedTemplate) {
                                if (!existingKeys_1.includes(newParsedTemplate.key)) {
                                    parsedTemplates_1.push(newParsedTemplate);
                                }
                            });
                            localStorage.setItem(bundle_DABR6HKW.p, JSON.stringify(parsedTemplates_1));
                        }
                        else {
                            localStorage.setItem(bundle_DABR6HKW.p, JSON.stringify([newParsedTemplates_1]));
                        }
                        // Update memory
                        appInfoDispatcher({
                            type: UPSERT_MESSAGE_TEMPLATES,
                            payload: newParsedTemplates_1.map(function (newParsedTemplate) {
                                return {
                                    key: newParsedTemplate.key,
                                    template: getProcessedTemplate(newParsedTemplate),
                                };
                            }),
                        });
                    }
                    else {
                        appInfoDispatcher({
                            type: MARK_ERROR_WAITING_TEMPLATE_KEYS,
                            payload: {
                                keys: templateKeys,
                                messageId: messageId,
                            },
                        });
                    }
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return {
        getCachedTemplate: getCachedTemplate,
        updateMessageTemplatesInfo: updateMessageTemplatesInfo,
        initializeMessageTemplatesInfo: initializeMessageTemplatesInfo,
    };
}

function SendbirdProvider_SendbirdProvider(props) {
    var localConfigs = uikitConfigMapper({
        legacyConfig: {
            replyType: props.replyType,
            isMentionEnabled: props.isMentionEnabled,
            isReactionEnabled: props.isReactionEnabled,
            disableUserProfile: props.disableUserProfile,
            isVoiceMessageEnabled: props.isVoiceMessageEnabled,
            isTypingIndicatorEnabledOnChannelList: props.isTypingIndicatorEnabledOnChannelList,
            isMessageReceiptStatusEnabledOnChannelList: props.isMessageReceiptStatusEnabledOnChannelList,
            showSearchIcon: props.showSearchIcon,
        },
        uikitOptions: props.uikitOptions,
    });
    return (react.createElement(esm/* UIKitConfigProvider */.wD, { storage: uikitConfigStorage, localConfigs: {
            common: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.common,
            groupChannel: {
                channel: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannel,
                channelList: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannelList,
                setting: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannelSettings,
            },
            openChannel: {
                channel: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.openChannel,
            },
        } },
        react.createElement(SendbirdSDK, (0,bundle_XQWyv823._)({}, props))));
}
var SendbirdSDK = function (_a) {
    var _b, _c, _d;
    var appId = _a.appId, userId = _a.userId, children = _a.children, accessToken = _a.accessToken, customApiHost = _a.customApiHost, customWebSocketHost = _a.customWebSocketHost, configureSession = _a.configureSession, _e = _a.theme, theme = _e === void 0 ? 'light' : _e, _f = _a.config, config = _f === void 0 ? {} : _f, _g = _a.nickname, nickname = _g === void 0 ? '' : _g, colorSet = _a.colorSet, stringSet = _a.stringSet, dateLocale = _a.dateLocale, _h = _a.profileUrl, profileUrl = _h === void 0 ? '' : _h, voiceRecord = _a.voiceRecord, userListQuery = _a.userListQuery, _j = _a.imageCompression, imageCompression = _j === void 0 ? {} : _j, _k = _a.allowProfileEdit, allowProfileEdit = _k === void 0 ? false : _k, _l = _a.disableMarkAsDelivered, disableMarkAsDelivered = _l === void 0 ? false : _l, renderUserProfile = _a.renderUserProfile, _onUserProfileMessage = _a.onUserProfileMessage, _onStartDirectMessage = _a.onStartDirectMessage, _m = _a.breakpoint, breakpoint = _m === void 0 ? false : _m, _o = _a.isUserIdUsedForNickname, isUserIdUsedForNickname = _o === void 0 ? true : _o, sdkInitParams = _a.sdkInitParams, customExtensionParams = _a.customExtensionParams, _p = _a.isMultipleFilesMessageEnabled, isMultipleFilesMessageEnabled = _p === void 0 ? false : _p, eventHandlers = _a.eventHandlers, _q = _a.htmlTextDirection, htmlTextDirection = _q === void 0 ? 'ltr' : _q, _r = _a.forceLeftToRightMessageLayout, forceLeftToRightMessageLayout = _r === void 0 ? false : _r;
    var onStartDirectMessage = _onStartDirectMessage !== null && _onStartDirectMessage !== void 0 ? _onStartDirectMessage : _onUserProfileMessage;
    var _s = config.logLevel, logLevel = _s === void 0 ? '' : _s, _t = config.userMention, userMention = _t === void 0 ? {} : _t, _u = config.isREMUnitEnabled, isREMUnitEnabled = _u === void 0 ? false : _u, customPubSub = config.pubSub;
    var isMobile = (0,bundle_R3uJ_0BB.u)().isMobile;
    var _v = (0,react.useState)(LoggerFactory(logLevel)), logger = _v[0], setLogger = _v[1];
    var pubSub = (0,react.useState)(function () { return customPubSub !== null && customPubSub !== void 0 ? customPubSub : (0,bundle_B5OWYHQO.p)(); })[0];
    var _w = (0,react.useReducer)(reducer$2, initialState$2), sdkStore = _w[0], sdkDispatcher = _w[1];
    var _x = (0,react.useReducer)(reducer$1, initialState$1), userStore = _x[0], userDispatcher = _x[1];
    var _y = (0,react.useReducer)(reducer, initialState), appInfoStore = _y[0], appInfoDispatcher = _y[1];
    var _z = (0,esm/* useUIKitConfig */.Jf)(), configs = _z.configs, configsWithAppAttr = _z.configsWithAppAttr, initDashboardConfigs = _z.initDashboardConfigs;
    var sdkInitialized = sdkStore.initialized;
    var sdk = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.sdk;
    var _0 = (_b = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) !== null && _b !== void 0 ? _b : {}, uploadSizeLimit = _0.uploadSizeLimit, multipleFilesMessageFileCountLimit = _0.multipleFilesMessageFileCountLimit;
    useTheme(colorSet);
    var _1 = useMessageTemplateUtils({
        sdk: sdk,
        logger: logger,
        appInfoStore: appInfoStore,
        appInfoDispatcher: appInfoDispatcher,
    }), getCachedTemplate = _1.getCachedTemplate, updateMessageTemplatesInfo = _1.updateMessageTemplatesInfo, initializeMessageTemplatesInfo = _1.initializeMessageTemplatesInfo;
    var utils = {
        updateMessageTemplatesInfo: updateMessageTemplatesInfo,
        getCachedTemplate: getCachedTemplate,
    };
    var reconnect = useConnect({
        appId: appId,
        userId: userId,
        accessToken: accessToken,
        isUserIdUsedForNickname: isUserIdUsedForNickname,
        isMobile: isMobile,
    }, {
        logger: logger,
        nickname: nickname,
        profileUrl: profileUrl,
        configureSession: configureSession,
        customApiHost: customApiHost,
        customWebSocketHost: customWebSocketHost,
        sdkInitParams: sdkInitParams,
        customExtensionParams: customExtensionParams,
        sdk: sdk,
        sdkDispatcher: sdkDispatcher,
        userDispatcher: userDispatcher,
        appInfoDispatcher: appInfoDispatcher,
        initDashboardConfigs: initDashboardConfigs,
        eventHandlers: eventHandlers,
        initializeMessageTemplatesInfo: initializeMessageTemplatesInfo,
    });
    useUnmount(function () {
        if (typeof sdk.disconnect === 'function') {
            disconnectSdk({
                logger: logger,
                sdkDispatcher: sdkDispatcher,
                userDispatcher: userDispatcher,
                sdk: sdk,
            });
        }
    }, [sdk.disconnectWebSocket]);
    // to create a pubsub to communicate between parent and child
    (0,react.useEffect)(function () {
        setLogger(LoggerFactory(logLevel));
    }, [logLevel]);
    // should move to reducer
    var _2 = (0,react.useState)(theme), currentTheme = _2[0], setCurrentTheme = _2[1];
    (0,react.useEffect)(function () {
        setCurrentTheme(theme);
    }, [theme]);
    (0,react.useEffect)(function () {
        var body = document.querySelector('body');
        body === null || body === void 0 ? void 0 : body.classList.remove('sendbird-experimental__rem__units');
        if (isREMUnitEnabled) {
            body === null || body === void 0 ? void 0 : body.classList.add('sendbird-experimental__rem__units');
        }
    }, [isREMUnitEnabled]);
    // add-remove theme from body
    (0,react.useEffect)(function () {
        logger.info('Setup theme', "Theme: ".concat(currentTheme));
        try {
            var body = document.querySelector('body');
            body === null || body === void 0 ? void 0 : body.classList.remove('sendbird-theme--light');
            body === null || body === void 0 ? void 0 : body.classList.remove('sendbird-theme--dark');
            body === null || body === void 0 ? void 0 : body.classList.add("sendbird-theme--".concat(currentTheme || 'light'));
            logger.info('Finish setup theme');
            // eslint-disable-next-line no-empty
        }
        catch (e) {
            logger.warning('Setup theme failed', "".concat(e));
        }
        return function () {
            try {
                var body = document.querySelector('body');
                body === null || body === void 0 ? void 0 : body.classList.remove('sendbird-theme--light');
                body === null || body === void 0 ? void 0 : body.classList.remove('sendbird-theme--dark');
                // eslint-disable-next-line no-empty
            }
            catch (_a) { }
        };
    }, [currentTheme]);
    (0,bundle_BbVJcZ9w.a)(htmlTextDirection);
    var isOnline = bundle_DNUUqUmN_useOnlineStatus(sdkStore.sdk, logger);
    var markAsReadScheduler = useMarkAsReadScheduler({ isConnected: isOnline }, { logger: logger });
    var markAsDeliveredScheduler = bundle_DNUUqUmN_useMarkAsDeliveredScheduler({ isConnected: isOnline }, { logger: logger });
    var localeStringSet = react.useMemo(function () {
        return (0,bundle_XQWyv823._)((0,bundle_XQWyv823._)({}, (0,bundle_BPcbf_pM.g)('en')), stringSet);
    }, [stringSet]);
    /**
     * Feature Configuration - TODO
     * This will be moved into the UIKitConfigProvider, aftering Dashboard applies
     */
    var uikitMultipleFilesMessageLimit = (0,react.useMemo)(function () {
        return Math.min(bundle_DABR6HKW.q, multipleFilesMessageFileCountLimit !== null && multipleFilesMessageFileCountLimit !== void 0 ? multipleFilesMessageFileCountLimit : Number.MAX_SAFE_INTEGER);
    }, [multipleFilesMessageFileCountLimit]);
    // Emoji Manager
    var emojiManager = (0,react.useMemo)(function () {
        return new bundle_NL8iE1lF.E({
            sdk: sdk,
            logger: logger,
        });
    }, [sdkStore.initialized]);
    return (react.createElement(withSendbird/* SendbirdSdkContext.Provider */.N.Provider, { value: {
            stores: {
                sdkStore: sdkStore,
                userStore: userStore,
                appInfoStore: appInfoStore,
            },
            dispatchers: {
                sdkDispatcher: sdkDispatcher,
                userDispatcher: userDispatcher,
                appInfoDispatcher: appInfoDispatcher,
                reconnect: reconnect,
            },
            config: {
                disableMarkAsDelivered: disableMarkAsDelivered,
                renderUserProfile: renderUserProfile,
                onStartDirectMessage: onStartDirectMessage,
                onUserProfileMessage: onStartDirectMessage, // legacy of onStartDirectMessage
                allowProfileEdit: allowProfileEdit,
                isOnline: isOnline,
                userId: userId,
                appId: appId,
                accessToken: accessToken,
                theme: currentTheme,
                setCurrentTheme: setCurrentTheme,
                setCurrenttheme: setCurrentTheme, // deprecated: typo
                isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled,
                uikitUploadSizeLimit: uploadSizeLimit !== null && uploadSizeLimit !== void 0 ? uploadSizeLimit : bundle_DABR6HKW.r,
                uikitMultipleFilesMessageLimit: uikitMultipleFilesMessageLimit,
                userListQuery: userListQuery,
                logger: logger,
                pubSub: pubSub,
                imageCompression: (0,bundle_XQWyv823._)({ compressionRate: 0.7, outputFormat: 'preserve' }, imageCompression),
                voiceRecord: {
                    maxRecordingTime: (_c = voiceRecord === null || voiceRecord === void 0 ? void 0 : voiceRecord.maxRecordingTime) !== null && _c !== void 0 ? _c : bundle_DABR6HKW.s,
                    minRecordingTime: (_d = voiceRecord === null || voiceRecord === void 0 ? void 0 : voiceRecord.minRecordingTime) !== null && _d !== void 0 ? _d : bundle_DABR6HKW.k,
                },
                userMention: {
                    maxMentionCount: (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || 10,
                    maxSuggestionCount: (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || 15,
                },
                markAsReadScheduler: markAsReadScheduler,
                markAsDeliveredScheduler: markAsDeliveredScheduler,
                // Remote configs set from dashboard by UIKit feature configuration
                common: configs.common,
                groupChannel: {
                    enableOgtag: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableOgtag,
                    enableTypingIndicator: configs.groupChannel.channel.enableTypingIndicator,
                    enableReactions: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableReactions,
                    enableMention: configs.groupChannel.channel.enableMention,
                    replyType: configs.groupChannel.channel.replyType,
                    threadReplySelectType: configs.groupChannel.channel.threadReplySelectType,
                    enableVoiceMessage: configs.groupChannel.channel.enableVoiceMessage,
                    enableDocument: configs.groupChannel.channel.input.enableDocument,
                    typingIndicatorTypes: configs.groupChannel.channel.typingIndicatorTypes,
                    enableFeedback: configs.groupChannel.channel.enableFeedback,
                    enableSuggestedReplies: configs.groupChannel.channel.enableSuggestedReplies,
                    showSuggestedRepliesFor: configs.groupChannel.channel.showSuggestedRepliesFor,
                    suggestedRepliesDirection: configs.groupChannel.channel.suggestedRepliesDirection,
                    enableMarkdownForUserMessage: configs.groupChannel.channel.enableMarkdownForUserMessage,
                    enableFormTypeMessage: configs.groupChannel.channel.enableFormTypeMessage,
                    enableReactionsSupergroup: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableReactionsSupergroup,
                },
                groupChannelList: {
                    enableTypingIndicator: configs.groupChannel.channelList.enableTypingIndicator,
                    enableMessageReceiptStatus: configs.groupChannel.channelList.enableMessageReceiptStatus,
                },
                groupChannelSettings: {
                    enableMessageSearch: sdkInitialized && configsWithAppAttr(sdk).groupChannel.setting.enableMessageSearch,
                },
                openChannel: {
                    enableOgtag: sdkInitialized && configsWithAppAttr(sdk).openChannel.channel.enableOgtag,
                    enableDocument: configs.openChannel.channel.input.enableDocument,
                },
                // deprecated configs
                disableUserProfile: !configs.common.enableUsingDefaultUserProfile,
                isReactionEnabled: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableReactions,
                isMentionEnabled: configs.groupChannel.channel.enableMention,
                isVoiceMessageEnabled: configs.groupChannel.channel.enableVoiceMessage,
                replyType: (0,bundle_BOn8npYv.g)(configs.groupChannel.channel.replyType).upperCase,
                isTypingIndicatorEnabledOnChannelList: configs.groupChannel.channelList.enableTypingIndicator,
                isMessageReceiptStatusEnabledOnChannelList: configs.groupChannel.channelList.enableMessageReceiptStatus,
                showSearchIcon: sdkInitialized && configsWithAppAttr(sdk).groupChannel.setting.enableMessageSearch,
                htmlTextDirection: htmlTextDirection,
                forceLeftToRightMessageLayout: forceLeftToRightMessageLayout,
            },
            eventHandlers: eventHandlers,
            emojiManager: emojiManager,
            utils: utils,
        } },
        react.createElement(bundle_R3uJ_0BB.M, { logger: logger, breakpoint: breakpoint },
            react.createElement(bundle_PhH_XFy.a, { stringSet: localeStringSet, dateLocale: dateLocale },
                react.createElement(VoiceMessageProvider, null,
                    react.createElement(bundle_NL8iE1lF.G, null, children)))),
        react.createElement(bundle_ml_PByBw.i, null),
        react.createElement(bundle_NL8iE1lF.d, null),
        react.createElement(bundle_ml_PByBw.j, null)));
};


//# sourceMappingURL=SendbirdProvider.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel.js
var uikit_react_GroupChannel = __webpack_require__(45333);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bv8KtnvF.js
var bundle_Bv8KtnvF = __webpack_require__(46776);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/context.js































var GroupChannelListContext = react.createContext(null);
var context_GroupChannelListProvider = function (props) {
    var _a, _b, _c;
    var children = props.children, _d = props.className, className = _d === void 0 ? '' : _d, selectedChannelUrl = props.selectedChannelUrl, _e = props.disableAutoSelect, disableAutoSelect = _e === void 0 ? false : _e, allowProfileEdit = props.allowProfileEdit, isTypingIndicatorEnabled = props.isTypingIndicatorEnabled, isMessageReceiptStatusEnabled = props.isMessageReceiptStatusEnabled, channelListQueryParams = props.channelListQueryParams, onThemeChange = props.onThemeChange, _f = props.onChannelSelect, onChannelSelect = _f === void 0 ? noop : _f, _g = props.onChannelCreated, onChannelCreated = _g === void 0 ? noop : _g, onCreateChannelClick = props.onCreateChannelClick, onBeforeCreateChannel = props.onBeforeCreateChannel, onUserProfileUpdated = props.onUserProfileUpdated;
    var globalStore = useSendbirdStateContext();
    var config = globalStore.config, stores = globalStore.stores;
    var sdkStore = stores.sdkStore;
    var sdk = sdkStore.sdk;
    var isConnected = useOnlineStatus(sdk, config.logger);
    var scheduler = useMarkAsDeliveredScheduler({ isConnected: isConnected }, config);
    var channelListDataSource = useGroupChannelList(sdk, {
        collectionCreator: getCollectionCreator(sdk, channelListQueryParams),
        markAsDelivered: function (channels) { return channels.forEach(scheduler.push); },
        onChannelsDeleted: function (channelUrls) {
            channelUrls.forEach(function (url) {
                if (url === selectedChannelUrl)
                    onChannelSelect(null);
            });
        },
    });
    var refreshing = channelListDataSource.refreshing, initialized = channelListDataSource.initialized, groupChannels = channelListDataSource.groupChannels, refresh = channelListDataSource.refresh, loadMore = channelListDataSource.loadMore;
    // SideEffect: Auto select channel
    useEffect(function () {
        var _a;
        if (!disableAutoSelect && stores.sdkStore.initialized && initialized) {
            if (!selectedChannelUrl)
                onChannelSelect((_a = groupChannels[0]) !== null && _a !== void 0 ? _a : null);
        }
    }, [disableAutoSelect, stores.sdkStore.initialized, initialized, selectedChannelUrl]);
    // Recreates the GroupChannelCollection when `channelListQueryParams` change
    useEffect(function () {
        refresh();
    }, [
        Object.keys(channelListQueryParams !== null && channelListQueryParams !== void 0 ? channelListQueryParams : {}).sort()
            .map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(JSON.stringify(channelListQueryParams[key]))); })
            .join('&'),
    ]);
    var _h = useState([]), typingChannelUrls = _h[0], setTypingChannelUrls = _h[1];
    useGroupChannelHandler(sdk, {
        onTypingStatusUpdated: function (channel) {
            var _a;
            var channelList = typingChannelUrls.filter(function (channelUrl) { return channelUrl !== channel.url; });
            if (((_a = channel.getTypingUsers()) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setTypingChannelUrls(channelList.concat(channel.url));
            }
            else {
                setTypingChannelUrls(channelList);
            }
        },
    });
    return (React__default.createElement(GroupChannelListContext.Provider, { value: {
            className: className,
            selectedChannelUrl: selectedChannelUrl,
            disableAutoSelect: disableAutoSelect,
            allowProfileEdit: (_a = allowProfileEdit !== null && allowProfileEdit !== void 0 ? allowProfileEdit : config.allowProfileEdit) !== null && _a !== void 0 ? _a : true,
            isTypingIndicatorEnabled: (_b = isTypingIndicatorEnabled !== null && isTypingIndicatorEnabled !== void 0 ? isTypingIndicatorEnabled : config.groupChannelList.enableTypingIndicator) !== null && _b !== void 0 ? _b : false,
            isMessageReceiptStatusEnabled: (_c = isMessageReceiptStatusEnabled !== null && isMessageReceiptStatusEnabled !== void 0 ? isMessageReceiptStatusEnabled : config.groupChannelList.enableMessageReceiptStatus) !== null && _c !== void 0 ? _c : false,
            onChannelSelect: onChannelSelect,
            onChannelCreated: onChannelCreated,
            onThemeChange: onThemeChange,
            onCreateChannelClick: onCreateChannelClick,
            onBeforeCreateChannel: onBeforeCreateChannel,
            onUserProfileUpdated: onUserProfileUpdated,
            typingChannelUrls: typingChannelUrls,
            refreshing: refreshing,
            initialized: initialized,
            groupChannels: groupChannels,
            refresh: refresh,
            loadMore: loadMore,
        } },
        React__default.createElement(UserProfileProvider, __assign({}, props),
            React__default.createElement("div", { className: "sendbird-channel-list ".concat(className) }, children))));
};
var context_useGroupChannelListContext = function () {
    var context = useContext(GroupChannelListContext);
    if (!context)
        throw new Error('GroupChannelListContext not found. Use within the GroupChannelList module.');
    return context;
};
function getCollectionCreator(sdk, channelListQueryParams) {
    return function (defaultParams) {
        var params = __assign(__assign({}, defaultParams), channelListQueryParams);
        return sdk.groupChannel.createGroupChannelCollection(__assign(__assign({}, params), { filter: new GroupChannelFilter(params) }));
    };
}


//# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-52W7LREX.js
var bundle_52W7LREX = __webpack_require__(82314);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Header.js
var ui_Header = __webpack_require__(56210);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ImageRenderer.js
var ImageRenderer = __webpack_require__(4399);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TextButton.js
var ui_TextButton = __webpack_require__(21790);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BL3yUpTV.js
var bundle_BL3yUpTV = __webpack_require__(21112);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader.js


















var GroupChannelListHeader_GroupChannelListHeader = function (_a) {
    var renderTitle = _a.renderTitle, renderIconButton = _a.renderIconButton, onEdit = _a.onEdit, allowProfileEdit = _a.allowProfileEdit, 
    // Header custom props
    renderLeft = _a.renderLeft, renderMiddle = _a.renderMiddle, renderRight = _a.renderRight;
    var stores = useSendbirdStateContext().stores;
    var user = stores.userStore.user;
    var stringSet = useLocalization().stringSet;
    var renderProfile = renderMiddle !== null && renderMiddle !== void 0 ? renderMiddle : renderTitle;
    return (React__default.createElement(Header, { className: classnames('sendbird-channel-header', allowProfileEdit && 'sendbird-channel-header--allow-edit'), renderLeft: renderLeft, renderMiddle: function () {
            var _a;
            return ((_a = renderProfile === null || renderProfile === void 0 ? void 0 : renderProfile()) !== null && _a !== void 0 ? _a : (React__default.createElement("div", { className: "sendbird-channel-header__title", role: "button", onClick: function () {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit();
                }, onKeyDown: function () {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit();
                }, tabIndex: 0 },
                React__default.createElement("div", { className: "sendbird-channel-header__title__left" },
                    React__default.createElement(Avatar, { width: "32px", height: "32px", src: user.profileUrl, alt: user.nickname })),
                React__default.createElement("div", { className: "sendbird-channel-header__title__right" },
                    React__default.createElement(Label, { className: "sendbird-channel-header__title__right__name", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_1 }, user.nickname || stringSet.NO_NAME),
                    React__default.createElement(Label, { className: "sendbird-channel-header__title__right__user-id", type: LabelTypography.BODY_2, color: LabelColors.ONBACKGROUND_2 }, user.userId)))));
        }, renderRight: renderRight !== null && renderRight !== void 0 ? renderRight : renderIconButton }));
};


//# sourceMappingURL=GroupChannelListHeader.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/EditUserProfile/context.js



var EditUserProfileProviderContext = react.createContext(null);
var context_EditUserProfileProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(EditUserProfileProviderContext.Provider, { value: props }, children);
};
var context_useEditUserProfileContext = function () {
    var context = React__default.useContext(EditUserProfileProviderContext);
    if (!context)
        throw new Error('EditUserProfileContext not found. Use within the EditUserProfile module.');
    return context;
};


//# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Input.js
var ui_Input = __webpack_require__(80385);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/EditUserProfile/components/EditUserProfileUI.js





































var EditUserProfileUIView = function (_a) {
    var _b;
    var formRef = _a.formRef, inputRef = _a.inputRef, onThemeChange = _a.onThemeChange, setProfileImage = _a.setProfileImage;
    var _c = useSendbirdStateContext(), stores = _c.stores, config = _c.config;
    var theme = config.theme, setCurrentTheme = config.setCurrentTheme;
    var user = (_b = stores.userStore) === null || _b === void 0 ? void 0 : _b.user;
    var stringSet = useLocalization().stringSet;
    var _d = useState(null), currentImg = _d[0], setCurrentImg = _d[1];
    var hiddenInputRef = useRef(null);
    return (React__default.createElement("form", { className: "sendbird-edit-user-profile", ref: formRef, onSubmit: function (e) { e.preventDefault(); } },
        React__default.createElement("section", { className: "sendbird-edit-user-profile__img" },
            React__default.createElement(InputLabel, null, stringSet.EDIT_PROFILE__IMAGE_LABEL),
            React__default.createElement("div", { className: "sendbird-edit-user-profile__img__avatar" },
                React__default.createElement(Avatar, { width: "80px", height: "80px", src: currentImg || (user === null || user === void 0 ? void 0 : user.profileUrl) })),
            React__default.createElement("input", { ref: hiddenInputRef, type: "file", accept: "image/gif, image/jpeg, image/png", style: { display: 'none' }, onChange: function (e) {
                    if (e.target.files) {
                        setCurrentImg(URL.createObjectURL(e.target.files[0]));
                        setProfileImage(e.target.files[0]);
                    }
                    if (hiddenInputRef.current) {
                        hiddenInputRef.current.value = '';
                    }
                } }),
            React__default.createElement(TextButton, { className: "sendbird-edit-user-profile__img__avatar-button", disableUnderline: true, onClick: function () { var _a; return (_a = hiddenInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } },
                React__default.createElement(Label, { type: LabelTypography.BUTTON_1, color: LabelColors.PRIMARY }, stringSet.EDIT_PROFILE__IMAGE_UPLOAD))),
        React__default.createElement("section", { className: "sendbird-edit-user-profile__name" },
            React__default.createElement(InputLabel, null, stringSet.EDIT_PROFILE__NICKNAME_LABEL),
            React__default.createElement(Input, { required: (user === null || user === void 0 ? void 0 : user.nickname) !== '', name: "sendbird-edit-user-profile__name__input", ref: inputRef, value: user === null || user === void 0 ? void 0 : user.nickname, placeHolder: stringSet.EDIT_PROFILE__NICKNAME_PLACEHOLDER })),
        React__default.createElement("section", { className: "sendbird-edit-user-profile__userid" },
            React__default.createElement(InputLabel, null, stringSet.EDIT_PROFILE__USERID_LABEL),
            React__default.createElement(Input, { disabled: true, name: "sendbird-edit-user-profile__userid__input", value: user === null || user === void 0 ? void 0 : user.userId })),
        React__default.createElement("section", { className: "sendbird-edit-user-profile__theme" },
            React__default.createElement(InputLabel, null, stringSet.EDIT_PROFILE__THEME_LABEL),
            React__default.createElement("div", { className: "sendbird-edit-user-profile__theme__theme-icon" }, theme === 'dark'
                ? (React__default.createElement(Icon, { onClick: function () {
                        setCurrentTheme('light');
                        onThemeChange === null || onThemeChange === void 0 ? void 0 : onThemeChange('light');
                    }, type: IconTypes.TOGGLE_ON, width: 44, height: 24 }))
                : (React__default.createElement(Icon, { onClick: function () {
                        setCurrentTheme('dark');
                        onThemeChange === null || onThemeChange === void 0 ? void 0 : onThemeChange('dark');
                    }, type: IconTypes.TOGGLE_OFF, width: 44, height: 24 }))))));
};

var handleUpdateUserInfo = function (_a) {
    var _b, _c, _d;
    var globalContext = _a.globalContext, formRef = _a.formRef, inputRef = _a.inputRef, profileImage = _a.profileImage, onEditProfile = _a.onEditProfile;
    var stores = globalContext.stores, dispatchers = globalContext.dispatchers;
    var sdk = stores.sdkStore.sdk;
    var user = stores.userStore.user;
    var userDispatcher = dispatchers.userDispatcher;
    if ((user === null || user === void 0 ? void 0 : user.nickname) !== '' && !inputRef.current.value) {
        (_c = (_b = formRef.current).reportValidity) === null || _c === void 0 ? void 0 : _c.call(_b); // might not work in explorer
        return;
    }
    sdk === null || sdk === void 0 ? void 0 : sdk.updateCurrentUserInfo({
        nickname: (_d = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _d === void 0 ? void 0 : _d.value,
        profileImage: profileImage !== null && profileImage !== void 0 ? profileImage : undefined,
    }).then(function (updatedUser) {
        userDispatcher({ type: USER_ACTIONS.UPDATE_USER_INFO, payload: updatedUser });
        onEditProfile === null || onEditProfile === void 0 ? void 0 : onEditProfile(updatedUser);
    });
};
var useEditUserProfileUISates = function (_a) {
    var onEditProfile = _a.onEditProfile;
    var globalContext = useSendbirdStateContext();
    var inputRef = useRef(null);
    var formRef = useRef(null);
    var _b = useState(null), profileImage = _b[0], setProfileImage = _b[1];
    var updateUserInfo = function () {
        handleUpdateUserInfo({
            globalContext: globalContext,
            formRef: formRef,
            inputRef: inputRef,
            profileImage: profileImage,
            onEditProfile: onEditProfile,
        });
    };
    return {
        formRef: formRef,
        inputRef: inputRef,
        updateUserInfo: updateUserInfo,
        profileImage: profileImage,
        setProfileImage: setProfileImage,
    };
};
var EditUserProfileUI_EditUserProfileUI = function () {
    var editProfileContext = useEditUserProfileContext();
    var onEditProfile = editProfileContext.onEditProfile, onCancel = editProfileContext.onCancel, onThemeChange = editProfileContext.onThemeChange;
    var stringSet = useContext(LocalizationContext).stringSet;
    var _a = useEditUserProfileUISates({ onEditProfile: onEditProfile }), formRef = _a.formRef, inputRef = _a.inputRef, updateUserInfo = _a.updateUserInfo, setProfileImage = _a.setProfileImage;
    return (React__default.createElement(Modal, { titleText: stringSet.EDIT_PROFILE__TITLE, submitText: stringSet.BUTTON__SAVE, type: ButtonTypes.PRIMARY, onCancel: onCancel, isFullScreenOnMobile: true, onSubmit: updateUserInfo },
        React__default.createElement(EditUserProfileUIView, { formRef: formRef, inputRef: inputRef, setProfileImage: setProfileImage, onThemeChange: onThemeChange })));
};


//# sourceMappingURL=EditUserProfileUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/EditUserProfile.js






































var EditUserProfile_EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};


//# sourceMappingURL=EditUserProfile.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/PlaceHolder.js
var ui_PlaceHolder = __webpack_require__(10364);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CtcQd9Ql.js
var bundle_CtcQd9Ql = __webpack_require__(18107);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BmCCzxjb.js



/**
 * Note: `leading` has higher priority rather than `trailing`
 * */
function bundle_BmCCzxjb_useThrottleCallback(callback, delay, options) {
    if (options === void 0) { options = {
        leading: true,
        trailing: false,
    }; }
    var timer = (0,react.useRef)(null);
    var trailingArgs = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        return function () {
            if (timer.current)
                clearTimeout(timer.current);
        };
    }, []);
    return (0,esm/* usePreservedCallback */.zS)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timer.current) {
            trailingArgs.current = args;
            return;
        }
        if (options.leading) {
            callback.apply(void 0, args);
        }
        else {
            trailingArgs.current = args;
        }
        var invoke = function () {
            if (options.trailing && trailingArgs.current) {
                callback.apply(void 0, trailingArgs.current);
                trailingArgs.current = null;
                timer.current = setTimeout(invoke, delay);
            }
            else {
                timer.current = null;
            }
        };
        timer.current = setTimeout(invoke, delay);
    });
}


//# sourceMappingURL=bundle-BmCCzxjb.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CxKIQVXi.js





var BUFFER_DELAY = 100;
function bundle_CxKIQVXi_useOnScrollPositionChangeDetector(params) {
    var onReachedTop = params.onReachedTop, onReachedBottom = params.onReachedBottom, onInBetween = params.onInBetween;
    var cb = usePreservedCallback(function (event) {
        if (event === null || event === void 0 ? void 0 : event.target) {
            var _a = event.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            var positionEvent = {
                distanceFromBottom: scrollHeight - scrollTop - clientHeight,
            };
            if (onReachedTop && isAboutSame(scrollTop, 0, SCROLL_BUFFER)) {
                onReachedTop(positionEvent);
            }
            else if (onReachedBottom && isAboutSame(scrollHeight, clientHeight + scrollTop, SCROLL_BUFFER)) {
                onReachedBottom(positionEvent);
            }
            else if (onInBetween) {
                onInBetween(positionEvent);
            }
        }
    });
    return useThrottleCallback(cb, BUFFER_DELAY, { trailing: true });
}


//# sourceMappingURL=bundle-CxKIQVXi.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CN0VQnSS.js







var bundle_CN0VQnSS_GroupChannelListUIView = function (_a) {
    var renderHeader = _a.renderHeader, renderPlaceHolderError = _a.renderPlaceHolderError, renderPlaceHolderLoading = _a.renderPlaceHolderLoading, renderPlaceHolderEmptyList = _a.renderPlaceHolderEmptyList, onChangeTheme = _a.onChangeTheme, onUserProfileUpdated = _a.onUserProfileUpdated, allowProfileEdit = _a.allowProfileEdit, channels = _a.channels, onLoadMore = _a.onLoadMore, initialized = _a.initialized, renderChannel = _a.renderChannel, renderAddChannel = _a.renderAddChannel;
    var _b = useState(false), showProfileEdit = _b[0], setShowProfileEdit = _b[1];
    var stores = useSendbirdStateContext().stores;
    var renderer = {
        addChannel: renderAddChannel,
        channel: renderChannel,
        placeholder: {
            loading: function () {
                if (initialized)
                    return null;
                if (renderPlaceHolderLoading)
                    return renderPlaceHolderLoading();
                return React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING });
            },
            empty: function () {
                if (!initialized)
                    return null;
                if (renderPlaceHolderEmptyList)
                    return renderPlaceHolderEmptyList();
                return React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.NO_CHANNELS });
            },
            error: function () {
                if (!initialized || !stores.sdkStore.error)
                    return null;
                if (renderPlaceHolderError)
                    return renderPlaceHolderError();
                return React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG });
            },
        },
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "sendbird-channel-list__header" }, (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || (React__default.createElement(GroupChannelListHeader, { onEdit: function () { return allowProfileEdit && setShowProfileEdit(true); }, allowProfileEdit: allowProfileEdit, renderIconButton: function () { return renderer.addChannel(); } }))),
        showProfileEdit && (React__default.createElement(EditUserProfile, { onThemeChange: onChangeTheme, onCancel: function () { return setShowProfileEdit(false); }, onEditProfile: function (user) {
                setShowProfileEdit(false);
                onUserProfileUpdated(user);
            } })),
        React__default.createElement(ChannelListComponent, { data: channels, renderItem: renderer.channel, onLoadMore: onLoadMore, placeholderLoading: renderer.placeholder.loading(), placeholderEmpty: renderer.placeholder.empty(), placeholderError: renderer.placeholder.error() })));
};
/**
 * To do: Implement windowing
 * Implement windowing if you are dealing with large number of messages/channels
 * https://github.com/bvaughn/react-window -> recommendation
 * We hesitate to bring one more dependency to our library,
 * we are planning to implement it inside the library
 * */
var ChannelListComponent = function (props) {
    var data = props.data, renderItem = props.renderItem, onLoadMore = props.onLoadMore, placeholderLoading = props.placeholderLoading, placeholderError = props.placeholderError, placeholderEmpty = props.placeholderEmpty;
    var onScroll = useOnScrollPositionChangeDetector({
        onReachedBottom: function () { return onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore(); },
    });
    return (React__default.createElement("div", { className: 'sendbird-channel-list__body', onScroll: onScroll },
        placeholderError,
        React__default.createElement("div", null, data.map(function (item, index) { return renderItem({ item: item, index: index }); })),
        placeholderLoading,
        data.length === 0 && placeholderEmpty));
};


//# sourceMappingURL=bundle-CN0VQnSS.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/components/GroupChannelPreviewAction.js





























var LeaveGroupChannel = function (_a) {
    var channel = _a.channel, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var config = useSendbirdStateContext().config;
    var logger = config.logger, isOnline = config.isOnline;
    var stringSet = useLocalization().stringSet;
    if (channel) {
        return (React__default.createElement(Modal, { disabled: !isOnline, onCancel: onCancel, onSubmit: function () {
                logger.info('LeaveGroupChannel: Leaving channel', channel);
                channel.leave().then(function () {
                    logger.info('LeaveGroupChannel: Leaving channel successful!', channel);
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                });
            }, submitText: stringSet.MODAL__LEAVE_CHANNEL__FOOTER, titleText: stringSet.MODAL__LEAVE_CHANNEL__TITLE }));
    }
};

function GroupChannelPreviewAction_GroupChannelPreviewAction(_a) {
    var channel = _a.channel, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onLeaveChannel = _a.onLeaveChannel;
    var parentRef = useRef(null);
    var parentContainerRef = useRef(null);
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    return (React__default.createElement("div", { ref: parentContainerRef, tabIndex: 0, role: "button", style: { display: 'inline-block' }, onKeyDown: function (e) { return e.stopPropagation(); }, onClick: function (e) { return e.stopPropagation(); } },
        React__default.createElement(ContextMenu, { menuTrigger: function (toggleDropdown) { return (React__default.createElement(IconButton, { ref: parentRef, onClick: toggleDropdown, height: "32px", width: "32px" },
                React__default.createElement(Icon, { type: IconTypes.MORE, fillColor: IconColors.PRIMARY, width: "24px", height: "24px" }))); }, menuItems: function (closeDropdown) { return (React__default.createElement(MenuItems, { parentRef: parentRef, parentContainRef: parentContainerRef, closeDropdown: closeDropdown },
                React__default.createElement(MenuItem, { onClick: function () {
                        if (disabled)
                            return;
                        setShowModal(true);
                        closeDropdown();
                    }, testID: "channel_list_item_context_menu_leave_channel" }, stringSet.CHANNEL_SETTING__LEAVE_CHANNEL__TITLE))); } }),
        showModal && (React__default.createElement(LeaveGroupChannel, { channel: channel, onSubmit: function () {
                setShowModal(false);
                onLeaveChannel === null || onLeaveChannel === void 0 ? void 0 : onLeaveChannel();
            }, onCancel: function () { return setShowModal(false); } }))));
}


//# sourceMappingURL=GroupChannelPreviewAction.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BX_znRDF.js
var bundle_BX_znRDF = __webpack_require__(95341);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CruP9bVM.js
var bundle_CruP9bVM = __webpack_require__(8627);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/TypingIndicator.js
var TypingIndicator = __webpack_require__(42443);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/Badge.js






function Badge_Badge(_a) {
    var count = _a.count, _b = _a.maxLevel, maxLevel = _b === void 0 ? 2 : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    var stringSet = useContext(LocalizationContext).stringSet;
    var maximumNumber = parseInt('9'.repeat(maxLevel > 6 ? 6 : maxLevel), 10);
    return (React__default.createElement("div", { className: __spreadArray(__spreadArray([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-badge',
        ], false).join(' ') },
        React__default.createElement("div", { className: "sendbird-badge__text" },
            React__default.createElement(Label, { type: LabelTypography.CAPTION_2, color: LabelColors.ONCONTENT_1 }, typeof count === 'string'
                ? count
                : count > maximumNumber
                    ? "".concat(maximumNumber).concat(stringSet.BADGE__OVER)
                    : count))));
}


//# sourceMappingURL=Badge.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ChannelAvatar.js
var ui_ChannelAvatar = __webpack_require__(80203);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/MentionUserLabel.js




function MentionUserLabel_MentionUserLabel(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.isReverse, isReverse = _c === void 0 ? false : _c, color = _a.color, userId = _a.userId;
    return (React__default.createElement("span", { className: classnames(MENTION_USER_LABEL_CLASSNAME, className, isReverse && 'reverse', color), contentEditable: false, "data-userid": userId, "data-sb-mention": true }, children));
}


//# sourceMappingURL=MentionUserLabel.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D7JevDoE.js
var bundle_D7JevDoE = __webpack_require__(1165);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-ZTcZWLri.js



















var bundle_ZTcZWLri_GroupChannelListItemView = function (_a) {
    var channel = _a.channel, tabIndex = _a.tabIndex, isTyping = _a.isTyping, isSelected = _a.isSelected, channelName = _a.channelName, _b = _a.isMessageStatusEnabled, isMessageStatusEnabled = _b === void 0 ? true : _b, _c = _a.onClick, onClick = _c === void 0 ? noop : _c, _d = _a.onLeaveChannel, onLeaveChannel = _d === void 0 ? function () { return Promise.resolve(); } : _d, renderChannelAction = _a.renderChannelAction;
    var config = useSendbirdStateContext().config;
    var theme = config.theme, userId = config.userId;
    var _e = useLocalization(), dateLocale = _e.dateLocale, stringSet = _e.stringSet;
    var isMobile = useMediaQueryContext().isMobile;
    var isMentionEnabled = config.groupChannel.enableMention;
    var lastMessage = getLastMessageText(channel, stringSet);
    var previewLastMessage = config.groupChannel.enableMarkdownForUserMessage
        ? getChannelPreviewMessage(lastMessage)
        : lastMessage;
    var _f = useState(false), showMobileLeave = _f[0], setShowMobileLeave = _f[1];
    var onLongPress = useLongPress({
        onLongPress: function () {
            if (isMobile) {
                setShowMobileLeave(true);
            }
        },
        onClick: onClick,
    }, {
        delay: 1000,
    });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", __assign({ className: [
                'sendbird-channel-preview',
                isSelected ? 'sendbird-channel-preview--active' : '',
            ].join(' '), role: "link", tabIndex: tabIndex }, (isMobile ? __assign({}, onLongPress) : { onClick: onClick })),
            React__default.createElement("div", { className: "sendbird-channel-preview__avatar" },
                React__default.createElement(ChannelAvatar, { channel: channel, userId: userId, theme: theme })),
            React__default.createElement("div", { className: "sendbird-channel-preview__content" },
                React__default.createElement("div", { className: "sendbird-channel-preview__content__upper" },
                    React__default.createElement("div", { className: "sendbird-channel-preview__content__upper__header" },
                        (channel.isBroadcast || false) && (React__default.createElement("div", { className: "sendbird-channel-preview__content__upper__header__broadcast-icon" },
                            React__default.createElement(Icon, { type: IconTypes.BROADCAST, fillColor: IconColors.SECONDARY, height: "16px", width: "16px" }))),
                        React__default.createElement(Label, { className: "sendbird-channel-preview__content__upper__header__channel-name", testID: "sendbird-channel-preview__content__upper__header__channel-name", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_1 }, channelName),
                        React__default.createElement(Label, { className: "sendbird-channel-preview__content__upper__header__total-members", type: LabelTypography.CAPTION_2, color: LabelColors.ONBACKGROUND_2 }, getTotalMembers(channel)),
                        (channel.isFrozen) && (React__default.createElement("div", { title: "Frozen", className: "sendbird-channel-preview__content__upper__header__frozen-icon" },
                            React__default.createElement(Icon, { type: IconTypes.FREEZE, fillColor: IconColors.PRIMARY, height: 12, width: 12 })))),
                    !channel.isEphemeral && isMessageStatusEnabled && (React__default.createElement(MessageStatus, { className: "sendbird-channel-preview__content__upper__last-message-at", channel: channel, message: channel.lastMessage, isDateSeparatorConsidered: false })),
                    !channel.isEphemeral && !isMessageStatusEnabled && (React__default.createElement(Label, { className: "sendbird-channel-preview__content__upper__last-message-at", type: LabelTypography.CAPTION_3, color: LabelColors.ONBACKGROUND_2 }, getLastMessageCreatedAt({
                        channel: channel,
                        locale: dateLocale,
                        stringSet: stringSet,
                    })))),
                React__default.createElement("div", { className: "sendbird-channel-preview__content__lower" },
                    React__default.createElement(Label, { className: "sendbird-channel-preview__content__lower__last-message", type: LabelTypography.BODY_2, color: LabelColors.ONBACKGROUND_3 },
                        isTyping && (React__default.createElement(TypingIndicatorText, { members: channel.getTypingUsers() })),
                        !isTyping
                            && !isVoiceMessage(channel.lastMessage)
                            && previewLastMessage,
                        !isTyping
                            && isVoiceMessage(channel.lastMessage)
                            && stringSet.VOICE_MESSAGE),
                    /**
                     * Do not show unread count for focused channel. This is because of the limitation where
                     * isScrollBottom and hasNext states needs to be added globally but they are from channel context
                     * so channel list cannot see them with the current architecture.
                     */
                    !isSelected && !channel.isEphemeral && (React__default.createElement("div", { className: "sendbird-channel-preview__content__lower__unread-message-count" },
                        isMentionEnabled && channel.unreadMentionCount > 0 ? (React__default.createElement(MentionUserLabel, { className: "sendbird-channel-preview__content__lower__unread-message-count__mention", color: "purple" }, '@')) : null,
                        getChannelUnreadMessageCount(channel) ? ( // return number
                        React__default.createElement(Badge, { count: getChannelUnreadMessageCount(channel) })) : null)))),
            !isMobile && (React__default.createElement("div", { className: "sendbird-channel-preview__action" }, renderChannelAction({ channel: channel })))),
        showMobileLeave && isMobile && (React__default.createElement(Modal, { className: "sendbird-channel-preview__leave--mobile", titleText: channelName, hideFooter: true, isCloseOnClickOutside: true, onCancel: function () { return setShowMobileLeave(false); } },
            React__default.createElement(TextButton, { onClick: function () {
                    onLeaveChannel();
                    setShowMobileLeave(false);
                }, className: "sendbird-channel-preview__leave-label--mobile" },
                React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.CHANNEL_PREVIEW_MOBILE_LEAVE))))));
};


//# sourceMappingURL=bundle-ZTcZWLri.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-QTCuDZTl.js
var bundle_QTCuDZTl = __webpack_require__(75010);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Loader.js
var ui_Loader = __webpack_require__(72661);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CmKxC8hb.js
var bundle_CmKxC8hb = __webpack_require__(25528);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/components/GroupChannelListItem.js



















































var GroupChannelListItem_GroupChannelListItem = function (_a) {
    var _b, _c, _d;
    var channel = _a.channel, isSelected = _a.isSelected, isTyping = _a.isTyping, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbirdStateContext().config;
    var stringSet = useLocalization().stringSet;
    var _e = useGroupChannelListContext(), _f = _e.isTypingIndicatorEnabled, isTypingIndicatorEnabled = _f === void 0 ? false : _f, _g = _e.isMessageReceiptStatusEnabled, isMessageReceiptStatusEnabled = _g === void 0 ? false : _g;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (!((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.isAdminMessage()))
        && ((_d = (_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, channelName: getChannelTitle(channel, userId, stringSet), isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected, isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};


//# sourceMappingURL=GroupChannelListItem.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/sendbirdSelectors.js
var sendbirdSelectors = __webpack_require__(22284);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CU6kTo_I.js




var bundle_CU6kTo_I_CHANNEL_TYPE;
(function (CHANNEL_TYPE) {
    CHANNEL_TYPE["GROUP"] = "group";
    CHANNEL_TYPE["SUPERGROUP"] = "supergroup";
    CHANNEL_TYPE["BROADCAST"] = "broadcast";
})(bundle_CU6kTo_I_CHANNEL_TYPE || (bundle_CU6kTo_I_CHANNEL_TYPE = {}));

var CreateChannelContext = react.createContext(null);
var bundle_CU6kTo_I_CreateChannelProvider = function (props) {
    var _a;
    var children = props.children, onCreateChannelClick = props.onCreateChannelClick, onBeforeCreateChannel = props.onBeforeCreateChannel, onChannelCreated = props.onChannelCreated, userListQuery = props.userListQuery, onCreateChannel = props.onCreateChannel, overrideInviteUser = props.overrideInviteUser;
    var store = useSendbirdStateContext();
    var _userListQuery = userListQuery !== null && userListQuery !== void 0 ? userListQuery : (_a = store === null || store === void 0 ? void 0 : store.config) === null || _a === void 0 ? void 0 : _a.userListQuery;
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var _c = useState(bundle_CU6kTo_I_CHANNEL_TYPE.GROUP), type = _c[0], setType = _c[1];
    return (React__default.createElement(CreateChannelContext.Provider, { value: {
            sdk: store.stores.sdkStore.sdk,
            createChannel: getCreateGroupChannel(store),
            onCreateChannelClick: onCreateChannelClick,
            onBeforeCreateChannel: onBeforeCreateChannel,
            onChannelCreated: onChannelCreated,
            userListQuery: _userListQuery,
            step: step,
            setStep: setStep,
            type: type,
            setType: setType,
            onCreateChannel: onCreateChannel,
            overrideInviteUser: overrideInviteUser,
        } }, children));
};
var bundle_CU6kTo_I_useCreateChannelContext = function () {
    var context = React__default.useContext(CreateChannelContext);
    if (!context)
        throw new Error('CreateChannelContext not found. Use within the CreateChannel module.');
    return context;
};


//# sourceMappingURL=bundle-CU6kTo_I.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UserListItem.js
var ui_UserListItem = __webpack_require__(56842);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DRlnZqdp.js
var bundle_DRlnZqdp = __webpack_require__(80031);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MutedAvatarOverlay.js
var MutedAvatarOverlay = __webpack_require__(67412);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Checkbox.js
var Checkbox = __webpack_require__(10856);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UserProfile.js
var UserProfile = __webpack_require__(13462);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/CreateChannel/components/InviteUsers.js








































var filterUser = function (idsToFilter) { return function (currentId) { return idsToFilter === null || idsToFilter === void 0 ? void 0 : idsToFilter.includes(currentId); }; };
var setChannelType = function (params, type) {
    if (type === 'broadcast') {
        // eslint-disable-next-line no-param-reassign
        params.isBroadcast = true;
    }
    if (type === 'supergroup') {
        // eslint-disable-next-line no-param-reassign
        params.isSuper = true;
    }
    return params;
};
var createDefaultUserListQuery = function (_a) {
    var sdk = _a.sdk, userFilledApplicationUserListQuery = _a.userFilledApplicationUserListQuery;
    var params = sdk.createApplicationUserListQuery();
    if (userFilledApplicationUserListQuery) {
        Object.keys(userFilledApplicationUserListQuery).forEach(function (key) {
            // @ts-ignore
            params[key] = userFilledApplicationUserListQuery[key];
        });
    }
    return params;
};

var BUFFER = 50;
var InviteUsers_InviteUsers = function (_a) {
    var _b, _c, _d;
    var onCancel = _a.onCancel, userListQuery = _a.userListQuery;
    var _e = useCreateChannelContext(), onCreateChannelClick = _e.onCreateChannelClick, onBeforeCreateChannel = _e.onBeforeCreateChannel, onChannelCreated = _e.onChannelCreated, createChannel = _e.createChannel, onCreateChannel = _e.onCreateChannel, overrideInviteUser = _e.overrideInviteUser, type = _e.type;
    var globalStore = useSendbirdStateContext();
    var userId = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _b === void 0 ? void 0 : _b.userId;
    var sdk = (_d = (_c = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _c === void 0 ? void 0 : _c.sdkStore) === null || _d === void 0 ? void 0 : _d.sdk;
    var idsToFilter = [userId];
    var _f = useState([]), users = _f[0], setUsers = _f[1];
    var _g = useState({}), selectedUsers = _g[0], setSelectedUsers = _g[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var _h = useState(null), usersDataSource = _h[0], setUsersDataSource = _h[1];
    var selectedCount = Object.keys(selectedUsers).length;
    var titleText = stringSet.MODAL__CREATE_CHANNEL__TITLE;
    var submitText = stringSet.BUTTON__CREATE;
    var isMobile = useMediaQueryContext().isMobile;
    var _j = useState(window.innerHeight), scrollableAreaHeight = _j[0], setScrollableAreaHeight = _j[1];
    useEffect(function () {
        var applicationUserListQuery = userListQuery ? userListQuery() : createDefaultUserListQuery({ sdk: sdk });
        setUsersDataSource(applicationUserListQuery);
        if (!(applicationUserListQuery === null || applicationUserListQuery === void 0 ? void 0 : applicationUserListQuery.isLoading)) {
            applicationUserListQuery.next().then(function (it) {
                setUsers(it);
            });
        }
    }, []);
    // To fix navbar break in mobile we set dynamic height to the scrollable area
    useEffect(function () {
        var scrollableAreaHeight = function () {
            setScrollableAreaHeight(window.innerHeight);
        };
        window.addEventListener('resize', scrollableAreaHeight);
        return function () {
            window.removeEventListener('resize', scrollableAreaHeight);
        };
    }, []);
    return (React__default.createElement(Modal, { isFullScreenOnMobile: true, titleText: titleText, submitText: submitText, type: ButtonTypes.PRIMARY, 
        // Disable the create button if no users are selected,
        // but if there's only the logged-in user in the user list,
        // then the create button should be enabled
        disabled: users.length > 1 && Object.keys(selectedUsers).length === 0, onCancel: onCancel, onSubmit: function () {
            var selectedUserList = Object.keys(selectedUsers).length > 0
                ? Object.keys(selectedUsers)
                : [userId];
            var _onChannelCreated = onChannelCreated !== null && onChannelCreated !== void 0 ? onChannelCreated : onCreateChannel;
            var _onCreateChannelClick = onCreateChannelClick !== null && onCreateChannelClick !== void 0 ? onCreateChannelClick : overrideInviteUser;
            if (typeof _onCreateChannelClick === 'function') {
                _onCreateChannelClick({
                    users: selectedUserList,
                    onClose: onCancel !== null && onCancel !== void 0 ? onCancel : noop,
                    channelType: type,
                });
                return;
            }
            if (onBeforeCreateChannel) {
                var params = onBeforeCreateChannel(selectedUserList);
                setChannelType(params, type);
                createChannel(params).then(function (channel) { return _onChannelCreated === null || _onChannelCreated === void 0 ? void 0 : _onChannelCreated(channel); });
            }
            else {
                var params = {};
                params.invitedUserIds = selectedUserList;
                params.isDistinct = false;
                if (userId) {
                    params.operatorUserIds = [userId];
                }
                setChannelType(params, type);
                // do not have custom params
                createChannel(params).then(function (channel) { return _onChannelCreated === null || _onChannelCreated === void 0 ? void 0 : _onChannelCreated(channel); });
            }
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        } },
        React__default.createElement("div", null,
            React__default.createElement(Label, { color: (selectedCount > 0) ? LabelColors.PRIMARY : LabelColors.ONBACKGROUND_3, type: LabelTypography.CAPTION_1 }, "".concat(selectedCount, " ").concat(stringSet.MODAL__INVITE_MEMBER__SELECTED)),
            React__default.createElement("div", { className: "sendbird-create-channel--scroll", style: isMobile ? { height: "calc(".concat(scrollableAreaHeight, "px - 200px)") } : {}, onScroll: function (e) {
                    if (!usersDataSource)
                        return;
                    var eventTarget = e.target;
                    var hasNext = usersDataSource.hasNext, isLoading = usersDataSource.isLoading;
                    var fetchMore = ((eventTarget.clientHeight + eventTarget.scrollTop + BUFFER) > eventTarget.scrollHeight);
                    if (hasNext && fetchMore && !isLoading) {
                        usersDataSource.next().then(function (usersBatch) {
                            setUsers(__spreadArray(__spreadArray([], users, true), usersBatch, true));
                        });
                    }
                } }, users.map(function (user) { return (!filterUser(idsToFilter)(user.userId)) && (React__default.createElement(UserListItem, { key: user.userId, user: user, checkBox: true, checked: selectedUsers[user.userId], onChange: function (event) {
                    var _a;
                    var modifiedSelectedUsers = __assign(__assign({}, selectedUsers), (_a = {}, _a[event.target.id] = event.target.checked, _a));
                    if (!event.target.checked) {
                        delete modifiedSelectedUsers[event.target.id];
                    }
                    setSelectedUsers(modifiedSelectedUsers);
                } })); })))));
};


//# sourceMappingURL=InviteUsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/CreateChannel/components/SelectChannelType.js
































var isBroadcastChannelEnabled = function (sdk) {
    var _a;
    var ALLOW_BROADCAST_CHANNEL = 'allow_broadcast_channel';
    var applicationAttributes = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.applicationAttributes;
    if (Array.isArray(applicationAttributes)) {
        return applicationAttributes.includes(ALLOW_BROADCAST_CHANNEL);
    }
    return false;
};
var isSuperGroupChannelEnabled = function (sdk) {
    var _a;
    var ALLOW_SUPER_GROUP_CHANNEL = 'allow_super_group_channel';
    var applicationAttributes = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.applicationAttributes;
    if (Array.isArray(applicationAttributes)) {
        return applicationAttributes.includes(ALLOW_SUPER_GROUP_CHANNEL);
    }
    return false;
};

var SelectChannelType_SelectChannelType = function (props) {
    var onCancel = props.onCancel;
    var store = useSendbirdStateContext();
    var sdk = getSdk(store);
    var createChannelProps = useCreateChannelContext();
    var setStep = createChannelProps.setStep, setType = createChannelProps.setType;
    var stringSet = useContext(LocalizationContext).stringSet;
    var isBroadcastAvailable = isBroadcastChannelEnabled(sdk);
    var isSupergroupAvailable = isSuperGroupChannelEnabled(sdk);
    return (React__default.createElement(Modal, { titleText: stringSet === null || stringSet === void 0 ? void 0 : stringSet.MODAL__CREATE_CHANNEL__TITLE, hideFooter: true, onCancel: function () { onCancel === null || onCancel === void 0 ? void 0 : onCancel(); }, className: "sendbird-add-channel__modal" },
        React__default.createElement("div", { className: "sendbird-add-channel__rectangle-wrap" },
            React__default.createElement("div", { className: "sendbird-add-channel__rectangle", onClick: function () {
                    setType(CHANNEL_TYPE.GROUP);
                    setStep(1);
                }, role: "button", tabIndex: 0, onKeyDown: function () {
                    setType(CHANNEL_TYPE.GROUP);
                    setStep(1);
                } },
                React__default.createElement(Icon, { className: "sendbird-add-channel__rectangle__chat-icon", type: IconTypes.CHAT, fillColor: IconColors.PRIMARY, width: "28px", height: "28px" }),
                React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.MODAL__CREATE_CHANNEL__GROUP)),
            isSupergroupAvailable && (React__default.createElement("div", { className: "sendbird-add-channel__rectangle", onClick: function () {
                    setType(CHANNEL_TYPE.SUPERGROUP);
                    setStep(1);
                }, role: "button", tabIndex: 0, onKeyDown: function () {
                    setType(CHANNEL_TYPE.SUPERGROUP);
                    setStep(1);
                } },
                React__default.createElement(Icon, { className: "sendbird-add-channel__rectangle__supergroup-icon", type: IconTypes.SUPERGROUP, fillColor: IconColors.PRIMARY, width: "28px", height: "28px" }),
                React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.MODAL__CREATE_CHANNEL__SUPER))),
            isBroadcastAvailable && (React__default.createElement("div", { className: "sendbird-add-channel__rectangle", onClick: function () {
                    setType(CHANNEL_TYPE.BROADCAST);
                    setStep(1);
                }, role: "button", tabIndex: 0, onKeyDown: function () {
                    setType(CHANNEL_TYPE.BROADCAST);
                    setStep(1);
                } },
                React__default.createElement(Icon, { className: "sendbird-add-channel__rectangle__broadcast-icon", type: IconTypes.BROADCAST, fillColor: IconColors.PRIMARY, width: "28px", height: "28px" }),
                React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.MODAL__CREATE_CHANNEL__BROADCAST))))));
};


//# sourceMappingURL=SelectChannelType.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/CreateChannel/components/CreateChannelUI.js










































var CreateChannelUI_CreateChannel = function (props) {
    var onCancel = props.onCancel, renderStepOne = props.renderStepOne;
    var _a = useCreateChannelContext(), step = _a.step, setStep = _a.setStep, userListQuery = _a.userListQuery;
    return (React__default.createElement(React__default.Fragment, null,
        step === 0 && ((renderStepOne === null || renderStepOne === void 0 ? void 0 : renderStepOne()) || (React__default.createElement(SelectChannelType, { onCancel: onCancel }))),
        step === 1 && (React__default.createElement(InviteUsers, { userListQuery: userListQuery, onCancel: function () {
                setStep(0);
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            } }))));
};


//# sourceMappingURL=CreateChannelUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/CreateChannel.js











































var CreateChannel_CreateChannel = function (props) {
    return (React__default.createElement(CreateChannelProvider, __assign({}, props),
        React__default.createElement(CreateChannel$1, __assign({}, props))));
};


//# sourceMappingURL=CreateChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DYrU3olW.js






var bundle_DYrU3olW_AddGroupChannelView = function (_a) {
    var createChannelVisible = _a.createChannelVisible, onChangeCreateChannelVisible = _a.onChangeCreateChannelVisible, onBeforeCreateChannel = _a.onBeforeCreateChannel, onCreateChannelClick = _a.onCreateChannelClick, onChannelCreated = _a.onChannelCreated;
    var config = useSendbirdStateContext().config;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(IconButton, { height: '32px', width: '32px', disabled: !config.isOnline, onClick: function () { return onChangeCreateChannelVisible(true); } },
            React__default.createElement(Icon, { type: IconTypes.CREATE, fillColor: IconColors.PRIMARY, width: '24px', height: '24px' })),
        createChannelVisible && (React__default.createElement(CreateChannel, { onCancel: function () { return onChangeCreateChannelVisible(false); }, onChannelCreated: function (channel) {
                onChannelCreated === null || onChannelCreated === void 0 ? void 0 : onChannelCreated(channel);
                onChangeCreateChannelVisible(false);
            }, onBeforeCreateChannel: onBeforeCreateChannel, onCreateChannelClick: onCreateChannelClick }))));
};


//# sourceMappingURL=bundle-DYrU3olW.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/components/AddGroupChannel.js















































var AddGroupChannel_AddGroupChannel = function () {
    var _a = useState(false), createChannelVisible = _a[0], setCreateChannelVisible = _a[1];
    var _b = useGroupChannelListContext(), onChannelCreated = _b.onChannelCreated, onBeforeCreateChannel = _b.onBeforeCreateChannel, onCreateChannelClick = _b.onCreateChannelClick;
    return (React__default.createElement(AddGroupChannelView, { createChannelVisible: createChannelVisible, onChangeCreateChannelVisible: setCreateChannelVisible, onCreateChannelClick: onCreateChannelClick, onBeforeCreateChannel: onBeforeCreateChannel, onChannelCreated: onChannelCreated }));
};


//# sourceMappingURL=AddGroupChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList/components/GroupChannelListUI.js















































































var GroupChannelListUI_GroupChannelListUI = function (props) {
    var renderHeader = props.renderHeader, renderChannelPreview = props.renderChannelPreview, renderPlaceHolderError = props.renderPlaceHolderError, renderPlaceHolderLoading = props.renderPlaceHolderLoading, renderPlaceHolderEmptyList = props.renderPlaceHolderEmptyList;
    var _a = useGroupChannelListContext(), onChannelSelect = _a.onChannelSelect, onThemeChange = _a.onThemeChange, allowProfileEdit = _a.allowProfileEdit, typingChannelUrls = _a.typingChannelUrls, groupChannels = _a.groupChannels, initialized = _a.initialized, selectedChannelUrl = _a.selectedChannelUrl, loadMore = _a.loadMore, onUserProfileUpdated = _a.onUserProfileUpdated;
    var _b = useSendbirdStateContext(), stores = _b.stores, config = _b.config;
    var logger = config.logger, isOnline = config.isOnline;
    var sdk = stores.sdkStore.sdk;
    var renderListItem = function (renderProps) {
        var channel = renderProps.item, index = renderProps.index;
        var itemProps = {
            channel: channel,
            tabIndex: index,
            isSelected: channel.url === selectedChannelUrl,
            isTyping: typingChannelUrls.includes(channel.url),
            renderChannelAction: function (props) { return React__default.createElement(GroupChannelPreviewAction, __assign({}, props)); },
            onClick: function () {
                if (isOnline || (sdk === null || sdk === void 0 ? void 0 : sdk.isCacheEnabled)) {
                    logger.info('ChannelList: Clicked on channel:', channel);
                    onChannelSelect(channel);
                }
                else {
                    logger.warning('ChannelList: Inactivated clicking channel item during offline.');
                }
            },
            onLeaveChannel: function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                logger.info('ChannelList: Leaving channel', channel);
                                return [4 /*yield*/, channel.leave()];
                            case 1:
                                _a.sent();
                                logger.info('ChannelList: Leaving channel success');
                                return [2 /*return*/];
                        }
                    });
                });
            },
        };
        if (renderChannelPreview) {
            return (React__default.createElement("div", { key: channel.url, onClick: itemProps.onClick }, renderChannelPreview(itemProps)));
        }
        return React__default.createElement(GroupChannelListItem, __assign({ key: channel.url }, itemProps));
    };
    return (React__default.createElement(GroupChannelListUIView, { renderHeader: renderHeader, renderChannel: renderListItem, renderPlaceHolderError: renderPlaceHolderError, renderPlaceHolderLoading: renderPlaceHolderLoading, renderPlaceHolderEmptyList: renderPlaceHolderEmptyList, onChangeTheme: onThemeChange !== null && onThemeChange !== void 0 ? onThemeChange : noop, allowProfileEdit: allowProfileEdit, onUserProfileUpdated: onUserProfileUpdated !== null && onUserProfileUpdated !== void 0 ? onUserProfileUpdated : noop, channels: groupChannels, onLoadMore: loadMore, initialized: initialized, renderAddChannel: function () { return React__default.createElement(AddGroupChannel, null); } }));
};


//# sourceMappingURL=GroupChannelListUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/GroupChannelList.js
















































































var GroupChannelList_GroupChannelList = function (props) {
    return (React__default.createElement(GroupChannelListProvider, __assign({}, props),
        React__default.createElement(GroupChannelListUI, __assign({}, props))));
};


//# sourceMappingURL=GroupChannelList.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-C6DfLTJj.js
var bundle_C6DfLTJj = __webpack_require__(48614);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DKR-710v.js
var bundle_DKR_710v = __webpack_require__(74531);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CCJRc28C.js







// For legacy
// These are not used for collections(GroupChannel)
var bundle_CCJRc28C_PREV_RESULT_SIZE = 30;
var bundle_CCJRc28C_NEXT_RESULT_SIZE = 15;

function bundle_CCJRc28C_useInitialMessagesFetch(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, initialTimeStamp = _a.initialTimeStamp, userFilledMessageListQuery = _a.userFilledMessageListQuery, replyType = _a.replyType, setIsScrolled = _a.setIsScrolled;
    var logger = _b.logger, scrollRef = _b.scrollRef, messagesDispatcher = _b.messagesDispatcher;
    var channelUrl = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url;
    /**
     * useCallback(() => {}, [currentGroupChannel]) was buggy, that is why we did
     * const channelUrl = currentGroupChannel && currentGroupChannel.url;
     * useCallback(() => {}, [channelUrl])
     * Again, this hook is supposed to execute when currentGroupChannel changes
     * The 'channelUrl' here is not the same memory reference from Conversation.props
     */
    var fetchMessages = useCallback(function () {
        logger.info('Channel useInitialMessagesFetch: Setup started', currentGroupChannel);
        setIsScrolled(false);
        messagesDispatcher({
            type: RESET_MESSAGES,
            payload: null,
        });
        if (currentGroupChannel && (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.getMessagesByTimestamp)) {
            var messageListParams_1 = {
                prevResultSize: bundle_CCJRc28C_PREV_RESULT_SIZE,
                isInclusive: true,
                includeReactions: true,
                includeMetaArray: true,
            };
            if (initialTimeStamp) {
                messageListParams_1.nextResultSize = bundle_CCJRc28C_NEXT_RESULT_SIZE;
            }
            if (replyType === 'QUOTE_REPLY' || replyType === 'THREAD') {
                messageListParams_1.includeThreadInfo = true;
                messageListParams_1.includeParentMessageInfo = true;
                messageListParams_1.replyType = ReplyType.ONLY_REPLY_TO_CHANNEL;
            }
            if (userFilledMessageListQuery) {
                Object.keys(userFilledMessageListQuery).forEach(function (key) {
                    // @ts-ignore
                    messageListParams_1[key] = userFilledMessageListQuery[key];
                });
            }
            if ((replyType
                && (replyType === 'QUOTE_REPLY' || replyType === 'THREAD'))
                || userFilledMessageListQuery) {
                logger.info('Channel useInitialMessagesFetch: Setup messageListParams', messageListParams_1);
                messagesDispatcher({
                    type: MESSAGE_LIST_PARAMS_CHANGED,
                    payload: messageListParams_1,
                });
            }
            logger.info('Channel: Fetching messages', { currentGroupChannel: currentGroupChannel, userFilledMessageListQuery: userFilledMessageListQuery });
            messagesDispatcher({
                type: FETCH_INITIAL_MESSAGES_START,
                payload: null,
            });
            currentGroupChannel
                .getMessagesByTimestamp(initialTimeStamp || new Date().getTime(), messageListParams_1)
                .then(function (messages) {
                messagesDispatcher({
                    type: FETCH_INITIAL_MESSAGES_SUCCESS,
                    payload: {
                        currentGroupChannel: currentGroupChannel,
                        messages: messages,
                    },
                });
            })
                .catch(function (error) {
                logger.error('Channel: Fetching messages failed', error);
                messagesDispatcher({
                    type: FETCH_INITIAL_MESSAGES_FAILURE,
                    payload: { currentGroupChannel: currentGroupChannel },
                });
            })
                .finally(function () {
                if (!initialTimeStamp) {
                    setTimeout(function () { return scrollIntoLast(0, scrollRef, setIsScrolled); }, SCROLL_BOTTOM_DELAY_FOR_FETCH);
                }
                else {
                    setTimeout(function () {
                        scrollToRenderedMessage(scrollRef, initialTimeStamp, setIsScrolled);
                    }, 500);
                }
            });
        }
    }, [channelUrl, userFilledMessageListQuery, initialTimeStamp]);
    useEffect(function () {
        fetchMessages();
    }, [fetchMessages]);
    return fetchMessages;
}


//# sourceMappingURL=bundle-CCJRc28C.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-lJZ9BTB_.js


function bundle_lJZ9BTB_useReconnectOnIdle(isOnline, currentGroupChannel, reconnectOnIdle) {
    if (reconnectOnIdle === void 0) { reconnectOnIdle = true; }
    var _a = useState(false), isTabHidden = _a[0], setIsTabHidden = _a[1];
    var wasOffline = !isOnline;
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (reconnectOnIdle) {
                setIsTabHidden(document.hidden);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [reconnectOnIdle, document.hidden]);
    var shouldReconnect = wasOffline && !!currentGroupChannel && !isTabHidden;
    return { shouldReconnect: shouldReconnect };
}


//# sourceMappingURL=bundle-lJZ9BTB_.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BApwq9D9.js
var bundle_BApwq9D9 = __webpack_require__(38204);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CDvkkTNs.js
var bundle_CDvkkTNs = __webpack_require__(13566);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/context.js












































var context_initialState = {
    initialized: false,
    loading: true,
    allMessages: [],
    /**
     * localMessages: pending & failed messages
     */
    localMessages: [],
    currentGroupChannel: null,
    // for scrollup
    hasMorePrev: false,
    oldestMessageTimeStamp: 0,
    // for scroll down
    // onScrollDownCallback is added for navigation to different timestamps on messageSearch
    // hasMorePrev, onScrollCallback -> scroll up(default behavior)
    // hasMoreNext, onScrollDownCallback -> scroll down
    hasMoreNext: false,
    latestMessageTimeStamp: 0,
    emojiContainer: { emojiCategories: [], emojiHash: '' },
    /** @deprecated Please use `unreadSinceDate` instead. * */
    unreadSince: null,
    /**
     * unreadSinceDate is a date information about message unread.
     * It's used only for the {unreadSinceDate && <UnreadCount unreadSinceDate={unreadSinceDate} />}
     */
    unreadSinceDate: null,
    isInvalid: false,
    readStatus: null,
    messageListParams: null,
    typingMembers: [],
};

var getOldestMessageTimeStamp = function (messages) {
    if (messages === void 0) { messages = []; }
    var oldestMessage = messages[0];
    return (oldestMessage && oldestMessage.createdAt) || null;
};
var getLatestMessageTimeStamp = function (messages) {
    if (messages === void 0) { messages = []; }
    var latestMessage = messages[messages.length - 1];
    return (latestMessage && latestMessage.createdAt) || null;
};
function hasReqId(message) {
    return 'reqId' in message;
}
function channelReducer(state, action) {
    var stringSet = useLocalization().stringSet;
    return K(action)
        .with({ type: RESET_MESSAGES }, function () {
        return __assign(__assign({}, state), { 
            // when user switches channel, if the previous channel `hasMorePrev`
            // the onScroll gets called twice, setting hasMorePrev false prevents this
            hasMorePrev: false, hasMoreNext: false, allMessages: [], localMessages: [] });
    })
        .with({ type: FETCH_INITIAL_MESSAGES_START }, function () {
        return __assign(__assign({}, state), { loading: true, allMessages: state.allMessages.filter(function (m) { return isSendableMessage(m)
                ? m.sendingStatus !== SendingStatus.SUCCEEDED
                : true; }), localMessages: [] });
    })
        .with({ type: FETCH_INITIAL_MESSAGES_SUCCESS }, function (action) {
        var _a;
        var _b = action.payload, currentGroupChannel = _b.currentGroupChannel, messages = _b.messages;
        if (!((currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) === ((_a = state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url))) {
            return state;
        }
        var oldestMessageTimeStamp = getOldestMessageTimeStamp(messages);
        var latestMessageTimeStamp = getLatestMessageTimeStamp(messages);
        return __assign(__assign({}, state), { loading: false, initialized: true, hasMorePrev: true, hasMoreNext: true, oldestMessageTimeStamp: oldestMessageTimeStamp, latestMessageTimeStamp: latestMessageTimeStamp, allMessages: __spreadArray([], messages, true) });
    })
        .with({ type: FETCH_PREV_MESSAGES_SUCCESS }, function (action) {
        var _a, _b, _c, _d;
        var _e = action.payload, currentGroupChannel = _e.currentGroupChannel, messages = _e.messages;
        if (!((currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) === ((_a = state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url))) {
            return state;
        }
        var hasMorePrev = ((_b = messages === null || messages === void 0 ? void 0 : messages.length) !== null && _b !== void 0 ? _b : 0)
            >= ((_d = (_c = state === null || state === void 0 ? void 0 : state.messageListParams) === null || _c === void 0 ? void 0 : _c.prevResultSize) !== null && _d !== void 0 ? _d : PREV_RESULT_SIZE) + 1;
        var oldestMessageTimeStamp = getOldestMessageTimeStamp(messages);
        // Remove duplicated messages
        var duplicatedMessageIds = [];
        var updatedOldMessages = state.allMessages.map(function (msg) {
            var duplicatedMessage = messages.find(function (_a) {
                var messageId = _a.messageId;
                return compareIds(messageId, msg.messageId);
            });
            if (!duplicatedMessage) {
                return msg;
            }
            duplicatedMessageIds.push(duplicatedMessage.messageId);
            return duplicatedMessage.updatedAt > msg.updatedAt
                ? duplicatedMessage
                : msg;
        });
        var filteredNewMessages = duplicatedMessageIds.length > 0
            ? messages.filter(function (msg) { return !duplicatedMessageIds.find(function (messageId) { return compareIds(messageId, msg.messageId); }); })
            : messages;
        return __assign(__assign({}, state), { hasMorePrev: hasMorePrev, oldestMessageTimeStamp: oldestMessageTimeStamp, allMessages: __spreadArray(__spreadArray([], filteredNewMessages, true), updatedOldMessages, true) });
    })
        .with({ type: FETCH_NEXT_MESSAGES_SUCCESS }, function (action) {
        var _a, _b, _c, _d;
        var _e = action.payload, currentGroupChannel = _e.currentGroupChannel, messages = _e.messages;
        if (!((currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) === ((_a = state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url))) {
            return state;
        }
        var hasMoreNext = ((_b = messages === null || messages === void 0 ? void 0 : messages.length) !== null && _b !== void 0 ? _b : 0)
            === ((_d = (_c = state === null || state === void 0 ? void 0 : state.messageListParams) === null || _c === void 0 ? void 0 : _c.nextResultSize) !== null && _d !== void 0 ? _d : NEXT_RESULT_SIZE) + 1;
        var latestMessageTimeStamp = getLatestMessageTimeStamp(messages);
        // sort ~
        var sortedMessages = mergeAndSortMessages(state.allMessages, messages);
        return __assign(__assign({}, state), { hasMoreNext: hasMoreNext, latestMessageTimeStamp: latestMessageTimeStamp, allMessages: sortedMessages });
    })
        .with({
        type: S.union(FETCH_INITIAL_MESSAGES_FAILURE, FETCH_PREV_MESSAGES_FAILURE, FETCH_NEXT_MESSAGES_FAILURE),
    }, function (action) {
        var _a;
        var currentGroupChannel = action.payload.currentGroupChannel;
        if ((currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) !== ((_a = state === null || state === void 0 ? void 0 : state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url))
            return state;
        // It shows something went wrong screen when fetching initial messages failed.
        var shouldInvalid = [FETCH_INITIAL_MESSAGES_FAILURE].includes(action.type);
        return __assign(__assign({}, state), { loading: false, isInvalid: shouldInvalid, initialized: false, allMessages: [], hasMorePrev: false, hasMoreNext: false, oldestMessageTimeStamp: null, latestMessageTimeStamp: null });
    })
        .with({ type: SEND_MESSAGE_START }, function (action) {
        // Message should not be spread here
        // it will loose some methods like `isUserMessage`
        return __assign(__assign({}, state), { localMessages: __spreadArray(__spreadArray([], state.localMessages, true), [action.payload], false) });
    })
        .with({ type: SEND_MESSAGE_SUCCESS }, function (action) {
        var message = action.payload;
        /**
         * Admin messages do not have reqId. We need to include them.
         */
        var filteredMessages = state.allMessages.filter(function (m) { return !hasReqId(m) || (m === null || m === void 0 ? void 0 : m.reqId) !== (message === null || message === void 0 ? void 0 : message.reqId); });
        // [Policy] Pending messages and failed messages
        // must always be at the end of the message list
        return __assign(__assign({}, state), { allMessages: __spreadArray(__spreadArray([], filteredMessages, true), [message], false), localMessages: state.localMessages.filter(function (m) { return hasReqId(m) && (m === null || m === void 0 ? void 0 : m.reqId) !== (message === null || message === void 0 ? void 0 : message.reqId); }) });
    })
        .with({ type: SEND_MESSAGE_FAILURE }, function (action) {
        // @ts-ignore
        action.payload.failed = true;
        return __assign(__assign({}, state), { localMessages: state.localMessages.map(function (m) { return compareIds(hasReqId(m) && m.reqId, action.payload.reqId)
                ? action.payload
                : m; }) });
    })
        .with({ type: SET_CURRENT_CHANNEL }, function (action) {
        return __assign(__assign({}, state), { currentGroupChannel: action.payload, isInvalid: false });
    })
        .with({ type: SET_CHANNEL_INVALID }, function () {
        return __assign(__assign({}, state), { currentGroupChannel: null, allMessages: [], localMessages: [], isInvalid: true });
    })
        .with({ type: ON_MESSAGE_RECEIVED }, function (action) {
        var _a, _b;
        var _c = action.payload, channel = _c.channel, message = _c.message;
        var members = channel.members;
        var sender = message.sender;
        var currentGroupChannel = state.currentGroupChannel;
        var currentGroupChannelUrl = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url;
        if (!compareIds(channel === null || channel === void 0 ? void 0 : channel.url, currentGroupChannelUrl)) {
            return state;
        }
        // Excluded overlapping messages
        if (state.allMessages.some(function (msg) { return msg.messageId === message.messageId; })) {
            return state;
        }
        // Filter by userFilledQuery
        if (state.messageListParams
            && !filterMessageListParams(state.messageListParams, message)) {
            return state;
        }
        if (message.isAdminMessage && message.isAdminMessage()) {
            return __assign(__assign({}, state), { allMessages: passUnsuccessfullMessages(state.allMessages, message) });
        }
        // Update members when sender profileUrl, nickname, friendName has been changed
        var senderMember = members === null || members === void 0 ? void 0 : members.find(function (m) { return (m === null || m === void 0 ? void 0 : m.userId) === (sender === null || sender === void 0 ? void 0 : sender.userId); });
        if ((senderMember === null || senderMember === void 0 ? void 0 : senderMember.profileUrl) !== (sender === null || sender === void 0 ? void 0 : sender.profileUrl)
            || (senderMember === null || senderMember === void 0 ? void 0 : senderMember.friendName) !== (sender === null || sender === void 0 ? void 0 : sender.friendName)
            || (senderMember === null || senderMember === void 0 ? void 0 : senderMember.nickname) !== (sender === null || sender === void 0 ? void 0 : sender.nickname)) {
            // @ts-ignore
            channel.members = members.map(function (member) {
                if (member.userId === sender.userId) {
                    return sender;
                }
                return member;
            });
        }
        return __assign(__assign({}, state), { currentGroupChannel: channel, unreadSince: (_a = state.unreadSince) !== null && _a !== void 0 ? _a : format(new Date(), stringSet.DATE_FORMAT__UNREAD_SINCE), unreadSinceDate: (_b = state.unreadSinceDate) !== null && _b !== void 0 ? _b : new Date(), allMessages: passUnsuccessfullMessages(state.allMessages, message) });
    })
        .with({ type: ON_MESSAGE_UPDATED }, function (action) {
        var _a;
        var _b = action.payload, channel = _b.channel, message = _b.message;
        var currentGroupChannelUrl = ((_a = state === null || state === void 0 ? void 0 : state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url) || '';
        if (!compareIds(channel === null || channel === void 0 ? void 0 : channel.url, currentGroupChannelUrl)) {
            return state; // Ignore event when it is not for the current channel
        }
        if (state.messageListParams
            && !filterMessageListParams(state.messageListParams, message)) {
            // Delete the message if it doesn't match to the params anymore
            return __assign(__assign({}, state), { allMessages: state.allMessages.filter(function (m) { return !compareIds(m.messageId, message === null || message === void 0 ? void 0 : message.messageId); }) });
        }
        return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (m) {
                if (compareIds(m.messageId, message.messageId)) {
                    return message;
                }
                if (compareIds(m.parentMessageId, message.messageId)) {
                    m.parentMessage = message; // eslint-disable-line no-param-reassign
                }
                return m;
            }) });
    })
        .with({ type: ON_MESSAGE_THREAD_INFO_UPDATED }, function (action) {
        var _a;
        var _b = action.payload, channel = _b.channel, event = _b.event;
        var channelUrl = event.channelUrl, threadInfo = event.threadInfo, targetMessageId = event.targetMessageId;
        var currentGroupChannelUrl = ((_a = state === null || state === void 0 ? void 0 : state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url) || '';
        if (!compareIds(channel === null || channel === void 0 ? void 0 : channel.url, currentGroupChannelUrl)
            || !compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
            return state; // Ignore event when it is not for the current channel
        }
        return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (m) {
                if (compareIds(m.messageId, targetMessageId)) {
                    // eslint-disable-next-line no-param-reassign
                    m.threadInfo = threadInfo; // Upsert threadInfo to the target message
                }
                return m;
            }) });
    })
        .with({ type: RESEND_MESSAGE_START }, function (action) {
        return __assign(__assign({}, state), { localMessages: state.localMessages.map(function (m) { return compareIds(hasReqId(m) && m.reqId, action.payload.reqId)
                ? action.payload
                : m; }) });
    })
        .with({ type: MARK_AS_READ }, function (action) {
        var _a, _b, _c;
        if (((_a = state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url) !== ((_c = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.channel) === null || _c === void 0 ? void 0 : _c.url)) {
            return state;
        }
        return __assign(__assign({}, state), { unreadSince: null, unreadSinceDate: null });
    })
        .with({ type: ON_MESSAGE_DELETED }, function (action) {
        return __assign(__assign({}, state), { allMessages: state.allMessages.filter(function (m) { return !compareIds(m.messageId, action.payload); }) });
    })
        .with({ type: ON_MESSAGE_DELETED_BY_REQ_ID }, function (action) {
        return __assign(__assign({}, state), { localMessages: state.localMessages.filter(function (m) { return !compareIds(hasReqId(m) && m.reqId, action.payload); }) });
    })
        .with({ type: SET_EMOJI_CONTAINER }, function (action) {
        return __assign(__assign({}, state), { emojiContainer: action.payload });
    })
        .with({ type: ON_REACTION_UPDATED }, function (action) {
        return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (m) {
                if (compareIds(m.messageId, action.payload.messageId)) {
                    if (m.applyReactionEvent
                        && typeof m.applyReactionEvent === 'function') {
                        m.applyReactionEvent(action.payload);
                    }
                    return m;
                }
                return m;
            }) });
    })
        .with({ type: MESSAGE_LIST_PARAMS_CHANGED }, function (action) {
        return __assign(__assign({}, state), { messageListParams: action.payload });
    })
        .with({ type: ON_FILE_INFO_UPLOADED }, function (action) {
        var _a, _b;
        var _c = action.payload, channelUrl = _c.channelUrl, requestId = _c.requestId, index = _c.index, uploadableFileInfo = _c.uploadableFileInfo, error = _c.error;
        if (!compareIds(channelUrl, (_a = state === null || state === void 0 ? void 0 : state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url)) {
            return state;
        }
        /**
         * We don't have to do anything here because
         * onFailed() will be called so handle error there instead.
         */
        if (error)
            return state;
        var localMessages = state.localMessages;
        var messageToUpdate = localMessages.find(function (message) { return compareIds(hasReqId(message) && message.reqId, requestId); });
        var fileInfoList = (_b = messageToUpdate
            .messageParams) === null || _b === void 0 ? void 0 : _b.fileInfoList;
        if (Array.isArray(fileInfoList)) {
            fileInfoList[index] = uploadableFileInfo;
        }
        return __assign(__assign({}, state), { localMessages: localMessages });
    })
        .with({ type: ON_TYPING_STATUS_UPDATED }, function (action) {
        var _a;
        var _b = action.payload, channel = _b.channel, typingMembers = _b.typingMembers;
        if (!compareIds(channel.url, (_a = state === null || state === void 0 ? void 0 : state.currentGroupChannel) === null || _a === void 0 ? void 0 : _a.url)) {
            return state;
        }
        return __assign(__assign({}, state), { typingMembers: typingMembers });
    })
        .otherwise(function () { return state; });
}

var DELIVERY_RECEIPT = 'delivery_receipt';
function useHandleChannelEvents(_a, _b) {
    var _c, _d, _e;
    var sdkInit = _a.sdkInit, currentGroupChannel = _a.currentGroupChannel, disableMarkAsRead = _a.disableMarkAsRead;
    var sdk = _b.sdk, logger = _b.logger, scrollRef = _b.scrollRef, setQuoteMessage = _b.setQuoteMessage, messagesDispatcher = _b.messagesDispatcher;
    var store = useSendbirdStateContext();
    var _f = store.config, markAsReadScheduler = _f.markAsReadScheduler, markAsDeliveredScheduler = _f.markAsDeliveredScheduler, disableMarkAsDelivered = _f.disableMarkAsDelivered;
    var canSetMarkAsDelivered = (_e = (_d = (_c = store.stores.sdkStore.sdk) === null || _c === void 0 ? void 0 : _c.appInfo) === null || _d === void 0 ? void 0 : _d.premiumFeatureList) === null || _e === void 0 ? void 0 : _e.find(function (feature) { return (feature === DELIVERY_RECEIPT); });
    useEffect(function () {
        var _a;
        var channelUrl = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url;
        var channelHandlerId = uuidv4();
        if (channelUrl && sdkInit) {
            var channelHandler = {
                onMessageReceived: function (channel, message) {
                    var _a, _b;
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        var scrollToEnd = false;
                        try {
                            var current = scrollRef.current;
                            if (current) {
                                scrollToEnd = current.offsetHeight + current.scrollTop >= current.scrollHeight - 10;
                            }
                            // 10 is a buffer
                        }
                        catch (error) {
                            //
                        }
                        logger.info('Channel | useHandleChannelEvents: onMessageReceived', message);
                        messagesDispatcher({
                            type: ON_MESSAGE_RECEIVED,
                            payload: { channel: channel, message: message },
                        });
                        if (scrollToEnd
                            && ((_a = document.getElementById('sendbird-dropdown-portal')) === null || _a === void 0 ? void 0 : _a.childElementCount) === 0
                            && ((_b = document.getElementById('sendbird-emoji-list-portal')) === null || _b === void 0 ? void 0 : _b.childElementCount) === 0) {
                            // and !openContextMenu
                            try {
                                setTimeout(function () { return scrollIntoLast(0, scrollRef); });
                                if (!disableMarkAsRead) {
                                    markAsReadScheduler.push(currentGroupChannel);
                                }
                                if (canSetMarkAsDelivered && !disableMarkAsDelivered) {
                                    markAsDeliveredScheduler.push(currentGroupChannel);
                                }
                            }
                            catch (error) {
                                logger.warning('Channel | onMessageReceived | scroll to end failed');
                            }
                        }
                    }
                },
                onUnreadMemberStatusUpdated: function (channel) {
                    logger.info('Channel | useHandleChannelEvents: onUnreadMemberStatusUpdated', channel);
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                // before(onDeliveryReceiptUpdated)
                onUndeliveredMemberStatusUpdated: function (channel) {
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onDeliveryReceiptUpdated', channel);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onMessageUpdated: function (channel, message) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onMessageUpdated', message);
                        messagesDispatcher({
                            type: ON_MESSAGE_UPDATED,
                            payload: { channel: channel, message: message },
                        });
                    }
                },
                onThreadInfoUpdated: function (channel, threadInfoUpdateEvent) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onThreadInfoUpdated', { channel: channel, threadInfoUpdateEvent: threadInfoUpdateEvent });
                        messagesDispatcher({
                            type: ON_MESSAGE_THREAD_INFO_UPDATED,
                            payload: { channel: channel, event: threadInfoUpdateEvent },
                        });
                    }
                },
                onMessageDeleted: function (channel, messageId) {
                    logger.info('Channel | useHandleChannelEvents: onMessageDeleted', { channel: channel, messageId: messageId });
                    setQuoteMessage(null);
                    messagesDispatcher({
                        type: ON_MESSAGE_DELETED,
                        payload: messageId,
                    });
                },
                onReactionUpdated: function (channel, reactionEvent) {
                    logger.info('Channel | useHandleChannelEvents: onReactionUpdated', { channel: channel, reactionEvent: reactionEvent });
                    messagesDispatcher({
                        type: ON_REACTION_UPDATED,
                        payload: reactionEvent,
                    });
                },
                onChannelChanged: function (channel) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onChannelChanged', channel);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onChannelFrozen: function (channel) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onChannelFrozen', channel);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onChannelUnfrozen: function (channel) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onChannelUnFrozen', channel);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onUserMuted: function (channel, user) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onUserMuted', { channel: channel, user: user });
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onUserUnmuted: function (channel, user) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onUserUnmuted', { channel: channel, user: user });
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onUserBanned: function (channel, user) {
                    var _a;
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl) && channel.isGroupChannel()) {
                        logger.info('Channel | useHandleChannelEvents: onUserBanned', { channel: channel, user: user });
                        var isByMe = (user === null || user === void 0 ? void 0 : user.userId) === ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: isByMe ? null : channel,
                        });
                    }
                },
                onOperatorUpdated: function (channel, users) {
                    if (channel.isGroupChannel() && compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onOperatorUpdated', { channel: channel, users: users });
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: channel,
                        });
                    }
                },
                onUserLeft: function (channel, user) {
                    var _a;
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | useHandleChannelEvents: onUserLeft', { channel: channel, user: user });
                        var isByMe = (user === null || user === void 0 ? void 0 : user.userId) === ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        messagesDispatcher({
                            type: SET_CURRENT_CHANNEL,
                            payload: isByMe ? null : channel,
                        });
                    }
                },
                onTypingStatusUpdated: function (channel) {
                    if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                        logger.info('Channel | onTypingStatusUpdated', { channel: channel });
                        var typingMembers = channel.getTypingUsers();
                        messagesDispatcher({
                            type: ON_TYPING_STATUS_UPDATED,
                            payload: {
                                channel: channel,
                                typingMembers: typingMembers,
                            },
                        });
                    }
                },
            };
            logger.info('Channel | useHandleChannelEvents: Setup event handler', { channelHandlerId: channelHandlerId, channelHandler: channelHandler });
            // Add this group channel handler to the Sendbird chat instance
            (_a = sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler(channelHandlerId, new GroupChannelHandler(channelHandler));
        }
        return function () {
            var _a;
            if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) {
                logger.info('Channel | useHandleChannelEvents: Removing message reciver handler', channelHandlerId);
                sdk.groupChannel.removeGroupChannelHandler(channelHandlerId);
            }
            else if (sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) {
                logger.error('Channel | useHandleChannelEvents: Not found the removeGroupChannelHandler');
            }
        };
    }, [currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url, sdkInit]);
}

function useGetChannel(_a, _b) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit, disableMarkAsRead = _a.disableMarkAsRead;
    var messagesDispatcher = _b.messagesDispatcher, sdk = _b.sdk, logger = _b.logger, markAsReadScheduler = _b.markAsReadScheduler;
    useEffect(function () {
        if (channelUrl && sdkInit && sdk && sdk.groupChannel) {
            logger.info('Channel | useSetChannel fetching channel', channelUrl);
            sdk.groupChannel
                .getChannel(channelUrl)
                .then(function (groupChannel) {
                logger.info('Channel | useSetChannel fetched channel', groupChannel);
                messagesDispatcher({
                    type: SET_CURRENT_CHANNEL,
                    payload: groupChannel,
                });
                logger.info('Channel: Mark as read', groupChannel);
                if (!disableMarkAsRead) {
                    markAsReadScheduler.push(groupChannel);
                }
            })
                .catch(function (e) {
                logger.warning('Channel | useSetChannel fetch channel failed', { channelUrl: channelUrl, e: e });
                messagesDispatcher({
                    type: SET_CHANNEL_INVALID,
                });
            });
            sdk
                .getAllEmoji()
                .then(function (emojiContainer_) {
                logger.info('Channel: Getting emojis success', emojiContainer_);
                messagesDispatcher({
                    type: SET_EMOJI_CONTAINER,
                    payload: emojiContainer_,
                });
            })
                .catch(function (err) {
                logger.error('Channel: Getting emojis failed', err);
            });
        }
    }, [channelUrl, sdkInit]);
}

function useHandleReconnect(_a, _b) {
    var isOnline = _a.isOnline, replyType = _a.replyType, disableMarkAsRead = _a.disableMarkAsRead, reconnectOnIdle = _a.reconnectOnIdle;
    var logger = _b.logger, sdk = _b.sdk, scrollRef = _b.scrollRef, currentGroupChannel = _b.currentGroupChannel, messagesDispatcher = _b.messagesDispatcher, markAsReadScheduler = _b.markAsReadScheduler, userFilledMessageListQuery = _b.userFilledMessageListQuery;
    var shouldReconnect = useReconnectOnIdle(isOnline, currentGroupChannel, reconnectOnIdle).shouldReconnect;
    useEffect(function () {
        return function () {
            var _a, _b, _c;
            // state changed from offline to online AND tab is visible
            if (shouldReconnect) {
                logger.info('Refreshing conversation state');
                var isReactionEnabled = ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.useReaction) || false;
                var messageListParams_1 = {
                    prevResultSize: PREV_RESULT_SIZE,
                    isInclusive: true,
                    includeReactions: isReactionEnabled,
                    includeMetaArray: true,
                    nextResultSize: NEXT_RESULT_SIZE,
                };
                if (replyType && replyType === 'QUOTE_REPLY') {
                    messageListParams_1.includeThreadInfo = true;
                    messageListParams_1.includeParentMessageInfo = true;
                    messageListParams_1.replyType = ReplyType.ONLY_REPLY_TO_CHANNEL;
                }
                if (userFilledMessageListQuery) {
                    Object.keys(userFilledMessageListQuery).forEach(function (key) {
                        // @ts-ignore
                        messageListParams_1[key] = userFilledMessageListQuery[key];
                    });
                }
                logger.info('Channel: Fetching messages', { currentGroupChannel: currentGroupChannel, userFilledMessageListQuery: userFilledMessageListQuery });
                messagesDispatcher({
                    type: FETCH_INITIAL_MESSAGES_START,
                    payload: null,
                });
                (_b = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _b === void 0 ? void 0 : _b.getChannel((_c = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) !== null && _c !== void 0 ? _c : '').then(function (groupChannel) {
                    var lastMessageTime = new Date().getTime();
                    groupChannel.getMessagesByTimestamp(lastMessageTime, messageListParams_1)
                        .then(function (messages) {
                        messagesDispatcher({
                            type: FETCH_INITIAL_MESSAGES_SUCCESS,
                            payload: {
                                currentGroupChannel: groupChannel,
                                messages: messages,
                            },
                        });
                        setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_FETCH);
                    })
                        .catch(function (error) {
                        logger.error('Channel: Fetching messages failed', error);
                        messagesDispatcher({
                            type: FETCH_INITIAL_MESSAGES_FAILURE,
                            payload: { currentGroupChannel: groupChannel },
                        });
                    });
                    if (!disableMarkAsRead) {
                        markAsReadScheduler.push(groupChannel);
                    }
                });
            }
        };
    }, [shouldReconnect, replyType]);
}

function useScrollCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, oldestMessageTimeStamp = _a.oldestMessageTimeStamp, userFilledMessageListQuery = _a.userFilledMessageListQuery, replyType = _a.replyType;
    var hasMorePrev = _b.hasMorePrev, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, sdk = _b.sdk;
    return useCallback(function (callback) {
        var _a, _b;
        if (!hasMorePrev) {
            return;
        }
        var messageListParams = {
            prevResultSize: PREV_RESULT_SIZE,
            isInclusive: true,
            includeMetaArray: true,
            includeReactions: (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.useReaction) !== null && _b !== void 0 ? _b : false,
        };
        if (replyType === 'QUOTE_REPLY' || replyType === 'THREAD') {
            messageListParams.includeThreadInfo = true;
            messageListParams.includeParentMessageInfo = true;
            messageListParams.replyType = ReplyType.ONLY_REPLY_TO_CHANNEL;
        }
        if (userFilledMessageListQuery) {
            Object.keys(userFilledMessageListQuery).forEach(function (key) {
                // @ts-ignore
                messageListParams[key] = userFilledMessageListQuery[key];
            });
        }
        logger.info('Channel: Fetching messages', {
            currentGroupChannel: currentGroupChannel,
            userFilledMessageListQuery: userFilledMessageListQuery,
        });
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.getMessagesByTimestamp(oldestMessageTimeStamp || new Date().getTime(), messageListParams).then(function (messages) {
            messagesDispatcher({
                type: FETCH_PREV_MESSAGES_SUCCESS,
                payload: { currentGroupChannel: currentGroupChannel, messages: messages },
            });
            if (callback)
                setTimeout(function () { return callback(); });
        }).catch(function () {
            messagesDispatcher({
                type: FETCH_PREV_MESSAGES_FAILURE,
                payload: { currentGroupChannel: currentGroupChannel },
            });
        });
    }, [currentGroupChannel, oldestMessageTimeStamp, replyType]);
}

function useScrollDownCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, latestMessageTimeStamp = _a.latestMessageTimeStamp, userFilledMessageListQuery = _a.userFilledMessageListQuery, hasMoreNext = _a.hasMoreNext, replyType = _a.replyType;
    var logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, sdk = _b.sdk;
    return useCallback(function (cb) {
        var _a, _b;
        if (!hasMoreNext) {
            return;
        }
        var isReactionEnabled = (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.useReaction) !== null && _b !== void 0 ? _b : false;
        var messageListParams = {
            nextResultSize: NEXT_RESULT_SIZE,
            isInclusive: true,
            includeReactions: isReactionEnabled,
            includeMetaArray: true,
        };
        if (replyType && (replyType === 'QUOTE_REPLY' || replyType === 'THREAD')) {
            messageListParams.includeThreadInfo = true;
            messageListParams.includeParentMessageInfo = true;
            messageListParams.replyType = ReplyType.ONLY_REPLY_TO_CHANNEL;
        }
        if (userFilledMessageListQuery) {
            Object.keys(userFilledMessageListQuery).forEach(function (key) {
                // @ts-ignore
                messageListParams[key] = userFilledMessageListQuery[key];
            });
        }
        logger.info('Channel: Fetching later messages', { currentGroupChannel: currentGroupChannel, userFilledMessageListQuery: userFilledMessageListQuery });
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.getMessagesByTimestamp(latestMessageTimeStamp || new Date().getTime(), messageListParams).then(function (messages) {
            messagesDispatcher({
                type: FETCH_NEXT_MESSAGES_SUCCESS,
                payload: { currentGroupChannel: currentGroupChannel, messages: messages },
            });
            setTimeout(function () { return cb([messages, null]); });
        }).catch(function (error) {
            logger.error('Channel: Fetching later messages failed', error);
            messagesDispatcher({
                type: FETCH_NEXT_MESSAGES_FAILURE,
                payload: { currentGroupChannel: currentGroupChannel },
            });
            setTimeout(function () { return cb([null, error]); });
        });
    }, [currentGroupChannel, latestMessageTimeStamp, hasMoreNext, replyType]);
}

function useDeleteMessageCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, messagesDispatcher = _a.messagesDispatcher;
    var logger = _b.logger;
    return useCallback(function (message) {
        logger.info('Channel | useDeleteMessageCallback: Deleting message', message);
        var sendingStatus = isSendableMessage(message) ? message.sendingStatus : undefined;
        return new Promise(function (resolve, reject) {
            logger.info('Channel | useDeleteMessageCallback: Deleting message requestState:', sendingStatus);
            // Message is only on local
            if ((sendingStatus === SendingStatus.FAILED || sendingStatus === SendingStatus.PENDING) && 'reqId' in message) {
                logger.info('Channel | useDeleteMessageCallback: Deleted message from local:', message);
                messagesDispatcher({
                    type: ON_MESSAGE_DELETED_BY_REQ_ID,
                    payload: message.reqId,
                });
                resolve();
            }
            else {
                logger.info('Channel | useDeleteMessageCallback: Deleting message from remote:', sendingStatus);
                currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.deleteMessage(message).then(function () {
                    logger.info('Channel | useDeleteMessageCallback: Deleting message success!', message);
                    messagesDispatcher({
                        type: ON_MESSAGE_DELETED,
                        payload: message.messageId,
                    });
                    resolve();
                }).catch(function (err) {
                    logger.warning('Channel | useDeleteMessageCallback: Deleting message failed!', err);
                    reject(err);
                });
            }
        });
    }, [currentGroupChannel, messagesDispatcher]);
}

function useUpdateMessageCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, messagesDispatcher = _a.messagesDispatcher, onBeforeUpdateUserMessage = _a.onBeforeUpdateUserMessage, isMentionEnabled = _a.isMentionEnabled;
    var logger = _b.logger, pubSub = _b.pubSub;
    return useCallback(function (props, callback) {
        var messageId = props.messageId, message = props.message, mentionedUsers = props.mentionedUsers, mentionTemplate = props.mentionTemplate;
        var createParamsDefault = function (message) {
            var params = {
                message: message,
            };
            if (isMentionEnabled && mentionedUsers && mentionedUsers.length > 0) {
                params.mentionedUsers = mentionedUsers;
            }
            if (isMentionEnabled && mentionTemplate) {
                params.mentionedMessageTemplate = mentionTemplate;
            }
            else {
                params.mentionedMessageTemplate = message;
            }
            return params;
        };
        var shouldCreateCustomParams = onBeforeUpdateUserMessage && typeof onBeforeUpdateUserMessage === 'function';
        if (shouldCreateCustomParams) {
            logger.info('Channel: creating params using onBeforeUpdateUserMessage', onBeforeUpdateUserMessage);
        }
        var params = shouldCreateCustomParams ? onBeforeUpdateUserMessage(message) : createParamsDefault(message);
        logger.info('Channel: Updating message!', params);
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.updateUserMessage(messageId, params).then(function (msg) {
            if (callback) {
                callback(null, msg);
            }
            logger.info('Channel: Updating message success!', msg);
            messagesDispatcher({
                type: ON_MESSAGE_UPDATED,
                payload: {
                    channel: currentGroupChannel,
                    message: msg,
                },
            });
            pubSub.publish(pubSubTopics.UPDATE_USER_MESSAGE, {
                message: msg,
                channel: currentGroupChannel,
                publishingModules: [PublishingModuleType.CHANNEL],
            });
        }).catch(function (err) {
            if (callback) {
                callback(err, null);
            }
        });
    }, [currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url, messagesDispatcher, onBeforeUpdateUserMessage]);
}

function useResendMessageCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, messagesDispatcher = _a.messagesDispatcher;
    var logger = _b.logger, pubSub = _b.pubSub;
    return useCallback(function (failedMessage) {
        logger.info('Channel: Resending message has started', failedMessage);
        if (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isResendable) {
            // userMessage
            if (failedMessage.isUserMessage()) {
                currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.resendMessage(failedMessage).onPending(function (message) {
                    logger.info('Channel: Resending message start!', message);
                    messagesDispatcher({
                        type: RESEND_MESSAGE_START,
                        payload: message,
                    });
                }).onSucceeded(function (message) {
                    logger.info('Channel: Resending message success!', message);
                    messagesDispatcher({
                        type: SEND_MESSAGE_SUCCESS,
                        payload: message,
                    });
                }).onFailed(function (e, message) {
                    logger.warning('Channel: Resending message failed!', e);
                    messagesDispatcher({
                        type: SEND_MESSAGE_FAILURE,
                        payload: message,
                    });
                });
            }
            else if (failedMessage.isFileMessage()) {
                currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.resendMessage(failedMessage).onPending(function (message) {
                    logger.info('Channel: Resending file message start!', message);
                    messagesDispatcher({
                        type: RESEND_MESSAGE_START,
                        payload: message,
                    });
                }).onSucceeded(function (message) {
                    logger.info('Channel: Resending file message success!', message);
                    messagesDispatcher({
                        type: SEND_MESSAGE_SUCCESS,
                        payload: message,
                    });
                }).onFailed(function (e, message) {
                    logger.warning('Channel: Resending file message failed!', e);
                    messagesDispatcher({
                        type: SEND_MESSAGE_FAILURE,
                        payload: message,
                    });
                });
            }
            else if (failedMessage.isMultipleFilesMessage()) {
                currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.resendMessage(failedMessage).onPending(function (message) {
                    logger.info('Channel: Resending multiple files message start!', message);
                    messagesDispatcher({
                        type: RESEND_MESSAGE_START,
                        payload: message,
                    });
                }).onFileUploaded(function (requestId, index, uploadableFileInfo, error) {
                    var _a;
                    logger.info('Channel: Resending multiple files message file uploaded!', {
                        requestId: requestId,
                        index: index,
                        error: error,
                        uploadableFileInfo: uploadableFileInfo,
                    });
                    pubSub.publish(pubSubTopics.ON_FILE_INFO_UPLOADED, {
                        response: {
                            channelUrl: (_a = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) !== null && _a !== void 0 ? _a : '',
                            requestId: requestId,
                            index: index,
                            uploadableFileInfo: uploadableFileInfo,
                            error: error,
                        },
                        publishingModules: [PublishingModuleType.CHANNEL],
                    });
                }).onSucceeded(function (message) {
                    logger.info('Channel: Resending multiple files message success!', message);
                    messagesDispatcher({
                        type: SEND_MESSAGE_SUCCESS,
                        payload: message,
                    });
                }).onFailed(function (e, message) {
                    logger.warning('Channel: Resending multiple files message failed!', e);
                    messagesDispatcher({
                        type: SEND_MESSAGE_FAILURE,
                        payload: message,
                    });
                });
            }
        }
        else {
            logger.error('Message is not resendable', failedMessage);
        }
    }, [currentGroupChannel, messagesDispatcher]);
}

function useSendMessageCallback(_a, _b) {
    var isMentionEnabled = _a.isMentionEnabled, currentGroupChannel = _a.currentGroupChannel, onBeforeSendUserMessage = _a.onBeforeSendUserMessage;
    var logger = _b.logger, pubSub = _b.pubSub, scrollRef = _b.scrollRef, messagesDispatcher = _b.messagesDispatcher;
    var messageInputRef = useRef(null);
    var sendMessage = useCallback(function (_a) {
        var quoteMessage = _a.quoteMessage, message = _a.message, mentionTemplate = _a.mentionTemplate, 
        // mentionedUserIds,
        mentionedUsers = _a.mentionedUsers;
        var createParamsDefault = function () {
            var params = {
                message: message,
            };
            // if (isMentionEnabled && mentionedUserIds?.length > 0) {
            if (isMentionEnabled && mentionedUsers && mentionedUsers.length > 0) {
                // params.mentionedUserIds = mentionedUserIds;
                params.mentionedUsers = mentionedUsers;
            }
            // if (isMentionEnabled && mentionTemplate && mentionedUserIds?.length > 0) {
            if (isMentionEnabled && mentionTemplate && mentionedUsers && mentionedUsers.length > 0) {
                params.mentionedMessageTemplate = mentionTemplate;
            }
            if (quoteMessage) {
                params.isReplyToChannel = true;
                params.parentMessageId = quoteMessage.messageId;
            }
            return params;
        };
        var shouldCreateCustomParams = onBeforeSendUserMessage && typeof onBeforeSendUserMessage === 'function';
        if (shouldCreateCustomParams) {
            logger.info('Channel: creating params using onBeforeSendUserMessage', onBeforeSendUserMessage);
        }
        var params = shouldCreateCustomParams ? onBeforeSendUserMessage(message, quoteMessage) : createParamsDefault();
        logger.info('Channel: Sending message has started', params);
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.sendUserMessage(params).onPending(function (pendingMsg) {
            pubSub.publish(pubSubTopics.SEND_MESSAGE_START, {
                /* pubSub is used instead of messagesDispatcher
                  to avoid redundantly calling `messageActionTypes.SEND_MESSAGE_START` */
                message: pendingMsg,
                channel: currentGroupChannel,
                publishingModules: [PublishingModuleType.CHANNEL],
            });
            setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_SEND);
        }).onFailed(function (err, msg) {
            logger.warning('Channel: Sending message failed!', { message: msg, error: err });
            messagesDispatcher({
                type: SEND_MESSAGE_FAILURE,
                payload: msg,
            });
        }).onSucceeded(function (msg) {
            logger.info('Channel: Sending message success!', msg);
            messagesDispatcher({
                type: SEND_MESSAGE_SUCCESS,
                payload: msg,
            });
        });
    }, [currentGroupChannel, onBeforeSendUserMessage]);
    return [messageInputRef, sendMessage];
}

function useSendFileMessageCallback(_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, onBeforeSendFileMessage = _a.onBeforeSendFileMessage, imageCompression = _a.imageCompression;
    var logger = _b.logger, pubSub = _b.pubSub, scrollRef = _b.scrollRef, messagesDispatcher = _b.messagesDispatcher;
    var sendMessage = useCallback(function (compressedFile, quoteMessage) { return new Promise(function (resolve, reject) {
        // Create FileMessageParams
        var params = onBeforeSendFileMessage === null || onBeforeSendFileMessage === void 0 ? void 0 : onBeforeSendFileMessage(compressedFile, quoteMessage);
        if (!params) {
            params = { file: compressedFile };
            if (quoteMessage) {
                params.isReplyToChannel = true;
                params.parentMessageId = quoteMessage.messageId;
            }
        }
        // Send FileMessage
        logger.info('Channel: Uploading file message start!', params);
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.sendFileMessage(params).onPending(function (pendingMessage) {
            pubSub.publish(pubSubTopics.SEND_MESSAGE_START, {
                /* pubSub is used instead of messagesDispatcher
                  to avoid redundantly calling `messageActionTypes.SEND_MESSAGE_START` */
                // TODO: remove data pollution
                message: __assign(__assign({}, pendingMessage), { url: URL.createObjectURL(compressedFile), 
                    // pending thumbnail message seems to be failed
                    requestState: 'pending', isUserMessage: pendingMessage.isUserMessage, isFileMessage: pendingMessage.isFileMessage, isAdminMessage: pendingMessage.isAdminMessage, isMultipleFilesMessage: pendingMessage.isMultipleFilesMessage }),
                channel: currentGroupChannel,
                publishingModules: [PublishingModuleType.CHANNEL],
            });
            setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_SEND);
        }).onFailed(function (err, failedMessage) {
            logger.error('Channel: Sending file message failed!', { failedMessage: failedMessage, err: err });
            // TODO: v4 - remove logic that modifies the original object.
            //  It makes the code difficult to track, likely causing unpredictable side effects.
            // @ts-ignore eslint-disable-next-line no-param-reassign
            failedMessage.localUrl = URL.createObjectURL(compressedFile);
            // @ts-ignore eslint-disable-next-line no-param-reassign
            failedMessage.file = compressedFile;
            messagesDispatcher({
                type: SEND_MESSAGE_FAILURE,
                payload: failedMessage,
            });
            reject(err);
        }).onSucceeded(function (succeededMessage) {
            logger.info('Channel: Sending file message success!', succeededMessage);
            messagesDispatcher({
                type: SEND_MESSAGE_SUCCESS,
                payload: succeededMessage,
            });
            resolve(succeededMessage);
        });
    }); }, [currentGroupChannel, onBeforeSendFileMessage, imageCompression]);
    return [sendMessage];
}

// To prevent multiple clicks on the message in the channel while scrolling
function deactivateClick(scrollRef) {
    var element = scrollRef.current;
    var parentNode = element === null || element === void 0 ? void 0 : element.parentNode;
    if (element && parentNode) {
        element.style.pointerEvents = 'none';
        parentNode.style.cursor = 'wait';
    }
}
function activateClick(scrollRef) {
    var element = scrollRef.current;
    var parentNode = element === null || element === void 0 ? void 0 : element.parentNode;
    if (element && parentNode) {
        element.style.pointerEvents = 'auto';
        parentNode.style.cursor = 'auto';
    }
}
function useScrollToMessage(_a, _b) {
    var setInitialTimeStamp = _a.setInitialTimeStamp, setAnimatedMessageId = _a.setAnimatedMessageId, allMessages = _a.allMessages, scrollRef = _a.scrollRef;
    var logger = _b.logger;
    return useCallback(function (createdAt, messageId) {
        var isPresent = allMessages.find(function (m) { return (m.messageId === messageId); });
        setAnimatedMessageId(null);
        setTimeout(function () {
            try {
                logger.info('Channel: scroll to message - disabling mouse events');
                deactivateClick(scrollRef);
                if (isPresent) {
                    logger.info('Channel: scroll to message - message is present');
                    setAnimatedMessageId(messageId);
                    scrollToRenderedMessage(scrollRef, createdAt);
                }
                else {
                    logger.info('Channel: scroll to message - fetching older messages');
                    setInitialTimeStamp(null);
                    setInitialTimeStamp(createdAt);
                    setAnimatedMessageId(messageId);
                }
            }
            finally {
                logger.info('Channel: scroll to message - enabled mouse events');
                activateClick(scrollRef);
            }
        });
    }, [
        setInitialTimeStamp,
        setAnimatedMessageId,
        allMessages,
    ]);
}

var useSendVoiceMessageCallback = function (_a, _b) {
    var currentGroupChannel = _a.currentGroupChannel, onBeforeSendVoiceMessage = _a.onBeforeSendVoiceMessage;
    var logger = _b.logger, pubSub = _b.pubSub, scrollRef = _b.scrollRef, messagesDispatcher = _b.messagesDispatcher;
    var sendMessage = useCallback(function (file, duration, quoteMessage) { return new Promise(function (resolve, reject) {
        if (!currentGroupChannel) {
            return;
        }
        var messageParams = (onBeforeSendVoiceMessage && typeof onBeforeSendVoiceMessage === 'function')
            ? onBeforeSendVoiceMessage(file, quoteMessage)
            : {
                file: file,
                fileName: VOICE_MESSAGE_FILE_NAME,
                mimeType: VOICE_MESSAGE_MIME_TYPE,
                metaArrays: [
                    new MessageMetaArray({
                        key: META_ARRAY_VOICE_DURATION_KEY,
                        value: ["".concat(duration)],
                    }),
                    new MessageMetaArray({
                        key: META_ARRAY_MESSAGE_TYPE_KEY,
                        value: [META_ARRAY_MESSAGE_TYPE_VALUE__VOICE],
                    }),
                ],
            };
        if (quoteMessage) {
            messageParams.isReplyToChannel = true;
            messageParams.parentMessageId = quoteMessage.messageId;
        }
        logger.info('Channel: Start sending voice message', messageParams);
        currentGroupChannel.sendFileMessage(messageParams)
            .onPending(function (pendingMessage) {
            pubSub.publish(pubSubTopics.SEND_MESSAGE_START, {
                /* pubSub is used instead of messagesDispatcher
                  to avoid redundantly calling `messageActionTypes.SEND_MESSAGE_START` */
                message: pendingMessage,
                channel: currentGroupChannel,
                publishingModules: [PublishingModuleType.CHANNEL],
            });
            setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_SEND);
        })
            .onFailed(function (err, failedMessage) {
            logger.error('Channel: Sending voice message failed!', { failedMessage: failedMessage, err: err });
            messagesDispatcher({
                type: SEND_MESSAGE_FAILURE,
                payload: failedMessage,
            });
            reject(err);
        })
            .onSucceeded(function (succeededMessage) {
            logger.info('Channel: Sending voice message success!', succeededMessage);
            messagesDispatcher({
                type: SEND_MESSAGE_SUCCESS,
                payload: succeededMessage,
            });
            resolve(succeededMessage);
        });
    }); }, [
        currentGroupChannel,
        onBeforeSendVoiceMessage,
    ]);
    return [sendMessage];
};

var useHandleChannelPubsubEvents = function (_a) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit, pubSub = _a.pubSub, dispatcher = _a.dispatcher, scrollRef = _a.scrollRef;
    useEffect(function () {
        var subscriber = new Map();
        if (pubSub === null || pubSub === void 0 ? void 0 : pubSub.subscribe) {
            subscriber.set(PUBSUB_TOPICS.SEND_USER_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.SEND_USER_MESSAGE, function (props) {
                var channel = props.channel, message = props.message;
                if (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    dispatcher({
                        type: SEND_MESSAGE_SUCCESS,
                        payload: message,
                    });
                    setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_SEND);
                }
            }));
            subscriber.set(PUBSUB_TOPICS.SEND_MESSAGE_START, pubSub.subscribe(PUBSUB_TOPICS.SEND_MESSAGE_START, function (props) {
                var channel = props.channel, message = props.message, publishingModules = props.publishingModules;
                if (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url) && shouldPubSubPublishToChannel(publishingModules)) {
                    dispatcher({
                        type: SEND_MESSAGE_START,
                        payload: message,
                    });
                }
            }));
            subscriber.set(PUBSUB_TOPICS.ON_FILE_INFO_UPLOADED, pubSub.subscribe(PUBSUB_TOPICS.ON_FILE_INFO_UPLOADED, function (props) {
                var response = props.response, publishingModules = props.publishingModules;
                if (channelUrl === response.channelUrl && shouldPubSubPublishToChannel(publishingModules)) {
                    dispatcher({
                        type: ON_FILE_INFO_UPLOADED,
                        payload: response,
                    });
                }
            }));
            subscriber.set(PUBSUB_TOPICS.SEND_MESSAGE_FAILED, pubSub.subscribe(PUBSUB_TOPICS.SEND_MESSAGE_FAILED, function (props) {
                var channel = props.channel, message = props.message, publishingModules = props.publishingModules;
                if (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url) && shouldPubSubPublishToChannel(publishingModules)) {
                    dispatcher({
                        type: SEND_MESSAGE_FAILURE,
                        payload: message,
                    });
                }
            }));
            subscriber.set(PUBSUB_TOPICS.SEND_FILE_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.SEND_FILE_MESSAGE, function (props) {
                var channel = props.channel, message = props.message;
                if (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    dispatcher({
                        type: SEND_MESSAGE_SUCCESS,
                        payload: message,
                    });
                    setTimeout(function () { return scrollIntoLast(0, scrollRef); }, SCROLL_BOTTOM_DELAY_FOR_SEND);
                }
            }));
            subscriber.set(PUBSUB_TOPICS.UPDATE_USER_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.UPDATE_USER_MESSAGE, function (props) {
                var channel = props.channel, message = props.message, fromSelector = props.fromSelector;
                if (fromSelector && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url)) && channel.isGroupChannel()) {
                    dispatcher({
                        type: ON_MESSAGE_UPDATED,
                        payload: { channel: channel, message: message },
                    });
                }
            }));
            subscriber.set(PUBSUB_TOPICS.DELETE_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.DELETE_MESSAGE, function (props) {
                var channel = props.channel, messageId = props.messageId;
                if (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    dispatcher({
                        type: ON_MESSAGE_DELETED,
                        payload: messageId,
                    });
                }
            }));
        }
        return function () {
            subscriber.forEach(function (s) {
                try {
                    s.remove();
                }
                catch (_a) {
                    //
                }
            });
        };
    }, [
        channelUrl,
        sdkInit,
    ]);
};

var ChannelContext = react.createContext(null);
/**
 * @deprecated This provider is deprecated and will be removed in the next major update.
 * Please use the `GroupChannelProvider` from '@sendbird/uikit-react/GroupChannel' instead.
 * For more information, please refer to the migration guide:
 * https://docs.sendbird.com/docs/chat/uikit/v3/react/introduction/group-channel-migration-guide
 */
var context_ChannelProvider = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var channelUrl = props.channelUrl, children = props.children, isReactionEnabled = props.isReactionEnabled, _g = props.isMessageGroupingEnabled, isMessageGroupingEnabled = _g === void 0 ? true : _g, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, showSearchIcon = props.showSearchIcon, animatedMessage = props.animatedMessage, highlightedMessage = props.highlightedMessage, startingPoint = props.startingPoint, onBeforeSendUserMessage = props.onBeforeSendUserMessage, onBeforeSendFileMessage = props.onBeforeSendFileMessage, onBeforeUpdateUserMessage = props.onBeforeUpdateUserMessage, onBeforeSendVoiceMessage = props.onBeforeSendVoiceMessage, onBeforeSendMultipleFilesMessage = props.onBeforeSendMultipleFilesMessage, onChatHeaderActionClick = props.onChatHeaderActionClick, onSearchClick = props.onSearchClick, onBackClick = props.onBackClick, threadReplySelectType = props.threadReplySelectType, queries = props.queries, filterMessageList = props.filterMessageList, _h = props.disableMarkAsRead, disableMarkAsRead = _h === void 0 ? false : _h, onReplyInThread = props.onReplyInThread, onQuoteMessageClick = props.onQuoteMessageClick, onMessageAnimated = props.onMessageAnimated, onMessageHighlighted = props.onMessageHighlighted, _j = props.scrollBehavior, scrollBehavior = _j === void 0 ? 'auto' : _j, _k = props.reconnectOnIdle, reconnectOnIdle = _k === void 0 ? true : _k;
    var globalStore = useSendbirdStateContext();
    var config = globalStore.config;
    var replyType = (_a = props.replyType) !== null && _a !== void 0 ? _a : getCaseResolvedReplyType(config.groupChannel.replyType).upperCase;
    var pubSub = config.pubSub, logger = config.logger, userId = config.userId, isOnline = config.isOnline, imageCompression = config.imageCompression, markAsReadScheduler = config.markAsReadScheduler, groupChannel = config.groupChannel, htmlTextDirection = config.htmlTextDirection, forceLeftToRightMessageLayout = config.forceLeftToRightMessageLayout;
    var sdk = (_c = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.sdk;
    var sdkInit = (_e = (_d = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _d === void 0 ? void 0 : _d.sdkStore) === null || _e === void 0 ? void 0 : _e.initialized;
    var globalConfigs = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config;
    var _l = useState(startingPoint), initialTimeStamp = _l[0], setInitialTimeStamp = _l[1];
    useEffect(function () {
        setInitialTimeStamp(startingPoint);
    }, [startingPoint, channelUrl]);
    var _m = useState(null), animatedMessageId = _m[0], setAnimatedMessageId = _m[1];
    var _o = useState(highlightedMessage), highLightedMessageId = _o[0], setHighLightedMessageId = _o[1];
    useEffect(function () {
        setHighLightedMessageId(highlightedMessage);
    }, [highlightedMessage]);
    var userFilledMessageListQuery = queries === null || queries === void 0 ? void 0 : queries.messageListParams;
    var _p = useState(null), quoteMessage = _p[0], setQuoteMessage = _p[1];
    var _q = useState(false), isScrolled = _q[0], setIsScrolled = _q[1];
    var _r = useReducer(channelReducer, context_initialState), messagesStore = _r[0], messagesDispatcher = _r[1];
    var scrollRef = useRef(null);
    var isMentionEnabled = groupChannel.enableMention;
    var allMessages = messagesStore.allMessages, localMessages = messagesStore.localMessages, loading = messagesStore.loading, initialized = messagesStore.initialized, unreadSince = messagesStore.unreadSince, unreadSinceDate = messagesStore.unreadSinceDate, isInvalid = messagesStore.isInvalid, currentGroupChannel = messagesStore.currentGroupChannel, hasMorePrev = messagesStore.hasMorePrev, oldestMessageTimeStamp = messagesStore.oldestMessageTimeStamp, hasMoreNext = messagesStore.hasMoreNext, latestMessageTimeStamp = messagesStore.latestMessageTimeStamp, emojiContainer = messagesStore.emojiContainer, readStatus = messagesStore.readStatus, typingMembers = messagesStore.typingMembers;
    var usingReaction = getIsReactionEnabled({
        channel: currentGroupChannel,
        config: config,
        moduleLevel: isReactionEnabled,
    });
    var emojiAllMap = useMemo(function () { return (usingReaction
        ? getAllEmojisMapFromEmojiContainer(emojiContainer)
        : new Map()); }, [emojiContainer]);
    var nicknamesMap = useMemo(function () { return ((usingReaction && currentGroupChannel)
        ? getNicknamesMapFromMembers(currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members)
        : new Map()); }, [currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members]);
    // Animate message
    useEffect(function () {
        if (animatedMessage) {
            setAnimatedMessageId(animatedMessage);
        }
    }, [animatedMessage]);
    // Scrollup is default scroll for channel
    var onScrollCallback = useScrollCallback({
        currentGroupChannel: currentGroupChannel,
        oldestMessageTimeStamp: oldestMessageTimeStamp,
        userFilledMessageListQuery: userFilledMessageListQuery,
        replyType: replyType,
    }, {
        hasMorePrev: hasMorePrev,
        logger: logger,
        messagesDispatcher: messagesDispatcher,
        sdk: sdk,
    });
    var scrollToMessage = useScrollToMessage({
        setInitialTimeStamp: setInitialTimeStamp,
        setAnimatedMessageId: setAnimatedMessageId,
        allMessages: allMessages,
        scrollRef: scrollRef,
    }, { logger: logger });
    // onScrollDownCallback is added for navigation to different timestamps on messageSearch
    // hasMorePrev, onScrollCallback -> scroll up(default behavior)
    // hasMoreNext, onScrollDownCallback -> scroll down
    var onScrollDownCallback = useScrollDownCallback({
        currentGroupChannel: currentGroupChannel,
        latestMessageTimeStamp: latestMessageTimeStamp,
        userFilledMessageListQuery: userFilledMessageListQuery,
        hasMoreNext: hasMoreNext,
        replyType: replyType,
    }, {
        logger: logger,
        messagesDispatcher: messagesDispatcher,
        sdk: sdk,
    });
    var toggleReaction = useToggleReactionCallback(currentGroupChannel, logger);
    // to create message-datasource
    // this hook sets currentGroupChannel asynchronously
    useGetChannel({ channelUrl: channelUrl, sdkInit: sdkInit, disableMarkAsRead: disableMarkAsRead }, { messagesDispatcher: messagesDispatcher, sdk: sdk, logger: logger, markAsReadScheduler: markAsReadScheduler });
    // to set quote message as null
    useEffect(function () {
        setQuoteMessage(null);
    }, [channelUrl]);
    // Hook to handle ChannelEvents and send values to useReducer using messagesDispatcher
    useHandleChannelEvents({
        currentGroupChannel: currentGroupChannel,
        sdkInit: sdkInit,
        currentUserId: userId,
        disableMarkAsRead: disableMarkAsRead,
    }, {
        messagesDispatcher: messagesDispatcher,
        sdk: sdk,
        logger: logger,
        scrollRef: scrollRef,
        setQuoteMessage: setQuoteMessage,
    });
    // hook that fetches messages when channel changes
    // to be clear here useGetChannel sets currentGroupChannel
    // and useInitialMessagesFetch executes when currentGroupChannel changes
    // p.s This one executes on initialTimeStamp change too
    useInitialMessagesFetch({
        currentGroupChannel: currentGroupChannel,
        userFilledMessageListQuery: userFilledMessageListQuery,
        initialTimeStamp: initialTimeStamp,
        replyType: replyType,
        setIsScrolled: setIsScrolled,
    }, {
        logger: logger,
        scrollRef: scrollRef,
        messagesDispatcher: messagesDispatcher,
    });
    // handles API calls from withSendbird
    useHandleChannelPubsubEvents({
        channelUrl: channelUrl,
        sdkInit: sdkInit,
        pubSub: pubSub,
        dispatcher: messagesDispatcher,
        scrollRef: scrollRef,
    });
    // handling connection breaks
    useHandleReconnect({ isOnline: isOnline, replyType: replyType, disableMarkAsRead: disableMarkAsRead, reconnectOnIdle: reconnectOnIdle }, {
        logger: logger,
        sdk: sdk,
        scrollRef: scrollRef,
        currentGroupChannel: currentGroupChannel,
        messagesDispatcher: messagesDispatcher,
        userFilledMessageListQuery: userFilledMessageListQuery,
        markAsReadScheduler: markAsReadScheduler,
    });
    useMessageLayoutDirection(htmlTextDirection, forceLeftToRightMessageLayout, loading);
    // callbacks for Message CURD actions
    var deleteMessage = useDeleteMessageCallback({ currentGroupChannel: currentGroupChannel, messagesDispatcher: messagesDispatcher }, { logger: logger });
    var updateMessage = useUpdateMessageCallback({ currentGroupChannel: currentGroupChannel, messagesDispatcher: messagesDispatcher, onBeforeUpdateUserMessage: onBeforeUpdateUserMessage, isMentionEnabled: isMentionEnabled }, { logger: logger, pubSub: pubSub });
    var resendMessage = useResendMessageCallback({ currentGroupChannel: currentGroupChannel, messagesDispatcher: messagesDispatcher }, { logger: logger, pubSub: pubSub });
    var _s = useSendMessageCallback({
        currentGroupChannel: currentGroupChannel,
        isMentionEnabled: isMentionEnabled,
        onBeforeSendUserMessage: onBeforeSendUserMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        scrollRef: scrollRef,
        messagesDispatcher: messagesDispatcher,
    }), messageInputRef = _s[0], sendMessage = _s[1];
    var sendFileMessage = useSendFileMessageCallback({
        currentGroupChannel: currentGroupChannel,
        imageCompression: imageCompression,
        onBeforeSendFileMessage: onBeforeSendFileMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        scrollRef: scrollRef,
        messagesDispatcher: messagesDispatcher,
    })[0];
    var sendVoiceMessage = useSendVoiceMessageCallback({
        currentGroupChannel: currentGroupChannel,
        onBeforeSendVoiceMessage: onBeforeSendVoiceMessage,
    }, {
        logger: logger,
        pubSub: pubSub,
        scrollRef: scrollRef,
        messagesDispatcher: messagesDispatcher,
    })[0];
    var sendMultipleFilesMessage = useSendMultipleFilesMessage({
        currentChannel: currentGroupChannel,
        onBeforeSendMultipleFilesMessage: onBeforeSendMultipleFilesMessage,
        publishingModules: [PublishingModuleType.CHANNEL],
    }, {
        logger: logger,
        pubSub: pubSub,
        scrollRef: scrollRef,
    })[0];
    return (React__default.createElement(ChannelContext.Provider, { value: {
            // props
            channelUrl: channelUrl,
            isReactionEnabled: usingReaction,
            isMessageGroupingEnabled: isMessageGroupingEnabled,
            isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled,
            showSearchIcon: showSearchIcon !== null && showSearchIcon !== void 0 ? showSearchIcon : globalConfigs.groupChannelSettings.enableMessageSearch,
            highlightedMessage: highlightedMessage,
            startingPoint: startingPoint,
            onBeforeSendUserMessage: onBeforeSendUserMessage,
            onBeforeSendFileMessage: onBeforeSendFileMessage,
            onBeforeUpdateUserMessage: onBeforeUpdateUserMessage,
            onChatHeaderActionClick: onChatHeaderActionClick,
            onSearchClick: onSearchClick,
            onBackClick: onBackClick,
            replyType: replyType,
            threadReplySelectType: (_f = threadReplySelectType !== null && threadReplySelectType !== void 0 ? threadReplySelectType : getCaseResolvedThreadReplySelectType(groupChannel.threadReplySelectType).upperCase) !== null && _f !== void 0 ? _f : ThreadReplySelectType.THREAD,
            queries: queries,
            filterMessageList: filterMessageList,
            disableMarkAsRead: disableMarkAsRead,
            onReplyInThread: onReplyInThread,
            onQuoteMessageClick: onQuoteMessageClick,
            onMessageAnimated: onMessageAnimated,
            onMessageHighlighted: onMessageHighlighted,
            // messagesStore
            allMessages: allMessages,
            localMessages: localMessages,
            loading: loading,
            initialized: initialized,
            unreadSince: unreadSince,
            unreadSinceDate: unreadSinceDate,
            isInvalid: isInvalid,
            currentGroupChannel: currentGroupChannel,
            hasMorePrev: hasMorePrev,
            hasMoreNext: hasMoreNext,
            oldestMessageTimeStamp: oldestMessageTimeStamp,
            latestMessageTimeStamp: latestMessageTimeStamp,
            emojiContainer: emojiContainer,
            readStatus: readStatus,
            typingMembers: typingMembers,
            // utils
            scrollToMessage: scrollToMessage,
            quoteMessage: quoteMessage,
            setQuoteMessage: setQuoteMessage,
            deleteMessage: deleteMessage,
            updateMessage: updateMessage,
            resendMessage: resendMessage,
            messageInputRef: messageInputRef,
            sendMessage: sendMessage,
            sendFileMessage: sendFileMessage,
            sendVoiceMessage: sendVoiceMessage,
            sendMultipleFilesMessage: sendMultipleFilesMessage,
            initialTimeStamp: initialTimeStamp,
            messageActionTypes: channelActions,
            messagesDispatcher: messagesDispatcher,
            setInitialTimeStamp: setInitialTimeStamp,
            setAnimatedMessageId: setAnimatedMessageId,
            setHighLightedMessageId: setHighLightedMessageId,
            animatedMessageId: animatedMessageId,
            highLightedMessageId: highLightedMessageId,
            nicknamesMap: nicknamesMap,
            emojiAllMap: emojiAllMap,
            onScrollCallback: onScrollCallback,
            onScrollDownCallback: onScrollDownCallback,
            scrollRef: scrollRef,
            scrollBehavior: scrollBehavior,
            toggleReaction: toggleReaction,
            isScrolled: isScrolled,
            setIsScrolled: setIsScrolled,
        } },
        React__default.createElement(UserProfileProvider, __assign({}, props), children)));
};
var context_useChannelContext = function () {
    var context = React__default.useContext(ChannelContext);
    if (!context)
        throw new Error('ChannelContext not found. Use within the Channel module.');
    return context;
};


//# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CLczesce.js
var bundle_CLczesce = __webpack_require__(22280);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BpNhTt2R.js
var bundle_BpNhTt2R = __webpack_require__(48609);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CgymNuYl.js
var bundle_CgymNuYl = __webpack_require__(11639);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/ChannelHeader.js























































var ChannelHeader_ChannelHeader = function (_a) {
    var className = _a.className;
    var context = useChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, context, { className: className, currentChannel: context.currentGroupChannel })));
};


//# sourceMappingURL=ChannelHeader.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CJirTNRH.js
var bundle_CJirTNRH = __webpack_require__(86694);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-C_v0tgQ0.js
var bundle_C_v0tgQ0 = __webpack_require__(70400);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/FileViewer.js

















































var FileViewer_FileViewer = function (props) {
    var deleteMessage = useChannelContext().deleteMessage;
    return React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage }));
};


//# sourceMappingURL=FileViewer.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BHNcTHkg.js
var bundle_BHNcTHkg = __webpack_require__(84241);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-B8L7dGsu.js
var bundle_B8L7dGsu = __webpack_require__(44892);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/RemoveMessageModal.js















































var RemoveMessageModal_RemoveMessageModal = function (props) {
    var deleteMessage = useChannelContext().deleteMessage;
    return React__default.createElement(RemoveMessageModalView, __assign({}, props, { deleteMessage: deleteMessage }));
};


//# sourceMappingURL=RemoveMessageModal.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BaMsxnN_.js
var bundle_BaMsxnN_ = __webpack_require__(30302);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Message/hooks/useDirtyGetMentions.js
var useDirtyGetMentions = __webpack_require__(66421);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/DateSeparator.js
var DateSeparator = __webpack_require__(8743);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageInput.js
var MessageInput = __webpack_require__(65134);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CLlCJbe7.js
var bundle_CLlCJbe7 = __webpack_require__(459);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-tC4B8MXx.js + 1 modules
var bundle_tC4B8MXx = __webpack_require__(89171);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageContent.js
var MessageContent = __webpack_require__(3533);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CfaZQwKj.js
var bundle_CfaZQwKj = __webpack_require__(24277);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageItemReactionMenu.js
var MessageItemReactionMenu = __webpack_require__(69139);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ReactionButton.js
var ReactionButton = __webpack_require__(60090);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/EmojiReactions.js
var EmojiReactions = __webpack_require__(27835);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ReactionBadge.js
var ReactionBadge = __webpack_require__(30156);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/BottomSheet.js
var BottomSheet = __webpack_require__(18087);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Tooltip.js
var Tooltip = __webpack_require__(76886);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TooltipWrapper.js
var TooltipWrapper = __webpack_require__(32080);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Message/context.js
var context = __webpack_require__(23012);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/AdminMessage.js
var AdminMessage = __webpack_require__(1167);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/QuoteMessage.js
var QuoteMessage = __webpack_require__(26862);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-oZLTNsQY.js
var bundle_oZLTNsQY = __webpack_require__(78828);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MobileMenu.js
var MobileMenu = __webpack_require__(56342);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ThreadReplies.js
var ThreadReplies = __webpack_require__(68873);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-KDJ0EkHX.js
var bundle_KDJ0EkHX = __webpack_require__(15394);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/OGMessageItemBody.js
var OGMessageItemBody = __webpack_require__(34835);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DjfGQ-DS.js
var bundle_DjfGQ_DS = __webpack_require__(1277);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MentionLabel.js
var MentionLabel = __webpack_require__(81823);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/LinkLabel.js
var LinkLabel = __webpack_require__(40286);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TextMessageItemBody.js
var TextMessageItemBody = __webpack_require__(50206);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FileMessageItemBody.js
var FileMessageItemBody = __webpack_require__(12210);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BFQnMRhA.js
var bundle_BFQnMRhA = __webpack_require__(43071);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FileViewer.js
var ui_FileViewer = __webpack_require__(6989);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-vS1u8K1w.js
var bundle_vS1u8K1w = __webpack_require__(60424);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/VoiceMessageItemBody.js
var VoiceMessageItemBody = __webpack_require__(71612);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ProgressBar.js
var ProgressBar = __webpack_require__(68962);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/VoicePlayer/useVoicePlayer.js
var useVoicePlayer = __webpack_require__(32177);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/PlaybackTime.js
var PlaybackTime = __webpack_require__(28464);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ThumbnailMessageItemBody.js
var ThumbnailMessageItemBody = __webpack_require__(48845);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/UnknownMessageItemBody.js
var UnknownMessageItemBody = __webpack_require__(33709);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TemplateMessageItemBody.js
var TemplateMessageItemBody = __webpack_require__(49754);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-KNrNIKZQ.js
var bundle_KNrNIKZQ = __webpack_require__(19652);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FallbackTemplateMessageItemBody.tsx.js
var FallbackTemplateMessageItemBody_tsx = __webpack_require__(34498);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/LoadingTemplateMessageItemBody.tsx.js
var LoadingTemplateMessageItemBody_tsx = __webpack_require__(64437);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageFeedbackFailedModal.js
var MessageFeedbackFailedModal = __webpack_require__(21402);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/FeedbackIconButton.js
var FeedbackIconButton = __webpack_require__(15345);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MobileFeedbackMenu.js
var MobileFeedbackMenu = __webpack_require__(45143);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageFeedbackModal.js
var MessageFeedbackModal = __webpack_require__(74062);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D634UqaM.js
var bundle_D634UqaM = __webpack_require__(76039);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/SuggestedReplies.js
var SuggestedReplies = __webpack_require__(52597);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CUxTGz0r.js
var bundle_CUxTGz0r = __webpack_require__(12225);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/Message.js
























































































































var Message_Message = function (props) {
    var _a, _b, _c;
    var config = useSendbirdStateContext().config;
    var _d = useChannelContext(), initialized = _d.initialized, currentGroupChannel = _d.currentGroupChannel, animatedMessageId = _d.animatedMessageId, setAnimatedMessageId = _d.setAnimatedMessageId, updateMessage = _d.updateMessage, scrollToMessage = _d.scrollToMessage, replyType = _d.replyType, threadReplySelectType = _d.threadReplySelectType, isReactionEnabled = _d.isReactionEnabled, toggleReaction = _d.toggleReaction, emojiContainer = _d.emojiContainer, nicknamesMap = _d.nicknamesMap, setQuoteMessage = _d.setQuoteMessage, resendMessage = _d.resendMessage, deleteMessage = _d.deleteMessage, renderUserMentionItem = _d.renderUserMentionItem, onReplyInThread = _d.onReplyInThread, onQuoteMessageClick = _d.onQuoteMessageClick, onMessageAnimated = _d.onMessageAnimated, sendMessage = _d.sendMessage, localMessages = _d.localMessages;
    var message = props.message;
    if (!currentGroupChannel)
        return null;
    return (React__default.createElement(MessageView, __assign({}, props, { channel: currentGroupChannel, emojiContainer: emojiContainer, editInputDisabled: !initialized || isDisabledBecauseFrozen(currentGroupChannel) || isDisabledBecauseMuted(currentGroupChannel) || !config.isOnline, shouldRenderSuggestedReplies: ((_a = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _a === void 0 ? void 0 : _a.enableSuggestedReplies)
            && (((_b = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _b === void 0 ? void 0 : _b.showSuggestedRepliesFor) === 'all_messages'
                ? true
                : message.messageId === ((_c = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.lastMessage) === null || _c === void 0 ? void 0 : _c.messageId))
            // the options should appear only when there's no failed or pending messages
            && (localMessages === null || localMessages === void 0 ? void 0 : localMessages.length) === 0
            && getSuggestedReplies(message).length > 0, isReactionEnabled: isReactionEnabled, replyType: replyType, threadReplySelectType: threadReplySelectType, nicknamesMap: nicknamesMap, renderUserMentionItem: renderUserMentionItem, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction, setQuoteMessage: setQuoteMessage, onQuoteMessageClick: onQuoteMessageClick, onReplyInThreadClick: onReplyInThread, sendUserMessage: function (params) {
            sendMessage({
                message: params.message,
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, updateUserMessage: function (messageId, params) {
            var _a;
            updateMessage({
                messageId: messageId,
                message: (_a = params.message) !== null && _a !== void 0 ? _a : '',
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, resendMessage: resendMessage, deleteMessage: deleteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, onMessageAnimated: onMessageAnimated, renderFileViewer: function (props) { return React__default.createElement(FileViewer, __assign({}, props)); }, renderRemoveMessageModal: function (props) { return React__default.createElement(RemoveMessageModal, __assign({}, props)); } })));
};


//# sourceMappingURL=Message.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BY9N9Qg0.js
var bundle_BY9N9Qg0 = __webpack_require__(15880);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/UnreadCount.js
var components_UnreadCount = __webpack_require__(11621);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/FrozenNotification.js
var components_FrozenNotification = __webpack_require__(88137);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Bj90BL0E.js





var DELAY = 100;
function calcScrollBottom(scrollHeight, scrollTop) {
    return scrollHeight - scrollTop;
}
function bundle_Bj90BL0E_useHandleOnScrollCallback(_a) {
    var hasMore = _a.hasMore, hasNext = _a.hasNext, onScroll = _a.onScroll, scrollRef = _a.scrollRef, setShowScrollDownButton = _a.setShowScrollDownButton;
    var scrollCb = (0,esm/* usePreservedCallback */.zS)(function () {
        var element = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
        if (element == null)
            return;
        var scrollTop = element.scrollTop, scrollHeight = element.scrollHeight, clientHeight = element.clientHeight;
        // https://sendbird.atlassian.net/browse/SBISSUE-11759
        // the edge case where channel is inside a page that already has scroll
        // scrollintoView will move the whole page, which we dont want
        var scrollBottom = calcScrollBottom(scrollHeight, scrollTop);
        // even if there is more to fetch or not,
        // we still have to show the scroll to bottom button
        if (typeof setShowScrollDownButton === 'function') {
            setShowScrollDownButton(scrollHeight > scrollTop + clientHeight + 1);
        }
        // Load previous messages
        // 1. check if hasMore(hasPrevious) and reached to top
        // 2. load previous messages (onScroll)
        // 3. maintain scroll position (sets the scroll position to the bottom of the new messages)
        if (hasMore && (0,bundle_CtcQd9Ql.a)(scrollTop, 0, bundle_DABR6HKW.S)) {
            onScroll(function () {
                var messagesAreAddedToView = element.scrollHeight > scrollHeight;
                if (messagesAreAddedToView)
                    element.scrollTop = element.scrollHeight - scrollBottom;
            });
        }
        // Load next messages
        // 1. check if hasNext and reached to bottom
        // 2. load next messages (onScroll)
        // 3. maintain scroll position (sets the scroll position to the top of the new messages)
        if (hasNext && (0,bundle_CtcQd9Ql.a)(clientHeight + scrollTop, scrollHeight, bundle_DABR6HKW.S)) {
            onScroll(function () {
                var messagesAreAddedToView = element.scrollHeight > scrollHeight;
                if (messagesAreAddedToView)
                    element.scrollTop = scrollTop;
            });
        }
    });
    return bundle_BmCCzxjb_useThrottleCallback(scrollCb, DELAY, { trailing: true });
}


//# sourceMappingURL=bundle-Bj90BL0E.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/TypingIndicatorBubble.js
var ui_TypingIndicatorBubble = __webpack_require__(10765);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Channel/utils/getMessagePartsInfo.js
var utils_getMessagePartsInfo = __webpack_require__(3196);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Channel/utils/compareMessagesForGrouping.js
var compareMessagesForGrouping = __webpack_require__(60196);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/MessageList.js



































































































































var MessageList_DELAY = 100;
function useSetScrollToBottom(_a) {
    var loading = _a.loading;
    var _b = useState(0), scrollBottom = _b[0], setScrollBottom = _b[1];
    useEffect(function () {
        if (loading) {
            setScrollBottom(0);
        }
    }, [loading]);
    var scrollCb = function (e) {
        var element = e.target;
        try {
            setScrollBottom(element.scrollHeight - element.scrollTop - element.offsetHeight);
        }
        catch (_a) {
            //
        }
    };
    return {
        scrollBottom: scrollBottom,
        scrollToBottomHandler: useThrottleCallback(scrollCb, MessageList_DELAY, { trailing: true }),
    };
}

function useScrollBehavior() {
    var _a = useChannelContext(), scrollRef = _a.scrollRef, _b = _a.scrollBehavior, scrollBehavior = _b === void 0 ? 'auto' : _b;
    useEffect(function () {
        if (scrollRef.current) {
            scrollRef.current.style.scrollBehavior = scrollBehavior;
        }
    }, [scrollRef.current]);
    return null;
}

/* We operate the CSS files for Channel&GroupChannel modules in the GroupChannel */
var SCROLL_BOTTOM_PADDING = 50;
var MessageList_MessageList = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = props.className, className = _f === void 0 ? '' : _f;
    var _g = deleteNullish(props), renderMessage = _g.renderMessage, renderMessageContent = _g.renderMessageContent, renderSuggestedReplies = _g.renderSuggestedReplies, renderCustomSeparator = _g.renderCustomSeparator, _h = _g.renderPlaceholderLoader, renderPlaceholderLoader = _h === void 0 ? function () { return React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING }); } : _h, _j = _g.renderPlaceholderEmpty, renderPlaceholderEmpty = _j === void 0 ? function () { return React__default.createElement(PlaceHolder, { className: "sendbird-conversation__no-messages", type: PlaceHolderTypes.NO_MESSAGES }); } : _j, _k = _g.renderFrozenNotification, renderFrozenNotification = _k === void 0 ? function () { return React__default.createElement(FrozenNotification, { className: "sendbird-conversation__messages__notification" }); } : _k;
    var _l = useChannelContext(), allMessages = _l.allMessages, localMessages = _l.localMessages, hasMorePrev = _l.hasMorePrev, hasMoreNext = _l.hasMoreNext, setInitialTimeStamp = _l.setInitialTimeStamp, setAnimatedMessageId = _l.setAnimatedMessageId, setHighLightedMessageId = _l.setHighLightedMessageId, isMessageGroupingEnabled = _l.isMessageGroupingEnabled, scrollRef = _l.scrollRef, onScrollCallback = _l.onScrollCallback, onScrollDownCallback = _l.onScrollDownCallback, messagesDispatcher = _l.messagesDispatcher, messageActionTypes = _l.messageActionTypes, currentGroupChannel = _l.currentGroupChannel, disableMarkAsRead = _l.disableMarkAsRead, filterMessageList = _l.filterMessageList, replyType = _l.replyType, loading = _l.loading, isScrolled = _l.isScrolled, unreadSince = _l.unreadSince, unreadSinceDate = _l.unreadSinceDate, typingMembers = _l.typingMembers;
    var store = useSendbirdStateContext();
    var allMessagesFiltered = typeof filterMessageList === 'function' ? allMessages.filter(filterMessageList) : allMessages;
    var markAsReadScheduler = store.config.markAsReadScheduler;
    var _m = useState(false), isScrollBottom = _m[0], setIsScrollBottom = _m[1];
    useScrollBehavior();
    /**
     * @param {function} callback callback from useHandleOnScrollCallback, it adjusts scroll position
     * */
    var onScroll = function (callback) {
        var element = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
        if (element == null) {
            return;
        }
        var scrollTop = element.scrollTop, clientHeight = element.clientHeight, scrollHeight = element.scrollHeight;
        if (hasMorePrev && isAboutSame(scrollTop, 0, SCROLL_BUFFER)) {
            onScrollCallback(callback);
        }
        if (hasMoreNext && isAboutSame(clientHeight + scrollTop, scrollHeight, SCROLL_BUFFER)) {
            onScrollDownCallback(callback);
        }
        if (!disableMarkAsRead && isAboutSame(clientHeight + scrollTop, scrollHeight, SCROLL_BUFFER) && !!currentGroupChannel) {
            messagesDispatcher({
                type: messageActionTypes.MARK_AS_READ,
                payload: { channel: currentGroupChannel },
            });
            markAsReadScheduler.push(currentGroupChannel);
        }
    };
    var onClickScrollBot = function () {
        var _a, _b;
        setInitialTimeStamp === null || setInitialTimeStamp === void 0 ? void 0 : setInitialTimeStamp(null);
        setAnimatedMessageId === null || setAnimatedMessageId === void 0 ? void 0 : setAnimatedMessageId(null);
        setHighLightedMessageId === null || setHighLightedMessageId === void 0 ? void 0 : setHighLightedMessageId(null);
        if (scrollRef.current && scrollRef.current.scrollTop > -1) {
            scrollRef.current.scrollTop = ((_a = scrollRef.current.scrollHeight) !== null && _a !== void 0 ? _a : 0) - ((_b = scrollRef.current.offsetHeight) !== null && _b !== void 0 ? _b : 0);
        }
    };
    /**
     * 1. Move the messsage list scroll
     *    when each message's height is changed by `reactions` OR `showEdit`
     * 2. Keep the scrollBottom value after fetching new message list
     */
    var moveScroll = function (isBottomMessageAffected) {
        if (isBottomMessageAffected === void 0) { isBottomMessageAffected = false; }
        var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
        if (current) {
            var bottom = current.scrollHeight - current.scrollTop - current.offsetHeight;
            if (scrollBottom < bottom && (!isBottomMessageAffected || scrollBottom < SCROLL_BUFFER)) {
                // Move the scroll as much as the height of the message has changed
                current.scrollTop += bottom - scrollBottom;
            }
        }
    };
    var handleOnScroll = useHandleOnScrollCallback({
        hasMore: hasMorePrev,
        hasNext: hasMoreNext,
        onScroll: onScroll,
        scrollRef: scrollRef,
    });
    var onScrollReachedEndDetector = useOnScrollPositionChangeDetector({
        onReachedBottom: function () {
            /**
             * Note that this event is already being called in onScroll() above. However, it is only being called when
             * hasMoreNext is true but it needs to be called when hasNext is false when reached bottom as well.
             */
            if (!hasMoreNext && !disableMarkAsRead && !!currentGroupChannel) {
                messagesDispatcher({
                    type: messageActionTypes.MARK_AS_READ,
                    payload: { channel: currentGroupChannel },
                });
                markAsReadScheduler.push(currentGroupChannel);
            }
            setIsScrollBottom(true);
        },
        onReachedTop: function () {
            setIsScrollBottom(false);
        },
        onInBetween: function () {
            setIsScrollBottom(false);
        },
    });
    var _o = useSetScrollToBottom({ loading: loading }), scrollToBottomHandler = _o.scrollToBottomHandler, scrollBottom = _o.scrollBottom;
    if (loading) {
        return renderPlaceholderLoader();
    }
    if (allMessagesFiltered.length < 1) {
        return renderPlaceholderEmpty();
    }
    return (React__default.createElement(React__default.Fragment, null,
        !isScrolled && React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING }),
        React__default.createElement("div", { className: "sendbird-conversation__messages ".concat(className) },
            React__default.createElement("div", { className: "sendbird-conversation__scroll-container" },
                React__default.createElement("div", { className: "sendbird-conversation__padding" }),
                React__default.createElement("div", { className: "sendbird-conversation__messages-padding", "data-testid": "sendbird-message-list-container", ref: scrollRef, onScroll: function (e) {
                        handleOnScroll();
                        scrollToBottomHandler(e);
                        onScrollReachedEndDetector(e);
                    } },
                    allMessagesFiltered.map(function (m, idx) {
                        var _a, _b;
                        var _c = getMessagePartsInfo({
                            allMessages: allMessagesFiltered,
                            replyType: replyType,
                            isMessageGroupingEnabled: isMessageGroupingEnabled,
                            currentIndex: idx,
                            currentMessage: m,
                            currentChannel: currentGroupChannel,
                        }), chainTop = _c.chainTop, chainBottom = _c.chainBottom, hasSeparator = _c.hasSeparator;
                        var isByMe = ((_a = m === null || m === void 0 ? void 0 : m.sender) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = store === null || store === void 0 ? void 0 : store.config) === null || _b === void 0 ? void 0 : _b.userId);
                        return (React__default.createElement(MessageProvider, { message: m, key: m === null || m === void 0 ? void 0 : m.messageId, isByMe: isByMe },
                            React__default.createElement(Message, { handleScroll: moveScroll, message: m, hasSeparator: hasSeparator, chainTop: chainTop, chainBottom: chainBottom, renderMessageContent: renderMessageContent, renderSuggestedReplies: renderSuggestedReplies, renderCustomSeparator: renderCustomSeparator, 
                                // backward compatibility
                                renderMessage: renderMessage })));
                    }),
                    localMessages.map(function (m, idx) {
                        var _a, _b;
                        var _c = getMessagePartsInfo({
                            allMessages: allMessagesFiltered,
                            replyType: replyType,
                            isMessageGroupingEnabled: isMessageGroupingEnabled,
                            currentIndex: idx,
                            currentMessage: m,
                            currentChannel: currentGroupChannel,
                        }), chainTop = _c.chainTop, chainBottom = _c.chainBottom;
                        var isByMe = ((_a = m === null || m === void 0 ? void 0 : m.sender) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = store === null || store === void 0 ? void 0 : store.config) === null || _b === void 0 ? void 0 : _b.userId);
                        return (React__default.createElement(MessageProvider, { message: m, key: m === null || m === void 0 ? void 0 : m.messageId, isByMe: isByMe },
                            React__default.createElement(Message, { handleScroll: moveScroll, message: m, chainTop: chainTop, chainBottom: chainBottom, renderMessageContent: renderMessageContent, renderSuggestedReplies: renderSuggestedReplies, renderCustomSeparator: renderCustomSeparator, 
                                // backward compatibility
                                renderMessage: renderMessage })));
                    }),
                    !hasMoreNext
                        && ((_b = (_a = store === null || store === void 0 ? void 0 : store.config) === null || _a === void 0 ? void 0 : _a.groupChannel) === null || _b === void 0 ? void 0 : _b.enableTypingIndicator)
                        && ((_e = (_d = (_c = store === null || store === void 0 ? void 0 : store.config) === null || _c === void 0 ? void 0 : _c.groupChannel) === null || _d === void 0 ? void 0 : _d.typingIndicatorTypes) === null || _e === void 0 ? void 0 : _e.has(TypingIndicatorType.Bubble)) && (React__default.createElement(TypingIndicatorBubble, { typingMembers: typingMembers, handleScroll: moveScroll })))),
            (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.isFrozen) && renderFrozenNotification(),
            /**
             * Show unread count IFF scroll is not bottom or is bottom but hasNext is true.
             */
            (!isScrollBottom || hasMoreNext) && (unreadSince || unreadSinceDate) && (React__default.createElement(UnreadCount, { className: "sendbird-conversation__messages__notification", count: currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.unreadMessageCount, time: unreadSince, lastReadAt: unreadSinceDate, onClick: function () {
                    if (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)
                        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
                    if (!disableMarkAsRead && !!currentGroupChannel) {
                        markAsReadScheduler.push(currentGroupChannel);
                        messagesDispatcher({
                            type: messageActionTypes.MARK_AS_READ,
                            payload: { channel: currentGroupChannel },
                        });
                    }
                    setInitialTimeStamp(null);
                    setAnimatedMessageId(null);
                    setHighLightedMessageId(null);
                } })),
            // This flag is an unmatched variable
            scrollBottom > SCROLL_BOTTOM_PADDING && (React__default.createElement("div", { className: "sendbird-conversation__scroll-bottom-button", onClick: onClickScrollBot, onKeyDown: onClickScrollBot, tabIndex: 0, role: "button" },
                React__default.createElement(Icon, { width: "24px", height: "24px", type: IconTypes.CHEVRON_DOWN, fillColor: IconColors.PRIMARY }))))));
};


//# sourceMappingURL=MessageList.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-SyLbPukg.js
var bundle_SyLbPukg = __webpack_require__(91607);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/SuggestedMentionList.js
var SuggestedMentionList = __webpack_require__(85562);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/QuoteMessageInput.js
var QuoteMessageInput = __webpack_require__(67840);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/VoiceRecorder/useVoiceRecorder.js
var useVoiceRecorder = __webpack_require__(19515);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DBeNFit6.js
var bundle_DBeNFit6 = __webpack_require__(12291);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BRWtuT59.js
var bundle_BRWtuT59 = __webpack_require__(85385);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/MessageInput.js







































































var MessageInput_MessageInputWrapper = function (props) {
    var context = useChannelContext();
    var quoteMessage = context.quoteMessage, currentGroupChannel = context.currentGroupChannel, sendMessage = context.sendMessage, sendFileMessage = context.sendFileMessage, sendVoiceMessage = context.sendVoiceMessage, sendMultipleFilesMessage = context.sendMultipleFilesMessage;
    return (React__default.createElement(MessageInputWrapperView, __assign({}, props, context, { currentChannel: currentGroupChannel, messages: context.allMessages, sendUserMessage: function (params) {
            return sendMessage({
                message: params.message,
                mentionTemplate: params.mentionedMessageTemplate,
                mentionedUsers: params.mentionedUsers,
                quoteMessage: quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined,
            });
        }, sendFileMessage: function (params) {
            return sendFileMessage(params.file, quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        }, sendVoiceMessage: function (_a, duration) {
            var file = _a.file;
            return sendVoiceMessage(file, duration, quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        }, sendMultipleFilesMessage: function (_a) {
            var fileInfoList = _a.fileInfoList;
            return sendMultipleFilesMessage(fileInfoList.map(function (fileInfo) { return fileInfo.file; }), quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        } })));
};


//# sourceMappingURL=MessageInput.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/ConnectionStatus.js
var ConnectionStatus = __webpack_require__(55922);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel/components/ChannelUI.js




















































































































































var ChannelUI_ChannelUI = function (props) {
    var context = useChannelContext();
    var channelUrl = context.channelUrl, isInvalid = context.isInvalid;
    // Inject components to presentation layer
    var _a = deleteNullish(props), _b = _a.renderChannelHeader, renderChannelHeader = _b === void 0 ? function (p) { return React__default.createElement(ChannelHeader, __assign({}, p)); } : _b, _c = _a.renderMessageList, renderMessageList = _c === void 0 ? function (p) { return React__default.createElement(MessageList, __assign({}, p, { className: "sendbird-conversation__message-list" })); } : _c, _d = _a.renderMessageInput, renderMessageInput = _d === void 0 ? function () { return React__default.createElement(MessageInputWrapper, __assign({}, props)); } : _d;
    return (React__default.createElement(GroupChannelUIView, __assign({}, props, context, { isLoading: props === null || props === void 0 ? void 0 : props.isLoading, isInvalid: isInvalid, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};


//# sourceMappingURL=ChannelUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/Channel.js





















































































































































/**
 * @deprecated This component is deprecated and will be removed in the next major update.
 * Please use the `GroupChannel` component from '@sendbird/uikit-react/GroupChannel' instead.
 * For more information, please refer to the migration guide:
 * https://docs.sendbird.com/docs/chat/uikit/v3/react/introduction/group-channel-migration-guide
 */
var Channel_Channel = function (props) {
    return (React__default.createElement(ChannelProvider, __assign({}, props),
        React__default.createElement(ChannelUI, __assign({}, props))));
};


//# sourceMappingURL=Channel.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DnMqBZ_F.js












var RESET_CHANNEL_LIST = 'RESET_CHANNEL_LIST';
var CREATE_CHANNEL = 'CREATE_CHANNEL';
var bundle_DnMqBZ_F_LEAVE_CHANNEL_SUCCESS = 'LEAVE_CHANNEL_SUCCESS';
var bundle_DnMqBZ_F_SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var FETCH_CHANNELS_START = 'FETCH_CHANNELS_START';
var FETCH_CHANNELS_SUCCESS = 'FETCH_CHANNELS_SUCCESS';
var FETCH_CHANNELS_FAILURE = 'FETCH_CHANNELS_FAILURE';
var INIT_CHANNELS_START = 'INIT_CHANNELS_START';
var INIT_CHANNELS_SUCCESS = 'INIT_CHANNELS_SUCCESS';
var REFRESH_CHANNELS_SUCCESS = 'REFRESH_CHANNELS_SUCCESS';
var INIT_CHANNELS_FAILURE = 'INIT_CHANNELS_FAILURE';
var ON_USER_JOINED = 'ON_USER_JOINED';
var ON_CHANNEL_DELETED = 'ON_CHANNEL_DELETED';
var ON_LAST_MESSAGE_UPDATED = 'ON_LAST_MESSAGE_UPDATED';
var ON_USER_LEFT = 'ON_USER_LEFT';
var ON_CHANNEL_CHANGED = 'ON_CHANNEL_CHANGED';
var ON_CHANNEL_ARCHIVED = 'ON_CHANNEL_ARCHIVED';
var ON_CHANNEL_FROZEN = 'ON_CHANNEL_FROZEN';
var ON_CHANNEL_UNFROZEN = 'ON_CHANNEL_UNFROZEN';
var ON_READ_RECEIPT_UPDATED = 'ON_READ_RECEIPT_UPDATED';
var ON_DELIVERY_RECEIPT_UPDATED = 'ON_DELIVERY_RECEIPT_UPDATED';
var CHANNEL_LIST_PARAMS_UPDATED = 'CHANNEL_LIST_PARAMS_UPDATED';

var bundle_DnMqBZ_F_DELIVERY_RECEIPT = 'delivery_receipt';
var createEventHandler = function (_a) {
    var sdk = _a.sdk, sdkChannelHandlerId = _a.sdkChannelHandlerId, channelListDispatcher = _a.channelListDispatcher, logger = _a.logger;
    var ChannelHandler = new GroupChannelHandler({
        onChannelChanged: function (channel) {
            if (channel.isGroupChannel()) {
                logger.info('ChannelList: onChannelChanged', channel);
                channelListDispatcher({
                    type: ON_CHANNEL_CHANGED,
                    payload: channel,
                });
            }
        },
        onChannelDeleted: function (channelUrl) {
            logger.info('ChannelList: onChannelDeleted', channelUrl);
            channelListDispatcher({
                type: ON_CHANNEL_DELETED,
                payload: channelUrl,
            });
        },
        onUserJoined: function (channel) {
            logger.info('ChannelList: onUserJoined', channel);
            channelListDispatcher({
                type: ON_USER_JOINED,
                payload: channel,
            });
        },
        onUserBanned: function (channel, user) {
            var _a;
            if (channel.isGroupChannel()) {
                logger.info('Channel: onUserBanned', channel);
                var isMe = user.userId === ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                channelListDispatcher({
                    type: ON_USER_LEFT,
                    payload: { channel: channel, isMe: isMe },
                });
            }
        },
        onUserLeft: function (channel, user) {
            var _a;
            logger.info('ChannelList: onUserLeft', channel);
            var isMe = user.userId === ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
            channelListDispatcher({
                type: ON_USER_LEFT,
                payload: { channel: channel, isMe: isMe },
            });
        },
        onUnreadMemberStatusUpdated: function (channel) {
            logger.info('ChannelList: onUnreadMemberStatusUpdated', channel);
            channelListDispatcher({
                type: ON_READ_RECEIPT_UPDATED,
                payload: channel,
            });
        },
        onUndeliveredMemberStatusUpdated: function (channel) {
            logger.info('ChannelList: onUndeliveredMemberStatusUpdated', channel);
            if (channel.lastMessage) {
                channelListDispatcher({
                    type: ON_DELIVERY_RECEIPT_UPDATED,
                    payload: channel,
                });
            }
        },
        onMessageUpdated: function (channel, message) {
            var _a;
            if (channel.isGroupChannel() && ((_a = channel.lastMessage) === null || _a === void 0 ? void 0 : _a.isEqual(message))) {
                logger.info('ChannelList: onMessageUpdated', channel);
                channelListDispatcher({
                    type: ON_LAST_MESSAGE_UPDATED,
                    payload: channel,
                });
            }
        },
        onChannelHidden: function (channel) {
            logger.info('ChannelList: onChannelHidden', channel);
            channelListDispatcher({
                type: ON_CHANNEL_ARCHIVED,
                payload: channel,
            });
        },
        onChannelFrozen: function (channel) {
            if (channel.isGroupChannel()) {
                logger.info('ChannelList: onChannelFrozen', channel);
                channelListDispatcher({
                    type: ON_CHANNEL_FROZEN,
                    payload: channel,
                });
            }
        },
        onChannelUnfrozen: function (channel) {
            if (channel.isGroupChannel()) {
                logger.info('ChannelList: onChannelUnfrozen', channel);
                channelListDispatcher({
                    type: ON_CHANNEL_UNFROZEN,
                    payload: channel,
                });
            }
        },
    });
    logger.info('ChannelList: Added channelHandler');
    sdk.groupChannel.addGroupChannelHandler(sdkChannelHandlerId, ChannelHandler);
};
var createChannelListQuery = function (_a) {
    var sdk = _a.sdk, _b = _a.userFilledChannelListQuery, userFilledChannelListQuery = _b === void 0 ? {} : _b;
    var params = {
        includeEmpty: false,
        limit: 20, // The value of pagination limit could be set up to 100.
        order: GroupChannelListOrder.LATEST_LAST_MESSAGE,
    };
    if (userFilledChannelListQuery) {
        Object.keys(userFilledChannelListQuery).forEach(function (key) {
            // @ts-ignore
            params[key] = userFilledChannelListQuery[key];
        });
    }
    return sdk.groupChannel.createMyGroupChannelListQuery(params);
};
function setupChannelList(_a) {
    var _b, _c, _d, _e;
    var sdk = _a.sdk, sdkChannelHandlerId = _a.sdkChannelHandlerId, channelListDispatcher = _a.channelListDispatcher, setChannelSource = _a.setChannelSource, onChannelSelect = _a.onChannelSelect, userFilledChannelListQuery = _a.userFilledChannelListQuery, logger = _a.logger, sortChannelList = _a.sortChannelList, disableAutoSelect = _a.disableAutoSelect, markAsDeliveredScheduler = _a.markAsDeliveredScheduler, disableMarkAsDelivered = _a.disableMarkAsDelivered;
    if (sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) {
        createEventHandler({
            sdk: sdk,
            channelListDispatcher: channelListDispatcher,
            sdkChannelHandlerId: sdkChannelHandlerId,
            logger: logger,
        });
    }
    else {
        logger.warning('ChannelList - createEventHandler: sdk or sdk.ChannelHandler does not exist', sdk);
    }
    logger.info('ChannelList - creating query', { userFilledChannelListQuery: userFilledChannelListQuery });
    var channelListQuery = createChannelListQuery({ sdk: sdk, userFilledChannelListQuery: userFilledChannelListQuery });
    logger.info('ChannelList - created query', channelListQuery);
    setChannelSource(channelListQuery);
    channelListDispatcher({
        type: INIT_CHANNELS_START,
        payload: {
            currentUserId: (_c = (_b = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId) !== null && _c !== void 0 ? _c : '',
        },
    });
    if (userFilledChannelListQuery) {
        logger.info('ChannelList - setting up channelListQuery', channelListQuery);
        channelListDispatcher({
            type: CHANNEL_LIST_PARAMS_UPDATED,
            payload: {
                channelListQuery: channelListQuery,
                currentUserId: (_e = (_d = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _d === void 0 ? void 0 : _d.userId) !== null && _e !== void 0 ? _e : '',
            },
        });
    }
    logger.info('ChannelList - fetching channels');
    if (channelListQuery.hasNext) {
        channelListQuery
            .next()
            .then(function (channelList) {
            var _a, _b;
            logger.info('ChannelList - fetched channels', channelList);
            // select first channel
            logger.info('ChannelList - highlight channel', channelList[0]);
            var sortedChannelList = channelList;
            if (sortChannelList && typeof sortChannelList === 'function') {
                sortedChannelList = sortChannelList(channelList);
                logger.info('ChannelList - channel list sorted', sortedChannelList);
            }
            if (!disableAutoSelect) {
                onChannelSelect === null || onChannelSelect === void 0 ? void 0 : onChannelSelect(sortedChannelList[0]);
            }
            channelListDispatcher({
                type: INIT_CHANNELS_SUCCESS,
                payload: {
                    channelList: sortedChannelList,
                    disableAutoSelect: disableAutoSelect,
                },
            });
            var canSetMarkAsDelivered = (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.premiumFeatureList) === null || _b === void 0 ? void 0 : _b.find(function (feature) { return feature === bundle_DnMqBZ_F_DELIVERY_RECEIPT; });
            if (canSetMarkAsDelivered && !disableMarkAsDelivered) {
                sortedChannelList.forEach(function (channel) {
                    markAsDeliveredScheduler.push(channel);
                });
            }
        })
            .catch(function (err) {
            if (err) {
                logger.error('ChannelList - couldnt fetch channels', err);
                channelListDispatcher({
                    type: INIT_CHANNELS_FAILURE,
                });
            }
        });
    }
    else {
        logger.info('ChannelList - there are no more channels');
    }
}
var pubSubHandleRemover = function (subscriber) {
    subscriber.forEach(function (s) {
        try {
            s.remove();
        }
        catch (_a) {
            //
        }
    });
};
var pubSubHandler = function (pubSub, channelListDispatcher) {
    var subscriber = new Map();
    if (!pubSub)
        return subscriber;
    subscriber.set(pubSubTopics.CREATE_CHANNEL, pubSub.subscribe(pubSubTopics.CREATE_CHANNEL, function (_a) {
        var channel = _a.channel;
        channelListDispatcher({
            type: CREATE_CHANNEL,
            payload: channel,
        });
    }));
    subscriber.set(pubSubTopics.UPDATE_USER_MESSAGE, pubSub.subscribe(pubSubTopics.UPDATE_USER_MESSAGE, function (_a) {
        var _b;
        var channel = _a.channel, message = _a.message;
        if (channel.isGroupChannel() && ((_b = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _b === void 0 ? void 0 : _b.messageId) === message.messageId) {
            channel.lastMessage = message;
            channelListDispatcher({
                type: ON_LAST_MESSAGE_UPDATED,
                payload: channel,
            });
        }
    }));
    subscriber.set(pubSubTopics.LEAVE_CHANNEL, pubSub.subscribe(pubSubTopics.LEAVE_CHANNEL, function (msg) {
        var channel = msg.channel;
        channelListDispatcher({
            type: bundle_DnMqBZ_F_LEAVE_CHANNEL_SUCCESS,
            payload: channel === null || channel === void 0 ? void 0 : channel.url,
        });
    }));
    return subscriber;
};

/**
 * NOTICE: Use this function IF the current channel is removed from allChannels.
 * This function will give you the next currentChannel value.
 */
var getNextChannel = function (_a) {
    var channel = _a.channel, currentChannel = _a.currentChannel, allChannels = _a.allChannels, disableAutoSelect = _a.disableAutoSelect;
    var nextChannel = null;
    if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === channel.url) {
        if (!disableAutoSelect && allChannels.length > 0) {
            var firstChannel = allChannels[0], _b = allChannels[1], secondChannel = _b === void 0 ? null : _b;
            nextChannel = firstChannel.url === channel.url ? secondChannel : firstChannel;
        }
    }
    else {
        nextChannel = currentChannel;
    }
    return nextChannel;
};

var bundle_DnMqBZ_F_initialState = {
    // we might not need this initialized state -> should remove
    initialized: false,
    loading: true,
    allChannels: [],
    currentChannel: null,
    channelListQuery: null,
    currentUserId: '',
    disableAutoSelect: false,
};

function channelListReducer(state, action) {
    return (K(action)
        .with({ type: INIT_CHANNELS_START }, function (_a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { loading: true, currentUserId: payload.currentUserId }));
    })
        .with({ type: RESET_CHANNEL_LIST }, function () {
        return bundle_DnMqBZ_F_initialState;
    })
        .with({ type: INIT_CHANNELS_SUCCESS }, function (action) {
        var _a = action.payload, channelList = _a.channelList, disableAutoSelect = _a.disableAutoSelect;
        return __assign(__assign({}, state), { initialized: true, loading: false, allChannels: channelList, disableAutoSelect: disableAutoSelect, currentChannel: !disableAutoSelect && channelList && channelList.length && channelList.length > 0 ? channelList[0] : state.currentChannel });
    })
        .with({ type: REFRESH_CHANNELS_SUCCESS }, function (action) {
        var _a = action.payload, channelList = _a.channelList, currentChannel = _a.currentChannel;
        return __assign(__assign({}, state), { loading: false, allChannels: channelList, currentChannel: currentChannel });
    })
        .with({ type: FETCH_CHANNELS_SUCCESS }, function (action) {
        var currentChannels = state.allChannels.map(function (c) { return c.url; });
        var filteredChannels = action.payload.filter(function (_a) {
            var url = _a.url;
            return !currentChannels.find(function (c) { return c === url; });
        });
        return __assign(__assign({}, state), { allChannels: __spreadArray(__spreadArray([], state.allChannels, true), filteredChannels, true) });
    })
        .with({ type: CREATE_CHANNEL }, function (action) {
        var _a;
        var channel = action.payload;
        var allChannels = state.allChannels, currentUserId = state.currentUserId, channelListQuery = state.channelListQuery;
        if (channelListQuery) {
            if (filterChannelListParams(channelListQuery, channel, currentUserId)) {
                // Good to add to the ChannelList
                return __assign(__assign({}, state), { currentChannel: channel, allChannels: getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order) });
            }
            // Do not add to the ChannelList
            return __assign(__assign({}, state), { currentChannel: channel });
        }
        // No channelListQuery
        // Add to the top of the ChannelList
        return __assign(__assign({}, state), { currentChannel: channel, allChannels: __spreadArray([channel], allChannels.filter(function (ch) { return ch.url !== (channel === null || channel === void 0 ? void 0 : channel.url); }), true) });
    })
        // A hidden channel will be unhidden when getting new message
        .with({ type: ON_CHANNEL_ARCHIVED }, function (action) {
        var _a;
        var channel = action.payload;
        var allChannels = state.allChannels, currentUserId = state.currentUserId, currentChannel = state.currentChannel, channelListQuery = state.channelListQuery, disableAutoSelect = state.disableAutoSelect;
        if (channelListQuery) {
            if (filterChannelListParams(channelListQuery, channel, currentUserId)) {
                // Good to [add to/keep in] the ChannelList
                return __assign(__assign({}, state), { allChannels: getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order) });
            }
            // * Remove the channel from the ChannelList: because the channel is filtered
        }
        // No channelListQuery
        // * Remove the channel from the ChannelList: because the channel is hidden
        // Replace the currentChannel if it's filtered or hidden
        var nextChannel = getNextChannel({
            channel: channel,
            currentChannel: currentChannel,
            allChannels: allChannels,
            disableAutoSelect: disableAutoSelect,
        });
        return __assign(__assign({}, state), { currentChannel: nextChannel, allChannels: allChannels.filter(function (_a) {
                var url = _a.url;
                return url !== (channel === null || channel === void 0 ? void 0 : channel.url);
            }) });
    })
        .with({ type: S.union(bundle_DnMqBZ_F_LEAVE_CHANNEL_SUCCESS, ON_CHANNEL_DELETED) }, function (action) {
        var _a;
        var channelUrl = action.payload;
        var allChannels = state.allChannels.filter(function (_a) {
            var url = _a.url;
            return url !== channelUrl;
        });
        return __assign(__assign({}, state), { currentChannel: channelUrl === ((_a = state.currentChannel) === null || _a === void 0 ? void 0 : _a.url) ? allChannels[0] : state.currentChannel, allChannels: allChannels });
    })
        .with({ type: ON_USER_LEFT }, function (action) {
        var _a;
        var _b = action.payload, channel = _b.channel, isMe = _b.isMe;
        var allChannels = state.allChannels, currentUserId = state.currentUserId, currentChannel = state.currentChannel, channelListQuery = state.channelListQuery, disableAutoSelect = state.disableAutoSelect;
        var nextChannels = __spreadArray([], allChannels, true);
        var nextChannel = channel;
        /**
         * 1. If I left channel:
         *   - Remove the channel from channel list
         *   - Replace currentChannel with the next ordered channel
         * 2. If other member left channel:
         *   2-1. If query is given:
         *     2-1-1. If channel no longer matches the query
         *       - Same as step 1
         *     2-1-2. If channel matches the query:
         *       - Upsert channel list with the channel
         *       - Replace currentChannel IFF url is same
         *   2-2. If query is not given,
         *     - Same as step 2-1-2
         */
        /* `1` and `2-1-1` */
        if (isMe || (channelListQuery && !filterChannelListParams(channelListQuery, channel, currentUserId))) {
            var channelAt = allChannels.findIndex(function (ch) { return ch.url === channel.url; });
            if (channelAt > -1) {
                nextChannels.splice(channelAt, 1);
                nextChannel = getNextChannel({
                    channel: channel,
                    currentChannel: currentChannel,
                    allChannels: allChannels,
                    disableAutoSelect: disableAutoSelect,
                });
            }
        }
        else {
            /* `2-1-2` and `2-2` */
            nextChannels = getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order);
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === channel.url) {
                nextChannel = channel;
            }
        }
        return __assign(__assign({}, state), { currentChannel: nextChannel, allChannels: nextChannels });
    })
        .with({
        type: S.union(ON_USER_JOINED, ON_CHANNEL_CHANGED, ON_READ_RECEIPT_UPDATED, ON_DELIVERY_RECEIPT_UPDATED),
    }, function (action) {
        var _a, _b, _c;
        var channel = action.payload;
        var _d = state.allChannels, allChannels = _d === void 0 ? [] : _d, currentUserId = state.currentUserId, currentChannel = state.currentChannel, channelListQuery = state.channelListQuery, disableAutoSelect = state.disableAutoSelect;
        var unreadMessageCount = channel.unreadMessageCount;
        if (channelListQuery) {
            if (filterChannelListParams(channelListQuery, channel, currentUserId)) {
                // Good to [add to/keep in] the ChannelList
                return __assign(__assign({}, state), { allChannels: getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order) });
            }
            // If the channel is just created and the current user is the only member,
            // don't add to the ChannelList but keep the currentChannel
            if (isChannelJustCreated(channel)) {
                return state;
            }
            // Filter the channel from the ChannelList
            // Replace the currentChannel if it's filtered channel
            var nextChannel = getNextChannel({
                channel: channel,
                currentChannel: currentChannel,
                allChannels: allChannels,
                disableAutoSelect: disableAutoSelect,
            });
            return __assign(__assign({}, state), { currentChannel: nextChannel, allChannels: allChannels.filter(function (_a) {
                    var url = _a.url;
                    return url !== (channel === null || channel === void 0 ? void 0 : channel.url);
                }) });
        }
        if (
        // When marking as read the channel
        unreadMessageCount === 0
            // @ts-ignore - When sending a message by the current peer
            && ((_c = (_b = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _b === void 0 ? void 0 : _b.sender) === null || _c === void 0 ? void 0 : _c.userId) !== currentUserId) {
            // Don't move to the top
            return __assign(__assign({}, state), { allChannels: allChannels.map(function (ch) { return (ch.url === (channel === null || channel === void 0 ? void 0 : channel.url) ? channel : ch); }) });
        }
        // Move to the top
        return __assign(__assign({}, state), { allChannels: __spreadArray([channel], allChannels.filter(function (_a) {
                var url = _a.url;
                return url !== channel.url;
            }), true) });
    })
        .with({ type: bundle_DnMqBZ_F_SET_CURRENT_CHANNEL }, function (action) {
        return __assign(__assign({}, state), { currentChannel: action.payload });
    })
        .with({ type: ON_LAST_MESSAGE_UPDATED }, function (action) {
        return __assign(__assign({}, state), { allChannels: state.allChannels.map(function (channel) { return (channel === null || channel === void 0 ? void 0 : channel.url) === action.payload.url ? action.payload : channel; }) });
    })
        .with({ type: ON_CHANNEL_FROZEN }, function (action) {
        var _a;
        var channel = action.payload;
        var allChannels = state.allChannels, currentUserId = state.currentUserId, currentChannel = state.currentChannel, channelListQuery = state.channelListQuery, disableAutoSelect = state.disableAutoSelect;
        if (channelListQuery) {
            if (filterChannelListParams(channelListQuery, channel, currentUserId)) {
                // Good to [add to/keep in] the ChannelList
                return __assign(__assign({}, state), { allChannels: getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order) });
            }
            // Filter the channel from the ChannelList
            // Replace the currentChannel if it's filtered channel
            var nextChannel = getNextChannel({
                channel: channel,
                currentChannel: currentChannel,
                allChannels: allChannels,
                disableAutoSelect: disableAutoSelect,
            });
            return __assign(__assign({}, state), { currentChannel: nextChannel, allChannels: allChannels.filter(function (_a) {
                    var url = _a.url;
                    return url !== (channel === null || channel === void 0 ? void 0 : channel.url);
                }) });
        }
        return __assign(__assign({}, state), { allChannels: allChannels.map(function (ch) {
                if (ch.url === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    // eslint-disable-next-line no-param-reassign
                    ch.isFrozen = true;
                    return ch;
                }
                return ch;
            }) });
    })
        .with({ type: ON_CHANNEL_UNFROZEN }, function (action) {
        var _a;
        var channel = action.payload;
        var allChannels = state.allChannels, currentUserId = state.currentUserId, currentChannel = state.currentChannel, channelListQuery = state.channelListQuery, disableAutoSelect = state.disableAutoSelect;
        if (channelListQuery) {
            if (filterChannelListParams(channelListQuery, channel, currentUserId)) {
                // Good to [add to/keep in] the ChannelList
                return __assign(__assign({}, state), { allChannels: getChannelsWithUpsertedChannel(allChannels, channel, (_a = state.channelListQuery) === null || _a === void 0 ? void 0 : _a.order) });
            }
            // Filter the channel from the ChannelList
            // Replace the currentChannel if it's filtered channel
            var nextChannel = getNextChannel({
                channel: channel,
                currentChannel: currentChannel,
                allChannels: allChannels,
                disableAutoSelect: disableAutoSelect,
            });
            return __assign(__assign({}, state), { currentChannel: nextChannel, allChannels: allChannels.filter(function (_a) {
                    var url = _a.url;
                    return url !== (channel === null || channel === void 0 ? void 0 : channel.url);
                }) });
        }
        // No channelListQuery
        return __assign(__assign({}, state), { allChannels: allChannels.map(function (ch) {
                if (ch.url === (channel === null || channel === void 0 ? void 0 : channel.url)) {
                    // eslint-disable-next-line no-param-reassign
                    ch.isFrozen = false;
                    return ch;
                }
                return ch;
            }) });
    })
        .with({ type: CHANNEL_LIST_PARAMS_UPDATED }, function (action) { return (__assign(__assign({}, state), { channelListQuery: action.payload.channelListQuery, currentUserId: action.payload.currentUserId })); })
        .otherwise(function () { return state; }));
}

function useActiveChannelUrl(_a, _b) {
    var activeChannelUrl = _a.activeChannelUrl, channels = _a.channels, sdk = _a.sdk;
    var logger = _b.logger, channelListDispatcher = _b.channelListDispatcher;
    return useEffect(function () {
        var _a;
        if (activeChannelUrl) {
            logger.info('ChannelListProvider: looking for active channel', { activeChannelUrl: activeChannelUrl });
            var activeChannel = channels === null || channels === void 0 ? void 0 : channels.find(function (channel) { return channel.url === activeChannelUrl; });
            if (activeChannel) {
                channelListDispatcher({
                    type: bundle_DnMqBZ_F_SET_CURRENT_CHANNEL,
                    payload: activeChannel,
                });
            }
            else {
                logger.info('ChannelListProvider: searching backend for active channel', { activeChannelUrl: activeChannelUrl });
                (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.getChannel(activeChannelUrl).then(function (channel) {
                    channelListDispatcher({
                        type: FETCH_CHANNELS_SUCCESS,
                        payload: [channel],
                    });
                    channelListDispatcher({
                        type: bundle_DnMqBZ_F_SET_CURRENT_CHANNEL,
                        payload: channel,
                    });
                }).catch(function () {
                    logger.warning('ChannelListProvider: Active channel not found');
                });
            }
        }
    }, [activeChannelUrl]);
}

var useFetchChannelList = function (_a, _b) {
    var channelSource = _a.channelSource, disableMarkAsDelivered = _a.disableMarkAsDelivered;
    var channelListDispatcher = _b.channelListDispatcher, logger = _b.logger, markAsDeliveredScheduler = _b.markAsDeliveredScheduler;
    return useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var channelList, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(channelSource === null || channelSource === void 0 ? void 0 : channelSource.hasNext)) {
                        logger.info('ChannelList: not able to fetch');
                        return [2 /*return*/];
                    }
                    logger.info('ChannelList: starting fetch');
                    channelListDispatcher({
                        type: FETCH_CHANNELS_START,
                        payload: null,
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, channelSource.next()];
                case 2:
                    channelList = _a.sent();
                    logger.info('ChannelList: succeeded fetch', { channelList: channelList });
                    channelListDispatcher({
                        type: FETCH_CHANNELS_SUCCESS,
                        payload: channelList,
                    });
                    if (!disableMarkAsDelivered) {
                        logger.info('ChannelList: mark as delivered to fetched channels');
                        // eslint-disable-next-line no-unused-expressions
                        channelList === null || channelList === void 0 ? void 0 : channelList.forEach(function (channel) {
                            if ((channel === null || channel === void 0 ? void 0 : channel.unreadMessageCount) > 0) {
                                markAsDeliveredScheduler.push(channel);
                            }
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error('ChannelList: failed fetch', { error: error_1 });
                    channelListDispatcher({
                        type: FETCH_CHANNELS_FAILURE,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        channelSource,
        disableMarkAsDelivered,
    ]);
};

function useHandleReconnectForChannelList(_a) {
    var isOnline = _a.isOnline, reconnectOnIdle = _a.reconnectOnIdle, logger = _a.logger, sdk = _a.sdk, currentGroupChannel = _a.currentGroupChannel, channelListDispatcher = _a.channelListDispatcher, setChannelSource = _a.setChannelSource, userFilledChannelListQuery = _a.userFilledChannelListQuery, sortChannelList = _a.sortChannelList, disableAutoSelect = _a.disableAutoSelect, markAsDeliveredScheduler = _a.markAsDeliveredScheduler, disableMarkAsDelivered = _a.disableMarkAsDelivered;
    var shouldReconnect = useReconnectOnIdle(isOnline, currentGroupChannel, reconnectOnIdle).shouldReconnect;
    useEffect(function () {
        return function () {
            var _a, _b, _c, _d;
            // state changed from offline to online AND tab is visible
            if (shouldReconnect) {
                logger.info('ChannelList refresh - creating query', { userFilledChannelListQuery: userFilledChannelListQuery });
                var channelListQuery = createChannelListQuery({ sdk: sdk, userFilledChannelListQuery: userFilledChannelListQuery });
                logger.info('ChannelList refresh - created query', channelListQuery);
                setChannelSource(channelListQuery);
                channelListDispatcher({
                    type: INIT_CHANNELS_START,
                    payload: {
                        currentUserId: (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : '',
                    },
                });
                if (userFilledChannelListQuery) {
                    logger.info('ChannelList refresh - setting up channelListQuery', channelListQuery);
                    channelListDispatcher({
                        type: CHANNEL_LIST_PARAMS_UPDATED,
                        payload: {
                            channelListQuery: channelListQuery,
                            currentUserId: (_d = (_c = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                        },
                    });
                }
                logger.info('ChannelList refresh - fetching channels');
                if (channelListQuery.hasNext) {
                    channelListQuery
                        .next()
                        .then(function (channelList) {
                        var _a, _b;
                        logger.info('ChannelList refresh - fetched channels', channelList);
                        var sortedChannelList = channelList;
                        if (sortChannelList && typeof sortChannelList === 'function') {
                            sortedChannelList = sortChannelList(channelList);
                            logger.info('ChannelList refresh - channel list sorted', sortedChannelList);
                        }
                        // select first channel
                        var newCurrentChannel = !disableAutoSelect ? sortedChannelList[0] : null;
                        if (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.url) {
                            var foundChannel = sortedChannelList.find(function (channel) { return (channel.url === currentGroupChannel.url); });
                            if (foundChannel) {
                                newCurrentChannel = foundChannel;
                            }
                        }
                        logger.info('ChannelList refresh - highlight channel', newCurrentChannel);
                        channelListDispatcher({
                            type: REFRESH_CHANNELS_SUCCESS,
                            payload: {
                                channelList: sortedChannelList,
                                currentChannel: newCurrentChannel,
                            },
                        });
                        var canSetMarkAsDelivered = (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) === null || _a === void 0 ? void 0 : _a.premiumFeatureList) === null || _b === void 0 ? void 0 : _b.find(function (feature) { return feature === DELIVERY_RECEIPT$1; });
                        if (canSetMarkAsDelivered && !disableMarkAsDelivered) {
                            sortedChannelList.forEach(function (channel) {
                                markAsDeliveredScheduler.push(channel);
                            });
                        }
                    })
                        .catch(function (err) {
                        if (err) {
                            logger.error('ChannelList refresh - could not fetch channels', err);
                            channelListDispatcher({
                                type: INIT_CHANNELS_FAILURE,
                            });
                        }
                    });
                }
                else {
                    logger.info('ChannelList refresh - there are no more channels');
                }
            }
        };
    }, [shouldReconnect]);
}

var ChannelListContext = react.createContext(null);
/**
 * @deprecated This provider is deprecated and will be removed in the next major update.
 * Please use the `GroupChannelListProvider` from '@sendbird/uikit-react/GroupChannelList' instead.
 * For more information, please refer to the migration guide:
 * https://docs.sendbird.com/docs/chat/uikit/v3/react/introduction/group-channel-migration-guide
 */
var bundle_DnMqBZ_F_ChannelListProvider = function (props) {
    var _a, _b;
    // destruct props
    var children = props.children, className = props.className, disableUserProfile = props.disableUserProfile, allowProfileEdit = props.allowProfileEdit, queries = props.queries, onProfileEditSuccess = props.onProfileEditSuccess, onThemeChange = props.onThemeChange, onBeforeCreateChannel = props.onBeforeCreateChannel, sortChannelList = props.sortChannelList, overrideInviteUser = props.overrideInviteUser, activeChannelUrl = props.activeChannelUrl, _c = props.isTypingIndicatorEnabled, isTypingIndicatorEnabled = _c === void 0 ? null : _c, _d = props.isMessageReceiptStatusEnabled, isMessageReceiptStatusEnabled = _d === void 0 ? null : _d, reconnectOnIdle = props.reconnectOnIdle;
    // disable autoselect, if activeChannelUrl is provided
    // useActiveChannelUrl should be executed when activeChannelUrl is present
    var disableAutoSelect = (props === null || props === void 0 ? void 0 : props.disableAutoSelect) || !!activeChannelUrl;
    var onChannelSelect = (props === null || props === void 0 ? void 0 : props.onChannelSelect) || noop;
    // fetch store from <SendbirdProvider />
    var globalStore = useSendbirdStateContext();
    var config = globalStore.config, stores = globalStore.stores;
    var sdkStore = stores.sdkStore;
    var pubSub = config.pubSub, logger = config.logger;
    var markAsDeliveredScheduler = config.markAsDeliveredScheduler, _e = config.disableMarkAsDelivered, disableMarkAsDelivered = _e === void 0 ? false : _e, isOnline = config.isOnline;
    var sdk = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.sdk;
    var _f = ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.appInfo) !== null && _a !== void 0 ? _a : {}).premiumFeatureList, premiumFeatureList = _f === void 0 ? [] : _f;
    // derive some variables
    // enable if it is true at least once(both are false by default)
    var enableEditProfile = allowProfileEdit || config.allowProfileEdit;
    var userFilledChannelListQuery = queries === null || queries === void 0 ? void 0 : queries.channelListQuery;
    var userFilledApplicationUserListQuery = queries === null || queries === void 0 ? void 0 : queries.applicationUserListQuery;
    var sdkIntialized = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.initialized;
    var _g = useReducer(channelListReducer, bundle_DnMqBZ_F_initialState), channelListStore = _g[0], channelListDispatcher = _g[1];
    var currentChannel = channelListStore.currentChannel;
    var _h = useState(null), channelSource = _h[0], setChannelSource = _h[1];
    var _j = useState([]), typingChannels = _j[0], setTypingChannels = _j[1];
    useEffect(function () {
        var subscriber = pubSubHandler(pubSub, channelListDispatcher);
        return function () {
            pubSubHandleRemover(subscriber);
        };
    }, [sdkIntialized]);
    useEffect(function () {
        var _a;
        var sdkChannelHandlerId = uuidv4();
        if (sdkIntialized) {
            logger.info('ChannelList: Setup channelHandlers');
            setupChannelList({
                sdk: sdk,
                sdkChannelHandlerId: sdkChannelHandlerId,
                channelListDispatcher: channelListDispatcher,
                setChannelSource: setChannelSource,
                onChannelSelect: onChannelSelect,
                userFilledChannelListQuery: __assign({}, userFilledChannelListQuery),
                logger: logger,
                sortChannelList: sortChannelList,
                disableAutoSelect: disableAutoSelect,
                markAsDeliveredScheduler: markAsDeliveredScheduler,
                disableMarkAsDelivered: disableMarkAsDelivered,
            });
        }
        else {
            logger.info('ChannelList: Removing channelHandlers');
            // remove previous channelHandlers
            if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) {
                sdk.groupChannel.removeGroupChannelHandler(sdkChannelHandlerId);
            }
            // remove channelSource
            setChannelSource(null);
            // cleanup
            channelListDispatcher({
                type: RESET_CHANNEL_LIST,
                payload: null,
            });
        }
        return function () {
            var _a, _b;
            logger.info('ChannelList: Removing channelHandlers');
            if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) {
                (_b = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _b === void 0 ? void 0 : _b.removeGroupChannelHandler(sdkChannelHandlerId);
            }
        };
    }, [
        sdkIntialized,
        sortChannelList,
        Object.entries(userFilledChannelListQuery !== null && userFilledChannelListQuery !== void 0 ? userFilledChannelListQuery : {}).map(function (_a) {
            var key = _a[0], value = _a[1];
            return key + value;
        }).join(),
    ]);
    useEffect(function () {
        var _a, _b;
        var typingHandlerId = '';
        if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler) {
            typingHandlerId = uuidv4();
            var handler = new GroupChannelHandler({
                onTypingStatusUpdated: function (channel) {
                    var _a;
                    var typingMemberCount = (_a = channel === null || channel === void 0 ? void 0 : channel.getTypingUsers()) === null || _a === void 0 ? void 0 : _a.length;
                    var channelList = typingChannels.filter(function (ch) { return ch.url !== channel.url; });
                    if (typingMemberCount > 0) {
                        setTypingChannels(__spreadArray(__spreadArray([], channelList, true), [channel], false));
                    }
                    else {
                        setTypingChannels(channelList);
                    }
                },
                onUnreadMemberStatusUpdated: function (channel) {
                    channelListDispatcher({
                        type: ON_LAST_MESSAGE_UPDATED,
                        payload: channel,
                    });
                },
                onUndeliveredMemberStatusUpdated: function (channel) {
                    channelListDispatcher({
                        type: ON_LAST_MESSAGE_UPDATED,
                        payload: channel,
                    });
                },
                onMessageUpdated: function (channel) {
                    if (channel.isGroupChannel()) {
                        channelListDispatcher({
                            type: ON_LAST_MESSAGE_UPDATED,
                            payload: channel,
                        });
                        sdk.groupChannel.getChannelWithoutCache(channel.url).then(function (ch) {
                            channelListDispatcher({
                                type: ON_LAST_MESSAGE_UPDATED,
                                payload: ch,
                            });
                        });
                    }
                },
                onMentionReceived: function (channel) {
                    if (channel.isGroupChannel()) {
                        channelListDispatcher({
                            type: ON_LAST_MESSAGE_UPDATED,
                            payload: channel,
                        });
                        sdk.groupChannel.getChannelWithoutCache(channel.url).then(function (ch) {
                            channelListDispatcher({
                                type: ON_LAST_MESSAGE_UPDATED,
                                payload: ch,
                            });
                        });
                    }
                },
            });
            (_b = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _b === void 0 ? void 0 : _b.addGroupChannelHandler(typingHandlerId, handler);
        }
        return function () {
            var _a;
            if (((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) && typingHandlerId !== '') {
                sdk.groupChannel.removeGroupChannelHandler(typingHandlerId);
            }
        };
    }, [(_b = sdk === null || sdk === void 0 ? void 0 : sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId]);
    var queries_ = useMemo(function () {
        return {
            applicationUserListQuery: userFilledApplicationUserListQuery,
            channelListQuery: userFilledChannelListQuery,
        };
    }, [userFilledApplicationUserListQuery, userFilledChannelListQuery]);
    var allChannels = channelListStore.allChannels;
    var sortedChannels = sortChannelList && typeof sortChannelList === 'function' ? sortChannelList(allChannels) : allChannels;
    if (sortedChannels.length !== allChannels.length) {
        var warning = "ChannelList: You have removed/added extra channels on sortChannelList\n      this could cause unexpected problems";
        // eslint-disable-next-line no-console
        console.warn(warning, { before: allChannels, after: sortedChannels });
        logger.warning(warning, { before: allChannels, after: sortedChannels });
    }
    // Set current channel (by on_channel_selected event)
    useEffect(function () {
        if (!sdk || !sdk.groupChannel) {
            return;
        }
        // When leaving a channel, tell consumers that the prior channel is no longer selected
        if (!(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
            onChannelSelect(null);
            return;
        }
        sdk.groupChannel.getChannel(currentChannel.url).then(function (groupChannel) {
            if (groupChannel) {
                onChannelSelect(groupChannel);
            }
            else {
                onChannelSelect(null);
            }
        });
    }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    // Set active channel (by url)
    useActiveChannelUrl({
        activeChannelUrl: activeChannelUrl,
        channels: sortedChannels,
        sdk: sdk,
    }, {
        logger: logger,
        channelListDispatcher: channelListDispatcher,
    });
    useHandleReconnectForChannelList({
        isOnline: isOnline,
        reconnectOnIdle: reconnectOnIdle,
        logger: logger,
        sdk: sdk,
        currentGroupChannel: currentChannel,
        channelListDispatcher: channelListDispatcher,
        setChannelSource: setChannelSource,
        userFilledChannelListQuery: userFilledChannelListQuery,
        sortChannelList: sortChannelList,
        disableAutoSelect: disableAutoSelect,
        markAsDeliveredScheduler: markAsDeliveredScheduler,
        disableMarkAsDelivered: disableMarkAsDelivered,
    });
    var fetchChannelList = useFetchChannelList({
        channelSource: channelSource,
        disableMarkAsDelivered: disableMarkAsDelivered || !premiumFeatureList.some(function (feature) { return feature === DELIVERY_RECEIPT$1; }),
    }, {
        channelListDispatcher: channelListDispatcher,
        logger: logger,
        markAsDeliveredScheduler: markAsDeliveredScheduler,
    });
    return (React__default.createElement(ChannelListContext.Provider, { value: __assign(__assign({ className: className, disableUserProfile: disableUserProfile, queries: queries_, onProfileEditSuccess: onProfileEditSuccess, onThemeChange: onThemeChange, onBeforeCreateChannel: onBeforeCreateChannel, overrideInviteUser: overrideInviteUser, onChannelSelect: onChannelSelect, sortChannelList: sortChannelList, allowProfileEdit: enableEditProfile, channelListDispatcher: channelListDispatcher, channelSource: channelSource }, channelListStore), { allChannels: sortedChannels, typingChannels: typingChannels, isTypingIndicatorEnabled: isTypingIndicatorEnabled !== null && isTypingIndicatorEnabled !== void 0 ? isTypingIndicatorEnabled : config.groupChannelList.enableTypingIndicator, isMessageReceiptStatusEnabled: isMessageReceiptStatusEnabled !== null && isMessageReceiptStatusEnabled !== void 0 ? isMessageReceiptStatusEnabled : config.groupChannelList.enableMessageReceiptStatus, fetchChannelList: fetchChannelList }) },
        React__default.createElement(UserProfileProvider, __assign({}, props),
            React__default.createElement("div", { className: "sendbird-channel-list ".concat(className) }, children))));
};
function bundle_DnMqBZ_F_useChannelListContext() {
    var context = useContext(ChannelListContext);
    if (!context)
        throw new Error('ChannelListContext not found. Use within the ChannelList module.');
    return context;
}


//# sourceMappingURL=bundle-DnMqBZ_F.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelList/components/ChannelPreview.js




















































var ChannelPreview_ChannelPreview = function (_a) {
    var _b, _c, _d, _e;
    var channel = _a.channel, _f = _a.isActive, isActive = _f === void 0 ? false : _f, _g = _a.isSelected, isSelected = _g === void 0 ? false : _g, _h = _a.isTyping, isTyping = _h === void 0 ? false : _h, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbirdStateContext().config;
    var stringSet = useLocalization().stringSet;
    var _j = useChannelListContext(), _k = _j.isTypingIndicatorEnabled, isTypingIndicatorEnabled = _k === void 0 ? false : _k, _l = _j.isMessageReceiptStatusEnabled, isMessageReceiptStatusEnabled = _l === void 0 ? false : _l;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (((_b = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _b === void 0 ? void 0 : _b.messageType) === 'user' || ((_c = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _c === void 0 ? void 0 : _c.messageType) === 'file')
        && ((_e = (_d = channel === null || channel === void 0 ? void 0 : channel.lastMessage) === null || _d === void 0 ? void 0 : _d.sender) === null || _e === void 0 ? void 0 : _e.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : isActive, channelName: getChannelTitle(channel, userId, stringSet), isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};


//# sourceMappingURL=ChannelPreview.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelList/components/AddChannel.js















































var AddChannel_AddChannel = function () {
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = useChannelListContext(), overrideInviteUser = _b.overrideInviteUser, onBeforeCreateChannel = _b.onBeforeCreateChannel, onChannelSelect = _b.onChannelSelect;
    return (React__default.createElement(AddGroupChannelView, { createChannelVisible: showModal, onChangeCreateChannelVisible: setShowModal, onCreateChannelClick: overrideInviteUser, onBeforeCreateChannel: onBeforeCreateChannel, onChannelCreated: function (it) { return onChannelSelect === null || onChannelSelect === void 0 ? void 0 : onChannelSelect(it); } }));
};


//# sourceMappingURL=AddChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelList/components/ChannelListUI.js















































































var ChannelListUI_ChannelListUI = function (props) {
    var renderHeader = props.renderHeader, renderChannelPreview = props.renderChannelPreview, renderPlaceHolderError = props.renderPlaceHolderError, renderPlaceHolderLoading = props.renderPlaceHolderLoading, renderPlaceHolderEmptyList = props.renderPlaceHolderEmptyList;
    var _a = useChannelListContext(), onThemeChange = _a.onThemeChange, allowProfileEdit = _a.allowProfileEdit, allChannels = _a.allChannels, currentChannel = _a.currentChannel, channelListDispatcher = _a.channelListDispatcher, typingChannels = _a.typingChannels, initialized = _a.initialized, fetchChannelList = _a.fetchChannelList, onProfileEditSuccess = _a.onProfileEditSuccess;
    var _b = useSendbirdStateContext(), stores = _b.stores, config = _b.config;
    var logger = config.logger, _c = config.isOnline, isOnline = _c === void 0 ? false : _c;
    var sdk = stores.sdkStore.sdk;
    var renderListItem = function (props) {
        var channel = props.item, index = props.index;
        var previewProps = {
            channel: channel,
            tabIndex: index,
            isSelected: (channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url),
            isTyping: typingChannels === null || typingChannels === void 0 ? void 0 : typingChannels.some(function (_a) {
                var url = _a.url;
                return url === (channel === null || channel === void 0 ? void 0 : channel.url);
            }),
            renderChannelAction: function (props) { return React__default.createElement(GroupChannelPreviewAction, __assign({}, props)); },
            onClick: function () {
                if (!isOnline && !(sdk === null || sdk === void 0 ? void 0 : sdk.isCacheEnabled)) {
                    logger.warning('ChannelList: Inactivated clicking channel item during offline.');
                    return;
                }
                logger.info('ChannelList: Clicked on channel:', channel);
                channelListDispatcher({
                    type: SET_CURRENT_CHANNEL,
                    payload: channel,
                });
            },
            onLeaveChannel: function (channel, cb) {
                return __awaiter(this, void 0, void 0, function () {
                    var response, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                logger.info('ChannelList: Leaving channel', channel);
                                if (!channel) return [3 /*break*/, 4];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, channel.leave()];
                            case 2:
                                response = _a.sent();
                                logger.info('ChannelList: Leaving channel success', response);
                                if (cb && typeof cb === 'function')
                                    cb(channel, null);
                                channelListDispatcher({
                                    type: LEAVE_CHANNEL_SUCCESS,
                                    payload: channel.url,
                                });
                                return [3 /*break*/, 4];
                            case 3:
                                err_1 = _a.sent();
                                logger.error('ChannelList: Leaving channel failed', err_1);
                                if (cb && typeof cb === 'function')
                                    cb(channel, err_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
        };
        if (renderChannelPreview) {
            return (React__default.createElement("div", { key: channel === null || channel === void 0 ? void 0 : channel.url, onClick: previewProps.onClick }, renderChannelPreview(previewProps)));
        }
        return React__default.createElement(ChannelPreview, __assign({ key: channel === null || channel === void 0 ? void 0 : channel.url }, previewProps));
    };
    return (React__default.createElement(GroupChannelListUIView, { renderHeader: renderHeader, renderChannel: renderListItem, renderPlaceHolderError: renderPlaceHolderError, renderPlaceHolderLoading: renderPlaceHolderLoading, renderPlaceHolderEmptyList: renderPlaceHolderEmptyList, onChangeTheme: onThemeChange !== null && onThemeChange !== void 0 ? onThemeChange : noop, allowProfileEdit: allowProfileEdit, onUserProfileUpdated: onProfileEditSuccess !== null && onProfileEditSuccess !== void 0 ? onProfileEditSuccess : noop, channels: allChannels, onLoadMore: fetchChannelList, initialized: initialized, renderAddChannel: function () { return React__default.createElement(AddChannel, null); } }));
};


//# sourceMappingURL=ChannelListUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelList.js
















































































/**
 * @deprecated This component is deprecated and will be removed in the next major update.
 * Please use the `GroupChannelList` component from '@sendbird/uikit-react/GroupChannelList' instead.
 * For more information, please refer to the migration guide:
 * https://docs.sendbird.com/docs/chat/uikit/v3/react/introduction/group-channel-migration-guide
 */
var ChannelList_ChannelList = function (props) {
    return (React__default.createElement(ChannelListProvider, __assign({}, props),
        React__default.createElement(ChannelListUI, __assign({}, props))));
};


//# sourceMappingURL=ChannelList.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/context.js































function useAsyncRequest(request, options) {
    var _this = this;
    var _a;
    var _b = useState({ loading: true, response: undefined, error: undefined }), state = _b[0], setState = _b[1];
    var updateWithRequest = function () { return __awaiter(_this, void 0, void 0, function () {
        var response_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setState(function (prev) { return ({ loading: true, error: undefined, response: (options === null || options === void 0 ? void 0 : options.resetResponseOnRefresh) ? undefined : prev.response }); });
                    return [4 /*yield*/, request()];
                case 1:
                    response_1 = _a.sent();
                    if (response_1) {
                        setState(function (prev) { return (__assign(__assign({}, prev), { response: response_1, loading: false })); });
                    }
                    else {
                        setState(function (prev) { return (__assign(__assign({}, prev), { loading: Boolean(options === null || options === void 0 ? void 0 : options.persistLoadingIfNoResponse) })); });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setState(function (prev) { return (__assign(__assign({}, prev), { error: error_1, loading: false })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        updateWithRequest();
        return function () {
            if (request.cancel && typeof request.cancel === 'function') {
                request.cancel();
            }
        };
    }, (_a = options === null || options === void 0 ? void 0 : options.deps) !== null && _a !== void 0 ? _a : []);
    return __assign(__assign({}, state), { refresh: updateWithRequest });
}

var ChannelSettingsContext = react.createContext(null);
var context_ChannelSettingsProvider = function (props) {
    var children = props.children, className = props.className, channelUrl = props.channelUrl, onCloseClick = props.onCloseClick, onLeaveChannel = props.onLeaveChannel, onChannelModified = props.onChannelModified, overrideInviteUser = props.overrideInviteUser, onBeforeUpdateChannel = props.onBeforeUpdateChannel, queries = props.queries, renderUserListItem = props.renderUserListItem;
    var _a = useSendbirdStateContext(), config = _a.config, stores = _a.stores;
    var sdkStore = stores.sdkStore;
    var logger = config.logger;
    var _b = useState(), channelHandlerId = _b[0], setChannelHandlerId = _b[1];
    // hack to keep track of channel updates by triggering useEffect
    var _c = useState(function () { return uuidv4(); }), channelUpdateId = _c[0], setChannelUpdateId = _c[1];
    var forceUpdateUI = function () { return setChannelUpdateId(uuidv4()); };
    var _d = useAsyncRequest(function () { return __awaiter(void 0, void 0, void 0, function () {
        var channel_1, channelHandler, newChannelHandlerId, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    logger.info('ChannelSettings: fetching channel');
                    if (!channelUrl) {
                        logger.warning('ChannelSettings: channel url is required');
                        return [2 /*return*/];
                    }
                    else if (!sdkStore.initialized || !sdkStore.sdk) {
                        logger.warning('ChannelSettings: SDK is not initialized');
                        return [2 /*return*/];
                    }
                    else if (!sdkStore.sdk.groupChannel) {
                        logger.warning('ChannelSettings: GroupChannelModule is not specified in the SDK');
                        return [2 /*return*/];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    if (channelHandlerId) {
                        if ((_b = (_a = sdkStore.sdk) === null || _a === void 0 ? void 0 : _a.groupChannel) === null || _b === void 0 ? void 0 : _b.removeGroupChannelHandler) {
                            logger.info('ChannelSettings: Removing message reciver handler', channelHandlerId);
                            sdkStore.sdk.groupChannel.removeGroupChannelHandler(channelHandlerId);
                        }
                        else if ((_c = sdkStore.sdk) === null || _c === void 0 ? void 0 : _c.groupChannel) {
                            logger.error('ChannelSettings: Not found the removeGroupChannelHandler');
                        }
                        setChannelHandlerId(undefined);
                    }
                    return [4 /*yield*/, sdkStore.sdk.groupChannel.getChannel(channelUrl)];
                case 2:
                    channel_1 = _e.sent();
                    channelHandler = {
                        onUserLeft: function (channel, user) {
                            if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl)) {
                                logger.info('ChannelSettings: onUserLeft', { channel: channel, user: user });
                                refresh();
                            }
                        },
                        onUserBanned: function (channel, user) {
                            if (compareIds(channel === null || channel === void 0 ? void 0 : channel.url, channelUrl) && channel.isGroupChannel()) {
                                logger.info('ChannelSettings: onUserBanned', { channel: channel, user: user });
                                refresh();
                            }
                        },
                    };
                    newChannelHandlerId = uuidv4();
                    (_d = sdkStore.sdk.groupChannel) === null || _d === void 0 ? void 0 : _d.addGroupChannelHandler(newChannelHandlerId, new GroupChannelHandler(channelHandler));
                    setChannelHandlerId(newChannelHandlerId);
                    return [2 /*return*/, channel_1];
                case 3:
                    error_1 = _e.sent();
                    logger.error('ChannelSettings: fetching channel error:', error_1);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); }, {
        resetResponseOnRefresh: true,
        persistLoadingIfNoResponse: true,
        deps: [sdkStore.initialized, sdkStore.sdk.groupChannel],
    }), _e = _d.response, channel = _e === void 0 ? null : _e, loading = _d.loading, error = _d.error, refresh = _d.refresh;
    useEffect(function () {
        refresh();
    }, [channelUrl, channelUpdateId]);
    return (React__default.createElement(ChannelSettingsContext.Provider, { value: {
            channelUrl: channelUrl,
            onCloseClick: onCloseClick,
            onLeaveChannel: onLeaveChannel,
            onChannelModified: onChannelModified,
            onBeforeUpdateChannel: onBeforeUpdateChannel,
            queries: queries,
            overrideInviteUser: overrideInviteUser,
            setChannelUpdateId: setChannelUpdateId,
            forceUpdateUI: forceUpdateUI,
            channel: channel,
            loading: loading,
            invalidChannel: Boolean(error),
            renderUserListItem: renderUserListItem,
        } },
        React__default.createElement(UserProfileProvider, __assign({}, props),
            React__default.createElement("div", { className: "sendbird-channel-settings ".concat(className) }, children))));
};
var context_useChannelSettingsContext = function () {
    var context = React__default.useContext(ChannelSettingsContext);
    if (!context)
        throw new Error('ChannelSettingsContext not found. Use within the ChannelSettings module');
    return context;
};


//# sourceMappingURL=context.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/ChannelSettingsHeader.js















var ChannelSettingsHeader_ChannelSettingsHeader = function (_a) {
    var onCloseClick = _a.onCloseClick, 
    // Header custom props
    renderLeft = _a.renderLeft, renderMiddle = _a.renderMiddle, renderRight = _a.renderRight;
    var stringSet = useLocalization().stringSet;
    var config = useSendbirdStateContext().config;
    var logger = config.logger;
    return (React__default.createElement(Header, { className: "sendbird-channel-settings__header", renderLeft: renderLeft, renderMiddle: renderMiddle !== null && renderMiddle !== void 0 ? renderMiddle : (function () { return (React__default.createElement(Header.Title, { title: stringSet.CHANNEL_SETTING__HEADER__TITLE })); }), renderRight: renderRight !== null && renderRight !== void 0 ? renderRight : (function () { return (React__default.createElement("div", { className: "sendbird-channel-settings__header-icon" },
            React__default.createElement(Header.IconButton, { type: IconTypes.CLOSE, onClick: function (e) {
                    logger.info('ChannelSettings: Click close');
                    onCloseClick(e);
                } }))); }) }));
};


//# sourceMappingURL=ChannelSettingsHeader.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/EditDetailsModal.js








































var EditDetailsModal_EditDetails = function (props) {
    var _a, _b, _c;
    var onSubmit = props.onSubmit, onCancel = props.onCancel;
    var _d = useChannelSettingsContext(), channel = _d.channel, onChannelModified = _d.onChannelModified, onBeforeUpdateChannel = _d.onBeforeUpdateChannel, setChannelUpdateId = _d.setChannelUpdateId;
    var title = channel === null || channel === void 0 ? void 0 : channel.name;
    var state = useSendbirdStateContext();
    var userId = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.userId;
    var theme = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.theme;
    var logger = (_c = state === null || state === void 0 ? void 0 : state.config) === null || _c === void 0 ? void 0 : _c.logger;
    var inputRef = useRef(null);
    var formRef = useRef(null);
    var hiddenInputRef = useRef(null);
    var _e = useState(null), currentImg = _e[0], setCurrentImg = _e[1];
    var _f = useState(null), newFile = _f[0], setNewFile = _f[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    return (React__default.createElement(Modal, { isFullScreenOnMobile: true, titleText: stringSet.MODAL__CHANNEL_INFORMATION__TITLE, submitText: stringSet.BUTTON__SAVE, onCancel: onCancel, onSubmit: function () {
            var _a, _b, _c;
            if (title !== '' && !((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value)) {
                if ((_b = formRef.current) === null || _b === void 0 ? void 0 : _b.reportValidity) { // might not work in explorer
                    formRef.current.reportValidity();
                }
                return;
            }
            var currentTitle = (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.value;
            var currentImg = newFile;
            logger.info('ChannelSettings: Channel information being updated', {
                currentTitle: currentTitle,
                currentImg: currentImg,
            });
            if (onBeforeUpdateChannel) {
                logger.info('ChannelSettings: onBeforeUpdateChannel');
                var params = onBeforeUpdateChannel(currentTitle !== null && currentTitle !== void 0 ? currentTitle : '', currentImg, channel === null || channel === void 0 ? void 0 : channel.data);
                channel === null || channel === void 0 ? void 0 : channel.updateChannel(params).then(function (groupChannel) {
                    onChannelModified === null || onChannelModified === void 0 ? void 0 : onChannelModified(groupChannel);
                    setChannelUpdateId(uuidv4());
                    onSubmit();
                });
            }
            else {
                logger.info('ChannelSettings: normal');
                channel === null || channel === void 0 ? void 0 : channel.updateChannel({
                    coverImage: currentImg,
                    name: currentTitle,
                    data: (channel === null || channel === void 0 ? void 0 : channel.data) || '',
                }).then(function (groupChannel) {
                    logger.info('ChannelSettings: Channel information updated', groupChannel);
                    onChannelModified === null || onChannelModified === void 0 ? void 0 : onChannelModified(groupChannel);
                    setChannelUpdateId === null || setChannelUpdateId === void 0 ? void 0 : setChannelUpdateId(uuidv4());
                    onSubmit();
                });
            }
        }, type: ButtonTypes.PRIMARY },
        React__default.createElement("form", { className: "channel-profile-form", ref: formRef, onSubmit: function (e) { e.preventDefault(); } },
            React__default.createElement("div", { className: "channel-profile-form__img-section" },
                React__default.createElement(InputLabel, null, stringSet.MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE),
                React__default.createElement("div", { className: "channel-profile-form__avatar" }, currentImg
                    ? (React__default.createElement(Avatar, { height: "80px", width: "80px", src: currentImg })) : (React__default.createElement(ChannelAvatar, { height: 80, width: 80, channel: channel, userId: userId, theme: theme }))),
                React__default.createElement("input", { ref: hiddenInputRef, type: "file", accept: "image/gif, image/jpeg, image/png", style: { display: 'none' }, onChange: function (e) {
                        if (e.target.files) {
                            setCurrentImg(URL.createObjectURL(e.target.files[0]));
                            setNewFile(e.target.files[0]);
                        }
                        if (hiddenInputRef.current) {
                            hiddenInputRef.current.value = '';
                        }
                    } }),
                React__default.createElement(TextButton, { className: "channel-profile-form__avatar-button", onClick: function () { var _a; return (_a = hiddenInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disableUnderline: true },
                    React__default.createElement(Label, { type: LabelTypography.BUTTON_1, color: LabelColors.PRIMARY }, stringSet.MODAL__CHANNEL_INFORMATION__UPLOAD))),
            React__default.createElement("div", { className: "channel-profile-form__name-section" },
                React__default.createElement(InputLabel, null, stringSet.MODAL__CHANNEL_INFORMATION__CHANNEL_NAME),
                React__default.createElement(Input, { required: title !== '', name: "channel-profile-form__name", ref: inputRef, value: title, placeHolder: stringSet.MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER })))));
};


//# sourceMappingURL=EditDetailsModal.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/ChannelProfile.js









































var ChannelProfile_ChannelProfile = function () {
    var _a, _b, _c;
    var state = useSendbirdStateContext();
    var channelSettingStore = useChannelSettingsContext();
    var stringSet = useContext(LocalizationContext).stringSet;
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var userId = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.userId;
    var theme = ((_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.theme) || 'light';
    var isOnline = (_c = state === null || state === void 0 ? void 0 : state.config) === null || _c === void 0 ? void 0 : _c.isOnline;
    var disabled = !isOnline;
    var channel = channelSettingStore === null || channelSettingStore === void 0 ? void 0 : channelSettingStore.channel;
    var channelName = useMemo(function () {
        if ((channel === null || channel === void 0 ? void 0 : channel.name) && channel.name !== 'Group Channel') {
            return channel.name;
        }
        if ((channel === null || channel === void 0 ? void 0 : channel.name) === 'Group Channel' || !(channel === null || channel === void 0 ? void 0 : channel.name)) {
            return ((channel === null || channel === void 0 ? void 0 : channel.members) || []).map(function (member) { return member.nickname || stringSet.NO_NAME; }).join(', ');
        }
        return stringSet.NO_TITLE;
    }, [channel === null || channel === void 0 ? void 0 : channel.name, channel === null || channel === void 0 ? void 0 : channel.joinedMemberCount]);
    return (React__default.createElement("div", { className: "sendbird-channel-profile" },
        React__default.createElement("div", { className: "sendbird-channel-profile--inner" },
            React__default.createElement("div", { className: "sendbird-channel-profile__avatar" },
                React__default.createElement(ChannelAvatar, { channel: channel, userId: userId, theme: theme, width: 80, height: 80 })),
            React__default.createElement(Label, { className: "sendbird-channel-profile__title", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_1 }, channelName),
            React__default.createElement(TextButton, { disabled: disabled, className: "sendbird-channel-profile__edit", onClick: function () {
                    if (disabled) {
                        return;
                    }
                    setShowModal(true);
                }, disableUnderline: true },
                React__default.createElement(Label, { type: LabelTypography.BUTTON_1, color: disabled ? LabelColors.ONBACKGROUND_2 : LabelColors.PRIMARY }, stringSet.CHANNEL_SETTING__PROFILE__EDIT)),
            showModal && (React__default.createElement(EditDetails, { onCancel: function () { return setShowModal(false); }, onSubmit: function () { return setShowModal(false); } })))));
};


//# sourceMappingURL=ChannelProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/LeaveChannel.js


































var LeaveChannel_LeaveChannel = function (props) {
    var _a, _b;
    var _c = props.onSubmit, onSubmit = _c === void 0 ? noop : _c, _d = props.onCancel, onCancel = _d === void 0 ? noop : _d;
    var _e = useChannelSettingsContext(), channel = _e.channel, onLeaveChannel = _e.onLeaveChannel;
    var stringSet = useLocalization().stringSet;
    var state = useSendbirdStateContext();
    var logger = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.logger;
    var isOnline = (_b = state === null || state === void 0 ? void 0 : state.config) === null || _b === void 0 ? void 0 : _b.isOnline;
    var isMobile = useMediaQueryContext().isMobile;
    var getChannelName = function (channel) {
        if ((channel === null || channel === void 0 ? void 0 : channel.name) && (channel === null || channel === void 0 ? void 0 : channel.name) !== 'Group Channel') {
            return channel.name;
        }
        if ((channel === null || channel === void 0 ? void 0 : channel.name) === 'Group Channel' || !(channel === null || channel === void 0 ? void 0 : channel.name)) {
            return ((channel === null || channel === void 0 ? void 0 : channel.members) || []).map(function (member) { return member.nickname || stringSet.NO_NAME; }).join(', ');
        }
        return stringSet.NO_TITLE;
    };
    if (isMobile) {
        return (React__default.createElement(Modal, { className: "sendbird-channel-settings__leave--mobile", titleText: getChannelName(channel), hideFooter: true, isCloseOnClickOutside: true, onCancel: onCancel },
            React__default.createElement(TextButton, { onClick: function () {
                    logger.info('ChannelSettings: Leaving channel', channel);
                    channel === null || channel === void 0 ? void 0 : channel.leave().then(function () {
                        logger.info('ChannelSettings: Leaving channel successful!', channel);
                        onLeaveChannel === null || onLeaveChannel === void 0 ? void 0 : onLeaveChannel();
                    });
                }, className: "sendbird-channel-settings__leave-label--mobile" },
                React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.CHANNEL_PREVIEW_MOBILE_LEAVE))));
    }
    return (React__default.createElement(Modal, { isFullScreenOnMobile: true, disabled: !isOnline, onCancel: onCancel, onSubmit: function () {
            logger.info('ChannelSettings: Leaving channel', channel);
            channel === null || channel === void 0 ? void 0 : channel.leave().then(function () {
                logger.info('ChannelSettings: Leaving channel successful!', channel);
                // is for backward compactability
                if (onLeaveChannel) {
                    onLeaveChannel();
                }
                else {
                    onSubmit();
                }
            });
        }, submitText: stringSet.MODAL__LEAVE_CHANNEL__FOOTER, titleText: stringSet.MODAL__LEAVE_CHANNEL__TITLE }));
};


//# sourceMappingURL=LeaveChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/ChannelSettingsMenuItem.js





var ChannelSettingsMenuItem_MenuItem = function (_a) {
    var renderLeft = _a.renderLeft, renderMiddle = _a.renderMiddle, _b = _a.renderRight, renderRight = _b === void 0 ? function (props) { return React__default.createElement(ChannelSettingsMenuItem_MenuItemAction, __assign({}, props)); } : _b, renderAccordion = _a.renderAccordion, className = _a.className, onClick = _a.onClick, onKeyDown = _a.onKeyDown, accordionOpened = _a.accordionOpened, setAccordionOpened = _a.setAccordionOpened;
    var useAccordion = typeof renderAccordion === 'function';
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: classnames('sendbird-channel-settings__panel-item', className), onClick: function (e) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                if (useAccordion)
                    setAccordionOpened(!accordionOpened);
            }, onKeyDown: function (e) {
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                if (useAccordion)
                    setAccordionOpened(!accordionOpened);
            } },
            renderLeft(),
            renderMiddle(),
            renderRight({
                useAccordion: useAccordion,
                accordionOpened: accordionOpened,
            })),
        accordionOpened && (renderAccordion === null || renderAccordion === void 0 ? void 0 : renderAccordion())));
};
var ChannelSettingsMenuItem_MenuItemAction = function (_a) {
    var useAccordion = _a.useAccordion, accordionOpened = _a.accordionOpened, children = _a.children;
    return useAccordion
        ? React__default.createElement(Icon, { type: IconTypes.CHEVRON_RIGHT, className: [
                'sendbird-accordion__panel-icon-right',
                'sendbird-accordion__panel-icon--chevron',
                (accordionOpened ? 'sendbird-accordion__panel-icon--open' : ''),
            ].join(' '), height: "24px", width: "24px" })
        : children;
};


//# sourceMappingURL=ChannelSettingsMenuItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/ChannelSettingMenuList.js



































var ChannelSettingMenuList_MenuListByRole = function (_a) {
    var menuItems = _a.menuItems;
    var channel = useChannelSettingsContext().channel;
    var menuItemsByRole = isOperator(channel) ? menuItems.operator : menuItems.nonOperator;
    // State to track the open accordion key
    var _b = useState(null), openAccordionKey = _b[0], setOpenAccordionKey = _b[1];
    return (React__default.createElement("div", { className: "sendbird-channel-settings__operator" }, Object.entries(menuItemsByRole).map(function (_a) {
        var key = _a[0], item = _a[1];
        if (item.hideMenu)
            return null;
        return (React__default.createElement(MenuItem, { key: key, onClick: item.onClick, onKeyDown: item.onKeyDown, renderLeft: function () { return React__default.createElement(Icon, __assign({}, item.icon)); }, renderMiddle: function () { return React__default.createElement(Label, __assign({}, item.label)); }, renderRight: item.rightComponent, renderAccordion: item.accordionComponent, accordionOpened: openAccordionKey === key, setAccordionOpened: function () {
                setOpenAccordionKey(function (prevKey) { return (prevKey === key ? null : key); });
            } }));
    })));
};


//# sourceMappingURL=ChannelSettingMenuList.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-B9c-G9oD.js














// Utility function to handle processing state and promise execution
var processToggleAction = function (isProcessing, action, errorHandler) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (isProcessing.current) {
                    errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(new Error('Processing in progress'));
                    return [2 /*return*/];
                }
                isProcessing.current = true;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, action()];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error_1);
                return [3 /*break*/, 5];
            case 4:
                isProcessing.current = false;
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var getInitialIsOperator = function (channel, user) {
    if (!channel)
        return false;
    if (channel instanceof OpenChannel) {
        return channel.isOperator(user);
    }
    return (user === null || user === void 0 ? void 0 : user.role) === Role.OPERATOR;
};
var getInitialIsMuted = function (channel, user) {
    return channel ? user === null || user === void 0 ? void 0 : user.isMuted : false;
};
var useToggleOperator = function (_a) {
    var channel = _a.channel, user = _a.user, onToggleOperatorState = _a.onToggleOperatorState, _isOperator = _a.isOperator;
    var _b = useState(_isOperator !== null && _isOperator !== void 0 ? _isOperator : getInitialIsOperator(channel, user)), isOperator = _b[0], setIsOperator = _b[1];
    var isProcessing = useRef(false);
    var toggleOperator = useCallback(function () {
        // If channel is undefined, resolve immediately
        if (!channel)
            return Promise.resolve();
        return processToggleAction(isProcessing, function () { return __awaiter(void 0, void 0, void 0, function () {
            var togglePromise, newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        togglePromise = isOperator
                            ? channel.removeOperators([user.userId])
                            : channel.addOperators([user.userId]);
                        return [4 /*yield*/, togglePromise];
                    case 1:
                        _a.sent();
                        newStatus = !isOperator;
                        setIsOperator(newStatus);
                        onToggleOperatorState === null || onToggleOperatorState === void 0 ? void 0 : onToggleOperatorState({ user: user, newStatus: newStatus });
                        return [2 /*return*/];
                }
            });
        }); }, function (error) {
            onToggleOperatorState === null || onToggleOperatorState === void 0 ? void 0 : onToggleOperatorState({ user: user, newStatus: isOperator, error: error });
        });
    }, [isOperator, channel.url, user.userId, onToggleOperatorState]);
    return {
        isOperator: isOperator,
        toggleOperator: toggleOperator,
    };
};
var useToggleMute = function (_a) {
    var channel = _a.channel, user = _a.user, onToggleMuteState = _a.onToggleMuteState, _isMuted = _a.isMuted;
    var _b = useState(_isMuted !== null && _isMuted !== void 0 ? _isMuted : getInitialIsMuted(channel, user)), isMuted = _b[0], setIsMuted = _b[1];
    var isProcessing = useRef(false);
    var toggleMute = useCallback(function () {
        // If channel is undefined, resolve immediately
        if (!channel)
            return Promise.resolve();
        return processToggleAction(isProcessing, function () { return __awaiter(void 0, void 0, void 0, function () {
            var togglePromise, newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        togglePromise = isMuted
                            ? channel.unmuteUser(user)
                            : channel.muteUser(user);
                        return [4 /*yield*/, togglePromise];
                    case 1:
                        _a.sent();
                        newStatus = !isMuted;
                        setIsMuted(newStatus);
                        onToggleMuteState === null || onToggleMuteState === void 0 ? void 0 : onToggleMuteState({ user: user, newStatus: newStatus });
                        return [2 /*return*/];
                }
            });
        }); }, function (error) {
            onToggleMuteState === null || onToggleMuteState === void 0 ? void 0 : onToggleMuteState({ user: user, newStatus: isMuted, error: error });
        });
    }, [isMuted, channel.url, user.userId, onToggleMuteState]);
    return {
        isMuted: isMuted,
        toggleMute: toggleMute,
    };
};
var useToggleBan = function (_a) {
    var channel = _a.channel, user = _a.user, onToggleBanState = _a.onToggleBanState, _isBanned = _a.isBanned;
    var _b = useState(_isBanned !== null && _isBanned !== void 0 ? _isBanned : false), isBanned = _b[0], setIsBanned = _b[1]; // Initially starting with false
    var isProcessing = useRef(false);
    var toggleBan = useCallback(function () {
        // If channel is undefined, resolve immediately
        if (!channel)
            return Promise.resolve();
        return processToggleAction(isProcessing, function () { return __awaiter(void 0, void 0, void 0, function () {
            var togglePromise, newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        togglePromise = isBanned
                            ? channel.unbanUser(user)
                            : channel.banUser(user);
                        return [4 /*yield*/, togglePromise];
                    case 1:
                        _a.sent();
                        newStatus = !isBanned;
                        setIsBanned(newStatus);
                        onToggleBanState === null || onToggleBanState === void 0 ? void 0 : onToggleBanState({ user: user, newStatus: newStatus });
                        return [2 /*return*/];
                }
            });
        }); }, function (error) {
            onToggleBanState === null || onToggleBanState === void 0 ? void 0 : onToggleBanState({ user: user, newStatus: isBanned, error: error });
        });
    }, [isBanned, channel.url, user.userId, onToggleBanState]);
    return {
        isBanned: isBanned,
        toggleBan: toggleBan,
    };
};

var UserListItemMenuContext = (0,react.createContext)(undefined);
var UserListItemMenuProvider = function (_a) {
    var children = _a.children, values = __rest(_a, ["children"]);
    var config = useSendbirdStateContext().config;
    var currentUserId = config.userId;
    var channel = values.channel, user = values.user;
    var isCurrentUser = user.userId === currentUserId;
    var isCurrentUserOperator = (function () {
        if (!channel)
            return false;
        return channel instanceof OpenChannel
            ? channel.isOperator(currentUserId)
            : channel.myRole === Role.OPERATOR;
    })();
    var operatorState = useToggleOperator(values);
    var muteState = useToggleMute(values);
    var banState = useToggleBan(values);
    return (React__default.createElement(UserListItemMenuContext.Provider, { value: __assign(__assign(__assign(__assign(__assign({}, values), operatorState), muteState), banState), { isCurrentUser: isCurrentUser, isCurrentUserOperator: isCurrentUserOperator }) }, children));
};
var useUserListItemMenuContext = function () {
    var context = useContext(UserListItemMenuContext);
    if (!context) {
        throw new Error('useUserListItemMenuContext must be used within a UserListItemMenuProvider.');
    }
    return context;
};

var OperatorToggleMenuItem = function (props) {
    var _a;
    var stringSet = useLocalization().stringSet;
    var _b = useUserListItemMenuContext(), isOperator = _b.isOperator, toggleOperator = _b.toggleOperator, isCurrentUser = _b.isCurrentUser, isCurrentUserOperator = _b.isCurrentUserOperator, hideMenu = _b.hideMenu;
    if (!isCurrentUserOperator)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(MenuItem, __assign({}, props, { onClick: function (e) {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            toggleOperator();
            hideMenu();
        }, disabled: isCurrentUser }), (_a = props === null || props === void 0 ? void 0 : props.children) !== null && _a !== void 0 ? _a : (isOperator
        ? stringSet.CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR
        : stringSet.CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR)));
};
var MuteToggleMenuItem = function (props) {
    var _a;
    var stringSet = useLocalization().stringSet;
    var _b = useUserListItemMenuContext(), isMuted = _b.isMuted, toggleMute = _b.toggleMute, isCurrentUserOperator = _b.isCurrentUserOperator, hideMenu = _b.hideMenu, channel = _b.channel;
    if (!isCurrentUserOperator || (channel === null || channel === void 0 ? void 0 : channel.isBroadcast))
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(MenuItem, __assign({}, props, { onClick: function (e) {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            toggleMute();
            hideMenu();
        } }), (_a = props === null || props === void 0 ? void 0 : props.children) !== null && _a !== void 0 ? _a : (isMuted
        ? stringSet.CHANNEL_SETTING__MODERATION__UNMUTE
        : stringSet.CHANNEL_SETTING__MODERATION__MUTE)));
};
var BanToggleMenuItem = function (props) {
    var _a;
    var stringSet = useLocalization().stringSet;
    var _b = useUserListItemMenuContext(), isBanned = _b.isBanned, toggleBan = _b.toggleBan, isCurrentUserOperator = _b.isCurrentUserOperator, hideMenu = _b.hideMenu;
    if (!isCurrentUserOperator)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(MenuItem, __assign({}, props, { onClick: function (e) {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            toggleBan();
            hideMenu();
        } }), (_a = props === null || props === void 0 ? void 0 : props.children) !== null && _a !== void 0 ? _a : (isBanned
        ? stringSet.CHANNEL_SETTING__MODERATION__UNBAN
        : stringSet.CHANNEL_SETTING__MODERATION__BAN)));
};

var TriggerIcon = function (_a) {
    var toggleMenu = _a.toggleMenu, ref = _a.ref;
    return (React__default.createElement(IconButton, { ref: ref, className: "sendbird-user-message__more__menu", width: "32px", height: "32px", onClick: toggleMenu },
        React__default.createElement(Icon, { width: "24px", height: "24px", type: IconTypes.MORE, fillColor: IconColors.CONTENT_INVERSE })));
};
var DefaultMenuItems = function (_a) {
    var items = _a.items;
    var OperatorToggleMenuItem = items.OperatorToggleMenuItem, MuteToggleMenuItem = items.MuteToggleMenuItem, BanToggleMenuItem = items.BanToggleMenuItem;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(OperatorToggleMenuItem, null),
        React__default.createElement(MuteToggleMenuItem, null),
        React__default.createElement(BanToggleMenuItem, null)));
};

var bundle_B9c_G9oD_UserListItemMenu = function (props) {
    var user = props.user, className = props.className, _a = props.renderTrigger, renderTrigger = _a === void 0 ? TriggerIcon : _a, _b = props.renderMenuItems, renderMenuItems = _b === void 0 ? DefaultMenuItems : _b;
    var _c = useState(false), isMenuVisible = _c[0], setMenuVisibility = _c[1];
    var containerRef = useRef(null);
    var triggerRef = useRef(null);
    var config = useSendbirdStateContext().config;
    var currentUserId = config.userId;
    var toggleMenu = function () {
        setMenuVisibility(function (prev) { return !prev; });
    };
    var hideMenu = function () {
        setMenuVisibility(false);
    };
    if (user.userId === currentUserId) {
        return null;
    }
    return (React__default.createElement("div", { className: classnames('sendbird-user-list-item-menu', className), ref: containerRef },
        React__default.createElement(UserListItemMenuProvider, __assign({}, props, { hideMenu: hideMenu, toggleMenu: toggleMenu }),
            renderTrigger({ ref: triggerRef, toggleMenu: toggleMenu }),
            isMenuVisible && (React__default.createElement(MenuItems
            // TODO: Add id using getObservingId for useElementObserver
            , { 
                // TODO: Add id using getObservingId for useElementObserver
                parentRef: triggerRef, parentContainRef: containerRef, closeDropdown: hideMenu }, renderMenuItems({
                items: {
                    OperatorToggleMenuItem: OperatorToggleMenuItem,
                    MuteToggleMenuItem: MuteToggleMenuItem,
                    BanToggleMenuItem: BanToggleMenuItem,
                },
            }))))));
};


//# sourceMappingURL=bundle-B9c-G9oD.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DN92WwJg.js













function OperatorsModal(_a) {
    var _this = this;
    var onCancel = _a.onCancel, _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.operatorListQueryParams, operatorListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), operators = _d[0], setOperators = _d[1];
    var _e = useState(null), operatorQuery = _e[0], setOperatorQuery = _e[1];
    var channel = useChannelSettingsContext().channel;
    var stringSet = useContext(LocalizationContext).stringSet;
    useEffect(function () {
        var operatorListQuery = channel === null || channel === void 0 ? void 0 : channel.createOperatorListQuery(__assign({ limit: 20 }, operatorListQueryParams));
        operatorListQuery === null || operatorListQuery === void 0 ? void 0 : operatorListQuery.next().then(function (operators) {
            setOperators(operators);
        });
        setOperatorQuery(operatorListQuery !== null && operatorListQuery !== void 0 ? operatorListQuery : null);
    }, []);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, hideFooter: true, titleText: stringSet.CHANNEL_SETTING__OPERATORS__TITLE_ALL, onCancel: onCancel },
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: useOnScrollPositionChangeDetector({
                    onReachedBottom: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (operatorQuery && operatorQuery.hasNext) {
                                operatorQuery.next().then(function (o) {
                                    setOperators(__spreadArray(__spreadArray([], operators, true), o, true));
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); },
                }) }, operators.map(function (member) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
                user: member,
                channel: channel,
                renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { isOperator: true, onToggleOperatorState: function (_a) {
                        var user = _a.user;
                        setOperators(operators.filter(function (_a) {
                            var userId = _a.userId;
                            return userId !== user.userId;
                        }));
                    }, renderMenuItems: function (_a) {
                        var items = _a.items;
                        return (React__default.createElement(items.OperatorToggleMenuItem, null));
                    } }))); },
            }))); })))));
}

function AddOperatorsModal(_a) {
    var _this = this;
    var onCancel = _a.onCancel, onSubmit = _a.onSubmit, _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b;
    var _c = useState([]), members = _c[0], setMembers = _c[1];
    var _d = useState({}), selectedMembers = _d[0], setSelectedMembers = _d[1];
    var _e = useState(null), memberQuery = _e[0], setMemberQuery = _e[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var channel = useChannelSettingsContext().channel;
    useEffect(function () {
        var memberListQuery = channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery({
            operatorFilter: OperatorFilter.NONOPERATOR,
            limit: 20,
        });
        memberListQuery === null || memberListQuery === void 0 ? void 0 : memberListQuery.next().then(function (members) {
            setMembers(members);
        });
        setMemberQuery(memberListQuery !== null && memberListQuery !== void 0 ? memberListQuery : null);
    }, []);
    var selectedCount = Object.keys(selectedMembers).filter(function (m) { return selectedMembers[m]; }).length;
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, type: ButtonTypes.PRIMARY, submitText: stringSet.CHANNEL_SETTING__OPERATORS__ADD_BUTTON, onCancel: onCancel, onSubmit: function () {
                var members = Object.keys(selectedMembers).filter(function (m) { return selectedMembers[m]; });
                channel === null || channel === void 0 ? void 0 : channel.addOperators(members).then(function () {
                    onSubmit(members);
                });
            }, titleText: stringSet.CHANNEL_SETTING__MEMBERS__SELECT_TITLE },
            React__default.createElement(Label, { color: (selectedCount > 0) ? LabelColors.PRIMARY : LabelColors.ONBACKGROUND_3, type: LabelTypography.CAPTION_1 }, "".concat(selectedCount, " ").concat(stringSet.MODAL__INVITE_MEMBER__SELECTED)),
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: useOnScrollPositionChangeDetector({
                    onReachedBottom: function () { return __awaiter(_this, void 0, void 0, function () {
                        var hasNext;
                        return __generator(this, function (_a) {
                            hasNext = memberQuery.hasNext;
                            if (hasNext) {
                                memberQuery.next().then(function (o) {
                                    setMembers(__spreadArray(__spreadArray([], members, true), o, true));
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); },
                }) }, members.map(function (member) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
                user: member,
                checkBox: true,
                checked: selectedMembers[member.userId],
                disabled: (member === null || member === void 0 ? void 0 : member.role) === 'operator',
                onChange: function (event) {
                    var _a;
                    var modifiedSelectedMembers = __assign(__assign({}, selectedMembers), (_a = {}, _a[event.target.id] = event.target.checked, _a));
                    if (!event.target.checked) {
                        delete modifiedSelectedMembers[event.target.id];
                    }
                    setSelectedMembers(modifiedSelectedMembers);
                },
            }))); })))));
}

var bundle_DN92WwJg_OperatorList = function (_a) {
    var _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.operatorListQueryParams, operatorListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), operators = _d[0], setOperators = _d[1];
    var _e = useState(false), showMore = _e[0], setShowMore = _e[1];
    var _f = useState(false), showAdd = _f[0], setShowAdd = _f[1];
    var _g = useState(false), hasNext = _g[0], setHasNext = _g[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var channel = useChannelSettingsContext().channel;
    var refreshList = useCallback(function () {
        if (!channel) {
            setOperators([]);
            return;
        }
        var operatorListQuery = channel === null || channel === void 0 ? void 0 : channel.createOperatorListQuery(__assign({ limit: 10 }, operatorListQueryParams));
        operatorListQuery.next().then(function (operators) {
            setOperators(operators);
            setHasNext(operatorListQuery.hasNext);
        });
    }, [channel === null || channel === void 0 ? void 0 : channel.url, channel === null || channel === void 0 ? void 0 : channel.createOperatorListQuery]);
    useEffect(refreshList, [channel === null || channel === void 0 ? void 0 : channel.url]);
    return (React__default.createElement(React__default.Fragment, null,
        operators.map(function (operator) { return (React__default.createElement(React__default.Fragment, { key: operator.userId }, renderUserListItem({
            user: operator,
            channel: channel,
            size: 'small',
            avatarSize: '24px',
            renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { 
                /**
                 * isOperator:
                 * The ReturnType of createOperatorListQuery is User[].
                 * We can't determine if this user is an operator, because User doesn't have a `role` property.
                 * Therefore, we need to explicitly specify that this user is an operator.
                */
                isOperator: true, onToggleOperatorState: function () {
                    // Limitation to server-side table update delay.
                    setTimeout(function () {
                        refreshList();
                    }, 500);
                }, renderMenuItems: function (_a) {
                    var items = _a.items;
                    return (React__default.createElement(items.OperatorToggleMenuItem, null));
                } }))); },
        }))); }),
        React__default.createElement("div", { className: "sendbird-channel-settings-accordion__footer" },
            React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () {
                    setShowAdd(true);
                } }, stringSet.CHANNEL_SETTING__OPERATORS__TITLE_ADD),
            hasNext && (React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () {
                    setShowMore(true);
                } }, stringSet.CHANNEL_SETTING__OPERATORS__TITLE_ALL))),
        showMore && (React__default.createElement(OperatorsModal, { onCancel: function () {
                setShowMore(false);
                refreshList();
            }, renderUserListItem: renderUserListItem, operatorListQueryParams: operatorListQueryParams })),
        showAdd && (React__default.createElement(AddOperatorsModal, { onCancel: function () { return setShowAdd(false); }, onSubmit: function () {
                /**
                 * Limitation to server-side table update delay.
                 */
                setTimeout(function () {
                    refreshList();
                }, 500);
                setShowAdd(false);
            }, renderUserListItem: renderUserListItem }))));
};

function BannedUsersModal(_a) {
    var _this = this;
    var onCancel = _a.onCancel, _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.bannedUserListQueryParams, bannedUserListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(null), memberQuery = _e[0], setMemberQuery = _e[1];
    var channel = useChannelSettingsContext().channel;
    var stringSet = useLocalization().stringSet;
    useEffect(function () {
        var bannedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery(__assign({ limit: 20 }, bannedUserListQueryParams));
        if (bannedUserListQuery) {
            bannedUserListQuery.next().then(function (users) {
                setMembers(users);
            });
            setMemberQuery(bannedUserListQuery);
        }
    }, []);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, hideFooter: true, onCancel: function () { return onCancel(); }, onSubmit: noop, titleText: stringSet.CHANNEL_SETTING__BANNED_MEMBERS__TITLE },
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: useOnScrollPositionChangeDetector({
                    onReachedBottom: function () { return __awaiter(_this, void 0, void 0, function () {
                        var hasNext;
                        return __generator(this, function (_a) {
                            if (!memberQuery)
                                return [2 /*return*/];
                            hasNext = memberQuery.hasNext;
                            if (hasNext) {
                                memberQuery.next().then(function (o) {
                                    setMembers(__spreadArray(__spreadArray([], members, true), o, true));
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); },
                }) }, members.map(function (member) { return (renderUserListItem({
                user: member,
                channel: channel,
                renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { isBanned: true, onToggleBanState: function () {
                        setMembers(members.filter(function (m) {
                            return (m.userId !== member.userId);
                        }));
                    }, renderMenuItems: function (_a) {
                        var items = _a.items;
                        return React__default.createElement(items.BanToggleMenuItem, null);
                    } }))); },
            })); })))));
}

var bundle_DN92WwJg_BannedUserList = function (_a) {
    var _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.bannedUserListQueryParams, bannedUserListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(false), hasNext = _e[0], setHasNext = _e[1];
    var _f = useState(false), showModal = _f[0], setShowModal = _f[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var channel = useChannelSettingsContext().channel;
    var refreshList = useCallback(function () {
        if (!channel) {
            setMembers([]);
            return;
        }
        var bannedUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery(__assign({ limit: 10 }, bannedUserListQueryParams));
        bannedUserListQuery.next().then(function (users) {
            setMembers(users);
            setHasNext(bannedUserListQuery.hasNext);
        });
    }, [channel === null || channel === void 0 ? void 0 : channel.url, channel === null || channel === void 0 ? void 0 : channel.createBannedUserListQuery]);
    useEffect(refreshList, [channel === null || channel === void 0 ? void 0 : channel.url]);
    return (React__default.createElement(React__default.Fragment, null,
        members.map(function (member) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
            user: member,
            channel: channel,
            size: 'small',
            avatarSize: '24px',
            renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { isBanned: true, onToggleBanState: function () { return refreshList(); }, renderMenuItems: function (_a) {
                    var items = _a.items;
                    return (React__default.createElement(items.BanToggleMenuItem, null));
                } }))); },
        }))); }),
        members && members.length === 0 && (React__default.createElement(Label, { className: "sendbird-channel-settings__empty-list", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_3 }, stringSet.CHANNEL_SETTING__MODERATION__EMPTY_BAN)),
        hasNext && (React__default.createElement("div", { className: "sendbird-channel-settings-accordion__footer" },
            React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () {
                    setShowModal(true);
                } }, stringSet.CHANNEL_SETTING__MODERATION__ALL_BAN))),
        showModal && (React__default.createElement(BannedUsersModal, { onCancel: function () {
                setShowModal(false);
                refreshList();
            }, renderUserListItem: renderUserListItem, bannedUserListQueryParams: bannedUserListQueryParams }))));
};

function MutedMembersModal(_a) {
    var _this = this;
    var onCancel = _a.onCancel, _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.memberListQueryParams, memberListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(null), memberQuery = _e[0], setMemberQuery = _e[1];
    var channel = useChannelSettingsContext().channel;
    var stringSet = useLocalization().stringSet;
    useEffect(function () {
        var memberUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery(__assign(__assign({ limit: 20 }, memberListQueryParams), { 
            // @ts-ignore
            mutedMemberFilter: 'muted' }));
        memberUserListQuery === null || memberUserListQuery === void 0 ? void 0 : memberUserListQuery.next().then(function (members) {
            setMembers(members);
        });
        setMemberQuery(memberUserListQuery !== null && memberUserListQuery !== void 0 ? memberUserListQuery : null);
    }, []);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, hideFooter: true, onCancel: function () { return onCancel(); }, onSubmit: noop, titleText: stringSet.CHANNEL_SETTING__MUTED_MEMBERS__TITLE },
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: useOnScrollPositionChangeDetector({
                    onReachedBottom: function () { return __awaiter(_this, void 0, void 0, function () {
                        var hasNext;
                        return __generator(this, function (_a) {
                            hasNext = memberQuery.hasNext;
                            if (hasNext) {
                                memberQuery.next().then(function (o) {
                                    setMembers(__spreadArray(__spreadArray([], members, true), o, true));
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); },
                }) }, members.map(function (member) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
                user: member,
                channel: channel,
                renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { onToggleMuteState: function () {
                        setMembers(members.filter(function (m) {
                            return (m.userId !== member.userId);
                        }));
                    }, renderMenuItems: function (_a) {
                        var items = _a.items;
                        return (React__default.createElement(items.MuteToggleMenuItem, null));
                    } }))); },
            }))); })))));
}

var bundle_DN92WwJg_MutedMemberList = function (_a) {
    var _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.memberListQueryParams, memberListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(false), hasNext = _e[0], setHasNext = _e[1];
    var _f = useState(false), showModal = _f[0], setShowModal = _f[1];
    var stringSet = useLocalization().stringSet;
    var channel = useChannelSettingsContext().channel;
    var refreshList = useCallback(function () {
        if (!channel) {
            setMembers([]);
            return;
        }
        var memberUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery(__assign(__assign({ limit: 10 }, memberListQueryParams), { 
            // @ts-ignore
            mutedMemberFilter: 'muted' }));
        memberUserListQuery.next().then(function (members) {
            setMembers(members);
            setHasNext(memberUserListQuery.hasNext);
        });
    }, [channel === null || channel === void 0 ? void 0 : channel.url, channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery]);
    useEffect(refreshList, [channel === null || channel === void 0 ? void 0 : channel.url]);
    return (React__default.createElement(React__default.Fragment, null,
        members.map(function (member) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
            user: member,
            channel: channel,
            size: 'small',
            avatarSize: '24px',
            renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { onToggleMuteState: function () {
                    // Limitation to server-side table update delay.
                    setTimeout(function () {
                        refreshList();
                    }, 500);
                }, renderMenuItems: function (_a) {
                    var items = _a.items;
                    return (React__default.createElement(items.MuteToggleMenuItem, null));
                } }))); },
        }))); }),
        members && members.length === 0 && (React__default.createElement(Label, { className: "sendbird-channel-settings__empty-list", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_3 }, stringSet.CHANNEL_SETTING__NO_UNMUTED)),
        hasNext && (React__default.createElement("div", { className: "sendbird-channel-settings-accordion__footer" },
            React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () {
                    setShowModal(true);
                } }, stringSet.CHANNEL_SETTING__MUTED_MEMBERS__TITLE_ALL))),
        showModal && (React__default.createElement(MutedMembersModal, { onCancel: function () {
                setShowModal(false);
                refreshList();
            }, renderUserListItem: renderUserListItem, memberListQueryParams: memberListQueryParams }))));
};


//# sourceMappingURL=bundle-DN92WwJg.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DKPIYAYp.js














function MembersModal(_a) {
    var _this = this;
    var onCancel = _a.onCancel, _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.memberListQueryParams, memberListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(null), memberQuery = _e[0], setMemberQuery = _e[1];
    var channel = useChannelSettingsContext().channel;
    var stringSet = useContext(LocalizationContext).stringSet;
    useEffect(function () {
        var memberListQuery = channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery(__assign({ limit: 20 }, memberListQueryParams));
        memberListQuery === null || memberListQuery === void 0 ? void 0 : memberListQuery.next().then(function (members) {
            setMembers(members);
        });
        setMemberQuery(memberListQuery !== null && memberListQuery !== void 0 ? memberListQuery : null);
    }, []);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, hideFooter: true, onCancel: function () { return onCancel(); }, onSubmit: noop, titleText: stringSet.CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS },
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: useOnScrollPositionChangeDetector({
                    onReachedBottom: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (memberQuery && memberQuery.hasNext) {
                                memberQuery.next().then(function (o) {
                                    setMembers(__spreadArray(__spreadArray([], members, true), o, true));
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); },
                }) }, members.map(function (member, index) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
                // NOTE: This `index` is used to display the current user's user item at the top when customizing externally.
                index: index,
                user: member,
                channel: channel,
                renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { onToggleOperatorState: function (_a) {
                        var isOperator = _a.newStatus;
                        var newMembers = __spreadArray([], members, true);
                        for (var _i = 0, newMembers_1 = newMembers; _i < newMembers_1.length; _i++) {
                            var newMember = newMembers_1[_i];
                            if (newMember.userId === member.userId) {
                                newMember.role = isOperator ? Role.OPERATOR : Role.NONE;
                                break;
                            }
                        }
                        setMembers(newMembers);
                    }, onToggleMuteState: function (_a) {
                        var isMuted = _a.newStatus;
                        var newMembers = __spreadArray([], members, true);
                        for (var _i = 0, newMembers_2 = newMembers; _i < newMembers_2.length; _i++) {
                            var newMember = newMembers_2[_i];
                            if (newMember.userId === member.userId) {
                                newMember.isMuted = isMuted;
                                break;
                            }
                        }
                        setMembers(newMembers);
                    }, onToggleBanState: function () {
                        setMembers(members.filter(function (_a) {
                            var userId = _a.userId;
                            return userId !== member.userId;
                        }));
                    } }))); },
            }))); })))));
}

function InviteUsersModal(_a) {
    var _this = this;
    var _b, _c, _d;
    var onCancel = _a.onCancel, onSubmit = _a.onSubmit, _e = _a.renderUserListItem, renderUserListItem = _e === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _e;
    var _f = useState([]), users = _f[0], setUsers = _f[1];
    var _g = useState(null), userListQuery = _g[0], setUserListQuery = _g[1];
    var _h = useState({}), selectedUsers = _h[0], setSelectedUsers = _h[1];
    var state = useSendbirdStateContext();
    var sdk = (_c = (_b = state === null || state === void 0 ? void 0 : state.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.sdk;
    var globalUserListQuery = (_d = state === null || state === void 0 ? void 0 : state.config) === null || _d === void 0 ? void 0 : _d.userListQuery;
    var _j = useChannelSettingsContext(), channel = _j.channel, overrideInviteUser = _j.overrideInviteUser, queries = _j.queries;
    var stringSet = useLocalization().stringSet;
    var onScroll = useOnScrollPositionChangeDetector({
        onReachedBottom: function () {
            return __awaiter(this, void 0, void 0, function () {
                var users_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(userListQuery === null || userListQuery === void 0 ? void 0 : userListQuery.hasNext)) return [3 /*break*/, 2];
                            return [4 /*yield*/, userListQuery.next()];
                        case 1:
                            users_1 = _a.sent();
                            setUsers(function (prev) { return __spreadArray(__spreadArray([], prev, true), users_1, true); });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var onInviteUsers = function () { return __awaiter(_this, void 0, void 0, function () {
        var userIdsToInvite;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userIdsToInvite = Object.keys(selectedUsers);
                    if (!(channel && typeof overrideInviteUser === 'function')) return [3 /*break*/, 1];
                    overrideInviteUser({ users: userIdsToInvite, onClose: onCancel, channel: channel });
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, (channel === null || channel === void 0 ? void 0 : channel.inviteWithUserIds(userIdsToInvite))];
                case 2:
                    _a.sent();
                    onSubmit(userIdsToInvite);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSelectUser = function (user) {
        setSelectedUsers(function (_a) {
            var draft = __rest(_a, []);
            if (draft[user.userId]) {
                delete draft[user.userId];
            }
            else {
                draft[user.userId] = user;
            }
            return draft;
        });
    };
    var membersMap = useMemo(function () {
        var _a;
        var _b, _c;
        // UIKit policy: In a super or broadcast channel, do not check the members when inviting users.
        if ((channel === null || channel === void 0 ? void 0 : channel.isSuper) || (channel === null || channel === void 0 ? void 0 : channel.isBroadcast))
            return _a = {}, _a[(_c = (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId) !== null && _c !== void 0 ? _c : ''] = sdk.currentUser, _a;
        return channel === null || channel === void 0 ? void 0 : channel.members.reduce(function (acc, cur) {
            acc[cur.userId] = cur;
            return acc;
        }, {});
    }, [channel === null || channel === void 0 ? void 0 : channel.members.length]);
    useEffect(function () {
        var fetchUsersAndSetQuery = function () { return __awaiter(_this, void 0, void 0, function () {
            var query, users_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = (_a = globalUserListQuery === null || globalUserListQuery === void 0 ? void 0 : globalUserListQuery()) !== null && _a !== void 0 ? _a : sdk === null || sdk === void 0 ? void 0 : sdk.createApplicationUserListQuery(queries === null || queries === void 0 ? void 0 : queries.applicationUserListQuery);
                        if (!query) return [3 /*break*/, 2];
                        return [4 /*yield*/, query.next()];
                    case 1:
                        users_2 = _b.sent();
                        setUserListQuery(query);
                        setUsers(users_2);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        fetchUsersAndSetQuery();
    }, [sdk]);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { isFullScreenOnMobile: true, disabled: Object.keys(selectedUsers).length === 0, submitText: stringSet.BUTTON__INVITE, type: ButtonTypes.PRIMARY, onCancel: function () { return onCancel(); }, onSubmit: onInviteUsers, titleText: stringSet.CHANNEL_SETTING__MEMBERS__SELECT_TITLE },
            React__default.createElement("div", { className: "sendbird-more-members__popup-scroll", onScroll: onScroll },
                React__default.createElement("div", { className: "sendbird-more-members__popup-scroll__inner" }, users.map(function (user) {
                    var isMember = Boolean(membersMap ? membersMap[user.userId] : false);
                    var isSelected = Boolean(selectedUsers[user.userId]);
                    return (React__default.createElement(React__default.Fragment, { key: user.userId }, renderUserListItem({
                        user: user,
                        checkBox: true,
                        checked: isMember || isSelected,
                        disabled: isMember,
                        onChange: function () { return onSelectUser(user); },
                    })));
                }))))));
}

var bundle_DKPIYAYp_MemberList = function (_a) {
    var _b = _a.renderUserListItem, renderUserListItem = _b === void 0 ? function (props) { return React__default.createElement(UserListItem, __assign({}, props)); } : _b, _c = _a.memberListQueryParams, memberListQueryParams = _c === void 0 ? {} : _c;
    var _d = useState([]), members = _d[0], setMembers = _d[1];
    var _e = useState(false), hasNext = _e[0], setHasNext = _e[1];
    var _f = useState(false), showAllMembers = _f[0], setShowAllMembers = _f[1];
    var _g = useState(false), showInviteUsers = _g[0], setShowInviteUsers = _g[1];
    var _h = useChannelSettingsContext(), channel = _h.channel, forceUpdateUI = _h.forceUpdateUI;
    var stringSet = useContext(LocalizationContext).stringSet;
    var refreshList = useCallback(function () {
        if (!channel) {
            setMembers([]);
            return;
        }
        var memberUserListQuery = channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery(__assign({ limit: 10 }, memberListQueryParams));
        memberUserListQuery.next().then(function (members) {
            setMembers(members);
            setHasNext(memberUserListQuery.hasNext);
        });
    }, [channel === null || channel === void 0 ? void 0 : channel.url, channel === null || channel === void 0 ? void 0 : channel.createMemberListQuery]);
    useEffect(refreshList, [channel === null || channel === void 0 ? void 0 : channel.url]);
    return (React__default.createElement("div", { className: "sendbird-channel-settings-member-list" },
        members.map(function (member, index) { return (React__default.createElement(React__default.Fragment, { key: member.userId }, renderUserListItem({
            // NOTE: This `index` is used to display the current user's user item at the top when customizing externally.
            index: index,
            user: member,
            channel: channel,
            size: 'small',
            avatarSize: '24px',
            renderListItemMenu: function (props) { return (React__default.createElement(UserListItemMenu, __assign({}, props, { onToggleOperatorState: function (_a) {
                    var isOperator = _a.newStatus;
                    var newMembers = __spreadArray([], members, true);
                    for (var _i = 0, newMembers_1 = newMembers; _i < newMembers_1.length; _i++) {
                        var newMember = newMembers_1[_i];
                        if (newMember.userId === member.userId) {
                            newMember.role = isOperator ? Role.OPERATOR : Role.NONE;
                            break;
                        }
                    }
                    setMembers(newMembers);
                }, onToggleMuteState: function (_a) {
                    var isMuted = _a.newStatus;
                    var newMembers = __spreadArray([], members, true);
                    for (var _i = 0, newMembers_2 = newMembers; _i < newMembers_2.length; _i++) {
                        var newMember = newMembers_2[_i];
                        if (newMember.userId === member.userId) {
                            newMember.isMuted = isMuted;
                            break;
                        }
                    }
                    setMembers(newMembers);
                }, onToggleBanState: function () {
                    setMembers(members.filter(function (_a) {
                        var userId = _a.userId;
                        return userId !== member.userId;
                    }));
                } }))); },
        }))); }),
        React__default.createElement("div", { className: "sendbird-channel-settings-accordion__footer" },
            hasNext && (React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () { return setShowAllMembers(true); } }, stringSet.CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS)),
            React__default.createElement(Button, { type: ButtonTypes.SECONDARY, size: ButtonSizes.SMALL, onClick: function () { return setShowInviteUsers(true); } }, stringSet.CHANNEL_SETTING__MEMBERS__INVITE_MEMBER)),
        showAllMembers && (React__default.createElement(MembersModal, { onCancel: function () {
                setShowAllMembers(false);
                refreshList();
                forceUpdateUI();
            }, renderUserListItem: renderUserListItem, memberListQueryParams: memberListQueryParams })),
        showInviteUsers && (React__default.createElement(InviteUsersModal, { onCancel: function () { return setShowInviteUsers(false); }, onSubmit: function () {
                setShowInviteUsers(false);
                refreshList();
                forceUpdateUI();
            }, renderUserListItem: renderUserListItem }))));
};


//# sourceMappingURL=bundle-DKPIYAYp.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/Toggle.js





/**
 * The default value of `checked` should be null
 * to support both case of controlled and uncontrolled component
 * ref: https://github.com/aaronshaf/react-toggle#props
 */
var Toggle_noop = function () { };
var TOGGLE_DEFAULT_VALUE = {
    checked: null,
    defaultChecked: false,
    disabled: false,
    onChange: Toggle_noop,
    onFocus: Toggle_noop,
    onBlur: Toggle_noop,
};
var ToggleContext = react.createContext(TOGGLE_DEFAULT_VALUE);
function useToggleContext() {
    var context = React__default.useContext(ToggleContext);
    if (context === undefined) {
        throw new Error('@sendbird/uikit-react/ui/Toggle: useToggleContext must be used within a ToggleContainer.');
    }
    return context;
}

// Props Explanation https://github.com/aaronshaf/react-toggle#props
function ToggleContainer(_a) {
    var _b = _a.checked, checked = _b === void 0 ? TOGGLE_DEFAULT_VALUE.checked : _b, // null
    _c = _a.defaultChecked, // null
    defaultChecked = _c === void 0 ? TOGGLE_DEFAULT_VALUE.defaultChecked : _c, _d = _a.disabled, disabled = _d === void 0 ? TOGGLE_DEFAULT_VALUE.disabled : _d, _e = _a.onChange, onChange = _e === void 0 ? TOGGLE_DEFAULT_VALUE.onChange : _e, _f = _a.onFocus, onFocus = _f === void 0 ? TOGGLE_DEFAULT_VALUE.onFocus : _f, _g = _a.onBlur, onBlur = _g === void 0 ? TOGGLE_DEFAULT_VALUE.onBlur : _g, children = _a.children;
    var _h = useState(defaultChecked || false), isChecked = _h[0], setChecked = _h[1];
    var handleChange = useCallback(function (e) {
        if (disabled) {
            return;
        }
        if (checked === null) {
            setChecked(e.currentTarget.checked);
        }
        onChange(e);
    }, [onChange, checked]);
    return (React__default.createElement(ToggleContext.Provider, { value: {
            checked: checked !== null ? checked : isChecked,
            disabled: disabled,
            onChange: handleChange,
            onFocus: function (e) {
                if (!disabled) {
                    onFocus(e);
                }
            },
            onBlur: function (e) {
                if (!disabled) {
                    onBlur(e);
                }
            },
        } }, children));
}

function filterNumber(input) {
    if (typeof input !== 'string' && typeof input !== 'number') {
        try {
            var config = useSendbirdStateContext().config;
            var logger = config.logger;
            logger.warning('@sendbird/uikit-react/ui/Toggle: TypeError - expected string or number.', input);
        }
        catch (_) { /* noop */ }
        return [];
    }
    if (typeof input === 'number') {
        return [input];
    }
    var regex = /(-?\d+)(\.\d+)?/g;
    var numbers = input.match(regex) || [];
    return numbers.map(parseFloat);
}

function ToggleUI(props) {
    var _a;
    var _b = props.reversed, reversed = _b === void 0 ? false : _b, _c = props.width, width = _c === void 0 ? '40px' : _c, _d = props.animationDuration, animationDuration = _d === void 0 ? '0.5s' : _d, _e = props.style, style = _e === void 0 ? {} : _e, _f = props.name, name = _f === void 0 ? '' : _f, _g = props.id, id = _g === void 0 ? '' : _g, _h = props.ariaLabel, ariaLabel = _h === void 0 ? '' : _h, _j = props.ariaLabelledby, ariaLabelledby = _j === void 0 ? '' : _j;
    var _k = useToggleContext(), checked = _k.checked, disabled = _k.disabled, onChange = _k.onChange, onFocus = _k.onFocus, onBlur = _k.onBlur;
    // animation should not be activated in the initialization step
    var _l = useState(''), animatedClassName = _l[0], setAnimatedClassName = _l[1];
    var toggleWidth = (_a = filterNumber(width)) === null || _a === void 0 ? void 0 : _a[0];
    var toggleHeight = toggleWidth / 2;
    // The size of dot should be 60% of toggle height
    var dotSize = toggleHeight * 0.6;
    return (React__default.createElement("label", { className: [
            'sendbird-input-toggle-button',
            animatedClassName,
            checked ? 'sendbird-input-toggle-button--checked' : 'sendbird-input-toggle-button--unchecked',
            disabled ? 'sendbird-input-toggle-button--disabled' : [],
            reversed ? 'sendbird-input-toggle-button--reversed' : [],
        ].flat().join(' '), "data-testid": "sendbird-input-toggle-button", style: __assign({ width: "".concat(toggleWidth, "px"), height: "".concat(toggleHeight, "px"), borderRadius: "".concat(dotSize, "px") }, style) },
        React__default.createElement("div", { className: [
                'sendbird-input-toggle-button__inner-dot',
                checked
                    ? 'sendbird-input-toggle-button__inner-dot--activate'
                    : 'sendbird-input-toggle-button__inner-dot--inactivate',
            ].join(' '), style: {
                width: "".concat(dotSize, "px"),
                height: "".concat(dotSize, "px"),
                animationDuration: animationDuration,
            } }),
        React__default.createElement("input", { type: "checkbox", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, name: name, id: id, checked: checked !== null && checked !== void 0 ? checked : undefined, disabled: disabled, onChange: function (e) {
                onChange === null || onChange === void 0 ? void 0 : onChange(e);
                setAnimatedClassName(e.currentTarget.checked ? 'sendbird-input-toggle-button--turned-on' : 'sendbird-input-toggle-button--turned-off');
            }, onFocus: onFocus, onBlur: onBlur })));
}

function Toggle_Toggle(props) {
    var 
    // ToggleProvider
    checked = props.checked, defaultChecked = props.defaultChecked, disabled = props.disabled, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, 
    // ToggleUI
    className = props.className, reversed = props.reversed, width = props.width, 
    // height will be half of width
    animationDuration = props.animationDuration, style = props.style, name = props.name, id = props.id, ariaLabel = props.ariaLabel, ariaLabelledby = props.ariaLabelledby;
    return (React__default.createElement("div", { className: "sendbird-ui-toggle ".concat(className) },
        React__default.createElement(ToggleContainer, { checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: onFocus, onBlur: onBlur },
            React__default.createElement(ToggleUI, { reversed: reversed, width: width, animationDuration: animationDuration, style: style, name: name, id: id, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby }))));
}


//# sourceMappingURL=Toggle.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/hooks/useMenuList.js



















































var useMenuList_kFormatter = function (num) {
    return Math.abs(num) > 999
        ? "".concat((Math.abs(num) / 1000).toFixed(1), "K")
        : num;
};
var commonIconProps = {
    fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY,
    width: 24,
    height: 24,
    className: 'sendbird-channel-settings__accordion-icon',
};
var commonLabelProps = {
    type: bundle_ixnsp7Bg.a.SUBTITLE_1,
    color: bundle_ixnsp7Bg.b.ONBACKGROUND_1,
};
var useMenuList_useMenuItems = function () {
    var _a = useState(false), frozen = _a[0], setFrozen = _a[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var _b = useChannelSettingsContext(), channel = _b.channel, renderUserListItem = _b.renderUserListItem;
    // work around for
    // https://sendbird.slack.com/archives/G01290GCDCN/p1595922832000900
    // SDK bug - after frozen/unfrozen myRole becomes "none"
    useEffect(function () {
        var _a;
        setFrozen((_a = channel === null || channel === void 0 ? void 0 : channel.isFrozen) !== null && _a !== void 0 ? _a : false);
    }, [channel === null || channel === void 0 ? void 0 : channel.isFrozen]);
    return useMemo(function () { return ({
        operator: {
            operators: {
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.OPERATOR }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__OPERATORS__TITLE }),
                accordionComponent: function () { return React__default.createElement(OperatorList, { renderUserListItem: renderUserListItem }); },
            },
            allUsers: {
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.MEMBERS }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__MEMBERS__TITLE }),
                rightComponent: function (props) { return (React__default.createElement("div", { className: "sendbird-channel-settings__members" },
                    React__default.createElement(Badge, { count: (channel === null || channel === void 0 ? void 0 : channel.memberCount) ? useMenuList_kFormatter(channel.memberCount) : '' }),
                    React__default.createElement(MenuItemAction, __assign({}, props)))); },
                accordionComponent: function () { return React__default.createElement(MemberList, { renderUserListItem: renderUserListItem }); },
            },
            mutedUsers: {
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.MUTE }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__MUTED_MEMBERS__TITLE }),
                accordionComponent: function () { return React__default.createElement(MutedMemberList, { renderUserListItem: renderUserListItem }); },
            },
            bannedUsers: {
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.BAN }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__BANNED_MEMBERS__TITLE }),
                accordionComponent: function () { return React__default.createElement(BannedUserList, { renderUserListItem: renderUserListItem }); },
            },
            freezeChannel: {
                hideMenu: channel === null || channel === void 0 ? void 0 : channel.isBroadcast,
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.FREEZE }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__FREEZE_CHANNEL }),
                rightComponent: function () { return React__default.createElement(Toggle, { className: "sendbird-channel-settings__frozen-icon", checked: frozen, onChange: function () {
                        if (frozen) {
                            channel === null || channel === void 0 ? void 0 : channel.unfreeze().then(function () {
                                setFrozen(function (prev) { return !prev; });
                            });
                        }
                        else {
                            channel === null || channel === void 0 ? void 0 : channel.freeze().then(function () {
                                setFrozen(function (prev) { return !prev; });
                            });
                        }
                    } }); },
            },
        },
        nonOperator: {
            allUsers: {
                icon: __assign(__assign({}, commonIconProps), { type: IconTypes.MEMBERS }),
                label: __assign(__assign({}, commonLabelProps), { children: stringSet.CHANNEL_SETTING__MEMBERS__TITLE }),
                rightComponent: function (props) { return (React__default.createElement("div", { className: "sendbird-channel-settings__members" },
                    React__default.createElement(Badge, { count: (channel === null || channel === void 0 ? void 0 : channel.memberCount) ? useMenuList_kFormatter(channel.memberCount) : '' }),
                    React__default.createElement(MenuItemAction, __assign({}, props)))); },
                accordionComponent: function () { return React__default.createElement(MemberList, { renderUserListItem: renderUserListItem }); },
            },
        }
    }); }, [channel === null || channel === void 0 ? void 0 : channel.url, frozen]);
};


//# sourceMappingURL=useMenuList.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings/components/ChannelSettingsUI.js

































































var ChannelSettingsUI_ChannelSettingsUI = function (props) {
    var _a;
    var _b = useChannelSettingsContext(), channel = _b.channel, invalidChannel = _b.invalidChannel, onCloseClick = _b.onCloseClick, loading = _b.loading;
    var _c = deleteNullish(props), _d = _c.renderHeader, renderHeader = _d === void 0 ? function (props) { return React__default.createElement(ChannelSettingsHeader, __assign({}, props)); } : _d, renderLeaveChannel = _c.renderLeaveChannel, renderChannelProfile = _c.renderChannelProfile, _e = _c.renderModerationPanel, renderModerationPanel = _e === void 0 ? function (props) { return React__default.createElement(MenuListByRole, __assign({}, props)); } : _e, renderPlaceholderError = _c.renderPlaceholderError, renderPlaceholderLoading = _c.renderPlaceholderLoading;
    var menuItems = useMenuItems();
    var state = useSendbirdStateContext();
    var _f = useState(false), showLeaveChannelModal = _f[0], setShowLeaveChannelModal = _f[1];
    var isOnline = (_a = state === null || state === void 0 ? void 0 : state.config) === null || _a === void 0 ? void 0 : _a.isOnline;
    var stringSet = useContext(LocalizationContext).stringSet;
    if (loading) {
        if (renderPlaceholderLoading)
            return renderPlaceholderLoading();
        return React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING });
    }
    var headerProps = { onCloseClick: onCloseClick };
    if (invalidChannel || !channel) {
        return (React__default.createElement("div", null,
            renderHeader(headerProps),
            React__default.createElement("div", null, renderPlaceholderError ? renderPlaceholderError() : React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG }))));
    }
    return (React__default.createElement(React__default.Fragment, null,
        renderHeader(headerProps),
        React__default.createElement("div", { className: "sendbird-channel-settings__scroll-area" },
            (renderChannelProfile === null || renderChannelProfile === void 0 ? void 0 : renderChannelProfile()) || React__default.createElement(ChannelProfile, null), renderModerationPanel === null || renderModerationPanel === void 0 ? void 0 :
            renderModerationPanel({ menuItems: menuItems }),
            (renderLeaveChannel === null || renderLeaveChannel === void 0 ? void 0 : renderLeaveChannel()) || (React__default.createElement(MenuItem, { className: classnames(!isOnline ? 'sendbird-channel-settings__panel-item__disabled' : '', 'sendbird-channel-settings__panel-item__leave-channel'), onKeyDown: function () {
                    if (!isOnline)
                        return;
                    setShowLeaveChannelModal(true);
                }, onClick: function () {
                    if (!isOnline)
                        return;
                    setShowLeaveChannelModal(true);
                }, renderLeft: function () { return (React__default.createElement(Icon, { className: ['sendbird-channel-settings__panel-icon-left', 'sendbird-channel-settings__panel-icon__leave'].join(' '), type: IconTypes.LEAVE, fillColor: IconColors.ERROR, height: "24px", width: "24px" })); }, renderMiddle: function () { return (React__default.createElement(Label, { type: LabelTypography.SUBTITLE_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.CHANNEL_SETTING__LEAVE_CHANNEL__TITLE)); } })),
            showLeaveChannelModal && (React__default.createElement(LeaveChannel, { onCancel: function () {
                    setShowLeaveChannelModal(false);
                }, onSubmit: function () {
                    setShowLeaveChannelModal(false);
                    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
                } })))));
};


//# sourceMappingURL=ChannelSettingsUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ChannelSettings.js


































































var ChannelSettings_ChannelSettings = function (props) {
    return (React__default.createElement(ChannelSettingsProvider, __assign({}, props),
        React__default.createElement(ChannelSettingsUI, __assign({}, props))));
};


//# sourceMappingURL=ChannelSettings.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/MessageSearch/context.js





var GET_SEARCHED_MESSAGES = 'GET_SEARCHED_MESSAGES';
var GET_NEXT_SEARCHED_MESSAGES = 'GET_NEXT_SEARCHED_MESSAGES';
var START_MESSAGE_SEARCH = 'START_MESSAGE_SEARCH';
var START_GETTING_SEARCHED_MESSAGES = 'START_GETTING_SEARCHED_MESSAGES';
var SET_QUERY_INVALID = 'SET_QUERY_INVALID';
var context_SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var CHANNEL_INVALID = 'CHANNEL_INVALID';
var RESET_SEARCH_STRING = 'RESET_SEARCH_STRING';

function context_reducer(state, action) {
    switch (action.type) {
        case context_SET_CURRENT_CHANNEL: {
            var currentChannel = action.payload;
            return __assign(__assign({}, state), { currentChannel: currentChannel, initialized: true });
        }
        case CHANNEL_INVALID: {
            return __assign(__assign({}, state), { currentChannel: null, initialized: false });
        }
        case GET_SEARCHED_MESSAGES: {
            var _a = action.payload, messages = _a.messages, createdQuery = _a.createdQuery;
            if (createdQuery
                && createdQuery.channelUrl === (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).channelUrl
                && createdQuery.key === (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).key) {
                return __assign(__assign({}, state), { loading: false, isInvalid: false, allMessages: __spreadArray([], messages, true), hasMoreResult: (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).hasNext });
            }
            return __assign({}, state);
        }
        case SET_QUERY_INVALID: {
            return __assign(__assign({}, state), { isInvalid: true });
        }
        case START_MESSAGE_SEARCH: {
            return __assign(__assign({}, state), { isInvalid: false, loading: false });
        }
        case START_GETTING_SEARCHED_MESSAGES: {
            var currentMessageSearchQuery = action.payload;
            return __assign(__assign({}, state), { loading: true, currentMessageSearchQuery: currentMessageSearchQuery });
        }
        case GET_NEXT_SEARCHED_MESSAGES: {
            var messages = action.payload;
            return __assign(__assign({}, state), { allMessages: __spreadArray(__spreadArray([], state.allMessages, true), messages, true), hasMoreResult: (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).hasNext });
        }
        case RESET_SEARCH_STRING: {
            return __assign(__assign({}, state), { allMessages: [] });
        }
        default: {
            return state;
        }
    }
}

var MessageSearch_context_initialState = {
    allMessages: [],
    loading: false,
    isInvalid: false,
    initialized: false,
    currentChannel: null,
    currentMessageSearchQuery: null,
    hasMoreResult: false,
};

function useSetChannel(_a, _b) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit;
    var sdk = _b.sdk, logger = _b.logger, messageSearchDispatcher = _b.messageSearchDispatcher;
    useEffect(function () {
        if (channelUrl && sdkInit && (sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel)) {
            sdk.groupChannel.getChannel(channelUrl).then(function (groupChannel) {
                logger.info('MessageSearch | useSetChannel group channel', groupChannel);
                messageSearchDispatcher({
                    type: context_SET_CURRENT_CHANNEL,
                    payload: groupChannel,
                });
            }).catch(function () {
                messageSearchDispatcher({
                    type: CHANNEL_INVALID,
                    payload: null,
                });
            });
        }
    }, [channelUrl, sdkInit]);
}

var MessageSearchOrder;
(function (MessageSearchOrder) {
    MessageSearchOrder["SCORE"] = "score";
    MessageSearchOrder["TIMESTAMP"] = "ts";
})(MessageSearchOrder || (MessageSearchOrder = {}));
function useGetSearchedMessages(_a, _b) {
    var currentChannel = _a.currentChannel, channelUrl = _a.channelUrl, requestString = _a.requestString, messageSearchQuery = _a.messageSearchQuery, onResultLoaded = _a.onResultLoaded, retryCount = _a.retryCount;
    var sdk = _b.sdk, logger = _b.logger, messageSearchDispatcher = _b.messageSearchDispatcher;
    useEffect(function () {
        messageSearchDispatcher({
            type: START_MESSAGE_SEARCH,
            payload: null,
        });
        if (sdk && channelUrl && sdk.createMessageSearchQuery && currentChannel) {
            if (requestString) {
                currentChannel.refresh()
                    .then(function (channel) {
                    var inputSearchMessageQueryObject = __assign({ order: MessageSearchOrder.TIMESTAMP, channelUrl: channelUrl, messageTimestampFrom: channel.invitedAt, keyword: requestString }, messageSearchQuery);
                    var createdQuery = sdk.createMessageSearchQuery(inputSearchMessageQueryObject);
                    createdQuery.next().then(function (messages) {
                        logger.info('MessageSearch | useGetSearchedMessages: succeeded getting messages', messages);
                        messageSearchDispatcher({
                            type: GET_SEARCHED_MESSAGES,
                            payload: {
                                messages: messages,
                                createdQuery: createdQuery,
                            },
                        });
                        if (onResultLoaded && typeof onResultLoaded === 'function') {
                            onResultLoaded(messages, undefined);
                        }
                    }).catch(function (error) {
                        logger.warning('MessageSearch | useGetSearchedMessages: failed getting search messages.', error);
                        messageSearchDispatcher({
                            type: SET_QUERY_INVALID,
                            payload: null,
                        });
                        if (onResultLoaded && typeof onResultLoaded === 'function') {
                            onResultLoaded(undefined, error);
                        }
                    });
                    messageSearchDispatcher({
                        type: START_GETTING_SEARCHED_MESSAGES,
                        payload: createdQuery,
                    });
                })
                    .catch(function (error) {
                    logger.warning('MessageSearch | useGetSearchedMessages: failed getting channel.', error);
                    messageSearchDispatcher({
                        type: SET_QUERY_INVALID,
                        payload: null,
                    });
                    if (onResultLoaded && typeof onResultLoaded === 'function') {
                        onResultLoaded(undefined, error);
                    }
                });
            }
            else {
                logger.info('MessageSearch | useGetSeasrchedMessages: search string is empty');
            }
        }
    }, [channelUrl, messageSearchQuery, requestString, currentChannel, retryCount]);
}

function context_useScrollCallback(_a, _b) {
    var currentMessageSearchQuery = _a.currentMessageSearchQuery, hasMoreResult = _a.hasMoreResult, onResultLoaded = _a.onResultLoaded;
    var logger = _b.logger, messageSearchDispatcher = _b.messageSearchDispatcher;
    return useCallback(function (cb) {
        if (!hasMoreResult) {
            logger.warning('MessageSearch | useScrollCallback: no more searched results', hasMoreResult);
        }
        if (currentMessageSearchQuery && currentMessageSearchQuery.hasNext) {
            currentMessageSearchQuery
                .next()
                .then(function (messages) {
                logger.info('MessageSearch | useScrollCallback: succeeded getting searched messages', messages);
                messageSearchDispatcher({
                    type: GET_NEXT_SEARCHED_MESSAGES,
                    payload: messages,
                });
                cb(messages, null);
                if (onResultLoaded && typeof onResultLoaded === 'function') {
                    onResultLoaded(messages, null);
                }
            })
                .catch(function (error) {
                logger.warning('MessageSearch | useScrollCallback: failed getting searched messages', error);
                cb(null, error);
                if (onResultLoaded && typeof onResultLoaded === 'function') {
                    onResultLoaded(null, error);
                }
            });
        }
        else {
            logger.warning('MessageSearch | useScrollCallback: no currentMessageSearchQuery');
        }
    }, [currentMessageSearchQuery, hasMoreResult]);
}

var DEBOUNCING_TIME = 500;
function useSearchStringEffect(_a, _b) {
    var searchString = _a.searchString;
    var messageSearchDispatcher = _b.messageSearchDispatcher;
    var _c = useState(''), requestString = _c[0], setRequestString = _c[1];
    var _d = useState(null), debouncingTimer = _d[0], setDebouncingTimer = _d[1];
    useEffect(function () {
        clearTimeout(debouncingTimer !== null && debouncingTimer !== void 0 ? debouncingTimer : undefined);
        if (searchString) {
            setDebouncingTimer(setTimeout(function () {
                setRequestString(searchString);
            }, DEBOUNCING_TIME));
        }
        else {
            setRequestString('');
            messageSearchDispatcher({
                type: RESET_SEARCH_STRING,
                payload: '',
            });
        }
    }, [searchString]);
    return requestString;
}

var MessageSearchContext = react.createContext(null);
var context_MessageSearchProvider = function (props) {
    var _a, _b, _c, _d, _e;
    var 
    // message search props
    channelUrl = props.channelUrl, searchString = props.searchString, messageSearchQuery = props.messageSearchQuery, onResultLoaded = props.onResultLoaded, onResultClick = props.onResultClick;
    var globalState = useSendbirdStateContext();
    // hook variables
    var _f = useState(0), retryCount = _f[0], setRetryCount = _f[1]; // this is a trigger flag for activating useGetSearchMessages
    var _g = useState(0), selectedMessageId = _g[0], setSelectedMessageId = _g[1];
    var _h = useReducer(context_reducer, MessageSearch_context_initialState), messageSearchStore = _h[0], messageSearchDispatcher = _h[1];
    var allMessages = messageSearchStore.allMessages, loading = messageSearchStore.loading, isInvalid = messageSearchStore.isInvalid, currentChannel = messageSearchStore.currentChannel, currentMessageSearchQuery = messageSearchStore.currentMessageSearchQuery, hasMoreResult = messageSearchStore.hasMoreResult;
    var logger = (_a = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _a === void 0 ? void 0 : _a.logger;
    var sdk = (_c = (_b = globalState === null || globalState === void 0 ? void 0 : globalState.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.sdk;
    var sdkInit = (_e = (_d = globalState === null || globalState === void 0 ? void 0 : globalState.stores) === null || _d === void 0 ? void 0 : _d.sdkStore) === null || _e === void 0 ? void 0 : _e.initialized;
    var scrollRef = useRef(null);
    var handleOnScroll = function (e) {
        var scrollElement = e.target;
        var scrollTop = scrollElement.scrollTop, scrollHeight = scrollElement.scrollHeight, clientHeight = scrollElement.clientHeight;
        if (!hasMoreResult) {
            return;
        }
        if (scrollTop + clientHeight >= scrollHeight) {
            onScroll(function () {
                // after load more searched messages
            });
        }
    };
    useSetChannel({ channelUrl: channelUrl, sdkInit: sdkInit }, { sdk: sdk, logger: logger, messageSearchDispatcher: messageSearchDispatcher });
    var requestString = useSearchStringEffect({ searchString: searchString !== null && searchString !== void 0 ? searchString : '' }, { messageSearchDispatcher: messageSearchDispatcher });
    useGetSearchedMessages({ currentChannel: currentChannel, channelUrl: channelUrl, requestString: requestString, messageSearchQuery: messageSearchQuery, onResultLoaded: onResultLoaded, retryCount: retryCount }, { sdk: sdk, logger: logger, messageSearchDispatcher: messageSearchDispatcher });
    var onScroll = context_useScrollCallback({ currentMessageSearchQuery: currentMessageSearchQuery, hasMoreResult: hasMoreResult, onResultLoaded: onResultLoaded }, { logger: logger, messageSearchDispatcher: messageSearchDispatcher });
    var handleRetryToConnect = function () {
        setRetryCount(retryCount + 1);
    };
    return (React__default.createElement(MessageSearchContext.Provider, { value: {
            channelUrl: channelUrl,
            searchString: searchString,
            requestString: requestString,
            messageSearchQuery: messageSearchQuery,
            onResultLoaded: onResultLoaded,
            onResultClick: onResultClick,
            retryCount: retryCount,
            setRetryCount: setRetryCount,
            selectedMessageId: selectedMessageId,
            setSelectedMessageId: setSelectedMessageId,
            messageSearchDispatcher: messageSearchDispatcher,
            allMessages: allMessages,
            loading: loading,
            isInvalid: isInvalid,
            currentChannel: currentChannel,
            currentMessageSearchQuery: currentMessageSearchQuery,
            hasMoreResult: hasMoreResult,
            onScroll: onScroll,
            scrollRef: scrollRef,
            handleRetryToConnect: handleRetryToConnect,
            handleOnScroll: handleOnScroll,
        } }, props === null || props === void 0 ? void 0 : props.children));
};
var context_useMessageSearchContext = function () {
    var context = React__default.useContext(MessageSearchContext);
    if (!context)
        throw new Error('MessageSearchContext not found. Use within the MessageSearch module.');
    return context;
};


//# sourceMappingURL=context.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageSearchItem.js















// getCreatedAt
function getCreatedAt (_a) {
    var createdAt = _a.createdAt, locale = _a.locale, stringSet = _a.stringSet;
    var optionalParam = { locale: locale };
    if (!createdAt) {
        return '';
    }
    if (isToday(createdAt)) {
        return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__TODAY, optionalParam);
    }
    if (isYesterday(createdAt)) {
        return stringSet.MESSAGE_STATUS__YESTERDAY;
    }
    if (isThisYear(createdAt)) {
        return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__THIS_YEAR, optionalParam);
    }
    return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__PREVIOUS_YEAR, optionalParam);
}

function MessageSearchItem_MessageSearchItem(_a) {
    var className = _a.className, message = _a.message, selected = _a.selected, onClick = _a.onClick;
    var createdAt = message.createdAt;
    var messageText = message.message;
    // @ts-ignore
    var sender = message.sender || message._sender;
    var profileUrl = sender.profileUrl, nickname = sender.nickname;
    var _b = useLocalization(), stringSet = _b.stringSet, dateLocale = _b.dateLocale;
    return (React__default.createElement("div", { className: __spreadArray(__spreadArray([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-message-search-item',
            selected ? 'sendbird-message-search-item--selected' : '',
        ], false).join(' '), onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(message);
        } },
        React__default.createElement("div", { className: "sendbird-message-search-item__left" },
            React__default.createElement(Avatar, { className: "sendbird-message-search-item__left__sender-avatar", src: profileUrl, alt: "profile image", width: "56px", height: "56px" })),
        React__default.createElement("div", { className: "sendbird-message-search-item__right" },
            React__default.createElement(Label, { className: "sendbird-message-search-item__right__sender-name", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_1 }, nickname || stringSet.NO_NAME),
            React__default.createElement(Label, { className: "sendbird-message-search-item__right__message-text", type: LabelTypography.BODY_2, color: LabelColors.ONBACKGROUND_3 }, messageText),
            React__default.createElement(Label, { className: "sendbird-message-search-item__right__message-created-at", type: LabelTypography.CAPTION_3, color: LabelColors.ONBACKGROUND_2 }, getCreatedAt({ createdAt: createdAt, locale: dateLocale, stringSet: stringSet }))),
        React__default.createElement("div", { className: "sendbird-message-search-item__right-footer" })));
}


//# sourceMappingURL=MessageSearchItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/MessageSearchFileItem.js





















function MessageSearchFileItem_getCreatedAt(_a) {
    var createdAt = _a.createdAt, locale = _a.locale, stringSet = _a.stringSet;
    var optionalParam = { locale: locale };
    if (!createdAt) {
        return '';
    }
    if (isToday(createdAt)) {
        return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__TODAY, optionalParam);
    }
    if (isYesterday(createdAt)) {
        return stringSet.MESSAGE_STATUS__YESTERDAY;
    }
    if (isThisYear(createdAt)) {
        return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__THIS_YEAR, optionalParam);
    }
    return format(createdAt, stringSet.DATE_FORMAT__LAST_MESSAGE_CREATED_AT__PREVIOUS_YEAR, optionalParam);
}
function getIconOfFileType(message) {
    var _a, _b, _c;
    var fileMessageUrl = (_a = getMessageFirstFileUrl(message)) !== null && _a !== void 0 ? _a : '';
    var fileExtension = (_c = (_b = (fileMessageUrl.match(/\.([^.]*?)(?=\?|#|$)/))) === null || _b === void 0 ? void 0 : _b[1]) !== null && _c !== void 0 ? _c : '';
    if (/(jpg|jpeg|png)$/i.test(fileExtension)) {
        return IconTypes.PHOTO;
    }
    else if (/mp4$/i.test(fileExtension) || isVoiceMessage(message)) {
        return IconTypes.PLAY;
    }
    else if (/mp3/i.test(fileExtension)) {
        return IconTypes.FILE_AUDIO;
    }
    else if (/gif/i.test(fileExtension)) {
        return IconTypes.GIF;
    }
    else {
        return IconTypes.FILE_DOCUMENT;
    }
}

function MessageSearchFileItem_MessageSearchFileItem(props) {
    var className = props.className, message = props.message, selected = props.selected, onClick = props.onClick;
    var createdAt = message.createdAt;
    var url = getMessageFirstFileUrl(message);
    var name = getMessageFirstFileName(message);
    // @ts-ignore
    var sender = message.sender || message._sender;
    var profileUrl = sender.profileUrl, nickname = sender.nickname;
    var _a = useLocalization(), stringSet = _a.stringSet, dateLocale = _a.dateLocale;
    var isVoiceMsg = isVoiceMessage(message);
    var prettyFilename = isVoiceMsg ? stringSet.VOICE_MESSAGE : (name || url);
    return (React__default.createElement("div", { className: __spreadArray(__spreadArray([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-message-search-file-item',
            selected ? 'sendbird-message-search-file-item--selected' : '',
        ], false).join(' '), onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(message);
        } },
        React__default.createElement("div", { className: "sendbird-message-search-file-item__left" },
            React__default.createElement(Avatar, { className: "sendbird-message-search-file-item__left__sender-avatar", src: profileUrl, alt: "profile image", width: "56px", height: "56px" })),
        React__default.createElement("div", { className: "sendbird-message-search-file-item__right" },
            React__default.createElement(Label, { className: "sendbird-message-search-file-item__right__sender-name", type: LabelTypography.SUBTITLE_2, color: LabelColors.ONBACKGROUND_1 }, nickname || stringSet.NO_NAME),
            React__default.createElement("div", { className: "sendbird-message-search-file-item__right__content" },
                !isVoiceMsg && (React__default.createElement("div", { className: 'sendbird-message-search-file-item__right__content__type-icon' },
                    React__default.createElement(Icon, { type: getIconOfFileType(message), fillColor: IconColors.PRIMARY, width: "18px", height: "18px" }))),
                React__default.createElement(Label, { className: "sendbird-message-search-file-item__right__content__url", type: LabelTypography.BODY_2, color: LabelColors.ONBACKGROUND_1 }, prettyFilename))),
        React__default.createElement(Label, { className: "sendbird-message-search-file-item__message-created-at", type: LabelTypography.CAPTION_3, color: LabelColors.ONBACKGROUND_2 }, MessageSearchFileItem_getCreatedAt({ createdAt: createdAt, locale: dateLocale, stringSet: stringSet })),
        React__default.createElement("div", { className: "sendbird-message-search-file-item__right-footer" })));
}


//# sourceMappingURL=MessageSearchFileItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/MessageSearch/components/MessageSearchUI.js




























var MessageSearchUI_MessageSearchUI = function (_a) {
    var renderPlaceHolderError = _a.renderPlaceHolderError, renderPlaceHolderLoading = _a.renderPlaceHolderLoading, renderPlaceHolderNoString = _a.renderPlaceHolderNoString, renderPlaceHolderEmptyList = _a.renderPlaceHolderEmptyList, renderSearchItem = _a.renderSearchItem;
    var _b = useMessageSearchContext(), isInvalid = _b.isInvalid, searchString = _b.searchString, requestString = _b.requestString, currentChannel = _b.currentChannel, retryCount = _b.retryCount, setRetryCount = _b.setRetryCount, loading = _b.loading, scrollRef = _b.scrollRef, hasMoreResult = _b.hasMoreResult, onScroll = _b.onScroll, allMessages = _b.allMessages, onResultClick = _b.onResultClick, selectedMessageId = _b.selectedMessageId, setSelectedMessageId = _b.setSelectedMessageId;
    var stringSet = useContext(LocalizationContext).stringSet;
    var handleRetryToConnect = function () {
        setRetryCount(retryCount + 1);
    };
    var handleOnScroll = function (e) {
        var scrollElement = e.target;
        var scrollTop = scrollElement.scrollTop, scrollHeight = scrollElement.scrollHeight, clientHeight = scrollElement.clientHeight;
        if (!hasMoreResult) {
            return;
        }
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            onScroll(function () {
                // after load more searched messages
            });
        }
    };
    var getChannelName = function () {
        if (currentChannel && (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.name) && (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.name) !== 'Group Channel') {
            return currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.name;
        }
        if (currentChannel && ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.name) === 'Group Channel' || !(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.name))) {
            return currentChannel.members.map(function (member) { return member.nickname || stringSet.NO_NAME; }).join(', ');
        }
        return stringSet.NO_TITLE;
    };
    if (isInvalid && searchString && requestString) {
        return (renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError()) || (React__default.createElement("div", { className: "sendbird-message-search" },
            React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG, retryToConnect: handleRetryToConnect })));
    }
    if (loading && searchString && requestString) {
        return (renderPlaceHolderLoading === null || renderPlaceHolderLoading === void 0 ? void 0 : renderPlaceHolderLoading()) || (React__default.createElement("div", { className: "sendbird-message-search" },
            React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.SEARCHING })));
    }
    if (!searchString) {
        return (renderPlaceHolderNoString === null || renderPlaceHolderNoString === void 0 ? void 0 : renderPlaceHolderNoString()) || (React__default.createElement("div", { className: "sendbird-message-search" },
            React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.SEARCH_IN, searchInString: getChannelName() })));
    }
    return (React__default.createElement("div", { className: "sendbird-message-search", onScroll: handleOnScroll, ref: scrollRef }, (allMessages.length > 0)
        ? (allMessages.map(function (message) {
            if (renderSearchItem) {
                return renderSearchItem({ message: message, onResultClick: onResultClick });
            }
            if (message.messageType === 'file') {
                return (React__default.createElement(MessageSearchFileItem, { className: "sendbird-message-search__message-search-item", message: message, key: message.messageId, selected: (selectedMessageId === message.messageId), onClick: function () {
                        onResultClick === null || onResultClick === void 0 ? void 0 : onResultClick(message);
                        setSelectedMessageId(message.messageId);
                    } }));
            }
            return (React__default.createElement(MessageSearchItem, { className: "sendbird-message-search__message-search-item", message: message, key: message.messageId, selected: (selectedMessageId === message.messageId), onClick: function () {
                    onResultClick === null || onResultClick === void 0 ? void 0 : onResultClick(message);
                    setSelectedMessageId(message.messageId);
                } }));
        }))
        : (renderPlaceHolderEmptyList === null || renderPlaceHolderEmptyList === void 0 ? void 0 : renderPlaceHolderEmptyList()) || (React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.NO_RESULTS }))));
};


//# sourceMappingURL=MessageSearchUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/MessageSearch.js


































function MessageSearch_MessageSearchPannel(props) {
    var channelUrl = props.channelUrl, onResultClick = props.onResultClick, onCloseClick = props.onCloseClick, messageSearchQuery = props.messageSearchQuery, renderPlaceHolderError = props.renderPlaceHolderError, renderPlaceHolderLoading = props.renderPlaceHolderLoading, renderPlaceHolderNoString = props.renderPlaceHolderNoString, renderPlaceHolderEmptyList = props.renderPlaceHolderEmptyList, renderSearchItem = props.renderSearchItem;
    var _a = useState(''), searchString = _a[0], setSearchString = _a[1];
    var _b = useState(''), inputString = _b[0], setInputString = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var stringSet = useContext(LocalizationContext).stringSet;
    var timeout = null;
    useEffect(function () {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            setSearchString(inputString);
            setLoading(true);
            timeout = null;
        }, 500);
    }, [inputString]);
    var handleOnChangeInputString = function (e) {
        setInputString(e.target.value);
    };
    var handleOnResultLoaded = function () {
        setLoading(false);
    };
    var handleOnClickResetStringButton = function (e) {
        e.stopPropagation();
        setInputString('');
        setSearchString('');
    };
    return (React__default.createElement("div", { className: "sendbird-message-search-pannel" },
        React__default.createElement(Header, { className: "sendbird-message-search-pannel__header", renderMiddle: function () { return (React__default.createElement(Header.Title, { title: stringSet.SEARCH_IN_CHANNEL })); }, renderRight: function () { return (React__default.createElement(Header.IconButton, { className: "sendbird-message-search-pannel__header__close-button", onClick: onCloseClick, type: IconTypes.CLOSE, color: IconColors.ON_BACKGROUND_1 })); } }),
        React__default.createElement("div", { className: "sendbird-message-search-pannel__input" },
            React__default.createElement("div", { className: "sendbird-message-search-pannel__input__container" },
                React__default.createElement(Icon, { className: "sendbird-message-search-pannel__input__container__search-icon", type: IconTypes.SEARCH, fillColor: IconColors.ON_BACKGROUND_3, width: "24px", height: "24px" }),
                React__default.createElement("input", { className: "sendbird-message-search-pannel__input__container__input-area", placeholder: stringSet.SEARCH, value: inputString, onChange: handleOnChangeInputString }),
                inputString && loading && (React__default.createElement(Loader, { className: "sendbird-message-search-pannel__input__container__spinner", width: "20px", height: "20px" },
                    React__default.createElement(Icon, { type: IconTypes.SPINNER, fillColor: IconColors.PRIMARY, width: "20px", height: "20px" }))),
                !loading && inputString && (React__default.createElement(Icon, { className: "sendbird-message-search-pannel__input__container__reset-input-button", type: IconTypes.REMOVE, fillColor: IconColors.ON_BACKGROUND_3, width: "20px", height: "20px", onClick: handleOnClickResetStringButton })))),
        React__default.createElement("div", { className: "sendbird-message-search-pannel__message-search" },
            React__default.createElement(MessageSearchProvider, { channelUrl: channelUrl, searchString: searchString, onResultClick: onResultClick, onResultLoaded: handleOnResultLoaded, messageSearchQuery: messageSearchQuery },
                React__default.createElement(MessageSearchUI, { renderPlaceHolderError: renderPlaceHolderError, renderPlaceHolderLoading: renderPlaceHolderLoading, renderPlaceHolderNoString: renderPlaceHolderNoString, renderPlaceHolderEmptyList: renderPlaceHolderEmptyList, renderSearchItem: renderSearchItem })))));
}


//# sourceMappingURL=MessageSearch.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread.js
var uikit_react_Thread = __webpack_require__(29205);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/context.js
var GroupChannel_context = __webpack_require__(27165);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/GroupChannelUI.js
var GroupChannelUI = __webpack_require__(48580);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/GroupChannelHeader.js
var GroupChannelHeader = __webpack_require__(24782);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/MessageList.js
var components_MessageList = __webpack_require__(84492);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/Message.js
var components_Message = __webpack_require__(61284);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/FileViewer.js
var components_FileViewer = __webpack_require__(41593);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/RemoveMessageModal.js
var components_RemoveMessageModal = __webpack_require__(53346);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/GroupChannel/components/MessageInputWrapper.js
var components_MessageInputWrapper = __webpack_require__(1195);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/context.js + 1 modules
var Thread_context = __webpack_require__(31723);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/context/types.js
var types = __webpack_require__(53474);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadUI.js
var ThreadUI = __webpack_require__(40287);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ParentMessageInfo.js
var ParentMessageInfo = __webpack_require__(33116);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BkDHtL7_.js
var bundle_BkDHtL7_ = __webpack_require__(24354);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ParentMessageInfoItem.js
var ParentMessageInfoItem = __webpack_require__(5806);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-CXPOT202.js
var bundle_CXPOT202 = __webpack_require__(41519);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BdZX50Kw.js
var bundle_BdZX50Kw = __webpack_require__(88221);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadHeader.js
var ThreadHeader = __webpack_require__(95137);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadList.js + 5 modules
var ThreadList = __webpack_require__(61029);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadListItem.js
var ThreadListItem = __webpack_require__(5591);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Thread/components/ThreadMessageInput.js
var ThreadMessageInput = __webpack_require__(38506);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/Channel/hooks/useHandleUploadFiles.js
var useHandleUploadFiles = __webpack_require__(73459);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/App.js






























































































































































































































var DesktopLayout = function (props) {
    var isReactionEnabled = props.isReactionEnabled, replyType = props.replyType, isMessageGroupingEnabled = props.isMessageGroupingEnabled, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, allowProfileEdit = props.allowProfileEdit, showSearchIcon = props.showSearchIcon, onProfileEditSuccess = props.onProfileEditSuccess, disableAutoSelect = props.disableAutoSelect, currentChannel = props.currentChannel, setCurrentChannel = props.setCurrentChannel, showSettings = props.showSettings, setShowSettings = props.setShowSettings, showSearch = props.showSearch, setShowSearch = props.setShowSearch, highlightedMessage = props.highlightedMessage, setHighlightedMessage = props.setHighlightedMessage, startingPoint = props.startingPoint, setStartingPoint = props.setStartingPoint, showThread = props.showThread, setShowThread = props.setShowThread, threadTargetMessage = props.threadTargetMessage, setThreadTargetMessage = props.setThreadTargetMessage, enableLegacyChannelModules = props.enableLegacyChannelModules;
    var updateFocusedChannel = function (channel) {
        setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(null);
        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null);
        if (channel) {
            setCurrentChannel(channel);
        }
        else {
            setCurrentChannel(undefined);
        }
    };
    var onClickThreadReply = function (_a) {
        var message = _a.message;
        // parent message
        setShowSettings(false);
        setShowSearch(false);
        if (replyType === 'THREAD') {
            setThreadTargetMessage(message);
            setShowThread(true);
        }
    };
    var channelListProps = {
        allowProfileEdit: allowProfileEdit,
        activeChannelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url,
        onProfileEditSuccess: onProfileEditSuccess,
        disableAutoSelect: disableAutoSelect,
        onChannelSelect: updateFocusedChannel,
        // for GroupChannelList
        selectedChannelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url,
        onChannelCreated: updateFocusedChannel,
        onUserProfileUpdated: onProfileEditSuccess,
    };
    var channelProps = {
        channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
        onChatHeaderActionClick: function () {
            setShowSearch(false);
            setShowThread(false);
            setShowSettings(!showSettings);
        },
        onSearchClick: function () {
            setShowSettings(false);
            setShowThread(false);
            setShowSearch(!showSearch);
        },
        onReplyInThread: onClickThreadReply,
        onQuoteMessageClick: function (_a) {
            var message = _a.message;
            // thread message
            setShowSettings(false);
            setShowSearch(false);
            if (replyType === 'THREAD') {
                setThreadTargetMessage(message);
                setShowThread(true);
            }
        },
        animatedMessage: highlightedMessage,
        onMessageAnimated: function () { return setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null); },
        showSearchIcon: showSearchIcon,
        startingPoint: startingPoint !== null && startingPoint !== void 0 ? startingPoint : undefined,
        isReactionEnabled: isReactionEnabled,
        replyType: replyType,
        isMessageGroupingEnabled: isMessageGroupingEnabled,
        isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled,
        // for GroupChannel
        animatedMessageId: highlightedMessage,
        onReplyInThreadClick: onClickThreadReply,
    };
    return (React__default.createElement("div", { className: "sendbird-app__wrap", id: APP_LAYOUT_ROOT },
        React__default.createElement("div", { className: "sendbird-app__channellist-wrap" }, enableLegacyChannelModules ? React__default.createElement(ChannelList, __assign({}, channelListProps)) : React__default.createElement(GroupChannelList, __assign({}, channelListProps))),
        React__default.createElement("div", { className: classnames('sendbird-app__conversation-wrap', showSettings && 'sendbird-app__conversation--settings-open', showSearch && 'sendbird-app__conversation--search-open') }, enableLegacyChannelModules ? React__default.createElement(Channel, __assign({}, channelProps)) : React__default.createElement(GroupChannel, __assign({}, channelProps))),
        showSettings && (React__default.createElement("div", { className: "sendbird-app__settingspanel-wrap" },
            React__default.createElement(ChannelSettings, { className: "sendbird-channel-settings", channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', onCloseClick: function () {
                    setShowSettings(false);
                } }))),
        showSearch && (React__default.createElement("div", { className: "sendbird-app__searchpanel-wrap" },
            React__default.createElement(MessageSearchPannel, { channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', onResultClick: function (message) {
                    if (message.messageId === highlightedMessage) {
                        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null);
                        setTimeout(function () {
                            setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(message.messageId);
                        });
                    }
                    else {
                        setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(message.createdAt);
                        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(message.messageId);
                    }
                }, onCloseClick: function () {
                    setShowSearch(false);
                } }))),
        showThread && (React__default.createElement(Thread, { className: "sendbird-app__thread", channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', message: threadTargetMessage, onHeaderActionClick: function () {
                setShowThread(false);
            }, onMoveToParentMessage: function (_a) {
                var message = _a.message, channel = _a.channel;
                if ((channel === null || channel === void 0 ? void 0 : channel.url) !== (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
                    setCurrentChannel(channel);
                }
                if ((message === null || message === void 0 ? void 0 : message.messageId) !== highlightedMessage) {
                    setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(message === null || message === void 0 ? void 0 : message.createdAt);
                }
                setTimeout(function () {
                    setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(null);
                    setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(message === null || message === void 0 ? void 0 : message.messageId);
                }, 500);
            } }))));
};

var PANELS;
(function (PANELS) {
    PANELS["CHANNEL_LIST"] = "CHANNEL_LIST";
    PANELS["CHANNEL"] = "CHANNEL";
    PANELS["CHANNEL_SETTINGS"] = "CHANNEL_SETTINGS";
    PANELS["MESSAGE_SEARCH"] = "MESSAGE_SEARCH";
    PANELS["THREAD"] = "THREAD";
})(PANELS || (PANELS = {}));
var MobileLayout = function (props) {
    var _a, _b, _c;
    var replyType = props.replyType, isMessageGroupingEnabled = props.isMessageGroupingEnabled, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, allowProfileEdit = props.allowProfileEdit, isReactionEnabled = props.isReactionEnabled, showSearchIcon = props.showSearchIcon, onProfileEditSuccess = props.onProfileEditSuccess, currentChannel = props.currentChannel, setCurrentChannel = props.setCurrentChannel, startingPoint = props.startingPoint, setStartingPoint = props.setStartingPoint, threadTargetMessage = props.threadTargetMessage, setThreadTargetMessage = props.setThreadTargetMessage, highlightedMessage = props.highlightedMessage, setHighlightedMessage = props.setHighlightedMessage, enableLegacyChannelModules = props.enableLegacyChannelModules;
    var _d = useState(PANELS.CHANNEL_LIST), panel = _d[0], setPanel = _d[1];
    var store = useSendbirdStateContext();
    var sdk = (_b = (_a = store === null || store === void 0 ? void 0 : store.stores) === null || _a === void 0 ? void 0 : _a.sdkStore) === null || _b === void 0 ? void 0 : _b.sdk;
    var userId = (_c = store === null || store === void 0 ? void 0 : store.config) === null || _c === void 0 ? void 0 : _c.userId;
    var pause = useVoicePlayerContext().pause;
    var goToMessage = function (message, timeoutCb) {
        setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint((message === null || message === void 0 ? void 0 : message.createdAt) || null);
        setTimeout(function () {
            timeoutCb === null || timeoutCb === void 0 ? void 0 : timeoutCb((message === null || message === void 0 ? void 0 : message.messageId) || null);
        }, 500);
    };
    useEffect(function () {
        if (panel !== PANELS.CHANNEL) {
            goToMessage(null, function () { return setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null); });
        }
    }, [panel]);
    useEffect(function () {
        var _a, _b;
        var handlerId = uuidv4();
        if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler) {
            var handler = new GroupChannelHandler({
                onUserBanned: function (groupChannel, user) {
                    if (groupChannel.url === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === userId) {
                        setPanel(PANELS.CHANNEL_LIST);
                    }
                },
                onChannelDeleted: function (channelUrl) {
                    if (channelUrl === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
                        setPanel(PANELS.CHANNEL_LIST);
                    }
                },
                onUserLeft: function (groupChannel, user) {
                    if (groupChannel.url === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === userId) {
                        setPanel(PANELS.CHANNEL_LIST);
                    }
                },
            });
            (_b = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _b === void 0 ? void 0 : _b.addGroupChannelHandler(handlerId, handler);
        }
        return function () {
            var _a, _b;
            (_b = (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler) === null || _b === void 0 ? void 0 : _b.call(_a, handlerId);
        };
    }, [sdk, currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    // if currentChannel is changed while on Thread
    // then change panel type to CHANNEL
    useEffect(function () {
        if (panel === PANELS.THREAD) {
            setPanel(PANELS.CHANNEL);
        }
    }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
    var channelListProps = {
        allowProfileEdit: allowProfileEdit,
        onProfileEditSuccess: onProfileEditSuccess,
        disableAutoSelect: true,
        onChannelSelect: function (channel) {
            setCurrentChannel(channel !== null && channel !== void 0 ? channel : undefined);
            if (channel) {
                setPanel(PANELS.CHANNEL);
            }
            else {
                setPanel(PANELS.CHANNEL_LIST);
            }
        },
        // for GroupChannelList
        onChannelCreated: function (channel) {
            setCurrentChannel(channel);
            setPanel(PANELS.CHANNEL);
        },
        onUserProfileUpdated: onProfileEditSuccess,
    };
    var channelProps = {
        channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
        onChatHeaderActionClick: function () {
            setPanel(PANELS.CHANNEL_SETTINGS);
        },
        onBackClick: function () {
            setPanel(PANELS.CHANNEL_LIST);
            pause(ALL);
        },
        onSearchClick: function () {
            setPanel(PANELS.MESSAGE_SEARCH);
        },
        onReplyInThread: function (_a) {
            var message = _a.message;
            if (replyType === 'THREAD') {
                setPanel(PANELS.THREAD);
                setThreadTargetMessage(message);
            }
        },
        onQuoteMessageClick: function (_a) {
            var message = _a.message;
            // thread message
            if (replyType === 'THREAD') {
                setThreadTargetMessage(message);
                setPanel(PANELS.THREAD);
            }
        },
        animatedMessage: highlightedMessage,
        onMessageAnimated: function () { return setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null); },
        showSearchIcon: showSearchIcon,
        startingPoint: startingPoint !== null && startingPoint !== void 0 ? startingPoint : undefined,
        isReactionEnabled: isReactionEnabled,
        replyType: replyType,
        isMessageGroupingEnabled: isMessageGroupingEnabled,
        isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled,
        // for GroupChannel
        animatedMessageId: highlightedMessage,
        onReplyInThreadClick: function (_a) {
            var message = _a.message;
            if (replyType === 'THREAD') {
                setPanel(PANELS.THREAD);
                setThreadTargetMessage(message);
            }
        },
    };
    return (React__default.createElement("div", { className: "sb_mobile", id: APP_LAYOUT_ROOT },
        panel === PANELS.CHANNEL_LIST && (React__default.createElement("div", { className: "sb_mobile__panelwrap" }, enableLegacyChannelModules ? React__default.createElement(ChannelList, __assign({}, channelListProps)) : React__default.createElement(GroupChannelList, __assign({}, channelListProps)))),
        panel === PANELS.CHANNEL && (React__default.createElement("div", { className: "sb_mobile__panelwrap" }, enableLegacyChannelModules ? React__default.createElement(Channel, __assign({}, channelProps)) : React__default.createElement(GroupChannel, __assign({}, channelProps)))),
        panel === PANELS.CHANNEL_SETTINGS && (React__default.createElement("div", { className: "sb_mobile__panelwrap" },
            React__default.createElement(ChannelSettings, { channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', onCloseClick: function () {
                    setPanel(PANELS.CHANNEL);
                }, onLeaveChannel: function () {
                    setPanel(PANELS.CHANNEL_LIST);
                } }))),
        panel === PANELS.MESSAGE_SEARCH && (React__default.createElement("div", { className: "sb_mobile__panelwrap" },
            React__default.createElement(MessageSearchPannel, { channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', onCloseClick: function () {
                    setPanel(PANELS.CHANNEL);
                }, onResultClick: function (message) {
                    setPanel(PANELS.CHANNEL);
                    goToMessage(message, function (messageId) {
                        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(messageId);
                    });
                } }))),
        panel === PANELS.THREAD && (React__default.createElement("div", { className: "sb_mobile__panelwrap" },
            React__default.createElement(Thread, { channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '', message: threadTargetMessage, onHeaderActionClick: function () {
                    setPanel(PANELS.CHANNEL);
                    pause(ALL);
                }, onMoveToParentMessage: function (_a) {
                    var message = _a.message, channel = _a.channel;
                    setCurrentChannel(channel);
                    goToMessage(message, function (messageId) {
                        setPanel(PANELS.CHANNEL);
                        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(messageId);
                    });
                } })))));
};

var AppLayout = function (props) {
    var _a, _b, _c;
    var isMessageGroupingEnabled = props.isMessageGroupingEnabled, allowProfileEdit = props.allowProfileEdit, onProfileEditSuccess = props.onProfileEditSuccess, disableAutoSelect = props.disableAutoSelect, currentChannel = props.currentChannel, setCurrentChannel = props.setCurrentChannel, enableLegacyChannelModules = props.enableLegacyChannelModules;
    var globalStore = useSendbirdStateContext();
    var globalConfigs = globalStore.config;
    var _d = useState(false), showThread = _d[0], setShowThread = _d[1];
    var _e = useState(null), threadTargetMessage = _e[0], setThreadTargetMessage = _e[1];
    var _f = useState(false), showSettings = _f[0], setShowSettings = _f[1];
    var _g = useState(false), showSearch = _g[0], setShowSearch = _g[1];
    var _h = useState(null), highlightedMessage = _h[0], setHighlightedMessage = _h[1];
    var _j = useState(null), startingPoint = _j[0], setStartingPoint = _j[1];
    var isMobile = useMediaQueryContext().isMobile;
    /**
     * Below configs can be set via Dashboard UIKit config setting but as a lower priority than App props.
     * So need to be have fallback value \w global configs even though each prop values are undefined
     */
    var replyType = (_a = props.replyType) !== null && _a !== void 0 ? _a : getCaseResolvedReplyType(globalConfigs.groupChannel.replyType).upperCase;
    var isReactionEnabled = (_b = props.isReactionEnabled) !== null && _b !== void 0 ? _b : globalConfigs.groupChannel.enableReactions;
    var showSearchIcon = (_c = props.showSearchIcon) !== null && _c !== void 0 ? _c : globalConfigs.groupChannelSettings.enableMessageSearch;
    return (React__default.createElement(React__default.Fragment, null, isMobile
        ? (React__default.createElement(MobileLayout, { replyType: replyType, showSearchIcon: showSearchIcon, isReactionEnabled: isReactionEnabled, isMessageGroupingEnabled: isMessageGroupingEnabled, allowProfileEdit: allowProfileEdit, onProfileEditSuccess: onProfileEditSuccess, currentChannel: currentChannel, setCurrentChannel: setCurrentChannel, highlightedMessage: highlightedMessage, setHighlightedMessage: setHighlightedMessage, startingPoint: startingPoint, setStartingPoint: setStartingPoint, threadTargetMessage: threadTargetMessage, setThreadTargetMessage: setThreadTargetMessage, enableLegacyChannelModules: enableLegacyChannelModules }))
        : (React__default.createElement(DesktopLayout, { replyType: replyType, isReactionEnabled: isReactionEnabled, showSearchIcon: showSearchIcon, isMessageGroupingEnabled: isMessageGroupingEnabled, allowProfileEdit: allowProfileEdit, onProfileEditSuccess: onProfileEditSuccess, disableAutoSelect: disableAutoSelect, currentChannel: currentChannel, setCurrentChannel: setCurrentChannel, showThread: showThread, setShowThread: setShowThread, threadTargetMessage: threadTargetMessage, setThreadTargetMessage: setThreadTargetMessage, showSettings: showSettings, setShowSettings: setShowSettings, showSearch: showSearch, setShowSearch: setShowSearch, highlightedMessage: highlightedMessage, setHighlightedMessage: setHighlightedMessage, startingPoint: startingPoint, setStartingPoint: setStartingPoint, enableLegacyChannelModules: enableLegacyChannelModules }))));
};

/**
 * This is a drop in Chat solution
 * Can also be used as an example for creating
 * default chat apps
 */
function App(props) {
    var appId = props.appId, userId = props.userId, _a = props.accessToken, accessToken = _a === void 0 ? '' : _a, _b = props.customApiHost, customApiHost = _b === void 0 ? '' : _b, _c = props.customWebSocketHost, customWebSocketHost = _c === void 0 ? '' : _c, breakpoint = props.breakpoint, _d = props.theme, theme = _d === void 0 ? 'light' : _d, userListQuery = props.userListQuery, _e = props.nickname, nickname = _e === void 0 ? '' : _e, _f = props.profileUrl, profileUrl = _f === void 0 ? '' : _f, dateLocale = props.dateLocale, _g = props.config, config = _g === void 0 ? {} : _g, voiceRecord = props.voiceRecord, _h = props.isMessageGroupingEnabled, isMessageGroupingEnabled = _h === void 0 ? true : _h, colorSet = props.colorSet, stringSet = props.stringSet, _j = props.allowProfileEdit, allowProfileEdit = _j === void 0 ? false : _j, _k = props.disableMarkAsDelivered, disableMarkAsDelivered = _k === void 0 ? false : _k, renderUserProfile = props.renderUserProfile, onProfileEditSuccess = props.onProfileEditSuccess, _l = props.imageCompression, imageCompression = _l === void 0 ? {} : _l, _m = props.disableAutoSelect, disableAutoSelect = _m === void 0 ? false : _m, sdkInitParams = props.sdkInitParams, customExtensionParams = props.customExtensionParams, eventHandlers = props.eventHandlers, isMultipleFilesMessageEnabled = props.isMultipleFilesMessageEnabled, _o = props.isUserIdUsedForNickname, isUserIdUsedForNickname = _o === void 0 ? true : _o, _p = props.enableLegacyChannelModules, enableLegacyChannelModules = _p === void 0 ? false : _p, uikitOptions = props.uikitOptions, _q = props.htmlTextDirection, htmlTextDirection = _q === void 0 ? 'ltr' : _q, _r = props.forceLeftToRightMessageLayout, forceLeftToRightMessageLayout = _r === void 0 ? false : _r, 
    // The below configs are duplicates of the Dashboard UIKit Configs.
    // Since their default values will be set in the Sendbird component,
    // we don't need to set them here.
    showSearchIcon = props.showSearchIcon, isMentionEnabled = props.isMentionEnabled, isReactionEnabled = props.isReactionEnabled, replyType = props.replyType, disableUserProfile = props.disableUserProfile, isVoiceMessageEnabled = props.isVoiceMessageEnabled, isTypingIndicatorEnabledOnChannelList = props.isTypingIndicatorEnabledOnChannelList, isMessageReceiptStatusEnabledOnChannelList = props.isMessageReceiptStatusEnabledOnChannelList;
    var _s = useState(), currentChannel = _s[0], setCurrentChannel = _s[1];
    return (React__default.createElement(SendbirdProvider, { stringSet: stringSet, appId: appId, userId: userId, accessToken: accessToken, customApiHost: customApiHost, customWebSocketHost: customWebSocketHost, breakpoint: breakpoint, theme: theme, nickname: nickname, profileUrl: profileUrl, dateLocale: dateLocale, userListQuery: userListQuery, config: config, colorSet: colorSet, disableMarkAsDelivered: disableMarkAsDelivered, renderUserProfile: renderUserProfile, imageCompression: imageCompression, isMultipleFilesMessageEnabled: isMultipleFilesMessageEnabled, voiceRecord: voiceRecord, onStartDirectMessage: function (channel) {
            setCurrentChannel(channel);
        }, uikitOptions: uikitOptions, isUserIdUsedForNickname: isUserIdUsedForNickname, sdkInitParams: sdkInitParams, customExtensionParams: customExtensionParams, eventHandlers: eventHandlers, isTypingIndicatorEnabledOnChannelList: isTypingIndicatorEnabledOnChannelList, isMessageReceiptStatusEnabledOnChannelList: isMessageReceiptStatusEnabledOnChannelList, replyType: replyType, showSearchIcon: showSearchIcon, disableUserProfile: disableUserProfile, isReactionEnabled: isReactionEnabled, isMentionEnabled: isMentionEnabled, isVoiceMessageEnabled: isVoiceMessageEnabled, htmlTextDirection: htmlTextDirection, forceLeftToRightMessageLayout: forceLeftToRightMessageLayout },
        React__default.createElement(AppLayout, { isMessageGroupingEnabled: isMessageGroupingEnabled, allowProfileEdit: allowProfileEdit, onProfileEditSuccess: onProfileEditSuccess, disableAutoSelect: disableAutoSelect, currentChannel: currentChannel, setCurrentChannel: setCurrentChannel, enableLegacyChannelModules: enableLegacyChannelModules, isReactionEnabled: isReactionEnabled, replyType: replyType, showSearchIcon: showSearchIcon })));
}


//# sourceMappingURL=App.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-Dil0V6Tg.js
















var shouldFetchMore = function (messageLength, maxMessages) {
    if (typeof maxMessages !== 'number') {
        return true;
    }
    return maxMessages > messageLength;
};
/* eslint-disable default-param-last */
var bundle_Dil0V6Tg_scrollIntoLast = function (initialTry, scrollRef) {
    if (initialTry === void 0) { initialTry = 0; }
    var MAX_TRIES = 10;
    var currentTry = initialTry;
    if (currentTry > MAX_TRIES) {
        return;
    }
    try {
        var scrollDOM = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) || document.querySelector('.sendbird-openchannel-conversation-scroll__container__item-container');
        // eslint-disable-next-line no-multi-assign
        if (scrollDOM) {
            scrollDOM.scrollTop = scrollDOM.scrollHeight;
        }
    }
    catch (error) {
        setTimeout(function () {
            bundle_Dil0V6Tg_scrollIntoLast(currentTry + 1, scrollRef);
        }, 500 * currentTry);
    }
};
var bundle_Dil0V6Tg_kFormatter = function (num) {
    if (Math.abs(num) > 999999) {
        return "".concat((Math.abs(num) / 1000000).toFixed(1), "M");
    }
    if (Math.abs(num) > 999) {
        return "".concat((Math.abs(num) / 1000).toFixed(1), "K");
    }
    return "".concat(num);
};
var bundle_Dil0V6Tg_isOperator = function (openChannel, userId) {
    var operators = openChannel === null || openChannel === void 0 ? void 0 : openChannel.operators;
    if (operators.map(function (operator) { return operator.userId; }).indexOf(userId) < 0) {
        return false;
    }
    return true;
};
var bundle_Dil0V6Tg_isDisabledBecauseFrozen = function (openChannel, userId) {
    if (!openChannel)
        return false;
    var isFrozen = openChannel.isFrozen;
    return isFrozen && !bundle_Dil0V6Tg_isOperator(openChannel, userId);
};
var bundle_Dil0V6Tg_isDisabledBecauseMuted = function (mutedParticipantIds, userId) {
    return mutedParticipantIds.indexOf(userId) > -1;
};
var fetchWithListQuery = function (listQuery, logger, eachQueryNextCallback) {
    var fetchList = function (query) {
        var hasNext = query.hasNext;
        if (hasNext) {
            query.next().then(function (users) {
                eachQueryNextCallback(users);
                fetchList(query);
            }).catch(function (error) {
                logger.warning('OpenChannel | FetchUserList failed', error);
            });
        }
        else {
            logger.info('OpenChannel | FetchUserList finished');
        }
    };
    logger.info('OpenChannel | FetchUserList start', listQuery);
    fetchList(listQuery);
};

var bundle_Dil0V6Tg_SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var bundle_Dil0V6Tg_SET_CHANNEL_INVALID = 'SET_CHANNEL_INVALID';
var bundle_Dil0V6Tg_RESET_MESSAGES = 'RESET_MESSAGES';
var EXIT_CURRENT_CHANNEL = 'EXIT_CURRENT_CHANNEL';
var GET_PREV_MESSAGES_START = 'GET_PREV_MESSAGES_START';
var GET_PREV_MESSAGES_SUCESS = 'GET_PREV_MESSAGES_SUCESS';
var GET_PREV_MESSAGES_FAIL = 'GET_PREV_MESSAGES_FAIL';
var SENDING_MESSAGE_FAILED = 'SENDING_MESSAGE_FAILED';
var SENDING_MESSAGE_SUCCEEDED = 'SENDING_MESSAGE_SUCCEEDED';
var SENDING_MESSAGE_START = 'SENDING_MESSAGE_START';
var RESENDING_MESSAGE_START = 'RESENDING_MESSAGE_START';
var FETCH_PARTICIPANT_LIST = 'FETCH_PARTICIPANT_LIST';
var FETCH_BANNED_USER_LIST = 'FETCH_BANNED_USER_LIST';
var FETCH_MUTED_USER_LIST = 'FETCH_MUTED_USER_LIST';
var TRIM_MESSAGE_LIST = 'TRIM_MESSAGE_LIST';
// event handlers
var bundle_Dil0V6Tg_ON_MESSAGE_RECEIVED = 'ON_MESSAGE_RECEIVED';
var bundle_Dil0V6Tg_ON_MESSAGE_UPDATED = 'ON_MESSAGE_UPDATED';
var bundle_Dil0V6Tg_ON_MESSAGE_DELETED = 'ON_MESSAGE_DELETED';
var bundle_Dil0V6Tg_ON_MESSAGE_DELETED_BY_REQ_ID = 'ON_MESSAGE_DELETED_BY_REQ_ID';
var ON_OPERATOR_UPDATED = 'ON_OPERATOR_UPDATED';
var ON_USER_ENTERED = 'ON_USER_ENTERED';
var ON_USER_EXITED = 'ON_USER_EXITED';
var ON_USER_MUTED = 'ON_USER_MUTED';
var ON_USER_UNMUTED = 'ON_USER_UNMUTED';
var ON_USER_BANNED = 'ON_USER_BANNED';
var ON_USER_UNBANNED = 'ON_USER_UNBANNED';
var bundle_Dil0V6Tg_ON_CHANNEL_FROZEN = 'ON_CHANNEL_FROZEN';
var bundle_Dil0V6Tg_ON_CHANNEL_UNFROZEN = 'ON_CHANNEL_UNFROZEN';
var bundle_Dil0V6Tg_ON_CHANNEL_CHANGED = 'ON_CHANNEL_CHANGED';
var bundle_Dil0V6Tg_ON_CHANNEL_DELETED = 'ON_CHANNEL_DELETED';
var ON_META_DATA_CREATED = 'ON_META_DATA_CREATED';
var ON_META_DATA_UPDATED = 'ON_META_DATA_UPDATED';
var ON_META_DATA_DELETED = 'ON_META_DATA_DELETED';
var ON_META_COUNTERS_CREATED = 'ON_META_COUNTERS_CREATED';
var ON_META_COUNTERS_UPDATED = 'ON_META_COUNTERS_UPDATED';
var ON_META_COUNTERS_DELETED = 'ON_META_COUNTERS_DELETED';
var ON_MENTION_RECEIVED = 'ON_MENTION_RECEIVED';

function bundle_Dil0V6Tg_reducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    switch (action.type) {
        case bundle_Dil0V6Tg_RESET_MESSAGES: {
            return __assign(__assign({}, state), { allMessages: [] });
        }
        case EXIT_CURRENT_CHANNEL: {
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.url) === ((_b = state.currentOpenChannel) === null || _b === void 0 ? void 0 : _b.url)) {
                return __assign(__assign({}, state), { currentOpenChannel: null });
            }
            return state;
        }
        case bundle_Dil0V6Tg_SET_CURRENT_CHANNEL: {
            var gottenChannel = action.payload;
            var operators = gottenChannel.operators;
            if (!state.isInvalid
                && state.currentOpenChannel
                && state.currentOpenChannel.url
                && (state.currentOpenChannel.url === gottenChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { currentOpenChannel: gottenChannel, isInvalid: false, operators: operators, participants: operators, bannedParticipantIds: [], mutedParticipantIds: [] });
        }
        case bundle_Dil0V6Tg_SET_CHANNEL_INVALID: {
            return __assign(__assign({}, state), { isInvalid: true });
        }
        case GET_PREV_MESSAGES_START: {
            return __assign(__assign({}, state), { loading: true });
        }
        case GET_PREV_MESSAGES_SUCESS:
        case GET_PREV_MESSAGES_FAIL: {
            var isFailed = (action.type === GET_PREV_MESSAGES_FAIL);
            var _j = action.payload, _k = _j.currentOpenChannel, currentOpenChannel = _k === void 0 ? {} : _k, _l = _j.messages, messages = _l === void 0 ? [] : _l, hasMore = _j.hasMore, lastMessageTimestamp = _j.lastMessageTimestamp;
            var actionChannelUrl = currentOpenChannel.url;
            var receivedMessages_1 = (isFailed ? [] : messages);
            var _hasMore = isFailed ? false : hasMore;
            var _lastMessageTimestamp = isFailed ? 0 : lastMessageTimestamp;
            var stateChannel = state.currentOpenChannel;
            var stateChannelUrl = stateChannel === null || stateChannel === void 0 ? void 0 : stateChannel.url;
            if (actionChannelUrl !== stateChannelUrl) {
                return state;
            }
            var filteredAllMessages = state.allMessages.filter(function (message) { return (!(receivedMessages_1.find(function (_a) {
                var messageId = _a.messageId;
                return compareIds(messageId, message.messageId);
            }))); });
            return __assign(__assign({}, state), { loading: false, initialized: true, hasMore: _hasMore, lastMessageTimestamp: _lastMessageTimestamp, allMessages: __spreadArray(__spreadArray([], receivedMessages_1, true), filteredAllMessages, true) });
        }
        case SENDING_MESSAGE_START: {
            var _m = action.payload, message_1 = _m.message, channel = _m.channel;
            if ((channel === null || channel === void 0 ? void 0 : channel.url) !== ((_c = state.currentOpenChannel) === null || _c === void 0 ? void 0 : _c.url)
                || state.allMessages.some(function (m) { return m.reqId === message_1.reqId; })
            // Handing failed first than sending start issue
            ) {
                return state;
            }
            return __assign(__assign({}, state), { allMessages: __spreadArray(__spreadArray([], state.allMessages, true), [
                    message_1,
                ], false) });
        }
        case SENDING_MESSAGE_SUCCEEDED: {
            var sentMessage_1 = action.payload;
            var newMessages = state.allMessages.map(function (m) { return (compareIds(m.reqId, sentMessage_1.reqId) ? sentMessage_1 : m); });
            return __assign(__assign({}, state), { allMessages: newMessages });
        }
        case SENDING_MESSAGE_FAILED: {
            var sentMessage_2 = action.payload;
            sentMessage_2.sendingStatus = 'failed';
            if (!(state.allMessages.some(function (m) { return (m === null || m === void 0 ? void 0 : m.reqId) === (sentMessage_2 === null || sentMessage_2 === void 0 ? void 0 : sentMessage_2.reqId); }))) {
                // Handling failed first than sending start issue
                return __assign(__assign({}, state), { allMessages: __spreadArray(__spreadArray([], state.allMessages.filter(function (m) { return !compareIds(m.reqId, sentMessage_2); }), true), [
                        sentMessage_2,
                    ], false) });
            }
            else {
                return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (m) { return (compareIds(m.reqId, sentMessage_2.reqId) ? sentMessage_2 : m); }) });
            }
        }
        case TRIM_MESSAGE_LIST: {
            var allMessages = state.allMessages;
            var messageLimit = (_d = action.payload) === null || _d === void 0 ? void 0 : _d.messageLimit;
            if (messageLimit
                && messageLimit > 0
                && (allMessages === null || allMessages === void 0 ? void 0 : allMessages.length) > messageLimit) {
                var sliceAt = allMessages.length - messageLimit;
                return __assign(__assign({}, state), { allMessages: allMessages.slice(sliceAt) });
            }
            return state;
        }
        case RESENDING_MESSAGE_START: {
            var eventedChannel = action.payload.channel;
            var resentMessage_1 = action.payload.message;
            if (eventedChannel.url !== ((_e = state.currentOpenChannel) === null || _e === void 0 ? void 0 : _e.url)) {
                return state;
            }
            return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (m) { return (compareIds(m.reqId, resentMessage_1.reqId) ? resentMessage_1 : m); }) });
        }
        case FETCH_PARTICIPANT_LIST: {
            var eventedChannel = action.payload.channel;
            var fetchedParticipantList = action.payload.users;
            if (eventedChannel.url !== ((_f = state.currentOpenChannel) === null || _f === void 0 ? void 0 : _f.url)) {
                return state;
            }
            return __assign(__assign({}, state), { participants: __spreadArray(__spreadArray([], state.participants, true), fetchedParticipantList, true) });
        }
        case FETCH_BANNED_USER_LIST: {
            var eventedChannel = action.payload.channel;
            var fetchedBannedUserList = action.payload.users;
            if ((eventedChannel.url !== ((_g = state.currentOpenChannel) === null || _g === void 0 ? void 0 : _g.url))
                || !(fetchedBannedUserList.every(function (user) { return typeof user.userId === 'string'; }))) {
                return state;
            }
            return __assign(__assign({}, state), { bannedParticipantIds: __spreadArray(__spreadArray([], state.bannedParticipantIds, true), fetchedBannedUserList.map(function (user) { return user.userId; }), true) });
        }
        case FETCH_MUTED_USER_LIST: {
            var eventedChannel = action.payload.channel;
            var fetchedMutedUserList = action.payload.users;
            if ((eventedChannel.url !== ((_h = state.currentOpenChannel) === null || _h === void 0 ? void 0 : _h.url))
                || !(fetchedMutedUserList.every(function (user) { return typeof user.userId === 'string'; }))) {
                return state;
            }
            return __assign(__assign({}, state), { mutedParticipantIds: __spreadArray(__spreadArray([], state.mutedParticipantIds, true), fetchedMutedUserList.map(function (user) { return user.userId; }), true) });
        }
        // events
        case bundle_Dil0V6Tg_ON_MESSAGE_RECEIVED: {
            var eventedChannel = action.payload.channel;
            var receivedMessage = action.payload.message;
            var currentOpenChannel = state.currentOpenChannel;
            if (!compareIds(eventedChannel.url, currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.url)
                || (!(state.allMessages.map(function (message) { return message.messageId; }).indexOf(receivedMessage.messageId) < 0))) {
                return state;
            }
            return __assign(__assign({}, state), { allMessages: __spreadArray(__spreadArray([], state.allMessages, true), [receivedMessage], false) });
        }
        case bundle_Dil0V6Tg_ON_MESSAGE_UPDATED: {
            var eventedChannel = action.payload.channel;
            var updatedMessage_1 = action.payload.message;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== eventedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { allMessages: state.allMessages.map(function (message) { return (message.isIdentical(updatedMessage_1)
                    ? updatedMessage_1
                    : message); }) });
        }
        case bundle_Dil0V6Tg_ON_MESSAGE_DELETED: {
            var eventedChannel = action.payload.channel;
            var deletedMessageId_1 = action.payload.messageId;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== eventedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { allMessages: state.allMessages.filter(function (message) { return (!compareIds(message.messageId, deletedMessageId_1)); }) });
        }
        case bundle_Dil0V6Tg_ON_MESSAGE_DELETED_BY_REQ_ID: {
            return __assign(__assign({}, state), { allMessages: state.allMessages.filter(function (m) { return (!compareIds(m.reqId, action.payload)); }) });
        }
        case ON_OPERATOR_UPDATED: {
            var eventedChannel = action.payload.channel;
            var updatedOperators = action.payload.operators;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== eventedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { currentOpenChannel: eventedChannel, operators: updatedOperators });
        }
        case ON_USER_ENTERED: {
            var eventedChannel = action.payload.channel;
            var enteredUser = action.payload.user;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== eventedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { participants: __spreadArray(__spreadArray([], state.participants, true), [enteredUser], false) });
        }
        case ON_USER_EXITED: {
            var eventedChannel = action.payload.channel;
            var exitedUser_1 = action.payload.user;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== eventedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { participants: state.participants.filter(function (participant) { return (!compareIds(participant.userId, exitedUser_1.userId)); }) });
        }
        case ON_USER_MUTED: {
            var eventedChannel = action.payload.channel;
            var mutedUser = action.payload.user;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel
                || (currentChannel.url && (currentChannel.url !== eventedChannel.url))
                || state.mutedParticipantIds.indexOf(mutedUser.userId) >= 0) {
                return state;
            }
            return __assign(__assign({}, state), { mutedParticipantIds: __spreadArray(__spreadArray([], state.mutedParticipantIds, true), [mutedUser.userId], false) });
        }
        case ON_USER_UNMUTED: {
            var eventedChannel = action.payload.channel;
            var unmutedUser_1 = action.payload.user;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel
                || (currentChannel.url && (currentChannel.url !== eventedChannel.url))
                || state.mutedParticipantIds.indexOf(unmutedUser_1.userId) < 0) {
                return state;
            }
            return __assign(__assign({}, state), { mutedParticipantIds: state.mutedParticipantIds.filter(function (userId) { return userId !== unmutedUser_1.userId; }) });
        }
        case ON_USER_BANNED: {
            var eventedChannel = action.payload.channel;
            var bannedUser = action.payload.user;
            var currentUser = action.payload.currentUser;
            var currentChannel = state.currentOpenChannel;
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (eventedChannel === null || eventedChannel === void 0 ? void 0 : eventedChannel.url) && (bannedUser === null || bannedUser === void 0 ? void 0 : bannedUser.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)) {
                return __assign(__assign({}, state), { currentOpenChannel: null });
            }
            else if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (eventedChannel === null || eventedChannel === void 0 ? void 0 : eventedChannel.url)) {
                return __assign(__assign({}, state), { bannedParticipantIds: __spreadArray(__spreadArray([], state.bannedParticipantIds, true), [bannedUser.userId], false) });
            }
            return state;
        }
        case ON_USER_UNBANNED: {
            var eventedChannel = action.payload.channel;
            var unbannedUser_1 = action.payload.user;
            var currentChannel = state.currentOpenChannel;
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (eventedChannel === null || eventedChannel === void 0 ? void 0 : eventedChannel.url)) {
                return __assign(__assign({}, state), { bannedParticipantIds: state.bannedParticipantIds.filter(function (userId) { return userId !== unbannedUser_1.userId; }) });
            }
            return state;
        }
        case bundle_Dil0V6Tg_ON_CHANNEL_FROZEN: {
            var frozenChannel = action.payload;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== frozenChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { frozen: true });
        }
        case bundle_Dil0V6Tg_ON_CHANNEL_UNFROZEN: {
            var unfrozenChannel = action.payload;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== unfrozenChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { frozen: false });
        }
        case bundle_Dil0V6Tg_ON_CHANNEL_CHANGED: {
            var changedChannel = action.payload;
            var currentChannel = state.currentOpenChannel;
            if (!currentChannel || currentChannel.url && (currentChannel.url !== changedChannel.url)) {
                return state;
            }
            return __assign(__assign({}, state), { currentOpenChannel: changedChannel });
        }
        case bundle_Dil0V6Tg_ON_CHANNEL_DELETED: {
            var deletedChannelUrl = action.payload;
            var currentChannel = state === null || state === void 0 ? void 0 : state.currentOpenChannel;
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === deletedChannelUrl) {
                return __assign(__assign({}, state), { currentOpenChannel: null });
            }
            return state;
        }
        case ON_META_DATA_CREATED: {
            // const eventedChannel = action.payload.channel;
            // const createdMetaData = action.payload.metaData;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_META_DATA_UPDATED: {
            // const eventedChannel = action.payload.channel;
            // const updatedMetaData = action.payload.metaData;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_META_DATA_DELETED: {
            // const eventedChannel = action.payload.channel;
            // const deletedMetaDataKeys = action.payload.metaDataKeys;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_META_COUNTERS_CREATED: {
            // const eventedChannel = action.payload.channel;
            // const createdMetaCounter = action.payload.metaCounter;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_META_COUNTERS_UPDATED: {
            // const eventedChannel = action.payload.channel;
            // const updatedMetaCounter = action.payload.metaCounter;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_META_COUNTERS_DELETED: {
            // const eventedChannel = action.payload.channel;
            // const deletedMetaCounterKeys = action.payload.metaCounterKeys;
            // return {
            //   ...state
            // };
            return state;
        }
        case ON_MENTION_RECEIVED: {
            // const eventedChannel = action.payload.channel;
            // const mentionedMessage = action.payload.message;
            // return {
            //   ...state
            // };
            return state;
        }
        default:
            return state;
    }
}

var bundle_Dil0V6Tg_initialState = {
    allMessages: [],
    loading: false,
    initialized: false,
    currentOpenChannel: null,
    isInvalid: false,
    hasMore: false,
    lastMessageTimestamp: 0,
    frozen: false,
    operators: [],
    participants: [],
    bannedParticipantIds: [],
    mutedParticipantIds: [],
};

function bundle_Dil0V6Tg_useSetChannel(_a, _b) {
    var channelUrl = _a.channelUrl, sdkInit = _a.sdkInit, fetchingParticipants = _a.fetchingParticipants, userId = _a.userId, currentOpenChannel = _a.currentOpenChannel;
    var sdk = _b.sdk, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher;
    useEffect(function () {
        var _a;
        if (channelUrl && sdkInit && (sdk === null || sdk === void 0 ? void 0 : sdk.openChannel)) {
            if (currentOpenChannel && (currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.exit)) {
                (_a = currentOpenChannel.exit) === null || _a === void 0 ? void 0 : _a.call(currentOpenChannel).then(function () {
                    logger.info('OpenChannel | useSetChannel: Exit from the previous open channel', currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.url);
                    messagesDispatcher({
                        type: EXIT_CURRENT_CHANNEL,
                        payload: currentOpenChannel,
                    });
                });
            }
            logger.info('OpenChannel | useSetChannel: Fetching channel', channelUrl);
            sdk.openChannel.getChannel(channelUrl).then(function (openChannel) {
                logger.info('OpenChannel | useSetChannel: Succeeded to fetch channel', openChannel);
                messagesDispatcher({
                    type: bundle_Dil0V6Tg_SET_CURRENT_CHANNEL,
                    payload: openChannel,
                });
                openChannel.enter().then(function () {
                    if (openChannel.isOperator(userId)) { // only operator has a permission to fetch these list
                        var bannedParticipantListQuery = openChannel.createBannedUserListQuery();
                        var mutedParticipantListQuery = openChannel.createMutedUserListQuery();
                        fetchWithListQuery(bannedParticipantListQuery, logger, function (users) {
                            messagesDispatcher({
                                type: FETCH_BANNED_USER_LIST,
                                payload: {
                                    channel: openChannel,
                                    users: users,
                                },
                            });
                        });
                        fetchWithListQuery(mutedParticipantListQuery, logger, function (users) {
                            messagesDispatcher({
                                type: FETCH_MUTED_USER_LIST,
                                payload: {
                                    channel: openChannel,
                                    users: users,
                                },
                            });
                        });
                    }
                    else {
                        openChannel.getMyMutedInfo()
                            .then(function (mutedInfo) {
                            if (mutedInfo === null || mutedInfo === void 0 ? void 0 : mutedInfo.isMuted) {
                                messagesDispatcher({
                                    type: FETCH_MUTED_USER_LIST,
                                    payload: {
                                        channel: openChannel,
                                        users: [sdk === null || sdk === void 0 ? void 0 : sdk.currentUser],
                                    },
                                });
                            }
                        });
                    }
                    if (fetchingParticipants) {
                        // fetch participants list
                        var participantListQuery = openChannel.createParticipantListQuery({
                            limit: openChannel.participantCount,
                        });
                        fetchWithListQuery(participantListQuery, logger, function (users) {
                            messagesDispatcher({
                                type: FETCH_PARTICIPANT_LIST,
                                payload: {
                                    channel: openChannel,
                                    users: users,
                                },
                            });
                        });
                    }
                }).catch(function (error) {
                    logger.warning('OpenChannel | useSetChannel: Failed to enter channel', { channelUrl: channelUrl, error: error });
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_SET_CHANNEL_INVALID,
                        payload: null,
                    });
                });
            }).catch(function (error) {
                logger.warning('OpenChannel | useSetChannel: Failed to fetch channel', { channelUrl: channelUrl, error: error });
                messagesDispatcher({
                    type: bundle_Dil0V6Tg_SET_CHANNEL_INVALID,
                    payload: null,
                });
            });
        }
    }, [channelUrl, sdkInit, fetchingParticipants]);
}

function bundle_Dil0V6Tg_useHandleChannelEvents(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel, checkScrollBottom = _a.checkScrollBottom;
    var sdk = _b.sdk, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, scrollRef = _b.scrollRef;
    useEffect(function () {
        var _a, _b;
        var messageReceiverId = uuidv4();
        if (currentOpenChannel && currentOpenChannel.url && ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.openChannel) === null || _a === void 0 ? void 0 : _a.addOpenChannelHandler)) {
            logger.info('OpenChannel | useHandleChannelEvents: Setup evnet handler', messageReceiverId);
            var channelHandlerParams = {
                onMessageReceived: function (channel, message) {
                    var scrollToEnd = checkScrollBottom();
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMessageReceived', { channelUrl: channelUrl, message: message });
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_MESSAGE_RECEIVED,
                        payload: { channel: channel, message: message },
                    });
                    if (scrollToEnd) {
                        try {
                            setTimeout(function () {
                                bundle_Dil0V6Tg_scrollIntoLast(0, scrollRef);
                            });
                        }
                        catch (error) {
                            logger.warning('OpenChannel | onMessageReceived | scroll to end failed');
                        }
                    }
                },
                onMessageUpdated: function (channel, message) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMessageUpdated', { channelUrl: channelUrl, message: message });
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_MESSAGE_UPDATED,
                        payload: { channel: channel, message: message },
                    });
                },
                onMessageDeleted: function (channel, messageId) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMessageDeleted', { channelUrl: channelUrl, messageId: messageId });
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_MESSAGE_DELETED,
                        payload: { channel: channel, messageId: messageId },
                    });
                },
                onOperatorUpdated: function (channel, operators) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onOperatorUpdated', { channelUrl: channelUrl, operators: operators });
                    messagesDispatcher({
                        type: ON_OPERATOR_UPDATED,
                        payload: { channel: channel, operators: operators },
                    });
                },
                onUserEntered: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserEntered', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_ENTERED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserExited: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserExited', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_EXITED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserMuted: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserMuted', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_MUTED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserUnmuted: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserUnmuted', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_UNMUTED,
                        payload: { channel: channel, user: user },
                    });
                },
                onUserBanned: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserBanned', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_BANNED,
                        payload: { channel: channel, user: user, currentUser: sdk === null || sdk === void 0 ? void 0 : sdk.currentUser },
                    });
                },
                onUserUnbanned: function (channel, user) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onUserUnbanned', { channelUrl: channelUrl, user: user });
                    messagesDispatcher({
                        type: ON_USER_UNBANNED,
                        payload: { channel: channel, user: user },
                    });
                },
                onChannelFrozen: function (channel) {
                    logger.info('OpenChannel | useHandleChannelEvents: onChannelFrozen', channel);
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_CHANNEL_FROZEN,
                        payload: channel,
                    });
                },
                onChannelUnfrozen: function (channel) {
                    logger.info('OpenChannel | useHandleChannelEvents: onChannelUnfrozen', channel);
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_CHANNEL_UNFROZEN,
                        payload: channel,
                    });
                },
                onChannelChanged: function (channel) {
                    logger.info('OpenChannel | useHandleChannelEvents: onChannelChanged', channel);
                    messagesDispatcher({
                        type: bundle_Dil0V6Tg_ON_CHANNEL_CHANGED,
                        payload: channel,
                    });
                },
                onMetaDataCreated: function (channel, metaData) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaDataCreated', { channelUrl: channelUrl, metaData: metaData });
                    messagesDispatcher({
                        type: ON_META_DATA_CREATED,
                        payload: { channel: channel, metaData: metaData },
                    });
                },
                onMetaDataUpdated: function (channel, metaData) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaDataUpdated', { channelUrl: channelUrl, metaData: metaData });
                    messagesDispatcher({
                        type: ON_META_DATA_UPDATED,
                        payload: { channel: channel, metaData: metaData },
                    });
                },
                onMetaDataDeleted: function (channel, metaDataKeys) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaDataDeleted', { channelUrl: channelUrl, metaDataKeys: metaDataKeys });
                    messagesDispatcher({
                        type: ON_META_DATA_DELETED,
                        payload: { channel: channel, metaDataKeys: metaDataKeys },
                    });
                },
                onMetaCounterCreated: function (channel, metaCounter) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaCountersCreated', { channelUrl: channelUrl, metaCounter: metaCounter });
                    messagesDispatcher({
                        type: ON_META_COUNTERS_CREATED,
                        payload: { channel: channel, metaCounter: metaCounter },
                    });
                },
                onMetaCounterUpdated: function (channel, metaCounter) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaCountersUpdated', { channelUrl: channelUrl, metaCounter: metaCounter });
                    messagesDispatcher({
                        type: ON_META_COUNTERS_UPDATED,
                        payload: { channel: channel, metaCounter: metaCounter },
                    });
                },
                onMetaCounterDeleted: function (channel, metaCounterKeys) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMetaCountersDeleted', { channelUrl: channelUrl, metaCounterKeys: metaCounterKeys });
                    messagesDispatcher({
                        type: ON_META_COUNTERS_DELETED,
                        payload: { channel: channel, metaCounterKeys: metaCounterKeys },
                    });
                },
                onMentionReceived: function (channel, message) {
                    var channelUrl = channel === null || channel === void 0 ? void 0 : channel.url;
                    logger.info('OpenChannel | useHandleChannelEvents: onMentionReceived', { channelUrl: channelUrl, message: message });
                    messagesDispatcher({
                        type: ON_MENTION_RECEIVED,
                        payload: { channel: channel, message: message },
                    });
                },
                onChannelDeleted: function (channelUrl, channelType) {
                    if (channelType === ChannelType.OPEN && (currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.url) === channelUrl) {
                        messagesDispatcher({
                            type: bundle_Dil0V6Tg_ON_CHANNEL_DELETED,
                            payload: channelUrl,
                        });
                    }
                },
            };
            var ChannelHandler = new OpenChannelHandler(channelHandlerParams);
            (_b = sdk === null || sdk === void 0 ? void 0 : sdk.openChannel) === null || _b === void 0 ? void 0 : _b.addOpenChannelHandler(messageReceiverId, ChannelHandler);
        }
        return function () {
            var _a;
            if ((_a = sdk === null || sdk === void 0 ? void 0 : sdk.openChannel) === null || _a === void 0 ? void 0 : _a.removeOpenChannelHandler) {
                logger.info('OpenChannel | useHandleChannelEvents: Removing message receiver handler', messageReceiverId);
                sdk.openChannel.removeOpenChannelHandler(messageReceiverId);
            }
        };
    }, [currentOpenChannel]);
}

function bundle_Dil0V6Tg_useInitialMessagesFetch(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel, userFilledMessageListParams = _a.userFilledMessageListParams;
    var logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, scrollRef = _b.scrollRef;
    useEffect(function () {
        logger.info('OpenChannel | useInitialMessagesFetch: Setup started', currentOpenChannel);
        messagesDispatcher({
            type: bundle_Dil0V6Tg_RESET_MESSAGES,
            payload: null,
        });
        if (currentOpenChannel && currentOpenChannel.getMessagesByTimestamp) {
            var messageListParams_1 = {
                nextResultSize: 0,
                prevResultSize: 30,
                isInclusive: true,
                includeReactions: false,
            };
            if (userFilledMessageListParams) {
                Object.keys(userFilledMessageListParams).forEach(function (key) {
                    // @ts-ignore
                    messageListParams_1[key] = userFilledMessageListParams[key];
                });
                logger.info('OpenChannel | useInitialMessagesFetch: Used customizedMessageListParams');
            }
            logger.info('OpenChannel | useInitialMessagesFetch: Fetching messages', { currentOpenChannel: currentOpenChannel, messageListParams: messageListParams_1 });
            messagesDispatcher({
                type: GET_PREV_MESSAGES_START,
                payload: null,
            });
            currentOpenChannel.getMessagesByTimestamp(new Date().getTime(), messageListParams_1).then(function (messages) {
                logger.info('OpenChannel | useInitialMessagesFetch: Fetching messages succeeded', messages);
                var hasMore = (messages && messages.length > 0);
                var lastMessageTimestamp = hasMore ? messages[0].createdAt : null;
                messagesDispatcher({
                    type: GET_PREV_MESSAGES_SUCESS,
                    payload: {
                        currentOpenChannel: currentOpenChannel,
                        messages: messages,
                        hasMore: hasMore,
                        lastMessageTimestamp: lastMessageTimestamp,
                    },
                });
                setTimeout(function () { bundle_Dil0V6Tg_scrollIntoLast(0, scrollRef); });
            }).catch(function (error) {
                logger.error('OpenChannel | useInitialMessagesFetch: Fetching messages failed', error);
                messagesDispatcher({
                    type: GET_PREV_MESSAGES_FAIL,
                    payload: {
                        currentOpenChannel: currentOpenChannel,
                        messages: [],
                        hasMore: false,
                        lastMessageTimestamp: 0,
                    },
                });
            });
        }
    }, [currentOpenChannel, userFilledMessageListParams]);
}

function bundle_Dil0V6Tg_useScrollCallback(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel, lastMessageTimestamp = _a.lastMessageTimestamp, fetchMore = _a.fetchMore;
    var sdk = _b.sdk, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, hasMore = _b.hasMore, userFilledMessageListParams = _b.userFilledMessageListParams;
    return useCallback(function (callback) {
        if (fetchMore && hasMore) {
            logger.info('OpenChannel | useScrollCallback: start');
            var messageListParams_1 = {
                prevResultSize: 30,
                includeReactions: false,
                nextResultSize: 0,
            };
            if (userFilledMessageListParams) {
                Object.keys(userFilledMessageListParams).forEach(function (key) {
                    // @ts-ignore
                    messageListParams_1[key] = userFilledMessageListParams[key];
                });
                logger.info('OpenChannel | useScrollCallback: Used userFilledMessageListParams', userFilledMessageListParams);
            }
            logger.info('OpenChannel | useScrollCallback: Fetching messages', { currentOpenChannel: currentOpenChannel, messageListParams: messageListParams_1 });
            currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.getMessagesByTimestamp(lastMessageTimestamp || new Date().getTime(), messageListParams_1).then(function (messages) {
                logger.info('OpenChannel | useScrollCallback: Fetching messages succeeded', messages);
                var hasMore = (messages && messages.length > 0);
                var lastMessageTimestamp = hasMore ? messages[0].createdAt : null;
                messagesDispatcher({
                    type: GET_PREV_MESSAGES_SUCESS,
                    payload: {
                        currentOpenChannel: currentOpenChannel,
                        messages: messages,
                        hasMore: hasMore,
                        lastMessageTimestamp: lastMessageTimestamp,
                    },
                });
                setTimeout(function () {
                    callback();
                });
            }).catch(function (error) {
                logger.error('OpenChannel | useScrollCallback: Fetching messages failed', error);
                messagesDispatcher({
                    type: GET_PREV_MESSAGES_FAIL,
                    payload: {
                        currentOpenChannel: currentOpenChannel,
                        messages: [],
                        hasMore: false,
                        lastMessageTimestamp: 0,
                    },
                });
            });
        }
    }, [currentOpenChannel, lastMessageTimestamp, fetchMore, sdk]);
}

function useCheckScrollBottom(_a, _b) {
    var conversationScrollRef = _a.conversationScrollRef;
    var logger = _b.logger;
    return useCallback(function () {
        var isBottom = true;
        if (conversationScrollRef && (conversationScrollRef === null || conversationScrollRef === void 0 ? void 0 : conversationScrollRef.current)) {
            try {
                var conversationScroll = conversationScrollRef.current;
                isBottom = conversationScroll.scrollHeight <= conversationScroll.scrollTop + conversationScroll.clientHeight;
            }
            catch (error) {
                logger.error('OpenChannel | useCheckScrollBottom', error);
            }
        }
        return isBottom;
    }, [conversationScrollRef]);
}

function bundle_Dil0V6Tg_useSendMessageCallback(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel, onBeforeSendUserMessage = _a.onBeforeSendUserMessage, messageInputRef = _a.messageInputRef;
    var sdk = _b.sdk, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, scrollRef = _b.scrollRef;
    return useCallback(function () {
        var _a;
        if (sdk) {
            var text = (_a = messageInputRef.current) === null || _a === void 0 ? void 0 : _a.innerText;
            var createParamsDefault = function (txt) {
                var message = txt;
                var params = {
                    message: message,
                };
                return params;
            };
            var createCustomParams = onBeforeSendUserMessage && typeof onBeforeSendUserMessage === 'function';
            if (createCustomParams) {
                logger.info('OpenChannel | useSendMessageCallback: Creating params using onBeforeSendUserMessage', onBeforeSendUserMessage);
            }
            var params = onBeforeSendUserMessage ? onBeforeSendUserMessage(text !== null && text !== void 0 ? text : '') : createParamsDefault(text !== null && text !== void 0 ? text : '');
            logger.info('OpenChannel | useSendMessageCallback: Sending message has started', params);
            var pendingMsg_1;
            currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.sendUserMessage(params).onPending(function (pendingMessage) {
                messagesDispatcher({
                    type: SENDING_MESSAGE_START,
                    payload: {
                        message: pendingMessage,
                        channel: currentOpenChannel,
                    },
                });
                pendingMsg_1 = pendingMessage;
                setTimeout(function () { return bundle_Dil0V6Tg_scrollIntoLast(0, scrollRef); });
            }).onSucceeded(function (message) {
                logger.info('OpenChannel | useSendMessageCallback: Sending message succeeded', message);
                messagesDispatcher({
                    type: SENDING_MESSAGE_SUCCEEDED,
                    payload: message,
                });
            }).onFailed(function (error) {
                logger.warning('OpenChannel | useSendMessageCallback: Sending message failed', error);
                messagesDispatcher({
                    type: SENDING_MESSAGE_FAILED,
                    payload: pendingMsg_1,
                });
                // https://sendbird.com/docs/chat/v3/javascript/guides/error-codes#2-server-error-codes
                // TODO: Do we need to handle the error cases?
                // @ts-ignore
                if ((error === null || error === void 0 ? void 0 : error.code) === 900041) {
                    messagesDispatcher({
                        type: ON_USER_MUTED,
                        payload: {
                            channel: currentOpenChannel,
                            user: sdk.currentUser,
                        },
                    });
                }
            });
        }
    }, [currentOpenChannel, onBeforeSendUserMessage, messageInputRef]);
}

function useFileUploadCallback(_a, _b) {
    var _this = this;
    var currentOpenChannel = _a.currentOpenChannel, _c = _a.imageCompression, imageCompression = _c === void 0 ? {} : _c, onBeforeSendFileMessage = _a.onBeforeSendFileMessage;
    var sdk = _b.sdk, logger = _b.logger, messagesDispatcher = _b.messagesDispatcher, scrollRef = _b.scrollRef;
    var stringSet = useLocalization().stringSet;
    var openModal = useGlobalModalContext().openModal;
    var config = useSendbirdStateContext().config;
    var uikitUploadSizeLimit = config.uikitUploadSizeLimit;
    return useCallback(function (files) { return __awaiter(_this, void 0, void 0, function () {
        var file_1, createCustomParams, createParamsDefault, compressedFiles, compressedFile, params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!sdk) return [3 /*break*/, 2];
                    file_1 = Array.isArray(files) ? files[0] : files;
                    createCustomParams = onBeforeSendFileMessage && typeof onBeforeSendFileMessage === 'function';
                    createParamsDefault = function (file) {
                        var params = {};
                        params.file = file;
                        return params;
                    };
                    /**
                     * Validate file sizes
                     * The default value of uikitUploadSizeLimit is 25MiB
                     */
                    if (file_1.size > uikitUploadSizeLimit) {
                        logger.info("OpenChannel | useFileUploadCallback: Cannot upload file size exceeding ".concat(uikitUploadSizeLimit));
                        openModal({
                            modalProps: {
                                titleText: stringSet.FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT.replace('%d', "".concat(Math.floor(uikitUploadSizeLimit / ONE_MiB))),
                                hideFooter: true,
                            },
                            childElement: function (_a) {
                                var closeModal = _a.closeModal;
                                return (React__default.createElement(ModalFooter, { type: ButtonTypes.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                            },
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, compressImages({
                            files: [file_1],
                            imageCompression: imageCompression,
                            logger: logger,
                        })];
                case 1:
                    compressedFiles = (_a.sent()).compressedFiles;
                    compressedFile = compressedFiles[0];
                    // Send FileMessage
                    if (createCustomParams) {
                        logger.info('OpenChannel | useFileUploadCallback: Creating params using onBeforeSendFileMessage', onBeforeSendFileMessage);
                    }
                    params = onBeforeSendFileMessage ? onBeforeSendFileMessage(compressedFile) : createParamsDefault(compressedFile);
                    logger.info('OpenChannel | useFileUploadCallback: Uploading file message start', params);
                    currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.sendFileMessage(params).onPending(function (pendingMessage) {
                        messagesDispatcher({
                            type: SENDING_MESSAGE_START,
                            payload: {
                                // TODO: remove data pollution
                                message: __assign(__assign({}, pendingMessage), { url: URL.createObjectURL(file_1), 
                                    // pending thumbnail message seems to be failed
                                    requestState: 'pending', isUserMessage: pendingMessage.isUserMessage, isFileMessage: pendingMessage.isFileMessage, isAdminMessage: pendingMessage.isAdminMessage, isMultipleFilesMessage: pendingMessage.isMultipleFilesMessage }),
                                channel: currentOpenChannel,
                            },
                        });
                        setTimeout(function () { return bundle_Dil0V6Tg_scrollIntoLast(0, scrollRef); });
                    }).onSucceeded(function (message) {
                        logger.info('OpenChannel | useFileUploadCallback: Sending message succeeded', message);
                        messagesDispatcher({
                            type: SENDING_MESSAGE_SUCCEEDED,
                            payload: message,
                        });
                    }).onFailed(function (error, message) {
                        logger.error('OpenChannel | useFileUploadCallback: Sending file message failed', { message: message, error: error });
                        // @ts-ignore
                        message.localUrl = URL.createObjectURL(file_1);
                        // @ts-ignore
                        message.file = file_1;
                        messagesDispatcher({
                            type: SENDING_MESSAGE_FAILED,
                            payload: message,
                        });
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [currentOpenChannel, onBeforeSendFileMessage, imageCompression]);
}

function bundle_Dil0V6Tg_useUpdateMessageCallback(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel, onBeforeSendUserMessage = _a.onBeforeSendUserMessage;
    var logger = _b.logger, messagesDispatcher = _b.messagesDispatcher;
    return useCallback(function (messageId, text, callback) {
        var createParamsDefault = function (txt) {
            return {
                message: txt,
            };
        };
        if (onBeforeSendUserMessage && typeof onBeforeSendUserMessage === 'function') {
            logger.info('OpenChannel | useUpdateMessageCallback: Creating params using onBeforeUpdateUserMessage');
        }
        var params = onBeforeSendUserMessage ? onBeforeSendUserMessage(text) : createParamsDefault(text);
        currentOpenChannel.updateUserMessage(messageId, params)
            .then(function (message) {
            if (callback) {
                callback();
            }
            logger.info('OpenChannel | useUpdateMessageCallback: Updating message succeeded', { message: message, params: params });
            messagesDispatcher({
                type: bundle_Dil0V6Tg_ON_MESSAGE_UPDATED,
                payload: {
                    channel: currentOpenChannel,
                    message: message,
                },
            });
        });
    }, [currentOpenChannel, onBeforeSendUserMessage]);
}

function bundle_Dil0V6Tg_useDeleteMessageCallback(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel;
    var logger = _b.logger, messagesDispatcher = _b.messagesDispatcher;
    return useCallback(function (message, callback) {
        logger.info('OpenChannel | useDeleteMessageCallback: Deleting message', message);
        var sendingStatus = message.sendingStatus;
        logger.info('OpenChannel | useDeleteMessageCallback: Deleting message requestState', sendingStatus);
        if (sendingStatus === 'failed' || sendingStatus === 'pending') {
            logger.info('OpenChannel | useDeleteMessageCallback: Deleted message from local', message);
            messagesDispatcher({
                type: bundle_Dil0V6Tg_ON_MESSAGE_DELETED_BY_REQ_ID,
                payload: message.reqId,
            });
            if (callback) {
                callback();
            }
        }
        else {
            if (!(message.messageType === 'file' || message.messageType === 'user')) {
                return;
            }
            var messageToDelete = message;
            currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.deleteMessage(messageToDelete).then(function () {
                logger.info('OpenChannel | useDeleteMessageCallback: Deleting message on server', sendingStatus);
                if (callback) {
                    callback();
                }
                logger.info('OpenChannel | useDeleteMessageCallback: Deleting message succeeded', message);
                messagesDispatcher({
                    type: bundle_Dil0V6Tg_ON_MESSAGE_DELETED,
                    payload: {
                        channel: currentOpenChannel,
                        messageId: message.messageId,
                    },
                });
            }).catch(function (error) {
                logger.warning('OpenChannel | useDeleteMessageCallback: Deleting message failed', error);
            });
        }
    }, [currentOpenChannel]);
}

function bundle_Dil0V6Tg_useResendMessageCallback(_a, _b) {
    var currentOpenChannel = _a.currentOpenChannel;
    var logger = _b.logger, messagesDispatcher = _b.messagesDispatcher;
    return useCallback(function (failedMessage) {
        logger.info('OpenChannel | useResendMessageCallback: Resending message has started', failedMessage);
        if (typeof (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.isResendable) === 'boolean'
            && failedMessage.isResendable) {
            // userMessage
            if (failedMessage.isUserMessage()) {
                currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.resendMessage(failedMessage).onPending(function (message) {
                    messagesDispatcher({
                        type: RESENDING_MESSAGE_START,
                        payload: {
                            channel: currentOpenChannel,
                            message: message,
                        },
                    });
                }).onSucceeded(function (message) {
                    logger.info('OpenChannel | useResendMessageCallback: Reseding message succeeded', message);
                    messagesDispatcher({
                        type: SENDING_MESSAGE_SUCCEEDED,
                        payload: message,
                    });
                }).onFailed(function (error, message) {
                    logger.warning('OpenChannel | useResendMessageCallback: Resending message failed', error);
                    messagesDispatcher({
                        type: SENDING_MESSAGE_FAILED,
                        payload: message,
                    });
                });
            }
            // fileMessage
            if (failedMessage.isFileMessage()) {
                currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.resendMessage(failedMessage).onPending(function (message) {
                    messagesDispatcher({
                        type: RESENDING_MESSAGE_START,
                        payload: {
                            channel: currentOpenChannel,
                            message: message,
                        },
                    });
                }).onSucceeded(function (message) {
                    logger.info('OpenChannel | useResendMessageCallback: Resending file message succeeded', message);
                    messagesDispatcher({
                        type: SENDING_MESSAGE_SUCCEEDED,
                        payload: message,
                    });
                }).onFailed(function (error, message) {
                    logger.warning('OpenChannel | useResendMessageCallback: Resending file message failed', error);
                    messagesDispatcher({
                        type: SENDING_MESSAGE_FAILED,
                        payload: message,
                    });
                });
            }
        }
        else {
            // to alert user on console
            // eslint-disable-next-line no-console
            console.error('OpenChannel | useResendMessageCallback: Message is not resendable');
            logger.warning('OpenChannel | useResendMessageCallback: Message is not resendable', failedMessage);
        }
    }, [currentOpenChannel]);
}

var THROTTLE_TIMER = 5000;
// to trim message list so that we wont keep thousands of messages in memory
// We are throttling here; not debouncing
// it will be called once very 5 sec if messagesLength, messageLimit changes
// we check if messagesLength > messageLimit before dispatching action
function useTrimMessageList(_a, _b) {
    var messagesLength = _a.messagesLength, messageLimit = _a.messageLimit;
    var messagesDispatcher = _b.messagesDispatcher, logger = _b.logger;
    var _c = useState(false), inProgress = _c[0], setInProgress = _c[1];
    useEffect(function () {
        if (inProgress) {
            return;
        }
        if (typeof messagesLength === 'number' && typeof messageLimit === 'number' && messagesLength > messageLimit) {
            logger.info('Trimming MessageList');
            messagesDispatcher({
                type: TRIM_MESSAGE_LIST,
                payload: { messageLimit: messageLimit },
            });
        }
        setInProgress(true);
        setTimeout(function () { setInProgress(false); }, THROTTLE_TIMER);
    }, [messagesLength, messageLimit]);
}

var OpenChannelContext = react.createContext(null);
var bundle_Dil0V6Tg_OpenChannelProvider = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var channelUrl = props.channelUrl, children = props.children, _h = props.isMessageGroupingEnabled, isMessageGroupingEnabled = _h === void 0 ? true : _h, queries = props.queries, onBeforeSendUserMessage = props.onBeforeSendUserMessage, messageLimit = props.messageLimit, onBeforeSendFileMessage = props.onBeforeSendFileMessage, onChatHeaderActionClick = props.onChatHeaderActionClick, onBackClick = props.onBackClick, disableUserProfile = props.disableUserProfile, renderUserProfile = props.renderUserProfile;
    // We didn't decide to support fetching participant list
    var fetchingParticipants = false;
    var globalStore = useSendbirdStateContext();
    var sdk = (_b = (_a = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _a === void 0 ? void 0 : _a.sdkStore) === null || _b === void 0 ? void 0 : _b.sdk;
    var sdkInit = (_d = (_c = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _c === void 0 ? void 0 : _c.sdkStore) === null || _d === void 0 ? void 0 : _d.initialized;
    var user = (_f = (_e = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _e === void 0 ? void 0 : _e.userStore) === null || _f === void 0 ? void 0 : _f.user;
    var config = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config;
    var userId = config.userId, isOnline = config.isOnline, logger = config.logger, pubSub = config.pubSub, imageCompression = config.imageCompression;
    // hook variables
    var _j = useReducer(bundle_Dil0V6Tg_reducer, bundle_Dil0V6Tg_initialState), messagesStore = _j[0], messagesDispatcher = _j[1];
    var allMessages = messagesStore.allMessages, loading = messagesStore.loading, initialized = messagesStore.initialized, currentOpenChannel = messagesStore.currentOpenChannel, isInvalid = messagesStore.isInvalid, hasMore = messagesStore.hasMore, lastMessageTimestamp = messagesStore.lastMessageTimestamp, operators = messagesStore.operators, bannedParticipantIds = messagesStore.bannedParticipantIds, mutedParticipantIds = messagesStore.mutedParticipantIds;
    // ref
    var messageInputRef = useRef(null); // useSendMessageCallback
    var conversationScrollRef = useRef(null); // useScrollAfterSendMessageCallback
    // const
    var userFilledMessageListParams = queries === null || queries === void 0 ? void 0 : queries.messageListParams;
    var disabled = !initialized
        || !isOnline
        || bundle_Dil0V6Tg_isDisabledBecauseFrozen(currentOpenChannel, userId)
        || bundle_Dil0V6Tg_isDisabledBecauseMuted(mutedParticipantIds, userId);
    // useMemo
    var amIBanned = useMemo(function () {
        return bannedParticipantIds.indexOf(user.userId) >= 0;
    }, [channelUrl, bannedParticipantIds, user]);
    var amIMuted = useMemo(function () {
        return mutedParticipantIds.indexOf(user.userId) >= 0;
    }, [channelUrl, mutedParticipantIds, user]);
    var amIOperator = useMemo(function () {
        return operators.map(function (operator) { return operator.userId; }).indexOf(user.userId) >= 0;
    }, [channelUrl, operators, user]);
    // use hooks
    bundle_Dil0V6Tg_useSetChannel({ channelUrl: channelUrl, sdkInit: sdkInit, fetchingParticipants: fetchingParticipants, userId: userId, currentOpenChannel: currentOpenChannel }, { sdk: sdk, logger: logger, messagesDispatcher: messagesDispatcher });
    var checkScrollBottom = useCheckScrollBottom({ conversationScrollRef: conversationScrollRef }, { logger: logger });
    bundle_Dil0V6Tg_useHandleChannelEvents({ currentOpenChannel: currentOpenChannel, checkScrollBottom: checkScrollBottom }, { sdk: sdk, logger: logger, messagesDispatcher: messagesDispatcher, scrollRef: conversationScrollRef });
    bundle_Dil0V6Tg_useInitialMessagesFetch({ currentOpenChannel: currentOpenChannel, userFilledMessageListParams: userFilledMessageListParams }, { logger: logger, messagesDispatcher: messagesDispatcher, scrollRef: conversationScrollRef });
    var fetchMore = shouldFetchMore(allMessages === null || allMessages === void 0 ? void 0 : allMessages.length, messageLimit);
    // do not fetch more for streaming
    var onScroll = bundle_Dil0V6Tg_useScrollCallback({ currentOpenChannel: currentOpenChannel, lastMessageTimestamp: lastMessageTimestamp, fetchMore: fetchMore }, { sdk: sdk, logger: logger, messagesDispatcher: messagesDispatcher, hasMore: hasMore, userFilledMessageListParams: userFilledMessageListParams });
    var handleSendMessage = bundle_Dil0V6Tg_useSendMessageCallback({ currentOpenChannel: currentOpenChannel, onBeforeSendUserMessage: onBeforeSendUserMessage, checkScrollBottom: checkScrollBottom, messageInputRef: messageInputRef }, { sdk: sdk, logger: logger, messagesDispatcher: messagesDispatcher, scrollRef: conversationScrollRef });
    var handleFileUpload = useFileUploadCallback({ currentOpenChannel: currentOpenChannel, onBeforeSendFileMessage: onBeforeSendFileMessage, checkScrollBottom: checkScrollBottom, imageCompression: imageCompression }, { sdk: sdk, logger: logger, messagesDispatcher: messagesDispatcher, scrollRef: conversationScrollRef });
    var updateMessage = bundle_Dil0V6Tg_useUpdateMessageCallback({ currentOpenChannel: currentOpenChannel, onBeforeSendUserMessage: onBeforeSendUserMessage }, { logger: logger, messagesDispatcher: messagesDispatcher });
    var deleteMessage = bundle_Dil0V6Tg_useDeleteMessageCallback({ currentOpenChannel: currentOpenChannel }, { logger: logger, messagesDispatcher: messagesDispatcher });
    var resendMessage = bundle_Dil0V6Tg_useResendMessageCallback({ currentOpenChannel: currentOpenChannel }, { logger: logger, messagesDispatcher: messagesDispatcher });
    useTrimMessageList({ messagesLength: allMessages === null || allMessages === void 0 ? void 0 : allMessages.length, messageLimit: messageLimit }, { messagesDispatcher: messagesDispatcher, logger: logger });
    // handle API calls from withSendbird
    useEffect(function () {
        var subscriber = new Map();
        if (!pubSub || !pubSub.subscribe) {
            return;
        }
        subscriber.set(pubSubTopics.SEND_USER_MESSAGE, pubSub.subscribe(pubSubTopics.SEND_USER_MESSAGE, function (msg) {
            var channel = msg.channel, message = msg.message;
            bundle_Dil0V6Tg_scrollIntoLast(0, conversationScrollRef);
            if (channel && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url))) {
                messagesDispatcher({
                    type: SENDING_MESSAGE_SUCCEEDED,
                    payload: message,
                });
            }
        }));
        subscriber.set(pubSubTopics.SEND_MESSAGE_START, pubSub.subscribe(pubSubTopics.SEND_MESSAGE_START, function (msg) {
            var channel = msg.channel, message = msg.message;
            if (channel && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url))) {
                messagesDispatcher({
                    type: SENDING_MESSAGE_START,
                    payload: { message: message, channel: channel },
                });
            }
        }));
        subscriber.set(pubSubTopics.SEND_FILE_MESSAGE, pubSub.subscribe(pubSubTopics.SEND_FILE_MESSAGE, function (msg) {
            var channel = msg.channel, message = msg.message;
            bundle_Dil0V6Tg_scrollIntoLast(0, conversationScrollRef);
            if (channel && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url))) {
                messagesDispatcher({
                    type: SENDING_MESSAGE_SUCCEEDED,
                    payload: { message: message, channel: channel },
                });
            }
        }));
        subscriber.set(pubSubTopics.UPDATE_USER_MESSAGE, pubSub.subscribe(pubSubTopics.UPDATE_USER_MESSAGE, function (msg) {
            var channel = msg.channel, message = msg.message, fromSelector = msg.fromSelector;
            if (fromSelector && channel && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url))) {
                messagesDispatcher({
                    type: bundle_Dil0V6Tg_ON_MESSAGE_UPDATED,
                    payload: { channel: channel, message: message },
                });
            }
        }));
        subscriber.set(pubSubTopics.DELETE_MESSAGE, pubSub.subscribe(pubSubTopics.DELETE_MESSAGE, function (msg) {
            var channel = msg.channel, messageId = msg.messageId;
            if (channel && (channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url))) {
                messagesDispatcher({
                    type: bundle_Dil0V6Tg_ON_MESSAGE_DELETED,
                    payload: messageId,
                });
            }
        }));
        return function () {
            if (subscriber) {
                subscriber.forEach(function (s) {
                    try {
                        s.remove();
                    }
                    catch (_a) {
                        //
                    }
                });
            }
        };
    }, [channelUrl, sdkInit]);
    return (React__default.createElement(OpenChannelContext.Provider, { value: {
            // props
            channelUrl: channelUrl,
            children: children,
            isMessageGroupingEnabled: isMessageGroupingEnabled,
            queries: queries,
            onBeforeSendUserMessage: onBeforeSendUserMessage,
            messageLimit: messageLimit,
            onBeforeSendFileMessage: onBeforeSendFileMessage,
            onChatHeaderActionClick: onChatHeaderActionClick,
            onBackClick: onBackClick,
            // store
            allMessages: allMessages,
            loading: loading,
            initialized: initialized,
            currentOpenChannel: currentOpenChannel,
            isInvalid: isInvalid,
            hasMore: hasMore,
            lastMessageTimestamp: lastMessageTimestamp,
            operators: operators,
            bannedParticipantIds: bannedParticipantIds,
            mutedParticipantIds: mutedParticipantIds,
            // derived/utils
            messageInputRef: messageInputRef,
            conversationScrollRef: conversationScrollRef,
            disabled: disabled,
            amIBanned: amIBanned,
            amIMuted: amIMuted,
            amIOperator: amIOperator,
            checkScrollBottom: checkScrollBottom,
            fetchMore: fetchMore,
            onScroll: onScroll,
            handleSendMessage: handleSendMessage,
            handleFileUpload: handleFileUpload,
            updateMessage: updateMessage,
            deleteMessage: deleteMessage,
            resendMessage: resendMessage,
            frozen: messagesStore.frozen,
            disableUserProfile: disableUserProfile,
            renderUserProfile: renderUserProfile,
            participants: messagesStore.participants,
        } },
        React__default.createElement(UserProfileProvider, { isOpenChannel: true, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile, disableUserProfile: (_g = props === null || props === void 0 ? void 0 : props.disableUserProfile) !== null && _g !== void 0 ? _g : config === null || config === void 0 ? void 0 : config.disableUserProfile }, children)));
};
var bundle_Dil0V6Tg_useOpenChannelContext = function () {
    var context = react.useContext(OpenChannelContext);
    if (!context)
        throw new Error('OpenChannelContext not found. Use within the OpenChannel module');
    return context;
};


//# sourceMappingURL=bundle-Dil0V6Tg.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/OpenChannelInput.js












































var OpenChannelInput_OpenChannelInput = react.forwardRef(function (props, ref) {
    var _a = bundle_Dil0V6Tg_useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = (0,react.useContext)(bundle_PhH_XFy.L).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (react.createElement("div", { className: "sendbird-openchannel-footer" },
        react.createElement(MessageInput/* default */.Z, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});


//# sourceMappingURL=OpenChannelInput.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/FrozenChannelNotification.js






var FrozenChannelNotification_FrozenNotification = function () {
    var stringSet = useContext(LocalizationContext).stringSet;
    return (React__default.createElement("div", { className: "sendbird-frozen-channel-notification" },
        React__default.createElement(Label, { className: "sendbird-frozen-channel-notification__text", type: LabelTypography.CAPTION_2 }, stringSet.CHANNEL_FROZEN)));
};


//# sourceMappingURL=FrozenChannelNotification.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/OpenChannelHeader.js





































function OpenChannelHeader_OpenchannelConversationHeader() {
    var stringSet = useContext(LocalizationContext).stringSet;
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, onChatHeaderActionClick = _a.onChatHeaderActionClick, amIOperator = _a.amIOperator, onBackClick = _a.onBackClick;
    var title = currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.name;
    var subTitle = "".concat(kFormatter(currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.participantCount), " ").concat(stringSet.OPEN_CHANNEL_CONVERSATION__TITLE_PARTICIPANTS);
    var coverImage = currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.coverUrl;
    var isMobile = useMediaQueryContext().isMobile;
    return (React__default.createElement("div", { className: "sendbird-openchannel-conversation-header" },
        React__default.createElement("div", { className: "sendbird-openchannel-conversation-header__left" },
            isMobile && (React__default.createElement(Icon, { className: "sendbird-oepnchannel-header__icon_back", onClick: onBackClick, fillColor: IconColors.PRIMARY, width: "24px", height: "24px", type: IconTypes.ARROW_LEFT })),
            coverImage ? (React__default.createElement(Avatar, { className: "sendbird-openchannel-conversation-header__left__cover-image", src: coverImage, alt: "channel cover image", width: "32px", height: "32px" })) : (React__default.createElement("div", { className: "sendbird-openchannel-conversation-header__left__cover-image--icon", style: { width: 32, height: 32 } },
                React__default.createElement(Icon, { type: IconTypes.CHANNELS, fillColor: IconColors.CONTENT, width: "18px", height: "18px" }))),
            React__default.createElement(Label, { className: "sendbird-openchannel-conversation-header__left__title", type: LabelTypography.H_2, color: LabelColors.ONBACKGROUND_1 }, title || stringSet.NO_TITLE),
            React__default.createElement(Label, { className: "sendbird-openchannel-conversation-header__left__sub-title", type: LabelTypography.BODY_2, color: LabelColors.ONBACKGROUND_2 }, subTitle || stringSet.NO_TITLE)),
        React__default.createElement("div", { className: "sendbird-openchannel-conversation-header__right" },
            React__default.createElement(IconButton, { className: "sendbird-openchannel-conversation-header__right__trigger", width: "32px", height: "32px", onClick: onChatHeaderActionClick },
                React__default.createElement(Icon, { type: (amIOperator
                        ? IconTypes.INFO
                        : IconTypes.MEMBERS), fillColor: IconColors.PRIMARY, width: "24px", height: "24px" })))));
}


//# sourceMappingURL=OpenChannelHeader.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BAXCq_Wt.js
var bundle_BAXCq_Wt = __webpack_require__(46367);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-BzaTQdTK.js
var copyToClipboard = function (text) {
    // @ts-ignore: Unreachable code error
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        // @ts-ignore: Unreachable code error
        return window.clipboardData.setData('Text', text);
    }
    if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand('copy'); // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            return false;
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
    return false;
};


//# sourceMappingURL=bundle-BzaTQdTK.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-D40MS86F.js





var OpenChannelMessageStatusTypes = {
    NONE: 'none',
    PENDING: 'pending',
    FAILED: 'failed',
    CANCELED: 'canceled',
    SUCCEEDED: 'succeeded',
};
var getSenderFromMessage = function (message) {
    // @ts-ignore
    return message.sender || message._sender;
};
var checkIsSent = function (status) { return (status === OpenChannelMessageStatusTypes.SUCCEEDED); };
var checkIsPending = function (status) { return (status === OpenChannelMessageStatusTypes.PENDING); };
var checkIsFailed = function (status) { return (status === OpenChannelMessageStatusTypes.FAILED); };
var checkIsByMe = function (message, userId) { return (getSenderFromMessage(message).userId === userId); };
var isFineCopy = function (_a) {
    var _b;
    var message = _a.message;
    return ((message === null || message === void 0 ? void 0 : message.messageType) === 'user' && ((_b = message === null || message === void 0 ? void 0 : message.message) === null || _b === void 0 ? void 0 : _b.length) > 0);
};
var isFineResend = function (_a) {
    var message = _a.message, status = _a.status, userId = _a.userId;
    return checkIsByMe(message, userId)
        && checkIsFailed(status)
        // @ts-ignore
        && (message === null || message === void 0 ? void 0 : message.isResendable);
};
var isFineEdit = function (_a) {
    var _b;
    var message = _a.message, status = _a.status, userId = _a.userId;
    return checkIsByMe(message, userId) && checkIsSent(status) && ((_b = message === null || message === void 0 ? void 0 : message.isUserMessage) === null || _b === void 0 ? void 0 : _b.call(message));
};
var isFineDelete = function (_a) {
    var message = _a.message, userId = _a.userId;
    return checkIsByMe(message, userId);
};
var isFineDownload = function (_a) {
    var _b;
    var message = _a.message, status = _a.status;
    if (((_b = message === null || message === void 0 ? void 0 : message.isFileMessage) === null || _b === void 0 ? void 0 : _b.call(message)) && checkIsSent(status)) {
        return true;
    }
    return false;
};
var showMenuTrigger = function (props) {
    var message = props.message, status = props.status, userId = props.userId;
    // @ts-ignore
    if (message.messageType === 'user') {
        return (isFineDelete({ message: message, status: status, userId: userId })
            || isFineEdit({ message: message, status: status, userId: userId })
            // @ts-ignore
            || isFineCopy({ message: message, status: status, userId: userId })
            || isFineResend({ message: message, status: status, userId: userId }));
    }
    else {
        return (isFineDelete({ message: message, status: status, userId: userId })
            || isFineResend({ message: message, status: status, userId: userId }));
    }
};

var OpenChannelMobileMenu = function (props) {
    var _a, _b;
    var message = props.message, parentRef = props.parentRef, resendMessage = props.resendMessage, showEdit = props.showEdit, showRemove = props.showRemove, copyToClipboard = props.copyToClipboard, hideMenu = props.hideMenu, _c = props.isEphemeral, isEphemeral = _c === void 0 ? false : _c;
    var userMessage = message;
    var status = message === null || message === void 0 ? void 0 : message.sendingStatus;
    var stringSet = (0,bundle_PhH_XFy.u)().stringSet;
    var userId = (_b = (_a = (0,uikit_react_useSendbirdStateContext/* useSendbirdStateContext */.A)()) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.userId;
    var fileMessage = message;
    return (react.createElement(bundle_ml_PByBw.C, { isOpen: true, menuItems: function () { return (react.createElement(bundle_ml_PByBw.b, { className: "sendbird-openchannel__mobile-menu", parentRef: parentRef, parentContainRef: parentRef, closeDropdown: hideMenu },
            isFineCopy({ message: userMessage, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__copy", onClick: function () {
                    copyToClipboard === null || copyToClipboard === void 0 ? void 0 : copyToClipboard();
                }, testID: "open_channel_mobile_context_menu_copy" },
                react.createElement(react.Fragment, null, stringSet.CONTEXT_MENU_DROPDOWN__COPY))),
            (!isEphemeral && isFineEdit({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__edit", onClick: function () {
                    showEdit === null || showEdit === void 0 ? void 0 : showEdit();
                }, testID: "open_channel_mobile_context_menu_edit" },
                react.createElement(react.Fragment, null, stringSet.CONTEXT_MENU_DROPDOWN__EDIT))),
            isFineResend({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                    resendMessage === null || resendMessage === void 0 ? void 0 : resendMessage();
                }, testID: "open_channel_mobile_context_menu_resend" },
                react.createElement(react.Fragment, null, stringSet.CONTEXT_MENU_DROPDOWN__RESEND))),
            (!isEphemeral && isFineDelete({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                    showRemove === null || showRemove === void 0 ? void 0 : showRemove();
                }, testID: "open_channel_mobile_context_menu_delete" },
                react.createElement(react.Fragment, null, stringSet.CONTEXT_MENU_DROPDOWN__DELETE))),
            isFineDownload({ message: message, status: status }) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                    hideMenu();
                }, testID: "open_channel_mobile_context_menu_download_file" },
                react.createElement("a", { className: "sendbird-openchannel__mobile-menu-hyperlink", rel: "noopener noreferrer", href: fileMessage === null || fileMessage === void 0 ? void 0 : fileMessage.url, target: "_blank" }, stringSet.CONTEXT_MENU_DROPDOWN__SAVE))))); } }));
};


//# sourceMappingURL=bundle-D40MS86F.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenchannelUserMessage.js









































function OpenchannelUserMessage(_a) {
    var className = _a.className, message = _a.message, isOperator = _a.isOperator, _b = _a.isEphemeral, isEphemeral = _b === void 0 ? false : _b, userId = _a.userId, resendMessage = _a.resendMessage, disabled = _a.disabled, showEdit = _a.showEdit, showRemove = _a.showRemove, chainTop = _a.chainTop;
    // hooks
    var _c = (0,bundle_PhH_XFy.u)(), stringSet = _c.stringSet, dateLocale = _c.dateLocale;
    var _d = (0,bundle_Bv8KtnvF.u)(), disableUserProfile = _d.disableUserProfile, renderUserProfile = _d.renderUserProfile;
    var messageRef = (0,react.useRef)();
    var avatarRef = (0,react.useRef)();
    var contextMenuRef = (0,react.useRef)();
    var mobileMenuRef = (0,react.useRef)();
    var _e = (0,react.useState)({}), contextStyle = _e[0], setContextStyle = _e[1];
    var _f = (0,react.useState)(false), contextMenu = _f[0], setContextMenu = _f[1];
    // consts
    var status = message === null || message === void 0 ? void 0 : message.sendingStatus;
    var isPending = checkIsPending(status);
    var isFailed = checkIsFailed(status);
    var sender = getSenderFromMessage(message);
    // place context menu top depending clientHeight of message component
    (0,react.useEffect)(function () {
        var _a;
        if (((_a = messageRef === null || messageRef === void 0 ? void 0 : messageRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) && messageRef.current.clientHeight > 36) {
            setContextStyle({ top: '8px ' });
        }
        else {
            setContextStyle({ top: '2px' });
        }
    }, [window.innerWidth]);
    var onLongPress = (0,bundle_CruP9bVM.u)({
        onLongPress: function () {
            setContextMenu(true);
        },
    });
    var isMobile = (0,bundle_R3uJ_0BB.u)().isMobile;
    if (!message || message.messageType !== 'user') {
        return react.createElement(react.Fragment, null);
    }
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], (Array.isArray(className) ? className : [className]), true), [
                'sendbird-openchannel-user-message',
            ], false).join(' '), ref: messageRef },
            react.createElement("div", { className: "sendbird-openchannel-user-message__left" }, !chainTop && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (react.createElement(bundle_52W7LREX.A, { className: "sendbird-openchannel-user-message__left__avatar", src: sender.profileUrl || '', ref: avatarRef, width: "28px", height: "28px", onClick: function () {
                        if (!disableUserProfile) {
                            toggleDropdown();
                        }
                    } })); }, menuItems: function (closeDropdown) { return (renderUserProfile
                    ? (renderUserProfile({
                        user: sender,
                        close: closeDropdown,
                        currentUserId: userId,
                        avatarRef: avatarRef,
                    }))
                    : (react.createElement(bundle_ml_PByBw.b, { parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                        react.createElement(UserProfile/* default */.Z, { user: sender, onSuccess: closeDropdown, disableMessaging: true })))); } }))),
            react.createElement("div", { className: "sendbird-openchannel-user-message__right" },
                !chainTop && (react.createElement("div", { className: "sendbird-openchannel-user-message__right__top" },
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-user-message__right__top__sender-name", type: bundle_ixnsp7Bg.a.CAPTION_2, color: isOperator ? bundle_ixnsp7Bg.b.SECONDARY_3 : bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, sender && (sender.friendName
                        || sender.nickname
                        || sender.userId)),
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-user-message__right__top__sent-at", type: bundle_ixnsp7Bg.a.CAPTION_3, color: bundle_ixnsp7Bg.b.ONBACKGROUND_3 }, (message === null || message === void 0 ? void 0 : message.createdAt) && ((0,bundle_QTCuDZTl.f)(message === null || message === void 0 ? void 0 : message.createdAt, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                        locale: dateLocale,
                    }))))),
                react.createElement("div", (0,bundle_XQWyv823._)({}, (isMobile ? (0,bundle_XQWyv823._)({}, onLongPress) : {}), { className: "sendbird-openchannel-user-message__right__bottom", ref: mobileMenuRef }),
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-user-message__right__bottom__message", type: bundle_ixnsp7Bg.a.BODY_1, color: bundle_ixnsp7Bg.b.ONBACKGROUND_1 }, message === null || message === void 0 ? void 0 :
                        message.message,
                        (0,bundle_D_9RmNe.d)(message) && (react.createElement(bundle_ixnsp7Bg.L, { key: (0,bundle_Bq93DTET.u)(), type: bundle_ixnsp7Bg.a.BODY_1, color: bundle_ixnsp7Bg.b.ONBACKGROUND_2, className: "sendbird-openchannel-user-message-word" }, " ".concat(stringSet.MESSAGE_EDITED, " "))))),
                (isPending || isFailed) && (react.createElement("div", { className: "sendbird-openchannel-user-message__right__tail" },
                    isPending && (react.createElement(ui_Loader/* default */.Z, { width: "16px", height: "16px" },
                        react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-user-message__right__tail__pending", type: ui_Icon/* IconTypes.SPINNER */.Qy.SPINNER, fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY, width: "16px", height: "16px" }))),
                    isFailed && (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-user-message__right__tail__failed", type: ui_Icon/* IconTypes.ERROR */.Qy.ERROR, fillColor: ui_Icon/* IconColors.ERROR */.zo.ERROR, width: "16px", height: "16px" }))))),
            !isMobile && (react.createElement("div", { className: "sendbird-openchannel-user-message__context-menu", ref: contextMenuRef, style: contextStyle },
                react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (showMenuTrigger({ message: message, userId: userId, status: status }) && (react.createElement(ui_IconButton/* default */.Z, { className: "sendbird-openchannel-user-message__context-menu--icon", width: "32px", height: "32px", onClick: function () {
                            toggleDropdown();
                        } },
                        react.createElement(ui_Icon/* default */.ZP, { type: ui_Icon/* IconTypes.MORE */.Qy.MORE, fillColor: ui_Icon/* IconColors.CONTENT_INVERSE */.zo.CONTENT_INVERSE, width: "24px", height: "24px" })))); }, menuItems: function (closeDropdown) { return (react.createElement(bundle_ml_PByBw.b, { parentRef: contextMenuRef, parentContainRef: contextMenuRef, closeDropdown: closeDropdown, openLeft: true },
                        isFineCopy({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-user-message__context-menu__copy", onClick: function () {
                                copyToClipboard(message.message);
                                closeDropdown();
                            }, testID: "open_channel_user_message_menu_copy" }, stringSet.CONTEXT_MENU_DROPDOWN__COPY)),
                        (!isEphemeral && isFineEdit({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-user-message__context-menu__edit", onClick: function () {
                                if (disabled) {
                                    return;
                                }
                                showEdit(true);
                                closeDropdown();
                            }, testID: "open_channel_user_message_menu_edit" }, stringSet.CONTEXT_MENU_DROPDOWN__EDIT)),
                        isFineResend({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-user-message__context-menu__resend", onClick: function () {
                                resendMessage(message);
                                closeDropdown();
                            }, testID: "open_channel_user_message_menu_resend" }, stringSet.CONTEXT_MENU_DROPDOWN__RESEND)),
                        (!isEphemeral && isFineDelete({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-user-message__context-menu__delete", onClick: function () {
                                if (disabled) {
                                    return;
                                }
                                showRemove(true);
                                closeDropdown();
                            }, testID: "open_channel_user_message_menu_delete" }, stringSet.CONTEXT_MENU_DROPDOWN__DELETE)))); } })))),
        contextMenu && (react.createElement(OpenChannelMobileMenu, { message: message, parentRef: mobileMenuRef, hideMenu: function () {
                setContextMenu(false);
            }, showRemove: function () {
                setContextMenu(false);
                showRemove(true);
            }, showEdit: function () {
                setContextMenu(false);
                showEdit(true);
            }, copyToClipboard: function () {
                setContextMenu(false);
                copyToClipboard(message === null || message === void 0 ? void 0 : message.message);
            }, resendMessage: function () {
                setContextMenu(false);
                resendMessage(message);
            } }))));
}


//# sourceMappingURL=OpenchannelUserMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenChannelAdminMessage.js





function OpenChannelAdminMessage(_a) {
    var className = _a.className, message = _a.message;
    return (react.createElement("div", { className: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-openchannel-admin-message',
        ], false).join(' ') },
        react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-admin-message__text", type: bundle_ixnsp7Bg.a.CAPTION_2, color: bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, message.message || '')));
}


//# sourceMappingURL=OpenChannelAdminMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenchannelOGMessage.js














































function OpenChannelOGMessage(_a) {
    var _b, _c, _d;
    var message = _a.message, isOperator = _a.isOperator, _e = _a.isEphemeral, isEphemeral = _e === void 0 ? false : _e, className = _a.className, disabled = _a.disabled, showEdit = _a.showEdit, showRemove = _a.showRemove, resendMessage = _a.resendMessage, chainTop = _a.chainTop, userId = _a.userId;
    var status = message === null || message === void 0 ? void 0 : message.sendingStatus;
    var ogMetaData = (_b = message.ogMetaData) !== null && _b !== void 0 ? _b : null;
    var defaultImage = ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.defaultImage;
    var _f = (0,bundle_PhH_XFy.u)(), stringSet = _f.stringSet, dateLocale = _f.dateLocale;
    var isMobile = (0,bundle_R3uJ_0BB.u)().isMobile;
    var _g = (0,bundle_Bv8KtnvF.u)(), disableUserProfile = _g.disableUserProfile, renderUserProfile = _g.renderUserProfile;
    var _h = (0,react.useState)({}), contextStyle = _h[0], setContextStyle = _h[1];
    var _j = (0,react.useState)(false), showContextMenu = _j[0], setShowContextMenu = _j[1];
    var openLink = function () { return (0,bundle_BHC96gO0.o)(ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.url); };
    var onLongPress = (0,bundle_CruP9bVM.u)({
        onLongPress: function () { return setShowContextMenu(true); },
        onClick: openLink,
    }, {
        delay: 300,
    });
    var messageComponentRef = (0,react.useRef)();
    var contextMenuRef = (0,react.useRef)();
    var mobileMenuRef = (0,react.useRef)();
    var avatarRef = (0,react.useRef)();
    var isPending = checkIsPending(status);
    var isFailed = checkIsFailed(status);
    var sender = getSenderFromMessage(message);
    var tokens = (0,react.useMemo)(function () {
        return (0,bundle_D7JevDoE.t)({
            messageText: message.message,
        });
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    // place conxt menu top depending clientHeight of message component
    (0,react.useEffect)(function () {
        var _a, _b;
        if (((_a = messageComponentRef === null || messageComponentRef === void 0 ? void 0 : messageComponentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) && ((_b = messageComponentRef === null || messageComponentRef === void 0 ? void 0 : messageComponentRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) > 36) {
            setContextStyle({ top: '8px ' });
        }
        else {
            setContextStyle({ top: '2px' });
        }
    }, [window.innerWidth]);
    if (!message || message.messageType !== 'user') {
        return react.createElement(react.Fragment, null);
    }
    return (react.createElement(react.Fragment, null,
        react.createElement("div", (0,bundle_XQWyv823._)({ className: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], (Array.isArray(className) ? className : [className]), true), [
                'sendbird-openchannel-og-message',
            ], false).join(' '), ref: messageComponentRef }, (isMobile ? (0,bundle_XQWyv823._)({}, onLongPress) : {})),
            react.createElement("div", { className: "sendbird-openchannel-og-message__top" },
                react.createElement("div", { className: "sendbird-openchannel-og-message__top__left" }, !chainTop && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (react.createElement(bundle_52W7LREX.A, { className: "sendbird-openchannel-og-message__top__left__avatar", src: sender.profileUrl || '', ref: avatarRef, width: "28px", height: "28px", onClick: function () {
                            if (!disableUserProfile) {
                                toggleDropdown();
                            }
                        } })); }, menuItems: function (closeDropdown) { return (renderUserProfile
                        ? (renderUserProfile({
                            user: sender,
                            close: closeDropdown,
                            currentUserId: userId,
                            avatarRef: avatarRef,
                        }))
                        : (react.createElement(bundle_ml_PByBw.b, { parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                            react.createElement(UserProfile/* default */.Z, { user: sender, onSuccess: closeDropdown, disableMessaging: true })))); } }))),
                react.createElement("div", { className: "sendbird-openchannel-og-message__top__right" },
                    !chainTop && (react.createElement("div", { className: "sendbird-openchannel-og-message__top__right__title" },
                        react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-og-message__top__right__title__sender-name", type: bundle_ixnsp7Bg.a.CAPTION_2, color: isOperator ? bundle_ixnsp7Bg.b.SECONDARY_3 : bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, sender && (sender.friendName
                            || sender.nickname
                            || sender.userId)),
                        react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-og-message__top__right__title__sent-at", type: bundle_ixnsp7Bg.a.CAPTION_3, color: bundle_ixnsp7Bg.b.ONBACKGROUND_3 }, (message === null || message === void 0 ? void 0 : message.createdAt) && ((0,bundle_QTCuDZTl.f)(message === null || message === void 0 ? void 0 : message.createdAt, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                            locale: dateLocale,
                        }))))),
                    react.createElement("div", { className: "sendbird-openchannel-og-message__top__right__description" },
                        react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-og-message__top__right__description__message", type: bundle_ixnsp7Bg.a.BODY_1, color: bundle_ixnsp7Bg.b.ONBACKGROUND_1 },
                            react.createElement(bundle_DjfGQ_DS.T, { tokens: tokens }),
                            (((_c = message === null || message === void 0 ? void 0 : message.updatedAt) !== null && _c !== void 0 ? _c : 0) > 0) && (react.createElement(bundle_ixnsp7Bg.L, { key: (0,bundle_Bq93DTET.u)(), className: 'sendbird-openchannel-og-message--word', type: bundle_ixnsp7Bg.a.BODY_1, color: bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, stringSet.MESSAGE_EDITED))))),
                !isMobile && (react.createElement("div", { className: "sendbird-openchannel-og-message__top__context-menu", ref: contextMenuRef, style: contextStyle },
                    react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (showMenuTrigger({ message: message, userId: userId, status: status }) && (react.createElement(ui_IconButton/* default */.Z, { className: "sendbird-openchannel-og-message__top__context-menu--icon", width: "32px", height: "32px", onClick: function () {
                                toggleDropdown();
                            } },
                            react.createElement(ui_Icon/* default */.ZP, { type: ui_Icon/* IconTypes.MORE */.Qy.MORE, fillColor: ui_Icon/* IconColors.CONTENT_INVERSE */.zo.CONTENT_INVERSE, width: "24px", height: "24px" })))); }, menuItems: function (closeDropdown) { return (react.createElement(bundle_ml_PByBw.b, { parentRef: contextMenuRef, parentContainRef: contextMenuRef, closeDropdown: closeDropdown, openLeft: true },
                            isFineCopy({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__copy", onClick: function () {
                                    copyToClipboard(message.message);
                                    closeDropdown();
                                }, testID: "open_channel_og_message_menu_copy" }, stringSet.CONTEXT_MENU_DROPDOWN__COPY)),
                            (!isEphemeral && isFineEdit({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__edit", onClick: function () {
                                    if (disabled) {
                                        return;
                                    }
                                    showEdit(true);
                                    closeDropdown();
                                }, testID: "open_channel_og_message_menu_edit" }, stringSet.CONTEXT_MENU_DROPDOWN__EDIT)),
                            isFineResend({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__resend", onClick: function () {
                                    resendMessage(message);
                                    closeDropdown();
                                }, testID: "open_channel_og_message_menu_resend" }, stringSet.CONTEXT_MENU_DROPDOWN__RESEND)),
                            (!isEphemeral && isFineDelete({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { className: "sendbird-openchannel-og-message__top__context-menu__delete", onClick: function () {
                                    if (disabled) {
                                        return;
                                    }
                                    showRemove(true);
                                    closeDropdown();
                                }, testID: "open_channel_og_message_menu_delete" }, stringSet.CONTEXT_MENU_DROPDOWN__DELETE)))); } })))),
            react.createElement("div", { className: "sendbird-openchannel-og-message__bottom" },
                react.createElement("div", { className: "sendbird-openchannel-og-message__bottom__og-tag", ref: mobileMenuRef },
                    (ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.url) && (react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-og-message__bottom__og-tag__url", type: bundle_ixnsp7Bg.a.CAPTION_3, color: bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, ogMetaData.url)),
                    (ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.title) && (react.createElement(LinkLabel/* default */.ZP, { className: "sendbird-openchannel-og-message__bottom__og-tag__title", src: (_d = ogMetaData.url) !== null && _d !== void 0 ? _d : '', type: bundle_ixnsp7Bg.a.SUBTITLE_2, color: bundle_ixnsp7Bg.b.PRIMARY }, ogMetaData.title)),
                    (ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.description) && (react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-og-message__bottom__og-tag__description", type: bundle_ixnsp7Bg.a.BODY_2, color: bundle_ixnsp7Bg.b.ONBACKGROUND_1 }, ogMetaData.description)),
                    (ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.url) && (react.createElement("div", { className: "sendbird-openchannel-og-message__bottom__og-tag__thumbnail", role: "button", onClick: openLink, onKeyDown: openLink, tabIndex: 0 }, defaultImage && (react.createElement(ImageRenderer/* default */.ZP, { className: "sendbird-openchannel-og-message__bottom__og-tag__thumbnail__image", url: defaultImage.url || '', alt: defaultImage.alt || '', width: "334px", height: "189px", defaultComponent: (react.createElement("div", { className: "sendbird-openchannel-og-message__bottom__og-tag__thumbnail__image--placeholder" },
                            react.createElement(ui_Icon/* default */.ZP, { type: ui_Icon/* IconTypes.THUMBNAIL_NONE */.Qy.THUMBNAIL_NONE, width: "56px", height: "56px" }))) }))))),
                (isPending || isFailed) && (react.createElement("div", { className: "sendbird-openchannel-og-message__top__right__tail" },
                    isPending && (react.createElement(ui_Loader/* default */.Z, { width: "16px", height: "16px" },
                        react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-og-message__top__right__tail__pending", type: ui_Icon/* IconTypes.SPINNER */.Qy.SPINNER, fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY, width: "16px", height: "16px" }))),
                    isFailed && (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-og-message__top__right__tail__failed", type: ui_Icon/* IconTypes.ERROR */.Qy.ERROR, fillColor: ui_Icon/* IconColors.ERROR */.zo.ERROR, width: "16px", height: "16px" })))))),
        showContextMenu && (react.createElement(OpenChannelMobileMenu, { message: message, parentRef: mobileMenuRef, hideMenu: function () {
                setShowContextMenu(false);
            }, showRemove: function () {
                setShowContextMenu(false);
                showRemove(true);
            }, showEdit: function () {
                setShowContextMenu(false);
                showEdit(true);
            }, copyToClipboard: function () {
                setShowContextMenu(false);
                copyToClipboard(message === null || message === void 0 ? void 0 : message.message);
            }, resendMessage: function () {
                setShowContextMenu(false);
                resendMessage(message);
            } }))));
}


//# sourceMappingURL=OpenchannelOGMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenchannelThumbnailMessage.js








































var SUPPORTING_TYPES = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    UNSUPPORTED: 'UNSUPPORTED',
};
var SUPPORTED_MIMES = {
    IMAGE: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
    ],
    VIDEO: [
        'video/mpeg',
        'video/ogg',
        'video/webm',
        'video/mp4',
    ],
};
var getSupportingFileType = function (type) {
    if (SUPPORTED_MIMES.IMAGE.indexOf(type) >= 0) {
        return SUPPORTING_TYPES.IMAGE;
    }
    if (SUPPORTED_MIMES.VIDEO.indexOf(type) >= 0) {
        return SUPPORTING_TYPES.VIDEO;
    }
    return SUPPORTING_TYPES.UNSUPPORTED;
};

function OpenchannelThumbnailMessage(_a) {
    var _b;
    var className = _a.className, message = _a.message, isOperator = _a.isOperator, _c = _a.isEphemeral, isEphemeral = _c === void 0 ? false : _c, disabled = _a.disabled, userId = _a.userId, chainTop = _a.chainTop, onClick = _a.onClick, showRemove = _a.showRemove, resendMessage = _a.resendMessage;
    var type = message.type, url = message.url, thumbnails = message.thumbnails, localUrl = message.localUrl;
    var status = message === null || message === void 0 ? void 0 : message.sendingStatus;
    var thumbnailUrl = (thumbnails && thumbnails.length > 0 && thumbnails[0].url) || null;
    var _d = (0,bundle_PhH_XFy.u)(), stringSet = _d.stringSet, dateLocale = _d.dateLocale;
    var _e = (0,bundle_Bv8KtnvF.u)(), disableUserProfile = _e.disableUserProfile, renderUserProfile = _e.renderUserProfile;
    var _f = (0,react.useState)(360), messageWidth = _f[0], setMessageWidth = _f[1];
    var _g = (0,react.useState)(false), contextMenu = _g[0], setContextMenu = _g[1];
    var messageRef = (0,react.useRef)(null);
    var mobileMenuRef = (0,react.useRef)(null);
    var contextMenuRef = (0,react.useRef)(null);
    var avatarRef = (0,react.useRef)(null);
    var onLongPress = (0,bundle_CruP9bVM.u)({
        onLongPress: function () { setContextMenu(true); },
        onClick: function () { onClick(true); },
    });
    var isMobile = (0,bundle_R3uJ_0BB.u)().isMobile;
    var memorizedThumbnailPlaceHolder = (0,react.useMemo)(function () { return function (type) { return function (_a) {
        var style = _a.style;
        return ( // eslint-disable-line
        react.createElement("div", { style: style },
            react.createElement(ui_Icon/* default */.ZP, { type: type, fillColor: ui_Icon/* IconColors.ON_BACKGROUND_2 */.zo.ON_BACKGROUND_2, width: "56px", height: "56px" })));
    }; }; }, []);
    var isMessageSent = checkIsSent(status);
    var isPending = checkIsPending(status);
    var isFailed = checkIsFailed(status);
    var sender = getSenderFromMessage(message);
    (0,react.useEffect)(function () {
        var _a, _b;
        var thumbnailWidth = ((_b = (_a = messageRef === null || messageRef === void 0 ? void 0 : messageRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0) - 80;
        setMessageWidth(thumbnailWidth > 360 ? 360 : thumbnailWidth);
    }, []);
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], (Array.isArray(className) ? className : [className]), true), [
                'sendbird-openchannel-thumbnail-message',
            ], false).join(' '), ref: messageRef },
            react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__left" }, !chainTop && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (react.createElement(bundle_52W7LREX.A, { className: "sendbird-openchannel-thumbnail-message__left__avatar", src: sender.profileUrl || '', ref: avatarRef, width: "28px", height: "28px", onClick: function () {
                        if (!disableUserProfile) {
                            toggleDropdown();
                        }
                    } })); }, menuItems: function (closeDropdown) { return (renderUserProfile
                    ? (renderUserProfile({
                        user: sender,
                        close: closeDropdown,
                        currentUserId: userId,
                        avatarRef: avatarRef,
                    }))
                    : (react.createElement(bundle_ml_PByBw.b, { parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                        react.createElement(UserProfile/* default */.Z, { user: sender, onSuccess: closeDropdown, disableMessaging: true })))); } }))),
            react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right" },
                !chainTop && (react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right__title" },
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-thumbnail-message__right__title__sender-name", type: bundle_ixnsp7Bg.a.CAPTION_2, color: isOperator ? bundle_ixnsp7Bg.b.SECONDARY_3 : bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, sender && (sender.friendName
                        || sender.nickname
                        || sender.userId)),
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-thumbnail-message__right__title__sent-at", type: bundle_ixnsp7Bg.a.CAPTION_3, color: bundle_ixnsp7Bg.b.ONBACKGROUND_3 }, (message === null || message === void 0 ? void 0 : message.createdAt) && ((0,bundle_QTCuDZTl.f)(message.createdAt, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                        locale: dateLocale,
                    }))))),
                react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right__body", ref: mobileMenuRef },
                    react.createElement("div", (0,bundle_XQWyv823._)({ className: "sendbird-openchannel-thumbnail-message__right__body__wrap", role: "button", onClick: function () {
                            if (isMessageSent) {
                                onClick(true);
                            }
                        }, onKeyDown: function () {
                            if (isMessageSent) {
                                onClick(true);
                            }
                        }, tabIndex: 0 }, (isMobile ? (0,bundle_XQWyv823._)({}, onLongPress) : {})),
                        react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__overlay" }),
                        (_b = {},
                            _b[SUPPORTING_TYPES.VIDEO] = ((url || localUrl)
                                ? (react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__video" },
                                    (thumbnailUrl)
                                        ? (react.createElement(ImageRenderer/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__video", url: thumbnailUrl, width: messageWidth, height: "270px", alt: "image", placeHolder: memorizedThumbnailPlaceHolder(ui_Icon/* IconTypes.PLAY */.Qy.PLAY) }))
                                        : (react.createElement("video", { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__video__video" },
                                            react.createElement("source", { src: url || localUrl, type: type }))),
                                    react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__video__icon", type: ui_Icon/* IconTypes.PLAY */.Qy.PLAY, fillColor: ui_Icon/* IconColors.ON_BACKGROUND_2 */.zo.ON_BACKGROUND_2, width: "56px", height: "56px" })))
                                : (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__video--icon", type: ui_Icon/* IconTypes.PHOTO */.Qy.PHOTO, fillColor: ui_Icon/* IconColors.ON_BACKGROUND_2 */.zo.ON_BACKGROUND_2, width: "56px", height: "56px" }))),
                            _b[SUPPORTING_TYPES.IMAGE] = ((url || localUrl)
                                ? (react.createElement(ImageRenderer/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__image", url: thumbnailUrl || url || localUrl || '', alt: "image", width: messageWidth, height: "270px", placeHolder: memorizedThumbnailPlaceHolder(ui_Icon/* IconTypes.PHOTO */.Qy.PHOTO) }))
                                : (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__image--icon", type: ui_Icon/* IconTypes.PHOTO */.Qy.PHOTO, fillColor: ui_Icon/* IconColors.ON_BACKGROUND_2 */.zo.ON_BACKGROUND_2, width: "56px", height: "56px" }))),
                            _b[SUPPORTING_TYPES.UNSUPPORTED] = (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__body__wrap__unknown", type: ui_Icon/* IconTypes.PHOTO */.Qy.PHOTO, fillColor: ui_Icon/* IconColors.ON_BACKGROUND_2 */.zo.ON_BACKGROUND_2, width: "56px", height: "56px" })),
                            _b)[getSupportingFileType(type)])),
                (isPending || isFailed) && (react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__right__tail" },
                    isPending && (react.createElement(ui_Loader/* default */.Z, { width: "16px", height: "16px" },
                        react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__tail__pending", type: ui_Icon/* IconTypes.SPINNER */.Qy.SPINNER, fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY, width: "16px", height: "16px" }))),
                    isFailed && (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-thumbnail-message__right__tail__failed", type: ui_Icon/* IconTypes.ERROR */.Qy.ERROR, fillColor: ui_Icon/* IconColors.ERROR */.zo.ERROR, width: "16px", height: "16px" }))))),
            !isMobile && (react.createElement("div", { className: "sendbird-openchannel-thumbnail-message__context-menu", ref: contextMenuRef }, (isFineResend({ message: message, userId: userId, status: status }) || !isEphemeral) && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (showMenuTrigger({ message: message, userId: userId, status: status }) && (react.createElement(ui_IconButton/* default */.Z, { className: "sendbird-openchannel-thumbnail-message__context-menu--icon", width: "32px", height: "32px", onClick: toggleDropdown },
                    react.createElement(ui_Icon/* default */.ZP, { type: ui_Icon/* IconTypes.MORE */.Qy.MORE, fillColor: ui_Icon/* IconColors.CONTENT_INVERSE */.zo.CONTENT_INVERSE, width: "24px", height: "24px" })))); }, menuItems: function (closeDropdown) { return (react.createElement(bundle_ml_PByBw.b, { parentRef: contextMenuRef, parentContainRef: contextMenuRef, closeDropdown: closeDropdown, openLeft: true },
                    isFineResend({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                            resendMessage(message);
                            closeDropdown();
                        }, testID: "open_channel_thumbnail_message_menu_resend" }, stringSet.CONTEXT_MENU_DROPDOWN__RESEND)),
                    (!isEphemeral && isFineDelete({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                            if (disabled) {
                                return;
                            }
                            showRemove(true);
                            closeDropdown();
                        }, testID: "open_channel_thumbnail_message_menu_delete" }, stringSet.CONTEXT_MENU_DROPDOWN__DELETE)))); } }))))),
        contextMenu && (react.createElement(OpenChannelMobileMenu, { message: message, parentRef: mobileMenuRef, hideMenu: function () {
                setContextMenu(false);
            }, showRemove: function () {
                setContextMenu(false);
                showRemove(true);
            }, resendMessage: function () {
                setContextMenu(false);
                resendMessage(message);
            } }))));
}


//# sourceMappingURL=OpenchannelThumbnailMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenchannelFileMessage.js










































var checkFileType = function (fileUrl) {
    var audioFile = /(\.mp3)$/i;
    var gifFile = /(\.gif)$/i;
    if (audioFile.test(fileUrl)) {
        return ui_Icon/* IconTypes.FILE_AUDIO */.Qy.FILE_AUDIO;
    }
    if (gifFile.test(fileUrl)) {
        return ui_Icon/* IconTypes.GIF */.Qy.GIF;
    }
    return ui_Icon/* IconTypes.FILE_DOCUMENT */.Qy.FILE_DOCUMENT;
};
var truncate = function (fullStr, strLen) {
    if (fullStr === null || fullStr === undefined)
        return '';
    if (fullStr.length <= strLen)
        return fullStr;
    var separator = '...';
    var sepLen = separator.length;
    var charsToShow = strLen - sepLen;
    var frontChars = Math.ceil(charsToShow / 2);
    var backChars = Math.floor(charsToShow / 2);
    return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars);
};

function OpenChannelFileMessage(_a) {
    var className = _a.className, message = _a.message, isOperator = _a.isOperator, _b = _a.isEphemeral, isEphemeral = _b === void 0 ? false : _b, userId = _a.userId, disabled = _a.disabled, chainTop = _a.chainTop, showRemove = _a.showRemove, resendMessage = _a.resendMessage;
    var status = message === null || message === void 0 ? void 0 : message.sendingStatus;
    var _c = (0,bundle_PhH_XFy.u)(), dateLocale = _c.dateLocale, stringSet = _c.stringSet;
    var contextMenuRef = (0,react.useRef)(null);
    var mobileMenuRef = (0,react.useRef)(null);
    var avatarRef = (0,react.useRef)(null);
    var _d = (0,bundle_Bv8KtnvF.u)(), disableUserProfile = _d.disableUserProfile, renderUserProfile = _d.renderUserProfile;
    var isMobile = (0,bundle_R3uJ_0BB.u)().isMobile;
    var openFileUrl = function () { return (0,bundle_BHC96gO0.o)(message.url); };
    var isPending = checkIsPending(status);
    var isFailed = checkIsFailed(status);
    var sender = getSenderFromMessage(message);
    var _e = (0,react.useState)(false), contextMenu = _e[0], setContextMenu = _e[1];
    var longPress = (0,bundle_CruP9bVM.u)({
        onLongPress: function () {
            if (isMobile) {
                setContextMenu(true);
            }
        },
        onClick: openFileUrl,
    }, { delay: 300 });
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: (0,bundle_XQWyv823.c)((0,bundle_XQWyv823.c)([], (Array.isArray(className) ? className : [className]), true), [
                'sendbird-openchannel-file-message',
            ], false).join(' '), ref: mobileMenuRef },
            react.createElement("div", { className: "sendbird-openchannel-file-message__left" }, !chainTop && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (react.createElement(bundle_52W7LREX.A, { className: "sendbird-openchannel-file-message__left__avatar", src: sender.profileUrl || '', ref: avatarRef, width: "28px", height: "28px", onClick: function () {
                        if (!disableUserProfile) {
                            toggleDropdown();
                        }
                    } })); }, menuItems: function (closeDropdown) { return (renderUserProfile
                    ? (renderUserProfile({
                        user: sender,
                        close: closeDropdown,
                        currentUserId: userId,
                        avatarRef: avatarRef,
                    }))
                    : (react.createElement(bundle_ml_PByBw.b, { parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                        react.createElement(UserProfile/* default */.Z, { user: sender, onSuccess: closeDropdown, disableMessaging: true })))); } }))),
            react.createElement("div", { className: "sendbird-openchannel-file-message__right" },
                !chainTop && (react.createElement("div", { className: "sendbird-openchannel-file-message__right__title" },
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-file-message__right__title__sender-name", type: bundle_ixnsp7Bg.a.CAPTION_2, color: isOperator ? bundle_ixnsp7Bg.b.SECONDARY_3 : bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, sender && (sender.friendName
                        || sender.nickname
                        || sender.userId)),
                    react.createElement(bundle_ixnsp7Bg.L, { className: "sendbird-openchannel-file-message__right__title__sent-at", type: bundle_ixnsp7Bg.a.CAPTION_3, color: bundle_ixnsp7Bg.b.ONBACKGROUND_3 }, (message === null || message === void 0 ? void 0 : message.createdAt) && ((0,bundle_QTCuDZTl.f)(message.createdAt, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                        locale: dateLocale,
                    }))))),
                react.createElement("div", (0,bundle_XQWyv823._)({ className: "sendbird-openchannel-file-message__right__body" }, (isMobile ? (0,bundle_XQWyv823._)({}, longPress) : {})),
                    checkFileType(message.url) && (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-file-message__right__body__icon", type: checkFileType(message.url), fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY, width: "48px", height: "48px" })),
                    react.createElement(ui_TextButton/* default */.Z, { className: "sendbird-openchannel-file-message__right__body__file-name", onClick: openFileUrl },
                        react.createElement(bundle_ixnsp7Bg.L, { type: bundle_ixnsp7Bg.a.BODY_1, color: bundle_ixnsp7Bg.b.ONBACKGROUND_1 }, truncate(message.name || message.url, 40)))),
                (isPending || isFailed) && (react.createElement("div", { className: "sendbird-openchannel-file-message__right__tail" },
                    isPending && (react.createElement(ui_Loader/* default */.Z, { width: "16px", height: "16px" },
                        react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-file-message__right__tail__pending", type: ui_Icon/* IconTypes.SPINNER */.Qy.SPINNER, fillColor: ui_Icon/* IconColors.PRIMARY */.zo.PRIMARY, width: "16px", height: "16px" }))),
                    isFailed && (react.createElement(ui_Icon/* default */.ZP, { className: "sendbird-openchannel-file-message__right__tail__failed", type: ui_Icon/* IconTypes.ERROR */.Qy.ERROR, fillColor: ui_Icon/* IconColors.ERROR */.zo.ERROR, width: "16px", height: "16px" }))))),
            !isMobile && (react.createElement("div", { className: "sendbird-openchannel-file-message__context-menu", ref: contextMenuRef }, (isFineResend({ message: message, userId: userId, status: status }) || !isEphemeral) && (react.createElement(bundle_ml_PByBw.C, { menuTrigger: function (toggleDropdown) { return (showMenuTrigger({ message: message, userId: userId, status: status }) && (react.createElement(ui_IconButton/* default */.Z, { className: "sendbird-openchannel-file-message__context-menu__icon", width: "32px", height: "32px", onClick: toggleDropdown },
                    react.createElement(ui_Icon/* default */.ZP, { type: ui_Icon/* IconTypes.MORE */.Qy.MORE, width: "24px", height: "24px" })))); }, menuItems: function (closeDropdown) { return (react.createElement(bundle_ml_PByBw.b, { parentRef: contextMenuRef, parentContainRef: contextMenuRef, closeDropdown: closeDropdown, openLeft: true },
                    isFineResend({ message: message, userId: userId, status: status }) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                            if (disabled) {
                                return;
                            }
                            resendMessage(message);
                            closeDropdown();
                        }, testID: "open_channel_file_message_context_menu_resend" }, stringSet.CONTEXT_MENU_DROPDOWN__RESEND)),
                    (!isEphemeral && isFineDelete({ message: message, userId: userId, status: status })) && (react.createElement(bundle_ml_PByBw.c, { onClick: function () {
                            if (disabled) {
                                return;
                            }
                            showRemove(true);
                            closeDropdown();
                        }, testID: "open_channel_file_message_context_menu_delete" }, stringSet.CONTEXT_MENU_DROPDOWN__DELETE)))); } }))))),
        contextMenu && (react.createElement(OpenChannelMobileMenu, { message: message, hideMenu: function () {
                setContextMenu(false);
            }, parentRef: mobileMenuRef, showRemove: function () {
                setContextMenu(false);
                showRemove(true);
            } }))));
}


//# sourceMappingURL=OpenchannelFileMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/OpenChannelMessage.js




































































function OpenChannelMessage_RemoveMessageModal(_a) {
    var message = _a.message, onCloseModal = _a.onCloseModal, onDeleteMessage = _a.onDeleteMessage;
    var stringSet = (0,react.useContext)(bundle_PhH_XFy.L).stringSet;
    return (react.createElement(bundle_NL8iE1lF.M, { onCancel: onCloseModal, onSubmit: onDeleteMessage, submitText: stringSet.MESSAGE_MENU__DELETE, titleText: (0,bundle_B8L7dGsu.g)(stringSet, message) }));
}

var MessageTypes = {
    ADMIN: 'ADMIN',
    USER: 'USER',
    FILE: 'FILE',
    THUMBNAIL: 'THUMBNAIL',
    OG: 'OG',
    UNKNOWN: 'UNKNOWN',
};
var SendingMessageStatus = {
    NONE: 'none',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
};
var getMessageType = function (message, options) {
    var _a, _b;
    var isOgMessageEnabledInOpenChannel = options === null || options === void 0 ? void 0 : options.isOgMessageEnabledInOpenChannel;
    if (((_a = message === null || message === void 0 ? void 0 : message.isUserMessage) === null || _a === void 0 ? void 0 : _a.call(message)) || (message === null || message === void 0 ? void 0 : message.messageType) === 'user') {
        return ((message === null || message === void 0 ? void 0 : message.ogMetaData) && isOgMessageEnabledInOpenChannel)
            ? MessageTypes.OG
            : MessageTypes.USER;
    }
    if ((_b = message === null || message === void 0 ? void 0 : message.isAdminMessage) === null || _b === void 0 ? void 0 : _b.call(message)) {
        return MessageTypes.ADMIN;
    }
    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'file') {
        return ((0,bundle_D_9RmNe.j)(message.type) || (0,bundle_D_9RmNe.h)(message.type))
            ? MessageTypes.THUMBNAIL
            : MessageTypes.FILE;
    }
    return MessageTypes.UNKNOWN;
};

function OpenChannelMessage(props) {
    var _a;
    var _b;
    var message = props.message, chainTop = props.chainTop, chainBottom = props.chainBottom, hasSeparator = props.hasSeparator, renderMessage = props.renderMessage;
    var _c = bundle_Dil0V6Tg_useOpenChannelContext(), currentOpenChannel = _c.currentOpenChannel, deleteMessage = _c.deleteMessage, updateMessage = _c.updateMessage, resendMessage = _c.resendMessage;
    var _d = (0,bundle_PhH_XFy.u)(), dateLocale = _d.dateLocale, stringSet = _d.stringSet;
    var editDisabled = currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isFrozen;
    var globalState = (0,uikit_react_useSendbirdStateContext/* useSendbirdStateContext */.A)();
    var currentUserId = (_b = globalState === null || globalState === void 0 ? void 0 : globalState.config) === null || _b === void 0 ? void 0 : _b.userId;
    var isOgMessageEnabledInOpenChannel = globalState.config.openChannel.enableOgtag;
    var sender;
    if ((message === null || message === void 0 ? void 0 : message.messageType) !== 'admin') {
        sender = message === null || message === void 0 ? void 0 : message.sender;
    }
    var _e = (0,react.useState)(false), showEdit = _e[0], setShowEdit = _e[1];
    var _f = (0,react.useState)(false), showRemove = _f[0], setShowRemove = _f[1];
    var _g = (0,react.useState)(false), showFileViewer = _g[0], setShowFileViewer = _g[1];
    var editMessageInputRef = (0,react.useRef)(null);
    var isByMe = false;
    if (sender && (message === null || message === void 0 ? void 0 : message.messageType) !== 'admin') {
        // pending and failed messages are by me
        isByMe = currentUserId === sender.userId
            || (message === null || message === void 0 ? void 0 : message.sendingStatus)
                === SendingMessageStatus.PENDING
            || (message === null || message === void 0 ? void 0 : message.sendingStatus)
                === SendingMessageStatus.FAILED;
    }
    if (renderMessage) {
        return (react.createElement("div", { className: "sendbird-msg-hoc sendbird-msg--scroll-ref", "data-testid": "sendbird-message-hoc" }, renderMessage({ message: message, chainTop: chainTop, chainBottom: chainBottom })));
    }
    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'user' && showEdit) {
        return (react.createElement(MessageInput/* default */.Z, { isEdit: true, channel: currentOpenChannel, disabled: editDisabled, ref: editMessageInputRef, message: message, onUpdateMessage: function (_a) {
                var messageId = _a.messageId, message = _a.message;
                updateMessage(messageId, message);
                setShowEdit(false);
            }, onCancelEdit: function () {
                setShowEdit(false);
            } }));
    }
    return (react.createElement("div", { className: "sendbird-msg-hoc sendbird-msg--scroll-ref", "data-testid": "sendbird-message-hoc" },
        react.createElement(react.Fragment, null,
            hasSeparator && (message === null || message === void 0 ? void 0 : message.createdAt) && (react.createElement(DateSeparator/* default */.Z, null,
                react.createElement(bundle_ixnsp7Bg.L, { type: bundle_ixnsp7Bg.a.CAPTION_2, color: bundle_ixnsp7Bg.b.ONBACKGROUND_2 }, (0,bundle_QTCuDZTl.f)(message === null || message === void 0 ? void 0 : message.createdAt, stringSet.DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR, { locale: dateLocale })))),
            (_a = {},
                _a[MessageTypes.ADMIN] = (function () {
                    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'admin') {
                        return (react.createElement(OpenChannelAdminMessage, { message: message }));
                    }
                })(),
                _a[MessageTypes.FILE] = (function () {
                    var _a;
                    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'file') {
                        return (react.createElement(OpenChannelFileMessage, { message: message, isOperator: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isOperator((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId), isEphemeral: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isEphemeral, disabled: editDisabled, userId: currentUserId, showRemove: setShowRemove, resendMessage: resendMessage, chainTop: chainTop, chainBottom: chainBottom }));
                    }
                })(),
                _a[MessageTypes.OG] = (function () {
                    var _a;
                    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'user'
                        && isOgMessageEnabledInOpenChannel) {
                        return (react.createElement(OpenChannelOGMessage, { message: message, isOperator: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isOperator((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId), isEphemeral: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isEphemeral, userId: currentUserId, showEdit: setShowEdit, disabled: editDisabled, showRemove: setShowRemove, resendMessage: resendMessage, chainTop: chainTop, chainBottom: chainBottom }));
                    }
                })(),
                _a[MessageTypes.THUMBNAIL] = (function () {
                    var _a;
                    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'file') {
                        return (react.createElement(OpenchannelThumbnailMessage, { message: message, isOperator: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isOperator((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId), isEphemeral: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isEphemeral, disabled: editDisabled, userId: currentUserId, showRemove: setShowRemove, resendMessage: resendMessage, onClick: setShowFileViewer, chainTop: chainTop, chainBottom: chainBottom }));
                    }
                })(),
                _a[MessageTypes.USER] = (function () {
                    var _a;
                    if ((message === null || message === void 0 ? void 0 : message.messageType) === 'user') {
                        return (react.createElement(OpenchannelUserMessage, { message: message, isOperator: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isOperator((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId), isEphemeral: currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isEphemeral, userId: currentUserId, disabled: editDisabled, showEdit: setShowEdit, showRemove: setShowRemove, resendMessage: resendMessage, chainTop: chainTop, chainBottom: chainBottom }));
                    }
                })(),
                _a[MessageTypes.UNKNOWN] = (function () {
                    // return (
                    //   <OpenChannelUnknownMessage message={message} />
                    // );
                })(),
                _a)[getMessageType(message, { isOgMessageEnabledInOpenChannel: isOgMessageEnabledInOpenChannel })],
            showRemove && (react.createElement(OpenChannelMessage_RemoveMessageModal, { message: message, onCloseModal: function () { return setShowRemove(false); }, onDeleteMessage: function () {
                    if ((message === null || message === void 0 ? void 0 : message.messageType) !== 'admin') {
                        deleteMessage(message);
                    }
                } })),
            showFileViewer && (message === null || message === void 0 ? void 0 : message.messageType) === 'file' && (react.createElement(ui_FileViewer/* default */.Z, { onClose: function () { return setShowFileViewer(false); }, message: message, onDelete: function () { return deleteMessage(message); }, isByMe: isByMe })))));
}


//# sourceMappingURL=OpenChannelMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/OpenChannelMessageList.js












































































function OpenChannelMessageList_OpenChannelMessageList(props, ref) {
    var _a = bundle_Dil0V6Tg_useOpenChannelContext(), _b = _a.isMessageGroupingEnabled, isMessageGroupingEnabled = _b === void 0 ? true : _b, allMessages = _a.allMessages, hasMore = _a.hasMore, onScroll = _a.onScroll;
    var store = (0,uikit_react_useSendbirdStateContext/* useSendbirdStateContext */.A)();
    var userId = store.config.userId;
    var localRef = (0,react.useRef)(null);
    var scrollRef = ref || localRef;
    var _c = (0,react.useState)(false), showScrollDownButton = _c[0], setShowScrollDownButton = _c[1];
    var scrollToBottom = function () {
        if (scrollRef && 'current' in scrollRef && scrollRef.current) {
            scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
            setShowScrollDownButton(false);
        }
    };
    var handleOnScroll = bundle_Bj90BL0E_useHandleOnScrollCallback({
        setShowScrollDownButton: setShowScrollDownButton,
        hasMore: hasMore,
        onScroll: onScroll,
        scrollRef: scrollRef,
    });
    var memoizedMessageList = (0,react.useMemo)(function () {
        var _a;
        if (allMessages.length > 0) {
            return (allMessages.map(function (message, index) {
                var _a;
                var previousMessage = allMessages[index - 1];
                var nextMessage = allMessages[index - 1];
                var previousMessageCreatedAt = previousMessage && previousMessage.createdAt;
                var currentCreatedAt = message === null || message === void 0 ? void 0 : message.createdAt;
                // https://stackoverflow.com/a/41855608
                var hasSeparator = !(previousMessageCreatedAt && ((0,bundle_BAXCq_Wt.i)(currentCreatedAt, previousMessageCreatedAt)));
                var _b = isMessageGroupingEnabled
                    ? (0,compareMessagesForGrouping/* compareMessagesForGrouping */.kt)(previousMessage, message, nextMessage)
                    : [false, false], chainTop = _b[0], chainBottom = _b[1];
                var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
                var key = (message === null || message === void 0 ? void 0 : message.messageId) || (message === null || message === void 0 ? void 0 : message.reqId);
                return (react.createElement(context/* MessageProvider */.x, { message: message, isByMe: isByMe, key: key },
                    react.createElement(OpenChannelMessage, { message: message, chainTop: chainTop, chainBottom: chainBottom, hasSeparator: hasSeparator, renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage })));
            }));
        }
        return (((_a = props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList) === null || _a === void 0 ? void 0 : _a.call(props)) || (react.createElement(ui_PlaceHolder/* default */.Z, { className: "sendbird-openchannel-conversation-scroll__container__place-holder", type: ui_PlaceHolder/* PlaceHolderTypes.NO_MESSAGES */.v.NO_MESSAGES })));
    }, [allMessages]);
    return (react.createElement("div", { className: "sendbird-openchannel-conversation-scroll" },
        react.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container" },
            react.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container__padding" }),
            react.createElement("div", { className: [
                    'sendbird-openchannel-conversation-scroll__container__item-container',
                    (allMessages.length > 0) ? '' : 'no-messages',
                ].join(' '), onScroll: handleOnScroll, ref: scrollRef }, memoizedMessageList)),
        showScrollDownButton && (react.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container__scroll-bottom-button", onClick: scrollToBottom, onKeyDown: scrollToBottom, tabIndex: 0, role: "button" },
            react.createElement(ui_Icon/* default */.ZP, { width: "24px", height: "24px", type: ui_Icon/* IconTypes.CHEVRON_DOWN */.Qy.CHEVRON_DOWN, fillColor: ui_Icon/* IconColors.CONTENT */.zo.CONTENT })))));
}
var OpenChannelMessageList$1 = react.forwardRef(OpenChannelMessageList_OpenChannelMessageList);


//# sourceMappingURL=OpenChannelMessageList.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel/components/OpenChannelUI.js
















































































var COMPONENT_CLASS_NAME = 'sendbird-openchannel-conversation';
var OpenChannelUI_OpenChannelUI = function (_a) {
    var renderMessage = _a.renderMessage, renderHeader = _a.renderHeader, renderPlaceHolderEmptyList = _a.renderPlaceHolderEmptyList, renderPlaceHolderError = _a.renderPlaceHolderError, renderPlaceHolderLoading = _a.renderPlaceHolderLoading, renderMessageInput = _a.renderMessageInput, renderInput = _a.renderInput;
    var _b = useOpenChannelContext(), currentOpenChannel = _b.currentOpenChannel, amIBanned = _b.amIBanned, loading = _b.loading, isInvalid = _b.isInvalid, messageInputRef = _b.messageInputRef, conversationScrollRef = _b.conversationScrollRef;
    if (!currentOpenChannel
        || !(currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.url)
        || amIBanned) {
        return ((renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.NO_CHANNELS })));
    }
    if (loading) {
        return ((renderPlaceHolderLoading === null || renderPlaceHolderLoading === void 0 ? void 0 : renderPlaceHolderLoading())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING })));
    }
    if (isInvalid) {
        return ((renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG })));
    }
    var renderInputComponent = renderMessageInput || renderInput;
    return (React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
        (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || React__default.createElement(OpenchannelConversationHeader, null),
        (currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isFrozen) && React__default.createElement(FrozenNotification, null),
        React__default.createElement(OpenChannelMessageList, { ref: conversationScrollRef, renderMessage: renderMessage, renderPlaceHolderEmptyList: renderPlaceHolderEmptyList }),
        (renderInputComponent === null || renderInputComponent === void 0 ? void 0 : renderInputComponent()) || React__default.createElement(OpenChannelInput, { ref: messageInputRef })));
};


//# sourceMappingURL=OpenChannelUI.js.map

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/OpenChannel.js

















































































var OpenChannel_OpenChannel = function (props) {
    return (React__default.createElement(OpenChannelProvider, { channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl, isMessageGroupingEnabled: props === null || props === void 0 ? void 0 : props.isMessageGroupingEnabled, queries: props === null || props === void 0 ? void 0 : props.queries, messageLimit: props === null || props === void 0 ? void 0 : props.messageLimit, onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage, onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage, onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick, disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile, onBackClick: props === null || props === void 0 ? void 0 : props.onBackClick },
        React__default.createElement(OpenChannelUI, { renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage, renderHeader: props === null || props === void 0 ? void 0 : props.renderHeader, renderInput: props === null || props === void 0 ? void 0 : props.renderInput, renderMessageInput: props === null || props === void 0 ? void 0 : props.renderMessageInput, renderPlaceHolderEmptyList: props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList, renderPlaceHolderError: props === null || props === void 0 ? void 0 : props.renderPlaceHolderError, renderPlaceHolderLoading: props === null || props === void 0 ? void 0 : props.renderPlaceHolderLoading })));
};


//# sourceMappingURL=OpenChannel.js.map

// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings.js
var OpenChannelSettings = __webpack_require__(66099);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings/components/OpenChannelSettingsUI.js
var OpenChannelSettingsUI = __webpack_require__(73798);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings/context.js
var OpenChannelSettings_context = __webpack_require__(95697);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings/components/OperatorUI.js
var OperatorUI = __webpack_require__(65192);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings/components/OpenChannelProfile.js
var OpenChannelProfile = __webpack_require__(78595);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/OpenChannelAvatar.js
var OpenChannelAvatar = __webpack_require__(23170);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/OpenChannelSettings/components/EditDetailsModal.js
var EditDetailsModal = __webpack_require__(77831);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/chunks/bundle-DX03rGyh.js
var bundle_DX03rGyh = __webpack_require__(47689);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/AccordionGroup.js
var AccordionGroup = __webpack_require__(78757);
// EXTERNAL MODULE: ./node_modules/@sendbird/uikit-react/ui/Accordion.js
var Accordion = __webpack_require__(72248);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-react/index.js























































































































































































































































//# sourceMappingURL=index.js.map


/***/ }),

/***/ 22284:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lo": function() { return /* binding */ getCreateGroupChannel; }
/* harmony export */ });
/* unused harmony exports UikitMessageHandler, default, getConnect, getCreateOpenChannel, getDeleteMessage, getDisconnect, getEnterOpenChannel, getExitOpenChannel, getFreezeChannel, getGetGroupChannel, getGetOpenChannel, getLeaveGroupChannel, getPubSub, getResendFileMessage, getResendUserMessage, getSdk, getSendFileMessage, getSendUserMessage, getUnfreezeChannel, getUpdateUserInfo, getUpdateUserMessage */
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80360);



/**
 * 1. UIKit Instances
 *    a. getSdk
 *    b. getPubSub
 * 2. Chat & Connection
 *    a. getConnect
 *    b. getDisconnect
 *    c. getUpdateUserInfo
 * 3. Channel
 *    a. getCreateGroupChannel
 *    b. getCreateOpenChannel
 *    c. getGetGroupChannel
 *    d. getGetOpenChannel
 *    e. getLeaveGroupChannel
 *    f. getEnterOpenChannel
 *    g. getExitOpenChannel
 *    h. getFreezeChannel
 *    i. getUnfreezeChannel
 * 4. Message
 *    a. getSendUserMessage
 *    b. getSendFileMessage
 *    c. getUpdateUserMessage
 *    d. x - getUpdateFileMessage
 *    e. getDeleteMessage
 *    f. getResendUserMessage
 *    g. getResendFileMessage
 */
/**
 * import useSendbirdStateContext from '@sendbird-uikit/useSendbirdStateContext'
 * import selectors from '@sendbird-uikit/send'
 * const state = useSendbirdStateContext();
 */
// 1. UIKit Instances
/**
 * const sdk = selectors.getSdk(state);
 */
var getSdk = function (state) {
    var _a = state.stores, stores = _a === void 0 ? {} : _a;
    var _b = stores.sdkStore, sdkStore = _b === void 0 ? {} : _b;
    var sdk = sdkStore.sdk;
    return sdk;
};
/**
 * const pubSub = selectors.getPubSub(state);
 */
var getPubSub = function (state) {
    var _a = state.config, config = _a === void 0 ? {} : _a;
    var pubSub = config.pubSub;
    return pubSub;
};
// 2. Chat & Connection
/**
 * const connect = selectors.getConnect(state);
 * connect('user-id-sendbirdian', 'access-token-0000')
 *  .then((user) => {})
 *  .catch((error) => {})
 */
var getConnect = function (state) { return (function (userId, accessToken) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!((sdk === null || sdk === void 0 ? void 0 : sdk.connect) && typeof sdk.connect === 'function')) {
        reject(new Error('Not found the function "connect'));
    }
    if (!accessToken) {
        sdk.connect(userId)
            .then(function (res) { return resolve(res); })
            .catch(function (err) { return reject(err); });
    }
    else {
        sdk.connect(userId, accessToken)
            .then(function (res) { return resolve(res); })
            .catch(function (err) { return reject(err); });
    }
})); }); };
/**
 * const disconnect = selectors.getDisconnect(state);
 * disconnect()
 *  .then(() => {})
 *  .catch((error) => {})
 */
var getDisconnect = function (state) { return (function () { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!(sdk.disconnect && typeof sdk.disconnect === 'function')) {
        reject(new Error('Not found the function "disconnect'));
    }
    sdk.disconnect()
        .then(function (res) { return resolve(res); })
        .catch(function (err) { return reject(err); });
})); }); };
/**
 * const updateUserInfo = selectors.getUpdateUserInfo(state);
 * updateUserInfo('new-nickname', 'new-profile-url')
 *  .then((user) => {})
 *  .catch((error) => {})
 */
var getUpdateUserInfo = function (state) { return (function (nickname, profileUrl) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!(sdk.updateCurrentUserInfo && typeof sdk.updateCurrentUserInfo === 'function')) {
        reject(new Error('Not found the function "updateCurrentUserInfo"'));
    }
    var userParams = { nickname: nickname };
    if (profileUrl) {
        userParams.profileUrl = profileUrl;
    }
    sdk.updateCurrentUserInfo(userParams)
        .then(function (res) { return resolve(res); })
        .catch(function (err) { return reject(err); });
})); }); };
// 3. Channel
/**
 * const createGroupChannel = selectors.getCreateGroupChannel(state);
 * createGroupChannel(channelParams: GroupChannelCreateParams)
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getCreateGroupChannel = function (state) { return (function (params) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    var pubSub = getPubSub(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!sdk.groupChannel) {
        reject(new Error('Not found GroupChannelModule'));
    }
    if (!(sdk.groupChannel.createChannel && typeof sdk.groupChannel.createChannel === 'function')) {
        reject(new Error('Not found the function "createChannel"'));
    }
    sdk.groupChannel.createChannel(params)
        .then(function (channel) {
        resolve(channel);
        pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.CREATE_CHANNEL, { channel: channel });
    })
        .catch(reject);
})); }); };
/**
 * const createOpenChannel = selectors.getCreateOpenChannel(state);
 * createOpenChannel(channelParams: OpenChannelCreateParams)
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getCreateOpenChannel = function (state) { return (function (params) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    // const pubSub = getPubSub(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!sdk.openChannel) {
        reject(new Error('Not found OpenChannelModule'));
    }
    if (!(sdk.openChannel.createChannel && typeof sdk.openChannel.createChannel === 'function')) {
        reject(new Error('Not found the function "createChannel"'));
    }
    sdk.openChannel.createChannel(params)
        .then(function (channel) {
        resolve(channel);
        // Consider pubSub process
    })
        .catch(reject);
})); }); };
/**
 * const getGroupChannel = selectors.getGetGroupChannel(state);
 * getGroupChannel('channel-url-1234', isSelected)
 *  .then((channel) => {
 *    // groupChannel = channel;
 *    // or
 *    // setCurrentChannel(channel);
 *  })
 *  .catch((error) => {})
 */
var getGetGroupChannel = function (state) { return (function (channelUrl) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    // const pubSub = getPubSub(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!sdk.groupChannel) {
        reject(new Error('Not found GroupChannelModule'));
    }
    if (!(sdk.groupChannel.getChannel && typeof sdk.groupChannel.getChannel === 'function')) {
        reject(new Error('Not found the function "getChannel"'));
    }
    sdk.groupChannel.getChannel(channelUrl)
        .then(function (channel) {
        resolve(channel);
        // Add pubSub with isSelected
    })
        .catch(reject);
})); }); };
/**
 * const getOpenChannel = selectors.getGetOpenChannel(state);
 * getOpenChannel('channel-url-12345')
 *  .then((channel) => {
 *    // openChannel = channel;
 *    // or
 *    // setCurrentChannel(channel);
 *  })
 *  .catch((error) => {})
 */
var getGetOpenChannel = function (state) { return (function (channelUrl) { return (new Promise(function (resolve, reject) {
    var sdk = getSdk(state);
    // const pubSub = getPubSub(state);
    if (!sdk) {
        reject(new Error('Sdk not found'));
    }
    if (!sdk.openChannel) {
        reject(new Error('Not found OpenChannelModule'));
    }
    if (!(sdk.openChannel.getChannel && typeof sdk.openChannel.getChannel === 'function')) {
        reject(new Error('Not found the function "getChannel"'));
    }
    sdk.openChannel.getChannel(channelUrl)
        .then(function (channel) {
        resolve(channel);
        // Add pubSub with isSelected
    })
        .catch(reject);
})); }); };
/**
 * const leaveChannel = selectors.getLeaveGroupChannel(state);
 * leaveChannel('group-channel-url')
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getLeaveGroupChannel = function (state) { return (function (channelUrl) { return (new Promise(function (resolve, reject) {
    var _a;
    (_a = getGetGroupChannel(state)) === null || _a === void 0 ? void 0 : _a(channelUrl).then(function (channel) {
        channel.leave()
            .then(function () {
            resolve();
            // Add pubSub process
        })
            .catch(reject);
    }).catch(reject);
})); }); };
/**
 * const enterChannel = selectors.getEnterOpenChannel(state);
 * enterChannel('open-channel-url')
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getEnterOpenChannel = function (state) { return (function (channelUrl) { return (new Promise(function (resolve, reject) {
    var _a;
    (_a = getGetOpenChannel(state)) === null || _a === void 0 ? void 0 : _a(channelUrl).then(function (channel) {
        channel.enter()
            .then(function () {
            resolve(channel);
            // Add pubSub process
        })
            .catch(reject);
    }).catch(reject);
})); }); };
/**
 * const exitChannel = selectors.getExitOpenChannel(state);
 * exitChannel('open-channel-url')
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getExitOpenChannel = function (state) { return (function (channelUrl) { return (new Promise(function (resolve, reject) {
    var _a;
    (_a = getGetOpenChannel(state)) === null || _a === void 0 ? void 0 : _a(channelUrl).then(function (channel) {
        channel.exit()
            .then(function () {
            resolve(channel);
            // Add pubSub process
        })
            .catch(reject);
    }).catch(reject);
})); }); };
/**
 * const freezeChannel = selectors.getFreezeChannel(currentChannel);
 * freezeChannel()
 *  .then(() => {})
 *  .catch((error) => {})
 */
var getFreezeChannel = function () { return (function (channel) { return (new Promise(function (resolve, reject) {
    if (!(channel.freeze && typeof (channel === null || channel === void 0 ? void 0 : channel.freeze) === 'function')) {
        reject(new Error('Not found the function "freeze"'));
    }
    channel.freeze()
        .then(function () {
        resolve();
        // Add pubSub process
        /**
         * consider divide the logic to
         * _freezeGroupChannel and _freezeOpenChannel
         */
    })
        .catch(reject);
})); }); };
/**
 * const unfreezeChannel = selectors.getUnfreezeChannel(currentChannel);
 * unfreezeChannel()
 *  .then((channel) => {})
 *  .catch((error) => {})
 */
var getUnfreezeChannel = function () { return (function (channel) { return (new Promise(function (resolve, reject) {
    if (!(channel.unfreeze && typeof (channel === null || channel === void 0 ? void 0 : channel.unfreeze) === 'function')) {
        reject(new Error('Not found the function "unfreeze"'));
    }
    channel.unfreeze()
        .then(function () {
        resolve();
        // Add pubSub process
        /**
         * consider divide the logic to
         * _unfreezeGroupChannel and _unfreezeOpenChannel
         */
    })
        .catch(reject);
})); }); };
// 4. Message
var UikitMessageHandler = /** @class */ (function () {
    function UikitMessageHandler() {
        this._onPending = _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n;
        this._onFailed = _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n;
        this._onSucceeded = _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n;
    }
    UikitMessageHandler.prototype.triggerPending = function (message) {
        this._onPending(message);
    };
    UikitMessageHandler.prototype.triggerFailed = function (error, message) {
        this._onFailed(error, (message === null || message === void 0 ? void 0 : message.isResendable) ? message : null);
    };
    UikitMessageHandler.prototype.triggerSucceeded = function (message) {
        this._onSucceeded(message);
    };
    UikitMessageHandler.prototype.onPending = function (handler) {
        if (typeof handler === 'function') {
            this._onPending = handler;
        }
        return this;
    };
    UikitMessageHandler.prototype.onFailed = function (handler) {
        if (typeof handler === 'function') {
            this._onFailed = handler;
        }
        return this;
    };
    UikitMessageHandler.prototype.onSucceeded = function (handler) {
        if (typeof handler === 'function') {
            this._onSucceeded = handler;
        }
        return this;
    };
    return UikitMessageHandler;
}());
/**
 * const sendUserMessage = selectors.getSendUserMessage(state);
 * sendUserMessage(
 *  channel: GroupChannel | OpenChannel,
 *  params: UserMessageCreateParams,
 * )
 *  .onPending((message) => {})
 *  .onFailed((error, message) => {})
 *  .onSucceeded((message) => {})
 */
var getSendUserMessage = function (state, publishingModules) {
    if (publishingModules === void 0) { publishingModules = []; }
    return (function (channel, params) {
        var handler = new UikitMessageHandler();
        var pubSub = getPubSub(state);
        channel.sendUserMessage(params)
            .onFailed(function (error, message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_MESSAGE_FAILED, { error: error, message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerFailed(error, message);
        })
            .onPending(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_MESSAGE_START, { message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerPending(message);
        })
            .onSucceeded(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_USER_MESSAGE, { message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerSucceeded(message);
        });
        return handler;
    });
};
/**
 * const sendFileMessage = selectors.getSendFileMessage(state);
 * sendFileMessage(
 *  channel: GroupChannel | OpenChannel,
 *  params: FileMessageCreateParams,
 * )
 *  .onPending((message) => {})
 *  .onFailed((error, message) => {})
 *  .onSucceeded((message) => {})
 */
var getSendFileMessage = function (state, publishingModules) {
    if (publishingModules === void 0) { publishingModules = []; }
    return (function (channel, params) {
        var handler = new UikitMessageHandler();
        var pubSub = getPubSub(state);
        channel.sendFileMessage(params)
            .onFailed(function (error, message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_MESSAGE_FAILED, { error: error, message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerFailed(error, message);
        })
            .onPending(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_MESSAGE_START, { message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerPending(message);
        })
            .onSucceeded(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_FILE_MESSAGE, { message: message, channel: channel, publishingModules: publishingModules });
            handler.triggerSucceeded(message);
        });
        return handler;
    });
};
/**
 * const updateUserMessage = selectors.getUpdateUserMessage(state);
 * updateUserMessage(
 *  channel: GroupChannel | OpenChannel,
 *  messageId: number,
 *  messageParams: UserMessageUpdateParams,
 * )
 *  .then((message) => {})
 *  .catch((error) => {})
 */
var getUpdateUserMessage = function (state, publishingModules) {
    if (publishingModules === void 0) { publishingModules = []; }
    return (function (channel, messageId, params) { return (new Promise(function (resolve, reject) {
        var pubSub = getPubSub(state);
        channel.updateUserMessage(messageId, params)
            .then(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.UPDATE_USER_MESSAGE, { message: message, channel: channel, fromSelector: true, publishingModules: publishingModules });
            resolve(message);
        })
            .catch(reject);
    })); });
};
// TODO: We will provie this function in the future
/**
 * const updateFileMessage = selectors.getUpdateFileMessage(state);
 * updateFileMessage(
 *  channel: GroupChannel | OpenChannel,
 *  messageId: number,
 *  params: FileMessageUpdateParams,
 * )
 *  .then((message) => {})
 *  .catch((error) => {})
 */
// const getUpdateFileMessage = (state: SendBirdState) => (
//   (channel: GroupChannel | OpenChannel, messageId: number, params: FileMessageUpdateParams) => (
//     new Promise((resolve, reject) => {
//       const pubSub = getPubSub(state);
//       channel.updateFileMessage(messageId, params)
//         .then((message) => {
//           pubSub.publish(
//             topics.UPDATE_USER_MESSAGE,
//             { message, channel, fromSelector: true },
//           );
//           resolve(message);
//         })
//         .catch(reject);
//     })
//   )
// );
/**
 * const deleteMessage = selectors.getDeleteMessage(state);
 * deleteMessage(
 *  channel: GroupChannel | OpenChannel,
 *  message: SendableMessage,
 * )
 *  .then((deletedMessage) => {})
 *  .catch((error) => {})
 */
var getDeleteMessage = function (state) { return (function (channel, message) { return (new Promise(function (resolve, reject) {
    var pubSub = getPubSub(state);
    var messageId = message.messageId;
    channel.deleteMessage(message)
        .then(function () {
        pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.DELETE_MESSAGE, { messageId: messageId, channel: channel });
        resolve(message);
    })
        .catch(reject);
})); }); };
/**
 * const resendUserMessage = selectors.getResendUserMessage(state);
 * resendUserMessage(
 *  channel: GroupChannel | OpenChannel,
 *  failedMessage: UserMessage,
 * )
 *  .then(() => {})
 *  .catch((error) => {})
 */
var getResendUserMessage = function (state, publishingModules) {
    if (publishingModules === void 0) { publishingModules = []; }
    return (function (channel, failedMessage) { return (new Promise(function (resolve, reject) {
        var pubSub = getPubSub(state);
        channel.resendUserMessage(failedMessage)
            .then(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_USER_MESSAGE, { message: message, channel: channel, publishingModules: publishingModules });
            resolve(message);
        })
            .catch(reject);
    })); });
};
/**
 * const resendFileMessage = selectors.getResendFileMessage(state);
 * resendFileMessage(
 *  channel: GroupChannel | OpenChannel,
 *  failedMessage: FileMessage,
 *  blob: Blob,
 * )
 *  .then(() => {})
 *  .catch((error) => {})
 */
var getResendFileMessage = function (state, publishingModules) {
    if (publishingModules === void 0) { publishingModules = []; }
    return (function (channel, failedMessage, blob) { return (new Promise(function (resolve, reject) {
        var pubSub = getPubSub(state);
        channel.resendFileMessage(failedMessage, blob)
            .then(function (message) {
            pubSub.publish(_chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_0__.p.SEND_FILE_MESSAGE, { message: message, channel: channel, publishingModules: publishingModules });
            resolve(message);
        })
            .catch(reject);
    })); });
};
var sendbirdSelectors = {
    getSdk: getSdk,
    getPubSub: getPubSub,
    getConnect: getConnect,
    getDisconnect: getDisconnect,
    getUpdateUserInfo: getUpdateUserInfo,
    getCreateGroupChannel: getCreateGroupChannel,
    getCreateOpenChannel: getCreateOpenChannel,
    getGetGroupChannel: getGetGroupChannel,
    getGetOpenChannel: getGetOpenChannel,
    getLeaveGroupChannel: getLeaveGroupChannel,
    getEnterOpenChannel: getEnterOpenChannel,
    getExitOpenChannel: getExitOpenChannel,
    getFreezeChannel: getFreezeChannel,
    getUnfreezeChannel: getUnfreezeChannel,
    getSendUserMessage: getSendUserMessage,
    getSendFileMessage: getSendFileMessage,
    getUpdateUserMessage: getUpdateUserMessage,
    getDeleteMessage: getDeleteMessage,
    getResendUserMessage: getResendUserMessage,
    getResendFileMessage: getResendFileMessage,
};


//# sourceMappingURL=sendbirdSelectors.js.map


/***/ }),

/***/ 72248:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Accordion; },
/* harmony export */   "bq": function() { return /* binding */ AccordionGroup; }
/* harmony export */ });
/* unused harmony export Accordion */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43822);
/* harmony import */ var _AccordionGroup_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78757);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);







var Accordion = function (_a) {
    var className = _a.className, id = _a.id, renderTitle = _a.renderTitle, renderContent = _a.renderContent, renderFooter = _a.renderFooter;
    var _b = (0,_AccordionGroup_js__WEBPACK_IMPORTED_MODULE_2__/* .useAccordionGroupContext */ .Po)(), openedListKeys = _b.openedListKeys, addOpenedListKey = _b.addOpenedListKey, removeOpenedListKey = _b.removeOpenedListKey;
    var isOpened = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return openedListKeys.includes(id); }, [openedListKeys]);
    var handleClick = function () {
        if (isOpened) {
            removeOpenedListKey(id);
        }
        else {
            addOpenedListKey(id);
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__.c)('sendbird-accordion', className, isOpened ? 'sendbird-accordion--opened' : 'sendbird-accordion--closed') },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-accordion__panel-header", id: id, role: "switch", "aria-checked": false, onClick: handleClick, onKeyDown: handleClick, tabIndex: 0 },
            renderTitle(),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.CHEVRON_RIGHT */ .Qy.CHEVRON_RIGHT, className: [
                    'sendbird-accordion__panel-icon-right',
                    'sendbird-accordion__panel-icon--chevron',
                    (isOpened ? 'sendbird-accordion__panel-icon--open' : ''),
                ].join(' '), height: "24px", width: "24px" })),
        isOpened && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-accordion-opened-list" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-accordion__list" }, renderContent()),
            renderFooter && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-accordion__footer" }, renderFooter()))))));
};

var AccordionGroup = _AccordionGroup_js__WEBPACK_IMPORTED_MODULE_2__/* .AccordionGroupProvider */ .oX;


//# sourceMappingURL=Accordion.js.map


/***/ }),

/***/ 78757:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Po": function() { return /* binding */ useAccordionGroupContext; },
/* harmony export */   "oX": function() { return /* binding */ AccordionGroupProvider; }
/* harmony export */ });
/* unused harmony exports AccordionGroupContext, default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80360);



var AccordionGroupContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    openedListKeys: [],
    addOpenedListKey: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n,
    removeOpenedListKey: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n,
    clearOpenedListKeys: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.n,
    allowMultipleOpen: false,
});
var AccordionGroupProvider = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.allowMultipleOpen, allowMultipleOpen = _b === void 0 ? false : _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), openedListKeys = _c[0], setOpenedListKeys = _c[1];
    var addOpenedListKey = function (key) {
        setOpenedListKeys(function (prevList) {
            if (!allowMultipleOpen) {
                return [key];
            }
            prevList.push(key);
            return prevList;
        });
    };
    var removeOpenedListKey = function (key) {
        setOpenedListKeys(function (prevList) { return prevList.filter(function (k) { return k !== key; }); });
    };
    var clearOpenedListKeys = function () {
        setOpenedListKeys([]);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-accordion-group-provider ".concat(className) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(AccordionGroupContext.Provider, { value: {
                openedListKeys: openedListKeys,
                addOpenedListKey: addOpenedListKey,
                removeOpenedListKey: removeOpenedListKey,
                clearOpenedListKeys: clearOpenedListKeys,
                allowMultipleOpen: allowMultipleOpen,
            } }, children)));
};
var useAccordionGroupContext = function () {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AccordionGroupContext);
    if (!context)
        throw new Error('No accordion group context available. Make sure you are rending <AccordionGroupContext />.');
    return context;
};


//# sourceMappingURL=AccordionGroup.js.map


/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdminMessage; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





function AdminMessage(_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, message = _a.message;
    if (!((message === null || message === void 0 ? void 0 : message.isAdminMessage) || (message === null || message === void 0 ? void 0 : message.messageType)) || !((_b = message === null || message === void 0 ? void 0 : message.isAdminMessage) === null || _b === void 0 ? void 0 : _b.call(message)) || (message === null || message === void 0 ? void 0 : message.messageType) !== 'admin') {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-admin-message',
        ], false).join(' ') },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-admin-message__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 }, message === null || message === void 0 ? void 0 : message.message)));
}


//# sourceMappingURL=AdminMessage.js.map


/***/ }),

/***/ 18087:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BottomSheet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17693);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99366);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78614);





























var BottomSheet = function (props) {
    var _a, _b, _c;
    var _d = props.className, className = _d === void 0 ? '' : _d, children = props.children, onBackdropClick = props.onBackdropClick;
    var logger = (_b = (_a = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)()) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.logger;
    // https://github.com/testing-library/react-testing-library/issues/62#issuecomment-438653348
    var portalRoot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    portalRoot.current = document.getElementById(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__.a);
    if (!portalRoot.current) {
        portalRoot.current = document.createElement('div');
        portalRoot.current.setAttribute('id', _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__.a);
        document.body.appendChild(portalRoot.current);
        (_c = logger === null || logger === void 0 ? void 0 : logger.warning) === null || _c === void 0 ? void 0 : _c.call(logger, '@sendbird/uikit-react/ui/BottomSheet | Should put a ModalRoot to use the BottomSheet.');
    }
    return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "".concat(className, " sendbird-bottomsheet") },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-bottomsheet__content", role: 'dialog', "aria-modal": 'true', "aria-expanded": 'true' }, children),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-bottomsheet__backdrop", onClick: function (e) {
                e === null || e === void 0 ? void 0 : e.stopPropagation();
                onBackdropClick === null || onBackdropClick === void 0 ? void 0 : onBackdropClick();
            } })), portalRoot.current);
};


//# sourceMappingURL=BottomSheet.js.map


/***/ }),

/***/ 88569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ ButtonSizes; },
/* harmony export */   "ZP": function() { return /* binding */ Button; },
/* harmony export */   "qh": function() { return /* binding */ ButtonTypes; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["PRIMARY"] = "PRIMARY";
    ButtonTypes["SECONDARY"] = "SECONDARY";
    ButtonTypes["DANGER"] = "DANGER";
    ButtonTypes["DISABLED"] = "DISABLED";
    ButtonTypes["WARNING"] = "WARNING";
})(ButtonTypes || (ButtonTypes = {}));
var ButtonSizes;
(function (ButtonSizes) {
    ButtonSizes["BIG"] = "BIG";
    ButtonSizes["SMALL"] = "SMALL";
})(ButtonSizes || (ButtonSizes = {}));

function changeTypeToClassName(type) {
    switch (type) {
        case ButtonTypes.PRIMARY: return 'sendbird-button--primary';
        case ButtonTypes.SECONDARY: return 'sendbird-button--secondary';
        case ButtonTypes.DANGER: return 'sendbird-button--danger';
        case ButtonTypes.DISABLED: return 'sendbird-button--disabled';
        case ButtonTypes.WARNING: return 'sendbird-button--warning';
        default: return '';
    }
}
function changeSizeToClassName(size) {
    switch (size) {
        case ButtonSizes.BIG: return 'sendbird-button--big';
        case ButtonSizes.SMALL: return 'sendbird-button--small';
        default: return '';
    }
}

function Button(_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? ButtonTypes.PRIMARY : _b, _c = _a.size, size = _c === void 0 ? ButtonSizes.BIG : _c, _d = _a.children, children = _d === void 0 ? 'Button' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f, _g = _a.labelType, labelType = _g === void 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BUTTON_1 : _g, _h = _a.labelColor, labelColor = _h === void 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONCONTENT_1 : _h;
    var injectingClassNames = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], ((Array.isArray(className)) ? className : [className]), true), [
        'sendbird-button',
        (disabled ? 'sendbird-button__disabled' : ''),
        changeTypeToClassName(type),
        changeSizeToClassName(size),
    ], false).join(' ');
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", { className: injectingClassNames, type: "button", onClick: onClick, disabled: disabled },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-button__text", type: labelType, color: labelColor }, children)));
}


//# sourceMappingURL=Button.js.map


/***/ }),

/***/ 80203:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChannelAvatar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82314);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17374);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4399);









function ChannelAvatar(_a) {
    var channel = _a.channel, userId = _a.userId, theme = _a.theme, _b = _a.width, width = _b === void 0 ? 56 : _b, _c = _a.height, height = _c === void 0 ? 56 : _c;
    var isBroadcast = channel === null || channel === void 0 ? void 0 : channel.isBroadcast;
    var memoizedAvatar = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (isBroadcast
        ? ((0,_chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_5__.g)(channel)
            ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-chat-header--default-avatar", style: {
                    width: width,
                    height: height,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.BROADCAST */ .Qy.BROADCAST, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.CONTENT */ .zo.CONTENT, width: width * 0.575, height: height * 0.575 })))
            : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: "sendbird-chat-header--avatar--broadcast-channel", src: (0,_chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_5__.a)(channel, userId), width: width, height: height, alt: channel === null || channel === void 0 ? void 0 : channel.name })))
        : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: "sendbird-chat-header--avatar--group-channel", src: (0,_chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_5__.a)(channel, userId), width: "".concat(width, "px"), height: "".concat(height, "px"), alt: channel === null || channel === void 0 ? void 0 : channel.name }))); }, [(0,_chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_5__.a)(channel, userId), theme]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, memoizedAvatar));
}


//# sourceMappingURL=ChannelAvatar.js.map


/***/ }),

/***/ 10856:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function Checkbox(_a) {
    var id = _a.id, _b = _a.checked, checked = _b === void 0 ? false : _b, disabled = _a.disabled, onChange = _a.onChange;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(checked), isChecked = _c[0], setIsCheck = _c[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: [
            'sendbird-checkbox',
            disabled ? 'disabled' : '',
        ].join(' '), htmlFor: id },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", { disabled: disabled, id: id, type: "checkbox", checked: isChecked, onClick: function () {
                if (!disabled)
                    setIsCheck(!isChecked);
            }, onChange: onChange }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: [
                'sendbird-checkbox--checkmark',
                disabled ? 'disabled' : '',
            ].join(' ') })));
}


//# sourceMappingURL=Checkbox.js.map


/***/ }),

/***/ 55922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ConnectionStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);








function ConnectionStatus() {
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-connection-status" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 }, stringSet.TRYING_TO_CONNECT),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.DISCONNECTED */ .Qy.DISCONNECTED, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.SENT */ .zo.SENT, width: "14px", height: "14px" })));
}


//# sourceMappingURL=ConnectionStatus.js.map


/***/ }),

/***/ 8743:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DateSeparator; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61448);






var DateSeparator = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.separatorColor, separatorColor = _d === void 0 ? _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__.C.ONBACKGROUND_4 : _d;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-separator',
        ], false).join(' ') },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: ['sendbird-separator__left', "".concat((0,_chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__.c)(separatorColor), "--background-color")].join(' ') }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-separator__text" }, children
            || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_2 }, "Date Separator"))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: ['sendbird-separator__right', "".concat((0,_chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__.c)(separatorColor), "--background-color")].join(' ') })));
};


//# sourceMappingURL=DateSeparator.js.map


/***/ }),

/***/ 27835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmojiReactions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ReactionBadge_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30156);
/* harmony import */ var _ReactionButton_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60090);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4399);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16167);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _BottomSheet_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18087);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99366);
/* harmony import */ var _UserListItem_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65614);
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76886);
/* harmony import */ var _TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32080);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41238);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23012);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(17693);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(14014);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61448);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71091);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29515);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(8978);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(82314);
/* harmony import */ var _MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(67412);
/* harmony import */ var _Checkbox_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(10856);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(80031);















































var ReactedMembersBottomSheet = function (_a) {
    var _b, _c, _d;
    var message = _a.message, channel = _a.channel, _e = _a.emojiKey, emojiKey = _e === void 0 ? '' : _e, hideMenu = _a.hideMenu, emojiContainer = _a.emojiContainer, onPressUserProfileHandler = _a.onPressUserProfileHandler;
    var _f = channel.members, members = _f === void 0 ? [] : _f;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(emojiKey), selectedEmoji = _g[0], setSelectedEmoji = _g[1];
    function onPressUserProfileCallBack() {
        if (onPressUserProfileHandler && message) {
            var sender = message === null || message === void 0 ? void 0 : message.sender;
            onPressUserProfileHandler(sender);
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BottomSheet_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { onBackdropClick: hideMenu },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-message__bottomsheet" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-message__bottomsheet__reacted-members" }, (_b = message.reactions) === null || _b === void 0 ? void 0 : _b.map(function (reaction) {
                var emojiUrl = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.V)(emojiContainer, reaction.key);
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { key: reaction.key, className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_35__.c)('sendbird-message__bottomsheet__reacted-members__item', selectedEmoji === reaction.key && 'sendbird-message__bottomsheet__reacted-members__item__selected'), onClick: function () {
                        setSelectedEmoji(reaction.key);
                    } },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { url: emojiUrl, width: "28px", height: "28px", placeHolder: function (_a) {
                            var style = _a.style;
                            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: style },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.QUESTION */ .Qy.QUESTION, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                        } }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.a.BUTTON_2, color: selectedEmoji === reaction.key ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.PRIMARY : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.ONBACKGROUND_3 }, reaction.userIds.length)));
            })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-message__bottomsheet__reactor-list" }, // making a member list who reacted to the message with the `selectedEmoji`
            ((_d = (_c = message.reactions) === null || _c === void 0 ? void 0 : _c.find(function (reaction) { return reaction.key === selectedEmoji; })) === null || _d === void 0 ? void 0 : _d.userIds.map(function (userId) { return members.find(function (member) { return member.userId === userId; }); }).filter(function (member) { return member !== undefined; }))
                .map(function (member) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_UserListItem_js__WEBPACK_IMPORTED_MODULE_9__/* .UserListItem */ .Q, { key: member.userId, className: "sendbird-message__bottomsheet__reactor-list__item", user: member, avatarSize: "36px", onUserAvatarClick: onPressUserProfileCallBack })); })))));
};

function ReactionItem(_a) {
    var _b;
    var reaction = _a.reaction, memberNicknamesMap = _a.memberNicknamesMap, setEmojiKey = _a.setEmojiKey, toggleReaction = _a.toggleReaction, emojisMap = _a.emojisMap, channel = _a.channel, message = _a.message, isFiltered = _a.isFiltered;
    var openModal = (0,_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_18__.b)().openModal;
    var store = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_16__/* .useSendbirdStateContext */ .A)();
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_13__.u)().isMobile;
    var messageStore = (0,_Message_context_js__WEBPACK_IMPORTED_MODULE_17__/* .useMessageContext */ .f)();
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_15__.L).stringSet;
    var userId = store.config.userId;
    var reactedByMe = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.W)(userId, reaction);
    var showHoverTooltip = (reaction.userIds.length > 0)
        && ((channel === null || channel === void 0 ? void 0 : channel.isGroupChannel()) && !channel.isSuper);
    var handleOnClick = function () {
        if (isFiltered && !reactedByMe) {
            openModal({
                modalProps: {
                    titleText: 'Add reaction failed',
                    hideFooter: true,
                    isCloseOnClickOutside: true,
                },
                childElement: function (_a) {
                    var closeModal = _a.closeModal;
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_18__.c, { type: _Button_js__WEBPACK_IMPORTED_MODULE_19__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, submitText: stringSet.BUTTON__OK, hideCancelButton: true, onCancel: closeModal, onSubmit: closeModal }));
                },
            });
            return;
        }
        setEmojiKey('');
        toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction((message !== null && message !== void 0 ? message : messageStore === null || messageStore === void 0 ? void 0 : messageStore.message), reaction.key, reactedByMe);
    };
    var longPress = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__.u)({
        onLongPress: function () {
            setEmojiKey(reaction.key);
        },
        onClick: handleOnClick,
    }, {
        shouldPreventDefault: true,
        shouldStopPropagation: true,
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, { className: "sendbird-emoji-reactions__reaction-badge", hoverTooltip: showHoverTooltip ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, null, (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.X)(reaction, userId, memberNicknamesMap, stringSet))) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_10__._)({}, (isMobile
            ? longPress
            : { onClick: handleOnClick })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { count: reaction.userIds.length, selected: reactedByMe },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { circle: true, url: ((_b = emojisMap.get(reaction === null || reaction === void 0 ? void 0 : reaction.key)) === null || _b === void 0 ? void 0 : _b.url) || '', width: "20px", height: "20px", defaultComponent: (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { width: "20px", height: "20px", type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.QUESTION */ .Qy.QUESTION })) })))));
}

var AddReactionBadgeItem = function (_a) {
    var onClick = _a.onClick;
    var onlyClick = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__.u)({
        onLongPress: function () { },
        onClick: onClick,
    }, {
        shouldPreventDefault: true,
        shouldStopPropagation: true,
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_10__._)({ className: "sendbird-emoji-reactions__add-reaction-badge", "data-testid": "sendbird-emoji-reactions__add-reaction-badge" }, onlyClick),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { isAdd: true },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.EMOJI_MORE */ .Qy.EMOJI_MORE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "20px", height: "20px" }))));
};

var MobileEmojisBottomSheet = function (_a) {
    var userId = _a.userId, message = _a.message, emojiContainer = _a.emojiContainer, hideMenu = _a.hideMenu, toggleReaction = _a.toggleReaction;
    var emojiAllList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.T)(emojiContainer);
    }, [emojiContainer]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BottomSheet_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { onBackdropClick: hideMenu },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-message__bottomsheet sendbird-message__emojis-bottomsheet" }, emojiAllList.map(function (emoji) {
            var _a, _b, _c, _d;
            var isReacted = (_d = ((_c = (_b = (_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.find(function (reaction) { return reaction.key === emoji.key; })) === null || _b === void 0 ? void 0 : _b.userIds) === null || _c === void 0 ? void 0 : _c.some(function (reactorId) { return reactorId === userId; }))) !== null && _d !== void 0 ? _d : false;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionButton_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { key: emoji.key, width: "44px", height: "44px", selected: isReacted, onClick: function (e) {
                    e === null || e === void 0 ? void 0 : e.stopPropagation();
                    toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
                    hideMenu();
                }, testID: "ui_mobile_emoji_reactions_menu_".concat(emoji.key) },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { url: emoji.url, width: "38px", height: "38px", placeHolder: function (_a) {
                        var style = _a.style;
                        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: style },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.QUESTION */ .Qy.QUESTION, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                    } })));
        }))));
};

var EmojiReactions = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.className, className = _g === void 0 ? '' : _g, userId = _a.userId, message = _a.message, channel = _a.channel, emojiContainer = _a.emojiContainer, memberNicknamesMap = _a.memberNicknamesMap, _h = _a.spaceFromTrigger, spaceFromTrigger = _h === void 0 ? { x: 0, y: 0 } : _h, _j = _a.isByMe, isByMe = _j === void 0 ? false : _j, toggleReaction = _a.toggleReaction, onPressUserProfile = _a.onPressUserProfile, filterEmojiCategoryIds = _a.filterEmojiCategoryIds;
    var showTheReactedMembers = false;
    try {
        var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_16__/* .useSendbirdStateContext */ .A)().config;
        showTheReactedMembers = channel ? (0,_chunks_bundle_B2NeDUAs_js__WEBPACK_IMPORTED_MODULE_36__.g)({
            channel: channel,
            config: config,
        }) : false;
    }
    catch (err) {
        // TODO: Handle error
    }
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_13__.u)().isMobile;
    var addReactionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showEmojiList = _k[0], setShowEmojiList = _k[1];
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), selectedEmojiKey = _l[0], setSelectedEmojiKey = _l[1];
    var emojisMap = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.Y)(emojiContainer);
    var filteredEmojis = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.u)(emojiContainer, filterEmojiCategoryIds === null || filterEmojiCategoryIds === void 0 ? void 0 : filterEmojiCategoryIds(message));
    }, [emojiContainer, filterEmojiCategoryIds]);
    var showAddReactionBadge = ((_c = (_b = message.reactions) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) < emojisMap.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.x)([
            className, 'sendbird-emoji-reactions',
            isByMe ? 'outgoing' : 'incoming',
        ]) },
        (((_e = (_d = message.reactions) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0) && ((_f = message.reactions) === null || _f === void 0 ? void 0 : _f.map(function (reaction) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReactionItem, { key: reaction === null || reaction === void 0 ? void 0 : reaction.key, reaction: reaction, memberNicknamesMap: memberNicknamesMap, setEmojiKey: setSelectedEmojiKey, toggleReaction: toggleReaction, emojisMap: emojisMap, channel: channel, message: message, isFiltered: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.u)(emojiContainer, filterEmojiCategoryIds === null || filterEmojiCategoryIds === void 0 ? void 0 : filterEmojiCategoryIds(message))
                    .every(function (elem) { return elem.key !== (reaction === null || reaction === void 0 ? void 0 : reaction.key); }) }));
        })),
        (!isMobile && showAddReactionBadge) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionBadge_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { className: "sendbird-emoji-reactions__add-reaction-badge", testID: "sendbird-emoji-reactions__add-reaction-badge", ref: addReactionRef, isAdd: true, onClick: function (e) {
                    var _a;
                    toggleDropdown();
                    (_a = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(e);
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.EMOJI_MORE */ .Qy.EMOJI_MORE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "20px", height: "20px" }))); }, menuItems: function (closeDropdown) {
                if (filteredEmojis.length === 0)
                    return null;
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.f, { parentRef: addReactionRef, parentContainRef: addReactionRef, closeDropdown: closeDropdown, spaceFromTrigger: spaceFromTrigger }, (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.u)(emojiContainer, filterEmojiCategoryIds === null || filterEmojiCategoryIds === void 0 ? void 0 : filterEmojiCategoryIds(message)).map(function (emoji) {
                    var _a, _b, _c;
                    var isReacted = ((_c = (_b = (_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.find(function (reaction) { return reaction.key === emoji.key; })) === null || _b === void 0 ? void 0 : _b.userIds) === null || _c === void 0 ? void 0 : _c.some(function (reactorId) { return reactorId === userId; })) || false;
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionButton_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { key: emoji.key, width: "36px", height: "36px", selected: isReacted, onClick: function (e) {
                            closeDropdown();
                            toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
                            e === null || e === void 0 ? void 0 : e.stopPropagation();
                        }, testID: "ui_emoji_reactions_menu_".concat(emoji.key) },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { url: (emoji === null || emoji === void 0 ? void 0 : emoji.url) || '', width: "28px", height: "28px", placeHolder: function (_a) {
                                var style = _a.style;
                                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: style },
                                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconTypes.QUESTION */ .Qy.QUESTION, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_4__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                            } })));
                })));
            } })),
        (isMobile && showAddReactionBadge) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(AddReactionBadgeItem, { onClick: function () {
                setShowEmojiList(true);
            } })),
        (isMobile && showEmojiList) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MobileEmojisBottomSheet, { userId: userId, message: message, emojiContainer: emojiContainer, hideMenu: function () {
                setShowEmojiList(false);
            }, toggleReaction: toggleReaction })),
        (isMobile && selectedEmojiKey && channel !== null && showTheReactedMembers) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReactedMembersBottomSheet, { message: message, channel: channel, emojiKey: selectedEmojiKey, hideMenu: function () {
                setSelectedEmojiKey('');
            }, emojiContainer: emojiContainer, onPressUserProfileHandler: onPressUserProfile }))));
};


//# sourceMappingURL=EmojiReactions.js.map


/***/ }),

/***/ 34498:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ FallbackTemplateMessageItemBody; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8978);












function FallbackTemplateMessageItemBody(_a) {
    var className = _a.className, message = _a.message, isByMe = _a.isByMe;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var text = message['message'];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.x)([
            className !== null && className !== void 0 ? className : '',
            isByMe ? 'outgoing' : 'incoming',
            'sendbird-template-message-item-body__fallback_message',
        ]) }, text
        ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONCONTENT_INVERSE_1 }, text))
        : react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: 'sendbird-template-message-item-body__fallback_message__header', type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONCONTENT_INVERSE_1 }, stringSet.UNKNOWN__TEMPLATE_ERROR),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: 'sendbird-template-message-item-body__fallback_message__description', type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONCONTENT_INVERSE_3 }, stringSet.UNKNOWN__CANNOT_READ_TEMPLATE))));
}


//# sourceMappingURL=FallbackTemplateMessageItemBody.tsx.js.map


/***/ }),

/***/ 15345:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeedbackIconButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var FeedbackIconButton = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
    var children = props.children, isSelected = props.isSelected, _a = props.onClick, onClick = _a === void 0 ? function () { } : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", { className: [
            'sendbird-iconbutton__feedback',
            isSelected ? 'sendbird-iconbutton__feedback__pressed' : '',
            disabled ? 'sendbird-iconbutton__feedback__disabled' : '',
        ].join(' '), ref: ref, type: 'button', onClick: function (e) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, disabled: disabled },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: [
                'sendbird-iconbutton__feedback__inner',
                isSelected ? 'sendbird-iconbutton__feedback__inner__pressed' : '',
                disabled ? 'sendbird-iconbutton__feedback__inner__disabled' : '',
            ].join(' ') }, children)));
});


//# sourceMappingURL=FeedbackIconButton.js.map


/***/ }),

/***/ 12210:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FileMessageItemBody; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _TextButton_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26765);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8978);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71091);


















function FileMessageItemBody(_a) {
    var _this = this;
    var _b, _c, _d;
    var _e = _a.className, className = _e === void 0 ? '' : _e, message = _a.message, _f = _a.isByMe, isByMe = _f === void 0 ? false : _f, _g = _a.mouseHover, mouseHover = _g === void 0 ? false : _g, _h = _a.isReactionEnabled, isReactionEnabled = _h === void 0 ? false : _h, truncateLimit = _a.truncateLimit, onBeforeDownloadFileMessage = _a.onBeforeDownloadFileMessage;
    var logger = null;
    try {
        logger = (_c = (_b = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_8__/* .useSendbirdStateContext */ .A)()) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.logger;
    }
    catch (err) {
        // TODO: Handle error
    }
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_7__.u)().isMobile;
    var truncateMaxNum = truncateLimit !== null && truncateLimit !== void 0 ? truncateLimit : (isMobile ? 20 : undefined);
    var downloadFileWithUrl = function () { return (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_12__.o)(message === null || message === void 0 ? void 0 : message.url); };
    var handleOnClickTextButton = onBeforeDownloadFileMessage
        ? function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message })];
                    case 1:
                        allowDownload = _c.sent();
                        if (allowDownload) {
                            downloadFileWithUrl();
                        }
                        else {
                            (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileMessageItemBody: Not allowed to download.');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileMessageItemBody: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }
        : downloadFileWithUrl;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.x)([
            className,
            'sendbird-file-message-item-body',
            isByMe ? 'outgoing' : 'incoming',
            mouseHover ? 'mouse-hover' : '',
            (isReactionEnabled && ((_d = message === null || message === void 0 ? void 0 : message.reactions) === null || _d === void 0 ? void 0 : _d.length) > 0) ? 'reactions' : '',
        ]) },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-file-message-item-body__file-icon" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-file-message-item-body__file-icon__icon", type: {
                    IMAGE: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.PHOTO */ .Qy.PHOTO,
                    VIDEO: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.PLAY */ .Qy.PLAY,
                    AUDIO: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.FILE_AUDIO */ .Qy.FILE_AUDIO,
                    GIF: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.GIF */ .Qy.GIF,
                    OTHERS: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.FILE_DOCUMENT */ .Qy.FILE_DOCUMENT,
                }[(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.o)(message === null || message === void 0 ? void 0 : message.type)], fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_TextButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { className: "sendbird-file-message-item-body__file-name", onClick: handleOnClickTextButton, color: isByMe ? _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_6__.C.ONCONTENT_1 : _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_6__.C.ONBACKGROUND_1 },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-file-message-item-body__file-name__text", testID: "sendbird-file-message-item-body__file-name__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.t)((message === null || message === void 0 ? void 0 : message.name) || (message === null || message === void 0 ? void 0 : message.url), truncateMaxNum)))));
}


//# sourceMappingURL=FileMessageItemBody.js.map


/***/ }),

/***/ 6989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FileViewer; }
/* harmony export */ });
/* unused harmony export FileViewerComponent */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99366);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69466);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78614);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8978);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(4399);

































// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
var ViewerTypes = {
    SINGLE: 'SINGLE',
    MULTI: 'MULTI',
};

function mapFileViewerComponentProps(_a) {
    var props = _a.props;
    if (props.viewerType === ViewerTypes.MULTI) {
        var _b = props, fileInfoList = _b.fileInfoList, currentIndex = _b.currentIndex;
        return fileInfoList[currentIndex];
    }
    var fileInfo = props;
    return {
        name: fileInfo.name,
        type: fileInfo.type,
        url: fileInfo.url,
    };
}

function DeleteButton(props) {
    if (props.viewerType !== ViewerTypes.MULTI) {
        var onDelete_1 = props.onDelete, isByMe = props.isByMe, disableDelete_1 = props.disableDelete, className = props.className;
        return (isByMe)
            ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__right__actions__delete ".concat(className) },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { className: disableDelete_1 ? 'disabled' : '', type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DELETE */ .Qy.DELETE, fillColor: disableDelete_1 ? _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.GRAY */ .zo.GRAY : _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: function (e) { if (!disableDelete_1) {
                        onDelete_1 === null || onDelete_1 === void 0 ? void 0 : onDelete_1(e);
                    } } })))
            : react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
}

// this is a slider component that is used to navigate between images
function Slider(props) {
    if (props.viewerType === ViewerTypes.MULTI) {
        var onClickLeft_1 = props.onClickLeft, onClickRight_1 = props.onClickRight;
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-file-viewer-slider" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-file-viewer-arrow--left" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.SLIDE_LEFT */ .Qy.SLIDE_LEFT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_22__.n, width: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_22__.n, onClick: function (e) {
                        onClickLeft_1 === null || onClickLeft_1 === void 0 ? void 0 : onClickLeft_1();
                        e.stopPropagation();
                    } })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-file-viewer-arrow--right" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.SLIDE_LEFT */ .Qy.SLIDE_LEFT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_22__.n, width: _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_22__.n, onClick: function (e) {
                        e.stopPropagation();
                        onClickRight_1 === null || onClickRight_1 === void 0 ? void 0 : onClickRight_1();
                    } }))));
    }
    // return empty fragment if viewerType is not ViewerTypes.MULTI
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
}

var FileViewerComponent = function (props) {
    var profileUrl = props.profileUrl, nickname = props.nickname, onClose = props.onClose, onDownloadClick = props.onDownloadClick;
    var _a = props, onClickLeft = _a.onClickLeft, onClickRight = _a.onClickRight;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var onKeyDown = (0,_chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_9__.u)(ref, {
        Escape: function (e) { return onClose === null || onClose === void 0 ? void 0 : onClose(e); },
        ArrowLeft: function () { return onClickLeft === null || onClickLeft === void 0 ? void 0 : onClickLeft(); },
        ArrowRight: function () { return onClickRight === null || onClickRight === void 0 ? void 0 : onClickRight(); },
    });
    var _b = mapFileViewerComponentProps({ props: props }), name = _b.name, type = _b.type, url = _b.url;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__.M, { onClose: onClose },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer", "data-testid": "sendbird-fileviewer", onKeyDown: onKeyDown, 
            // to focus
            tabIndex: 1, ref: ref },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__left" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__left__avatar" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_6__.A, { height: "32px", width: "32px", src: profileUrl })),
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__left__text-container" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { className: "sendbird-fileviewer__header__left__filename", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, name),
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { className: "sendbird-fileviewer__header__left__sender-name", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_2 }, nickname))),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__right" },
                    (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.f)(type) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__right__actions" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", { className: "sendbird-fileviewer__header__right__actions__download", rel: "noopener noreferrer", href: url, target: "_blank", onClick: onDownloadClick },
                            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DOWNLOAD */ .Qy.DOWNLOAD, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px" })),
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(DeleteButton, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: 'sendbird-fileviewer__header__right__actions__delete' }, props)))),
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__header__right__actions__close" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.CLOSE */ .Qy.CLOSE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_1 */ .zo.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: function (e) { return onClose === null || onClose === void 0 ? void 0 : onClose(e); } })))),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__content" },
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.h)(type) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("video", { controls: true, className: "sendbird-fileviewer__content__video" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("source", { src: url, type: type }))),
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.j)(type) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", { src: url, alt: name, className: props.viewerType === ViewerTypes.MULTI
                        ? 'sendbird-fileviewer__content__img__multi'
                        : 'sendbird-fileviewer__content__img' })),
                !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.f)(type) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-fileviewer__content__unsupported" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.H_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, (stringSet === null || stringSet === void 0 ? void 0 : stringSet.UI__FILE_VIEWER__UNSUPPORT) || 'Unsupported message'))),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(Slider, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props))))));
};
function FileViewer(_a) {
    var _b, _c, _d;
    var message = _a.message, _e = _a.statefulFileInfoList, statefulFileInfoList = _e === void 0 ? [] : _e, onClose = _a.onClose, _f = _a.isByMe, isByMe = _f === void 0 ? false : _f, onDelete = _a.onDelete, currentIndex = _a.currentIndex, onClickLeft = _a.onClickLeft, onClickRight = _a.onClickRight, onDownloadClick = _a.onDownloadClick;
    if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.c)(message)) {
        var castedMessage = message;
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(FileViewerComponent, { profileUrl: castedMessage.sender.profileUrl, nickname: castedMessage.sender.nickname, viewerType: ViewerTypes.MULTI, fileInfoList: statefulFileInfoList.filter(function (fileInfo) {
                return fileInfo.url; // Caution: This assumes that defined url means file upload has completed.
            }).map(function (fileInfo) {
                return {
                    name: fileInfo.fileName || '',
                    type: fileInfo.mimeType || '',
                    url: fileInfo.url || '',
                };
            }), currentIndex: currentIndex || 0, onClickLeft: onClickLeft || _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.n, onClickRight: onClickRight || _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.n, onClose: onClose, onDownloadClick: onDownloadClick }));
    }
    else if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.b)(message)) {
        var castedMessage = message;
        return (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)((react__WEBPACK_IMPORTED_MODULE_1__.createElement(FileViewerComponent, { profileUrl: (_b = castedMessage.sender) === null || _b === void 0 ? void 0 : _b.profileUrl, nickname: (_c = castedMessage.sender) === null || _c === void 0 ? void 0 : _c.nickname, name: castedMessage.name, type: castedMessage.type, url: castedMessage === null || castedMessage === void 0 ? void 0 : castedMessage.url, isByMe: isByMe, disableDelete: (((_d = castedMessage.threadInfo) === null || _d === void 0 ? void 0 : _d.replyCount) || 0) > 0, onClose: onClose, onDelete: onDelete || _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.n, onDownloadClick: onDownloadClick })), document.getElementById(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__.a));
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
}


//# sourceMappingURL=FileViewer.js.map


/***/ }),

/***/ 56210:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Header$1; }
/* harmony export */ });
/* unused harmony exports Header, Icon, IconButton, Title */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26765);
/* harmony import */ var _TextButton_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21790);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29515);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21112);











var Header = function (_a) {
    var _b;
    var className = _a.className, renderLeft = _a.renderLeft, renderRight = _a.renderRight, renderMiddle = _a.renderMiddle;
    var isMobile = false;
    try {
        isMobile = (_b = _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__.u === null || _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__.u === void 0 ? void 0 : (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__.u)()) === null || _b === void 0 ? void 0 : _b.isMobile;
    }
    catch (err) {
        // TODO: handle it
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-ui-header', className), "data-testid": "sendbird-ui-header" },
        renderLeft ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-ui-header__left', isMobile ? 'sendbird-ui-header--is-mobile' : 'sendbird-ui-header--is-desktop') }, renderLeft === null || renderLeft === void 0 ? void 0 : renderLeft())) : null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-ui-header__middle" }, renderMiddle === null || renderMiddle === void 0 ? void 0 : renderMiddle()),
        renderRight ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.c)('sendbird-ui-header__right', isMobile ? 'sendbird-ui-header--is-mobile' : 'sendbird-ui-header--is-desktop') }, renderRight === null || renderRight === void 0 ? void 0 : renderRight())) : null));
};
var Title = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, onClickSubtitle = _a.onClickSubtitle;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-ui-header__middle" },
        title && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-ui-header__middle__title", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, title)),
        subtitle && (onClickSubtitle ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_TextButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { className: "sendbird-ui-header__middle__subtitle__container", onClick: onClickSubtitle, disableUnderline: true },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-ui-header__middle__subtitle", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 }, subtitle))) : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-ui-header__middle__subtitle", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_2 }, subtitle)))));
};
var IconButton = function (_a) {
    var className = _a.className, onClick = _a.onClick, type = _a.type, color = _a.color, _b = _a.width, width = _b === void 0 ? '32px' : _b, _c = _a.height, height = _c === void 0 ? '32px' : _c, _d = _a.renderIcon, renderIcon = _d === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Icon, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _d;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_IconButton_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { className: className, width: width, height: height, onClick: onClick }, renderIcon({ type: type, color: color })));
};
var Icon = function (_a) {
    var className = _a.className, type = _a.type, color = _a.color, _b = _a.width, width = _b === void 0 ? '22px' : _b, _c = _a.height, height = _c === void 0 ? '22px' : _c, _d = _a.onClick, onClick = _d === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.n : _d;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { className: className, type: type, fillColor: color, width: width, height: height, onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e); } }));
};
var Header$1 = Object.assign(Header, { Title: Title, IconButton: IconButton, Icon: Icon });


//# sourceMappingURL=Header.js.map


/***/ }),

/***/ 43822:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qy": function() { return /* binding */ IconTypes; },
/* harmony export */   "ZP": function() { return /* binding */ Icon; },
/* harmony export */   "zo": function() { return /* binding */ IconColors; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80360);





/* eslint-disable no-redeclare */
var Types = {
    ADD: 'ADD',
    ARROW_LEFT: 'ARROW_LEFT',
    ATTACH: 'ATTACH',
    AUDIO_ON_LINED: 'AUDIO_ON_LINED',
    BAN: 'BAN',
    BROADCAST: 'BROADCAST',
    CAMERA: 'CAMERA',
    CHANNELS: 'CHANNELS',
    CHAT: 'CHAT',
    CHAT_FILLED: 'CHAT_FILLED',
    CHEVRON_DOWN: 'CHEVRON_DOWN',
    CHEVRON_RIGHT: 'CHEVRON_RIGHT',
    CLOSE: 'CLOSE',
    COLLAPSE: 'COLLAPSE',
    COPY: 'COPY',
    CREATE: 'CREATE',
    DELETE: 'DELETE',
    DISCONNECTED: 'DISCONNECTED',
    DOCUMENT: 'DOCUMENT',
    DONE: 'DONE',
    DONE_ALL: 'DONE_ALL',
    DOWNLOAD: 'DOWNLOAD',
    EDIT: 'EDIT',
    EMOJI_MORE: 'EMOJI_MORE',
    ERROR: 'ERROR',
    EXPAND: 'EXPAND',
    FILE_AUDIO: 'FILE_AUDIO',
    FILE_DOCUMENT: 'FILE_DOCUMENT',
    FREEZE: 'FREEZE',
    GIF: 'GIF',
    INFO: 'INFO',
    LEAVE: 'LEAVE',
    MEMBERS: 'MEMBERS',
    MESSAGE: 'MESSAGE',
    MODERATIONS: 'MODERATIONS',
    MORE: 'MORE',
    MUTE: 'MUTE',
    NOTIFICATIONS: 'NOTIFICATIONS',
    NOTIFICATIONS_OFF_FILLED: 'NOTIFICATIONS_OFF_FILLED',
    OPERATOR: 'OPERATOR',
    PHOTO: 'PHOTO',
    PLAY: 'PLAY',
    PLUS: 'PLUS',
    QUESTION: 'QUESTION',
    REFRESH: 'REFRESH',
    REPLY: 'REPLY',
    REMOVE: 'REMOVE',
    SEARCH: 'SEARCH',
    SEND: 'SEND',
    SETTINGS_FILLED: 'SETTINGS_FILLED',
    SLIDE_LEFT: 'SLIDE_LEFT',
    SPINNER: 'SPINNER',
    SUPERGROUP: 'SUPERGROUP',
    THREAD: 'THREAD',
    THUMBNAIL_NONE: 'THUMBNAIL_NONE',
    TOGGLE_OFF: 'TOGGLE_OFF',
    TOGGLE_ON: 'TOGGLE_ON',
    USER: 'USER',
    FEEDBACK_LIKE: 'FEEDBACK_LIKE',
    FEEDBACK_DISLIKE: 'FEEDBACK_DISLIKE',
};

/* eslint-disable no-redeclare */
var Colors = {
    DEFAULT: 'DEFAULT',
    PRIMARY: 'PRIMARY',
    PRIMARY_2: 'PRIMARY_2',
    SECONDARY: 'SECONDARY',
    SECONDARY_2: 'SECONDARY_2',
    CONTENT: 'CONTENT',
    CONTENT_INVERSE: 'CONTENT_INVERSE',
    CONTENT_INVERSE_3: 'CONTENT_INVERSE_3',
    WHITE: 'WHITE',
    GRAY: 'GRAY',
    THUMBNAIL_ICON: 'THUMBNAIL_ICON',
    SENT: 'SENT',
    READ: 'READ',
    ON_BACKGROUND_1: 'ON_BACKGROUND_1',
    ON_BACKGROUND_2: 'ON_BACKGROUND_2',
    ON_BACKGROUND_3: 'ON_BACKGROUND_3',
    ON_BACKGROUND_4: 'ON_BACKGROUND_4',
    BACKGROUND_3: 'BACKGROUND_3',
    ERROR: 'ERROR',
};

function changeColorToClassName(color) {
    switch (color) {
        case Colors.PRIMARY: return 'sendbird-icon-color--primary';
        case Colors.PRIMARY_2: return 'sendbird-icon-color--primary-2';
        case Colors.SECONDARY: return 'sendbird-icon-color--secondary';
        case Colors.SECONDARY_2: return 'sendbird-icon-color--secondary-2';
        case Colors.CONTENT: return 'sendbird-icon-color--content';
        case Colors.CONTENT_INVERSE: return 'sendbird-icon-color--content-inverse';
        case Colors.CONTENT_INVERSE_3: return 'sendbird-icon-color--content-inverse-3';
        case Colors.WHITE: return 'sendbird-icon-color--white';
        case Colors.GRAY: return 'sendbird-icon-color--gray';
        case Colors.THUMBNAIL_ICON: return 'sendbird-icon-color--thumbnail-icon';
        case Colors.SENT: return 'sendbird-icon-color--sent';
        case Colors.READ: return 'sendbird-icon-color--read';
        case Colors.ON_BACKGROUND_1: return 'sendbird-icon-color--on-background-1';
        case Colors.ON_BACKGROUND_2: return 'sendbird-icon-color--on-background-2';
        case Colors.ON_BACKGROUND_3: return 'sendbird-icon-color--on-background-3';
        case Colors.ON_BACKGROUND_4: return 'sendbird-icon-color--on-background-4';
        case Colors.BACKGROUND_3: return 'sendbird-icon-color--background-3';
        case Colors.ERROR: return 'sendbird-icon-color--error';
        default: return '';
    }
}
function changeTypeToIconClassName(type) {
    switch (type) {
        case Types.ADD: return 'sendbird-icon-add';
        case Types.ARROW_LEFT: return 'sendbird-icon-arrow-left';
        case Types.ATTACH: return 'sendbird-icon-attach';
        case Types.AUDIO_ON_LINED: return 'sendbird-icon-audio-on-lined';
        case Types.BAN: return 'sendbird-icon-ban';
        case Types.BROADCAST: return 'sendbird-icon-broadcast';
        case Types.CAMERA: return 'sendbird-icon-camera';
        case Types.CHANNELS: return 'sendbird-icon-channels';
        case Types.CHAT: return 'sendbird-icon-chat';
        case Types.CHAT_FILLED: return 'sendbird-icon-chat-filled';
        case Types.CHEVRON_DOWN: return 'sendbird-icon-chevron-down';
        case Types.CHEVRON_RIGHT: return 'sendbird-icon-chevron-right';
        case Types.CLOSE: return 'sendbird-icon-close';
        case Types.COLLAPSE: return 'sendbird-icon-collapse';
        case Types.COPY: return 'sendbird-icon-copy';
        case Types.CREATE: return 'sendbird-icon-create';
        case Types.DELETE: return 'sendbird-icon-delete';
        case Types.DISCONNECTED: return 'sendbird-icon-disconnected';
        case Types.DOCUMENT: return 'sendbird-icon-document';
        case Types.DONE: return 'sendbird-icon-done';
        case Types.DONE_ALL: return 'sendbird-icon-done-all';
        case Types.DOWNLOAD: return 'sendbird-icon-down-load';
        case Types.EDIT: return 'sendbird-icon-edit';
        case Types.EMOJI_MORE: return 'sendbird-icon-emoji-more';
        case Types.ERROR: return 'sendbird-icon-error';
        case Types.EXPAND: return 'sendbird-icon-expand';
        case Types.FILE_AUDIO: return 'sendbird-icon-file-audio';
        case Types.FILE_DOCUMENT: return 'sendbird-icon-file-document';
        case Types.FREEZE: return 'sendbird-icon-freeze';
        case Types.GIF: return 'sendbird-icon-gif';
        case Types.INFO: return 'sendbird-icon-info';
        case Types.LEAVE: return 'sendbird-icon-leave';
        case Types.MEMBERS: return 'sendbird-icon-members';
        case Types.MESSAGE: return 'sendbird-icon-message';
        case Types.MODERATIONS: return 'sendbird-icon-moderations';
        case Types.MORE: return 'sendbird-icon-more';
        case Types.MUTE: return 'sendbird-icon-mute';
        case Types.NOTIFICATIONS: return 'sendbird-icon-notifications';
        case Types.NOTIFICATIONS_OFF_FILLED: return 'sendbird-icon-notifications-off-filled';
        case Types.OPERATOR: return 'sendbird-icon-operator';
        case Types.PHOTO: return 'sendbird-icon-photo';
        case Types.PLAY: return 'sendbird-icon-play';
        case Types.PLUS: return 'sendbird-iconn-plus';
        case Types.QUESTION: return 'sendbird-icon-question';
        case Types.REFRESH: return 'sendbird-icon-refresh';
        case Types.REMOVE: return 'sendbird-icon-remove';
        case Types.REPLY: return 'sendbird-icon-reply';
        case Types.SEARCH: return 'sendbird-icon-search';
        case Types.SEND: return 'sendbird-icon-send';
        case Types.SETTINGS_FILLED: return 'sendbird-icon-settings-filled';
        case Types.SPINNER: return 'sendbird-icon-spinner';
        case Types.SUPERGROUP: return 'sendbird-icon-supergroup';
        case Types.THREAD: return 'sendbird-icon-thread';
        case Types.THUMBNAIL_NONE: return 'sendbird-icon-thumbnail-none';
        case Types.TOGGLE_OFF: return 'sendbird-icon-toggle-off';
        case Types.TOGGLE_ON: return 'sendbird-icon-toggle-on';
        case Types.USER: return 'sendbird-icon-user';
        case Types.FEEDBACK_LIKE: return 'sendbird-icon-feedback-like';
        case Types.FEEDBACK_DISLIKE: return 'sendbird-icon-feedback-dislike';
        default: return 'sendbird-icon-unknown'; // If you see this text 'icon' replace icon for it
    }
}

var _path$U;
function _extends$X() { return _extends$X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$X.apply(null, arguments); }
const SvgIconAdd = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$X({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$U || (_path$U = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M50.667 5.333a8 8 0 0 1 8 8v37.334a8 8 0 0 1-8 8H13.333a8 8 0 0 1-8-8V13.333a8 8 0 0 1 8-8zm0 5.334H13.333a2.667 2.667 0 0 0-2.666 2.666v37.334a2.667 2.667 0 0 0 2.666 2.666h37.334a2.667 2.667 0 0 0 2.666-2.666V13.333a2.667 2.667 0 0 0-2.666-2.666m-18.667 8a2.667 2.667 0 0 1 2.649 2.355l.018.311v8h8a2.667 2.667 0 0 1 .311 5.316l-.311.018h-8v8a2.667 2.667 0 0 1-5.316.311l-.018-.311v-8h-8a2.667 2.667 0 0 1-.311-5.316l.311-.018h8v-8A2.667 2.667 0 0 1 32 18.667",
  className: "icon-add_svg__fill"
})));

var _path$T;
function _extends$W() { return _extends$W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$W.apply(null, arguments); }
const SvgIconArrowLeft = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$W({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$T || (_path$T = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M33.886 8.781a2.67 2.67 0 0 1 .221 3.52l-.221.251-16.78 16.781H56a2.667 2.667 0 0 1 .311 5.316l-.311.018-38.895-.001 16.78 16.782a2.666 2.666 0 0 1 .222 3.52l-.221.251a2.67 2.67 0 0 1-3.52.222l-.252-.222L8.781 33.886a2.67 2.67 0 0 1-.222-3.52l.222-.252L30.114 8.781a2.67 2.67 0 0 1 3.772 0",
  className: "icon-arrow-left_svg__fill"
})));

var _path$S;
function _extends$V() { return _extends$V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$V.apply(null, arguments); }
const SvgIconAttach = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$V({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$S || (_path$S = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m55.334 28.926-24.506 23.34c-5.222 4.973-13.74 4.973-18.962 0-5.149-4.903-5.149-12.797 0-17.7l24.506-23.34c3.138-2.988 8.278-2.988 11.416 0 3.064 2.919 3.064 7.594 0 10.513L23.255 45.077c-1.055 1.005-2.815 1.005-3.87.001-.98-.933-.98-2.39 0-3.325l22.64-21.535a2.667 2.667 0 0 0-3.676-3.864L15.709 37.89a7.58 7.58 0 0 0-.001 11.05c3.113 2.966 8.11 2.966 11.224 0l24.533-23.338c5.272-5.021 5.272-13.217 0-18.238-5.197-4.95-13.573-4.95-18.77 0L8.187 30.704c-7.356 7.005-7.356 18.419 0 25.424 7.281 6.935 19.036 6.935 26.318 0l24.506-23.34a2.666 2.666 0 1 0-3.678-3.862z",
  className: "icon-attach_svg__fill"
})));

var _g$2, _defs;
function _extends$U() { return _extends$U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$U.apply(null, arguments); }
const SvgIconAudioOnLined = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$U({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g$2 || (_g$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("g", {
  clipPath: "url(#icon-audio-on-lined_svg__a)"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  d: "M32 0C26.11 0 21.333 4.776 21.333 10.667V32c0 5.891 4.776 10.667 10.667 10.667S42.667 37.89 42.667 32V10.667C42.667 4.776 37.89 0 32 0m-5.333 10.667a5.333 5.333 0 0 1 10.666 0V32a5.333 5.333 0 0 1-10.666 0z",
  className: "icon-audio-on-lined_svg__fill",
  clipRule: "evenodd"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  d: "M16 26.667a2.667 2.667 0 1 0-5.333 0V32c0 10.879 8.143 19.856 18.666 21.168v5.499h-8a2.667 2.667 0 0 0 0 5.333h21.334a2.667 2.667 0 1 0 0-5.333h-8v-5.499C45.19 51.856 53.333 42.88 53.333 32v-5.333a2.667 2.667 0 1 0-5.333 0V32c0 8.837-7.163 16-16 16s-16-7.163-16-16z",
  className: "icon-audio-on-lined_svg__fill"
}))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("clipPath", {
  id: "icon-audio-on-lined_svg__a"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));

var _path$R;
function _extends$T() { return _extends$T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$T.apply(null, arguments); }
const SvgIconBan = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$T({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$R || (_path$R = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8m12.333 21.333a1 1 0 0 1 1 1v3.334a1 1 0 0 1-1 1H19.667a1 1 0 0 1-1-1v-3.334a1 1 0 0 1 1-1z",
  className: "icon-ban_svg__fill"
})));

var _path$Q;
function _extends$S() { return _extends$S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$S.apply(null, arguments); }
const SvgIconBroadcast = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$S({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$Q || (_path$Q = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M58.545 5.498q.121.389.122.796v46.079a2.666 2.666 0 0 1-3.462 2.546l-17.951-5.61c-.645 5.273-5.14 9.358-10.587 9.358C20.776 58.667 16 53.89 16 48v-5.334h-5.333a8 8 0 0 1-7.997-7.75l-.003-.25V24a8 8 0 0 1 8-8H16L55.205 3.749a2.665 2.665 0 0 1 3.34 1.75zM21.333 44.587V48a5.333 5.333 0 0 0 10.652.398L32 47.92zm32-34.667-32 9.997v18.83l32 9.997zM16 21.333h-5.333a2.67 2.67 0 0 0-2.65 2.356L8 24v10.667a2.667 2.667 0 0 0 2.667 2.666H16z",
  className: "icon-broadcast_svg__fill"
})));

var _path$P;
function _extends$R() { return _extends$R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$R.apply(null, arguments); }
const SvgIconCamera = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$R({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$P || (_path$P = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M40 5.333c.892 0 1.724.446 2.219 1.188l4.541 6.812H56a8 8 0 0 1 7.986 7.53l.014.47v29.334a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V21.333a8 8 0 0 1 8-8h9.237l4.544-6.812a2.67 2.67 0 0 1 1.888-1.167l.331-.02zm-1.43 5.334H25.428l-4.542 6.812a2.66 2.66 0 0 1-1.887 1.167l-.331.02H8a2.67 2.67 0 0 0-2.667 2.667v29.334A2.667 2.667 0 0 0 8 53.333h48a2.667 2.667 0 0 0 2.667-2.666V21.333A2.667 2.667 0 0 0 56 18.667H45.333a2.67 2.67 0 0 1-2.218-1.188zM32 21.333c7.364 0 13.333 5.97 13.333 13.334S39.363 48 32 48s-13.333-5.97-13.333-13.333S24.637 21.333 32 21.333m0 5.334a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
  className: "icon-camera_svg__fill"
})));

var _path$O;
function _extends$Q() { return _extends$Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Q.apply(null, arguments); }
const SvgIconChannels = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$Q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$O || (_path$O = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m42.65 5.333.311.017a2.666 2.666 0 0 1 2.373 2.633l-.017.311-1.45 13.04h9.466a2.667 2.667 0 0 1 .311 5.315l-.31.018H43.271l-1.184 10.666h11.245a2.667 2.667 0 0 1 .312 5.316l-.31.018H41.495l-1.512 13.627a2.667 2.667 0 0 1-5.318-.277l.017-.311 1.448-13.04H25.496l-1.512 13.628a2.667 2.667 0 0 1-5.318-.277l.017-.311 1.448-13.04h-9.464a2.667 2.667 0 0 1-.311-5.315l.31-.018h10.057l1.186-10.667H10.667a2.667 2.667 0 0 1-.311-5.315l.31-.018h11.835l1.515-13.627a2.67 2.67 0 0 1 2.634-2.373l.311.017a2.666 2.666 0 0 1 2.373 2.633l-.017.311-1.45 13.04H38.5l1.515-13.628a2.67 2.67 0 0 1 2.634-2.373zm-5.927 32 1.186-10.667H27.272l-1.184 10.667z",
  className: "icon-channels_svg__fill"
})));

var _path$N;
function _extends$P() { return _extends$P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$P.apply(null, arguments); }
const SvgIconChat = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$P({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$N || (_path$N = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58q-8.947 2.868-12.504 1.981-4.198-1.047-1.657-3.663 1.757-2.094 2.928-5.234.934-2.502-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667M32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62 62 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.9 23.9 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8",
  className: "icon-chat_svg__fill"
})));

var _path$M;
function _extends$O() { return _extends$O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$O.apply(null, arguments); }
const SvgIconChatFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$O({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$M || (_path$M = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58q-8.947 2.868-12.504 1.981-4.198-1.047-1.657-3.663 1.757-2.094 2.928-5.234.934-2.502-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667",
  className: "icon-chat-filled_svg__fill"
})));

var _path$L;
function _extends$N() { return _extends$N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$N.apply(null, arguments); }
const SvgIconChevronDown = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$N({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$L || (_path$L = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.121 21.879a3 3 0 0 0-4.242 0 3 3 0 0 0 0 4.242l18 18a3 3 0 0 0 4.242 0l18-18a3 3 0 0 0 0-4.242 3 3 0 0 0-4.242 0L32 37.757z",
  className: "icon-chevron-down_svg__fill"
})));

var _path$K;
function _extends$M() { return _extends$M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$M.apply(null, arguments); }
const SvgIconChevronRight = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$M({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$K || (_path$K = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M22.114 46.114a2.668 2.668 0 0 0 3.772 3.772l16-16a2.67 2.67 0 0 0 0-3.772l-16-16a2.668 2.668 0 0 0-3.772 3.772L36.23 32z",
  className: "icon-chevron-right_svg__fill"
})));

var _path$J;
function _extends$L() { return _extends$L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$L.apply(null, arguments); }
const SvgIconClose = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$L({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$J || (_path$J = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M52.552 11.448a2.666 2.666 0 0 1 .222 3.52l-.222.251-16.781 16.78 16.781 16.782a2.665 2.665 0 0 1 0 3.771 2.666 2.666 0 0 1-3.52.222l-.251-.222L32 35.771 15.219 52.552a2.665 2.665 0 0 1-3.771 0 2.666 2.666 0 0 1-.222-3.52l.222-.251L28.228 32l-16.78-16.781a2.665 2.665 0 0 1 0-3.771 2.666 2.666 0 0 1 3.52-.222l.251.222 16.78 16.78 16.782-16.78a2.665 2.665 0 0 1 3.771 0",
  className: "icon-close_svg__fill"
})));

var _path$I;
function _extends$K() { return _extends$K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$K.apply(null, arguments); }
const SvgIconCollapse = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$K({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$I || (_path$I = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16 8a2.667 2.667 0 0 0-2.649 2.356l-.018.31v42.667a2.667 2.667 0 0 0 5.316.311l.018-.31V34.666h25.56l-6.113 6.114a2.67 2.67 0 0 0-.221 3.52l.221.251a2.666 2.666 0 0 0 3.52.222l.252-.222 10.666-10.666a2.666 2.666 0 0 0 .222-3.52l-.222-.252-10.666-10.666a2.666 2.666 0 0 0-3.993 3.52l.221.251 6.113 6.114h-25.56V10.667A2.667 2.667 0 0 0 16 8",
  className: "icon-collapse_svg__fill"
})));

var _path$H;
function _extends$J() { return _extends$J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$J.apply(null, arguments); }
const SvgIconCopy = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$J({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$H || (_path$H = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M53.333 21.333a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8h-24a8 8 0 0 1-8-8v-24a8 8 0 0 1 8-8zm0 5.334h-24a2.667 2.667 0 0 0-2.666 2.666v24A2.667 2.667 0 0 0 29.333 56h24A2.667 2.667 0 0 0 56 53.333v-24a2.667 2.667 0 0 0-2.667-2.666m-18.666-24a8 8 0 0 1 7.986 7.53l.014.47v2.666a2.667 2.667 0 0 1-5.316.311l-.018-.31v-2.667a2.67 2.67 0 0 0-2.355-2.65L34.667 8h-24a2.67 2.67 0 0 0-2.65 2.356l-.017.31v24a2.67 2.67 0 0 0 2.356 2.65l.31.017h2.667a2.667 2.667 0 0 1 .311 5.316l-.31.018h-2.667a8 8 0 0 1-7.987-7.53l-.013-.47v-24c0-4.26 3.33-7.743 7.53-7.987l.47-.013z",
  className: "icon-copy_svg__fill"
})));

var _path$G;
function _extends$I() { return _extends$I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$I.apply(null, arguments); }
const SvgIconCreate = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$I({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$G || (_path$G = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58q-8.947 2.868-12.504 1.981-4.198-1.047-1.657-3.663 1.757-2.094 2.928-5.234.934-2.502-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667M32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62 62 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.9 23.9 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8m2.667 16v5.333H40c3.556 0 3.556 5.334 0 5.334h-5.333V40c0 3.556-5.334 3.556-5.334 0v-5.333H24c-3.556 0-3.556-5.334 0-5.334h5.333V24c0-3.556 5.334-3.556 5.334 0",
  className: "icon-create_svg__fill"
})));

var _path$F;
function _extends$H() { return _extends$H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$H.apply(null, arguments); }
const SvgIconDelete = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$H({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$F || (_path$F = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M37.333 2.667c4.26 0 7.743 3.33 7.987 7.53l.013.47v2.666H56a2.667 2.667 0 0 1 .311 5.316l-.311.018h-2.668l.001 34.666c0 4.26-3.33 7.743-7.53 7.987l-.47.013H18.667a8 8 0 0 1-7.987-7.53l-.013-.47V18.667H8a2.667 2.667 0 0 1-.311-5.316L8 13.333h10.666v-2.666a8 8 0 0 1 7.53-7.987l.47-.013zm10.666 16H16v34.666a2.67 2.67 0 0 0 2.356 2.65l.31.017h26.667a2.67 2.67 0 0 0 2.65-2.356l.017-.31zm-21.332 8a2.667 2.667 0 0 1 2.648 2.355l.018.311v16a2.667 2.667 0 0 1-5.316.311l-.017-.31v-16a2.667 2.667 0 0 1 2.667-2.667m10.666 0a2.67 2.67 0 0 1 2.65 2.355l.017.311v16a2.667 2.667 0 0 1-5.315.311l-.018-.31v-16a2.667 2.667 0 0 1 2.666-2.667m0-18.667H26.667a2.67 2.67 0 0 0-2.65 2.356l-.017.31v2.667h16v-2.666a2.67 2.67 0 0 0-2.356-2.65L37.334 8z",
  className: "icon-delete_svg__fill"
})));

var _path$E;
function _extends$G() { return _extends$G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$G.apply(null, arguments); }
const SvgIconDisconnected = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$G({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$E || (_path$E = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m54.534 6.069-.248.217-9.736 9.735-.04.04-9.573 9.573q-.226.178-.405.404L6.286 54.286a2.423 2.423 0 0 0 3.18 3.645l.248-.217 13.374-13.373a2.42 2.42 0 0 0 1.88-.401 12.12 12.12 0 0 1 14.04 0 2.424 2.424 0 1 0 2.808-3.952 16.95 16.95 0 0 0-11.303-3.072l6.743-6.744a24.1 24.1 0 0 1 10.159 5.021 2.424 2.424 0 0 0 3.11-3.719 29 29 0 0 0-9.34-5.23l5.633-5.634a36.2 36.2 0 0 1 9.225 5.934 2.425 2.425 0 0 0 3.211-3.633 41 41 0 0 0-8.796-5.941l7.256-7.256a2.423 2.423 0 0 0-3.18-3.645m-35.04 21.474a29 29 0 0 0-6.032 3.942 2.424 2.424 0 0 0 3.137 3.697 24 24 0 0 1 5.022-3.282 2.425 2.425 0 0 0-2.127-4.357M4.748 22.909a2.424 2.424 0 0 0 3.207 3.636 36.36 36.36 0 0 1 26.978-8.977 2.424 2.424 0 0 0 .389-4.832A41.2 41.2 0 0 0 4.748 22.909",
  className: "icon-disconnected_svg__fill"
})));

var _path$D;
function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$F.apply(null, arguments); }
const SvgIconDocument = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$F({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$D || (_path$D = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M37.333 2.667a3 3 0 0 1 .274.014l.085.01.058.008q.07.01.141.026l.029.007q.075.016.146.037l.034.01q.357.107.663.303l.034.022q.053.034.104.072l.057.043q.045.033.085.068.091.075.176.16l-.126-.117q.075.065.143.135L55.21 19.438q.07.07.134.143l.035.04q.04.047.076.096l.04.054.07.1.024.038c.16.253.279.535.347.836l.01.048q.014.064.024.13l.006.048.007.051.004.041q.014.135.014.27v32a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V10.667a8 8 0 0 1 8-8zM34.666 8H16a2.667 2.667 0 0 0-2.667 2.667v42.666A2.667 2.667 0 0 0 16 56h32a2.667 2.667 0 0 0 2.667-2.667L50.666 24H37.333a2.667 2.667 0 0 1-2.648-2.356l-.018-.31zm12.227 10.667-6.894-6.894.001 6.894z",
  className: "icon-document_svg__fill"
})));

var _path$C;
function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$E.apply(null, arguments); }
const SvgIconDone = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$E({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$C || (_path$C = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M12.552 31.448a2.665 2.665 0 1 0-3.771 3.771l13.333 13.333a2.666 2.666 0 0 0 3.772 0L55.219 19.22a2.667 2.667 0 0 0-3.771-3.771L24 42.895z",
  className: "icon-done_svg__fill"
})));

var _path$B;
function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$D.apply(null, arguments); }
const SvgIconDoneAll = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$D({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$B || (_path$B = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M5.886 31.448 19.219 44.78a2.667 2.667 0 0 1-3.771 3.771L2.114 35.22a2.667 2.667 0 0 1 3.772-3.771zm52.228-16a2.666 2.666 0 1 1 3.772 3.771L32.552 48.552a2.665 2.665 0 0 1-3.771 0L15.448 35.22a2.665 2.665 0 0 1 0-3.771 2.665 2.665 0 0 1 3.771 0l11.448 11.447zm-9.562 0a2.665 2.665 0 0 1 0 3.771L32.556 35.215a2.665 2.665 0 0 1-3.771 0 2.664 2.664 0 0 1 0-3.77L44.78 15.447a2.665 2.665 0 0 1 3.771 0z",
  className: "icon-done-all_svg__fill"
})));

var _path$A;
function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$C.apply(null, arguments); }
const SvgIconDownload = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$C({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$A || (_path$A = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M56 42.667a2.667 2.667 0 0 1 2.649 2.355l.018.311v8c0 4.26-3.33 7.743-7.53 7.987l-.47.013H13.333a8 8 0 0 1-7.986-7.53l-.014-.47v-8a2.667 2.667 0 0 1 5.316-.311l.018.311v8a2.67 2.67 0 0 0 2.355 2.65l.311.017h37.334a2.667 2.667 0 0 0 2.648-2.356l.018-.31v-8A2.667 2.667 0 0 1 56 42.667m-36.552-8.781a2.666 2.666 0 0 1 3.52-3.993l.251.221 6.114 6.114V5.333a2.667 2.667 0 0 1 5.316-.311l.018.311v30.894l6.114-6.113a2.67 2.67 0 0 1 3.52-.221l.251.221a2.666 2.666 0 0 1 .222 3.52l-.222.252-10.658 10.657a2 2 0 0 1-.135.128l.127-.119a3 3 0 0 1-.195.176l-.056.045-.086.064-.056.04-.086.056-.06.036-.081.046-.079.04a3 3 0 0 1-.14.065l-.09.036q-.034.014-.067.025l-.09.03-.063.019q-.064.018-.13.034l-.013.003-.144.028-.064.01q-.045.008-.092.012l-.084.008-.103.006-.069.002h-.095q-.042 0-.082-.003l.139.003q-.126 0-.249-.011l-.061-.007-.092-.012-.09-.015-.118-.025-.04-.01a3 3 0 0 1-.34-.11l-.015-.006q-.074-.03-.145-.063l-.042-.02L30.71 45l-.067-.039q-.045-.026-.087-.054l-.062-.041q-.045-.03-.088-.063l-.04-.03-.008-.007a3 3 0 0 1-.251-.223z",
  className: "icon-download_svg__fill"
})));

var _path$z;
function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$B.apply(null, arguments); }
const SvgIconEdit = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$B({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 65 65"
}, props), _path$z || (_path$z = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M56 56a2.667 2.667 0 0 1 .311 5.315l-.311.018H8a2.667 2.667 0 0 1-.311-5.316L8 56zM35.448 3.448a2.665 2.665 0 0 1 3.771 0l10.667 10.666a2.67 2.67 0 0 1 0 3.772L20.552 47.219c-.5.5-1.178.781-1.885.781H8a2.667 2.667 0 0 1-2.667-2.667V34.667c0-.708.281-1.386.781-1.886zm1.885 5.659L10.667 35.77v6.896h6.89L44.227 16z",
  className: "icon-edit_svg__fill"
})));

var _path$y;
function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$A.apply(null, arguments); }
const SvgIconEmojiMore = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$A({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$y || (_path$y = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32.097 3.22c2.65 0 5.255.357 7.763 1.054a2.134 2.134 0 0 1-1.144 4.111 24.7 24.7 0 0 0-6.619-.899c-13.603 0-24.63 11.027-24.63 24.63s11.027 24.63 24.63 24.63 24.63-11.027 24.63-24.63c0-2.227-.295-4.413-.87-6.518a2.13 2.13 0 0 1 1.494-2.62 2.13 2.13 0 0 1 2.62 1.494 29 29 0 0 1 1.023 7.644c0 15.96-12.938 28.897-28.897 28.897-15.96 0-28.897-12.937-28.897-28.897S16.138 3.22 32.097 3.22m10.705 34.792a2.133 2.133 0 0 1 2.024 2.808c-1.873 5.623-6.937 9.488-12.729 9.488s-10.856-3.865-12.73-9.488a2.134 2.134 0 0 1 1.875-2.803l.15-.005zm-3.477 4.266H24.867l.294.382c1.539 1.887 3.718 3.113 6.115 3.342l.314.024.507.015c2.617 0 5.037-1.188 6.743-3.151l.193-.23zM21.392 21.954c1.087 0 1.985.814 2.116 1.866l.017.267v5.353a2.133 2.133 0 0 1-4.25.268l-.017-.268v-5.353c0-1.178.955-2.133 2.134-2.133m21.41 0c1.088 0 1.985.814 2.117 1.866l.017.267v5.353a2.133 2.133 0 0 1-4.25.268l-.017-.268v-5.353c0-1.178.955-2.133 2.133-2.133M54.853 0a.8.8 0 0 1 .8.8v7.786h7.76a.8.8 0 0 1 .8.8v2.667a.8.8 0 0 1-.8.8h-7.76v7.758a.8.8 0 0 1-.8.8h-2.666a.8.8 0 0 1-.8-.8v-7.758h-7.785a.8.8 0 0 1-.8-.8V9.387a.8.8 0 0 1 .8-.8l7.784-.001V.8a.8.8 0 0 1 .8-.8z",
  className: "icon-emoji-more_svg__fill"
})));

var _path$x;
function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$z.apply(null, arguments); }
const SvgIconError = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$x || (_path$x = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 5.06a8 8 0 0 1 6.561 3.424l.287.439 22.608 37.744a8 8 0 0 1 .022 7.962 8 8 0 0 1-6.356 4.014l-.535.024H9.384a8 8 0 0 1-6.862-4.038 8.01 8.01 0 0 1-.226-7.493l.27-.506L25.16 8.91A8 8 0 0 1 32 5.06m0 5.333c-.816 0-1.58.372-2.076.99l-.196.28-22.565 37.67a2.67 2.67 0 0 0 1.909 3.973l.341.027h45.144a2.67 2.67 0 0 0 2.45-3.659l-.148-.304L34.28 11.676A2.67 2.67 0 0 0 32 10.393m0 32.274A2.667 2.667 0 1 1 32 48a2.667 2.667 0 0 1 0-5.333m0-21.334a2.667 2.667 0 0 1 2.649 2.356l.018.311v10.667a2.667 2.667 0 0 1-5.316.311l-.018-.311V24A2.667 2.667 0 0 1 32 21.333",
  className: "icon-error_svg__fill"
})));

var _path$w;
function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$y.apply(null, arguments); }
const SvgIconExpand = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$w || (_path$w = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M48 8a2.667 2.667 0 0 1 2.649 2.356l.018.31V32l-.001.027v21.306a2.667 2.667 0 0 1-5.315.311l-.018-.31V34.665H19.772l6.114 6.115a2.67 2.67 0 0 1 .221 3.52l-.221.251a2.666 2.666 0 0 1-3.52.222l-.252-.222-10.666-10.666a2.666 2.666 0 0 1-.222-3.52l.222-.252 10.666-10.666a2.666 2.666 0 0 1 3.993 3.52l-.221.251-6.113 6.114h25.56V10.667A2.667 2.667 0 0 1 48 8",
  className: "icon-expand_svg__fill"
})));

var _path$v;
function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$x.apply(null, arguments); }
const SvgIconFileAudio = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$v || (_path$v = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M30.52 12.51c1.685-1.226 4.139-.103 4.139 1.893v35.194c0 1.996-2.454 3.119-4.138 1.893l-12.45-9.909H7.898c-1.416 0-2.564-1.074-2.564-2.399V24.818c0-1.325 1.148-2.4 2.564-2.4h10.175zm20.427.163c10.293 10.667 10.293 27.987 0 38.654a2.137 2.137 0 0 1-3.156-.047c-.86-.942-.84-2.448.044-3.364 8.49-8.799 8.49-23.033 0-31.832-.884-.916-.904-2.422-.044-3.364a2.137 2.137 0 0 1 3.156-.047m-8.492 8.799c5.597 5.8 5.597 15.231 0 21.031a2.136 2.136 0 0 1-3.156-.046c-.86-.942-.84-2.448.044-3.364 3.794-3.932 3.794-10.279 0-14.211-.884-.916-.904-2.422-.044-3.363a2.136 2.136 0 0 1 3.156-.047",
  className: "icon-file-audio_svg__fill"
})));

var _path$u;
function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$w.apply(null, arguments); }
const SvgIconFileDocument = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$u || (_path$u = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M39.414 6.4a2.4 2.4 0 0 1 1.71.701l12.642 12.75c.407.41.634.953.634 1.516v29.765c0 3.542-4.342 6.468-8 6.468H16.16c-3.658 0-6.4-2.926-6.4-6.468L9.6 12.868c0-3.542 2.902-6.468 6.56-6.468zm3.331 35.173-21.49.027-.147.005c-1.066.08-1.908 1.014-1.908 2.155 0 1.193.92 2.16 2.055 2.16l21.49-.027.147-.005c1.066-.08 1.908-1.014 1.908-2.155 0-1.193-.92-2.16-2.055-2.16m0-8.533-21.49.027-.147.005c-1.066.08-1.908 1.014-1.908 2.155 0 1.193.92 2.16 2.055 2.16l21.49-.027.147-.005c1.066-.08 1.908-1.014 1.908-2.155 0-1.193-.92-2.16-2.055-2.16m-11.807-8.507h-9.6l-.153.006a2.15 2.15 0 0 0-1.985 2.154c0 1.193.957 2.16 2.138 2.16h9.6l.152-.005a2.15 2.15 0 0 0 1.985-2.155c0-1.193-.957-2.16-2.137-2.16",
  className: "icon-file-document_svg__fill"
})));

var _path$t;
function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$v.apply(null, arguments); }
const SvgIconFreeze = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$t || (_path$t = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m41.636 3.226.251.222a2.67 2.67 0 0 1 .222 3.52l-.222.251-7.219 7.218V27.38l11.209-6.472 2.643-9.86a2.667 2.667 0 0 1 5.218 1.051l-.067.329-2.237 8.35 8.352 2.24a2.67 2.67 0 0 1 1.952 2.938l-.067.328a2.67 2.67 0 0 1-2.937 1.952l-.329-.066-9.861-2.643L37.334 32l11.209 6.47 9.862-2.64.329-.067a2.67 2.67 0 0 1 2.937 1.952l.067.328a2.67 2.67 0 0 1-1.952 2.938l-8.353 2.237 2.238 8.353.067.329a2.666 2.666 0 0 1-5.218 1.052l-2.643-9.861-11.209-6.472v12.944l7.219 7.218a2.667 2.667 0 0 1-3.52 3.993l-.251-.222L32 54.437l-6.114 6.115a2.666 2.666 0 0 1-3.52.222l-.251-.222a2.666 2.666 0 0 1-.222-3.52l.222-.251 7.218-7.22V36.62l-11.209 6.47-2.642 9.863a2.666 2.666 0 0 1-5.218-1.052l.067-.329 2.236-8.351-8.35-2.24a2.665 2.665 0 0 1-1.953-2.937l.067-.328a2.665 2.665 0 0 1 2.937-1.952l.329.066 9.861 2.642L26.667 32l-11.209-6.472-9.86 2.643-.329.066a2.665 2.665 0 0 1-2.937-1.952l-.067-.328a2.67 2.67 0 0 1 1.952-2.938l8.35-2.239-2.235-8.351-.067-.329a2.667 2.667 0 0 1 5.218-1.052l2.642 9.862 11.209 6.47V14.439L22.116 7.22a2.665 2.665 0 0 1 0-3.771 2.666 2.666 0 0 1 3.52-.222l.251.222 6.114 6.112 6.115-6.112a2.666 2.666 0 0 1 3.52-.222z",
  className: "icon-freeze_svg__fill"
})));

var _path$s;
function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$u.apply(null, arguments); }
const SvgIconGif = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$s || (_path$s = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.664 45.333q3.233 0 5.89-.953 2.658-.954 4.113-2.683V31.34h-10.29v3.94h4.902v4.474q-1.292 1.284-4.327 1.283-3.017 0-4.58-2.085-1.561-2.085-1.562-6.168v-1.657q.018-4.047 1.455-6.097t4.184-2.05q2.155 0 3.385 1.034t1.59 3.262h5.243q-.486-4.206-3.107-6.408t-7.273-2.201q-3.34 0-5.827 1.506t-3.807 4.35q-1.32 2.843-1.32 6.728v1.765q.036 3.78 1.428 6.578 1.392 2.797 3.95 4.269 2.56 1.47 5.953 1.47m20.67 0V18.667H32v26.666h5.333zm10.396 0V34.436h9.721v-4.432H47.73v-6.887h10.937v-4.45h-16v26.666z",
  className: "icon-gif_svg__fill"
})));

var _path$r;
function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$t.apply(null, arguments); }
const SvgIconInfo = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$r || (_path$r = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8m1.667 21.333a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3.334a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1zm-1.667-8a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334",
  className: "icon-info_svg__fill"
})));

var _path$q;
function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$s.apply(null, arguments); }
const SvgIconLeave = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$q || (_path$q = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 5.333a2.667 2.667 0 0 1 .311 5.316l-.311.018H10.667a2.67 2.67 0 0 0-2.65 2.355L8 13.333v37.334a2.667 2.667 0 0 0 2.356 2.648l.31.018H32a2.667 2.667 0 0 1 .311 5.316l-.311.018H10.667a8 8 0 0 1-7.987-7.53l-.013-.47V13.333a8 8 0 0 1 7.53-7.986l.47-.014zm17.634 13.893.252.222 10.666 10.666a2.666 2.666 0 0 1 .222 3.52l-.222.252-10.666 10.666a2.666 2.666 0 0 1-3.993-3.52l.221-.251 4.78-4.782L20 36a2.667 2.667 0 0 1-.311-5.315l.311-.018h33.56l-7.446-7.448a2.67 2.67 0 0 1-.221-3.52l.221-.251a2.666 2.666 0 0 1 3.52-.222",
  className: "icon-leave_svg__fill"
})));

var _path$p;
function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$r.apply(null, arguments); }
const SvgIconMembers = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$p || (_path$p = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M34.667 37.333c7.17 0 13.018 5.66 13.32 12.755l.013.579V56a2.667 2.667 0 0 1-5.315.311L42.667 56v-5.333c0-4.26-3.33-7.743-7.53-7.987l-.47-.013H13.333a8 8 0 0 0-7.986 7.53l-.014.47V56a2.667 2.667 0 0 1-5.316.311L0 56v-5.333c0-7.17 5.66-13.019 12.755-13.321l.578-.013zM54 37.765a13.33 13.33 0 0 1 9.986 12.297l.014.605V56a2.667 2.667 0 0 1-5.315.311L58.667 56v-5.331a8 8 0 0 0-6-7.74A2.667 2.667 0 1 1 54 37.765M24 5.333c7.364 0 13.333 5.97 13.333 13.334S31.363 32 24 32s-13.333-5.97-13.333-13.333S16.637 5.333 24 5.333m19.328.43a13.333 13.333 0 0 1 0 25.834 2.667 2.667 0 1 1-1.323-5.167 8 8 0 0 0 0-15.5 2.667 2.667 0 1 1 1.323-5.167M24 10.667a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
  className: "icon-members_svg__fill"
})));

var _path$o;
function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$q.apply(null, arguments); }
const SvgIconMessage = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$o || (_path$o = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58q-8.947 2.868-12.504 1.981-4.198-1.047-1.657-3.663 1.757-2.094 2.928-5.234.934-2.502-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667M32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62 62 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.9 23.9 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8M18.667 29.333a2.667 2.667 0 1 1-.001 5.333 2.667 2.667 0 0 1 .001-5.333m13.333 0a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334m13.333 0a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334",
  className: "icon-message_svg__fill"
})));

var _path$n;
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
const SvgIconModerations = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$n || (_path$n = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M18.667 34.667a2.667 2.667 0 0 1 .311 5.316l-.311.017h-5.334v16a2.667 2.667 0 0 1-5.316.311L8 56V40H2.667a2.667 2.667 0 0 1-.311-5.315l.31-.018h16zM32 29.333a2.667 2.667 0 0 1 2.649 2.356l.018.311v24a2.667 2.667 0 0 1-5.316.311L29.333 56V32A2.667 2.667 0 0 1 32 29.333M61.333 40a2.667 2.667 0 0 1 .311 5.315l-.31.018h-5.335L56 56a2.667 2.667 0 0 1-5.315.311L50.667 56l-.001-10.668-5.333.001a2.667 2.667 0 0 1-.311-5.316l.311-.017zm-8-34.667a2.67 2.67 0 0 1 2.65 2.356L56 8v24a2.667 2.667 0 0 1-5.315.311L50.667 32V8a2.667 2.667 0 0 1 2.666-2.667m-42.666 0a2.667 2.667 0 0 1 2.648 2.356l.018.311v18.667a2.667 2.667 0 0 1-5.316.311L8 26.667V8a2.667 2.667 0 0 1 2.667-2.667m21.333 0a2.667 2.667 0 0 1 2.649 2.356l.018.311-.001 10.666H40a2.668 2.668 0 0 1 .311 5.317L40 24H24a2.667 2.667 0 0 1-.311-5.315l.311-.018h5.333V8A2.667 2.667 0 0 1 32 5.333",
  className: "icon-moderations_svg__fill"
})));

var _path$m;
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
const SvgIconMore = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$m || (_path$m = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 45.333a5.333 5.333 0 1 1 0 10.666 5.333 5.333 0 0 1 0-10.666M32 28a5.333 5.333 0 1 1 0 10.668A5.333 5.333 0 0 1 32 28m0-17.333c2.946 0 5.333 2.387 5.333 5.333S34.946 21.333 32 21.333 26.667 18.946 26.667 16s2.387-5.333 5.333-5.333",
  className: "icon-more_svg__fill"
})));

var _path$l;
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
const SvgIconMute = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$l || (_path$l = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m55.62 19.616.067.123A26.55 26.55 0 0 1 58.667 32c0 4.326-1.03 8.41-2.864 12.025q-1.518 4.089-.67 6.363 1.066 2.855 2.662 4.758 2.31 2.379-1.506 3.33-3.135.782-10.879-1.646l-.488-.155-1.594-.527A26.6 26.6 0 0 1 32 58.667a26.55 26.55 0 0 1-12.326-3.014l-.059-.03 4-4A21.2 21.2 0 0 0 32 53.333c2.993 0 5.89-.614 8.562-1.786l.498-.226 1.925-.905 3.613 1.196.695.219q1.093.337 2.054.595l.472.125.485.121-.167-.42-.2-.594c-.814-2.685-.484-5.681.713-9.065l.154-.425.106-.284.528-1.084a21.2 21.2 0 0 0 1.895-8.8 21.2 21.2 0 0 0-1.71-8.385zm2.266-13.502a2.67 2.67 0 0 1 .221 3.52l-.221.252-48 48a2.668 2.668 0 0 1-3.993-3.52l.221-.252 5.238-5.237a26.56 26.56 0 0 1-6.015-16.412L5.333 32C5.333 17.272 17.273 5.333 32 5.333a26.55 26.55 0 0 1 16.877 6.02l5.237-5.239a2.67 2.67 0 0 1 3.772 0M32 10.667c-11.782 0-21.333 9.55-21.333 21.333 0 4.836 1.614 9.401 4.48 13.084l29.936-29.938A21.25 21.25 0 0 0 32 10.666z",
  className: "icon-mute_svg__fill"
})));

var _path$k;
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
const SvgIconNotifications = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$k || (_path$k = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M36.613 53.333c2.056 0 3.338 2.227 2.307 4.005a8 8 0 0 1-13.84 0c-.98-1.689.129-3.783 2.004-3.988l.303-.017zM32 2.667c11.56 0 20.972 9.194 21.323 20.669l.01.664v13.333a5.334 5.334 0 0 0 4.936 5.319l.753.033c2.963.318 3.077 4.616.342 5.24l-.342.056-.355.019H5.333l-.355-.019c-3.082-.33-3.082-4.965 0-5.296l.753-.033a5.335 5.335 0 0 0 4.92-4.9l.016-.419V24c0-11.782 9.55-21.333 21.333-21.333M32 8c-8.636 0-15.674 6.842-15.989 15.4L16 24v13.333c0 1.562-.336 3.046-.939 4.383l-.275.564-.218.387h34.861l-.215-.387a10.6 10.6 0 0 1-1.146-3.74l-.055-.674-.013-.533V24c0-8.837-7.163-16-16-16",
  className: "icon-notifications_svg__fill"
})));

var _path$j;
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
const SvgIconNotificationsOffFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$j || (_path$j = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M36.613 53.333c2.056 0 3.338 2.227 2.307 4.005a8 8 0 0 1-13.84 0c-.98-1.689.129-3.783 2.004-3.988l.303-.017zM32 2.667c7.173 0 13.52 3.54 17.387 8.97l5.686-5.687a2.105 2.105 0 0 1 2.85-.117l.127.117a2.105 2.105 0 0 1 0 2.977L8.927 58.05c-.78.781-2.023.82-2.85.117l-.127-.117a2.105 2.105 0 0 1 0-2.977L13.023 48h-7.69l-.355-.019c-3.082-.33-3.082-4.965 0-5.296l.753-.033a5.335 5.335 0 0 0 4.92-4.9l.016-.419V24c0-11.782 9.55-21.333 21.333-21.333m20.85 16.795c.271 1.253.433 2.548.473 3.874l.01.664v13.333a5.334 5.334 0 0 0 4.936 5.319l.753.033c2.963.318 3.077 4.616.342 5.24l-.342.056-.355.019H24.31z",
  className: "icon-notifications-off-filled_svg__fill"
})));

var _path$i;
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
const SvgIconOperator = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$i || (_path$i = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M29.83 6.45a2.667 2.667 0 0 1 4.34 0l11.697 16.374L57 13.918c1.88-1.504 4.573.054 4.32 2.35l-.047.29-8 37.334A2.666 2.666 0 0 1 50.666 56H13.333a2.666 2.666 0 0 1-2.607-2.108l-8-37.333c-.525-2.452 2.315-4.207 4.273-2.641l11.132 8.906zM32 12.587l-11.163 15.63a2.667 2.667 0 0 1-3.836.532l-7.497-5.997 5.984 27.915h33.021l5.984-27.915L47 28.749a2.667 2.667 0 0 1-3.632-.281l-.204-.251zM32 32a5.333 5.333 0 1 1 0 10.668A5.333 5.333 0 0 1 32 32",
  className: "icon-operator_svg__fill"
})));

var _path$h;
function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
const SvgIconPhoto = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$h || (_path$h = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M50.667 5.333a8 8 0 0 1 8 8v37.334a8 8 0 0 1-8 8H13.333a8 8 0 0 1-8-8V13.333a8 8 0 0 1 8-8zm-8 25.107L19.77 53.332l30.896.001a2.667 2.667 0 0 0 2.661-2.498l.005-.168v-9.564L42.666 30.44zm8-19.773H13.333a2.667 2.667 0 0 0-2.666 2.666v37.334c0 1.143.72 2.119 1.731 2.498L40.781 24.78a2.67 2.67 0 0 1 3.52-.222l.251.222 8.78 8.78.001-20.228a2.667 2.667 0 0 0-2.498-2.661zm-28 5.333a6.666 6.666 0 1 1 0 13.333 6.666 6.666 0 0 1 0-13.333m0 5.333a1.334 1.334 0 1 0 0 2.667 1.334 1.334 0 0 0 0-2.667",
  className: "icon-photo_svg__fill"
})));

var _path$g;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
const SvgIconPlay = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$g || (_path$g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M51.908 34.75c1.9-1.233 1.896-3.26.013-4.514L19.376 8.577c-1.893-1.26-3.404-.391-3.376 1.968l.522 42.888c.028 2.347 1.596 3.247 3.493 2.016z",
  className: "icon-play_svg__fill"
})));

var _path$f;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
const SvgIconPlus = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$f || (_path$f = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M34.667 29.333h18.666c3.556 0 3.556 5.334 0 5.334H34.667v18.666c0 3.556-5.334 3.556-5.334 0V34.667H10.667c-3.556 0-3.556-5.334 0-5.334h18.666V10.667c0-3.556 5.334-3.556 5.334 0z",
  className: "icon-plus_svg__fill"
})));

var _path$e;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
const SvgIconQuestion = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$e || (_path$e = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 61.333C15.8 61.333 2.667 48.2 2.667 32S15.8 2.667 32 2.667 61.333 15.8 61.333 32 48.2 61.333 32 61.333M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24m2.213-18.63a2.667 2.667 0 1 1-5.333 0v-2.69c0-1.148.734-2.168 1.823-2.53.173-.058.532-.195 1.01-.407.809-.36 1.616-.79 2.354-1.282 1.835-1.223 2.813-2.528 2.813-3.786a5.333 5.333 0 0 0-10.364-1.777 2.667 2.667 0 0 1-5.032-1.77 10.668 10.668 0 0 1 20.729 3.551c0 3.413-2.022 6.109-5.187 8.22a21 21 0 0 1-2.813 1.578zm-5.333 7.523a2.667 2.667 0 1 1 5.333 0v.44a2.667 2.667 0 1 1-5.333 0v-.44",
  className: "icon-question_svg__fill"
})));

var _path$d;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
const SvgIconRefresh = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$d || (_path$d = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m46.14 14.43.562.537 6.631 6.167v-7.8a2.67 2.67 0 0 1 2.356-2.65l.311-.017a2.667 2.667 0 0 1 2.649 2.355l.018.311v16a2.67 2.67 0 0 1-2.356 2.65L56 32H40a2.667 2.667 0 0 1-.311-5.315l.311-.018h11.452l-8.44-7.85c-5.964-5.893-15.168-7.182-22.563-3.156-7.38 4.018-11.172 12.357-9.314 20.455 1.859 8.107 8.935 14.032 17.362 14.518 8.43.487 16.162-4.585 18.967-12.426a2.667 2.667 0 0 1 5.022 1.797C48.88 50.082 38.973 56.582 28.19 55.959c-10.785-.623-19.862-8.222-22.254-18.65C3.542 26.872 8.426 16.135 17.9 10.977c9.227-5.024 20.65-3.579 28.241 3.453z",
  className: "icon-refresh_svg__fill"
})));

var _path$c;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
const SvgIconRemove = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$c || (_path$c = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667m9.886 19.447a2.67 2.67 0 0 0-3.772 0L32 28.23l-6.114-6.115-.134-.124a2.667 2.667 0 0 0-3.638.124l-.124.134a2.667 2.667 0 0 0 .124 3.638L28.23 32l-6.115 6.114-.124.134a2.667 2.667 0 0 0 .124 3.638l.134.124a2.667 2.667 0 0 0 3.638-.124L32 35.77l6.114 6.115.134.124a2.667 2.667 0 0 0 3.638-.124l.124-.134a2.667 2.667 0 0 0-.124-3.638L35.77 32l6.115-6.114.124-.134a2.667 2.667 0 0 0-.124-3.638z",
  className: "icon-remove_svg__fill"
})));

var _path$b;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
const SvgIconReplyFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}, props), _path$b || (_path$b = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.774 10.5c.062 0 .12-.025.164-.07a.22.22 0 0 0 .062-.164c-.069-1.447-.495-2.678-1.268-3.66-.618-.785-1.455-1.409-2.49-1.855a9.3 9.3 0 0 0-2.406-.655 10 10 0 0 0-.862-.078V2.225a.23.23 0 0 0-.128-.203.23.23 0 0 0-.24.028L.084 5.692A.22.22 0 0 0 0 5.865c0 .068.03.132.082.175l4.523 3.737c.067.056.16.068.24.03a.22.22 0 0 0 .13-.202v-1.95c1.134-.08 2.178.003 3.107.25a6.4 6.4 0 0 1 2.087.96c1.018.724 1.398 1.5 1.401 1.507a.23.23 0 0 0 .204.128",
  className: "icon-reply-filled_svg__fill"
})));

var _path$a;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
const SvgIconSearch = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$a || (_path$a = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M26.667 48C14.885 48 5.333 38.449 5.333 26.667S14.885 5.333 26.667 5.333 48 14.885 48 26.667c0 4.93-1.672 9.469-4.48 13.081l13.67 13.67a2.668 2.668 0 0 1-3.772 3.772l-13.67-13.67A21.24 21.24 0 0 1 26.667 48m0-5.333c8.836 0 16-7.164 16-16s-7.164-16-16-16-16 7.163-16 16 7.163 16 16 16",
  className: "icon-search_svg__fill"
})));

var _path$9;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
const SvgIconSend = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$9 || (_path$9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M59.795 29.43 7.329 2.979C4.691 1.802 1.76 4.153 2.932 6.798l6.925 18.609a2 2 0 0 0 1.544 1.275l32.273 5.394L11.4 37.47a2 2 0 0 0-1.544 1.275L2.932 57.353c-.879 2.645 1.76 4.997 4.397 3.527l52.466-26.453c2.051-.882 2.051-3.82 0-4.996z",
  className: "icon-send_svg__fill"
})));

var _path$8;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
const SvgIconSettingsFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$8 || (_path$8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 2.667A5.33 5.33 0 0 1 37.333 8v.24A4.4 4.4 0 0 0 40 12.267a4.4 4.4 0 0 0 4.853-.88l.16-.16a5.33 5.33 0 0 1 7.547 0 5.333 5.333 0 0 1 0 7.546l-.16.16a4.4 4.4 0 0 0-.88 4.854V24a4.4 4.4 0 0 0 4.027 2.667H56c2.946 0 5.333 2.387 5.333 5.333S58.946 37.333 56 37.333h-.24A4.4 4.4 0 0 0 51.733 40a4.4 4.4 0 0 0 .88 4.853l.16.16a5.33 5.33 0 0 1 0 7.547 5.333 5.333 0 0 1-7.546 0l-.16-.16a4.4 4.4 0 0 0-4.854-.88 4.4 4.4 0 0 0-2.666 4.027V56a5.333 5.333 0 0 1-10.667 0v-.24A4.4 4.4 0 0 0 24 51.733a4.4 4.4 0 0 0-4.853.88l-.16.16a5.33 5.33 0 0 1-7.547 0 5.333 5.333 0 0 1 0-7.546l.16-.16a4.4 4.4 0 0 0 .88-4.854 4.4 4.4 0 0 0-4.027-2.666H8A5.333 5.333 0 0 1 8 26.88h.24A4.4 4.4 0 0 0 12.267 24a4.4 4.4 0 0 0-.88-4.853l-.16-.16a5.33 5.33 0 0 1 0-7.547 5.333 5.333 0 0 1 7.546 0l.16.16a4.4 4.4 0 0 0 4.854.88H24a4.4 4.4 0 0 0 2.667-4.027V8A5.33 5.33 0 0 1 32 2.667M32 24a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
  className: "icon-settings-filled_svg__fill"
})));

var _path$7;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
const SvgIconSlideLeft = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path$7 || (_path$7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  d: "M21.943 24.39a1.333 1.333 0 0 1-1.886 1.886l-9.333-9.333a1.333 1.333 0 0 1 0-1.886l9.333-9.333a1.333 1.333 0 1 1 1.886 1.885L13.553 16z",
  className: "icon-slide-left_svg__fill",
  clipRule: "evenodd"
})));

var _path$6;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
const SvgIconSpinner = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$6 || (_path$6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M32 61.333C48.2 61.333 61.333 48.2 61.333 32S48.2 2.667 32 2.667 2.667 15.8 2.667 32a2.838 2.838 0 1 0 5.678 0C8.344 18.935 18.934 8.344 32 8.344c13.065 0 23.656 10.591 23.656 23.656S45.065 55.656 32 55.656a2.838 2.838 0 1 0 0 5.677",
  className: "icon-spinner_svg__fill"
})));

var _path$5;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
const SvgIconSupergroup = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$5 || (_path$5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M36.889 43.013c6.608 0 12.121 4.685 12.43 10.734l.014.537V58a2.667 2.667 0 0 1-5.316.311L44 58v-3.716c0-3.07-2.87-5.718-6.636-5.925l-.475-.013H27.11c-3.838 0-6.86 2.525-7.096 5.557l-.015.381V58a2.667 2.667 0 0 1-5.315.311L14.667 58v-3.716c0-6.126 5.324-10.986 11.864-11.26l.58-.011zm18.578-17.291q.401 0 .784.118c4.632 1.426 7.518 4.801 7.736 9.688l.013.594v12.8a2.667 2.667 0 0 1-5.315.311l-.018-.311V36.124c-.002-2.595-1.163-4.171-3.528-5.034l-.104-.037-2.502.002a2.667 2.667 0 0 1-2.648-2.356l-.018-.31a2.67 2.67 0 0 1 2.355-2.65l.311-.017zm-44 0 .31.018a2.666 2.666 0 0 1 2.356 2.648l-.018.311a2.666 2.666 0 0 1-2.648 2.356l-2.51-.002-.119.042c-2.246.85-3.503 2.574-3.505 5.147v12.68l-.018.31A2.666 2.666 0 0 1 0 48.922V36.24l.014-.591c.225-4.874 3.203-8.415 7.712-9.809q.384-.117.788-.118zM32 19.958c5.512 0 10 4.409 10 9.871s-4.488 9.872-10 9.872-10-4.41-10-9.872 4.488-9.871 10-9.871m0 5.333c-2.588 0-4.667 2.043-4.667 4.538s2.08 4.538 4.667 4.538c2.588 0 4.667-2.042 4.667-4.538 0-2.495-2.08-4.538-4.667-4.538M17.333 2.667c5.513 0 10 4.409 10 9.871s-4.487 9.871-10 9.871c-5.512 0-10-4.409-10-9.871s4.488-9.871 10-9.871m29.334 0c5.512 0 10 4.409 10 9.871s-4.488 9.871-10 9.871c-5.513 0-10-4.409-10-9.871s4.487-9.871 10-9.871M17.333 8c-2.587 0-4.666 2.042-4.666 4.538s2.079 4.538 4.666 4.538S22 15.034 22 12.538 19.921 8 17.333 8m29.334 0C44.079 8 42 10.042 42 12.538s2.079 4.538 4.667 4.538 4.666-2.042 4.666-4.538S49.254 8 46.667 8",
  className: "icon-supergroup_svg__fill"
})));

var _path$4, _path2;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
const SvgIconThread = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path$4 || (_path$4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  d: "M38.824 25.895a2.95 2.95 0 0 1 4.16-.074L57.1 39.378a2.92 2.92 0 0 1 .002 4.213L42.985 57.177a2.95 2.95 0 0 1-4.158-.07 2.92 2.92 0 0 1 .07-4.14l11.928-11.48-11.926-11.451a2.92 2.92 0 0 1-.075-4.14",
  className: "icon-thread_svg__fill",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  d: "M8.866 6c1.583 0 2.866 1.216 2.866 2.716V25.5c0 7.672 6.846 14.068 15.475 14.068h22.927c1.583 0 2.866 1.216 2.866 2.716S51.717 45 50.134 45H27.207C15.604 45 6 36.35 6 25.5V8.716C6 7.216 7.283 6 8.866 6",
  className: "icon-thread_svg__fill",
  clipRule: "evenodd"
})));

var _path$3;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
const SvgIconThumbnailNone = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$3 || (_path$3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M34.667 5.333a2.667 2.667 0 0 1 0 5.334H13.333a2.667 2.667 0 0 0-2.666 2.666v37.334c0 1.143.72 2.118 1.73 2.497l28.384-28.383a2.667 2.667 0 0 1 3.771 0l8.781 8.78v-4.228a2.667 2.667 0 0 1 2.498-2.661l.169-.005a2.667 2.667 0 0 1 2.667 2.666v21.334a8 8 0 0 1-8 8H13.33a8 8 0 0 1-7.998-8V13.333a8 8 0 0 1 8-8zm8 25.105L19.77 53.333h30.897a2.667 2.667 0 0 0 2.661-2.498l.005-.168v-9.563zM22.667 16a6.666 6.666 0 1 1 0 13.333 6.666 6.666 0 0 1 0-13.333m0 5.333a1.334 1.334 0 1 0 0 2.667 1.334 1.334 0 0 0 0-2.667M56.78 3.448a2.665 2.665 0 0 1 3.771 0 2.665 2.665 0 0 1 0 3.771l-4.782 4.78 4.782 4.782c.998.998 1.04 2.59.125 3.638l-.125.133a2.665 2.665 0 0 1-3.771 0l-4.782-4.781-4.78 4.781a2.667 2.667 0 0 1-3.638.125l-.133-.125a2.665 2.665 0 0 1 0-3.771L48.228 12l-4.78-4.781a2.667 2.667 0 0 1-.125-3.638l.125-.133a2.665 2.665 0 0 1 3.771 0l4.78 4.78z",
  className: "icon-thumbnail-none_svg__fill"
})));

var _g$1;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
const SvgIconToggleoff = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 88 48"
}, props), _g$1 || (_g$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("rect", {
  width: 80,
  height: 40,
  x: 4,
  y: 4,
  fill: "#000",
  className: "icon-toggleoff_svg__fill",
  rx: 20
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 12,
  fill: "#FFF"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#FFF",
  d: "M64 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4zm0 2H24C14.059 6 6 14.059 6 24c0 9.764 7.774 17.712 17.47 17.992L24 42h40c9.941 0 18-8.059 18-18 0-9.764-7.774-17.712-17.47-17.992z"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  d: "M64 0H24C10.745 0 0 10.745 0 24s10.745 24 24 24h40c13.255 0 24-10.745 24-24S77.255 0 64 0m0 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4z",
  className: "icon-toggleoff_svg__fill"
}))));

var _g;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
const SvgIconToggleon = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 88 48"
}, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("rect", {
  width: 80,
  height: 40,
  x: 4,
  y: 4,
  fill: "#000",
  className: "icon-toggleon_svg__fill",
  rx: 20
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("circle", {
  cx: 64,
  cy: 24,
  r: 12,
  fill: "#FFF"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#FFF",
  d: "M64 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4zm0 2H24C14.059 6 6 14.059 6 24c0 9.764 7.774 17.712 17.47 17.992L24 42h40c9.941 0 18-8.059 18-18 0-9.764-7.774-17.712-17.47-17.992z"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  d: "M64 0H24C10.745 0 0 10.745 0 24s10.745 24 24 24h40c13.255 0 24-10.745 24-24S77.255 0 64 0m0 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4z",
  className: "icon-toggleon_svg__fill"
}))));

var _path$2;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
const SvgIconUser = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path$2 || (_path$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M42.667 37.333c7.17 0 13.018 5.66 13.32 12.755l.013.579V56a2.667 2.667 0 0 1-5.315.311L50.667 56v-5.333c0-4.26-3.33-7.743-7.53-7.987l-.47-.013H21.333a8 8 0 0 0-7.986 7.53l-.014.47V56a2.667 2.667 0 0 1-5.316.311L8 56v-5.333c0-7.17 5.66-13.019 12.755-13.321l.578-.013zM32 5.333c7.364 0 13.333 5.97 13.333 13.334S39.363 32 32 32s-13.333-5.97-13.333-13.333S24.637 5.333 32 5.333m0 5.334a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
  className: "icon-user_svg__fill"
})));

var _path$1;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
const SvgIconFeedbackLike = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path$1 || (_path$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M12.346 5.336v-.001c.405-.523 1.182-.524 1.58-.037.162.2.25.443.25.69v3.678c0 .518.42.938.938.938H18.6c.359 0 .7.179.911.488l.001.001.369.548.003.004c.174.256.226.583.134.895l-1.532 5.316c-.131.459-.559.782-1.044.782h-7.075c-.3 0-.593-.127-.8-.345l-1.13-1.222v-6.647zm-4.73 3.078 3.245-4.223.002-.002c1.125-1.456 3.339-1.521 4.517-.075.421.52.671 1.177.671 1.874v2.74h2.55c.99 0 1.908.496 2.462 1.31l.002.004.368.547.002.002a2.93 2.93 0 0 1 .382 2.475v.003l-1.528 5.302a2.96 2.96 0 0 1-2.847 2.142h-7.075a2.99 2.99 0 0 1-2.166-.935l-.007-.007-.066-.072a2.13 2.13 0 0 1-1.821 1.025H4.192a2.13 2.13 0 0 1-2.13-2.13v-8.3a2.13 2.13 0 0 1 2.13-2.13h2.115c.493 0 .948.168 1.31.45m-3.678 1.68c0-.141.114-.255.254-.255h2.115c.14 0 .254.114.254.255v8.3c0 .14-.114.255-.254.255H4.192a.255.255 0 0 1-.255-.255z",
  clipRule: "evenodd"
})));

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgIconFeedbackDislike = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.654 18.664v.001c-.405.523-1.182.524-1.58.037-.162-.2-.25-.444-.25-.69v-3.678a.94.94 0 0 0-.938-.938H5.4c-.359 0-.7-.179-.911-.488l-.001-.001-.369-.548-.003-.004a1.05 1.05 0 0 1-.134-.895l1.532-5.316c.131-.459.559-.782 1.044-.782h7.075c.3 0 .593.127.8.345l1.13 1.222v6.647zm4.73-3.078-3.245 4.223-.002.002c-1.125 1.456-3.339 1.521-4.517.075a2.98 2.98 0 0 1-.671-1.874v-2.74h-2.55c-.99 0-1.908-.496-2.462-1.31l-.002-.004-.368-.547-.002-.002a2.93 2.93 0 0 1-.382-2.475v-.003L3.711 5.63a2.96 2.96 0 0 1 2.847-2.142h7.075c.823 0 1.608.345 2.166.935l.007.007.066.072a2.13 2.13 0 0 1 1.821-1.025h2.115a2.13 2.13 0 0 1 2.13 2.13v8.3a2.13 2.13 0 0 1-2.13 2.13h-2.115a2.12 2.12 0 0 1-1.31-.45m3.678-1.68c0 .141-.114.255-.254.255h-2.115a.255.255 0 0 1-.255-.255v-8.3c0-.14.115-.255.255-.255h2.115c.14 0 .255.114.255.255z",
  clipRule: "evenodd"
})));

function changeTypeToIconComponent(type) {
    switch (type) {
        case Types.ADD: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconAdd, null);
        case Types.ARROW_LEFT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconArrowLeft, null);
        case Types.ATTACH: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconAttach, null);
        case Types.AUDIO_ON_LINED: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconAudioOnLined, null);
        case Types.BAN: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconBan, null);
        case Types.BROADCAST: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconBroadcast, null);
        case Types.CAMERA: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconCamera, null);
        case Types.CHANNELS: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconChannels, null);
        case Types.CHAT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconChat, null);
        case Types.CHAT_FILLED: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconChatFilled, null);
        case Types.CHEVRON_DOWN: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconChevronDown, null);
        case Types.CHEVRON_RIGHT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconChevronRight, null);
        case Types.CLOSE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconClose, null);
        case Types.COLLAPSE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconCollapse, null);
        case Types.COPY: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconCopy, null);
        case Types.CREATE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconCreate, null);
        case Types.DELETE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDelete, null);
        case Types.DISCONNECTED: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDisconnected, null);
        case Types.DOCUMENT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDocument, null);
        case Types.DONE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDone, null);
        case Types.DONE_ALL: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDoneAll, null);
        case Types.DOWNLOAD: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconDownload, null);
        case Types.EDIT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconEdit, null);
        case Types.EMOJI_MORE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconEmojiMore, null);
        case Types.ERROR: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconError, null);
        case Types.EXPAND: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconExpand, null);
        case Types.FILE_AUDIO: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconFileAudio, null);
        case Types.FILE_DOCUMENT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconFileDocument, null);
        case Types.FREEZE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconFreeze, null);
        case Types.GIF: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconGif, null);
        case Types.INFO: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconInfo, null);
        case Types.LEAVE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconLeave, null);
        case Types.MEMBERS: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconMembers, null);
        case Types.MESSAGE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconMessage, null);
        case Types.MODERATIONS: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconModerations, null);
        case Types.MORE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconMore, null);
        case Types.MUTE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconMute, null);
        case Types.NOTIFICATIONS: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconNotifications, null);
        case Types.NOTIFICATIONS_OFF_FILLED: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconNotificationsOffFilled, null);
        case Types.OPERATOR: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconOperator, null);
        case Types.PHOTO: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconPhoto, null);
        case Types.PLAY: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconPlay, null);
        case Types.PLUS: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconPlus, null);
        case Types.QUESTION: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconQuestion, null);
        case Types.REFRESH: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconRefresh, null);
        case Types.REMOVE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconRemove, null);
        case Types.REPLY: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconReplyFilled, null);
        case Types.SEARCH: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSearch, null);
        case Types.SEND: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSend, null);
        case Types.SETTINGS_FILLED: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSettingsFilled, null);
        case Types.SLIDE_LEFT: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSlideLeft, null);
        case Types.SPINNER: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSpinner, null);
        case Types.SUPERGROUP: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconSupergroup, null);
        case Types.THREAD: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconThread, null);
        case Types.THUMBNAIL_NONE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconThumbnailNone, null);
        case Types.TOGGLE_OFF: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconToggleoff, null);
        case Types.TOGGLE_ON: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconToggleon, null);
        case Types.USER: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconUser, null);
        case Types.FEEDBACK_LIKE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconFeedbackLike, null);
        case Types.FEEDBACK_DISLIKE: return react__WEBPACK_IMPORTED_MODULE_1__.createElement(SvgIconFeedbackDislike, null);
        default: return 'icon'; // If you see this text 'icon' replace icon for it
    }
}
function Icon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, type = _a.type, _c = _a.fillColor, fillColor = _c === void 0 ? Colors.DEFAULT : _c, _d = _a.width, width = _d === void 0 ? 26 : _d, _e = _a.height, height = _e === void 0 ? 26 : _e, _f = _a.onClick, onClick = _f === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _f, _g = _a.children, children = _g === void 0 ? null : _g, testID = _a.testID;
    var iconStyle = {
        width: typeof width === 'string' ? width : "".concat(width, "px"),
        minWidth: typeof width === 'string' ? width : "".concat(width, "px"),
        height: typeof height === 'string' ? height : "".concat(height, "px"),
        minHeight: typeof height === 'string' ? height : "".concat(height, "px"),
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-icon',
            changeTypeToIconClassName(type),
            changeColorToClassName(fillColor),
        ], false).join(' '), "data-testid": testID, role: 'button', onClick: onClick, onKeyDown: onClick, tabIndex: 0, style: iconStyle }, children || changeTypeToIconComponent(type)));
}
var IconTypes = Types;
var IconColors = Colors;


//# sourceMappingURL=Icon.js.map


/***/ }),

/***/ 29515:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var IconButton = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
    var _a = props.className, className = _a === void 0 ? '' : _a, children = props.children, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.width, width = _c === void 0 ? '56px' : _c, _d = props.height, height = _d === void 0 ? '56px' : _d, _e = props.type, type = _e === void 0 ? 'button' : _e, _f = props.style, style = _f === void 0 ? {} : _f, _g = props.onBlur, onBlur = _g === void 0 ? function () { } : _g, _h = props.onClick, onClick = _h === void 0 ? function () { } : _h, testID = props.testID;
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPressed = _j[0], setIsPressed = _j[1];
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", { "data-testid": testID, className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-iconbutton',
            isPressed ? 'sendbird-iconbutton--pressed' : '',
        ], false).join(' '), disabled: disabled, ref: ref, type: type, style: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, style), { height: height, width: width }), onClick: function (e) {
            if (disabled) {
                return;
            }
            setIsPressed(true);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, onBlur: function (e) {
            setIsPressed(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", { className: "sendbird-iconbutton__inner" }, children)));
});


//# sourceMappingURL=IconButton.js.map


/***/ }),

/***/ 4399:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mh": function() { return /* binding */ getBorderRadiusForMultipleImageRenderer; },
/* harmony export */   "ZP": function() { return /* binding */ ImageRenderer; }
/* harmony export */ });
/* unused harmony export getBorderRadiusForImageRenderer */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80360);




var numberToPx = (function (value) {
    if (value === null)
        return undefined;
    return typeof value === 'number' ? "".concat(value, "px") : value;
});

function getDynamicMinLengthInPx(sideLength, maxSideLength, defaultMinLength) {
    var _a;
    return "min(".concat(maxSideLength !== null && maxSideLength !== void 0 ? maxSideLength : defaultMinLength, ", ").concat((_a = numberToPx(sideLength)) !== null && _a !== void 0 ? _a : defaultMinLength, ")");
}

function useDynamicSideLength(_a) {
    var width = _a.width, height = _a.height, maxSideLength = _a.maxSideLength, defaultMinLength = _a.defaultMinLength;
    var dynamicMinWidth = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        return getDynamicMinLengthInPx(width, maxSideLength, defaultMinLength);
    }, [width]);
    var dynamicMinHeight = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        return getDynamicMinLengthInPx(height, maxSideLength, defaultMinLength);
    }, [height]);
    return [dynamicMinWidth, dynamicMinHeight];
}

var useIsElementInViewport = function () {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isVisible = _a[0], setIsVisible = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), element = _b[0], setElement = _b[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (node) {
        if (node !== null)
            setElement(node);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (!element)
            return;
        var observer = new IntersectionObserver(function (entries) {
            var entry = entries[0];
            setIsVisible(entry.isIntersecting);
        });
        observer.observe(element);
        return function () {
            observer.disconnect();
        };
    }, [element]);
    return [ref, isVisible];
};

var useLazyImageLoader = function () {
    var isLoaded = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var _a = useIsElementInViewport(), ref = _a[0], isVisible = _a[1];
    if (isVisible)
        isLoaded.current = true;
    return [ref, isLoaded.current];
};

function getBorderRadiusForImageRenderer(circle, borderRadius) {
    if (circle === void 0) { circle = false; }
    if (borderRadius === void 0) { borderRadius = null; }
    return circle ? '50%' : numberToPx(borderRadius);
}
function getBorderRadiusForMultipleImageRenderer(borderRadius, index, totalCount) {
    var value = typeof borderRadius === 'string' ? parseInt(borderRadius, 10) : borderRadius;
    var lastIndex = totalCount - 1;
    var topLeft = index === 0 ? value * 2 : value;
    var topRight = index === 1 ? value * 2 : value;
    var bottomRight = index === lastIndex ? value * 2 : value;
    var bottomLeft = index === lastIndex - 1 ? value * 2 : value;
    return "".concat(topLeft, "px ").concat(topRight, "px ").concat(bottomRight, "px ").concat(bottomLeft, "px");
}
/*
  ImageRenderer displays image with url or source
  it checks if the source exist with img tag first
  if it exists onLoad is called, if not onError is called
  and those properties switch img tag to real purposing element
*/
var ImageRenderer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, url = _a.url, _c = _a.alt, alt = _c === void 0 ? '' : _c, _d = _a.width, width = _d === void 0 ? null : _d, _e = _a.maxSideLength, maxSideLength = _e === void 0 ? null : _e, _f = _a.height, height = _f === void 0 ? null : _f, _g = _a.circle, circle = _g === void 0 ? false : _g, _h = _a.fixedSize, fixedSize = _h === void 0 ? false : _h, _j = _a.placeHolder, placeHolder = _j === void 0 ? null : _j, _k = _a.defaultComponent, defaultComponent = _k === void 0 ? null : _k, _l = _a.borderRadius, borderRadius = _l === void 0 ? null : _l, _m = _a.onLoad, onLoad = _m === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _m, _o = _a.onError, onError = _o === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _o, shadeOnHover = _a.shadeOnHover, _p = _a.isUploaded, isUploaded = _p === void 0 ? true : _p;
    var _q = useLazyImageLoader(), ref = _q[0], isVisible = _q[1];
    var internalUrl = isVisible ? url : null;
    var _r = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), defaultComponentVisible = _r[0], setDefaultComponentVisible = _r[1];
    var _s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), placeholderVisible = _s[0], setPlaceholderVisible = _s[1];
    var _t = useDynamicSideLength({
        width: width,
        height: height,
        maxSideLength: maxSideLength,
        defaultMinLength: '400px',
    }), dynamicMinWidth = _t[0], dynamicMinHeight = _t[1];
    var renderPlaceholder = function () {
        if (typeof placeHolder === 'function') {
            return placeHolder({
                style: {
                    width: '100%',
                    minWidth: dynamicMinWidth,
                    maxWidth: fixedSize ? dynamicMinWidth : '400px',
                    height: dynamicMinHeight,
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            });
        }
        return placeHolder;
    };
    var renderDefault = function () {
        if (typeof defaultComponent === 'function')
            return defaultComponent();
        return defaultComponent;
    };
    var renderImage = function () {
        var backgroundStyle = internalUrl ? {
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: "url(".concat(internalUrl, ")"),
        } : {};
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-image-renderer__image", style: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ width: '100%', minWidth: dynamicMinWidth, maxWidth: fixedSize ? dynamicMinWidth : '400px', height: dynamicMinHeight, position: 'absolute', borderRadius: getBorderRadiusForImageRenderer(circle, borderRadius) }, backgroundStyle) }));
    };
    return (dynamicMinWidth
        && dynamicMinHeight && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { ref: ref, className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), ['sendbird-image-renderer'], false).join(' '), style: {
            width: '100%',
            minWidth: dynamicMinWidth,
            maxWidth: fixedSize ? dynamicMinWidth : '400px',
            height: dynamicMinHeight,
        } },
        placeholderVisible && renderPlaceholder(),
        (!internalUrl || defaultComponentVisible) ? renderDefault() : renderImage(),
        shadeOnHover && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-multiple-files-image-renderer__image-cover", style: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ borderRadius: getBorderRadiusForImageRenderer(circle, borderRadius) }, (isUploaded ? {} : { display: 'inline-flex' })) })),
        internalUrl && react__WEBPACK_IMPORTED_MODULE_1__.createElement(HiddenImageLoader, { src: internalUrl, alt: alt, onLoadStart: function () {
                setPlaceholderVisible(true);
                setDefaultComponentVisible(false);
            }, onLoad: function () {
                setPlaceholderVisible(false);
                setDefaultComponentVisible(false);
                onLoad();
            }, onError: function () {
                setPlaceholderVisible(false);
                setDefaultComponentVisible(true);
                onError();
            } }))));
};
// Image is loaded as a background-image, but this component serves as a hidden component to receive events indicating whether the image has actually been loaded.
var HiddenImageLoader = function (props) {
    var src = props.src, alt = props.alt, _a = props.onLoadStart, onLoadStart = _a === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _a, _b = props.onLoad, onLoad = _b === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _b, _c = props.onError, onError = _c === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_2__.n : _c;
    var reloadCtx = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        currSrc: src,
        prevSrc: src,
        loadFailure: false,
    });
    if (reloadCtx.current.currSrc !== src) {
        reloadCtx.current.prevSrc = reloadCtx.current.currSrc;
        reloadCtx.current.currSrc = src;
    }
    // SideEffect: If the image URL has changed or loading has failed, please try again
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
        if (src) {
            var sourceChanged = reloadCtx.current.prevSrc !== reloadCtx.current.currSrc;
            var loadFailure = reloadCtx.current.loadFailure;
            if (sourceChanged || loadFailure) {
                onLoadStart();
            }
        }
    }, [src, navigator.onLine]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", { className: "sendbird-image-renderer__hidden-image-loader", src: src, alt: alt, onLoad: function () {
            reloadCtx.current.loadFailure = false;
            onLoad();
        }, onError: function () {
            reloadCtx.current.loadFailure = true;
            onError();
        } }));
};


//# sourceMappingURL=ImageRenderer.js.map


/***/ }),

/***/ 80385:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ InputLabel; },
/* harmony export */   "Z": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





var InputLabel = function (_a) {
    var children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-input-label", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_1 }, children));
};
var Input = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
    var name = props.name, required = props.required, disabled = props.disabled, value = props.value, placeHolder = props.placeHolder, _a = props.autoFocus, autoFocus = _a === void 0 ? false : _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), inputValue = _b[0], setInputValue = _b[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-input" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", { className: "sendbird-input__input", ref: ref, name: name, required: required, disabled: disabled, value: inputValue, onChange: function (e) {
                setInputValue(e.target.value);
            }, autoFocus: autoFocus }),
        (placeHolder && !inputValue) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-input__placeholder", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_3 }, placeHolder))));
});


//# sourceMappingURL=Input.js.map


/***/ }),

/***/ 40286:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ LinkLabel; }
/* harmony export */ });
/* unused harmony exports LinkLabelColors, LinkLabelTypography */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);






var http = /https?:\/\//;
function LinkLabel(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, src = _a.src, type = _a.type, color = _a.color, children = _a.children;
    var url = http.test(src) ? src : "http://".concat(src);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-link-label',
            (0,_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.d)(color),
        ], false).join(' '), href: url, target: "_blank", rel: "noopener noreferrer", 
        // for mobile
        onTouchEnd: function (e) {
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation();
            (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__.o)(url);
        } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-link-label__label", testID: "sendbird-link-label__label", type: type, color: color }, children)));
}
var LinkLabelTypography = _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a;
var LinkLabelColors = _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b;


//# sourceMappingURL=LinkLabel.js.map


/***/ }),

/***/ 72661:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);





function Loader(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.width, width = _c === void 0 ? '26px' : _c, _d = _a.height, height = _d === void 0 ? '26px' : _d, children = _a.children, testID = _a.testID;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-loader',
        ], false).join(' '), "data-testid": testID, style: {
            width: typeof width === 'string' ? width : "".concat(width, "px"),
            height: typeof height === 'string' ? height : "".concat(height, "px"),
        } }, children
        || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.SPINNER */ .Qy.SPINNER, width: "26px", height: "26px" }))));
}


//# sourceMappingURL=Loader.js.map


/***/ }),

/***/ 64437:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LoadingTemplateMessageItemBody; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Loader_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72661);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);






var TEMPLATE_LOADING_SPINNER_SIZE = '40px';
function LoadingTemplateMessageItemBody(_a) {
    var className = _a.className, isByMe = _a.isByMe;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__.c)(className, isByMe ? 'outgoing' : 'incoming', 'sendbird-template-loading-message-item-body') },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Loader_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { className: "sendbird-message-status__icon", testID: "sendbird-message-status-icon", width: TEMPLATE_LOADING_SPINNER_SIZE, height: TEMPLATE_LOADING_SPINNER_SIZE },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.SPINNER */ .Qy.SPINNER, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.CONTENT_INVERSE_3 */ .zo.CONTENT_INVERSE_3, width: TEMPLATE_LOADING_SPINNER_SIZE, height: TEMPLATE_LOADING_SPINNER_SIZE }))));
}


//# sourceMappingURL=LoadingTemplateMessageItemBody.tsx.js.map


/***/ }),

/***/ 81823:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MentionLabel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16167);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13462);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65614);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71091);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29515);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26765);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88569);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90832);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(82314);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4399);




































function MentionLabel(props) {
    var _a, _b, _c;
    var mentionTemplate = props.mentionTemplate, mentionedUserId = props.mentionedUserId, mentionedUserNickname = props.mentionedUserNickname, isByMe = props.isByMe;
    var mentionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var sendbirdState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useSendbirdStateContext */ .A)();
    var userId = (_a = sendbirdState === null || sendbirdState === void 0 ? void 0 : sendbirdState.config) === null || _a === void 0 ? void 0 : _a.userId;
    var sdk = (_c = (_b = sendbirdState === null || sendbirdState === void 0 ? void 0 : sendbirdState.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.sdk;
    var amIBeingMentioned = userId === mentionedUserId;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), user = _d[0], setUser = _d[1];
    var fetchUser = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (toggleDropdown) {
        if (user || !(sdk === null || sdk === void 0 ? void 0 : sdk.createApplicationUserListQuery)) {
            toggleDropdown();
            return;
        }
        var query = sdk === null || sdk === void 0 ? void 0 : sdk.createApplicationUserListQuery({
            userIdsFilter: [mentionedUserId],
        });
        query.next().then(function (members) {
            if ((members === null || members === void 0 ? void 0 : members.length) > 0) {
                setUser(members[0]);
            }
            toggleDropdown();
        });
    }, [sdk, mentionedUserId]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_25__.c)('sendbird-word__mention', amIBeingMentioned && 'sendbird-word__mention--me'), onClick: function () { return fetchUser(toggleDropdown); }, ref: mentionRef, "data-userid": mentionedUserId, "data-nickname": mentionedUserNickname, "data-sb-mention": true },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, "".concat(mentionTemplate).concat(mentionedUserNickname)))); }, menuItems: function (closeDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__.b
        /**
        * parentRef: For catching location(x, y) of MenuItems
        * parentContainRef: For toggling more options(menus & reactions)
        */
        , { 
            /**
            * parentRef: For catching location(x, y) of MenuItems
            * parentContainRef: For toggling more options(menus & reactions)
            */
            parentRef: mentionRef, parentContainRef: mentionRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_UserProfile_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { user: user, onSuccess: closeDropdown, currentUserId: userId }))); } }));
}


//# sourceMappingURL=MentionLabel.js.map


/***/ }),

/***/ 3533:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "En": function() { return /* binding */ MessageContent; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75010);
/* harmony import */ var _chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95341);
/* harmony import */ var _chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24277);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16167);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99366);
/* harmony import */ var _MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69139);
/* harmony import */ var _EmojiReactions_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27835);
/* harmony import */ var _AdminMessage_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1167);
/* harmony import */ var _QuoteMessage_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26862);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41238);
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(51947);
/* harmony import */ var _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(4500);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8627);
/* harmony import */ var _MobileMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56342);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26765);
/* harmony import */ var _ThreadReplies_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68873);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48614);
/* harmony import */ var _chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15394);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43822);
/* harmony import */ var _FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(15345);
/* harmony import */ var _MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45143);
/* harmony import */ var _MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(74062);
/* harmony import */ var _MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(21402);
/* harmony import */ var _chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(76039);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(69466);
/* harmony import */ var _Loader_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(72661);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_CmKxC8hb_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(25528);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(29515);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(61448);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(4399);
/* harmony import */ var _ReactionButton_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(60090);
/* harmony import */ var _ReactionBadge_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(30156);
/* harmony import */ var _BottomSheet_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(18087);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(17693);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(90832);
/* harmony import */ var _UserListItem_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56842);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(82314);
/* harmony import */ var _MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(67412);
/* harmony import */ var _Checkbox_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(10856);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(13462);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(80031);
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(76886);
/* harmony import */ var _TooltipWrapper_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(32080);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(23012);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(78828);
/* harmony import */ var _OGMessageItemBody_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(34835);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(1165);
/* harmony import */ var _MentionLabel_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(81823);
/* harmony import */ var _LinkLabel_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(40286);
/* harmony import */ var _TextMessageItemBody_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(50206);
/* harmony import */ var _FileMessageItemBody_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(12210);
/* harmony import */ var _TextButton_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(21790);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(21112);
/* harmony import */ var _chunks_bundle_BFQnMRhA_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(43071);
/* harmony import */ var _FileViewer_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(6989);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(60424);
/* harmony import */ var _VoiceMessageItemBody_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(71612);
/* harmony import */ var _ProgressBar_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(32177);
/* harmony import */ var _PlaybackTime_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(28464);
/* harmony import */ var _ThumbnailMessageItemBody_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(48845);
/* harmony import */ var _UnknownMessageItemBody_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(33709);
/* harmony import */ var _TemplateMessageItemBody_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(49754);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(19652);
/* harmony import */ var _FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(34498);
/* harmony import */ var _LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(64437);
/* harmony import */ var _chunks_bundle_BaMsxnN_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(30302);
/* harmony import */ var _Input_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(80385);






























































































var SbFeedbackStatus;
(function (SbFeedbackStatus) {
    /** Feedback is unavailable for this message. This is the default value for base message. */
    SbFeedbackStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** Feedback can be set for this message, but nothing has been submitted yet. */
    SbFeedbackStatus["NO_FEEDBACK"] = "NO_FEEDBACK";
    /** Feedback can be set for this message, and something has been submitted. */
    SbFeedbackStatus["SUBMITTED"] = "SUBMITTED";
})(SbFeedbackStatus || (SbFeedbackStatus = {}));

function MessageContentForTemplateMessage(props) {
    var _a, _b, _c;
    var channel = props.channel, message = props.message, showFileViewer = props.showFileViewer, onMessageHeightChange = props.onMessageHeightChange, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, renderSenderProfile = props.renderSenderProfile, renderMessageHeader = props.renderMessageHeader, renderMessageBody = props.renderMessageBody, isByMe = props.isByMe, displayThreadReplies = props.displayThreadReplies, mouseHover = props.mouseHover, isMobile = props.isMobile, isReactionEnabledInChannel = props.isReactionEnabledInChannel, hoveredMenuClassName = props.hoveredMenuClassName, templateType = props.templateType, useReplying = props.useReplying;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__/* .useSendbirdStateContext */ .A)().config;
    var dateLocale = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_12__.u)().dateLocale;
    var uiContainerTypeClassName = (_a = _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.N[templateType]) !== null && _a !== void 0 ? _a : '';
    var senderProfile = renderSenderProfile((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), { chainBottom: false, className: '', isByMe: isByMe, displayThreadReplies: displayThreadReplies }));
    var messageHeader = renderMessageHeader(props);
    var messageBody = renderMessageBody({
        message: message,
        channel: channel,
        showFileViewer: showFileViewer,
        onMessageHeightChange: onMessageHeightChange,
        mouseHover: mouseHover,
        isMobile: isMobile,
        config: config,
        isReactionEnabledInChannel: isReactionEnabledInChannel,
        isByMe: isByMe,
        onBeforeDownloadFileMessage: onBeforeDownloadFileMessage,
    });
    var timeStamp = react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle__body-container__created-at', 'right', hoveredMenuClassName, uiContainerTypeClassName), type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_2 }, (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)((message === null || message === void 0 ? void 0 : message.createdAt) || 0, 'p', {
        locale: dateLocale,
    }));
    var templateData = (_b = message.extendedMessagePayload) === null || _b === void 0 ? void 0 : _b[_chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_79__.i];
    var _d = (_c = templateData === null || templateData === void 0 ? void 0 : templateData.container_options) !== null && _c !== void 0 ? _c : {}, _e = _d.profile, profile = _e === void 0 ? true : _e, _f = _d.time, time = _f === void 0 ? true : _f, _g = _d.nickname, nickname = _g === void 0 ? true : _g;
    var hasContainerHeader = profile || nickname;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__sendbird-ui-container-type__default__root" },
        !isByMe
            && hasContainerHeader
            && !useReplying
            && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__sendbird-ui-container-type__default__header-container" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__sendbird-ui-container-type__default__header-container__left__profile" }, profile && senderProfile),
                nickname && messageHeader)),
        messageBody,
        (!isByMe && time)
            && react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__sendbird-ui-container-type__default__bottom" }, timeStamp)));
}

function MessageContent(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var 
    // Internal props
    className = props.className, userId = props.userId, channel = props.channel, message = props.message, _p = props.disabled, disabled = _p === void 0 ? false : _p, _q = props.chainTop, chainTop = _q === void 0 ? false : _q, _r = props.chainBottom, chainBottom = _r === void 0 ? false : _r, _s = props.isReactionEnabled, isReactionEnabled = _s === void 0 ? false : _s, _t = props.disableQuoteMessage, disableQuoteMessage = _t === void 0 ? false : _t, replyType = props.replyType, threadReplySelectType = props.threadReplySelectType, nicknamesMap = props.nicknamesMap, emojiContainer = props.emojiContainer, scrollToMessage = props.scrollToMessage, showEdit = props.showEdit, showRemove = props.showRemove, showFileViewer = props.showFileViewer, resendMessage = props.resendMessage, deleteMessage = props.deleteMessage, toggleReaction = props.toggleReaction, setQuoteMessage = props.setQuoteMessage, onReplyInThread = props.onReplyInThread, onQuoteMessageClick = props.onQuoteMessageClick, onMessageHeightChange = props.onMessageHeightChange, onBeforeDownloadFileMessage = props.onBeforeDownloadFileMessage, filterEmojiCategoryIds = props.filterEmojiCategoryIds;
    // Public props for customization
    var _u = (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.d)(props), _v = _u.renderSenderProfile, renderSenderProfile = _v === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_19__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _v, _w = _u.renderMessageBody, renderMessageBody = _w === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_19__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _w, _x = _u.renderMessageHeader, renderMessageHeader = _x === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KDJ0EkHX_js__WEBPACK_IMPORTED_MODULE_19__.b, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _x, _y = _u.renderMessageMenu, renderMessageMenu = _y === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_CfaZQwKj_js__WEBPACK_IMPORTED_MODULE_4__.M, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _y, _z = _u.renderEmojiMenu, renderEmojiMenu = _z === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MessageItemReactionMenu_js__WEBPACK_IMPORTED_MODULE_7__/* .MessageEmojiMenu */ .j, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _z, _0 = _u.renderEmojiReactions, renderEmojiReactions = _0 === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_EmojiReactions_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _0, _1 = _u.renderMobileMenuOnLongPress, renderMobileMenuOnLongPress = _1 === void 0 ? function (props) { return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MobileMenu_js__WEBPACK_IMPORTED_MODULE_15__/* .MobileMenu */ .nn, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)); } : _1;
    var _2 = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_12__.u)(), dateLocale = _2.dateLocale, stringSet = _2.stringSet;
    var _3 = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_13__/* .useSendbirdStateContext */ .A)(), config = _3.config, eventHandlers = _3.eventHandlers;
    var logger = config.logger;
    var onPressUserProfileHandler = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.reaction) === null || _a === void 0 ? void 0 : _a.onPressUserProfile;
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var threadRepliesRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var feedbackButtonsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__.u)().isMobile;
    var _4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMenu = _4[0], setShowMenu = _4[1];
    var _5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mouseHover = _5[0], setMouseHover = _5[1];
    var isMenuMounted = (0,_chunks_bundle_D634UqaM_js__WEBPACK_IMPORTED_MODULE_25__.u)("#".concat((0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.g)(message.messageId), ".").concat(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.e), [
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.d),
        document.getElementById(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_5__.E),
    ]);
    // Feedback states
    var _6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFeedbackOptionsMenu = _6[0], setShowFeedbackOptionsMenu = _6[1];
    var _7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFeedbackModal = _7[0], setShowFeedbackModal = _7[1];
    var _8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), feedbackFailedText = _8[0], setFeedbackFailedText = _8[1];
    var isByMe = (userId === ((_b = message === null || message === void 0 ? void 0 : message.sender) === null || _b === void 0 ? void 0 : _b.userId))
        || ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'pending')
        || ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'failed');
    var isByMeClassName = isByMe ? 'outgoing' : 'incoming';
    var chainTopClassName = chainTop ? 'chain-top' : '';
    var isReactionEnabledInChannel = isReactionEnabled && !(channel === null || channel === void 0 ? void 0 : channel.isEphemeral);
    var isReactionEnabledClassName = isReactionEnabledInChannel ? 'use-reactions' : '';
    var hoveredMenuClassName = isMenuMounted ? 'sendbird-mouse-hover' : '';
    var useReplying = !!((replyType === 'QUOTE_REPLY' || replyType === 'THREAD')
        && (message === null || message === void 0 ? void 0 : message.parentMessageId) && (message === null || message === void 0 ? void 0 : message.parentMessage)
        && !disableQuoteMessage);
    var useReplyingClassName = useReplying ? 'use-quote' : '';
    // Thread replies
    var displayThreadReplies = ((_c = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _c === void 0 ? void 0 : _c.replyCount)
        && message.threadInfo.replyCount > 0
        && replyType === 'THREAD';
    // Feedback buttons
    var isFeedbackMessage = !isByMe
        && !!(message === null || message === void 0 ? void 0 : message.myFeedbackStatus)
        && message.myFeedbackStatus !== SbFeedbackStatus.NOT_APPLICABLE;
    var isFeedbackEnabled = !!((_d = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _d === void 0 ? void 0 : _d.enableFeedback) && isFeedbackMessage;
    var hasFeedback = (_e = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _e === void 0 ? void 0 : _e.rating;
    /**
     * For TemplateMessage, do not display:
     *   - in web view:
     *     - message menu
     *     - reaction menu
     *     - reply in thread
     *   - in mobile view:
     *     - bottom sheet on long click
     */
    var isNotSpecialMessage = !((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.C)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.O)(message));
    var showLongPressMenu = isNotSpecialMessage && isMobile;
    var showOutgoingMenu = isNotSpecialMessage && isByMe && !isMobile;
    var showThreadReplies = isNotSpecialMessage && displayThreadReplies;
    var showRightContent = isNotSpecialMessage && !isByMe && !isMobile;
    var getTotalBottom = function () {
        var sum = 2;
        if (threadRepliesRef.current) {
            sum += 4 + threadRepliesRef.current.clientHeight;
        }
        if (feedbackButtonsRef.current) {
            sum += 4 + feedbackButtonsRef.current.clientHeight;
        }
        return sum;
    };
    var totalBottom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return getTotalBottom(); }, []);
    var onCloseFeedbackForm = function () {
        setShowFeedbackModal(false);
    };
    var openFeedbackFormOrMenu = function (hasFeedback) {
        if (hasFeedback === void 0) { hasFeedback = false; }
        if (isMobile && hasFeedback) {
            setShowFeedbackOptionsMenu(true);
        }
        else {
            setShowFeedbackModal(true);
        }
    };
    // onMouseDown: (e: React.MouseEvent<T>) => void;
    // onTouchStart: (e: React.TouchEvent<T>) => void;
    // onMouseUp: (e: React.MouseEvent<T>) => void;
    // onMouseLeave: (e: React.MouseEvent<T>) => void;
    // onTouchEnd: (e: React.TouchEvent<T>) => void;
    var longPress = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__.u)({
        onLongPress: function () {
            if (showLongPressMenu) {
                setShowMenu(true);
            }
        },
        onClick: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.n,
    }, {
        delay: 300,
        shouldPreventDefault: false,
    });
    if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.P)(message)) {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_AdminMessage_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { message: message }));
    }
    if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.C)(message)) {
        var templatePayload = message.extendedMessagePayload[_chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_79__.i];
        if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.Q)(templatePayload)) {
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MessageContentForTemplateMessage, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { renderSenderProfile: renderSenderProfile, renderMessageHeader: renderMessageHeader, renderMessageBody: renderMessageBody, isByMe: isByMe, displayThreadReplies: displayThreadReplies, mouseHover: mouseHover, isMobile: isMobile, isReactionEnabledInChannel: isReactionEnabledInChannel, hoveredMenuClassName: hoveredMenuClassName, templateType: templatePayload['type'], useReplying: useReplying })));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.x)([
            className !== null && className !== void 0 ? className : '',
            'sendbird-message-content',
            isByMeClassName,
        ]), onMouseOver: function () { return setMouseHover(true); }, onMouseLeave: function () { return setMouseHover(false); } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__left', isReactionEnabledClassName, isByMeClassName, useReplyingClassName), "data-testid": "sendbird-message-content__left" },
            renderSenderProfile((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), { className: 'sendbird-message-content__left__avatar', isByMe: isByMe, displayThreadReplies: displayThreadReplies, bottom: totalBottom > 0 ? totalBottom + 'px' : '' })),
            showOutgoingMenu && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content-menu', isReactionEnabledClassName, hoveredMenuClassName, isByMeClassName) },
                renderMessageMenu({
                    channel: channel,
                    message: message,
                    isByMe: isByMe,
                    replyType: replyType,
                    showEdit: showEdit,
                    showRemove: showRemove,
                    resendMessage: resendMessage,
                    setQuoteMessage: setQuoteMessage,
                    onReplyInThread: function (_a) {
                        var _b, _c;
                        var message = _a.message;
                        if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.THREAD) {
                            onReplyInThread === null || onReplyInThread === void 0 ? void 0 : onReplyInThread({ message: message });
                        }
                        else if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.PARENT) {
                            scrollToMessage === null || scrollToMessage === void 0 ? void 0 : scrollToMessage((_c = (_b = message.parentMessage) === null || _b === void 0 ? void 0 : _b.createdAt) !== null && _c !== void 0 ? _c : 0, message.parentMessageId);
                        }
                    },
                    deleteMessage: deleteMessage,
                }),
                isReactionEnabledInChannel && (renderEmojiMenu({
                    message: message,
                    userId: userId,
                    emojiContainer: emojiContainer,
                    toggleReaction: toggleReaction,
                    filterEmojiCategoryIds: filterEmojiCategoryIds,
                }))))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle'), "data-testid": "sendbird-message-content__middle" }, (isMobile ? (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, longPress) : {}), { ref: contentRef }),
            (!isByMe && !chainTop && !useReplying) && renderMessageHeader(props),
            (useReplying) ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle__quote-message', isByMe ? 'outgoing' : 'incoming', useReplyingClassName), "data-testid": "sendbird-message-content__middle__quote-message" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_QuoteMessage_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { className: "sendbird-message-content__middle__quote-message__quote", message: message, userId: userId, isByMe: isByMe, isUnavailable: ((_f = channel === null || channel === void 0 ? void 0 : channel.messageOffsetTimestamp) !== null && _f !== void 0 ? _f : 0) > ((_h = (_g = message.parentMessage) === null || _g === void 0 ? void 0 : _g.createdAt) !== null && _h !== void 0 ? _h : 0), onClick: function () {
                        var _a;
                        if (replyType === 'THREAD' && threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.THREAD) {
                            onQuoteMessageClick === null || onQuoteMessageClick === void 0 ? void 0 : onQuoteMessageClick({ message: message });
                        }
                        if ((replyType === 'QUOTE_REPLY' || (replyType === 'THREAD' && threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.PARENT))
                            && ((_a = message === null || message === void 0 ? void 0 : message.parentMessage) === null || _a === void 0 ? void 0 : _a.createdAt) && (message === null || message === void 0 ? void 0 : message.parentMessageId)) {
                            scrollToMessage === null || scrollToMessage === void 0 ? void 0 : scrollToMessage(message.parentMessage.createdAt, message.parentMessageId);
                        }
                    } }))) : null,
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle__body-container') },
                (isByMe && !chainBottom) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle__body-container__created-at', 'left', hoveredMenuClassName) },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__middle__body-container__created-at__component-container" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_BX_znRDF_js__WEBPACK_IMPORTED_MODULE_3__.M, { message: message, channel: channel })))),
                renderMessageBody({
                    message: message,
                    channel: channel,
                    showFileViewer: showFileViewer,
                    onMessageHeightChange: onMessageHeightChange,
                    mouseHover: mouseHover,
                    isMobile: isMobile,
                    config: config,
                    isReactionEnabledInChannel: isReactionEnabledInChannel,
                    isByMe: isByMe,
                    onBeforeDownloadFileMessage: onBeforeDownloadFileMessage,
                }),
                (isReactionEnabledInChannel && ((_j = message === null || message === void 0 ? void 0 : message.reactions) === null || _j === void 0 ? void 0 : _j.length) > 0) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content-reactions', (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.c)(message) ? 'image-grid'
                        : (isByMe && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.p)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.M)(message)) && 'primary', mouseHover && 'mouse-hover') }, renderEmojiReactions({
                    userId: userId,
                    message: message,
                    channel: channel,
                    isByMe: isByMe,
                    // @ts-ignore
                    emojiContainer: emojiContainer !== null && emojiContainer !== void 0 ? emojiContainer : new _sendbird_chat__WEBPACK_IMPORTED_MODULE_80__/* .EmojiContainer */ .W8({}),
                    memberNicknamesMap: nicknamesMap !== null && nicknamesMap !== void 0 ? nicknamesMap : new Map(),
                    toggleReaction: toggleReaction,
                    onPressUserProfile: onPressUserProfileHandler,
                    filterEmojiCategoryIds: filterEmojiCategoryIds,
                }))),
                (!isByMe && !chainBottom) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.L, { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__middle__body-container__created-at', 'right', hoveredMenuClassName), type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_2 }, (0,_chunks_bundle_QTCuDZTl_js__WEBPACK_IMPORTED_MODULE_2__.f)((message === null || message === void 0 ? void 0 : message.createdAt) || 0, stringSet.DATE_FORMAT__MESSAGE_CREATED_AT, {
                    locale: dateLocale,
                })))),
            showThreadReplies && (message === null || message === void 0 ? void 0 : message.threadInfo) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ThreadReplies_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, { className: "sendbird-message-content__middle__thread-replies", threadInfo: message === null || message === void 0 ? void 0 : message.threadInfo, onClick: function () { return onReplyInThread === null || onReplyInThread === void 0 ? void 0 : onReplyInThread({ message: message }); }, ref: threadRepliesRef })),
            isFeedbackEnabled && react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-content__middle__body-container__feedback-buttons-container", ref: feedbackButtonsRef },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, { isSelected: ((_k = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _k === void 0 ? void 0 : _k.rating) === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.GOOD, onClick: function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                        var error_1;
                        var _a, _b;
                        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!!hasFeedback) return [3 /*break*/, 5];
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, message.submitFeedback({
                                            rating: _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.GOOD,
                                        })];
                                case 2:
                                    _c.sent();
                                    openFeedbackFormOrMenu();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _c.sent();
                                    (_b = (_a = config === null || config === void 0 ? void 0 : config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'Channel: Submit feedback failed.', error_1);
                                    setFeedbackFailedText(stringSet.FEEDBACK_FAILED_SUBMIT);
                                    return [3 /*break*/, 4];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    openFeedbackFormOrMenu(true);
                                    _c.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); }, disabled: !!(message === null || message === void 0 ? void 0 : message.myFeedback) && message.myFeedback.rating !== _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.GOOD },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_20__/* .IconTypes.FEEDBACK_LIKE */ .Qy.FEEDBACK_LIKE, width: '24px', height: '24px' })),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FeedbackIconButton_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, { isSelected: ((_l = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _l === void 0 ? void 0 : _l.rating) === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.BAD, onClick: function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                        var error_2;
                        var _a, _b;
                        return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!!hasFeedback) return [3 /*break*/, 5];
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, message.submitFeedback({
                                            rating: _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.BAD,
                                        })];
                                case 2:
                                    _c.sent();
                                    openFeedbackFormOrMenu();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _c.sent();
                                    (_b = (_a = config === null || config === void 0 ? void 0 : config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'Channel: Submit feedback failed.', error_2);
                                    setFeedbackFailedText(stringSet.FEEDBACK_FAILED_SUBMIT);
                                    return [3 /*break*/, 4];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    openFeedbackFormOrMenu(true);
                                    _c.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); }, disabled: !!(message === null || message === void 0 ? void 0 : message.myFeedback) && message.myFeedback.rating !== _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b3.BAD },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_20__/* .IconTypes.FEEDBACK_DISLIKE */ .Qy.FEEDBACK_DISLIKE, width: '24px', height: '24px' })))),
        showRightContent && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content__right', chainTopClassName, isReactionEnabledClassName, useReplyingClassName), "data-testid": "sendbird-message-content__right" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_78__.c)('sendbird-message-content-menu', chainTopClassName, hoveredMenuClassName, isByMeClassName) },
                isReactionEnabledInChannel && (renderEmojiMenu({
                    className: 'sendbird-message-content-menu__reaction-menu',
                    message: message,
                    userId: userId,
                    emojiContainer: emojiContainer,
                    toggleReaction: toggleReaction,
                    filterEmojiCategoryIds: filterEmojiCategoryIds,
                })),
                renderMessageMenu({
                    className: 'sendbird-message-content-menu__normal-menu',
                    channel: channel,
                    message: message,
                    isByMe: isByMe,
                    replyType: replyType,
                    showRemove: showRemove,
                    resendMessage: resendMessage,
                    setQuoteMessage: setQuoteMessage,
                    onReplyInThread: function (_a) {
                        var _b, _c;
                        var message = _a.message;
                        if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.THREAD) {
                            onReplyInThread === null || onReplyInThread === void 0 ? void 0 : onReplyInThread({ message: message });
                        }
                        else if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.PARENT) {
                            scrollToMessage === null || scrollToMessage === void 0 ? void 0 : scrollToMessage((_c = (_b = message.parentMessage) === null || _b === void 0 ? void 0 : _b.createdAt) !== null && _c !== void 0 ? _c : 0, message.parentMessageId);
                        }
                    },
                    deleteMessage: deleteMessage,
                })))),
        showMenu && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.k)(message) && channel && renderMobileMenuOnLongPress({
            parentRef: contentRef,
            channel: channel,
            hideMenu: function () { setShowMenu(false); },
            message: message,
            isReactionEnabled: isReactionEnabledInChannel,
            isByMe: isByMe,
            userId: userId,
            replyType: replyType,
            disabled: disabled,
            showRemove: showRemove,
            emojiContainer: emojiContainer,
            resendMessage: resendMessage,
            deleteMessage: deleteMessage,
            setQuoteMessage: setQuoteMessage,
            toggleReaction: toggleReaction,
            showEdit: showEdit,
            onReplyInThread: function (_a) {
                var _b;
                var message = _a.message;
                if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.THREAD) {
                    onReplyInThread === null || onReplyInThread === void 0 ? void 0 : onReplyInThread({ message: message });
                }
                else if (threadReplySelectType === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_18__.T.PARENT) {
                    scrollToMessage === null || scrollToMessage === void 0 ? void 0 : scrollToMessage(((_b = message === null || message === void 0 ? void 0 : message.parentMessage) === null || _b === void 0 ? void 0 : _b.createdAt) || 0, (message === null || message === void 0 ? void 0 : message.parentMessageId) || 0);
                }
            },
            onDownloadClick: function (e) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var allowDownload, err_1;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!onBeforeDownloadFileMessage) {
                                return [2 /*return*/];
                            }
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, onBeforeDownloadFileMessage({ message: message })];
                        case 2:
                            allowDownload = _c.sent();
                            if (!allowDownload) {
                                e.preventDefault();
                                (_a = logger === null || logger === void 0 ? void 0 : logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'MessageContent: Not allowed to download.');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _c.sent();
                            (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'MessageContent: Error occurred while determining download continuation:', err_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
        }),
        ((_m = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _m === void 0 ? void 0 : _m.rating) && showFeedbackOptionsMenu && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MobileFeedbackMenu_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, { hideMenu: function () {
                setShowFeedbackOptionsMenu(false);
            }, onEditFeedback: function () {
                setShowFeedbackOptionsMenu(false);
                setShowFeedbackModal(true);
            }, onRemoveFeedback: function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var error_3;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 3, , 4]);
                            if (!(message.myFeedback !== null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, message.deleteFeedback(message.myFeedback.id)];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            error_3 = _c.sent();
                            (_b = (_a = config === null || config === void 0 ? void 0 : config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'Channel: Delete feedback failed.', error_3);
                            setFeedbackFailedText(stringSet.FEEDBACK_FAILED_DELETE);
                            return [3 /*break*/, 4];
                        case 4:
                            setShowFeedbackOptionsMenu(false);
                            return [2 /*return*/];
                    }
                });
            }); } })),
        ((_o = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _o === void 0 ? void 0 : _o.rating) && showFeedbackModal && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MessageFeedbackModal_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, { selectedFeedback: message.myFeedback.rating, message: message, onUpdate: function (selectedFeedback, comment) { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var newFeedback, error_4;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(message.myFeedback !== null)) return [3 /*break*/, 4];
                            newFeedback = new _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_81__.b2({
                                id: message.myFeedback.id,
                                rating: selectedFeedback,
                                comment: comment,
                            });
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, message.updateFeedback(newFeedback)];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_4 = _c.sent();
                            (_b = (_a = config === null || config === void 0 ? void 0 : config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'Channel: Update feedback failed.', error_4);
                            setFeedbackFailedText(stringSet.FEEDBACK_FAILED_SAVE);
                            return [3 /*break*/, 4];
                        case 4:
                            onCloseFeedbackForm();
                            return [2 /*return*/];
                    }
                });
            }); }, onClose: onCloseFeedbackForm, onRemove: function () { return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.a)(_this, void 0, void 0, function () {
                var error_5;
                var _a, _b;
                return (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.b)(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 3, , 4]);
                            if (!(message.myFeedback !== null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, message.deleteFeedback(message.myFeedback.id)];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            error_5 = _c.sent();
                            (_b = (_a = config === null || config === void 0 ? void 0 : config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'Channel: Delete feedback failed.', error_5);
                            setFeedbackFailedText(stringSet.FEEDBACK_FAILED_DELETE);
                            return [3 /*break*/, 4];
                        case 4:
                            onCloseFeedbackForm();
                            return [2 /*return*/];
                    }
                });
            }); } })),
        feedbackFailedText && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MessageFeedbackFailedModal_js__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, { text: feedbackFailedText, onCancel: function () {
                setFeedbackFailedText('');
            } }))));
}


//# sourceMappingURL=MessageContent.js.map


/***/ }),

/***/ 21402:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MessageFeedbackFailedModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17693);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29515);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78614);






























function MessageFeedbackFailedModal(props) {
    var text = props.text, onCancel = props.onCancel;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onKeyDown = (0,_chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_5__.u)(modalRef, {
        Enter: function () { return onCancel === null || onCancel === void 0 ? void 0 : onCancel(); },
        Escape: function () { return onCancel === null || onCancel === void 0 ? void 0 : onCancel(); },
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { onKeyDown: onKeyDown },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__.M, { contentClassName: 'sendbird-message-feedback-modal-content__mobile', type: _Button_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, onSubmit: onCancel, onClose: onCancel, submitText: stringSet.BUTTON__OK, renderHeader: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-modal__header' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.H_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_1, className: 'sendbird-message-feedback-modal-header' }, text))); }, customFooter: react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-feedback-modal-footer__root_failed' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { onClick: onCancel },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BUTTON_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONCONTENT_1 }, stringSet.BUTTON__OK))) })));
}


//# sourceMappingURL=MessageFeedbackFailedModal.js.map


/***/ }),

/***/ 74062:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MessageFeedbackModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17693);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88569);
/* harmony import */ var _Input_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80385);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60424);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73935);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29515);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(78614);































function MessageFeedbackModal(props) {
    var _a, _b;
    var selectedFeedback = props.selectedFeedback, message = props.message, onClose = props.onClose, onSubmit = props.onSubmit, onUpdate = props.onUpdate, onRemove = props.onRemove;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_6__.u)().isMobile;
    var isEdit = (message === null || message === void 0 ? void 0 : message.myFeedback) && selectedFeedback === message.myFeedback.rating;
    var hasComment = (_a = message === null || message === void 0 ? void 0 : message.myFeedback) === null || _a === void 0 ? void 0 : _a.comment;
    var onSubmitWrapper = function () {
        var _a, _b, _c;
        if (!selectedFeedback)
            return;
        var comment = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        if (isEdit) {
            if (comment !== ((_c = message.myFeedback) === null || _c === void 0 ? void 0 : _c.comment)) {
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(selectedFeedback, comment);
            }
            else {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }
        else if (!message.myFeedback) {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(selectedFeedback, comment);
        }
    };
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var onKeyDown = (0,_chunks_bundle_vS1u8K1w_js__WEBPACK_IMPORTED_MODULE_7__.u)(modalRef, {
        Enter: function () { return onSubmitWrapper(); },
        Escape: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); },
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { onKeyDown: onKeyDown },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_2__.M, { contentClassName: 'sendbird-message-feedback-modal-content__mobile', type: _Button_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, onCancel: onClose, onSubmit: function () {
                onSubmitWrapper();
            }, submitText: stringSet.BUTTON__SUBMIT, renderHeader: function () { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-modal__header' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.H_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_1, className: 'sendbird-message-feedback-modal-header' }, stringSet.FEEDBACK_MODAL_TITLE))); }, customFooter: react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-feedback-modal-footer__root' },
                !isMobile && (message === null || message === void 0 ? void 0 : message.myFeedback) && selectedFeedback === message.myFeedback.rating
                    ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _Button_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonTypes.WARNING */ .qh.WARNING, onClick: onRemove, labelType: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.BUTTON_3 }, stringSet.BUTTON__REMOVE_FEEDBACK)
                    : react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-feedback-modal-footer__right-content' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _Button_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, onClick: onClose },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.BUTTON_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_1 }, stringSet.BUTTON__CANCEL)),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { onClick: function () { return onSubmitWrapper(); } },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.BUTTON_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONCONTENT_1 }, hasComment ? stringSet.BUTTON__SAVE : stringSet.BUTTON__SUBMIT)))) },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-feedback-modal-body__root' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { name: 'sendbird-message-feedback-modal-body__root', ref: inputRef, value: isEdit ? (_b = message.myFeedback) === null || _b === void 0 ? void 0 : _b.comment : undefined, placeHolder: stringSet.FEEDBACK_CONTENT_PLACEHOLDER, autoFocus: true })))));
}


//# sourceMappingURL=MessageFeedbackModal.js.map


/***/ }),

/***/ 65134:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MessageInput; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(459);
/* harmony import */ var _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48614);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89171);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59587);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(93475);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27856);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61448);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71091);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8978);


























/**
 * FIXME:
 * Import this ChannelType enum from @sendbird/chat
 * once MessageInput.spec unit tests can be run \wo jest <-> ESM issue
 */
var ChannelType;
(function (ChannelType) {
    ChannelType["BASE"] = "base";
    ChannelType["GROUP"] = "group";
    ChannelType["OPEN"] = "open";
})(ChannelType || (ChannelType = {}));
/**
 * FIXME: Simplify this in UIKit@v4
 * If customer is using MessageInput inside our modules(ie: Channel, Thread, etc),
 * we should use the config from the module.
 * If customer is using MessageInput outside our modules(ie: custom UI),
 * we expect Channel to be undefined and customer gets control to show/hide file-upload.
 * @param {*} channel GroupChannel | OpenChannel
 * @param {*} config SendBirdStateConfig
 * @returns boolean
 */
var checkIfFileUploadEnabled = function (_a) {
    var channel = _a.channel, config = _a.config;
    var isEnabled = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.K)(channel === null || channel === void 0 ? void 0 : channel.channelType)
        .with(ChannelType.GROUP, function () { var _a; return (_a = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _a === void 0 ? void 0 : _a.enableDocument; })
        .with(ChannelType.OPEN, function () { var _a; return (_a = config === null || config === void 0 ? void 0 : config.openChannel) === null || _a === void 0 ? void 0 : _a.enableDocument; })
        .otherwise(function () { return true; });
    return isEnabled;
};

var TEXT_FIELD_ID = 'sendbird-message-input-text-field';
var LINE_HEIGHT = 76;
var DEFAULT_CHAT_VIEW_HEIGHT = 600;
var noop = function () {
    return null;
};
var displayCaret = function (element, position) {
    var range = document.createRange();
    var sel = window.getSelection();
    range.setStart(element.childNodes[0], position);
    range.collapse(true);
    sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
    sel === null || sel === void 0 ? void 0 : sel.addRange(range);
    element.focus();
};
var resetInput = function (ref) {
    if (ref && ref.current) {
        ref.current.innerHTML = '';
    }
};
var initialTargetStringInfo = {
    targetString: '',
    startNodeIndex: null,
    startOffsetIndex: null,
    endNodeIndex: null,
    endOffsetIndex: null,
};
var MessageInput = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, externalRef) {
    var _a, _b, _c, _d, _e;
    var channel = props.channel, _f = props.className, className = _f === void 0 ? '' : _f, _g = props.messageFieldId, messageFieldId = _g === void 0 ? '' : _g, _h = props.isEdit, isEdit = _h === void 0 ? false : _h, _j = props.isMobile, isMobile = _j === void 0 ? false : _j, _k = props.isMentionEnabled, isMentionEnabled = _k === void 0 ? false : _k, _l = props.isVoiceMessageEnabled, isVoiceMessageEnabled = _l === void 0 ? true : _l, _m = props.isSelectingMultipleFilesEnabled, isSelectingMultipleFilesEnabled = _m === void 0 ? false : _m, _o = props.disabled, disabled = _o === void 0 ? false : _o, _p = props.message, message = _p === void 0 ? null : _p, _q = props.placeholder, placeholder = _q === void 0 ? '' : _q, _r = props.maxLength, maxLength = _r === void 0 ? 5000 : _r, _s = props.onFileUpload, onFileUpload = _s === void 0 ? noop : _s, _t = props.onSendMessage, onSendMessage = _t === void 0 ? noop : _t, _u = props.onUpdateMessage, onUpdateMessage = _u === void 0 ? noop : _u, _v = props.onCancelEdit, onCancelEdit = _v === void 0 ? noop : _v, _w = props.onStartTyping, onStartTyping = _w === void 0 ? noop : _w, _x = props.channelUrl, channelUrl = _x === void 0 ? '' : _x, _y = props.mentionSelectedUser, mentionSelectedUser = _y === void 0 ? null : _y, _z = props.onUserMentioned, onUserMentioned = _z === void 0 ? noop : _z, _0 = props.onMentionStringChange, onMentionStringChange = _0 === void 0 ? noop : _0, _1 = props.onMentionedUserIdsUpdated, onMentionedUserIdsUpdated = _1 === void 0 ? noop : _1, _2 = props.onVoiceMessageIconClick, onVoiceMessageIconClick = _2 === void 0 ? noop : _2, _3 = props.onKeyUp, onKeyUp = _3 === void 0 ? noop : _3, _4 = props.onKeyDown, onKeyDown = _4 === void 0 ? noop : _4, _5 = props.renderFileUploadIcon, renderFileUploadIcon = _5 === void 0 ? noop : _5, _6 = props.renderVoiceMessageIcon, renderVoiceMessageIcon = _6 === void 0 ? noop : _6, _7 = props.renderSendMessageIcon, renderSendMessageIcon = _7 === void 0 ? noop : _7, _8 = props.setMentionedUsers, setMentionedUsers = _8 === void 0 ? noop : _8, acceptableMimeTypes = props.acceptableMimeTypes;
    var internalRef = (externalRef && 'current' in externalRef) ? externalRef : null;
    var ghostInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var textFieldId = messageFieldId || TEXT_FIELD_ID;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__.u)().stringSet;
    var _9 = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__/* .useSendbirdStateContext */ .A)(), config = _9.config, eventHandlers = _9.eventHandlers;
    var isFileUploadEnabled = checkIfFileUploadEnabled({
        channel: channel,
        config: config,
    });
    var fileInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var _10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isInput = _10[0], setIsInput = _10[1];
    var _11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), mentionedUserIds = _11[0], setMentionedUserIds = _11[1];
    var _12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, initialTargetStringInfo)), targetStringInfo = _12[0], setTargetStringInfo = _12[1];
    var setHeight = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        var elem = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
        if (!elem)
            return;
        try {
            var estimatedChatViewHeight = window.document.body.offsetHeight || DEFAULT_CHAT_VIEW_HEIGHT;
            var MAX_HEIGHT = estimatedChatViewHeight * 0.6;
            if (elem.scrollHeight >= LINE_HEIGHT) {
                if (MAX_HEIGHT < elem.scrollHeight) {
                    elem.style.height = 'auto';
                    elem.style.height = "".concat(MAX_HEIGHT, "px");
                }
                else {
                    elem.style.height = '';
                }
            }
        }
        catch (error) {
            // error
        }
    }, []);
    // #Edit mode
    // for easilly initialize input value from outside, but
    // useEffect(_, [channelUrl]) erase it
    var initialValue = props === null || props === void 0 ? void 0 : props.value;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var textField = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
        try {
            if (textField && initialValue) {
                textField.innerHTML = initialValue;
                displayCaret(textField, initialValue === null || initialValue === void 0 ? void 0 : initialValue.length);
            }
        }
        catch (_a) {
            //
        }
        setMentionedUserIds([]);
        setIsInput((textField === null || textField === void 0 ? void 0 : textField.textContent) ? textField.textContent.trim().length > 0 : false);
        setHeight();
    }, [initialValue]);
    // #Mention | Clear input value when channel changes
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (!isEdit) {
            setIsInput(false);
            resetInput(internalRef);
        }
    }, [channelUrl]);
    // #Mention & #Edit | Fill message input values
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var _a, _b;
        if (isEdit && (message === null || message === void 0 ? void 0 : message.messageId)) {
            // const textField = document.getElementById(textFieldId);
            var textField = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
            if (isMentionEnabled
                && (message === null || message === void 0 ? void 0 : message.mentionedUsers)
                && message.mentionedUsers.length > 0
                && (message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate)
                && message.mentionedMessageTemplate.length > 0) {
                /* mention enabled */
                var _c = message.mentionedUsers, mentionedUsers_1 = _c === void 0 ? [] : _c;
                var tokens = (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_12__.t)({
                    messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
                    mentionedUsers: mentionedUsers_1,
                    includeMarkdown: channel.isGroupChannel() && config.groupChannel.enableMarkdownForUserMessage,
                });
                if (textField) {
                    textField.innerHTML = tokens
                        .map(function (token) {
                        if (token.type === _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_12__.T.mention) {
                            var mentionedUser = mentionedUsers_1.find(function (user) { return user.userId === token.userId; });
                            var nickname = "".concat(_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_12__.U).concat((mentionedUser === null || mentionedUser === void 0 ? void 0 : mentionedUser.nickname) || token.value || stringSet.MENTION_NAME__NO_NAME);
                            return (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.r)({
                                userId: token.userId,
                                nickname: nickname,
                            });
                        }
                        return (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.s)(token.value);
                    })
                        .join('');
                }
            }
            else {
                /* mention disabled */
                try {
                    if (textField) {
                        textField.innerHTML = (_a = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.s)(message === null || message === void 0 ? void 0 : message.message)) !== null && _a !== void 0 ? _a : '';
                    }
                }
                catch (_d) {
                    //
                }
                setMentionedUserIds([]);
            }
            setIsInput((textField === null || textField === void 0 ? void 0 : textField.textContent) ? ((_b = textField === null || textField === void 0 ? void 0 : textField.textContent) === null || _b === void 0 ? void 0 : _b.trim().length) > 0 : false);
            setHeight();
        }
    }, [isEdit, message]);
    // #Mention | Detect MentionedLabel modified
    var useMentionedLabelDetection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        var _a;
        var textField = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
        if (isMentionEnabled && textField) {
            var newMentionedUserIds = Array.from(textField.getElementsByClassName('sendbird-mention-user-label')).map(
            // @ts-ignore
            function (node) { var _a; return (_a = node === null || node === void 0 ? void 0 : node.dataset) === null || _a === void 0 ? void 0 : _a.userid; });
            if (!(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.G)(mentionedUserIds, newMentionedUserIds) || newMentionedUserIds.length === 0) {
                onMentionedUserIdsUpdated(newMentionedUserIds);
                setMentionedUserIds(newMentionedUserIds);
            }
        }
        setIsInput((textField === null || textField === void 0 ? void 0 : textField.textContent) ? ((_a = textField.textContent) === null || _a === void 0 ? void 0 : _a.trim().length) > 0 : false);
    }, [targetStringInfo, isMentionEnabled]);
    // #Mention | Replace selected user nickname to the MentionedUserLabel
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        var _a, _b, _c, _d;
        if (isMentionEnabled && mentionSelectedUser) {
            var targetString = targetStringInfo.targetString, startNodeIndex = targetStringInfo.startNodeIndex, startOffsetIndex = targetStringInfo.startOffsetIndex, endNodeIndex = targetStringInfo.endNodeIndex, endOffsetIndex = targetStringInfo.endOffsetIndex;
            var textField_1 = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
            if (targetString && startNodeIndex !== null && startOffsetIndex !== null && endOffsetIndex !== null && endNodeIndex !== null && textField_1) {
                // const textField = document.getElementById(textFieldId);
                var childNodes = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.n)(textField_1 === null || textField_1 === void 0 ? void 0 : textField_1.childNodes);
                var startNodeTextContent = (_b = (_a = childNodes[startNodeIndex]) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : '';
                var frontTextNode = document.createTextNode(startNodeTextContent.slice(0, startOffsetIndex));
                var endNodeTextContent = (_d = (_c = childNodes[endNodeIndex]) === null || _c === void 0 ? void 0 : _c.textContent) !== null && _d !== void 0 ? _d : '';
                var backTextNode = endOffsetIndex && document.createTextNode("\u00A0".concat(endNodeTextContent.slice(endOffsetIndex)));
                var mentionLabel = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.r)({
                    userId: mentionSelectedUser === null || mentionSelectedUser === void 0 ? void 0 : mentionSelectedUser.userId,
                    nickname: "".concat(_chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_3__.a).concat((mentionSelectedUser === null || mentionSelectedUser === void 0 ? void 0 : mentionSelectedUser.nickname) || stringSet.MENTION_NAME__NO_NAME),
                });
                var div = document.createElement('div');
                div.innerHTML = mentionLabel;
                var newNodes = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], childNodes.slice(0, startNodeIndex), true), [
                    frontTextNode,
                    div.childNodes[0],
                    backTextNode
                ], false), childNodes.slice(endNodeIndex + 1), true);
                if (textField_1) {
                    textField_1.innerHTML = '';
                    newNodes.forEach(function (newNode) {
                        if (newNode) {
                            textField_1.appendChild(newNode);
                        }
                    });
                }
                onUserMentioned(mentionSelectedUser);
                if (window.getSelection || document.getSelection) {
                    // set caret postion
                    var selection = window.getSelection() || document.getSelection();
                    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                    var range = new Range();
                    range.selectNodeContents(textField_1);
                    range.setStart(textField_1.childNodes[startNodeIndex + 2], 1);
                    range.setEnd(textField_1.childNodes[startNodeIndex + 2], 1);
                    range.collapse(false);
                    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
                    textField_1.focus();
                }
                setTargetStringInfo((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, initialTargetStringInfo));
                setHeight();
                useMentionedLabelDetection();
            }
        }
    }, [mentionSelectedUser, isMentionEnabled]);
    // #Mention | Detect mentioning user nickname
    var useMentionInputDetection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        var _a, _b;
        var selection = ((_a = window === null || window === void 0 ? void 0 : window.getSelection) === null || _a === void 0 ? void 0 : _a.call(window)) || ((_b = document === null || document === void 0 ? void 0 : document.getSelection) === null || _b === void 0 ? void 0 : _b.call(document));
        var textField = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
        if ((selection === null || selection === void 0 ? void 0 : selection.anchorNode) === textField) {
            onMentionStringChange('');
        }
        if (isMentionEnabled
            && textField
            && selection
            && selection.anchorNode === selection.focusNode
            && selection.anchorOffset === selection.focusOffset) {
            var textStack = '';
            var startNodeIndex = null;
            var startOffsetIndex = null;
            var _loop_1 = function (index) {
                var currentNode = textField.childNodes[index];
                if (currentNode.nodeType === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_2__.N.TextNode) {
                    /* text node */
                    var textContent = (function () {
                        var _a;
                        if (currentNode === selection.anchorNode) {
                            return (currentNode === null || currentNode === void 0 ? void 0 : currentNode.textContent) ? currentNode === null || currentNode === void 0 ? void 0 : currentNode.textContent.slice(0, selection.anchorOffset) : '';
                        }
                        return (_a = currentNode === null || currentNode === void 0 ? void 0 : currentNode.textContent) !== null && _a !== void 0 ? _a : '';
                    })();
                    if (textStack.length > 0) {
                        textStack += textContent;
                    }
                    else {
                        var charLastIndex = textContent.lastIndexOf(_chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_3__.a);
                        for (var i = charLastIndex - 1; i > -1; i -= 1) {
                            if (textContent[i] === _chunks_bundle_C6DfLTJj_js__WEBPACK_IMPORTED_MODULE_3__.a) {
                                charLastIndex = i;
                            }
                            else {
                                break;
                            }
                        }
                        if (charLastIndex > -1) {
                            textStack = textContent;
                            startNodeIndex = index;
                            startOffsetIndex = charLastIndex;
                        }
                    }
                }
                else {
                    /* other nodes */
                    textStack = '';
                    startNodeIndex = null;
                    startOffsetIndex = null;
                }
                if (currentNode === selection.anchorNode) {
                    /**
                     * targetString could be ''
                     * startNodeIndex and startOffsetIndex could be null
                     */
                    var targetString = textStack && startOffsetIndex !== null ? textStack.slice(startOffsetIndex) : ''; // include template character
                    setTargetStringInfo({
                        targetString: targetString,
                        startNodeIndex: startNodeIndex,
                        startOffsetIndex: startOffsetIndex,
                        endNodeIndex: index,
                        endOffsetIndex: selection.anchorOffset,
                    });
                    onMentionStringChange(targetString);
                    return { value: void 0 };
                }
            };
            for (var index = 0; index < textField.childNodes.length; index += 1) {
                var state_1 = _loop_1(index);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
    }, [isMentionEnabled]);
    var sendMessage = function () {
        var _a, _b;
        try {
            var textField_2 = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
            if (!isEdit && (textField_2 === null || textField_2 === void 0 ? void 0 : textField_2.textContent)) {
                var _c = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.e)(textField_2.childNodes), messageText = _c.messageText, mentionTemplate = _c.mentionTemplate;
                var params = { message: messageText, mentionTemplate: mentionTemplate };
                onSendMessage(params);
                resetInput(internalRef);
                /**
                 * Note: contentEditable does not work as expected in mobile WebKit (Safari).
                 * @see https://github.com/sendbird/sendbird-uikit-react/pull/1108
                 */
                if ((0,_chunks_bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_17__.i)(navigator.userAgent)) {
                    if (ghostInputRef.current)
                        ghostInputRef.current.focus();
                    requestAnimationFrame(function () { return textField_2.focus(); });
                }
                else {
                    // important: keeps the keyboard open -> must add test on refactor
                    textField_2.focus();
                }
                setIsInput(false);
                setHeight();
            }
        }
        catch (error) {
            (_b = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.message) === null || _a === void 0 ? void 0 : _a.onSendMessageFailed) === null || _b === void 0 ? void 0 : _b.call(_a, message, error);
        }
    };
    var isEditDisabled = !((_b = (_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim());
    var editMessage = function () {
        var _a, _b;
        try {
            var textField = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current;
            var messageId = message === null || message === void 0 ? void 0 : message.messageId;
            if (isEdit && messageId && textField) {
                var _c = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.e)(textField.childNodes), messageText = _c.messageText, mentionTemplate = _c.mentionTemplate;
                var params = { messageId: messageId, message: messageText, mentionTemplate: mentionTemplate };
                onUpdateMessage(params);
                resetInput(internalRef);
            }
        }
        catch (error) {
            (_b = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.message) === null || _a === void 0 ? void 0 : _a.onUpdateMessageFailed) === null || _b === void 0 ? void 0 : _b.call(_a, message, error);
        }
    };
    var onPaste = (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.u)({
        ref: internalRef,
        setMentionedUsers: setMentionedUsers,
        channel: channel,
        setIsInput: setIsInput,
        setHeight: setHeight,
    });
    var uploadFile = function (event) {
        var _a, _b;
        var files = event.currentTarget.files;
        try {
            if (files) {
                onFileUpload(Array.from(files));
            }
        }
        catch (error) {
            (_b = (_a = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.message) === null || _a === void 0 ? void 0 : _a.onFileUploadFailed) === null || _b === void 0 ? void 0 : _b.call(_a, error);
        }
        finally {
            event.target.value = '';
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("form", { className: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_18__.c.apply(void 0, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), false), [isEdit && 'sendbird-message-input__edit',
            disabled && 'sendbird-message-input-form__disabled'], false)) },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_18__.c)('sendbird-message-input', disabled && 'sendbird-message-input__disabled'), "data-testid": "sendbird-message-input" },
            (0,_chunks_bundle_eZsqrPY3_js__WEBPACK_IMPORTED_MODULE_17__.i)(navigator.userAgent) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("input", { id: 'ghost-input-reset-ime-cjk', ref: ghostInputRef, style: { opacity: 0, padding: 0, margin: 0, height: 0, border: 'none', position: 'absolute', top: -9999 }, defaultValue: '_' })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { id: "".concat(textFieldId).concat(isEdit ? message === null || message === void 0 ? void 0 : message.messageId : ''), className: "sendbird-message-input--textarea ".concat(textFieldId), contentEditable: !disabled, role: "textbox", "aria-label": "Text Input", ref: externalRef, 
                // @ts-ignore
                disabled: disabled, maxLength: maxLength, onKeyDown: function (e) {
                    var _a, _b, _c, _d;
                    var preventEvent = onKeyDown(e);
                    if (preventEvent) {
                        e.preventDefault();
                    }
                    else {
                        if (!e.shiftKey
                            && e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_2__.M.Enter
                            && !isMobile
                            && ((_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.textContent)
                            && internalRef.current.textContent.trim().length > 0
                            && ((_b = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _b === void 0 ? void 0 : _b.isComposing) !== true
                        /**
                         * NOTE: What isComposing does?
                         * Check if the user has finished composing characters
                         * (e.g., for languages like Korean, Japanese, where characters are composed from multiple keystrokes)
                         * Prevents executing the code while the user is still composing characters.
                         */
                        ) {
                            e.preventDefault();
                            sendMessage();
                        }
                        if (e.key === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_2__.M.Backspace
                            && ((_d = (_c = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _c === void 0 ? void 0 : _c.childNodes) === null || _d === void 0 ? void 0 : _d.length) === 2
                            && !internalRef.current.childNodes[0].textContent
                            && internalRef.current.childNodes[1].nodeType === _chunks_bundle_CLlCJbe7_js__WEBPACK_IMPORTED_MODULE_2__.N.ElementNode) {
                            internalRef.current.removeChild(internalRef.current.childNodes[1]);
                        }
                    }
                }, onKeyUp: function (e) {
                    var preventEvent = onKeyUp(e);
                    if (preventEvent) {
                        e.preventDefault();
                    }
                    else {
                        useMentionInputDetection();
                    }
                }, onClick: function () {
                    useMentionInputDetection();
                }, onInput: function () {
                    var _a;
                    setHeight();
                    onStartTyping();
                    setIsInput(((_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.textContent) ? internalRef.current.textContent.trim().length > 0 : false);
                    useMentionedLabelDetection();
                }, onPaste: onPaste }),
            ((_e = (_d = (_c = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) === 0 && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.L, { className: "sendbird-message-input--placeholder", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.a.BODY_1, color: disabled ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.ONBACKGROUND_4 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_8__.b.ONBACKGROUND_3 }, placeholder || stringSet.MESSAGE_INPUT__PLACE_HOLDER)),
            !isEdit && isInput && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_IconButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { className: "sendbird-message-input--send", height: "32px", width: "32px", onClick: function () { return sendMessage(); }, testID: "sendbird-message-input-send-button" }, (renderSendMessageIcon === null || renderSendMessageIcon === void 0 ? void 0 : renderSendMessageIcon()) || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconTypes.SEND */ .Qy.SEND, fillColor: disabled ? _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.ON_BACKGROUND_4 */ .zo.ON_BACKGROUND_4 : _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "20px", height: "20px" })))),
            !isEdit
                && !isInput
                && ((renderFileUploadIcon === null || renderFileUploadIcon === void 0 ? void 0 : renderFileUploadIcon())
                    // UIKit Dashboard configuration should have lower priority than
                    // renderFileUploadIcon which is set in code level
                    || (isFileUploadEnabled && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_IconButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_18__.c)('sendbird-message-input--attach', isVoiceMessageEnabled && 'is-voice-message-enabled'), height: "32px", width: "32px", onClick: function () {
                            var _a, _b;
                            // todo: clear previous input
                            (_b = (_a = fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
                        } },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconTypes.ATTACH */ .Qy.ATTACH, fillColor: disabled ? _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.ON_BACKGROUND_4 */ .zo.ON_BACKGROUND_4 : _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE, width: "20px", height: "20px" }),
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement("input", { className: "sendbird-message-input--attach-input", type: "file", ref: fileInputRef, 
                            // It will affect to <Channel /> and <Thread />
                            onChange: function (event) { return uploadFile(event); }, accept: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_11__.H)(acceptableMimeTypes), multiple: isSelectingMultipleFilesEnabled && (0,_chunks_bundle_tC4B8MXx_js__WEBPACK_IMPORTED_MODULE_6__.i)(channel) }))))),
            isVoiceMessageEnabled && !isEdit && !isInput && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_IconButton_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { className: "sendbird-message-input--voice-message", width: "32px", height: "32px", onClick: onVoiceMessageIconClick }, (renderVoiceMessageIcon === null || renderVoiceMessageIcon === void 0 ? void 0 : renderVoiceMessageIcon()) || (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconTypes.AUDIO_ON_LINED */ .Qy.AUDIO_ON_LINED, fillColor: disabled ? _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.ON_BACKGROUND_4 */ .zo.ON_BACKGROUND_4 : _Icon_js__WEBPACK_IMPORTED_MODULE_7__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE, width: "20px", height: "20px" }))))),
        isEdit && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message-input--edit-action", "data-testid": "sendbird-message-input--edit-action" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { className: "sendbird-message-input--edit-action__cancel", type: _Button_js__WEBPACK_IMPORTED_MODULE_5__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, size: _Button_js__WEBPACK_IMPORTED_MODULE_5__/* .ButtonSizes.SMALL */ .Ph.SMALL, onClick: onCancelEdit }, stringSet.BUTTON__CANCEL),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { className: "sendbird-message-input--edit-action__save", type: _Button_js__WEBPACK_IMPORTED_MODULE_5__/* .ButtonTypes.PRIMARY */ .qh.PRIMARY, size: _Button_js__WEBPACK_IMPORTED_MODULE_5__/* .ButtonSizes.SMALL */ .Ph.SMALL, disabled: isEditDisabled, onClick: function () { return editMessage(); } }, stringSet.BUTTON__SAVE)))));
});


//# sourceMappingURL=MessageInput.js.map


/***/ }),

/***/ 69139:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MessageEmojiMenu; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16167);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29515);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4399);
/* harmony import */ var _ReactionButton_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60090);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65614);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26765);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8978);


























function MessageEmojiMenu(_a) {
    var className = _a.className, message = _a.message, userId = _a.userId, _b = _a.spaceFromTrigger, spaceFromTrigger = _b === void 0 ? { x: 0, y: 0 } : _b, emojiContainer = _a.emojiContainer, filterEmojiCategoryIds = _a.filterEmojiCategoryIds, toggleReaction = _a.toggleReaction;
    var triggerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var filteredEmojis = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.u)(emojiContainer, filterEmojiCategoryIds === null || filterEmojiCategoryIds === void 0 ? void 0 : filterEmojiCategoryIds(message));
    }, [emojiContainer, filterEmojiCategoryIds]);
    if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.v)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.w)(message)) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_6__.x)([className !== null && className !== void 0 ? className : '', 'sendbird-message-item-reaction-menu']), ref: containerRef },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { className: "sendbird-message-item-reaction-menu__trigger", ref: triggerRef, width: "32px", height: "32px", onClick: function () {
                    toggleDropdown();
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: "sendbird-message-item-reaction-menu__trigger__icon", testID: "sendbird-message-item-reaction-menu__trigger__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.EMOJI_MORE */ .Qy.EMOJI_MORE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.CONTENT_INVERSE */ .zo.CONTENT_INVERSE, width: "24px", height: "24px" }))); }, menuItems: function (closeDropdown) {
                if (filteredEmojis.length === 0)
                    return null;
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__.f, { id: (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_1__.g)(message.messageId), parentRef: triggerRef, parentContainRef: containerRef, closeDropdown: closeDropdown, spaceFromTrigger: spaceFromTrigger }, filteredEmojis.map(function (emoji) {
                    var _a, _b, _c;
                    var isReacted = ((_c = (_b = (_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.find(function (reaction) { return reaction.key === emoji.key; })) === null || _b === void 0 ? void 0 : _b.userIds) === null || _c === void 0 ? void 0 : _c.some(function (reactorId) { return reactorId === userId; })) || false;
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ReactionButton_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { key: emoji.key, width: "36px", height: "36px", selected: isReacted, onClick: function () {
                            closeDropdown();
                            toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
                        }, testID: "ui_emoji_reactions_menu_".concat(emoji.key) },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, { url: emoji.url, width: "28px", height: "28px", placeHolder: function (_a) {
                                var style = _a.style;
                                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: style },
                                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.QUESTION */ .Qy.QUESTION, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                            } })));
                })));
            } })));
}


//# sourceMappingURL=MessageItemReactionMenu.js.map


/***/ }),

/***/ 45143:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MobileFeedbackMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _BottomSheet_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18087);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88569);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43822);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(61448);






























function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.u)().stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BottomSheet_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { onBackdropClick: hideMenu },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}


//# sourceMappingURL=MobileFeedbackMenu.js.map


/***/ }),

/***/ 56342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nn": function() { return /* binding */ MobileMenu; }
/* harmony export */ });
/* unused harmony exports MobileBottomSheet, MobileContextMenu, default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(80360);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16167);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29515);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99366);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43822);
/* harmony import */ var _BottomSheet_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18087);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4399);
/* harmony import */ var _ReactionButton_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60090);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8978);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71091);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26765);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8627);

































var CopyMenuItem$1 = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message))
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.A)(message.message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__COPY),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.COPY */ .Qy.COPY, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var ReplyMenuItem$1 = function (props) {
    var _a, _b, _c;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _d = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _d.message, hideMenu = _d.hideMenu, setQuoteMessage = _d.setQuoteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { disabled: message.parentMessageId > 0, onClick: function (e) {
            var _a;
            setQuoteMessage(message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: ((_b = message.parentMessageId) !== null && _b !== void 0 ? _b : 0) > 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_4 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__REPLY),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.REPLY */ .Qy.REPLY, fillColor: ((_c = message.parentMessageId) !== null && _c !== void 0 ? _c : 0) > 0 ? _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_4 */ .zo.ON_BACKGROUND_4 : _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var ThreadMenuItem$1 = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu, onReplyInThread = _b.onReplyInThread;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            onReplyInThread({ message: message });
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__THREAD),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.THREAD */ .Qy.THREAD, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var EditMenuItem$1 = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), hideMenu = _b.hideMenu, showEdit = _b.showEdit, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                showEdit(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__EDIT),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.EDIT */ .Qy.EDIT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var ResendMenuItem$1 = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu, resendMessage = _b.resendMessage, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                resendMessage(message);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__RESEND),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.REFRESH */ .Qy.REFRESH, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var DeleteMenuItem$1 = function (props) {
    var _a, _b, _c;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _d = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _d.message, hideMenu = _d.hideMenu, deleteMessage = _d.deleteMessage, showRemove = _d.showRemove, isOnline = _d.isOnline, disableDeleteMessage = _d.disableDeleteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { disabled: typeof disableDeleteMessage === 'boolean'
            ? disableDeleteMessage
            : ((_b = (_a = message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) !== null && _b !== void 0 ? _b : 0) > 0, onClick: function (e) {
            var _a;
            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message)) {
                deleteMessage(message);
            }
            else if (isOnline) {
                showRemove(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_c = props.children) !== null && _c !== void 0 ? _c : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: disableDeleteMessage ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_4 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__DELETE),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DELETE */ .Qy.DELETE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};
var DownloadMenuItem$1 = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), hideMenu = _b.hideMenu, message = _b.message, onDownloadClick = _b.onDownloadClick;
    var url = message.url;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.a, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function () {
            hideMenu();
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", { className: "sendbird-message__contextmenu--hyperlink", rel: "noopener noreferrer", href: url, target: "_blank", onClick: onDownloadClick },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__SAVE),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DOWNLOAD */ .Qy.DOWNLOAD, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" })))));
};

var MobileContextMenu = function (props) {
    var _a, _b, _c, _d;
    var channel = props.channel, message = props.message, replyType = props.replyType, userId = props.userId, resendMessage = props.resendMessage, showEdit = props.showEdit, showRemove = props.showRemove, deleteMenuState = props.deleteMenuState, deleteMessage = props.deleteMessage, setQuoteMessage = props.setQuoteMessage, parentRef = props.parentRef, onReplyInThread = props.onReplyInThread, _e = props.isOpenedFromThread, isOpenedFromThread = _e === void 0 ? false : _e, _f = props.onDownloadClick, onDownloadClick = _f === void 0 ? null : _f, renderMenuItems = props.renderMenuItems, hideMobileMenu = props.hideMenu;
    var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)().config;
    var isOnline = config.isOnline;
    // Menu Items condition
    var showMenuItemCopy = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message);
    var showMenuItemEdit = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message) && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.q)(message) && isByMe;
    var showMenuItemResend = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message) && (message === null || message === void 0 ? void 0 : message.isResendable) && isByMe;
    var showMenuItemDelete = !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && isByMe;
    var showMenuItemDeleteByState = isByMe && (deleteMenuState === undefined || deleteMenuState !== 'HIDE');
    var showMenuItemDeleteFinal = showMenuItemDeleteByState && showMenuItemDelete;
    var showMenuItemDownload = !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.b)(message) && !((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.i)(message) && (channel === null || channel === void 0 ? void 0 : channel.isSuper) || (channel === null || channel === void 0 ? void 0 : channel.isBroadcast));
    var showMenuItemReply = replyType === 'QUOTE_REPLY' && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && (channel === null || channel === void 0 ? void 0 : channel.isGroupChannel());
    var showMenuItemThread = replyType === 'THREAD' && !isOpenedFromThread && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.R)(message) && (channel === null || channel === void 0 ? void 0 : channel.isGroupChannel());
    var disableDeleteMessage = (deleteMenuState !== undefined && deleteMenuState === 'DISABLE') || ((_c = (_b = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _b === void 0 ? void 0 : _b.replyCount) !== null && _c !== void 0 ? _c : 0) > 0;
    var contextValue = {
        message: message,
        hideMenu: hideMobileMenu,
        setQuoteMessage: setQuoteMessage,
        onReplyInThread: onReplyInThread,
        onMoveToParentMessage: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.n,
        showEdit: showEdit,
        showRemove: showRemove,
        deleteMessage: deleteMessage,
        resendMessage: resendMessage,
        isOnline: isOnline,
        disableDeleteMessage: disableDeleteMessage,
        triggerRef: parentRef,
        containerRef: parentRef,
        onDownloadClick: onDownloadClick,
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.M, { value: contextValue },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.b, { className: "sendbird-message__mobile-context-menu", parentRef: parentRef, parentContainRef: parentRef, closeDropdown: hideMobileMenu }, (_d = renderMenuItems === null || renderMenuItems === void 0 ? void 0 : renderMenuItems({
            items: {
                CopyMenuItem: CopyMenuItem$1,
                ReplyMenuItem: ReplyMenuItem$1,
                ThreadMenuItem: ThreadMenuItem$1,
                EditMenuItem: EditMenuItem$1,
                ResendMenuItem: ResendMenuItem$1,
                DeleteMenuItem: DeleteMenuItem$1,
            },
        })) !== null && _d !== void 0 ? _d : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
            showMenuItemCopy && react__WEBPACK_IMPORTED_MODULE_1__.createElement(CopyMenuItem$1, null),
            showMenuItemReply && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ReplyMenuItem$1, null),
            showMenuItemThread && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ThreadMenuItem$1, null),
            showMenuItemEdit && react__WEBPACK_IMPORTED_MODULE_1__.createElement(EditMenuItem$1, null),
            showMenuItemResend && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ResendMenuItem$1, null),
            showMenuItemDeleteFinal && react__WEBPACK_IMPORTED_MODULE_1__.createElement(DeleteMenuItem$1, null),
            showMenuItemDownload && react__WEBPACK_IMPORTED_MODULE_1__.createElement(DownloadMenuItem$1, null))))));
};

var CopyMenuItem = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message))
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.A)(message.message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.COPY */ .Qy.COPY, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__COPY)))));
};
var EditMenuItem = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), hideMenu = _b.hideMenu, showEdit = _b.showEdit, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                showEdit(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.EDIT */ .Qy.EDIT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__EDIT)))));
};
var ResendMenuItem = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu, resendMessage = _b.resendMessage, isOnline = _b.isOnline;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            if (isOnline) {
                resendMessage(message);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.REFRESH */ .Qy.REFRESH, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__RESEND)))));
};
var ReplyMenuItem = function (props) {
    var _a, _b, _c;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _d = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _d.message, hideMenu = _d.hideMenu, setQuoteMessage = _d.setQuoteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { disabled: message.parentMessageId > 0, onClick: function (e) {
            var _a;
            setQuoteMessage(message);
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.REPLY */ .Qy.REPLY, fillColor: ((_b = message.parentMessageId) !== null && _b !== void 0 ? _b : 0) > 0 ? _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3 : _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: ((_c = message.parentMessageId) !== null && _c !== void 0 ? _c : 0) > 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_4 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__REPLY)))));
};
var ThreadMenuItem = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _b.message, hideMenu = _b.hideMenu, onReplyInThread = _b.onReplyInThread;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { onClick: function (e) {
            var _a;
            onReplyInThread({ message: message });
            hideMenu();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }), (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.THREAD */ .Qy.THREAD, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__THREAD)))));
};
var DeleteMenuItem = function (props) {
    var _a, _b, _c;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _d = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), message = _d.message, hideMenu = _d.hideMenu, deleteMessage = _d.deleteMessage, showRemove = _d.showRemove, isOnline = _d.isOnline, disableDeleteMessage = _d.disableDeleteMessage;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props, { disabled: typeof disableDeleteMessage === 'boolean'
            ? disableDeleteMessage
            : ((_b = (_a = message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) !== null && _b !== void 0 ? _b : 0) > 0, onClick: function (e) {
            var _a;
            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message)) {
                deleteMessage(message);
            }
            else if (isOnline) {
                showRemove(true);
                hideMenu();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), (_c = props.children) !== null && _c !== void 0 ? _c : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DELETE */ .Qy.DELETE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: disableDeleteMessage ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_4 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__DELETE)))));
};
var DownloadMenuItem = function (props) {
    var _a;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_6__.u)().stringSet;
    var _b = (0,_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.u)(), hideMenu = _b.hideMenu, message = _b.message, onDownloadClick = _b.onDownloadClick;
    var url = message.url;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.B, { onClick: function () { return hideMenu(); } }, (_a = props.children) !== null && _a !== void 0 ? _a : (react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", { className: "sendbird-message__bottomsheet--hyperlink", rel: "noopener noreferrer", href: url, target: "_blank", onClick: onDownloadClick },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.DOWNLOAD */ .Qy.DOWNLOAD, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "24px", height: "24px" }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_7__.b.ONBACKGROUND_1 }, stringSet.MESSAGE_MENU__SAVE)))));
};

var EMOJI_SIZE = 38;
var MobileBottomSheet = function (props) {
    var _a, _b, _c, _d;
    var hideMenu = props.hideMenu, channel = props.channel, emojiContainer = props.emojiContainer, message = props.message, replyType = props.replyType, userId = props.userId, resendMessage = props.resendMessage, deleteMessage = props.deleteMessage, toggleReaction = props.toggleReaction, _e = props.isReactionEnabled, isReactionEnabled = _e === void 0 ? false : _e, showEdit = props.showEdit, showRemove = props.showRemove, deleteMenuState = props.deleteMenuState, setQuoteMessage = props.setQuoteMessage, onReplyInThread = props.onReplyInThread, _f = props.isOpenedFromThread, isOpenedFromThread = _f === void 0 ? false : _f, onDownloadClick = props.onDownloadClick, renderMenuItems = props.renderMenuItems;
    var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useSendbirdStateContext */ .A)().config;
    var isOnline = config.isOnline;
    var showMenuItemCopy = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message);
    var showMenuItemEdit = ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.l)(message) && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.q)(message) && isByMe);
    var showMenuItemResend = (isOnline && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message) && (message === null || message === void 0 ? void 0 : message.isResendable) && isByMe);
    var showMenuItemDelete = !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && isByMe;
    var showMenuItemDeleteByState = isByMe && (deleteMenuState === undefined || deleteMenuState !== 'HIDE');
    var showMenuItemDeleteFinal = showMenuItemDeleteByState && showMenuItemDelete;
    var disableDelete = ((deleteMenuState !== undefined && deleteMenuState === 'DISABLE')
        || ((_c = (_b = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _b === void 0 ? void 0 : _b.replyCount) !== null && _c !== void 0 ? _c : 0) > 0);
    var showMenuItemDownload = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.q)(message) && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.b)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.i)(message);
    var showReaction = !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message) && isReactionEnabled;
    var showMenuItemReply = (replyType === 'QUOTE_REPLY')
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message)
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message)
        && ((channel === null || channel === void 0 ? void 0 : channel.isGroupChannel()) && !(channel === null || channel === void 0 ? void 0 : channel.isBroadcast));
    var showMenuItemThread = (replyType === 'THREAD') && !isOpenedFromThread
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.w)(message)
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.v)(message)
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.R)(message)
        && ((channel === null || channel === void 0 ? void 0 : channel.isGroupChannel()) && !(channel === null || channel === void 0 ? void 0 : channel.isBroadcast));
    var maxEmojisPerRow = Math.floor(window.innerWidth / EMOJI_SIZE) - 1;
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showEmojisOnly = _g[0], setShowEmojisOnly = _g[1];
    var emojis = emojiContainer && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.T)(emojiContainer);
    var visibleEmojis = showEmojisOnly ? emojis : emojis === null || emojis === void 0 ? void 0 : emojis.slice(0, maxEmojisPerRow);
    var canShowMoreEmojis = emojis && emojis.length > maxEmojisPerRow;
    var contextValue = {
        message: message,
        hideMenu: hideMenu,
        setQuoteMessage: setQuoteMessage,
        onReplyInThread: onReplyInThread,
        onMoveToParentMessage: function () { },
        showEdit: showEdit,
        showRemove: showRemove,
        deleteMessage: deleteMessage,
        resendMessage: resendMessage,
        isOnline: isOnline,
        disableDeleteMessage: disableDelete,
        triggerRef: null,
        containerRef: null,
        onDownloadClick: onDownloadClick,
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_4__.M, { value: contextValue },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_BottomSheet_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { onBackdropClick: hideMenu },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message__bottomsheet" },
                showReaction && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message__bottomsheet-reactions" },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement("ul", { className: "sendbird-message__bottomsheet-reaction-bar" },
                        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.c)('sendbird-message__bottomsheet-reaction-bar__row', showEmojisOnly && 'sendbird-message__bottomsheet-reaction-bar__all') },
                            visibleEmojis.map(function (emoji) {
                                var _a, _b, _c;
                                var isReacted = (_c = (_b = (_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.filter(function (reaction) { return reaction.key === emoji.key; })[0]) === null || _b === void 0 ? void 0 : _b.userIds) === null || _c === void 0 ? void 0 : _c.some(function (reactorId) { return reactorId === userId; });
                                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ReactionButton_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { key: emoji.key, width: "".concat(EMOJI_SIZE, "px"), height: "".concat(EMOJI_SIZE, "px"), selected: isReacted, onClick: function () {
                                        hideMenu();
                                        toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
                                    }, testID: "ui_mobile_emoji_reactions_menu_".concat(emoji.key) },
                                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { url: (emoji === null || emoji === void 0 ? void 0 : emoji.url) || '', width: "28px", height: "28px", placeHolder: function (_a) {
                                            var style = _a.style;
                                            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { style: style },
                                                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.QUESTION */ .Qy.QUESTION, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                                        } })));
                            }),
                            canShowMoreEmojis && !showEmojisOnly && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ReactionButton_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { key: "emoji_more", width: "38px", height: "38px", onClick: function () { return setShowEmojisOnly(true); }, testID: "ui_mobile_emoji_reactions_menu_emojiadd" },
                                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, { url: '', width: "28px", height: "28px", placeHolder: function (_a) {
                                        var style = _a.style;
                                        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { style: style },
                                            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconTypes.EMOJI_MORE */ .Qy.EMOJI_MORE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_8__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "28px", height: "28px" })));
                                    } }))))))),
                !showEmojisOnly && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-message__bottomsheet--actions" }, (_d = renderMenuItems === null || renderMenuItems === void 0 ? void 0 : renderMenuItems({
                    items: {
                        CopyMenuItem: CopyMenuItem,
                        EditMenuItem: EditMenuItem,
                        ResendMenuItem: ResendMenuItem,
                        ReplyMenuItem: ReplyMenuItem,
                        ThreadMenuItem: ThreadMenuItem,
                        DeleteMenuItem: DeleteMenuItem,
                    },
                })) !== null && _d !== void 0 ? _d : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
                    showMenuItemCopy && react__WEBPACK_IMPORTED_MODULE_1__.createElement(CopyMenuItem, null),
                    showMenuItemEdit && react__WEBPACK_IMPORTED_MODULE_1__.createElement(EditMenuItem, null),
                    showMenuItemResend && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ResendMenuItem, null),
                    showMenuItemReply && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ReplyMenuItem, null),
                    showMenuItemThread && react__WEBPACK_IMPORTED_MODULE_1__.createElement(ThreadMenuItem, null),
                    showMenuItemDeleteFinal && react__WEBPACK_IMPORTED_MODULE_1__.createElement(DeleteMenuItem, null),
                    showMenuItemDownload && react__WEBPACK_IMPORTED_MODULE_1__.createElement(DownloadMenuItem, null)))))))));
};

var MobileMenu = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (props === null || props === void 0 ? void 0 : props.isReactionEnabled) ? react__WEBPACK_IMPORTED_MODULE_1__.createElement(MobileBottomSheet, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props)) : react__WEBPACK_IMPORTED_MODULE_1__.createElement(MobileContextMenu, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props))));
};


//# sourceMappingURL=MobileMenu.js.map


/***/ }),

/***/ 67412:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MutedAvatarOverlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);





function MutedAvatarOverlay(props) {
    var _a = props.height, height = _a === void 0 ? 24 : _a, _b = props.width, width = _b === void 0 ? 24 : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-muted-avatar", style: {
            height: "".concat(height, "px"),
            width: "".concat(width, "px"),
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-muted-avatar__icon" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-muted-avatar__bg", style: {
                    height: "".concat(height, "px"),
                    width: "".concat(width, "px"),
                } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.MUTE */ .Qy.MUTE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.WHITE */ .zo.WHITE, width: "".concat(height - 8, "px"), height: "".concat(width - 8, "px") }))));
}


//# sourceMappingURL=MutedAvatarOverlay.js.map


/***/ }),

/***/ 34835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OGMessageItemBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4399);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_BmHwyA9G_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(13195);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8978);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23012);
/* harmony import */ var _MentionLabel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81823);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16167);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71091);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29515);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(13462);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(17693);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(88569);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(41238);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(82314);
/* harmony import */ var _LinkLabel_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(40286);










































function OGMessageItemBody(_a) {
    var _b, _c, _d, _e;
    var className = _a.className, message = _a.message, _f = _a.isByMe, isByMe = _f === void 0 ? false : _f, _g = _a.mouseHover, mouseHover = _g === void 0 ? false : _g, _h = _a.isMentionEnabled, isMentionEnabled = _h === void 0 ? false : _h, _j = _a.isReactionEnabled, isReactionEnabled = _j === void 0 ? false : _j, _k = _a.isMarkdownEnabled, isMarkdownEnabled = _k === void 0 ? false : _k, _l = _a.onMessageHeightChange, onMessageHeightChange = _l === void 0 ? function () {
        /* noop */
    } : _l;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_5__.L).stringSet;
    var isMessageMentioned = isMentionEnabled && ((_b = message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate) === null || _b === void 0 ? void 0 : _b.length) > 0 && (message === null || message === void 0 ? void 0 : message.mentionedUsers) && ((_c = message === null || message === void 0 ? void 0 : message.mentionedUsers) === null || _c === void 0 ? void 0 : _c.length) > 0;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var _a;
        if (isMessageMentioned) {
            return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_7__.t)({
                mentionedUsers: (_a = message === null || message === void 0 ? void 0 : message.mentionedUsers) !== null && _a !== void 0 ? _a : undefined,
                messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
                includeMarkdown: isMarkdownEnabled,
            });
        }
        return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_7__.t)({
            messageText: message === null || message === void 0 ? void 0 : message.message,
            includeMarkdown: isMarkdownEnabled,
        });
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    var openOpenGraphURL = function () { var _a; return (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_30__.o)((_a = message === null || message === void 0 ? void 0 : message.ogMetaData) === null || _a === void 0 ? void 0 : _a.url); };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.x)([
            className !== null && className !== void 0 ? className : '',
            'sendbird-og-message-item-body',
            isByMe ? 'outgoing' : 'incoming',
            mouseHover ? 'mouse-hover' : '',
            isReactionEnabled && ((_d = message === null || message === void 0 ? void 0 : message.reactions) === null || _d === void 0 ? void 0 : _d.length) > 0 ? 'reactions' : '',
        ]) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_1 },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _chunks_bundle_BmHwyA9G_js__WEBPACK_IMPORTED_MODULE_31__.O },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_6__.T, { tokens: tokens }),
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.d)(message) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-og-message-item-body__text-bubble__message", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONCONTENT_2 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_2 }, " ".concat(stringSet.MESSAGE_EDITED, " "))))),
        ((_e = message.ogMetaData) === null || _e === void 0 ? void 0 : _e.defaultImage) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(OGImageSection, { onClick: openOpenGraphURL, ogImage: message.ogMetaData.defaultImage, onMessageHeightChange: onMessageHeightChange })),
        message.ogMetaData && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(OGDescriptionSection, { onClick: openOpenGraphURL, ogMetaData: message.ogMetaData, onMessageHeightChange: onMessageHeightChange })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-og-message-item-body__cover" })));
}
var OGImageSection = function (props) {
    var onClick = props.onClick, ogImage = props.ogImage, onMessageHeightChange = props.onMessageHeightChange;
    var imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isMobile = (0,_chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_8__.u)().isMobile;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: imageRef, className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_30__.c)('sendbird-og-message-item-body__og-thumbnail', !ogImage.url && 'sendbird-og-message-item-body__og-thumbnail__empty'), onClick: function () { return onClick(); } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { className: "sendbird-og-message-item-body__og-thumbnail__image", url: ogImage.url || '', alt: ogImage.alt || '', width: "100%", height: isMobile ? '136px' : '240px', onLoad: onMessageHeightChange, onError: function () {
                var _a, _b;
                try {
                    (_b = (_a = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('sendbird-og-message-item-body__og-thumbnail__empty');
                }
                catch (error) {
                    // do nothing
                }
            }, defaultComponent: react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-og-message-item-body__og-thumbnail__place-holder" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: "sendbird-og-message-item-body__og-thumbnail__place-holder__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.THUMBNAIL_NONE */ .Qy.THUMBNAIL_NONE, width: "56px", height: "56px" })) })));
};
var OGDescriptionSection = function (props) {
    var onClick = props.onClick, ogMetaData = props.ogMetaData, onMessageHeightChange = props.onMessageHeightChange;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        onMessageHeightChange();
    }, [ogMetaData.title, ogMetaData.description, ogMetaData.url]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-og-message-item-body__description", onClick: function () { return onClick(); } },
        ogMetaData.title && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-og-message-item-body__description__title", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.SUBTITLE_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_1 }, ogMetaData.title)),
        ogMetaData.description && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-og-message-item-body__description__description", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_1 }, ogMetaData.description)),
        ogMetaData.url && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-og-message-item-body__description__url", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_2 }, ogMetaData.url))));
};


//# sourceMappingURL=OGMessageItemBody.js.map


/***/ }),

/***/ 23170:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChannelAvatar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17374);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65614);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4399);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61448);











function ChannelAvatar(_a) {
    var channel = _a.channel, theme = _a.theme, _b = _a.height, height = _b === void 0 ? 56 : _b, _c = _a.width, width = _c === void 0 ? 56 : _c;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.L).stringSet;
    var memoizedAvatar = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: "sendbird-chat-header__avatar--open-channel", src: (0,_chunks_bundle_CcuSHuDt_js__WEBPACK_IMPORTED_MODULE_7__.b)(channel), width: "".concat(width, "px"), height: "".concat(height, "px"), alt: (channel === null || channel === void 0 ? void 0 : channel.name) || stringSet.OPEN_CHANNEL_SETTINGS__NO_TITLE }));
    }, [channel === null || channel === void 0 ? void 0 : channel.coverUrl, theme]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, memoizedAvatar));
}


//# sourceMappingURL=OpenChannelAvatar.js.map


/***/ }),

/***/ 10364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlaceHolder; },
/* harmony export */   "v": function() { return /* binding */ PlaceHolderTypes; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59587);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99366);
/* harmony import */ var _Loader_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72661);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61448);









var PlaceHolderTypes = {
    LOADING: 'LOADING',
    NO_CHANNELS: 'NO_CHANNELS',
    NO_MESSAGES: 'NO_MESSAGES',
    WRONG: 'WRONG',
    SEARCH_IN: 'SEARCH_IN',
    SEARCHING: 'SEARCHING',
    NO_RESULTS: 'NO_RESULTS',
};
function PlaceHolder(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, type = _a.type, iconSize = _a.iconSize, _c = _a.searchInString, searchInString = _c === void 0 ? '' : _c, retryToConnect = _a.retryToConnect;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_2__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-place-holder',
        ], false).join(' ') },
        type === PlaceHolderTypes.LOADING && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Loader_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { width: iconSize || '48px', height: iconSize || '48px' },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.SPINNER */ .Qy.SPINNER, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: iconSize || '48px', height: iconSize || '48px' }))),
        (type === PlaceHolderTypes.NO_CHANNELS
            || type === PlaceHolderTypes.NO_MESSAGES
            || type === PlaceHolderTypes.WRONG) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-place-holder__body" },
            type === PlaceHolderTypes.NO_CHANNELS && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-place-holder__body__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.CHAT */ .Qy.CHAT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: iconSize || '64px', height: iconSize || '64px' })),
            type === PlaceHolderTypes.WRONG && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-place-holder__body__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.ERROR */ .Qy.ERROR, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: iconSize || '64px', height: iconSize || '64px' })),
            type === PlaceHolderTypes.NO_MESSAGES && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-place-holder__body__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.MESSAGE */ .Qy.MESSAGE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: iconSize || '64px', height: iconSize || '64px' })),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-holder__body__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 },
                type === PlaceHolderTypes.NO_CHANNELS && (stringSet.PLACE_HOLDER__NO_CHANNEL),
                type === PlaceHolderTypes.WRONG && (stringSet.PLACE_HOLDER__WRONG),
                type === PlaceHolderTypes.NO_MESSAGES && (stringSet.PLACE_HOLDER__NO_MESSAGES)),
            retryToConnect && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-place-holder__body__reconnect", role: "button", onClick: retryToConnect, onKeyPress: retryToConnect, tabIndex: 0 },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-place-holder__body__reconnect__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes.REFRESH */ .Qy.REFRESH, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_3__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "20px", height: "20px" }),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-holder__body__reconnect__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BUTTON_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.PRIMARY }, stringSet.PLACE_HOLDER__RETRY_TO_CONNECT))))),
        (type === PlaceHolderTypes.NO_RESULTS
            || type === PlaceHolderTypes.SEARCH_IN
            || type === PlaceHolderTypes.SEARCHING) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-place-holder__body--align-top" },
            type === PlaceHolderTypes.SEARCH_IN && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-place-holder__body--align-top__text" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-holder__body--align-top__text__search-in", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BUTTON_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, stringSet.SEARCH_IN),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-holder__body--align-top__text__channel-name", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BUTTON_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.PRIMARY }, "'".concat(searchInString)),
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-holder__body--align-top__text__quote", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BUTTON_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.PRIMARY }, '\''))),
            type === PlaceHolderTypes.SEARCHING && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-hlder__body--align-top__searching", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, stringSet.SEARCHING)),
            type === PlaceHolderTypes.NO_RESULTS && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.L, { className: "sendbird-place-hlder__body--align-top__no-result", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_4__.b.ONBACKGROUND_2 }, stringSet.NO_SEARCHED_MESSAGE))))));
}


//# sourceMappingURL=PlaceHolder.js.map


/***/ }),

/***/ 28464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PlaybackTime; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





var PlaybackTime = function (_a) {
    var className = _a.className, _b = _a.time, time = _b === void 0 ? 0 : _b, _c = _a.labelType, labelType = _c === void 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.CAPTION_2 : _c, _d = _a.labelColor, labelColor = _d === void 0 ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONCONTENT_1 : _d;
    var naturalTime = time < 0 ? 0 : time;
    var hour = Math.floor(naturalTime / 3600000);
    var min = Math.floor(naturalTime % 3600000 / 60000);
    var sec = Math.floor((naturalTime % 3600000 % 60000) / 1000);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-play-time ".concat(className) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { type: labelType, color: labelColor }, "".concat(hour ? hour + ':' : '').concat(min < 10 ? '0' : '').concat(min ? min : '0', ":").concat(sec < 10 ? '0' : '').concat(sec))));
};


//# sourceMappingURL=PlaybackTime.js.map


/***/ }),

/***/ 68962:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ko": function() { return /* binding */ ProgressBar; },
/* harmony export */   "v1": function() { return /* binding */ ProgressBarColorTypes; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80360);



/* eslint-disable no-redeclare */
var ProgressBarColorTypes = {
    PRIMARY: 'progress-bar-color--primary',
    GRAY: 'progress-bar-color--gray',
};
var ProgressBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, maxSize = _a.maxSize, _d = _a.currentSize, currentSize = _d === void 0 ? 0 : _d, _e = _a.colorType, colorType = _e === void 0 ? ProgressBarColorTypes.PRIMARY : _e;
    var width = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return "".concat(currentSize / maxSize * 100, "%");
    }, [currentSize, maxSize]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_1__.c)('sendbird-progress-bar', className, colorType, disabled && 'progress-bar--disabled') },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-progress-bar__fill", style: { width: width } })));
};


//# sourceMappingURL=ProgressBar.js.map


/***/ }),

/***/ 26862:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuoteMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78828);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8978);
















function QuoteMessage(_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h;
    var message = _a.message, _j = _a.userId, userId = _j === void 0 ? '' : _j, _k = _a.isByMe, isByMe = _k === void 0 ? false : _k, _l = _a.className, className = _l === void 0 ? '' : _l, _m = _a.isUnavailable, isUnavailable = _m === void 0 ? false : _m, onClick = _a.onClick;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.L).stringSet;
    var parentMessage = message.parentMessage;
    var parentMessageSender = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.sender;
    var parentMessageSenderNickname = (userId === (parentMessageSender === null || parentMessageSender === void 0 ? void 0 : parentMessageSender.userId)) ? stringSet.QUOTED_MESSAGE__CURRENT_USER : parentMessageSender === null || parentMessageSender === void 0 ? void 0 : parentMessageSender.nickname;
    var parentMessageUrl = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.g)(parentMessage);
    var parentMessageType = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.a)(parentMessage);
    var currentMessageSenderNickname = (userId === ((_c = message === null || message === void 0 ? void 0 : message.sender) === null || _c === void 0 ? void 0 : _c.userId)) ? stringSet.QUOTED_MESSAGE__CURRENT_USER : (_d = message === null || message === void 0 ? void 0 : message.sender) === null || _d === void 0 ? void 0 : _d.nickname;
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isThumbnailLoaded = _o[0], setThumbnailLoaded = _o[1];
    var uikitFileTypes = (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.y)();
    var splitFileName = (_f = (_e = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.b)(parentMessage)) === null || _e === void 0 ? void 0 : _e.split('/')) !== null && _f !== void 0 ? _f : parentMessageUrl.split('/');
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.x)([className, 'sendbird-quote-message', isByMe ? 'outgoing' : 'incoming', isUnavailable ? 'unavailable' : '']), key: parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId, onClick: function () {
            if (!isUnavailable && onClick) {
                onClick();
            }
        }, onTouchEnd: function () {
            if (!isUnavailable && onClick) {
                onClick();
            }
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-to" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { className: "sendbird-quote-message__replied-to__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.REPLY */ .Qy.REPLY, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "12px", height: "12px" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-quote-message__replied-to__text", testID: "sendbird-quote-message__replied-to__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_3 },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-quote-message__replied-to__text__nickname" }, currentMessageSenderNickname),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-quote-message__replied-to__text__text" }, stringSet.QUOTED_MESSAGE__REPLIED_TO),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sendbird-quote-message__replied-to__text__nickname" }, parentMessageSenderNickname))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message" },
            isUnavailable && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__text-message" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-quote-message__replied-message__text-message__word", testID: "sendbird-quote-message__replied-message__text-message__word", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.QUOTED_MESSAGE__UNAVAILABLE))),
            (((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.l)(parentMessage) && ((_g = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.message) === null || _g === void 0 ? void 0 : _g.length) > 0) && !isUnavailable) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__text-message" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-quote-message__replied-message__text-message__word", testID: "sendbird-quote-message__replied-message__text-message__word", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.message))),
            ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.i)(parentMessage) && parentMessageUrl && !isUnavailable) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__text-message" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-quote-message__replied-message__text-message__word", testID: "sendbird-quote-message__replied-message__text-message__word", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, stringSet.VOICE_MESSAGE))),
            (((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.p)(parentMessage)
                || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.c)(parentMessage))
                && parentMessageUrl
                && !isUnavailable) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-quote-message__replied-message__thumbnail-message__image", url: parentMessageUrl, alt: parentMessageType, width: "144px", height: "108px", onLoad: function () { return setThumbnailLoaded(true); }, defaultComponent: (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__placeholder" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__placeholder__icon" },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.h)(parentMessageType) ? _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.PLAY */ .Qy.PLAY : _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.PHOTO */ .Qy.PHOTO, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "22px", height: "22px" })))) }),
                ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.h)(parentMessageType) && !(((_h = parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.thumbnails) === null || _h === void 0 ? void 0 : _h.length) > 0)) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", { className: "sendbird-quote-message__replied-message__thumbnail-message__video" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: parentMessageUrl, type: parentMessageType })),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__cover" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__cover__icon" },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.PLAY */ .Qy.PLAY, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "14px", height: "14px" }))))),
                (isThumbnailLoaded && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.z)(parentMessageType)) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__cover" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__thumbnail-message__cover__icon" },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.GIF */ .Qy.GIF, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.THUMBNAIL_ICON */ .zo.THUMBNAIL_ICON, width: "14px", height: "14px" })))))),
            ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.m)(parentMessage) === _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.U.FILE && parentMessageUrl && !isUnavailable) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote-message__replied-message__file-message" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { className: "sendbird-quote-message__replied-message__file-message__type-icon", type: (_b = {},
                        _b[uikitFileTypes.IMAGE] = _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.PHOTO */ .Qy.PHOTO,
                        _b[uikitFileTypes.VIDEO] = _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.PLAY */ .Qy.PLAY,
                        _b[uikitFileTypes.AUDIO] = _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.FILE_AUDIO */ .Qy.FILE_AUDIO,
                        _b[uikitFileTypes.GIF] = _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.GIF */ .Qy.GIF,
                        _b[uikitFileTypes.OTHERS] = _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconTypes.FILE_DOCUMENT */ .Qy.FILE_DOCUMENT,
                        _b)[(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.o)(parentMessageType)], fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_1__/* .IconColors.ON_BACKGROUND_3 */ .zo.ON_BACKGROUND_3, width: "16px", height: "16px" }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-quote-message__replied-message__file-message__file-name", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_3 }, (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__.t)(splitFileName[splitFileName.length - 1])))))));
}


//# sourceMappingURL=QuoteMessage.js.map


/***/ }),

/***/ 67840:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuoteMessageInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6623);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78828);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65614);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
















var componentClassname = 'sendbird-quote_message_input__avatar';
function QuoteMessageThumbnail(_a) {
    var _b;
    var message = _a.message;
    if (!(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.b)(message) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.i)(message)) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
    }
    var thumbnailUrl = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.c)(message);
    if (!thumbnailUrl) {
        if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.I)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.r)(message)) {
            thumbnailUrl = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.g)(message);
        }
        else if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c)(message) && (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.J)((_b = message.fileInfoList) === null || _b === void 0 ? void 0 : _b[0])) {
            thumbnailUrl = message.fileInfoList[0].url;
        }
    }
    if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.r)(message) && thumbnailUrl) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: componentClassname },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", { style: {
                    width: '44px',
                    height: '44px',
                }, src: thumbnailUrl })));
    }
    else if (((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.p)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c)(message)) && thumbnailUrl) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { className: componentClassname, url: thumbnailUrl, alt: (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.a)(message), width: "44px", height: "44px", fixedSize: true }));
    }
    else if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.L)(message)) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: componentClassname },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.FILE_AUDIO */ .Qy.FILE_AUDIO, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "24px", height: "24px" })));
    }
    else {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: componentClassname },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.FILE_DOCUMENT */ .Qy.FILE_DOCUMENT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "24px", height: "24px" })));
    }
}

function QuoteMessageInput(_a) {
    var className = _a.className, replyingMessage = _a.replyingMessage, onClose = _a.onClose;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.L).stringSet;
    var fileMessage = replyingMessage;
    var sender = replyingMessage === null || replyingMessage === void 0 ? void 0 : replyingMessage.sender;
    var displayFileIcon = ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.b)(replyingMessage) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c)(replyingMessage))
        && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.i)(replyingMessage);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.x)(['sendbird-quote_message_input', className !== null && className !== void 0 ? className : '']) },
        displayFileIcon && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuoteMessageThumbnail, { message: fileMessage })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-quote_message_input__body", style: {
                width: "calc(100% - ".concat(displayFileIcon ? '164px' : '120px', ")"),
                left: displayFileIcon ? '92px' : '40px',
            } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-quote_message_input__body__sender-name", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.CAPTION_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_1 }, "".concat(stringSet.QUOTE_MESSAGE_INPUT__REPLY_TO, " ").concat((sender && sender.nickname) ? sender.nickname : stringSet.NO_NAME)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-quote_message_input__body__message-content", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.BODY_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.ONBACKGROUND_3 },
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.I)(fileMessage) && !(0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.s)(fileMessage) && stringSet.QUOTE_MESSAGE_INPUT__FILE_TYPE_IMAGE,
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.r)(fileMessage) && stringSet.QUOTE_MESSAGE_INPUT__FILE_TYPE__VIDEO,
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.s)(fileMessage) && stringSet.QUOTE_MESSAGE_INPUT__FILE_TYPE_GIF,
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.l)(replyingMessage) && replyingMessage.message,
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.m)(replyingMessage) === _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.U.FILE && (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.b)(fileMessage),
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.c)(replyingMessage)
                    && "".concat(fileMessage.fileInfoList.length, " Photos"),
                (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_1__.i)(replyingMessage) && stringSet.VOICE_MESSAGE)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: "sendbird-quote_message_input__close-button", type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.CLOSE */ .Qy.CLOSE, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.ON_BACKGROUND_2 */ .zo.ON_BACKGROUND_2, width: "24px", height: "24px", onClick: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(replyingMessage); } })));
}


//# sourceMappingURL=QuoteMessageInput.js.map


/***/ }),

/***/ 30156:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReactionBadge; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





var ReactionBadge = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
    var _a = props.className, className = _a === void 0 ? '' : _a, testID = props.testID, children = props.children, _b = props.count, count = _b === void 0 ? '' : _b, _c = props.isAdd, isAdd = _c === void 0 ? false : _c, _d = props.selected, selected = _d === void 0 ? false : _d, _e = props.onClick, onClick = _e === void 0 ? function () { } : _e;
    var getClassNameTail = function () {
        if (selected && !isAdd) {
            return '--selected';
        }
        if (isAdd) {
            return '--is-add';
        }
        return '';
    };
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            "sendbird-reaction-badge".concat(getClassNameTail()),
        ], false).join(' '), "data-testid": testID, role: "button", ref: ref, onClick: onClick, onKeyDown: onClick, onTouchEnd: onClick, tabIndex: 0 },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-reaction-badge__inner" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-reaction-badge__inner__icon" }, children),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: (children && count) ? 'sendbird-reaction-badge__inner__count' : '', type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONBACKGROUND_1 }, count))));
});


//# sourceMappingURL=ReactionBadge.js.map


/***/ }),

/***/ 60090:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReactionButton; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26765);






var ReactionButton = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
    var className = props.className, width = props.width, height = props.height, selected = props.selected, _a = props.dataSbId, dataSbId = _a === void 0 ? '' : _a, testID = props.testID, onClick = props.onClick, children = props.children;
    var onClickHandler = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_2__.u)({
        onLongPress: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_4__.n,
        onClick: onClick,
    }, {
        shouldPreventDefault: true,
        shouldStopPropagation: true,
    });
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            "sendbird-reaction-button".concat(selected ? '--selected' : ''),
        ], false).join(' '), ref: ref, role: "button", style: { width: width, height: height } }, onClickHandler, { tabIndex: 0, "data-sb-id": testID !== null && testID !== void 0 ? testID : dataSbId, "data-testid": testID !== null && testID !== void 0 ? testID : dataSbId }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-reaction-button__inner" }, children)));
});


//# sourceMappingURL=ReactionButton.js.map


/***/ }),

/***/ 78614:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SortByRow; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88071);




var componentClassName = 'sendbird-sort-by-row';
function SortByRow(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, maxItemCount = _a.maxItemCount, itemWidth = _a.itemWidth, itemHeight = _a.itemHeight, children = _a.children;
    if (Array.isArray(children) && children.length > maxItemCount) {
        var result = [];
        for (var i = 0; i < children.length; i += maxItemCount) {
            result.push(react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
                    componentClassName,
                ], false).join(' '), key: (0,_chunks_bundle_Bq93DTET_js__WEBPACK_IMPORTED_MODULE_2__.u)(), style: {
                    width: itemWidth * maxItemCount,
                    height: itemHeight,
                } }, children.slice(i, i + maxItemCount)));
        }
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, result);
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            componentClassName,
        ], false).join(' '), style: {
            width: itemWidth * (Array.isArray(children) ? children.length : 1),
            height: itemHeight,
        } }, children));
}


//# sourceMappingURL=SortByRow.js.map


/***/ }),

/***/ 49754:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ TemplateMessageItemBody; }
/* harmony export */ });
/* unused harmony exports default, replaceVariablesInTemplateString */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19652);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
/* harmony import */ var _FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34498);
/* harmony import */ var _LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64437);
/* harmony import */ var _chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69466);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8978);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99366);
/* harmony import */ var _Loader_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72661);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43822);




















var MessageTemplateWrapper = function (_a) {
    var message = _a.message, templateVersion = _a.templateVersion, templateItems = _a.templateItems;
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_3__.M, { message: message },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_KNrNIKZQ_js__WEBPACK_IMPORTED_MODULE_3__.a, { templateVersion: templateVersion, templateItems: templateItems }));
};

var splitColorVariables = function (colorVariables) {
    var light = {};
    var dark = {};
    for (var key in colorVariables) {
        if (Object.prototype.hasOwnProperty.call(colorVariables, key)) {
            var value = colorVariables[key];
            if (typeof value === 'object' && value !== null) {
                var _a = splitColorVariables(value), nestedLight = _a[0], nestedDark = _a[1];
                light[key] = nestedLight;
                dark[key] = nestedDark;
            }
            else if (typeof value === 'string') {
                var _b = value.split(','), lightColor = _b[0], darkColor = _b[1];
                light[key] = lightColor;
                dark[key] = darkColor || lightColor; // when dark color is not provided, use light color
            }
            else {
                light[key] = value;
                dark[key] = value;
            }
        }
    }
    return [light, dark];
};
function selectColorVariablesByTheme(_a) {
    var colorVariables = _a.colorVariables, theme = _a.theme;
    var _b = splitColorVariables(colorVariables), light = _b[0], dark = _b[1];
    return theme === 'light' ? light : dark;
}

var MessageTemplateErrorBoundary = /** @class */ (function (_super) {
    (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.e)(MessageTemplateErrorBoundary, _super);
    function MessageTemplateErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    MessageTemplateErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    MessageTemplateErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a;
        (_a = this.props.logger) === null || _a === void 0 ? void 0 : _a.error('Error caught by ErrorBoundary: ', error, errorInfo);
    };
    MessageTemplateErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return this.props.fallbackMessage;
        }
        return this.props.children;
    };
    return MessageTemplateErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component));

var flattenObjectHelper = function (currentObject, flattenObject, parentKeyPath) {
    if (parentKeyPath === void 0) { parentKeyPath = ''; }
    for (var _i = 0, _a = Object.entries(currentObject); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var currentKeyPath = parentKeyPath ? "".concat(parentKeyPath, ".").concat(key) : key;
        if (value && typeof value === 'object') {
            flattenObjectHelper(value, flattenObject, currentKeyPath);
        }
        else {
            flattenObject[currentKeyPath] = value;
        }
    }
};
/**
 * Returns flattened object.
 * ex.
 * given { key-1: { key-1.1: 'value-1.1' }, key-2: 'value-2' }
 * returns { key-1.key-1.1: 'value-1.1', key-2: 'value-2' }
 */
function flattenObject(object) {
    var result = {};
    flattenObjectHelper(object, result);
    return result;
}

var TEMPLATE_FETCH_RETRY_BUFFER_TIME_IN_MILLIES = 500; // It takes about 450ms for isError update
var replaceVariablesInTemplateString = function (_a) {
    var template = _a.template, _b = _a.templateData, templateData = _b === void 0 ? {} : _b, colorVariables = _a.colorVariables, theme = _a.theme;
    var selectedThemeColorVariables = {};
    if (colorVariables && theme) {
        selectedThemeColorVariables = selectColorVariablesByTheme({
            colorVariables: colorVariables,
            theme: theme,
        });
    }
    var source = (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({}, templateData), selectedThemeColorVariables);
    var flattenedSource = flattenObject(source);
    var replaced = template;
    Object.entries(flattenedSource).forEach(function (_a) {
        var key = _a[0], val = _a[1];
        var pattern = "\\{".concat(key, "\\}");
        var regex = new RegExp(pattern, 'g');
        replaced = replaced.replace(regex, val);
    });
    return replaced;
};
function TemplateMessageItemBody(_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, message = _a.message, _d = _a.isByMe, isByMe = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? 'light' : _e;
    var templateData = (_b = message.extendedMessagePayload) === null || _b === void 0 ? void 0 : _b[_chunks_bundle_DABR6HKW_js__WEBPACK_IMPORTED_MODULE_14__.i];
    var getFailedBody = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_5__/* .FallbackTemplateMessageItemBody */ .x, { className: className, message: message, isByMe: isByMe });
    };
    if (!(templateData === null || templateData === void 0 ? void 0 : templateData.key)) {
        return getFailedBody();
    }
    var templateKey = templateData.key;
    var globalState = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useSendbirdStateContext */ .A)();
    if (!globalState) {
        return getFailedBody();
    }
    var logger = globalState.config.logger;
    var _f = globalState.utils, getCachedTemplate = _f.getCachedTemplate, updateMessageTemplatesInfo = _f.updateMessageTemplatesInfo;
    var waitingTemplateKeysMap = globalState.stores.appInfoStore.waitingTemplateKeysMap;
    var waitingTemplateKeysMapString = Object.entries(waitingTemplateKeysMap)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, value.requestedAt, value.erroredMessageIds.join(',')].join('-');
    }).join('_');
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(getFilledMessageTemplateItems()), renderData = _g[0], setRenderData = _g[1];
    function findSubstrings(input, matchString) {
        var indices = [];
        var startIndex = 0;
        while ((startIndex = input.indexOf(matchString, startIndex)) !== -1) {
            indices.push({ start: startIndex, end: startIndex + matchString.length });
            startIndex += matchString.length;
        }
        return indices;
    }
    function replaceAtIndices(input, indices, replacement) {
        var result = '';
        var lastIndex = 0;
        indices.forEach(function (_a) {
            var start = _a.start, end = _a.end;
            result += input.slice(lastIndex, start) + replacement;
            lastIndex = end;
        });
        // Add any remaining part of the string after the last match
        result += input.slice(lastIndex);
        return result;
    }
    function replaceReservationKeys(templateString, reservationKey, replacement) {
        var indices = findSubstrings(templateString, reservationKey);
        return replaceAtIndices(templateString, indices, replacement);
    }
    /**
     * Returns filled rootTemplate. Given rootTemplate,
     * 1. replace any reservation key with matching cached template,
     * 2. fill variables and view_variables.
     *
     * Assume below facts:
     * - carousel type template cannot have a carousel typed template in any
     * depth of items.
     * - However, box type template can have a carousel typed template in any
     * depth of items.
     *
     * @param rootTemplate
     */
    function getFilledRootTemplate(rootTemplate) {
        var rootTemplateString = replaceVariablesInTemplateString({
            template: rootTemplate.uiTemplate,
            templateData: templateData.variables,
            colorVariables: rootTemplate.colorVariables,
            theme: theme,
        });
        if (templateData.view_variables) {
            var reservationKeyToItems_1 = {};
            Object.entries(templateData.view_variables).forEach(function (_a) {
                var reservationKey = _a[0], simpleTemplateDataList = _a[1];
                var filledSimpleTemplates = [];
                simpleTemplateDataList.forEach(function (simpleTemplateData) {
                    var simpleTemplateKey = simpleTemplateData === null || simpleTemplateData === void 0 ? void 0 : simpleTemplateData.key;
                    if (simpleTemplateKey) {
                        var cachedTemplate = getCachedTemplate(simpleTemplateKey);
                        if (!cachedTemplate) {
                            logger.error('TemplateMessageItemBody | simple template is expected to be cached: ', simpleTemplateKey);
                        }
                        var items = replaceVariablesInTemplateString({
                            template: cachedTemplate.uiTemplate,
                            templateData: simpleTemplateData.variables,
                            colorVariables: cachedTemplate.colorVariables,
                            theme: theme,
                        });
                        filledSimpleTemplates.push({
                            version: cachedTemplate.version,
                            body: {
                                items: JSON.parse(items),
                            },
                        });
                        reservationKeyToItems_1[reservationKey] = JSON.stringify(filledSimpleTemplates);
                    }
                });
            });
            Object.entries(reservationKeyToItems_1).forEach(function (_a) {
                var reservationKey = _a[0], filledSimpleTemplates = _a[1];
                rootTemplateString = replaceReservationKeys(rootTemplateString, "\"@{".concat(reservationKey, "}\""), filledSimpleTemplates);
            });
        }
        return JSON.parse(rootTemplateString);
    }
    function getFilledMessageTemplateItems() {
        var result = {
            filledMessageTemplateItemsList: [],
            isErrored: false,
        };
        var nonCachedTemplateKeys = [];
        var cachedTemplate = getCachedTemplate(templateKey);
        if (!cachedTemplate) {
            nonCachedTemplateKeys.push(templateKey);
        }
        if (templateData === null || templateData === void 0 ? void 0 : templateData.view_variables) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                Object.entries(templateData.view_variables).forEach(function (_a) {
                    var _ = _a[0], simpleTemplateDataList = _a[1];
                    simpleTemplateDataList.forEach(function (simpleTemplateData) {
                        var simpleTemplateKey = simpleTemplateData === null || simpleTemplateData === void 0 ? void 0 : simpleTemplateData.key;
                        if (simpleTemplateKey
                            && !getCachedTemplate(simpleTemplateKey)
                            && !nonCachedTemplateKeys.includes(simpleTemplateKey)) {
                            nonCachedTemplateKeys.push(simpleTemplateKey);
                        }
                    });
                });
            }
            catch (e) {
                logger.error('TemplateMessageItemBody | received view_variables is malformed: ', templateData);
                result.isErrored = true;
                return result;
            }
        }
        try {
            if (nonCachedTemplateKeys.length > 0) {
                tryFetchTemplateByKey(nonCachedTemplateKeys);
            }
            else if (cachedTemplate) {
                var items = getFilledRootTemplate(cachedTemplate);
                result.filledMessageTemplateItemsList.push({
                    version: cachedTemplate.version,
                    items: items,
                });
            }
        }
        catch (e) {
            logger.error('TemplateMessageItemBody | fetching non-cached templates by given template keys failed: ', e);
            result.isErrored = true;
        }
        return result;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (!renderData.isErrored && renderData.filledMessageTemplateItemsList.length === 0) {
            var newRenderData = getFilledMessageTemplateItems();
            setRenderData(newRenderData);
        }
    }, [templateData.key, waitingTemplateKeysMapString]);
    /**
     * Attempt GET template by key IFF one of below cases is met:
     * 1. This is the first GET call for the template key.
     * 2. Minimum buffer time has passed since the previous GET error.
     */
    function tryFetchTemplateByKey(templateKeys) {
        if (templateKeys.length > 0) {
            var waitingTemplateKeyDataList_1 = [];
            templateKeys.forEach(function (templateKey) {
                var waitingTemplateKeyData = waitingTemplateKeysMap[templateKey];
                waitingTemplateKeyDataList_1.push([templateKey, waitingTemplateKeyData]);
            });
            var requestedAt_1 = Date.now();
            var keysToUpdate_1 = [];
            waitingTemplateKeyDataList_1.forEach(function (_a) {
                var templateKey = _a[0], waitingTemplateKeyData = _a[1];
                if (!waitingTemplateKeyData
                    || (waitingTemplateKeyData.erroredMessageIds.indexOf(message.messageId) === -1
                        && requestedAt_1 > waitingTemplateKeyData.requestedAt + TEMPLATE_FETCH_RETRY_BUFFER_TIME_IN_MILLIES)) {
                    keysToUpdate_1.push(templateKey);
                }
                else if (waitingTemplateKeyData.erroredMessageIds.indexOf(message.messageId) > -1) {
                    throw new Error("TemplateMessageItemBody | fetching template key ".concat(templateKey, " for messageId: ").concat(message.messageId, " has failed."));
                }
            });
            if (keysToUpdate_1.length > 0) {
                updateMessageTemplatesInfo(keysToUpdate_1, message.messageId, requestedAt_1);
            }
        }
    }
    if (renderData.isErrored) {
        return getFailedBody();
    }
    if (renderData.filledMessageTemplateItemsList.length === 0) {
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(_LoadingTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_6__/* .LoadingTemplateMessageItemBody */ .w, { className: className, isByMe: isByMe });
    }
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.x)([
            className,
            isByMe ? 'outgoing' : 'incoming',
            'sendbird-template-message-item-body',
        ]) },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(MessageTemplateErrorBoundary, { fallbackMessage: react__WEBPACK_IMPORTED_MODULE_1__.createElement(_FallbackTemplateMessageItemBody_tsx_js__WEBPACK_IMPORTED_MODULE_5__/* .FallbackTemplateMessageItemBody */ .x, { className: className, message: message, isByMe: isByMe }), logger: logger }, renderData.filledMessageTemplateItemsList.map(function (filledMessageTemplateItem, i) {
            var _a;
            return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(MessageTemplateWrapper, { key: i, message: message, templateVersion: (_a = filledMessageTemplateItem.version) !== null && _a !== void 0 ? _a : 0, templateItems: filledMessageTemplateItem.items }));
        }))));
}


//# sourceMappingURL=TemplateMessageItemBody.js.map


/***/ }),

/***/ 21790:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21112);




var TextButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.color, color = _c === void 0 ? _chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__.C.ONBACKGROUND_1 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.disableUnderline, disableUnderline = _e === void 0 ? false : _e, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f, children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            (0,_chunks_bundle_BL3yUpTV_js__WEBPACK_IMPORTED_MODULE_2__.c)(color),
            disableUnderline ? 'sendbird-textbutton--not-underline' : 'sendbird-textbutton',
            disabled ? 'sendbird-textbutton--disabled' : '',
        ], false).join(' '), role: "button", tabIndex: 0, onClick: function (e) { return onClick(e); }, onKeyPress: function (e) { return onClick(e); } }, children));
};


//# sourceMappingURL=TextButton.js.map


/***/ }),

/***/ 50206:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextMessageItemBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1165);
/* harmony import */ var _chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1277);
/* harmony import */ var _chunks_bundle_CXiD3Is4_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(16423);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8978);
/* harmony import */ var _Message_context_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23012);
/* harmony import */ var _MentionLabel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81823);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16167);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73935);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78614);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71091);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29515);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13462);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(46776);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63507);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26765);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(88569);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(90832);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(41238);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(80031);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(82314);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4399);
/* harmony import */ var _LinkLabel_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(40286);










































function TextMessageItemBody(_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, message = _a.message, _d = _a.isByMe, isByMe = _d === void 0 ? false : _d, _e = _a.mouseHover, mouseHover = _e === void 0 ? false : _e, _f = _a.isMentionEnabled, isMentionEnabled = _f === void 0 ? false : _f, _g = _a.isReactionEnabled, isReactionEnabled = _g === void 0 ? false : _g, _h = _a.isMarkdownEnabled, isMarkdownEnabled = _h === void 0 ? false : _h;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    var isMessageMentioned = isMentionEnabled
        && (message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate)
        && message.mentionedMessageTemplate.length > 0
        && (message === null || message === void 0 ? void 0 : message.mentionedUsers)
        && message.mentionedUsers.length > 0;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var _a;
        if (isMessageMentioned) {
            return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_4__.t)({
                mentionedUsers: (_a = message === null || message === void 0 ? void 0 : message.mentionedUsers) !== null && _a !== void 0 ? _a : undefined,
                messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
                includeMarkdown: isMarkdownEnabled,
            });
        }
        return (0,_chunks_bundle_D7JevDoE_js__WEBPACK_IMPORTED_MODULE_4__.t)({
            messageText: message === null || message === void 0 ? void 0 : message.message,
            includeMarkdown: isMarkdownEnabled,
        });
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_1 },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.x)([
                className,
                _chunks_bundle_CXiD3Is4_js__WEBPACK_IMPORTED_MODULE_30__.T,
                isByMe ? 'outgoing' : 'incoming',
                mouseHover ? 'mouse-hover' : '',
                (isReactionEnabled && ((_b = message === null || message === void 0 ? void 0 : message.reactions) === null || _b === void 0 ? void 0 : _b.length) > 0) ? 'reactions' : '',
            ]) },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_DjfGQ_DS_js__WEBPACK_IMPORTED_MODULE_5__.T, { tokens: tokens }),
            (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.d)(message) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-text-message-item-body__message edited", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONCONTENT_2 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_2 }, " ".concat(stringSet.MESSAGE_EDITED, " "))))));
}


//# sourceMappingURL=TextMessageItemBody.js.map


/***/ }),

/***/ 68873:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreadReplies$1; }
/* harmony export */ });
/* unused harmony export ThreadReplies */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82314);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65614);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61448);











function ThreadReplies(_a, ref) {
    var _b;
    var className = _a.className, threadInfo = _a.threadInfo, onClick = _a.onClick;
    var _c = threadInfo.mostRepliedUsers, mostRepliedUsers = _c === void 0 ? [] : _c, replyCount = threadInfo.replyCount;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_4__.u)().stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-thread-replies ".concat(className), role: "button", onClick: function (e) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e === null || e === void 0 ? void 0 : e.stopPropagation();
        }, onKeyDown: function (e) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e === null || e === void 0 ? void 0 : e.stopPropagation();
        }, ref: ref },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-thread-replies__user-profiles" },
            mostRepliedUsers.slice(0, 4).map(function (user) {
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { key: user.userId, className: "sendbird-ui-thread-replies__user-profiles__avatar", src: user === null || user === void 0 ? void 0 : user.profileUrl, alt: "user profile", width: "20px", height: "20px" }));
            }),
            (mostRepliedUsers === null || mostRepliedUsers === void 0 ? void 0 : mostRepliedUsers.length) >= 5 && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-thread-replies__user-profiles__avatar" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: "sendbird-ui-thread-replies__user-profiles__avatar__image", src: (_b = mostRepliedUsers === null || mostRepliedUsers === void 0 ? void 0 : mostRepliedUsers[4]) === null || _b === void 0 ? void 0 : _b.profileUrl, alt: "user profile", width: "20px", height: "20px" }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-thread-replies__user-profiles__avatar__cover" }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-ui-thread-replies__user-profiles__avatar__plus" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.PLUS */ .Qy.PLUS, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.WHITE */ .zo.WHITE, width: "16px", height: "16px" }))))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.L, { className: "sendbird-ui-thread-replies__reply-counts", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_3__.b.PRIMARY }, replyCount === 1
            ? "".concat(replyCount, " ").concat(stringSet.CHANNEL__THREAD_REPLY)
            : "".concat(replyCount > 99 ? stringSet.CHANNEL__THREAD_OVER_MAX : replyCount, " ").concat(stringSet.CHANNEL__THREAD_REPLIES)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { className: "sendbird-ui-thread-replies__icon", type: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.CHEVRON_RIGHT */ .Qy.CHEVRON_RIGHT, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.PRIMARY */ .zo.PRIMARY, width: "16px", height: "16px" })));
}
var ThreadReplies$1 = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ThreadReplies);


//# sourceMappingURL=ThreadReplies.js.map


/***/ }),

/***/ 48845:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThumbnailMessageItemBody; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43822);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4399);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8627);
/* harmony import */ var _chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78828);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26765);















function ThumbnailMessageItemBody(_a) {
    var _b, _c;
    var _d = _a.className, className = _d === void 0 ? '' : _d, message = _a.message, _e = _a.isByMe, isByMe = _e === void 0 ? false : _e, _f = _a.mouseHover, mouseHover = _f === void 0 ? false : _f, _g = _a.isReactionEnabled, isReactionEnabled = _g === void 0 ? false : _g, _h = _a.showFileViewer, showFileViewer = _h === void 0 ? _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.n : _h, _j = _a.style, style = _j === void 0 ? {} : _j;
    var thumbnailUrl = (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.c)(message);
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), imageRendered = _k[0], setImageRendered = _k[1];
    var onClickHandler = (0,_chunks_bundle_CruP9bVM_js__WEBPACK_IMPORTED_MODULE_5__.u)({
        onLongPress: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_9__.n,
        onClick: function () {
            if ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.q)(message)) {
                showFileViewer === null || showFileViewer === void 0 ? void 0 : showFileViewer(true);
            }
        },
    });
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__._)({ className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.x)([
            className,
            'sendbird-thumbnail-message-item-body',
            isByMe ? 'outgoing' : 'incoming',
            mouseHover ? 'mouse-hover' : '',
            (isReactionEnabled && ((_c = (_b = message.reactions) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0) ? 'reactions' : '',
        ]) }, onClickHandler),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { className: "sendbird-thumbnail-message-item-body__thumbnail", url: thumbnailUrl || (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.g)(message), alt: (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.a)(message), width: (style === null || style === void 0 ? void 0 : style.width) || '360px', height: (style === null || style === void 0 ? void 0 : style.height) || '270px', onLoad: function () { setImageRendered(true); }, placeHolder: function (_a) {
                var style = _a.style;
                return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thumbnail-message-item-body__placeholder", style: style }));
            } }),
        ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.r)(message) && !thumbnailUrl) && !imageRendered && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("video", { className: "sendbird-thumbnail-message-item-body__video" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("source", { src: (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.g)(message), type: (0,_chunks_bundle_oZLTNsQY_js__WEBPACK_IMPORTED_MODULE_6__.a)(message) }))),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thumbnail-message-item-body__image-cover" }),
        ((0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.r)(message) || (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.s)(message)) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thumbnail-message-item-body__icon-wrapper" },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-thumbnail-message-item-body__icon-wrapper__icon" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { type: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_4__.r)(message) ? _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.PLAY */ .Qy.PLAY : _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes.GIF */ .Qy.GIF, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_2__/* .IconColors.THUMBNAIL_ICON */ .zo.THUMBNAIL_ICON, width: "34px", height: "34px" }))))));
}


//# sourceMappingURL=ThumbnailMessageItemBody.js.map


/***/ }),

/***/ 76886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61448);





function Tooltip(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.children, children = _c === void 0 ? '' : _c;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-tooltip',
        ], false).join(' ') },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.L, { className: "sendbird-tooltip__text", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_2__.b.ONCONTENT_1 }, children)));
}


//# sourceMappingURL=Tooltip.js.map


/***/ }),

/***/ 32080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TooltipWrapper; }
/* harmony export */ });
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var SPACE_FROM_TRIGGER = 8;
function TooltipWrapper(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, hoverTooltip = _a.hoverTooltip;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showHoverTooltip = _c[0], setShowHoverTooltip = _c[1];
    var childrenRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)((0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([], (Array.isArray(className) ? className : [className]), true), [
            'sendbird-tooltip-wrapper',
        ], false).join(' '), onMouseOver: function () { setShowHoverTooltip(true); }, onFocus: function () { setShowHoverTooltip(true); }, onMouseOut: function () { setShowHoverTooltip(false); }, onBlur: function () { setShowHoverTooltip(false); } },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-tooltip-wrapper__children", ref: childrenRef }, children),
        showHoverTooltip && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-tooltip-wrapper__hover-tooltip", style: { bottom: "calc(100% + ".concat(SPACE_FROM_TRIGGER, "px)") } },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-tooltip-wrapper__hover-tooltip__inner" },
                react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: "sendbird-tooltip-wrapper__hover-tooltip__inner__tooltip-container", style: { left: childrenRef.current ? "calc(".concat(childrenRef.current.offsetWidth / 2, "px - 50%)") : undefined } }, hoverTooltip))))));
}


//# sourceMappingURL=TooltipWrapper.js.map


/***/ }),

/***/ 10765:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TypingIndicatorBubble; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4399);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43822);








var TypingDots = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'typing-dots-container' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null)));
};

var AVATAR_BORDER_SIZE = 2;
var AVATAR_DIAMETER_WITHOUT_BORDER = 28;
var AVATAR_DIAMETER = AVATAR_DIAMETER_WITHOUT_BORDER + (AVATAR_BORDER_SIZE * 2);
var LEFT_GAP = 24;
var MAX_PROFILES_COUNT = 3;
var LEFT_FOR_BORDER = AVATAR_BORDER_SIZE;
var AvatarStack = function (props) {
    var sources = props.sources, max = props.max;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        " ",
        sources.slice(0, max).map(function (src, index) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: 'sendbird-message-content__left__avatar multiple', src: src || '', key: "avatar_stack_item_".concat(src), 
            // TODO: Divide getting profileUrl logic to utils
            width: "".concat(AVATAR_DIAMETER_WITHOUT_BORDER, "px"), height: "".concat(AVATAR_DIAMETER_WITHOUT_BORDER, "px"), zIndex: index, left: "".concat(index * LEFT_GAP - LEFT_FOR_BORDER, "px") })); }),
        " "));
};
var TypingIndicatorBubbleAvatar = function (props) {
    var typingMembers = props.typingMembers;
    var membersCount = typingMembers.length;
    var displayCount = Math.min(membersCount, 4);
    var hiddenCount = membersCount - MAX_PROFILES_COUNT;
    var superImposedWidth = ((displayCount - 1) * (AVATAR_DIAMETER - LEFT_GAP));
    var rightPaddingSize = 12;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-content__left incoming', style: {
            minWidth: (displayCount * AVATAR_DIAMETER) - superImposedWidth + rightPaddingSize,
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(AvatarStack, { sources: typingMembers.map(function (member) { return member.profileUrl; }), max: MAX_PROFILES_COUNT }),
        hiddenCount > 0
            ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.A, { className: 'sendbird-message-content__left__avatar multiple', 
                // TODO: Divide getting profileUrl logic to utils
                width: "".concat(AVATAR_DIAMETER_WITHOUT_BORDER, "px"), height: "".concat(AVATAR_DIAMETER_WITHOUT_BORDER, "px"), zIndex: MAX_PROFILES_COUNT, left: "".concat(MAX_PROFILES_COUNT * LEFT_GAP, "px"), customDefaultComponent: function (_a) {
                    var width = _a.width, height = _a.height;
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_1__.a, { width: width, height: height, text: "+".concat(hiddenCount) }));
                } })
            : null));
};
var TypingIndicatorBubble = function (props) {
    var typingMembers = props.typingMembers, handleScroll = props.handleScroll;
    if (typingMembers.length === 0)
        return null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
        // Keep the scrollBottom value after fetching new message list
        handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll(true);
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-content incoming', style: { marginBottom: '2px' } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(TypingIndicatorBubbleAvatar, { typingMembers: typingMembers }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: 'sendbird-message-content__middle' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(TypingDots, null)));
};


//# sourceMappingURL=TypingIndicatorBubble.js.map


/***/ }),

/***/ 33709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnknownMessageItemBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61448);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8978);












function UnknownMessageItemBody(_a) {
    var _b;
    var className = _a.className, message = _a.message, _c = _a.isByMe, isByMe = _c === void 0 ? false : _c, _d = _a.mouseHover, mouseHover = _d === void 0 ? false : _d, _e = _a.isReactionEnabled, isReactionEnabled = _e === void 0 ? false : _e;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_3__.L).stringSet;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_2__.x)([
            className !== null && className !== void 0 ? className : '',
            'sendbird-unknown-message-item-body',
            isByMe ? 'outgoing' : 'incoming',
            mouseHover ? 'mouse-hover' : '',
            (isReactionEnabled && ((_b = message === null || message === void 0 ? void 0 : message.reactions) === null || _b === void 0 ? void 0 : _b.length) > 0) ? 'reactions' : '',
        ]) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-unknown-message-item-body__header", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_1 }, stringSet.UNKNOWN__UNKNOWN_MESSAGE_TYPE),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.L, { className: "sendbird-unknown-message-item-body__description", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.a.BODY_1, color: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONCONTENT_2 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_1__.b.ONBACKGROUND_2 }, stringSet.UNKNOWN__CANNOT_READ_MESSAGE)));
}


//# sourceMappingURL=UnknownMessageItemBody.js.map


/***/ }),

/***/ 56842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ UserListItem; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6623);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26765);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16167);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46776);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82314);
/* harmony import */ var _MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67412);
/* harmony import */ var _Checkbox_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10856);
/* harmony import */ var _UserProfile_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(13462);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(81715);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73935);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88569);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43822);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8978);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(61448);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(78614);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4399);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(80031);






































function UserListItem(_a) {
    var user = _a.user, channel = _a.channel, _b = _a.className, className = _b === void 0 ? undefined : _b, checked = _a.checked, checkBox = _a.checkBox, isOperator = _a.isOperator, disabled = _a.disabled, disableMessaging = _a.disableMessaging, action = _a.action, onChange = _a.onChange, _c = _a.avatarSize, avatarSize = _c === void 0 ? '40px' : _c, onClick = _a.onClick, onUserAvatarClick = _a.onUserAvatarClick, renderListItemMenu = _a.renderListItemMenu, _d = _a.size, size = _d === void 0 ? 'normal' : _d;
    var operator = isOperator !== null && isOperator !== void 0 ? isOperator : (user === null || user === void 0 ? void 0 : user.role) === 'operator';
    var uniqueKey = user.userId;
    var actionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var parentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var avatarRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _e = (0,_chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_11__.u)(), disableUserProfile = _e.disableUserProfile, renderUserProfile = _e.renderUserProfile;
    var stringSet = (0,_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_7__.u)().stringSet;
    var config = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_10__/* .useSendbirdStateContext */ .A)().config;
    var currentUser = config.userId;
    var itemClassName = size === 'small' ? 'sendbird-user-list-item--small' : 'sendbird-user-list-item';
    var avatarClassName = size === 'small' ? 'sendbird-user-list-item--small__avatar' : 'sendbird-user-list-item__avatar';
    var titleClassName = size === 'small' ? 'sendbird-user-list-item--small__title' : 'sendbird-user-list-item__title';
    var subtitleClassName = size === 'small' ? 'sendbird-user-list-item--small__subtitle' : 'sendbird-user-list-item__subtitle';
    var checkboxClassName = size === 'small' ? 'sendbird-user-list-item--small__checkbox' : 'sendbird-user-list-item__checkbox';
    var actionClassName = size === 'small' ? 'sendbird-user-list-item--small__action' : 'sendbird-user-list-item__action';
    var operatorClassName = size === 'small' ? 'sendbird-user-list-item--small__operator' : 'sendbird-user-list-item__operator';
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_27__.c.apply(void 0, (0,_chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__.c)([itemClassName], (Array.isArray(className) ? className : [className]), false)), ref: parentRef },
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_9__.C, { menuTrigger: function (toggleDropdown) { return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null,
                react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_12__.A, { className: avatarClassName, ref: avatarRef, src: (user === null || user === void 0 ? void 0 : user.profileUrl) || (user === null || user === void 0 ? void 0 : user.plainProfileUrl) || '', width: avatarSize, height: avatarSize, onClick: function () {
                        var _a;
                        if (!disableUserProfile) {
                            toggleDropdown();
                            (_a = (onUserAvatarClick !== null && onUserAvatarClick !== void 0 ? onUserAvatarClick : onClick)) === null || _a === void 0 ? void 0 : _a();
                        }
                    } }),
                (user === null || user === void 0 ? void 0 : user.isMuted) && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MutedAvatarOverlay_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, { height: (0,_chunks_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_28__.p)(avatarSize), width: (0,_chunks_bundle_BdwvjJsK_js__WEBPACK_IMPORTED_MODULE_28__.p)(avatarSize) })))); }, menuItems: function (closeDropdown) { return (renderUserProfile
                ? renderUserProfile({
                    user: user,
                    currentUserId: currentUser !== null && currentUser !== void 0 ? currentUser : '',
                    close: closeDropdown,
                    avatarRef: avatarRef,
                })
                : (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_9__.b, { openLeft: true, parentRef: avatarRef, parentContainRef: avatarRef, closeDropdown: closeDropdown, style: { paddingTop: '0px', paddingBottom: '0px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__.createElement(_UserProfile_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, { disableMessaging: disableMessaging, user: user, currentUserId: currentUser, onSuccess: closeDropdown })))); } }),
        react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: titleClassName, type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.SUBTITLE_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_1 },
            user.nickname || stringSet.NO_NAME,
            (currentUser === user.userId) && (stringSet.CHANNEL_SETTING__MEMBERS__YOU)),
        !user.nickname && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: subtitleClassName, type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.CAPTION_3, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_2 }, user.userId)),
        checkBox && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("label", { className: checkboxClassName, htmlFor: uniqueKey },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Checkbox_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, { id: uniqueKey, checked: checked, disabled: disabled, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event); } }))),
        operator && (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.L, { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_27__.c)(operatorClassName, checkBox && 'checkbox'), type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.a.SUBTITLE_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_16__.b.ONBACKGROUND_2 }, stringSet.LABEL__OPERATOR)),
        !checkBox && !renderListItemMenu && action && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: actionClassName, ref: actionRef }, action({ actionRef: actionRef, parentRef: parentRef }))),
        !checkBox && renderListItemMenu && (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: actionClassName, ref: actionRef }, renderListItemMenu({ channel: channel, user: user })))));
}


//# sourceMappingURL=UserListItem.js.map


/***/ }),

/***/ 13462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserProfile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46776);
/* harmony import */ var _sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22284);
/* harmony import */ var _chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82314);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99366);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88569);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61448);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29515);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78614);
/* harmony import */ var _chunks_bundle_DRlnZqdp_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(80031);
/* harmony import */ var _ImageRenderer_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(4399);



































function UserProfile(_a) {
    var _b, _c;
    var user = _a.user, currentUserId = _a.currentUserId, _d = _a.disableMessaging, disableMessaging = _d === void 0 ? false : _d, onSuccess = _a.onSuccess;
    var store = (0,_useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_7__/* .useSendbirdStateContext */ .A)();
    var createChannel = (0,_sendbirdSelectors_js__WEBPACK_IMPORTED_MODULE_3__/* .getCreateGroupChannel */ .Lo)(store);
    var logger = (_b = store === null || store === void 0 ? void 0 : store.config) === null || _b === void 0 ? void 0 : _b.logger;
    var stringSet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_1__.L).stringSet;
    var currentUserId_ = currentUserId || ((_c = store === null || store === void 0 ? void 0 : store.config) === null || _c === void 0 ? void 0 : _c.userId);
    var onStartDirectMessage = (0,_chunks_bundle_Bv8KtnvF_js__WEBPACK_IMPORTED_MODULE_2__.u)().onStartDirectMessage;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird__user-profile" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", { className: "sendbird__user-profile-avatar" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_52W7LREX_js__WEBPACK_IMPORTED_MODULE_4__.A, { height: "80px", width: "80px", src: user === null || user === void 0 ? void 0 : user.profileUrl })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", { className: "sendbird__user-profile-name" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.H_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_1 }, (user === null || user === void 0 ? void 0 : user.nickname) || stringSet.NO_NAME)),
        ((user === null || user === void 0 ? void 0 : user.userId) !== currentUserId_) && !disableMessaging && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", { className: "sendbird__user-profile-message" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { type: _Button_js__WEBPACK_IMPORTED_MODULE_6__/* .ButtonTypes.SECONDARY */ .qh.SECONDARY, onClick: function () {
                    // Create 1:1 channel
                    var params = {
                        isDistinct: false,
                        invitedUserIds: (user === null || user === void 0 ? void 0 : user.userId) ? [user === null || user === void 0 ? void 0 : user.userId] : [],
                        operatorUserIds: [currentUserId_],
                    };
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    createChannel(params)
                        .then(function (groupChannel) {
                        logger.info('UserProfile, channel create', groupChannel);
                        onStartDirectMessage === null || onStartDirectMessage === void 0 ? void 0 : onStartDirectMessage(groupChannel);
                    });
                } }, stringSet.USER_PROFILE__MESSAGE))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird__user-profile-separator" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", { className: "sendbird__user-profile-userId" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { className: "sendbird__user-profile-userId--label", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.CAPTION_2, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_2 }, stringSet.USER_PROFILE__USER_ID),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.L, { className: "sendbird__user-profile-userId--value", type: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.a.BODY_1, color: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_5__.b.ONBACKGROUND_1 }, user === null || user === void 0 ? void 0 : user.userId))));
}


//# sourceMappingURL=UserProfile.js.map


/***/ }),

/***/ 71612:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoiceMessageItemBody; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ProgressBar_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68962);
/* harmony import */ var _VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32177);
/* harmony import */ var _PlaybackTime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28464);
/* harmony import */ var _Loader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72661);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43822);
/* harmony import */ var _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99366);
/* harmony import */ var _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90832);
/* harmony import */ var _chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(80360);
/* harmony import */ var _chunks_bundle_NL8iE1lF_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17693);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65614);
/* harmony import */ var _chunks_bundle_D_9RmNe_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6623);
/* harmony import */ var _utils_message_getOutgoingMessageState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8978);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73935);
/* harmony import */ var _chunks_bundle_PhH_XFy_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59587);
/* harmony import */ var _chunks_bundle_BPcbf_pM_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61448);
/* harmony import */ var _chunks_bundle_R3uJ_0BB_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26765);
/* harmony import */ var _IconButton_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29515);
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88569);
/* harmony import */ var _sendbird_uikit_tools__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63507);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71091);
/* harmony import */ var _useSendbirdStateContext_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41238);
/* harmony import */ var _chunks_bundle_ml_PByBw_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16167);
/* harmony import */ var _SortByRow_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78614);

































var VoiceMessageItemBody = function (_a) {
    var _b;
    var className = _a.className, message = _a.message, channelUrl = _a.channelUrl, _c = _a.isByMe, isByMe = _c === void 0 ? false : _c, _d = _a.isReactionEnabled, isReactionEnabled = _d === void 0 ? false : _d;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), usingReaction = _e[0], setUsingReaction = _e[1];
    var _f = (0,_VoicePlayer_useVoicePlayer_js__WEBPACK_IMPORTED_MODULE_2__/* .useVoicePlayer */ .O)({
        channelUrl: channelUrl,
        key: "".concat(message === null || message === void 0 ? void 0 : message.messageId),
        audioFileUrl: message === null || message === void 0 ? void 0 : message.url,
        audioFileMimeType: message === null || message === void 0 ? void 0 : message.type,
    }), play = _f.play, 
    // do not pause on unmount, because on desktop layout
    // the component can be paused when it is played from
    // channel and same message is unmounted from the thread
    pause = _f.pause, _g = _f.playbackTime, playbackTime = _g === void 0 ? 0 : _g, duration = _f.duration, _h = _f.playingStatus, playingStatus = _h === void 0 ? _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__.V.IDLE : _h;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var _a;
        if (isReactionEnabled && ((_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setUsingReaction(true);
        }
        else {
            setUsingReaction(false);
        }
    }, [isReactionEnabled, (_b = message === null || message === void 0 ? void 0 : message.reactions) === null || _b === void 0 ? void 0 : _b.length]);
    var progressBarMaxSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var _a;
        var DEFAULT_MAX_SIZE = 1;
        if (message === null || message === void 0 ? void 0 : message.metaArrays) {
            var duration_1 = (_a = message === null || message === void 0 ? void 0 : message.metaArrays.find(function (metaArray) { return metaArray.key === 'KEY_VOICE_MESSAGE_DURATION'; })) === null || _a === void 0 ? void 0 : _a.value[0];
            return duration_1 ? parseInt(duration_1) : DEFAULT_MAX_SIZE;
        }
        return DEFAULT_MAX_SIZE;
    }, [message === null || message === void 0 ? void 0 : message.metaArrays]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_chunks_bundle_BHC96gO0_js__WEBPACK_IMPORTED_MODULE_23__.c)('sendbird-voice-message-item-body', className, usingReaction && 'is-reactions-contained') },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProgressBar_js__WEBPACK_IMPORTED_MODULE_1__/* .ProgressBar */ .ko, { className: "sendbird-voice-message-item-body__progress-bar", maxSize: duration || progressBarMaxSize, currentSize: playbackTime, colorType: isByMe ? _ProgressBar_js__WEBPACK_IMPORTED_MODULE_1__/* .ProgressBarColorTypes.PRIMARY */ .v1.PRIMARY : _ProgressBar_js__WEBPACK_IMPORTED_MODULE_1__/* .ProgressBarColorTypes.GRAY */ .v1.GRAY }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button" },
            (playingStatus === _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__.V.IDLE || playingStatus === _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__.V.PAUSED) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button__button", onClick: play },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { width: "18px", height: "18px", type: _Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconTypes.PLAY */ .Qy.PLAY, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconColors.PRIMARY */ .zo.PRIMARY }))),
            playingStatus === _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__.V.PREPARING && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Loader_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { width: "22.2px", height: "22.2px" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { width: "22.2px", height: "22.2px", type: _Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconTypes.SPINNER */ .Qy.SPINNER, fillColor: _Icon_js__WEBPACK_IMPORTED_MODULE_5__/* .IconColors.PRIMARY_2 */ .zo.PRIMARY_2 }))),
            playingStatus === _chunks_bundle_BMJP8SSM_js__WEBPACK_IMPORTED_MODULE_7__.V.PLAYING && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button__button", onClick: function () { pause(); } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button__button__pause" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button__button__pause__inner" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "sendbird-voice-message-item-body__status-button__button__pause__inner" }))))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PlaybackTime_js__WEBPACK_IMPORTED_MODULE_3__/* .PlaybackTime */ .S, { className: "sendbird-voice-message-item-body__playback-time", time: progressBarMaxSize - playbackTime, labelType: _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.a.BODY_1, labelColor: isByMe ? _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONCONTENT_1 : _chunks_bundle_ixnsp7Bg_js__WEBPACK_IMPORTED_MODULE_6__.b.ONBACKGROUND_1 })));
};


//# sourceMappingURL=VoiceMessageItemBody.js.map


/***/ }),

/***/ 41238:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useSendbirdStateContext; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _withSendbird_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71091);
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65614);




/**
 * Example:
 * const MyComponent = () => {
 *  const context = useSendbirdStateContext();
 *  const sdk = sendbirdSelectors.getSdk(context);
 *  return (<div>...</div>);
 * }
 */
var NO_CONTEXT_ERROR = 'No sendbird state value available. Make sure you are rendering `<SendbirdProvider>` at the top of your app.';
function useSendbirdStateContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_withSendbird_js__WEBPACK_IMPORTED_MODULE_1__/* .SendbirdSdkContext */ .N);
    if (!context)
        throw new Error(NO_CONTEXT_ERROR);
    return context;
}


//# sourceMappingURL=useSendbirdStateContext.js.map


/***/ }),

/***/ 8978:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getOutgoingMessageState; },
/* harmony export */   "o": function() { return /* binding */ OutgoingMessageStates; }
/* harmony export */ });
var OutgoingMessageStates;
(function (OutgoingMessageStates) {
    OutgoingMessageStates["NONE"] = "NONE";
    OutgoingMessageStates["PENDING"] = "PENDING";
    OutgoingMessageStates["SENT"] = "SENT";
    OutgoingMessageStates["FAILED"] = "FAILED";
    OutgoingMessageStates["DELIVERED"] = "DELIVERED";
    OutgoingMessageStates["READ"] = "READ";
})(OutgoingMessageStates || (OutgoingMessageStates = {}));
var getOutgoingMessageState = function (channel, message) {
    var _a, _b, _c, _d, _e;
    if (!message || !('sendingStatus' in message))
        return OutgoingMessageStates.NONE;
    if (message.sendingStatus === 'pending') {
        return OutgoingMessageStates.PENDING;
    }
    if (message.sendingStatus === 'failed') {
        return OutgoingMessageStates.FAILED;
    }
    if ((_a = channel === null || channel === void 0 ? void 0 : channel.isGroupChannel) === null || _a === void 0 ? void 0 : _a.call(channel)) {
        /* GroupChannel only */
        if (((_c = (_b = channel).getUnreadMemberCount) === null || _c === void 0 ? void 0 : _c.call(_b, message)) === 0) {
            return OutgoingMessageStates.READ;
        }
        else if (((_e = (_d = channel).getUndeliveredMemberCount) === null || _e === void 0 ? void 0 : _e.call(_d, message)) === 0) {
            return OutgoingMessageStates.DELIVERED;
        }
    }
    if (message.sendingStatus === 'succeeded') {
        return OutgoingMessageStates.SENT;
    }
    return OutgoingMessageStates.NONE;
};


//# sourceMappingURL=getOutgoingMessageState.js.map


/***/ }),

/***/ 71091:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SendbirdSdkContext; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _chunks_bundle_XQWyv823_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65614);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var SendbirdSdkContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
/**
 * @deprecated This function is deprecated. Use `useSendbirdStateContext` instead.
 * */
var withSendbirdContext = function (OriginalComponent, mapStoreToProps) {
    var ContextAwareComponent = function (props) { return (React__default.createElement(SendbirdSdkContext.Consumer, null, function (context) {
        if (mapStoreToProps && typeof mapStoreToProps !== 'function') {
            // eslint-disable-next-line no-console
            console.warn('Second parameter to withSendbirdContext must be a pure function');
        }
        var mergedProps = (mapStoreToProps && typeof mapStoreToProps === 'function')
            ? __assign(__assign({}, mapStoreToProps(context)), props) : __assign(__assign({}, context), props);
        return React__default.createElement(OriginalComponent, __assign({}, mergedProps));
    })); };
    var componentName = OriginalComponent.displayName || OriginalComponent.name || 'Component';
    ContextAwareComponent.displayName = "SendbirdAware".concat(componentName);
    return ContextAwareComponent;
};


//# sourceMappingURL=withSendbird.js.map


/***/ }),

/***/ 63507:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ UIKitConfigProvider; },
  "bd": function() { return /* reexport */ useAsyncEffect_useAsyncEffect; },
  "A0": function() { return /* reexport */ useAsyncLayoutEffect; },
  "l7": function() { return /* reexport */ useGroupChannelHandler_useGroupChannelHandler; },
  "Tz": function() { return /* reexport */ useGroupChannelMessages; },
  "B7": function() { return /* reexport */ useIIFE; },
  "zS": function() { return /* reexport */ usePreservedCallback_usePreservedCallback; },
  "Jf": function() { return /* reexport */ useUIKitConfig; }
});

// UNUSED EXPORTS: UIKitConfigContext, applicationAttributes, initialConfig, initialRemoteConfig, premiumFeatures, sbuConstants, useForceUpdate, useGroupChannelList, useGroupChannelThreadMessages, useUniqId

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/constants/applicationAttributes.js
const applicationAttributes = {
    reactions: 'reactions',
    message_search_v3: 'message_search_v3',
    enable_og_tag: 'enable_og_tag',
    enable_message_threading: 'enable_message_threading',
    allow_broadcast_channel: 'allow_broadcast_channel',
    allow_super_group_channel: 'allow_super_group_channel',
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/constants/premiumFeatures.js
const premiumFeatures_premiumFeatures = {
    reactions: 'reactions',
    moderation_group: 'moderation_group',
    message_search_v3: 'message_search_v3',
    data_export: 'data_export',
    migration: 'migration',
    delivery_receipt: 'delivery_receipt',
    auto_thumbnail: 'auto_thumbnail',
    image_moderation: 'image_moderation',
    super_group_channel: 'super_group_channel',
    announcement: 'announcement',
    moderation_open: 'moderation_open',
    desk: 'desk',
    bot_interface: 'bot_interface',
    auto_trans: 'auto_trans',
};

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-24f017be.js
var _bundle_24f017be = __webpack_require__(77522);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/constants/sbuConstants.js

const sbuConstants_sbuConstants = {
    collection: {
        groupChannel: {
            defaultLimit: 20,
            defaultOrder: _bundle_24f017be.G.LATEST_LAST_MESSAGE,
            defaultIncludeEmpty: false,
        },
        message: {
            defaultLimit: { next: 25, prev: 25 },
            searchLimit: { next: 10, prev: 10 },
        },
    },
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/constants/index.js




;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useAsyncEffect.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const useAsyncEffect_useAsyncEffect = (asyncEffect, deps) => {
    (0,react.useEffect)(createAsyncEffectCallback(asyncEffect), deps);
};
const useAsyncLayoutEffect = (asyncEffect, deps) => {
    (0,react.useLayoutEffect)(createAsyncEffectCallback(asyncEffect), deps);
};
const iife = (callback) => typeof callback === 'function' && callback();
const createAsyncEffectCallback = (asyncEffect) => () => {
    const destructor = iife(asyncEffect);
    return () => {
        if (!destructor)
            return;
        if (destructor instanceof Promise) {
            iife(() => __awaiter(void 0, void 0, void 0, function* () {
                const awaitedDestructor = yield destructor;
                if (typeof awaitedDestructor === 'function')
                    awaitedDestructor();
            }));
        }
        else if (typeof destructor === 'function') {
            iife(destructor);
        }
    };
};

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/groupChannel.js
var groupChannel = __webpack_require__(42391);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useUniqId.js

let id = 0;
function useUniqId() {
    return (0,react.useState)(() => `${id++}`)[0];
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelHandler.js



const useGroupChannelHandler_useGroupChannelHandler = (sdk, hookHandler, handlerId) => {
    const handlerRef = (0,react.useRef)(hookHandler);
    const id = useUniqId();
    const internalHandlerId = handlerId !== null && handlerId !== void 0 ? handlerId : id;
    handlerRef.current = hookHandler;
    (0,react.useEffect)(() => {
        var _a;
        const handlerMapper = (handler) => {
            const handlerKeys = Object.keys(handler);
            handlerKeys.forEach((key) => {
                // @ts-ignore
                handler[key] = (...args) => { var _a, _b; return (_b = (_a = handlerRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); };
            });
            return handler;
        };
        (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler(internalHandlerId, handlerMapper(new groupChannel/* GroupChannelHandler */.pe()));
        return () => {
            var _a;
            (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler(internalHandlerId);
        };
    }, [sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel, internalHandlerId]);
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/usePreservedCallback.js

/**
 * Preserves a reference to the given callback function as an argument while the component is mounted.
 * Wraps the given callback in React's Ref to preserve the reference.
 * @param callback want to be preserved
 */
function usePreservedCallback_usePreservedCallback(callback) {
    const callbackRef = (0,react.useRef)(callback);
    callbackRef.current = callback;
    // useEffect(() => {
    //   callbackRef.current = callback;
    // });
    return (0,react.useCallback)((...args) => callbackRef.current(...args), [callbackRef]);
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelList/reducer.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const defaultReducer = (_a, action) => {
    var draft = __rest(_a, []);
    const compareByOrder = createCompareByOrder(draft.order);
    switch (action.type) {
        case 'update_refreshing': {
            draft.refreshing = action.value.status;
            break;
        }
        case 'update_initialized': {
            draft.initialized = action.value.status;
            break;
        }
        case 'update_channels': {
            getGroupChannels(action.value.channels).forEach((freshChannel) => {
                const idx = draft.groupChannels.findIndex((staleChannel) => staleChannel.url === freshChannel.url);
                if (idx > -1)
                    draft.groupChannels[idx] = freshChannel;
            });
            compareByOrder && (draft.groupChannels = draft.groupChannels.sort(compareByOrder));
            break;
        }
        case 'delete_channels': {
            action.value.channelUrls.forEach((url) => {
                const idx = draft.groupChannels.findIndex((c) => c.url === url);
                if (idx > -1)
                    draft.groupChannels.splice(idx, 1);
            });
            compareByOrder && (draft.groupChannels = draft.groupChannels.sort(compareByOrder));
            break;
        }
        case 'append_channels': {
            const groupChannels = getGroupChannels(action.value.channels);
            if (action.value.clearBeforeAction) {
                draft.groupChannels = groupChannels;
            }
            else {
                draft.groupChannels = mergeObjectArrays(draft.groupChannels, groupChannels, 'url');
            }
            compareByOrder && (draft.groupChannels = draft.groupChannels.sort(compareByOrder));
            break;
        }
        case 'update_order': {
            draft.order = action.value.order;
            const compareByOrder = createCompareByOrder(draft.order);
            compareByOrder && (draft.groupChannels = draft.groupChannels.sort(compareByOrder));
            break;
        }
    }
    return draft;
};
const reducer_useGroupChannelListReducer = (order) => {
    const [{ initialized, refreshing, groupChannels }, dispatch] = useReducer(defaultReducer, {
        initialized: false,
        refreshing: false,
        groupChannels: [],
        order,
    });
    const updateChannels = (channels) => {
        dispatch({ type: 'update_channels', value: { channels } });
    };
    const deleteChannels = (channelUrls) => {
        dispatch({ type: 'delete_channels', value: { channelUrls } });
    };
    const appendChannels = (channels, clearBeforeAction) => {
        dispatch({ type: 'append_channels', value: { channels, clearBeforeAction } });
    };
    const updateInitialized = (status) => {
        dispatch({ type: 'update_initialized', value: { status } });
    };
    const updateRefreshing = (status) => {
        dispatch({ type: 'update_refreshing', value: { status } });
    };
    const updateOrder = (order) => {
        dispatch({ type: 'update_order', value: { order } });
    };
    return {
        updateInitialized,
        updateRefreshing,
        updateChannels,
        deleteChannels,
        appendChannels,
        updateOrder,
        initialized,
        refreshing,
        groupChannels,
    };
};
const createCompareByOrder = (order) => {
    if (!order)
        return undefined;
    return (channel1, channel2) => {
        switch (order) {
            case 'latest_last_message': {
                if (channel1.lastMessage && channel2.lastMessage) {
                    return channel2.lastMessage.createdAt - channel1.lastMessage.createdAt;
                }
                else if (channel1.lastMessage) {
                    return -1;
                }
                else if (channel2.lastMessage) {
                    return 1;
                }
                else {
                    return channel2.createdAt - channel1.createdAt;
                }
            }
            case 'chronological': {
                return channel2.createdAt - channel1.createdAt;
            }
            case 'channel_name_alphabetical': {
                return channel1.name.localeCompare(channel2.name);
            }
            default: {
                return 0;
            }
        }
    };
};
function mergeObjectArrays(A, B, key) {
    const uniqueValues = new Set(A.map((obj) => obj[key]));
    const newArr = [...A];
    for (let i = 0; i < B.length; i++) {
        if (!uniqueValues.has(B[i][key])) {
            newArr.push(B[i]);
            uniqueValues.add(B[i][key]);
        }
    }
    return newArr;
}
function getGroupChannels(channels) {
    return channels.filter((it) => it.isGroupChannel());
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelList/index.js
var useGroupChannelList_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








const createGroupChannelListCollection = (sdk, collectionCreator) => {
    const basicParams = {
        includeEmpty: sbuConstants.collection.groupChannel.defaultIncludeEmpty,
        limit: sbuConstants.collection.groupChannel.defaultLimit,
        order: sbuConstants.collection.groupChannel.defaultOrder,
    };
    const passedCollection = collectionCreator === null || collectionCreator === void 0 ? void 0 : collectionCreator(basicParams);
    if (passedCollection)
        return passedCollection;
    return sdk.groupChannel.createGroupChannelCollection(Object.assign(Object.assign({}, basicParams), { filter: new GroupChannelFilter(basicParams) }));
};
const useGroupChannelList = (sdk, options) => {
    var _a, _b, _c;
    const deliveryReceiptEnabled = Boolean((_b = (_a = sdk.appInfo) === null || _a === void 0 ? void 0 : _a.premiumFeatureList) === null || _b === void 0 ? void 0 : _b.includes(premiumFeatures.delivery_receipt));
    const collectionRef = useRef();
    // update reference for event handler
    const internalOptions = useRef(options);
    internalOptions.current = options;
    const { initialized, groupChannels, refreshing, appendChannels, deleteChannels, updateRefreshing, updateInitialized, } = useGroupChannelListReducer();
    const updateChannelsAndMarkAsDelivered = (shouldMarkAsDelivered, source, updatedChannels) => {
        var _a, _b, _c, _d;
        const channels = (_b = (_a = collectionRef.current) === null || _a === void 0 ? void 0 : _a.channels) !== null && _b !== void 0 ? _b : [];
        appendChannels(channels, true);
        if (shouldMarkAsDelivered && deliveryReceiptEnabled) {
            switch (source) {
                case GroupChannelEventSource.EVENT_MESSAGE_RECEIVED:
                case GroupChannelEventSource.EVENT_MESSAGE_SENT:
                case GroupChannelEventSource.SYNC_CHANNEL_BACKGROUND:
                case GroupChannelEventSource.SYNC_CHANNEL_CHANGELOGS:
                case undefined:
                    (_d = (_c = internalOptions.current) === null || _c === void 0 ? void 0 : _c.markAsDelivered) === null || _d === void 0 ? void 0 : _d.call(_c, updatedChannels !== null && updatedChannels !== void 0 ? updatedChannels : channels);
                    break;
            }
        }
    };
    const init = usePreservedCallback((uid) => useGroupChannelList_awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f, _g;
        if (collectionRef.current)
            (_d = collectionRef.current) === null || _d === void 0 ? void 0 : _d.dispose();
        if (uid) {
            collectionRef.current = createGroupChannelListCollection(sdk, options === null || options === void 0 ? void 0 : options.collectionCreator);
            (_e = collectionRef.current) === null || _e === void 0 ? void 0 : _e.setGroupChannelCollectionHandler({
                onChannelsAdded: (context, channels) => {
                    var _a, _b;
                    const groupChannels = channels.filter((channel) => channel.isGroupChannel());
                    updateChannelsAndMarkAsDelivered(true, context.source, groupChannels);
                    (_b = (_a = internalOptions.current) === null || _a === void 0 ? void 0 : _a.onChannelsAdded) === null || _b === void 0 ? void 0 : _b.call(_a, groupChannels);
                },
                onChannelsUpdated: (context, channels) => {
                    var _a, _b;
                    const groupChannels = channels.filter((channel) => channel.isGroupChannel());
                    updateChannelsAndMarkAsDelivered(true, context.source, groupChannels);
                    (_b = (_a = internalOptions.current) === null || _a === void 0 ? void 0 : _a.onChannelsUpdated) === null || _b === void 0 ? void 0 : _b.call(_a, groupChannels);
                },
                onChannelsDeleted: (_, channelUrls) => {
                    var _a, _b;
                    updateChannelsAndMarkAsDelivered(false);
                    (_b = (_a = internalOptions.current) === null || _a === void 0 ? void 0 : _a.onChannelsDeleted) === null || _b === void 0 ? void 0 : _b.call(_a, channelUrls);
                },
            });
            if ((_f = collectionRef.current) === null || _f === void 0 ? void 0 : _f.hasMore) {
                yield ((_g = collectionRef.current) === null || _g === void 0 ? void 0 : _g.loadMore());
                updateChannelsAndMarkAsDelivered(true);
            }
        }
    }));
    useEffect(() => {
        return () => {
            var _a;
            if (collectionRef.current)
                (_a = collectionRef.current) === null || _a === void 0 ? void 0 : _a.dispose();
        };
    }, []);
    useAsyncEffect(() => useGroupChannelList_awaiter(void 0, void 0, void 0, function* () {
        updateInitialized(false);
        if (sdk.currentUser) {
            yield init(sdk.currentUser.userId);
            updateInitialized(true);
        }
    }), [sdk, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId]);
    useGroupChannelHandler(sdk, {
        onUserBanned: (channel, user) => {
            var _a, _b, _c;
            const isMe = user.userId === ((_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
            if (isMe) {
                deleteChannels([channel.url]);
                (_c = (_b = internalOptions.current) === null || _b === void 0 ? void 0 : _b.onChannelsDeleted) === null || _c === void 0 ? void 0 : _c.call(_b, [channel.url]);
            }
            else {
                updateChannelsAndMarkAsDelivered(false);
            }
        },
    });
    const refresh = usePreservedCallback(() => useGroupChannelList_awaiter(void 0, void 0, void 0, function* () {
        if (sdk.currentUser) {
            updateRefreshing(true);
            yield init(sdk.currentUser.userId);
            updateRefreshing(false);
        }
    }));
    const loadMore = usePreservedCallback(() => useGroupChannelList_awaiter(void 0, void 0, void 0, function* () {
        var _h, _j;
        if ((_h = collectionRef.current) === null || _h === void 0 ? void 0 : _h.hasMore) {
            yield ((_j = collectionRef.current) === null || _j === void 0 ? void 0 : _j.loadMore());
            updateChannelsAndMarkAsDelivered(true);
        }
    }));
    return {
        /**
         * Initializing state, only available on first render
         * */
        initialized,
        /**
         * Get group channels state
         * */
        groupChannels,
        /**
         * Refresh, clear and reload messages from latest
         * @return {Promise<void>}
         * */
        refresh,
        /**
         * Refreshing state, status is changes when the refresh is called.
         * */
        refreshing,
        /**
         * Fetch more channels to state
         * @return {Promise<void>}
         * */
        loadMore,
    };
};

// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-1db3fd0b.js
var _bundle_1db3fd0b = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-e1a5e3f1.js
var _bundle_e1a5e3f1 = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/@sendbird/chat/lib/__bundle-cc71b396.js
var _bundle_cc71b396 = __webpack_require__(18490);
;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/utils/channel.js
/**
 * Diff utils for channel
 * @param {BaseChannel} [a]
 * @param {BaseChannel} [b]
 * @returns {boolean}
 * */
function channel_isDifferentChannel(a, b) {
    if (!a || !b)
        return true;
    return a.url !== b.url;
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/utils/message.js
function message_isSendableMessage(msg) {
    return msg !== undefined && msg !== null && 'sendingStatus' in msg;
}
function message_isMyMessage(msg, currentUserId = '##__USER_ID_IS_NOT_PROVIDED__##') {
    var _a;
    if (!message_isSendableMessage(msg))
        return false;
    return ((_a = msg.sender) === null || _a === void 0 ? void 0 : _a.userId) === currentUserId;
}
function message_isNewMessage(msg, currentUserId) {
    const myMessage = message_isMyMessage(msg, currentUserId);
    if (myMessage)
        return false;
    if (msg.isAdminMessage())
        return false;
    return msg.updatedAt === 0;
}
function message_getMessageUniqId(msg) {
    if ('sendingStatus' in msg) {
        if (msg.sendingStatus === 'succeeded')
            return String(msg.messageId);
        return msg.reqId;
    }
    return String(msg.messageId);
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/utils/validators.js
// NOTE: type guard fix for optional chaining - https://github.com/microsoft/TypeScript/pull/55613
function isBoolean(val) {
    return typeof val === 'boolean';
}
function isOneOf(val, values) {
    return values.includes(val);
}
function isSet(val) {
    return val instanceof Set;
}
function validators_isNotEmptyArray(arr) {
    if (!arr || !Array.isArray(arr))
        return false;
    return arr.length !== 0;
}
function isSameType(a, b) {
    // we do this cause typeof can't differenciate object/ array/ null
    return Object.prototype.toString.call(a) === Object.prototype.toString.call(b);
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useForceUpdate.js

const useForceUpdate_useForceUpdate = () => {
    const [, updater] = (0,react.useState)(0);
    return (0,react.useCallback)(() => updater((prev) => prev + 1), []);
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/utils/convertors.js
function snakeToCamel(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => snakeToCamel(item));
    }
    const result = {};
    Object.keys(obj).forEach((key) => {
        const camelKey = key.replace(/_\w/g, (m) => m[1].toUpperCase());
        // @ts-ignore
        result[camelKey] = snakeToCamel(obj[key]);
    });
    return result;
}
function arrayToMapWithGetter(arr, getSelector) {
    return arr.reduce((accum, curr) => {
        const _key = getSelector(curr);
        accum[_key] = curr;
        return accum;
    }, {});
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelMessages/reducer.js
var reducer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const reducer_defaultReducer = (_a, action) => {
    var draft = reducer_rest(_a, []);
    switch (action.type) {
        case 'update_initialized': {
            draft['initialized'] = action.value.status;
            return draft;
        }
        case 'update_refreshing': {
            draft['refreshing'] = action.value.status;
            return draft;
        }
        case 'update_loading': {
            draft['loading'] = action.value.status;
            return draft;
        }
        case 'update_messages': {
            if (action.value.clearBeforeAction) {
                draft['messageMap'] = messagesToObject(action.value.messages);
            }
            else {
                const draftMessageMap = Object.assign({}, draft['messageMap']);
                const messagesToDelete = [];
                const messagesToAdd = [];
                action.value.messages.forEach((next) => {
                    const requestId = message_isSendableMessage(next) ? next.reqId : undefined;
                    const messageId = next.messageId || undefined;
                    [requestId, messageId].forEach((id) => {
                        if (!id)
                            return;
                        const prev = draftMessageMap[id];
                        if (shouldUpdateMessage(prev, next)) {
                            prev && messagesToDelete.push(prev);
                            messagesToAdd.push(next);
                        }
                    });
                });
                // Remove existing messages before update to prevent duplicate display
                messagesToDelete.forEach((it) => {
                    if (message_isSendableMessage(it))
                        delete draftMessageMap[it.reqId];
                    delete draftMessageMap[it.messageId];
                });
                messagesToAdd.forEach((it) => {
                    if (message_isSendableMessage(it))
                        draftMessageMap[it.reqId] = it;
                    draftMessageMap[it.messageId] = it;
                });
                draft['messageMap'] = draftMessageMap;
            }
            return draft;
        }
        case 'update_new_messages': {
            const userId = action.value.currentUserId;
            const newMessages = action.value.messages.filter((it) => message_isNewMessage(it, userId));
            if (action.value.clearBeforeAction) {
                draft['newMessageMap'] = arrayToMapWithGetter(newMessages, message_getMessageUniqId);
            }
            else {
                // Remove existing messages before update to prevent duplicate display
                const messageKeys = newMessages.map((it) => it.messageId);
                messageKeys.forEach((key) => delete draft['newMessageMap'][key]);
                draft['newMessageMap'] = Object.assign(Object.assign({}, draft['newMessageMap']), arrayToMapWithGetter(newMessages, message_getMessageUniqId));
            }
            return draft;
        }
        case 'delete_messages':
        case 'delete_new_messages': {
            const key = action.type === 'delete_messages' ? 'messageMap' : 'newMessageMap';
            draft[key] = Object.assign({}, draft[key]);
            action.value.messageIds.forEach((msgId) => {
                const message = draft[key][msgId];
                if (message) {
                    if (message_isSendableMessage(message))
                        delete draft[key][message.reqId];
                    delete draft[key][message.messageId];
                }
            });
            action.value.reqIds.forEach((reqId) => {
                const message = draft[key][reqId];
                if (message) {
                    if (message_isSendableMessage(message))
                        delete draft[key][message.reqId];
                    delete draft[key][message.messageId];
                }
            });
            return draft;
        }
    }
};
const messagesToObject = (messages) => {
    return messages.reduce((accum, curr) => {
        if (message_isSendableMessage(curr)) {
            accum[curr.reqId] = curr;
            if (curr.sendingStatus === _bundle_1db3fd0b.ao.SUCCEEDED) {
                accum[curr.messageId] = curr;
            }
        }
        else {
            accum[curr.messageId] = curr;
        }
        return accum;
    }, {});
};
const shouldUpdateMessage = (prev, next) => {
    if (!message_isSendableMessage(prev) || !message_isSendableMessage(next))
        return true;
    // message data update (e.g. reactions)
    if (prev.sendingStatus === _bundle_1db3fd0b.ao.SUCCEEDED)
        return next.sendingStatus === _bundle_1db3fd0b.ao.SUCCEEDED;
    // message sending status update
    return prev.sendingStatus !== next.sendingStatus;
};
const useChannelMessagesReducer = (sortComparator = defaultMessageComparator) => {
    const [{ initialized, loading, refreshing, messageMap, newMessageMap }, dispatch] = (0,react.useReducer)(reducer_defaultReducer, {
        initialized: false,
        loading: true,
        refreshing: false,
        messageMap: {},
        newMessageMap: {},
    });
    const updateMessages = (messages, clearBeforeAction, currentUserId) => {
        dispatch({ type: 'update_messages', value: { messages, clearBeforeAction, currentUserId } });
    };
    const deleteMessages = (messageIds, reqIds) => {
        dispatch({ type: 'delete_messages', value: { messageIds, reqIds } });
    };
    const updateNewMessages = (messages, clearBeforeAction, currentUserId) => {
        dispatch({ type: 'update_new_messages', value: { messages, clearBeforeAction, currentUserId } });
    };
    const deleteNewMessages = (messageIds, reqIds) => {
        dispatch({ type: 'delete_new_messages', value: { messageIds, reqIds } });
    };
    const updateInitialized = (status) => {
        dispatch({ type: 'update_initialized', value: { status } });
    };
    const updateLoading = (status) => {
        dispatch({ type: 'update_loading', value: { status } });
    };
    const updateRefreshing = (status) => {
        dispatch({ type: 'update_refreshing', value: { status } });
    };
    const newMessages = Object.values(newMessageMap);
    const messages = (0,react.useMemo)(() => Array.from(new Set(Object.values(messageMap))).sort(sortComparator), [messageMap]);
    return {
        updateInitialized,
        updateLoading,
        updateRefreshing,
        updateMessages,
        deleteMessages,
        initialized,
        loading,
        refreshing,
        messages,
        newMessages,
        updateNewMessages,
        deleteNewMessages,
    };
};
const LARGE_OFFSET = Math.floor(Number.MAX_SAFE_INTEGER / 10);
function defaultMessageComparator(a, b) {
    let aStatusOffset = 0;
    let bStatusOffset = 0;
    if (message_isSendableMessage(a) && a.sendingStatus !== 'succeeded')
        aStatusOffset = LARGE_OFFSET;
    if (message_isSendableMessage(b) && b.sendingStatus !== 'succeeded')
        bStatusOffset = LARGE_OFFSET;
    return a.createdAt + aStatusOffset - (b.createdAt + bStatusOffset);
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelMessages/index.js
var useGroupChannelMessages_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











const createMessageCollection = (channel, limit, options) => {
    var _a;
    const basicParams = {
        prevResultLimit: limit.prev,
        nextResultLimit: limit.next,
        startingPoint: options === null || options === void 0 ? void 0 : options.startingPoint,
        replyType: options === null || options === void 0 ? void 0 : options.replyType,
    };
    const passedCollection = (_a = options === null || options === void 0 ? void 0 : options.collectionCreator) === null || _a === void 0 ? void 0 : _a.call(options, basicParams);
    if (passedCollection)
        return passedCollection;
    return channel.createMessageCollection(Object.assign(Object.assign({}, basicParams), { filter: new _bundle_e1a5e3f1.K(basicParams) }));
};
// NOTE: In React-Native's FlatList, the bidirectional message loading doesn't work reliably, causing a bug
//  where scrolling jumps to a random position when loading a large number of messages at once.
//  Therefore, in the message search that explores past messages, a small number of messages is loaded to address this issue.
function getCollectionLimitBy(startingPoint) {
    return startingPoint < Date.now()
        ? sbuConstants_sbuConstants.collection.message.searchLimit
        : sbuConstants_sbuConstants.collection.message.defaultLimit;
}
/**
 * group channel messages hook
 * - Receive new messages from other users & should count new messages -> append to state(newMessages)
 * - onTopReached -> prev() -> fetch prev messages and append to state(messages)
 * - onBottomReached -> next() -> fetch next messages and append to state(messages)
 * */
const useGroupChannelMessages = (sdk, channel, options = {}) => {
    var _a, _b, _c;
    const internalOptions = (0,react.useRef)(options); // to keep reference of options in event handler
    internalOptions.current = options;
    const channelRef = (0,react.useRef)(channel); // to keep reference of channel in event handler
    channelRef.current = channel;
    const logger = internalOptions.current.logger;
    const initialStartingPoint = (_a = internalOptions.current.startingPoint) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER;
    const initialLimit = getCollectionLimitBy(initialStartingPoint);
    const isFetching = (0,react.useRef)({ prev: false, next: false });
    const forceUpdate = useForceUpdate_useForceUpdate();
    const collectionRef = (0,react.useRef)({
        initialized: false,
        apiInitialized: false,
        instance: null,
    });
    const { initialized, loading, refreshing, messages, newMessages, updateMessages, updateNewMessages, deleteNewMessages, deleteMessages, updateInitialized, updateLoading, updateRefreshing, } = useChannelMessagesReducer(options === null || options === void 0 ? void 0 : options.sortComparator);
    const markAsReadBySource = usePreservedCallback_usePreservedCallback((source) => {
        var _a, _b, _c, _d;
        if (!channelRef.current || !channelRef.current.url)
            return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
        try {
            switch (source) {
                case _bundle_1db3fd0b.a2.EVENT_MESSAGE_RECEIVED:
                case _bundle_1db3fd0b.a2.EVENT_MESSAGE_SENT_SUCCESS:
                case _bundle_1db3fd0b.a2.SYNC_MESSAGE_FILL:
                case undefined:
                    (_c = (_b = internalOptions.current).markAsRead) === null || _c === void 0 ? void 0 : _c.call(_b, [channelRef.current]);
                    break;
            }
        }
        catch (e) {
            (_d = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _d === void 0 ? void 0 : _d.call(logger, '[useGroupChannelMessages/markAsReadBySource]', e);
        }
    });
    const updateNewMessagesReceived = usePreservedCallback_usePreservedCallback((source, messages) => {
        var _a, _b, _c, _d, _e;
        const incomingMessages = messages.filter((it) => { var _a; return !message_isMyMessage(it, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId); });
        if (incomingMessages.length > 0) {
            switch (source) {
                case _bundle_1db3fd0b.a2.EVENT_MESSAGE_RECEIVED:
                case _bundle_1db3fd0b.a2.SYNC_MESSAGE_FILL: {
                    if ((_b = (_a = internalOptions.current).shouldCountNewMessages) === null || _b === void 0 ? void 0 : _b.call(_a)) {
                        updateNewMessages(incomingMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                    }
                    (_e = (_d = internalOptions.current).onMessagesReceived) === null || _e === void 0 ? void 0 : _e.call(_d, incomingMessages);
                    break;
                }
            }
        }
    });
    const init = usePreservedCallback_usePreservedCallback((startingPoint, limit) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            var _a, _b;
            if (!channelRef.current || !channelRef.current.url)
                return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
            if (collectionRef.current.instance)
                collectionRef.current.instance.dispose();
            markAsReadBySource();
            updateNewMessages([], true, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId);
            const updateUnsentMessages = () => {
                var _a, _b, _c;
                const { pendingMessages, failedMessages } = (_a = collectionRef.current.instance) !== null && _a !== void 0 ? _a : {};
                if (validators_isNotEmptyArray(pendingMessages))
                    updateMessages(pendingMessages, false, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId);
                if (validators_isNotEmptyArray(failedMessages))
                    updateMessages(failedMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
            };
            const collectionInstance = createMessageCollection(channelRef.current, limit, Object.assign(Object.assign({}, internalOptions.current), { startingPoint }));
            collectionRef.current = { apiInitialized: false, initialized: false, instance: collectionInstance };
            collectionInstance.setMessageCollectionHandler({
                onMessagesAdded: (ctx, __, messages) => {
                    var _a;
                    markAsReadBySource(ctx.source);
                    updateNewMessagesReceived(ctx.source, messages);
                    updateMessages(messages, false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                },
                onMessagesUpdated: (ctx, __, messages) => {
                    var _a, _b, _c;
                    markAsReadBySource(ctx.source);
                    updateNewMessagesReceived(ctx.source, messages); // NOTE: admin message is not added via onMessagesAdded handler, not checked yet is this a bug.
                    updateMessages(messages, false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    if (ctx.source === _bundle_1db3fd0b.a2.EVENT_MESSAGE_UPDATED) {
                        (_c = (_b = internalOptions.current).onMessagesUpdated) === null || _c === void 0 ? void 0 : _c.call(_b, messages);
                    }
                },
                onMessagesDeleted: (_, __, ___, messages) => {
                    const msgIds = messages.map((it) => it.messageId);
                    const reqIds = messages.filter(message_isSendableMessage).map((it) => it.reqId);
                    deleteMessages(msgIds, reqIds);
                    deleteNewMessages(msgIds, reqIds);
                },
                onChannelDeleted: (_, channelUrl) => {
                    var _a, _b;
                    (_b = (_a = internalOptions.current).onChannelDeleted) === null || _b === void 0 ? void 0 : _b.call(_a, channelUrl);
                },
                onChannelUpdated: (_, channel) => {
                    var _a, _b;
                    forceUpdate();
                    (_b = (_a = internalOptions.current).onChannelUpdated) === null || _b === void 0 ? void 0 : _b.call(_a, channel);
                },
                onHugeGapDetected: () => {
                    init(Number.MAX_SAFE_INTEGER, sbuConstants_sbuConstants.collection.message.defaultLimit);
                },
            });
            collectionInstance
                .initialize(_bundle_cc71b396.u.CACHE_AND_REPLACE_BY_API)
                .onCacheResult((err, messages) => {
                var _a, _b, _c;
                if (err)
                    sdk.isCacheEnabled && ((_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages/onCacheResult]', err));
                else if (messages) {
                    (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelMessages/onCacheResult]', 'message length:', messages.length);
                    updateMessages(messages, true, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                    updateUnsentMessages();
                    // Note: If there are messages exchanged in the channel but no cached messages have been saved yet,
                    //  to prevent the API-retrieved messages from appearing immediately after the 'no messages' UI is displayed,
                    //  resolve only when there are messages present in the cache
                    if (messages.length > 0) {
                        collectionRef.current.initialized = true;
                        resolve();
                    }
                }
            })
                .onApiResult((err, messages) => {
                var _a, _b, _c, _d, _e;
                if (err)
                    (_a = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages/onApiResult]', err);
                else if (messages) {
                    (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelMessages/onApiResult]', 'message length:', messages.length);
                    updateMessages(messages, true, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                    if (!internalOptions.current.startingPoint)
                        (_e = (_d = internalOptions.current).onMessagesReceived) === null || _e === void 0 ? void 0 : _e.call(_d, messages);
                    if (sdk.isCacheEnabled)
                        updateUnsentMessages();
                }
                collectionRef.current.initialized = true;
                collectionRef.current.apiInitialized = true;
                resolve();
            });
        });
    }));
    useGroupChannelHandler_useGroupChannelHandler(sdk, {
        onUserBanned(eventChannel, bannedUser) {
            var _a, _b, _c;
            if (eventChannel.isGroupChannel() && !channel_isDifferentChannel(eventChannel, channelRef.current)) {
                if (bannedUser.userId === ((_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId)) {
                    (_c = (_b = internalOptions.current).onCurrentUserBanned) === null || _c === void 0 ? void 0 : _c.call(_b);
                }
                else {
                    forceUpdate();
                }
            }
        },
    });
    (0,react.useLayoutEffect)(() => {
        const timeout = setTimeout(() => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
            if (sdk.currentUser && channelRef.current) {
                updateInitialized(false);
                updateLoading(true);
                yield init(initialStartingPoint, initialLimit);
                updateLoading(false);
                updateInitialized(true);
            }
        }));
        return () => clearTimeout(timeout);
    }, [sdk, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId, (_c = channelRef.current) === null || _c === void 0 ? void 0 : _c.url, internalOptions.current.replyType]);
    (0,react.useEffect)(() => {
        return () => {
            if (collectionRef.current.instance)
                collectionRef.current.instance.dispose();
        };
    }, []);
    const refresh = usePreservedCallback_usePreservedCallback(() => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        if (sdk.currentUser && channelRef.current) {
            updateRefreshing(true);
            yield init(Number.MAX_SAFE_INTEGER, sbuConstants_sbuConstants.collection.message.defaultLimit);
            updateRefreshing(false);
        }
    }));
    const loadPrevious = usePreservedCallback_usePreservedCallback(() => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _d;
        const collection = collectionRef.current.instance;
        if ((collection === null || collection === void 0 ? void 0 : collection.hasPrevious) && !isFetching.current.prev) {
            try {
                isFetching.current.prev = true;
                const list = yield collection.loadPrevious();
                updateMessages(list, false, (_d = sdk.currentUser) === null || _d === void 0 ? void 0 : _d.userId);
            }
            catch (_e) {
                // noop
            }
            finally {
                isFetching.current.prev = false;
            }
        }
    }));
    const hasPrevious = usePreservedCallback_usePreservedCallback(() => {
        const { initialized, instance } = collectionRef.current;
        if (initialized && instance) {
            return instance.hasPrevious;
        }
        else {
            return false;
        }
    });
    const loadNext = usePreservedCallback_usePreservedCallback(() => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _f;
        const collection = collectionRef.current.instance;
        if ((collection === null || collection === void 0 ? void 0 : collection.hasNext) && !isFetching.current.next) {
            try {
                isFetching.current.next = true;
                const list = yield collection.loadNext();
                updateMessages(list, false, (_f = sdk.currentUser) === null || _f === void 0 ? void 0 : _f.userId);
            }
            catch (_g) {
                // noop
            }
            finally {
                isFetching.current.next = false;
            }
        }
    }));
    const hasNext = usePreservedCallback_usePreservedCallback(() => {
        // When the API is not initialized, the default value of collection.hasNext is true.
        // Due to this, there is an issue with UI elements such as the scroll to bottom button appearing and disappearing.
        // To address this, we additionally check the API initialized state.
        const { initialized, apiInitialized, instance } = collectionRef.current;
        if (apiInitialized && initialized && instance) {
            return instance.hasNext;
        }
        else {
            return false;
        }
    });
    const sendUserMessage = usePreservedCallback_usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendUserMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const sendFileMessage = usePreservedCallback_usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendFileMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const sendFileMessages = usePreservedCallback_usePreservedCallback((paramsList, onPending) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _h;
        if (!channelRef.current || !channelRef.current.url) {
            (_h = logger === null || logger === void 0 ? void 0 : logger.error) === null || _h === void 0 ? void 0 : _h.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve) => {
            const messages = [];
            channelRef.current
                .sendFileMessages(paramsList)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.isFileMessage() && sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    messages.push(sentMessage);
                }
                if (messages.length === paramsList.length)
                    resolve(messages);
            })
                .onFailed((_, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    messages.push(failedMessage);
                }
                else {
                    // NOTE: Since failedMessage is nullable by type, to resolve the promise, handle pushing null even when there is no failedMessage.
                    messages.push(null);
                }
                if (messages.length === paramsList.length)
                    resolve(messages);
            });
        });
    }));
    const sendMultipleFilesMessage = usePreservedCallback_usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendMultipleFilesMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onFileUploaded(() => {
                // Just re-render to use updated message.messageParams
                forceUpdate();
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const updateUserMessage = usePreservedCallback_usePreservedCallback((messageId, params) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _j, _k;
        if (!channelRef.current || !channelRef.current.url) {
            (_j = logger === null || logger === void 0 ? void 0 : logger.error) === null || _j === void 0 ? void 0 : _j.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        const updatedMessage = yield channelRef.current.updateUserMessage(messageId, params);
        if (updatedMessage.channelUrl === channelRef.current.url) {
            updateMessages([updatedMessage], false, (_k = sdk.currentUser) === null || _k === void 0 ? void 0 : _k.userId);
        }
        return updatedMessage;
    }));
    const updateFileMessage = usePreservedCallback_usePreservedCallback((messageId, params) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _l, _m;
        if (!channelRef.current || !channelRef.current.url) {
            (_l = logger === null || logger === void 0 ? void 0 : logger.error) === null || _l === void 0 ? void 0 : _l.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        const updatedMessage = yield channelRef.current.updateFileMessage(messageId, params);
        if (updatedMessage.channelUrl === channelRef.current.url) {
            updateMessages([updatedMessage], false, (_m = sdk.currentUser) === null || _m === void 0 ? void 0 : _m.userId);
        }
        return updatedMessage;
    }));
    const resendMessage = usePreservedCallback_usePreservedCallback((failedMessage) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _o;
        if (!channelRef.current || !channelRef.current.url) {
            (_o = logger === null || logger === void 0 ? void 0 : logger.error) === null || _o === void 0 ? void 0 : _o.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            let handler = undefined;
            if (failedMessage.isUserMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (failedMessage.isFileMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (failedMessage.isMultipleFilesMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (handler) {
                if ('onPending' in handler) {
                    handler.onPending((message) => {
                        var _a;
                        if (message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                    });
                }
                if ('onFileUploaded' in handler) {
                    handler.onFileUploaded(() => {
                        // Just re-render to use updated message.messageParams
                        forceUpdate();
                    });
                }
                if ('onSucceeded' in handler) {
                    handler.onSucceeded((message) => {
                        var _a;
                        if (message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                        resolve(message);
                    });
                }
                if ('onFailed' in handler) {
                    handler.onFailed((err, message) => {
                        var _a;
                        if (message && message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                        reject(err);
                    });
                }
            }
        });
    }));
    const deleteMessage = usePreservedCallback_usePreservedCallback((message) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _p, _q;
        if (!channelRef.current || !channelRef.current.url) {
            (_p = logger === null || logger === void 0 ? void 0 : logger.error) === null || _p === void 0 ? void 0 : _p.call(logger, '[useGroupChannelMessages] channel is required');
            throw new Error('Channel is required');
        }
        if (message.sendingStatus === 'succeeded') {
            if (message.isUserMessage())
                yield channelRef.current.deleteMessage(message);
            if (message.isFileMessage())
                yield channelRef.current.deleteMessage(message);
            if (message.isMultipleFilesMessage())
                yield channelRef.current.deleteMessage(message);
        }
        else {
            try {
                yield ((_q = collectionRef.current.instance) === null || _q === void 0 ? void 0 : _q.removeFailedMessage(message.reqId));
            }
            finally {
                deleteMessages([message.messageId], [message.reqId]);
            }
        }
    }));
    const resetNewMessages = usePreservedCallback_usePreservedCallback(() => {
        var _a;
        updateNewMessages([], true, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
    });
    const resetWithStartingPoint = usePreservedCallback_usePreservedCallback((startingPoint) => useGroupChannelMessages_awaiter(void 0, void 0, void 0, function* () {
        var _r;
        if (sdk.currentUser && channelRef.current) {
            const limit = getCollectionLimitBy(startingPoint);
            updateLoading(true);
            updateMessages([], true, (_r = sdk.currentUser) === null || _r === void 0 ? void 0 : _r.userId);
            yield init(startingPoint, limit);
            updateLoading(false);
        }
    }));
    return {
        /**
         * Initialized state, only available on first render
         * */
        initialized,
        /**
         * Loading state, status is changes on first mount or when the resetWithStartingPoint is called.
         * */
        loading,
        /**
         * Refreshing state, status is changes when the refresh is called.
         * */
        refreshing,
        /**
         * Get messages, this state is for render
         * For example, if a user receives a new messages while searching for an old message
         * for this case, new messages will be included here.
         * */
        messages,
        /**
         * If the `shouldCountNewMessages()` is true, only then push in the newMessages state.
         * (Return false for the `shouldCountNewMessages()` if the message scroll is the most recent; otherwise, return true.)
         *
         * A new message means a message that meets the below conditions
         * - Not admin message
         * - Not updated message
         * - Not current user's message
         * */
        newMessages,
        /**
         * Reset new message list
         * @return {void}
         * */
        resetNewMessages,
        /**
         * Reset message list and create a new collection for latest messages
         * @return {Promise<void>}
         * */
        refresh,
        /**
         * Load previous messages to state
         * @return {Promise<void>}
         * */
        loadPrevious,
        /**
         * Check if there are more previous messages to fetch
         * @return {boolean}
         * */
        hasPrevious,
        /**
         * Load next messages to state
         * @return {Promise<void>}
         * */
        loadNext,
        /**
         * Check if there are more next messages to fetch
         * @return {boolean}
         * */
        hasNext,
        /**
         * Send user message
         * @param {UserMessageCreateParams} params user message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<UserMessage>} succeeded message
         * */
        sendUserMessage,
        /**
         * Send file message
         * @param {FileMessageCreateParams} params file message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<FileMessage>} succeeded message
         * */
        sendFileMessage,
        /**
         * Send file messages
         * @param {FileMessageCreateParams[]} paramList file message create params
         * @param {function} [onPending] pending message callback for each message request
         * @return {Promise<FileMessage[]>} succeeded or failed message
         * */
        sendFileMessages,
        /**
         * Send multiple files message
         * @param {MultipleFilesMessageCreateParams} params multiple files message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<MultipleFilesMessage>} succeeded message
         * */
        sendMultipleFilesMessage,
        /**
         * Update user message
         * @param {number} messageId
         * @param {UserMessageUpdateParams} params user message update params
         * @return {Promise<UserMessage>}
         * */
        updateUserMessage,
        /**
         * Update file message
         * @param {number} messageId
         * @param {FileMessageUpdateParams} params file message update params
         * @return {Promise<FileMessage>}
         * */
        updateFileMessage,
        /**
         * Resend failed message
         * @template {UserMessage | FileMessage | MultipleFilesMessage} T
         * @param {T} failedMessage message to resend
         * @return {Promise<T>}
         * */
        resendMessage,
        /**
         * Delete a message
         * @template {UserMessage | FileMessage | MultipleFilesMessage} T
         * @param {T} message succeeded or failed message
         * @return {Promise<void>}
         * */
        deleteMessage,
        /**
         * Reset message list and create a new collection with starting point
         * @param {number} startingPoint
         * @param {function} callback
         * @return {void}
         * */
        resetWithStartingPoint,
        /**
         * Do not use this api
         * */
        _dangerous_reducer_updateMessages: updateMessages,
        /**
         * Do not use this api
         * */
        _dangerous_reducer_deleteMessages: deleteMessages,
    };
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelThreadMessages/reducer.js
var useGroupChannelThreadMessages_reducer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function reducer_arrayToMapWithGetter(arr, getSelector) {
    return arr.reduce((accum, curr) => {
        const _key = getSelector(curr);
        accum[_key] = curr;
        return accum;
    }, {});
}
const useGroupChannelThreadMessages_reducer_defaultReducer = (_a, action) => {
    var draft = useGroupChannelThreadMessages_reducer_rest(_a, []);
    switch (action.type) {
        case 'update_initialized': {
            draft['initialized'] = action.value.status;
            return draft;
        }
        case 'update_refreshing': {
            draft['refreshing'] = action.value.status;
            return draft;
        }
        case 'update_loading': {
            draft['loading'] = action.value.status;
            return draft;
        }
        case 'update_has_previous': {
            draft['hasPreviousMessages'] = action.value.status;
            return draft;
        }
        case 'update_has_next': {
            draft['hasNextMessages'] = action.value.status;
            return draft;
        }
        case 'update_messages': {
            const userId = action.value.currentUserId;
            if (action.value.clearBeforeAction) {
                draft['messageMap'] = reducer_messagesToObject(action.value.messages);
            }
            else {
                // Filtering meaningless message updates
                const nextMessages = action.value.messages.filter((next) => {
                    var _a;
                    if (isMyMessage(next, userId)) {
                        const prev = (_a = draft['messageMap'][next.reqId]) !== null && _a !== void 0 ? _a : draft['messageMap'][next.messageId];
                        if (isMyMessage(prev, userId)) {
                            const shouldUpdate = reducer_shouldUpdateMessage(prev, next);
                            if (shouldUpdate) {
                                // Remove existing messages before update to prevent duplicate display
                                delete draft['messageMap'][prev.reqId];
                                delete draft['messageMap'][prev.messageId];
                            }
                            return shouldUpdate;
                        }
                    }
                    return true;
                });
                const obj = reducer_messagesToObject(nextMessages);
                draft['messageMap'] = Object.assign(Object.assign({}, draft['messageMap']), obj);
            }
            return draft;
        }
        case 'update_new_messages': {
            const userId = action.value.currentUserId;
            const newMessages = action.value.messages.filter((it) => isNewMessage(it, userId));
            if (action.value.clearBeforeAction) {
                draft['newMessageMap'] = reducer_arrayToMapWithGetter(newMessages, getMessageUniqId);
            }
            else {
                // Remove existing messages before update to prevent duplicate display
                const messageKeys = newMessages.map((it) => it.messageId);
                messageKeys.forEach((key) => delete draft['newMessageMap'][key]);
                draft['newMessageMap'] = Object.assign(Object.assign({}, draft['newMessageMap']), reducer_arrayToMapWithGetter(newMessages, getMessageUniqId));
            }
            return draft;
        }
        case 'delete_messages':
        case 'delete_new_messages': {
            const key = action.type === 'delete_messages' ? 'messageMap' : 'newMessageMap';
            draft[key] = Object.assign({}, draft[key]);
            action.value.messageIds.forEach((msgId) => {
                const message = draft[key][msgId];
                if (message) {
                    if (isSendableMessage(message))
                        delete draft[key][message.reqId];
                    delete draft[key][message.messageId];
                }
            });
            action.value.reqIds.forEach((reqId) => {
                const message = draft[key][reqId];
                if (message) {
                    if (isSendableMessage(message))
                        delete draft[key][message.reqId];
                    delete draft[key][message.messageId];
                }
            });
            return draft;
        }
    }
};
const reducer_messagesToObject = (messages) => {
    return messages.reduce((accum, curr) => {
        if (isSendableMessage(curr)) {
            accum[curr.reqId] = curr;
            if (curr.sendingStatus === SendingStatus.SUCCEEDED) {
                accum[curr.messageId] = curr;
            }
        }
        else {
            accum[curr.messageId] = curr;
        }
        return accum;
    }, {});
};
const reducer_shouldUpdateMessage = (prev, next) => {
    // message data update (e.g. reactions)
    if (prev.sendingStatus === SendingStatus.SUCCEEDED)
        return next.sendingStatus === SendingStatus.SUCCEEDED;
    // message sending status update
    return prev.sendingStatus !== next.sendingStatus;
};
const getOldestMessageTimeStamp = (messages) => {
    return messages.reduce((accum, curr) => {
        return Math.min(accum, curr.createdAt);
    }, Number.MAX_SAFE_INTEGER);
};
const getLatestMessageTimeStamp = (messages) => {
    return messages.reduce((accum, curr) => {
        return Math.max(accum, curr.createdAt);
    }, Number.MIN_SAFE_INTEGER);
};
const reducer_useChannelThreadMessagesReducer = (sortComparator = reducer_defaultMessageComparator) => {
    const [{ initialized, loading, refreshing, hasPreviousMessages, hasNextMessages, messageMap, newMessageMap }, dispatch,] = useReducer(useGroupChannelThreadMessages_reducer_defaultReducer, {
        initialized: false,
        loading: true,
        refreshing: false,
        hasPreviousMessages: false,
        hasNextMessages: false,
        messageMap: {},
        newMessageMap: {},
    });
    const updateMessages = (messages, clearBeforeAction, currentUserId) => {
        dispatch({ type: 'update_messages', value: { messages, clearBeforeAction, currentUserId } });
    };
    const deleteMessages = (messageIds, reqIds) => {
        dispatch({ type: 'delete_messages', value: { messageIds, reqIds } });
    };
    const updateNewMessages = (messages, clearBeforeAction, currentUserId) => {
        dispatch({ type: 'update_new_messages', value: { messages, clearBeforeAction, currentUserId } });
    };
    const deleteNewMessages = (messageIds, reqIds) => {
        dispatch({ type: 'delete_new_messages', value: { messageIds, reqIds } });
    };
    const updateInitialized = (status) => {
        dispatch({ type: 'update_initialized', value: { status } });
    };
    const updateLoading = (status) => {
        dispatch({ type: 'update_loading', value: { status } });
    };
    const updateRefreshing = (status) => {
        dispatch({ type: 'update_refreshing', value: { status } });
    };
    const updateHasPreviousMessages = (status) => {
        dispatch({ type: 'update_has_previous', value: { status } });
    };
    const updateHasNextMessages = (status) => {
        dispatch({ type: 'update_has_next', value: { status } });
    };
    const newMessages = Object.values(newMessageMap);
    const messages = useMemo(() => Array.from(new Set(Object.values(messageMap))).sort(sortComparator), [messageMap]);
    const oldestMessageTimeStamp = getOldestMessageTimeStamp(messages);
    const latestMessageTimeStamp = getLatestMessageTimeStamp(messages);
    return {
        updateInitialized,
        updateLoading,
        updateRefreshing,
        updateMessages,
        deleteMessages,
        updateHasPreviousMessages,
        updateHasNextMessages,
        initialized,
        loading,
        refreshing,
        hasPreviousMessages,
        hasNextMessages,
        oldestMessageTimeStamp,
        latestMessageTimeStamp,
        messages,
        newMessages,
        updateNewMessages,
        deleteNewMessages,
    };
};
const reducer_LARGE_OFFSET = Math.floor(Number.MAX_SAFE_INTEGER / 10);
function reducer_defaultMessageComparator(a, b) {
    let aStatusOffset = 0;
    let bStatusOffset = 0;
    if (isSendableMessage(a) && a.sendingStatus !== 'succeeded')
        aStatusOffset = reducer_LARGE_OFFSET;
    if (isSendableMessage(b) && b.sendingStatus !== 'succeeded')
        bStatusOffset = reducer_LARGE_OFFSET;
    return a.createdAt + aStatusOffset - (b.createdAt + bStatusOffset);
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useGroupChannelThreadMessages/index.js
var useGroupChannelThreadMessages_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













function isThreadedMessage(message, parentMessage) {
    return message.parentMessageId === parentMessage.messageId;
}
const useGroupChannelThreadMessages = (sdk, channel, parentMessage, options = {}) => {
    var _a, _b, _c, _d, _e;
    const internalOptions = useRef(options); // to keep reference of options in event handler
    internalOptions.current = options;
    const channelRef = useRef(channel); // to keep reference of channel in event handler
    channelRef.current = channel;
    const parentMessageRef = useRef(parentMessage); // to keep reference of parent message in event handler
    parentMessageRef.current = parentMessage;
    const startingPoint = useRef(((_a = internalOptions.current) === null || _a === void 0 ? void 0 : _a.startingPoint) || Number.MAX_SAFE_INTEGER);
    startingPoint.current = ((_b = internalOptions.current) === null || _b === void 0 ? void 0 : _b.startingPoint) || Number.MAX_SAFE_INTEGER;
    const prevFetchSize = sbuConstants.collection.message.defaultLimit.prev;
    const nextFetchSize = sbuConstants.collection.message.defaultLimit.next;
    const logger = internalOptions.current.logger;
    const isFetching = useRef({ prev: false, next: false });
    const forceUpdate = useForceUpdate();
    const collectionRef = useRef({
        initialized: false,
        apiInitialized: false,
        instance: null,
    });
    const { initialized, loading, refreshing, hasPreviousMessages, hasNextMessages, oldestMessageTimeStamp, latestMessageTimeStamp, messages, newMessages, updateMessages, updateNewMessages, deleteNewMessages, deleteMessages, updateInitialized, updateLoading, updateRefreshing, updateHasPreviousMessages, updateHasNextMessages, } = useChannelThreadMessagesReducer(options === null || options === void 0 ? void 0 : options.sortComparator);
    const markAsReadBySource = usePreservedCallback((source) => {
        var _a, _b, _c, _d;
        if (!channelRef.current || !channelRef.current.url) {
            return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages] channel is required');
        }
        try {
            switch (source) {
                case CollectionEventSource.EVENT_MESSAGE_RECEIVED:
                case CollectionEventSource.EVENT_MESSAGE_SENT_SUCCESS:
                case CollectionEventSource.SYNC_MESSAGE_FILL:
                case undefined:
                    (_c = (_b = internalOptions.current).markAsRead) === null || _c === void 0 ? void 0 : _c.call(_b, [channelRef.current]);
                    break;
            }
        }
        catch (e) {
            (_d = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _d === void 0 ? void 0 : _d.call(logger, '[useGroupChannelThreadMessages/markAsReadBySource]', e);
        }
    });
    const updateNewMessagesReceived = usePreservedCallback((source, messages) => {
        var _a, _b, _c, _d, _e;
        const incomingMessages = messages.filter((it) => { var _a; return isThreadedMessage(it, parentMessageRef.current) && !isMyMessage(it, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId); });
        if (incomingMessages.length > 0) {
            switch (source) {
                case CollectionEventSource.EVENT_MESSAGE_RECEIVED:
                case CollectionEventSource.SYNC_MESSAGE_FILL: {
                    if ((_b = (_a = internalOptions.current).shouldCountNewMessages) === null || _b === void 0 ? void 0 : _b.call(_a)) {
                        updateNewMessages(incomingMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                    }
                    (_e = (_d = internalOptions.current).onMessagesReceived) === null || _e === void 0 ? void 0 : _e.call(_d, incomingMessages);
                    break;
                }
            }
        }
    });
    useAsyncEffect(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h, _j, _k;
        const messages = yield ((_f = channelRef.current) === null || _f === void 0 ? void 0 : _f.getMessagesByMessageId((_g = parentMessageRef.current) === null || _g === void 0 ? void 0 : _g.messageId, {
            prevResultSize: 1,
            nextResultSize: 1,
            isInclusive: true,
            includeThreadInfo: true,
            includeMetaArray: true,
            includeReactions: (_h = internalOptions.current.isReactionEnabled) !== null && _h !== void 0 ? _h : false,
        }));
        const parentMessage = messages === null || messages === void 0 ? void 0 : messages.find((message) => {
            return message.messageId === parentMessageRef.current.messageId;
        });
        if (parentMessage) {
            parentMessageRef.current = parentMessage;
            (_k = (_j = internalOptions.current).onParentMessageUpdated) === null || _k === void 0 ? void 0 : _k.call(_j, parentMessage);
        }
    }), [(_c = channelRef.current) === null || _c === void 0 ? void 0 : _c.url, internalOptions.current.isReactionEnabled]);
    const init = usePreservedCallback((startingPoint) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            var _a, _b, _c;
            if (!channelRef.current || !channelRef.current.url) {
                return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages] channel is required');
            }
            if (!parentMessageRef.current) {
                return (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelThreadMessages] parent message is required');
            }
            if (collectionRef.current.instance)
                collectionRef.current.instance.dispose();
            markAsReadBySource();
            updateNewMessages([], true, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
            const updateUnsentMessages = () => {
                var _a, _b;
                const { pendingMessages, failedMessages } = (_a = collectionRef.current.instance) !== null && _a !== void 0 ? _a : {};
                let filteredMessages;
                if (isNotEmptyArray(pendingMessages)) {
                    filteredMessages = pendingMessages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                }
                if (isNotEmptyArray(failedMessages)) {
                    filteredMessages = failedMessages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                }
                if (isNotEmptyArray(filteredMessages))
                    updateMessages(filteredMessages, false, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId);
            };
            setTimeout(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
                var _d, _e, _f, _g;
                try {
                    if (parentMessageRef.current) {
                        const params = {
                            prevResultSize: prevFetchSize,
                            nextResultSize: nextFetchSize,
                            isInclusive: true,
                            includeMetaArray: true,
                            includeReactions: (_d = internalOptions.current.isReactionEnabled) !== null && _d !== void 0 ? _d : false,
                        };
                        const { threadedMessages } = yield parentMessageRef.current.getThreadedMessagesByTimestamp(startingPoint, params);
                        if (isNotEmptyArray(threadedMessages)) {
                            const prevMessagesCount = threadedMessages.filter((message) => message.createdAt < startingPoint).length;
                            const nextMessagesCount = threadedMessages.filter((message) => message.createdAt > startingPoint).length;
                            updateHasPreviousMessages(prevMessagesCount >= prevFetchSize);
                            updateHasNextMessages(nextMessagesCount >= nextFetchSize);
                            updateMessages(threadedMessages, true, (_e = sdk.currentUser) === null || _e === void 0 ? void 0 : _e.userId);
                        }
                    }
                    else {
                        (_f = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _f === void 0 ? void 0 : _f.call(logger, '[useGroupChannelThreadMessages] parent message is required');
                    }
                    resolve();
                }
                catch (error) {
                    (_g = logger === null || logger === void 0 ? void 0 : logger.error) === null || _g === void 0 ? void 0 : _g.call(logger, '[useGroupChannelThreadMessages] Initialize thread list failed.', error);
                }
            }));
            const collectionInstance = channelRef.current.createMessageCollection({
                prevResultLimit: prevFetchSize,
                nextResultLimit: nextFetchSize,
                startingPoint: startingPoint - 1,
                filter: new MessageFilter({ replyType: ReplyType.ALL }),
            });
            collectionRef.current = { apiInitialized: false, initialized: false, instance: collectionInstance };
            collectionInstance.setMessageCollectionHandler({
                onMessagesAdded: (ctx, __, messages) => {
                    var _a;
                    const filteredMessages = messages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                    if (isNotEmptyArray(filteredMessages)) {
                        markAsReadBySource(ctx.source);
                        updateNewMessagesReceived(ctx.source, filteredMessages);
                        updateMessages(filteredMessages, false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    }
                },
                onMessagesUpdated: (ctx, __, messages) => {
                    var _a, _b, _c, _d, _e;
                    const filteredMessages = messages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                    const parentMessage = messages.find((message) => message.messageId === parentMessageRef.current.messageId);
                    if (parentMessage) {
                        parentMessageRef.current = parentMessage;
                        (_b = (_a = internalOptions.current).onParentMessageUpdated) === null || _b === void 0 ? void 0 : _b.call(_a, parentMessage);
                    }
                    if (isNotEmptyArray(filteredMessages)) {
                        markAsReadBySource(ctx.source);
                        updateNewMessagesReceived(ctx.source, filteredMessages); // NOTE: admin message is not added via onMessagesAdded handler, not checked yet is this a bug.
                        updateMessages(filteredMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                        if (ctx.source === CollectionEventSource.EVENT_MESSAGE_UPDATED) {
                            (_e = (_d = internalOptions.current).onMessagesUpdated) === null || _e === void 0 ? void 0 : _e.call(_d, filteredMessages);
                        }
                    }
                },
                onMessagesDeleted: (_, __, ___, messages) => {
                    var _a, _b;
                    const parentMessage = messages.find((message) => message.messageId === parentMessageRef.current.messageId);
                    if (parentMessage) {
                        (_b = (_a = internalOptions.current).onParentMessageDeleted) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }
                    const filteredMessages = messages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                    if (isNotEmptyArray(filteredMessages)) {
                        const msgIds = filteredMessages.map((it) => it.messageId);
                        const reqIds = filteredMessages.filter(isSendableMessage).map((it) => it.reqId);
                        deleteMessages(msgIds, reqIds);
                        deleteNewMessages(msgIds, reqIds);
                    }
                },
                onChannelDeleted: (_, channelUrl) => {
                    var _a, _b;
                    (_b = (_a = internalOptions.current).onChannelDeleted) === null || _b === void 0 ? void 0 : _b.call(_a, channelUrl);
                },
                onChannelUpdated: (_, channel) => {
                    var _a, _b;
                    forceUpdate();
                    (_b = (_a = internalOptions.current).onChannelUpdated) === null || _b === void 0 ? void 0 : _b.call(_a, channel);
                },
                onHugeGapDetected: () => {
                    init(startingPoint);
                },
            });
            collectionInstance
                .initialize(MessageCollectionInitPolicy.CACHE_AND_REPLACE_BY_API)
                .onCacheResult((err, messages) => {
                var _a, _b, _c;
                if (err) {
                    sdk.isCacheEnabled && ((_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages/onCacheResult]', err));
                }
                else if (messages) {
                    (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelThreadMessages/onCacheResult]', 'message length:', messages.length);
                    const filteredMessages = messages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                    if (isNotEmptyArray(filteredMessages)) {
                        updateMessages(filteredMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                        updateUnsentMessages();
                    }
                }
            })
                .onApiResult((err, messages) => {
                var _a, _b, _c;
                if (err) {
                    (_a = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages/onApiResult]', err);
                }
                else if (messages) {
                    (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelThreadMessages/onApiResult]', 'message length:', messages.length);
                    const filteredMessages = messages.filter((message) => isThreadedMessage(message, parentMessageRef.current));
                    if (isNotEmptyArray(filteredMessages)) {
                        updateMessages(filteredMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
                        if (sdk.isCacheEnabled)
                            updateUnsentMessages();
                    }
                }
                collectionRef.current.initialized = true;
                collectionRef.current.apiInitialized = true;
            });
        });
    }));
    useGroupChannelHandler(sdk, {
        onUserBanned(eventChannel, bannedUser) {
            var _a, _b, _c;
            if (eventChannel.isGroupChannel() && !isDifferentChannel(eventChannel, channelRef.current)) {
                if (bannedUser.userId === ((_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId)) {
                    (_c = (_b = internalOptions.current).onCurrentUserBanned) === null || _c === void 0 ? void 0 : _c.call(_b);
                }
                else {
                    forceUpdate();
                }
            }
        },
    });
    useLayoutEffect(() => {
        const timeout = setTimeout(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
            if (sdk.currentUser && channelRef.current) {
                updateInitialized(false);
                updateLoading(true);
                yield init(startingPoint.current);
                updateLoading(false);
                updateInitialized(true);
            }
        }));
        return () => clearTimeout(timeout);
    }, [sdk, (_d = sdk.currentUser) === null || _d === void 0 ? void 0 : _d.userId, (_e = channelRef.current) === null || _e === void 0 ? void 0 : _e.url, startingPoint.current]);
    useEffect(() => {
        return () => {
            if (collectionRef.current.instance)
                collectionRef.current.instance.dispose();
        };
    }, []);
    const refresh = usePreservedCallback(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        if (sdk.currentUser && channelRef.current) {
            updateRefreshing(true);
            yield init(startingPoint.current);
            updateRefreshing(false);
        }
    }));
    const loadPrevious = usePreservedCallback(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _l, _m, _o, _p;
        if (!channelRef.current || !channelRef.current.url || !parentMessageRef.current) {
            (_l = logger === null || logger === void 0 ? void 0 : logger.error) === null || _l === void 0 ? void 0 : _l.call(logger, '[useGroupChannelThreadMessages] channel or parent message is required');
            return;
        }
        if (hasPreviousMessages && !isFetching.current.prev) {
            try {
                isFetching.current.prev = true;
                const params = {
                    prevResultSize: prevFetchSize,
                    nextResultSize: 0,
                    isInclusive: false,
                    includeReactions: (_m = internalOptions.current.isReactionEnabled) !== null && _m !== void 0 ? _m : false,
                };
                const { threadedMessages } = yield parentMessageRef.current.getThreadedMessagesByTimestamp(oldestMessageTimeStamp, params);
                if (isNotEmptyArray(threadedMessages)) {
                    updateHasPreviousMessages(threadedMessages.length >= prevFetchSize);
                    updateMessages(threadedMessages, false, (_o = sdk.currentUser) === null || _o === void 0 ? void 0 : _o.userId);
                }
            }
            catch (error) {
                (_p = logger === null || logger === void 0 ? void 0 : logger.error) === null || _p === void 0 ? void 0 : _p.call(logger, '[useGroupChannelThreadMessages] loadPrevious thread list failed.', error);
            }
            finally {
                isFetching.current.prev = false;
            }
        }
    }));
    const hasPrevious = usePreservedCallback(() => {
        return hasPreviousMessages;
    });
    const loadNext = usePreservedCallback(() => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _q, _r, _s, _t;
        if (!channelRef.current || !channelRef.current.url || !parentMessageRef.current) {
            (_q = logger === null || logger === void 0 ? void 0 : logger.error) === null || _q === void 0 ? void 0 : _q.call(logger, '[useGroupChannelThreadMessages] channel or parent message is required');
            return;
        }
        if (hasNextMessages && !isFetching.current.next) {
            try {
                isFetching.current.prev = true;
                const params = {
                    prevResultSize: 0,
                    nextResultSize: nextFetchSize,
                    isInclusive: false,
                    includeReactions: (_r = internalOptions.current.isReactionEnabled) !== null && _r !== void 0 ? _r : false,
                };
                const { threadedMessages } = yield parentMessageRef.current.getThreadedMessagesByTimestamp(latestMessageTimeStamp, params);
                updateHasNextMessages(threadedMessages.length >= nextFetchSize);
                updateMessages(threadedMessages, false, (_s = sdk.currentUser) === null || _s === void 0 ? void 0 : _s.userId);
            }
            catch (error) {
                (_t = logger === null || logger === void 0 ? void 0 : logger.error) === null || _t === void 0 ? void 0 : _t.call(logger, '[useGroupChannelThreadMessages] loadNext thread list failed.', error);
            }
            finally {
                isFetching.current.next = false;
            }
        }
    }));
    const hasNext = usePreservedCallback(() => {
        return hasNextMessages;
    });
    const sendUserMessage = usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendUserMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const sendFileMessage = usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendFileMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const sendFileMessages = usePreservedCallback((paramsList, onPending) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _u;
        if (!channelRef.current || !channelRef.current.url) {
            (_u = logger === null || logger === void 0 ? void 0 : logger.error) === null || _u === void 0 ? void 0 : _u.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve) => {
            const messages = [];
            channelRef.current
                .sendFileMessages(paramsList)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.isFileMessage() && sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    messages.push(sentMessage);
                }
                if (messages.length === paramsList.length)
                    resolve(messages);
            })
                .onFailed((_, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                    messages.push(failedMessage);
                }
                else {
                    // NOTE: Since failedMessage is nullable by type, to resolve the promise, handle pushing null even when there is no failedMessage.
                    messages.push(null);
                }
                if (messages.length === paramsList.length)
                    resolve(messages);
            });
        });
    }));
    const sendMultipleFilesMessage = usePreservedCallback((params, onPending) => {
        var _a;
        if (!channelRef.current || !channelRef.current.url) {
            (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            channelRef.current
                .sendMultipleFilesMessage(params)
                .onPending((pendingMessage) => {
                var _a;
                if (pendingMessage.channelUrl === channelRef.current.url) {
                    updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
            })
                .onFileUploaded(() => {
                // Just re-render to use updated message.messageParams
                forceUpdate();
            })
                .onSucceeded((sentMessage) => {
                var _a;
                if (sentMessage.channelUrl === channelRef.current.url) {
                    updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                resolve(sentMessage);
            })
                .onFailed((err, failedMessage) => {
                var _a;
                if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
                    updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                }
                reject(err);
            });
        });
    });
    const updateUserMessage = usePreservedCallback((messageId, params) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _v, _w;
        if (!channelRef.current || !channelRef.current.url) {
            (_v = logger === null || logger === void 0 ? void 0 : logger.error) === null || _v === void 0 ? void 0 : _v.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        const updatedMessage = yield channelRef.current.updateUserMessage(messageId, params);
        if (updatedMessage.channelUrl === channelRef.current.url &&
            isThreadedMessage(updatedMessage, parentMessageRef.current)) {
            updateMessages([updatedMessage], false, (_w = sdk.currentUser) === null || _w === void 0 ? void 0 : _w.userId);
        }
        return updatedMessage;
    }));
    const updateFileMessage = usePreservedCallback((messageId, params) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _x, _y;
        if (!channelRef.current || !channelRef.current.url) {
            (_x = logger === null || logger === void 0 ? void 0 : logger.error) === null || _x === void 0 ? void 0 : _x.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        const updatedMessage = yield channelRef.current.updateFileMessage(messageId, params);
        if (updatedMessage.channelUrl === channelRef.current.url &&
            isThreadedMessage(updatedMessage, parentMessageRef.current)) {
            updateMessages([updatedMessage], false, (_y = sdk.currentUser) === null || _y === void 0 ? void 0 : _y.userId);
        }
        return updatedMessage;
    }));
    const resendMessage = usePreservedCallback((failedMessage) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _z;
        if (!channelRef.current || !channelRef.current.url) {
            (_z = logger === null || logger === void 0 ? void 0 : logger.error) === null || _z === void 0 ? void 0 : _z.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        return new Promise((resolve, reject) => {
            let handler = undefined;
            if (failedMessage.isUserMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (failedMessage.isFileMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (failedMessage.isMultipleFilesMessage())
                handler = channelRef.current.resendMessage(failedMessage);
            if (handler) {
                if ('onPending' in handler) {
                    handler.onPending((message) => {
                        var _a;
                        if (message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                    });
                }
                if ('onFileUploaded' in handler) {
                    handler.onFileUploaded(() => {
                        // Just re-render to use updated message.messageParams
                        forceUpdate();
                    });
                }
                if ('onSucceeded' in handler) {
                    handler.onSucceeded((message) => {
                        var _a;
                        if (message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                        resolve(message);
                    });
                }
                if ('onFailed' in handler) {
                    handler.onFailed((err, message) => {
                        var _a;
                        if (message && message.channelUrl === channelRef.current.url) {
                            updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
                        }
                        reject(err);
                    });
                }
            }
        });
    }));
    const deleteMessage = usePreservedCallback((message) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _0, _1;
        if (!channelRef.current || !channelRef.current.url) {
            (_0 = logger === null || logger === void 0 ? void 0 : logger.error) === null || _0 === void 0 ? void 0 : _0.call(logger, '[useGroupChannelThreadMessages] channel is required');
            throw new Error('Channel is required');
        }
        if (message.sendingStatus === 'succeeded') {
            if (message.isUserMessage())
                yield channelRef.current.deleteMessage(message);
            if (message.isFileMessage())
                yield channelRef.current.deleteMessage(message);
            if (message.isMultipleFilesMessage())
                yield channelRef.current.deleteMessage(message);
        }
        else {
            try {
                yield ((_1 = collectionRef.current.instance) === null || _1 === void 0 ? void 0 : _1.removeFailedMessage(message.reqId));
            }
            finally {
                deleteMessages([message.messageId], [message.reqId]);
            }
        }
    }));
    const resetNewMessages = usePreservedCallback(() => {
        var _a;
        updateNewMessages([], true, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
    });
    const resetWithStartingPoint = usePreservedCallback((startingPoint) => useGroupChannelThreadMessages_awaiter(void 0, void 0, void 0, function* () {
        var _2;
        if (sdk.currentUser && channelRef.current) {
            updateLoading(true);
            updateMessages([], true, (_2 = sdk.currentUser) === null || _2 === void 0 ? void 0 : _2.userId);
            yield init(startingPoint);
            updateLoading(false);
        }
    }));
    return {
        /**
         * Initialized state, only available on first render
         * */
        initialized,
        /**
         * Loading state, status is changes on first mount or when the resetWithStartingPoint is called.
         * */
        loading,
        /**
         * Refreshing state, status is changes when the refresh is called.
         * */
        refreshing,
        /**
         * Get messages, this state is for render
         * For example, if a user receives a new messages while searching for an old message
         * for this case, new messages will be included here.
         * */
        messages,
        /**
         * If the `shouldCountNewMessages()` is true, only then push in the newMessages state.
         * (Return false for the `shouldCountNewMessages()` if the message scroll is the most recent; otherwise, return true.)
         *
         * A new message means a message that meets the below conditions
         * - Not admin message
         * - Not updated message
         * - Not current user's message
         * */
        newMessages,
        /**
         * Reset new message list
         * @return {void}
         * */
        resetNewMessages,
        /**
         * Reset message list and create a new collection for latest messages
         * @return {Promise<void>}
         * */
        refresh,
        /**
         * Load previous messages to state
         * @return {Promise<void>}
         * */
        loadPrevious,
        /**
         * Check if there are more previous messages to fetch
         * @return {boolean}
         * */
        hasPrevious,
        /**
         * Load next messages to state
         * @return {Promise<void>}
         * */
        loadNext,
        /**
         * Check if there are more next messages to fetch
         * @return {boolean}
         * */
        hasNext,
        /**
         * Send user message
         * @param {UserMessageCreateParams} params user message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<UserMessage>} succeeded message
         * */
        sendUserMessage,
        /**
         * Send file message
         * @param {FileMessageCreateParams} params file message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<FileMessage>} succeeded message
         * */
        sendFileMessage,
        /**
         * Send file messages
         * @param {FileMessageCreateParams[]} paramList file message create params
         * @param {function} [onPending] pending message callback for each message request
         * @return {Promise<FileMessage[]>} succeeded or failed message
         * */
        sendFileMessages,
        /**
         * Send multiple files message
         * @param {MultipleFilesMessageCreateParams} params multiple files message create params
         * @param {function} [onPending] pending message callback
         * @return {Promise<MultipleFilesMessage>} succeeded message
         * */
        sendMultipleFilesMessage,
        /**
         * Update user message
         * @param {number} messageId
         * @param {UserMessageUpdateParams} params user message update params
         * @return {Promise<UserMessage>}
         * */
        updateUserMessage,
        /**
         * Update file message
         * @param {number} messageId
         * @param {FileMessageUpdateParams} params file message update params
         * @return {Promise<FileMessage>}
         * */
        updateFileMessage,
        /**
         * Resend failed message
         * @template {UserMessage | FileMessage | MultipleFilesMessage} T
         * @param {T} failedMessage message to resend
         * @return {Promise<T>}
         * */
        resendMessage,
        /**
         * Delete a message
         * @template {UserMessage | FileMessage | MultipleFilesMessage} T
         * @param {T} message succeeded or failed message
         * @return {Promise<void>}
         * */
        deleteMessage,
        /**
         * Reset message list and create a new collection with starting point
         * @param {number} startingPoint
         * @param {function} callback
         * @return {void}
         * */
        resetWithStartingPoint,
    };
};

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/useIIFE.js
const useIIFE = (callback) => {
    return useIIFE_iife(callback);
};
const useIIFE_iife = (callback) => typeof callback === 'function' && callback();

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/hooks/index.js










;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/utils/mergeObject.js

/**
 * Merges values from the subset object into the target object.
 *
 * @param target - The target object to merge into.
 * @param subset - The subset object from which values are merged into the target.
 * @returns A new object resulting from the merge operation.
 */
function mergeObject(target, subset) {
    // copy target to prevent mutation
    const object = Object.assign({}, target);
    Object.keys(subset).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(object, key) && isSameType(object[key], subset[key])) {
            if (typeof subset[key] === 'object' && !Array.isArray(subset[key])) {
                // Recursively call getConfigsByPriority only when the value of the key is Object
                object[key] = mergeObject(object[key], subset[key]);
            }
            else {
                object[key] = subset[key];
            }
        }
    });
    return object;
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/initialConfig.js
const createInitialConfig = () => ({
    common: {
        enableUsingDefaultUserProfile: false,
    },
    groupChannel: {
        channel: {
            enableMention: false,
            enableOgtag: true,
            enableReactions: true,
            enableReactionsSupergroup: false,
            enableTypingIndicator: true,
            enableVoiceMessage: false,
            input: {
                camera: {
                    enablePhoto: true,
                    enableVideo: true,
                },
                enableDocument: true,
                gallery: {
                    enablePhoto: true,
                    enableVideo: true,
                },
            },
            replyType: 'quote_reply',
            threadReplySelectType: 'thread',
            typingIndicatorTypes: new Set(['text']),
            enableFeedback: false,
            enableSuggestedReplies: false,
            showSuggestedRepliesFor: 'last_message_only',
            suggestedRepliesDirection: 'vertical',
            enableMarkdownForUserMessage: false,
            enableFormTypeMessage: false,
        },
        channelList: {
            enableMessageReceiptStatus: false,
            enableTypingIndicator: false,
        },
        setting: {
            enableMessageSearch: false,
        },
    },
    openChannel: {
        channel: {
            enableOgtag: true,
            input: {
                camera: {
                    enablePhoto: true,
                    enableVideo: true,
                },
                enableDocument: true,
                gallery: {
                    enablePhoto: true,
                    enableVideo: true,
                },
            },
        },
    },
});
function deleteLocalConfigs(config) {
    // @ts-ignore
    delete config.groupChannel.channel.typingIndicatorTypes;
    // @ts-ignore
    delete config.groupChannel.channel.enableFeedback;
    // @ts-ignore
    delete config.groupChannel.channel.enableSuggestedReplies;
    // @ts-ignore
    delete config.groupChannel.channel.showSuggestedRepliesFor;
    // @ts-ignore
    delete config.groupChannel.channel.suggestedRepliesDirection;
    // @ts-ignore
    delete config.groupChannel.channel.enableMarkdownForUserMessage;
    // @ts-ignore
    delete config.groupChannel.channel.enableFormTypeMessage;
    return config;
}
const createInitialRemoteConfig = () => {
    const config = createInitialConfig();
    return deleteLocalConfigs(config);
};
const initialConfig = createInitialConfig();
const initialRemoteConfig = createInitialRemoteConfig();

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/configManager.js
var configManager_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const MemoryStorage = {
    items: {},
    getItem(key) {
        var _a;
        return configManager_awaiter(this, void 0, void 0, function* () {
            return (_a = MemoryStorage.items[key]) !== null && _a !== void 0 ? _a : null;
        });
    },
    setItem(key, value) {
        return configManager_awaiter(this, void 0, void 0, function* () {
            MemoryStorage.items[key] = value;
        });
    },
};
class UIKitConfigManager {
    constructor(storage) {
        this.storage = storage !== null && storage !== void 0 ? storage : MemoryStorage;
    }
    init(appId) {
        this.key = `sbu@${appId}.uikitConfiguration`;
        return this.get();
    }
    get safeKey() {
        if (!this.key)
            throw new Error('Please UIKitConfigManager.init() first');
        return this.key;
    }
    update(remoteConfigPayload) {
        return configManager_awaiter(this, void 0, void 0, function* () {
            const storedConfigPayload = yield this.get();
            const mergedConfigPayload = {
                updatedAt: remoteConfigPayload.updatedAt,
                configuration: mergeObject(storedConfigPayload.configuration, remoteConfigPayload.configuration),
            };
            yield this.storage.setItem(this.safeKey, JSON.stringify(mergedConfigPayload));
            return mergedConfigPayload;
        });
    }
    get() {
        return configManager_awaiter(this, void 0, void 0, function* () {
            const initialPayload = {
                updatedAt: 0,
                configuration: initialRemoteConfig,
            };
            try {
                const storedConfig = yield this.storage.getItem(this.safeKey);
                if (storedConfig) {
                    // TODO: Validation
                    return JSON.parse(storedConfig);
                }
                else {
                    return initialPayload;
                }
            }
            catch (_a) {
                return initialPayload;
            }
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/updators/updateCommonConfigs.js

function updateCommonConfigs(target, local, remote) {
    var _a, _b;
    // common.enableUsingDefaultUserProfile
    if (remote.common && isBoolean((_a = remote.common) === null || _a === void 0 ? void 0 : _a.enableUsingDefaultUserProfile)) {
        target.enableUsingDefaultUserProfile = remote.common.enableUsingDefaultUserProfile;
    }
    if (local.common && isBoolean((_b = local.common) === null || _b === void 0 ? void 0 : _b.enableUsingDefaultUserProfile)) {
        target.enableUsingDefaultUserProfile = local.common.enableUsingDefaultUserProfile;
    }
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/updators/updateGroupChannelConfigs.js

function updateGroupChannelConfigs(target, local, remote) {
    // target.channel
    updateChannelConfig(target, local, remote);
    // target.channel.input
    updateChannelInputConfig(target, local, remote);
    //target.channelList
    updateChannelListConfig(target, local, remote);
    //target.setting
    updateChannelSettingConfig(target, local, remote);
}
function updateChannelConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86;
    // enableOgtag: boolean;
    if (((_a = remote.groupChannel) === null || _a === void 0 ? void 0 : _a.channel) && isBoolean((_c = (_b = remote.groupChannel) === null || _b === void 0 ? void 0 : _b.channel) === null || _c === void 0 ? void 0 : _c.enableOgtag)) {
        target.channel.enableOgtag = remote.groupChannel.channel.enableOgtag;
    }
    if (((_d = local.groupChannel) === null || _d === void 0 ? void 0 : _d.channel) && isBoolean((_f = (_e = local.groupChannel) === null || _e === void 0 ? void 0 : _e.channel) === null || _f === void 0 ? void 0 : _f.enableOgtag)) {
        target.channel.enableOgtag = (_h = (_g = local.groupChannel) === null || _g === void 0 ? void 0 : _g.channel) === null || _h === void 0 ? void 0 : _h.enableOgtag;
    }
    // enableTypingIndicator: boolean;
    if (((_j = remote.groupChannel) === null || _j === void 0 ? void 0 : _j.channel) && isBoolean((_l = (_k = remote.groupChannel) === null || _k === void 0 ? void 0 : _k.channel) === null || _l === void 0 ? void 0 : _l.enableTypingIndicator)) {
        target.channel.enableTypingIndicator = (_o = (_m = remote.groupChannel) === null || _m === void 0 ? void 0 : _m.channel) === null || _o === void 0 ? void 0 : _o.enableTypingIndicator;
    }
    if (((_p = local.groupChannel) === null || _p === void 0 ? void 0 : _p.channel) && isBoolean((_r = (_q = local.groupChannel) === null || _q === void 0 ? void 0 : _q.channel) === null || _r === void 0 ? void 0 : _r.enableTypingIndicator)) {
        target.channel.enableTypingIndicator = (_t = (_s = local.groupChannel) === null || _s === void 0 ? void 0 : _s.channel) === null || _t === void 0 ? void 0 : _t.enableTypingIndicator;
    }
    // enableReactions: boolean;
    if (((_u = remote.groupChannel) === null || _u === void 0 ? void 0 : _u.channel) && isBoolean((_w = (_v = remote.groupChannel) === null || _v === void 0 ? void 0 : _v.channel) === null || _w === void 0 ? void 0 : _w.enableReactions)) {
        target.channel.enableReactions = (_y = (_x = remote.groupChannel) === null || _x === void 0 ? void 0 : _x.channel) === null || _y === void 0 ? void 0 : _y.enableReactions;
    }
    if (((_z = local.groupChannel) === null || _z === void 0 ? void 0 : _z.channel) && isBoolean((_1 = (_0 = local.groupChannel) === null || _0 === void 0 ? void 0 : _0.channel) === null || _1 === void 0 ? void 0 : _1.enableReactions)) {
        target.channel.enableReactions = (_3 = (_2 = local.groupChannel) === null || _2 === void 0 ? void 0 : _2.channel) === null || _3 === void 0 ? void 0 : _3.enableReactions;
    }
    // enableReactionsSupergroup: boolean;
    if (((_4 = remote.groupChannel) === null || _4 === void 0 ? void 0 : _4.channel) && isBoolean((_6 = (_5 = remote.groupChannel) === null || _5 === void 0 ? void 0 : _5.channel) === null || _6 === void 0 ? void 0 : _6.enableReactionsSupergroup)) {
        target.channel.enableReactionsSupergroup = (_8 = (_7 = remote.groupChannel) === null || _7 === void 0 ? void 0 : _7.channel) === null || _8 === void 0 ? void 0 : _8.enableReactionsSupergroup;
    }
    // NOTE: 2024.06.10 currently, no local configuration for this
    if (((_9 = local.groupChannel) === null || _9 === void 0 ? void 0 : _9.channel) && isBoolean((_11 = (_10 = local.groupChannel) === null || _10 === void 0 ? void 0 : _10.channel) === null || _11 === void 0 ? void 0 : _11.enableReactionsSupergroup)) {
        console.warn('Currently, EnableReactionsSupergroup feature is turned off by default. If you wish to use this feature, contact us: https://dashboard.sendbird.com/settings/contact_us?category=feedback_and_feature_requests&product=UIKit');
    }
    // enableMention: boolean;
    if (((_12 = remote.groupChannel) === null || _12 === void 0 ? void 0 : _12.channel) && isBoolean((_14 = (_13 = remote.groupChannel) === null || _13 === void 0 ? void 0 : _13.channel) === null || _14 === void 0 ? void 0 : _14.enableMention)) {
        target.channel.enableMention = (_16 = (_15 = remote.groupChannel) === null || _15 === void 0 ? void 0 : _15.channel) === null || _16 === void 0 ? void 0 : _16.enableMention;
    }
    if (((_17 = local.groupChannel) === null || _17 === void 0 ? void 0 : _17.channel) && isBoolean((_19 = (_18 = local.groupChannel) === null || _18 === void 0 ? void 0 : _18.channel) === null || _19 === void 0 ? void 0 : _19.enableMention)) {
        target.channel.enableMention = (_21 = (_20 = local.groupChannel) === null || _20 === void 0 ? void 0 : _20.channel) === null || _21 === void 0 ? void 0 : _21.enableMention;
    }
    // replyType: 'none' | 'quote_reply' | 'thread';
    if (((_22 = remote.groupChannel) === null || _22 === void 0 ? void 0 : _22.channel) &&
        isOneOf((_24 = (_23 = remote.groupChannel) === null || _23 === void 0 ? void 0 : _23.channel) === null || _24 === void 0 ? void 0 : _24.replyType, ['none', 'quote_reply', 'thread'])) {
        target.channel.replyType = (_26 = (_25 = remote.groupChannel) === null || _25 === void 0 ? void 0 : _25.channel) === null || _26 === void 0 ? void 0 : _26.replyType;
    }
    if (((_27 = local.groupChannel) === null || _27 === void 0 ? void 0 : _27.channel) &&
        isOneOf((_29 = (_28 = local.groupChannel) === null || _28 === void 0 ? void 0 : _28.channel) === null || _29 === void 0 ? void 0 : _29.replyType, ['none', 'quote_reply', 'thread'])) {
        target.channel.replyType = (_31 = (_30 = local.groupChannel) === null || _30 === void 0 ? void 0 : _30.channel) === null || _31 === void 0 ? void 0 : _31.replyType;
    }
    // threadReplySelectType: 'thread' | 'parent';
    if (((_32 = remote.groupChannel) === null || _32 === void 0 ? void 0 : _32.channel) &&
        isOneOf((_34 = (_33 = remote.groupChannel) === null || _33 === void 0 ? void 0 : _33.channel) === null || _34 === void 0 ? void 0 : _34.threadReplySelectType, ['thread', 'parent'])) {
        target.channel.threadReplySelectType = (_36 = (_35 = remote.groupChannel) === null || _35 === void 0 ? void 0 : _35.channel) === null || _36 === void 0 ? void 0 : _36.threadReplySelectType;
    }
    if (((_37 = local.groupChannel) === null || _37 === void 0 ? void 0 : _37.channel) &&
        isOneOf((_39 = (_38 = local.groupChannel) === null || _38 === void 0 ? void 0 : _38.channel) === null || _39 === void 0 ? void 0 : _39.threadReplySelectType, ['thread', 'parent'])) {
        target.channel.threadReplySelectType = (_41 = (_40 = local.groupChannel) === null || _40 === void 0 ? void 0 : _40.channel) === null || _41 === void 0 ? void 0 : _41.threadReplySelectType;
    }
    // enableVoiceMessage: boolean;
    if (((_42 = remote.groupChannel) === null || _42 === void 0 ? void 0 : _42.channel) && isBoolean((_44 = (_43 = remote.groupChannel) === null || _43 === void 0 ? void 0 : _43.channel) === null || _44 === void 0 ? void 0 : _44.enableVoiceMessage)) {
        target.channel.enableVoiceMessage = (_46 = (_45 = remote.groupChannel) === null || _45 === void 0 ? void 0 : _45.channel) === null || _46 === void 0 ? void 0 : _46.enableVoiceMessage;
    }
    if (((_47 = local.groupChannel) === null || _47 === void 0 ? void 0 : _47.channel) && isBoolean((_49 = (_48 = local.groupChannel) === null || _48 === void 0 ? void 0 : _48.channel) === null || _49 === void 0 ? void 0 : _49.enableVoiceMessage)) {
        target.channel.enableVoiceMessage = (_51 = (_50 = local.groupChannel) === null || _50 === void 0 ? void 0 : _50.channel) === null || _51 === void 0 ? void 0 : _51.enableVoiceMessage;
    }
    // typingIndicatorTypes: Set<TypingIndicatorType>;
    // NOTE: 2023.11.03 currently, no remote configuration for this
    // if (remote.groupChannel?.channel && isArray(remote.groupChannel?.channel?.typingIndicatorTypes)) {
    //   target.channel.typingIndicatorTypes = toSet(remote.groupChannel?.channel?.typingIndicatorTypes);
    // }
    if (((_52 = local.groupChannel) === null || _52 === void 0 ? void 0 : _52.channel) && isSet((_54 = (_53 = local.groupChannel) === null || _53 === void 0 ? void 0 : _53.channel) === null || _54 === void 0 ? void 0 : _54.typingIndicatorTypes)) {
        target.channel.typingIndicatorTypes = (_56 = (_55 = local.groupChannel) === null || _55 === void 0 ? void 0 : _55.channel) === null || _56 === void 0 ? void 0 : _56.typingIndicatorTypes;
    }
    // enableFeedback: boolean;
    // NOTE: 2024.01.12 currently, no remote configuration for this
    // if (remote.groupChannel?.channel && isBoolean(remote.groupChannel?.channel?.enableFeedback)) {
    //   target.channel.enableFeedback = remote.groupChannel?.channel?.enableFeedback;
    // }
    if (((_57 = local.groupChannel) === null || _57 === void 0 ? void 0 : _57.channel) && isBoolean((_59 = (_58 = local.groupChannel) === null || _58 === void 0 ? void 0 : _58.channel) === null || _59 === void 0 ? void 0 : _59.enableFeedback)) {
        target.channel.enableFeedback = (_61 = (_60 = local.groupChannel) === null || _60 === void 0 ? void 0 : _60.channel) === null || _61 === void 0 ? void 0 : _61.enableFeedback;
    }
    // enableSuggestedReplies: boolean;
    // NOTE: 2024.02.01 currently, no remote configuration for this
    // if (remote.groupChannel?.channel && isBoolean(remote.groupChannel?.channel?.enableSuggestedReplies)) {
    //   target.channel.enableSuggestedReplies = remote.groupChannel?.channel?.enableSuggestedReplies;
    // }
    if (((_62 = local.groupChannel) === null || _62 === void 0 ? void 0 : _62.channel) && isBoolean((_64 = (_63 = local.groupChannel) === null || _63 === void 0 ? void 0 : _63.channel) === null || _64 === void 0 ? void 0 : _64.enableSuggestedReplies)) {
        target.channel.enableSuggestedReplies = (_66 = (_65 = local.groupChannel) === null || _65 === void 0 ? void 0 : _65.channel) === null || _66 === void 0 ? void 0 : _66.enableSuggestedReplies;
    }
    // showSuggestedRepliesFor: 'all_messages' | 'last_message_only';
    // NOTE: 2024.02.25 currently, no remote configuration for this
    // if (
    //   remote.groupChannel?.channel &&
    //   isOneOf(remote.groupChannel?.channel?.showSuggestedRepliesFor, ['all_messages', 'last_message_only'])
    // ) {
    //   target.channel.showSuggestedRepliesFor = remote.groupChannel?.channel?.showSuggestedRepliesFor;
    // }
    if (((_67 = local.groupChannel) === null || _67 === void 0 ? void 0 : _67.channel) &&
        isOneOf((_69 = (_68 = local.groupChannel) === null || _68 === void 0 ? void 0 : _68.channel) === null || _69 === void 0 ? void 0 : _69.showSuggestedRepliesFor, ['all_messages', 'last_message_only'])) {
        target.channel.showSuggestedRepliesFor = (_71 = (_70 = local.groupChannel) === null || _70 === void 0 ? void 0 : _70.channel) === null || _71 === void 0 ? void 0 : _71.showSuggestedRepliesFor;
    }
    // suggestedRepliesDirection: 'vertical' | 'horizontal';
    // NOTE: 2024.04.22 currently, no remote configuration for this
    // if (
    //   remote.groupChannel?.channel &&
    //   isOneOf(remote.groupChannel?.channel?.suggestedRepliesDirection, ['vertical', 'horizontal'])
    // ) {
    //   target.channel.suggestedRepliesDirection = remote.groupChannel?.channel?.suggestedRepliesDirection;
    // }
    if (((_72 = local.groupChannel) === null || _72 === void 0 ? void 0 : _72.channel) &&
        isOneOf((_74 = (_73 = local.groupChannel) === null || _73 === void 0 ? void 0 : _73.channel) === null || _74 === void 0 ? void 0 : _74.suggestedRepliesDirection, ['vertical', 'horizontal'])) {
        target.channel.suggestedRepliesDirection = (_76 = (_75 = local.groupChannel) === null || _75 === void 0 ? void 0 : _75.channel) === null || _76 === void 0 ? void 0 : _76.suggestedRepliesDirection;
    }
    // enableMarkdownForUserMessage: boolean;
    // NOTE: 2024.06.03 currently, no remote configuration for this
    // if (remote.groupChannel?.channel && isBoolean(remote.groupChannel?.channel?.enableMarkdownForUserMessage)) {
    //   target.channel.enableMarkdownForUserMessage = remote.groupChannel?.channel?.enableMarkdownForUserMessage;
    // }
    if (((_77 = local.groupChannel) === null || _77 === void 0 ? void 0 : _77.channel) && isBoolean((_79 = (_78 = local.groupChannel) === null || _78 === void 0 ? void 0 : _78.channel) === null || _79 === void 0 ? void 0 : _79.enableMarkdownForUserMessage)) {
        target.channel.enableMarkdownForUserMessage = (_81 = (_80 = local.groupChannel) === null || _80 === void 0 ? void 0 : _80.channel) === null || _81 === void 0 ? void 0 : _81.enableMarkdownForUserMessage;
    }
    // enableFormTypeMessage: boolean;
    // NOTE: 2024.06.17 currently, no remote configuration for this
    // if (remote.groupChannel?.channel && isBoolean(remote.groupChannel?.channel?.enableFormTypeMessage)) {
    //   target.channel.enableFormTypeMessage = remote.groupChannel?.channel?.enableFormTypeMessage;
    // }
    if (((_82 = local.groupChannel) === null || _82 === void 0 ? void 0 : _82.channel) && isBoolean((_84 = (_83 = local.groupChannel) === null || _83 === void 0 ? void 0 : _83.channel) === null || _84 === void 0 ? void 0 : _84.enableFormTypeMessage)) {
        target.channel.enableFormTypeMessage = (_86 = (_85 = local.groupChannel) === null || _85 === void 0 ? void 0 : _85.channel) === null || _86 === void 0 ? void 0 : _86.enableFormTypeMessage;
    }
}
function updateChannelInputConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79;
    // input.enableDocument: boolean;
    if (((_b = (_a = remote.groupChannel) === null || _a === void 0 ? void 0 : _a.channel) === null || _b === void 0 ? void 0 : _b.input) && isBoolean((_e = (_d = (_c = remote.groupChannel) === null || _c === void 0 ? void 0 : _c.channel) === null || _d === void 0 ? void 0 : _d.input) === null || _e === void 0 ? void 0 : _e.enableDocument)) {
        target.channel.input.enableDocument = (_h = (_g = (_f = remote.groupChannel) === null || _f === void 0 ? void 0 : _f.channel) === null || _g === void 0 ? void 0 : _g.input) === null || _h === void 0 ? void 0 : _h.enableDocument;
    }
    if (((_k = (_j = local.groupChannel) === null || _j === void 0 ? void 0 : _j.channel) === null || _k === void 0 ? void 0 : _k.input) && isBoolean((_o = (_m = (_l = local.groupChannel) === null || _l === void 0 ? void 0 : _l.channel) === null || _m === void 0 ? void 0 : _m.input) === null || _o === void 0 ? void 0 : _o.enableDocument)) {
        target.channel.input.enableDocument = (_r = (_q = (_p = local.groupChannel) === null || _p === void 0 ? void 0 : _p.channel) === null || _q === void 0 ? void 0 : _q.input) === null || _r === void 0 ? void 0 : _r.enableDocument;
    }
    // input.camera.enablePhoto: boolean;
    if (((_u = (_t = (_s = remote.groupChannel) === null || _s === void 0 ? void 0 : _s.channel) === null || _t === void 0 ? void 0 : _t.input) === null || _u === void 0 ? void 0 : _u.camera) &&
        isBoolean((_y = (_x = (_w = (_v = remote.groupChannel) === null || _v === void 0 ? void 0 : _v.channel) === null || _w === void 0 ? void 0 : _w.input) === null || _x === void 0 ? void 0 : _x.camera) === null || _y === void 0 ? void 0 : _y.enablePhoto)) {
        target.channel.input.camera.enablePhoto = (_2 = (_1 = (_0 = (_z = remote.groupChannel) === null || _z === void 0 ? void 0 : _z.channel) === null || _0 === void 0 ? void 0 : _0.input) === null || _1 === void 0 ? void 0 : _1.camera) === null || _2 === void 0 ? void 0 : _2.enablePhoto;
    }
    if (((_5 = (_4 = (_3 = local.groupChannel) === null || _3 === void 0 ? void 0 : _3.channel) === null || _4 === void 0 ? void 0 : _4.input) === null || _5 === void 0 ? void 0 : _5.camera) &&
        isBoolean((_9 = (_8 = (_7 = (_6 = local.groupChannel) === null || _6 === void 0 ? void 0 : _6.channel) === null || _7 === void 0 ? void 0 : _7.input) === null || _8 === void 0 ? void 0 : _8.camera) === null || _9 === void 0 ? void 0 : _9.enablePhoto)) {
        target.channel.input.camera.enablePhoto = (_13 = (_12 = (_11 = (_10 = local.groupChannel) === null || _10 === void 0 ? void 0 : _10.channel) === null || _11 === void 0 ? void 0 : _11.input) === null || _12 === void 0 ? void 0 : _12.camera) === null || _13 === void 0 ? void 0 : _13.enablePhoto;
    }
    // input.camera.enableVideo: boolean;
    if (((_16 = (_15 = (_14 = remote.groupChannel) === null || _14 === void 0 ? void 0 : _14.channel) === null || _15 === void 0 ? void 0 : _15.input) === null || _16 === void 0 ? void 0 : _16.camera) &&
        isBoolean((_20 = (_19 = (_18 = (_17 = remote.groupChannel) === null || _17 === void 0 ? void 0 : _17.channel) === null || _18 === void 0 ? void 0 : _18.input) === null || _19 === void 0 ? void 0 : _19.camera) === null || _20 === void 0 ? void 0 : _20.enableVideo)) {
        target.channel.input.camera.enableVideo = (_24 = (_23 = (_22 = (_21 = remote.groupChannel) === null || _21 === void 0 ? void 0 : _21.channel) === null || _22 === void 0 ? void 0 : _22.input) === null || _23 === void 0 ? void 0 : _23.camera) === null || _24 === void 0 ? void 0 : _24.enableVideo;
    }
    if (((_27 = (_26 = (_25 = local.groupChannel) === null || _25 === void 0 ? void 0 : _25.channel) === null || _26 === void 0 ? void 0 : _26.input) === null || _27 === void 0 ? void 0 : _27.camera) &&
        isBoolean((_31 = (_30 = (_29 = (_28 = local.groupChannel) === null || _28 === void 0 ? void 0 : _28.channel) === null || _29 === void 0 ? void 0 : _29.input) === null || _30 === void 0 ? void 0 : _30.camera) === null || _31 === void 0 ? void 0 : _31.enableVideo)) {
        target.channel.input.camera.enableVideo = (_35 = (_34 = (_33 = (_32 = local.groupChannel) === null || _32 === void 0 ? void 0 : _32.channel) === null || _33 === void 0 ? void 0 : _33.input) === null || _34 === void 0 ? void 0 : _34.camera) === null || _35 === void 0 ? void 0 : _35.enableVideo;
    }
    // input.gallery.enablePhoto: boolean;
    if (((_38 = (_37 = (_36 = remote.groupChannel) === null || _36 === void 0 ? void 0 : _36.channel) === null || _37 === void 0 ? void 0 : _37.input) === null || _38 === void 0 ? void 0 : _38.gallery) &&
        isBoolean((_42 = (_41 = (_40 = (_39 = remote.groupChannel) === null || _39 === void 0 ? void 0 : _39.channel) === null || _40 === void 0 ? void 0 : _40.input) === null || _41 === void 0 ? void 0 : _41.gallery) === null || _42 === void 0 ? void 0 : _42.enablePhoto)) {
        target.channel.input.gallery.enablePhoto = (_46 = (_45 = (_44 = (_43 = remote.groupChannel) === null || _43 === void 0 ? void 0 : _43.channel) === null || _44 === void 0 ? void 0 : _44.input) === null || _45 === void 0 ? void 0 : _45.gallery) === null || _46 === void 0 ? void 0 : _46.enablePhoto;
    }
    if (((_49 = (_48 = (_47 = local.groupChannel) === null || _47 === void 0 ? void 0 : _47.channel) === null || _48 === void 0 ? void 0 : _48.input) === null || _49 === void 0 ? void 0 : _49.gallery) &&
        isBoolean((_53 = (_52 = (_51 = (_50 = local.groupChannel) === null || _50 === void 0 ? void 0 : _50.channel) === null || _51 === void 0 ? void 0 : _51.input) === null || _52 === void 0 ? void 0 : _52.gallery) === null || _53 === void 0 ? void 0 : _53.enablePhoto)) {
        target.channel.input.gallery.enablePhoto = (_57 = (_56 = (_55 = (_54 = local.groupChannel) === null || _54 === void 0 ? void 0 : _54.channel) === null || _55 === void 0 ? void 0 : _55.input) === null || _56 === void 0 ? void 0 : _56.gallery) === null || _57 === void 0 ? void 0 : _57.enablePhoto;
    }
    // input.gallery.enableVideo: boolean;
    if (((_60 = (_59 = (_58 = remote.groupChannel) === null || _58 === void 0 ? void 0 : _58.channel) === null || _59 === void 0 ? void 0 : _59.input) === null || _60 === void 0 ? void 0 : _60.gallery) &&
        isBoolean((_64 = (_63 = (_62 = (_61 = remote.groupChannel) === null || _61 === void 0 ? void 0 : _61.channel) === null || _62 === void 0 ? void 0 : _62.input) === null || _63 === void 0 ? void 0 : _63.gallery) === null || _64 === void 0 ? void 0 : _64.enableVideo)) {
        target.channel.input.gallery.enableVideo = (_68 = (_67 = (_66 = (_65 = remote.groupChannel) === null || _65 === void 0 ? void 0 : _65.channel) === null || _66 === void 0 ? void 0 : _66.input) === null || _67 === void 0 ? void 0 : _67.gallery) === null || _68 === void 0 ? void 0 : _68.enableVideo;
    }
    if (((_71 = (_70 = (_69 = local.groupChannel) === null || _69 === void 0 ? void 0 : _69.channel) === null || _70 === void 0 ? void 0 : _70.input) === null || _71 === void 0 ? void 0 : _71.gallery) &&
        isBoolean((_75 = (_74 = (_73 = (_72 = local.groupChannel) === null || _72 === void 0 ? void 0 : _72.channel) === null || _73 === void 0 ? void 0 : _73.input) === null || _74 === void 0 ? void 0 : _74.gallery) === null || _75 === void 0 ? void 0 : _75.enableVideo)) {
        target.channel.input.gallery.enableVideo = (_79 = (_78 = (_77 = (_76 = local.groupChannel) === null || _76 === void 0 ? void 0 : _76.channel) === null || _77 === void 0 ? void 0 : _77.input) === null || _78 === void 0 ? void 0 : _78.gallery) === null || _79 === void 0 ? void 0 : _79.enableVideo;
    }
}
function updateChannelListConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    // enableTypingIndicator: boolean;
    if (((_a = remote.groupChannel) === null || _a === void 0 ? void 0 : _a.channelList) && isBoolean((_c = (_b = remote.groupChannel) === null || _b === void 0 ? void 0 : _b.channelList) === null || _c === void 0 ? void 0 : _c.enableTypingIndicator)) {
        target.channelList.enableTypingIndicator = remote.groupChannel.channelList.enableTypingIndicator;
    }
    if (((_d = local.groupChannel) === null || _d === void 0 ? void 0 : _d.channelList) && isBoolean((_f = (_e = local.groupChannel) === null || _e === void 0 ? void 0 : _e.channelList) === null || _f === void 0 ? void 0 : _f.enableTypingIndicator)) {
        target.channelList.enableTypingIndicator = (_h = (_g = local.groupChannel) === null || _g === void 0 ? void 0 : _g.channelList) === null || _h === void 0 ? void 0 : _h.enableTypingIndicator;
    }
    // enableMessageReceiptStatus: boolean;
    if (((_j = remote.groupChannel) === null || _j === void 0 ? void 0 : _j.channelList) && isBoolean((_l = (_k = remote.groupChannel) === null || _k === void 0 ? void 0 : _k.channelList) === null || _l === void 0 ? void 0 : _l.enableMessageReceiptStatus)) {
        target.channelList.enableMessageReceiptStatus = (_o = (_m = remote.groupChannel) === null || _m === void 0 ? void 0 : _m.channelList) === null || _o === void 0 ? void 0 : _o.enableMessageReceiptStatus;
    }
    if (((_p = local.groupChannel) === null || _p === void 0 ? void 0 : _p.channelList) && isBoolean((_r = (_q = local.groupChannel) === null || _q === void 0 ? void 0 : _q.channelList) === null || _r === void 0 ? void 0 : _r.enableMessageReceiptStatus)) {
        target.channelList.enableMessageReceiptStatus = (_t = (_s = local.groupChannel) === null || _s === void 0 ? void 0 : _s.channelList) === null || _t === void 0 ? void 0 : _t.enableMessageReceiptStatus;
    }
}
function updateChannelSettingConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // enableMessageSearch: boolean;
    if (((_a = remote.groupChannel) === null || _a === void 0 ? void 0 : _a.setting) && isBoolean((_c = (_b = remote.groupChannel) === null || _b === void 0 ? void 0 : _b.setting) === null || _c === void 0 ? void 0 : _c.enableMessageSearch)) {
        target.setting.enableMessageSearch = remote.groupChannel.setting.enableMessageSearch;
    }
    if (((_d = local.groupChannel) === null || _d === void 0 ? void 0 : _d.setting) && isBoolean((_f = (_e = local.groupChannel) === null || _e === void 0 ? void 0 : _e.setting) === null || _f === void 0 ? void 0 : _f.enableMessageSearch)) {
        target.setting.enableMessageSearch = (_h = (_g = local.groupChannel) === null || _g === void 0 ? void 0 : _g.setting) === null || _h === void 0 ? void 0 : _h.enableMessageSearch;
    }
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/updators/updateOpenChannelConfigs.js

function updateOpenChannelConfigs(target, local, remote) {
    // target.channel
    updateOpenChannelConfigs_updateChannelConfig(target, local, remote);
    // target.channel.input
    updateOpenChannelConfigs_updateChannelInputConfig(target, local, remote);
}
function updateOpenChannelConfigs_updateChannelConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // enableOgtag: boolean;
    if (((_a = remote.openChannel) === null || _a === void 0 ? void 0 : _a.channel) && isBoolean((_c = (_b = remote.openChannel) === null || _b === void 0 ? void 0 : _b.channel) === null || _c === void 0 ? void 0 : _c.enableOgtag)) {
        target.channel.enableOgtag = remote.openChannel.channel.enableOgtag;
    }
    if (((_d = local.openChannel) === null || _d === void 0 ? void 0 : _d.channel) && isBoolean((_f = (_e = local.openChannel) === null || _e === void 0 ? void 0 : _e.channel) === null || _f === void 0 ? void 0 : _f.enableOgtag)) {
        target.channel.enableOgtag = (_h = (_g = local.openChannel) === null || _g === void 0 ? void 0 : _g.channel) === null || _h === void 0 ? void 0 : _h.enableOgtag;
    }
}
function updateOpenChannelConfigs_updateChannelInputConfig(target, local, remote) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79;
    // input.enableDocument: boolean;
    if (((_b = (_a = remote.openChannel) === null || _a === void 0 ? void 0 : _a.channel) === null || _b === void 0 ? void 0 : _b.input) && isBoolean((_e = (_d = (_c = remote.openChannel) === null || _c === void 0 ? void 0 : _c.channel) === null || _d === void 0 ? void 0 : _d.input) === null || _e === void 0 ? void 0 : _e.enableDocument)) {
        target.channel.input.enableDocument = (_h = (_g = (_f = remote.openChannel) === null || _f === void 0 ? void 0 : _f.channel) === null || _g === void 0 ? void 0 : _g.input) === null || _h === void 0 ? void 0 : _h.enableDocument;
    }
    if (((_k = (_j = local.openChannel) === null || _j === void 0 ? void 0 : _j.channel) === null || _k === void 0 ? void 0 : _k.input) && isBoolean((_o = (_m = (_l = local.openChannel) === null || _l === void 0 ? void 0 : _l.channel) === null || _m === void 0 ? void 0 : _m.input) === null || _o === void 0 ? void 0 : _o.enableDocument)) {
        target.channel.input.enableDocument = (_r = (_q = (_p = local.openChannel) === null || _p === void 0 ? void 0 : _p.channel) === null || _q === void 0 ? void 0 : _q.input) === null || _r === void 0 ? void 0 : _r.enableDocument;
    }
    // input.camera.enablePhoto: boolean;
    if (((_u = (_t = (_s = remote.openChannel) === null || _s === void 0 ? void 0 : _s.channel) === null || _t === void 0 ? void 0 : _t.input) === null || _u === void 0 ? void 0 : _u.camera) &&
        isBoolean((_y = (_x = (_w = (_v = remote.openChannel) === null || _v === void 0 ? void 0 : _v.channel) === null || _w === void 0 ? void 0 : _w.input) === null || _x === void 0 ? void 0 : _x.camera) === null || _y === void 0 ? void 0 : _y.enablePhoto)) {
        target.channel.input.camera.enablePhoto = (_2 = (_1 = (_0 = (_z = remote.openChannel) === null || _z === void 0 ? void 0 : _z.channel) === null || _0 === void 0 ? void 0 : _0.input) === null || _1 === void 0 ? void 0 : _1.camera) === null || _2 === void 0 ? void 0 : _2.enablePhoto;
    }
    if (((_5 = (_4 = (_3 = local.openChannel) === null || _3 === void 0 ? void 0 : _3.channel) === null || _4 === void 0 ? void 0 : _4.input) === null || _5 === void 0 ? void 0 : _5.camera) && isBoolean((_9 = (_8 = (_7 = (_6 = local.openChannel) === null || _6 === void 0 ? void 0 : _6.channel) === null || _7 === void 0 ? void 0 : _7.input) === null || _8 === void 0 ? void 0 : _8.camera) === null || _9 === void 0 ? void 0 : _9.enablePhoto)) {
        target.channel.input.camera.enablePhoto = (_13 = (_12 = (_11 = (_10 = local.openChannel) === null || _10 === void 0 ? void 0 : _10.channel) === null || _11 === void 0 ? void 0 : _11.input) === null || _12 === void 0 ? void 0 : _12.camera) === null || _13 === void 0 ? void 0 : _13.enablePhoto;
    }
    // input.camera.enableVideo: boolean;
    if (((_16 = (_15 = (_14 = remote.openChannel) === null || _14 === void 0 ? void 0 : _14.channel) === null || _15 === void 0 ? void 0 : _15.input) === null || _16 === void 0 ? void 0 : _16.camera) &&
        isBoolean((_20 = (_19 = (_18 = (_17 = remote.openChannel) === null || _17 === void 0 ? void 0 : _17.channel) === null || _18 === void 0 ? void 0 : _18.input) === null || _19 === void 0 ? void 0 : _19.camera) === null || _20 === void 0 ? void 0 : _20.enableVideo)) {
        target.channel.input.camera.enableVideo = (_24 = (_23 = (_22 = (_21 = remote.openChannel) === null || _21 === void 0 ? void 0 : _21.channel) === null || _22 === void 0 ? void 0 : _22.input) === null || _23 === void 0 ? void 0 : _23.camera) === null || _24 === void 0 ? void 0 : _24.enableVideo;
    }
    if (((_27 = (_26 = (_25 = local.openChannel) === null || _25 === void 0 ? void 0 : _25.channel) === null || _26 === void 0 ? void 0 : _26.input) === null || _27 === void 0 ? void 0 : _27.camera) && isBoolean((_31 = (_30 = (_29 = (_28 = local.openChannel) === null || _28 === void 0 ? void 0 : _28.channel) === null || _29 === void 0 ? void 0 : _29.input) === null || _30 === void 0 ? void 0 : _30.camera) === null || _31 === void 0 ? void 0 : _31.enableVideo)) {
        target.channel.input.camera.enableVideo = (_35 = (_34 = (_33 = (_32 = local.openChannel) === null || _32 === void 0 ? void 0 : _32.channel) === null || _33 === void 0 ? void 0 : _33.input) === null || _34 === void 0 ? void 0 : _34.camera) === null || _35 === void 0 ? void 0 : _35.enableVideo;
    }
    // input.gallery.enablePhoto: boolean;
    if (((_38 = (_37 = (_36 = remote.openChannel) === null || _36 === void 0 ? void 0 : _36.channel) === null || _37 === void 0 ? void 0 : _37.input) === null || _38 === void 0 ? void 0 : _38.gallery) &&
        isBoolean((_42 = (_41 = (_40 = (_39 = remote.openChannel) === null || _39 === void 0 ? void 0 : _39.channel) === null || _40 === void 0 ? void 0 : _40.input) === null || _41 === void 0 ? void 0 : _41.gallery) === null || _42 === void 0 ? void 0 : _42.enablePhoto)) {
        target.channel.input.gallery.enablePhoto = (_46 = (_45 = (_44 = (_43 = remote.openChannel) === null || _43 === void 0 ? void 0 : _43.channel) === null || _44 === void 0 ? void 0 : _44.input) === null || _45 === void 0 ? void 0 : _45.gallery) === null || _46 === void 0 ? void 0 : _46.enablePhoto;
    }
    if (((_49 = (_48 = (_47 = local.openChannel) === null || _47 === void 0 ? void 0 : _47.channel) === null || _48 === void 0 ? void 0 : _48.input) === null || _49 === void 0 ? void 0 : _49.gallery) &&
        isBoolean((_53 = (_52 = (_51 = (_50 = local.openChannel) === null || _50 === void 0 ? void 0 : _50.channel) === null || _51 === void 0 ? void 0 : _51.input) === null || _52 === void 0 ? void 0 : _52.gallery) === null || _53 === void 0 ? void 0 : _53.enablePhoto)) {
        target.channel.input.gallery.enablePhoto = (_57 = (_56 = (_55 = (_54 = local.openChannel) === null || _54 === void 0 ? void 0 : _54.channel) === null || _55 === void 0 ? void 0 : _55.input) === null || _56 === void 0 ? void 0 : _56.gallery) === null || _57 === void 0 ? void 0 : _57.enablePhoto;
    }
    // input.gallery.enableVideo: boolean;
    if (((_60 = (_59 = (_58 = remote.openChannel) === null || _58 === void 0 ? void 0 : _58.channel) === null || _59 === void 0 ? void 0 : _59.input) === null || _60 === void 0 ? void 0 : _60.gallery) &&
        isBoolean((_64 = (_63 = (_62 = (_61 = remote.openChannel) === null || _61 === void 0 ? void 0 : _61.channel) === null || _62 === void 0 ? void 0 : _62.input) === null || _63 === void 0 ? void 0 : _63.gallery) === null || _64 === void 0 ? void 0 : _64.enableVideo)) {
        target.channel.input.gallery.enableVideo = (_68 = (_67 = (_66 = (_65 = remote.openChannel) === null || _65 === void 0 ? void 0 : _65.channel) === null || _66 === void 0 ? void 0 : _66.input) === null || _67 === void 0 ? void 0 : _67.gallery) === null || _68 === void 0 ? void 0 : _68.enableVideo;
    }
    if (((_71 = (_70 = (_69 = local.openChannel) === null || _69 === void 0 ? void 0 : _69.channel) === null || _70 === void 0 ? void 0 : _70.input) === null || _71 === void 0 ? void 0 : _71.gallery) &&
        isBoolean((_75 = (_74 = (_73 = (_72 = local.openChannel) === null || _72 === void 0 ? void 0 : _72.channel) === null || _73 === void 0 ? void 0 : _73.input) === null || _74 === void 0 ? void 0 : _74.gallery) === null || _75 === void 0 ? void 0 : _75.enableVideo)) {
        target.channel.input.gallery.enableVideo = (_79 = (_78 = (_77 = (_76 = local.openChannel) === null || _76 === void 0 ? void 0 : _76.channel) === null || _77 === void 0 ? void 0 : _77.input) === null || _78 === void 0 ? void 0 : _78.gallery) === null || _79 === void 0 ? void 0 : _79.enableVideo;
    }
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/utils.js




/**
 * @param localConfigs Set directly in code level. It has higher priority than remote ones
 * @param remoteConfigs Set by Feature Config setting in Dashboard
 * @returns SBUConfig
 */
function getConfigsByPriority(localConfigs, remoteConfigs) {
    const prioritizedConfigs = createInitialConfig();
    // configs.common
    updateCommonConfigs(prioritizedConfigs.common, localConfigs, remoteConfigs);
    // configs.groupChannel.channel
    updateGroupChannelConfigs(prioritizedConfigs.groupChannel, localConfigs, remoteConfigs);
    // configs.groupChannel.channelList
    // configs.openChannel
    updateOpenChannelConfigs(prioritizedConfigs.openChannel, localConfigs, remoteConfigs);
    return prioritizedConfigs;
}
/**
 * @param json UIKitConfiguration's json
 * @returns boolean
 * */
function isRawSBUConfigPayload(json) {
    return typeof json === 'object' && 'configuration' in json && 'updated_at' in json;
}

;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/context.js
var context_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







function getApplicationAttributes(sdk) {
    var _a, _b;
    return (_b = (_a = sdk.appInfo) === null || _a === void 0 ? void 0 : _a.applicationAttributes) !== null && _b !== void 0 ? _b : [];
}
const UIKitConfigContext = (0,react.createContext)({
    initDashboardConfigs: () => Promise.resolve(),
    configs: initialConfig,
    configsWithAppAttr: () => initialConfig,
});
const UIKitConfigProvider = ({ storage, children, localConfigs = {} }) => {
    // Set by Feature Config setting in Dashboard
    const [remoteConfigs, setRemoteConfigs] = (0,react.useState)(createInitialRemoteConfig);
    const [manager] = (0,react.useState)(() => new UIKitConfigManager(storage));
    const initDashboardConfigs = (0,react.useCallback)((sdk) => context_awaiter(void 0, void 0, void 0, function* () {
        // Compare the sdk uikitConfig's lastUpdatedAt <-> stored one
        const storedConfigPayload = yield manager.init(sdk.appId);
        if (sdk.appInfo && sdk.appInfo.uikitConfigInfo.lastUpdatedAt === storedConfigPayload.updatedAt) {
            setRemoteConfigs(storedConfigPayload.configuration);
        }
        else {
            try {
                // @ts-ignore
                const response = yield sdk.getUIKitConfiguration();
                if (isRawSBUConfigPayload(response.json)) {
                    const remoteConfigPayload = snakeToCamel(response.json);
                    const updatedConfigPayload = yield manager.update(remoteConfigPayload);
                    setRemoteConfigs(updatedConfigPayload.configuration);
                }
            }
            catch (_a) {
                setRemoteConfigs(storedConfigPayload.configuration);
            }
        }
    }), [manager]);
    const configs = getConfigsByPriority(localConfigs, remoteConfigs);
    const configsWithAppAttr = usePreservedCallback_usePreservedCallback((sdk) => ({
        groupChannel: {
            channel: {
                get enableReactions() {
                    return (configs.groupChannel.channel.enableReactions &&
                        getApplicationAttributes(sdk).includes(applicationAttributes.reactions));
                },
                get enableReactionsSupergroup() {
                    return (configs.groupChannel.channel.enableReactionsSupergroup &&
                        getApplicationAttributes(sdk).includes(applicationAttributes.reactions));
                },
                get enableOgtag() {
                    return (configs.groupChannel.channel.enableOgtag &&
                        getApplicationAttributes(sdk).includes(applicationAttributes.enable_og_tag));
                },
            },
            setting: {
                get enableMessageSearch() {
                    return (configs.groupChannel.setting.enableMessageSearch &&
                        getApplicationAttributes(sdk).includes(applicationAttributes.message_search_v3));
                },
            },
        },
        openChannel: {
            channel: {
                get enableOgtag() {
                    return (configs.openChannel.channel.enableOgtag &&
                        getApplicationAttributes(sdk).includes(applicationAttributes.enable_og_tag));
                },
            },
        },
    }));
    return (react.createElement(UIKitConfigContext.Provider, { value: { initDashboardConfigs, configs, configsWithAppAttr } }, children));
};
const useUIKitConfig = () => (0,react.useContext)(UIKitConfigContext);


;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/internal/exports.js



;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/uikitConfiguration/index.js



;// CONCATENATED MODULE: ./node_modules/@sendbird/uikit-tools/dist/esm/index.js





/***/ })

}]);